(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ecCom"), require("mobxReact"), require("antd"), require("mobx"), require("jQuery"), require("comsMobx"), require("ReactDOM"), require("loadjs"), require("ReactRouter"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ecCom", "mobxReact", "antd", "mobx", "jQuery", "comsMobx", "ReactDOM", "loadjs", "ReactRouter"], factory);
	else if(typeof exports === 'object')
		exports["weaCube"] = factory(require("React"), require("ecCom"), require("mobxReact"), require("antd"), require("mobx"), require("jQuery"), require("comsMobx"), require("ReactDOM"), require("loadjs"), require("ReactRouter"));
	else
		root["weaCube"] = factory(root["React"], root["ecCom"], root["mobxReact"], root["antd"], root["mobx"], root["jQuery"], root["comsMobx"], root["ReactDOM"], root["loadjs"], root["ReactRouter"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_29__, __WEBPACK_EXTERNAL_MODULE_162__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/cube/static/";
/******/
/******/ 	// __webpack_content_path__
/******/ 	__webpack_require__.v = "ecologyContentPath";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 433);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54), __webpack_require__(25)(module)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeViewType", function() { return changeViewType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeViewPage", function() { return changeViewPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceE8Url", function() { return replaceE8Url; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openHref", function() { return openHref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openHrefWithChinese", function() { return openHrefWithChinese; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modeopenFullWindowHaveBar", function() { return modeopenFullWindowHaveBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dealChineseOfFieldParams", function() { return dealChineseOfFieldParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modeopenFullWindowHaveBarForWFList", function() { return modeopenFullWindowHaveBarForWFList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openFullWindowBySelf", function() { return openFullWindowBySelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cubeOpenFullWindowBySelf", function() { return cubeOpenFullWindowBySelf; });
/* harmony export (immutable) */ __webpack_exports__["openFullWindowHaveBar"] = openFullWindowHaveBar;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spellResourceCondition", function() { return spellResourceCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEnterFun", function() { return addEnterFun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCreateTemplateForm", function() { return getCreateTemplateForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUrl", function() { return isUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlSearch", function() { return UrlSearch; });
/* harmony export (immutable) */ __webpack_exports__["removeHTMLTag"] = removeHTMLTag;
/* harmony export (immutable) */ __webpack_exports__["getListKey"] = getListKey;
/* harmony export (immutable) */ __webpack_exports__["getListMainKey"] = getListMainKey;
/* harmony export (immutable) */ __webpack_exports__["getListSubKey"] = getListSubKey;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardUtil", function() { return CardUtil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertSpecialChar", function() { return convertSpecialChar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doGlobalSpin", function() { return doGlobalSpin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _this = this;




window.downloads = function (files) {
    window.open(Object(__WEBPACK_IMPORTED_MODULE_2__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.file.FileDownload?fileid=" + files + "&download=1"));
};
var changeViewType = function (type) {
    var query = window.weaHistory.getCurrentLocation().query;
    query.type = type;
    var queryStr = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(query, function (value, key) {
        return key + "=" + value;
    })).join("&");
    window.weaHistory.push({ pathname: "/main/cube/card?" + queryStr });
};
var changeViewPage = function (url, params) {
    var query = window.weaHistory.getCurrentLocation().query;
    var queryStr = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(__assign({}, query, params), function (value, key) {
        return key + "=" + value;
    })).join("&");
    window.location.href = url + "?" + queryStr;
};
var replaceE8Url = function (url) {
    url = url.replace('/formmode/view/AddFormMode.jsp', '/spa/cube/index.html#/main/cube/card');
    url = url.replace('/formmode/view/AddFormModeIframe.jsp', '/spa/cube/index.html#/main/cube/card');
    url = url.replace('/formmode/search/CustomSearchBySimple.jsp', '/spa/cube/index.html#/main/cube/search');
    url = url.replace('/formmode/search/CustomSearchBySimpleIframe.jsp', '/spa/cube/index.html#/main/cube/search');
    url = url.replace('/formmode/tree/ViewCustomTree.jsp', '/spa/cube/index.html#/main/cube/tree');
    url = url.replace('/formmode/view/formModeComTab.jsp', '/spa/cube/index.html#/main/cube/reply');
    url = url.replace('/formmode/view/FormModeMap.jsp', '/spa/cube/index.html#/main/cube/map');
    if (url.indexOf("CustomSearchByAdvanced.jsp") > -1 || url.indexOf("CustomSearchByAdvancedIframe.jsp") > -1) {
        url = url.replace('/formmode/search/CustomSearchByAdvanced.jsp', '/spa/cube/index.html#/main/cube/search');
        url = url.replace('/formmode/search/CustomSearchByAdvancedIframe.jsp', '/spa/cube/index.html#/main/cube/search');
        url = url + "&type=advanced";
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__util_contentPath__["a" /* getContentPath */])(url);
};
var openHref = function (url) {
    window.open(replaceE8Url(url));
};
var openHrefWithChinese = function (url) {
    openHref(dealChineseOfFieldParams(url));
};
window.openHrefWithChinese = openHrefWithChinese;
window.openHref = openHref;
var modeopenFullWindowHaveBar = function (url, _) {
    url = replaceE8Url(url);
    url = dealChineseOfFieldParams(url);
    url = url.replace(/\+/g, "%2B");
    openFullWindowHaveBar(url);
};
window.modeopenFullWindowHaveBar = modeopenFullWindowHaveBar;
var dealChineseOfFieldParams = function (url) {
    if (url.indexOf("/workflow/request/AddRequest.jsp") == -1 && url.indexOf("/spa/cube/index.html#/main/cube/card") != 0) {
        return url;
    }
    var params = "";
    var path = url.substring(0, url.indexOf("?") + 1);
    var filedparams = url.substring(url.indexOf("?") + 1);
    var fieldparam = filedparams.split("&");
    for (var i = 0; i < fieldparam.length; i++) {
        var tmpindex = fieldparam[i].indexOf("=");
        if (tmpindex != -1) {
            var key = fieldparam[i].substring(0, tmpindex);
            var value = fieldparam[i].substring(tmpindex + 1);
            //防止数据卡片中的日期、日期时间字段赋值错误，日期、日期时间中的冒号不编码
            var timeReg = /^(0?[0-9]|1[0-9]|2[0-3]):(0?[0-9]|[1-5][0-9])$/gi;
            var dateReg = /^[1-2]\d{3}\-(0[1-9]|1[0-2])\-(0[1-9]|[1-2][0-9]|3[0-1])$/gi;
            var isDateTime = false;
            var arr = value.split(" ");
            if (arr.length == 2 && dateReg.test(arr[0]) && timeReg.test(arr[1])) {
                isDateTime = true;
            }
            if (!(timeReg.test(value) || isDateTime)) {
                value = encodeURIComponent(value);
            }
            params += "&" + key + "=" + value;
        }
    }
    return path + params.substring(1);
};
var modeopenFullWindowHaveBarForWFList = function (url) {
    openFullWindowHaveBarForWFList(url);
};
window.modeopenFullWindowHaveBarForWFList = modeopenFullWindowHaveBarForWFList;
function openFullWindowHaveBarForWFList(url) {
    var redirectUrl = url;
    var width = screen.availWidth - 10;
    var height = screen.availHeight - 50;
    var szFeatures = "top=0,";
    szFeatures += "left=0,";
    szFeatures += "width=" + width + ",";
    szFeatures += "height=" + height + ",";
    szFeatures += "directories=no,";
    szFeatures += "status=yes,toolbar=no,location=no,";
    szFeatures += "menubar=no,";
    szFeatures += "scrollbars=yes,";
    szFeatures += "resizable=yes"; //channelmode
    window.open(redirectUrl, "", szFeatures);
}
var openFullWindowBySelf = function (url) {
    url = replaceE8Url(url);
    url = dealChineseOfFieldParams(url);
    url = url.replace(/\+/g, "%2B");
    window.location.href = url;
};
window.openFullWindowBySelf = openFullWindowBySelf;
var cubeOpenFullWindowBySelf = function (url) {
    url = replaceE8Url(url);
    url = dealChineseOfFieldParams(url);
    url = url.replace(/\+/g, "%2B");
    if (url && url.indexOf('/spa/cube/index.html') === -1) { // 非建模路径，直接跳转相应路径
        window.location.replace(url);
    }
    else {
        var routeurl = url.split('#')[1];
        window.weaHistory.push({ pathname: routeurl });
    }
};
window.cubeOpenFullWindowBySelf = cubeOpenFullWindowBySelf;
function openFullWindowHaveBar(url) {
    url = replaceE8Url(url);
    var redirectUrl = url;
    var width = screen.availWidth - 10;
    var height = screen.availHeight - 50;
    //if (height == 768 ) height -= 75 ;
    //if (height == 600 ) height -= 60 ;
    var szFeatures = "top=0,";
    szFeatures += "left=0,";
    szFeatures += "width=" + width + ",";
    szFeatures += "height=" + height + ",";
    szFeatures += "directories=no,";
    szFeatures += "status=yes,toolbar=no,location=no,";
    szFeatures += "menubar=no,";
    szFeatures += "scrollbars=yes,";
    szFeatures += "resizable=yes"; //channelmode
    window.open(redirectUrl, "", szFeatures);
}
//人力资源条件数据处理
var spellResourceCondition = function (datas) {
    if (datas) {
        var value_1 = [];
        datas.map(function (item) {
            var candownload = item.canDownload == '是' ? '1' : '0';
            if (item.sharetype == "1") {
                value_1.push("1_" + item.relatedshare + "_0_0_" + candownload);
            }
            else if (item.sharetype == "2" || item.sharetype == "3") {
                value_1.push(item.sharetype + "_" + item.relatedshare + "_0_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "4") {
                value_1.push("4_" + item.relatedshare + "_" + item.rolelevel + "_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "5") {
                value_1.push("5_0_0_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "6") {
                if (item.joblevel == '2') {
                    value_1.push("6_" + item.relatedshare + "_0_2|@|2_" + candownload);
                }
                else {
                    value_1.push("6_" + item.relatedshare + "_0_" + item.joblevel + "|@|" + item.jobfield + "_" + candownload);
                }
            }
        });
        return value_1.join('~');
    }
    return '';
};
window.openFullWindowHaveBar = openFullWindowHaveBar;
var addEnterFun = function (searchFun) {
    var adEnterDiv = document.getElementsByClassName('cube-search-advance');
    if (adEnterDiv.length > 0 && adEnterDiv[0]['onkeydown'] == null) {
        adEnterDiv[0]['onkeydown'] = function (e) {
            if (e.keyCode == 13 && e.target.className.indexOf('ant-input') > -1) {
                searchFun();
            }
        };
    }
};
// export const getBaseSearchs = (form, conditioninfo, customComponent?: any) => {
//     return getAdvancedSearchs(form, conditioninfo, customComponent)
// }
var getCreateTemplateForm = function (form, fields) {
    var isFormInit = form.isFormInit;
    if (isFormInit) {
        var formParams_1 = form.getFormParams(); // 获取表单的值
        var result = (React.createElement("div", null, fields[0].items.map(function (field, idn) { return (React.createElement(__WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@e62426@" + idn, label: "" + field.label, labelCol: { span: field.labelcol }, wrapperCol: { span: field.fieldcol } },
            React.createElement(__WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaSwitch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSwitch@evro9s@" + idn, fieldConfig: field, form: form, formParams: formParams_1 }),
            React.createElement("div", { className: "form-item-error", dangerouslySetInnerHTML: { __html: form.$('templatename').$error } }))); })));
        return result;
    }
    else {
        return null;
    }
};
var isUrl = function (url) {
    var strRegex = '^((https|http|ftp|rtsp|mms)?://)'
        + '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' //ftp的user@
        + '(([0-9]{1,3}.){3}[0-9]{1,3}' // IP形式的URL- 199.194.52.184
        + '|' // 允许IP和DOMAIN（域名）
        + '([0-9a-z_!~*\'()-]+.)*' // 域名- www.
        + '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' // 二级域名
        + '[a-z]{2,6})' // first level domain- .com or .museum
        + '(:[0-9]{1,4})?' // 端口- :80
        + '((/?)|' // a slash isn't required if there is no file name
        + '(/[0-9a-z_!~*\'().;?:@&=+$,%#-]+)+/?)$';
    var re = new RegExp(strRegex);
    //re.test()
    if (re.test(url)) {
        return (true);
    }
    else {
        return (false);
    }
};
var UrlSearch = /** @class */ (function () {
    function UrlSearch(location) {
        var href = location.href;
        var num = href.indexOf("?");
        var str = href.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
        var arr = str.split("&"); //各个参数放到数组里
        for (var i = 0; i < arr.length; i++) {
            num = arr[i].indexOf("=");
            if (num > 0) {
                this[arr[i].substring(0, num)] = arr[i].substr(num + 1);
            }
        }
    }
    return UrlSearch;
}());

function removeHTMLTag(str) {
    str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
    str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
    //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
    str = str.replace(/&nbsp;/ig, ''); //去掉&nbsp;
    str = str.replace(/&gt;/ig, ">");
    str = str.replace(/&lt;/ig, "<");
    str = str.replace(/&quot;/ig, "\"");
    return str;
}
function getListKey(data) {
    if ('randomFieldSubKeyd_id' in data) {
        return data.randomFieldId + "_" + data.randomFieldSubKeyd_id;
    }
    else {
        return "" + data.randomFieldId;
    }
}
function getListMainKey(data) {
    return "" + data.randomFieldId;
}
function getListSubKey(data) {
    if ('randomFieldSubKeyd_id' in data) {
        return "" + data.randomFieldSubKeyd_id;
    }
    else {
        return '';
    }
}
/* harmony default export */ __webpack_exports__["default"] = (window);
var CardUtil = {
    findRowSpan: function (row, col, ecMap) {
        var find = false;
        for (var j = col; j >= 0 && !find; j--) {
            for (var i = row - 1; i >= 0 && !find; i--) {
                var cellObj = ecMap[i + "," + j];
                var rowSpan = cellObj ? (cellObj["rowspan"] || 1) : 0;
                var colSpan = cellObj ? (cellObj["colspan"] || 1) : 0;
                if (rowSpan > 1 && rowSpan >= (row - i + 1) && colSpan >= (col - j + 1)) {
                    find = true;
                }
            }
        }
        return find;
    }
};
var convertSpecialChar = function (str) {
    str = str.toString();
    str = str.replace(/<br>/ig, "\n");
    str = str.replace(/&nbsp;/ig, " ");
    str = str.replace(/&lt;/ig, "<");
    str = str.replace(/&gt;/ig, ">");
    str = str.replace(/&quot;/ig, "\"");
    str = str.replace(/&amp;/ig, "&");
    return str;
};
//代码块中 控制全局spin
var doGlobalSpin = function (spinInfo) {
    try {
        var isShow = spinInfo.isShow, size = spinInfo.size, tip = spinInfo.tip;
        if (isShow == 'show') {
            __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaLoadingGlobal"].start({ size: size, tip: tip });
        }
        else if (isShow == 'hide') {
            var timer_1 = setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaLoadingGlobal"].end(); // 停止遮罩loading
                __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaLoadingGlobal"].destroy(); // 销毁遮罩loading
                clearTimeout(timer_1);
            }, 500);
        }
    }
    catch (error) {
        console && console.log(error, 'error');
    }
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(492)();
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getContentPath; });
//二级路径加前缀
var getContentPath = function (url) {
    var ecologyContentPath = window['ecologyContentPath'] || ""; //二级路径
    if (ecologyContentPath != "" && !!url) {
        if (url.startsWith("/") && !url.startsWith(ecologyContentPath)) {
            url = ecologyContentPath + url;
        }
        else if (url.startsWith("http")) {
            var origin = window.location.origin;
            if (!origin) {
                origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
            }
            if (url.startsWith(origin) && !url.startsWith(origin + ecologyContentPath)) {
                url = url.replace(origin, origin + ecologyContentPath);
            }
        }
    }
    return url;
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isNumber; });
/* unused harmony export camelCase */
/* harmony export (immutable) */ __webpack_exports__["g"] = guid;
/* harmony export (immutable) */ __webpack_exports__["a"] = camelCaseObject;
/* harmony export (immutable) */ __webpack_exports__["e"] = getRowIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = getColIndex;
/* unused harmony export getDomId */
/* harmony export (immutable) */ __webpack_exports__["d"] = getDomIdByFieldKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkHref;
/* harmony export (immutable) */ __webpack_exports__["f"] = getUrlParams;
/* harmony export (immutable) */ __webpack_exports__["i"] = transitionCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

var isNumber = function (value) {
    var reg = /^[0-9]+.?[0-9]*$/;
    return reg.test(value);
};
function camelCase(name) {
    return name.replace(/-(\w)/g, function (_, n) {
        return n.toUpperCase();
    });
}
function guid(len, radix) {
    if (len === void 0) { len = 32; }
    if (radix === void 0) { radix = 16; }
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [];
    radix = radix || chars.length;
    if (len) {
        // Compact form
        for (var i = 0; i < len; i++)
            uuid[i] = chars[0 | Math.random() * radix];
    }
    else {
        // rfc4122, version 4 form
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        // Fill in random data. At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (var i = 0; i < 36; i++) {
            if (!uuid[i]) {
                var r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    return uuid.join('');
}
function camelCaseObject(obj) {
    var rt = {};
    if (obj && obj.constructor == String) {
        obj['split'](';').forEach(function (item) {
            var is = item.split(':');
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.set(rt, is[0] || '', is[1] || '');
        });
    }
    else {
        for (var key in obj) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.set(rt, camelCase(key), __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(obj, key));
        }
    }
    return rt;
}
function getRowIndex(id) {
    return parseInt(id.replace('row_', ''), 0);
}
function getColIndex(id) {
    return parseInt(id.replace('col_', ''), 0);
}
function getDomId(fieldid, detail, index) {
    if (detail) {
        return fieldid + "_" + index;
    }
    else {
        return fieldid;
    }
}
function getDomIdByFieldKey(fieldPath) {
    var fieldpaths = fieldPath.split('.');
    if (fieldpaths.length == 3) {
        return fieldpaths[2] + "_" + fieldpaths[1];
    }
    else {
        return fieldPath;
    }
}
function checkHref(href) {
    var exceptArr = [
        "/spa/workflow/index_form.jsp",
        "/spa/document/index.jsp",
        "/spa/hrm/index_mobx.html",
        "/spa/cube/index.html",
        "/spa/cube/index.jsp",
    ];
    for (var index = 0; index < exceptArr.length; index++) {
        var element = exceptArr[index];
        if (href.indexOf(element) > -1) {
            href = href.replace(/(jsp#)|(html#)/g, function (item) {
                return item.replace(/(jsp)|(html)/g, function (type) {
                    return type + ("?__random__=" + Date.now());
                });
            });
            return href;
        }
    }
    return href;
}
function getUrlParams() {
    if (!window.location.href.includes('?'))
        return;
    var hrefArr = window.location.href.split('?');
    var paramsArr = hrefArr.length > 1 ? hrefArr[hrefArr.length - 1].split('&') : [];
    var urlParams = {};
    paramsArr.forEach(function (item) {
        var key_val = item.split('=');
        urlParams[key_val[0]] = key_val[1];
    });
    return urlParams;
}
;
/*****
 * 处理url转换的特殊字符
 */
function transitionCode(params) {
    var tempobj = {};
    for (var key in params) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(params[key])) {
            tempobj[key] = params[key];
        }
        else {
            var value = params[key] && params[key].replace(/%2C/g, ",") || "";
            tempobj[key] = value;
        }
    }
    return tempobj;
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(91);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(517);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(521);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(91);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(496);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return showExportMenu; });
/* unused harmony export formPost */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return verifyCustomRegisterEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return showExpendError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isDragula; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isFromProtal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fixedDetailHead; });
/* unused harmony export syncFixedHeadWidth */
/* unused harmony export syncDetailScrollXPosition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateDetailAreaStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return importantParamRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return spellResourceCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return unSpellResourceCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getReConditionObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultValueSpan; });
/* unused harmony export toWrongLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _this = this;


var RadioGroup = __WEBPACK_IMPORTED_MODULE_1_antd__["Radio"].Group;


var getLabel = __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaLocaleProvider"].getLabel;

var showExportMenu = function (datas, billsid, modeid, type, comefrom, modeCustomid, dataKey, expcardname, layoutid, callBack) {
    var _a = expcardname.isExpOne, isExpOne = _a === void 0 ? '' : _a;
    showModal(getLabel(17416, '导出'), (React.createElement("div", { style: { minHeight: 100, maxHeight: 400, overflow: "scroll", margin: "-30px -50px", textAlign: 'center', } },
        isExpOne == '' ? React.createElement(RadioGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_RadioGroup@iqno60", onChange: function (e) {
                localStorage.setItem("cube_export_type", e.target.value);
            }, defaultValue: datas[0]['key'] || "" }, getRadioGroup(datas)) : '',
        expcardname && expcardname.key == "1" ? React.createElement(__WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@hpxels", style: datas.length > 1 ? { top: '0px' } : { top: '30px' }, label: getLabel(17517, '文件名称'), labelCol: { span: 6 }, wrapperCol: { span: 16 }, width: "20%" },
            React.createElement("div", null,
                React.createElement(__WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@iinc5i", value: expcardname.showname, width: "60%", onChange: function (e) {
                        localStorage.setItem("cube_export_name", e);
                    } }))) : "")), 400, billsid, modeid, layoutid ? layoutid : '0', type, comefrom, modeCustomid, dataKey, isExpOne, callBack);
};
var getRadioGroup = function (datas) {
    if (datas === void 0) { datas = []; }
    var radioArr = [];
    var radioStyle = {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        marginLeft: "10px",
    };
    for (var i = 0; i < datas.length; i++) {
        var item = datas[i];
        radioArr.push(React.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Radio"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Radio@efgyg3@" + i, style: radioStyle, key: item.key, value: item.key }, item.showname));
    }
    return radioArr;
};
var showModal = function (title, content, width, billsid, modeid, layoutid, type, comefrom, modeCustomid, dataKey, isExpOne, callBack) {
    if (width === void 0) { width = 400; }
    if (comefrom === void 0) { comefrom = ""; }
    if (modeCustomid === void 0) { modeCustomid = ""; }
    if (dataKey === void 0) { dataKey = ""; }
    if (isExpOne === void 0) { isExpOne = ""; }
    __WEBPACK_IMPORTED_MODULE_1_antd__["Modal"].info({
        title: React.createElement("span", null,
            React.createElement("div", { className: 'wea-browser-single-icon-circle', style: { background: "#96358a" } },
                React.createElement("i", { className: 'icon-coms-ModelingEngine' })),
            title),
        content: content,
        iconType: "",
        okText: getLabel(33703, "确认"),
        width: width,
        onOk: function () {
            if (type === "list") {
                if (localStorage.getItem("cube_export_type") == "list" || isExpOne == "1") { //如果选择的是列表EXCEL列表文件，走老的导出   ,当后台设置了一种导出类型的时候直接导出
                    var excelName = localStorage.getItem("cube_export_name");
                    typeof callBack == "function" && callBack(billsid, excelName);
                    return;
                }
                formPost(Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.formmode.expcard.servlet.ExpCardServer"), {
                    action: "expbatchcard",
                    fileType: localStorage.getItem("cube_export_type"),
                    billids: billsid,
                    modeId: modeid,
                    excelName: localStorage.getItem("cube_export_name"),
                    comefrom: comefrom,
                    modeCustomid: modeCustomid,
                    dataKey: dataKey
                });
            }
            else if (type === "card") {
                formPost(Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.formmode.expcard.servlet.ExpCardServer"), {
                    action: "expcard",
                    fileType: localStorage.getItem("cube_export_type"),
                    billid: billsid,
                    layoutid: layoutid,
                    modeId: modeid,
                    doInterface: 1
                });
            }
            setTimeout(function () {
                localStorage.setItem("cube_export_type", "");
                localStorage.setItem("cube_export_name", "");
            }, 500);
        },
    });
};
var formPost = function (URL, PARAMTERS) {
    if (URL === void 0) { URL = ""; }
    if (PARAMTERS === void 0) { PARAMTERS = {}; }
    //创建form表单
    var temp_form = document.createElement("form");
    temp_form.action = URL;
    //如需打开新窗口，form的target属性要设置为'_blank'
    temp_form.target = "_self";
    temp_form.method = "post";
    temp_form.style.display = "none";
    //添加参数
    for (var item in PARAMTERS) {
        var opt = document.createElement("input");
        opt.name = item;
        opt.value = PARAMTERS[item];
        temp_form.appendChild(opt);
    }
    document.body.appendChild(temp_form);
    //提交数据
    temp_form.submit();
};
//自定义注册事件校验
var verifyCustomRegisterEvent = function (params, callback, registerFnParams) {
    if (registerFnParams === void 0) { registerFnParams = {}; }
    var result = null;
    var opertype = convertOpertype(params);
    var eventArr = opertype === null ? new Array() : __WEBPACK_IMPORTED_MODULE_2__excelUtil__["modeForm"].eventList[opertype];
    //存在注册事件
    if (typeof eventArr === "object" && eventArr.length > 0) {
        var index_1 = 0;
        var executeVerify_1 = function () {
            if (index_1 < eventArr.length) {
                eventArr[index_1++](function () {
                    executeVerify_1();
                }, registerFnParams);
            }
            else {
                result = callback();
            }
        };
        executeVerify_1();
    }
    else {
        result = callback();
    }
    return result;
};
var convertOpertype = function (params) {
    if (typeof params === "string")
        return params;
    return null;
};
var showExpendError = function (pageExpendResult, href) {
    var content = [];
    var orihref = href;
    for (var data in pageExpendResult.errordata) {
        var pcontent = getLabel('512681', '执行{0}出错').replace(/\{0\}/, data) + "," + getLabel('512682', '数据id为') + ":" + pageExpendResult.errordata[data];
        var a = React.createElement("a", { href: orihref + "expanderrorid=" + pageExpendResult.errordata[data], target: "_blank", style: { marginLeft: 10, verticalAlign: 'middle' } }, getLabel('385156', '查看列表'));
        content.push(React.createElement("p", { style: { textAlign: 'center' } },
            React.createElement("span", { title: pcontent, style: { textAlign: 'left', width: '300px', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', whiteSpace: 'nowrap', verticalAlign: 'middle' } }, pcontent),
            a));
    }
    __WEBPACK_IMPORTED_MODULE_1_antd__["Modal"].error({
        width: 500,
        content: content
    });
};
/**
 *
 * @param pageExpendResult 明细表是否要拖动
 * @param href
 */
var isDragula = function (card, detail) {
    var type = card.base.type == '2' || card.base.type == '1';
    var detailtable = card.getDetailTable(detail);
    var excel = card.modeExcel.getExcel(detail);
    var _a = excel.detailProps.isPagination, isPagination = _a === void 0 ? false : _a;
    var isNeedPagination = (card.base.type == '0' || card.base.type == '1' || card.base.type == '2') && isPagination;
    var result = type && detailtable.isOpenCustomOrder && !isNeedPagination;
    return result;
};
/**
 * 是否来自门户菜单点击
 */
var isFromProtal = function () {
    var url = __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].WindowFunc.getTop().location.href;
    if (url.indexOf('/spa/cube/') > 0) {
        return false;
    }
    return true;
};
//滚动过程中控制表头固定
var fixedDetailHead = function () {
    var container = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.cube-card-form-content');
    var conOffsetTop = container.offset().top;
    container.find(".excelDetailTableDiv").each(function () {
        var groupid = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).attr("data-groupid");
        var detailFixedDiv = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).find("[class^=excelDetailFixedHead]");
        var detailTable = __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#oTable" + groupid);
        var lockedBtn = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).parent().find(".cube-detail-locked-btnrow");
        var existLockedBtn = lockedBtn.length > 0;
        var detailHeight = detailTable.height();
        var unFixedFn = function () {
            if (existLockedBtn) {
                lockedBtn.removeClass("cube-detail-locked-btnrow-fixed");
                calculateDetailAreaStyle(__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.cube-card-excelMainTable-wrapper'));
            }
            detailFixedDiv.hide();
        };
        if (detailHeight < 300) { //此if不能后移，会导致部分ios滑动闪屏，why...
            unFixedFn();
            return true;
        }
        var detailOffsetTop = detailTable.offset().top;
        var fixedHeadHeight = detailFixedDiv.height();
        var lockedBtnHeight = 0;
        if (existLockedBtn) {
            lockedBtnHeight = lockedBtn.height();
            detailHeight += lockedBtnHeight;
            fixedHeadHeight += lockedBtnHeight;
        }
        var fixedFn = function () {
            if (existLockedBtn) {
                lockedBtn.addClass("cube-detail-locked-btnrow-fixed");
                lockedBtn.find(".cube-detail-locked-btnrow-content").css("top", conOffsetTop);
            }
            detailFixedDiv.css("top", conOffsetTop + lockedBtnHeight).show();
            syncFixedHeadWidth(groupid);
            syncDetailScrollXPosition(groupid);
        };
        //冻结表头，明细表最低要求200px高度
        //console.log("groupid",groupid,"detailHeight",detailHeight,"detailOffsetTop",detailOffsetTop,"conOffsetTop",conOffsetTop,"fixedHeadHeight",fixedHeadHeight);
        if (detailOffsetTop < conOffsetTop && detailOffsetTop + detailHeight >= fixedHeadHeight + conOffsetTop) {
            fixedFn();
        }
        else {
            unFixedFn();
        }
    });
};
//同步列宽到固定表头,列锁定情况仅同步滚动区域
var syncFixedHeadWidth = function (groupid) {
    try {
        var detailTable = __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#oTable" + groupid);
        var detailFixedTable = __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#oTable" + groupid + "_head");
        var detailFixedDiv = detailFixedTable.parent();
        if (!detailFixedDiv.is(":hidden")) {
            detailFixedTable.width(detailTable.width());
            // const fixedWidthRow = detailFixedTable.find("tr.detailControlWidth");
            // detailTable.find("tr.detailControlWidth").children().each(function(index){
            //     fixedWidthRow.find("td:eq("+index+")").css("width", jQuery(this).width()+"px");
            // });
            var topRowWidth = detailFixedDiv.parent().width();
            var wrapperWidth = detailFixedDiv.parents('.cube-card-excelMainTable-wrapper').width();
            /* 解决固定表头宽度问题，谁小取谁 */
            if (wrapperWidth < 763) {
                topRowWidth = wrapperWidth;
                detailFixedDiv.css({ "margin-left": "-1px", "border-left": "1px solid #e7f3fc", "border-right": "1px solid #e7f3fc" });
            }
            else {
                detailFixedDiv.css({ "margin-left": "0px", "border-left": "none", "border-right": "none" });
            }
            detailFixedDiv.css("width", topRowWidth);
            calculateDetailAreaStyle(__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.cube-card-excelMainTable-wrapper'));
        }
    }
    catch (e) { }
};
//同步横向滚动条位置到固定表头
var syncDetailScrollXPosition = function (groupid) {
    try {
        var detailArea = window.jQuery("#dTableArea_" + groupid);
        var cardScrollLeft = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.cube-card-excelMainTable-wrapper').scrollLeft();
        var scrollLeft = detailArea.find(".excelDetailTable_wrap").scrollLeft() + cardScrollLeft;
        detailArea.find(".excelDetailFixedHead").scrollLeft(scrollLeft);
        detailArea.find(".excelDetailFixedHead_locked").css("width", detailArea.find("#oTable" + groupid + "_locked").width() - cardScrollLeft);
        detailArea.find("#oTable" + groupid + "_head_locked").css('marginLeft', 0 - cardScrollLeft);
    }
    catch (e) { }
};
//计算指定区域下明细表样式，兼容标签页内嵌明细情况
var calculateDetailAreaStyle = function (area) {
    if (area === void 0) { area = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(); }
    area.find(".cube-detail").each(function () {
        if (!__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).is(":visible"))
            return true;
        // const excelDetailTableDiv = jQuery(this).find(".excelDetailTableDiv");
        // const groupid = parseInt(excelDetailTableDiv.attr("data-groupid"));
        // const swapWidth = excelDetailTableDiv.width();
        // const dataAreaWidth = excelDetailTableDiv.find("#oTable"+groupid).width();
        // // const lockedAreaWidth = excelDetailTableDiv.find("#oTable"+groupid+"_locked") && excelDetailTableDiv.find("#oTable"+groupid+"_locked").width() || 0;
        // const detailObj = detailMap.get("detail_"+(groupid+1));
        // if(swapWidth >=dataAreaWidth ){     //宽度不足，横向滚动条失效
        //     detailObj.controlVariableMap("forceDisabledScrollX", true);
        // }
        var lockedBtnRow = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).find(".cube-detail-locked-btnrow");
        if (lockedBtnRow.length > 0) {
            var topRowHeight = lockedBtnRow.height();
            var topRowWidth = lockedBtnRow.parent().width();
            var wrapperWidth = lockedBtnRow.parents('.cube-card-excelMainTable-wrapper').width();
            var isFixed = lockedBtnRow.hasClass('cube-detail-locked-btnrow-fixed');
            /* 解决固定表头宽度问题，谁小取谁 */
            if (isFixed && wrapperWidth < 763) {
                topRowWidth = wrapperWidth;
                lockedBtnRow.find(".cube-detail-locked-btnrow-content").css('margin-left', '-1px'); // 固定表头错位问题
            }
            else {
                lockedBtnRow.find(".cube-detail-locked-btnrow-content").css('margin-left', '0px'); // 固定表头错位问题
            }
            lockedBtnRow.find(".cube-detail-locked-btnrow-content").width(topRowWidth);
            lockedBtnRow.find(".cube-detail-locked-btnrow-placeholder").height(topRowHeight);
        }
        // syncLockedForDidMount(groupid);
    });
};
var importantParamRange = ["token", "billid", "type", "modeId", "formId", "customid", "layoutid", "isFormMode", "iscreate", "src",
    "currentLayoutId", "pageexpandid", "JSONStr", "btntype", "issystemflag", "oldmodedatastatus"
];
//人力资源条件数据处理 sharetype_relatedshare_rolelevel_seclevel_canDownload
var spellResourceCondition = function (datas) {
    if (datas) {
        var value_1 = [];
        datas.map(function (item) {
            var candownload = item.canDownload == '是' ? '1' : '0';
            if (item.sharetype == "1") {
                value_1.push("1_" + item.relatedshare + "_0_0_" + candownload);
            }
            else if (item.sharetype == "2" || item.sharetype == "3") {
                value_1.push(item.sharetype + "_" + item.relatedshare + "_0_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "4") {
                value_1.push("4_" + item.relatedshare + "_" + item.rolelevel + "_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "5") {
                value_1.push("5_0_0_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "6") {
                if (item.joblevel == '2') {
                    value_1.push("6_" + item.relatedshare + "_0_2|@|2_" + candownload);
                }
                else {
                    value_1.push("6_" + item.relatedshare + "_0_" + item.joblevel + "|@|" + item.jobfield + "_" + candownload);
                }
            }
        });
        return value_1.join('~');
    }
    return '';
};
var unSpellResourceCondition = function (str) {
    if (str === void 0) { str = ''; }
    var array = str.split('~');
    return array.map(function (item) {
        var obj = {};
        var valArr = item.split('_');
        var sharetype = valArr[0];
        obj.sharetype = sharetype;
        if (sharetype == '1') {
            obj.relatedshare = valArr[1];
        }
        else if (sharetype == "2" || sharetype == "3") {
            obj.relatedshare = valArr[1];
            obj.seclevel = valArr[3].replace('|@|', '-');
        }
        else if (sharetype == "4") {
            obj.relatedshare = valArr[1];
            obj.rolelevel = valArr[2];
            if (valArr[2] == '0') {
                obj.rolelevelspan = getLabel(27511, '部门');
            }
            if (valArr[2] == '1') {
                obj.rolelevelspan = getLabel(33553, '分部');
            }
            if (valArr[2] == '2') {
                obj.rolelevelspan = getLabel(140, '总部');
            }
            obj.seclevel = valArr[3].replace('|@|', '-');
        }
        else if (sharetype == "5") {
            obj.seclevel = valArr[3].replace('|@|', '-');
        }
        else if (sharetype == "6") {
            obj.relatedshare = valArr[1];
            if (valArr[3] == '2|@|2') {
                obj.joblevel = '2';
            }
            else {
                var temp = valArr[3].split('|@|');
                obj.joblevel = temp[0];
                obj.jobfield = temp[1];
            }
        }
        obj.canDownload = valArr[4] && valArr[4] == '1' ? getLabel(163, '是') : getLabel(30587, '否');
        return obj;
    });
};
var getTypeName = function (sharetype) {
    var TYPEFLECT = {
        '1': getLabel(30042, '人员'),
        '2': getLabel(33553, '分部'),
        '3': getLabel(27511, '部门'),
        '4': getLabel(122, '角色'),
        '5': getLabel(1340, '所有人'),
        '6': getLabel(6086, '岗位'),
    };
    return TYPEFLECT[sharetype] || "";
};
var getReConditionObj = function (val, name) {
    var sharetype = val.sharetype;
    if (sharetype == '5') {
        name = getLabel(1340, '所有人');
    }
    else {
        var nametemp = name.match(/\((.*)\)/);
        if (nametemp && nametemp.length > 1) {
            name = nametemp[1];
        }
    }
    var valueObj = {
        key: val.relatedshare || "",
        id: val.relatedshare || "",
        name: name,
        relatedshare: val.relatedshare || "",
        relatedsharespan: name,
        relatedshareurl: "/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/" + val.relatedshare || '',
        sharetype: sharetype || "",
        sharetypespan: getTypeName(sharetype),
        canDownload: val.canDownload,
        seclevel: val.seclevel || '',
    };
    if (sharetype == '4') {
        valueObj = __assign({}, valueObj, { rolelevel: val.rolelevel || '', rolelevelspan: val.rolelevelspan || '', relatedshareurl: "/hrm/roles/HrmRolesEdit.jsp?id=" + val.relatedshare || "" });
    }
    else if (sharetype == '5') {
        delete valueObj.relatedshare;
        delete valueObj.relatedsharespan;
        delete valueObj.relatedshareurl;
    }
    else if (sharetype == '6') {
        var nameJob = [];
        if (name.indexOf('/') > -1) {
            nameJob = name.split('/');
        }
        var oterInfo = {};
        if (val.joblevel !== '2') {
            try {
                oterInfo = {
                    jobfield: val.jobfield,
                    jobfieldspan: nameJob[1].match(/\((.*)\)/)[1].trim().split(" ").join(","),
                };
            }
            catch (error) { }
        }
        var jobSpan = [getLabel(500670, '指定部门'), getLabel(19437, '指定分部'), getLabel(140, '总部')];
        valueObj = __assign({}, valueObj, oterInfo, { name: nameJob.length > 0 ? nameJob[0] : name, relatedsharespan: nameJob.length > 0 ? nameJob[0] : name, joblevel: val.joblevel, joblevelspan: jobSpan[val.joblevel] });
    }
    return valueObj;
};
var getDefaultValueSpan = function (valuespan, value) {
    try {
        return valuespan.replace(/<\/?[^>]*>/g, '');
    }
    catch (error) {
        return valuespan;
    }
};
/**
 * @description 自动定位到showError的报错信息位置
 * */
var toWrongLocation = function () {
    try {
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wea-error.has-error .error-tip').eq(0).attr('hidefocus', true).attr('tabIndex', '0').focus().removeAttr('tabIndex');
        }, 0);
    }
    catch (err) {
    }
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export url */
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* unused harmony export saveCubeLikeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(7);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var url = '/api/formmode/page/';
var newUrl = '/api/cube/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                // reject();
                // window.weaHistory.push('/main/cube/noright');
                resolve(__assign({ noRight: noRight }, data));
            }
            else {
                resolve(data);
            }
        });
    });
};
__WEBPACK_IMPORTED_MODULE_1__util__["default"].WeaTools = __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"];
var init = function (params) {
    var result = CallAPI(url + "init", "get", params);
    return result;
};
var update = function (params) {
    var result = CallAPI(url + "update", "post", params);
    return result;
};
var datas = function (params) {
    var result = CallAPI(url + "datas", "post", params);
    return result;
};
var dataKey = function (params) {
    var result = CallAPI(newUrl + "search/getList", "post", params);
    return result;
};
var getCountData = function (params) {
    var result = CallAPI("/api/cube/search/getCountData", "post", params);
    return result;
};
var getGroupData = function (params) {
    var result = CallAPI("/api/cube/search/getGroupData", "post", params);
    return result;
};
var amkjzgSlectOption = function (params) {
    var result = CallAPI(newUrl + "search/getamkjzgSlectOption", "get", params);
    return result;
};
var amkjzgdataKey = function (params) {
    var result = CallAPI(newUrl + "search/getamkjzgList", "get", params);
    return result;
};
var cleanCol = function (params) {
    var result = CallAPI(newUrl + "search/cleanCol", "get", params);
    return result;
};
var edit = function (params) {
    return CallAPI(url + "edit", "post", params);
};
var doInterface = function (params) {
    return CallAPI(newUrl + "expand/interface", "post", params);
};
var initSearch = function (params) {
    return CallAPI(newUrl + "search/init", "get", params);
};
var deleteData = function (params) {
    return CallAPI(newUrl + "expand/deleteData", "get", params);
};
var getConditionInfo = function (params) {
    return CallAPI(newUrl + "search/condition", "get", params);
};
var getAdvancedInfo = function (params) {
    return CallAPI(newUrl + "search/advanced", "get", params);
};
var getTitleField = function (params) {
    return CallAPI(newUrl + "search/getTitleField", "get", params);
};
var getBarCode = function (params) {
    return CallAPI(newUrl + "expand/getBarCode", "get", params);
};
var getQrCode = function (params) {
    return CallAPI(newUrl + "expand/getQrCode", "get", params);
};
var getConditionParams = function (params) {
    return CallAPI(newUrl + "search/getConditionParams", "get", params);
};
var getTemplates = function (params) {
    return CallAPI(newUrl + "search/getTemplate", "get", params);
};
var getTemplateInfo = function (params) {
    return CallAPI(newUrl + "search/getTemplateInfo", "get", params);
};
var saveTemplate = function (params) {
    return CallAPI(newUrl + "search/saveTemplate", "POST", params);
};
var batchShareCondition = function (params) {
    return CallAPI(newUrl + "right/getConditions", "get", params);
};
var saveBatchShare = function (params) {
    return CallAPI(newUrl + "right/saveBatchShare", "get", params);
};
var analyzePageExpandLinkUrl = function (params) {
    return CallAPI(newUrl + "expand/analyzePageExpandLinkUrl", "get", params);
};
var getMapTitles = function (params) {
    return CallAPI(newUrl + "expand/getMapTitles", "get", params);
};
var batchSave = function (params) {
    return CallAPI(newUrl + "expand/batchSave", "get", params);
};
var saveTabBatch = function (params) {
    return CallAPI('/api/cube/tab/saveTabBatch', "post", params);
};
var getTemplateList = function (params) {
    return CallAPI(newUrl + "search/getTemplateList", "get", params);
};
var saveOrUpdateTemplate = function (params) {
    return CallAPI(newUrl + "search/saveOrUpdateTemplate", "POST", params);
};
var deleteTemplate = function (params) {
    return CallAPI(newUrl + "search/deleteTemplate", "get", params);
};
var setDefault = function (params) {
    return CallAPI(newUrl + "search/setDefault", "get", params);
};
var getColumnSetInfo = function (params) {
    return CallAPI(newUrl + "search/getColumnSetInfo", "get", params);
};
var saveTemplateField = function (params) {
    return CallAPI(newUrl + "search/saveTemplateField", "POST", params);
};
var getSearchColumnInfo = function (params) {
    return CallAPI(newUrl + "search/getSearchColumnInfo", "get", params);
};
var batchEditSave = function (params) {
    return CallAPI(newUrl + "search/batchEditSave", "POST", params);
};
var checkDataChange = function (params) {
    return CallAPI(newUrl + "search/checkDataChange", "POST", params);
};
var getBatchModifyField = function (params) {
    return CallAPI(newUrl + "search/getBatchModifyField", "GET", params);
};
var saveBatchModifyField = function (params) {
    return CallAPI(newUrl + "search/saveBatchModifyField", "POST", params);
};
var batchEditGetVerifyField = function (params) {
    return CallAPI(newUrl + "search/batchEditGetVerifyField", "GET", params);
};
var batchEditVerifyData = function (params) {
    return CallAPI(newUrl + "search/batchEditVerifyData", "POST", params);
};
var getAppInfoByID = function (params) {
    return CallAPI(newUrl + "mode/app/getAppInfoByID", "GET", params);
};
var getJsCodeArea = function (params) {
    return CallAPI(newUrl + "list/getJsCodeArea", "GET", params);
};
var checkDataIsChange = function (params) {
    return CallAPI(newUrl + "search/checkDataIsChange", "GET", params);
};
var doExcelExpost = function (params) {
    return CallAPI(newUrl + "search/doExcelExpost", "POST", params);
};
var getExcelExpProgress = function (params) {
    return CallAPI(newUrl + "search/getExcelExpProgress", "GET", params);
};
var cancelExcelExp = function (params) {
    return CallAPI(newUrl + "search/cancelExcelExp", "POST", params);
};
var checkCanExcelExp = function (params) {
    return CallAPI(newUrl + "search/checkCanExcelExp", "POST", params);
};
var getOriginalTableWidth = function (params) {
    return CallAPI(newUrl + "search/getOriginalTableWidth", "GET", params);
};
var backUpData = function (params) {
    return CallAPI("/api/cube/mode/mode/backUpData", "POST", params);
};
var saveCubeLikeInfo = function (params) {
    return CallAPI(newUrl + "new/card/saveCubeLikeInfo", "get", params);
};
var doDelLoadingpost = function (params) {
    return CallAPI(newUrl + "search/doDelLoadingpost", "POST", params);
};
var getDelLoadingProgress = function (params) {
    return CallAPI(newUrl + "search/getDelLoadingProgress", "GET", params);
};
var modeSecondaryVerify = function (params) {
    return CallAPI(newUrl + "search/modeSecondaryVerify", "POST", params);
};
var updateFreeSecretTime = function (params) {
    return CallAPI(newUrl + "search/updateFreeSecretTime", "GET", params);
};
var showLittleCard = function (params) {
    return CallAPI(newUrl + "list/showLittleCard", "GET", params);
};
var saveLittleCardFieldValue = function (params) {
    return CallAPI(newUrl + "list/saveLittleCardFieldValue", "POST", params);
};
var getRowClickHref = function (params) {
    return CallAPI(newUrl + "list/getRowClickHref", "get", params);
};
/* harmony default export */ __webpack_exports__["a"] = ({
    init: init,
    dataKey: dataKey,
    amkjzgdataKey: amkjzgdataKey,
    amkjzgSlectOption: amkjzgSlectOption,
    cleanCol: cleanCol,
    datas: datas,
    edit: edit,
    update: update,
    doInterface: doInterface,
    initSearch: initSearch,
    deleteData: deleteData,
    doDelLoadingpost: doDelLoadingpost,
    getDelLoadingProgress: getDelLoadingProgress,
    getConditionInfo: getConditionInfo,
    getAdvancedInfo: getAdvancedInfo,
    getTitleField: getTitleField,
    getBarCode: getBarCode,
    getQrCode: getQrCode,
    getConditionParams: getConditionParams,
    getTemplates: getTemplates,
    getTemplateInfo: getTemplateInfo,
    saveTemplate: saveTemplate,
    batchShareCondition: batchShareCondition,
    saveBatchShare: saveBatchShare,
    analyzePageExpandLinkUrl: analyzePageExpandLinkUrl,
    getMapTitles: getMapTitles,
    batchSave: batchSave,
    saveTabBatch: saveTabBatch,
    getTemplateList: getTemplateList,
    saveOrUpdateTemplate: saveOrUpdateTemplate,
    deleteTemplate: deleteTemplate,
    setDefault: setDefault,
    getColumnSetInfo: getColumnSetInfo,
    saveTemplateField: saveTemplateField,
    getSearchColumnInfo: getSearchColumnInfo,
    batchEditSave: batchEditSave,
    checkDataChange: checkDataChange,
    getBatchModifyField: getBatchModifyField,
    saveBatchModifyField: saveBatchModifyField,
    batchEditGetVerifyField: batchEditGetVerifyField,
    batchEditVerifyData: batchEditVerifyData,
    getAppInfoByID: getAppInfoByID,
    getJsCodeArea: getJsCodeArea,
    checkDataIsChange: checkDataIsChange,
    doExcelExpost: doExcelExpost,
    getExcelExpProgress: getExcelExpProgress,
    cancelExcelExp: cancelExcelExp,
    checkCanExcelExp: checkCanExcelExp,
    getOriginalTableWidth: getOriginalTableWidth,
    backUpData: backUpData,
    saveCubeLikeInfo: saveCubeLikeInfo,
    modeSecondaryVerify: modeSecondaryVerify,
    updateFreeSecretTime: updateFreeSecretTime,
    showLittleCard: showLittleCard,
    saveLittleCardFieldValue: saveLittleCardFieldValue,
    getRowClickHref: getRowClickHref,
    getCountData: getCountData,
    getGroupData: getGroupData
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(293);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modeForm", function() { return modeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MyCustomDialog", function() { return MyCustomDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "syncLockedForDidMount", function() { return syncLockedForDidMount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_excel_layout_cell_field_browser_element_Browser__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stores__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__excelUtil2__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_excel_layout_TableCell__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cubeUtil__ = __webpack_require__(19);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// import jQuery from "jquery";














__WEBPACK_IMPORTED_MODULE_10_jquery___default.a.fn.extend({
    bindPropertyChange: function (funobj) {
        return this.each(function () {
            var thisid = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this).attr('id');
            __WEBPACK_IMPORTED_MODULE_0____["default"].ModeForm.addPropertyChangeFn(thisid, funobj);
        });
    }
});
var modeForm = __assign({ dialogObj: undefined, __propertyChangeFnObj: {}, __detailFieldChangeFnObj: {}, 
    /**
     * 获取当前的卡片的store
     */
    getCurrentModeStore: function () {
        var currentCardStore;
        if (!__WEBPACK_IMPORTED_MODULE_0____["default"].location.href.includes('cube')) {
            var uuid = __WEBPACK_IMPORTED_MODULE_0____["default"].location.hash.slice(__WEBPACK_IMPORTED_MODULE_0____["default"].location.hash.lastIndexOf("=") + 1);
            currentCardStore = __WEBPACK_IMPORTED_MODULE_0____["default"].Card[uuid];
        }
        else if (__WEBPACK_IMPORTED_MODULE_0____["default"].location.href.includes('/cube/viewResource') || __WEBPACK_IMPORTED_MODULE_5__stores__["default"].cubeViewResource.visible) {
            /***
             * //针对资源面板里面的card页面，cardstore是单独的
             * 或者自定义页面配置了资源面板
             */
            currentCardStore = __WEBPACK_IMPORTED_MODULE_5__stores__["default"].cubeViewResource.card;
        }
        else if (__WEBPACK_IMPORTED_MODULE_0____["default"].location.href.includes('/cube/viewCustomPage')) { //针对自定义页面里面的card页面，cardstore是单独的
            currentCardStore = __WEBPACK_IMPORTED_MODULE_5__stores__["default"].customPageStore.card;
            if (__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#cube-custompage-div").eq(0) && __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#cube-custompage-div").eq(0).parent('.cube-custompage-container').css('display') == 'block') { // 自定义页面内嵌卡片
                currentCardStore = __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#cube-custompage-div")[0].contentWindow.cubeStore.Card;
            }
        }
        else if (__WEBPACK_IMPORTED_MODULE_0____["default"].location.href.includes('/cube/tree')) {
            currentCardStore = __WEBPACK_IMPORTED_MODULE_5__stores__["default"].Card;
            if (__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#cube-tree-mainFrame").eq(0) && __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#cube-tree-mainFrame").eq(0).parent('.cube-tree-main-frame').css('display') == 'block') { // 树节点挂载卡片
                currentCardStore = __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#cube-tree-mainFrame")[0].contentWindow.cubeStore.Card;
            }
        }
        else {
            currentCardStore = __WEBPACK_IMPORTED_MODULE_5__stores__["default"].Card;
            if (__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#tabcontentviewframe")[0] && __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#tabcontentviewframe")[0].src.indexOf('#/main/cube/card') > -1) { // 卡片页面扩展顶部卡片
                currentCardStore = __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#tabcontentviewframe")[0].contentWindow.cubeStore.Card;
            }
            if (currentCardStore.isCardShow) { //卡片页面扩展内嵌卡片
                currentCardStore = __WEBPACK_IMPORTED_MODULE_5__stores__["default"].Card.card;
            }
        }
        return currentCardStore;
    }, 
    /**
    * 字段名称转换为字段id
    * @param symbol  主表/明细表标示，main/detail_1/detail_2，默认为main
    * @param prefix 是否需要field字符串前缀，默认为true
    */
    convertFieldNameToId: function (fieldname, symbol, prefix) {
        symbol = !!symbol ? symbol : "main";
        prefix = typeof prefix === "undefined" ? true : prefix;
        var fieldNameMap = this.getCurrentModeStore().fieldNameMap;
        var fieldKey = symbol + "." + fieldname.toUpperCase();
        var fieldid = "";
        if (fieldNameMap.has(fieldKey)) {
            fieldid = fieldNameMap.get(fieldKey);
            fieldid = prefix ? "field" + fieldid : fieldid;
        }
        return fieldid;
    }, 
    /**
    * 获取字段值
    */
    getFieldValue: function (fieldMark) {
        var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
        var fieldProps = this.getFieldInfo(fieldid);
        if (fieldProps.isdetail) {
            var detailindex = fieldProps["detail"];
            return this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid).values();
        }
        else {
            return this.getCurrentModeStore().cubeForm.$(fieldMark).values();
        }
    }, 
    /**
    * 获取字段值对象
    */
    getFieldValueObj: function (fieldMark) {
        var fieldObj = this.getFieldObj(fieldMark);
        return fieldObj === null ? {} : fieldObj;
    }, getFieldObj: function (fieldMark) {
        if (fieldMark.indexOf("field") === -1)
            return null;
        var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
        var fieldProps = this.getFieldInfo(fieldid);
        if (fieldProps.isdetail) {
            var detailindex = fieldProps["detail"];
            var bindObj = this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid).bind();
            return {
                value: bindObj.value,
                valueSpan: bindObj.valueSpan,
                specialobj: bindObj.valueObj
            };
        }
        else {
            var bindObj = this.getCurrentModeStore().cubeForm.$(fieldMark).bind();
            return {
                value: bindObj.value,
                valueSpan: bindObj.valueSpan,
                specialobj: bindObj.valueObj
            };
        }
    }, 
    /**
   * 修改字段值，适用范围(单行文本、多行文本、选择框、浏览框、check框(0/1))
   * @params valueInfo(JSON)    非浏览框格式为：valueObj ="修改后的值"，
   *   *                specialobj为浏览按 钮信息，数组格式;
   *                showhtml属性只在文本字段类型且只读情况下生效；
   */
    changeFieldValue: function (fieldMark, valueInfo, type) {
        if (type === void 0) { type = ""; }
        var that = this;
        try {
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldProps = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(that.getFieldInfo(fieldid));
            var _cubeForm = this.getCurrentModeStore().cubeForm;
            if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(valueInfo)) {
                var valueObj = void 0;
                if (valueInfo.specialobj && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(valueInfo.specialobj)) {
                    valueObj = valueInfo.specialobj;
                }
                else {
                    valueObj = valueInfo.value;
                }
                var isEqualShowHtml = true;
                var oldShowhtml = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.getCurrentModeStore().allFields, fieldid).showhtml;
                if (oldShowhtml && valueInfo.showhtml) {
                    isEqualShowHtml = oldShowhtml === valueInfo.showhtml;
                    if (!isEqualShowHtml) {
                        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(this.getCurrentModeStore().allFields, fieldid + ".showhtml", valueInfo.showhtml);
                    }
                }
                else if (oldShowhtml || valueInfo.showhtml) {
                    isEqualShowHtml = false;
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(this.getCurrentModeStore().allFields, fieldid + ".showhtml", oldShowhtml ? '' : valueInfo.showhtml);
                }
                if (fieldProps && (fieldProps.fieldhtmltype == '1' && fieldProps.fieldtype == '2')) { //整数
                    valueObj = valueObj ? String(valueObj).split('.')[0] : '';
                }
                var newval = valueObj;
                var oldval = '';
                if (fieldProps.isdetail) {
                    var detailindex = fieldProps["detail"];
                    if (fieldProps && fieldProps.fieldhtmltype == 3) { //浏览按钮
                        oldval = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(_cubeForm.$(detailindex).$(index).$(fieldid).valueObj);
                    }
                    else if (type == 'upload') {
                        _cubeForm.$(detailindex).$(index).$(fieldid).setUploadData({ filedatas: valueInfo });
                        return;
                    }
                    else {
                        oldval = _cubeForm.$(detailindex).$(index).$(fieldid).values();
                    }
                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(oldval, newval) && isEqualShowHtml) {
                        return;
                    }
                    _cubeForm.setValue(detailindex + "." + index + "." + fieldid, valueObj);
                }
                else {
                    if (fieldProps && fieldProps.fieldhtmltype == 3) { //浏览按钮
                        oldval = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(_cubeForm.$(fieldMark).valueObj);
                    }
                    else if (type == 'upload') {
                        _cubeForm.$(fieldMark).setUploadData({ filedatas: valueInfo });
                        return;
                    }
                    else {
                        oldval = _cubeForm.$(fieldMark).values();
                    }
                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(oldval, newval) && isEqualShowHtml) {
                        return;
                    }
                    _cubeForm.setValue(fieldMark, valueObj);
                }
            }
        }
        catch (e) {
        }
    }, 
    /**
   * 修改字段只读/可编辑/必填/隐藏属性/隐藏行，此接口优先级低于标准功能显示属性联动(即设置了显示属性联动的可能覆盖此设置)
   * @params viewAttr(int)  1：只读，2：可编辑，3：必填，4：隐藏字段标签及 内容,5:隐藏行，注意目前只有主表有隐藏行功能
   */
    changeFieldAttr: function (fieldMark, viewAttr) {
        var that = this;
        try {
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldProps = that.getFieldInfo(fieldid);
            if (viewAttr == "1") {
                viewAttr = 3;
            }
            else if (viewAttr == "2") {
                viewAttr = 1;
            }
            else if (viewAttr == "3") {
                viewAttr = 2;
            }
            if (fieldProps.isdetail) {
                var detailindex = fieldProps["detail"];
                this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid).setViewAttrs("", viewAttr);
            }
            else {
                if (this.getCurrentModeStore().cubeForm.has(fieldid)) {
                    // 如果隐藏了行,修改为未隐藏行
                    this.getCurrentModeStore().cubeForm.$(fieldid).viewAttrs[""] == '5' && viewAttr != '5' &&
                        this.getCurrentModeStore().cubeForm.$(fieldid).hideOrShowTr(false);
                    this.getCurrentModeStore().cubeForm.$(fieldid).setViewAttrs("", viewAttr);
                }
            }
        }
        catch (e) {
        }
    }, 
    /**
     * 修改单个字段属性，修改值同时修改显示属性,这个方法目前不需要
     * @params valueInfo(obj) 可为空，变更的字段值
     */
    changeSingleField: function (fieldMark, valueObj, variableInfo) {
        if (valueObj) {
            this.changeFieldValue(fieldMark, valueObj);
        }
        if (variableInfo && variableInfo.viewAttr) {
            this.changeFieldAttr(fieldMark, variableInfo.viewAttr);
        }
    }, 
    /**
    * 批量修改多个字段值及属性
    * @params changeDatas(obj)  格式{field110:{value:"11"},field111_1:{value:"22"}
    * @params changeVariable(obj) 格式{field110:{viewAttr:1},field111_1:{viewAttr:3}}
    */
    changeMoreField: function (changeDatas, changeVariable) {
        if (changeDatas === void 0) { changeDatas = {}; }
        if (changeVariable === void 0) { changeVariable = {}; }
        var that = this;
        try {
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(changeDatas, function (value, key) {
                return that.changeFieldValue(key, value);
            });
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(changeVariable, function (value, key) {
                return that.changeFieldAttr(key, value["viewAttr"]);
            });
        }
        catch (e) {
        }
    }, 
    /**
     * 添加明细并赋值
     * @param fieldMark
     *
     */
    addDetailRow: function (detailMark, initialData) {
        if (initialData === void 0) { initialData = {}; }
        var _a, _b;
        var that = this;
        try {
            var orderid = detailMark.split("_")[1];
            this.getCurrentModeStore().cubeForm.addRow(orderid);
            //const len = this.getCurrentModeStore().cubeForm.$(detailMark).values().length;
            if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(initialData)) {
                var detailData_1 = {};
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(initialData, function (value, key) {
                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(value['value'])) {
                        detailData_1[key] = that.deal4ReplaceDatas(value['value'], key);
                    }
                    else {
                        detailData_1[key] = value['value'];
                    }
                });
                var field = this.getCurrentModeStore().cubeForm.$(detailMark);
                var fields = field.map(function (d) { return parseInt(d.key); });
                var maxIndex = fields.length > 0 ? Math.max.apply(Math, fields) : 0;
                var key = "" + (maxIndex ? maxIndex : 0);
                this.getCurrentModeStore().cubeForm.updateValues((_a = {}, _a[detailMark] = (_b = {}, _b[key] = detailData_1, _b), _a), {});
                //this.getCurrentModeStore().cubeForm.updateValues({ [detailMark]: { [len]: detailData } }, {})
            }
        }
        catch (error) {
        }
    }, 
    /**
    * 删除明细行,没有提示删除的确认框(会清空明细已选情况)
    * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
    *
    */
    delDetailRow: function (detailMark, rowIndexMark) {
        try {
            if (this.getCurrentModeStore().cubeForm.has(detailMark)) {
                this.getCurrentModeStore().cubeForm.delDetailRow(detailMark, rowIndexMark);
            }
        }
        catch (error) {
        }
    }, 
    /**
    * 选中明细行
    * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
    * @params rowIndexMark(String) 明细行标示，全部选中:all,选中部分："0,1，2，3"
    * @params needClearBeforeChecked(Boolean) 是否需要清除已有选中，默认为false
    */
    checkDetailRow: function (detailMark, rowIndexMark, needClearBeforeChecked) {
        var _a;
        try {
            var obj_1 = {};
            var valueArr_1 = this.getCurrentModeStore().cubeForm.$(detailMark).values();
            if (rowIndexMark == "all") {
                valueArr_1 && valueArr_1.length > 0 && valueArr_1.map(function (data, index) {
                    var _a;
                    obj_1 = __assign({}, obj_1, (_a = {}, _a[index] = __assign({}, data, { checkbox: "1" }), _a));
                });
            }
            else {
                var rowIndexMarkArr = rowIndexMark.split(",");
                if (needClearBeforeChecked) {
                    valueArr_1 = valueArr_1.map(function (data) { return __assign({}, data, { checkbox: "0" }); });
                }
                rowIndexMarkArr && rowIndexMarkArr.length > 0 && rowIndexMarkArr.map(function (data) {
                    var _a;
                    obj_1 = __assign({}, obj_1, (_a = {}, _a[data] = __assign({}, valueArr_1[data], { checkbox: "1" }), _a));
                });
            }
            this.getCurrentModeStore().cubeForm.updateValues((_a = {}, _a[detailMark] = __assign({}, valueArr_1, obj_1), _a));
        }
        catch (error) {
        }
    }, 
    /**
   * 获取明细所有行标示，逗号分隔
   * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
   */
    getDetailAllRowIndexStr: function (detailMark) {
        try {
            var indexArr = this.getCurrentModeStore().cubeForm.$(detailMark).map(function (d) { return d.key; });
            return "" + indexArr;
        }
        catch (error) {
        }
    }, 
    /**
        * 根据字段id获取对应的明细行数据库key值
        */
    getDetailRowKey: function (fieldMark) {
        var that = this;
        try {
            if (fieldMark.indexOf("field") === -1 || fieldMark.indexOf("_") === -1)
                return -1;
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldInfo = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(that.getFieldInfo(fieldid));
            var row = void 0;
            if (fieldInfo.isdetail) {
                var detailindex = fieldInfo["detail"];
                row = this.getCurrentModeStore().cubeForm.$(detailindex).$(index).values();
            }
            var id = row.dtl_id ? row.dtl_id : -1;
            return id;
        }
        catch (e) {
            return -2;
        }
    }, 
    /**
    * 控制明细点添加是否复制指定行记录(不复制附件上传字段)
    * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
    * @params needCopy(Boolean)  true需要复制，false取消复制
    */
    setDetailAddUseCopy: function (detailMark, needCopy) {
        var that = this;
        try {
            if (needCopy) {
                var initParams = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.last(this.getCurrentModeStore().cubeForm.$(detailMark).values());
                that.addDetailRow(detailMark, initParams);
            }
            else {
                that.addDetailRow(detailMark, {});
            }
        }
        catch (error) {
        }
    }, 
    /**
    * 浏览按钮请求数据接口，支持传输自定义参数，联想输入及弹窗都支持
    */
    appendBrowserDataUrlParam: function (fieldMark, jsonParam) {
        if (jsonParam === void 0) { jsonParam = {}; }
        var that = this;
        try {
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldInfo = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(that.getFieldInfo(fieldid));
            var tempParams = this.getCurrentModeStore().allFields[fieldid].browserProps.dataParams || {};
            if (fieldInfo && fieldInfo.fieldhtmltype == 3) {
                if (fieldInfo.isdetail) { //明细表
                    var detailindex = fieldInfo["detail"];
                    var detailProps = this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid);
                    detailProps.dataParams = __assign({}, tempParams, jsonParam);
                }
                else {
                    this.getCurrentModeStore().cubeForm.$(fieldid).dataParams = __assign({}, tempParams, jsonParam);
                }
            }
        }
        catch (error) {
        }
    }, 
    /**
    * 获取浏览按钮字段对应的显示值
    */
    getBrowserShowName: function (fieldMark, splitChar) {
        if (splitChar === void 0) { splitChar = ","; }
        var showname = "";
        var showNameArr = [];
        var that = this;
        try {
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldProps = that.getFieldInfo(fieldid);
            if (fieldProps.isdetail) {
                var detailindex = fieldProps["detail"];
                showNameArr = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid).valueObj);
            }
            else {
                showNameArr = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(this.getCurrentModeStore().cubeForm.$(fieldMark).valueObj);
            }
        }
        catch (e) {
        }
        var tempArr = [];
        showNameArr.map(function (item) {
            tempArr.push(item.name);
        });
        showname = tempArr.join(splitChar);
        return showname;
    }, 
    /**
    * 移除选择框字段选项  被移除之外其他选项可选
    */
    removeSelectOption: function (fieldMark, optionKeys) {
        var that = this;
        try {
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldInfo = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(that.getFieldInfo(fieldid));
            var newOptions_1 = fieldInfo.options;
            if (fieldInfo && fieldInfo.options) {
                optionKeys = optionKeys.split(",");
                optionKeys && optionKeys.length > 0 && optionKeys.map(function (key) {
                    newOptions_1 = newOptions_1.filter(function (d) { return d.key !== key + ""; });
                    newOptions_1 = newOptions_1.filter(function (d) { return d.cancel != '1'; });
                });
            }
            if (fieldInfo.isdetail) {
                var detailindex = fieldInfo["detail"];
                this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid).set('options', newOptions_1);
            }
            else {
                this.getCurrentModeStore().cubeForm.$(fieldid).set('options', newOptions_1);
            }
        }
        catch (error) {
        }
    }, 
    /**
        * 控制选择框字段选项范围   范围外选项隐藏
        * @params optionKeys(Arrsry) [1,2]
        */
    controlSelectOption: function (fieldMark, optionKey) {
        var that = this;
        try {
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldInfo = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(that.getFieldInfo(fieldid));
            var newOptions_2 = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(fieldInfo.options);
            var options_1 = [];
            if (fieldInfo && fieldInfo.options) {
                var optionKeys = optionKey.split(",");
                optionKeys && optionKeys.length > 0 && optionKeys.map(function (key) {
                    var temp = newOptions_2.filter(function (d) { return d.key == key + "" && d.cancel != '1'; })[0];
                    if (temp) {
                        options_1.push(temp);
                    }
                });
            }
            if (fieldInfo.isdetail) {
                var detailindex = fieldInfo["detail"];
                this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid).set('options', options_1);
            }
            else {
                this.getCurrentModeStore().cubeForm.$(fieldid).set('options', options_1);
            }
        }
        catch (error) {
        }
    }, 
    /**
   * 控制表单按钮是否点击
   * @param flag : true 按钮全部置灰不可操作 false 恢复按钮可操作状态
   */
    controlBtnDisabled: function (isDisabled) {
        this.getCurrentModeStore().cardTab.disabled = isDisabled;
    }, 
    /**
     * 获取字段信息
     */
    getFieldInfo: function (fieldMark) {
        var mainFields = this.getCurrentModeStore().allFields;
        var fieldProps = __WEBPACK_IMPORTED_MODULE_5__stores__["default"].Card.fieldsProps;
        try {
            var fieldid = fieldMark.split("_")[0];
            var fieldProp = __assign({}, fieldProps[fieldid]);
            var ismandatory = fieldProp.ismandatory, isedit = fieldProp.isedit;
            var viewattr = ismandatory ? 3 : (isedit ? 2 : 1);
            return __assign({}, mainFields[fieldid], { viewattr: viewattr });
        }
        catch (e) {
        }
    }, 
    /**
    * 获取字段当前的字段属性
    */
    getFieldCurViewAttr: function (fieldMark) {
        var _this = this;
        try {
            var childrenFields = __WEBPACK_IMPORTED_MODULE_10_jquery___default()("*.fieldValue"); //隐藏行内的field元素
            var fieldattr_1 = "";
            if (childrenFields) {
                Array.prototype.forEach.call(childrenFields, function (element) {
                    var dataset = _this.getDataset(element);
                    if (dataset.fieldmark == fieldMark) {
                        fieldattr_1 = dataset.fieldattr;
                    }
                });
            }
            return fieldattr_1;
        }
        catch (e) {
        }
    }, getDataset: function (ele) {
        if (ele.dataset) {
            return ele.dataset;
        }
        else {
            var attrs = ele.attributes, //元素的属性集合
            dataset = {}, name, matchStr;
            for (var i = 0; i < attrs.length; i++) { //是否是data- 开头
                matchStr = attrs[i].name.match(/^data-(.+)/);
                if (matchStr) { //data-auto-play 转成驼峰写法 autoPlay
                    name = matchStr[1].replace(/-([\da-z])/gi, function (all, letter) {
                        return letter.toUpperCase();
                    });
                    dataset[name] = attrs[i].value;
                }
            }
            return dataset;
        }
    }, 
    /***
     *
     */
    getCardUrlInfo: function () {
        try {
            var baseinfo = this.getCurrentModeStore().base;
            var baseParams = this.getCurrentModeStore().params;
            return __assign({}, baseParams, baseinfo);
        }
        catch (e) {
        }
    }, 
    /***
     * 打开一个自定义对话框
     */
    openCustomDialog: function (prop, buttons) {
        var newbuttons = new Array();
        var dia = this.dialogObj;
        var num = 0;
        var _loop_1 = function (button) {
            newbuttons.push(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (this_1 && this_1.props && this_1.props.ecId || '') + "_Button@bdxdhf@" + num, id: button.btnname, type: 'primary', onClick: function (e) {
                    var methodname = button.callfun;
                    if (methodname.indexOf('base.') >= 0) {
                        methodname = methodname.replace('base.', '');
                        eval(methodname + "()");
                    }
                    else {
                        eval('$(e.target).closest(".ant-modal-content").find("iframe")[0].contentWindow.' + methodname + "()");
                    }
                } }, button.btnname));
            num++;
        };
        var this_1 = this;
        for (var _i = 0, buttons_1 = buttons; _i < buttons_1.length; _i++) {
            var button = buttons_1[_i];
            _loop_1(button);
        }
        if (dia == undefined) {
            var node = document.createElement('div');
            __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(MyCustomDialog, { ecId: (this && this.props && this.props.ecId || '') + "_MyCustomDialog@jxl7iw", ref: function (r) { return dia = r; }, prop: prop, buttons: newbuttons }), node);
            __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].WindowFunc.getTop().document.body.appendChild(node);
            this.dialogObj = dia;
        }
        else {
            this.dialogObj.update(prop, newbuttons);
            this.dialogObj.show();
        }
        return dia;
    }, 
    /**
     * 关闭指定的自定义对话框
     */
    closeCustomDialog: function (callBack) {
        if (callBack === void 0) { callBack = function () { }; }
        var _dialogObj = this.dialogObj;
        /******* 解决了查询列表设置滑动窗口打开，代码块中使用关闭自定义弹窗，点击关闭无效的问题 *******/
        var _iframeDOM = __WEBPACK_IMPORTED_MODULE_10_jquery___default()('.Cube-WeaSlideModal .wea-slide-modal-content > iframe')[0];
        if (_iframeDOM && _iframeDOM.src.indexOf('#/main/cube/card') > -1) {
            _dialogObj = _iframeDOM.contentWindow.ModeForm.dialogObj;
        }
        /**********/
        _dialogObj.close(callBack);
    }, 
    /**
    * 添加明细行
    * @params detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
    * @params initAddRowData(JSON) 新增行设置的初始值，可不传；格式为{field110:"111",field112:"22",...},注意key不带下划线标示
    */
    deal4ReplaceDatas: function (replaceDatas, fieldtype) {
        if (fieldtype == '141') {
            var props = replaceDatas.map(function (d) { return d.prop; });
            return {
                value: Object(__WEBPACK_IMPORTED_MODULE_4__components_excel_layout_cell_field_browser_element_Browser__["b" /* spellResourceCondition */])(props),
                valueObj: props
            };
        }
        else {
            return {
                value: replaceDatas.map(function (d) { return d.id || d.randomFieldId; }).join(","),
                valueSpan: replaceDatas.map(function (d) { return d.name || d.lastname; }).join(","),
                valueObj: replaceDatas
            };
        }
    }, 
    /**
     * 文本字段可编辑状态，当值为空显示默认灰色提示信息，鼠标点击输入时消失
     */
    setTextFieldEmptyShowContent: function (fieldMark, showContent) {
        try {
            if (!fieldMark || fieldMark.indexOf("field") === -1)
                return;
            var fieldid = fieldMark.split("_")[0];
            var fieldInfo = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(this.getFieldInfo(fieldid));
            if (fieldInfo.isdetail) {
                // const detailindex = fieldInfo["detail"];
                // this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid).$placeholder = showContent;
                this.getCurrentModeStore().controlDetailRowAttr(fieldMark, { emptyShowContent: showContent });
            }
            else {
                this.getCurrentModeStore().cubeForm.$(fieldid).$placeholder = showContent;
            }
        }
        catch (error) {
        }
    }, 
    /**
     * 复写浏览按钮属性
     */
    overrideBrowserProp: function (fieldMark, jsonParam) {
        if (jsonParam === void 0) { jsonParam = {}; }
        try {
            var fieldid = fieldMark.split("_")[0];
            var fieldInfo = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(this.getFieldInfo(fieldid));
            if (fieldInfo && fieldInfo.fieldhtmltype == 3) { //限制浏览框类型
                this.getCurrentModeStore().controlBrowserProp(fieldMark, jsonParam);
            }
        }
        catch (error) {
        }
    }, 
    /**
     * 更新提交参数
     * @param {Object} updateInfo
     */
    updateSubmitInfo: function (updateInfo) {
    }, 
    /**
     * 获取submitParams 中的参数值
     * @param {Object} key
     */
    getSubmitInfoByKey: function (key) {
    }, 
    /**
     * 附件下载
     * @param {Object} downloadUrl
     */
    setFileDownload: function (downloadUrl) {
    }, downLoadFile: function (fileid) { }, changeReplyAttr: function () {
    }, 
    /**
    * 字段值变化绑定事件
    * @params fieldMark(String) 绑定字段标示串，明细字段带下划线标示
    */
    bindFieldChangeEvent: function (fieldMarkStr, funobj) {
        var _this = this;
        !!fieldMarkStr && fieldMarkStr.split(",").map(function (fieldMark) {
            _this.addPropertyChangeFn(fieldMark, funobj);
        });
    }, addPropertyChangeFn: function (key, funobj) {
        if (!key || key.indexOf("field") === -1)
            return;
        var fnArr = this.__propertyChangeFnObj[key];
        if (!!!fnArr) {
            fnArr = new Array();
            this.__propertyChangeFnObj[key] = fnArr;
        }
        fnArr.push(funobj);
    }, 
    /**
     * 明细字段值变化绑定事件，绑定后对新添加的行也生效
     * @params fieldMark(String) 绑定的明细字段标示串，不带下划线标示
     */
    bindDetailFieldChangeEvent: function (fieldMarkStr, funobj) {
        var _this = this;
        var reg = /^field\d+$/;
        !!fieldMarkStr && fieldMarkStr.split(",").map(function (key) {
            if (!key || !reg.test(key))
                return "";
            var fnArr = _this.__detailFieldChangeFnObj[key];
            if (!!!fnArr) {
                fnArr = new Array();
                _this.__detailFieldChangeFnObj[key] = fnArr;
            }
            fnArr.push(funobj);
        });
    }, 
    /**
     * 刷新当前卡片页面
     */
    reloadCard: function (params) {
        if (params === void 0) { params = {}; }
        this.getCurrentModeStore().reloadCard(params);
    }, 
    /**
     * 卡片保存方法 doCardSubmit(pageexpandid, issystemflag, btntype,isRefreshto,callBack)
     * @param pageexpandid string,页面扩展id,必填
     * @param issystemflag string ,是否是系统默认，默认值 0 选填
     * @param btntype string,按钮类型，选填，默认值为 空 ；3 //保存并新建4 //保存并复制5 //明细导入 99保存草稿
     * @param isRefreshto boolean,默认值true,保存后是否跳转到显示页面，默认值true，选填
     * @param callBack function,保存完成后回调方法，选填
     * @param method submit接口的src替换参数
     * @param needValidate 是否需要必填校验
     */
    doCardSubmit: function (pageexpandid, issystemflag, btntype, isRefreshto, callBack, method, needValidate) {
        if (issystemflag === void 0) { issystemflag = '0'; }
        if (btntype === void 0) { btntype = ""; }
        if (isRefreshto === void 0) { isRefreshto = true; }
        if (callBack === void 0) { callBack = function () { }; }
        if (needValidate === void 0) { needValidate = true; }
        this.getCurrentModeStore().Actions.doSubmit(pageexpandid, issystemflag, btntype, isRefreshto, callBack, method, needValidate);
    }, 
    /***
     * 获取卡片表单的所有数据
     */
    getSubmitData: function () {
        var datas = {};
        datas = this.getCurrentModeStore().Actions.submitActions.getSubmitData();
        return datas;
    }, 
    /**
    * @param pageexpandid   获取页面扩展id
    */
    getCardSubmitExpendId: function () {
        var rightmenus = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(this.getCurrentModeStore().cardTab.rightMenus);
        var expendid = "";
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(rightmenus, function (item) {
            if (item.function.indexOf("doSubmit") > -1) {
                expendid = item.key;
            }
        });
        return expendid;
    }, 
    //根据href获取值
    getHrefQuery: function (href) {
        var query = href.split('?')[1];
        var querys = query ? query.split("&") : [];
        var queryObj = {};
        querys.map(function (q) {
            var index = q.indexOf("=");
            var name = q.substring(0, index);
            var value = q.substring(index + 1);
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(queryObj, name, value);
        });
        return queryObj;
    }, 
    //列表滑动打开卡片，关闭滑动的窗口
    closePageBySlide: function () {
        __WEBPACK_IMPORTED_MODULE_5__stores__["default"].Search.slideModalVisible = false;
    } }, __WEBPACK_IMPORTED_MODULE_11__excelUtil2__["a" /* modeForm_pc */], { 
    /**
    * 钩子机制，指定动作触发注册函数
    */
    ACTION_ADDROW: "action_addrow_", ACTION_DELROW: "action_delrow_", actionFnList: {}, registerAction: function (key, fn) {
        if (typeof (fn) !== "function")
            return;
        if (!(key in this.actionFnList) || !(this.actionFnList[key] instanceof Array))
            this.actionFnList[key] = new Array();
        this.actionFnList[key].push(fn);
    }, triggerAction: function (key, args, timeout) {
        var _this = this;
        if (args === void 0) { args = []; }
        if (timeout === void 0) { timeout = 0; }
        var fnAction = function () {
            if (key.indexOf(_this.ACTION_ADDROW) > -1) {
                var detailIndex = parseInt(key.replace(_this.ACTION_ADDROW, ""));
                try {
                    eval("_customAddFun" + detailIndex + "(" + args[0] + ")");
                }
                catch (e) { }
            }
            else if (key.indexOf(_this.ACTION_DELROW) > -1) {
                var detailIndex = parseInt(key.replace(_this.ACTION_DELROW, ""));
                try {
                    eval("_customDelFun" + detailIndex + "()");
                }
                catch (e) { }
            }
            var fnArr = _this.actionFnList[key] || [];
            fnArr && fnArr.map(function (fn) {
                try {
                    fn.apply(void 0, args);
                }
                catch (e) { }
            });
        };
        timeout > 0 ? __WEBPACK_IMPORTED_MODULE_0____["default"].setTimeout(function () {
            fnAction();
        }, timeout) : fnAction();
    }, 
    /**
    * 获取选择框字段对应的显示值
    */
    getSelectShowName: function (fieldMark, splitChar) {
        try {
            if (fieldMark.indexOf("field") === -1)
                return "";
            if (typeof splitChar === "undefined" || splitChar === "")
                splitChar = ",";
            var showname_1 = "";
            var fieldValue = this.getFieldValue(fieldMark);
            var info = this.getFieldInfo(fieldMark);
            if (fieldValue !== "" && info.fieldhtmltype == 5 && info.options) {
                var selectitemlist = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(info.options) || [];
                var valueArray_1 = fieldValue.split(",");
                valueArray_1 = valueArray_1.filter(function (v) { return v !== ""; });
                selectitemlist.map(function (item) {
                    if (item.key !== "" && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.indexOf(valueArray_1, item.key + "") > -1) {
                        if (showname_1 !== "")
                            showname_1 += splitChar;
                        showname_1 += item.showname;
                    }
                });
            }
            return showname_1;
        }
        catch (error) {
        }
    }, 
    /**
     * 控制radio框字段打印时仅打印选中值名称
     */
    controlRadioPrintText: function (fieldMark) {
        var _a;
        try {
            this.getCurrentModeStore().batchControlVariableMap((_a = {}, _a["radioPrintText_" + fieldMark] = true, _a));
        }
        catch (error) {
        }
    }, 
    //根据行号获取行序号
    getDetailRowSerailNum: function (mark, rowIndex) {
        if (rowIndex === void 0) { rowIndex = -1; }
        try {
            var detailMark = "";
            var serialNum = -1;
            if (mark.startsWith("field") && mark.indexOf("_") > -1) {
                var _a = mark.split("_"), fieldid = _a[0], index = _a[1];
                var fieldProps = this.getFieldInfo(fieldid);
                var detailindex = fieldProps["detail"];
                detailMark = detailindex;
                rowIndex = index;
            }
            else if (mark.startsWith("detail_")) {
                detailMark = mark;
            }
            var keyArr = this.getCurrentModeStore().cubeForm.$(detailMark).map(function (d) { return d.key; });
            var rowI = keyArr.indexOf(Number(rowIndex));
            if (rowI > -1) {
                serialNum = rowI + 1;
            }
            return serialNum;
        }
        catch (error) {
        }
    }, 
    //获取明细行总数
    getDetailRowCount: function (detailMark) {
        try {
            var allRowIndexStr = this.getCurrentModeStore().cubeForm.$(detailMark).map(function (d) { return d.key; });
            return allRowIndexStr === "" ? 0 : allRowIndexStr.length;
        }
        catch (error) {
        }
    }, 
    /**
    * 控制明细数据行的显示及隐藏
    * @param detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
    * @param rowIndexMark(String) 明细行标示，全部行:all,部分行："1，2，3"
    * @param needHide 是否隐藏行，true:隐藏，false:显示
    */
    controlDetailRowDisplay: function (detailMark, rowIndexMark, needHide) {
        if (needHide === void 0) { needHide = true; }
        try {
            if (rowIndexMark === "all")
                rowIndexMark = this.getDetailAllRowIndexStr(detailMark);
            var attr_1 = {};
            rowIndexMark !== "" && rowIndexMark.split(",").map(function (rowIndex) {
                attr_1["row_" + rowIndex] = { needHide: needHide };
            });
            var from = this.getCurrentModeStore().cubeForm;
            if (!from.has(detailMark)) {
                if (__WEBPACK_IMPORTED_MODULE_0____["default"].console)
                    console.log(" " + detailMark + " Not Exist");
                return null;
            }
            this.getCurrentModeStore().controlDetailRowAttr(detailMark, attr_1);
        }
        catch (error) {
        }
    }, 
    /**
     * 控制明细数据行check是否禁用勾选
     * @param detailMark(String) 明细表标示，明细1就是detail_1，以此递增类推
     * @param rowIndexMark(String) 明细行标示，全部行:all,部分行："1，2，3"
     * @param disableCheck 是否禁用勾选
     */
    controlDetailRowDisableCheck: function (detailMark, rowIndexMark, disableCheck) {
        if (disableCheck === void 0) { disableCheck = true; }
        if (rowIndexMark === "all")
            rowIndexMark = this.getDetailAllRowIndexStr(detailMark);
        var attr = {};
        rowIndexMark !== "" && rowIndexMark.split(",").map(function (rowIndex) {
            attr["row_" + rowIndex] = { disableCheck: disableCheck };
        });
        this.getCurrentModeStore().controlDetailRowAttr(detailMark, attr);
    }, 
    //获取明细选中行主键ID
    getDetailCheckedRowKey: function (detailMark) {
        try {
            var allDetailVals = this.getCurrentModeStore().cubeForm.$(detailMark).values().map(function (d) { return d; });
            var allRowKeyArr_1 = [];
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(allDetailVals, function (item, index) {
                if (item.checkbox == "1") {
                    allRowKeyArr_1.push(item['dtl_id']);
                }
            });
            return "" + allRowKeyArr_1;
        }
        catch (error) {
        }
    }, 
    //获取明细选中行下标，逗号分隔
    getDetailCheckedRowIndexStr: function (detailMark) {
        try {
            var checkbox = this.getCurrentModeStore().cubeForm.$(detailMark).values().map(function (d) { return d.checkbox; });
            var detailIndex_1 = this.getCurrentModeStore().cubeForm.$(detailMark).map(function (d) { return d.key; });
            var checkIndex_1 = [];
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(checkbox, function (item, index) {
                if (item == "1") {
                    checkIndex_1.push(detailIndex_1[index]);
                }
            });
            return "" + checkIndex_1;
        }
        catch (error) {
        }
    }, 
    /**
    * @param type {onblur、onfocus、onclick、ondbclick、mouseover、mouseout}
    * 字段绑定公式触发动作事件
    */
    bindFieldAction: function (type, fieldids, fn) {
        var _this = this;
        try {
            if (typeof (fn) !== "function")
                return;
            var reg_1 = /^field[-]?\d+$/; //[-]? 匹配 ecme下字段为负
            var fieldArr = fieldids.split(",");
            fieldArr && fieldArr.map(function (fieldKey) {
                if (reg_1.test(fieldKey)) {
                    _this.registerAction(fieldKey + "|" + type, fn);
                }
            });
        }
        catch (error) {
        }
    }, triggerFieldAction: function (type, fieldMark) {
        if (!fieldMark || fieldMark.indexOf("field") !== 0)
            return;
        var index = fieldMark.indexOf("_");
        var fieldKey = index > 0 ? fieldMark.substring(0, index) : fieldMark;
        var rowIndex = index > 0 ? parseInt(fieldMark.substring(index + 1)) : -1;
        this.triggerAction(fieldKey + "|" + type, [fieldKey, rowIndex]);
    }, 
    /**
    * 建模操作注册接口
    */
    OPER_ADDROW: 'oper_addrow', OPER_DELROW: 'oper_delrow', eventList: {}, registerCheckEvent: function (types, fn) {
        var _this = this;
        if (typeof (fn) !== "function")
            return;
        var arr = types.split(",");
        arr && arr.map(function (t) {
            if (!(t in _this.eventList))
                _this.eventList[t] = new Array();
            _this.eventList[t].push(fn);
        });
    }, 
    /**
     * 字段组件自定义渲染
     * 单行文本类型，支持代理渲染原字段组件
     * 所有表单字段，支持换行追加组件
     */
    proxyComps: {}, afterComps: {}, proxyFieldComp: function (fieldMark, el, range) {
        this.customFieldComp(fieldMark, el, range, 1);
    }, afterFieldComp: function (fieldMark, el, range) {
        this.customFieldComp(fieldMark, el, range, 2);
    }, customFieldComp: function (fieldMark, el, range, type) {
        if (!fieldMark || fieldMark.indexOf("field") !== 0)
            return;
        var fieldid = fieldMark.split("_")[0];
        var comp = typeof el === "string" ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: el } }) : el;
        var rangeArr = !!range ? range.split(",") : ["1", "2", "3"];
        if (type === 1) {
            var fieldAttr = this.getFieldInfo(fieldid);
            if (fieldAttr.fieldhtmltype == 1 && fieldAttr.fieldtype == 1) { //单行文本 字段类型
                this.proxyComps[fieldMark] = { comp: comp, rangeArr: rangeArr };
                this.forceRenderField(fieldMark);
            }
        }
        else if (type === 2) {
            this.afterComps[fieldMark] = { comp: comp, rangeArr: rangeArr };
            this.forceRenderField(fieldMark);
        }
    }, forceRenderField: function (fieldMark) {
        var that = this;
        try {
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldProps = that.getFieldInfo(fieldid);
            if (fieldProps.isdetail) {
                var detailindex = fieldProps["detail"];
                this.getCurrentModeStore().cubeForm.$(detailindex).$(index).$(fieldid).forceRender = new Date().getTime();
            }
            else {
                this.getCurrentModeStore().cubeForm.$(fieldMark).forceRender = new Date().getTime();
            }
        }
        catch (e) {
        }
    }, renderCustomComp: function (fieldMark, viewAttr, type, extendProps) {
        if (extendProps === void 0) { extendProps = {}; }
        var customComps = type === 1 ? this.proxyComps : this.afterComps;
        if (fieldMark in customComps) {
            var customComp = customComps[fieldMark];
            var comp = customComp.comp, rangeArr = customComp.rangeArr;
            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.indexOf(rangeArr, viewAttr.toString()) > -1) {
                return type === 1 ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(comp, __assign({}, extendProps)) : comp;
            }
        }
        return null;
    }, 
    /**
     * 代理组件渲染函数
     */
    proxyCompFn: {}, proxyFieldContentComp: function (fieldMark, fn) {
        if (typeof fn === "function")
            this.proxyCompFn["FieldContent_" + fieldMark] = fn;
    }, getCustomProxyCompFn: function (key) {
        return key in this.proxyCompFn ? this.proxyCompFn[key] : null;
    }, 
    /**
     * 控制日期选择范围
     */
    controlDateRange: function (fieldMark, start, end) {
        try {
            var startDate = '';
            var endDate = '';
            var reg = /^(-?\d+)(\.\d+)?$/;
            if (typeof start !== "undefined") {
                startDate = start.toString();
                if (reg.test(startDate))
                    startDate = new Date(new Date().getTime() + start * 24 * 60 * 60 * 1000).toLocaleDateString().replace(/日/g, '').replace(/\/|年|月/g, '-').replace(/[^\d-]/g, '');
            }
            if (typeof end !== "undefined") {
                endDate = end.toString();
                if (reg.test(endDate))
                    endDate = new Date(new Date().getTime() + end * 24 * 60 * 60 * 1000).toLocaleDateString().replace(/日/g, '').replace(/\/|年|月/g, '-').replace(/[^\d-]/g, '');
            }
            var _a = fieldMark.split("_"), fieldid = _a[0], index = _a[1];
            var fieldProps = this.getFieldInfo(fieldid);
            if (fieldProps.isdetail) {
                var detailindex = fieldProps["detail"];
                this.getCurrentModeStore().cubeForm.setDate(detailindex + "." + index + "." + fieldid, startDate, endDate);
            }
            else {
                this.getCurrentModeStore().cubeForm.setDate(fieldMark, startDate, endDate);
            }
        }
        catch (error) {
        }
    }, 
    /**
     * ecmeField绑定事件回调 event (onChange  onblur onfocus)三种事件触发回调
     */
    ecmeFieldEventCallBack: function (type, fieldMark, comfrom) {
        if (!fieldMark || fieldMark.indexOf("field") !== 0)
            return;
        var index = fieldMark.indexOf("_");
        var rowIndex = index > 0 ? parseInt(fieldMark.substring(index + 1)) : -1;
        if (fieldMark.startsWith('field-') && this.getCurrentModeStore()) {
            var newvalue = this.getFieldValue(fieldMark);
            var fieldInfo = this.getFieldInfo(fieldMark);
            var _fieldhtmltype = fieldInfo.fieldhtmltype;
            if (comfrom == 'form' && _fieldhtmltype == 1) {
                return;
            }
            var browserShowName = "";
            if (_fieldhtmltype == 3) {
                browserShowName = this.getBrowserShowName(fieldMark);
            }
            var fieldid = void 0;
            if (rowIndex > -1) {
                fieldid = fieldMark.substring(0, index);
            }
            else {
                fieldid = fieldMark;
            }
            var _type = "" + type;
            var ecmeFieldEventCallBack = this.getCurrentModeStore().cubeForm.card.ecmeFieldEventCallBack;
            var iscustom = fieldInfo.issystem === "4" ? "true" : "false";
            if (typeof (ecmeFieldEventCallBack) == 'function') {
                try {
                    var params = {
                        changetype: _type,
                        fieldMark: fieldid,
                        fieldInfo: fieldInfo,
                        fieldnewvalue: newvalue,
                        rowIndex: rowIndex,
                        iscustom: iscustom,
                        browserShowName: browserShowName,
                    };
                    this.getCurrentModeStore().cubeForm.card.ecmeFieldEventCallBack(params);
                }
                catch (e) {
                    console.log(e);
                }
            }
        }
    }, 
    /***
     * 根据字段标识获取字段组件
     */
    generateFieldContentComp: function (fieldMark) {
        try {
            var index = fieldMark.indexOf("_");
            var fieldId = fieldMark.split("_")[0];
            var fieldid_1 = index > -1 ? fieldMark.substring(5, index) : fieldMark.substring(5);
            var rowIndex = index > -1 ? fieldMark.substring(index + 1) : -1;
            var fieldInfo = this.getFieldInfo(fieldId);
            var isdetail = fieldInfo.isdetail;
            var detail = fieldInfo.detail;
            var card = this.getCurrentModeStore();
            if (isdetail) {
                var excel = card.modeExcel.getExcel(detail);
                var cell = excel.cells.slice().filter(function (d) { return d.field == fieldid_1 && d.etype == '3'; }) || [];
                return cell && cell.length > 0 ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_excel_layout_TableCell__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_TableCell@9avgf3", cell: cell[0], form: card.cubeForm.$(detail).$(rowIndex), excel: excel, card: card, index: rowIndex, detail: detail }) : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span", null);
            }
            else {
                var excel = card.modeExcel.cells.slice().filter(function (d) { return d.field == fieldid_1 && d.etype == '3'; }) || [];
                return excel && excel.length > 0 ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_excel_layout_TableCell__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_TableCell@4apgpb", cell: excel[0], form: card.cubeForm, excel: card.modeExcel, card: card, index: rowIndex }) : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span", null);
            }
        }
        catch (error) {
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span", null, "Field Not Exist");
        }
    }, 
    /***调用右键事件
     * 系统按钮：type= functionname
     * 页面扩展 type = doCustomFunction,expendid,name,必填一个，先走前面的id
     */
    doRightBtnEvent: function (type, expendid, name) {
        try {
            var card = this.getCurrentModeStore();
            var rightMenu = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(card.cardTab.rightMenus);
            var btnObj_1 = type;
            var pageid_1;
            if (type === 'doCustomFunction') { //自定义按钮
                if (expendid) {
                    pageid_1 = expendid;
                }
                else if (name) { //支持多语言。eg：商务管理~~Business~~商務管理
                    var names_1 = name.split('~~');
                    rightMenu && rightMenu.map(function (item) {
                        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.indexOf(names_1, item.name) >= 0) {
                            btnObj_1 = item;
                            pageid_1 = item.key;
                        }
                    });
                }
                else {
                    this.showMessage('请填写指定的页面扩展id或者名称！');
                }
            }
            else {
                rightMenu && rightMenu.map(function (item) {
                    var _fun = item.function.replace('javascript:', '');
                    _fun = _fun.split("(")[0];
                    if (type === _fun) {
                        btnObj_1 = item;
                        pageid_1 = item.key;
                    }
                });
            }
            if (btnObj_1 && pageid_1) {
                card.cardTab.rightMenuHandle(pageid_1);
            }
        }
        catch (e) {
        }
    }, 
    /***
     * 打开侧滑窗口
     */
    slideOpenModal: function (bool, url, sliderPercentage) {
        if (sliderPercentage === void 0) { sliderPercentage = 70; }
        this.getCurrentModeStore().showSlideModal(bool, url, sliderPercentage);
    }, 
    /***
     * 控制全局spin的开始与结束
     */
    showLoading: function (bool, size, tip) {
        this.getCurrentModeStore().showGlobalSpin = {
            isShow: bool ? 'show' : 'hide',
            size: size || 'defalut',
            tip: tip || '',
        };
    }, 
    /*****
     * 表单提交之前添加参数
     */
    appendSubmitParam: function (obj) {
        if (obj === void 0) { obj = {}; }
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forIn(obj, function (v, k) {
            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.indexOf(__WEBPACK_IMPORTED_MODULE_13__cubeUtil__["e" /* importantParamRange */], k) > -1)
                delete obj[k];
        });
        this.getCurrentModeStore().changeSubmitParam(obj);
    } });
var MyCustomDialog = /** @class */ (function (_super) {
    __extends(MyCustomDialog, _super);
    function MyCustomDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.close = function (callBack) {
            _this.setState({ visible: false });
            callBack && typeof callBack == 'function' && callBack();
        };
        _this.show = function () {
            _this.setState({ visible: true });
        };
        _this.update = function (prop, buttons) {
            _this.setState({ prop: prop, buttons: buttons });
        };
        var _a = _this.props, prop = _a.prop, buttons = _a.buttons;
        _this.state = { visible: true, prop: prop, buttons: buttons };
        return _this;
    }
    MyCustomDialog.prototype.render = function () {
        var _this = this;
        var _a = this.state, prop = _a.prop, buttons = _a.buttons;
        return (__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", { id: "dialogdiv" },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaDialog"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@g3ah7a", className: (prop.title ? "" : 'cube-dialog-notitle') + " wea-auth-modal cube-dialog", iconBgcolor: "#96358a", icon: 'icon-coms-ModelingEngine', iconFontColor: "#fff", buttons: buttons, visible: this.state.visible, hasScroll: true, destroyBodyOnClose: true, onCancel: function () { _this.setState({ visible: false }); } }, prop))));
    };
    MyCustomDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_8_mobx_react__["observer"]
    ], MyCustomDialog);
    return MyCustomDialog;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component));

//锁定列情况，加载完同步一次高度宽度
var syncLockedForDidMount = function (groupid) {
    var syncFn = function () {
        var dTableArea = __WEBPACK_IMPORTED_MODULE_10_jquery___default()("#dTableArea_" + groupid);
        // if(dTableArea.attr("data-supportlockedcol") !== "true")
        //     return;
        var oTable = dTableArea.find("table#oTable" + groupid);
        var oTable_head = dTableArea.find("table#oTable" + groupid + "_head");
        var oTableLocked = dTableArea.find("table#oTable" + groupid + "_locked");
        var oTableLocked_head = dTableArea.find("table#oTable" + groupid + "_head_locked");
        if (oTable.length !== 1 || oTableLocked.length !== 1)
            return;
        oTableLocked.find("tr[data-rowindex]").each(function () {
            var rowindex = __WEBPACK_IMPORTED_MODULE_10_jquery___default()(this).attr("data-rowindex");
            var lockedRow = oTableLocked.find("tr[data-rowindex=" + rowindex + "]");
            var dataRow = oTable.find("tr[data-rowindex=" + rowindex + "]");
            if (lockedRow.length === 1 && dataRow.length === 1) {
                if (dataRow.height() == lockedRow.height()) {
                    return true;
                }
                var maxHeight = dataRow.height() >= lockedRow.height() ? dataRow.height() : lockedRow.height();
                lockedRow.add(dataRow).css("height", maxHeight);
                oTable_head.add(oTableLocked_head).find("tr[data-rowindex=" + rowindex + "]").css("height", maxHeight);
            }
        });
        // //解决隐藏列宽度变化问题,将数据层的隐藏列宽度总和赋值给锁定层
        // const lockedCount = oTableLocked.find(".detailControlWidth").children().length;
        // let totalWidth = 0;
        // oTable.find(".detailControlWidth").children().each(function(index){
        //     if(index < lockedCount && !jQuery(this).hasClass("detail_hide_col"))
        //         totalWidth += jQuery(this).width();
        // });
        // if(Math.abs(oTableLocked.width()-totalWidth) > 3){
        //     dTableArea.find("table#oTable"+groupid+"_head_locked").width(totalWidth);
        //     oTableLocked.width(totalWidth);
        // }
    };
    var begintime = new Date().getTime();
    var didsynctimer = __WEBPACK_IMPORTED_MODULE_0____["default"].setInterval(function () {
        try {
            syncFn();
            var curtime = new Date().getTime();
            if (curtime - begintime > 2000)
                __WEBPACK_IMPORTED_MODULE_0____["default"].clearInterval(didsynctimer);
        }
        catch (e) { }
    }, 0);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isBoolean2 = __webpack_require__(132);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _uniqueId2 = __webpack_require__(630);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _isUndefined2 = __webpack_require__(200);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _max2 = __webpack_require__(631);

var _max3 = _interopRequireDefault(_max2);

var _isInteger2 = __webpack_require__(314);

var _isInteger3 = _interopRequireDefault(_isInteger2);

var _ary2 = __webpack_require__(635);

var _ary3 = _interopRequireDefault(_ary2);

var _isDate2 = __webpack_require__(204);

var _isDate3 = _interopRequireDefault(_isDate2);

var _isObject2 = __webpack_require__(23);

var _isObject3 = _interopRequireDefault(_isObject2);

var _keys2 = __webpack_require__(46);

var _keys3 = _interopRequireDefault(_keys2);

var _values2 = __webpack_require__(205);

var _values3 = _interopRequireDefault(_values2);

var _map2 = __webpack_require__(137);

var _map3 = _interopRequireDefault(_map2);

var _union2 = __webpack_require__(671);

var _union3 = _interopRequireDefault(_union2);

var _isPlainObject2 = __webpack_require__(52);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isEmpty2 = __webpack_require__(81);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _isString2 = __webpack_require__(47);

var _isString3 = _interopRequireDefault(_isString2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _has2 = __webpack_require__(82);

var _has3 = _interopRequireDefault(_has2);

var _partial2 = __webpack_require__(676);

var _partial3 = _interopRequireDefault(_partial2);

var _trim2 = __webpack_require__(142);

var _trim3 = _interopRequireDefault(_trim2);

var _replace2 = __webpack_require__(344);

var _replace3 = _interopRequireDefault(_replace2);

var _isNil2 = __webpack_require__(83);

var _isNil3 = _interopRequireDefault(_isNil2);

var _intersection2 = __webpack_require__(345);

var _intersection3 = _interopRequireDefault(_intersection2);

var _every2 = __webpack_require__(681);

var _every3 = _interopRequireDefault(_every2);

var _some2 = __webpack_require__(684);

var _some3 = _interopRequireDefault(_some2);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _mobx = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var props = {
  booleans: ['hasError', 'isValid', 'isDirty', 'isPristine', 'isDefault', 'isEmpty', 'focused', 'touched', 'changed', 'disabled', 'resetting', 'clearing'],
  field: ['value', 'initial', 'default', 'label', 'placeholder', 'disabled', 'related', 'options', 'extra', 'bindings', 'type', 'hooks', 'handlers', 'error'],
  separated: ['values', 'initials', 'defaults', 'labels', 'placeholders', 'disabled', 'related', 'options', 'extra', 'bindings', 'types', 'hooks', 'handlers'],
  handlers: ['onChange', 'onToggle', 'onFocus', 'onBlur', 'onDrop', 'onSubmit', 'onReset', 'onClear', 'onAdd', 'onDel'],
  function: ['observers', 'interceptors', 'input', 'output'],
  validation: ['rules', 'validators', 'validateWith'],
  types: {
    isDirty: 'some',
    isValid: 'every',
    isPristine: 'every',
    isDefault: 'every',
    isEmpty: 'every',
    hasError: 'some',
    focused: 'some',
    touched: 'some',
    changed: 'some',
    disabled: 'every',
    clearing: 'every',
    resetting: 'every'
  }
};

var getObservableMapValues = function getObservableMapValues(observableMap) {
  if (_mobx.values) {
    return (0, _mobx.values)(observableMap);
  }

  return observableMap.values();
};

var getObservableMapKeys = function getObservableMapKeys(observableMap) {
  if (_mobx.values) {
    return (0, _mobx.keys)(observableMap);
  }

  return observableMap.keys();
};

var checkObserveItem = function checkObserveItem(change) {
  return function (_ref) {
    var key = _ref.key,
        to = _ref.to,
        type = _ref.type,
        exec = _ref.exec;
    return change.type === type && change.name === key && change.newValue === to && exec.apply(change, [change]);
  };
};

var checkObserve = function checkObserve(collection) {
  return function (change) {
    return collection.map(checkObserveItem(change));
  };
};

var checkPropType = function checkPropType(_ref2) {
  var type = _ref2.type,
      data = _ref2.data;

  var $check = void 0;
  switch (type) {
    case 'some':
      $check = function $check($data) {
        return (0, _some3.default)($data, Boolean);
      };break;
    case 'every':
      $check = function $check($data) {
        return (0, _every3.default)($data, Boolean);
      };break;
    default:
      $check = null;
  }
  return $check(data);
};

var hasProps = function hasProps($type, $data) {
  var $props = void 0;
  switch ($type) {
    case 'booleans':
      $props = props.booleans;
      break;
    case 'field':
      $props = [].concat(_toConsumableArray(props.field), _toConsumableArray(props.validation), _toConsumableArray(props.function), _toConsumableArray(props.handlers));break;
    case 'all':
      $props = ['id'].concat(_toConsumableArray(props.booleans), _toConsumableArray(props.field), _toConsumableArray(props.validation), _toConsumableArray(props.function), _toConsumableArray(props.handlers));break;
    default:
      $props = null;
  }

  return (0, _intersection3.default)($data, $props).length > 0;
};

/**
  Check Allowed Properties
*/
var allowedProps = function allowedProps(type, data) {
  if (hasProps(type, data)) return;
  var $msg = 'The selected property is not allowed';
  throw new Error($msg + ' (' + JSON.stringify(data) + ')');
};

/**
  Throw Error if undefined Fields
*/
var throwError = function throwError(path, fields) {
  var msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!(0, _isNil3.default)(fields)) return;
  var $msg = (0, _isNil3.default)(msg) ? 'The selected field is not defined' : msg;
  throw new Error($msg + ' (' + path + ')');
};

var pathToStruct = function pathToStruct(path) {
  var struct = void 0;
  struct = (0, _replace3.default)(path, new RegExp('[.]\\d+($|.)', 'g'), '[].');
  struct = (0, _replace3.default)(struct, '..', '.');
  struct = (0, _trim3.default)(struct, '.');
  return struct;
};

var hasSome = function hasSome(obj, keys) {
  return (0, _some3.default)(keys, (0, _partial3.default)(_has3.default, obj));
};

var isPromise = function isPromise(obj) {
  return !!obj && typeof obj.then === 'function' && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function');
};

var isStruct = function isStruct(struct) {
  return (0, _isArray3.default)(struct) && (0, _every3.default)(struct, _isString3.default);
};

var isEmptyArray = function isEmptyArray(field) {
  return (0, _isEmpty3.default)(field) && (0, _isArray3.default)(field);
};

var isArrayOfObjects = function isArrayOfObjects(fields) {
  return (0, _isArray3.default)(fields) && (0, _every3.default)(fields, _isPlainObject3.default);
};

var $getKeys = function $getKeys(fields) {
  return (0, _union3.default)((0, _map3.default)((0, _values3.default)(fields), function (values) {
    return (0, _keys3.default)(values);
  })[0]);
};

var hasUnifiedProps = function hasUnifiedProps(_ref3) {
  var fields = _ref3.fields;
  return !isStruct({ fields: fields }) && hasProps('field', $getKeys(fields));
};

var hasSeparatedProps = function hasSeparatedProps(initial) {
  return hasSome(initial, props.separated) || hasSome(initial, props.validation);
};

var allowNested = function allowNested(field, strictProps) {
  return (0, _isObject3.default)(field) && !(0, _isDate3.default)(field) && !(0, _has3.default)(field, 'fields') && (!hasSome(field, [].concat(_toConsumableArray(props.field), _toConsumableArray(props.validation), _toConsumableArray(props.function), _toConsumableArray(props.handlers))) || strictProps);
};

var parseIntKeys = function parseIntKeys(fields) {
  return (0, _map3.default)(getObservableMapKeys(fields), (0, _ary3.default)(parseInt, 1));
};

var hasIntKeys = function hasIntKeys(fields) {
  return (0, _every3.default)(parseIntKeys(fields), _isInteger3.default);
};

var maxKey = function maxKey(fields) {
  var max = (0, _max3.default)(parseIntKeys(fields));
  return (0, _isUndefined3.default)(max) ? 0 : max + 1;
};

var uniqueId = function uniqueId(field) {
  return (0, _uniqueId3.default)([(0, _replace3.default)(field.path, new RegExp('\\.', 'g'), '-'), '--'].join(''));
};

var $isEvent = function $isEvent(obj) {
  if ((0, _isNil3.default)(obj) || typeof Event === 'undefined') return false;
  return obj instanceof Event || !(0, _isNil3.default)(obj.target); // eslint-disable-line
};

var $hasFiles = function $hasFiles($) {
  return $.target.files && $.target.files.length !== 0;
};

var $isBool = function $isBool($, val) {
  return (0, _isBoolean3.default)(val) && (0, _isBoolean3.default)($.target.checked);
};

var $try = function $try() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var found = null;

  args.map(function (val) {
    return (// eslint-disable-line
      found === null && !(0, _isNil3.default)(val) && (found = val)
    );
  });

  return found;
};

exports.default = {
  props: props,
  checkObserve: checkObserve,
  checkPropType: checkPropType,
  hasProps: hasProps,
  allowedProps: allowedProps,
  throwError: throwError,
  isPromise: isPromise,
  isStruct: isStruct,
  isEmptyArray: isEmptyArray,
  isArrayOfObjects: isArrayOfObjects,
  pathToStruct: pathToStruct,
  hasUnifiedProps: hasUnifiedProps,
  hasSeparatedProps: hasSeparatedProps,
  allowNested: allowNested,
  parseIntKeys: parseIntKeys,
  hasIntKeys: hasIntKeys,
  maxKey: maxKey,
  uniqueId: uniqueId,
  $isEvent: $isEvent,
  $hasFiles: $hasFiles,
  $isBool: $isBool,
  $try: $try,
  getObservableMapKeys: getObservableMapKeys,
  getObservableMapValues: getObservableMapValues
};
module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(360);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_29__;

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* unused harmony export validatePrompt */
/* unused harmony export init */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return initDetailExcelFile; });
/* unused harmony export dataInput */
/* unused harmony export fieldAttrAjax */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return likeReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return unlikeReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return initReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return replySubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return layoutBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return mainFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return initDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getDetailFields; });
/* unused harmony export getDefaultValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getRowColCons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getTopTabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getInnerTabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getRightMenus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getInputEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cubeDataInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getLayoutFieldAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cubeFieldAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getFieldAttrLinkPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getVerifyEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cubeVerifyRepeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return doSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkCardDataChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return reply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getCardLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return recoverData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCardLogDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getDetailFieldLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getMainFieldLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkCardRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getModeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getCubeLikeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return saveCubeLikeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getBarCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getTreeDataUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getWaterMarkImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return detailImportNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getCardMarginData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return doExpCardConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return doSaveDetailPagesize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return confirmTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return docustompage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

// import window from '../util';
var newUrl = '/api/cube/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                // reject();
                // window.weaHistory.push('/main/cube/noright');
                resolve(__assign({ noRight: noRight }, data));
            }
            else {
                resolve(data);
            }
        });
    });
};
var validatePrompt = function (params) {
    return CallAPI(newUrl + "card/validatePrompt", "post", params);
};
var init = function (params) {
    return CallAPI(newUrl + "card/init", "get", params);
};
var initDetailExcelFile = function (params) {
    return CallAPI(newUrl + "card/initDetailExcelFile", "get", params);
};
var dataInput = function (params) {
    return CallAPI(newUrl + "card/dataInput", "get", params);
};
var fieldAttrAjax = function (params) {
    return CallAPI(newUrl + "card/fieldAttr", "get", params);
};
var likeReply = function (params) {
    return CallAPI(newUrl + "card/likeReply", "get", params);
};
var unlikeReply = function (params) {
    return CallAPI(newUrl + "card/unlikeReply", "get", params);
};
var initReply = function (params) {
    return CallAPI(newUrl + "new/card/initReply", "get", params);
};
var replySubmit = function (params) {
    return CallAPI(newUrl + "new/card/replySubmit", "post", params);
};
var deleteReply = function (params) {
    return CallAPI(newUrl + "new/card/deleteReply", "get", params);
};
var layoutBase = function (params) {
    return CallAPI(newUrl + "new/card/layoutBase", "get", params);
};
var mainFields = function (params) {
    return CallAPI(newUrl + "new/card/mainFields", "get", params);
};
var initDetail = function (params) {
    return CallAPI(newUrl + "new/card/initDetail", "get", params);
};
var getDetailFields = function (params) {
    return CallAPI(newUrl + "new/card/getDetailFields", "get", params);
};
var getDefaultValue = function (params) {
    return CallAPI(newUrl + "new/card/getDefaultValue", "get", params);
};
var getRowColCons = function (params) {
    return CallAPI(newUrl + "new/card/getRowColCons", "get", params);
};
var getTopTabs = function (params) {
    return CallAPI(newUrl + "new/card/topTabs", "get", params);
};
var getInnerTabs = function (params) {
    return CallAPI(newUrl + "new/card/innerTabs", "get", params);
};
var getRightMenus = function (params) {
    return CallAPI(newUrl + "new/card/rightMenus", "get", params);
};
var getInputEntry = function (params) {
    return CallAPI(newUrl + "new/card/getInputEntry", "get", params);
};
var cubeDataInput = function (params) {
    return CallAPI(newUrl + "new/card/cubeDataInput", "post", params);
};
var getLayoutFieldAttr = function (params) {
    return CallAPI(newUrl + "new/card/getLayoutFieldAttr", "get", params);
};
var cubeFieldAttr = function (params) {
    return CallAPI(newUrl + "new/card/cubeFieldAttr", "get", params);
};
var getFieldAttrLinkPage = function (params) {
    return CallAPI(newUrl + "new/card/getFieldAttrLinkPage", "get", params);
};
var getVerifyEntity = function (params) {
    return CallAPI(newUrl + "new/card/getVerifyEntity", "get", params);
};
var cubeVerifyRepeat = function (params) {
    return CallAPI(newUrl + "new/card/cubeVerifyRepeat", "post", params);
};
var doSubmit = function (params) {
    return CallAPI(newUrl + "new/card/doSubmit", "post", params);
};
var checkCardDataChange = function (params) {
    return CallAPI(newUrl + "new/card/checkCardDataChange", "post", params);
};
var reply = function (params) {
    return CallAPI(newUrl + "new/card/reply", "get", params);
};
var getCardLog = function (params) {
    return CallAPI("/api/formmode/card/modeLog", "post", params);
};
var recoverData = function (params) {
    return CallAPI("/api/formmode/card/recoverData", "post", params);
};
var getCardLogDetail = function (params) {
    return CallAPI("/api/formmode/card/modeLogDetail", "post", params);
};
var getDetailFieldLog = function (params) {
    return CallAPI("/api/formmode/card/getDetailFieldLog", "get", params);
};
var getMainFieldLog = function (params) {
    return CallAPI("/api/formmode/card/getMainFieldLog", "get", params);
};
var checkCardRight = function (params) {
    return CallAPI(newUrl + "new/card/checkCardRight", "get", params);
};
var getModeBase = function (params) {
    return CallAPI(newUrl + "new/card/getModeBase", "get", params);
};
var getCubeLikeInfo = function (params) {
    return CallAPI(newUrl + "new/card/getCubeLikeInfo", "get", params);
};
var saveCubeLikeInfo = function (params) {
    return CallAPI(newUrl + "new/card/saveCubeLikeInfo", "get", params);
};
var getQRCode = function (params) {
    return CallAPI(newUrl + "new/card/getQRCode", "get", params);
};
var getBarCode = function (params) {
    return CallAPI(newUrl + "new/card/getBarCode", "get", params);
};
var getIframe = function (params) {
    return CallAPI(newUrl + "new/card/getIframe", "get", params);
};
var getTreeDataUrl = function (params) {
    return CallAPI(newUrl + "new/card/getTreeDataUrl", "get", params);
};
var getWaterMarkImg = function (params) {
    return CallAPI(newUrl + "setting/waterMarkImg", "get", params);
};
var detailImportNew = function (params) {
    return CallAPI(newUrl + "card/detailImportNew", "POST", params);
};
var getCardMarginData = function (params) {
    return CallAPI("/api/cube/setting/getCardSize", "GET", params);
};
/**卡片导出excel模板 */
var doExpCardConfig = function (params) {
    return CallAPI("/api/cube/mode/mode/doExpCardConfig", "POST", params);
};
var doSaveDetailPagesize = function (params) {
    return CallAPI("/api/cube/new/card/saveDetailPageSize", "get", params);
};
var confirmTemplate = function (params) {
    return CallAPI("/api/cube/new/card/confirmTemplate", "get", params);
};
var docustompage = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/formmode/request/CustomPageForward.jsp', 'POST', params, 'text');
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(38);
var core = __webpack_require__(22);
var ctx = __webpack_require__(55);
var hide = __webpack_require__(49);
var has = __webpack_require__(58);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(177)('wks');
var uid = __webpack_require__(116);
var Symbol = __webpack_require__(38).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SearchDisplayType", function() { return SearchDisplayType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listStore", function() { return listStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cubeUtil__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TopStore__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AdvancedStore__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TemplateStore__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ShareStore__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ListEditStore__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BatchEditStore__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mobxTable_table__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mobxTable_list__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__card_CustomDialog__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_pagination__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__apis_table__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_watermark__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__BatchAddStore__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ExcelStore__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_searchUtil__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__verticalListStore__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_list_littleCard_LittleCard__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__util_contentPath__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


































var getParent = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].WindowFunc.getParent;
var TableStore = __WEBPACK_IMPORTED_MODULE_6_comsMobx__["WeaTableNew"].TableStore;
var getLabel = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaLocaleProvider"].getLabel;
var flag1 = false; //批量修改保存按钮状态，多次点击保存按钮，只会发送一次请求
var SearchDisplayType;
(function (SearchDisplayType) {
    SearchDisplayType["Excel"] = "excel";
    SearchDisplayType["Normal"] = "normal";
    SearchDisplayType["TreeType"] = "treeType";
    SearchDisplayType["ImgType"] = "imgType";
    SearchDisplayType["Empty"] = "";
    SearchDisplayType["VerticalType"] = "verticalType";
})(SearchDisplayType || (SearchDisplayType = {}));
var listStore = /** @class */ (function () {
    function listStore() {
        var _this_1 = this;
        this.component = '';
        this.customId = '';
        this.modeId = '';
        this.formId = '';
        this.isDelShow = false;
        this.sessionKey = '';
        this.hasQuickSearch = false;
        this.hasKeySearch = false;
        this.disquerycheck = '';
        this.keySearchFields = [];
        this.keyFieldidInfo = {};
        this.modename = '日志';
        this.nondefaultshared = false;
        this.defaultshared = false;
        this.treeFieldStr = '';
        this.urlMap = {};
        this.confirmMap = {};
        this.tableData = {
            total: 0,
            Data: [],
        };
        this.dataShowtype = 'normal'; //列表的类型
        this.treeData = []; //分组显示数据
        this.treeColumn = []; //分组显示字段
        this.treePercent = 0;
        this.isExpTree = ''; //是否分组导出
        this.rightMenus = [];
        this.printEdcUrl = ''; //数据中心打印地址
        this.tempRightMenus = [];
        this.batchTempRightMenus = [];
        this.height = 0;
        this.viewResHeight = 0; //资源面板查询高度
        this.params = {};
        this.customparms = {};
        this.query = {};
        this.viewtype = '';
        this.type = 'advanced';
        this.loading = false; // 加载中状态
        this.top = new __WEBPACK_IMPORTED_MODULE_9__TopStore__["a" /* default */]();
        this.newTable = new TableStore();
        this.quickSearchValue = '';
        this.advanced = new __WEBPACK_IMPORTED_MODULE_10__AdvancedStore__["a" /* default */]();
        this.condition = new __WEBPACK_IMPORTED_MODULE_10__AdvancedStore__["a" /* default */]();
        this.treecolumns = []; //查询分组显示
        this.treedatas = []; //查询分组显示
        this.searchTree = {
            current: 1,
            pagesize: 10
        };
        this.searchImg = {
            loading: false,
        };
        this.checkAdvanedData = ''; //用于高级查询必填字段的校验
        this.changeDataTime = '';
        this.pagesizetree = ''; //显示判断
        this.isTreeSearch = ''; //显示判断
        this.treeValueId = ''; //勾选的树组合显示的id值
        this.changeSearch = ''; //查询树显示转换
        this.enableTreeList = ''; //是否开启组合查询
        this.isTreeType = ''; //是否开启组合查询
        this.isTree = false;
        this.form = new __WEBPACK_IMPORTED_MODULE_6_comsMobx__["WeaForm"]();
        this.conditionInfo = [];
        this.advancedInfo = [];
        this.quickConditions = {};
        this.quickConditionConfig = [];
        this.isShowCondition = false;
        this.isfrontmultlang = false;
        this.windowTitle = ''; //页面标题
        this.printWindowTitle = ''; //打印页面标题（单独处理）
        this.isBatchSubmit = true; //数据修改冲突提醒后，不进行数据验证提交
        this.listEditStore = new __WEBPACK_IMPORTED_MODULE_13__ListEditStore__["a" /* ListEditStore */](this);
        this.batchEditStore = new __WEBPACK_IMPORTED_MODULE_14__BatchEditStore__["a" /* default */]();
        this.simpleDialogBody = null;
        this.simpleDialog = {};
        this.dialogVisible = false;
        this.msgConfirmVisible = false; //批量修改信息确认
        this.msgConfirmData = null; //批量修改数据暂存
        this.msgConfirmOldData = null; //批量修改老数据暂存
        this.templateid = '';
        this.template = new __WEBPACK_IMPORTED_MODULE_11__TemplateStore__["a" /* default */]();
        this.isInit = false;
        // @observable forceUpdate = false;//资源面板手动动态刷新列表高度
        // @observable listHeight = 250;//资源面板手动动态刷新列表高度
        this.share = new __WEBPACK_IMPORTED_MODULE_12__ShareStore__["default"]();
        this._isInnerTab = false;
        this.reloadModeTop = {};
        this.isInTree = false;
        this.tagVisible = false;
        this.sqlNeedKey = { randomkey: new Date().getTime() };
        this.datalist = [];
        this.mergeInfos = [];
        this.mergeFields = [];
        this.mergeTempColumns = [];
        this.isEdit = false;
        this.editTableStore = new __WEBPACK_IMPORTED_MODULE_16__mobxTable_table__["a" /* default */]();
        this.customDialog = new __WEBPACK_IMPORTED_MODULE_18__card_CustomDialog__["a" /* default */]();
        this.verified = false;
        this.hasRight = false; //权限
        this.quickSearchData = {}; //快速搜索数据
        this.quickSearchDataWithNoChange = {}; //仅快速搜索处使用，记录空数据结构，不做改变
        this.quickSearchFormData = {}; //快速搜索表单数据
        this.isTempSearch = "";
        this.selectedRowKeys = [];
        this.slideModalVisible = false;
        this.slideModalUrl = "";
        this.slideModalUrlold = "";
        this.sliderPercentage = "";
        this.slideflgvla = "";
        this.countReturn = 0; //优化数据渲染
        this.dosubmitvla = false;
        this.imgPageRefresh = false; //相册的分页 刷新时不清空选项
        this.selectRowkeys = []; //图形列表 + 纵向列表也用这个
        this.imgSelectValue = ""; //图形列表中主表id
        // @observable displayTypeForImg: any;
        this.isPagesizeForImg = false;
        this.defalutPagesize = 0;
        this.rowCheckKey = [];
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.cubeMap = {
            visible: false,
            location: ""
        };
        this.needFixedToTop = false; // 资源面板下的右键菜单在高度不够的情况下需要设置top：0；避免被遮挡的问题
        this.countData = {}; //查询统计数据
        this.isCharts = false; //查询统计数据
        this.countDisplayPosition = ''; //统计-显示位置 '0':顶部显示、'1':顶部简约显示、'2':右上角显示
        this.showMoreCountData = false; //是否显示下拉列表中的查询统计数据
        this.waterImg = "";
        this.dataBoard = null;
        this.starttime = new Date().getTime();
        this.showProgerss = false; //是否显示导出进度
        this.isCancel = false; //是否显示导出进度
        this.isClose = false; //是否关闭进度条
        this.progress = {}; //是否显示导出进度
        this.delLoadingProgress = {}; //是否显示删除进度
        this.exportkey = ""; //导出唯一key
        this.delkey = ""; //删除唯一key
        this.quickSearchConditionData = {}; //快速搜索输入的数据(用于浏览框动态参数)
        this.batchAddStore = new __WEBPACK_IMPORTED_MODULE_23__BatchAddStore__["a" /* default */]();
        this.showExpList = false; //是否显示导出类型列表
        this.expCardParm = {
            datas: [],
            billsid: '',
            modeid: '',
            type: 'list',
            comefrom: "",
            modeCustomid: "",
            dataKey: "",
            expcardname: '',
            callBack: ''
        };
        //***************数据筛选相关******************* */
        this.doRealAction = false; //是否执行真正的方法
        this.checkLoading = false; //数据筛选loading
        /**
         * 是否是批量导入数据还原
         */
        this.isBackUpData = false;
        this.backupDataLoading = false; //数据还原loading
        /**
         * 批量导入数据类型是否是覆盖(不是覆盖则是还原)
         */
        this.isCoverType = false;
        this.tempTabledatas = {}; // 按钮前的tableDatas
        this.tempselectedRowKeys = []; // 按钮前的选中项
        this.oldMenueKey = "";
        this.filterSelectRows = []; //数据筛选能勾选的数据
        this.showGlobalSpin = {
            isShow: 'none',
        };
        //******************************************** */
        this.secondflag = true; //判断是否需要二次验证
        this.reloadParams = ''; // 存储调用API.dataKey接口传递的参数，在register_table触发reload方法调用API.dataKey接口时需传递这些参数
        //行点击事件
        this.rowClick = {};
        this.search = undefined;
        this.parentSearch = undefined;
        this.isInSearch = false;
        this.rightLayoutHref = '';
        this.rightLayoutWidth = '0%';
        this.modeDataMatched = true;
        this.clearTable = function () {
            _this_1.newTable = new TableStore();
        };
        this.editPagination = new __WEBPACK_IMPORTED_MODULE_20__util_pagination__["a" /* default */]();
        this.requireTimes = 0; //用于判断是否是当前请求
        this.requireTimesdata = 0; //用于判断是否是当前请求table
        this.isSuspend = false; //是否悬浮显示自定义按钮
        this.isShowIcon = false; //自定义按钮仅显示图标
        this.showButtomNum = 5; //自定义按钮显示数量
        this.verticalListStore = new __WEBPACK_IMPORTED_MODULE_29__verticalListStore__["a" /* default */](this);
        this.isclick = false;
        /************** 资源面板 *************/
        this.isFromViewResource = false; // 查询列表是否内嵌于资源面板内嵌
        this.changeIsInTree = function () {
            _this_1.isInTree = true;
        };
        this.changeIsFromViewResource = function () {
            _this_1.isFromViewResource = true;
        };
        this.clear = function () {
            _this_1.isInit = false;
            _this_1.form = new __WEBPACK_IMPORTED_MODULE_6_comsMobx__["WeaForm"]();
            _this_1.form.isFormInit = false;
            _this_1.newTable = new TableStore();
            _this_1.top = new __WEBPACK_IMPORTED_MODULE_9__TopStore__["a" /* default */]();
            _this_1.advanced = new __WEBPACK_IMPORTED_MODULE_10__AdvancedStore__["a" /* default */]();
            _this_1.condition = new __WEBPACK_IMPORTED_MODULE_10__AdvancedStore__["a" /* default */]();
            _this_1.template = new __WEBPACK_IMPORTED_MODULE_11__TemplateStore__["a" /* default */]();
            _this_1.quickSearchValue = '';
            _this_1.loading = false;
            _this_1.formId = '';
            _this_1.modeId = '';
            _this_1.customId = '';
            _this_1.sessionKey = '';
            _this_1.hasQuickSearch = false;
            _this_1.isShowCondition = false;
            _this_1.isfrontmultlang = false;
            _this_1.isEdit = false;
            _this_1.rightMenus = [];
            _this_1.tempRightMenus = [];
            _this_1.waterImg = "";
            _this_1.templateid = "";
            _this_1._isInnerTab = false;
            _this_1.confirmMap = {};
            _this_1.checkBtn = '';
            _this_1.oldMenueKey = '';
            _this_1.doRealAction = false;
            // 相册
            _this_1.selectRowkeys = [];
            _this_1.verticalListStore = new __WEBPACK_IMPORTED_MODULE_29__verticalListStore__["a" /* default */](_this_1);
            _this_1.rowClick = [];
            _this_1.countData = {};
            _this_1.countDisplayPosition = '';
            _this_1.search = undefined;
            _this_1.rightLayoutWidth = '0%';
            _this_1.rightLayoutHref = '';
            _this_1.isFromViewResource = false;
        };
        // getRowKey(sublist){
        //     return
        // }
        this.resetTreeValueId = function () {
            _this_1.treeValueId = "";
        };
        this.getSelectedRowKeys = function () {
            _this_1.selectedRowKeys = [];
        };
        this.update = function (param) {
            for (var key in param) {
                if (param.hasOwnProperty(key)) {
                    _this_1[key] = param[key];
                }
            }
        };
        this.updateParams = function (params) {
            params = Object(__WEBPACK_IMPORTED_MODULE_26__util_typeUtil__["i" /* transitionCode */])(params);
            // let temp = !_.isEmpty(this.params) && !_.isEqual(toJS(this.params), params);  //这里存在矛盾，先去掉吧
            var temp = !__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.params), params);
            delete params._key; //浏览器回退时 _key值不变 会影响查询列表刷新。
            _this_1.params = params;
            if (params.viewtype == '2') { //高级搜索查询
                params.type = 'advanced';
            }
            if (temp) {
                _this_1.reloadSearch(params);
            }
        };
        this.rightMenuClick = function (key) {
            if (key == '-1') {
                if (!_this_1.isShowCondition) {
                    _this_1.condition.update({ visible: false });
                }
                _this_1.refresh();
            }
            else if (key == '-2') {
                _this_1.advanced.form.reset();
            }
            else if (key == '-3') {
                _this_1.template.saveAsTemplate();
            }
            var rightMenus = _this_1.rightMenus.filter(function (d) { return d.key == key; });
            if (rightMenus.length == 0) {
                return;
            }
            var menu = rightMenus[0];
            return _this_1.doCustomAction(menu);
        };
        this.init = function (_a) {
            var _b = _a.type, type = _b === void 0 ? 'base' : _b, params = __rest(_a, ["type"]);
            var copyparams = {};
            _this_1.copyDataSource = {};
            for (var key in params) {
                try {
                    copyparams[key] = decodeURI(params[key]);
                }
                catch (error) {
                    copyparams[key] = params[key];
                }
            }
            params = copyparams;
            //树工具栏相关
            if (params.fromToolBar && params.fromToolBar == '1') {
                _this_1.quickSearchValue = params.quickSearchValue || '';
            }
            _this_1.params = params;
            _this_1.component = 'Search';
            _this_1.viewtype = params.viewtype;
            _this_1.type = type;
            if (!_this_1.isInSearch) {
                __WEBPACK_IMPORTED_MODULE_4__util__["default"]._xtable_CheckedCheckboxId = function () {
                    if (_this_1.displayType === SearchDisplayType.Excel) {
                        return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.excelStore.selectedRowKeys).join(',');
                    }
                    else {
                        // this.newTable.datas.map(d => this.newTable.selectedRowKeys.indexOf(getListKey(d)) > -1).map(d => d.randomFieldId);
                        // return _.uniq(this.newTable.selectedRowKeys.map(d => d.split('_')[0])).join(',');
                        return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.newTable.selectedRowKeysAllPages.map(function (d) { return d.split('_')[0]; })).join(',');
                    }
                };
                __WEBPACK_IMPORTED_MODULE_4__util__["default"]._xtable_CleanCheckedCheckbox = function () {
                    // this.newTable.setSelectedRowKeys([]);
                    if (_this_1.displayType === SearchDisplayType.Excel) {
                        _this_1.excelStore.selectedRowKeys = [];
                    }
                    else if (_this_1.displayType == SearchDisplayType.ImgType) {
                        _this_1.selectRowKeyAll(true);
                    }
                    else if (_this_1.displayType == SearchDisplayType.VerticalType) {
                        _this_1.verticalListStore.selectRowKeyAll(true);
                    }
                    else {
                        _this_1.newTable.setSelectedRowKeysAllPages([]);
                    }
                };
            }
            //处理快速切换菜单多个异步请求，防止数据被覆盖
            var requireTimes = _this_1.requireTimes;
            _this_1.update({ requireTimes: requireTimes + 1 });
            //qc1062707清空treeValueId、imgSelectValue、verticalListStore.selectValue
            _this_1.treeValueId = "";
            _this_1.imgSelectValue = "";
            _this_1.verticalListStore.selectValue = "";
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].initSearch(params).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, encrypt = _a.encrypt, rowClick = _a.rowClick, top = _a.top, rightMenus = _a.rightMenus, printEdcUrl = _a.printEdcUrl, quickSearch = _a.quickSearch, nondefaultshared = _a.nondefaultshared, defaultshare = _a.defaultshare, isCharts = _a.isCharts, noRight = _a.noRight, _b = _a.isfromTab, isfromTab = _b === void 0 ? '' : _b, _c = _a.isfromRight, isfromRight = _c === void 0 ? '' : _c, isImgType = _a.isImgType, datashowtype = _a.datashowtype, excelFixed = _a.excelFixed, dataBoard = _a.dataBoard, originalTableWidth = _a.originalTableWidth, pageSize = _a.pageSize, isBackUpData = _a.isBackUpData, secondPassword = _a.secondPassword, isCoverType = _a.isCoverType, props = __rest(_a, ["error", "status", "encrypt", "rowClick", "top", "rightMenus", "printEdcUrl", "quickSearch", "nondefaultshared", "defaultshare", "isCharts", "noRight", "isfromTab", "isfromRight", "isImgType", "datashowtype", "excelFixed", "dataBoard", "originalTableWidth", "pageSize", "isBackUpData", "secondPassword", "isCoverType"]);
                if (encrypt) {
                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.push('/main/cube/encrypt');
                }
                var requireTimesNow = _this_1.requireTimes;
                _this_1.rowClick = rowClick;
                if (requireTimesNow == requireTimes + 1) {
                    /*if (secondPassword && this.secondflag) {
                        this.doSecondaryVirty(params);
                    }*/
                    var initList_1 = function () {
                        if (noRight) {
                            _this_1.hasRight = false;
                            _this_1.verified = true;
                            _this_1.isInit = true;
                            return;
                        }
                        else {
                            _this_1.originalTableWidth = originalTableWidth;
                            _this_1.isBackUpData = isBackUpData;
                            _this_1.isCoverType = isCoverType;
                            _this_1.hasRight = true;
                            _this_1.verified = true;
                            _this_1.dataShowtype = datashowtype;
                            _this_1.isPagesizeForImg = false;
                            _this_1.defalutPagesize = pageSize;
                            _this_1.searchTree = {
                                current: 1,
                                pagesize: pageSize
                            };
                            _this_1.verticalListStore.update({ pageSize: pageSize || 10 });
                            if (pageSize && pageSize > 0 && _this_1.editPagination.pageSizeOptions.indexOf(pageSize) == -1) {
                                _this_1.editPagination.pageSizeOptions.push(pageSize);
                                _this_1.editPagination.pageSizeOptions = _this_1.editPagination.pageSizeOptions.sort(function (a, b) { return a - b; });
                            }
                            if (datashowtype === SearchDisplayType.ImgType) {
                                _this_1.isPagesizeForImg = true;
                            }
                            //Excel方式展现列表
                            if (_this_1.displayType === SearchDisplayType.Excel) {
                                params = __assign({}, params, { "displayType": "excel" });
                                _this_1.excelStore = new __WEBPACK_IMPORTED_MODULE_25__ExcelStore__["b" /* default */](params);
                                if (datashowtype === SearchDisplayType.Excel) {
                                    _this_1.excelStore.setFiexdInfo(excelFixed);
                                }
                            }
                            _this_1.toGetJsCodeArea(function () {
                                _this_1.rightMenus = rightMenus;
                                _this_1.tempRightMenus = rightMenus;
                                _this_1.getTemplate(params, true, function (bool) {
                                    if (bool && _this_1.type == "base") {
                                        _this_1.refresh();
                                    }
                                    else {
                                        _this_1.getConditionOrAdvanced(params);
                                    }
                                });
                            });
                        }
                        if (status == '1') {
                            _this_1.getIconInfo(props.modeId);
                            _this_1.update(props);
                            _this_1.top.update(top);
                            if (top) {
                                if (top.selectedKey) {
                                    _this_1.top.selectedKey = top.selectedKey;
                                }
                                else if (top.tabs && top.tabs.length > 0) {
                                    _this_1.top.selectedKey = top.tabs[0].key;
                                }
                            }
                            _this_1.top.isInit = true;
                            _this_1.nondefaultshared = nondefaultshared;
                            _this_1.defaultshared = defaultshare;
                            if (type == 'base') {
                                if (_this_1.isShowCondition) {
                                    _this_1.condition.update({ visible: true });
                                }
                                else {
                                    _this_1.condition.update({ visible: false });
                                }
                            }
                            // 页面扩展关联字段不回显，linkFields为后台返回的当前关联字段，目前关联字段支持三种，1、单行文本 2、选择框 3、浏览按钮
                            if (isfromTab == '1' || isfromRight == '1') {
                                if (undefined != quickSearch.quicksearchinfo && quickSearch.linkFields) {
                                    var quicksearchinfo = quickSearch.quicksearchinfo;
                                    var linkFields = quickSearch.linkFields;
                                    for (var i = 0; i < quicksearchinfo.length; i++) {
                                        for (var j = 0; j < linkFields.length; j++) {
                                            if (quicksearchinfo[i]['searchGroup']) { //分组
                                                for (var k = 0; k < quicksearchinfo[i]['searchGroup'].length; k++) {
                                                    if (quicksearchinfo[i]['searchGroup'][k] && quicksearchinfo[i]['searchGroup'][k]['fieldid'] == linkFields[j]) {
                                                        // 浏览框
                                                        if (quicksearchinfo[i]['searchGroup'][k]['fieldhtmltype'] == '3') {
                                                            quicksearchinfo[i]['searchGroup'][k]["replaceDatas"] = [];
                                                            if (quicksearchinfo[i]['searchGroup'][k]['fieldtype'] == '1') {
                                                                quicksearchinfo[i]['searchGroup'][k]["value"] = ["-5", ""];
                                                            }
                                                            else if (quicksearchinfo[i]['searchGroup'][k]['fieldtype'] == '2') {
                                                                quicksearchinfo[i]['searchGroup'][k]["value"] = ["0", "", ""];
                                                            }
                                                            else {
                                                                quicksearchinfo[i]['searchGroup'][k]["value"] = [];
                                                            }
                                                            // 单行文本
                                                        }
                                                        else if (quicksearchinfo[i]['searchGroup'][k]['fieldhtmltype'] == '1') {
                                                            if (quicksearchinfo[i]['searchGroup'][k]["options"] != undefined && quicksearchinfo[i]['searchGroup'][k] != '') {
                                                                var options = quicksearchinfo[i]['searchGroup'][k]["options"];
                                                                options.forEach(function (element) {
                                                                    if (element.selected == true) {
                                                                        element.selected = false;
                                                                    }
                                                                });
                                                            }
                                                            quicksearchinfo[i]['searchGroup'][k]["value"] = '';
                                                            // 选择框
                                                        }
                                                        else if (quicksearchinfo[i]['searchGroup'][k]['fieldhtmltype'] == '5') {
                                                            quicksearchinfo[i]['searchGroup'][k]["value"] = '';
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                if (quicksearchinfo[i] && quicksearchinfo[i]['fieldid'] == linkFields[j]) {
                                                    // 浏览框
                                                    if (quicksearchinfo[i]['fieldhtmltype'] == '3') {
                                                        quicksearchinfo[i]["replaceDatas"] = [];
                                                        if (quicksearchinfo[i]['fieldtype'] == '1') {
                                                            quicksearchinfo[i]["value"] = ["-5", ""];
                                                        }
                                                        else if (quicksearchinfo[i]['fieldtype'] == '2') {
                                                            quicksearchinfo[i]["value"] = ["0", "", ""];
                                                        }
                                                        else {
                                                            quicksearchinfo[i]["value"] = [];
                                                        }
                                                        // 单行文本
                                                    }
                                                    else if (quicksearchinfo[i]['fieldhtmltype'] == '1') {
                                                        if (quicksearchinfo[i]["options"] != undefined && quicksearchinfo[i]['options'] != '') {
                                                            var options = quicksearchinfo[i]["options"];
                                                            options.forEach(function (element) {
                                                                if (element.selected == true) {
                                                                    element.selected = false;
                                                                }
                                                            });
                                                        }
                                                        quicksearchinfo[i]["value"] = '';
                                                        // 选择框
                                                    }
                                                    else if (quicksearchinfo[i]['fieldhtmltype'] == '5') {
                                                        quicksearchinfo[i]["value"] = '';
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    quickSearch.quicksearchinfo = quicksearchinfo;
                                }
                            }
                            _this_1.quickSearchFormData = {};
                            _this_1.printEdcUrl = printEdcUrl;
                            if (undefined != quickSearch.quicksearchinfo && __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isArray(quickSearch.quicksearchinfo)) {
                                quickSearch.quicksearchinfo = quickSearch.quicksearchinfo.sort(function (a, b) {
                                    return a.orderid - b.orderid;
                                });
                            }
                            // 解决 由于quicksearchinfo中数据未返回value字段，导致value改变未被正常观察到的问题
                            if (quickSearch.quicksearchinfo != undefined && quickSearch.quicksearchinfo.length > 0) {
                                quickSearch.quicksearchinfo.map(function (item) {
                                    if (item.searchGroup) {
                                        item.searchGroup.map(function (field) {
                                            if (!field.hasOwnProperty('value') && field['fieldhtmltype'] == '5') {
                                                field["value"] = '';
                                            }
                                            return field;
                                        });
                                    }
                                    else if (!item.hasOwnProperty('value')) {
                                        // 浏览框
                                        if (item['fieldhtmltype'] == '3') {
                                            item["value"] = [];
                                            // 统一处理浏览按钮，当后台未返回replaceDatas值时，主动添加上，成为观察对象
                                            // 解决浏览按钮replaceDatas未被观察导致的组件值未更新的问题
                                            if (!item.hasOwnProperty('replaceDatas')) {
                                                item["replaceDatas"] = [];
                                            }
                                            // 单行文本
                                        }
                                        else if (item['fieldhtmltype'] == '1') {
                                            item["value"] = '';
                                            // 选择框
                                        }
                                        else if (item['fieldhtmltype'] == '5') {
                                            item["value"] = '';
                                        }
                                    }
                                    return item;
                                });
                            }
                            _this_1.quickSearchData = quickSearch;
                            _this_1.quickSearchDataWithNoChange = JSON.stringify(_this_1.clearDefaultValue(quickSearch.quicksearchinfo)); //转换为字符串防止对象修改
                            _this_1.isCharts = isCharts;
                            _this_1.dataBoard = dataBoard;
                            _this_1.initQuickValue();
                            Object(__WEBPACK_IMPORTED_MODULE_19__apis_card__["G" /* getWaterMarkImg */])({ customid: _this_1.params.customid }).then(function (data) {
                                if (data.status == '1') {
                                    if (data.isWatermark == 1) {
                                        if (data.waterType == "0") { //文字
                                            _this_1.waterImg = __WEBPACK_IMPORTED_MODULE_22__pages_watermark__["a" /* __waterDocumentSvg */](__assign({}, data));
                                        }
                                        else {
                                            _this_1.waterImg = "data:image/png;base64," + data.img; //data:image/png;base64,
                                        }
                                    }
                                    else {
                                        _this_1.waterImg = "";
                                    }
                                }
                                else {
                                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error("" + getLabel(127353, '错误'));
                                }
                            });
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                            throw error;
                        }
                        var timeCount = function () {
                            var _this = _this_1;
                            var timer = setTimeout(function () {
                                if ((__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".react-resizable-handle") && __WEBPACK_IMPORTED_MODULE_7_jquery___default()(".react-resizable-handle").length > 0) || Number(timer) > 100000) {
                                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(".react-resizable-handle").on("mousedown", _this.addRightMenu);
                                    clearTimeout(timer);
                                }
                                else {
                                    timeCount();
                                }
                            }, 200);
                        };
                        timeCount();
                    };
                    try {
                        //开启了二次身份验证
                        __WEBPACK_IMPORTED_MODULE_4__util__["default"].doCheckSecondaryVerify4ec({ mouldCode: "FORMMODE", itemCode: "PAGE", customid: props.customId }, function (res) {
                            if (res.status != '1') {
                                _this_1.hasRight = false;
                                _this_1.verified = true;
                                _this_1.isInit = true;
                                return;
                            }
                            else {
                                initList_1();
                            }
                        });
                    }
                    catch (_d) {
                        initList_1();
                    }
                }
            }));
        };
        this.clearDefaultValue = function (datas) {
            if (datas === void 0) { datas = []; }
            var resetToEmpty = function (item) {
                var fieldhtmltype = item.fieldhtmltype, fieldtype = item.fieldtype, _a = item.value, value = _a === void 0 ? '' : _a;
                if ((fieldhtmltype == '1' && fieldtype != '1') //数值类型
                    || (fieldhtmltype == '5' && fieldtype == '1') //下拉框
                    || (fieldhtmltype == '4' && fieldtype == '1') //勾选框
                    || (fieldhtmltype == '5' && fieldtype == '2') //多选框
                    || (fieldhtmltype == '5' && fieldtype == '3') //单选框
                ) {
                    if (fieldhtmltype == '1' && fieldtype != '1') {
                        item.value = '-1';
                    }
                    else {
                        item.value = '';
                    }
                }
                else if (fieldhtmltype == '3' && fieldtype == '1') { //人员 ["-5",""]||[]
                    if (value[0] == '-5') { //全部 ["0", null]
                        item.value = ["-5", ""];
                    }
                    else {
                        item.value = ["0"];
                    }
                }
                else if (fieldhtmltype == '3' && fieldtype == '2') { //创建日期
                    item.value = ["0"];
                }
                else if (item.hasOwnProperty('replaceDatas')) {
                    item.replaceDatas = [];
                }
                else {
                    item.value = '';
                }
                return item;
            };
            var res = datas.map(function (data) {
                if (data.hasOwnProperty('searchGroup')) {
                    data.searchGroup = data.searchGroup.map(function (item) {
                        return resetToEmpty(item);
                    });
                }
                else {
                    data = resetToEmpty(data);
                }
                return data;
            });
            return res;
        };
        this.addRightMenu = function () {
            var flag = true;
            _this_1.rightMenus.forEach(function (e) {
                if (e.key == 'CleanCol') {
                    flag = false;
                }
            });
            if (flag) {
                _this_1.rightMenus.push({
                    function: "CleanCol",
                    icon: "icon-mode-batch-editing",
                    key: "CleanCol",
                    name: "初始化列宽",
                    quickButton: false
                });
            }
        };
        this.initQuickValue = function () {
            _this_1.quickSearchData.quicksearchinfo && _this_1.quickSearchData.quicksearchinfo.map(function (item) {
                var setItem = function (item) {
                    var value;
                    var fieldhtmltype = item.fieldhtmltype, fieldtype = item.fieldtype;
                    if (fieldhtmltype == '1') {
                        if (fieldtype == '1' && item.value) {
                            value = item.value;
                        }
                        if (['2', '3', '4', '5'].indexOf(fieldtype) > -1) { //数值
                            var selectArr = item.options.filter(function (opt) { return opt.selected == true; });
                            if (selectArr.length > 0) {
                                value = selectArr[0].key;
                                item.value = value; //暂时在前端改，后期需要后端返回value
                            }
                        }
                    }
                    else if (fieldhtmltype == '3') {
                        var isHrm = fieldtype == '1' || ('1' == item.conditiontransition && '17' == fieldtype);
                        if (isHrm || ['2', '19', '290'].indexOf(fieldtype) > -1) { //人力资源和日期等
                            if (item.value) {
                                value = item.value;
                            }
                        }
                        else {
                            if (item.replaceDatas) {
                                value = item.replaceDatas.reduce(function (pre, current, c, d) { return pre ? pre + "," + current.id : current.id; }, '');
                            }
                        }
                    }
                    else if ((fieldhtmltype == '5' && ['1', '2', '3'].indexOf(fieldtype) > -1) || (fieldhtmltype == '4' && fieldtype == '1')) { //选择框、勾选框等
                        var selectArr = item.options.filter(function (opt) { return opt.selected == true; });
                        if (selectArr.length > 0) {
                            value = selectArr[0].key;
                        }
                    }
                    return value;
                };
                if (item.hasOwnProperty('searchGroup')) {
                    item.searchGroup.map(function (groupItem) {
                        var value = setItem(groupItem);
                        if (value) {
                            __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.set(_this_1.quickSearchFormData, groupItem.fieldid, value);
                        }
                    });
                }
                else {
                    var value = setItem(item);
                    if (value) {
                        __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.set(_this_1.quickSearchFormData, item.fieldid, value);
                    }
                }
            });
        };
        this.getConditionOrAdvanced = function (params) {
            if (_this_1.type == 'advanced') {
                _this_1.getAdvancedInfo(params, function () { });
            }
            else {
                _this_1.getConditionInfo(params, _this_1.afterConditionInit);
            }
        };
        this.afterConditionInit = function (params) {
            for (var field in params) {
                if (_this_1.condition.form.fieldMap && _this_1.condition.form.fieldMap[field] && _this_1.condition.form.fieldMap[field]['conditionType'] && _this_1.condition.form.fieldMap[field]['conditionType'] == 'SCOPE') { //条件参数传参，scope类型处理
                    if (typeof params[field] == 'string') { //如果是字符串
                        params[field] = [params[field].split(',')[0], params[field].split(',')[1]];
                    }
                }
            }
            _this_1.params = params;
            _this_1.getConditionParams(params, function (dataSource) {
                var _a;
                var dataSourceParams = {};
                for (var field in dataSource) {
                    if (Array.isArray(dataSource[field])) {
                        dataSourceParams[field] = dataSource[field].join(',');
                    }
                    else if (typeof dataSource[field] == 'object') {
                        dataSourceParams[field] = dataSource[field].value;
                    }
                    else {
                        dataSourceParams[field] = dataSource[field];
                    }
                    //多部门单独处理
                    if (field.startsWith('dbm_con_')) {
                        _this_1.params[field] = dataSourceParams[field];
                    }
                }
                if (JSON.stringify(_this_1.copyDataSource) == "{}") {
                    _this_1.copyDataSource = dataSourceParams;
                }
                _this_1.copyIsNullField = dataSource;
                var isQuickValue = {};
                var canAdd = 0;
                var _b = _this_1.quickSearchData.quicksearchinfo, quicksearchinfo = _b === void 0 ? [] : _b;
                quicksearchinfo.map(function (item) {
                    var isadd = 0;
                    for (var key in dataSourceParams) {
                        var fieldid = key.substring(4, key.length);
                        if (fieldid == item.fieldid) {
                            isadd++;
                            // _.set(this.quickSearchFormData, item.fieldid,dataSourceParams[key]);
                        }
                    }
                    if (isadd == 0) {
                        var _a = item.value, value_1 = _a === void 0 ? '' : _a, _b = item.replaceDatas, replaceDatas_1 = _b === void 0 ? [] : _b, _c = item.options, options_1 = _c === void 0 ? [] : _c, _d = item.conditiontransition, conditiontransition_1 = _d === void 0 ? '' : _d, _e = item.fieldtype, fieldtype_1 = _e === void 0 ? '' : _e, _f = item.groupid, groupid = _f === void 0 ? '0' : _f;
                        if (groupid != '' && groupid != '0') { //存在分组
                            var searchGroup = item.searchGroup || [];
                            searchGroup.map(function (item_group) {
                                value_1 = item_group.value || '';
                                replaceDatas_1 = item_group.replaceDatas || [];
                                options_1 = item_group.options || [];
                                conditiontransition_1 = item_group.conditiontransition || '';
                                fieldtype_1 = item_group.fieldtype || '';
                                if (value_1 != '') {
                                    if (conditiontransition_1 == '1' && fieldtype_1 == '17') { //但人力资源单选变多选单独解析
                                        var hrmValue = '';
                                        if (item_group.value[1] && item_group.value[1] != '') {
                                            if (item_group.value[1][0]) {
                                                hrmValue = item_group.value[1][0];
                                            }
                                        }
                                        else if (item_group.value[0] && item_group.value[0] != '') {
                                            hrmValue = item_group.value[0];
                                        }
                                        isQuickValue[item_group.fieldid] = hrmValue;
                                    }
                                    else {
                                        isQuickValue[item_group.fieldid] = item_group.value;
                                    }
                                    canAdd++;
                                }
                                else if (replaceDatas_1 != '') {
                                    var repalceValues_1 = '';
                                    replaceDatas_1.map(function (its) {
                                        repalceValues_1 += its.id + ",";
                                    });
                                    repalceValues_1 = repalceValues_1.substring(0, repalceValues_1.length - 1);
                                    isQuickValue[item_group.fieldid] = repalceValues_1;
                                    canAdd++;
                                }
                                else if (options_1 != '') {
                                    var opValue_1 = '';
                                    var isOptions_1 = 0;
                                    options_1.map(function (opItem) {
                                        var _a = opItem.key, key = _a === void 0 ? '' : _a, selected = opItem.selected;
                                        if (selected) {
                                            opValue_1 = key + ",";
                                            isOptions_1++;
                                            canAdd++;
                                        }
                                    });
                                    if (isOptions_1 > 0) {
                                        opValue_1 = opValue_1.substring(0, opValue_1.length - 1);
                                        isQuickValue[item_group.fieldid] = opValue_1;
                                    }
                                }
                            });
                        }
                        else {
                            if (value_1 != '') {
                                if (conditiontransition_1 == '1' && fieldtype_1 == '17') { //但人力资源单选变多选单独解析
                                    var hrmValue = '';
                                    if (item.value[1] && item.value[1] != '') {
                                        if (item.value[1][0]) {
                                            hrmValue = item.value[1][0];
                                        }
                                    }
                                    else if (item.value[0] && item.value[0] != '') {
                                        hrmValue = item.value[0];
                                    }
                                    isQuickValue[item.fieldid] = hrmValue;
                                }
                                else {
                                    isQuickValue[item.fieldid] = item.value;
                                }
                                canAdd++;
                            }
                            else if (replaceDatas_1 != '') {
                                var repalceValues_2 = '';
                                replaceDatas_1.map(function (its) {
                                    repalceValues_2 += its.id + ",";
                                });
                                repalceValues_2 = repalceValues_2.substring(0, repalceValues_2.length - 1);
                                isQuickValue[item.fieldid] = repalceValues_2;
                                canAdd++;
                            }
                            else if (options_1 != '') {
                                var opValue_2 = '';
                                var isOptions_2 = 0;
                                options_1.map(function (opItem) {
                                    var _a = opItem.key, key = _a === void 0 ? '' : _a, selected = opItem.selected;
                                    if (selected) {
                                        opValue_2 = key + ",";
                                        isOptions_2++;
                                        canAdd++;
                                    }
                                });
                                if (isOptions_2 > 0) {
                                    opValue_2 = opValue_2.substring(0, opValue_2.length - 1);
                                    isQuickValue[item.fieldid] = opValue_2;
                                }
                            }
                        }
                    }
                });
                if (canAdd > 0) {
                    isQuickValue = __assign({}, isQuickValue, { canIsQuickSearch: '1' });
                }
                var isNewTableSearch = { isNewTableSearch: "1" };
                var linkParams = {};
                //存在页面扩展关联字段，则需要取关联字段的值QC944386
                var linkFields = _this_1.copyDataSource && _this_1.copyDataSource.linkFields || '';
                if (linkFields) {
                    linkParams = {
                        linkFields: linkFields
                    };
                    var templinkFields = linkFields.split(",");
                    for (var i = 0; i < templinkFields.length; i++) {
                        linkParams = __assign((_a = {}, _a[templinkFields[i]] = _this_1.copyDataSource[templinkFields[i]], _a), linkParams);
                    }
                }
                if (_this_1.isEdit) {
                    _this_1.doBatchEdit_datakey();
                }
                else {
                    _this_1.dataKey(__assign({}, _this_1.params, _this_1.getConditionValues(), dataSourceParams, isQuickValue, isNewTableSearch, linkParams));
                }
                //树工具栏相关
                if (params.fromToolBar && params.fromToolBar == '1') {
                    delete params.quickSearchValue;
                    delete params.datasqlwhere;
                    delete _this_1.params.quickSearchValue;
                    delete _this_1.params.datasqlwhere;
                }
                if (!_this_1.isShowCondition) {
                    _this_1.condition.update({ visible: false });
                }
            });
        };
        this.getTemplate = function (params, first, callback) {
            if (first === void 0) { first = false; }
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getTemplates(__assign({}, params, { type: (_this_1.type == 'advanced' ? '1' : '2') //显示普通查询的模板或高级查询的
             })).then(function (_a) {
                var error = _a.error, status = _a.status, _b = _a.templates, templates = _b === void 0 ? [] : _b;
                if (status == '1') {
                    if (_this_1.type == 'advanced') {
                        _this_1.advanced.templates = templates;
                    }
                    else {
                        _this_1.condition.templates = templates;
                    }
                    if (first) {
                        var selected = templates.filter(function (t) { return t.selected; });
                        if (selected.length > 0) {
                            _this_1.changeTemplate(selected[0].key, function () {
                                if (_this_1.type == "base") {
                                    callback && callback(true);
                                }
                            });
                        }
                        else {
                            callback && callback(false);
                        }
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.changeTemplate = function (templateid, callback) {
            _this_1.templateid = templateid;
            if (!templateid) {
                if (_this_1.type == 'advanced') {
                    _this_1.advanced.form = new __WEBPACK_IMPORTED_MODULE_6_comsMobx__["WeaForm"]();
                }
                else {
                    _this_1.condition.form = new __WEBPACK_IMPORTED_MODULE_6_comsMobx__["WeaForm"]();
                }
                _this_1.getConditionOrAdvanced(_this_1.params);
                return;
            }
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getTemplateInfo(__assign({}, _this_1.params, { templateid: templateid })).then(function (_a) {
                var status = _a.status, error = _a.error, conditionInfo = _a.conditionInfo, dataSource = _a.dataSource, checkAdvanedData = _a.checkAdvanedData;
                _this_1.isTempSearch = "1";
                if (status == '1') {
                    _this_1.checkAdvanedData = checkAdvanedData;
                    //qc808406如果模板中查询条件全部取消勾选，模板不生效
                    if (conditionInfo[0].items && conditionInfo[0].items.length <= 0) {
                        _this_1.getConditionOrAdvanced(_this_1.params);
                    }
                    else {
                        var _timer_1 = function (advanced) {
                            if (advanced.form.isFormInit) {
                                advanced.updateField(dataSource, true);
                                if (callback) {
                                    callback();
                                }
                                else {
                                    _this_1.type == "base" && _this_1.refresh();
                                }
                            }
                            else {
                                setTimeout(function () {
                                    if (advanced.form.isFormInit) {
                                        advanced.updateField(dataSource, true);
                                        if (callback) {
                                            callback();
                                        }
                                        else {
                                            _this_1.type == "base" && _this_1.refresh();
                                        }
                                    }
                                    else {
                                        _timer_1(advanced);
                                    }
                                }, 200);
                            }
                        };
                        if (_this_1.type == 'advanced') {
                            _this_1.advanced.form = new __WEBPACK_IMPORTED_MODULE_6_comsMobx__["WeaForm"]();
                            _this_1.advancedInfo = conditionInfo;
                            _this_1.advanced.form.initFormFields(conditionInfo);
                            _this_1.isInit = true;
                            _timer_1(_this_1.advanced);
                        }
                        else {
                            _this_1.condition.form = new __WEBPACK_IMPORTED_MODULE_6_comsMobx__["WeaForm"]();
                            _this_1.conditionInfo = conditionInfo;
                            _this_1.condition.form.initFormFields(conditionInfo);
                            _timer_1(_this_1.condition);
                        }
                        if (!_this_1.isShowCondition) {
                            _this_1.condition.update({ visible: false });
                        }
                    }
                    // this.refresh();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.reloadSearch = function (params, card) {
            _this_1.clear();
            if (card) {
                _this_1.card = card;
            }
            _this_1.init(params);
        };
        this.getConditionParams = function (params, callback) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getConditionParams(__assign({}, params, { type: _this_1.type })).then(function (_a) {
                var error = _a.error, status = _a.status, dataSource = _a.dataSource;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.keys(params).forEach(function (item) {
                        if (item.startsWith('con_') && !dataSource[item]) {
                            delete _this_1.params[item];
                        }
                    });
                    var newDataSource = __assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.params), dataSource);
                    var expendNewDataSource = __assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.params), dataSource);
                    // 如果是页面扩展卡片页面的关联字段，则条件不回显到高级查询
                    var linkFields = expendNewDataSource.linkFields;
                    if (linkFields && (expendNewDataSource.isfromTab == '1' || expendNewDataSource.isfromRight == '1')) {
                        for (var field in expendNewDataSource) {
                            for (var i = 0; i < linkFields.length; i++) {
                                if (field == linkFields[i]) {
                                    delete expendNewDataSource[field];
                                }
                            }
                        }
                    }
                    if (_this_1.type == 'advanced') {
                        _this_1.advanced.updateField(expendNewDataSource);
                    }
                    else {
                        _this_1.condition.updateField(expendNewDataSource);
                    }
                    callback && callback(newDataSource);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.getAdvancedInfo = function (params, callback) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getAdvancedInfo(params).then(function (_a) {
                var error = _a.error, status = _a.status, props = __rest(_a, ["error", "status"]);
                if (status == '1') {
                    var checkAdvanedData = props.checkAdvanedData;
                    _this_1.checkAdvanedData = checkAdvanedData;
                    var _b = props.dataSource, dataSource = _b === void 0 ? {} : _b;
                    _this_1.advanced.form = new __WEBPACK_IMPORTED_MODULE_6_comsMobx__["WeaForm"]();
                    _this_1.advancedInfo = props.advancedInfo;
                    _this_1.advanced.form.initFormFields(_this_1.advancedInfo);
                    if (!__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isEmpty(dataSource)) {
                        _this_1.advanced.updateField(dataSource);
                    }
                    _this_1.isInit = true;
                    callback && callback(params);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.getConditionInfo = function (params, callback) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getConditionInfo(params).then(function (_a) {
                var error = _a.error, status = _a.status, props = __rest(_a, ["error", "status"]);
                if (status == '1') {
                    if (params.customid == _this_1.params.customid) {
                        _this_1.update(props);
                        _this_1.condition.form.initFormFields(props.conditionInfo);
                        _this_1.condition.form.isFormInit = true;
                        callback && callback(params);
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.toGetJsCodeArea = function (callback) {
            __WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB = null; //预加载回调函数，清理函数代码缓存。
            var params = { customId: _this_1.params.customid };
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getJsCodeArea(params).then(function (_a) {
                var status = _a.status, error = _a.error, scriptStr = _a.scriptStr;
                if (status == '1') {
                    try {
                        __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#custompageCodeArea").html("").append(scriptStr);
                        __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isFunction(callback) && callback();
                    }
                    catch (e) {
                        console && console.log("加载查询列表代码块异常！css 部分请用：<style type=\"text/css\"></style>; js部请用：<script type=\"text/javascript\"></script>包裹");
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(127353, "错误") + " :" + error);
                }
            });
        };
        this.changeDetailPageSize = function (current, pagesize) {
            var _a;
            _this_1.searchTree = {
                current: current == 0 ? 1 : current,
                pagesize: pagesize
            };
            _this_1.pagesizetree = pagesize;
            if (current == 0) {
                return;
            }
            var linkParams = {};
            //存在页面扩展关联字段，则需要取关联字段的值QC944386
            var linkFields = _this_1.copyDataSource && _this_1.copyDataSource.linkFields || '';
            if (linkFields) {
                linkParams = {
                    linkFields: linkFields
                };
                var templinkFields = linkFields.split(",");
                for (var i = 0; i < templinkFields.length; i++) {
                    linkParams = __assign((_a = {}, _a[templinkFields[i]] = _this_1.copyDataSource[templinkFields[i]], _a), linkParams);
                }
            }
            var params = Object.keys(_this_1.getConditionValues()).length == 0 ? __assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.quickSearchFormData), { isQuickSearch: 1 }) : _this_1.getConditionValues();
            _this_1.dataKey(__assign({ current: _this_1.searchTree.current, pagesize: pagesize }, params, linkParams));
        };
        this.nextDetailDatas = function (pagination) {
            var current = pagination;
            _this_1.searchTree = __assign({}, _this_1.searchTree, { current: current });
            _this_1.tableData = {
                total: 0,
                Data: [],
            };
            if (current == 0) {
                _this_1.searchTree.current = 1;
                return;
            }
            var params = Object.keys(_this_1.getConditionValues()).length == 0 ? __assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.quickSearchFormData), { isQuickSearch: 1 }) : _this_1.getConditionValues();
            _this_1.dataKey(__assign({ current: current, pagesize: _this_1.pagesizetree }, params));
        };
        this.imgPageChaneg = function (current, pageSize) {
            _this_1.newTable.datas = [];
            _this_1.imgPageRefresh = true;
            if (pageSize) {
                Object(__WEBPACK_IMPORTED_MODULE_21__apis_table__["c" /* setTablePageSize */])({
                    pageSize: pageSize,
                    dataKey: _this_1.sessionKey
                }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                    var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas;
                    if (status == '1') {
                        _this_1.newTable.current = 1;
                        _this_1.newTable.getDatas(_this_1.sessionKey, _this_1.newTable.current, _this_1.newTable.pageSize, {}, _this_1.addScroll);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error("[" + (getLabel(127353, '错误') + errorCode) + "]:" + error);
                    }
                }));
            }
            else {
                _this_1.newTable.current = current;
                _this_1.newTable.getDatas(_this_1.sessionKey, _this_1.newTable.current, _this_1.newTable.pageSize, {}, _this_1.addScroll);
            }
        };
        this.dataKey = function (params) {
            var _a;
            //处理选择框的key
            var keys = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.keys(params);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (key.indexOf(',') > 0) {
                    params[key.split(',')[0]] = params[key];
                }
            }
            // @ts-ignore
            var windowWidth = document.documentElement.clientWidth;
            _this_1.loading = true;
            if (params && params['isQuickSearch']) {
                if (params && params['isfromTab'] != '1') {
                    __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.forOwn(_this_1.params, function (value, key) {
                        if (key.startsWith('con_')) {
                            delete _this_1.params[key];
                        }
                    });
                }
            }
            if (_this_1.displayType === SearchDisplayType.ImgType) {
                _this_1.imgSelectValue = "";
                _this_1.searchImg.loading = true;
                params = __assign({}, params, { current: _this_1.newTable.current, pagesize: _this_1.newTable.pageSize });
                if (!_this_1.imgPageRefresh) {
                    _this_1.selectRowKeyAll(true);
                }
                else {
                    _this_1.imgPageRefresh = false;
                }
            }
            /**z纵向列表清空数据， */
            if (_this_1.displayType === SearchDisplayType.VerticalType) {
                _this_1.selectRowkeys = [];
                _this_1.verticalListStore.clear();
                _this_1.verticalListStore.update({ loading: true });
            }
            if (_this_1.top.selectedKey !== 'all') {
                params.groupValue = _this_1.top.selectedKey;
            }
            //分组列表-分页
            var pageInfo = {};
            if (_this_1.displayType && _this_1.displayType == 'treeType') {
                pageInfo['current'] = _this_1.searchTree.current;
                pageInfo['pagesize'] = _this_1.searchTree.pagesize;
            }
            //存在页面扩展关联字段，则需要取关联字段的值QC944386
            var linkParams = {};
            var linkFields = _this_1.copyDataSource && _this_1.copyDataSource.linkFields || '';
            if (linkFields) {
                linkParams = {
                    linkFields: linkFields
                };
                var templinkFields = linkFields.split(",");
                for (var i = 0; i < templinkFields.length; i++) {
                    linkParams = __assign((_a = {}, _a[templinkFields[i]] = _this_1.copyDataSource[templinkFields[i]], _a), linkParams);
                }
            }
            //处理选择框的key
            var requireTimes = _this_1.requireTimesdata;
            _this_1.update({ requireTimesdata: requireTimes + 1 });
            _this_1.reloadParams = params;
            var tempParams = __assign({}, _this_1.params, params, { displayType: _this_1.displayType }, pageInfo, { isTempSearch: _this_1.isTempSearch, windowWidth: windowWidth, isTreeType: _this_1.isTreeType }, linkParams);
            //统计和分组统计单独处理
            _this_1.getCountData(tempParams);
            _this_1.getGroupData(tempParams);
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].dataKey(tempParams).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, datas = _a.datas, countDisplayPosition = _a.countDisplayPosition, buttonBody = _a.buttonBody, treeFieldStr = _a.treeFieldStr, editableColumns = _a.editableColumns, singleKeyField = _a.singleKeyField, treemap = _a.treemap, enableTreeList = _a.enableTreeList, isTreeSearch = _a.isTreeSearch, treeposition = _a.treeposition, windowTitle = _a.windowTitle, changeDataTime = _a.changeDataTime, isChexkAdvanedDate = _a.isChexkAdvanedDate, treeDataWidth = _a.treeDataWidth, mergeInfos = _a.mergeInfos, mergeFields = _a.mergeFields;
                var requireTimesNow = _this_1.requireTimesdata;
                if (requireTimesNow == requireTimes + 1) {
                    if (status == '1') {
                        _this_1.isTempSearch = "";
                        _this_1.sessionKey = datas;
                        _this_1.mergeInfos = mergeInfos;
                        _this_1.mergeFields = mergeFields;
                        // const tempKey = datas;
                        _this_1.treeDataWidth = treeDataWidth;
                        _this_1.isTree = false;
                        _this_1.checkAdvanedData = isChexkAdvanedDate;
                        _this_1.countDisplayPosition = String(countDisplayPosition);
                        try {
                            __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#cubelistCodeArea").html("");
                            __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#cubelistCodeArea").append("<script type=\"text/javascript\">" + buttonBody + " </script>");
                        }
                        catch (e) {
                            console && console.log(getLabel('522704', '自定义按钮代码块异常!'));
                        }
                        _this_1.listEditStore.editableColumns = editableColumns;
                        _this_1.enableTreeList = enableTreeList;
                        _this_1.changeDataTime = changeDataTime;
                        _this_1.printWindowTitle = windowTitle;
                        if (_this_1.params.menuIds) { //门户工具栏的点击,不需要改变页面title
                            _this_1.windowTitle = windowTitle;
                        }
                        _this_1.isTreeSearch = isTreeSearch;
                        if (treeposition != "" && isTreeSearch == "1" && enableTreeList == "y" && _this_1.isTreeType == '') {
                            _this_1.isTree = true;
                        }
                        if (_this_1.displayType === SearchDisplayType.Excel) {
                            _this_1.excelStore.getDatas(datas);
                        }
                        else if (_this_1.displayType == SearchDisplayType.TreeType && _this_1.isTree) {
                            //QC:723922
                            if (!params || (params.isNewTableSearch && params.isNewTableSearch == 1)) {
                                _this_1.selectedRowKeys = [];
                                _this_1.treeKey = [];
                            }
                            _this_1.isExpTree = '1';
                            var _b = treemap, _c = _b.total, total = _c === void 0 ? 0 : _c, _d = _b.treecolumns, treecolumns = _d === void 0 ? [] : _d;
                            var treedatas = treemap.treedatas;
                            _this_1.addScrollForTree(treedatas);
                            if (_this_1.doRealAction) { //数据筛选
                                _this_1.checkLoading = true;
                                _this_1.tempTabledatas = JSON.parse(JSON.stringify(treedatas));
                                _this_1.tempselectedRowKeys = _this_1.selectedRowKeys;
                                var removeSelct_1 = [];
                                _this_1.checkBtn = "expandid_" + _this_1.oldMenueKey;
                                treedatas.map(function (item) {
                                    if (item[_this_1.checkBtn] == "true") {
                                        item.randomFieldCk = "false";
                                        removeSelct_1.push(item['key'] || item['id'] || item['randomFieldId']);
                                    }
                                    if (item.sublist) {
                                        item.sublist = _this_1.dealSubList(item.sublist, removeSelct_1);
                                    }
                                });
                                var rowkeys = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.difference(_this_1.tempselectedRowKeys, removeSelct_1);
                                _this_1.filterSelectRows = removeSelct_1;
                                _this_1.tableData.Data = JSON.parse(JSON.stringify(datas));
                                _this_1.selectedRowKeys = rowkeys;
                                setTimeout(function () {
                                    _this_1.checkLoading = false;
                                }, 1000);
                            }
                            if (__WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB && typeof __WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB == 'function') {
                                // @ts-ignore
                                treedatas = __WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(treedatas), 'treeType');
                            }
                            _this_1.tableData = {
                                total: total,
                                Data: treedatas
                            };
                            var treePercent_1 = 0;
                            treecolumns.map(function (col) {
                                treePercent_1 += parseFloat(col.width.replace('%', ''));
                            });
                            if (_this_1.searchTree.current == 0) {
                                _this_1.searchTree.current = 1;
                            }
                            _this_1.treePercent = treePercent_1;
                            _this_1.treecolumns = treecolumns;
                            _this_1.changeSearch = '1';
                            if (countDisplayPosition === 2) { // 针对分组列表，需在top加载后再render一次，加载右上角展示的“统计项”
                                setTimeout(function () {
                                    _this_1.countData = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.countData);
                                }, 100);
                            }
                        }
                        else {
                            // if(!this.doRealAction){
                            //     this.clearTable();
                            // }else{
                            _this_1.countReturn = 0;
                            _this_1.newTable = new TableStore({
                                dataHandle: function (datas) {
                                    _this_1.rightLayoutWidth = '0%';
                                    if (_this_1.rowClick['5']) { //如果存在列表小卡片，处理下分页函数
                                        _this_1._$('tr[littlecard]').remove();
                                    }
                                    _this_1.countReturn++; // table请求datas接口后会多次执行dataHandle方法，用来标记次数
                                    if (_this_1.doRealAction) { //数据筛选
                                        _this_1.checkLoading = true;
                                        if (_this_1.countReturn == 2) {
                                            if (__WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB && typeof __WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB == 'function') {
                                                // @ts-ignore
                                                datas = __WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(datas), 'normal');
                                            }
                                        }
                                        _this_1.tempTabledatas = JSON.parse(JSON.stringify(datas));
                                        var isImgSearch_1 = _this_1.displayType == SearchDisplayType.ImgType;
                                        _this_1.tempselectedRowKeys = isImgSearch_1 ? _this_1.selectRowkeys : _this_1.newTable.selectedRowKeys;
                                        var removeSelct_2 = [];
                                        var expandBtn = "expandid_" + _this_1.oldMenueKey + "span";
                                        if (_this_1.displayType == SearchDisplayType.TreeType) {
                                            expandBtn = "expandid_" + _this_1.oldMenueKey;
                                        }
                                        _this_1.checkBtn = expandBtn;
                                        datas.map(function (item) {
                                            if (item[_this_1.checkBtn] == "true") {
                                                item.randomFieldCk = "false";
                                                if (isImgSearch_1) {
                                                    var imgId = item.randomFieldId ? (item.randomFieldSubKeyd_id != undefined ? item.randomFieldId + "_" + item.randomFieldSubKeyd_id : item.randomFieldId) : "";
                                                    removeSelct_2.push(imgId);
                                                }
                                                else {
                                                    removeSelct_2.push(item['id']);
                                                }
                                            }
                                        });
                                        var rowkeys = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.difference(_this_1.tempselectedRowKeys, removeSelct_2);
                                        _this_1.filterSelectRows = removeSelct_2;
                                        _this_1.newTable.selectedRowKeys = rowkeys;
                                        if (isImgSearch_1) {
                                            _this_1.selectRowkeys = rowkeys;
                                            _this_1.setImgSelectValue(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(rowkeys.map(function (d) { return d.split('_')[0]; })).join(','));
                                        }
                                        // this.newTable.selectedRowKeysAllPages = rowkeys;
                                        setTimeout(function () {
                                            _this_1.checkLoading = false;
                                        }, 1000);
                                    }
                                    else {
                                        if (_this_1.countReturn == 2) {
                                            if (__WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB && typeof __WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB == 'function') {
                                                // @ts-ignore
                                                datas = __WEBPACK_IMPORTED_MODULE_28__util_searchUtil__["modeList"].dataLoadAfterCB(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(datas), 'normal');
                                            }
                                        }
                                    }
                                    if (_this_1.displayType === SearchDisplayType.ImgType) {
                                        _this_1.searchImg.loading = false;
                                    }
                                    if (_this_1.countReturn == 2 && _this_1.displayType === SearchDisplayType.VerticalType && countDisplayPosition === 2) {
                                        // 针对分组列表，需在top加载后再render一次，加载右上角展示的“统计项”
                                        setTimeout(function () {
                                            _this_1.countData = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.countData);
                                        }, 100);
                                    }
                                    if (_this_1.countReturn == 2) {
                                        _this_1.countReturn = 0;
                                    }
                                    return datas;
                                },
                            });
                            // }
                            //纵向列表pagesize =
                            if (_this_1.displayType == SearchDisplayType.VerticalType) {
                                var _e = _this_1.verticalListStore, current = _e.current, pageSize = _e.pageSize, newDataBacks = _e.newDataBacks;
                                _this_1.newTable.getDatas(datas, current, pageSize, {}, newDataBacks);
                            }
                            else {
                                _this_1.newTable.getDatas(datas, _this_1.newTable.current, _this_1.newTable.pageSize, {}, _this_1.addScroll);
                            }
                            _this_1.changeSearch = '0';
                        }
                        _this_1.treeFieldStr = treeFieldStr;
                        if (singleKeyField) {
                        }
                        if (_this_1.cubeViewResource && _this_1.cubeViewResource.isEditList) { // 1000483资源面板-保存后继续修改
                            _this_1.isEdit = true;
                            _this_1.cubeViewResource.setIsEditList(false);
                            _this_1.doBatchEdit();
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                        throw error;
                    }
                    if (!_this_1.condition.isInit) {
                        _this_1.condition.isInit = true;
                        if (_this_1.isShowCondition) {
                            _this_1.condition.update({ visible: true });
                        }
                        else {
                            _this_1.condition.update({ visible: false });
                        }
                    }
                    _this_1.isInit = true;
                    if (_this_1.isInnerTab) {
                        var changeLoadingState = getParent().changeLoadingState;
                        changeLoadingState && changeLoadingState(false);
                    }
                    else {
                        _this_1.loading = false;
                    }
                }
            }));
        };
        this.deleteData = function (params, callback) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].deleteData(params).then(function (_a) {
                var status = _a.status, error = _a.error, data = __rest(_a, ["status", "error"]);
                if (status == '1') {
                    _this_1.isDelShow = false;
                    callback(data);
                    if (_this_1.params.isRefreshTree == '1') { //树的 删除的时候检查是否刷新左侧树
                        __WEBPACK_IMPORTED_MODULE_4__util__["default"].refreshTree(_this_1.params.customTreeDataId);
                    }
                    if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].location.hash.indexOf('#/main/cube/viewResource') > -1 && _this_1.cubeViewResource) {
                        _this_1.cubeViewResource.query(); // 触发资源面板更新
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        /**
         * 用于分组列表添加无数据时的横向滚动条
         */
        this.addScrollForTree = function (treedatas) {
            if (treedatas === void 0) { treedatas = []; }
            var scrollText = _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').attr("style");
            if (scrollText) {
                _this_1._$('.e8operate').hover(function (e) {
                    // jQuery("table tr").hover(function(){
                    //     var lh = jQuery(this).index();//这个前面得到的是tr的序号，从0开始，要得到第几行，+1即可
                    //     jQuery(jQuery('.hoverDiv')[lh]).css("display","block");
                    // })
                    // jQuery("table tr").mouseover(function(){
                    //     setTimeout(()=>{
                    //         var lh = jQuery(this).index();//这个前面得到的是tr的序号，从0开始，要得到第几行，+1即可
                    //         jQuery(jQuery('.hoverDiv')[lh]).css("display","none");
                    //        } ,100)
                    // })
                });
                if (treedatas.length < 1) { //若分组列表无数据
                    if (!!__WEBPACK_IMPORTED_MODULE_4__util__["default"]['ActiveXObject'] || "ActiveXObject" in __WEBPACK_IMPORTED_MODULE_4__util__["default"]) {
                        _this_1._$('.ant-table-body').css('overflow-x', 'hidden').css('overflow-y', 'hidden');
                    }
                    var styleCss = scrollText + "margin-bottom: 0px !important;padding-bottom:0px !important;";
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').css('cssText', styleCss).css('overflow-x', 'scroll');
                }
                else {
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').css('cssText', '');
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-body').css('overflow-x', 'auto').css('overflow-y', 'auto');
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').css('overflow-x', 'hidden');
                }
            }
            else {
                var _this_2 = _this_1;
                setTimeout(function () {
                    _this_2.addScrollForTree(treedatas);
                }, 200);
            }
        };
        /**
         * 用于添加无数据时的横向滚动条(除分组列表)
         */
        this.addScroll = function () {
            var scrollText = _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').attr("style");
            if (scrollText && !(_this_1.displayType === SearchDisplayType.TreeType && _this_1.isTree)) {
                if (_this_1.newTable.datas.length < 1 && !_this_1.newTable.isSts) { //若table无数据，将标题栏设为可滚动
                    if (!!__WEBPACK_IMPORTED_MODULE_4__util__["default"].ActiveXObject || "ActiveXObject" in __WEBPACK_IMPORTED_MODULE_4__util__["default"]) {
                        _this_1._$('.ant-table-body').css('overflow-x', 'hidden').css('overflow-y', 'hidden');
                    }
                    var styleCss = scrollText + ";margin-bottom: 0px !important;padding-bottom:0px !important";
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').css('cssText', styleCss);
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').css('overflow-x', 'scroll');
                }
                else {
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').css('cssText', '');
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-body').css('overflow-x', 'auto').css('overflow-y', 'auto');
                    _this_1._$('.cube-list-wrapper .cube-list-table .ant-table-header').css('overflow-x', 'hidden');
                }
            }
            else {
                var _this_3 = _this_1;
                setTimeout(function () {
                    _this_3.addScroll();
                }, 200);
            }
        };
        /**
        * 批量修改用于添加无数据时的横向滚动条
        */
        this.addScroll1 = function (datas) {
            var scrollText = _this_1._$('.cube-list-wrapper .cube-table .cube-table-header').attr("style");
            if (scrollText && _this_1.isEdit) {
                if (datas.length < 1) { //若table无数据，将标题栏设为可滚动
                    if (!!__WEBPACK_IMPORTED_MODULE_4__util__["default"].ActiveXObject || "ActiveXObject" in __WEBPACK_IMPORTED_MODULE_4__util__["default"]) {
                        _this_1._$('.cube-table-body').css('overflow-x', 'hidden').css('overflow-y', 'hidden');
                    }
                    var styleCss = scrollText + ";margin-bottom: 0px !important;padding-bottom:0px !important";
                    _this_1._$('.cube-list-wrapper .cube-table .cube-table-header').css('cssText', styleCss);
                    _this_1._$('.cube-list-wrapper .cube-table .cube-table-header').css('overflow-x', 'scroll');
                }
                else {
                    _this_1._$('.cube-list-wrapper .cube-table .cube-table-header').css('cssText', '');
                    _this_1._$('.cube-list-wrapper .cube-table .cube-table-body').css('overflow-x', 'auto').css('overflow-y', 'auto');
                    _this_1._$('.cube-list-wrapper .cube-table .cube-table-header').css('overflow-x', 'hidden');
                }
            }
            else {
                var _this_4 = _this_1;
                setTimeout(function () {
                    _this_4.addScroll1(datas);
                }, 200);
            }
        };
        /**
         * @description 高级查询条件
         */
        this.getConditionValues = function () {
            var values;
            if (_this_1.type == 'advanced') {
                values = _this_1.advanced.form.getFormParams();
            }
            else {
                values = _this_1.condition.form.getFormParams();
                values = __assign({}, _this_1.advanced.form.getFormParams(), values);
            }
            var newValues = {};
            __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.forEach(values, function (value, key) {
                if (_this_1.params[key] && value == '') {
                    newValues[key] = value;
                }
                if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.compact(("" + value).split(',')).length > 0) {
                    newValues[key] = value;
                }
            });
            return newValues;
        };
        this.refresh = function (isQuickSearch, isAdvancedSearch) {
            var _a, _b;
            if (!_this_1.checkRequiredConditionIsFilled()) {
                return;
            }
            ;
            _this_1.loading = true;
            if (_this_1.isInnerTab) {
                var changeLoadingState = getParent().changeLoadingState;
                changeLoadingState && changeLoadingState(true);
                //判断是否含有条件hidetop=1，如果有则隐藏Top栏
                if (_this_1.params.hidetop) {
                    var hidetop = _this_1.params.hidetop;
                    _this_1.isInnerTab = hidetop && (hidetop | 0) === 1;
                }
            }
            else {
                _this_1.loading = true;
            }
            _this_1.advanced.visible = false;
            if (!_this_1.isShowCondition) {
                _this_1.condition.visible = false;
            }
            // if (!isQuickSearch) {
            //     this.quickSearchValue = '';
            // }
            var isQuickSearch1 = false;
            var quickSearchFormData = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.quickSearchFormData);
            if (quickSearchFormData && JSON.stringify(quickSearchFormData) !== '{}') {
                isQuickSearch1 = true;
            }
            _this_1.searchTree.current = 1;
            var advancedSearchParam = {};
            var linkParams = {};
            if (isAdvancedSearch) {
                //如果是高级搜索，不能走完全匹配
                advancedSearchParam = {
                    "isfromTab": '0',
                    "isfromRight": '0'
                };
            }
            //存在页面扩展关联字段，则需要取关联字段的值QC944386
            var linkFields = _this_1.copyDataSource && _this_1.copyDataSource.linkFields || '';
            if (linkFields) {
                linkParams = {
                    linkFields: linkFields
                };
                var templinkFields = linkFields.split(",");
                for (var i = 0; i < templinkFields.length; i++) {
                    linkParams = __assign((_a = {}, _a[templinkFields[i]] = _this_1.copyDataSource[templinkFields[i]], _a), linkParams);
                }
            }
            if (_this_1.isEdit) {
                _this_1.doBatchEdit_datakey();
                return;
            }
            _this_1.dataKey(__assign({}, _this_1.params, _this_1.customparms, isQuickSearch ? { quickSearchValue: _this_1.quickSearchValue } : {}, _this_1.getConditionValues(), linkParams, { groupValue: _this_1.top.selectedKey }, _this_1.quickConditions, isQuickSearch1 ? __assign({ isQuickSearch: "1" }, _this_1.quickSearchFormData) : {}, advancedSearchParam));
            if (_this_1.type == 'advanced') {
                _this_1.type = 'base';
                _this_1.getConditionInfo(_this_1.params, function () {
                    _this_1.condition.form.updateFields(_this_1.advanced.form.getFormDatas(), false);
                });
                _this_1.getTemplate(_this_1.params);
            }
            else {
                var keySearchFieldKeys = _this_1.keySearchFields.slice();
                if (isQuickSearch && keySearchFieldKeys.length == 1) {
                    if (_this_1.condition.form.isFormInit) {
                        if (_this_1.keyFieldidInfo.fieldid && _this_1.keyFieldidInfo.type == '1'
                            && (_this_1.keyFieldidInfo.htmltype == '1' || _this_1.keyFieldidInfo.htmltype == '2')) {
                            _this_1.condition.updateField((_b = {}, _b["con_" + _this_1.keyFieldidInfo.fieldid] = _this_1.quickSearchValue, _b));
                        }
                    }
                }
            }
            // this.searchTree = {
            //     current: 1,
            //     pagesize: 10
            // }
            _this_1.selectedRowKeys = [];
            // this.selectRowkeys = [];
        };
        this.reload = function () {
            if (_this_1.newTable.dataKey) { // 仅dataKey存在才调用getDatas方法，否则会报dataKey为空的错误提示
                _this_1.newTable.getDatas('', _this_1.newTable.current, _this_1.newTable.pageSize, {}, _this_1.addScroll);
            }
            _this_1.reloadTabsAndCounts(); //更新下基础数据，tabs，
            _this_1.selectRowkeys = [];
        };
        this.reloadBaseList = function () {
            _this_1.newTable.getDatas(_this_1.sessionKey, _this_1.newTable.current, _this_1.newTable.pageSize, {}, _this_1.addScroll);
            _this_1.reloadTabsAndCounts(); //更新下基础数据，tabs，
            _this_1.selectRowkeys = [];
        };
        this.saveTemplate = function () {
            _this_1.template.saveTemplate(_this_1);
        };
        this.managerTemplate = function () {
            _this_1.template.managerTemplate(_this_1);
        };
        this.onQuickConditionChange = function (params) {
            _this_1.update({ quickConditions: __assign({}, _this_1.quickConditions, params) });
            _this_1.refresh();
            return _this_1;
        };
        this.setTreeValueId = function (treeValueId) {
            _this_1.treeValueId = treeValueId;
        };
        this.checkSeleted = function () {
            var selectedRows = _this_1.treeValueId == "" ? __WEBPACK_IMPORTED_MODULE_4__util__["default"]._xtable_CheckedCheckboxId() : _this_1.treeValueId;
            if (_this_1.displayType == SearchDisplayType.ImgType) {
                selectedRows = _this_1.imgSelectValue;
            }
            if (_this_1.displayType == SearchDisplayType.VerticalType) {
                selectedRows = _this_1.verticalListStore.selectValue;
            }
            if (_this_1.displayType == SearchDisplayType.TreeType && _this_1.treeKey && _this_1.isTreeType != '1') {
                selectedRows = _this_1.treeKey;
                _this_1.treeValueId = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.treeKey.map(function (d) { return d.split('_')[0]; })).join(",");
            }
            if (selectedRows.length < 1) {
                __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(20149, '请至少选择一条记录。'));
                return false;
            }
            return true;
        };
        /**
         * @description 查询高级搜索必填字段拦截
         */
        this.checkRequiredConditionIsFilled = function () {
            var isFilled = true;
            var quickSearchInfo = _this_1.quickSearchData.quicksearchinfo;
            if (quickSearchInfo !== undefined || _this_1.type === "advanced") { // excel 模式未开启快捷搜索 || 高级搜索页
                var conditonObj = _this_1.conditionInfo[0] || _this_1.advancedInfo[0]; // 通过高级查询菜单地址访问
                var advancedSearchInfo = conditonObj['items'];
                var searchInfo_1 = advancedSearchInfo.slice();
                if (quickSearchInfo !== undefined) { // 高级搜索页
                    searchInfo_1 = searchInfo_1.concat(quickSearchInfo);
                }
                var requiredFiledIds_1 = searchInfo_1.filter(function (i) { return i['viewAttr'] === 3; }).map(function (i) { return i['fieldid'] || i['domkey'][0]; });
                var prefix_1 = "con_";
                requiredFiledIds_1.forEach(function (element, index) {
                    if (element.indexOf(prefix_1) != -1) {
                        requiredFiledIds_1[index] = element.split("_")[1];
                    }
                });
                //去重
                requiredFiledIds_1 = Array.from(new Set(requiredFiledIds_1));
                if (requiredFiledIds_1.length == 0) {
                    return isFilled;
                }
                var searchData_1 = __assign({}, _this_1.getConditionValues(), _this_1.quickSearchConditionData);
                var emptyVals_1 = ["", null, undefined, ["0", null, null]];
                if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isEmpty(searchData_1) && requiredFiledIds_1.length > 0) {
                    _this_1.tableDatas.clear();
                    _this_1.checkAdvanedData = getLabel(512283, "查询条件/快捷搜索条件有必填字段未填写，请填写后再试！");
                    return !isFilled;
                }
                requiredFiledIds_1.forEach(function (value, index) {
                    var requiredConditionValue = searchData_1[prefix_1 + value];
                    var type = "";
                    __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.forEach(searchInfo_1, function (o, index) {
                        var id;
                        if (o['domkey'] === undefined) {
                            id = o['fieldid'];
                        }
                        else {
                            id = o['domkey'][0];
                        }
                        if (prefix_1 + value === id) {
                            type = o['conditionType'];
                            return;
                        }
                    });
                    if (type == "DATE") {
                        var arr = requiredConditionValue;
                        if (arr[0] == 6) {
                            if (arr.length === 1 || arr[1] == "" || arr[2] == "") {
                                _this_1.tableDatas.clear();
                                _this_1.checkAdvanedData = getLabel(512283, "查询条件/快捷搜索条件有必填字段未填写，请填写后再试！");
                                isFilled = false;
                                return;
                            }
                        }
                    }
                    if (requiredConditionValue === undefined || __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.findIndex(emptyVals_1, function (e) { return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isEqual(e, value); }) != -1) {
                        _this_1.tableDatas.clear();
                        _this_1.checkAdvanedData = getLabel(512283, "查询条件/快捷搜索条件有必填字段未填写，请填写后再试！");
                        isFilled = false;
                        return;
                    }
                });
            }
            return isFilled;
        };
        this.submitData = function () {
            _this_1.refresh();
        };
        this.doBatchAdd = function () {
            _this_1.batchAddStore.customid = _this_1.customId;
            _this_1.batchAddStore.params = _this_1.params;
            _this_1.batchAddStore.init();
            __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].loadCss();
            _this_1.batchAddStore.visible = true;
            __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].loadCss();
            _this_1.batchAddStore.isfrontmultlang = _this_1.isfrontmultlang;
        };
        this.doBatchEdit = function () {
            _this_1.loading = true;
            _this_1.editTableStore.isDataLoaded = false;
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getSearchColumnInfo({ customid: _this_1.customId }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, dataList = _a.dataList, optionsMap = _a.optionsMap, browserMap = _a.browserMap, editFieldCount = _a.editFieldCount, bathEditSaveQuickButton = _a.bathEditSaveQuickButton;
                if (status == '1') {
                    if (editFieldCount == '0') {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].warn('查询列表字段定义中批量修改没有勾选，请联系管理员处理！');
                        _this_1.loading = false;
                        return;
                    }
                    _this_1.batchTempRightMenus = _this_1.rightMenus;
                    _this_1.rightMenus = [
                        bathEditSaveQuickButton,
                    ];
                    _this_1.batchTempRightMenus.forEach(function (item) {
                        if (item.function == 'submitData' && item.icon == 'icon-coms-search') {
                            _this_1.rightMenus.push({
                                'function': 'submitData',
                                'icon': 'icon-coms-search',
                                'key': 'submitData',
                                // 'name': getLabel(192, '搜索'),
                                'name': item.name,
                                'quickButton': item.quickButton
                            });
                        }
                    });
                    _this_1.rightMenus.push({
                        'function': 'doBack',
                        'icon': 'icon-coms-go-back',
                        'key': 'doBack',
                        'name': getLabel(1290, '返回'),
                        'quickButton': false
                    });
                    if (_this_1.displayType === SearchDisplayType.Excel) {
                        _this_1.isEdit = true;
                        var parm_1 = {
                            urlMap: _this_1.urlMap,
                            modeId: _this_1.modeId,
                            formId: _this_1.formId,
                            confirmMap: _this_1.confirmMap
                        };
                        _this_1.datalist = dataList;
                        _this_1.doBatchEdit_datakey(function (dataKey) {
                            if (_this_1.displayType == "excel") { // 针对Excel列表，延迟加载，避免出现Excel加载异常的问题
                                var _this_5 = _this_1;
                                setTimeout(function () {
                                    _this_5.excelStore.batchEdit(dataKey, dataList, browserMap, _this_5.batchTempRightMenus, parm_1);
                                }, 500);
                            }
                            else {
                                _this_1.excelStore.batchEdit(dataKey, dataList, browserMap, _this_1.batchTempRightMenus, parm_1);
                            }
                        });
                    }
                    else {
                        _this_1.isEdit = true;
                        _this_1.editTableStore.customid = _this_1.params.customid;
                        _this_1.datalist = dataList;
                        //let columns1 = this.dealmergecolumn(dataList);
                        _this_1.editTableStore.initTableForm([], Object(__WEBPACK_IMPORTED_MODULE_17__mobxTable_list__["a" /* getColumns */])(dataList, optionsMap, browserMap, _this_1.isfrontmultlang, _this_1.editTableStore, _this_1.buildsqlkey(dataList)));
                        _this_1.mergeTempColumns = _this_1.editTableStore.columns;
                        _this_1.editPagination.current = 1;
                        _this_1.editPagination.pageSize = _this_1.newTable.pageSize;
                        _this_1.editPagination.total = _this_1.newTable.count;
                        _this_1.editPagination.onChange = function (current, pageSize) {
                            _this_1.editPagination.current = current;
                            _this_1.editPagination.pageSize = pageSize || _this_1.editPagination.pageSize;
                            _this_1.getEditDatas();
                        };
                        _this_1.editPagination.onShowSizeChange = function (current, pageSize) {
                            _this_1.editPagination.current = current;
                            _this_1.editPagination.pageSize = pageSize || _this_1.editPagination.pageSize;
                            Object(__WEBPACK_IMPORTED_MODULE_21__apis_table__["c" /* setTablePageSize */])({
                                pageSize: pageSize,
                                dataKey: _this_1.sessionKey
                            }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                                var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas;
                                if (status == '1') {
                                    _this_1.getEditDatas();
                                }
                                else {
                                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error("[" + (getLabel(127353, '错误') + errorCode) + "]:" + error);
                                }
                            }));
                        };
                        _this_1.doBatchEdit_datakey();
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
                _this_1.loading = false;
            }));
        };
        this.dealmergecolumn = function (columns) {
            var mergeFields = _this_1.mergeFields ? _this_1.mergeFields : '';
            var columns1 = [];
            var columns2 = []; //已经处理的列
            for (var n = 0; n < columns.length; n++) {
                var dataindex = columns[n].key;
                var fieldhtmltype = columns[n].fieldhtmltype;
                var type = columns[n].fieldtype;
                if (columns[n].fieldid && (columns[n].fieldid == '-2' || columns[n].fieldid == '-4' || columns[n].fieldid == '-5') || columns[n].fieldid == '-7') {
                    dataindex = dataindex.replace('span', '');
                }
                //浮点数 金额转换 金额千分位 多行文本 特殊字段的key加了span
                if ((fieldhtmltype == '1' && (type == '3' || type == '4' || type == '5')) || (fieldhtmltype == '2' && type == '1') || (fieldhtmltype == '7')) {
                    dataindex = dataindex.replace('span', '');
                }
                if (mergeFields.indexOf(dataindex) < 0) { //如果不是合并列
                    columns1.push(columns[n]);
                }
                else { //是合并列
                    if (columns2.indexOf(dataindex) < 0) {
                        var column = _this_1.getColumn(columns, dataindex, columns2);
                        columns1.push(column);
                        //columns2.push(dataindex)
                    }
                }
            }
            return columns1;
        };
        this.buildsqlkey = function (dataList) {
            var sqlNeedKeytemp = { randomkey: new Date().getTime() };
            dataList.map(function (item) {
                __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.set(sqlNeedKeytemp, item.fieldname, item.sqlNeedFieldKey);
            });
            _this_1.sqlNeedKey = sqlNeedKeytemp;
            return sqlNeedKeytemp;
        };
        this.getSqlNeedFieldKey = function (item, index, columns, tableStore) {
            var currenttime = new Date().getTime();
            var datalisttemp = _this_1.datalist;
            __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.forEach(_this_1.sqlNeedKey, function (value, fieldids) {
                var fields = { currenttime: currenttime };
                __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.forEach(value, function (value1, sql) {
                    var keytemp = columns.key;
                    var value1temp = value1;
                    if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.parseInt(sql) % 2 === 0) { //主表字段
                        if (keytemp.indexOf("span") != -1) {
                            keytemp = columns.key.replace("span", "");
                            //fieldids=fieldids+"span";
                            value1temp = value1temp + "span";
                        }
                        if (keytemp === value1) {
                            var oldbrowserProps = tableStore.form.$('tableForm').$(item.randomFieldId + "_" + item.randomFieldSubKeyd_id).$(fieldids).browserProps || {};
                            __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.set(fields, value1 + "_" + currenttime, item[value1temp]);
                            __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.set(fields, 'field' + columns.fieldid, item[value1temp]);
                            tableStore.form.$('tableForm').$(item.randomFieldId + "_" + item.randomFieldSubKeyd_id).$(fieldids).browserProps = {
                                dataParams: __assign({}, oldbrowserProps.dataParams, fields),
                                conditionDataParams: __assign({}, oldbrowserProps.conditionDataParams, fields),
                                completeParams: __assign({}, oldbrowserProps.completeParams, fields),
                            };
                        }
                    }
                    else {
                        var valuetemp = "d_" + value1;
                        if (keytemp.indexOf("span") != -1) {
                            keytemp = columns.key.replace("span", "");
                            //fieldids = fieldids+"span";
                            value1temp = value1temp + "span";
                        }
                        if (keytemp === valuetemp) {
                            datalisttemp.map(function (itemtemp) {
                                if (itemtemp.fieldname === valuetemp) {
                                    var oldbrowserProps = tableStore.form.$('tableForm').$(item.randomFieldId + "_" + item.randomFieldSubKeyd_id).$(fieldids).browserProps || {};
                                    __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.set(fields, itemtemp.detailtable + "_" + value1 + "_" + currenttime, item[valuetemp]);
                                    __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.set(fields, 'field' + columns.fieldid, item[value1temp]);
                                    tableStore.form.$('tableForm').$(item.randomFieldId + "_" + item.randomFieldSubKeyd_id).$(fieldids).browserProps = {
                                        dataParams: __assign({}, oldbrowserProps.dataParams, fields),
                                        conditionDataParams: __assign({}, oldbrowserProps.conditionDataParams, fields),
                                        completeParams: __assign({}, oldbrowserProps.completeParams, fields),
                                    };
                                }
                            });
                        }
                    }
                });
            });
        };
        this.doBatchEdit_datakey = function (callback, params, isQuickSearch) {
            var _a;
            var selectedRowKeysStr = '';
            if (typeof (_this_1.treeKey) != "undefined" && _this_1.isTreeType != '1') { //分组列表
                _this_1.treeKey.forEach(function (element) {
                    selectedRowKeysStr += '\'' + element + '\',';
                });
            }
            else if (_this_1.selectRowkeys && _this_1.selectRowkeys.length > 0) {
                _this_1.selectRowkeys.forEach(function (element) {
                    selectedRowKeysStr += '\'' + element + '\',';
                });
            }
            else {
                _this_1.newTable.selectedRowKeysAllPages.forEach(function (element) {
                    selectedRowKeysStr += '\'' + element + '\',';
                });
            }
            if (selectedRowKeysStr.endsWith(',')) {
                selectedRowKeysStr = selectedRowKeysStr.substring(0, selectedRowKeysStr.length - 1);
            }
            // let keys = _.keys(this.quickSearchFormData);
            // let isQuickSearch = keys.length;
            var isQuickSearch1 = false;
            var quickSearchFormData = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.quickSearchFormData);
            if (quickSearchFormData && JSON.stringify(quickSearchFormData) !== '{}') {
                isQuickSearch1 = true;
            }
            if (!isQuickSearch) {
                _this_1.quickSearchValue = '';
            }
            var linkParams = {};
            var linkFields = _this_1.copyDataSource && _this_1.copyDataSource.linkFields || '';
            if (linkFields) {
                linkParams = {
                    linkFields: linkFields
                };
                var templinkFields = linkFields.split(",");
                for (var i = 0; i < templinkFields.length; i++) {
                    linkParams = __assign((_a = {}, _a[templinkFields[i]] = _this_1.copyDataSource[templinkFields[i]], _a), linkParams);
                }
            }
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].dataKey(__assign({}, params, _this_1.params, { customid: _this_1.customId, selectedRowKeysStr: selectedRowKeysStr, groupValue: _this_1.top.selectedKey }, isQuickSearch1 ? __assign({ isQuickSearch: "1" }, _this_1.quickSearchFormData) : {}, isQuickSearch ? { quickSearchValue: _this_1.quickSearchValue } : _this_1.getConditionValues(), linkParams, { isEdit: _this_1.isEdit })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, datas = _a.datas;
                if (status == '1') {
                    _this_1.editTableStore.oldDataRecord = [];
                    _this_1.sessionKey = datas;
                    Object(__WEBPACK_IMPORTED_MODULE_21__apis_table__["a" /* getTableCounts */])({ dataKey: datas }).then(function (_a) {
                        var count = _a.count;
                        _this_1.editPagination.total = count;
                    });
                    if (_this_1.displayType === SearchDisplayType.Excel && callback) {
                        if (_this_1.isInnerTab) { // excel列表批量编辑需将loading置为false
                            var changeLoadingState = getParent().changeLoadingState;
                            changeLoadingState && changeLoadingState(false);
                        }
                        callback(_this_1.sessionKey);
                        return;
                    }
                    _this_1.getEditDatas();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        // 相册数据
        this.selectRowKey = function (t) {
            if (_this_1.disquerycheck != '1') {
                var selectRowkey_1 = [];
                var tempvalue_1 = __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#imgtpyeselectCol" + t).text();
                if (_this_1.selectRowkeys.indexOf(tempvalue_1) > -1) {
                    _this_1.selectRowkeys.forEach(function (item) {
                        if (item != tempvalue_1) {
                            selectRowkey_1.push(item);
                        }
                    });
                    _this_1.selectRowkeys = selectRowkey_1;
                }
                else {
                    _this_1.selectRowkeys.push(tempvalue_1);
                }
                _this_1.setImgSelectValue(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.selectRowkeys.map(function (d) { return d.split('_')[0]; })).join(','));
            }
        };
        this.setImgSelectValue = function (imgSelectValue) {
            _this_1.imgSelectValue = imgSelectValue;
        };
        this.getAllImgListIds = function () {
            var selectRowkey = [];
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(".td-selectCol").each(function (index, el) {
                if (!_this_1.doRealAction || (!_this_1.filterSelectRows.includes(el.textContent))) {
                    selectRowkey.push(el.textContent);
                }
            });
            return selectRowkey;
        };
        this.selectRowKeyAll = function (isClear) {
            var selectStr = '';
            if (isClear) {
                _this_1.selectRowkeys = [];
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(".td-selectCol").each(function (index, el) {
                    if (!_this_1.doRealAction || (!_this_1.filterSelectRows.includes(el.textContent))) {
                        _this_1.selectRowkeys.push(el.textContent);
                    }
                });
                selectStr = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.selectRowkeys.map(function (d) { return d.split('_')[0]; })).join(',');
            }
            _this_1.setImgSelectValue(selectStr);
        };
        this.getListInfoForImgSearch = function (customid) {
            if (customid === void 0) { customid = _this_1.customId; }
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getTitleField({ customid: customid }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, titleField = _a.titleField, datashowinfo = _a.datashowinfo, userInfo = _a.userInfo;
                if (status == '1') {
                    _this_1.titleField = titleField;
                    _this_1.dataShowInfo = datashowinfo;
                    _this_1.userInfo = userInfo;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        this.getEditDatas = function () {
            _this_1.loading = true;
            Object(__WEBPACK_IMPORTED_MODULE_21__apis_table__["b" /* getTableDatas */])(__assign({}, _this_1.editPagination, { dataKey: _this_1.sessionKey })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas;
                if (status == '1') {
                    if (_this_1.mergeFields && _this_1.mergeInfos && _this_1.mergeInfos.length > 0) { //如果是合并列批量修改之后继续修改需要吧columns赋值为合并列处理前的值
                        _this_1.editTableStore.columns = _this_1.mergeTempColumns;
                    }
                    var textareas_1 = _this_1.editTableStore.columns.filter(function (item) { return item.conditionType == 'textarea'; }).map(function (item) { return item.key; });
                    var data = datas.map(function (item) {
                        textareas_1.forEach(function (ele) {
                            item[ele] = item[ele].replace(/<br\/>/g, '\n');
                        });
                        return __assign({ _modified_: false, randomkey: item.randomFieldId + '_' + item.randomFieldSubKeyd_id }, item);
                    });
                    _this_1.editTableStore.initTableForm([]);
                    _this_1.editTableStore.updateDatas(data);
                    _this_1.addScroll1(data);
                    datas.map(function (item, index) {
                        //oldValue赋值
                        //const datamap = {};
                        _this_1.editTableStore.columns.map(function (element) {
                            _this_1.editTableStore.form.$("tableForm." + (item.randomFieldId + '_' + item.randomFieldSubKeyd_id) + "." + element.key).oldValue = item[element.key];
                            _this_1.getSqlNeedFieldKey(item, index, element, _this_1.editTableStore);
                        });
                    });
                    var tempColumns = _this_1.editTableStore.columns;
                    _this_1.editTableStore.columns = _this_1.dealmergecolumn(tempColumns);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error("[" + (getLabel(127353, '错误') + errorCode) + "]:" + error);
                }
                _this_1.loading = false;
                _this_1.editTableStore.isDataLoaded = true;
            }));
        };
        this.doBack = function () {
            var _a;
            _this_1.rightMenus = _this_1.tempRightMenus;
            if (_this_1.displayType === 'treeType') {
                _this_1.treeKey = [];
            }
            var linkParams = {};
            var linkFields = _this_1.copyDataSource && _this_1.copyDataSource.linkFields || '';
            if (linkFields) {
                linkParams = {
                    linkFields: linkFields
                };
                var templinkFields = linkFields.split(",");
                for (var i = 0; i < templinkFields.length; i++) {
                    linkParams = __assign((_a = {}, _a[templinkFields[i]] = _this_1.copyDataSource[templinkFields[i]], _a), linkParams);
                }
            }
            if (_this_1.displayType === SearchDisplayType.Excel) {
                _this_1.excelStore.changedValues = {};
                _this_1.excelStore.insertedRows = [];
                _this_1.dataKey(__assign({}, _this_1.params, { customid: _this_1.customId }, _this_1.quickSearchValue ? { quickSearchValue: _this_1.quickSearchValue } : _this_1.getConditionValues(), { groupValue: _this_1.top.selectedKey }, linkParams, _this_1.quickConditions));
                _this_1.excelStore.editable = false;
                _this_1.isEdit = false;
                return;
            }
            _this_1.isEdit = false;
            if (_this_1.displayType === SearchDisplayType.ImgType) {
                _this_1.newTable.datas = [];
            }
            var isQuickSearch = false;
            if (_this_1.quickSearchFormData && JSON.stringify(_this_1.quickSearchFormData) !== '{}') {
                isQuickSearch = true;
            }
            _this_1.newTable.pageSize = _this_1.editPagination.pageSize;
            _this_1.dataKey(__assign({}, _this_1.params, { customid: _this_1.customId }, _this_1.quickSearchValue ? { quickSearchValue: _this_1.quickSearchValue } : _this_1.getConditionValues(), { groupValue: _this_1.top.selectedKey }, linkParams, _this_1.quickConditions, isQuickSearch ? __assign({ isQuickSearch: "1" }, _this_1.quickSearchFormData) : {}));
            _this_1.selectedRowKeys = [];
            _this_1.selectRowkeys = [];
        };
        this.doBatchStorage = function () {
            if (flag1) {
                return;
            }
            flag1 = true;
            var data = [];
            var oldData = [];
            if (_this_1.displayType === SearchDisplayType.Excel) {
                flag1 = false;
                return _this_1.excelStore.doBatchStorage();
            }
            _this_1.editTableStore.oldDataRecord.forEach(function (v) {
                var d = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.findKey(data, function (o) { return o.randomFieldId == v.randomFieldId && o.randomFieldSubKeyd_id == v.randomFieldSubKeyd_id; });
                var o_d = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.findKey(oldData, function (o) { return o.randomFieldId == v.randomFieldId && o.randomFieldSubKeyd_id == v.randomFieldSubKeyd_id; });
                var m_data = { randomFieldId: v.randomFieldId, randomFieldSubKeyd_id: v.randomFieldSubKeyd_id };
                var old_data = { randomFieldId: v.randomFieldId, randomFieldSubKeyd_id: v.randomFieldSubKeyd_id, changeDataTime: _this_1.changeDataTime };
                if (d && o_d) {
                    m_data = data[d];
                    old_data = oldData[o_d];
                    m_data[v._fieldid] = v[v._fieldid];
                    old_data[v._fieldid] = v.oldValue;
                }
                else {
                    m_data[v._fieldid] = v[v._fieldid];
                    old_data[v._fieldid] = v.oldValue;
                    data.push(m_data);
                    oldData.push(old_data);
                }
            });
            if (data.length == 0) {
                __WEBPACK_IMPORTED_MODULE_3_antd__["message"].warn(getLabel(385557, '未做任何修改！'));
                flag1 = false;
                return;
            }
            //重复验证
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].batchEditGetVerifyField({ customid: _this_1.customId }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, result = _a.result;
                if (status == '1') {
                    if (result && result.VerifyField && result.VerifyField.length > 0) {
                        var fields_1 = '';
                        result.VerifyField.forEach(function (element) {
                            fields_1 += element.fieldids + ',';
                        });
                        // let isEdit = false;
                        __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].checkDataChange({ oldData: JSON.stringify(oldData), customid: _this_1.customId }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                            var errMessage = _a.errMessage, datas = _a.datas;
                            if (errMessage && errMessage != '') {
                                _this_1.isBatchSubmit = false;
                                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                                    title: errMessage,
                                    okText: getLabel(382958, '确定'),
                                    cancelText: getLabel(201, '取消'),
                                    onOk: function () {
                                        datas.map(function (item) {
                                            var index = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.findIndex(oldData, function (o) { return o['id'] == item.id; });
                                            oldData.splice(index, 1);
                                            data.splice(index, 1);
                                        });
                                        // isEdit = true;
                                        data = JSON.stringify(data);
                                        oldData = JSON.stringify(oldData);
                                        if (errMessage != getLabel(508326, '本次编辑的所有数据已被修改，本次修改无效，请重新刷新页面')) {
                                            _this_1.doBatchEditSave(data, oldData);
                                        }
                                    },
                                    onCancel: function () {
                                        return;
                                    }
                                });
                                flag1 = false;
                            }
                            // if (fields == '' && isEdit) {
                            // }
                        }));
                        var fieldArray = fields_1.split(',');
                        var verifyDataObj = new Array();
                        var datas = _this_1.editTableStore.form.$("tableForm").values();
                        var columns = _this_1.editTableStore.columns;
                        var leafCols_1 = [];
                        var getLeafCols_1 = function (cols) {
                            cols.forEach(function (col) {
                                if (col.children && typeof (col.children) == 'object') {
                                    getLeafCols_1(col.children);
                                }
                                else {
                                    col.fieldid && leafCols_1.push(col);
                                }
                            });
                        };
                        getLeafCols_1(columns);
                        datas.forEach(function (item, index) {
                            var fieldvalues = {};
                            fieldArray.forEach(function (fieldid, index) {
                                leafCols_1.forEach(function (element) {
                                    if (element.fieldid == fieldid) {
                                        fieldvalues['pluginName' + fieldid] = item[element.key];
                                    }
                                });
                            });
                            fieldvalues[result.primaryKeyPluginName] = item['randomFieldId'];
                            if (result.detailPrimaryKeyPluginName) {
                                fieldvalues[result.detailPrimaryKeyPluginName] = item['randomFieldSubKeyd_id'];
                            }
                            fieldvalues['^_^rownum^_^'] = index;
                            verifyDataObj.push(fieldvalues);
                        });
                        var jsonstr = JSON.stringify(verifyDataObj);
                        __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].batchEditVerifyData({
                            customid: _this_1.customId,
                            data: jsonstr
                        }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                            var error = _a.error, status = _a.status, result = _a.result, colorMap = _a.colorMap;
                            if (status == '1') {
                                _this_1.checkFail(result, _this_1.doBatchEditSave, data, oldData, leafCols_1, colorMap);
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                                throw error;
                            }
                        }));
                    }
                    else {
                        var oldDatas = JSON.stringify(oldData);
                        __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].checkDataChange({ oldData: oldDatas, customid: _this_1.customId }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                            var _b = _a.errMessage, errMessage = _b === void 0 ? '' : _b, datas = _a.datas, isAllData = _a.isAllData;
                            if (errMessage != '') {
                                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                                    title: errMessage,
                                    okText: getLabel(382958, '确定'),
                                    cancelText: getLabel(201, '取消'),
                                    onOk: function () {
                                        if (isAllData) {
                                            datas.map(function (item) {
                                                var index = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.findIndex(oldData, function (o) { return o['id'] == item.id; });
                                                oldData.splice(index, 1);
                                                data.splice(index, 1);
                                            });
                                            data = JSON.stringify(data);
                                            oldData = JSON.stringify(oldData);
                                            _this_1.doBatchEditSave(data, oldData);
                                        }
                                        else {
                                            return;
                                        }
                                    },
                                    onCancel: function () {
                                        return;
                                    }
                                });
                                flag1 = false;
                            }
                            else {
                                data = JSON.stringify(data);
                                oldData = JSON.stringify(oldData);
                                _this_1.doBatchEditSave(data, oldData);
                            }
                        }));
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        //重复验证返回信息处理
        this.checkFail = function (result, func, data, oldData, columns, colorMap) {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.cube-table-fixed')[1]).find('td').css('backgroundColor', '');
            if (result.verify || result.confirmbefore && result.confirmbefore.verify) {
                var detail = result.detail;
                detail && detail.forEach(function (elem, index) {
                    var columnsIndex = elem.fields.map(function (element) {
                        return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.findIndex(columns, function (o) {
                            var fieldname = element.detailtable ? 'd_' + element.fieldname : element.fieldname;
                            var fieldhtmltype = o.fieldhtmltype, fieldtype = o.fieldtype;
                            if (fieldhtmltype == '1') {
                                if (fieldtype == '3' || fieldtype == '4' || fieldtype == '5') { //浮点数 金额转换 金额千分位
                                    fieldname += 'span';
                                }
                            }
                            else if (fieldhtmltype == '2') {
                                if (fieldtype == '1') {
                                    fieldname += 'span';
                                }
                            }
                            return o['key'] == fieldname;
                        });
                    });
                    var tableNode = document.getElementsByClassName('cube-table-fixed')[1];
                    if (elem.rownums != null && elem.rownums != undefined && elem.rownums.constructor == Number)
                        elem.rownums = [elem.rownums];
                    elem.rownums && (elem.rownums.constructor == Array) && elem.rownums.forEach(function (rowNum) {
                        columnsIndex.forEach(function (columnNum) {
                            if (tableNode && tableNode.rows && tableNode.rows[rowNum] && tableNode.rows[rowNum].cells[columnNum]) {
                                tableNode.rows[rowNum].cells[columnNum].style.backgroundColor = colorMap[elem.verifyid];
                            }
                        });
                    });
                });
                var operate = result.operate || result.confirmbefore && result.confirmbefore.operate;
                if (!operate) {
                    operate = '0';
                }
                if (operate == '0') {
                    if (_this_1.isBatchSubmit) {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                            title: getLabel(558, '提示'),
                            width: 500,
                            content: __WEBPACK_IMPORTED_MODULE_30_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: result.msg }, style: { maxHeight: 600, overflowY: 'auto' } }),
                            onOk: function () {
                            },
                        });
                        flag1 = false;
                    }
                }
                else {
                    if (result.confirmbefore) {
                        _this_1.checkFail(result.confirmbefore, function () {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                                width: 500,
                                title: __WEBPACK_IMPORTED_MODULE_30_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: result.msg || getLabel(15382, '是否继续？') }, style: { maxHeight: 600, overflowY: 'auto' } }),
                                okText: getLabel(382958, '继续'),
                                cancelText: getLabel(201, '取消'),
                                onOk: function () {
                                    func && func(data, oldData);
                                },
                                onCancel: function () {
                                    flag1 = false;
                                }
                            });
                        }, data, oldData, columns, colorMap);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                            width: 500,
                            title: __WEBPACK_IMPORTED_MODULE_30_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: result.msg }, style: { maxHeight: 600, overflowY: 'auto' } }),
                            okText: getLabel(382958, '继续'),
                            cancelText: getLabel(201, '取消'),
                            onOk: function () {
                                func && func(data, oldData);
                            },
                            onCancel: function () {
                                flag1 = false;
                            }
                        });
                    }
                }
            }
            else {
                if (_this_1.isBatchSubmit) {
                    data = JSON.stringify(data);
                    oldData = JSON.stringify(oldData);
                    _this_1.doBatchEditSave(data, oldData);
                }
            }
            _this_1.isBatchSubmit = true;
        };
        this.openMsgConfirm = function (visible, data, oldData) {
            _this_1.msgConfirmVisible = visible;
            if (visible) {
                _this_1.msgConfirmData = data;
                _this_1.msgConfirmOldData = oldData;
            }
            else {
                _this_1.msgConfirmData = null;
                _this_1.msgConfirmOldData = null;
                flag1 = false; //可以再次保存
            }
        };
        this.onBatchEditSave = function (needContinueEdit) {
            var data = _this_1.msgConfirmData;
            var oldData = _this_1.msgConfirmOldData;
            if (typeof data == 'object') {
                data = JSON.stringify(data);
            }
            if (typeof oldData == 'object') {
                oldData = JSON.stringify(oldData);
            }
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].batchEditSave(__assign({}, _this_1.params, { customid: _this_1.customId, data: data, oldData: oldData })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, resultMessage = _a.resultMessage, changeDataTime = _a.changeDataTime, pageExpendResult = _a.pageExpendResult;
                if (status == '1') {
                    var mythis = _this_1;
                    _this_1.changeDataTime = changeDataTime;
                    _this_1.editTableStore.oldDataRecord = [];
                    if (pageExpendResult && pageExpendResult.haveError) {
                        Object(__WEBPACK_IMPORTED_MODULE_24__util_cubeUtil__["h" /* showExpendError */])(pageExpendResult, Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/search?customid=" + _this_1.customId + "&"));
                        mythis.doBatchEdit_datakey();
                        return;
                    }
                    if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].location.hash.indexOf('#/main/cube/viewResource') > -1 && _this_1.cubeViewResource) {
                        _this_1.cubeViewResource.query(); // 触发资源面板更新
                    }
                    else {
                        if (needContinueEdit) {
                            mythis.doBatchEdit_datakey();
                            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.cube-table-fixed')[1]).find('td').css('backgroundColor', '');
                        }
                        else {
                            mythis.doBack();
                        }
                    }
                    _this_1.openMsgConfirm(false);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
                flag1 = false;
            }));
        };
        this.doBatchEditSave = function (data, oldData) {
            _this_1.openMsgConfirm(true, data, oldData);
        };
        this.batchEditGoBack = function () {
            _this_1.listEditStore.back();
        };
        this.Add = function () {
            var fields = '';
            var treeconid = '';
            var treecontype = ''; //目标字段类型
            var treecon_value = '';
            for (var key in _this_1.params) {
                var fieldvalue = _this_1.params[key];
                //afterConditionInit方法中对数值类型的设置为了数组类型导致这里fieldvalue都多了一个逗号,没敢改那里,这里做个设置,取第一项
                if (Array.isArray(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(fieldvalue))) {
                    fieldvalue = fieldvalue[0];
                }
                if (key.startsWith('con_')) {
                    var fieldKey = key.replace('con_', 'field');
                    fields = fields + "&" + fieldKey + "=" + fieldvalue;
                }
                if (key.startsWith('p_')) {
                    var fieldKey = key;
                    fields = fields + "&" + fieldKey + "=" + fieldvalue;
                }
                if (key.startsWith('treecon') && key.indexOf('_value') > 0) {
                    treecon_value = fieldvalue;
                }
                if (key == 'treeconid') {
                    treeconid = fieldvalue;
                }
                if (key == 'treecontype') {
                    treecontype = fieldvalue;
                }
            }
            if (treeconid != '' && treecon_value != '' && treecontype != '') {
                if (treecontype == '161' || treecontype == '162') {
                    var index = treecon_value.indexOf('_');
                    if (index > 0) {
                        treecon_value = treecon_value.substring(index + 1);
                    }
                }
                fields = fields + "&field" + treeconid + "=" + treecon_value;
            }
            __WEBPACK_IMPORTED_MODULE_4__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/card?type=1&modeId=" + _this_1.modeId + "&formId=" + _this_1.formId + fields + (_this_1.treeFieldStr ? _this_1.treeFieldStr : '')));
        };
        this.Del = function (pageexpandid) {
            if (!_this_1.checkSeleted()) {
                return;
            }
            var that = _this_1;
            var ids = _this_1.getCheckedIds();
            __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                title: getLabel(129890, '确定要删除吗?', 'label'),
                okText: getLabel(382958, '确定'),
                okType: 'danger',
                cancelText: getLabel(201, '取消'),
                onOk: function () {
                    var id = ids.split(",");
                    if (id.length >= 20) {
                        __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].doDelLoadingpost({ billids: ids }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                            var error = _a.error, status = _a.status, key = _a.key, canExpObj = _a.canExpObj;
                            if (status == '1') { //成功
                                that.delkey = key;
                                that.isDelShow = true;
                                that.deleteData(__assign({}, that.params, { customid: that.customId, operate: 'DeleteAction', billids: ids, pageexpandid: pageexpandid, key: that.delkey, modeId: that.modeId }), function (_a) {
                                    var message = _a.message;
                                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].success({
                                        content: message,
                                    });
                                    that.refresh();
                                });
                                that.getDelLoadingProgress();
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                            }
                        }));
                    }
                    else {
                        that.deleteData(__assign({}, that.params, { customid: that.customId, operate: 'DeleteAction', billids: ids, pageexpandid: pageexpandid, modeId: that.modeId }), function (_a) {
                            var message = _a.message;
                            __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].success({
                                content: message,
                            });
                            that.refresh();
                        });
                    }
                }
            });
        };
        this.getDelLoadingProgress = function () {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getDelLoadingProgress({ key: _this_1.delkey }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, progress = _a.progress;
                if (status == '1') { //成功
                    if (!_this_1.isCancel) {
                        _this_1.delLoadingProgress = progress;
                        if (progress.step == 'end') {
                            _this_1.isDelShow = false;
                            _this_1.delLoadingProgress = {};
                        }
                        else {
                            setTimeout(function () {
                                _this_1.getDelLoadingProgress();
                            }, 1000);
                        }
                    }
                }
                else if (status == '2') {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].info(error);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                }
            }));
        };
        this.getAllExcelOut = function (billid) {
            var allIds = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.newTable.selectedRowKeysAllPages.map(function (d) { return d.split('_')[0]; })).join(',');
            if (_this_1.displayType == SearchDisplayType.TreeType && _this_1.treeKey) {
                allIds = _this_1.treeValueId;
            }
            if (_this_1.selectRowkeys && _this_1.selectRowkeys.length > 0) {
                allIds = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.selectRowkeys.map(function (d) { return d.split('_')[0]; })).join(',');
            }
            Object(__WEBPACK_IMPORTED_MODULE_19__apis_card__["i" /* doExpCardConfig */])({
                action: 'getBacthExpList',
                customid: _this_1.customId,
                modeid: _this_1.modeId
            }).then(function (data) {
                try {
                    if (Number(_this_1.modeId) > 0) {
                        if (data.canExpObj && !data.canExpObj.canExp) {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                                title: getLabel(15172, '系统提示'),
                                content: (__WEBPACK_IMPORTED_MODULE_30_react__["createElement"]("div", null, data.canExpObj.canExpMsg)),
                                onOk: function () {
                                },
                            });
                            return;
                        }
                        var billids = allIds;
                        if (data.BacthExplist.length > 0 || (data.expcardname && data.expcardname.key == '1')) {
                            if (data.BacthExplist.length == 1 && data.expcardname.key != '1') { //当后台设置了一种导出类型的时候直接导出
                                var key = data.BacthExplist[0]['key'];
                                if (key == "list") {
                                    _this_1.doExcelExpost(allIds, data.expcardname.showname);
                                }
                                else {
                                    var parms = {
                                        action: "expbatchcard",
                                        fileType: data.BacthExplist[0]['key'],
                                        billids: billids,
                                        modeId: _this_1.modeId,
                                        comefrom: 'frommode',
                                        modeCustomid: _this_1.customId,
                                        dataKey: _this_1.sessionKey,
                                        excelName: data.expcardname.showname
                                    };
                                    _this_1.doExcelExpost(billids, '', parms);
                                }
                                // window.open(`/weaver/weaver.formmode.expcard.servlet.ExpCardServer?action=expbatchcard&fileType=${data.BacthExplist[0]['key']}&billids=${billids}&modeId=${this.modeId}`);
                            }
                            else {
                                var cube_export_type = data.BacthExplist.length > 0 ? data.BacthExplist[0]['key'] : 'list';
                                __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].ls.set('cube_export_type', cube_export_type);
                                __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].ls.set('cube_export_name', data.expcardname.showname);
                                _this_1.expCardParm = {
                                    datas: data.BacthExplist,
                                    billsid: allIds,
                                    modeid: _this_1.modeId,
                                    type: 'list',
                                    comefrom: "frommode",
                                    modeCustomid: _this_1.customId,
                                    dataKey: _this_1.sessionKey,
                                    expcardname: data.expcardname,
                                    callBack: _this_1.doExcelExpost
                                };
                                _this_1.showExpList = true;
                            }
                        }
                        else {
                            _this_1.doExcelExpost(allIds, data.expcardname.showname);
                        }
                    }
                    else {
                        _this_1.doExcelExpost(allIds, data.expcardname.showname);
                    }
                }
                catch (error) {
                }
            });
        };
        this.doExcelExpost = function (allIds, excelName, cardparm) {
            // const allIds = _.uniq(this.newTable.selectedRowKeysAllPages.map(d => d.split('_')[0])).join(',');
            var selectedRows = allIds;
            _this_1.starttime = new Date().getTime();
            _this_1.progress = {};
            _this_1.isCancel = false;
            _this_1.isClose = false;
            _this_1.exportkey = '';
            var params;
            if (_this_1.changeSearch == '0') {
                _this_1.isExpTree = "";
            }
            else if (_this_1.changeSearch == '1') {
                _this_1.isExpTree = "1";
            }
            if (cardparm) { //批量导出文件
                var Base64 = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].Base64;
                var modeCustomid = Base64.encode(_this_1.customId);
                params = __assign({}, cardparm, { exptype: 'card' });
                params.modeCustomid = modeCustomid;
            }
            else { //默认excel导出
                var Base64 = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].Base64;
                var modeCustomid = Base64.encode(_this_1.customId);
                params = {
                    showOrder: 'all',
                    iscustomsearch: 1,
                    comefrom: 'frommode',
                    excelName: excelName,
                    isexptree: _this_1.isExpTree,
                    modeCustomid: modeCustomid,
                    dataKey: _this_1.sessionKey,
                    isSelectGroup: _this_1.top.selectedKey != 'all',
                    exptype: 'excel'
                };
                if (selectedRows.length > 0) {
                    var Base64_1 = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].Base64;
                    var ids = Base64_1.encode(selectedRows);
                    params.ids = ids;
                }
            }
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].doExcelExpost(params).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, key = _a.key, canExpObj = _a.canExpObj;
                if (status == '1') { //成功
                    // message.info(getLabel('508305', '正在导出文件'));
                    _this_1.exportkey = key;
                    _this_1.showProgerss = true;
                    _this_1.getExcelExpProgress();
                }
                else if (status == '2') {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].info(error);
                    _this_1.refresh();
                }
                else if (status == '3') {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                        title: getLabel(15172, '系统提示'),
                        content: (__WEBPACK_IMPORTED_MODULE_30_react__["createElement"]("div", null, canExpObj.canExpMsg)),
                        onOk: function () {
                        },
                    });
                    return;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                }
            }));
            // formPost("/weaver/weaver.formmode.excel.ExpExcelServer", params);
        };
        this.getExcelExpProgress = function () {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getExcelExpProgress({ key: _this_1.exportkey }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, progress = _a.progress;
                if (status == '1') { //成功
                    if (!_this_1.isCancel) {
                        _this_1.progress = progress;
                        if (progress.step == 'end') {
                            _this_1.showProgerss = false;
                            var url = Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.formmode.data.FileDownload?type=listExcelOut&key=") + _this_1.exportkey + "&filename=" + encodeURI(progress.filename);
                            if (progress.zipkey) {
                                url += "&zipkey=" + progress.zipkey;
                            }
                            __WEBPACK_IMPORTED_MODULE_4__util__["default"].location.href = url;
                            _this_1.progress = {};
                        }
                        else {
                            setTimeout(function () {
                                _this_1.getExcelExpProgress();
                            }, 1000);
                        }
                    }
                }
                else if (status == '2') {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].info(error);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                }
            }));
        };
        this.cancelExport = function () {
            var that = _this_1;
            __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                title: getLabel('509723', '确定取消本次导出') + "?",
                okText: getLabel(382958, '确定'),
                cancelText: getLabel(201, '取消'),
                onOk: function () {
                    that.showProgerss = false;
                    that.isCancel = true;
                    __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].cancelExcelExp({ key: that.exportkey }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                        var error = _a.error, status = _a.status;
                        if (status == '1') { //成功
                        }
                        else if (status == '2') {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["message"].info(error);
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                        }
                    }));
                },
                onCancel: function () {
                    return;
                }
            });
        };
        /****
         * y用来公用获取选中id的
         */
        this.getCheckedIds = function () {
            var ids = _this_1.treeValueId == "" ?
                _this_1.imgSelectValue == "" ?
                    _this_1.verticalListStore.selectValue == '' ? __WEBPACK_IMPORTED_MODULE_4__util__["default"]._xtable_CheckedCheckboxId()
                        : _this_1.verticalListStore.selectValue
                    : _this_1.imgSelectValue
                : _this_1.treeValueId;
            return ids;
        };
        //批量打印
        this.doBatchPrint = function (pageexpandid, printEdcUrl) {
            var ids = _this_1.getCheckedIds();
            var id = ids.split(",");
            var msg = getLabel(504438, "请勾选打印的数据");
            if (ids == '') {
                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                    title: "",
                    content: msg,
                    width: 300,
                    onOk: function () {
                        return;
                    }
                });
            }
            else if (id.length > 20) {
                msg = getLabel(504440, "请勾选打印的数据");
                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                    title: "",
                    content: msg,
                    width: 300,
                    onOk: function () {
                        return;
                    }
                });
            }
            else {
                if (printEdcUrl && printEdcUrl != '') {
                    var printUrl = printEdcUrl + "&cubePrintKey=" + id;
                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].openFullWindowHaveBar(printUrl);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].openFullWindowHaveBar(Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/BatchPrint?modeId=" + _this_1.modeId + "&customId=" + _this_1.customId + "&formId=" + _this_1.formId + "&billId=" + _this_1.getCheckedIds() + "&windowTitle=" + __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].Base64.encode(_this_1.printWindowTitle)));
                }
            }
        };
        this.ChangeSearch = function () {
            _this_1.quickSearchValue = "";
            _this_1.quickSearchFormData = {};
            if (_this_1.quickSearchConditionData) {
                for (var key in _this_1.quickSearchConditionData) {
                    if (_this_1.condition.form.has(key))
                        _this_1.condition.form.$(key).value = "";
                }
            }
            _this_1.quickSearchConditionData = {};
            if (_this_1.changeSearch == '1') {
                _this_1.isTreeType = '1';
                _this_1.dataKey(_this_1.params);
            }
            else if (_this_1.changeSearch == '0') {
                _this_1.isTreeType = '';
                _this_1.dataKey(_this_1.params);
            }
        };
        this.columnMake = function () {
            _this_1.newTable.tableColSet(true);
            _this_1.newTable.setColSetVisible(true);
            var timer;
            var func = function () {
                if (_this_1.newTable.colSetVisible) {
                    clearInterval(timer);
                    timer = setInterval(function () {
                        //  this.newTable.colSetVisible
                        if (!_this_1.newTable.colSetVisible) {
                            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getOriginalTableWidth({ customid: _this_1.customId }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                                var error = _a.error, status = _a.status, originalTableWidth = _a.originalTableWidth;
                                if (status == '1' && originalTableWidth) { //成功
                                    _this_1.originalTableWidth = originalTableWidth;
                                }
                                else if (status == '2') {
                                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].info(error);
                                }
                                else {
                                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                                }
                            }));
                            _this_1.addRightMenu();
                            clearInterval(timer);
                        }
                    }, 50);
                }
            };
            func();
        };
        this.batchCreateQRCode = function () {
            if (!_this_1.checkSeleted()) {
                return;
            }
            _this_1.check_uses('getQrCode', function () {
                __WEBPACK_IMPORTED_MODULE_4__util__["default"].modeopenFullWindowHaveBar(Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/qrCode?modeId=" + _this_1.modeId + "&customId=" + _this_1.customId + "&formId=" + _this_1.formId + "&billId=" + _this_1.getCheckedIds()));
            });
        };
        this.batchCreateBARCode = function () {
            if (!_this_1.checkSeleted()) {
                return;
            }
            _this_1.check_uses('getBarCode', function () {
                __WEBPACK_IMPORTED_MODULE_4__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/barCode?modeId=" + _this_1.modeId + "&customId=" + _this_1.customId + "&formId=" + _this_1.formId + "&billId=" + _this_1.getCheckedIds()));
            });
        };
        this.showMapPage = function () {
            var selectedRowKeys = _this_1.newTable.selectedRowKeys;
            var ids = _this_1.treeValueId == "" ?
                _this_1.imgSelectValue == "" ?
                    _this_1.verticalListStore.selectValue == '' ? selectedRowKeys
                        : _this_1.verticalListStore.selectValue
                    : _this_1.imgSelectValue
                : _this_1.treeValueId;
            __WEBPACK_IMPORTED_MODULE_4__util__["default"].modeopenFullWindowHaveBar(Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/map?customid=" + _this_1.customId + "&billids=" + ids));
        };
        this.batchEditSave = function () {
            _this_1.listEditStore.batchSave();
        };
        this.doCustomAction = function (menu) {
            if (menu.isfilter == 1 && !_this_1.doRealAction) { //设置了数据筛选的按钮第一次点击的时候禁用check框
                _this_1.resetMenu(menu.key);
            }
            else {
                if (menu.key == '-100') {
                    _this_1.onclickCancel();
                    return;
                }
                if (menu.function) {
                    try {
                        var func = eval("this." + menu.function);
                        if (typeof func == 'function') {
                            if (menu.function == 'doBatchPrint') {
                                func(menu.key, _this_1.printEdcUrl);
                            }
                            else {
                                func(menu.key);
                            }
                        }
                    }
                    catch (e) {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(e);
                        throw e;
                    }
                }
            }
        };
        this.BatchImport = function (pageexpandid) {
            // window.open(`/formmode/interfaces/ModeDataBatchImport.jsp?ajax=1&modeid=${this.modeId}&pageexpandid=${pageexpandid}`);
            __WEBPACK_IMPORTED_MODULE_4__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/cube/engine.html#/cubeengine/app/modebatchimport?modeid=" + _this_1.modeId + "&customid=" + _this_1.customId));
        };
        this.CleanCol = function () {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].cleanCol({ customid: _this_1.customId }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].location.reload();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        this.batchShare = function () {
            _this_1.share.batchShare(_this_1);
        };
        this.batchmodifyfeildvalue = function (key) {
            var selectedRows;
            if (typeof (_this_1.treeKey) != "undefined" && _this_1.isTreeType != '1') {
                selectedRows = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.treeKey.map(function (d) { return d.split('_')[0]; }));
                if (selectedRows && selectedRows.length > 0) {
                    _this_1.batchEditStore.selectedRowKeys = selectedRows;
                    _this_1.batchEditStore.pageexpandid = key;
                    _this_1.batchEditStore.customid = _this_1.customId;
                    _this_1.batchEditStore.showBatctEdit(_this_1.dataKey, _this_1.getConditionValues());
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                        title: getLabel(15172, '系统提示'),
                        content: getLabel(20149, '请至少选择一条记录。')
                    });
                }
            }
            else if (typeof (_this_1.selectRowkeys) != "undefined" && _this_1.selectRowkeys.length > 0) {
                selectedRows = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.selectRowkeys.map(function (d) { return d.split('_')[0]; }));
                if (selectedRows && selectedRows.length > 0) {
                    _this_1.batchEditStore.selectedRowKeys = selectedRows;
                    _this_1.batchEditStore.pageexpandid = key;
                    _this_1.batchEditStore.customid = _this_1.customId;
                    _this_1.batchEditStore.showBatctEdit(_this_1.reload);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                        title: getLabel(15172, '系统提示'),
                        content: getLabel(20149, '请至少选择一条记录。')
                    });
                }
            }
            else {
                selectedRows = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.newTable.selectedRowKeysAllPages.map(function (d) { return d.split('_')[0]; }));
                if (selectedRows && selectedRows.length > 0) {
                    _this_1.batchEditStore.selectedRowKeys = selectedRows;
                    _this_1.batchEditStore.pageexpandid = key;
                    _this_1.batchEditStore.customid = _this_1.customId;
                    _this_1.batchEditStore.showBatctEdit(_this_1.reload);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                        title: getLabel(15172, '系统提示'),
                        content: getLabel(20149, '请至少选择一条记录。')
                    });
                }
            }
        };
        this.modeOpenUrl = function (operate, record, __, url, _bank) {
            if (operate.linkkey && operate.linkvaluecolumn) {
                //多个参数
                url = url.indexOf('?') >= 0 ? url + "&" : url + "?";
                var linkkeys = operate.linkkey.split(",");
                var linkvaluecolumns_1 = operate.linkvaluecolumn.split(",");
                if (linkvaluecolumns_1.length === linkkeys.length) {
                    linkkeys.forEach(function (key, i) {
                        var temp = '';
                        if (!isNaN(Number("" + record[linkvaluecolumns_1[i]]))
                            || ("" + record[linkvaluecolumns_1[i]]).split(",").filter(function (i) { return isNaN(Number(i)); }).length == 0) { //列表主表下拉框、复选框处理
                            temp = "" + record[linkvaluecolumns_1[i]];
                        }
                        else {
                            //数据显示模式为列表、分组列表
                            temp = "" + (record[linkvaluecolumns_1[i] + "span"] || record[linkvaluecolumns_1[i] + "_value"] || record['randomField' + i] || '');
                            if (temp.startsWith('<span><p><div')) { //处理多文本html
                                temp = ("" + record[linkvaluecolumns_1[i]]).replace(/&nbsp;/gi, ' ');
                            }
                            if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.replace(temp, / /g, '').indexOf("<ahref") != -1 || __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.replace(temp, / /g, '').indexOf("<atitle") != -1) {
                                temp = "" + (record[linkvaluecolumns_1[i]] || record[linkvaluecolumns_1[i] + "_value"] || record['randomField' + i] || '');
                            }
                        }
                        url += key + "=" + temp + "&";
                    });
                }
                else {
                    url += operate.linkkey + "=" + (record[operate.linkvaluecolumn] || '');
                }
                url = url.endsWith('&') ? url.substr(0, url.length - 1) : url;
            }
            if ('_blank' == _bank) {
                __WEBPACK_IMPORTED_MODULE_4__util__["default"].location.href = url;
            }
            else {
                __WEBPACK_IMPORTED_MODULE_4__util__["default"].modeopenFullWindowHaveBar(url);
            }
        };
        this.createBARCode = function (billid, text, expandid) {
            _this_1.check_uses('getBarCode', function () {
                _this_1.doInterfacesAction([billid], expandid, function () {
                    // CubeUtil.createBARCode(billid, text, this.customId, this.modeId, this.formId)
                    _this_1.customDialog.showCustomDialog(__WEBPACK_IMPORTED_MODULE_19__apis_card__["m" /* getBarCode */], {
                        customId: _this_1.customId,
                        modeId: _this_1.modeId,
                        formId: _this_1.formId,
                        billid: billid
                    }, 'barCode', getLabel(1362, '条形码'));
                });
            }, billid);
        };
        this.createQRCode = function (billid, text, expandid) {
            _this_1.check_uses('getQrCode', function () {
                _this_1.doInterfacesAction([billid], expandid, function () {
                    // CubeUtil.createQRCode(billid, text, this.customId, this.modeId, this.formId);
                    _this_1.customDialog.showCustomDialog(__WEBPACK_IMPORTED_MODULE_19__apis_card__["A" /* getQRCode */], {
                        customId: _this_1.customId,
                        modeId: _this_1.modeId,
                        formId: _this_1.formId,
                        billid: billid
                    }, 'qrCode', getLabel(30184, '二维码'));
                });
            }, billid);
        };
        this.check_uses = function (type, callback, billid) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */][type]({
                'modeId': _this_1.modeId,
                'customId': _this_1.customId,
                'formId': _this_1.formId,
                'billId': "" + _this_1.getCheckedIds() || billid
            }).then(function (_a) {
                var status = _a.status, showError = _a.showError, message = _a.message, error = _a.error, html = _a.html;
                if (status == '1') {
                    if (showError) {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].error({ content: message, align: 'top', className: 'cube-custom-dialog-error' });
                    }
                    else {
                        callback();
                    }
                }
                else {
                    message.error(error);
                }
            });
        };
        this.viewLog = function (billid, text, expandid) {
            _this_1.doInterfacesAction([billid], expandid, function () {
                __WEBPACK_IMPORTED_MODULE_5__cubeUtil__["default"].viewLog(billid, text, _this_1.modeId, _this_1.modename);
            });
        };
        this.toEdit = function (billid, text, expandid) {
            _this_1.doInterfacesAction([billid], expandid, function () {
                __WEBPACK_IMPORTED_MODULE_5__cubeUtil__["default"].toEdit(billid, text, _this_1.modeId, _this_1.formId);
            });
        };
        this.doprint = function (billid, text, expandid) {
            _this_1.doInterfacesAction([billid], expandid, function () {
                __WEBPACK_IMPORTED_MODULE_5__cubeUtil__["default"].doprint(billid, text, _this_1.modeId, _this_1.formId);
            });
        };
        this.toDel = function (billid, _, pageexpandid) {
            var self = _this_1;
            __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                title: getLabel(129890, '确定要删除吗?', 'label'),
                okText: getLabel(382958, '确定'),
                okType: 'danger',
                cancelText: getLabel(201, '取消'),
                onOk: function () {
                    self.deleteData(__assign({}, self.params, { customid: self.customId, operate: 'DeleteAction', billids: billid, pageexpandid: pageexpandid, modeId: self.modeId }), function (_a) {
                        var message = _a.message;
                        __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].success({
                            content: message,
                        });
                        self.refresh();
                    });
                }
            });
        };
        this.doShare = function (billid, _) {
            _this_1.share.update({
                singleVisible: true,
                billid: billid
            });
        };
        this.openPageExpandLinkUrl = function (billid, pageexpandid) {
            var executeJsCode = function (param) {
                var hreftarget = param.hreftarget;
                eval(hreftarget);
            };
            var directlyOpenUrl = function (param) {
                __WEBPACK_IMPORTED_MODULE_4__util__["default"].openFullWindowHaveBar(param.hreftarget);
            };
            _this_1.secondConfirmPrompt(pageexpandid, function () {
                __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].analyzePageExpandLinkUrl({
                    modeid: _this_1.modeId,
                    formid: _this_1.formId,
                    billid: billid,
                    pageexpandid: pageexpandid,
                    cardid: _this_1.params.cardid ? _this_1.params.cardid : ''
                }).then(function (_a) {
                    var hreftarget = _a.hreftarget, opentype = _a.opentype, showtype = _a.showtype;
                    var param = { billid: billid, hreftarget: hreftarget };
                    if (showtype == 2 && opentype == 3) {
                        _this_1.doPageExpandAction(billid, pageexpandid, executeJsCode, param);
                    }
                    else {
                        _this_1.doPageExpandAction(billid, pageexpandid, directlyOpenUrl, param);
                    }
                });
            });
        };
        this.expCard = function (billid, _, pageexpandid) {
            var that = _this_1;
            // this.doInterfacesAction([billid], pageexpandid, () => {
            //     // CubeUtil.expCard(billid, _, this.modeId, this.formId);
            //    that.getSingleExcelOut(billid,pageexpandid);
            // })
            var modeid = _this_1.modeId;
            var formid = _this_1.formId;
            var CheckedCheckboxIds = [billid];
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].doInterface(__assign({ pageexpandid: pageexpandid, CheckedCheckboxIds: CheckedCheckboxIds, modeid: modeid, formid: formid }, _this_1.params)).then(function (_a) {
                var pageExpendResult = _a.pageExpendResult, status = _a.status;
                if (pageExpendResult && pageExpendResult.haveError) {
                    Object(__WEBPACK_IMPORTED_MODULE_24__util_cubeUtil__["h" /* showExpendError */])(pageExpendResult, _this_1.getHref());
                    return;
                }
                else {
                    that.getSingleExcelOut(billid);
                }
            });
        };
        this.doPageExpandAction = function (billid, pageexpandid, callBackFun, param) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].doInterface(__assign({ pageexpandid: pageexpandid, billid: billid, modeid: _this_1.modeId, formid: _this_1.formId }, _this_1.params)).then(function (_a) {
                var pageExpendResult = _a.pageExpendResult, status = _a.status;
                if (pageExpendResult && pageExpendResult.haveError) {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].error({
                        content: pageExpendResult.executeResult.errmsg
                    });
                    return;
                }
                callBackFun && callBackFun(param);
            });
        };
        this.updateLikeOrDis = function (billid, isshowlistspan, likesinfospan) {
            _this_1.newTable.datas = _this_1.newTable.datas.map(function (item) {
                if (item.randomFieldId == billid) {
                    if (isshowlistspan.length > 0) {
                        return __assign({}, item, { likesinfospan: likesinfospan, isshowlistspan: JSON.stringify(isshowlistspan) });
                    }
                    else {
                        return __assign({}, item, { likesinfospan: likesinfospan });
                    }
                }
                return __assign({}, item);
            });
        };
        this.doCustomButton = function (record, _, operate, __) {
            var otherpara = operate.otherpara;
            var otherparas = otherpara.split("+");
            var index = 0;
            for (index; index < otherparas.length; index++) {
                otherparas[index] = otherparas[index].replace("column:", "");
            }
            var url = operate.href;
            url = url.replace(/&amp;/g, '&');
            var modeOpenUrl = _this_1.modeOpenUrl.bind(_this_1, operate, record, operate.text);
            var createBARCode = _this_1.createBARCode.bind(_this_1, record.randomFieldId, operate.text);
            var viewLog = _this_1.viewLog.bind(_this_1, record.randomFieldId, operate.text);
            var createQRCode = _this_1.createQRCode.bind(_this_1, record.randomFieldId, operate.text);
            var toEdit = _this_1.toEdit.bind(_this_1, record.randomFieldId, operate.text);
            var doprint = _this_1.doprint.bind(_this_1, record.randomFieldId, operate.text);
            var toDel = _this_1.toDel.bind(_this_1, record.randomFieldId, operate.text);
            var doShare = _this_1.doShare.bind(_this_1, record.randomFieldId, operate.text);
            var expCard = _this_1.expCard.bind(_this_1, record.randomFieldId, operate.text);
            var openPageExpandLinkUrl = _this_1.openPageExpandLinkUrl.bind(_this_1, record.randomFieldId);
            if (url.startsWith('javascript:modeOpenUrl')) { //链接
                url = url.replace('javascript:', '');
            }
            else { //手动输入
                var n = url.lastIndexOf(',');
                if (n > 0) {
                    url = url.substring(0, n);
                }
                else {
                    var urls = url.split(')');
                    url = urls[0];
                }
                url = url.replace('javascript:', '');
                url += (url.trim().endsWith('(') ? "" : ",") + "'" + record.randomFieldId + "'";
                if (otherpara) {
                    url += ',';
                    // if (operate.index && record['randomFieldOpPara' + operate.index] && record['randomFieldOpPara' + operate.index][0]) {
                    //     otherpara = record['randomFieldOpPara' + operate.index][0].obj;
                    // }
                    var i = 0;
                    var randomFieldOpPara = "";
                    while (record[otherparas[i]] != undefined) {
                        var item = record[otherparas[i]];
                        if (record[otherparas[i] + "_value"]) { //分组列表因为返回的数据的原因,record中的列都是转化后值,不是数据库原始值
                            item = record[otherparas[i] + "_value"];
                        }
                        if (~item.indexOf('<') && ~item.indexOf('>')) {
                            //如果otherpara是标签,可能将引发eval中的内容为非标准字符串的问题，以及将会抛出标签，因此做过滤。
                            var text = item.replace(/"/g, "'"); //对双引号统一转引号
                            if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()(text).length > 0) { //利用jq获取innerHTML
                                text = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(item).html();
                                item = text;
                            }
                        }
                        item = Object(__WEBPACK_IMPORTED_MODULE_4__util__["removeHTMLTag"])(item).replace(/[\r\n]/g, "");
                        randomFieldOpPara += item + "+";
                        i++;
                    }
                    randomFieldOpPara = randomFieldOpPara.substring(0, randomFieldOpPara.length - 1);
                    otherpara = randomFieldOpPara;
                    url += '\'' + otherpara + '\'';
                }
                url += ')';
            }
            if (modeOpenUrl || createBARCode || viewLog || createQRCode || toEdit || doprint || toDel || doShare || expCard || openPageExpandLinkUrl) {
                try {
                    /****
                     * 为什么这个会有replaceE8Url ？
                     * onUrl('41','<a href="spa/xxxxx">就很真实</a>')
                     * 参数或有这个地址
                     */
                    url = Object(__WEBPACK_IMPORTED_MODULE_4__util__["replaceE8Url"])(url);
                    var func = eval("" + url);
                    if (typeof func == 'function') {
                        func(record);
                    }
                }
                catch (e) {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(e);
                    throw e;
                }
            }
        };
        this.windowOpenOnSelf = function (expandid, billid) {
            var billids = [];
            if (_this_1.displayType === SearchDisplayType.Excel) {
                billids = _this_1.excelStore.selectedRowKeys;
            }
            else {
                billids = _this_1.newTable.selectedRowKeysAllPages.slice();
            }
            var url = _this_1.urlMap[expandid];
            if (_this_1.displayType == SearchDisplayType.TreeType && _this_1.treeKey) {
                billids = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.treeKey.map(function (d) { return d.split('_')[0]; }));
                url += "&displayType=treeType";
            }
            if (!_this_1.checkIsSelect(expandid)) {
                return;
            }
            _this_1.secondConfirmPrompt(expandid, function () {
                _this_1.doInterfacesAction(billid ? [billid] : billids, expandid, _this_1.windowOpenOnSelfCallBack, { url: url });
            });
        };
        this.windowOpenOnSelfCallBack = function (_a) {
            var url = _a.url;
            if (url) {
                __WEBPACK_IMPORTED_MODULE_4__util__["default"].location.href = Object(__WEBPACK_IMPORTED_MODULE_4__util__["replaceE8Url"])(url);
            }
        };
        this.checkIsSelect = function (expandid) {
            var isHasCheck;
            _this_1.rightMenus.map(function (item) {
                item['key'] == expandid && item['isCheckSelectRow'] ? isHasCheck = item['isCheckSelectRow'] : '';
            });
            if (isHasCheck == 1 && !_this_1.checkSeleted()) {
                return false;
            }
            else {
                return true;
            }
        };
        this.windowOpenOnNew = function (expandid, billid) {
            var billids = [];
            if (_this_1.displayType === SearchDisplayType.Excel) {
                billids = _this_1.excelStore.selectedRowKeys;
            }
            else {
                billids = _this_1.newTable.selectedRowKeysAllPages.slice();
            }
            var url = _this_1.urlMap[expandid];
            if (_this_1.displayType == SearchDisplayType.TreeType && _this_1.treeKey) {
                billids = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.treeKey.map(function (d) { return d.split('_')[0]; }));
                url += "&displayType=treeType";
            }
            if (!_this_1.checkIsSelect(expandid)) {
                return;
            }
            _this_1.secondConfirmPrompt(expandid, function () {
                _this_1.doInterfacesAction(billid ? [billid] : billids, expandid, _this_1.windowOpenOnNewCallBack, { url: url });
            });
        };
        this.windowOpenOnNewCallBack = function (_a) {
            var url = _a.url;
            _this_1.refresh();
            var width = screen.availWidth - 10;
            var height = screen.availHeight - 50;
            var szFeatures = 'top=0,';
            szFeatures += 'left=0,';
            szFeatures += 'width=' + width + ',';
            szFeatures += 'height=' + height + ',';
            szFeatures += 'directories=no,';
            szFeatures += 'status=yes,toolbar=no,location=no,';
            szFeatures += 'menubar=no,';
            szFeatures += 'scrollbars=yes,';
            szFeatures += 'resizable=yes'; //channelmode
            __WEBPACK_IMPORTED_MODULE_4__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_4__util__["replaceE8Url"])(url), '', szFeatures);
        };
        //页面扩展得方法执行
        this.doCustomFunction = function (expandid, _, billid) {
            var billids = [];
            if (_this_1.displayType === SearchDisplayType.Excel) {
                billids = _this_1.excelStore.selectedRowKeys;
            }
            else {
                billids = _this_1.newTable.selectedRowKeysAllPages.slice();
            }
            var url = _this_1.urlMap[expandid];
            if (_this_1.displayType == SearchDisplayType.TreeType && _this_1.treeKey) {
                billids = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["uniq"])(_this_1.treeKey.map(function (d) { return d.split('_')[0]; }));
                if (url.indexOf("/cube/search") > -1) {
                    url += "&displayType=treeType";
                }
            }
            if (!_this_1.checkIsSelect(expandid)) {
                return;
            }
            _this_1.secondConfirmPrompt(expandid, function () {
                _this_1.doInterfacesAction(billid ? [billid] : billids, expandid, _this_1.doCustomFunctionCallBack, { url: url });
            });
        };
        this.doCustomFunctionCallBack = function (_a) {
            var url = _a.url;
            eval(url);
        };
        //二次确认提示
        this.secondConfirmPrompt = function (pageexpandid, callBackFun) {
            var confirmContent = _this_1.confirmMap[pageexpandid];
            if (confirmContent !== '' && confirmContent !== undefined) {
                confirmContent = _this_1.getConfirmInfo(confirmContent);
                if (confirmContent == '') {
                    return;
                }
                if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.trim(confirmContent)) { //页面扩展得二次确认提示
                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                        title: __WEBPACK_IMPORTED_MODULE_30_react__["createElement"]("div", { dangerouslySetInnerHTML: { __html: confirmContent } }),
                        okText: getLabel(382958, '继续'),
                        cancelText: getLabel(201, '取消'),
                        onOk: function () {
                            callBackFun();
                        },
                        onCancel: function () {
                        },
                    });
                    return;
                }
            }
            callBackFun();
            return true;
        };
        this.getConfirmInfo = function (confirmContent) {
            var info = '';
            if (confirmContent.startsWith('javascript:getConfirmMessage')) {
                var str = confirmContent.substring(confirmContent.indexOf('{') + 1, confirmContent.indexOf('}'));
                str = str.replace('return', '');
                try {
                    info = eval(str);
                }
                catch (e) {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel('511399', '二次确认提示的js函数有错'));
                }
            }
            else {
                info = confirmContent;
            }
            return info;
        };
        //执行接口动作
        this.doInterfacesAction = function (CheckedCheckboxIds, pageexpandid, callBackFun, params) {
            if (CheckedCheckboxIds && CheckedCheckboxIds.length > 0) {
                var modeid = _this_1.modeId;
                var formid = _this_1.formId;
                __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].doInterface(__assign({ pageexpandid: pageexpandid, CheckedCheckboxIds: CheckedCheckboxIds, modeid: modeid, formid: formid }, _this_1.params)).then(function (_a) {
                    var pageExpendResult = _a.pageExpendResult, status = _a.status;
                    if (pageExpendResult && pageExpendResult.haveError) {
                        Object(__WEBPACK_IMPORTED_MODULE_24__util_cubeUtil__["h" /* showExpendError */])(pageExpendResult, _this_1.getHref());
                        return;
                    }
                });
            }
            setTimeout(function () {
                if (callBackFun) {
                    if (params) {
                        callBackFun(params);
                    }
                    else {
                        callBackFun();
                    }
                }
            });
        };
        this.getHref = function () {
            var href = Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/search?");
            for (var parm in _this_1.params) {
                href += parm + "=" + _this_1.params[parm] + "&";
            }
            return href;
        };
        this.setTag = function () {
            var selectedRowKeysAllPages = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.newTable.selectedRowKeysAllPages.map(function (d) { return d.split('_')[0]; }));
            if (_this_1.displayType == SearchDisplayType.TreeType && _this_1.treeKey) {
                selectedRowKeysAllPages = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.treeKey.map(function (d) { return d.split('_')[0]; }));
            }
            if (_this_1.selectRowkeys.length > 0) {
                selectedRowKeysAllPages = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.selectRowkeys.map(function (d) { return d.split('_')[0]; }));
            }
            if (selectedRowKeysAllPages && selectedRowKeysAllPages.length > 0) {
                _this_1.tagVisible = true;
            }
            else {
                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                    title: getLabel(15172, '系统提示'),
                    content: getLabel(20149, '请至少选择一条记录。')
                });
            }
        };
        this.saveTabBatch = function (para) {
            var params = __assign({ modeid: _this_1.modeId, formid: _this_1.formId }, para);
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].saveTabBatch(params).then(function (_a) {
                var error = _a.error, status = _a.status;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].info(getLabel(83551, '保存成功！'));
                    _this_1.tagVisible = false;
                    _this_1.refresh();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.slideflg = function () {
            return _this_1.slideflgvla;
        };
        this.dosubmitfun = function () {
            _this_1.dosubmitvla = true;
        };
        this.showSlideModal = function (bool, url, percentage) {
            if (_this_1.parentSearch) {
                _this_1.parentSearch.showSlideModal(bool, url, percentage);
            }
            if (!_this_1.isclick) {
                _this_1.isclick = true;
                var _this_6 = _this_1;
                setTimeout(function () {
                    _this_6.isclick = false;
                }, 300); //500ms内仅能点击一次
                url = Object(__WEBPACK_IMPORTED_MODULE_4__util__["replaceE8Url"])(url);
                //url = url.replace('/spa/cube/index.html#', '/spa/cube/index.jsp#');
                url = url.replace(/&_key=\w{1,10}&/g, '&'); //去掉用户配置多加的key
                url = Object(__WEBPACK_IMPORTED_MODULE_26__util_typeUtil__["b" /* checkHref */])(url);
                if (bool) {
                    if (_this_1.slideModalUrlold == url) {
                        return;
                    }
                    else {
                        _this_1.slideModalUrlold = url;
                    }
                    _this_1.slideModalUrl = url;
                    if (url.indexOf('?') != -1) {
                        _this_1.slideModalUrl += "&time=" + new Date().getTime();
                    }
                    _this_1.sliderPercentage = percentage;
                }
                else {
                    _this_1.slideModalUrlold = "";
                    _this_1.slideModalUrl = "";
                    _this_1.sliderPercentage = "";
                    if (_this_1.dosubmitvla) {
                        if (_this_1.displayType === SearchDisplayType.Excel) { //excel列表
                            _this_1.excelStore.getDatas(_this_1.sessionKey, _this_1.editPagination.current);
                        }
                        else if (_this_1.displayType === SearchDisplayType.TreeType) {
                            var params = Object.keys(_this_1.getConditionValues()).length == 0 ? __assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.quickSearchFormData), { isQuickSearch: 1 }) : _this_1.getConditionValues();
                            _this_1.dataKey(__assign({}, _this_1.params, params));
                        }
                        else if (_this_1.displayType === SearchDisplayType.ImgType || _this_1.displayType === SearchDisplayType.VerticalType) {
                            _this_1.dataKey({});
                        }
                        else {
                            _this_1.slideflgvla && __WEBPACK_IMPORTED_MODULE_4__util__["default"]._table.reLoad();
                        }
                        _this_1.slideModalUrl = url;
                        if (url.indexOf('?') != -1) {
                            _this_1.slideModalUrl += "&time=" + new Date().getTime();
                        }
                        _this_1.sliderPercentage = percentage;
                    }
                    _this_1.dosubmitvla = false;
                }
                _this_1.slideflgvla = bool;
                _this_1.slideModalVisible = bool;
                //weaTop层级问题,列表内嵌卡片滑出头部被遮盖了
                if (bool) {
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.wea-new-top-req-wapper .wea-new-top-req').css({ zIndex: 0 });
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.wea-new-top-req-wapper .wea-new-top-req').css({ zIndex: 1 });
                }
            }
        };
        this.showCubeMap = function (bool, title) {
            if (title === void 0) { title = ""; }
            _this_1.cubeMap = {
                visible: bool,
                location: title
            };
        };
        this.getIconInfo = function (modeid) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getAppInfoByID({ modeid: modeid }).then(function (data) {
                if (data.status == "1") {
                    _this_1.iconInfo = {
                        icon: data.icon || "icon-coms-ModelingEngine",
                        iconColor: data.iconColor || "#fff",
                        iconBg: data.iconBg || "#96358a"
                    };
                }
            });
        };
        this.getSingleExcelOut = function (billid) {
            Object(__WEBPACK_IMPORTED_MODULE_19__apis_card__["i" /* doExpCardConfig */])({ action: 'getExpList', modeid: _this_1.modeId }).then(function (data) {
                try {
                    if (data.ExpList.length > 0) {
                        if (data.ExpList.length == 1) { //当后台设置了一种导出类型的时候直接导出
                            __WEBPACK_IMPORTED_MODULE_4__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.formmode.expcard.servlet.ExpCardServer?action=expcard&fileType=" + data.ExpList[0]['key'] + "&billid=" + billid + "&modeId=" + _this_1.modeId));
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].ls.set('cube_export_type', data.ExpList[0]['key']);
                            Object(__WEBPACK_IMPORTED_MODULE_24__util_cubeUtil__["i" /* showExportMenu */])(data.ExpList, billid, _this_1.modeId, "card", "", "", "", "");
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                            title: getLabel(17416, '导出'),
                            content: (__WEBPACK_IMPORTED_MODULE_30_react__["createElement"]("div", null, getLabel('500890', '模块没有设置导出文件类型，请联系管理员！'))),
                            onOk: function () {
                            },
                        });
                    }
                }
                catch (error) {
                }
            });
        };
        this.reloadTabsAndCounts = function () {
            if (_this_1.displayType == SearchDisplayType.ImgType) {
                if (!_this_1.imgPageRefresh) {
                    _this_1.selectRowKeyAll(true);
                }
                else {
                    _this_1.imgPageRefresh = false;
                }
            }
            var params = __assign({}, _this_1.params, _this_1.reloadParams);
            _this_1.getCountData(params);
            _this_1.getGroupData(params);
        };
        //**************数据筛选相关的**************** */
        this.resetMenu = function (menuKey) {
            _this_1.checkLoading = true;
            _this_1.oldMenueKey = menuKey;
            _this_1.tempTabledatas = JSON.parse(JSON.stringify(_this_1.newTable.datas));
            var isImgSearch = _this_1.displayType == SearchDisplayType.ImgType;
            var isTree = _this_1.displayType == SearchDisplayType.TreeType;
            var isVertical = _this_1.displayType == SearchDisplayType.VerticalType;
            _this_1.tempselectedRowKeys = (isImgSearch || isVertical) ? _this_1.selectRowkeys : _this_1.newTable.selectedRowKeys;
            var removeSelct = [];
            _this_1.checkBtn = "expandid_" + menuKey + "span";
            var datas = [];
            datas = JSON.parse(JSON.stringify(_this_1.newTable.datas));
            if (isTree) {
                datas = JSON.parse(JSON.stringify(_this_1.tableData.Data));
                _this_1.tempTabledatas = JSON.parse(JSON.stringify(_this_1.tableData.Data));
                _this_1.tempselectedRowKeys = _this_1.selectedRowKeys;
                _this_1.checkBtn = "expandid_" + menuKey;
            }
            datas.map(function (item) {
                if (item[_this_1.checkBtn] == "true") {
                    item.randomFieldCk = "false";
                    if (isTree) {
                        var tempid = item['key'] || item['id'] || item['randomFieldId'];
                        removeSelct.push(tempid);
                    }
                    else {
                        var imgId = item.randomFieldId ? (item.randomFieldSubKeyd_id != undefined ? item.randomFieldId + "_" + item.randomFieldSubKeyd_id : item.randomFieldId) : "";
                        removeSelct.push(imgId);
                    }
                    item.randomFieldOp = 'true';
                }
                if (isTree && item.sublist) {
                    item.sublist = _this_1.dealSubList(item.sublist, removeSelct);
                }
            });
            var rowkeys = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.difference(_this_1.tempselectedRowKeys, removeSelct);
            _this_1.filterSelectRows = removeSelct;
            if (isTree) {
                _this_1.tableData.Data = JSON.parse(JSON.stringify(datas));
                _this_1.selectedRowKeys = rowkeys;
                _this_1.treeKey = rowkeys; //批量修改参数用的这个，这里筛选定义一下
            }
            else {
                _this_1.newTable.tableUpdate({ datas: datas });
                _this_1.newTable.selectedRowKeys = rowkeys;
                _this_1.newTable.selectedRowKeysAllPages = rowkeys;
            }
            var rightMenustmp = _this_1.rightMenus.filter(function (d) { return (d.isfilter == '1' && d.key == menuKey); });
            var cancel = { function: "Cancel", icon: "icon-coms-go-back", key: "-100", name: getLabel(1, '取消'), quickButton: true };
            rightMenustmp.push(cancel);
            _this_1.rightMenus = rightMenustmp;
            _this_1.doRealAction = true;
            var _this = _this_1;
            if (isImgSearch || isVertical) {
                _this_1.selectRowkeys = rowkeys;
                _this_1.setImgSelectValue(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(rowkeys.map(function (d) { return d.split('_')[0]; })).join(','));
            }
            setTimeout(function () {
                _this.checkLoading = false;
            }, 1000);
        };
        this.onclickCancel = function () {
            _this_1.rightMenus = _this_1.tempRightMenus;
            _this_1.doRealAction = false;
            _this_1.filterSelectRows = [];
            _this_1.checkBtn = __WEBPACK_IMPORTED_MODULE_27_prop_types__["any"];
            _this_1.newTable.datas = _this_1.tempTabledatas;
            _this_1.newTable.selectedRowKeys = _this_1.tempselectedRowKeys;
            _this_1.newTable.selectedRowKeysAllPages = _this_1.tempselectedRowKeys;
            if (_this_1.displayType == SearchDisplayType.ImgType) {
                _this_1.selectRowkeys = _this_1.tempselectedRowKeys;
                _this_1.setImgSelectValue(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.selectRowkeys.map(function (d) { return d.split('_')[0]; })).join(','));
            }
            if (_this_1.displayType == SearchDisplayType.TreeType) {
                _this_1.tableData.Data = _this_1.tempTabledatas;
                _this_1.selectedRowKeys = _this_1.tempselectedRowKeys;
            }
            /***如果被修改就识别不到了，重新请求下 */
            _this_1.refresh();
        };
        this.backUpData = function () {
            var idarr = _this_1.newTable.selectedRowKeysAllPages.slice();
            var idset = new Set();
            idarr.forEach(function (element) {
                idset.add(element.split('_')[0]);
            });
            idarr = Array.from(idset);
            var ids = idarr.join(',');
            var content = getLabel('515098', '是否确认还原全部数据') + "？";
            if (ids != '') {
                content = getLabel('515099', '是否确认还原已勾选的数据') + "？";
            }
            var count = _this_1.newTable.count;
            if (count <= 0) {
                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].info({
                    title: getLabel(15172, '系统提示'),
                    content: getLabel('515213', '暂无待还原数据'),
                });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                    title: getLabel(131329, '信息确认'),
                    content: content,
                    onOk: function () { return _this_1.doBackUp(ids); }
                });
            }
        };
        this.doBackUp = function (ids) {
            _this_1.backupDataLoading = true;
            var parms = { ids: ids, customid: _this_1.customId, backuplogid: _this_1.params.backuplogid };
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].backUpData(__assign({}, parms)).then(function (data) {
                _this_1.backupDataLoading = false;
                if (data.status == "1") {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].success({
                        title: getLabel(131329, '信息确认'),
                        content: data.msg
                    });
                }
                _this_1.refresh();
            });
        };
        this.needSet = function (fieldid) {
            var result = false;
            _this_1.conditionInfo[0].items.map(function (item) {
                var domkey = item.domkey;
                if (domkey[0] == "con_" + fieldid) {
                    result = true;
                }
            });
            return result;
        };
        this.changeQuickSearchData = function (domkey) {
            _this_1.quickSearchData.quicksearchinfo.map(function (item) {
                var handleItem = function (item) {
                    if (item.parentDomkey && item.parentDomkey[0] == domkey) {
                        item.value = '';
                        // todo
                        // console.log(this.condition.form.getFormDatas())
                        var conDatas = _this_1.condition.form.getFormDatas();
                        if (conDatas[item.domkey[0]]) {
                            _this_1.condition.form.$(item.domkey[0]).value = '';
                        }
                        _this_1.quickSearchFormData[item.domkey[0].split('_')[1]] = '';
                        _this_1.changeQuickSearchData(item.domkey[0]);
                    }
                };
                if (item.hasOwnProperty('searchGroup')) {
                    item.searchGroup.forEach(function (field) {
                        handleItem(field);
                    });
                }
                else {
                    handleItem(item);
                }
            });
        };
        this.setQuickSearchInfo = function (data) {
            if (data === void 0) { data = []; }
            _this_1.quickSearchData = __assign({}, _this_1.quickSearchData, { quicksearchinfo: data });
        };
        //二次密码验证
        this.doSecondaryVirty = function (params) {
            var getLabel = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaLocaleProvider"].getLabel;
            var url = Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])("/spa/hrm/index_mobx.html#/main/hrmSingle/secondaryVerify/30");
            var onSecondaryCancel = function () {
            };
            var onCallbackHandle = function (f) {
                if (f == 'success') {
                    __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].updateFreeSecretTime({ customid: params.customid, viewtype: params.viewtype }).then(function (data) {
                        if (data.result) {
                            _this_1.reloadSearch(params);
                            _this_1.secondflag = false;
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.message);
                        }
                    });
                }
            };
            var showSecondaryVirty = function () { return __awaiter(_this_1, void 0, void 0, function () {
                var _this_1 = this;
                return __generator(this, function (_a) {
                    __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].modeSecondaryVerify({ customid: params.customid, viewtype: params.viewtype }).then(function (data) {
                        if (data.status == '1') {
                            if (data.isNeedSecondPwdVerify) {
                                _this_1.hasRight = false;
                                _this_1.verified = true;
                                var style = { 'width': 600, 'height': 200 };
                                var secondaryVrifyDialog = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTools"].createDialog({ moduleName: 'hrm', title: getLabel(501195, '身份验证'), url: url, style: style, callback: onCallbackHandle, onSecondaryCancel: onSecondaryCancel });
                                secondaryVrifyDialog.show();
                            }
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.message);
                        }
                    });
                    return [2 /*return*/];
                });
            }); };
            showSecondaryVirty();
        };
        // 纵向列表数据
        this.selectVerticalRowKey = function (value) {
            _this_1.verticalListStore.update({ rowCheckKey: [value] });
            if (_this_1.disquerycheck != '1') {
                var selectRowkey_2 = [];
                if (_this_1.selectRowkeys.indexOf(value) > -1) {
                    _this_1.selectRowkeys.forEach(function (item) {
                        if (item != value) {
                            selectRowkey_2.push(item);
                        }
                    });
                    _this_1.selectRowkeys = selectRowkey_2;
                }
                else {
                    _this_1.selectRowkeys.push(value);
                }
                _this_1.verticalListStore.update({ selectValue: __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(_this_1.selectRowkeys.map(function (d) { return d.split('_')[0]; })).join(',') });
            }
        };
        /***********************      查询统计      **************************** */
        /* 是否显示‘统计’下拉列表 */
        this.handleShowMoreCountData = function (showMoreCountData) {
            _this_1.showMoreCountData = !showMoreCountData;
        };
        //-----------------------------------------------------------------------------------------------点击展示小卡片
        this.rowClickFun = function (record, e) {
            var currentTr = _this_1._$(e.srcElement).closest('tr[class*="ant-table-row"]');
            if (currentTr[0]) {
                _this_1.showRowClick(currentTr, record.randomFieldId, record.randomFieldSubKeyd_id);
            }
        };
        this.showRowClick = function (currentTr, id, d_id) {
            if (_this_1.rowClick['1']) { //默认窗口
                __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getRowClickHref({ modeid: _this_1.modeId, formid: _this_1.formId, billid: id, id: _this_1.rowClick['1'].id }).then(function (data) {
                    if (data.status == '1') {
                        if (data.href.startsWith('javascript:')) {
                            _this_1.doCustomFunctionCallBack({ url: data.href });
                        }
                        else {
                            top.window.location.href = Object(__WEBPACK_IMPORTED_MODULE_32__util_contentPath__["a" /* getContentPath */])(data.href);
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.message);
                    }
                });
                return;
            }
            if (_this_1.rowClick['2']) { //弹出窗口
                __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getRowClickHref({ modeid: _this_1.modeId, formid: _this_1.formId, billid: id, id: _this_1.rowClick['2'].id }).then(function (data) {
                    if (data.status == '1') {
                        if (data.href.startsWith('javascript:')) {
                            _this_1.doCustomFunctionCallBack({ url: data.href });
                        }
                        else {
                            top.window.open(data.href);
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.message);
                    }
                });
            }
            if (_this_1.rowClick['4']) { //右侧展开
                __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getRowClickHref({ modeid: _this_1.modeId, formid: _this_1.formId, billid: id, id: _this_1.rowClick['4'].id }).then(function (data) {
                    if (data.status == '1') {
                        if (data.href.startsWith('javascript:')) {
                            _this_1.doCustomFunctionCallBack({ url: data.href });
                        }
                        else {
                            _this_1.rightLayoutHref = data.href;
                            var hreftype = _this_1.rowClick['4'].hreftype;
                            if (hreftype == 1) { // 关联类型为模块
                                _this_1.modeDataMatched = data.isMatched;
                            }
                        }
                        if (_this_1.rowClick['4'].width) {
                            _this_1.rightLayoutWidth = _this_1.rowClick['4'].width;
                        }
                        else {
                            _this_1.rightLayoutWidth = '35%';
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.message);
                    }
                });
            }
            if (_this_1.rowClick['5']) { //下方展示列表小卡片
                var nextTr = currentTr.next();
                if (nextTr[0]) { //如果存在下一个兄弟tr判断下一个兄弟是否是小卡片
                    if (nextTr.attr('littleCard') == '1') {
                        if (nextTr.css('display') == 'none') {
                            _this_1._$('tr[littleCard="1"]').css('display', 'none');
                            nextTr.css('display', 'table-row');
                        }
                        else {
                            nextTr.css('display', 'none');
                        }
                    }
                    else {
                        _this_1.littleCardContent(currentTr, id, d_id);
                    }
                }
                else { //如果不存在则可能点击的是最后一行
                    _this_1.littleCardContent(currentTr, id, d_id);
                }
            }
            if (_this_1.rowClick['3']) { //其它
                if (_this_1.rowClick['3'].hreftarget.indexOf('$') > -1) {
                    __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getRowClickHref({ modeid: _this_1.modeId, formid: _this_1.formId, billid: id, id: _this_1.rowClick['3'].id }).then(function (data) {
                        if (data.status == '1') {
                            _this_1.doCustomFunctionCallBack({ url: data.href });
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.message);
                        }
                    });
                }
                else {
                    _this_1.doCustomFunctionCallBack({ url: _this_1.rowClick['3'].hreftarget });
                }
            }
        };
        this.littleCardContent = function (currentTr, id, d_id) {
            _this_1._$('tr[littleCard="1"]').css('display', 'none');
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('<tr littleCard="1"><td colspan="' + currentTr.children().length + '"><div id="littleCard_' + id + '_' + d_id + '" style="text-align:center;padding:5px;"></div></td></tr>').insertAfter(currentTr);
            var div = document.getElementById("littleCard_" + id + "_" + d_id);
            __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_30_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_antd__["Spin"], { ecId: "_Spin@hz9apz", spinning: true }), div);
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].showLittleCard({ customid: _this_1.customId, billid: id, d_id: d_id }).then(function (data) {
                if (data.status == '1') {
                    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_30_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__components_list_littleCard_LittleCard__["a" /* default */], { ecId: "_LittleCard@7a7eom", width: _this_1.rowClick['5'].width, canEdit: data.canEdit, onChange: function (fieldid, value) {
                            _this_1.littleCardFieldChange(fieldid, value, id, d_id);
                        }, datas: data.datas }), div);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.message);
                }
            });
        };
        this.littleCardFieldChange = function (fieldid, value, id, d_id) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].saveLittleCardFieldValue({ fieldid: fieldid, value: value, id: id, d_id: d_id, modeid: _this_1.modeId }).then(function (data) {
                if (data.status == '1') {
                    if (data.errorCode && data.errorCode == '-1') {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.error);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].success(getLabel(83551, '保存成功！'));
                        _this_1.reload();
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(data.message);
                }
            });
        };
        /**获取当前的查询，提供给用到jquery操作dom的地方 */
        this._$ = function (selector) {
            return __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#cube_search_" + _this_1.params.customid).find(__WEBPACK_IMPORTED_MODULE_7_jquery___default()(selector)).not(__WEBPACK_IMPORTED_MODULE_7_jquery___default()("div[id=\"cube_search_" + _this_1.params.customid + "\"] div[id^=\"cube_search_\"]").find(__WEBPACK_IMPORTED_MODULE_7_jquery___default()(selector)));
        };
        this.changeConditioninfo = function (fieldid, v) {
            _this_1.conditionInfo[0].items.map(function (item) {
                var domkey = item.domkey;
                if (domkey[0] == "con_" + fieldid) {
                    _this_1.condition.form.$("con_" + fieldid).set(v);
                }
            });
        };
        this.changeConditioninfoForBrowser = function (fieldid, ids, data, valueSpan) {
            _this_1.conditionInfo[0].items.map(function (item) {
                var domkey = item.domkey;
                if (domkey[0] == "con_" + fieldid) {
                    _this_1.condition.form.$("con_" + fieldid).value = ids;
                    _this_1.condition.form.$("con_" + fieldid).valueObj = data;
                    _this_1.condition.form.$("con_" + fieldid).valueSpan = valueSpan;
                }
            });
        };
        this.getCountData = function (params) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getCountData(params).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (res) {
                if (res.status == '1') {
                    _this_1.countData = res.countData;
                }
            }));
        };
        this.getGroupData = function (params) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getGroupData(params).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, groupCount = _a.groupCount;
                if (status == '1') {
                    if (groupCount && _this_1.top.selectedKey != 'empty') { //未分组为0，则不显示
                        _this_1.top.onHandleEmptyTab(groupCount['empty']);
                    }
                    _this_1.top.update({ groupCount: groupCount });
                }
            }));
        };
        /* 传入store */
        this.setStore = function (key, value) {
            _this_1[key] = value;
        };
        this.isNeedFixedToTop = function (listHeight) {
            var rightMenus = _this_1.rightMenus;
            if (rightMenus && rightMenus.length > 0) {
                if ((rightMenus.length + 5) * 30 + 20 > listHeight) {
                    _this_1.needFixedToTop = true;
                    return;
                }
            }
            _this_1.needFixedToTop = false;
            return;
        };
        __WEBPACK_IMPORTED_MODULE_4__util__["default"].onresize = function () {
            // @ts-ignore
            _this_1.height = document.documentElement.clientHeight;
        };
        this.modename = getLabel(83, '日志');
    }
    Object.defineProperty(listStore.prototype, "isInnerTab", {
        get: function () {
            return this._isInnerTab;
        },
        set: function (bol) {
            this._isInnerTab = bol;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(listStore.prototype, "register_table", {
        get: function () {
            var _this_1 = this;
            return {
                reLoad: function () {
                    _this_1.reload();
                    if (_this_1.params.isRefreshTree == '1') {
                        __WEBPACK_IMPORTED_MODULE_4__util__["default"].refreshTree(_this_1.params.customTreeDataId);
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(listStore.prototype, "displayType", {
        get: function () {
            var type = this.params.displayType;
            if (!type || type !== SearchDisplayType.Excel) {
                type = this.dataShowtype;
            }
            return type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(listStore.prototype, "tableDatas", {
        get: function () {
            return this.newTable.datas;
        },
        enumerable: true,
        configurable: true
    });
    listStore.prototype.setSelectedRowKeys = function (rowKey, value) {
        var _this_1 = this;
        //树展示，最多五层结构，暂不写递归
        this.treeKey = [];
        if (value.length > 0) {
            value.map(function (item) {
                if (item.randomFieldCk != 'false') {
                    _this_1.treeKey.push(item.key);
                }
                var sublist = item.sublist;
                if (sublist != undefined && sublist != '') { //第二层
                    sublist.map(function (items) {
                        if (items.randomFieldCk != 'false') {
                            _this_1.treeKey.push(items.key);
                        }
                        var sublist = items.sublist;
                        if (sublist != undefined && sublist != '') { //第三层
                            sublist.map(function (it) {
                                if (it.randomFieldCk != 'false') {
                                    _this_1.treeKey.push(it.key);
                                }
                                var sublist = it.sublist;
                                if (sublist != undefined && sublist != '') { //第四层
                                    sublist.map(function (it) {
                                        if (it.randomFieldCk != 'false') {
                                            _this_1.treeKey.push(it.key);
                                        }
                                        var sublist = it.sublist;
                                        if (sublist != undefined && sublist != '') { //第五层
                                            sublist.map(function (it) {
                                                if (it.randomFieldCk != 'false') {
                                                    _this_1.treeKey.push(it.key);
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }
        else {
            this.treeKey = rowKey;
        }
        this.selectedRowKeys = this.treeKey;
    };
    listStore.prototype.getColumn = function (columns, dataindex, columns2) {
        var mergeInfos = this.mergeInfos;
        for (var i = 0; i < mergeInfos.length; i++) {
            if (mergeInfos[i].fields.indexOf(dataindex) > -1) {
                for (var m = 0; m < mergeInfos[i].fields.length; m++) {
                    columns2.push(mergeInfos[i].fields[m]);
                }
                var mergecolumn = {};
                mergecolumn.title = mergeInfos[i].mergename;
                mergecolumn.className = "column-text-center";
                mergecolumn.display = "true";
                //let fieldcount = parseInt(mergeInfos[i].fields.length);
                mergecolumn.width = this.getoldWidth(mergeInfos[i], columns);
                mergecolumn.children = this.getchildren(mergeInfos[i], columns);
                return mergecolumn;
            }
        }
    };
    listStore.prototype.getoldWidth = function (mergeInfo, columns) {
        var width = 0;
        var children = mergeInfo.children;
        if (children) {
            for (var j = 0; j < children.length; j++) {
                if (children[j].fieldname) {
                    var fieldname = children[j].fieldname;
                    for (var i = 0; i < columns.length; i++) {
                        var key = columns[i].key;
                        var fieldhtmltype = columns[i].fieldhtmltype;
                        var type = columns[i].fieldtype;
                        if (columns[i].fieldid && (columns[i].fieldid == '-2' || columns[i].fieldid == '-4' || columns[i].fieldid == '-5') || columns[i].fieldid == '-7') {
                            key = key.replace('span', '');
                        }
                        //浮点数 金额转换 金额千分位 多行文本 特殊字段的key加了span
                        if ((fieldhtmltype == '1' && (type == '3' || type == '4' || type == '5')) || (fieldhtmltype == '2' && type == '1') || (fieldhtmltype == '7')) {
                            key = key.replace('span', '');
                        }
                        if (fieldname == key) {
                            var childrenwidth = parseFloat(columns[i].width || '0');
                            width = width + childrenwidth;
                        }
                    }
                }
                else {
                    width = width + this.getoldWidth(children[j], columns);
                }
            }
        }
        return width;
    };
    listStore.prototype.getchildren = function (mergeInfo, columns) {
        var children = mergeInfo.children;
        var childrens = [];
        if (children) {
            for (var j = 0; j < children.length; j++) {
                var childreninfo = {};
                if (children[j].fieldname) {
                    var fieldname = children[j].fieldname;
                    for (var i = 0; i < columns.length; i++) {
                        var key = columns[i].key;
                        var fieldhtmltype = columns[i].fieldhtmltype;
                        var type = columns[i].fieldtype;
                        if (columns[i].fieldid && (columns[i].fieldid == '-2' || columns[i].fieldid == '-4' || columns[i].fieldid == '-5') || columns[i].fieldid == '-7') {
                            key = key.replace('span', '');
                        }
                        //浮点数 金额转换 金额千分位 多行文本 特殊字段的key加了span
                        if ((fieldhtmltype == '1' && (type == '3' || type == '4' || type == '5')) || (fieldhtmltype == '2' && type == '1') || (fieldhtmltype == '7')) {
                            key = key.replace('span', '');
                        }
                        if (fieldname == key) {
                            childreninfo = columns[i];
                            break;
                        }
                    }
                }
                else {
                    childreninfo.title = children[j].mergename;
                    childreninfo.className = "column-text-center";
                    childreninfo.display = "true";
                    childreninfo.width = "100";
                    childreninfo.children = this.getchildren(children[j], columns);
                }
                childrens.push(childreninfo);
            }
        }
        return childrens;
    };
    listStore.prototype.likeOrDislike = function (record, key, index, type) {
        var _this_1 = this;
        /***
         * type 列表类型 1 :normal, 0 :imgtype, 2:分组列表，5：纵向列表  [5: "赞"标签  6: "踩"标签]
         */
        var billid = record.randomFieldId;
        __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].saveCubeLikeInfo({ modeid: this.modeId, billid: billid, status: key }).then(function (data) {
            if (data.status == '1') {
                if (data.issuccess) {
                    //this.newTable.getDatas('', this.newTable.current, this.newTable.pageSize);
                    var likecount = data.likecount || '0';
                    var dislikecount = data.dislikecount || '0';
                    var likestatus = data.likestatus || '0';
                    if (type == '1' || type == '0' || type == '5' || type == '6') {
                        var isshowlistspan = void 0;
                        var likesinfospan = likecount + ',' + dislikecount + ',' + likestatus;
                        if (type == '1' || type == '0') {
                            isshowlistspan = (_this_1.newTable.datas[index].isshowlistspan && JSON.parse(_this_1.newTable.datas[index].isshowlistspan)) || [];
                        }
                        else {
                            isshowlistspan = (_this_1.verticalListStore.allDatas[index].isshowlistspan && JSON.parse(_this_1.verticalListStore.allDatas[index].isshowlistspan)) || [];
                        }
                        var index1 = 0;
                        for (index1; index1 < isshowlistspan.length; index1++) {
                            var otherpara = isshowlistspan[index1].otherpara || '';
                            if (otherpara.indexOf('#islikebutton:1') > -1) {
                                var otherparas = isshowlistspan[index1].otherpara.split("+");
                                if (otherparas[1]) {
                                    var likeinfo = otherparas[1].replace("#likeinfo:", "");
                                    var hreftype1 = likeinfo.split(",")[0];
                                    if (hreftype1 == '5' || hreftype1 == '6') {
                                        isshowlistspan[index1].otherpara = '#islikebutton:1+#likeinfo:' + hreftype1 + ',' + likecount + ',' + dislikecount + ',' + likestatus;
                                    }
                                }
                            }
                        }
                        if (type == '1' || type == '0') {
                            _this_1.updateLikeOrDis(billid, isshowlistspan, likesinfospan);
                        }
                        else {
                            _this_1.verticalListStore.updateLikeOrDis(billid, isshowlistspan, likesinfospan);
                        }
                    }
                    if (type == '2') {
                        var datas = _this_1.tableData.Data;
                        var cube_expandmap = JSON.parse(datas[index].cube_expandmap);
                        var index1 = 0;
                        for (index1; index1 < cube_expandmap.length; index1++) {
                            var otherpara = cube_expandmap[index1].otherpara || '';
                            if (otherpara.indexOf('#islikebutton:1') > -1) {
                                var otherparas = cube_expandmap[index1].otherpara.split("+");
                                if (otherparas[1]) {
                                    var likeinfo = otherparas[1].replace("#likeinfo:", "");
                                    var hreftype1 = likeinfo.split(",")[0];
                                    if (hreftype1 == '5' || hreftype1 == '6') {
                                        cube_expandmap[index1].otherpara = '#islikebutton:1+#likeinfo:' + hreftype1 + ',' + likecount + ',' + dislikecount + ',' + likestatus;
                                    }
                                }
                            }
                        }
                        for (var index2 = 0; index2 < datas.length; index2++) {
                            if (datas[index2].randomfieldid == record.randomFieldId) { //第一层
                                datas[index2].cube_expandmap = JSON.stringify(cube_expandmap);
                                // break;
                            }
                            else if (datas[index2].sublist && datas[index2].sublist.length > 0) {
                                for (var index3 = 0; index3 < datas[index2].sublist.length; index3++) {
                                    if (datas[index2].sublist[index3].randomfieldid == record.randomFieldId) { //第二层
                                        datas[index2].sublist[index3].cube_expandmap = JSON.stringify(cube_expandmap);
                                        // break;
                                    }
                                    else if (datas[index2].sublist[index3].sublist && datas[index2].sublist[index3].sublist.length > 0) {
                                        for (var index4 = 0; index4 < datas[index2].sublist[index3].sublist.length; index4++) {
                                            if (datas[index2].sublist[index3].sublist[index4].randomfieldid == record.randomFieldId) { //第三层
                                                datas[index2].sublist[index3].sublist[index4].cube_expandmap = JSON.stringify(cube_expandmap);
                                                // break;
                                            }
                                            else if (datas[index2].sublist[index3].sublist[index4].sublist && datas[index2].sublist[index3].sublist[index4].sublist.length > 0) {
                                                for (var index5 = 0; index5 < datas[index2].sublist[index3].sublist[index4].sublist.length; index5++) {
                                                    if (datas[index2].sublist[index3].sublist[index4].sublist[index5].randomfieldid == record.randomFieldId) { //第四层
                                                        datas[index2].sublist[index3].sublist[index4].sublist[index5].cube_expandmap = JSON.stringify(cube_expandmap);
                                                        // break;
                                                    }
                                                    else if (datas[index2].sublist[index3].sublist[index4].sublist[index5].sublist && datas[index2].sublist[index3].sublist[index4].sublist[index5].sublist.length > 0) {
                                                        for (var index6 = 0; index6 < datas[index2].sublist[index3].sublist[index4].sublist[index5].sublist.length; index6++) {
                                                            if (datas[index2].sublist[index3].sublist[index4].sublist[index5].sublist[index6].randomfieldid == record.randomFieldId) { //第五层
                                                                datas[index2].sublist[index3].sublist[index4].sublist[index5].sublist[index6].cube_expandmap = JSON.stringify(cube_expandmap);
                                                                // break;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        //datas[index].cube_expandmap = JSON.stringify(cube_expandmap);
                        _this_1.tableData.Data = datas;
                    }
                }
            }
            else {
                __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error("" + getLabel(127353, '错误'));
            }
        });
    };
    listStore.prototype.dealSubList = function (sublist, removeSelct) {
        var _this_1 = this;
        var sublistDatas = [];
        sublistDatas = JSON.parse(JSON.stringify(sublist));
        var isTree = this.displayType == SearchDisplayType.TreeType;
        sublistDatas.map(function (item) {
            if (item[_this_1.checkBtn] == "true") {
                item.randomFieldCk = "false";
                if (isTree) {
                    var tempid = item['key'] || item['id'] || item['randomFieldId'];
                    removeSelct.push(tempid);
                }
                else {
                    removeSelct.push(item['id'] || item['randomFieldId']);
                }
                item.randomFieldOp = 'true';
            }
            if (item.sublist) {
                item.sublist = _this_1.dealSubList(item.sublist, removeSelct);
            }
        });
        sublist = JSON.parse(JSON.stringify(sublistDatas));
        return sublist;
    };
    listStore.prototype.customSearch = function (arr) {
        var _this_1 = this;
        if (arr == undefined || arr == null || !Array.isArray(arr)) {
            return;
        }
        var customparm = {};
        arr.forEach(function (element) {
            var key = 'con_' + element.fieldid;
            if (!element.isdel) {
                customparm[key] = element.value;
            }
            _this_1.setValue(element);
        });
        this.customparms = customparm;
        this.refresh();
    };
    listStore.prototype.setValue = function (obj) {
        var fieldid = obj.fieldid, fieldhtmltype = obj.fieldhtmltype, fieldtype = obj.fieldtype, value = obj.value, valueSpan = obj.valueSpan, _a = obj.isdel, isdel = _a === void 0 ? false : _a;
        var valueObj = { id: value, name: valueSpan };
        if (!fieldid) {
            return;
        }
        if (fieldid && !this.needSet(fieldid)) {
            return;
        }
        if (isdel) {
            value = '';
            valueSpan = '';
            valueObj = {};
        }
        if (fieldhtmltype == '1' //文本类型
            || (fieldhtmltype == '5' && fieldtype == '1')) { //下拉框
            if (fieldhtmltype == '1' && fieldtype != '1') {
                var j = [];
                if (value == "-1" || value == "") {
                    this.condition.form.$("con_" + fieldid).value = j;
                }
                else {
                    var i = value.split(",");
                    this.condition.form.$("con_" + fieldid).value = i;
                }
            }
            else {
                this.condition.form.$("con_" + fieldid).set(value);
            }
        }
        else if (fieldhtmltype == '3') {
            if (fieldtype == '2' || fieldtype == '19' || fieldtype == '290' //日期 时间
                || '1' == fieldtype || '17' == fieldtype) {
                this.condition.form.$("con_" + fieldid).set(value);
            }
            else {
                this.condition.form.$("con_" + fieldid).value = value;
                this.condition.form.$("con_" + fieldid).valueObj = valueObj;
                this.condition.form.$("con_" + fieldid).valueSpan = valueSpan;
            }
        }
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "tableData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "dataShowtype", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "treeData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "treeColumn", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "treePercent", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isExpTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "rightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "printEdcUrl", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "tempRightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "batchTempRightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "height", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "viewResHeight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "customparms", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "query", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "viewtype", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "type", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "top", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "newTable", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "quickSearchValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "advanced", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "condition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "treecolumns", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "treedatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "searchTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "searchImg", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "treeDataWidth", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "checkAdvanedData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "changeDataTime", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "pagesizetree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isTreeSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "treeValueId", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "changeSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "enableTreeList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isTreeType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "treeKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "conditionInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "advancedInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "quickConditions", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "quickConditionConfig", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isShowCondition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isfrontmultlang", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "printWindowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isBatchSubmit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "listEditStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "batchEditStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "copyDataSource", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "copyIsNullField", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "simpleDialogBody", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "simpleDialog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "dialogVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "msgConfirmVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "msgConfirmData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "msgConfirmOldData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "templateid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "template", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "share", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "_isInnerTab", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "reloadModeTop", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isInTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "tagVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "sqlNeedKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "datalist", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "mergeInfos", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "mergeFields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "mergeTempColumns", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isEdit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "editTableStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "customDialog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "verified", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "hasRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "quickSearchData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "quickSearchDataWithNoChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "quickSearchFormData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isTempSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "selectedRowKeys", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "slideModalVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "slideModalUrl", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "slideModalUrlold", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "sliderPercentage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "slideflgvla", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "countReturn", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "dosubmitvla", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "titleField", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "imgPageRefresh", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "selectRowkeys", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "imgSelectValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "dataShowInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "userInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isPagesizeForImg", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "defalutPagesize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "rowCheckKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "cubeMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "needFixedToTop", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "countData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isCharts", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "countDisplayPosition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "showMoreCountData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "waterImg", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "dataBoard", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "excelStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "starttime", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "showProgerss", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isClose", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "progress", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "delLoadingProgress", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "exportkey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "delkey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], listStore.prototype, "isInnerTab", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "batchAddStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "showExpList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "expCardParm", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "doRealAction", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "checkBtn", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "checkLoading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isBackUpData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "backupDataLoading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isCoverType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "filterSelectRows", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "interVal", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "showGlobalSpin", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "rightLayoutHref", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "rightLayoutWidth", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "modeDataMatched", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "editPagination", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "requireTimes", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "requireTimesdata", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isSuspend", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isShowIcon", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "showButtomNum", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "verticalListStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isclick", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], listStore.prototype, "isFromViewResource", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], listStore.prototype, "register_table", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], listStore.prototype, "displayType", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], listStore.prototype, "tableDatas", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "changeIsInTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "changeIsFromViewResource", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "clear", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getConditionOrAdvanced", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "afterConditionInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getTemplate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "changeTemplate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "reloadSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getConditionParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getAdvancedInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getConditionInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "toGetJsCodeArea", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "changeDetailPageSize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "nextDetailDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "imgPageChaneg", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "dataKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "deleteData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "refresh", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "reload", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "reloadBaseList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doBatchEdit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doBatchEdit_datakey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getListInfoForImgSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getEditDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doBack", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doBatchStorage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "openMsgConfirm", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "onBatchEditSave", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doBatchEditSave", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doExcelExpost", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doCustomAction", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "CleanCol", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "likeOrDislike", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "updateLikeOrDis", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doCustomButton", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "slideflg", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "dosubmitfun", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "showSlideModal", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "showCubeMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getIconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getSingleExcelOut", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "reloadTabsAndCounts", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "resetMenu", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "dealSubList", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "onclickCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "backUpData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "changeQuickSearchData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "setQuickSearchInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "doSecondaryVirty", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "handleShowMoreCountData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "rowClickFun", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "littleCardContent", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "littleCardFieldChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "changeConditioninfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "changeConditioninfoForBrowser", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getCountData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "getGroupData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], listStore.prototype, "setStore", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])('计算右键菜单是否超出列表高度')
    ], listStore.prototype, "isNeedFixedToTop", void 0);
    return listStore;
}());

/* harmony default export */ __webpack_exports__["default"] = (new listStore());


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(56);
var IE8_DOM_DEFINE = __webpack_require__(265);
var toPrimitive = __webpack_require__(171);
var dP = Object.defineProperty;

exports.f = __webpack_require__(35) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(57)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(72),
    getRawTag = __webpack_require__(584),
    objectToString = __webpack_require__(585);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(60);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldHtmlType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRandomId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreFuncs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_excelsearch__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__excel_command__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__excel_celltypes_HeaderCellType__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__excel_util__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_modeUtil__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__apis_batchAdd__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_searchUtil__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_contentPath__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};















var getLabel = __WEBPACK_IMPORTED_MODULE_12_ecCom__["WeaLocaleProvider"].getLabel;





var FieldHtmlType;
(function (FieldHtmlType) {
    FieldHtmlType["Input"] = "1";
    FieldHtmlType["Textarea"] = "2";
    FieldHtmlType["Browser"] = "3";
    FieldHtmlType["Check"] = "4";
    FieldHtmlType["Select"] = "5";
    FieldHtmlType["Upload"] = "6";
    FieldHtmlType["Null"] = "";
})(FieldHtmlType || (FieldHtmlType = {}));
var flag1 = false; //批量修改保存按钮状态，多次点击保存按钮，只会发送一次请求
var getRandomFieldId = function (key) {
    var _a = key.split('^^--^^'), randomFieldId = _a[0], _b = _a[1], randomFieldSubKeyd_id = _b === void 0 ? '' : _b;
    return {
        randomFieldId: randomFieldId,
        randomFieldSubKeyd_id: randomFieldSubKeyd_id
    };
};
var getRandomId = function (data) {
    return data.randomFieldSubKeyd_id ? data.randomFieldId + "^^--^^" + data.randomFieldSubKeyd_id : data.randomFieldId;
};
var StoreFuncs = {};
var ExcelStore = /** @class */ (function () {
    function ExcelStore(params) {
        var _this = this;
        this.columns = [];
        this.editable = false;
        this.loading = false;
        this.current = 1;
        this.hasMore = true;
        this.pageSize = 10;
        this.oldInfo = "";
        this.datas = [];
        this.browserMap = {};
        this.changedValues = {};
        this.topRow = 0;
        this.leftCol = 0;
        this.rowHeights = {};
        this.insertedRows = [];
        this.siderWidth = 70;
        this.newDatas = [];
        this.filterVisible = false;
        this.parm = {};
        this.rightMenus = [];
        this.billIds = [];
        this.colorData = [];
        this.keyIndex = {};
        this.nameIndex = {};
        this.opentype = ''; // 打开链接方式
        this.lockrow = '-1'; //锁定行
        this.lockcol = '-1'; //锁定列
        this.deleteDatas = [];
        this.sortBtnWidth = 75;
        this.rightScrollBtnWidth = 20;
        // 点击排序
        this.cilckSort = function (orderkey) {
            _this.filterVisible = false;
            var sort = 'ascend';
            if (_this.sortKey) {
                var sorts = _this.sortKey.split("@");
                if (sorts[0] == orderkey) {
                    sort = sorts[1] == 'ascend' ? 'descend' : 'ascend';
                }
            }
            _this.sortKey = orderkey + "@" + sort;
            _this.getExcelDataBySort(orderkey == 'modedatacreatedate' ?
                [{ "orderkey": orderkey, "sortOrder": sort }, { "orderkey": "modedatacreatetime", "sortOrder": sort }]
                : [{ "orderkey": orderkey, "sortOrder": sort }]);
        };
        this.init = function (workbook) {
            _this.workbook = workbook;
            _this.workbook.bind(GC.Spread.Sheets.Events.EditStarting, _this.editStarting);
            //    this.workbook.bind(GC.Spread.Sheets.Events.TopRowChanged, this.topRowChanged); 取消上拉刷新
            _this.workbook.bind(GC.Spread.Sheets.Events.ValueChanged, _this.valueChanged);
            _this.workbook.bind(GC.Spread.Sheets.Events.DragFillBlock, _this.dragFillBlock);
            _this.workbook.bind(GC.Spread.Sheets.Events.DragDropBlock, _this.dragDropBlock);
            _this.workbook.bind(GC.Spread.Sheets.Events.ColumnWidthChanged, function (e, info) {
                var colList = info.colList, sheet = info.sheet;
                __WEBPACK_IMPORTED_MODULE_2__apis_excelsearch__["c" /* columnWidth */](__assign({}, _this.params, { colList: JSON.stringify(colList.map(function (d) { return ({
                        col: d,
                        dataIndex: _this.backColumn[d].id,
                        width: sheet.getColumnWidth(d)
                    }); })) }));
            });
            // this.workbook.bind(GC.Spread.Sheets.Events.RowHeightChanged, (e, info: GC.Spread.Sheets.IRowHeightChangedEventArgs) => {
            //     const { sheet, rowList } = info;
            //     const { row: rowStart } = this.table.dataRange();
            //     const datas: any[] = this.dataSource.getValue('datas') as any[] || [];
            //     API.rowHeight({
            //         ...this.params,
            //         rowList: JSON.stringify(rowList.map(d => ({
            //             row: d,
            //             randomFieldId: datas[d - rowStart].randomFieldId,
            //             randomFieldSubKeyd_id: datas[d - rowStart].randomFieldSubKeyd_id,
            //             height: sheet.getRowHeight(d)
            //         })))
            //     })
            // })
            _this.workbook.bind(GC.Spread.Sheets.Events.LeftColumnChanged, function (e, info) {
                _this.leftCol = info.newLeftCol;
            });
            _this.workbook.bind(GC.Spread.Sheets.Events.TopRowChanged, function (e, info) {
                _this.topRow = info.newTopRow;
            });
            _this.dataSource = new GC.Spread.Sheets.Bindings.CellBindingSource({ datas: [] });
            Object(__WEBPACK_IMPORTED_MODULE_6__excel_command__["a" /* register */])(_this.workbook.commandManager(), _this);
            _this.contextMenu = _this.workbook.contextMenu;
            var onOpenMenu = _this.contextMenu.onOpenMenu;
            var that = _this;
            _this.contextMenu.onOpenMenu = function (menuData, itemsDataForShown, hitInfo, spread) {
                if (that.editable) {
                    return onOpenMenu(menuData, itemsDataForShown, hitInfo, spread);
                }
                else {
                    return true;
                }
            };
        };
        this.getAddedData = function () {
            var dataArray = [];
            var fieldName = {};
            _this.backColumn.forEach(function (col) {
                fieldName[col.id] = col.column;
            });
            Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["each"])(_this.changedValues, function (data, key) {
                var randomFieldId = getRandomFieldId(key).randomFieldId;
                if (_this.insertedRows.indexOf(randomFieldId) > -1 && _this.deleteDatas.indexOf(randomFieldId) === -1) { //删除的集合中包括这个id，那么就不保存
                    var addData_1 = {};
                    Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["each"])(data.new, function (value, key) {
                        addData_1[fieldName[key]] = value;
                    });
                    dataArray.push(addData_1);
                }
            });
            return dataArray;
        };
        this.getChangedData = function () {
            var dataArray = [];
            Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["each"])(_this.changedValues, function (data, key) {
                var _a = getRandomFieldId(key), randomFieldId = _a.randomFieldId, randomFieldSubKeyd_id = _a.randomFieldSubKeyd_id;
                if (_this.insertedRows.indexOf(randomFieldId) === -1) {
                    dataArray.push(__assign({}, data.new, { randomFieldId: randomFieldId,
                        randomFieldSubKeyd_id: randomFieldSubKeyd_id }));
                }
            });
            return dataArray;
        };
        this.getChangedOldData = function () {
            var dataArray = [];
            Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["each"])(_this.changedValues, function (data, key) {
                var _a = getRandomFieldId(key), randomFieldId = _a.randomFieldId, randomFieldSubKeyd_id = _a.randomFieldSubKeyd_id;
                if (_this.insertedRows.indexOf(randomFieldId) === -1) {
                    dataArray.push(__assign({}, data.old, { randomFieldId: randomFieldId,
                        randomFieldSubKeyd_id: randomFieldSubKeyd_id }));
                }
            });
            return dataArray;
        };
        this.setChangedValue = function (randomFieldId, column, info) {
            //    const { typeName } = column;
            var newValue = info.newValue, oldValue = info.oldValue, sheet = info.sheet, col = info.col;
            var data = _this.changedValues[randomFieldId] || { new: {}, old: {} };
            data.new[column.id] = Object(__WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["f" /* getInputValue */])(newValue);
            if (data.old[column.id] === void 0) {
                data.old[column.id] = Object(__WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["f" /* getInputValue */])(oldValue) || '';
            }
            if (data.new[column.id] === data.old[column.id]) {
                delete data.new[column.id];
                delete data.old[column.id];
                Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(sheet.modifyedValues, randomFieldId + "." + col, false);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(sheet.modifyedValues, randomFieldId + "." + col, true);
            }
            try {
                if (typeof oldValue === 'string') {
                    data.old["row"] = JSON.parse(oldValue).row || info.row;
                    data.old["time"] = JSON.parse(oldValue).time || info.time;
                }
                else {
                    data.old["row"] = oldValue.row || info.row;
                    data.old["time"] = oldValue.time || info.time;
                }
            }
            catch (e) {
            }
            _this.changedValues[randomFieldId] = data;
        };
        this.checkValue = function (col, newValue, cancel) {
            var typeName = col.typeName;
            var canceled = false;
            var realValue = Object(__WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["f" /* getInputValue */])(newValue);
            if (realValue === '' || realValue === null) { //GC.Spread.Sheets.IValueChangedEventArgs 获取到的newValue为空暂时这么处理
                return true;
            }
            if (typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Text) {
                if (Object(__WEBPACK_IMPORTED_MODULE_8__excel_util__["b" /* getRealLength */])(realValue) > col.length) {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7" + col.length);
                    canceled = true;
                }
            }
            else if (typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Int) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_9__util_modeUtil__["b" /* judgeValueIsInt */])(realValue)) {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("\u8BF7\u5F55\u5165\u6574\u6570");
                    canceled = true;
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_8__excel_util__["b" /* getRealLength */])(realValue) > col.length) {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7" + col.length);
                    canceled = true;
                }
            }
            else if (typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Float || typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Thousand || typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Money) {
                if (typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Thousand) {
                    realValue = realValue.replace(/,/g, '');
                }
                if (realValue !== '' && !Object(__WEBPACK_IMPORTED_MODULE_9__util_modeUtil__["c" /* judgeValueIsNumber */])(realValue)) {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("\u8BF7\u5F55\u5165\u6D6E\u70B9\u6570");
                    canceled = true;
                }
                else {
                    if (realValue) {
                        var _a = realValue.split('.'), left = _a[0], _b = _a[1], right = _b === void 0 ? '' : _b;
                        if (right.length > col.qfws) {
                            __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("\u5C0F\u6570\u4F4D\u6570\u4E0D\u80FD\u8D85\u8FC7" + col.qfws);
                            canceled = true;
                        }
                        else if (left.length > col.length) {
                            __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("\u6574\u6570\u4F4D\u6570\u4E0D\u80FD\u8D85\u8FC7" + col.length);
                            canceled = true;
                        }
                    }
                }
            }
            if (canceled) {
                cancel();
                return false;
            }
            else {
                return true;
            }
        };
        this.valueChanged = function (e, info) {
            if (_this.dataSource && _this.backColumn && _this.table) {
                var sheet_1 = info.sheet, row_1 = info.row, col_1 = info.col, newValue = info.newValue;
                var oldValue_1 = info.oldValue;
                var column = _this.backColumn[col_1];
                if (_this.checkValue(column, newValue, function () {
                    sheet_1.setValue(row_1, col_1, oldValue_1);
                })) {
                    var datas = _this.dataSource.getValue('datas');
                    var startRow = _this.table.dataRange().row;
                    var data = datas[row_1 - startRow] || {};
                    if (column.typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Select
                        || column.typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Text
                        || column.typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Int
                        || column.typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Float
                        || column.typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Thousand
                        || column.typeName === __WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["a" /* FieldTypeName */].Money) {
                        data[column.column] = Object(__WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["f" /* getInputValue */])(newValue);
                    }
                    datas[row_1 - startRow] = data;
                    try {
                        if (typeof info.oldValue === 'string') {
                            info.oldValue = __assign({}, JSON.parse(info.oldValue), { row: row_1, time: data.time });
                        }
                        else {
                            info.oldValue = __assign({}, info.oldValue, { row: row_1, time: data.time });
                        }
                    }
                    catch (e) {
                    }
                    _this.setChangedValue(getRandomId(data), column, info);
                }
            }
        };
        this.getExcelDataBySort = function (sort) {
            _this.sort = JSON.stringify(sort);
            _this.getDatas(_this.dataKey, _this.current);
        };
        this.getDatas = function (dataKey, current) {
            if (current === void 0) { current = 1; }
            _this.loading = true;
            _this.dataKey = dataKey;
            _this.current = current;
            _this.hasMore = true;
            if (_this.dataSource) {
                _this.dataSource.setValue('datas', []);
            }
            var initData = function () {
                if (_this.workbook) {
                    Promise.all([__WEBPACK_IMPORTED_MODULE_2__apis_excelsearch__["d" /* columns */](_this.params), __WEBPACK_IMPORTED_MODULE_2__apis_excelsearch__["f" /* getDataAndTime */](__assign({ dataKey: dataKey, current: current, sortParams: _this.sort }, _this.params)), __WEBPACK_IMPORTED_MODULE_2__apis_excelsearch__["g" /* getTableCounts */]({ dataKey: dataKey })]).then(function (_a) {
                        var columnsResult = _a[0], dataResult = _a[1], datacount = _a[2];
                        _this.datas = [];
                        _this.current = current;
                        var data = dataResult.data, time = dataResult.time, opentype = dataResult.opentype;
                        _this.data = data;
                        _this.opentype = opentype;
                        __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.current = current;
                        __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.pageSize = data.pageSize;
                        __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.total = datacount.count;
                        __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.onChange = function (current, pageSize) {
                            __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.pageSize = pageSize || __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.pageSize;
                            _this.pageSize = pageSize;
                            try {
                                var dataArray_1 = [];
                                Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["each"])(_this.changedValues, function (data, key) {
                                    var _a = getRandomFieldId(key), randomFieldId = _a.randomFieldId, randomFieldSubKeyd_id = _a.randomFieldSubKeyd_id;
                                    if (_this.insertedRows.indexOf(randomFieldId) === -1) {
                                        dataArray_1.push(__assign({}, data.new, { randomFieldId: randomFieldId,
                                            randomFieldSubKeyd_id: randomFieldSubKeyd_id }));
                                    }
                                });
                                _this.newDatas = dataArray_1;
                                if (_this.newDatas.length > 0 || _this.insertedRows.length > 0) {
                                    __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].confirm({
                                        title: "当前页的数据还未保存，跳转页数后修改的数据将丢失,是否继续跳转？",
                                        okText: getLabel(382958, '确定'),
                                        cancelText: getLabel(201, '取消'),
                                        onOk: function () {
                                            __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.current = current;
                                            _this.getDatas(_this.dataKey, current);
                                            _this.changedValues = {};
                                            _this.insertedRows = [];
                                        },
                                        onCancel: function () {
                                        }
                                    });
                                    return;
                                }
                                else {
                                    __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.current = current;
                                    _this.getDatas(_this.dataKey, current);
                                }
                            }
                            catch (e) { }
                        };
                        __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.onShowSizeChange = function (current, pageSize) {
                            __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.current = current;
                            __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.pageSize = pageSize || __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination.pageSize;
                            _this.pageSize = pageSize;
                            __WEBPACK_IMPORTED_MODULE_2__apis_excelsearch__["h" /* setTablePageSize */]({
                                pageSize: pageSize,
                                dataKey: _this.dataKey
                            }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                                var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas;
                                if (status == '1') {
                                    _this.getDatas(_this.dataKey, current);
                                }
                                else {
                                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("[" + (getLabel(127353, '错误') + errorCode) + "]:" + error);
                                }
                            }));
                        };
                        /****
                         * 当excel出现在右侧查询是，分页信息绑定调整
                         */
                        if (__WEBPACK_IMPORTED_MODULE_13__index__["default"].search && __WEBPACK_IMPORTED_MODULE_13__index__["default"].search.isInSearch) {
                            __WEBPACK_IMPORTED_MODULE_13__index__["default"].search.editPagination = __WEBPACK_IMPORTED_MODULE_13__index__["default"].editPagination;
                        }
                        Promise.all([_this.setColumns(columnsResult), _this.setDatas(data, time), _this.getCellColor(data)]).then(_this.bingDatas);
                    });
                }
                else {
                    setTimeout(function () {
                        initData();
                    }, 500);
                }
            };
            initData();
        };
        this.setDatas = function (result, time) {
            return new Promise(function (resolve) {
                var datas = result.datas;
                var tempDatas;
                tempDatas = datas.map(function (data) {
                    return __assign({}, data, { time: time });
                });
                if (__WEBPACK_IMPORTED_MODULE_16__util_searchUtil__["modeList"].dataLoadAfterCB && typeof __WEBPACK_IMPORTED_MODULE_16__util_searchUtil__["modeList"].dataLoadAfterCB == 'function') {
                    // @ts-ignore
                    tempDatas = __WEBPACK_IMPORTED_MODULE_16__util_searchUtil__["modeList"].dataLoadAfterCB(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(tempDatas), 'excel');
                }
                _this.pushDatas(tempDatas);
                if (result.datas.length < _this.pageSize) {
                    _this.hasMore = false;
                }
                // API.getRowHeight({
                //     ...this.params,
                //     randomIds: JSON.stringify(datas.map(d => ({ randomFieldId: d.randomFieldId, randomFieldSubKeyd_id: d.randomFieldSubKeyd_id })))
                // }).then(({ rowHeight = [] }: { rowHeight: IRowHeight[] }) => {
                //     rowHeight.forEach(rh => {
                //         this.rowHeights[getRandomId(rh)] = rh.height;
                //     });
                //     this.loading = false;
                //     resolve();
                // })
                resolve();
            });
        };
        this.getCellColor = function (result) {
            return new Promise(function (resolve) {
                var datas = result.datas;
                __WEBPACK_IMPORTED_MODULE_2__apis_excelsearch__["e" /* getCellColor */](__assign({}, _this.params, { randomIds: JSON.stringify(datas.map(function (d) { return ({ randomFieldId: d.randomFieldId, randomFieldSubKeyd_id: d.randomFieldSubKeyd_id }); })) })).then(function (dataResult) {
                    var color = dataResult.color, time = dataResult.time;
                    _this.colorData = color;
                    _this.colortime = time;
                    _this.loading = false;
                    resolve();
                });
            });
        };
        this.showInfo = function (info) {
            if (info === _this.oldInfo) {
                __WEBPACK_IMPORTED_MODULE_14__util__["default"].clearTimeout(_this.clearInfoTimer);
                _this.clearInfoTimer = __WEBPACK_IMPORTED_MODULE_14__util__["default"].setTimeout(function () {
                    _this.oldInfo = '';
                }, 700);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_4_antd__["message"].info(info);
                _this.oldInfo = info;
            }
        };
        this.editStarting = function (e, info) {
            var row = info.row, sheet = info.sheet, col = info.col;
            var column = _this.backColumn.length > col ? _this.backColumn[col] : {};
            if (sheet.tables.find(row, col) && _this.editable && column.editable === '1') {
            }
            else {
                info.cancel = true;
            }
        };
        this.setColumns = function (result) {
            return new Promise(function (resolve) {
                if (result.status === '1') {
                    _this.siderWidth = result.siderWidth;
                    _this.pushColumns(result.resultList);
                }
                resolve();
            });
        };
        this.pushDatas = function (datas) {
            if (datas === void 0) { datas = []; }
            var olddatas = _this.dataSource.getValue('datas');
            var newdatas = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["uniqBy"])(olddatas.concat(datas), function (d) { return getRandomId(d); });
            _this.dataSource.setValue('datas', newdatas);
        };
        this.setFiexdInfo = function (val) {
            var valArr = val.split(',');
            _this.lockrow = valArr[0] || 0;
            _this.lockcol = valArr[1] || 0;
        };
        this.pushColumns = function (columns) {
            _this.backColumn = columns.map(function (d) {
                return __assign({}, d, { length: Object(__WEBPACK_IMPORTED_MODULE_8__excel_util__["c" /* getTextLength */])(d), qfws: Object(__WEBPACK_IMPORTED_MODULE_8__excel_util__["a" /* getFloatQfws */])(d) });
            });
            _this.workbook.suspendPaint();
            _this.workbook.fromJSON({}, false);
            var sheet = _this.workbook.getSheet(0);
            sheet.setChangedValue = _this.setChangedValue;
            sheet.setColumnCount(columns.length);
            __WEBPACK_IMPORTED_MODULE_14__util__["default"].table = _this.table = sheet.tables.add('表格', 0, 0, 1, columns.length, GC.Spread.Sheets.Tables.TableThemes.light11, { showHeader: false, rowFilterVisible: false });
            sheet.modifyedValues = {};
            _this.insertedRows = [];
            //  const style= GC.Spread.Sheets.Tables.TableThemes.light11.headerRowStyle();
            var getInt = function (value, def) {
                if (value) {
                    var a = parseInt(value);
                    a = isNaN(a) ? def : a;
                    return a;
                }
                return def;
            };
            var _a = _this.params, lockrow = _a.lockrow, lockcol = _a.lockcol;
            sheet.frozenRowCount(getInt(lockrow ? lockrow : (_this.lockrow != '-1' ? _this.lockrow : 0), 0));
            sheet.frozenColumnCount(getInt(lockcol ? lockcol : (_this.lockcol != '-1' ? _this.lockcol : 0), 0));
            var style = GC.Spread.Sheets.Tables.TableThemes.light11.headerRowStyle();
            var widths = [];
            var totalWidth = 0;
            var clientWidth = document.documentElement.clientWidth - sheet.getColumnWidth(0, GC.Spread.Sheets.SheetArea.rowHeader) - _this.rightScrollBtnWidth;
            var perWidth = clientWidth / 100;
            _this.columns = columns.map(function (d, index) {
                var width = parseFloat(d.colwidth);
                // if (d.width !== void 0) {
                //     width = d.width / perWidth;
                // }
                totalWidth += width;
                widths.push(width);
                sheet.getCell(0, index, GC.Spread.Sheets.SheetArea.colHeader)
                    .font(style.font)
                    .foreColor(style.foreColor)
                    .backColor(style.backColor)
                    .cellType(Object(__WEBPACK_IMPORTED_MODULE_7__excel_celltypes_HeaderCellType__["a" /* default */])(d, _this));
                return new GC.Spread.Sheets.Tables.TableColumn(d.id).dataField(d.column + 'span').name(d.text);
            });
            var noneWidths = widths.filter(function (d) { return d <= 0; });
            var avgwidth = 5;
            if (totalWidth + noneWidths.length * 5 < 100) {
                avgwidth = (100 - totalWidth) / noneWidths.length;
            }
            avgwidth = avgwidth * perWidth;
            // 列宽自适应
            _this.workbook.options.autoFitType = GC.Spread.Sheets.AutoFitType.cellWithHeader;
            widths.forEach(function (width, index) {
                if (width == 0) {
                    // 列宽自适应
                    sheet.autoFitColumn(index);
                    var colWidth = sheet.getColumnWidth(index);
                    sheet.setColumnWidth(index, colWidth + _this.sortBtnWidth);
                }
                else {
                    // sheet.setColumnWidth(index, width <= 0 ? avgwidth : width * perWidth)
                    // sheet.setColumnWidth(index, (width * perWidth) + this.sortBtnWidth)
                    sheet.setColumnWidth(index, (width / 100) * clientWidth);
                }
            });
            _this.table.bindingPath('datas');
            _this.table.bindColumns(_this.columns);
            _this.table.autoGenerateColumns(false);
            // sheet.bindColumns(this.columns);
            //自动换行
            var tempStyle = sheet.getDefaultStyle();
            tempStyle.wordWrap = true;
            sheet.setDefaultStyle(tempStyle);
            // sheet.autoFitRow(1);
            _this.workbook.resumePaint();
        };
        this.bingDatas = function () {
            _this.workbook.suspendPaint();
            _this.workbook.sheets.forEach(function (sheet) {
                sheet.setDataSource(_this.dataSource);
            });
            var sheet = _this.workbook.getActiveSheet();
            _this.table.bindingPath('datas');
            _this.backColumn = _this.backColumn.map(function (col) {
                return __assign({}, col, { title: _this.browserMap[col.id] ? _this.browserMap[col.id].title : '', 
                    // asynLoadAll: this.browserMap[col.id] ? this.browserMap[col.id].asynLoadAll : false,
                    defaultExpandedLevel: _this.browserMap[col.id] ? _this.browserMap[col.id].defaultExpandedLevel : 0, dataParams: _this.browserMap[col.id] ? _this.browserMap[col.id].dataParams : {}, destDataParams: _this.browserMap[col.id] ? _this.browserMap[col.id].destDataParams : {}, tabs: _this.browserMap[col.id] ? _this.browserMap[col.id].tabs : [], conditionDataParams: _this.browserMap[col.id] ? _this.browserMap[col.id].conditionDataParams : {}, hasAdvanceSerach: _this.browserMap[col.id] ? _this.browserMap[col.id].hasAdvanceSerach : false, scrollx: _this.browserMap[col.id] ? _this.browserMap[col.id].scrollx : false });
            });
            _this.backColumn.forEach(function (col, index) {
                var cellType = Object(__WEBPACK_IMPORTED_MODULE_5__excel_celltypes_FieldCellType__["b" /* default */])(col, _this.editable && col.editable === '1');
                sheet.getRange(row, index, rowCount, 1).cellType(cellType);
                //  sheet.setValue(0,index,"",GC.Spread.Sheets.SheetArea.colHeader);//设置头部列名为空
                _this.nameIndex[col.column] = index; //列名-index
            });
            var id_columnColor = {};
            if (_this.colorData) {
                // //获取行号
                for (var index = 0; index < _this.colorData.length; index++) {
                    var randomFieldId = _this.colorData[index].randomFieldId;
                    if (id_columnColor[randomFieldId] == null) {
                        var columnColor = {};
                        columnColor[_this.colorData[index].fieldname] = _this.colorData[index].color;
                        id_columnColor[randomFieldId] = columnColor;
                    }
                    else {
                        id_columnColor[randomFieldId][_this.colorData[index].fieldname] = _this.colorData[index].color;
                    }
                }
            }
            var datas = _this.dataSource.getValue('datas');
            var _a = _this.table.dataRange(), row = _a.row, rowCount = _a.rowCount, colCount = _a.colCount;
            datas.forEach(function (d, i) {
                var height = _this.rowHeights[getRandomId(d)] === void 0 ? 30 : _this.rowHeights[getRandomId(d)];
                sheet.setRowHeight(i + row, height);
                var id = d.randomFieldId || '';
                var colorMap = id_columnColor[id];
                try {
                    for (var j = 0; j < colCount; j++) { //插入行的时候，颜色会自动复制，这里先清除颜色。
                        var cell = _this.workbook.getActiveSheet().getCell(i, j);
                        cell.backColor("");
                    }
                    if (colorMap != null) {
                        Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["each"])(colorMap, function (data, key) {
                            var col = _this.nameIndex[key];
                            if (col != null) {
                                sheet.getRange(i, col, 1, 1).backColor(data);
                            }
                        });
                    }
                }
                catch (error) {
                    console && console.log(error);
                }
            });
            sheet.getRange(0, 0, rowCount, colCount).font(__WEBPACK_IMPORTED_MODULE_11_jquery___default()('body').css('font')).formatter("@").vAlign(GC.Spread.Sheets.VerticalAlign.center);
            sheet.setRowCount(rowCount);
            sheet.showRow(_this.topRow, GC.Spread.Sheets.VerticalPosition.top);
            sheet.showColumn(_this.leftCol, GC.Spread.Sheets.HorizontalPosition.left);
            //  sheet.setColumnVisible(0, false, GC.Spread.Sheets.SheetArea.rowHeader);//隐藏行号
            //   sheet.setRowVisible(0, false, GC.Spread.Sheets.SheetArea.colHeader);//隐藏列号
            _this.workbook.options.tabStripVisible = false; // 左下角tab页不显示
            _this.workbook.resumePaint();
        };
        this.batchEdit = function (dataKey, dataList, browserMap, rightMenus, parm) {
            _this.editable = true;
            var dataMap = {};
            dataList.forEach(function (data) {
                dataMap[data.fieldid] = data;
            });
            _this.browserMap = browserMap;
            _this.parm = parm;
            _this.rightMenus = rightMenus;
            _this.backColumn = _this.backColumn.map(function (col) {
                return __assign({}, col, dataMap[col.id]);
            });
            _this.changedValues = {};
            _this.dataKey = dataKey;
            _this.getDatas(dataKey, 1);
        };
        this.doBack = function (dataKey) {
            _this.editable = false;
            _this.dataKey = dataKey;
            _this.changedValues = {};
            _this.insertedRows = [];
            _this.getDatas(dataKey, 1);
        };
        this.doBatchStorage = function (callback) {
            if (flag1) {
                return;
            }
            flag1 = true;
            var customid = _this.params.customid;
            var newDatas = _this.getChangedData();
            if (newDatas.length == 0 && _this.insertedRows.length == 0) {
                __WEBPACK_IMPORTED_MODULE_4_antd__["message"].warn('未做任何修改！');
                flag1 = false;
                return;
            }
            new Promise(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].batchEditGetVerifyField({ customid: customid }).then(function (_a) {
                    var status = _a.status, result = _a.result;
                    if (result.status === '1') {
                        resolve(result.VerifyField);
                    }
                    resolve([]);
                }).catch(function (e) {
                    resolve([]);
                });
            }).then(function (verifyFields) {
                if (verifyFields.length === 0) {
                    return;
                }
            }).then(function () {
                _this.batchEditSave(callback);
            }).catch(function (error) {
                // console.log(error);
            });
        };
        this.batchEditSave = function (callback) {
            var oldData = JSON.stringify(_this.getChangedOldData());
            var odata = _this.getChangedOldData(); //旧数据
            var newdata = _this.getChangedData(); //新数据
            var customid = _this.params.customid;
            if (odata.length > 0) { //修改
                __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].checkDataIsChange({ customid: customid, oldData: oldData }).then(function (data) {
                    if (data.status == "1") {
                        if (data.errMessage) {
                            __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].confirm({
                                title: '系统提示',
                                width: 400,
                                okText: getLabel(382958, '确定'),
                                cancelText: getLabel(201, '取消'),
                                content: React.createElement("div", { dangerouslySetInnerHTML: { __html: data.errMessage } }),
                                onOk: function () {
                                    var trueOldData = [];
                                    var trueData = [];
                                    var temp = [];
                                    for (var i in data.datas) {
                                        temp[data.datas[i].randomFieldId] = true;
                                    }
                                    for (var k in odata) {
                                        if (!temp[odata[k].randomFieldId]) {
                                            trueOldData.push(odata[k]);
                                        }
                                    }
                                    for (var a in newdata) {
                                        if (!temp[newdata[a].randomFieldId]) {
                                            trueData.push(newdata[a]);
                                        }
                                    }
                                    _this.submitData(trueOldData, trueData, callback);
                                },
                                onCancel: function () { },
                            });
                            flag1 = false;
                        }
                        else {
                            _this.submitData(null, null, callback);
                        }
                    }
                    else {
                        flag1 = false;
                        __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("校验数据是否过期出现异常");
                    }
                });
            }
            else {
                _this.submitData(null, null, callback);
            }
        };
        this.submitData = function (trueOldData, trueData, callback) {
            _this.loading = true;
            var data = trueData ? JSON.stringify(trueData) : JSON.stringify(_this.getChangedData());
            var oldData = trueOldData ? JSON.stringify(trueOldData) : JSON.stringify(_this.getChangedOldData());
            var customid = _this.params.customid;
            Promise.all([Object(__WEBPACK_IMPORTED_MODULE_10__apis_batchAdd__["b" /* saveDatas */])(__assign({}, _this.params, { datas: JSON.stringify(_this.getAddedData()) })), __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].batchEditSave({ customid: customid, data: data, oldData: oldData })]).then(function (_a) {
                var result1 = _a[0], result = _a[1];
                var _b = result, error = _b.error, status = _b.status, pageExpendResult = _b.pageExpendResult;
                if (status == '1') {
                    if (callback) {
                        callback();
                    }
                    _this.changedValues = {};
                    _this.workbook.getActiveSheet().modifyedValues = {}; //取消红点
                    _this.workbook.getActiveSheet().repaint(); //重新绘制spread
                    _this.loading = false;
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].info(getLabel(83551, '保存成功！'));
                    _this.getDatas(_this.dataKey, _this.current);
                    if (pageExpendResult && pageExpendResult.haveError) {
                        Object(__WEBPACK_IMPORTED_MODULE_15__util_cubeUtil__["h" /* showExpendError */])(pageExpendResult, Object(__WEBPACK_IMPORTED_MODULE_17__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/search?customid=" + customid + "&"));
                        return;
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
                flag1 = false;
            });
        };
        this.doCustomAction = function (menu) {
            if (menu.function) {
                try {
                    var func = eval("this." + menu.function);
                    if (typeof func == 'function') {
                        func(menu.key);
                    }
                }
                catch (e) {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error(e);
                    throw e;
                }
            }
        };
        this.windowOpenOnSelf = function (expandid, billid) {
            _this.secondConfirmPrompt(expandid, function () {
                _this.doInterfacesAction(_this.billIds, expandid, _this.windowOpenOnSelfCallBack, { url: _this.parm.urlMap[expandid] });
            });
        };
        this.windowOpenOnSelfCallBack = function (_a) {
            var url = _a.url;
            if (url) {
                __WEBPACK_IMPORTED_MODULE_14__util__["default"].location.href = Object(__WEBPACK_IMPORTED_MODULE_14__util__["replaceE8Url"])(url);
            }
        };
        this.windowOpenOnNew = function (expandid, billid) {
            _this.secondConfirmPrompt(expandid, function () {
                _this.doInterfacesAction(_this.billIds, expandid, _this.windowOpenOnNewCallBack, { url: _this.parm.urlMap[expandid] });
            });
        };
        this.windowOpenOnNewCallBack = function (_a) {
            var url = _a.url;
            //    this.refresh();
            var width = screen.availWidth - 10;
            var height = screen.availHeight - 50;
            var szFeatures = 'top=0,';
            szFeatures += 'left=0,';
            szFeatures += 'width=' + width + ',';
            szFeatures += 'height=' + height + ',';
            szFeatures += 'directories=no,';
            szFeatures += 'status=yes,toolbar=no,location=no,';
            szFeatures += 'menubar=no,';
            szFeatures += 'scrollbars=yes,';
            szFeatures += 'resizable=yes'; //channelmode
            __WEBPACK_IMPORTED_MODULE_14__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_14__util__["replaceE8Url"])(url), '', szFeatures);
        };
        //页面扩展得方法执行
        this.doCustomFunction = function (expandid, _, billid) {
            _this.secondConfirmPrompt(expandid, function () {
                _this.doInterfacesAction(_this.billIds, expandid, _this.doCustomFunctionCallBack, { url: _this.parm.urlMap[expandid] });
            });
        };
        this.doCustomFunctionCallBack = function (_a) {
            var url = _a.url;
            eval(url);
        };
        //二次确认提示
        this.secondConfirmPrompt = function (pageexpandid, callBackFun) {
            var confirmContent = _this.parm.confirmMap[pageexpandid];
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.trim(confirmContent)) { //页面扩展得二次确认提示
                __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].confirm({
                    title: React.createElement("div", { dangerouslySetInnerHTML: { __html: confirmContent } }),
                    okText: getLabel(382958, '继续'),
                    cancelText: getLabel(201, '取消'),
                    onOk: function () {
                        callBackFun();
                    },
                    onCancel: function () {
                    },
                });
                return;
            }
            callBackFun();
            return true;
        };
        //执行接口动作
        this.doInterfacesAction = function (CheckedCheckboxIds, pageexpandid, callBackFun, params) {
            if (CheckedCheckboxIds && CheckedCheckboxIds.length > 0) {
                var modeid = _this.parm.modeId;
                var formid = _this.parm.formId;
                __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].doInterface(__assign({ pageexpandid: pageexpandid, CheckedCheckboxIds: CheckedCheckboxIds, modeid: modeid, formid: formid }, _this.parm));
            }
            setTimeout(function () {
                if (callBackFun) {
                    if (params) {
                        callBackFun(params);
                    }
                    else {
                        callBackFun();
                    }
                }
            });
        };
        this.dragFillBlock = function (e, info) {
            if (!_this.loading && _this.editable && _this.dataSource && _this.table) {
                var fillRange = info.fillRange, fillDirection = info.fillDirection, sheet = info.sheet, sheetName = info.sheetName;
                sheet.suspendPaint();
                var row = fillRange.row, startCol = fillRange.col, rowCount = fillRange.rowCount, colCount = fillRange.colCount;
                if (fillDirection === GC.Spread.Sheets.Fill.FillDirection.down) {
                    for (var colIndex = 0; colIndex < colCount; colIndex++) {
                        var col = startCol + colIndex;
                        var datas = _this.dataSource.getValue('datas');
                        var startRow = _this.table.dataRange().row;
                        var index = row - startRow - 1;
                        var column = _this.backColumn[col];
                        if (index > -1 && index < datas.length && column.editable === '1') {
                            var spanKey = column.column + "span";
                            var oldData = (datas[index] || {});
                            var value = oldData[column.column];
                            var valueSpan = oldData[spanKey];
                            for (var temp = 1; temp <= rowCount; temp++) {
                                var data = datas[temp + index];
                                var oldValue = data[column.column];
                                var newValue = value;
                                data[column.column] = newValue;
                                data[spanKey] = valueSpan;
                                datas[temp + index] = data;
                                _this.setChangedValue(getRandomId(data), column, { sheet: sheet, row: row + temp - 1, col: col, newValue: { value: newValue }, oldValue: { value: oldValue }, sheetName: sheetName, time: data["time"] });
                            }
                            _this.dataSource.setValue('datas', datas);
                        }
                    }
                }
                sheet.resumePaint();
            }
            info.cancel = true;
        };
        this.dragDropBlock = function (e, info) {
            var sheet = info.sheet, sheetName = info.sheetName, rowCount = info.rowCount, colCount = info.colCount, fromRow = info.fromRow, fromCol = info.fromCol, toRow = info.toRow, toCol = info.toCol;
            if (_this.table && _this.dataSource && _this.editable && fromCol === toCol) {
                var startRow = _this.table.dataRange().row;
                var row = fromRow - startRow;
                var row1 = toRow - startRow;
                var datas = _this.dataSource.getValue('datas');
                sheet.suspendPaint();
                for (var colIndex = 0; colIndex < colCount; colIndex++) {
                    var col = _this.backColumn[fromCol + colIndex];
                    if (col.editable === '1') {
                        for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
                            var fromRow_1 = row + rowIndex;
                            var toRow_1 = row1 + rowIndex;
                            var from = "datas." + fromRow_1;
                            var to = "datas." + toRow_1;
                            var tokey = to + "." + col.column;
                            var formKey = from + "." + col.column;
                            var oldValue = _this.dataSource.getValue(tokey);
                            var newValue = _this.dataSource.getValue(formKey);
                            var fromKeySapn = formKey + "span";
                            var todata = datas[toRow_1];
                            var fromdata = datas[fromRow_1];
                            var fromRandomFieldId = getRandomId(_this.dataSource.getValue(from));
                            var toRandomFieldId = getRandomId(_this.dataSource.getValue(to));
                            _this.dataSource.setValue(tokey, newValue);
                            _this.dataSource.setValue(tokey + "span", _this.dataSource.getValue(fromKeySapn));
                            _this.dataSource.setValue(formKey, '');
                            _this.dataSource.setValue(fromKeySapn, '');
                            _this.setChangedValue(fromRandomFieldId, col, { sheet: sheet, row: fromRow_1, col: fromCol, oldValue: { value: newValue }, newValue: { value: '' }, sheetName: sheetName, time: fromdata["time"] });
                            _this.setChangedValue(toRandomFieldId, col, { sheet: sheet, row: toRow_1, col: fromCol, newValue: { value: newValue }, oldValue: { value: oldValue }, sheetName: sheetName, time: todata["time"] });
                        }
                    }
                }
                sheet.resumePaint();
            }
            info.cancel = true;
        };
        this.clipboardPasted = function (info) {
            if (_this.editable && _this.table && _this.dataSource) {
                var sheetName = info.sheetName, _a = info.fromRanges, fromRanges = _a === void 0 ? [] : _a, fromSheet = info.fromSheet, pastedRanges = info.pastedRanges, clipboardText = info.clipboardText;
                _this.workbook.commandManager().execute({
                    autoFitType: GC.Spread.Sheets.AutoFitType.cell,
                    cmd: 'cube-paste-data',
                    sheet: _this.workbook.getSheetFromName(sheetName),
                    sourceRange: fromRanges && fromRanges[0],
                    sourceSheet: fromSheet,
                    cellRange: pastedRanges && pastedRanges[0],
                    value: clipboardText,
                    table: _this.table,
                    dataSource: _this.dataSource,
                    backColumn: _this.backColumn,
                    setChangedValue: _this.setChangedValue
                });
            }
        };
        this.params = params;
        StoreFuncs.changeValue = function (info) {
            _this.valueChanged('', info);
        };
        StoreFuncs.getInstance = function () { return _this; };
        StoreFuncs.getRandomId = function (row) {
            var startRow = _this.table.dataRange().row;
            var data = _this.dataSource.getValue("datas." + (row - startRow));
            return getRandomId(data);
        };
        __WEBPACK_IMPORTED_MODULE_14__util__["default"].cubeOpenHreflinkFromExcel = function (hreflink) {
            var opentype = _this.opentype;
            if (hreflink.indexOf('opentype=0') > -1 || opentype === '0') {
                __WEBPACK_IMPORTED_MODULE_14__util__["default"].modeopenFullWindowHaveBar(hreflink);
            }
            else if (hreflink.indexOf('opentype=1') > -1 || opentype === '1') {
                __WEBPACK_IMPORTED_MODULE_14__util__["default"].cubeOpenFullWindowBySelf(hreflink);
            }
            else if (hreflink.indexOf('opentype=2') > -1 || opentype === '2') {
                __WEBPACK_IMPORTED_MODULE_14__util__["default"].openSlideModal(true, hreflink, _this.siderWidth);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_14__util__["default"].open(hreflink);
            }
        };
        this.bingDatas = this.bingDatas.bind(this);
    }
    Object.defineProperty(ExcelStore.prototype, "selectedRowKeys", {
        get: function () {
            if (this.workbook && this.dataSource) {
                var selections = this.workbook.getActiveSheet().getSelections();
                var rows_1 = [];
                var dataRow_1 = this.table.dataRange().row;
                selections.forEach(function (_a) {
                    var row = _a.row, rowCount = _a.rowCount;
                    for (var index = 0; index < rowCount; index++) {
                        rows_1.push(row + index - dataRow_1);
                    }
                });
                var datas_1 = this.dataSource.getValue('datas');
                return rows_1.filter(function (row) { return row > -1; }).map(function (row) {
                    return datas_1[row] ? datas_1[row].randomFieldId : '';
                });
            }
            else {
                return [];
            }
        },
        set: function (selectedRowKeys) {
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "editable", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "dataKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "current", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "hasMore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "browserMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "filterVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "sortKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "rightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "billIds", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "sort", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "colorData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "data", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "opentype", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "lockrow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ExcelStore.prototype, "lockcol", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], ExcelStore.prototype, "selectedRowKeys", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "cilckSort", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "setChangedValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "checkValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "valueChanged", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "getExcelDataBySort", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "getDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "setDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "getCellColor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "editStarting", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "setColumns", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "pushDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "setFiexdInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "pushColumns", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "bingDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "batchEdit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "doBack", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "doBatchStorage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "batchEditSave", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ExcelStore.prototype, "doCustomAction", void 0);
    return ExcelStore;
}());
/* harmony default export */ __webpack_exports__["b"] = (ExcelStore);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(654),
    baseMatchesProperty = __webpack_require__(665),
    identity = __webpack_require__(78),
    isArray = __webpack_require__(13),
    property = __webpack_require__(667);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.connect = exports.Provider = undefined;

var _Provider2 = __webpack_require__(823);

var _Provider3 = _interopRequireDefault(_Provider2);

var _connect2 = __webpack_require__(824);

var _connect3 = _interopRequireDefault(_connect2);

var _create2 = __webpack_require__(826);

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(260);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObject = __webpack_require__(23);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(44),
    isLength = __webpack_require__(196);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(307),
    baseKeys = __webpack_require__(311),
    isArrayLike = __webpack_require__(45);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isArray = __webpack_require__(13),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentWindow", function() { return getCurrentWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateUUID", function() { return generateUUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatMultLang", function() { return formatMultLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeMultiLang", function() { return decodeMultiLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "manageScriptContent", function() { return manageScriptContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkFormComponentIsFilled", function() { return checkFormComponentIsFilled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_map__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var _this = this;



// import FileDownload from './pages/FileDownload';




var WindowFunc = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].WindowFunc;
var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;
var showModal = function (title, content, width) {
    if (width === void 0) { width = 600; }
    __WEBPACK_IMPORTED_MODULE_1_antd__["Modal"].success({
        title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'wea-browser-single-icon-circle', style: { background: "#96358a" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-ModelingEngine' })),
            title),
        content: content,
        iconType: "",
        okText: getLabel(309, "关闭"),
        width: width,
        onOk: function () { },
    });
};
__WEBPACK_IMPORTED_MODULE_3__util__["default"].cubeshowDdImg = function (fieldids, w, h, isbatch, isdownload, docs, formmode_authorizeUrl) {
    playImg(__WEBPACK_IMPORTED_MODULE_3__util__["default"].event, fieldids, isdownload, formmode_authorizeUrl);
};
var playImg = function (e, fieldid, isdownload, formmode_authorizeUrl) {
    var jq = getCurrentJQuery();
    var currentWindow = getCurrentWindow();
    var imgPool = [];
    var indexNum = 0;
    var fieldids = fieldid.split(',');
    fieldids.map(function (item) {
        imgPool.push("" + ("/weaver/weaver.file.FileDownload?fileid=" + item + formmode_authorizeUrl));
    });
    for (var i = 0; i < imgPool.length; i++) {
        if (jq(e.target).attr('data-imgsrc') === imgPool[i]) {
            break;
        }
        else {
            indexNum++;
        }
    }
    __WEBPACK_IMPORTED_MODULE_3__util__["default"].IMCarousel.showImgScanner4Pool(true, imgPool, indexNum, null, currentWindow.top);
};
var getCurrentJQuery = function () {
    var currentWindow = getCurrentWindow();
    return currentWindow.$ || currentWindow.jQuery;
};
// 获取 window
var getCurrentWindow = function () {
    return WindowFunc.getParent() !== __WEBPACK_IMPORTED_MODULE_3__util__["default"] ? WindowFunc.getTop()
        : __WEBPACK_IMPORTED_MODULE_3__util__["default"];
};
/* harmony default export */ __webpack_exports__["default"] = ({
    createBARCode: function (id, text, customId, modeId, formId) {
        showModal(text, (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'center', minHeight: 60 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.formmode.servelt.BARcodeBuildAction?modeid=" + modeId + "&formid=" + formId + "&billid=" + id + "&customid=" + customId + "&randomnum=" + new Date().getTime()) }))));
    },
    createQRCode: function (id, text, customId, modeId, formId) {
        showModal(text, (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'center', minHeight: 60 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.formmode.servelt.QRcodeBuildAction?modeid=" + modeId + "&formid=" + formId + "&billid=" + id + "&customid=" + customId + "&randomnum=" + new Date().getTime()) }))));
    },
    viewLog: function (billid, text, modeId, _) {
        __WEBPACK_IMPORTED_MODULE_3__util__["default"].modeopenFullWindowHaveBar(Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/logList?modeId=" + modeId + "&billid=" + billid + "&modename=" + text));
    },
    toEdit: function (billid, _, modeId, formId) {
        __WEBPACK_IMPORTED_MODULE_3__util__["default"].modeopenFullWindowHaveBar(Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/card?type=2&modeId=" + modeId + "&formId=" + formId + "&billid=" + billid));
    },
    doprint: function (billid, _, modeId, formId) {
        __WEBPACK_IMPORTED_MODULE_3__util__["default"].modeopenFullWindowHaveBar(Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/card?type=4&modeId=" + modeId + "&formId=" + formId + "&billid=" + billid));
    },
    showFormModeMap: function (fieldvalue) {
        showModal(getLabel(82639, '地图'), (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: 450, margin: "-30px -50px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_map__["c" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_CubeMap@nfp3kg", titles: fieldvalue }))), 700);
    },
    expCard: function (billid, _, modeId, formId) {
        __WEBPACK_IMPORTED_MODULE_3__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.formmode.excel.ExpCardExcelServer?modeId=" + modeId + "&formId=" + formId + "&action=expcard&billid=" + billid));
    }
});
var generateUUID = function () {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};
var formatMultLang = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length == 0) {
        return '';
    }
    else if (args.length == 1) {
        return args[0];
    }
    else {
        var str = args[0];
        for (var i = 1; i < args.length; i++) {
            str = str.replace('{' + (i - 1) + '}', args[i]);
        }
        return str;
    }
};
var decodeMultiLang = function (value) {
    if (!value) {
        return "";
    }
    if (value && typeof value == 'string' && value.startsWith('base64_')) {
        value = value.substring(7);
        return __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].Base64.decode(value);
    }
    else if (value && typeof value == 'string' && value.startsWith('~`~`') && value.endsWith('`~`~')) {
        var languageidweaver_1 = __WEBPACK_IMPORTED_MODULE_3__util__["default"].localStorage.getItem('languageidweaver') || '7';
        var v_1 = '';
        __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaInputLocale"].getList(value, function (list) {
            Object.keys(list).map(function (item) {
                if (item.trim() == languageidweaver_1) {
                    v_1 = list[item];
                }
            });
            return v_1;
        });
        return v_1;
    }
    else {
        return value;
    }
};
//代码块中<script id>标签转换处理
var manageScriptContent = function (content) {
    if (!content)
        return "";
    //script标签存在自定义属性的，生成个空span兼容
    var reg = new RegExp("<script .*?id=.*?></script>|<script .*?id=.*?/>", "ig");
    var arr = content.match(reg);
    var appendScriptSpan = "";
    arr && arr.map(function (v) {
        appendScriptSpan += v.replace(new RegExp("(<|/)script", "ig"), "$1span");
    });
    //document.write覆写Dom结构兼容
    content = content.replace(/document.write/g, 'jQuery("#scriptArea").append');
    //剔除html头等信息
    content = content.replace(/<(\/?)(html|body|head)>/ig, "");
    //剔除部分JS文件引入导致异常
    var scriptSrcArr = [
        "/wui/common/jquery/plugin/Listener_wev8.js",
        "/js/workflow/VCEventHandle_wev8.js"
    ];
    scriptSrcArr.forEach(function (item) {
        content = content.replace(new RegExp("<script .*?" + Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])(item) + ".*?></script>|<script .*?" + Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])(item) + ".*?/>", "ig"), "");
    });
    return content + appendScriptSpan;
};
/**
 * @description 表单组件判空（日期、时间、人力资源、日期时间）
 */
var checkFormComponentIsFilled = function (htmlType, type, value) {
    var isFilled = true;
    var isNotFilled = false;
    if (htmlType == 3) {
        var arr = value;
        if (type == 2) { //日期
            if (arr[0] == 6) {
                if (arr.length === 1 || arr[1] == "" || arr[2] == "") {
                    return isNotFilled;
                }
            }
        }
        else if (type == 19) { //时间
            if (arr.length === 0 || arr[0] == "" || arr[1] == "") {
                return isNotFilled;
            }
        }
        else if (type == 1) { //人力资源
            // 默认空 || 手动清空
            if (arr[0] == -5 && (arr[1] == "" || arr[1].map(function (o) { return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(o); }).filter(function (o) { return o == true; }).length === 3)) {
                return isNotFilled;
            }
        }
        else if (type == 290) { //日期时间
            // 默认空 || 手动清空
            if (arr.length === 0 || arr.some(function (o) { return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(o); })) {
                return isNotFilled;
            }
        }
    }
    return isFilled;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34);
var createDesc = __webpack_require__(90);
module.exports = __webpack_require__(35) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldTypeName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBrowserValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getInputValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHreflink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getParamValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dotPngImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return linkedColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserCellType__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputCellType__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectCellType__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateTimeCellType__ = __webpack_require__(545);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var FieldTypeName;
(function (FieldTypeName) {
    FieldTypeName["Text"] = "text";
    FieldTypeName["Int"] = "int";
    FieldTypeName["Float"] = "float";
    FieldTypeName["Thousand"] = "thousand";
    FieldTypeName["Money"] = "money";
    FieldTypeName["Check"] = "check";
    FieldTypeName["Browser"] = "browser";
    FieldTypeName["DateTime"] = "dateTime";
    FieldTypeName["Select"] = "select";
    FieldTypeName["Radio"] = "radio";
    FieldTypeName["Checkbox"] = "checkbox";
    FieldTypeName["Upload"] = "upload";
})(FieldTypeName || (FieldTypeName = {}));
var getBrowserValue = function (value) {
    try {
        var result = JSON.parse(value);
        //if (isArray(result.datas)) {
        return result.datas;
        // }
    }
    catch (e) {
    }
    return [];
};
var getInputValue = function (value) {
    try {
        if (typeof value === 'string') {
            var v = JSON.parse(value).value;
            //if (isArray(result.datas)) {
            return v;
            // }
        }
        else {
            return value['value'] || '';
        }
    }
    catch (e) {
        if (typeof value === 'string') {
            //value值中可能含有双引号,导致转换成json对象报错
            var start = value.indexOf("value");
            var end = value.lastIndexOf('"');
            if (end > (start + 8)) {
                return value.substring(start + 8, end);
            }
        }
    }
    return "";
};
var getHreflink = function (value) {
    try {
        var hreflink = JSON.parse(value).hreflink;
        //if (isArray(result.datas)) {
        return hreflink;
        // }
    }
    catch (e) {
    }
    return "";
};
/**
 * 获取目标属性值
 * @param value 目标属性值
 * @param key 目标属性
 */
var getParamValue = function (value, key) {
    try {
        if (typeof value === 'string') {
            var _a = key, v = JSON.parse(value)[_a];
            //if (isArray(result.datas)) {
            return v;
            // }
        }
        else {
            return value[key] || '';
        }
    }
    catch (e) {
        if (typeof value === 'string') {
            //value值中可能含有双引号,导致转换成json对象报错
            var start = value.indexOf(key);
            var end = value.lastIndexOf('"');
            if (end > (start + 8)) {
                return value.substring(start + 8, end);
            }
        }
    }
    return "";
};
var dotPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAtElEQVR42o1Quw3CMBQ8EYPoECJAiDFiF2hhF1ZISgZgnCyQgiKxTUVlRqAFH4qjSIjPSSc9vXfvd0CD8wRSy97BquikpTiaebQrxxihi2qKxBczq4Szq8GDNEvhmCtjLF4iGyP1kzKj+vcgaulzvpZfgSG4rlbi9iZqxcKZBGvwpo+ihheJDXj4L2FNYZVGe/3Palrw7RkbniFogT8h79rDmDkd7AkofBdX6Bm2JOMiTPJ4Aqm/kS+wSQAzAAAAAElFTkSuQmCC';
var dotPngImg = document.createElement('img');
dotPngImg.src = dotPng;
var linkedColor = '#2db7f5';
var getEditorType = function (col) {
    var typeName = col.typeName;
    if (typeName === FieldTypeName.Browser) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_0__BrowserCellType__["a" /* default */])(col, true);
        return new Type();
    }
    else if (typeName === FieldTypeName.DateTime) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_4__DateTimeCellType__["a" /* default */])(col, true);
        return new Type();
    }
    else if (typeName === FieldTypeName.Select) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_3__SelectCellType__["a" /* default */])(col, true);
        return new Type(col.options, col.column);
    }
    else if (typeName === FieldTypeName.Check) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["b" /* default */])(col, true);
        return new Type();
    }
    else if (typeName === FieldTypeName.Checkbox) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["b" /* default */])(col, true);
        var cellType = new Type(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["a" /* CheckBoxType */].MutilCheck);
        cellType.items(col.options || []);
        return cellType;
    }
    else if (typeName === FieldTypeName.Radio) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["b" /* default */])(col, true);
        var cellType = new Type(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["a" /* CheckBoxType */].Raido);
        cellType.items(col.options || []);
        return cellType;
    }
    else if (typeName === FieldTypeName.Text || typeName === FieldTypeName.Int || typeName === FieldTypeName.Float || typeName === FieldTypeName.Thousand || typeName === FieldTypeName.Money) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_2__InputCellType__["a" /* default */])(col, true);
        return new Type();
    }
    var Default = Object(__WEBPACK_IMPORTED_MODULE_2__InputCellType__["a" /* default */])(__assign({}, col, { typeName: FieldTypeName.Text }), false);
    return new Default();
};
/* harmony default export */ __webpack_exports__["b"] = (function (col, isEditable) {
    if (isEditable === void 0) { isEditable = false; }
    var typeName = col.typeName;
    if (col.column.toLowerCase() === 'id' || col.column.toLowerCase() === 'modedatacreatedate' || col.column.toLowerCase() === 'modedatamodifydatetime') {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_2__InputCellType__["a" /* default */])(__assign({}, col, { typeName: FieldTypeName.Text }));
        return new Type();
    }
    else if (col.column.toLowerCase() === 'modedatacreater' || col.column.toLowerCase() === 'modedatamodifier') {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_0__BrowserCellType__["a" /* default */])(__assign({}, col, { type: '1', typeName: FieldTypeName.Browser, dbtype: 'int' }), false);
        return new Type();
    }
    else if (isEditable) {
        return getEditorType(col);
    }
    if (typeName === FieldTypeName.Browser) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_0__BrowserCellType__["a" /* default */])(col, false);
        return new Type();
    }
    else if (typeName === FieldTypeName.DateTime) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_4__DateTimeCellType__["a" /* default */])(col, false);
        return new Type();
    }
    else if (typeName === FieldTypeName.Select) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_3__SelectCellType__["a" /* default */])(col, false);
        return new Type(col.options || [], col.column);
    }
    else if (typeName === FieldTypeName.Text || typeName === FieldTypeName.Int || typeName === FieldTypeName.Float || typeName === FieldTypeName.Thousand || typeName === FieldTypeName.Money) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_2__InputCellType__["a" /* default */])(col);
        return new Type();
    }
    else if (typeName === FieldTypeName.Check) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["b" /* default */])(col, false);
        return new Type();
    }
    else if (typeName === FieldTypeName.Checkbox) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["b" /* default */])(col, false);
        var cellType = new Type(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["a" /* CheckBoxType */].MutilCheck);
        cellType.items(col.options || []);
        return cellType;
    }
    else if (typeName === FieldTypeName.Radio) {
        var Type = Object(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["b" /* default */])(col, false);
        var cellType = new Type(__WEBPACK_IMPORTED_MODULE_1__CheckBoxCellType__["a" /* CheckBoxType */].Raido);
        cellType.items(col.options || []);
        return cellType;
    }
    var Default = Object(__WEBPACK_IMPORTED_MODULE_2__InputCellType__["a" /* default */])(__assign({}, col, { typeName: FieldTypeName.Text }), false);
    return new Default();
});


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    getPrototype = __webpack_require__(195),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(626);


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(264);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(43);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(583),
    getValue = __webpack_require__(588);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(72),
    arrayMap = __webpack_require__(51),
    isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(95);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(188),
    baseAssignValue = __webpack_require__(189);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.1';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 64 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return convertKeyCode; });
/* harmony export (immutable) */ __webpack_exports__["f"] = judgeIsNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertAmountChinese;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return realLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertFloatValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertFormatValue; });
/* unused harmony export formatToDate */
/* unused harmony export formatDate */
/* unused harmony export dataToChinese */
/* unused harmony export convertNumToChinese */
/* unused harmony export formatToTime */
/* unused harmony export formatToPercent */
/* unused harmony export formatToScience */
/* unused harmony export formatToSpecial */
/* unused harmony export specialTrans */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return transHTML; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_trim__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_modeUtil__ = __webpack_require__(66);
var _this = this;



//根据event获取keycode(兼容火狐)
var convertKeyCode = function (e) {
    e = e.nativeEvent ? e.nativeEvent : e;
    e = e ? e : window.event;
    var keyCode = e.nativeEvent ? e.nativeEvent.keyCode : e.which;
    return keyCode;
};
function judgeIsNumber(val) {
    if (val === null || typeof val === "undefined")
        return false;
    var reg = /^(-?\d+)(\.\d+)?$/;
    return reg.test(val.toString());
}
function convertAmountChinese(num) {
    if (!judgeIsNumber(num))
        return "";
    var amount_convert_unit = "元";
    /* if(window.WfForm.getReqFormState() && window.WfForm.getReqFormState().getIn(["conf", "propFileCfg", "amount_convert_unit"]) === true)
        amount_convert_unit = "圆"; */
    if (typeof num === "string")
        num = parseFloat(num);
    var prefh = "";
    if (num < 0) {
        prefh = "负";
        num = Math.abs(num);
    }
    if (num > Math.pow(10, 12))
        return "";
    var cn = "零壹贰叁肆伍陆柒捌玖";
    var unit = new Array("拾佰仟", "分角");
    var unit1 = new Array("万亿万", "");
    var numArray = num.toString().split(".");
    var start = new Array(numArray[0].length - 1, 2);
    function toChinese(num, index) {
        var num = num.replace(/\d/g, function ($1) {
            return cn.charAt($1) + unit[index].charAt(start-- % 4 ? start % 4 : -1);
        });
        return num;
    }
    for (var i = 0; i < numArray.length; i++) {
        var tmp = "";
        for (var j = 0; j * 4 < numArray[i].length; j++) {
            var strIndex = numArray[i].length - (j + 1) * 4;
            var str = numArray[i].substring(strIndex, strIndex + 4);
            var start = i ? 2 : str.length - 1;
            var tmp1 = toChinese(str, i);
            tmp1 = tmp1.replace(/(零.)+/g, "零").replace(/零+$/, "");
            tmp = (tmp1 + unit1[i].charAt(j - 1)) + tmp;
        }
        numArray[i] = tmp;
    }
    numArray[1] = numArray[1] ? numArray[1] : "";
    numArray[0] = numArray[0] ? numArray[0] + amount_convert_unit : numArray[0];
    numArray[1] = numArray[1].replace(/^零+/, "");
    numArray[1] = numArray[1].match(/分/) ? numArray[1] : numArray[1] + "整";
    var money = numArray[0] + numArray[1];
    money = money.replace(/(亿万)+/g, "亿");
    if (money == "整") {
        money = "零" + amount_convert_unit + "整";
    }
    else {
        money = prefh + money;
    }
    return money;
}
var realLength = function (str) {
    var j = 0;
    for (var i = 0; i <= str.length - 1; i++) {
        j = j + 1;
        if ((str.charCodeAt(i)) > 127) {
            j = j + 2;
        }
    }
    return j;
};
var checkLength = function (str, strLen, elMaxLen) {
    if (strLen <= elMaxLen) {
        return str;
    }
    var j = 0;
    for (var i = 0; i <= str.length - 1; i++) {
        j = j + 1;
        if ((str.charCodeAt(i)) > 127) {
            j = j + 2;
        }
        if (j > elMaxLen) {
            return str.substring(0, i);
        }
        if (j == elMaxLen) {
            return str.substring(0, i + 1);
        }
    }
    return str;
};
var convertFloatValue = function (realval, decimals, transQfw, transAbs) {
    if (!judgeIsNumber(realval)) //非数值直接返回原始值
        return realval;
    realval = realval.toString();
    var formatval = "";
    if (decimals === 0) { //需取整
        formatval = Math.round(parseFloat(realval)).toString();
    }
    else {
        var pindex = realval.indexOf(".");
        var pointLength = pindex > -1 ? realval.substr(pindex + 1).length : 0; //当前小数位数
        if (pointLength > decimals) { //四舍五入
            var n = Math.pow(10, decimals);
            formatval = (Math.round(parseFloat(realval) * n) / n).toString();
        }
        else {
            formatval = realval;
        }
        pindex = formatval.indexOf(".");
        pointLength = pindex > -1 ? formatval.substr(pindex + 1).length : 0; //当前小数位数
        if (decimals > pointLength) { //需补零
            if (pindex == -1)
                formatval += ".";
            for (var i = 0; i < decimals - pointLength; i++) {
                formatval += "0";
            }
        }
    }
    var index = formatval.indexOf(".");
    var intPar = index > -1 ? formatval.substring(0, index) : formatval;
    var pointPar = index > -1 ? formatval.substring(index) : "";
    //当整数位是-0时需要补“-”,不然直接parseInt会丢失“-”
    if (intPar.indexOf("-") > -1 && parseInt(intPar) == 0) {
        intPar = "-" + parseInt(intPar).toString();
    }
    else {
        intPar = parseInt(intPar).toString(); // 整数位开头是0
    }
    //取绝对值
    if (transAbs === true) { //取绝对值
        intPar = Math.abs(intPar).toString();
    }
    if (transQfw === true) { //整数位format成千分位
        var reg1 = /(-?\d+)(\d{3})/;
        while (reg1.test(intPar)) {
            intPar = intPar.replace(reg1, "$1,$2");
        }
    }
    formatval = intPar + pointPar;
    return formatval;
};
var convertFormatValue = function (realval, formatJSON) {
    try {
        var formatval = "";
        var numberType = parseInt(formatJSON["numberType"]);
        if (numberType === 1) { //1常规
        }
        else if (numberType === 2) { //2数值
            var transQfw = parseInt(formatJSON["thousands"] || 0) === 1;
            var transAbs = formatJSON["formatPattern"] == "3" || formatJSON["formatPattern"] == "4";
            if (parseInt(formatJSON["decimals"]) < 0) {
                return realval;
            }
            formatval = convertFloatValue(realval, parseInt(formatJSON["decimals"]), transQfw, transAbs);
        }
        else if (numberType === 3) { //3日期
            //formatval = this.formatToDate(realval,formatJSON["formatPattern"]);
            formatval = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTools"].formatDate(realval, formatJSON["formatPattern"]);
        }
        else if (numberType === 4) { //4时间
            //formatval = this.formatToTime(realval,formatJSON["formatPattern"]);
            formatval = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTools"].formatTime(realval, formatJSON["formatPattern"]);
        }
        else if (numberType === 5) { //5百分比
            formatval = formatToPercent(realval, formatJSON["decimals"]);
        }
        else if (numberType === 6) { //6科学计数
            formatval = formatToScience(realval, formatJSON["decimals"]);
        }
        else if (numberType === 7) { //7文本
        }
        else if (numberType === 8) { //8特殊
            formatval = formatToSpecial(realval, formatJSON["formatPattern"]);
        }
        return formatval;
    }
    catch (e) {
        Object(__WEBPACK_IMPORTED_MODULE_2__util_modeUtil__["d" /* writeLog */])("format error:", e);
        return realval;
    }
};
var formatToDate = function (realVal, formatPattern) {
    var pattern = new RegExp("^\\d{2,4}-\\d{1,2}-\\d{1,2}$");
    if (!pattern.test(realVal)) {
        return realVal;
    }
    /**
     * formatPattern
     * 1：yyyy/MM/dd
     * 2：yyyy-MM-dd
     * 3：yyyy年MM月dd日
     * 4：yyyy年MM月
     * 5：MM月dd日
     * 6：EEEE
     * 7：日期大写
     * 8：yyyy/MM/dd hh:mm a
     * 9：yyyy/MM/dd HH:mm
     */
    var arr = realVal.split("-");
    var year = arr[0];
    var month = arr[1];
    var day = arr[2];
    if (parseInt(month) > 12 || parseInt(day) > 31 || parseInt(year) <= 0 || parseInt(month) <= 0 || parseInt(day) <= 0) {
        return realVal;
    }
    if (year.length == 2)
        year = "00" + year;
    if (year.length == 3)
        year = "0" + year;
    if (month.length == 1)
        month = "0" + month;
    if (day.length == 1)
        day = "0" + day;
    realVal = year + "-" + month + "-" + day;
    if (new Date(realVal).toString().indexOf("undefined") > -1) { //解决IE下类似不存在的日期2014-9-31通过new Date无法生成日期问题，chrome下默认取的下一天
        return realVal;
    }
    switch (parseInt(formatPattern)) {
        case 1:
            return _this.formatDate(new Date(realVal), "yyyy/MM/dd");
        case 2:
            return _this.formatDate(new Date(realVal), "yyyy-MM-dd");
        case 3:
            return _this.formatDate(new Date(realVal), "yyyy年MM月dd日");
        case 4:
            return _this.formatDate(new Date(realVal), "yyyy年MM月");
        case 5:
            return _this.formatDate(new Date(realVal), "MM月dd日");
        case 6:
            return _this.formatDate(new Date(realVal), "wwww");
        case 7:
            return _this.dataToChinese(new Date(realVal));
        case 8:
            return _this.formatDate(new Date(realVal), "yyyy/MM/dd 12:00 a");
        case 9:
            return _this.formatDate(new Date(realVal), "yyyy/MM/dd 00:00");
        default:
            return realVal;
    }
};
var formatDate = function (date, fmt) {
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
    var obj = {
        'y': date.getFullYear(),
        'M': date.getMonth() + 1,
        'd': date.getDate(),
        'q': Math.floor((date.getMonth() + 3) / 3),
        'w': date.getDay(),
        'H': 12,
        'h': 12,
        'm': 0,
        's': 0,
        'S': 0,
        'a': 'AM'
    };
    var week = ['天', '一', '二', '三', '四', '五', '六'];
    for (var i in obj) {
        fmt = fmt.replace(new RegExp(i + '+', 'g'), function (m) {
            var val = obj[i] + '';
            if (i == 'a')
                return val;
            if (i == 'w')
                return (m.length > 2 ? '星期' : '周') + week[val];
            for (var j = 0, len = val.length; j < m.length - len; j++)
                val = '0' + val;
            return m.length == 1 ? val : val.substring(val.length - m.length);
        });
    }
    return fmt;
};
var dataToChinese = function (date) {
    var arr = ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var tempYear = year.toString().split('').map(function (o) {
        return arr[parseInt(o)];
    }).toString();
    return (tempYear + "年" + convertNumToChinese(month) + "月" + convertNumToChinese(day) + "日").replace(/\,/g, '');
};
var convertNumToChinese = function (num) {
    var arr1 = ["", "", "二", "三"];
    var arr2 = ["", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    num = num < 10 ? "0" + num.toString() : num.toString();
    var first = parseInt(num.toString().split("")[0]);
    var second = parseInt(num.toString().split("")[1]);
    return arr1[first] + (first > 0 ? "十" : "") + arr2[second];
};
var formatToTime = function (realVal, formatPattern) {
    var pattern = new RegExp("^(\\d{1,2}:\\d{1,2})(:\\d{1,2})?$");
    if (!pattern.test(realVal)) {
        return realVal;
    }
    /**
     * formatPattern
     * 1：HH:MI:SS
     * 2：HH:MI:SS AM/PM
     * 3：HH:MI
     * 4：HH:MI AM/PM
     * 5：HH时MI分SS秒
     * 6：HH时MI分
     * 7：HH时MI分SS秒 AM/PM
     * 8：HH时MI分 AM/PM
     **/
    var realValArr = realVal.split(":");
    var hour = realValArr[0];
    var minute = realValArr[1];
    var separatorChar = ":";
    var suffix = parseInt(hour) < 12 ? " AM" : " PM";
    switch (parseInt(formatPattern)) {
        case 1:
            return hour + separatorChar + minute + separatorChar + "00";
        case 2:
            return hour + separatorChar + minute + separatorChar + "00" + suffix;
        case 3:
            return hour + separatorChar + minute;
        case 4:
            return hour + separatorChar + minute + suffix;
        case 5:
            return hour + "时" + minute + "分00秒";
        case 6:
            return hour + "时" + minute + "分";
        case 7:
            return hour + "时" + minute + "分00秒" + suffix;
        case 8:
            return hour + "时" + minute + "分" + suffix;
        default:
            return realVal;
    }
};
var formatToPercent = function (realVal, decimals) {
    var pattern = new RegExp("^(-?\\d+)(\\.\\d+)?$");
    if (!pattern.test(realVal)) {
        return realVal;
    }
    return convertFloatValue(Number(realVal) * 100, parseInt(decimals), false) + "%";
};
var formatToScience = function (realVal, decimals) {
    var pattern = new RegExp("^(-?\\d+)(\\.\\d+)?$");
    if (!pattern.test(realVal)) {
        return realVal;
    }
    var result = Number(realVal).toExponential(decimals).toUpperCase();
    result = result.replace(/E(\+|-)(\d){1}$/, "E$10$2"); //补零
    return result;
};
var formatToSpecial = function (realVal, formatPattern) {
    var pattern = new RegExp("^(-?\\d{1,12})(\\.\\d+)?$");
    if (!pattern.test(realVal)) {
        return realVal;
    }
    if (parseInt(formatPattern) === 1) {
        var digit = ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
        var unit = [["", "万", "亿"], ["", "十", "百", "千"]];
        return specialTrans(realVal, digit, unit);
    }
    else {
        var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
        var unit = [["", "万", "亿"], ["", "拾", "佰", "千"]];
        return specialTrans(realVal, digit, unit);
    }
};
var specialTrans = function (realVal, digit, unit) {
    realVal = parseFloat(realVal).toString();
    if (parseFloat(realVal) === 0) {
        return digit[0];
    }
    var headfix = "";
    var intPar_t = "";
    var pointPar_t = "";
    if (parseFloat(realVal) < 0) {
        realVal = realVal.substring(1);
        headfix = "-";
    }
    var realValArr = realVal.split(".");
    var intPar = __WEBPACK_IMPORTED_MODULE_0_lodash_trim___default()(realValArr[0]);
    while (intPar.length > 0 && parseInt(intPar[0]) === 0) {
        intPar = intPar.substr(1);
    }
    var pointPar = realValArr.length === 2 ? __WEBPACK_IMPORTED_MODULE_0_lodash_trim___default()(realValArr[1]) : "";
    var lastflag = false;
    var intParArr = intPar.length > 0 ? intPar.toString().split('') : [];
    var pointParArr = pointPar.length > 0 ? pointPar.toString().split('') : [];
    var j = 0;
    pointPar_t = pointPar.length > 0 ? "." : pointPar_t;
    pointParArr.map(function (v) {
        pointPar_t = pointPar_t + digit[parseInt(v)];
    });
    for (var i = intParArr.length - 1; i >= 0; i--, j++) {
        var v = parseInt(intParArr[i]);
        var m = j % 4;
        if (m === 0) {
            lastflag = false;
            intPar_t = unit[0][j / 4] + intPar_t;
        }
        if (v === 0) {
            if (lastflag && intPar_t[0] === digit[0]) {
                intPar_t = digit[v] + intPar_t;
            }
        }
        else {
            lastflag = true;
            intPar_t = digit[v] + unit[1][m] + intPar_t;
        }
    }
    intPar_t = __WEBPACK_IMPORTED_MODULE_0_lodash_trim___default()(intPar_t).length === 0 ? digit[0] : intPar_t;
    return headfix + intPar_t + pointPar_t;
};
var transHTML = function (str) {
    if (str === void 0) { str = ""; }
    str = str.toString();
    //需先转译
    str = str.replace(/&/ig, "&amp;");
    str = str.replace(/</ig, "&lt;");
    str = str.replace(/>/ig, "&gt;");
    //后转译
    str = str.replace(/\n/ig, "<br/>");
    str = str.replace(/\r/g, "<br/>");
    str = str.replace(/'/g, "&apos;");
    str = str.replace(/( {2,})/ig, function (val) { return " " + val.substring(1).replace(/ /ig, "&nbsp;"); });
    str = str.replace(/\"/ig, "&quot;");
    return str;
};


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export replaceUrl */
/* unused harmony export initJs */
/* unused harmony export check_form */
/* unused harmony export printMessage */
/* unused harmony export deepCopy */
/* unused harmony export contains */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return writeLog; });
/* unused harmony export getFieldValue */
/* unused harmony export getChangeData */
/* unused harmony export changeField */
/* unused harmony export changeFieldLink */
/* unused harmony export convertValue */
/* unused harmony export formatToPercent */
/* unused harmony export formatToScience */
/* unused harmony export formatToSpecial */
/* unused harmony export specialTrans */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return judgeValueIsNumber; });
/* unused harmony export judgeValueIsNumber0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return judgeValueIsInt; });
/* unused harmony export checkNumberFieldLenth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatFloatValue; });
/* unused harmony export changecolCons */
/* unused harmony export changerowCons */
/* unused harmony export FormatFloatValue */
/* unused harmony export changeformula */
/* unused harmony export getGroupid */
/* unused harmony export EXCEL_SUM */
/* unused harmony export EXCEL_AVERAGE */
/* unused harmony export EXCEL_ABS */
/* unused harmony export EXCEL_ROUND */
/* unused harmony export EXCEL_IF */
/* unused harmony export EXCEL_MAX */
/* unused harmony export EXCEL_MIN */
/* unused harmony export dataInput0 */
/* unused harmony export checkFieldAttr */
/* unused harmony export checkshowAttrObj */
/* unused harmony export checkShowAttr */
/* unused harmony export changeSelectItem */
/* unused harmony export checkField */
/* unused harmony export checkFieldBlur */
/* unused harmony export checkFieldFocus */
/* unused harmony export checkLength */
/* unused harmony export checkFloatLength */
/* unused harmony export realLengthInput */
/* unused harmony export checkLengthInput */
/* unused harmony export checkcount */
/* unused harmony export checkItemScale */
/* unused harmony export changeToNormalFormat */
/* unused harmony export changeToThousands2 */
/* unused harmony export commafy */
/* unused harmony export checkFloat */
/* unused harmony export addZero */
/* unused harmony export realLength */
/* unused harmony export realLengthOnly */
/* unused harmony export numberChangeToChinese */
/* unused harmony export chineseChangeToNumber */
/* unused harmony export openUnFullWindow */
/* unused harmony export spellResourceCondition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var replaceUrl = function (url) {
    if (!url)
        return url;
    url = url.replace('/spa/formmode#/formmode/card', '/spa/cube/index.html#/main/cube/card')
        .replace('/spa/formmode/index.html#/formmode/card', '/spa/cube/index.html#/main/cube/card')
        .replace('/spa/formmode/index.html#/formmode/replyPage', '/spa/cube/index.html#/main/cube/reply')
        .replace('/formmode/view/formModeComTab.jsp', '/spa/cube/index.html#/main/cube/reply')
        .replace('/formmode/view/FormModeMap.jsp', '/spa/cube/index.html#/main/cube/map');
    return Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])(url);
};
/**
 * 布局init之后对布局js部分渲染
 */
var initJs = function (loading, rightmenu, mainFields, modeField, type) {
    if (loading != "loading") {
        //加载之前先要清除掉之前的布局的js
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#initJs").remove();
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()("[id^=layoutScript]").remove();
        var script = document.createElement('script');
        script.type = "text/javascript";
        script.id = "initJs";
        var initJs_1 = "";
        //加载按钮js
        var urlMap = rightmenu ? rightmenu.url : {};
        if (urlMap) {
            for (var item in urlMap) {
                var hreftarget = urlMap[item].hreftarget;
                hreftarget = hreftarget.replace("/formmode/search/CustomSearchBySimple.jsp?customid=", "/spa/cube/index.html#/main/cube/search?customid=");
                hreftarget = hreftarget.replace("/formmode/view/AddFormMode.jsp", "/spa/cube/index.html#/main/cube/card");
                hreftarget = hreftarget.replace("/formmode/view/formModeComTab.jsp", "/spa/formmode/index.html#/formmode/replyPage");
                hreftarget = hreftarget.replace('/formmode/view/FormModeMap.jsp', '/spa/cube/index.html#/main/cube/map');
                //hreftarget = hreftarget.replace("/formmode/view/formModeComTab.jsp", "/#/replyPage");
                initJs_1 += ("let url_id_" + item + " = \"" + Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])(hreftarget) + "\";");
            }
        }
        //加载必填js  已废弃
        if (mainFields) {
            var needCheckStr = "";
            for (var item in mainFields) {
                var ismandatory = mainFields[item].ismandatory;
                if (ismandatory == "1") {
                    needCheckStr += (",field" + item);
                }
            }
            initJs_1 += ("let needcheck=\"" + needCheckStr + "\";");
        }
        initJs_1 += "let page;let util;";
        script.innerHTML = initJs_1;
        document.body.appendChild(script);
        /*page = objthis;
        //使用了modeForm公共方法内容  暂时去掉等待后面重新确认方式后再加回来
        let type = objthis.props.type;
        let showReply = objthis.props.showReply;
        if (showReply && type == "0") {//如果是显示布局 并且开启了回复评论 给页面主体表单以及底部评论列表绑定点击隐藏评论区域事件
            jQuery("#modeForm").bind('mousedown', window.modeForm.changeReplyAttr);
            jQuery("#replyList").bind('mousedown', window.modeForm.changeReplyAttr);
            jQuery(".wea-new-top-content").each(
                function () {
                    jQuery(this).scroll(function () {
                        window.modeForm.changeReplyAttr();
                    });
                }
            )

        }*/
        //加载css
        if (modeField && modeField.LayoutStyle) {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()("body").append(modeField.LayoutStyle);
        }
        var styles = modeField ? modeField.cssArr : [];
        for (var i = 0; i < styles.length; i++) {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()("body").append(styles[i]);
        }
        //加载布局js
        var scripts = modeField ? modeField.scripts : "";
        if (scripts) {
            script = document.createElement('script');
            script.id = "layoutScript0";
            script.innerHTML = scripts;
            document.body.appendChild(script);
        }
        var jsArr = modeField ? modeField.jsArr : null;
        if (jsArr) {
            for (var j = 0; j < jsArr.length; j++) {
                var jsSrc = jsArr[j];
                var srcJs = document.createElement('script');
                srcJs.type = "text/javascript";
                srcJs.id = "layoutScript" + j;
                srcJs.src = jsSrc;
                document.head.appendChild(srcJs);
            }
        }
        if (type == "0") {
        }
    }
};
/**
 * 表单必填内容校验
 */
var check_form = function (needcheck, mainFields, mainData, detailData) {
    try {
        var nc = needcheck.split(",");
        for (var i = 0; i < nc.length; i++) {
            var id = nc[i];
            if (id != "") {
                var fieldid = void 0;
                if (id.indexOf("_") > 0) {
                    var ids = id.split("_");
                    fieldid = ids[0].substring(5);
                }
                else {
                    fieldid = id.substring(5);
                }
                var field = mainFields[fieldid];
                var fieldname = field.fieldlabel;
                if (field.detailtable && id.indexOf("_") < 0) {
                    var tablename = field.detailtable;
                    var size = detailData.data[tablename].data.length;
                    for (var j = 0; j < size; j++) {
                        //if (!jQuery("#" + id + "_" + j).val()) {
                        if (!detailData.data[tablename].data[j][fieldid].value) {
                            printMessage("warning", fieldname + " 未填写", "必填内容未填写");
                            //alert(fieldname + "未填写");
                            return false;
                        }
                    }
                }
                else {
                    //if (!jQuery("#" + id).val()) {
                    if (!mainData.data[fieldid].value) {
                        printMessage("warning", fieldname + " 未填写", "必填内容未填写");
                        //alert(fieldname + "未填写");
                        return false;
                    }
                }
            }
        }
    }
    catch (e) {
        writeLog("", e);
        return false;
    }
    return true;
};
/**
 * 提示信息
 */
var printMessage = function (type, message, title) {
    if (type == "warning") {
        __WEBPACK_IMPORTED_MODULE_0_antd__["Modal"].warning({
            title: title,
            content: message,
            okText: "确认",
        });
    }
};
var deepCopy = function (obj) {
    var newO = {};
    if (obj instanceof Array) {
        newO = [];
    }
    for (var key in obj) {
        var val = obj[key];
        newO[key] = typeof val === 'object' ? arguments.callee(val) : val;
    }
    return newO;
};
/**
 * contains方法 判断数组中是否包含某一元素
 */
var contains = function (arr, obj) {
    if (!arr)
        return false;
    var i = arr.length;
    while (i--) {
        if (arr[i] === obj) {
            return true;
        }
    }
    return false;
};
var writeLog = function (msg, e) {
    if (console && console.log) {
        console.log(msg, e);
    }
};
/**
 * 获取字段值方法
 */
var getFieldValue = function (fieldid, drowIndex) {
    var card = __WEBPACK_IMPORTED_MODULE_2____["default"].cubeStore.Card;
    var mainFields = card.mainFields;
    var fieldObj = mainFields[fieldid];
    var detailtable = fieldObj.detailtable;
    if (!!fieldObj) {
        try {
            if (detailtable) {
                var detailData = card.detailData;
                return detailData.data[detailtable].data[drowIndex][fieldid].value;
            }
            else {
                var mainData = card.mainData;
                return mainData.data[fieldid].value;
            }
        }
        catch (e) {
            writeLog("输入内容有误！", e);
        }
    }
    else {
        writeLog("输入内容有误！", "");
    }
    return "";
};
//--------------------------------------------------------------------------联动相关js start
var getChangeData = function (fieldObj, value, symbol, drowIndex, mainData, detailData) {
    var flag = false;
    var fieldid = fieldObj.fieldid;
    var htmltype = fieldObj ? fieldObj.htmltype : "";
    var detailtype = fieldObj ? fieldObj.type : "";
    if (htmltype == "2" && detailtype == 2) { //没有id的组件也无法集成表单联动的字段  从统一封装到mainDara 的 otherData中
        var otherData = mainData.otherData ? mainData.otherData : {};
        if (symbol == "emaintable" || symbol.indexOf("mc_") == 0 || symbol.indexOf("tab_") == 0) {
            var _value = mainData.data[fieldid].value;
            if (_value !== value.replace(/^\s+|\s+$/gm, '')) {
                otherData["field" + fieldid] = value;
                flag = true;
            }
        }
        else {
            var _value = detailData.data[symbol].data[drowIndex][fieldid].value;
            if (_value !== value.replace(/^\s+|\s+$/gm, '')) {
                otherData["field" + fieldid + "_" + drowIndex] = value;
                flag = true;
            }
        }
        mainData.otherData = otherData;
    }
    try {
        var specialobj = fieldObj.specialobj;
        if (symbol == "emaintable" || symbol.indexOf("mc_") == 0 || symbol.indexOf("tab_") == 0) { //处理字段的值 value未改变直接return 不执行后续方法
            var _value = mainData.data[fieldid].value;
            if (htmltype == "2" && detailtype == 2) {
                if (_value.replace(/^\s+|\s+$/gm, '') !== value.replace(/^\s+|\s+$/gm, '')) {
                    flag = true;
                }
            }
            else {
                if (_value !== value) {
                    flag = true;
                }
            }
            mainData.data[fieldid].value = value; //修改Redux字段值 已经改为在actions changeFieldData中处理 这里执行设置value只是提供给后续的联动方法使用最新的value
            if (specialobj)
                mainData.data[fieldid].specialobj = specialobj;
        }
        else {
            var _value = detailData.data[symbol].data[drowIndex][fieldid].value;
            if (htmltype == "2" && detailtype == 2) {
                if (_value.replace(/^\s+|\s+$/gm, '') !== value.replace(/^\s+|\s+$/gm, '')) {
                    flag = true;
                }
            }
            else {
                if (_value !== value) {
                    flag = true;
                }
            }
            detailData.data[symbol].data[drowIndex][fieldid].value = value; //修改Redux字段值 已经改为在actions changeFieldData中处理 这里执行设置value只是提供给后续的联动方法使用最新的value
            if (specialobj)
                detailData.data[symbol].data[drowIndex][fieldid].specialobj = specialobj;
        }
    }
    catch (e) {
        alert(e);
    }
    return flag;
};
var changeField = function (changeData, _mainData, _detailData, _mainFields, page) {
    var mainData = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, _mainData);
    var detailData = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, _detailData);
    var mainFields = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, _mainFields);
    var triggrtData = {}; //需要触发联动的字段集合
    var returnData = {
        data: {}, mainFields: changeData._mainFields ? changeData._mainFields : {}
    };
    for (var item in changeData.data) { //先循环value
        var obj = changeData.data[item];
        if (getChangeData(obj.fieldObj, obj.value, obj.symbol, obj.drowIndex, mainData, detailData)) {
            triggrtData[item] = obj;
            returnData.data[item] = obj;
        }
    }
    page.actions.changeFieldData(returnData);
    for (var item in triggrtData) { //再触发联动
        var obj = triggrtData[item];
        changeFieldLink(obj.fieldObj, obj.value, obj.symbol, obj.drowIndex, mainData, detailData, mainFields, page);
    }
};
/**
 * 所有联动方法 changeFiele中涉及到的所有字段赋值 都使用此方法执行并触发目标字段的所有联动方法
 * 已废弃  迁移到formaction fieldDataChange方法
 */
var changeFieldLink = function (fieldObj, value, symbol, drowIndex, _mainData, _detailData, _mainFields, page) {
    var mainData = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, _mainData);
    var detailData = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, _detailData);
    var mainFields = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, _mainFields);
    var modeField = page.modeField;
    var orderlyjson = page.orderlyjson;
    var detailTable = page.detailTable;
    var fieldid = fieldObj.fieldid;
    // const htmltype = fieldObj ? fieldObj.htmltype : "";
    // const detailtype = fieldObj ? fieldObj.type : "";
    var changeData = { data: {}, _mainFields: {}, _detailData: { data: {} } };
    //每种计算类型单独try catch 防止一种出错所有都无法执行
    try {
        var colcalstr = modeField.colcalstr;
        var colCons = colcalstr[fieldid];
        if (colCons) { //列字段规则
            changecolCons(symbol, mainData, colCons, detailData, fieldid, mainFields, changeData);
        }
    }
    catch (e) {
        writeLog("", e);
    }
    try {
        var rowcalstr = modeField.rowcalstr;
        var rowCons = rowcalstr[fieldid];
        if (rowCons) { //行字段规则
            changerowCons(symbol, mainData, rowCons, detailData, mainFields, modeField, drowIndex, changeData);
        }
    }
    catch (e) {
        writeLog("", e);
    }
    try {
        var formula = orderlyjson.formula;
        var forCons = formula[fieldid];
        if (forCons) { //excel中的公式
            changeformula(symbol, drowIndex, forCons, mainData, detailData, mainFields, orderlyjson.etables, fieldObj, page, changeData);
        }
    }
    catch (e) {
        writeLog("", e);
    }
    try {
        var inputentry = modeField.inputentry; //字段联动
        var inputCons = inputentry[fieldid];
        if (inputCons) { //字段联动
            //dataInput(value, symbol, drowIndex, inputCons, mainData, detailData, mainFields, orderlyjson.etables, fieldObj, detailTable, page);
            /*mainData = returnObj.mainData;
            detailData = returnObj.detailData;
            mainFields = returnObj.mainFields;*/
        }
    }
    catch (e) {
        writeLog("", e);
    }
    try {
        var fieldattr = modeField.fieldattr; //字段属性
        var fieldCons = fieldattr[fieldid];
        if (fieldCons) { //字段属性
            var returnObj = checkFieldAttr(value, symbol, drowIndex, fieldCons, mainData, detailData, mainFields, orderlyjson.etables, fieldObj, detailTable, page);
            mainData = returnObj.mainData;
            detailData = returnObj.detailData;
            mainFields = returnObj.mainFields;
        }
    }
    catch (e) {
        writeLog("", e);
    }
    if (fieldObj.htmltype == "5") { //如果是选择框字段
        //首先解析属性联动
        try {
            var linkage = modeField.linkage;
            var linkCons = linkage[fieldid];
            if (linkCons) { //字段属性
                var returnObj = checkShowAttr(value, symbol, drowIndex, linkCons, mainData, detailData, mainFields, fieldObj); //属性联动
                mainData = returnObj.mainData;
                detailData = returnObj.detailData;
                mainFields = returnObj.mainFields;
            }
        }
        catch (e) {
            writeLog("", e);
        }
        //解析子项联动
        try {
            var returnObj = changeSelectItem(fieldObj, symbol, value, drowIndex, mainData, detailData, mainFields, page);
            mainData = returnObj.mainData;
            detailData = returnObj.detailData;
            mainFields = returnObj.mainFields;
        }
        catch (e) {
            writeLog("", e);
        }
    }
    //触发bindPropertyChange
    try {
        var fieldName_1 = symbol == "emaintable" ? "field" + fieldid : "field" + fieldid + "_" + drowIndex;
        if (fieldName_1 in __WEBPACK_IMPORTED_MODULE_2____["default"].__propertyChangeFnArray) {
            __WEBPACK_IMPORTED_MODULE_2____["default"].__propertyChangeFnArray[fieldName_1].map(function (fn) {
                try {
                    fn(__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#" + fieldName_1)[0]);
                }
                catch (e) {
                    writeLog("", e);
                }
            });
        }
    }
    catch (e) {
        writeLog("", e);
    }
    return { mainData: mainData, detailData: detailData, mainFields: mainFields };
};
/**
 * 单元格格式解析
 */
var convertValue = function (realval, formatJSON) {
    try {
        var formatval = "";
        var numberType = parseInt(formatJSON["numberType"]);
        if (numberType === 1) { //1常规
            return realval;
        }
        else if (numberType === 2) { //2数值
            var transQfw = parseInt(formatJSON["thousands"] || 0) === 1;
            var transAbs = formatJSON["formatPattern"] == "3" || formatJSON["formatPattern"] == "4";
            if (parseInt(formatJSON["decimals"]) < 0) {
                return realval;
            }
            formatval = formatFloatValue(realval, parseInt(formatJSON["decimals"]), transQfw, transAbs);
        }
        else if (numberType === 3) { //3日期
            //formatval = this.formatToDate(realval,formatJSON["formatPattern"]);
            formatval = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTools"].formatDate(realval, formatJSON["formatPattern"]);
        }
        else if (numberType === 4) { //4时间
            //formatval = this.formatToTime(realval,formatJSON["formatPattern"]);
            formatval = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTools"].formatTime(realval, formatJSON["formatPattern"]);
        }
        else if (numberType === 5) { //5百分比
            formatval = formatToPercent(realval, formatJSON["decimals"]);
        }
        else if (numberType === 6) { //6科学计数
            formatval = formatToScience(realval, formatJSON["decimals"]);
        }
        else if (numberType === 7) { //7文本
        }
        else if (numberType === 8) { //8特殊
            formatval = formatToSpecial(realval, formatJSON["formatPattern"]);
        }
        return formatval;
    }
    catch (e) {
        writeLog("format error:", e);
        return realval;
    }
};
/**
 * 单元格格式-转百分比
 */
var formatToPercent = function (realVal, decimals) {
    var pattern = new RegExp("^(-?\\d+)(\\.\\d+)?$");
    if (!pattern.test(realVal)) {
        return realVal;
    }
    return formatFloatValue(Number(realVal) * 100, parseInt(decimals), false) + "%";
};
/**
 * 单元格格式-转科学计数
 */
var formatToScience = function (realVal, decimals) {
    var pattern = new RegExp("^(-?\\d+)(\\.\\d+)?$");
    if (!pattern.test(realVal)) {
        return realVal;
    }
    var result = Number(realVal).toExponential(decimals).toUpperCase();
    result = result.replace(/E(\+|-)(\d){1}$/, "E$10$2"); //补零
    return result;
};
/**
 * 单元格格式-特殊字符
 */
var formatToSpecial = function (realVal, formatPattern) {
    var pattern = new RegExp("^(-?\\d{1,12})(\\.\\d+)?$");
    if (!pattern.test(realVal)) {
        return realVal;
    }
    if (parseInt(formatPattern) === 1) {
        var digit = ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
        var unit = [["", "万", "亿"], ["", "十", "百", "千"]];
        return specialTrans(realVal, digit, unit);
    }
    else {
        var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
        var unit = [["", "万", "亿"], ["", "拾", "佰", "千"]];
        return specialTrans(realVal, digit, unit);
    }
};
var specialTrans = function (realVal, digit, unit) {
    realVal = parseFloat(realVal).toString();
    if (parseFloat(realVal) === 0) {
        return digit[0];
    }
    var headfix = "";
    var intPar_t = "";
    var pointPar_t = "";
    if (parseFloat(realVal) < 0) {
        realVal = realVal.substring(1);
        headfix = "-";
    }
    var realValArr = realVal.split(".");
    var intPar = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.trim(realValArr[0]);
    while (intPar.length > 0 && parseInt(intPar[0]) === 0) {
        intPar = intPar.substr(1);
    }
    var pointPar = realValArr.length === 2 ? __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.trim(realValArr[1]) : "";
    var lastflag = false;
    var intParArr = intPar.length > 0 ? intPar.toString().split('') : [];
    var pointParArr = pointPar.length > 0 ? pointPar.toString().split('') : [];
    var j = 0;
    pointPar_t = pointPar.length > 0 ? "." : pointPar_t;
    pointParArr.map(function (v) {
        pointPar_t = pointPar_t + digit[parseInt(v)];
    });
    for (var i = intParArr.length - 1; i >= 0; i--, j++) {
        var v = parseInt(intParArr[i]);
        var m = j % 4;
        if (m === 0) {
            lastflag = false;
            intPar_t = unit[0][j / 4] + intPar_t;
        }
        if (v === 0) {
            if (lastflag && intPar_t[0] === digit[0]) {
                intPar_t = digit[v] + intPar_t;
            }
        }
        else {
            lastflag = true;
            intPar_t = digit[v] + unit[1][m] + intPar_t;
        }
    }
    intPar_t = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.trim(intPar_t).length === 0 ? digit[0] : intPar_t;
    return headfix + intPar_t + pointPar_t;
};
var judgeValueIsNumber = function (val) {
    if (val === null || typeof val === "undefined")
        return false;
    var reg = /^(-?\d+)(\.\d+)?$/;
    return reg.test(val.toString());
};
var judgeValueIsNumber0 = function (val) {
    if (val === '' || val === null || typeof val === "undefined")
        return true;
    var reg = /^[0-9]+([.]{1}[0-9]+){0,1}$/; ///^(-?\d+)(\.)?(\d+)?$/;
    return reg.test(val.toString());
};
var judgeValueIsInt = function (val) {
    if (val === '' || val === null || typeof val === "undefined")
        return true;
    return /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/.test(val) && val.indexOf('.') < 0;
};
var checkNumberFieldLenth = function (_val, length, qfws) {
    var _a = _val.split('.'), first = _a[0], last = _a[1];
    if (first.length > length) {
        return false;
    }
    if (qfws && last && last.length > parseInt(qfws, 0)) {
        return false;
    }
    return true;
};
/**
 * 数值转换(精度、千分位)等
 * @param {String} realval   真实值
 * @param {int} decimals  精度
 * @param {Boolean} transQfw  是否千分位
 * @param {Boolean} transAbs  是否绝对值
 */
var formatFloatValue = function (realval, decimals, transQfw, transAbs) {
    if (!judgeValueIsNumber(realval)) //非数值直接返回原始值
        return realval;
    realval = realval.toString();
    var formatval;
    if (decimals === 0) { //需取整
        formatval = Math.round(parseFloat(realval)).toString();
    }
    else {
        //let n = Math.pow(10, decimals);
        formatval = realval; //(Math.round(parseFloat(realval) * n) / n).toString();
        var pindex = formatval.indexOf(".");
        var pointLength = pindex > -1 ? formatval.substr(pindex + 1).length : 0; //当前小数位数
        if (decimals > pointLength) { //需补零
            if (pindex == -1)
                formatval += ".";
            for (var i = 0; i < decimals - pointLength; i++) {
                formatval += "0";
            }
        }
    }
    var index = formatval.indexOf(".");
    var intPar = index > -1 ? formatval.substring(0, index) : formatval;
    var pointPar = index > -1 ? formatval.substring(index) : "";
    intPar = parseFloat(intPar);
    //取绝对值
    if (transAbs === true) { //取绝对值
        intPar = Math.abs(intPar).toString();
    }
    if (transQfw === true) { //整数位format成千分位
        var reg1 = /(-?\d+)(\d{3})/;
        while (reg1.test(intPar)) {
            intPar = intPar.replace(reg1, "$1,$2");
        }
    }
    formatval = intPar + pointPar;
    if (realval < 0) {
        if (!(formatval < 0)) {
            formatval = -formatval;
        }
    }
    return formatval;
};
/**
 * 计算列字段规则
 */
var changecolCons = function (symbol, mainData, colCons, detailData, fieldid, mainFields, changeData) {
    if (mainData) { }
    var maincalstr = colCons.maincalstr;
    if (!maincalstr)
        return;
    var mf = maincalstr.split("=")[0].replace("mainfield_", "");
    var detailValue = detailData.data[symbol].data;
    var mainFieldObj = mainFields[mf];
    var fieldSumValue = 0;
    var detailtype = mainFieldObj ? mainFieldObj.type : "";
    for (var i = 0; i < detailValue.length; i++) {
        var fieldValue = detailValue[i][fieldid].value;
        if (fieldValue && !isNaN(fieldValue))
            fieldSumValue += parseFloat(fieldValue);
    }
    var decimals = 2;
    if (mainFieldObj && (detailtype == "1" || detailtype == "2"))
        decimals = 0;
    else if (mainFieldObj && (detailtype == "3" || detailtype == "5"))
        decimals = parseInt(mainFieldObj.qfws, 0);
    var thousands = detailtype == "5" ? 1 : 0;
    changeData.data[mf] = { fieldObj: mainFields[mf], value: FormatFloatValue(fieldSumValue, decimals, thousands), symbol: "emaintable" };
    //return changeField(mainFields[mf], FormatFloatValue(fieldSumValue, decimals, thousands), "emaintable", null, mainData, detailData, mainFields, page);
    //mainData.data[mf].value = FormatFloatValue(fieldSumValue, decimals, thousands);
    //return mainData;
};
/**
 * 计算行字段规则
 */
var changerowCons = function (symbol, mainData, rowCons, detailData, mainFields, modeField, drowIndex, changeData) {
    //let colcalstr = modeField.colcalstr;
    if (modeField) { }
    for (var item in rowCons) {
        var cons = rowCons[item];
        var pat = new RegExp("detailfield_\\d+");
        var result = void 0;
        do {
            result = pat.exec(cons);
            var fvalue = void 0;
            if (result) {
                var fid = result[0].replace("detailfield_", "");
                var fidValue = detailData.data[symbol].data[drowIndex][fid].value;
                fvalue = (!fidValue || isNaN(fidValue)) ? "0" : parseFloat(fidValue);
                cons = cons.replace(result, fvalue);
            }
        } while (result != null);
        var changeValue = eval(cons);
        changeData.data[item + "_" + drowIndex] = { fieldObj: mainFields[item], value: changeValue, symbol: symbol, drowIndex: drowIndex };
    }
    return { mainData: mainData, detailData: detailData, mainFields: mainFields };
};
/**
 * 行列规则补0方法
 */
var FormatFloatValue = function (realval, decimals, thousands) {
    var regnum = /^(-?\d+)(\.\d+)?$/;
    if (!regnum.test(realval)) {
        return realval;
    }
    realval = realval.toString();
    var formatval;
    if (decimals === 0) { //需取整
        formatval = Math.round(parseFloat(realval));
    }
    else {
        var n = Math.pow(10, decimals);
        formatval = Math.round(parseFloat(realval) * n) / n;
        var pindex = realval.indexOf(".");
        var pointLength = pindex > -1 ? realval.substr(pindex + 1).length : 0; //当前小数位数
        if (decimals > pointLength) { //需补零
            if (pindex == -1)
                formatval += ".";
            for (var i = 0; i < decimals - pointLength; i++) {
                formatval += "0";
            }
        }
    }
    formatval = formatval.toString();
    var index = formatval.indexOf(".");
    var intPar = index > -1 ? formatval.substring(0, index) : formatval;
    var pointPar = index > -1 ? formatval.substring(index) : "";
    if (thousands === 1) { //整数位format成千分位
        var reg1 = /(-?\d+)(\d{3})/;
        while (reg1.test(intPar)) {
            intPar = intPar.replace(reg1, "$1,$2");
        }
    }
    formatval = intPar + pointPar;
    return formatval;
};
//---------------------------------------------------------------解析公式excel布局中的公式start
/**
 * excel布局公式计算
 * 新增dealType参数 表示当前操作状态 1字段变更 2页面刷新 3新增明细 4删除明细
 * 新增curTableName参数  作用在新增、删除明细行的时候 标识新增的行的表名 字段公式存在明细表赋值给主表的计算关系 执行逻辑如下
 * 删除行时候 只有赋值字段是主表字段 取值字段是这个明细的公式才执行
 * 添加行时候 赋值字段、取值字段只要有包含了这一明细的字段的都会执行
 */
var changeformula = function (symbol, drowIndex, forCons, mainData, detailData, mainFields, etables, TriggerFieldObj, changeData, dealType, curTableName, _) {
    if (symbol) { }
    for (var item in forCons) {
        var formula = forCons[item];
        var destcell = formula.destcell;
        var fieldid = convertCellAttrToFieldid(etables, destcell);
        var formulaTxt = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.trim(formula.formulatxt).substring(1);
        //let analysistxt = jQuery.trim(formula.analysistxt).substring(1);
        var cellrange = formula.cellrange;
        var conFlag = false;
        if (dealType == "3") { //添加明细
            conFlag = destcell.indexOf(curTableName.toUpperCase()) > -1 || formulaTxt.indexOf(curTableName.toUpperCase()) > -1;
            //赋值字段或者计算公式里 任意一个包含了这个明细的字段
        }
        else if (dealType == "4") { //删除明细
            conFlag = destcell.indexOf("MAIN") > -1 && formulaTxt.indexOf(curTableName.toUpperCase()) > -1;
            //赋值字段是主表 计算公式包含了这个明细的字段
        }
        if (conFlag)
            continue;
        try {
            var result = void 0;
            var flag = true;
            if (destcell.indexOf("DETAIL_") === -1) { //赋值给主表字段
                if ((/DETAIL_\d+\./).test(formulaTxt)) { //取值字段包含明细表字段
                    var reg = /^(EXCEL_AVERAGE|EXCEL_MIN|EXCEL_MAX)\((\s*(MAIN|TAB_\d+|DETAIL_\d+)\.[A-Z]+\d+\s*(\,)?)+\)$/;
                    if (reg.test(formulaTxt)) { //求平均、最大、最小特殊处理(例：AVG(明细字段或主字段))
                        result = calculate_detail_special(mainData, detailData, formulaTxt, cellrange, etables, mainFields);
                    }
                    else {
                        result = calculate_detail_sum(mainData, detailData, formulaTxt, cellrange, etables, mainFields);
                    }
                }
                else { //取值字段全部为主表字段
                    result = calculate_single(mainData, detailData, formulaTxt, cellrange, etables, mainFields, "-1");
                }
            }
            else { //赋值给明细表字段
                var detailtable = TriggerFieldObj.detailtable;
                if (formulaTxt.match(/(MAIN|TAB_\d+)\./g) && !detailtable) { //取值字段包含主表字段 并且触发字段为主字段 需计算对应明细所有行记录
                    var returnObj = calculate_detailAllRow(fieldid, mainData, detailData, formulaTxt, cellrange, etables, mainFields, changeData);
                    mainData = returnObj ? returnObj.mainData : mainData;
                    detailData = returnObj ? returnObj.detailData : detailData;
                    mainFields = returnObj ? returnObj.mainFields : mainFields;
                    flag = false;
                }
                else { //触发字段为明细字段 暂时只考虑当前表单的联动
                    var fieldObj = mainFields[fieldid];
                    var tablename = fieldObj.detailtable;
                    if (tablename == detailtable) {
                        result = calculate_single(mainData, detailData, formulaTxt, cellrange, etables, mainFields, drowIndex + "");
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_antd__["message"].warning("公式计算出错，请联系管理员");
                        flag = false;
                    }
                }
            }
            if (flag) {
                var fieldObj = mainFields[fieldid];
                var tablename = fieldObj.detailtable;
                //let returnObj;
                if (tablename) {
                    changeData.data[fieldid + "_" + drowIndex] = { fieldObj: mainFields[fieldid], value: result, symbol: tablename, drowIndex: drowIndex };
                }
                else {
                    changeData.data[fieldid] = { fieldObj: mainFields[fieldid], value: result, symbol: "emaintable" };
                }
            }
        }
        catch (e) {
            __WEBPACK_IMPORTED_MODULE_0_antd__["message"].warning("公式计算错误:" + e);
            writeLog("formula calculate error:", e);
        }
    }
    return { mainData: mainData, detailData: detailData, mainFields: mainFields };
};
/**
 * 单条/单行公式计算
 */
var calculate_single = function (mainData, detailData, formulaTxt, cellrange, etables, mainFields, drowIndex) {
    var _formulaTxt = replaceFormula(mainData, detailData, cellrange, formulaTxt, drowIndex, etables, mainFields, true);
    return eval(_formulaTxt);
};
/**
 * 明细列求平均/最大赋值主字段，特殊公式处理
 */
var calculate_detail_special = function (mainData, detailData, formulaTxt, cellrange, etables, mainFields) {
    var _formulaTxt = replaceFormula(mainData, detailData, cellrange, formulaTxt, "all", etables, mainFields, true);
    return eval(_formulaTxt);
};
/**
 * 明细所有行公式计算--赋值字段为明细字段，触发字段为主表字段；明细表每条记录都需经过公式计算再赋值
 * 还需要在公式计算时对默认添加明细行的默认值进行赋值为只有主表字段联动的结果 提供给添加明细时赋默认值
 */
var calculate_detailAllRow = function (destFieldid, mainData, detailData, formulaTxt, cellrange, etables, mainFields, changeData) {
    var tablename = mainFields[destFieldid].detailtable;
    var rowIndex = detailData.data[tablename].data.length;
    for (var i = 0; i < rowIndex; i++) {
        try {
            var formulaTxt_clone = formulaTxt;
            formulaTxt_clone = replaceFormula(mainData, detailData, cellrange, formulaTxt, i + "", etables, mainFields, true);
            var calculateResult = eval(formulaTxt_clone);
            //detailData.data[tablename].data[i][destFieldid].value = calculateResult;
            changeData.data[destFieldid + "_" + i] = { fieldObj: mainFields[destFieldid], value: calculateResult, symbol: tablename, drowIndex: i };
            var dData = changeData._detailData.data[tablename] ? changeData._detailData.data[tablename] : {};
            var defaultValue = dData.defaultValue ? dData.defaultValue : {};
            defaultValue[destFieldid] = calculateResult;
            dData.defaultValue = defaultValue;
            changeData._detailData.data[tablename] = dData;
        }
        catch (e) { }
    }
    return { mainData: mainData, detailData: detailData, mainFields: mainFields };
};
/**
 * 明细作为取值字段的公式，计算明细每一行公式结果，再合计赋值主字段(修复之前主字段明细字段合计错误问题、多个明细同时合计错误问题)
 */
var calculate_detail_sum = function (mainData, detailData, formulaTxt, cellrange, etables, mainFields) {
    var sumResult = 0;
    var reg = /(DETAIL_\d+)/g;
    var allRowIndex = 0;
    formulaTxt.match(reg).map(function (detail) {
        var detailMark = detail.toLowerCase();
        var curRowIndex = detailData.data[detailMark].data.length;
        if (curRowIndex > allRowIndex) {
            allRowIndex = curRowIndex;
        }
    });
    //此处的处理逻辑有bug  原有布局公式计算方式 cellrange中含有多个明细表的字段操作时 默认只用第一个明细表的rowindex做明细index数量
    //沿用部分原有计算逻辑，当含有多个明细时候 取明细行数量最多的子表的rowindex做循环  不存在的子表字段按照空值处理
    for (var i = 0; i < allRowIndex; i++) {
        try {
            var _formulaTxt = replaceFormula(mainData, detailData, cellrange, formulaTxt, i + "", etables, mainFields, i == 0);
            var singleRowResult = eval(_formulaTxt);
            if (!isNaN(parseFloat(singleRowResult))) { //非法数值结果
                sumResult = rewrite_add(sumResult, singleRowResult);
            }
        }
        catch (ev) {
            __WEBPACK_IMPORTED_MODULE_0_antd__["message"].warning("公式计算错误:" + ev);
            writeLog("公式计算错误:", ev);
        }
    }
    return sumResult;
};
/**
 * 替换公式，单元格标示替换成对应字段值
 */
var replaceFormula = function (mainData, detailData, cellrange, formulatxt, rowid, etables, mainFields, flag) {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.each(cellrange, function (_, cellattr) {
        var cellValue = "";
        var fieldid = convertCellAttrToFieldid(etables, cellattr);
        if (rowid === "all" && cellattr.indexOf("DETAIL_") > -1) { //需替换明细所有行字段
            //let groupid = getGroupid(cellattr);
            var fieldObj = mainFields[fieldid];
            var tablename = fieldObj.detailtable;
            for (var i = 0; i < detailData.data[tablename].data.length; i++) {
                var _cellValue = detailData.data[tablename].data[i][fieldid].value;
                _cellValue = _cellValue ? _cellValue : "\"emptyval\"";
                if (i != 0)
                    _cellValue = "," + _cellValue;
                cellValue += _cellValue;
            }
        }
        else {
            var fieldObj = mainFields[fieldid];
            var tablename = fieldObj.detailtable;
            if (tablename) {
                try {
                    cellValue = detailData.data[tablename].data[rowid][fieldid].value;
                    cellValue = cellValue ? cellValue : "\"emptyval\"";
                }
                catch (e) {
                    cellValue = "\"emptyval\"";
                }
            }
            else {
                //cellValue = rowid=="0"?(mainData[fieldid].value?mainData[fieldid].value:"emptyval"):"emptyval";
                if (flag) {
                    cellValue = mainData.data[fieldid].value;
                    cellValue = cellValue ? cellValue : "\"emptyval\"";
                }
                else {
                    cellValue = "\"emptyval\"";
                }
            }
        }
        if (cellValue == "")
            cellValue = "\"" + cellValue + "\"";
        var curindex = -1;
        while (formulatxt.indexOf(cellattr) > curindex) {
            curindex = formulatxt.indexOf(cellattr);
            var str1 = formulatxt.substring(0, curindex);
            var str2 = formulatxt.substring(curindex + cellattr.length);
            var reg = /^[0-9]$/;
            var nextchar = str2.substr(0, 1);
            if (reg.test(nextchar))
                continue;
            formulatxt = str1 + cellValue + str2;
        }
    });
    return formulatxt;
};
/**
 * 公式标示转换成单元格标示(例：DETAIL_1.C4------>detail_1_4_3)
 */
var convertCellAttrToFieldid = function (etables, cellAttr) {
    var fa = cellAttr.split("\.");
    var symbol = fa[0] == "MAIN" ? "emaintable" : fa[0].toLowerCase();
    var tObj = etables[symbol];
    var letter = fa[1];
    var rowid = parseInt(letter.match(/\d+$/)[0]) - 1;
    var colid = convertCharToInt(letter.match(/^[a-zA-Z]+/)[0]) - 1;
    var id = rowid + "," + colid;
    var fieldObj = tObj[id];
    return fieldObj.field;
};
/**
 * 字母转数字
 */
var convertCharToInt = function (value) {
    var rtn = 0;
    var powIndex = 0;
    for (var i = value.length - 1; i >= 0; i--) {
        var tmpInt = value[i].charCodeAt() - 64;
        rtn += Math.pow(26, powIndex) * tmpInt;
        powIndex++;
    }
    return rtn;
};
/**
 * 获取属于哪个明细表groupid
 */
var getGroupid = function (cellattr) {
    var idx = cellattr.indexOf("DETAIL_");
    if (cellattr.indexOf("DETAIL_") == -1)
        return -1;
    var groupid = cellattr.substring(idx + 7, cellattr.indexOf("."));
    return parseInt(groupid) - 1;
};
/**
 * JS parseFloat求和精度不一致问题解决
 */
function rewrite_add(arg1, arg2) {
    var r1 = 0, r2 = 0;
    try {
        r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) { }
    try {
        r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) { }
    var m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
}
/**
 * 求和
 */
function EXCEL_SUM() {
    var result = 0;
    for (var i = 0; i < arguments.length; i++) {
        var par = arguments[i];
        if (!isNaN(parseFloat(par))) {
            result = rewrite_add(result, par);
        }
    }
    return result;
}
/**
 * 求平均数
 */
function EXCEL_AVERAGE() {
    var count = 0;
    var sumVal = 0;
    for (var i = 0; i < arguments.length; i++) {
        var par = arguments[i];
        if (!isNaN(parseFloat(par))) {
            //sumVal += parseFloat(par);
            sumVal = rewrite_add(sumVal, par);
            count++;
        }
    }
    if (count > 0) {
        return sumVal / count;
    }
    else {
        throw new Error("EXCEL_AVERAGE divisor is zero");
    }
}
/**
 * 求绝对值
 */
function EXCEL_ABS() {
    if (arguments.length == 1) {
        var par = arguments[0];
        if (!isNaN(parseFloat(par))) {
            var result = Math.abs(parseFloat(par));
            return result;
        }
        else {
            throw new Error("EXCEL_ABS arguments value is not a number");
        }
    }
    else {
        throw new Error("EXCEL_ABS arguments number must equal one");
    }
}
/**
 * 精度计算
 */
function EXCEL_ROUND() {
    if (arguments.length == 2) {
        var result = 0;
        var par1 = arguments[0];
        var par2 = arguments[1];
        if (!isNaN(parseFloat(par1))) {
            par1 = parseFloat(par1);
        }
        else {
            throw new Error("EXCEL_ROUND first argument value is not a number");
        }
        if (par2) {
            par2 = parseInt(par2);
        }
        else {
            throw new Error("EXCEL_ROUND second argument value is not a int");
        }
        result = par1.toFixed(par2);
        return result;
    }
    else {
        throw new Error("EXCEL_ROUND arguments number must equal two");
    }
}
/**
 * 条件判断
 */
function EXCEL_IF() {
    if (arguments.length == 3) {
        if (eval(arguments[0])) {
            return arguments[1];
        }
        else {
            return arguments[2];
        }
    }
    else {
        throw new Error("EXCEL_IF arguments number must equal three");
    }
}
/**
 * 求最大值
 */
function EXCEL_MAX() {
    var result;
    for (var i = 0; i < arguments.length; i++) {
        var par = arguments[i];
        if (!isNaN(parseFloat(par))) {
            if (result == null) {
                result = parseFloat(par);
            }
            else {
                if (parseFloat(par) > result)
                    result = parseFloat(par);
            }
        }
    }
    if (result != null) {
        return result;
    }
    else {
        throw new Error("EXCEL_MAX arguments value must contain a number");
    }
}
/**
 * 求最小值
 */
function EXCEL_MIN() {
    var result;
    for (var i = 0; i < arguments.length; i++) {
        var par = arguments[i];
        if (!isNaN(parseFloat(par))) {
            if (result == null) {
                result = parseFloat(par);
            }
            else {
                if (parseFloat(par) < result)
                    result = parseFloat(par);
            }
        }
    }
    if (result != null) {
        return result;
    }
    else {
        throw new Error("EXCEL_MIN arguments value must contain a number");
    }
}
//---------------------------------------------------------------解析公式excel布局中的公式end
/**
 * 解析字段联动
 */
var dataInput0 = function (value, symbol, drowIndex, inputCons, mainData, detailData, mainFields, etables, fieldObj, detailTable, page) {
    if (etables || fieldObj) { }
    var dataInputArr = {};
    for (var i = 0; i < inputCons.length; i++) {
        var dataInputObj = inputCons[i];
        var id = dataInputObj.id;
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({
            url: Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])("/api/formmode/card/dataInput"),
            data: { formId: page.formId, value: value, id: id, data: symbol == "emaintable" ? JSON.stringify(mainData.data) : JSON.stringify(detailData.data[symbol].data[drowIndex]) },
            dataType: 'json',
            type: 'POST',
            async: false,
            success: function (res) {
                var data = res.data;
                for (var item in data) {
                    var dataObj = data[item];
                    if (item == "emaintable") { //主表字段联动结果是主表的
                        for (var field in dataObj) {
                            var valueObj = dataObj[field];
                            var fieldValue = valueObj.value;
                            var _fieldObj = mainFields[field];
                            if (valueObj.specialobj) {
                                _fieldObj.specialobj = valueObj.specialobj;
                            }
                            dataInputArr[field] = { fieldObj: _fieldObj, value: fieldValue, symbol: "emaintable" };
                            /*returnObj = changeField(_fieldObj, fieldValue, "emaintable", null, mainData, detailData, mainFields, page);
                            mainData = returnObj.mainData;
                            detailData = returnObj.detailData;
                            mainFields = returnObj.mainFields;*/
                            //mainData.data[field].value = value;//主表字段赋值
                        }
                    }
                    else if (item == "detailData") { //明细表自身联动
                        for (var field in dataObj) {
                            var valueObj = dataObj[field];
                            var fieldValue = valueObj.value;
                            var _fieldObj = mainFields[field];
                            if (valueObj.specialobj) {
                                _fieldObj.specialobj = valueObj.specialobj;
                            }
                            dataInputArr[field + "_" + drowIndex] = { fieldObj: _fieldObj, value: fieldValue, symbol: symbol, drowIndex: drowIndex };
                            /*returnObj = changeField(_fieldObj, fieldValue, symbol, drowIndex, mainData, detailData, mainFields, page);
                            mainData = returnObj.mainData;
                            detailData = returnObj.detailData;
                            mainFields = returnObj.mainFields;*/
                        }
                    }
                    else { //主表字段联动结果是明细的
                        var rowCount = detailData.data[item].data.length;
                        var i_1 = 0;
                        for (; i_1 < dataObj.length; i_1++) {
                            var rowObj = dataObj[i_1];
                            var addObj = JSON.parse(detailTable[item].addObj);
                            var key = (rowCount + i_1) + "";
                            addObj.index = key;
                            detailData.data[item].data.push(addObj); //子表方式修改，先加行 再赋值，触发联动事件
                            for (var field in rowObj) {
                                var valueObj = rowObj[field];
                                var fieldValue = valueObj.value;
                                var _fieldObj = mainFields[field];
                                if (valueObj.specialobj) {
                                    _fieldObj.specialobj = valueObj.specialobj;
                                }
                                //addObj[field].value = value;
                                //dataInputArr[field + "_" + (rowCount + i)] = { fieldObj: _fieldObj, value: fieldValue, symbol: item, drowIndex }//主表联动明细 直接触发
                                var returnObj = changeField(_fieldObj, fieldValue, item, rowCount + i_1, mainData);
                                mainData = returnObj.mainData;
                                detailData = returnObj.detailData;
                                mainFields = returnObj.mainFields;
                            }
                        }
                        detailData.data[item].size = (parseInt(rowCount) + i_1);
                        var drs = detailData.detailRowSize;
                        detailData.detailRowSize = (parseInt(drs) + 1);
                    }
                }
            }
        });
    }
    for (var item in dataInputArr) {
        var obj = dataInputArr[item];
        var fieldObj_1 = obj.fieldObj;
        var value_1 = obj.value;
        var symbol_1 = obj.symbol;
        var drowIndex_1 = obj.drowIndex;
        var returnObj = changeField(fieldObj_1, value_1, symbol_1, drowIndex_1, mainData);
        mainData = returnObj.mainData;
        detailData = returnObj.detailData;
        mainFields = returnObj.mainFields;
    }
    return { mainData: mainData, detailData: detailData, mainFields: mainFields };
};
//export const dataInput = (value, symbol, drowIndex, inputCons, mainData, detailData, mainFields, etables, fieldObj, detailTable, page) => {
/*  for (let i = 0; i < inputCons.length; i++) {
     let changeData = { data: {}, _mainFields: {}, _detailData: { data: {} } };
     let dataInputObj = inputCons[i];
     let id = dataInputObj.id;
 } */
//return { mainData, detailData, mainFields }
//}
/**
 * 解析字段属性
 */
var checkFieldAttr = function (value, symbol, drowIndex, fieldCons, mainData, detailData, mainFields, etables, fieldObj, detailTable, page, changeData) {
    var _loop_1 = function (item) {
        var obj = fieldCons[item];
        var field = mainFields[item];
        var valueObj = void 0;
        var fieldType = 0;
        var detailtable = field.detailtable;
        if (detailtable) { //联动字段为明细表
            var data = symbol == "emaintable" ? detailData.data[field.detailtable] : detailData.data[field.detailtable].data[drowIndex];
            fieldType = symbol == "emaintable" ? 2 : 1;
            valueObj = __assign({}, mainData.data, data);
        }
        else {
            valueObj = mainData.data;
        }
        if (valueObj || fieldType || value || etables || fieldObj || detailTable || page) { }
        // let id = obj.id;
        var caltype = obj.caltype;
        // let htmltype = field ? field.htmltype : "";
        // let detailtype = field ? field.type : "";
        if (caltype == "2") { //字段赋值目前只支持主表字段（原有规则）
            var attrcontent_1 = obj.attrcontent;
            var index = attrcontent_1.indexOf("doFieldMath(\"");
            if (index > -1) {
                attrcontent_1 = attrcontent_1.substring(index + 13);
                index = attrcontent_1.lastIndexOf("\")");
                if (index > -1) {
                    attrcontent_1 = attrcontent_1.substring(0, index);
                }
                var reg = /\$\d+\$/g;
                attrcontent_1.match(reg).map(function (detail) {
                    var fid = detail.replace(/\$/g, "");
                    var value = mainData.data[fid].value;
                    if (isNaN(parseFloat(value))) {
                        value = "0";
                    }
                    attrcontent_1 = attrcontent_1.replace(detail, value);
                });
                var fieldValue = void 0;
                try {
                    fieldValue = eval(attrcontent_1);
                }
                catch (e) { }
                changeData.data[item] = { fieldObj: field, value: fieldValue, symbol: "emaintable" };
                /*let returnObj = changeField(field, fieldValue, "emaintable", null, mainData, detailData, mainFields, page);
                mainData = returnObj.mainData;
                detailData = returnObj.detailData;
                mainFields = returnObj.mainFields;*/
            }
        }
        else if (caltype == "5") { //地图元素不在联动中解析 使用ModeMap组件实现
        }
        else {
            //采用同步调用ajax防止多次dispatch造成参数之间相互影响
            /*jQuery.ajax({
                url: "/api/formmode/card/fieldAttr",
                data: { id, fieldType, fields: JSON.stringify(mainFields), data: JSON.stringify(valueObj), field: JSON.stringify(field) },
                dataType: 'json',
                type: 'POST',
                async: false,
                success: function (res) {*/
            /*API.fieldAttr({ id, fieldType, fields: JSON.stringify(mainFields), data: JSON.stringify(valueObj), field: JSON.stringify(field) }).then(({ data, api_errormsg, api_status }) => {
                if (api_status) {
                    let name;
                    let key;
                    if (fieldType != "2") {
                        if (data.length > 0) {
                            name = data[0].name;
                            key = data[0].key;
                        }
                    }
                    if (htmltype == "3") {//浏览框字段单独处理
                        if (detailtable && symbol == "emaintable") {
                            let size = data.length;

                            let specialobj = {
                                showname: "",
                                replaceDatas: new Array()
                            }

                            for (let j = 0; j < size; j++) {
                                name = data[j].name;
                                key = data[j].key;

                                let keys = key.split(",");
                                let names = name.replace(/&nbsp;/g, ",").split(",");
                                let replaceDatas = new Array();
                                let showname = "";
                                for (let i = 0; i < keys.length; i++) {
                                    showname += "," + names[i];
                                    replaceDatas.push({ id: keys[i], name: names[i] })
                                }
                                if (showname)
                                    showname = showname.substring(1);
                                specialobj.showname = showname;
                                specialobj.replaceDatas = replaceDatas;
                                field.specialobj = specialobj;
                            }
                            let returnObj = changeField(field, keys, detailtable, j, mainData, detailData, mainFields, page);
                            mainData = returnObj.mainData;
                            detailData = returnObj.detailData;
                            mainFields = returnObj.mainFields;
                        } else {
                            if (name) {
                                let keys = key.split(",");
                                let names = name.replace(/&nbsp;/g, ",").split(",");
                                let replaceDatas = new Array();
                                let showname = "";
                                for (let i = 0; i < keys.length; i++) {
                                    showname += "," + names[i];
                                    replaceDatas.push({ id: keys[i], name: names[i] })
                                }
                                if (showname)
                                    showname = showname.substring(1);
                                let specialobj = {
                                    showname: showname,
                                    replaceDatas: replaceDatas
                                }
                                field.specialobj = specialobj;
                                if (detailtable) {//当赋值字段是明细表字段时候 需要先判断是从主表字段的联动还是从明细字段的联动（实际设置中 只有sql字段支持这种配置 日期计算明细表关联主表字段）
                                    if (symbol != "emaintable") {//联动字段是明细时 只修改当前行的字段值
                                        let returnObj = changeField(field, keys, detailtable, drowIndex, mainData, detailData, mainFields, page);
                                        mainData = returnObj.mainData;
                                        detailData = returnObj.detailData;
                                        mainFields = returnObj.mainFields;
                                    }
                                } else {
                                    let returnObj = changeField(field, keys, "emaintable", null, mainData, detailData, mainFields, page);
                                    mainData = returnObj.mainData;
                                    detailData = returnObj.detailData;
                                    mainFields = returnObj.mainFields;
                                }
                            }
                        }
                    } else {//选择框字段跟其他字段一起处理 区别是选择框需要传key 而文本字段传name
                        if (detailtable) {//当赋值字段是明细表字段时候 需要先判断是从主表字段的联动还是从明细字段的联动
                            if (symbol == "emaintable") {//联动字段是主表时 修改所有明细对应字段
                                let size = data.length;
                                for (let j = 0; j < size; j++) {
                                    name = data[j].name;
                                    key = data[j].key;
                                    let returnObj = changeField(field, htmltype == "5" ? key : name, detailtable, j, mainData, detailData, mainFields, page);
                                    mainData = returnObj.mainData;
                                    detailData = returnObj.detailData;
                                    mainFields = returnObj.mainFields;
                                }
                            } else {//联动字段是明细时 只修改当前行的字段值
                                let returnObj = changeField(field, htmltype == "5" ? key : name, detailtable, drowIndex, mainData, detailData, mainFields, page);
                                mainData = returnObj.mainData;
                                detailData = returnObj.detailData;
                                mainFields = returnObj.mainFields;
                            }
                        } else {
                            let returnObj = changeField(field, htmltype == "5" ? key : name, "emaintable", null, mainData, detailData, mainFields, page);
                            mainData = returnObj.mainData;
                            detailData = returnObj.detailData;
                            mainFields = returnObj.mainFields;
                        }
                    }
                    page.actions.changeField({ mainData, detailData, mainFields });
                    //page.forceUpdate();//强制重新渲染
                }
            });*/
        }
    };
    for (var item in fieldCons) {
        _loop_1(item);
    }
    return { mainData: mainData, detailData: detailData, mainFields: mainFields };
};
var checkshowAttrObj = function (showAttrObj) {
    return showAttrObj;
};
/**
 * 属性联动方法 属性联动中设置的参数 attrEdit，attrHide，attrView，attrMandatory 优先级高于 mainFields中默认的显示参数 isedit等
 */
var checkShowAttr = function (value, symbol, drowIndex, linkCons, mainData, detailData, mainFields, fieldObj, changeData, _) {
    if (symbol || mainData || detailData) {
    }
    if (fieldObj.detailtable) {
        for (var index = 0; index < linkCons.length; index++) {
            var valueLinkage = linkCons[index];
            var selectfieldvalue = valueLinkage.selectfieldvalue;
            var tablename = fieldObj.detailtable;
            var viewattr = "";
            var changefieldids = valueLinkage.changefieldids;
            if (value == selectfieldvalue) { //对应到当前选中值得项目才加载属性联动样式 其余字段全部还原为空
                viewattr = valueLinkage ? valueLinkage.viewattr : "";
            }
            var cfa = changefieldids.split(",");
            var dData = changeData._detailData.data[tablename] ? changeData._detailData.data[tablename] : {};
            var dataArr = dData.data ? dData.data : {};
            var datas = dataArr[drowIndex] ? dataArr[drowIndex] : {};
            for (var i = 0; i < cfa.length; i++) {
                var cfid = cfa[i];
                var showAttrObj = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, datas[cfid] ? datas[cfid] : { needBreak: false });
                if (showAttrObj.needBreak) {
                    continue;
                }
                showAttrObj.attrEdit = (viewattr == "") ? mainFields[cfid].isedit : ((viewattr == "3" || viewattr == "4") ? "0" : "1");
                showAttrObj.attrHide = (viewattr == "") ? mainFields[cfid].ishide : (viewattr == "4" ? "1" : "0");
                showAttrObj.attrView = (viewattr == "") ? mainFields[cfid].isview : (viewattr == "4" ? "0" : "1");
                //let mandatory = mainFields[cfid].attrMandatory;
                // let _mandatory = (viewattr == "") ? mainFields[cfid].ismandatory : (viewattr == "2" ? "1" : "0");
                showAttrObj.attrMandatory = (viewattr == "") ? mainFields[cfid].ismandatory : (viewattr == "2" ? "1" : "0");
                showAttrObj.needBreak = value == selectfieldvalue;
                datas[cfid] = showAttrObj;
            }
            dataArr[drowIndex] = datas;
            dData.data = dataArr;
            changeData._detailData.data[tablename] = dData;
        }
    }
    else {
        for (var index = 0; index < linkCons.length; index++) {
            var valueLinkage = linkCons[index];
            var selectfieldvalue = valueLinkage.selectfieldvalue;
            var viewattr = "";
            var changefieldids = valueLinkage.changefieldids;
            if (value == selectfieldvalue) { //对应到当前选中值得项目才加载属性联动样式 其余字段全部还原为空
                viewattr = valueLinkage ? valueLinkage.viewattr : "";
            }
            var cfa = changefieldids.split(",");
            if (cfa.length > 0) {
                for (var i = cfa.length - 1; i >= 0; i--) {
                    var cfid = cfa[i];
                    var showAttrObj = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(true, {}, changeData._mainFields[cfid] ? changeData._mainFields[cfid] : {});
                    if (showAttrObj.needBreak) {
                        continue;
                    }
                    showAttrObj.attrEdit = (viewattr == "") ? mainFields[cfid].isedit : ((viewattr == "3" || viewattr == "4") ? "0" : "1");
                    showAttrObj.attrHide = (viewattr == "") ? mainFields[cfid].ishide : (viewattr == "4" ? "1" : "0");
                    showAttrObj.attrView = (viewattr == "") ? mainFields[cfid].isview : (viewattr == "4" ? "0" : "1");
                    // let mandatory = mainFields[cfid].attrMandatory;
                    // let _mandatory = (viewattr == "") ? mainFields[cfid].ismandatory : (viewattr == "2" ? "1" : "0");
                    showAttrObj.attrMandatory = (viewattr == "") ? mainFields[cfid].ismandatory : (viewattr == "2" ? "1" : "0");
                    showAttrObj.needBreak = value == selectfieldvalue;
                    changeData._mainFields[cfid] = showAttrObj;
                }
            }
        }
    }
};
/**
 * 选择框子项联动
 */
var changeSelectItem = function (fieldObj, symbol, value, drowIndex, mainData, detailData, mainFields, changeData) {
    var selectAttr = fieldObj ? fieldObj.selectAttr : {};
    var childfieldid = selectAttr.childfieldid ? selectAttr.childfieldid : 0;
    if (childfieldid != 0) {
        if (symbol == "emaintable") {
            var showAttrObj = changeData._mainFields[childfieldid] ? changeData._mainFields[childfieldid] : {};
            showAttrObj.pValue = value;
            changeData._mainFields[childfieldid] = showAttrObj;
            var cvalue = mainData.data[childfieldid].value;
            /*if (!contains(mainFields[childfieldid + ""].valueObj[value], cvalue)) {//如果子项当前值 不在联动出来的结果集中 则清空子项当前选中内容
                changeData.data[childfieldid] = { fieldObj: mainFields[childfieldid + ""], value: "", symbol: "emaintable" }
                /*let returnObj = changeField(mainFields[childfieldid + ""], "", "emaintable", null, mainData, detailData, mainFields, page);
                mainData = returnObj ? returnObj.mainData : mainData;
                detailData = returnObj ? returnObj.detailData : detailData;
                mainFields = returnObj ? returnObj.mainFields : mainFields;*/
            //mainData.data[childfieldid].value = "";
            //}
            var sValue = "";
            if (contains(mainFields[childfieldid + ""].valueObj[value], cvalue)) {
                sValue = cvalue;
            }
            else {
                var selectList = (mainFields[childfieldid + ""].selectAttr ? mainFields[childfieldid + ""].selectAttr : { selectList: [] }).selectList;
                for (var i = 0; i < selectList.length; i++) {
                    var selectvalue = selectList[i].selectvalue;
                    var isdefault = selectList[i].isdefault;
                    if (contains(mainFields[childfieldid + ""].valueObj[value], selectvalue + "") && isdefault === 1) {
                        sValue = selectvalue + "";
                        break;
                    }
                }
            }
            changeData.data[childfieldid] = { fieldObj: mainFields[childfieldid + ""], value: sValue, symbol: "emaintable" };
        }
        else {
            var dData = changeData._detailData.data[symbol] ? changeData._detailData.data[symbol] : {};
            var dataArr = dData.data ? dData.data : {};
            var datas = dataArr[drowIndex] ? dataArr[drowIndex] : {};
            var showAttrObj = datas[childfieldid] ? datas[childfieldid] : {};
            showAttrObj.pValue = value;
            datas[childfieldid] = showAttrObj;
            dataArr[drowIndex] = datas;
            dData.data = dataArr;
            changeData._detailData.data[symbol] = dData;
            //detailData.data[symbol].data[drowIndex][childfieldid].pValue = value;
            var cvalue = detailData.data[symbol].data[drowIndex][childfieldid].value;
            var sValue = "";
            if (contains(mainFields[childfieldid + ""].valueObj[value], cvalue)) {
                sValue = cvalue;
            }
            else {
                var selectList = (mainFields[childfieldid + ""].selectAttr ? mainFields[childfieldid + ""].selectAttr : { selectList: [] }).selectList;
                for (var i = 0; i < selectList.length; i++) {
                    var selectvalue = selectList[i].selectvalue;
                    var isdefault = selectList[i].isdefault;
                    if (contains(mainFields[childfieldid + ""].valueObj[value], selectvalue + "") && isdefault === 1) {
                        sValue = selectvalue + "";
                        break;
                    }
                }
            }
            changeData.data[childfieldid + "_" + drowIndex] = { fieldObj: mainFields[childfieldid + ""], value: sValue, symbol: symbol, drowIndex: drowIndex };
            /*if (!contains(mainFields[childfieldid + ""].valueObj[value], cvalue)) {
                changeData.data[childfieldid + "_" + drowIndex] = { fieldObj: mainFields[childfieldid + ""], value: "", symbol, drowIndex }
                /*let returnObj = changeField(mainFields[childfieldid + ""], "", symbol, drowIndex, mainData, detailData, mainFields, page);
                mainData = returnObj ? returnObj.mainData : mainData;
                detailData = returnObj ? returnObj.detailData : detailData;
                mainFields = returnObj ? returnObj.mainFields : mainFields;*/
            //detailData.data[symbol].data[drowIndex][childfieldid].value = "";
            //}
        }
    }
};
//--------------------------------------------------------------------------联动相关js end
/***************************字段校验相关js******************************* */
/**
 * 字段校验方法总入口 change校验
 */
var checkField = function (value, fieldObj) {
    var fieldlabel = fieldObj ? fieldObj.fieldlabel : "";
    var detailtype = fieldObj ? fieldObj.type : "";
    var fielddbtype = fieldObj ? fieldObj.fielddbtype : "";
    if (detailtype == "1") { //文本类型字段
        if (fielddbtype.indexOf("varchar") > -1) {
            var fieldlength_tmp = parseInt(fielddbtype.substring(fielddbtype.indexOf("(") + 1, fielddbtype.length - 1));
            value = checkLength(value, fieldlength_tmp, fieldlabel);
        }
    }
    else if (detailtype == "2") { //整数类型字段
        value = checkcount(value);
        value = checkItemScale(value, "整数长度不能超过9位，请重新输入", -999999999, 999999999);
    }
    else if (detailtype == "3") {
        value = checkFloatLength(value);
    }
    return value;
};
/**
 * 字段校验方法总入口 blur校验
 */
var checkFieldBlur = function (value, fieldObj) {
    var detailtype = fieldObj ? fieldObj.type : "";
    var qfws = fieldObj ? fieldObj.qfws : "2";
    var data = { value: value };
    if (detailtype == "3") {
        value = checkFloat(value, parseInt(qfws));
        data.value = value;
        data.reload = true;
    }
    else if (detailtype == "5") {
        value = changeToThousands2(value, qfws, detailtype);
        data.value = value;
        data.reload = true;
    }
    return data;
};
/**
 * 字段校验方法总入口 focus校验
 */
var checkFieldFocus = function (value, fieldObj) {
    var detailtype = fieldObj ? fieldObj.type : "";
    var data = { value: value };
    if (detailtype == "5") {
        value = changeToNormalFormat(value);
        data.value = value;
        data.reload = true;
    }
    return data;
};
/**
 * 字段长度校验
 */
var checkLength = function (value, len, fieldlabel) {
    if (len != 0 && realLength(value) > len) {
        printMessage("warning", fieldlabel + "文本长度不能超过" + len + ",(1个中文字符等于3个长度)");
        while (realLength(value) > len) {
            value = value.substring(0, value.length - 1);
        }
    }
    return value;
};
var checkFloatLength = function (value) {
    return value;
};
var realLengthInput = function (str) {
    var j = 0;
    for (var i = 0; i <= str.length - 1; i++) {
        j = j + 1;
        if ((str.charCodeAt(i)) > 127) {
            j = j + 2;
        }
    }
    return j;
};
var checkLengthInput = function (str, strLen, elMaxLen) {
    if (strLen <= elMaxLen) {
        return str;
    }
    var j = 0;
    for (var i = 0; i <= str.length - 1; i++) {
        j = j + 1;
        if ((str.charCodeAt(i)) > 127) {
            j = j + 2;
        }
        if (j > elMaxLen) {
            return str.substring(0, i);
        }
        if (j == elMaxLen) {
            return str.substring(0, i + 1);
        }
    }
    return str;
};
/**
 * 数字校验
 */
var checkcount = function (value) {
    var valuechar = value.split("");
    var isnumber = false;
    for (var i = 0; i < valuechar.length; i++) {
        var charnumber = parseInt(valuechar[i]);
        if (isNaN(charnumber) && (valuechar[i] != "-" || (valuechar[i] == "-" && i != 0))) {
            isnumber = true;
        }
        if (valuechar.length == 1 && valuechar[i] == "-") {
            isnumber = true;
        }
    }
    return isnumber ? "" : value;
};
/**
 * 数字范围校验
 */
var checkItemScale = function (value, msg, minValue, maxValue) {
    var val = value;
    if (val != "") {
        try {
            //调用parseInt转换类型必须指定第二个参数值，来设置保存数字的进制的值。否则有可能使用8进制 16进制来转换数据。
            val = parseInt(val, 10);
            if (val < minValue || val > maxValue) {
                printMessage("warning", msg);
                return "";
            }
            else {
                return value;
            }
        }
        catch (e) {
            return "";
        }
    }
    return value;
};
/**
 * 金额前分位置获取焦点时候去掉,
 */
var changeToNormalFormat = function (value) {
    return value.replace(/,/g, "");
};
/**
 * 千分位转换
 */
var changeToThousands2 = function (sourcevalue, dlength, detailtype) {
    var tovalue;
    if (0 < dlength && detailtype != "4" && detailtype != "5") {
        sourcevalue = addZero(sourcevalue, dlength);
        tovalue = sourcevalue;
    }
    else if (detailtype == "4" || detailtype == "5") {
        sourcevalue = addZero(sourcevalue, dlength);
        sourcevalue = sourcevalue.replace(/\s+/g, "");
        var sourcevalue01 = sourcevalue;
        if (sourcevalue01 != '') {
            tovalue = commafy(sourcevalue01);
        }
        else {
            tovalue = sourcevalue;
        }
    }
    else {
        tovalue = sourcevalue;
    }
    return tovalue;
};
/**
 * 数字格式转换成千分位
 */
var commafy = function (num) {
    num = num + "";
    num = num.replace(/[ ]/g, ""); //去除空格
    if (num == "") {
        return;
    }
    if (isNaN(num)) {
        return;
    }
    //2.针对是否有小数点，分情况处理
    var index = num.indexOf(".");
    if (index == -1) { //无小数点
        var reg = /(-?\d+)(\d{3})/;
        while (reg.test(num)) {
            num = num.replace(reg, "$1,$2");
        }
    }
    else {
        var intPart = num.substring(0, index);
        var pointPart = num.substring(index + 1, num.length);
        var reg = /(-?\d+)(\d{3})/;
        while (reg.test(intPart)) {
            intPart = intPart.replace(reg, "$1,$2");
        }
        num = intPart + "." + pointPart;
    }
    return num;
};
/**
 * 浮点数校验
 */
var checkFloat = function (value, qfws) {
    //let reg = /^-?([1-9]\d*.\d*|0.\d*[1-9]\d*|0?.0+|0)$/;
    var reg = /^(-?\d+)(\.\d+)?$/;
    if (value != "") {
        if (!reg.test(value)) {
            return "";
        }
        else {
            return addZero(value, qfws);
        }
    }
    return value;
};
/**
 * 补充0方法
 */
var addZero = function (aNumber, precision) {
    if (!precision) {
        return aNumber;
    }
    if (aNumber == null || aNumber.toString().trim() == "" || isNaN(aNumber))
        return "";
    var valInt = (aNumber.toString().split(".")[1] + "").length;
    if (valInt != precision) {
        var lengInt = precision - valInt;
        //判断添加小数位0的个数
        if (lengInt == 1) {
            aNumber += "0";
        }
        else if (lengInt == 2) {
            aNumber += "00";
        }
        else if (lengInt == 3) {
            aNumber += "000";
        }
        else if (lengInt < 0) {
            if (precision == 1) {
                aNumber += ".0";
            }
            else if (precision == 2) {
                aNumber += ".00";
            }
            else if (precision == 3) {
                aNumber += ".000";
            }
            else if (precision == 4) {
                aNumber += ".0000";
            }
            var ins = aNumber.toString().split(".");
            if (ins.length > 2) {
                aNumber = parseFloat(ins[0] + "." + ins[1]).toFixed(precision);
            }
        }
    }
    return aNumber;
};
/*
 * Function: 取字符串字节长度 Document by by 2007-3-9
 */
var realLength = function (str) {
    var j = 0;
    for (var i = 0; i <= str.length - 1; i++) {
        j = j + 1;
        if ((str.charCodeAt(i)) > 127) {
            j = j + 1;
        }
    }
    return j;
};
// 中文作为3个字节处理
var realLengthOnly = function (str) {
    var j = 0;
    for (var i = 0; i <= str.length - 1; i++) {
        j = j + 1;
        if ((str.charCodeAt(i)) > 127) {
            j = j + 2;
        }
    }
    return j;
};
//数字金额小写转大写
var numberChangeToChinese = function (num) {
    var prefh = "";
    if (num === "") {
        return "";
    }
    if (!isNaN(num)) {
        if (num < 0) {
            prefh = "负";
            num = Math.abs(num);
        }
    }
    if (isNaN(num) || num > Math.pow(10, 12))
        return "";
    var cn = "零壹贰叁肆伍陆柒捌玖";
    var unit = new Array("拾佰仟", "分角");
    var unit1 = new Array("万亿万", "");
    var numArray = num.toString().split(".");
    //  let start = new Array(numArray[0].length - 1, 2);
    var toChinese = function (number, index, unit, start) {
        var num = number.replace(/\d/g, function ($1) {
            return cn.charAt($1) + unit[index].charAt(start-- % 4 ? start % 4 : -1);
        });
        return num;
    };
    for (var i = 0; i < numArray.length; i++) {
        var tmp = "";
        for (var j = 0; j * 4 < numArray[i].length; j++) {
            var strIndex = numArray[i].length - (j + 1) * 4;
            var str = numArray[i].substring(strIndex, strIndex + 4);
            var start = i ? 2 : str.length - 1;
            var tmp1 = toChinese(str, i, unit, start);
            tmp1 = tmp1.replace(/(零.)+/g, "零").replace(/零+$/, "");
            // tmp1 = tmp1.replace(/^壹拾/, "拾")
            tmp = (tmp1 + unit1[i].charAt(j - 1)) + tmp;
        }
        numArray[i] = tmp;
    }
    numArray[1] = numArray[1] ? numArray[1] : "";
    numArray[0] = numArray[0] ? numArray[0] + "圆" : numArray[0], numArray[1] = numArray[1].replace(/^零+/, "");
    numArray[1] = numArray[1].match(/分/) ? numArray[1] : numArray[1] + "整";
    var money = numArray[0] + numArray[1];
    money = money.replace(/(亿万)+/g, "亿");
    if (money == "整") {
        money = "零圆整";
    }
    else {
        money = prefh + money;
    }
    return money;
};
var chineseChangeToNumber = function (num) {
    var prefh = "";
    if (num.length > 0) {
        if (num.indexOf("负") == 0) {
            prefh = "-";
            num = num.substr(1);
        }
    }
    var numArray = new Array();
    var unit = "万亿万圆$";
    for (var i = 0; i < unit.length; i++) {
        var re = eval("/" + (numArray[i - 1] ? unit.charAt(i - 1) : "") + "(.*)" + unit.charAt(i) + "/");
        if (num.match(re)) {
            // numArray[i] = num.match(re)[1].replace(/^拾/, "壹拾")
            numArray[i] = numArray[i].replace(/[零壹贰叁肆伍陆柒捌玖]/g, function ($1) {
                return "零壹贰叁肆伍陆柒捌玖".indexOf($1);
            });
            numArray[i] = numArray[i].replace(/[分角拾佰仟]/g, function ($1) {
                return "*" + Math.pow(10, "分角 拾佰仟 ".indexOf($1) - 2) + "+";
            }).replace(/^\*|\+$/g, "").replace(/整/, "0");
            numArray[i] = "(" + numArray[i] + ")*" + Math.ceil(Math.pow(10, (2 - i) * 4));
        }
        else
            numArray[i] = 0;
    }
    return prefh + eval(numArray.join("+"));
};
var openUnFullWindow = function (url, width, height, top, left) {
    var szFeatures = "top=" + top + ",";
    szFeatures += "left=" + left + ",";
    szFeatures += "width=" + width + ",";
    szFeatures += "height=" + height + ",";
    szFeatures += "directories=no,";
    szFeatures += "status=yes,toolbar=no,location=no,";
    szFeatures += "menubar=no,";
    szFeatures += "scrollbars=yes,";
    szFeatures += "resizable=yes"; //channelmode
    __WEBPACK_IMPORTED_MODULE_2____["default"].open(url, "", szFeatures);
};
__WEBPACK_IMPORTED_MODULE_2____["default"].openUnFullWindow = openUnFullWindow;
//人力资源条件数据处理
var spellResourceCondition = function (datas) {
    if (datas) {
        var value_2 = [];
        datas.map(function (item) {
            if (item.sharetype == "1") {
                value_2.push("1_" + item.relatedshare + "_0_0");
            }
            else if (item.sharetype == "2" || item.sharetype == "3") {
                value_2.push(item.sharetype + "_" + item.relatedshare + "_0_" + item.seclevel.replace('-', '|@|'));
            }
            else if (item.sharetype == "4") {
                value_2.push("4_" + item.relatedshare + "_" + item.rolelevel + "_" + item.seclevel.replace('-', '|@|'));
            }
            else if (item.sharetype == "5") {
                value_2.push("5_0_0_" + item.seclevel.replace('-', '|@|'));
            }
            else if (item.sharetype == "6") {
                if (item.joblevel == '2') {
                    value_2.push("6_" + item.relatedshare + "_0_2|@|2");
                }
                else {
                    value_2.push("6_" + item.relatedshare + "_0_" + item.joblevel + "|@|" + item.jobfield);
                }
            }
        });
        return value_2.join('~');
    }
    return '';
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(172);
var defined = __webpack_require__(174);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(174);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return renderSearchAdPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return customOperates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return parserColumnsForFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return parserColumnsForShowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return computeSearchAd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTopLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isExitIconHandle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_searchUtil__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_list__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
var _this = this;











var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var MenuItem = __WEBPACK_IMPORTED_MODULE_5_antd__["Menu"].Item;
/*****componentDidMount 后的一些绑定计算处理 */
var renderSearchAdPanel = function (Search) {
    //窗口变化后，重新计算高级搜索的面板位置。如果查询条件默认展开，使用默认位置，不计算。
    if (!Search.isShowCondition) {
        try {
            var hei = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .wea-tab .ant-row').height() || 46;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .wea-tab .wea-search-container ').css({ top: hei });
        }
        catch (e) {
        }
    }
};
var componentComputed = function (Search, computeTableHeight) {
    var renderMaskDark = function () {
        //窗口变化后，重新计算高级搜索的遮盖蒙版
        try {
            var searchContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .wea-search-container');
            if (searchContainer.length) {
                var pos_top = searchContainer.eq(0).position().top + searchContainer.eq(0).height();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .wea-tab.wea-tab-search-ad').css({ position: 'static' }).find('.mask-dark').css({
                    top: pos_top,
                    bottom: 0,
                    height: 'auto'
                });
            }
        }
        catch (e) {
        }
    };
    __WEBPACK_IMPORTED_MODULE_1__util__["default"].addEventListener('resize', function () {
        __WEBPACK_IMPORTED_MODULE_1__util__["default"]['computeTableHeight']();
        var quickSearchData = Search.quickSearchData;
        var _a = quickSearchData.quicksearchinfo, quicksearchinfo = _a === void 0 ? [] : _a;
        if (quicksearchinfo.length && !Search.isShowCondition) {
            renderSearchAdPanel(Search);
            renderMaskDark();
        }
    });
    __WEBPACK_IMPORTED_MODULE_1__util__["default"]['openSlideModalDel'] = function (flg, url, sliderPercentage) {
        Search.showSlideModal(flg, url, sliderPercentage);
        __WEBPACK_IMPORTED_MODULE_2__util_searchUtil__["modeList"].reloadTable();
    };
    __WEBPACK_IMPORTED_MODULE_1__util__["default"]['dosubmitfun'] = function () {
        Search.dosubmitfun();
    };
    __WEBPACK_IMPORTED_MODULE_1__util__["default"]['removeStatusIconForMode'] = function (flg, billid) {
        if (flg)
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".statusiconformmode_" + billid).hide();
    };
    __WEBPACK_IMPORTED_MODULE_1__util__["default"]['slideflgfun'] = function () {
        return Search.slideflg;
    };
    __WEBPACK_IMPORTED_MODULE_1__util__["default"]['openSlideModal'] = function (flg, url, sliderPercentage) {
        Search.showSlideModal(flg, url, sliderPercentage);
    };
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.coms-mode-docker').delegate('.mask-wrapper', 'click', function () {
        Search.condition.update({ visible: false });
    });
    setTimeout(function () {
        var quickSearchData = Search.quickSearchData;
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(quickSearchData.quicksearchinfo)) {
            /***有快捷搜索的时候计算下weatab的高度，方便展开蒙层 */
            if (!Search.isShowCondition) {
                renderSearchAdPanel(Search);
            }
            else {
                computeTableHeight && computeTableHeight(Search);
            }
        }
    }, 2500);
    __WEBPACK_IMPORTED_MODULE_1__util__["default"]['computeTableHeight'] = function () {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-mobx-table-tbody-tr-td-lk')[0]) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-mobx-table-tbody-tr-td-lk')[0]).find('.cube-table-body')[0]) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-mobx-table-tbody-tr-td-lk')[0]).find('.cube-table-body')[0].style.maxHeight = (document.body.offsetHeight - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-mobx-table-tbody-tr-td-lk').eq(0).find('.cube-table-body')[0]).offset().top - 90) + 'px';
            }
        }
    };
    __WEBPACK_IMPORTED_MODULE_1__util__["default"].perfectHeight = function () {
        if (!Search.newTable.loading) {
            var topHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-wapper').find('.wea-new-top').height() || 0;
            var tabHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-wapper').find('.wea-new-top-content').find('.wea-tab').height() || 0;
            var countHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-wapper').find('.cube-list-countContainer').height() || 0;
            if (Search.displayType === __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].ImgType) { //图片看板
                var imgDivHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-wapper').find('.imgTypeDiv-tableCol-innerHtml').height() || 0;
                return imgDivHeight + topHeight + tabHeight + countHeight + 375;
            }
            else if (Search.displayType === __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].VerticalType) {
                var listHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-wapper').find('.cube-vertical-list').height() || 0;
                return listHeight + topHeight + tabHeight + countHeight + 375;
            }
            else if (Search.displayType === __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].Excel) { //excel
                var excelDivHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-wapper').find('.cube-excel-list').height() || 0;
                if (excelDivHeight > 375) {
                    return;
                }
                return excelDivHeight + topHeight + tabHeight + countHeight + 375;
            }
            else {
                var bodyScrollHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.coms-mode-search').find('.cube-list-table').find('.ant-table-scroll').find('.ant-table-body').prop('scrollHeight');
                bodyScrollHeight = bodyScrollHeight ? bodyScrollHeight : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-mobx-table-tbody-tr-td-lk .cube-table-body').height();
                return bodyScrollHeight + topHeight + tabHeight + countHeight + 375;
                //考虑到数据没有的时候高级搜索不显示完全。设置375吧最低
            }
        }
    };
    /**挂载地图显示方法 */
    __WEBPACK_IMPORTED_MODULE_1__util__["default"].showFormModeMap = function (fieldvalue) {
        Search.showCubeMap(true, fieldvalue);
    };
    !__WEBPACK_IMPORTED_MODULE_7_loadjs___default.a.isDefined('imcarouselJS') && __WEBPACK_IMPORTED_MODULE_7_loadjs___default()([
        '/social/js/drageasy/drageasy.js',
        '/social/js/bootstrap/js/bootstrap.js',
        '/social/im/js/IMUtil_wev8.js',
        '/social/js/imcarousel/imcarousel.js',
    ], 'imcarouselJS');
    /**
     *  处理列表兼容火狐
     */
    var htmlObj = document.documentElement;
    htmlObj.setAttribute('data-useragent', navigator.userAgent);
    htmlObj.setAttribute('data-platform', navigator.platform);
};
/****自定义mobxtable的操作按钮 */
var customOperates = function (record, index, operates, Search) {
    var itemsArr = [];
    var operatesshow = record.operatesshowspan || '';
    var likestatus = record.likesinfospan && record.likesinfospan.split(',')[2] ? record.likesinfospan.split(',')[2] : '';
    var likecount = record.likesinfospan && record.likesinfospan.split(',')[0] ? record.likesinfospan.split(',')[0] : '0';
    var dislikecount = record.likesinfospan && record.likesinfospan.split(',')[1] ? record.likesinfospan.split(',')[1] : '0';
    var isExitIcon = isExitIconHandle('customOpt', operates, operatesshow);
    operates.map(function (value, index1, array) {
        //判断自定义按钮权限
        if (operatesshow.split('+')[index1] && operatesshow.split('+')[index1] == 'true') {
            if (array[index1].nodeName && array[index1].nodeName == 'operate') {
                if (array[index1].href == 'javascript:likes') {
                    var classname = 'icon-coms02-like-o';
                    var titlename = array[index1].text;
                    var key_1 = '1';
                    if (likestatus == '1') {
                        classname = 'icon-coms02-like';
                        titlename = getLabel('31129', '取消') + array[index1].text;
                        key_1 = '0';
                    }
                    itemsArr.push(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@7lbdd3@" + index1 },
                        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("a", { href: "javascript:void(0);", onClick: function () {
                                Search.likeOrDislike(record, key_1, index, '0');
                            } },
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: titlename, className: classname }),
                            ' ' + array[index1].text + ' (' + likecount + ')')));
                }
                else if (array[index1].href == 'javascript:dislikes') {
                    var classname = 'icon-coms02-Negative-comment-o';
                    var titlename = array[index1].text;
                    var key_2 = '2';
                    if (likestatus == '2') {
                        classname = 'icon-coms02-Negative-comment';
                        titlename = getLabel('31129', '取消') + array[index1].text;
                        key_2 = '0';
                    }
                    itemsArr.push(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@46p8mr@" + index1 },
                        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("a", { href: "javascript:void(0);", onClick: function () {
                                Search.likeOrDislike(record, key_2, index, '0');
                            } },
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: titlename, className: classname }),
                            ' ' + array[index1].text + ' (' + dislikecount + ')')));
                }
                else {
                    itemsArr.push(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@e43md4@" + index1 },
                        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("a", { href: "javascript:void(0);", onClick: function () {
                                Search.doCustomButton(record, '', array[index1], '');
                            } },
                            isExitIcon ? __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", { className: 'cube-list-icon-box' }, array[index1].icon ? __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("img", { src: array[index1].icon }) : '') : '',
                            array[index1].text)));
                }
            }
        }
    });
    return (__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@wjen9s" }, itemsArr));
};
/*****
 * 计算列表数据区域高度
 */
var timeCounter;
var getHeight = function (Search) {
    var ImgType = __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].ImgType, VerticalType = __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].VerticalType, Excel = __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].Excel;
    timeCounter = setTimeout(function () {
        var newTable = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .wea-new-table');
        if (newTable && newTable.children().length) {
            clearTimeout(timeCounter);
            var urlParams = Object(__WEBPACK_IMPORTED_MODULE_8__util_typeUtil__["f" /* getUrlParams */])();
            var _a = urlParams.displayType, displayType = _a === void 0 ? '' : _a;
            var noData = !(Search.newTable.datas.length > 0);
            try {
                if (displayType == "treeType" || Search.displayType == 'treeType') {
                    var pageHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ant-pagination').height();
                    var paginationHeight = pageHeight ? pageHeight + 32 : 46;
                    var headerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ant-table-header').height() || 32;
                    var mxheight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-table').offset().top - headerHeight - paginationHeight;
                    var minHeight = noData ? 0 : 100;
                    if (mxheight < minHeight) {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-content').css("overflow-y", "auto");
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .cube-list-table .ant-table-body').css('minHeight', minHeight);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".wea-new-top-content").scrollTop(0, 0);
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-content').css("overflow-y", "hidden");
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .cube-list-table .ant-table-body').css('minHeight', 'auto');
                    }
                    mxheight && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .cube-list-table .ant-table-body').css('maxHeight', mxheight < minHeight ? minHeight : mxheight);
                }
                else if (Search.displayType == VerticalType) { //列表右侧出现纵向列表
                    var preClassName = '';
                    var isFromCard = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.coms-mode-card').length > 0; // 查询列表作为卡片的页面扩展 内嵌或者外嵌 高度计算出错
                    if (isFromCard) {
                        preClassName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-card-content').css('display') == 'inline' ? '.cube-card-content' : '.cube-toptab-container';
                    }
                    var mxheight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".cube-rightleft-layout-right " + preClassName + " .cube-vertical-list").offset().top - 20;
                    var listH = mxheight < 100 ? 100 : mxheight;
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-rightleft-layout-right .cube-vertical-list').css('height', listH);
                    var listItemsH = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-rightleft-layout-right .cube-vertical-list .vertical-list-items').height();
                    if (listItemsH > listH) {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-rightleft-layout-right .cube-vertical-list .cube-vertical-list-loadingmore').hide();
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-rightleft-layout-right .cube-vertical-list .cube-vertical-list-loadingmore').show();
                    }
                }
                else if (Search.displayType == Excel) { //列表右侧挂载excel高度计算问题
                    var paginationHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-rightleft-layout-right .ant-pagination').height() + 20 || 46;
                    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#excelDiv") && __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#excelDiv").offset()) {
                        var mxheight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#excelDiv").offset().top - paginationHeight;
                        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#excelDiv').height() == mxheight) {
                            clearTimeout(timeCounter);
                        }
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#excelDiv').height(mxheight);
                    }
                }
                else if (displayType != "excel") {
                    var preClassName = '';
                    var isFromCard = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.coms-mode-card').length > 0; // 查询列表作为卡片的页面扩展 内嵌或者外嵌 高度计算出错
                    if (isFromCard) {
                        preClassName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-card-content').css('display') == 'inline' ? '.cube-card-content' : '.cube-toptab-container';
                    }
                    var paginationHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(preClassName + " .wea-table-pagination").height() || 44;
                    // const headerHeight = jQuery(`${preClassName} .ant-table-header`).height() || 41;
                    var headerHeight = 41; // 存在headerHeight高度小于41的情况，导致body高度计算错误，出现双滚动条问题。
                    var mxheight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cube_search_" + Search.customId + " " + preClassName + " .wea-new-table.cube-list-table").offset().top - headerHeight - paginationHeight - 10;
                    var minHeight = noData ? 0 : 50; //table上面内容太多，会导致table数据不显示
                    if (mxheight < minHeight) {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-content').css("overflow-y", "auto"); //内容过多时，给table最小高度同时外部添加滚动。
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .cube-list-table .ant-table-body').css('minHeight', minHeight);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".wea-new-top-content").scrollTop(0, 0);
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.wea-new-top-content').css("overflow-y", "hidden");
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .cube-list-table .ant-table-body').css('minHeight', 'auto');
                    }
                    mxheight && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-list-wrapper .cube-list-table .ant-table-body').css('maxHeight', mxheight < minHeight ? minHeight : mxheight);
                    // 自定义页面，无top高度赋值
                    var customDom = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.coms-mode-viewCustomPage');
                    if (customDom.length > 0 && Search.isInnerTab) {
                        var listDom = customDom.find('.cube-card-list-wrapper');
                        if (listDom.length > 0) {
                            listDom.find('.cube-list-wrapper').css('height', listDom.height());
                        }
                    }
                }
            }
            catch (e) {
            }
        }
        else if (Search.displayType == ImgType || Search.displayType == VerticalType) {
            /***
             * 在相册基础上计算下数据展示区域的高度
             */
            try {
                var preClassName = '';
                var isFromCard = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.coms-mode-card').length > 0; // 查询列表作为卡片的页面扩展 内嵌或者外嵌 高度计算出错
                if (isFromCard) {
                    preClassName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-card-content').css('display') == 'inline' ? '.cube-card-content' : '.cube-toptab-container';
                }
                var paginationHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(preClassName + " .wea-table-pagination").height() || 44;
                var headerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(preClassName + " .ant-table-header").height() || 41;
                if (Search.displayType == ImgType) {
                    var mxheight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(preClassName + " .imgTypeDiv-tableCol-innerHtml").offset().top - headerHeight - paginationHeight - 20;
                    var minHeight = 100; //table上面内容太多，会导致table数据不显示
                    var imgH = mxheight < minHeight ? minHeight : mxheight;
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.imgTypeDiv-tableCol-innerHtml').css('maxHeight', imgH);
                    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.imgTypeDiv-tableCol-innerHtml').height() == imgH) {
                        clearTimeout(timeCounter);
                    }
                }
                if (Search.displayType == VerticalType) {
                    var mxheight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(preClassName + " .cube-vertical-list").offset().top - 20;
                    var listH = mxheight < 100 ? 100 : mxheight;
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(preClassName + " .cube-vertical-list").css('height', listH);
                    var listItemsH = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-vertical-list .vertical-list-items').height();
                    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(preClassName + " .cube-vertical-list").height() == listH) {
                        clearTimeout(timeCounter);
                    }
                    if (listItemsH > listH) {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-vertical-list .cube-vertical-list-loadingmore').hide();
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cube-vertical-list .cube-vertical-list-loadingmore').show();
                    }
                }
            }
            catch (e) {
            }
        }
        else if (Search.displayType == 'excel') {
            var paginationHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ant-pagination').height() + 20 || 46;
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#excelDiv") && __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#excelDiv").offset()) {
                var mxheight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#excelDiv").offset().top - paginationHeight;
                if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#excelDiv').height() == mxheight) {
                    clearTimeout(timeCounter);
                }
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#excelDiv').height(mxheight);
            }
        }
        else {
            if (timeCounter < 20000) {
                getHeight(Search);
            }
            else {
                clearTimeout(timeCounter);
            }
        }
    }, 200);
};
/*****
 * 处理自定义按钮的，之前没有公用，我写纵向列表的时候提出来，后面看下能不能别的也走这里的逻辑 -- ljc
 * Search:liststore
 * ,type: 点赞的type列表类型 1 :normal, 0 :imgtype, 2:分组列表，5：纵向列表
 */
var parserColumnsForFunc = function (record, num, cb, index, Search, type, isExitIcon) {
    var otherparas = cb.otherpara.split("+");
    var index1 = 0;
    var _loop_1 = function () {
        var islikebutton = otherparas[index1].replace("#islikebutton:", "");
        if (islikebutton && islikebutton == '1') {
            var likeinfo = otherparas[index1 + 1].replace("#likeinfo:", "");
            var likecount = likeinfo.split(",")[1];
            var dislikecount = likeinfo.split(",")[2];
            var type_1 = likeinfo.split(",")[0];
            var status = likeinfo.split(",")[3];
            if (type_1 == '5') {
                if (status == '1') {
                    return { value: __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@orhgq1" },
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { onClick: function () {
                                    Search.likeOrDislike(record, "0", index, type_1);
                                } },
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-like" }),
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { style: { color: '#000' } }, ' ' + cb.text + '(' + likecount + ')')))) };
                }
                else {
                    return { value: __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@xhv3sg" },
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { onClick: function () {
                                    Search.likeOrDislike(record, "1", index, type_1);
                                } },
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: cb.text, className: "icon-coms02-like-o" }),
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + likecount + ')')))) };
                }
            }
            else if (type_1 == '6') {
                if (status == '2') {
                    return { value: __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@gxvlwm" },
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { onClick: function () {
                                    Search.likeOrDislike(record, "0", index, type_1);
                                } },
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-Negative-comment" }),
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + dislikecount + ')')))) };
                }
                else {
                    return { value: __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@qbjl35" },
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { onClick: function () {
                                    Search.likeOrDislike(record, "2", index, type_1);
                                } },
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: cb.text, className: "icon-coms02-Negative-comment-o" }),
                                    __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + dislikecount + ')')))) };
                }
            }
        }
    };
    for (index1; index1 < otherparas.length; index1++) {
        var state_1 = _loop_1();
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@3jke1d" },
        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { onClick: function () {
                Search.doCustomButton(record, '', cb, '');
            } },
            isExitIcon ? __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", { className: 'cube-list-icon-box' }, cb.icon ? __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("img", { src: cb.icon }) : '') : '',
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { style: { color: '#000' } }, cb.text)));
};
var parserColumnsForShowList = function (record, num, cb, index, isShowIcon, Search, listtype) {
    var otherparas = cb.otherpara.split("+");
    var index1 = 0;
    for (index1; index1 < otherparas.length; index1++) {
        var islikebutton = otherparas[index1].replace("#islikebutton:", "");
        if (islikebutton && islikebutton == '1') {
            var likeinfo = otherparas[index1 + 1].replace("#likeinfo:", "");
            var type = likeinfo.split(",")[0];
            var status = likeinfo.split(",")[3];
            var likecount = likeinfo.split(",")[1];
            var dislikecount = likeinfo.split(",")[2];
            if (type == '5') {
                if (status == '1') {
                    return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@9iawj2", type: "ghost", onClick: function () {
                            Search.likeOrDislike(record, "0", index, listtype);
                        } },
                        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-like" }),
                            isShowIcon ? __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { title: cb.text || '' }, '(' + likecount + ')') :
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null, ' ' + cb.text + '(' + likecount + ')')));
                }
                else {
                    return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@sowsjw", type: "ghost", onClick: function () {
                            Search.likeOrDislike(record, "1", index, listtype);
                        } },
                        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: cb.text, className: "icon-coms02-like-o" }),
                            isShowIcon ? __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { title: cb.text || '' }, '(' + likecount + ')') :
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null, ' ' + cb.text + ' (' + likecount + ')')));
                }
            }
            else if (type == '6') {
                if (status == '2') {
                    return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@d7l3ji", type: "ghost", onClick: function () {
                            Search.likeOrDislike(record, "0", index, listtype);
                        } },
                        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-Negative-comment" }),
                            isShowIcon ? __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { title: cb.text || '' }, '(' + dislikecount + ')') :
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null, ' ' + cb.text + ' (' + dislikecount + ')')));
                }
                else {
                    return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@iaryrn", type: "ghost", onClick: function () {
                            Search.likeOrDislike(record, "2", index, listtype);
                        } },
                        __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null,
                            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("i", { title: cb.text, className: "icon-coms02-Negative-comment-o" }),
                            isShowIcon ? __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", { title: cb.text || '' }, '(' + dislikecount + ')') :
                                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("span", null, ' ' + cb.text + ' (' + dislikecount + ')')));
                }
            }
        }
    }
    return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@icul1z", title: cb.text || '', type: "ghost", onClick: function () {
            Search.doCustomButton(record, '', cb, '');
        } },
        cb.icon ?
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", { className: 'cube-list-icon-box' },
                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("img", { src: cb.icon })) : (!isShowIcon ? '' :
            __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", { className: 'cube-list-icon-box' },
                __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("img", { src: Object(__WEBPACK_IMPORTED_MODULE_9__util_contentPath__["a" /* getContentPath */])('/mobilemode/piclibrary/01-E9_default/setup.png') }))),
        !isShowIcon ? cb.text : '');
};
/****
 *
 * 导出文件
 */
var getContent = function (Search) {
    var progress = Search.progress;
    var step = progress.step;
    var content = "";
    if (!step) {
        return getLabel('508305', '正在导出文件');
    }
    if (step == 'start') {
        content = getLabel('508301', '正在进行导出准备');
    }
    else if (step == 'expSheet') {
        var total = parseInt(progress.sheetcount);
        if (total > 1) {
            content = getLabel('509502', '正在导出第{current}/{total}个sheet') + " ," + getLabel('384158', '当前进度') + " :" + progress.current + "/" + progress.total;
            content = content.replace(/\{current\}/, progress.currsheet).replace(/\{total\}/, progress.sheetcount);
        }
        else {
            content = getLabel('384158', '当前进度') + " \uFF1A" + progress.current + "/" + progress.total;
        }
    }
    else if (step == 'createFile') {
        content = getLabel('508304', '正在创建文件');
    }
    else if (step == 'querydata') {
        content = getLabel('513078', '正在查询数据');
    }
    else if (step == 'zip') {
        content = getLabel('513077', '正在压缩文件');
    }
    else if (step == 'expcard') {
        content = getLabel('513076', '正在导出第{current}/{total}个文件');
        content = content.replace(/\{current\}/, progress.current).replace(/\{total\}/, progress.total);
    }
    return content;
};
// 计算高级搜索面板最大值
var computeSearchAd = function (Search) {
    try {
        var domViewRes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.coms-mode-viewResource .list-container'); //资源面板
        if (domViewRes.length > 0 && Search.viewResHeight) {
            var tabHeight = domViewRes.find('.cube-list-wrapper .wea-tab').height() || 0;
            domViewRes.find('.cube-list-wrapper .wea-advanced-searchsAd').css('maxHeight', Search.viewResHeight - tabHeight - 62 + "px");
        }
    }
    catch (error) {
    }
};
/***
 * mobxtableedit  计算滚动高度
 */
var getScroll = function (Search) {
    var width = 0, height = document.documentElement.clientHeight;
    Search.editTableStore.columns.map(function (column) {
        if (column.width) {
            if (typeof column.width === 'string') {
                if (column.width.indexOf('%') > -1) {
                    width += document.documentElement.clientWidth * parseFloat(column.width.replace('%', ''));
                }
                else {
                    width += parseFloat(column.width);
                }
            }
            else if (typeof column.width === 'number') {
                width += column.width;
            }
        }
        else {
            width += 100;
        }
    });
    return {
        x: width,
        y: height - 214
    };
};
/*****
 * 获取当前菜单布局
 * 计算顶部，左侧距离，滑动出来的需要
 */
var getTopLeft = function () {
    var themelayoutType = (__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].ls.getJSONObj('theme-themeInfo') && __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].ls.getJSONObj('theme-themeInfo').themeLayoutType) || "1"; //门户布局
    var top = 0;
    if (themelayoutType == '1') { //默认布局
        top = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout-main").offset() ? (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout-main").offset().top ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout-main").offset().top + 10 : 0) : 0;
    }
    else {
        top = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout" + themelayoutType + "-main").offset() ? (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout" + themelayoutType + "-main").offset().top ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout" + themelayoutType + "-main").offset().top + 10 : 0) : 0;
    }
    if (top == 0) {
        top = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e8theme-layout-main").offset() ? (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e8theme-layout-main").offset().top ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e8theme-layout-main").offset().top + 10 : 0) : 0;
    }
    var left = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout-main").offset() ? (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout-main").offset().left ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e9theme-layout-main").offset().left + 10 : 0) : 0;
    if (left == 0) {
        left = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e8theme-layout-main").offset() ? (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e8theme-layout-main").offset().left ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".e8theme-layout-main").offset().left + 10 : 0) : 0;
        if (left == 0) {
            left = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".cube-tree-list").css('width');
            if (left == undefined) {
                left = 0;
            }
            else {
                left = left.replace('px', '') - 14;
            }
        }
        else {
            var treeleft = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".cube-tree-list").css('width');
            if (treeleft == undefined) {
                treeleft = 0;
            }
            else {
                left = left + parseFloat(treeleft.replace('px', '')) - 10;
            }
        }
    }
    else {
        var treeleft = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".cube-tree-list").css('width');
        if (treeleft == undefined) {
            treeleft = 0;
        }
        else {
            left = left + parseFloat(treeleft.replace('px', '')) - 10;
        }
    }
    return { top: top, left: left };
};
/**
 * 判断自定义按钮是否存在图标
 * type: 'opt':操作"更多"  'customOpt':自定义按钮
 * custombtnArr: 下拉选项数组数据
 * filter: 过滤条件
 */
var isExitIconHandle = function (type, custombtnArr, filter) {
    if (type === 'opt') {
        if (custombtnArr) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.some(custombtnArr, function (item) { return item.icon; });
        }
        return true;
    }
    else if (type === 'customOpt') {
        var filterArr_1 = filter.split('+');
        return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.some(custombtnArr, function (item, index) {
            if (filterArr_1[index] === 'true' && item.icon) {
                return true;
            }
            return false;
        });
    }
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isKey = __webpack_require__(190),
    stringToPath = __webpack_require__(589),
    toString = __webpack_require__(37);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(95);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(610),
    createAssigner = __webpack_require__(308);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(307),
    baseKeysIn = __webpack_require__(622),
    isArrayLike = __webpack_require__(45);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(78),
    overRest = __webpack_require__(309),
    setToString = __webpack_require__(198);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(627),
    createBaseEach = __webpack_require__(312);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(634);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(311),
    getTag = __webpack_require__(101),
    isArguments = __webpack_require__(97),
    isArray = __webpack_require__(13),
    isArrayLike = __webpack_require__(45),
    isBuffer = __webpack_require__(99),
    isPrototype = __webpack_require__(129),
    isTypedArray = __webpack_require__(130);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(675),
    hasPath = __webpack_require__(339);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(363);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1015),
    getValue = __webpack_require__(1018);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return spellResourceCondition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_contentPath__ = __webpack_require__(9);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;
var Browser = /** @class */ (function (_super) {
    __extends(Browser, _super);
    function Browser(props) {
        var _this = _super.call(this, props) || this;
        _this.openFullWindow = function (url) {
            var width = screen.availWidth - 10;
            var height = screen.availHeight - 50;
            var szFeatures = 'top=0,';
            szFeatures += 'left=0,';
            szFeatures += "width=" + width + ",";
            szFeatures += "height=" + height + ",";
            szFeatures += 'directories=no,';
            szFeatures += 'status=yes,toolbar=no,location=no,';
            szFeatures += 'menubar=no,';
            szFeatures += 'scrollbars=yes,';
            szFeatures += 'resizable=yes';
            __WEBPACK_IMPORTED_MODULE_6__util__["default"].open(url, '', szFeatures);
        };
        _this.addOnClick = function () {
            var _a = _this.props, cell = _a.cell, form = _a.form, card = _a.card;
            var path = cell.getPath();
            var bindObj = form.$(path);
            var fieldMark = Object(__WEBPACK_IMPORTED_MODULE_4__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
            var secretLevel = 4;
            var seclevelInfo = card.seclevelInfo;
            if (seclevelInfo != undefined && seclevelInfo != "-1") {
                if (__WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getCurrentModeStore().cubeForm.$(seclevelInfo).values() != '') {
                    secretLevel = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getCurrentModeStore().cubeForm.$(seclevelInfo).values();
                }
            }
            __WEBPACK_IMPORTED_MODULE_6__util__["default"].__createDocFn = function (o) {
                var fieldvalueobj = __WEBPACK_IMPORTED_MODULE_6__util__["default"].ModeForm.getFieldValueObj(fieldMark) || {};
                var old_docids = fieldvalueobj.value || '';
                var old_docspecialobj = Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(fieldvalueobj.specialobj) || [];
                old_docspecialobj.push({ id: o.docid, name: o.docSubject });
                var new_fieldvalueobj = {
                    value: old_docspecialobj.length > 0 && old_docids != '' ? old_docids + ',' + o.docid : o.docid,
                    specialobj: old_docspecialobj,
                    _secretLevel: secretLevel
                };
                __WEBPACK_IMPORTED_MODULE_6__util__["default"].ModeForm.changeFieldValue(fieldMark, new_fieldvalueobj);
            };
            _this.openFullWindow(Object(__WEBPACK_IMPORTED_MODULE_8__util_contentPath__["a" /* getContentPath */])('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=cube&_secretLevel=' + secretLevel));
        };
        _this.sapBrowserChange = function (ids, names, datas) {
            var _a = _this.state.sapBrowserPro, fieldid = _a.fieldid, fielddbtype = _a.fielddbtype, isdetail = _a.isdetail, detailRowIndex = _a.detailRowIndex;
            var params = { fieldid: fieldid, fielddbtype: fielddbtype, datas: JSON.stringify(datas), fromNodeorReport: 0, requestid: -1 };
            if (ids == '') {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTools"].callApi('/api/SapIntegration/browser/assignToBill', 'POST', params).then(function (result) {
                var fieldsValueMap = result.datas[0];
                Object.keys(fieldsValueMap).forEach(function (key) {
                    try {
                        __WEBPACK_IMPORTED_MODULE_6__util__["default"].ModeForm.changeFieldValue(key, fieldsValueMap[key]);
                        if (isdetail) {
                            __WEBPACK_IMPORTED_MODULE_6__util__["default"].ModeForm.changeFieldValue(key + '_' + detailRowIndex, fieldsValueMap[key]);
                        }
                    }
                    catch (e) { }
                });
            });
        };
        _this.state = {
            sapBrowserPro: {}
        };
        return _this;
    }
    Browser.prototype.render = function () {
        var _this = this;
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_4__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var bind = bindObj.bind();
        var quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues;
        var _viewAttr = bind.viewAttr, isEdit = bind.isEdit, isMandatory = bind.isMandatory;
        var hasAdvanceSerach = true;
        var _b = card.getFieldProps(path), fieldtype = _b.fieldtype, isdetail = _b.isdetail, expendattr = _b.expendattr, sqlNeedFieldKey = _b.sqlNeedFieldKey;
        var browserProps = bind.browserProps || card.getFieldProps(path).browserProps;
        var tabs = bind.tabs || card.getFieldProps(path).tabs || [];
        var secretLevel = '';
        var seclevelInfo = card.seclevelInfo;
        if (seclevelInfo != undefined && seclevelInfo != "-1") {
            if (__WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getCurrentModeStore().cubeForm.$(seclevelInfo).values() != '') {
                secretLevel = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getCurrentModeStore().cubeForm.$(seclevelInfo).values();
            }
        }
        if (tabs.length > 0) {
            browserProps = __assign({}, browserProps, { tabs: Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(tabs) });
        }
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        var showDropMenu = fieldtype == '4' || fieldtype == '164'; //部门分部显示维度菜单
        var hasAddBtn = false; //多文档显示新建文档按钮
        if (viewAttr != '1') {
            hasAddBtn = fieldtype == '37' && (card.base.type == '1' || card.base.type == '2');
        }
        var otherProps = {};
        if (fieldtype == '141') {
            otherProps.onChange = function (_, __, datas) {
                bindObj.onChange(spellResourceCondition(datas), __, datas);
            };
        }
        if (fieldtype == '17' && !isdetail) {
            browserProps.hasAddGroup = true;
        }
        if (fieldtype == '1' || fieldtype == '17') {
            browserProps.isShowGroup = !isdetail;
        }
        var relateFieldid = browserProps.relateFieldid;
        var completeParams = browserProps.completeParams || {};
        var dataParams = bind.dataParams || browserProps.dataParams || {};
        var destDataParams = bind.destDataParams || browserProps.destDataParams || {};
        if (fieldtype == '4' || fieldtype == '57' || fieldtype == '164' || fieldtype == '169' || fieldtype == '194' || fieldtype == '167' || fieldtype == '170' || fieldtype == '168') { //部门，多部门，分部，多分部，单点分权，分权单部门，分权多分部，分权多部门
            dataParams = __assign({}, dataParams, { fromModule: "model", "secretLevel": secretLevel });
            destDataParams = __assign({}, dataParams, { fromModule: "model" });
            completeParams = __assign({}, completeParams, { fromModule: "model", "secretLevel": secretLevel });
        }
        if (fieldtype == '165' || fieldtype == '166' || fieldtype == '167' || fieldtype == '168' || fieldtype == '169' || fieldtype == '170') { //分权单人力资源，分权多人力资源，分权单部门，分权多部门，分权单分部，分权多分部
            dataParams = __assign({}, dataParams, { fromModule: "model", fieldid: path.replace("field", ""), isbill: "1", viewtype: isdetail ? 1 : 0 });
            destDataParams = __assign({}, dataParams, { fromModule: "model", fieldid: path.replace("field", ""), isbill: "1", viewtype: isdetail ? 1 : 0 });
            completeParams = __assign({}, completeParams, { fromModule: "model", fieldid: path.replace("field", ""), isbill: "1", viewtype: isdetail ? 1 : 0, "secretLevel": secretLevel });
        }
        var conditionDataParams = browserProps.conditionDataParams || {};
        var parm = {
            isFromMode: "1",
            modeId: card.base.modeId,
            fieldid: path.replace("field", ""),
            isbill: 1,
            viewtype: isdetail ? "1" : "0",
        };
        dataParams = __assign({}, dataParams, parm, { "secretLevel": secretLevel });
        conditionDataParams = __assign({}, conditionDataParams, parm);
        completeParams = __assign({}, completeParams, parm, { "secretLevel": secretLevel });
        //let disabledInput = false;
        if (fieldtype == '161' || fieldtype == '162') {
            var formData = card.getDataParamsForSql(path, form, sqlNeedFieldKey);
            dataParams = __assign({}, dataParams, formData, { "secretLevel": secretLevel });
            conditionDataParams = __assign({}, conditionDataParams, formData);
            completeParams = __assign({}, completeParams, formData, { "secretLevel": secretLevel });
            // con26705_value: 8      con浏览框查询条件字段id
            var relateFieldValues_1 = {};
            if (relateFieldid) {
                relateFieldid.map(function (fieldid_) {
                    var field = "field" + fieldid_.split("_")[0];
                    var fieldinfo = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getFieldInfo(field);
                    try {
                        if (fieldinfo.isdetail) {
                            var detailRowIndex = form.path.split(".")[1];
                            relateFieldValues_1[field] = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getFieldValue(field + "_" + detailRowIndex);
                        }
                        else {
                            relateFieldValues_1[field] = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getFieldValue(field);
                        }
                    }
                    catch (e) {
                        relateFieldValues_1[field] = '';
                    }
                });
            }
            dataParams = __assign({}, dataParams, relateFieldValues_1, { "secretLevel": secretLevel }); //field45270:"6"
            conditionDataParams = __assign({}, conditionDataParams, relateFieldValues_1);
            completeParams = __assign({}, completeParams, relateFieldValues_1, { "secretLevel": secretLevel });
        }
        else if (fieldtype == '256' || fieldtype == '257') {
            //disabledInput = true;//树形不支持快捷搜索
            var formData = card.getDataParamsForSql(path, form, sqlNeedFieldKey);
            dataParams = __assign({}, dataParams, formData, { selectedCount: (bind.valueObj && bind.valueObj.length) || 0, "secretLevel": secretLevel });
            //asynLoadAll为true时才自动展开节点,根据defaultExpandedLevel来决定展开的节点层数(如果树浏览框选择了值,默认展开10层,一般情况下应该够用了)
            //组件不支持递归调用自动全部展开,因此如果是11层的树,则最后一层不会自动展开
            // if (bind.valueObj.length > 0) {//如果树浏览框选择了值,则下次打开要展开所有层级
            //     browserProps['asynLoadAll'] = true;
            //     browserProps['defaultExpandedLevel'] = 10;
            // } else {
            //     if (browserProps.expandfirstnode) {//如果默认展开一级节点
            //         // browserProps['asynLoadAll'] = true;
            //         browserProps['defaultExpandedLevel'] = 1;
            //     }
            // }
            otherProps['asynLoadAll'] = false;
            hasAdvanceSerach = browserProps.hasAdvanceSerach;
            conditionDataParams = __assign({}, conditionDataParams, formData);
            completeParams = __assign({}, completeParams, formData, { "secretLevel": secretLevel });
            if (expendattr.startsWith("treerootnode")) {
                var key = expendattr.substring(expendattr.indexOf("=") + 1);
                var arr = key.split(",");
                var treerootnode = "";
                for (var i = 0, len = arr.length; i < len; i++) {
                    var tempKey = arr[i].substring(arr[i].indexOf("$") + 1, arr[i].lastIndexOf("$")) + "_" + dataParams.currenttime;
                    if (dataParams[tempKey] != "" && dataParams[tempKey] != undefined) {
                        if (i != 0) {
                            treerootnode += ",";
                        }
                        treerootnode += dataParams[tempKey];
                    }
                }
                dataParams["treerootnode"] = treerootnode;
            }
        }
        else if (fieldtype == '226') { //sap 系统集成单选浏览按钮
            var relateFields = card.getFieldProps(path).relateFields.slice();
            var relateFieldValues_2 = {};
            relateFields.map(function (v) {
                var field = 'field' + v.split("_")[0];
                try {
                    if (isdetail) {
                        var detailRowIndex = form.path.split(".")[1];
                        _this.state.sapBrowserPro['detailRowIndex'] = detailRowIndex;
                        relateFieldValues_2[field] = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getFieldValue(field + "_" + detailRowIndex);
                    }
                    else {
                        relateFieldValues_2[field] = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getFieldValue(field);
                    }
                }
                catch (e) {
                    relateFieldValues_2[field] = '';
                }
            });
            var sapOtherParams = { isbill: 1, rowIndex: isdetail ? 0 : -1 };
            sapOtherParams['fieldid'] = card.getFieldProps(path).fieldid;
            sapOtherParams['fielddbtype'] = card.getFieldProps(path).fielddbtype;
            sapOtherParams['billid'] = card.base.formId;
            sapOtherParams['issearch'] = true;
            dataParams = __assign({}, dataParams, relateFieldValues_2, sapOtherParams);
            conditionDataParams = __assign({}, conditionDataParams, relateFieldValues_2, sapOtherParams);
            completeParams = __assign({}, completeParams, relateFieldValues_2, sapOtherParams);
            browserProps['onChange'] = this.sapBrowserChange; //sap赋值动作
            this.state.sapBrowserPro['fieldid'] = card.getFieldProps(path).fieldid;
            this.state.sapBrowserPro['rowIndex'] = -1;
            this.state.sapBrowserPro['fielddbtype'] = card.getFieldProps(path).fielddbtype;
            this.state.sapBrowserPro['isdetail'] = isdetail;
        }
        else {
            var relateFieldValues_3 = {};
            if (fieldtype == '270') { //qc:985018
                bind.valueObj && bind.valueObj.map(function (item) {
                    if (item.namespan) {
                        item.namespan = item.name;
                    }
                });
            }
            if (relateFieldid) {
                //    const fieldinfo = modeForm.getFieldInfo(fieldName);
                //    const rowIndex = fieldinfo.isdetail ? fieldName.split('_')[1] : '-1';
                relateFieldid.map(function (fieldid_) {
                    var field = "field" + fieldid_.split("_")[0];
                    var fieldinfo = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getFieldInfo(field);
                    try {
                        if (fieldinfo.isdetail) {
                            var detailRowIndex = form.path.split(".")[1];
                            relateFieldValues_3[field] = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getFieldValue(field + "_" + detailRowIndex);
                        }
                        else {
                            relateFieldValues_3[field] = __WEBPACK_IMPORTED_MODULE_7__util_excelUtil__["modeForm"].getFieldValue(field);
                        }
                    }
                    catch (e) {
                        relateFieldValues_3[field] = '';
                    }
                });
            }
            dataParams = __assign({}, dataParams, relateFieldValues_3, { "secretLevel": secretLevel }); //field45270:"6"
            conditionDataParams = __assign({}, conditionDataParams, relateFieldValues_3);
            completeParams = __assign({}, completeParams, relateFieldValues_3, { "secretLevel": secretLevel });
        }
        // let iconStyle:any = {};
        /**
         * fieldtype == '161' || fieldtype == '162')
         * 这两个自定义单多选的浏览框是建模和系统集成两部分工用的，这里不好控制，云商店沟通确定了在处理
         */
        // if(fieldtype == '256' || fieldtype == '257'){  //自定义树形单多选浏览框图标可以用户自定义
        // iconStyle.icon = card.iconInfo.icon;
        // iconStyle.iconBgcolor =card.iconInfo.iconBg;
        // iconStyle.iconFontColor =card.iconInfo.iconColor;
        // }
        //前端自定义浏览框属性覆盖
        var overBrowserProps = {};
        var customBrowserProp = card.browserPropMap[fieldName] || {};
        for (var key in customBrowserProp) {
            overBrowserProps[key] = customBrowserProp[key];
        }
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldtype": fieldtype, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaBrowser"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@hp0ja1" }, bind, browserProps, { dataParams: dataParams, conditionDataParams: conditionDataParams, destDataParams: destDataParams, completeParams: completeParams, hasAddBtn: hasAddBtn, addOnClick: this.addOnClick, layout: document.body, showDropMenu: showDropMenu, type: fieldtype, fieldName: fieldName, viewAttr: viewAttr, viewtype: isdetail ? "1" : "0", 
                    //disabledInput={disabledInput}
                    // title={label}
                    resize: false, maxBrowerHeight: 77, hasAdvanceSerach: hasAdvanceSerach }, otherProps, { replaceDatas: bind.value ? Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(bind.valueObj) : [], 
                    // valueObj={bind.valueObj.slice()}
                    scrollx: true, emptyValueNotClear: true, modalStyle: { width: 850 }, key: new Date().getTime() }, overBrowserProps, { onBeforeFocusCheck: function (success) {
                        if (seclevelInfo == 'field-9' && !secretLevel) { // 存在密级字段才进行必填提醒
                            __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(getLabel('530630', '请先填写卡片密级！'));
                        }
                        else {
                            success();
                        }
                    } })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" })))));
    };
    Browser = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], Browser);
    return Browser;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Browser);
//人力资源条件数据处理
var spellResourceCondition = function (datas) {
    if (datas) {
        var value_1 = [];
        datas.map(function (item) {
            var candownload = item.canDownload == '是' ? '1' : '0';
            if (item.sharetype == "1") {
                value_1.push("1_" + item.relatedshare + "_0_0_" + candownload);
            }
            else if (item.sharetype == "2" || item.sharetype == "3") {
                value_1.push(item.sharetype + "_" + item.relatedshare + "_0_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "4") {
                value_1.push("4_" + item.relatedshare + "_" + item.rolelevel + "_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "5") {
                value_1.push("5_0_0_" + item.seclevel.replace('-', '|@|') + "_" + candownload);
            }
            else if (item.sharetype == "6") {
                if (item.joblevel == '2') {
                    value_1.push("6_" + item.relatedshare + "_0_2|@|2_" + candownload);
                }
                else {
                    value_1.push("6_" + item.relatedshare + "_0_" + item.joblevel + "|@|" + item.jobfield + "_" + candownload);
                }
            }
        });
        return value_1.join('~');
    }
    return '';
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(109),
    getRawTag = __webpack_require__(453),
    objectToString = __webpack_require__(454);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(502);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(510);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reply__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailImport__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ModeExcel__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cube_trigger__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardTab__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__list_ShareStore__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MapStore__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CustomDialog__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__list__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__list_LogListStore__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_watermark__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__cubeUtil__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__quickEditStore__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_contentPath__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




























var getCurrentLabel = __WEBPACK_IMPORTED_MODULE_19_ecCom__["WeaInputLocale"].getCurrentLabel;
var getLabel = __WEBPACK_IMPORTED_MODULE_19_ecCom__["WeaLocaleProvider"].getLabel;
var CardStore = /** @class */ (function () {
    function CardStore() {
        var _this_1 = this;
        this.query = {};
        this.layoutType = '0';
        this.isOreadySubmit = true;
        this.pageError = false;
        this.errorMessage = '';
        this.layoutError = '';
        this.windowTitle = '';
        this.changeDataTime = '';
        this.datajson = {};
        this.modeTabKey = {};
        this.showReply = false;
        this.icon = 'icon-coms-ModelingEngine';
        this.iconBgcolor = "#96358a";
        this.categorytype = '';
        this.ifrmaeHeight = 0;
        this.uploadFields = [];
        this.isInline = false;
        this.modeExcel = new __WEBPACK_IMPORTED_MODULE_9__ModeExcel__["a" /* default */]();
        this.allFields = {};
        this.fieldsProps = {};
        this.loading = false;
        this.layoutBaseLoading = false;
        this.fieldsLoading = false;
        this.isInit = false;
        this.detailTable = {};
        this.Actions = new __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */](this);
        this.cardTab = new __WEBPACK_IMPORTED_MODULE_13__CardTab__["a" /* default */](this);
        this.params = {};
        this.layoutid = '';
        this.printEdcUrl = '';
        this.token = '';
        this.setTabearaActiveKey = {};
        this.share = new __WEBPACK_IMPORTED_MODULE_14__list_ShareStore__["default"]();
        this.mapStore = new __WEBPACK_IMPORTED_MODULE_15__MapStore__["a" /* default */](this);
        this.customDialog = new __WEBPACK_IMPORTED_MODULE_16__CustomDialog__["a" /* default */]();
        this.isSearchShow = false;
        this.isCardShow = false;
        this.isInTree = false;
        this.isShowReply = false;
        this.isLogListShow = false;
        this.empowmentType = ''; //是否开启临时赋权
        //是否允许点赞和踩
        this.isallowlike = '';
        this.likeshowname = '';
        this.isallowdislike = '';
        this.dislikeshowname = '';
        this.likecount = 0;
        this.dislikecount = 0;
        this.likestatus = '';
        this.seclevelInfo = '4';
        this.secretTimeDefValue = { 1: "20年", 2: "10年" };
        this.secretTimeDefStyle = { 0: "-1", 1: "1", 2: "1", 3: "-1", 4: "-1" };
        this.datastatus = 0; // 判断编辑布局是否为草稿状态 0：编辑，1：草稿
        this.base = {};
        this.orderbyfield = '';
        this.orderbytype = false;
        this.newParamsAdd = {};
        this.scriptCode = {};
        this.waterImg = "";
        this.targetHref = "";
        this.verified = false;
        this.hasRight = false; //权限
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.cardMarginParams = {
            padding: {
                top: 30,
                bottom: 30,
                left: 50,
                right: 50,
            }
        };
        this.variableMap = {};
        this.detailMap = {};
        this.browserPropMap = {};
        this.getEcmeFieldData = __WEBPACK_IMPORTED_MODULE_23_prop_types__["any"];
        this.ecmeFieldEventCallBack = __WEBPACK_IMPORTED_MODULE_23_prop_types__["any"];
        this.submitParam = {}; //存储额外的提交参数
        this.sliderParams = { sliderPercentage: '70', slideModalUrl: "" };
        this.slideModalVisible = false;
        this.showGlobalSpin = {
            isShow: 'none',
        };
        this.secondflag = true; //判断是否需要二次验证
        this.quickEditStore = new __WEBPACK_IMPORTED_MODULE_25__quickEditStore__["a" /* QuickEditStore */](this);
        this.reloadParams = {};
        this.modeTitleFieldArr = []; //用来存放控制标题变化的字段
        this.defaultValues = {}; //存储后端返回的明细默认值
        this.getModeTitleFieldFields = function (modeTitleFieldArr) {
            if (modeTitleFieldArr === void 0) { modeTitleFieldArr = []; }
            var fieldArr = [];
            modeTitleFieldArr.forEach(function (item) {
                if (item.fieldid) {
                    fieldArr.push(item.fieldid);
                }
            });
            _this_1.modeTitleFieldArr = fieldArr;
        };
        // 当组成标题的字段发生改变时，重新拼接标题字符串
        this.changeModeTitle = function (value, fieldName) {
            /***r如果没有设置字段为标题字段就不要走了 */
            if (_this_1.modeTitleFieldArr.indexOf(fieldName) < 0) {
                return;
            }
            if (_this_1.base.type == '0' || _this_1.base.type == '3') {
                return;
            }
            var escape2Html = function (str) {
                str = str.replace(/[\r\n]/g, "");
                var arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"', 'hellip': '…' };
                return str.replace(/&(lt|gt|nbsp|amp|quot|hellip);/ig, function (all, t) { return arrEntities[t]; });
            };
            //选择框字段用在模块标题中时 需要转换一下显示名。
            var _a = _this_1.getFieldProps(fieldName), fieldhtmltype = _a.fieldhtmltype, fieldtype = _a.fieldtype, options = _a.options;
            if (fieldhtmltype == 5 && fieldtype == 2 && value) {
                var val = value.split(",").sort();
                var showname = "";
                val.forEach(function (item) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_10__util_typeUtil__["h" /* isNumber */])(item)) {
                        var itemshowname = options.get(item).showname;
                        showname += " " + itemshowname;
                    }
                });
                if (showname != undefined && showname != '') {
                    value = showname.substring(1);
                }
            }
            var newModeTitle = [];
            if (_this_1.base.modeTitleFieldList) {
                _this_1.base.modeTitleFieldList.forEach(function (item) {
                    var val = item.value;
                    if (item.inputValue == '1' && item.fieldid == fieldName) {
                        val = item.value = value ? value.toString().replace(/<[^>]+>/g, "") : value; //当value为富文本框的值时，去除HTML标签，只保留文本内容
                    }
                    if (val != undefined && val != '') {
                        if (val.startsWith('base64_')) {
                            var Base64 = __WEBPACK_IMPORTED_MODULE_19_ecCom__["WeaTools"].Base64;
                            val = val.substring(7);
                            val = Base64.decode(val);
                        }
                        val = getCurrentLabel(val);
                    }
                    val = val ? escape2Html(val) : val;
                    newModeTitle.push(val);
                });
                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.trim(newModeTitle.join(''))) { // 当拼接出的标题字段为空时，将modeName作为默认标题展示，而不直接显示空白
                    _this_1.base.modeTitle = newModeTitle.join('');
                }
                else {
                    _this_1.base.modeTitle = _this_1.base.modeName;
                }
                if (__WEBPACK_IMPORTED_MODULE_5__util__["default"].location.href.indexOf('card') > -1 && __WEBPACK_IMPORTED_MODULE_5__util__["default"].location.href.indexOf('wui/index.html') == -1) { // 仅当为card时，保持windowTitle同步修改
                    _this_1.windowTitle = _this_1.base.modeTitle;
                }
            }
        };
        this.loadReply = function () {
            _this_1.reply = new __WEBPACK_IMPORTED_MODULE_3__reply__["a" /* default */]({ pagesize: _this_1.reply ? _this_1.reply.pagesize : 5 });
            var p = _this_1.params;
            if (_this_1.base && _this_1.base.replyposition) {
                p = __assign({}, _this_1.params, { replyposition: _this_1.base.replyposition });
            }
            _this_1.reply.updateParams(p);
        };
        this.setRefreshParams = function (fieldObj) {
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(fieldObj, function (objvalue, fieldid) {
                if (objvalue.isdetail) {
                    __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(_this_1.allFields, fieldid + ".order", null);
                }
            });
        };
        this.refreshDetail = function (field, orderbytype) {
            var detail = _this_1.getFieldProps(field).detail;
            var datas = _this_1.cubeForm.getDetailInitData(detail);
            var _a = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this_1.allFields, field), fieldhtmltype = _a.fieldhtmltype, fieldtype = _a.fieldtype;
            var _datas = [];
            if (!orderbytype) { //降序
                if (fieldhtmltype == 1 && fieldtype != 1) { //整数或浮点数
                    _datas = datas.sort(function (a, b) {
                        a = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(a, field);
                        b = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(b, field);
                        if (a == '')
                            return -1;
                        if (b == '')
                            return 1;
                        return a - b;
                    });
                }
                else {
                    _datas = datas.sort(function (a, b) { return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(a, field) > __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(b, field) ? 1 : -1; });
                }
            }
            else { // 升序
                if (fieldhtmltype == 1 && fieldtype != 1) { //整数或浮点数
                    _datas = datas.sort(function (a, b) {
                        a = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(a, field);
                        b = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(b, field);
                        if (a == '')
                            return 1;
                        if (b == '')
                            return -1;
                        return b - a;
                    });
                }
                else {
                    _datas = datas.sort(function (a, b) { return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(b, field) > __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(a, field) ? 1 : -1; });
                }
            }
            if (_this_1.cubeForm.has(detail)) {
                _this_1.cubeForm.$(detail).map(function (r) {
                    _this_1.cubeForm.$(detail).del(r.key);
                });
            }
            _this_1.initDetailDatas(_datas, detail, _this_1.defaultValues);
        };
        this.getFieldProps = function (path) {
            return __assign({}, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this_1.allFields, path));
            //return { ..._.get(this.allFields, path), needSum: this.needSumFields.indexOf(path) > -1 }
        };
        /***获取快速编辑的状态 */
        this.getFieldEditState = function (path) {
            return __assign({}, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this_1.fieldsProps, path));
        };
        this.getDetailTable = function (path) {
            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this_1.detailTable, path) || {};
        };
        this.addDetailDefaultDatas = function () {
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(_this_1.detailTable, function (detail) {
                if (detail.isDefault && _this_1.cubeForm.$("detail_" + detail.orderid).values().length === 0) {
                    //    this.cubeForm.addRow(detail.orderid);
                    if (detail.adddefaultrow != undefined && _this_1.base.type == '1') { //只有新建布局默认新增明细生效
                        for (var i = 0; i < detail.adddefaultrow; i++) {
                            _this_1.cubeForm.addRow(detail.orderid);
                        }
                    }
                }
            });
        };
        this.getDetailTables = function (params) {
            if (params === void 0) { params = _this_1.params; }
            Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["H" /* initDetail */])(params).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, detailTable = _a.detailTable;
                if (status == '1') {
                    if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(detailTable)) {
                        _this_1.cubeTrigger.init(params, _this_1.addDetailDefaultDatas).then(function () {
                            if (_this_1.ecmecallBack && typeof _this_1.ecmecallBack == 'function')
                                _this_1.ecmecallBack();
                            try {
                                if (_this_1.params.isecmeview && _this_1.params.isecmeview === "1") {
                                    __WEBPACK_IMPORTED_MODULE_5__util__["default"].parent.ecmeLayoutCache(params.type);
                                }
                            }
                            catch (e) {
                            }
                        });
                    }
                    // this.isDetailLoaded = true;
                    _this_1.detailTable = detailTable;
                    var getDetailFieldArr_1 = [];
                    var detailArr_1 = [];
                    __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(detailTable, function (detail, key) {
                        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(_this_1.modeExcel.details, "detail_" + detail.orderid + ".detailProps", detail);
                        if (_this_1.cubeForm.has(key)) {
                            _this_1.cubeForm.$(key).pageSize = detail.detailPageSize || 10; //更新明细表的分页pagesize
                        }
                        getDetailFieldArr_1.push(Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["s" /* getDetailFields */])(__assign({}, params, { tablename: detail.tablename, formId: detail.formId, groupid: detail.orderid - 1 })));
                        detailArr_1.push(detail);
                    });
                    getDetailFieldArr_1.length > 0 && Promise.all(getDetailFieldArr_1).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (result) {
                        result.map(function (_a, index) {
                            var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas, defaultValue = _a.defaultValue, orders = _a.orders;
                            if (status !== "1") {
                                __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                                return;
                            }
                            _this_1.defaultValues = defaultValue;
                            _this_1.DetailDatas = datas;
                            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(orders, function (order, fieldid) {
                                __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(_this_1.allFields, "field" + fieldid + ".order", order === 'desc');
                            });
                            var detailPageSize = Number(detailArr_1[index].detailPageSize);
                            if (detailArr_1[index].isPagination) { //如果启动分期，初始化form异步加载
                                _this_1.initDetailDatas(datas.slice(0, detailPageSize), "detail_" + detailArr_1[index].orderid, defaultValue);
                                var _this_2 = _this_1;
                                setTimeout(function () {
                                    _this_2.initDetailDatas(datas.slice(detailPageSize), "detail_" + detailArr_1[index].orderid, defaultValue, detailPageSize, _this_2.cubeTrigger.doRowColConsComputed);
                                }, 100);
                            }
                            else {
                                _this_1.initDetailDatas(datas, "detail_" + detailArr_1[index].orderid, defaultValue);
                            }
                            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(_this_1.detailTable, detailArr_1[index] + ".defaultValue", defaultValue);
                        });
                    })).then(function () {
                        _this_1.cubeTrigger.init(params, _this_1.addDetailDefaultDatas).then(function () {
                            if (_this_1.ecmecallBack && typeof _this_1.ecmecallBack == 'function')
                                _this_1.ecmecallBack();
                            try {
                                if (_this_1.params.isecmeview && _this_1.params.isecmeview === "1") {
                                    __WEBPACK_IMPORTED_MODULE_5__util__["default"].parent.ecmeLayoutCache(params.type);
                                }
                            }
                            catch (e) {
                            }
                        });
                    });
                    try {
                        var that_1 = _this_1;
                        setTimeout(function () {
                            __WEBPACK_IMPORTED_MODULE_5__util__["default"].checkCustomize = ""; //每次清除这个二次校验得方法
                            __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#custompageCodeArea").append(that_1.scriptCode.codejs);
                            var uuid = __WEBPACK_IMPORTED_MODULE_5__util__["default"].location.hash.slice(__WEBPACK_IMPORTED_MODULE_5__util__["default"].location.hash.lastIndexOf("=") + 1), idname = "#custompageCodeArea-" + uuid;
                            if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()(idname).length > 0) {
                                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(idname).append(that_1.scriptCode.codejs);
                            }
                        }, 500);
                    }
                    catch (e) {
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this_1.fieldsLoading = false;
            }));
        };
        this.initDetailDatas = function (datas, detail, defaultValue, startkey, callback) {
            if (startkey === void 0) { startkey = 0; }
            if (_this_1.cubeForm) {
                _this_1.cubeForm.initDetailDatas(datas, detail, _this_1.allFields, defaultValue, startkey, callback);
            }
            else {
                _this_1.initDetailDatas(datas, detail, defaultValue);
            }
            _this_1.doSelectItemChange(); //下拉框联动
        };
        this.showDetailImport = function () {
            _this_1.detailImport = new __WEBPACK_IMPORTED_MODULE_6__DetailImport__["a" /* default */]();
            _this_1.detailImport.initCard = _this_1.init.bind(_this_1, _this_1.params);
            _this_1.detailImport.uploadParams = __assign({ isImportDetail: true }, _this_1.params);
            _this_1.detailImport.modename = _this_1.base.modeName;
            _this_1.detailImport.show();
        };
        this.init = function (params, callback) {
            _this_1.clear();
            __WEBPACK_IMPORTED_MODULE_20__apis__["a" /* default */].getAppInfoByID({ modeid: params.modeId }).then(function (data) {
                if (data.status == "1") {
                    _this_1.iconInfo = {
                        icon: data.icon || "icon-coms-ModelingEngine",
                        iconColor: data.iconColor || "#fff",
                        iconBg: data.iconBg || "#96358a"
                    };
                }
            });
            _this_1.cubeForm = undefined;
            _this_1.mapStore = new __WEBPACK_IMPORTED_MODULE_15__MapStore__["a" /* default */](_this_1);
            _this_1.modeExcel = new __WEBPACK_IMPORTED_MODULE_9__ModeExcel__["a" /* default */]();
            _this_1.cardTab = new __WEBPACK_IMPORTED_MODULE_13__CardTab__["a" /* default */](_this_1); //qc： 504122  去掉了，需要回归这个一下
            _this_1.isInline = params.istabinline == '1';
            __WEBPACK_IMPORTED_MODULE_5__util__["default"].changeLoadingState = _this_1.changeLoadingState;
            _this_1.params = params;
            var uuid = Object(__WEBPACK_IMPORTED_MODULE_10__util_typeUtil__["g" /* guid */])();
            var _params = __assign({}, params, { uuid: uuid });
            _this_1.mapStore.showButtons = params.type == '1' || params.type == '2';
            _this_1.loading = true;
            _this_1.isInit = false;
            Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["b" /* checkCardRight */])(_params).then(function (_a) {
                var hasRight = _a.hasRight, data = __rest(_a, ["hasRight"]);
                if (!hasRight) {
                    _this_1.hasRight = false;
                    _this_1.verified = true;
                    _this_1.isInit = true;
                    _this_1.loading = false;
                    return;
                }
                else {
                    CardStore.isTitleChanged = "0";
                    _this_1.hasRight = true;
                    _this_1.verified = true;
                    var datas_1 = [];
                    _this_1.getCardMarginData(_params);
                    Promise.all([
                        Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["z" /* getModeBase */])(_params),
                        Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["M" /* mainFields */])(_params)
                    ]).then(function (res1) {
                        datas_1 = res1;
                        if (undefined != datas_1[1].changeDataTime) {
                            _this_1.changeDataTime = datas_1[1].changeDataTime;
                        }
                        _this_1.seclevelInfo = datas_1[1].seclevelInfo;
                        _this_1.secretTimeDefValue = datas_1[1].secretTimeDefValue;
                        _this_1.secretTimeDefStyle = datas_1[1].secretTimeDefStyle;
                        if (!datas_1[1].isTitle) {
                            if (datas_1[0].modeTitle.startsWith('base64_')) {
                                var Base64 = __WEBPACK_IMPORTED_MODULE_19_ecCom__["WeaTools"].Base64;
                                datas_1[0].modeTitle = Base64.decode(datas_1[0].modeTitle.substring(7));
                            }
                            if (!datas_1[0].modeTitle) {
                                datas_1[0].modeTitle = datas_1[0].modeName;
                            }
                            _this_1.windowTitle = datas_1[0].modeTitle;
                        }
                        if (_this_1.windowTitle != undefined && _this_1.windowTitle != '') {
                            if (_this_1.windowTitle.startsWith('base64_')) {
                                var Base64 = __WEBPACK_IMPORTED_MODULE_19_ecCom__["WeaTools"].Base64;
                                _this_1.windowTitle = _this_1.windowTitle.substring(7);
                                _this_1.windowTitle = Base64.decode(_this_1.windowTitle);
                            }
                        }
                        _this_1.isfrontmultlang = datas_1[0]["isfrontmultlang"] || 0;
                        var modedatastatus = datas_1[0]['modedatastatus'] || 0;
                        _this_1.empowmentType = datas_1[0]['empowmentType'] || "";
                        _this_1.isallowlike = datas_1[0]['isallowlike'] || "0";
                        _this_1.likeshowname = datas_1[0]['likeshowname'] || "";
                        _this_1.isallowdislike = datas_1[0]['isallowdislike'] || "0";
                        _this_1.dislikeshowname = datas_1[0]['dislikeshowname'] || "";
                        _this_1.base.defaultcontraction = datas_1[0]['defaultcontraction'] || "";
                        var billidtemp = datas_1[0]['billid'] || "";
                        if (billidtemp != undefined && billidtemp != '') {
                            _this_1.params.billid = billidtemp;
                        }
                        if (_this_1.base.billid != undefined && _this_1.base.billid != '') {
                            datas_1[0]['billid'] = _this_1.base.billid;
                        }
                        else {
                            datas_1[0]['billid'] = _params.billid;
                        }
                        _this_1.initCardLikeInfo(_params);
                        return Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["K" /* layoutBase */])(__assign({}, _params, { modedatastatus: modedatastatus }));
                    }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (res2) {
                        /* 存在密级字段且密级字段可编辑，需要添加保密期限字段，用于必填校验 */
                        if (res2.fields && res2.fields.hasOwnProperty('field-9') && res2.fields['field-9'].isedit == "1") {
                            res2.fields['field-10'] = { editstate: "1", fieldid: "-10", fieldname: "modesecrettime", isedit: "1", ishide: "", ismandatory: "1", isview: "1", orderid: "18" };
                        }
                        datas_1.push(res2);
                        var layoutid = datas_1[2].layoutid;
                        //开启了二次身份验证
                        try {
                            __WEBPACK_IMPORTED_MODULE_5__util__["default"].doCheckSecondaryVerify4ec({ mouldCode: "FORMMODE", itemCode: "PAGE", layoutid: layoutid }, function (res) {
                                if (res.status == '1') {
                                    _this_1.initcardothers(params, datas_1, _params, callback);
                                }
                                else {
                                    _this_1.hasRight = false;
                                    _this_1.loading = false;
                                }
                            });
                        }
                        catch (_a) {
                            _this_1.initcardothers(params, datas_1, _params, callback);
                        }
                    }));
                }
            });
        };
        //初始化卡片页面
        this.initcardothers = function (params, datas, _params, callback) {
            var _a = datas[0], status0 = _a.status, errorCode0 = _a.errorCode, error0 = _a.error, modeTitleFieldList = _a.modeTitleFieldList, card = __rest(_a, ["status", "errorCode", "error", "modeTitleFieldList"]);
            var _b = datas[2], status = _b.status, errorCode = _b.errorCode, error = _b.error, errorPage = _b.errorPage, msg = _b.message, datajson = _b.datajson, showReply = _b.showReply, fields = _b.fields, layoutid = _b.layoutid, datastatus = _b.datastatus, layoutType = _b.layoutType, printEdcUrl = _b.printEdcUrl, script = _b.script, token = _b.token, detailOpenCustomOrder = _b.detailOpenCustomOrder, custompage = _b.custompage, newProps = __rest(_b, ["status", "errorCode", "error", "errorPage", "message", "datajson", "showReply", "fields", "layoutid", "datastatus", "layoutType", "printEdcUrl", "script", "token", "detailOpenCustomOrder", "custompage"]);
            var _c = datas[1], status1 = _c.status, errorCode1 = _c.errorCode, error1 = _c.error, fields1 = _c.fields;
            if (status0 != '1') {
                __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode0) + "]:" + error0);
            }
            else if (status != '1') {
                __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
            }
            else if (status1 != '1') {
                __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode1) + "]:" + error1);
            }
            else if (errorPage) {
                __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error(msg);
            }
            else {
                /****
                 * 加个接口判断是不是有e8或者e9布局
                 * layoutType == '1' e8
                 */
                if (layoutType == '1') {
                    //暂时先这样做后续修改为将解析的html布局内容直接以innerHtml的方式嵌入新页面
                    var query = __WEBPACK_IMPORTED_MODULE_5__util__["default"].weaHistory.getCurrentLocation().query;
                    var queryStr = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mapKeys(query, function (value, key) {
                        return key + "=" + value;
                    })).join("&");
                    if (params.type == '4') {
                        __WEBPACK_IMPORTED_MODULE_5__util__["default"].location.href = Object(__WEBPACK_IMPORTED_MODULE_26__util_contentPath__["a" /* getContentPath */])("/formmode/view/FormModePrint.jsp?" + queryStr);
                    }
                    else {
                        var doThemeAction = __WEBPACK_IMPORTED_MODULE_5__util__["default"].doThemeAction;
                        if (typeof doThemeAction == 'function') {
                            __WEBPACK_IMPORTED_MODULE_5__util__["default"].doThemeAction('onLoadMain', {
                                url: Object(__WEBPACK_IMPORTED_MODULE_26__util_contentPath__["a" /* getContentPath */])("/formmode/view/AddFormMode.jsp?" + queryStr),
                                target: 'mainFrame'
                            });
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_5__util__["default"].location.href = Object(__WEBPACK_IMPORTED_MODULE_26__util_contentPath__["a" /* getContentPath */])("/formmode/view/AddFormMode.jsp?" + queryStr);
                        }
                    }
                    return;
                }
                // if (this.params && !this.params['isbatchprint']) {
                //     /**
                //      * //这里打印模板的时候，有的方法需要先执行下，但是直接都执行了可能会有坑，
                //      * 暂时不知道会有啥，具体遇见再看，插入代码快控制radio样式加的
                //      */
                //     if (params.type == '4') {
                //         try {
                //             $("#custompageCodeArea").html("").append(script);
                //         } catch (error) {}
                //     }
                // }
                _this_1.modeExcel.isDragulaMap = detailOpenCustomOrder || {};
                if (custompage && custompage != "") {
                    _this_1.docustompage(custompage, params);
                }
                _this_1.addCode(script);
                _this_1.getModeTitleFieldFields(modeTitleFieldList);
                _this_1.base = __assign({}, card, { modeTitleFieldList: modeTitleFieldList });
                _this_1.token = token;
                _this_1.layoutBase = __assign({}, newProps);
                /*不关联模块的浏览框解决*/
                _this_1.params = __assign({ billid: card.billid }, _this_1.params, { modeId: card.modeId });
                _params = __assign({}, _params, { modeId: card.modeId });
                _this_1.cubeTrigger = new __WEBPACK_IMPORTED_MODULE_12__cube_trigger__["a" /* default */](_this_1);
                _this_1.loadReply();
                if (callback && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isFunction(callback)) {
                    if (_this_1.params.isecme && _this_1.params.isecme === "1") {
                        _this_1.ecmecallBack = callback;
                    }
                    else {
                        callback();
                    }
                }
                _this_1.layoutid = layoutid;
                _this_1.datastatus = datastatus;
                if (params.type == '0') {
                    _this_1.printEdcUrl = printEdcUrl;
                }
                _this_1.scriptCode = script;
                var newParams = __assign({}, _params, { layoutid: layoutid, modedatastatus: card.modedatastatus || "" });
                // this.newParamsAdd = newParams;
                _this_1.cardTab.init(newParams);
                _this_1.getDetailTables(newParams);
                _this_1.showReply = showReply;
                _this_1.allFields = fields1;
                //this.setRefreshParams(fields1);
                var uploadFields_1 = [];
                __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(fields1, function (f, k) {
                    if (f.fieldhtmltype == '6') {
                        uploadFields_1.push(k);
                    }
                });
                _this_1.uploadFields = uploadFields_1;
                _this_1.modeExcel.init(datajson, params.type);
                _this_1.reloadParams = __assign({}, newParams, { datajson: datajson });
                _this_1.cubeForm = Object(__WEBPACK_IMPORTED_MODULE_11__form__["b" /* getLayoutFields */])(fields1, _this_1, __assign({}, newParams, { datajson: datajson })); //初始化card form
                // this.base = {...card} as any;
                _this_1.fieldsProps = fields;
                _this_1.isInit = true;
                _this_1.doSelectItemChange();
                _this_1.getWaterMarkImg(card.modeId);
                // setTimeout(() => {
                // this.cubeTrigger.init(newParams, this.addDetailDefaultDatas);
                // }, 300)
                if (_this_1.params && !_this_1.params['isbatchprint']) {
                    if (params.type == '4') {
                        __WEBPACK_IMPORTED_MODULE_7_jquery___default()("body").addClass("printBody");
                        setTimeout(function () {
                            __WEBPACK_IMPORTED_MODULE_5__util__["default"].print();
                        }, 3000);
                    }
                }
            }
            _this_1.loading = false;
            CardStore.isTitleChanged = "1";
        };
        this.addCode = function (scriptCode) {
            try {
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#custompageCodeArea").html("");
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#custompageCodeArea").append(scriptCode.codecss);
                var uuid = __WEBPACK_IMPORTED_MODULE_5__util__["default"].location.hash.slice(__WEBPACK_IMPORTED_MODULE_5__util__["default"].location.hash.lastIndexOf("=") + 1), idname = "#custompageCodeArea-" + uuid;
                if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()(idname).length > 0) {
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(idname).html("");
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(idname).append(scriptCode.codecss);
                }
            }
            catch (e) { }
        };
        this.docustompage = function (address, params) {
            params["__address__"] = address;
            params["formmodeid"] = params.modeId;
            params["formid"] = params.formId;
            Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["l" /* docustompage */])(params).then(function (result) {
                setTimeout(function () {
                    try {
                        var tempstr = Object(__WEBPACK_IMPORTED_MODULE_24__cubeUtil__["manageScriptContent"])(result);
                        __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#custompageCodeArea").append("<div class=\"_custom_script_\">" + tempstr + "</div>");
                    }
                    catch (e) {
                        if (__WEBPACK_IMPORTED_MODULE_5__util__["default"].console) {
                            console.log(e);
                        }
                    }
                }, 100);
            });
        };
        this.getWaterMarkImg = function (id) {
            var pagetype = _this_1.base.type;
            Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["G" /* getWaterMarkImg */])({ modeid: id }).then(function (data) {
                if (data.status == '1') {
                    if (data.isWatermark == 1 && (pagetype == '3' || pagetype == '4' || pagetype == '0')) { //开启,显示，打印，监控布局
                        if (data.waterType == "0") { //文字
                            _this_1.waterImg = __WEBPACK_IMPORTED_MODULE_21__pages_watermark__["a" /* __waterDocumentSvg */](__assign({}, data));
                        }
                        else {
                            _this_1.waterImg = "data:image/png;base64," + data.img; //data:image/png;base64,
                        }
                    }
                    else {
                        _this_1.waterImg = "";
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("" + getLabel(127353, '错误'));
                }
            });
        };
        this.getQuery = function (href) {
            var lastofnum = href.lastIndexOf('?');
            href = href.slice(lastofnum);
            var query = href.split('?')[1];
            var querys = query.split("&");
            var queryObj = {};
            // _.set(queryObj, url, url)
            querys.map(function (q) {
                // const [name, value] = q.split("=");
                var index = q.indexOf("=");
                var name = q.substring(0, index);
                var value = decodeURIComponent(q.substring(index + 1));
                __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(queryObj, name, value);
            });
            return queryObj;
        };
        this.showSearch = function (href) {
            _this_1.isSearchShow = true;
            __WEBPACK_IMPORTED_MODULE_17__list__["default"].reloadSearch(_this_1.getQuery(href), _this_1);
        };
        this.showCard = function (href) {
            _this_1.isCardShow = true;
            if (!_this_1.card) {
                _this_1.card = new CardStore();
            }
            _this_1.card.targetHref = href;
            _this_1.card.reloadSearch(_this_1.getQuery(href), _this_1);
        };
        this.innerCardInit = function (param) {
            if (param === void 0) { param = {}; }
            _this_1.reloadSearch(param, _this_1);
        };
        this.showInnerReply = function (href) {
            _this_1.isShowReply = true;
            if (href.indexOf('isfromTab=1') > -1) {
                _this_1.reply.setFromTabInfo(true);
            }
        };
        this.showInnerLogList = function (href) {
            _this_1.isLogListShow = true;
            __WEBPACK_IMPORTED_MODULE_18__list_LogListStore__["a" /* default */].updateParams(_this_1.getQuery(href));
        };
        this.doSelectItemChange = function (newRow) {
            var detailField = {};
            for (var i in _this_1.allFields) {
                if (_this_1.allFields[i].isdetail == true) {
                    detailField[i] = _this_1.allFields[i];
                }
            }
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(newRow ? detailField : _this_1.allFields, function (field, key) {
                var changeSelectItem = function (form, field, key, changeFieldId, isChangeValue) {
                    if (form.has(key) && field.options && form.has(changeFieldId)) {
                        var value_1 = form.$(key).getValue();
                        var filterOptions_1 = [];
                        field.options.slice().map(function (option) {
                            if (option.key == value_1) {
                                var options = _this_1.getFieldProps(changeFieldId).options;
                                filterOptions_1 = options.filter(function (opt) { return option.childitemid.indexOf(opt.key) > -1; });
                            }
                        });
                        var changeField_1 = form.$(changeFieldId);
                        changeField_1.set("options", filterOptions_1.filter(function (d) { return d.cancel != '1'; }));
                        if (filterOptions_1 != undefined && !isChangeValue) {
                            var filterOptions_KeyArr_1 = filterOptions_1.map(function (d) { return d.key; });
                            var defaultOptions_KeyArr_1 = filterOptions_1.filter(function (d) { return d.isdefault == 'y'; });
                            changeField_1.getValue().split(',').forEach(function (item) {
                                if (filterOptions_KeyArr_1.indexOf(item) < 0) {
                                    var v = defaultOptions_KeyArr_1.length > 0 ? defaultOptions_KeyArr_1[0]['key'] : '';
                                    changeField_1.onChange(v);
                                }
                            });
                            // changeField.onChange('');
                        }
                    }
                };
                var doSelectItem = function (field, key, index, isChangeValue) {
                    var _a = _this_1.getFieldProps(key), isdetail = _a.isdetail, detail = _a.detail;
                    var changeFieldId = "field" + field.childfieldid;
                    if (isdetail) {
                        if (_this_1.cubeForm.has(detail)) {
                            _this_1.cubeForm.$(detail).map(function (row) {
                                if (index && row.key != index) {
                                    return null;
                                }
                                changeSelectItem(row, field, key, changeFieldId, isChangeValue);
                            });
                        }
                    }
                    else {
                        changeSelectItem(_this_1.cubeForm, field, key, changeFieldId, isChangeValue);
                    }
                };
                if (field.fieldhtmltype == '5' && field.childfieldid && field.childfieldid != '-1' && field.options && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(field.options.slice())) {
                    // 新建布局和点击新增明细时选择框才联动出默认值,其余情况只更新option
                    var isChangeValue = _this_1.base.type == '1' && !newRow ? '' : 1;
                    doSelectItem(field, key, '', isChangeValue);
                    _this_1.cubeTrigger.addOnChange(key, function (index) {
                        doSelectItem(__assign({}, field), key, index);
                    });
                }
            });
        };
        this.changeLoadingState = function (bool) {
            if (bool === void 0) { bool = false; }
            _this_1.loading = bool;
            var tabcontentframe = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_5__util__["default"].frames, 'tabcontentframe');
            if (tabcontentframe) {
                try {
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#tabcontentframe').height(Math.max(__WEBPACK_IMPORTED_MODULE_7_jquery___default()(__WEBPACK_IMPORTED_MODULE_5__util__["default"].frames['tabcontentframe'].document).find('.coms-mode-docker').height(), __WEBPACK_IMPORTED_MODULE_7_jquery___default()(".cube-card-iframe").height() - 5));
                }
                catch (e) { }
            }
        };
        this.chooseDocCategroy = function (selectFieldId) {
            var field = "field" + selectFieldId;
            var _a = _this_1.getFieldProps(field), _b = _a.options, options = _b === void 0 ? [] : _b, fieldlabel = _a.fieldlabel;
            if (_this_1.cubeForm.has(field)) {
                var value_2 = _this_1.cubeForm.$(field).getValue();
                var selectOpt = options.filter(function (opt) { return opt.key == value_2; });
                if (selectOpt.length > 0) {
                    var category = {};
                    var opt = selectOpt[0];
                    if (opt.docCategory) {
                        var _c = opt.docCategory.split(","), mainCategory = _c[0], subCategory = _c[1], secCategory = _c[2];
                        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(category, 'mainCategory', mainCategory);
                        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(category, 'subCategory', subCategory);
                        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(category, 'secCategory', secCategory);
                        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(category, 'maxUploadSize', opt.maxUploadSize > 0 ? opt.maxUploadSize : 5);
                    }
                    return category;
                }
            }
            return { msg: "" + (getLabel(125389, '请先选择') + fieldlabel) };
        };
        this.getDataParams = function (fieldid, form) {
            var currenttime = new Date().getTime();
            var fields = { currenttime: currenttime };
            _this_1.cubeForm.map(function (f) {
                if (f.key.startsWith('field')) {
                    var fieldname = _this_1.getFieldProps(f.key).fieldname;
                    __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(fields, fieldname + "_" + currenttime, f.getValue());
                }
            });
            var isdetail = _this_1.getFieldProps(fieldid).isdetail;
            if (isdetail) {
                form.map(function (f) {
                    if (f.key.startsWith('field')) {
                        var _a = _this_1.getFieldProps(f.key), fieldname = _a.fieldname, detailtable = _a.detailtable;
                        fields[detailtable + "_" + fieldname + "_" + currenttime] = f.getValue();
                    }
                });
            }
            return fields;
        };
        this.getDataParamsForSql = function (fieldid, form, sqlNeedFieldKey) {
            var currenttime = new Date().getTime();
            var fields = { currenttime: currenttime };
            var that = _this_1;
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(sqlNeedFieldKey, function (value, sql) {
                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.parseInt(sql) % 2 === 0) {
                    that.cubeForm.map(function (f) {
                        var fieldname = that.getFieldProps(f.key).fieldname;
                        if (f.key.startsWith('field') && fieldname.toLowerCase() === value) {
                            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(fields, fieldname + "_" + currenttime, f.getValue());
                        }
                    });
                }
                else {
                    var isdetail = that.getFieldProps(fieldid).isdetail;
                    if (isdetail) {
                        form.map(function (f) {
                            var _a = that.getFieldProps(f.key), fieldname = _a.fieldname, detailtable = _a.detailtable;
                            if (f.key.startsWith('field') && fieldname.toLowerCase() === value) {
                                fields[detailtable + "_" + fieldname + "_" + currenttime] = f.getValue();
                            }
                        });
                    }
                }
            });
            return fields;
        };
        this.update = function (param) {
            for (var key in param) {
                _this_1[key] = param[key];
            }
        };
        this.reloadSearch = function (params, card) {
            if (card) {
                _this_1.parentCard = card;
            }
            _this_1.init(params);
        };
        this.updateParams = function (params) {
            params = Object(__WEBPACK_IMPORTED_MODULE_10__util_typeUtil__["i" /* transitionCode */])(params);
            //若链接传有同名参数则只取第一个参数值
            var keys = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.keys(params);
            for (var i = 0; i < keys.length; i++) {
                if (params[keys[i]].constructor == Array) {
                    params[keys[i]] = params[keys[i]][0];
                }
            }
            //若链接传有同名参数则只取第一个参数值
            var temp = !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.params), params);
            _this_1.params = params;
            if (temp) {
                _this_1.reloadSearch(params);
            }
        };
        this.setBrowserProps = function (fieldid, params) {
            if (params === void 0) { params = {}; }
            if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(params)) {
                __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(_this_1.allFields, fieldid + ".browserProps.dataParams", __assign({}, _this_1.allFields.fieldid.browserProps.dataParams, params));
                return;
            }
        };
        this.clear = function () {
            _this_1.isSearchShow = false;
            _this_1.isCardShow = false;
            _this_1.isInTree = false;
            _this_1.isShowReply = false;
            if (_this_1.reply) {
                _this_1.reply.setFromTabInfo(false);
            }
            _this_1.isLogListShow = false;
            __WEBPACK_IMPORTED_MODULE_22__util_excelUtil__["modeForm"].__propertyChangeFnObj = {};
            __WEBPACK_IMPORTED_MODULE_22__util_excelUtil__["modeForm"].__detailFieldChangeFnObj = {};
            __WEBPACK_IMPORTED_MODULE_22__util_excelUtil__["modeForm"].actionFnList = {};
            _this_1.scriptCode = {};
            _this_1.isOreadySubmit = true;
            _this_1.sliderParams = { sliderPercentage: '70', slideModalUrl: "" };
            _this_1.base.billid = '';
            _this_1.submitParam = {};
        };
        this.getCardMarginData = function (param) {
            Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["p" /* getCardMarginData */])(param).then(function (data) {
                if (data.status == "1") {
                    var res = data.datas;
                    var type = res.type || "0";
                    var padding = {};
                    if (type == "0") { //标准
                        padding = {
                            top: 30,
                            bottom: 30,
                            left: 50,
                            right: 50,
                        };
                    }
                    else if (type == "1") { //无边距
                        padding = {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                        };
                    }
                    else { //自定义边距
                        padding = {
                            top: res.top,
                            bottom: res.bottom,
                            left: res.left,
                            right: res.right,
                        };
                    }
                    _this_1.cardMarginParams = { padding: padding };
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error(getLabel(127353, "错误") + " :" + data.error);
                }
            });
        };
        this.saveDetailPageSize = function (size, detail) {
            var detail_num = detail.split('_')[1];
            var params = {
                layoutid: _this_1.layoutid,
                modeId: _this_1.base.modeId,
                type: _this_1.base.type,
                modedatastatus: _this_1.base.modedatastatus,
                detailPageSize: size,
                detail_num: detail_num,
                billid: _this_1.base.billid
            };
            Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["j" /* doSaveDetailPagesize */])(params).then(function (data) {
            });
        };
        this.reloadCard = function (obj) {
            if (obj === void 0) { obj = {}; }
            var params = __assign({}, _this_1.params, obj);
            _this_1.init(params);
        };
        this.controlDetailRowAttr = function (detailMark, obj) {
            if (obj === void 0) { obj = {}; }
            var newMap = __assign({}, _this_1.detailMap);
            if (!newMap[detailMark]) {
                newMap[detailMark] = {};
            }
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(obj, function (v, k) {
                newMap[detailMark][k] = v;
                if (v['disableCheck'] && v['disableCheck'] == true) {
                    _this_1.cubeForm.controlDetailCheck(detailMark, k, false);
                }
            });
            _this_1.detailMap = newMap;
        };
        this.controlBrowserProp = function (fieldMark, obj) {
            if (obj === void 0) { obj = {}; }
            var newMap = __assign({}, _this_1.browserPropMap);
            if (!newMap[fieldMark]) {
                newMap[fieldMark] = {};
            }
            newMap[fieldMark] = obj;
            _this_1.browserPropMap = newMap;
        };
        this.showSlideModal = function (bool, url, percentage) {
            if (percentage === void 0) { percentage = '70'; }
            url = Object(__WEBPACK_IMPORTED_MODULE_5__util__["replaceE8Url"])(url);
            url = url.replace(/&_key=\w{1,10}&/g, '&'); //去掉用户配置多加的key
            url = Object(__WEBPACK_IMPORTED_MODULE_10__util_typeUtil__["b" /* checkHref */])(url);
            if (bool) {
                _this_1.sliderParams = {
                    slideModalUrl: url,
                    sliderPercentage: percentage
                };
            }
            else {
            }
            _this_1.slideModalVisible = bool;
            //weaTop层级问题,列表内嵌卡片滑出头部被遮盖了
            if (bool) {
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.wea-new-top-req-wapper .wea-new-top-req').css({ zIndex: 0 });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()('.wea-new-top-req-wapper .wea-new-top-req').css({ zIndex: 1 });
            }
        };
        //二次密码验证
        this.doSecondaryVirty = function (params, datas, _params, callback) {
            var getLabel = __WEBPACK_IMPORTED_MODULE_19_ecCom__["WeaLocaleProvider"].getLabel;
            var layoutid = datas[2].layoutid;
            var url = Object(__WEBPACK_IMPORTED_MODULE_26__util_contentPath__["a" /* getContentPath */])("/spa/hrm/index_mobx.html#/main/hrmSingle/secondaryVerify/30");
            var onSecondaryCancel = function () {
            };
            var onCallbackHandle = function (f) {
                if (f == 'success') {
                    __WEBPACK_IMPORTED_MODULE_20__apis__["a" /* default */].updateFreeSecretTime({ layoutid: layoutid }).then(function (data) {
                        if (data.result) {
                            _this_1.reloadCard(params);
                            _this_1.secondflag = false;
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error(data.message);
                        }
                    });
                }
            };
            var showSecondaryVirty = function () { return __awaiter(_this_1, void 0, void 0, function () {
                var _this_1 = this;
                return __generator(this, function (_a) {
                    __WEBPACK_IMPORTED_MODULE_20__apis__["a" /* default */].modeSecondaryVerify({ layoutid: layoutid }).then(function (data) {
                        if (data.status == '1') {
                            if (data.isNeedSecondPwdVerify) {
                                _this_1.hasRight = false;
                                _this_1.verified = true;
                                _this_1.isInit = true;
                                _this_1.loading = false;
                                var style = { 'width': 600, 'height': 200 };
                                var secondaryVrifyDialog = __WEBPACK_IMPORTED_MODULE_19_ecCom__["WeaTools"].createDialog({ moduleName: 'hrm', title: getLabel(501195, '身份验证'), url: url, style: style, callback: onCallbackHandle, onSecondaryCancel: onSecondaryCancel });
                                secondaryVrifyDialog.show();
                            }
                            else {
                                _this_1.initcardothers(params, datas, _params, callback);
                            }
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error(data.message);
                        }
                    });
                    return [2 /*return*/];
                });
            }); };
            showSecondaryVirty();
        };
        this.getDetailFormValues = function (form) {
            return form && form.values();
        };
        this.reloadCardDatas = function () {
            Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["M" /* mainFields */])(__assign({}, _this_1.params, { uuid: Object(__WEBPACK_IMPORTED_MODULE_10__util_typeUtil__["g" /* guid */])() })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (res) {
                var status1 = res.status, errorCode1 = res.errorCode, error1 = res.error, fields1 = res.fields;
                if (status1 != '1') {
                    __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode1) + "]:" + error1);
                }
                else {
                    if (undefined != res.changeDataTime) {
                        _this_1.changeDataTime = res.changeDataTime;
                    }
                    _this_1.cubeTrigger = new __WEBPACK_IMPORTED_MODULE_12__cube_trigger__["a" /* default */](_this_1);
                    _this_1.getDetailTables(__assign({}, _this_1.reloadParams, { datajson: '' }));
                    _this_1.allFields = fields1;
                    //this.setRefreshParams(fields1);
                    var uploadFields_2 = [];
                    __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(fields1, function (f, k) {
                        if (f.fieldhtmltype == '6') {
                            uploadFields_2.push(k);
                        }
                    });
                    _this_1.uploadFields = uploadFields_2;
                    _this_1.cubeForm = Object(__WEBPACK_IMPORTED_MODULE_11__form__["b" /* getLayoutFields */])(fields1, _this_1, __assign({}, _this_1.reloadParams)); //初始化card form
                }
            }));
        };
        this.changeSubmitParam = function (param) {
            if (param === void 0) { param = {}; }
            _this_1.submitParam = __assign({}, _this_1.submitParam, param);
        };
    }
    Object.defineProperty(CardStore.prototype, "isShowLoading", {
        get: function () {
            if (this.isSearchShow) {
                return __WEBPACK_IMPORTED_MODULE_17__list__["default"].newTable.loading;
            }
            else if (this.isCardShow) {
                return this.card.loading;
            }
            else {
                return this.loading;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardStore.prototype, "fieldsPropsToShow", {
        get: function () {
            if (this.isCardShow) {
                return this.card.fieldsProps;
            }
            else {
                return this.fieldsProps;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardStore.prototype, "needSumFields", {
        get: function () {
            return this.cubeTrigger.needSumFields;
        },
        enumerable: true,
        configurable: true
    });
    CardStore.prototype.setIsOreadySubmit = function (isOreadySubmit) {
        this.isOreadySubmit = isOreadySubmit;
    };
    Object.defineProperty(CardStore.prototype, "docCategroy", {
        get: function () {
            if (this.base.categoryType == '1') {
                var field = "field" + this.base.selectCategory;
                var _a = this.getFieldProps(field), _b = _a.options, options = _b === void 0 ? [] : _b, fieldlabel = _a.fieldlabel;
                if (this.cubeForm.has(field)) {
                    var value_3 = this.cubeForm.$(field).getValue();
                    var selectOpt = options.filter(function (opt) { return opt.key == value_3; });
                    if (selectOpt.length > 0) {
                        var category = {};
                        var opt = selectOpt[0];
                        if (opt.docCategory) {
                            var _c = opt.docCategory.split(","), mainCategory = _c[0], subCategory = _c[1], secCategory = _c[2];
                            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(category, 'mainCategory', mainCategory);
                            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(category, 'subCategory', subCategory);
                            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(category, 'secCategory', secCategory);
                            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(category, 'maxUploadSize', opt.maxUploadSize > 0 ? opt.maxUploadSize : 5);
                        }
                        return category;
                    }
                }
                if (this.base.type == "1" || this.base.type == "2" || this.base.type == "0") {
                    return { msg: "" + (getLabel(125389, '请先选择') + fieldlabel) };
                }
                else {
                    return { msg: "" };
                }
            }
            else {
                return this.base.category || {};
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardStore.prototype, "fieldNameMap", {
        get: function () {
            var nameMap = __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].map ? __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"].map({}) : Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["asMap"])({});
            !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.allFields) && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forIn(this.allFields, function (v, k) {
                if (v.fieldname) {
                    if (v.isdetail) { //明细表
                        nameMap.set(v.detail + "." + v.fieldname.toUpperCase(), v.fieldid);
                    }
                    else {
                        nameMap.set('main' + "." + v.fieldname.toUpperCase(), v.fieldid);
                    }
                }
            });
            return nameMap;
        },
        enumerable: true,
        configurable: true
    });
    CardStore.prototype.batchControlVariableMap = function (obj) {
        if (obj === void 0) { obj = {}; }
        var newMap = __assign({}, this.variableMap);
        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(obj, function (v, k) {
            newMap[k] = v;
        });
        this.variableMap = newMap;
    };
    CardStore.prototype.initCardLikeInfo = function (_params) {
        var _this_1 = this;
        Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["q" /* getCubeLikeInfo */])(_params).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (data) {
            if (data.status == '1') {
                _this_1.likecount = data.likecount || 0;
                _this_1.dislikecount = data.dislikecount || 0;
                _this_1.likestatus = data.likestatus || '0';
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("" + getLabel(127353, '错误'));
            }
        }));
    };
    CardStore.prototype.likeOrdislike = function (key) {
        var _this_1 = this;
        var isNeedReload = false; //是否需要刷新查询列表
        Object(__WEBPACK_IMPORTED_MODULE_8__apis_card__["Q" /* saveCubeLikeInfo */])({ modeid: this.base.modeId, billid: this.params.billid, status: key, customid: this.params.customid }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (data) {
            if (data.status == '1') {
                if (data.issuccess) {
                    isNeedReload = data.isNeedRefresh;
                    var _params = {
                        modeId: _this_1.base.modeId,
                        billid: _this_1.params.billid
                    };
                    _this_1.initCardLikeInfo(_params);
                }
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("" + getLabel(127353, '错误'));
            }
            try {
                _this_1.cardTab.disabled = false;
                if (isNeedReload == true) {
                    if (__WEBPACK_IMPORTED_MODULE_5__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_5__util__["default"].opener._table && __WEBPACK_IMPORTED_MODULE_5__util__["default"].opener._table.reLoad) {
                        __WEBPACK_IMPORTED_MODULE_5__util__["default"].opener._table.reLoad();
                    }
                    else if (__WEBPACK_IMPORTED_MODULE_5__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_5__util__["default"].opener.cubeStore) {
                        __WEBPACK_IMPORTED_MODULE_5__util__["default"].opener.cubeStore.Search.refresh();
                    }
                    else if (_this_1.params && _this_1.params.viewfrom) {
                        if (_this_1.params.viewfrom == 'fromsearchlist') { //查询列表的 iframe 链接过来的卡片,保存之后刷新列表 
                            __WEBPACK_IMPORTED_MODULE_5__util__["default"].parent.cubeStore.Search.refresh();
                        }
                    }
                }
            }
            catch (e) {
            }
        }));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "parentCard", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "card", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "query", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "layoutType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isOreadySubmit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "pageError", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "errorMessage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "layoutError", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isexcel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isImportDetail", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "custompage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "istabinline", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isfromTab", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "changeDataTime", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "datajson", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "modeTabKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "showReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "icon", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "iconBgcolor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "categorytype", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "ifrmaeHeight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "DetailDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isInline", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isfrontmultlang", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "modeExcel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "allFields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "fieldsProps", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "cubeForm", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "layoutBaseLoading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "fieldsLoading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "detailTable", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "cubeTrigger", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "cardTab", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "layoutid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "printEdcUrl", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "token", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "reply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "detailImport", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "setTabearaActiveKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "share", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "mapStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "customDialog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isSearchShow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isCardShow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isInTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isShowReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isLogListShow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "empowmentType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isallowlike", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "likeshowname", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "isallowdislike", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "dislikeshowname", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "likecount", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "dislikecount", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "likestatus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "seclevelInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "secretTimeDefValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "secretTimeDefStyle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "datastatus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "base", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "orderbyfield", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "orderbytype", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "newParamsAdd", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "scriptCode", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "waterImg", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "targetHref", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "verified", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "hasRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "cardMarginParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "variableMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "detailMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "browserPropMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "getEcmeFieldData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "ecmeFieldEventCallBack", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "submitParam", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardStore.prototype, "isShowLoading", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardStore.prototype, "fieldsPropsToShow", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardStore.prototype, "needSumFields", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "ecmecallBack", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "sliderParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "slideModalVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "showGlobalSpin", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "quickEditStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "layoutBase", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardStore.prototype, "modeTitleFieldArr", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "changeModeTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "setIsOreadySubmit", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "loadReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "refreshDetail", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "addDetailDefaultDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "getDetailTables", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "initDetailDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "showDetailImport", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "docustompage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "getWaterMarkImg", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "showSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "showCard", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "innerCardInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "showInnerReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "showInnerLogList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "doSelectItemChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "changeLoadingState", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardStore.prototype, "docCategroy", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "reloadSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardStore.prototype, "fieldNameMap", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "clear", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "getCardMarginData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "saveDetailPageSize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "reloadCard", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])('批量控制变量区')
    ], CardStore.prototype, "batchControlVariableMap", null);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])('控制明细行属性对象')
    ], CardStore.prototype, "controlDetailRowAttr", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])('控制浏览按钮属性覆盖')
    ], CardStore.prototype, "controlBrowserProp", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "showSlideModal", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "doSecondaryVirty", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardStore.prototype, "getDetailFormValues", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"] //改变提交参数
    ], CardStore.prototype, "changeSubmitParam", void 0);
    return CardStore;
}());
/* harmony default export */ __webpack_exports__["default"] = (CardStore);


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(617),
    isObjectLike = __webpack_require__(24);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(45),
    isObjectLike = __webpack_require__(24);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(21),
    stubFalse = __webpack_require__(618);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(293);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(662),
    Map = __webpack_require__(192),
    Promise = __webpack_require__(663),
    Set = __webpack_require__(335),
    WeakMap = __webpack_require__(318),
    baseGetTag = __webpack_require__(36),
    toSource = __webpack_require__(294);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = __webpack_require__(140);

var _get3 = _interopRequireDefault(_get2);

var _startsWith2 = __webpack_require__(730);

var _startsWith3 = _interopRequireDefault(_startsWith2);

var _filter2 = __webpack_require__(731);

var _filter3 = _interopRequireDefault(_filter2);

var _set2 = __webpack_require__(187);

var _set3 = _interopRequireDefault(_set2);

var _each2 = __webpack_require__(53);

var _each3 = _interopRequireDefault(_each2);

var _isEmpty2 = __webpack_require__(81);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _map2 = __webpack_require__(137);

var _map3 = _interopRequireDefault(_map2);

var _isPlainObject2 = __webpack_require__(52);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _has2 = __webpack_require__(82);

var _has3 = _interopRequireDefault(_has2);

var _merge2 = __webpack_require__(75);

var _merge3 = _interopRequireDefault(_merge2);

var _split2 = __webpack_require__(145);

var _split3 = _interopRequireDefault(_split2);

var _reduce2 = __webpack_require__(352);

var _reduce3 = _interopRequireDefault(_reduce2);

var _last2 = __webpack_require__(216);

var _last3 = _interopRequireDefault(_last2);

var _trimEnd2 = __webpack_require__(354);

var _trimEnd3 = _interopRequireDefault(_trimEnd2);

var _endsWith2 = __webpack_require__(734);

var _endsWith3 = _interopRequireDefault(_endsWith2);

var _reduceRight2 = __webpack_require__(735);

var _reduceRight3 = _interopRequireDefault(_reduceRight2);

var _without2 = __webpack_require__(740);

var _without3 = _interopRequireDefault(_without2);

var _values2 = __webpack_require__(205);

var _values3 = _interopRequireDefault(_values2);

var _parseInt2 = __webpack_require__(741);

var _parseInt3 = _interopRequireDefault(_parseInt2);

var _isInteger2 = __webpack_require__(314);

var _isInteger3 = _interopRequireDefault(_isInteger2);

var _replace2 = __webpack_require__(344);

var _replace3 = _interopRequireDefault(_replace2);

var _isString2 = __webpack_require__(47);

var _isString3 = _interopRequireDefault(_isString2);

var _isNumber2 = __webpack_require__(212);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _isBoolean2 = __webpack_require__(132);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _isDate2 = __webpack_require__(204);

var _isDate3 = _interopRequireDefault(_isDate2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _utils = __webpack_require__(27);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultClearValue = function defaultClearValue(_ref) {
  var value = _ref.value;

  if ((0, _isArray3.default)(value)) return [];
  if ((0, _isDate3.default)(value)) return null;
  if ((0, _isBoolean3.default)(value)) return false;
  if ((0, _isNumber3.default)(value)) return 0;
  if ((0, _isString3.default)(value)) return '';
  return undefined;
};

var defaultValue = function defaultValue(_ref2) {
  var type = _ref2.type,
      _ref2$isEmptyArray = _ref2.isEmptyArray,
      isEmptyArray = _ref2$isEmptyArray === undefined ? false : _ref2$isEmptyArray;

  if (type === 'date') return null;
  if (type === 'checkbox') return false;
  if (type === 'number') return 0;
  return isEmptyArray ? [] : '';
};

var parsePath = function parsePath(path) {
  var $path = path;
  $path = (0, _replace3.default)($path, new RegExp('\\[', 'g'), '.');
  $path = (0, _replace3.default)($path, new RegExp('\\]', 'g'), '');
  return $path;
};

var parseInput = function parseInput(input, _ref3) {
  var type = _ref3.type,
      isEmptyArray = _ref3.isEmptyArray,
      separated = _ref3.separated,
      unified = _ref3.unified,
      initial = _ref3.initial;
  return input(_utils2.default.$try(separated, unified, initial, defaultValue({ type: type, isEmptyArray: isEmptyArray })));
};

// make integers labels empty
var parseGetLabel = function parseGetLabel(label) {
  return (0, _isInteger3.default)((0, _parseInt3.default)(label)) ? '' : label;
};

var parseArrayProp = function parseArrayProp($val, $prop) {
  var $values = (0, _values3.default)($val);
  if ($prop === 'value' || $prop === 'initial' || $prop === 'default') {
    return (0, _without3.default)($values, null, undefined, '');
  }
  return $values;
};

var parseCheckArray = function parseCheckArray(field, value, prop) {
  return field.hasIncrementalKeys ? parseArrayProp(value, prop) : value;
};

var parseCheckOutput = function parseCheckOutput($field, $prop) {
  return $prop === 'value' ? $field.$output($field[$prop]) : $field[$prop];
};

var defineFieldsFromStruct = function defineFieldsFromStruct(struct) {
  var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0, _reduceRight3.default)(struct, function ($, name) {
    var obj = {};
    if ((0, _endsWith3.default)(name, '[]')) {
      var val = add ? [$] : [];
      obj[(0, _trimEnd3.default)(name, '[]')] = val;
      return obj;
    }
    // no brakets
    var prev = struct[struct.indexOf(name) - 1];
    var stop = (0, _endsWith3.default)(prev, '[]') && (0, _last3.default)(struct) === name;
    if (!add && stop) return obj;
    obj[name] = $;
    return obj;
  }, {});
};

var handleFieldsArrayOfStrings = function handleFieldsArrayOfStrings($fields) {
  var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var fields = $fields;
  // handle array with field struct (strings)
  if (_utils2.default.isStruct(fields)) {
    fields = (0, _reduce3.default)(fields, function ($obj, $) {
      var pathStruct = (0, _split3.default)($, '.');
      // as array of strings (with empty values)
      if (!pathStruct.length) return Object.assign($obj, _defineProperty({}, $, ''));
      // define flat or nested fields from pathStruct
      return (0, _merge3.default)($obj, defineFieldsFromStruct(pathStruct, add));
    }, {});
  }
  return fields;
};

var handleFieldsArrayOfObjects = function handleFieldsArrayOfObjects($fields) {
  var fields = $fields;
  // handle array of objects (with unified props)
  if (_utils2.default.isArrayOfObjects(fields)) {
    fields = (0, _reduce3.default)(fields, function ($obj, field) {
      if (_utils2.default.hasUnifiedProps({ fields: { field: field } }) && !(0, _has3.default)(field, 'name')) return undefined;
      return Object.assign($obj, _defineProperty({}, field.name, field));
    }, {});
  }
  return fields;
};

var handleFieldsNested = function handleFieldsNested(fields) {
  var strictProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (0, _reduce3.default)(fields, function (obj, field, key) {
    if (_utils2.default.allowNested(field, strictProps)) {
      // define nested field
      return Object.assign(obj, _defineProperty({}, key, { fields: _utils2.default.isEmptyArray(field) ? [] : handleFieldsNested(field) }));
    }
    return Object.assign(obj, _defineProperty({}, key, field));
  }, {});
};

/* mapNestedValuesToUnifiedValues

FROM:

{
  street: '123 Fake St.',
  zip: '12345',
}

TO:

[{
  name: 'street'
  value: '123 Fake St.',
}, {
  name: 'zip'
  value: '12345',
}]

*/
var mapNestedValuesToUnifiedValues = function mapNestedValuesToUnifiedValues(data) {
  return (0, _isPlainObject3.default)(data) ? (0, _map3.default)(data, function (value, name) {
    return { value: value, name: name };
  }) : undefined;
};

/* reduceValuesToUnifiedFields

FROM:

{
  name: 'fatty',
  address: {
    street: '123 Fake St.',
    zip: '12345',
  },
};

TO:

{
  name: {
    value: 'fatty',
    fields: undefined
  },
  address: {
    value: {
      street: '123 Fake St.',
      zip: '12345'
    },
    fields: [ ... ]
  },
};

*/
var reduceValuesToUnifiedFields = function reduceValuesToUnifiedFields(values) {
  return (0, _reduce3.default)(values, function (obj, value, key) {
    return Object.assign(obj, _defineProperty({}, key, {
      value: value,
      fields: mapNestedValuesToUnifiedValues(value)
    }));
  }, {});
};

/*
  Fallback Unified Props to Sepated Mode
*/
var handleFieldsPropsFallback = function handleFieldsPropsFallback(fields, initial) {
  if (!(0, _has3.default)(initial, 'values')) return fields;
  // if the 'values' object is passed in constructor
  // then update the fields definitions
  var values = initial.values;

  if (_utils2.default.hasUnifiedProps({ fields: fields })) {
    values = reduceValuesToUnifiedFields(values);
  }
  return (0, _merge3.default)(fields, values);
};

var mergeSchemaDefaults = function mergeSchemaDefaults(fields, validator) {
  if (validator) {
    var properties = validator.schema.properties;

    if ((0, _isEmpty3.default)(fields) && !!properties) {
      (0, _each3.default)(properties, function (prop, key) {
        (0, _set3.default)(fields, key, {
          value: prop.default,
          label: prop.title
        });
      });
    }
  }
  return fields;
};

var prepareFieldsData = function prepareFieldsData(initial) {
  var strictProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var fields = (0, _merge3.default)(handleFieldsArrayOfStrings(initial.fields, false), handleFieldsArrayOfStrings(initial.struct, false));

  fields = handleFieldsArrayOfObjects(fields);
  fields = handleFieldsPropsFallback(fields, initial);
  fields = handleFieldsNested(fields, strictProps);

  return fields;
};

var pathToFieldsTree = function pathToFieldsTree(struct, path) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var add = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var structPath = _utils2.default.pathToStruct(path);
  var structArray = (0, _filter3.default)(struct, function (item) {
    return (0, _startsWith3.default)(item, structPath);
  });
  var $tree = handleFieldsArrayOfStrings(structArray, add);
  var $struct = (0, _replace3.default)(structPath, new RegExp('\\[]', 'g'), '[' + n + ']');
  return handleFieldsNested((0, _get3.default)($tree, $struct));
};

exports.default = {
  defaultValue: defaultValue,
  defaultClearValue: defaultClearValue,
  parseInput: parseInput,
  parsePath: parsePath,
  parseGetLabel: parseGetLabel,
  parseArrayProp: parseArrayProp,
  parseCheckArray: parseCheckArray,
  parseCheckOutput: parseCheckOutput,
  mergeSchemaDefaults: mergeSchemaDefaults,
  handleFieldsNested: handleFieldsNested,
  handleFieldsArrayOfStrings: handleFieldsArrayOfStrings,
  prepareFieldsData: prepareFieldsData,
  pathToFieldsTree: pathToFieldsTree
};
module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(222),
    getRawTag = __webpack_require__(841),
    objectToString = __webpack_require__(842);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = measureScrollbar;
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["d"] = warningOnce;
/* harmony export (immutable) */ __webpack_exports__["c"] = remove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var scrollbarSize = void 0;

// Measure scrollbar width for padding body during modal show/hide
var scrollbarMeasure = {
  position: 'absolute',
  top: '-9999px',
  width: '50px',
  height: '50px',
  overflow: 'scroll'
};

function measureScrollbar() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'vertical';

  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0;
  }
  if (scrollbarSize) {
    return scrollbarSize;
  }
  var scrollDiv = document.createElement('div');
  Object.keys(scrollbarMeasure).forEach(function (scrollProp) {
    scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
  });
  document.body.appendChild(scrollDiv);
  var size = 0;
  if (direction === 'vertical') {
    size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  } else if (direction === 'horizontal') {
    size = scrollDiv.offsetHeight - scrollDiv.clientHeight;
  }

  document.body.removeChild(scrollDiv);
  scrollbarSize = size;
  return scrollbarSize;
}

function debounce(func, wait, immediate) {
  var timeout = void 0;
  function debounceFunc() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;
    // https://fb.me/react-event-pooling
    if (args[0] && args[0].persist) {
      args[0].persist();
    }
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  }
  debounceFunc.cancel = function cancel() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounceFunc;
}

var warned = {};
function warningOnce(condition, format, args) {
  if (!warned[format]) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(condition, format, args);
    warned[format] = !condition;
  }
}

function remove(array, item) {
  var index = array.indexOf(item);
  var front = array.slice(0, index);
  var last = array.slice(index + 1, array.length);
  return front.concat(last);
}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyFromChildrenIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenuIdFromSubMenuEventKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = loopMenuItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = loopMenuItemRecursively;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return menuAllProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function noop() {}

function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || prefix + 'item_' + index;
}

function getMenuIdFromSubMenuEventKey(eventKey) {
  return eventKey + '-menu-';
}

function loopMenuItem(children, cb) {
  var index = -1;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    index++;
    if (c && c.type && c.type.isMenuItemGroup) {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(c.props.children, function (c2) {
        index++;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}

function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
    if (c) {
      var construct = c.type;
      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }
      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}

var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements',

// the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme'];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(419);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(42);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableCell__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_typeUtil__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var ExcelTableTds = /** @class */ (function (_super) {
    __extends(ExcelTableTds, _super);
    function ExcelTableTds() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExcelTableTds.prototype.componentDidMount = function () {
        var _a = this.props, detail = _a.detail, excel = _a.excel;
        if (detail && detail.indexOf("detail_") > -1) {
            //明细锁定列同步一次高度
            var groupid = detail.replace('detail_', '');
            var supportLockedCol = excel.edlockedcol || -1;
            if (supportLockedCol > -1)
                Object(__WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["syncLockedForDidMount"])(groupid);
        }
    };
    ExcelTableTds.prototype.render = function () {
        var _this = this;
        var _a = this.props, excel = _a.excel, row = _a.row, form = _a.form, card = _a.card, detail = _a.detail, isFixFieldDiv = _a.isFixFieldDiv, _b = _a.rowspanJson, rowspanJson = _b === void 0 ? {} : _b, _c = _a.detailIndex, detailIndex = _c === void 0 ? 0 : _c;
        if (isFixFieldDiv) {
            return (excel.getFixFieldTds(row, detail, excel.combineCell, excel.fixFieldIndex, detailIndex, rowspanJson).map(function (td) {
                var verifyColor = {};
                var domProps = {};
                if (td && td.etype == '3' && form.has(td.getPath())) {
                    var color = form.$(td.getPath()).color;
                    if (color) {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(verifyColor, "background", color);
                    }
                    var etype = td.etype;
                    var path = td.getPath();
                    var bindObj = form.$(path);
                    var fieldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
                    var fieldMark_1 = fieldName;
                    if (etype == "3") { //字段
                        domProps.onClick = function () { __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].triggerFieldAction("onclick", fieldMark_1); };
                        domProps.onDoubleClick = function () { __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].triggerFieldAction("ondbclick", fieldMark_1); };
                        domProps.onMouseOver = function () { __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].triggerFieldAction("mouseover", fieldMark_1); };
                        domProps.onMouseOut = function () { __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].triggerFieldAction("mouseout", fieldMark_1); };
                    }
                }
                if (detail) {
                    return (td ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({}, domProps, { style: __assign({}, td.style, verifyColor, { display: td.hidechild && td.hidechild === "y" ? "none" : "" }) }, td.otherProps),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableCell__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableCell@vcjx4u@" + detailIndex, cell: td, form: form, excel: excel, card: card, detail: detail, index: detailIndex })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null));
                }
            }));
        }
        return (excel.getTds(row, detail, excel.combineCell, detailIndex, rowspanJson).map(function (td, index) {
            var verifyColor = {};
            var domProps = {};
            if (td && td.etype == '3' && form.has(td.getPath())) {
                var color = form.$(td.getPath()).color;
                if (color) {
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(verifyColor, "background", color);
                }
                var etype = td.etype;
                var path = td.getPath();
                var bindObj = form.$(path);
                var fieldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
                var fieldMark_2 = fieldName;
                if (etype == "3") { //字段
                    domProps.onClick = function () { return __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].triggerFieldAction("onclick", fieldMark_2); };
                    domProps.onDoubleClick = function () { return __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].triggerFieldAction("ondbclick", fieldMark_2); };
                    domProps.onMouseOver = function () { return __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].triggerFieldAction("mouseover", fieldMark_2); };
                    domProps.onMouseOut = function () { return __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].triggerFieldAction("mouseout", fieldMark_2); };
                }
            }
            if (detail) {
                return (td ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({}, domProps, { style: __assign({}, td.style, verifyColor, { display: td.hidechild && td.hidechild === "y" ? "none" : "" }) }, td.otherProps),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableCell__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableCell@ugxhpb@" + detailIndex, cell: td, form: form, excel: excel, card: card, detail: detail, index: detailIndex })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null));
            }
            if (td && td.etype == "6") {
                //  excel设计器插入单元格  图片，插入背景图处理
                return td ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({ style: __assign({}, td.style, verifyColor, { backgroundImage: "url(" + td.field + ")" }) }, td.otherProps),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { width: "100%", display: td.hidechild && td.hidechild === "y" ? "none" : "" } }, td.evalue ? td.evalue : "")) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null);
            }
            return (td ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({ style: __assign({}, td.style, verifyColor) }, td.otherProps),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({}, domProps, { style: { width: "100%", display: td.hidechild && td.hidechild === "y" ? "none" : "" } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableCell__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableCell@frvkko@" + detailIndex, cell: td, form: form, excel: excel, card: card, detail: detail, index: detailIndex }))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null));
        }));
    };
    ExcelTableTds = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], ExcelTableTds);
    return ExcelTableTds;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableTds);


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Group__ = __webpack_require__(276);
/* unused harmony reexport CheckboxProps */
/* unused harmony reexport CheckboxGroupProps */
/* unused harmony reexport CheckboxOptionType */




__WEBPACK_IMPORTED_MODULE_0__Checkbox__["a" /* default */].Group = __WEBPACK_IMPORTED_MODULE_1__Group__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Checkbox__["a" /* default */]);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(267);
var enumBugKeys = __webpack_require__(178);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(175);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(56);
var dPs = __webpack_require__(506);
var enumBugKeys = __webpack_require__(178);
var IE_PROTO = __webpack_require__(176)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(266)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(507).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(34).f;
var has = __webpack_require__(58);
var TAG = __webpack_require__(32)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modeList", function() { return modeList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_list__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__excelUtil2__ = __webpack_require__(166);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;

var modeList = __assign({ 
    // dialogObj: undefined,
    /****获取当前查询类型
     *  Excel = 'excel',
     *  Normal = 'normal',
      *  TreeType = 'treeType', 分组列表
      *  ImgType = 'imgType'  相册列表
      *  VerticalType = 'verticalType',  //纵向列表
      */
    getSearchCurrentType: function () {
        var type = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].displayType || 'normal';
        if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].displayType === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType) {
            type = __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType;
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].displayType == __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].Excel) {
            type = __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].Excel;
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].displayType == __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType) {
            type = __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType;
        }
        else if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].displayType == __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType) {
            type = __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType;
        }
        return type;
    }, 
    /**
     *  选中的checkbox的值（主表数据ID)
     *  返回值说明： 多个数据ID以英文半角逗号分开
     *  返回例子： 1,2,3,4
     *  支持环境： normal/treetype/imgtype
     */
    getCheckedID: function () {
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType) {
            var ids = '';
            if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].treeKey) {
                ids = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].treeKey.map(function (d) { return d.split('_')[0]; })).join(",");
            }
            return ids;
        }
        else if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType) {
            if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys && __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys.length > 0) {
                return __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].imgSelectValue;
            }
            return '';
        }
        else if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType) {
            if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys && __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys.length > 0) {
                return __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].verticalListStore.selectValue;
            }
            return '';
        }
        else if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].Excel) {
            return __WEBPACK_IMPORTED_MODULE_0____["default"]._xtable_CheckedCheckboxId();
        }
        else {
            var allIds = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.selectedRowKeysAllPages;
            allIds = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(allIds, function (d) { return d.split('_')[0]; });
            /*var selectedIds = searchStores.newTable.datas.filter(d => allIds.indexOf(this.getListKey(d)) > -1)
                .map(d => d.randomFieldId);*/
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(allIds).join(',');
        }
    }, getTitleVal: function () {
        return getLabel(16641, "高效源于协同");
    }, 
    /**
     *  选中的checkbox的带有明细的值（主表数据ID_明细数据ID)
     *  返回值说明： 多个数据ID以英文半角逗号分开；如果没有明细格式：主表数据ID + “_”
     *  返回例子： 1_1,1_2,2_1 ；当不存在明细：1_
     *  支持环境： normal/treetype/imgtype
     */
    getCheckedIDWithDetail: function () {
        var ids = new Array();
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType) {
            if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].treeKey) {
                ids = this.handleIds(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].treeKey));
            }
        }
        else if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType || this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType) {
            var allIds = Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys) || [];
            ids = this.handleIds(allIds);
        }
        else {
            ids = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.selectedRowKeysAllPages;
        }
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(ids).join(',');
    }, 
    /***分组列表数据处理ids */
    handleIds: function (datas) {
        if (datas === void 0) { datas = []; }
        var idarrs = new Array();
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(datas, function (id) {
            if (id.indexOf('_') < 0) {
                idarrs.push(id + '_');
            }
            else {
                idarrs.push(id);
            }
        });
        return idarrs;
    }, 
    /***获取分组列表的所有数据id */
    getAllTreeListIds: function () {
        var idarrs = new Array();
        var datas = Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].tableData.Data);
        var loop = function (data) { return data.map(function (item) {
            if (item.sublist && item.sublist.length > 0) {
                idarrs.push(item.key);
                return loop(item.sublist);
            }
            return idarrs.push(item.key);
        }); };
        loop(datas);
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(idarrs);
    }, 
    /**
     * 未选中的checkbox的值（主表数据ID)
     * 返回值说明： 多个数据ID以英文半角逗号分开
     * 返回例子： 1,2,3,4
     * 支持环境： normal/treetype/imgtype
     */
    getUnCheckedID: function () {
        var _this = this;
        var ids;
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType) {
            var allids = this.getAllTreeListIds();
            var checkids_1 = new Array();
            if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].treeKey) {
                checkids_1 = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].treeKey);
            }
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(allids.filter(function (d) { return checkids_1.indexOf(d) == -1; }).map(function (d) { return d.split('_')[0]; }).join(","));
        }
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType) {
            var allIds = Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys) || [];
            ids = this.handleIds(allIds);
            var unIds_1 = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].verticalListStore.allDatas.filter(function (d) { return ids.indexOf(_this.getListKey(d)) == -1; })
                .map(function (d) { return d.randomFieldId; });
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(unIds_1).join(',');
        }
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType) {
            var allIds = Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys) || [];
            ids = this.handleIds(allIds);
        }
        else {
            ids = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.selectedRowKeys;
        }
        var unIds = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.datas.filter(function (d) { return ids.indexOf(_this.getListKey(d)) == -1; })
            .map(function (d) { return d.randomFieldId; });
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(unIds).join(',');
    }, 
    /**
     *  未选中的checkbox的带有明细的值（主表数据ID_明细数据ID)
     *  返回值说明： 多个数据ID以英文半角逗号分开, 如果没有明细格式：主表数据ID + “_”
     *  返回例子： 1_1,1_2,2_1; 当不存在明细：1_
     *  支持环境： normal/treetype/imgtype
     */
    getUnCheckedIDWithDetail: function () {
        var _this = this;
        var ids;
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType) {
            var allids = this.getAllTreeListIds();
            var checkids_2 = new Array();
            if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].treeKey) {
                checkids_2 = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].treeKey);
            }
            var ids_1 = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(allids.filter(function (d) { return checkids_2.indexOf(d) == -1; }));
            return this.handleIds(ids_1).join(',');
        }
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType) {
            var allIds = Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys) || [];
            ids = this.handleIds(allIds);
            var unIds_2 = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].verticalListStore.allDatas.filter(function (d) { return ids.indexOf(_this.getListKey(d)) == -1; })
                .map(function (d) { return _this.getListKey(d); });
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(unIds_2).join(',');
        }
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType) {
            var allIds = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].getAllImgListIds();
            var checkids_3 = new Array();
            if (__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys) {
                checkids_3 = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowkeys);
            }
            ids = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(allIds.filter(function (d) { return checkids_3.indexOf(d) == -1; }));
            return this.handleIds(ids).join(',');
        }
        ids = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.selectedRowKeys;
        var unIds = __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.datas.filter(function (d) { return ids.indexOf(_this.getListKey(d)) == -1; })
            .map(function (d) { return _this.getListKey(d); });
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(unIds).join(',');
    }, 
    /**
     * 清除选中的checkbox
     *
     */
    clearChecked: function () {
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType) {
            return __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].setSelectedRowKeys([], []);
        }
        return __WEBPACK_IMPORTED_MODULE_0____["default"]._xtable_CleanCheckedCheckbox();
    }, 
    /**
     *  全选
     */
    setAllChecked: function () {
        this.clearChecked();
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType) {
            var allids = this.getAllTreeListIds();
            __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].setSelectedRowKeys(allids, []);
        }
        else {
            if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType) {
                __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].selectRowKeyAll();
            }
            else if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType) {
                __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].verticalListStore.selectRowKeyAll();
            }
            else {
                __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.setSelectedRowKeys(this.getUnCheckedIDWithDetail().split(","));
            }
        }
    }, 
    /**
     * 重新加载表格
     */
    reloadTable: function () {
        if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].TreeType || this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].Excel) {
            __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].refresh();
        }
        else if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType || this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType) {
            __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].refresh();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0____["default"]._table.reLoad();
        }
    }, 
    /**
     * 重新加载表格--全部数据
     */
    reloadTableAll: function () {
        __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].refresh();
        // if (this.getSearchCurrentType() === SearchDisplayType.TreeType) {
        //     searchStores.refresh();
        // }else if (searchStores.displayTypeForImg && this.getSearchCurrentType() === SearchDisplayType.ImgType) {
        //     searchStores.refresh();
        // } else {
        //     searchStores.refresh();
        // }
    }, 
    /**
     * 获取查询列表Id
     */
    getCustomID: function () {
        return __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].customId;
    }, 
    /**
     * 获取查询列表对应表单ID
     */
    getFormID: function () {
        return __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].formId;
    }, 
    /**
     * 获取查询列表对应模块ID
     */
    getModeID: function () {
        return __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].modeId;
    }, 
    /**
     *  获取查询列表Id+模块Id+表单Id
     *  返回格式{customId:customId,formId:formId,modeId:modeId}
     */
    getCustomIdWithModeIDAndFormID: function () {
        return {
            customId: __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].customId,
            formId: __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].formId,
            modeId: __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].modeId
        };
    }, 
    /**
     *  获取查询列表url地址中的参数
     *  返回格式{customid: customid,guid: guid,_key: _key}
     */
    getListUrlInfo: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].params);
    }, 
    /**
     *
     * 获取当页表格json数据
     */
    getTableDatas: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.datas).map(function (o) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(o, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(o).filter(function (fieldName) { return !fieldName.endsWith("span") && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.eq("span", fieldName); }));
        });
    }, 
    /**
     *
     * 获取当页表格json数据
     */
    getTableDatasWithSpan: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].newTable.datas);
    }, getListKey: function (data) {
        if ('randomFieldSubKeyd_id' in data) { // 明细ID
            // 相册单独处理
            if (this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].ImgType || this.getSearchCurrentType() === __WEBPACK_IMPORTED_MODULE_3__stores_list__["SearchDisplayType"].VerticalType) {
                return data.randomFieldSubKeyd_id ? data.randomFieldId + "_" + data.randomFieldSubKeyd_id : "" + data.randomFieldId;
            }
            else {
                return data.randomFieldId + "_" + data.randomFieldSubKeyd_id;
            }
        }
        else {
            return "" + data.randomFieldId;
        }
    }, 
    /**
     * dataLoadAfter的回调函数,对列表的数据进行二次加工，并渲染
     * @param datas (array) 列表数据
     * @param displayType (string) normal 普通列表,excel 表格视图,treeType 树形列表
     */
    dataLoadAfterCB: null, 
    /**
     * 对列表的数据进行二次加工，并渲染
     */
    dataLoadAfter: function (callback) {
        this.dataLoadAfterCB = callback;
    }, 
    /***
     * 打开一个自定义对话框
     */
    openCustomDialog: function (prop, buttons) {
        __WEBPACK_IMPORTED_MODULE_0____["default"].modeForm.openCustomDialog(prop, buttons);
    }, 
    /**
     * 关闭指定的自定义对话框
     */
    closeCustomDialog: function () {
        __WEBPACK_IMPORTED_MODULE_0____["default"].modeForm.closeCustomDialog();
    }, 
    /**
    *
    * 自定义查询
    */
    customSearch: function (condition) {
        __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].customSearch(condition);
    }, 
    /****
     * 打开侧滑窗口
     */
    slideOpenModal: function (bool, url, sliderPercentage) {
        if (sliderPercentage === void 0) { sliderPercentage = 70; }
        if (bool && __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].isclick) {
            __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].isclick = false;
        }
        __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].showSlideModal(bool, url, sliderPercentage);
    }, 
    /***
     * 获取批量修改的字段值
     */
    getBatchEditDatas: function () {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].editTableStore.form.$('tableForm').values());
        }
        catch (error) {
        }
    }, 
    /***
    * 获取当前查询条件的值
    */
    getHighSearchDatas: function () {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].condition.form.values());
        }
        catch (error) {
        }
    }, 
    /***
    * 获取顶部查询条件的值
    */
    getTopSearchDatas: function () {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].quickSearchFormData);
        }
        catch (error) {
        }
    }, 
    /***
     * 控制全局spin的开始与结束
     */
    showLoading: function (bool, size, tip) {
        __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].showGlobalSpin = {
            isShow: bool ? 'show' : 'hide',
            size: size || 'defalut',
            tip: tip || '',
        };
    }, 
    /***右键-导出 */
    getAllExcelOut: function (billid) {
        __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].getAllExcelOut(billid);
    }, 
    /***调用右键事件
    * 系统按钮：type= functionname
    * 页面扩展 type = doCustomFunction,expendid,name,必填一个，先走前面的id
    */
    doRightBtnEvent: function (type, expendid, name) {
        try {
            var rightMenu = Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(__WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].rightMenus);
            var btnObj_1 = type;
            var pageid_1;
            if (type === 'doCustomFunction') { //自定义按钮
                if (expendid) {
                    pageid_1 = expendid;
                }
                else if (name) { //支持多语言。eg：商务管理~~Business~~商務管理
                    var names_1 = name.split('~~');
                    rightMenu && rightMenu.map(function (item) {
                        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(names_1, item.name) >= 0) {
                            btnObj_1 = item;
                            pageid_1 = item.key;
                        }
                    });
                }
                else {
                    this.showMessage('请填写指定的页面扩展id或者名称！');
                }
            }
            else {
                rightMenu && rightMenu.map(function (item) {
                    var _fun = item.function; //"submitData"
                    if (type === _fun) {
                        btnObj_1 = item;
                        pageid_1 = item.key;
                    }
                });
            }
            if (btnObj_1 && pageid_1) {
                __WEBPACK_IMPORTED_MODULE_3__stores_list__["default"].rightMenuClick(pageid_1);
            }
        }
        catch (e) {
        }
    } }, __WEBPACK_IMPORTED_MODULE_5__excelUtil2__["a" /* modeForm_pc */]);


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treeBaseStore__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_tree__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_cubeUtil__ = __webpack_require__(19);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};








var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var TreeStore = /** @class */ (function (_super) {
    __extends(TreeStore, _super);
    function TreeStore() {
        var _this = _super.call(this) || this;
        _this.tree = undefined;
        _this.url = '';
        _this.mainFrameRefVisible = false;
        _this.remarkRefVisible = false;
        _this.treeDatas = [];
        _this.defaultHideLeft = false;
        _this.onChangeTree = function (treeid) {
            if (_this.combintreeinfo && _this.combintreeinfo[treeid]) {
                _this.update(_this.combintreeinfo[treeid]);
                var defaultAdress = _this.combintreeinfo[treeid].defaultAdress;
                _this.isCube = false;
                _this.url = '';
                if (defaultAdress) {
                    _this.onLoadRight({ href: defaultAdress });
                }
                else {
                    _this.remarkRefVisible = true;
                    _this.mainFrameRefVisible = false;
                }
            }
            _this.currentTree = treeid;
            _this.expandKeys = [];
            _this.datas = [];
            _this.params['id'] = treeid;
            _this.getTreeData(__assign({}, _this.params), true, function (datas) {
                if (_this.expandFirstNode > 0 && datas && datas.length > 0) {
                    _this.getTreeDataRecursion({ pid: datas[0].domid }, _this.expandFirstNode);
                    _this.expandKeys.push(datas[0].domid);
                }
            });
        };
        _this.refreshTree = function (id) {
            var pid = _this.getPid(_this.datas, id);
            if (!pid)
                return;
            _this.getTreeData({ pid: pid }, false, function (datas) {
                if (_this.expandKeys.indexOf(id) >= 0) {
                    _this.getTreeData({ pid: id }, false);
                }
            });
        };
        _this.getPid = function (datas, id, pid) {
            if (pid === void 0) { pid = '0_0'; }
            var rs = false;
            for (var _i = 0, datas_1 = datas; _i < datas_1.length; _i++) {
                var d = datas_1[_i];
                if (d.key == id) {
                    return pid;
                }
                else if (d.childs) {
                    var rs_1 = _this.getPid(d.childs.slice(), id, d.domid);
                    if (rs_1) {
                        return rs_1;
                    }
                }
            }
            return rs;
        };
        _this.init = function (params, callback) {
            __WEBPACK_IMPORTED_MODULE_4__util__["default"].refreshTree = _this.refreshTree;
            _this.params = params;
            if (params.treehavekeyword && params.treehavekeyword == 'false') {
                __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].error({
                    title: getLabel(558, '提示'),
                    content: getLabel('389773', "树对应的查询列表未设置关键字，请先设置关键字"),
                    onOk: function () {
                    },
                });
            }
            __WEBPACK_IMPORTED_MODULE_3__apis_tree__["c" /* initTree */](params).then(function (_a) {
                var status = _a.status, error = _a.error, props = __rest(_a, ["status", "error"]);
                if (Object(__WEBPACK_IMPORTED_MODULE_7__util_cubeUtil__["g" /* isFromProtal */])()) {
                    delete props.windowTitle;
                }
                if (status == '1') {
                    _this.update(props);
                    _this.initLeftTreeShow();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
                callback && callback();
                if (props.combintree && props.combintree.length > 0) {
                    _this.currentTree = props.combintree[0].companyid;
                }
                _this.getTreeData(params, true, function (datas, hideroot) {
                    if (_this.expandFirstNode > 0 && datas && datas.length > 0) {
                        if (hideroot) {
                            datas.forEach(function (e) {
                                if (e.haschild) {
                                    var hrmparm = {};
                                    if (e.hrmtype) {
                                        hrmparm['hrmtype'] = e.hrmtype;
                                    }
                                    _this.getTreeDataRecursion(__assign({ pid: e.domid }, hrmparm), _this.expandFirstNode);
                                    _this.expandKeys.push(e.domid);
                                }
                            });
                        }
                        else {
                            _this.getTreeDataRecursion({ pid: datas[0].domid }, _this.expandFirstNode);
                            _this.expandKeys.push(datas[0].domid);
                        }
                    }
                });
            });
        };
        _this.getTreeDataRecursion = function (params, expandFirstNode) {
            expandFirstNode--;
            var pids = _this.getPids(params);
            __WEBPACK_IMPORTED_MODULE_3__apis_tree__["a" /* getTreeDatas */](__assign({}, _this.params, params)).then(function (_a) {
                var status = _a.status, error = _a.error, datas = _a.datas, props = __rest(_a, ["status", "error", "datas"]);
                if (status == '1') {
                    _this.update(props);
                    _this.treeDatas = datas;
                    datas = _this.addParentId2Node(pids, datas);
                    _this.updateTreeDatas(params, datas);
                    if (expandFirstNode > 0) {
                        datas.forEach(function (e) {
                            if (e.haschild) {
                                var hrmparm = {};
                                if (e.hrmtype) {
                                    hrmparm['hrmtype'] = e.hrmtype;
                                }
                                _this.getTreeDataRecursion(__assign({ pid: e.domid }, hrmparm), expandFirstNode);
                                _this.expandKeys.push(e.domid);
                            }
                        });
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        _this.getParentInfo = function (datas, pid, key) {
            var rs = false;
            for (var _i = 0, datas_2 = datas; _i < datas_2.length; _i++) {
                var d = datas_2[_i];
                if (d.domid == pid) {
                    return d[key];
                }
                else if (d.childs) {
                    var rs_2 = _this.getParentInfo(d.childs.slice(), pid, key);
                    if (rs_2) {
                        return rs_2;
                    }
                }
            }
            return rs;
        };
        _this.getPids = function (_a) {
            var pid = _a.pid;
            var pids = _this.getParentInfo(_this.datas, pid, "pids");
            if (!pids) {
                pids = "";
            }
            else {
                pids += ",";
            }
            if (pid && pid.length > 33 && pid.charAt(32) == '_') { //有uuid前缀
                pid = pid.substring(pid.indexOf("_") + 1);
            }
            pids += pid;
            return pids;
        };
        _this.getTreeData = function (params, init, callback) {
            var hrmparam = {};
            if (_this.currentNodeData && _this.currentNodeData.data && _this.currentNodeData.data.hrmtype) {
                hrmparam['hrmtype'] = _this.currentNodeData.data.hrmtype;
            }
            var pids = _this.getPids(params);
            __WEBPACK_IMPORTED_MODULE_3__apis_tree__["a" /* getTreeDatas */](__assign({}, _this.params, params, hrmparam)).then(function (_a) {
                var status = _a.status, error = _a.error, datas = _a.datas, hideroot = _a.hideroot, noRight = _a.noRight, props = __rest(_a, ["status", "error", "datas", "hideroot", "noRight"]);
                if (noRight) {
                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.push('/main/cube/encrypt');
                }
                callback && callback(datas, hideroot);
                if (status == '1') {
                    _this.update(props);
                    _this.treeDatas = datas;
                    if (init) {
                        _this.datas = datas;
                    }
                    else {
                        datas = _this.addParentId2Node(pids, datas);
                        _this.updateTreeDatas(params, datas);
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
                _this.isInit = true;
            });
        };
        _this.setDefaultHideLeft = function (bool) {
            _this.defaultHideLeft = bool;
        };
        _this.setShowLeft = function (bool) {
            _this.showLeft = bool;
        };
        _this.initLeftTreeShow = function () {
            if (_this.defaultHideLeft) {
                return _this.setShowLeft(false);
            }
            else {
                if (_this.defaulthideleft && _this.defaulthideleft == '1' && _this.showLeft == undefined) {
                    return _this.setShowLeft(false);
                }
            }
            _this.setShowLeft(true);
        };
        _this.getTreeHref = function (params, hrmtype) {
            var hrmparam = {};
            if (hrmtype) {
                hrmparam = { hrmtype: hrmtype };
            }
            __WEBPACK_IMPORTED_MODULE_3__apis_tree__["b" /* getTreeHref */](__assign({}, _this.params, params, { isRefreshTree: _this.isRefreshTree }, hrmparam)).then(function (_a) {
                var status = _a.status, error = _a.error, href = _a.href, props = __rest(_a, ["status", "error", "href"]);
                if (status == '1') {
                    href = _this.getRealHref(params.pid, href);
                    var beginindex = href.indexOf("$");
                    while (beginindex > -1) {
                        var endindex = href.indexOf("$", beginindex + 1);
                        var subDress = href.substring(beginindex + 1, endindex);
                        if (endindex > -1) {
                            if (_this.params && _this.params[subDress]) {
                                href = href.replace('$' + subDress + '$', _this.params[subDress]);
                            }
                            else {
                                href = href.replace('$' + subDress + '$', '');
                            }
                        }
                        else {
                            break;
                        }
                        beginindex = href.indexOf("$");
                    }
                    _this.update(props);
                    if (href != '') {
                        _this.onLoadRight({ href: href });
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        _this.getRealHref = function (id, href) {
            if (href.indexOf("$") < 0 || id.indexOf("_") < 0) {
                return href;
            }
            var lowerHref = href.toLowerCase();
            if (lowerHref.indexOf("$treenodeid_id$") > -1) { //树节点id
                var treenodeid = id.substring(0, id.lastIndexOf("_"));
                if (id.length > 33 && id.charAt(32) == '_') { //有uuid前缀
                    treenodeid = id.substring(id.indexOf("_") + 1);
                }
                href = href.replace(new RegExp("\\$treenodeid_id\\$", "gi"), treenodeid);
            }
            if (lowerHref.indexOf("$treenodeid$") > -1) { //树节点id
                var treenodeid = id.substring(0, id.lastIndexOf("_"));
                if (id.length > 33 && id.charAt(32) == '_') { //有uuid前缀
                    treenodeid = id.substring(id.indexOf("_") + 1, id.lastIndexOf("_"));
                }
                href = href.replace(new RegExp("\\$treenodeid\\$", "gi"), treenodeid);
            }
            if (lowerHref.indexOf("$superiorkey$") > -1) { //直接上级节点的主键值
                var parentPkId = _this.getParentInfo(_this.datas, id, "pids");
                var parentPkIdArr = parentPkId.split(",");
                if (parentPkIdArr.length > 0) {
                    parentPkId = parentPkIdArr[parentPkIdArr.length - 1];
                }
                if (parentPkId.indexOf("_") > -1) {
                    parentPkId = parentPkId.substring(parentPkId.lastIndexOf("_") + 1);
                }
                href = href.replace(new RegExp("\\$superiorkey\\$", "gi"), parentPkId);
            }
            if (lowerHref.indexOf("$treenodeid_superiorkey$") > -1) {
                var parentPkId = _this.getParentInfo(_this.datas, id, "pids");
                var parentPkIdArr = parentPkId.split(",");
                if (parentPkIdArr.length > 0) {
                    parentPkId = parentPkIdArr[parentPkIdArr.length - 1];
                }
                href = href.replace(new RegExp("\\$treenodeid_superiorkey\\$", "gi"), parentPkId);
            }
            if (lowerHref.indexOf("$allsuperiorkey$") > -1) { //所有上级节点的主键值
                var pids = _this.getParentInfo(_this.datas, id, "pids");
                var pidArr = pids.split(",");
                var pkIds = "";
                for (var _i = 0, pidArr_1 = pidArr; _i < pidArr_1.length; _i++) {
                    var pid = pidArr_1[_i];
                    pkIds += "," + pid.substring(pid.indexOf("_") + 1);
                }
                if (pkIds.length > 0) {
                    pkIds = pkIds.substring(1);
                }
                href = href.replace(new RegExp("\\$allsuperiorkey\\$", "gi"), pkIds);
            }
            if (lowerHref.indexOf("$treenodeid_allsuperiorkey$") > -1) {
                var pids = _this.getParentInfo(_this.datas, id, "pids");
                var pidArr = pids.split(",");
                var pkIds = "";
                for (var _a = 0, pidArr_2 = pidArr; _a < pidArr_2.length; _a++) {
                    var pid = pidArr_2[_a];
                    pkIds += "," + pid;
                }
                if (pkIds.length > 0) {
                    pkIds = pkIds.substring(1);
                }
                href = href.replace(new RegExp("\\$treenodeid_allsuperiorkey\\$", "gi"), pkIds);
            }
            var count = 10;
            while (href.toLowerCase().indexOf("superiorkey") > -1 && count > 0) {
                count--;
                var suplevel = 1;
                var isNeedNodeId = false;
                var superiorkey = href.substring(href.toLowerCase().indexOf("superiorkey"));
                if (href.toLowerCase().indexOf("$superiorkey") > -1) { //不包含树节点id
                    superiorkey = href.substring(href.toLowerCase().indexOf("$superiorkey") + 1);
                }
                else { //包含树节点id
                    isNeedNodeId = true;
                    superiorkey = href.substring(href.toLowerCase().indexOf("$treenodeid_superiorkey") + 1);
                }
                superiorkey = superiorkey.substring(0, superiorkey.indexOf("$"));
                suplevel = suplevel + _this.getCount(superiorkey, "_key");
                var pids = _this.getParentInfo(_this.datas, id, "pids");
                var pidArr = pids.split(",");
                var pkIds = "";
                if (pidArr.length < suplevel) {
                    pkIds = "";
                    if (!!(__WEBPACK_IMPORTED_MODULE_4__util__["default"].console && __WEBPACK_IMPORTED_MODULE_4__util__["default"].console.log)) {
                        __WEBPACK_IMPORTED_MODULE_4__util__["default"].console.log("pids获取失败:", pids);
                    }
                }
                pkIds = pidArr[pidArr.length - suplevel];
                if (!isNeedNodeId) {
                    pkIds = pkIds.substring(pkIds.lastIndexOf("_") + 1);
                }
                href = href.replace(new RegExp("\\$" + superiorkey + "\\$", "gi"), pkIds);
            }
            href = _this.getUrlParams(href);
            return href;
        };
        _this.getUrlParams = function (href) {
            for (var key in _this.params) {
                if (key == "id" || key == "_key" || key == "guid" || href.indexOf("?" + key + "=") > -1 || href.indexOf("&" + key + "=") > -1) {
                    continue;
                }
                if (href.indexOf("?") > -1) {
                    href += "&";
                }
                else {
                    href += "?";
                }
                href += key;
            }
            return href;
        };
        _this.getCount = function (str, r) {
            r = eval("/" + r + "/ig");
            return str.match(r) ? str.match(r).length : 0;
        };
        _this.quickSearch = function (search) {
            var urlParams = _this.parseUrlParams();
            var _id = _this.params.id;
            if (search || (_id && _id !== urlParams.id)) { // 平铺展示时，search为空仍需调用quickSearch接口
                __WEBPACK_IMPORTED_MODULE_3__apis_tree__["d" /* quickSearch */](__assign({}, _this.params, { search: search })).then(function (_a) {
                    var status = _a.status, error = _a.error, datas = _a.datas, expandKeys = _a.expandKeys;
                    if (status == '1') {
                        _this.datas = datas;
                        _this.expandKeys = expandKeys;
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                        throw error;
                    }
                });
            }
            else {
                _this.expandKeys = [];
                _this.init(_this.params);
            }
        };
        _this.parseUrlParams = function () {
            var urlHash = location.hash.split('?')[1];
            var urlParams = {};
            if (urlHash) {
                var paramsArr = urlHash.split('&');
                for (var i = 0, len = paramsArr.length; i < len; i++) {
                    var item = paramsArr[i].split('=');
                    urlParams[item[0]] = item[1];
                }
            }
            return urlParams;
        };
        _this.reloadSearch = function (params, callback) {
            if (callback === void 0) { callback = function () {
                if (_this.defaultAdress) {
                    var beginindex = _this.defaultAdress.indexOf("$");
                    while (beginindex > -1) {
                        var endindex = _this.defaultAdress.indexOf("$", beginindex + 1);
                        var subDress = _this.defaultAdress.substring(beginindex + 1, endindex);
                        if (endindex > -1) {
                            if (params && params[subDress]) {
                                _this.defaultAdress = _this.defaultAdress.replace('$' + subDress + '$', params[subDress]);
                            }
                            else {
                                _this.defaultAdress = _this.defaultAdress.replace('$' + subDress + '$', '');
                            }
                        }
                        else {
                            break;
                        }
                        beginindex = _this.defaultAdress.indexOf("$");
                    }
                    _this.onLoadRight({ href: _this.defaultAdress });
                }
                else {
                    _this.isCube = false;
                    _this.mainFrameRefVisible = false;
                    _this.remarkRefVisible = true;
                }
            }; }
            _this.clear();
            _this.init(params, callback);
        };
        _this.onExpandChange = function (expandKeys) {
            _this.expandKeys = expandKeys;
        };
        _this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
        _this.updateParams = function (params, forceRefreash) {
            if (forceRefreash === void 0) { forceRefreash = false; }
            var temp = !__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(_this.params), params);
            _this.params = params;
            if (temp || forceRefreash) {
                _this.reloadSearch(params);
            }
        };
        _this.getQuery = function (href) {
            var lastofnum = href.lastIndexOf('?');
            href = href.slice(lastofnum);
            var _a = href.split('?'), url = _a[0], query = _a[1];
            var querys = query.split("&");
            var queryObj = {};
            __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.set(queryObj, url, url);
            querys.map(function (q) {
                var _a = q.split("="), name = _a[0], value = _a[1];
                __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.set(queryObj, name, value);
            });
            return queryObj;
        };
        _this.onLoadRight = function (_a) {
            var href = _a.href;
            _this.isCube = false;
            if (href) {
                var url = Object(__WEBPACK_IMPORTED_MODULE_4__util__["replaceE8Url"])(href);
                url = _this.checkHref(url);
                if (url.indexOf('?') > -1) {
                    _this.url = url.split('?').join('?istree=true&_t=' + new Date().getTime() + '&');
                }
                else {
                    _this.url = url + "?istree=true&_t=" + new Date().getTime();
                }
                if (url.indexOf("/spa/cube/index.html") >= 0) {
                    _this.isCube = true;
                    if (url.indexOf("main/cube/card") >= 0) {
                    }
                    else if (url.indexOf("main/cube/search") >= 0) {
                    }
                    else if (url.indexOf("main/cube/tree") >= 0) {
                    }
                    else if (url.indexOf("main/cube/reply") >= 0) {
                    }
                    else {
                        _this.isCube = false;
                    }
                    _this.mainFrameRefVisible = false;
                }
                if (!_this.isCube) {
                    var mainFrame = document.getElementById("cube-tree-mainFrame");
                    if (mainFrame) {
                        mainFrame.src = _this.url ? _this.url.replace(/&_key=\w{1,10}&/g, '&') : ''; //去掉用户配置多加的key
                        _this.mainFrameRefVisible = true;
                    }
                }
                _this.remarkRefVisible = false;
            }
            else {
                _this.remarkRefVisible = true;
                _this.mainFrameRefVisible = false;
            }
        };
        _this.changeLoading = function (loading) {
            if (loading === void 0) { loading = false; }
            _this.rightLoading = loading;
        };
        _this.checkHref = function (href) {
            var exceptArr = [
                // "/spa/cube/index.html#/main/cube/card",
                "/spa/workflow/index_form.jsp",
                "/spa/document/index.jsp",
                "/spa/hrm/index_mobx.html",
            ];
            for (var index = 0; index < exceptArr.length; index++) {
                var element = exceptArr[index];
                if (href.indexOf(element) > -1) {
                    href = href.replace(/(jsp#)|(html#)/g, function (item) {
                        return item.replace(/(jsp)|(html)/g, function (type) {
                            return type + ("?__random__=" + Date.now());
                        });
                    });
                    return href;
                }
            }
            return href;
        };
        return _this;
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], TreeStore.prototype, "mainFrameRefVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], TreeStore.prototype, "remarkRefVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], TreeStore.prototype, "currentNodeData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], TreeStore.prototype, "combintreeinfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], TreeStore.prototype, "showLeft", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], TreeStore.prototype, "defaultHideLeft", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "getTreeData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "setDefaultHideLeft", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "setShowLeft", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "initLeftTreeShow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "getTreeHref", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "quickSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "reloadSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "onExpandChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "onLoadRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "changeLoading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], TreeStore.prototype, "checkHref", void 0);
    return TreeStore;
}(__WEBPACK_IMPORTED_MODULE_0__treeBaseStore__["a" /* default */]));

/* harmony default export */ __webpack_exports__["b"] = (new TreeStore());


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(599),
    listCacheDelete = __webpack_require__(600),
    listCacheGet = __webpack_require__(601),
    listCacheHas = __webpack_require__(602),
    listCacheSet = __webpack_require__(603);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(94);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(605);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(123),
    stackClear = __webpack_require__(611),
    stackDelete = __webpack_require__(612),
    stackGet = __webpack_require__(613),
    stackHas = __webpack_require__(614),
    stackSet = __webpack_require__(615);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 127 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(619),
    baseUnary = __webpack_require__(61),
    nodeUtil = __webpack_require__(100);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(94),
    isArrayLike = __webpack_require__(45),
    isIndex = __webpack_require__(96),
    isObject = __webpack_require__(23);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(128),
    isObject = __webpack_require__(23);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(135);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(328),
    baseIsNaN = __webpack_require__(647),
    strictIndexOf = __webpack_require__(648);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(51),
    baseIteratee = __webpack_require__(40),
    baseMap = __webpack_require__(670),
    isArray = __webpack_require__(13);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(191),
    setCacheAdd = __webpack_require__(657),
    setCacheHas = __webpack_require__(658);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(141);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(73),
    toKey = __webpack_require__(74);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(60),
    baseTrim = __webpack_require__(296),
    castSlice = __webpack_require__(143),
    charsEndIndex = __webpack_require__(341),
    charsStartIndex = __webpack_require__(342),
    stringToArray = __webpack_require__(144),
    toString = __webpack_require__(37);

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(340);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(677),
    hasUnicode = __webpack_require__(343),
    unicodeToArray = __webpack_require__(678);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(60),
    castSlice = __webpack_require__(143),
    hasUnicode = __webpack_require__(343),
    isIterateeCall = __webpack_require__(131),
    isRegExp = __webpack_require__(700),
    stringToArray = __webpack_require__(144),
    toString = __webpack_require__(37);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlDocker", function() { return UrlDocker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__list__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tree__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amkjzg__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reply__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cubeMind__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__custompage__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_bar_code__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_no_right__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_map__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_deep_equal__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_log_list__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_view_resource__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_templateManage__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__board__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__timeline__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mindMap__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__list_BatchPrint__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__gantt__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_no_right_encrypt__ = __webpack_require__(1166);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





























var getLabel = __WEBPACK_IMPORTED_MODULE_14_ecCom__["WeaLocaleProvider"].getLabel;
var UrlDocker = /** @class */ (function (_super) {
    __extends(UrlDocker, _super);
    function UrlDocker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getGuid = function (href) {
            if (href === void 0) { href = ''; }
            var url = href.split('?')[0];
            if (url.indexOf("/spa/cube/index.html") > -1 || url.indexOf("/spa/cube/index.jsp") > -1) {
                if (url.endsWith("card")) {
                    return "card";
                }
                else if (url.endsWith("search")) {
                    return 'search';
                }
                else if (url.endsWith("tree")) {
                    return 'tree';
                }
                else if (url.endsWith("reply")) {
                    return 'reply';
                }
                else if (url.endsWith("viewCustomPage")) {
                    return "viewCustomPage";
                }
                else if (url.endsWith("BatchPrint")) {
                    return "BatchPrint";
                }
                else if (url.endsWith("amkjzg")) {
                    return "amkjzg";
                }
            }
            return '';
        };
        _this.getQuery = function (href) {
            var lastofnum = href.lastIndexOf('?');
            href = href.slice(lastofnum);
            var query = href.split('?')[1];
            var querys = query ? query.split("&") : [];
            var queryObj = {};
            querys.map(function (q) {
                var index = q.indexOf("=");
                var name = q.substring(0, index);
                var value = decodeURIComponent(q.substring(index + 1));
                __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.set(queryObj, name, value);
            });
            __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.set(queryObj, 'guid', _this.getGuid(href));
            return queryObj;
        };
        _this.doUpdate = function (url) {
            var query = _this.getQuery(url);
            var guid = _this.getGuid(url);
            var store = __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(_this.props, guid.charAt(0).toUpperCase() + guid.slice(1));
            if (store) {
                if (guid == 'search') {
                    store.updateParams(__assign({}, query, { t: new Date().getTime() }), true);
                    return;
                }
                store.updateParams(query, true);
            }
        };
        return _this;
    }
    UrlDocker.prototype.componentWillMount = function () {
        this.props.url && this.doUpdate(this.props.url);
    };
    UrlDocker.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.url != nextProps.url) {
            this.doUpdate(nextProps.url);
        }
    };
    UrlDocker.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_24_jquery___default()("#custompageCodeArea").html("");
        __WEBPACK_IMPORTED_MODULE_24_jquery___default()("#cubelistCodeArea").html('');
    };
    UrlDocker.prototype.render = function () {
        var _a = this.props, _b = _a.prefixCls, prefixCls = _b === void 0 ? 'coms-mode-docker' : _b, className = _a.className;
        var guid = this.getGuid(this.props.url);
        var Com = { search: __WEBPACK_IMPORTED_MODULE_4__list__["a" /* default */], tree: __WEBPACK_IMPORTED_MODULE_5__tree__["a" /* default */], card: __WEBPACK_IMPORTED_MODULE_6__card__["default"], amkjzg: __WEBPACK_IMPORTED_MODULE_7__amkjzg__["a" /* default */], reply: __WEBPACK_IMPORTED_MODULE_8__reply__["default"], viewCustomPage: __WEBPACK_IMPORTED_MODULE_10__custompage__["a" /* default */] }[guid];
        var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, prefixCls, "coms-mode-" + guid);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: classNames },
            window.location.href.indexOf('/spa/cube/index.html') > -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_ecCom__["WeaPopoverHrm"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaPopoverHrm@r3urbn" }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null),
            Com && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CubeErrorPage, { ecId: (this && this.props && this.props.ecId || '') + "_CubeErrorPage@amu4sl" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Com, __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Com@xwxere" }, this.props))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "custompageCodeArea", style: { display: "none" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cubelistCodeArea", style: { display: "none" } })));
    };
    return UrlDocker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var getQuery = function (href) {
    var lastofnum = href.lastIndexOf('?');
    href = href.slice(lastofnum);
    var query = href.split('?')[1];
    var querys = query ? query.split("&") : [];
    var queryObj = {};
    querys.map(function (q) {
        var index = q.indexOf("=");
        var name = q.substring(0, index);
        var value = decodeURIComponent(q.substring(index + 1));
        //处理带入数据卡片页面的多行文本
        if (name.indexOf('field') !== -1) {
            // value = decodeURIComponent(value);
            if (value.startsWith('<span><p>')) { //非html多行文本
                value = __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.replace(value, /<span>|<\/span>|<p>|<\/p>/g, '');
                value = __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.replace(value, '<br/>', '\n');
            }
        }
        __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.set(queryObj, name, value);
    });
    return queryObj;
};
var Docker = /** @class */ (function (_super) {
    __extends(Docker, _super);
    function Docker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doUpdate = function (props) {
            var location = props.location, params = props.params, Search = props.Search, Tree = props.Tree, BarCodeStore = props.BarCodeStore, QrCodeStore = props.QrCodeStore, Card = props.Card, Amkjzg = props.Amkjzg, reply = props.reply, cubeLogList = props.cubeLogList, cubeViewResource = props.cubeViewResource, mapStore = props.mapStore, customPageStore = props.customPageStore, BatchPrint = props.BatchPrint;
            var query = getQuery(window.location.href); //这里不要使用location.search，问题见#608611  decodeURI
            if (params.guid == 'anyurl') {
                Object(__WEBPACK_IMPORTED_MODULE_3__apis_card__["E" /* getTreeDataUrl */])(query).then(function (_a) {
                    var status = _a.status, error = _a.error, errorCode = _a.errorCode, href = _a.href;
                    if (status == '1') {
                        window.location.href = href;
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_19_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                        window.location.href = Object(__WEBPACK_IMPORTED_MODULE_27__util_contentPath__["a" /* getContentPath */])('/spa/cube/index.html#/main/cube/nofound');
                    }
                });
                return;
            }
            var store = { search: Search, tree: Tree, barCode: BarCodeStore, qrCode: QrCodeStore, card: Card, amkjzg: Amkjzg, reply: reply, logList: cubeLogList, viewResource: cubeViewResource, map: mapStore, viewCustomPage: customPageStore, BatchPrint: BatchPrint }[params.guid];
            if (store && store.updateParams) {
                store.updateParams(__assign({}, query, params, { _key: location.key }));
            }
        };
        return _this;
    }
    Docker.prototype.componentWillMount = function () {
        this.doUpdate(this.props);
    };
    Docker.prototype.componentWillReceiveProps = function (nextProps) {
        var nextP = nextProps.location.action;
        var thisP = this.props.location;
        delete nextP.action;
        delete thisP.action;
        if (!__WEBPACK_IMPORTED_MODULE_15_deep_equal___default()(nextP, thisP)) {
            this.doUpdate(nextProps);
        }
    };
    Docker.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_24_jquery___default()("#custompageCodeArea").html("");
        __WEBPACK_IMPORTED_MODULE_24_jquery___default()("#cubelistCodeArea").html('');
    };
    Docker.prototype.render = function () {
        if (window.location.href.indexOf('/main/cube/cubeMind') > 0) {
            window.location.href = window.location.href.replace('cubeMind', 'mindMap') + '&isold=1';
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
        }
        var _a = this.props, _b = _a.prefixCls, prefixCls = _b === void 0 ? 'coms-mode-docker' : _b, className = _a.className, params = _a.params;
        var Com = {
            search: __WEBPACK_IMPORTED_MODULE_4__list__["a" /* default */], tree: __WEBPACK_IMPORTED_MODULE_5__tree__["a" /* default */], card: __WEBPACK_IMPORTED_MODULE_6__card__["default"], amkjzg: __WEBPACK_IMPORTED_MODULE_7__amkjzg__["a" /* default */], barCode: __WEBPACK_IMPORTED_MODULE_11__pages_bar_code__["a" /* default */],
            noright: __WEBPACK_IMPORTED_MODULE_12__pages_no_right__["a" /* default */], qrCode: __WEBPACK_IMPORTED_MODULE_11__pages_bar_code__["a" /* default */], map: __WEBPACK_IMPORTED_MODULE_13__pages_map__["b" /* MapViewer */], reply: __WEBPACK_IMPORTED_MODULE_8__reply__["default"],
            logList: __WEBPACK_IMPORTED_MODULE_16__pages_log_list__["a" /* default */], viewResource: __WEBPACK_IMPORTED_MODULE_17__pages_view_resource__["a" /* default */],
            viewCustomPage: __WEBPACK_IMPORTED_MODULE_10__custompage__["a" /* default */], templateManage: __WEBPACK_IMPORTED_MODULE_20__pages_templateManage__["a" /* default */], cubeMind: __WEBPACK_IMPORTED_MODULE_9__cubeMind__["a" /* default */], board: __WEBPACK_IMPORTED_MODULE_21__board__["a" /* default */], mindMap: __WEBPACK_IMPORTED_MODULE_23__mindMap__["a" /* default */],
            BatchPrint: __WEBPACK_IMPORTED_MODULE_25__list_BatchPrint__["a" /* BatchPrint */], timeline: __WEBPACK_IMPORTED_MODULE_22__timeline__["a" /* default */], gantt: __WEBPACK_IMPORTED_MODULE_26__gantt__["a" /* default */], encrypt: __WEBPACK_IMPORTED_MODULE_28__pages_no_right_encrypt__["a" /* default */]
        }[params.guid];
        var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, prefixCls, "coms-mode-" + params.guid);
        var printClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, "cube-card-wrap");
        var props = { location: this.props.location };
        if (params.guid == 'barCode') {
            props.CodeStore = this.props.BarCodeStore;
        }
        else if (params.guid == 'qrCode') {
            props.CodeStore = this.props.QrCodeStore;
        }
        else if (params.guid == 'BatchPrint') {
            props.BatchPrintStore = this.props.BatchPrint;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: params.guid == 'BatchPrint' ? printClassNames : classNames },
            window.location.href.indexOf('/spa/cube/index.html') > -1 || window.location.href.indexOf('/spa/cube/index.jsp') > -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_ecCom__["WeaPopoverHrm"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaPopoverHrm@pv6cqj" }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null),
            Com && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CubeErrorPage, { ecId: (this && this.props && this.props.ecId || '') + "_CubeErrorPage@yg9594" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Com, __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Com@knmejd" }, props))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "custompageCodeArea", style: { display: "none" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cubelistCodeArea", style: { display: "none" } })));
    };
    Docker = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('Search', 'Tree', 'BarCodeStore', 'QrCodeStore', 'Card', 'Amkjzg', 'reply', 'cubeLogList', 'cubeViewResource', "mapStore", 'customPageStore', 'BatchPrint')
    ], Docker);
    return Docker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (Docker);
var CubeErrorPage = /** @class */ (function (_super) {
    __extends(CubeErrorPage, _super);
    function CubeErrorPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isError: false };
        return _this;
    }
    CubeErrorPage.prototype.componentDidCatch = function (error, info) {
        this.setState({
            isError: true,
        });
    };
    CubeErrorPage.prototype.render = function () {
        if (this.state.isError) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_ecCom__["WeaErrorPage"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaErrorPage@hi4pwf", msg: getLabel(383324, "对不起，该页面异常，请联系管理员") });
        }
        else {
            return this.props.children;
        }
    };
    return CubeErrorPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__top_title__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__right_menu_wrap__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__advanced__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_batch_share__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_template__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_batch_share_Single__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modeTab_TabSetDialog__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__stores_list__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mobx_table__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__card_CustomDialog__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Batchmodifyfeild__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__card_RightLeftLayout__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_map__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__batchAdd__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Excel__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Tree__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ImgSearch__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dataBoard__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__style_selectcast_less__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__style_selectcast_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__style_selectcast_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28____ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__quickSearch__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__verticalList__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__AdvancedSearchs__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ListCount__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__commonComs_buttonNew__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__util_contentPath__ = __webpack_require__(9);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _this = this;





































var WeaTable = __WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaTableNew"].WeaTable;
var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var RadioGroup = __WEBPACK_IMPORTED_MODULE_5_antd__["Radio"].Group;
var MenuItem = __WEBPACK_IMPORTED_MODULE_5_antd__["Menu"].Item;
var ButtonGroup = __WEBPACK_IMPORTED_MODULE_5_antd__["Button"].Group;
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hideAdvancedSearchPanel = false;
        _this.pageSizeOptions = [];
        _this.setStore = function () {
            if (__WEBPACK_IMPORTED_MODULE_8__util__["default"].location.hash.indexOf('#/main/cube/viewResource') > -1) { //资源面板页面，需要在listStore中调用cubeViewResource方法
                var _a = _this.props, Search = _a.Search, cubeViewResource = _a.cubeViewResource;
                var setStore = Search.setStore;
                setStore('cubeViewResource', cubeViewResource);
            }
        };
        _this.quickSearch = function (quickSearchValue) {
            var Search = _this.props.Search;
            quickSearchValue = __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.trim(quickSearchValue);
            Search.update({ quickSearchValue: quickSearchValue });
            if (Search.isEdit && (Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].Empty || Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].Normal)) {
                Search.doBatchEdit_datakey(null, {}, true);
            }
            else {
                Search.refresh(true);
            }
        };
        _this.changeQuickSearchValue = function (val) {
            var Search = _this.props.Search;
            var quickSearchValue = val;
            Search.update({ quickSearchValue: quickSearchValue });
        };
        _this.refresh = function () {
            var Search = _this.props.Search;
            if (!Search.isShowCondition) {
                Search.condition.update({ visible: false });
            }
            if (Search.isEdit) {
                if (Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].Excel) {
                    Search.doBatchEdit_datakey(function (dataKey) {
                        Search.excelStore.getDatas(dataKey, 1);
                    });
                }
                else {
                    Search.doBatchEdit_datakey();
                }
            }
            else {
                Search.refresh(false, true);
            }
        };
        _this.batchShare = function () {
            var Search = _this.props.Search;
            if (!Search.checkSeleted()) {
                return;
            }
        };
        _this.judgeTopHide = function () {
            var Search = _this.props.Search;
            if (Search.params.hidetop) { // && Search.params.guid === 'search'严格限制为search
                var hidetop = Search.params.hidetop;
                Search.isInnerTab = hidetop && (hidetop | 0) === 1;
                _this.hideAdvancedSearchPanel = hidetop && (hidetop | 0) === 1;
            }
        };
        _this.hide = function (advanced) {
            advanced.update({ visible: false });
        };
        /* 统计 在右上角显示时，将超出部分以下拉框形式显示 type:'selectedKey'时需重新计算下拉框宽度*/
        _this.showCountDataOnTopRight = function () {
            var Search = _this.props.Search;
            var handleShowMoreCountData = Search.handleShowMoreCountData;
            var $topCountDataMore = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('#top-countData-more');
            if ($topCountDataMore.length > 0) {
                setTimeout(function () {
                    if (__WEBPACK_IMPORTED_MODULE_25_jquery___default()('#top-countData-more').length > 0) { // 再次判断，针对自定义页面weatop会先加载再隐藏的问题
                        // 恢复样式
                        __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.wea-new-top .cube-list-top-countData').attr('style', '');
                        __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.wea-new-top .cube-list-top-countData-more').attr('style', '');
                        __WEBPACK_IMPORTED_MODULE_25_jquery___default()('#top-countData-list').attr('style', '');
                        $topCountDataMore.show();
                        /*  动态计算“统计项”展示的宽度  */
                        var containerWidth = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('#top-countData-more').parents(".wea-new-top").width(); // top宽度
                        var containerToLeft = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('#top-countData-more').parents(".wea-new-top").offset().left; // wea-new-top距左侧的距离
                        var topCountMoreToLeft = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('#top-countData-more').offset().left; // top-countData-more按钮距左侧的距离
                        // 计算 top右侧的快捷搜索按钮宽度和  快捷搜索按钮宽度和 = top宽度 + wea-new-top距左侧的距离 - top-countData-more按钮距左侧的距离
                        var btnsWidth = containerWidth + containerToLeft - topCountMoreToLeft;
                        var newTopTitleWidth = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.coms-mode-search .coms-mode-top-title .ant-col-14 .wea-new-top-title').width(); // top 标题 整体宽度
                        var newTopTitleBreadcrumbWidth = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.coms-mode-search .coms-mode-top-title .wea-new-top-title .wea-new-top-title-breadcrumb').width(); // top 标题文字宽度
                        /**
                         * 由于ie浏览器下 span内文字长度会超过span元素的宽度，而获取到的是span的宽度，因此当span内文字过长时，依然存在与右侧“统计项”重叠的问题
                         * 因此需要增加判断，当newTopTitleBreadcrumbWidth快要超过父元素newTopTitleWidth的宽度时，就采用父元素newTopTitleWidth的宽度
                         */
                        if (!__WEBPACK_IMPORTED_MODULE_25_jquery___default.a.browser.chrome && newTopTitleBreadcrumbWidth + 100 > newTopTitleWidth) {
                            newTopTitleBreadcrumbWidth = newTopTitleWidth;
                        }
                        // 计算top左侧标题宽度
                        var leftTitleWidth = Math.min(newTopTitleWidth, newTopTitleBreadcrumbWidth);
                        // 计算留给'统计'展示的剩余宽度  留给'统计'展示的剩余宽度 = top宽度 - top标题宽度 - 右侧快捷按钮宽度和
                        var fixedWidth = Math.min(containerWidth - leftTitleWidth, containerWidth * 0.6) - btnsWidth - 60;
                        var countDataWidthSum_1 = 0; // 所有“统计项”总宽度
                        var topCountDataWidth = 0; // 展示在top中的“统计项”总宽度
                        var index = 0; //隐藏的'统计项'数量
                        var $topCountDataList = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.wea-new-top .cube-list-top-countData'); // 水平展示'统计'项
                        var $topCountDataListMore = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.wea-new-top .cube-list-top-countData-more'); // 下拉展示'统计'项
                        // 计算'统计'项的总宽度
                        $topCountDataListMore.each(function () {
                            countDataWidthSum_1 += __WEBPACK_IMPORTED_MODULE_25_jquery___default()(this).width();
                        });
                        if (countDataWidthSum_1 > fixedWidth) { // 判断是否需要显示“显示更多”按钮
                            $topCountDataMore.show(); // 需要显示“显示更多”按钮
                            __WEBPACK_IMPORTED_MODULE_25_jquery___default()('#top-countData-more .icon-coms').css('visibility', 'visible');
                            // 当top展示的“统计项”总长度小于可展示位置的宽度，则从左至右将“统计项”显示在top中
                            while (topCountDataWidth + $topCountDataListMore.eq(index).width() + 10 < fixedWidth) {
                                topCountDataWidth += $topCountDataListMore.eq(index).width() + 10;
                                $topCountDataList.eq(index).css('display', 'inline-block');
                                $topCountDataListMore.eq(index).css('display', 'none');
                                index++;
                            }
                            // 由于ie与Chrome计算宽度的不同，ie下会出现重叠现象，因此隐藏一个统计项避免重叠
                            if (!__WEBPACK_IMPORTED_MODULE_25_jquery___default.a.browser.chrome && index > 0) {
                                index--;
                                topCountDataWidth = topCountDataWidth - $topCountDataListMore.eq(index).width() - 10;
                                $topCountDataList.eq(index).css('display', 'none');
                                $topCountDataListMore.eq(index).css('display', 'inline-block');
                            }
                        }
                        else {
                            $topCountDataMore.hide(); // 不需要显示“显示更多”按钮
                            $topCountDataList.css('display', 'inline-block');
                            $topCountDataListMore.css('display', 'none');
                        }
                        // 调整下拉列表位置/宽度
                        __WEBPACK_IMPORTED_MODULE_25_jquery___default()('#top-countData-list').css({ 'width': topCountDataWidth + 22, 'right': btnsWidth - 14 });
                        document.addEventListener('click', function () {
                            handleShowMoreCountData(true);
                        });
                    }
                }, 200);
            }
        };
        _this.getSerchButtons = function (advanced, hasCancel) {
            var Search = _this.props.Search;
            var btns = new Array();
            btns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__commonComs_buttonNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonNew@le1eep@refresh", type: "primary", content: getLabel(197, '搜索'), onClick: _this.refresh }));
            btns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__commonComs_buttonNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonNew@gtgug5@reset", content: getLabel(2022, '重置'), id: advanced, onClick: _this.reset }));
            if (_this.props.Search.templateid) {
                btns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@r8fgra@saveTemplate", onClick: Search.saveTemplate }, getLabel(86, '保存')));
            }
            if (_this.props.Search.type != 'advanced' && !Search.templateid && !Search.isBackUpData) {
                btns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__commonComs_buttonNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonNew@gqwd84@saveAsTemplate", content: getLabel(18418, '存为模板'), onClick: Search.template.saveAsTemplate }));
            }
            if (hasCancel) {
                btns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__commonComs_buttonNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonNew@k2vhag@hide", content: getLabel(201, '取消'), id: advanced, onClick: _this.hide }));
            }
            return btns;
        };
        _this.reset = function (advanced) {
            var Search = _this.props.Search;
            advanced.form.resetForm();
            Search.quickSearchValue = '';
        };
        _this.changeTabs = function (selectedKey) {
            var Search = _this.props.Search;
            var params = Search.params, top = Search.top;
            Search.top.update({ selectedKey: selectedKey });
            Search.update({ params: __assign({}, params, { groupValue: top.selectedKey }) });
            if (Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].ImgType) {
                Search.newTable.current = 1;
            }
            _this.refresh();
        };
        _this.hideAdvacedIfNoCondition = function () {
            var Search = _this.props.Search;
            try {
                if (Search.conditionInfo && Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(Search.conditionInfo)[0].items && Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(Search.conditionInfo)[0].items.length <= 0) {
                    _this.hideAdvancedSearchPanel = true;
                }
                else if (Search.conditionInfo && Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(Search.conditionInfo)[0].items && Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(Search.conditionInfo)[0].items.length > 0) {
                    _this.hideAdvancedSearchPanel = false;
                }
            }
            catch (e) {
            }
            //判断是否出现高级搜索，如果高级搜索中不存在条件头目，则隐藏，
        };
        _this.getAdvancedQuickButtons = function () {
            var Search = _this.props.Search;
            return [
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@elfmyr@refresh", type: "primary", onClick: _this.refresh }, getLabel(197, '搜索')),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@0mgn7w@onReset", onClick: Search.advanced.form.onReset }, getLabel(2022, '重置')),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@mm996b@saveAsTemplate", onClick: Search.template.saveAsTemplate }, getLabel(18418, '存为模板')),
            ];
        };
        _this.getTemplateSelect = function (advanced) {
            var Search = _this.props.Search;
            var isBackUpData = Search.isBackUpData;
            if (isBackUpData) {
                return null;
            }
            return ([
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["SelectNew"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectNew@qdgh2n", className: "mode-template-select", style: { width: 'calc( 100% - 70px )', borderRadius: 0, textAlign: 'left', maxWidth: '200px' }, placeholder: getLabel(23039, '选择模板'), value: Search.templateid, onChange: Search.changeTemplate },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["SelectNew"].Option, { ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectNew.Option@fp2r2v", value: '' }, ''),
                    advanced.templates.map(function (t, index) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["SelectNew"].Option, { ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectNew.Option@u80idt@" + index, value: t.key }, t.name)); })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { style: { width: 60, marginLeft: 10 }, onClick: Search.managerTemplate }, getLabel(17857, '模板管理'))
            ]);
        };
        _this.getTopQuickButtonsArr = function (buttons) {
            var Search = _this.props.Search;
            var checkBtn = Search.checkBtn, rightMenuClick = Search.rightMenuClick, countData = Search.countData, countDisplayPosition = Search.countDisplayPosition, showMoreCountData = Search.showMoreCountData, displayType = Search.displayType;
            var butArrs = [];
            var arr = [], arrMore = [];
            if (countDisplayPosition === '2' && countData.length > 0) { //countDisplayPosition:统计-显示位置 ['0':顶部显示、'1':顶部简约显示、'2':右上角显示]
                countData.forEach(function (item, index) {
                    arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-list-top-countData" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: item.icon }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "cube-list-top-countData-title" },
                            item.name,
                            ":"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, item.countnum),
                        item.setdesc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaHelpfulTip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaHelpfulTip@hrwoxd@" + index, width: "auto", style: { paddingLeft: '5px' }, title: item.setdesc })));
                    arrMore.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-list-top-countData-more" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: item.icon }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "cube-list-top-countData-title" },
                            item.name,
                            ":"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, item.countnum),
                        item.setdesc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaHelpfulTip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaHelpfulTip@ee8yp8@" + index, width: "auto", style: { paddingLeft: '5px' }, title: item.setdesc })));
                });
                arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "top-countData-more", onClick: _this.handleCountDataClick },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: showMoreCountData ? 'icon-coms icon-coms-up2' : 'icon-coms icon-coms-down2' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { id: "top-countData-list", className: showMoreCountData ? 'showMore' : '' }, arrMore)));
                butArrs.push(arr);
            }
            buttons && buttons.map(function (btn, index) {
                var expandBtn = "expandid_" + btn.key + "span";
                if (displayType == __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].TreeType) { //分组列表
                    expandBtn = "expandid_" + btn.key;
                }
                var searchData = _this.getSearchData();
                var btnDisable = (btn.isfilter == '1' && checkBtn == expandBtn && (searchData.length < 1 || !searchData));
                if (index < 5) {
                    butArrs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__commonComs_buttonNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonNew@813let@" + index, type: 'primary', content: btn.name, id: btn.key, onClick: rightMenuClick, disabled: btnDisable }));
                }
            });
            return butArrs;
        };
        _this.handleCountDataClick = function (e) {
            var Search = _this.props.Search;
            var showMoreCountData = Search.showMoreCountData, handleShowMoreCountData = Search.handleShowMoreCountData;
            e.nativeEvent.stopImmediatePropagation();
            handleShowMoreCountData(showMoreCountData);
        };
        _this.getQuickButtons = function (bool) {
            var Search = _this.props.Search;
            var rightMenus = Search.rightMenus;
            var quickButtons = rightMenus.slice().filter(function (d) { return d.quickButton; });
            if (bool) {
                return Search.type == 'advanced' ? _this.getAdvancedQuickButtons() : _this.getTopQuickButtonsArr(quickButtons);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__util__["default"].handleQuickBtnClick = Search.rightMenuClick;
                __WEBPACK_IMPORTED_MODULE_8__util__["default"].handleRightMenuClick = Search.rightMenuClick;
                return Search.type == 'advanced' ?
                    [
                        { type: 'primary', btnName: getLabel(197, '搜索'), param1: -1 },
                        { btnName: getLabel(2022, '重置'), param1: -2 },
                        { btnName: getLabel(18418, '存为模板'), param1: -3 }
                    ] : quickButtons.map(function (btn, index) {
                    if (index == 0) {
                        return {
                            type: 'primary',
                            btnName: btn.name,
                            param1: btn.key
                        };
                    }
                    return {
                        btnName: btn.name,
                        param1: btn.key
                    };
                });
            }
        };
        _this.handleParentIframe = function () {
            if (self != top) { //在iframe内部
                if (__WEBPACK_IMPORTED_MODULE_25_jquery___default()(__WEBPACK_IMPORTED_MODULE_8__util__["default"].frameElement).attr("adjustheight") == "y") { //自适应高度
                    var height_1 = 0;
                    _this.fixedHeight = setInterval(function () {
                        try {
                            var iframe = __WEBPACK_IMPORTED_MODULE_25_jquery___default()(__WEBPACK_IMPORTED_MODULE_8__util__["default"].frameElement);
                            if (iframe[0]) {
                                var perfectHeight = __WEBPACK_IMPORTED_MODULE_8__util__["default"].perfectHeight;
                                if (__WEBPACK_IMPORTED_MODULE_26_lodash___default.a.isFunction(perfectHeight)) {
                                    var newHeight = perfectHeight();
                                    if (newHeight && !isNaN(newHeight) && height_1 != newHeight) {
                                        height_1 = newHeight;
                                        iframe.height(newHeight);
                                        clearInterval(_this.fixedHeight);
                                    }
                                }
                            }
                        }
                        catch (e) {
                            clearInterval(_this.fixedHeight);
                        }
                    }, 100);
                }
            }
        };
        _this.parserColumnsForShowList = function (record, num, cb, index) {
            var isShowIcon = _this.props.Search.isShowIcon;
            var otherparas = cb.otherpara.split("+");
            var index1 = 0;
            for (index1; index1 < otherparas.length; index1++) {
                var islikebutton = otherparas[index1].replace("#islikebutton:", "");
                if (islikebutton && islikebutton == '1') {
                    var likeinfo = otherparas[index1 + 1].replace("#likeinfo:", "");
                    var type = likeinfo.split(",")[0];
                    var status = likeinfo.split(",")[3];
                    var likecount = likeinfo.split(",")[1];
                    var dislikecount = likeinfo.split(",")[2];
                    if (type == '5') {
                        if (status == '1') {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@s34rbi", type: "ghost", onClick: function () { _this.props.Search.likeOrDislike(record, "0", index, '1'); } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-like" }),
                                    isShowIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: cb.text || '' }, '(' + likecount + ')') : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, ' ' + cb.text + '(' + likecount + ')')));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@hlxdxk", type: "ghost", onClick: function () { _this.props.Search.likeOrDislike(record, "1", index, '1'); } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: cb.text, className: "icon-coms02-like-o" }),
                                    isShowIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: cb.text || '' }, '(' + likecount + ')') : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, ' ' + cb.text + ' (' + likecount + ')')));
                        }
                    }
                    else if (type == '6') {
                        if (status == '2') {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@66e1l5", type: "ghost", onClick: function () { _this.props.Search.likeOrDislike(record, "0", index, '1'); } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-Negative-comment" }),
                                    isShowIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: cb.text || '' }, '(' + dislikecount + ')') : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, ' ' + cb.text + ' (' + dislikecount + ')')));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@78pn64", type: "ghost", onClick: function () { _this.props.Search.likeOrDislike(record, "2", index, '1'); } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: cb.text, className: "icon-coms02-Negative-comment-o" }),
                                    isShowIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: cb.text || '' }, '(' + dislikecount + ')') : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, ' ' + cb.text + ' (' + dislikecount + ')')));
                        }
                    }
                }
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@f7ir7u", title: cb.text || '', type: "ghost", onClick: function () {
                    _this.props.Search.doCustomButton(record, '', cb, '');
                } },
                cb.icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'cube-list-icon-box' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: cb.icon })) : (!isShowIcon ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'cube-list-icon-box' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: Object(__WEBPACK_IMPORTED_MODULE_35__util_contentPath__["a" /* getContentPath */])('/mobilemode/piclibrary/01-E9_default/setup.png') }))),
                !isShowIcon ? cb.text : '');
        };
        _this.parserColumnsForFunc = function (record, num, cb, index, isExitIcon) {
            var otherparas = cb.otherpara.split("+");
            var index1 = 0;
            for (index1; index1 < otherparas.length; index1++) {
                var islikebutton = otherparas[index1].replace("#islikebutton:", "");
                if (islikebutton && islikebutton == '1') {
                    var likeinfo = otherparas[index1 + 1].replace("#likeinfo:", "");
                    var likecount = likeinfo.split(",")[1];
                    var dislikecount = likeinfo.split(",")[2];
                    var type = likeinfo.split(",")[0];
                    var status = likeinfo.split(",")[3];
                    if (type == '5') {
                        if (status == '1') {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@ij77nw" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function () {
                                        _this.props.Search.likeOrDislike(record, "0", index, '1');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-like" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#000' } }, ' ' + cb.text + '(' + likecount + ')'))));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@kqhsr8" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function () {
                                        _this.props.Search.likeOrDislike(record, "1", index, '1');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: cb.text, className: "icon-coms02-like-o" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + likecount + ')'))));
                        }
                    }
                    else if (type == '6') {
                        if (status == '2') {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@polona" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function () {
                                        _this.props.Search.likeOrDislike(record, "0", index, '1');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-Negative-comment" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + dislikecount + ')'))));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@udof24" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function () {
                                        _this.props.Search.likeOrDislike(record, "2", index, '1');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: cb.text, className: "icon-coms02-Negative-comment-o" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + dislikecount + ')'))));
                        }
                    }
                }
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@ggr6gv" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function () {
                        _this.props.Search.doCustomButton(record, '', cb, '');
                    } },
                    isExitIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'cube-list-icon-box' }, cb.icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: cb.icon }) : '') : '',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#000' } }, cb.text)));
        };
        _this.dealmergecolumn = function (columns) {
            var Search = _this.props.Search;
            var mergeFields = Search.mergeFields ? Search.mergeFields : '';
            var columns1 = [];
            var columns2 = []; //已经处理的列
            for (var n = 0; n < columns.length; n++) {
                var dataindex = columns[n].dataIndex;
                if (mergeFields.indexOf(dataindex) < 0) { //如果不是合并列
                    columns1.push(columns[n]);
                }
                else { //是合并列
                    if (columns2.indexOf(dataindex) < 0) {
                        var column = _this.getColumn(columns, dataindex, columns2);
                        columns1.push(column);
                        //columns2.push(dataindex)
                    }
                }
            }
            return columns1;
        };
        _this.parseColumns = function (columns) {
            var Search = _this.props.Search;
            var isSuspend = Search.isSuspend, isShowIcon = Search.isShowIcon, showButtomNum = Search.showButtomNum;
            var columns1 = columns.map(function (col) {
                var flag = true;
                var oldwidth = col.oldWidth || '5%';
                if (oldwidth.indexOf("px") < 0 && col.dataIndex != 'randomFieldId') {
                    flag = false;
                    var widthInt = parseFloat(oldwidth.replace('%', ''));
                    if (widthInt <= 0) {
                        widthInt = 5;
                    }
                    col.oldWidth = widthInt + "%";
                }
                if (col.dataIndex == 'randomFieldId' && flag) {
                    col.oldWidth = "100px";
                }
                if (col.dataIndex == 'modelableid') { //如果是标签
                    var newColumn_1 = col;
                    var classname_1 = col.className == 'column-text-right' ? 'right' : col.className == 'column-text-center' ? 'center' : 'left';
                    newColumn_1.render = function (text, record, index) {
                        var valueSpan = record[newColumn_1.dataIndex + "span"] !== undefined ? record[newColumn_1.dataIndex + "span"] : record[newColumn_1.dataIndex];
                        var weatag = valueSpan && valueSpan.startsWith('[') && JSON.parse(valueSpan).map(function (tag) {
                            if (tag.tabname != '') {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTag"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTag@wksgcx@" + index, title: tag.tabname, style: {
                                        borderRadius: '4px',
                                        marginBottom: 2,
                                        marginRight: 10,
                                        color: tag.color,
                                        backgroundColor: tag.bgcolor,
                                        borderColor: tag.bdcolor
                                    } }, tag.tabname.length > 10 ? tag.tabname.slice(0, 10) + "..." : tag.tabname);
                            }
                            else {
                                return tag + " ";
                            }
                        });
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: classname_1, whiteSpace: 'normal' } }, weatag));
                    };
                    return newColumn_1;
                }
                else if (col.className && col.className.indexOf("checkBox") > 0) { //是checkbox
                    var newColumn_2 = col;
                    var classname_2 = col.className == 'column-text-right checkBox' ? 'right' : col.className == 'column-text-center checkBox' ? 'center' : 'left';
                    newColumn_2.render = function (text, record, index) {
                        if (!record._stat) { //排除合计
                            var valueSpan = record[newColumn_2.dataIndex + "span"] !== undefined ? record[newColumn_2.dataIndex + "span"] : record[newColumn_2.dataIndex];
                            if (valueSpan != '0' && valueSpan != '1' && valueSpan != '') { //被转换 去除条件record[newColumn.dataIndex]!=''&&，当check框为空时也显示转换
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: valueSpan } });
                            }
                            else {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: classname_2, whiteSpace: 'normal' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaCheckbox"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaCheckbox@5n2ms7", viewAttr: '1', id: valueSpan, value: valueSpan }));
                            }
                        }
                    };
                    return newColumn_2;
                }
                else if (col.dataIndex == 'isshowlist') { //如果是自定义按钮
                    var newColumn_3 = col;
                    var classname_3 = col.className == 'column-text-right' ? 'right' : col.className == 'column-text-center' ? 'center' : 'left';
                    newColumn_3.render = function (text, record, index) {
                        var valueSpan = record[newColumn_3.dataIndex + "span"] !== undefined ? record[newColumn_3.dataIndex + "span"] : record[newColumn_3.dataIndex];
                        var num = -1;
                        try {
                            // #1117048 解决操作列显示到统计列前面查询列表直接就报错问题
                            // 当isshowlist列作为“当页统计”和“总计”被设置的列时，valueSpan是字符串而非json对象
                            JSON.parse(valueSpan);
                        }
                        catch (_a) {
                            // 如果非json对象，则认为作为了“当页统计”和“总计”列，直接渲染span标签
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: valueSpan, className: "wea-url", dangerouslySetInnerHTML: { __html: valueSpan } });
                        }
                        var count = valueSpan && JSON.parse(valueSpan).length;
                        var custombutton;
                        var custombuttonArray;
                        if (count > showButtomNum && !isShowIcon) {
                            if (showButtomNum > 0) {
                                var valueSpanarrry = JSON.parse(valueSpan).slice(0, showButtomNum);
                                var valueSpanTemp = JSON.parse(valueSpan).slice(showButtomNum - 1);
                                var isExitIcon_1 = Object(__WEBPACK_IMPORTED_MODULE_29__utils__["h" /* isExitIconHandle */])('opt', valueSpanTemp);
                                custombuttonArray = valueSpanTemp && valueSpanTemp.map(function (cb) {
                                    return _this.parserColumnsForFunc(record, num, cb, index, isExitIcon_1);
                                });
                                custombutton = valueSpanarrry && valueSpanarrry.map(function (cb) {
                                    num++;
                                    if (num < showButtomNum - 1) {
                                        return _this.parserColumnsForShowList(record, num, cb, index);
                                    }
                                    else if (num == showButtomNum - 1) {
                                        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDropdown@sa74qf@" + num, className: 'wea-table-page-more-drop-down', getPopupContainer: function () { return document.getElementById("buttonGroupbtn" + index); }, overlay: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@ij2953" }, custombuttonArray) }, getLabel(17499, "更多")));
                                    }
                                });
                            }
                            else {
                                var valueSpanTemp = JSON.parse(valueSpan).slice(0);
                                var isExitIcon_2 = Object(__WEBPACK_IMPORTED_MODULE_29__utils__["h" /* isExitIconHandle */])('opt', valueSpanTemp);
                                custombuttonArray = valueSpanTemp && valueSpanTemp.map(function (cb) {
                                    return _this.parserColumnsForFunc(record, num, cb, index, isExitIcon_2);
                                });
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function (e) { return e.stopPropagation(); } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "buttonGroupbtn" + index, className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: classname_3, whiteSpace: 'normal' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@ek9k63" },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDropdown@wnq87e", className: 'wea-table-page-more-drop-down', getPopupContainer: function () { return document.getElementById("buttonGroupbtn" + index); }, overlay: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@yazaaw" }, custombuttonArray) }, getLabel(17499, "更多")))));
                            }
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function (e) { return e.stopPropagation(); } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "buttonGroupbtn" + index, className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: classname_3, whiteSpace: 'normal' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@jx1rg5" }, custombutton)));
                        }
                        else {
                            custombutton = valueSpan && JSON.parse(valueSpan).map(function (cb) {
                                num++;
                                return _this.parserColumnsForShowList(record, num, cb, index);
                            });
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: isShowIcon ? 'cube-list-table-cusoperate-onlyicon' : 'cube-list-table-cusoperate-andicon', onClick: function (e) { return e.stopPropagation(); } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: classname_3, whiteSpace: 'normal' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@vb2fe4", className: "cube-custom-btn-group" }, custombutton)));
                        }
                    };
                    return newColumn_3;
                }
                return col;
            });
            columns1 = _this.dealmergecolumn(columns1);
            return columns1;
        };
        _this.tableWidth = function (_) {
            var Search = _this.props.Search;
            return Search.originalTableWidth;
        };
        _this.closeMsgConfirm = function () {
            _this.props.Search.openMsgConfirm(false);
        };
        _this.onContinueEdit = function () {
            _this.props.cubeViewResource.setIsEditList(true);
            _this.props.Search.onBatchEditSave(true);
        };
        _this.onBatchEditBack = function () {
            _this.props.cubeViewResource.setIsEditList(false);
            _this.props.Search.onBatchEditSave(false);
        };
        _this.onClick = function () {
            var Search = _this.props.Search;
            Search.backUpData();
        };
        _this.setAdcancAction = function (bool) {
            var Search = _this.props.Search;
            Search.condition.update({ visible: bool });
            if (bool) {
                Object(__WEBPACK_IMPORTED_MODULE_29__utils__["k" /* renderSearchAdPanel */])(Search);
            }
        };
        _this.onClose = function (v) {
            var Search = _this.props.Search;
            __WEBPACK_IMPORTED_MODULE_8__util__["default"].console && console.log("Search.checkAdvanedData:", Search.checkAdvanedData);
        };
        _this.cancelExport = function () {
            var Search = _this.props.Search;
            Search.cancelExport();
        };
        _this.showProIsclose = function () {
            var Search = _this.props.Search;
            Search.isClose = true;
            Search.showProgerss = false;
        };
        _this.weaSlidClose = function () {
            var Search = _this.props.Search;
            Search.showSlideModal(false, "", "");
        };
        _this.weashowSlideModal = function () {
            var Search = _this.props.Search;
            Search.showSlideModal(false, "", "");
        };
        _this.onComponentDidUpdate = function () {
            var Search = _this.props.Search;
            if (Search.slideModalVisible) {
                _this.componentDidUpdate();
            }
        };
        _this.getlistCompent = function () {
            var _a = _this.props, Search = _a.Search, hideRightmenu = _a.hideRightmenu;
            var hasKeySearch = Search.hasKeySearch, keySearchFields = Search.keySearchFields, quickSearchData = Search.quickSearchData, countData = Search.countData, countDisplayPosition = Search.countDisplayPosition, slideModalVisible = Search.slideModalVisible, needFixedToTop = Search.needFixedToTop, isfrontmultlang = Search.isfrontmultlang, displayType = Search.displayType, mergeFields = Search.mergeFields, mergeInfos = Search.mergeInfos, _b = Search.top.tabs, tabs = _b === void 0 ? [] : _b;
            var newTabs = tabs;
            var className = "cube-list-table";
            var isMergeLine = false;
            if (mergeFields && mergeInfos && mergeInfos.length > 0) {
                isMergeLine = true;
                className = "cube-list-table mergeLine";
            }
            var newRightmenus = _this.getNewRightmenus();
            //分页选项值处理
            var len = 0;
            __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.forEach(Search.editPagination.pageSizeOptions, function (d, index) {
                _this.pageSizeOptions[index] = d;
                len = index;
            });
            _this.pageSizeOptions.splice(len + 1);
            var hasSearch = Search.conditionInfo && Search.conditionInfo.length > 0 && Search.conditionInfo[0].items.length > 0;
            var havetab = newTabs.length > 0 || hasSearch && !_this.hideAdvancedSearchPanel;
            var fromStyle = _this.getFormStyle();
            /***获取当前布局的top和left距离 */
            var topLeft = Object(__WEBPACK_IMPORTED_MODULE_29__utils__["g" /* getTopLeft */])();
            // @ts-ignore
            var scrollheigth = document.documentElement.clientHeight - topLeft.top;
            // @ts-ignore
            var scrollwidth = document.documentElement.clientWidth - topLeft.left;
            var classnameval = slideModalVisible ? "div-Cube-WeaSlideModalblock" : "div-Cube-WeaSlideModalnone";
            /* 关键字搜索框增加title属性 */
            __WEBPACK_IMPORTED_MODULE_25_jquery___default()(".wea-tab-right .wea-input-focus input").attr('title', keySearchFields);
            // this.computeTableHeight(Search);
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: _this.weashowSlideModal, onBlur: _this.onComponentDidUpdate, style: { height: "100%" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__right_menu_wrap__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_RightMenusWrap@bxnk71", rightMenus: newRightmenus, rightMenuClick: Search.rightMenuClick, hideRightmenu: hideRightmenu, needFixedToTop: needFixedToTop },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__top_title__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Top@pa6ex4", top: Search.top, topType: "tabs", loading: Search.loading, showDropIcon: true, dropMenuDatas: newRightmenus, onDropMenuClick: Search.rightMenuClick, refresh: _this.refresh, searchType: Search.isShowCondition ? 'base' : 'advanced', advanced: Search.type == 'advanced', buttons: _this.getQuickButtons, isInnerTab: Search.isInnerTab, iconInfo: Search.iconInfo },
                        undefined != Search.checkAdvanedData && Search.checkAdvanedData != '' ?
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Alert"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Alert@7dahck", message: Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(Search.checkAdvanedData), type: "warning", closable: true, onClose: _this.onClose }) : '',
                        Search.isInit && (Search.type == 'advanced' ?
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__advanced__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Advanced@ufosh2", advanced: Search.advanced, content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__AdvancedSearchs__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_AdvancedSearchs@f2vj1j", form: Search.advanced.form, conditioninfo: Search.advancedInfo, customComponent: _this.getTemplateSelect(Search.advanced), quickSearch: _this.refresh, listStore: Search }), buttons: _this.getSerchButtons(Search.advanced, false) })
                            :
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-list-wrapper", style: fromStyle }, [
                                    (newTabs.length > 0 || hasSearch && !_this.hideAdvancedSearchPanel || Search.isBackUpData) &&
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTab"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTab@kxss2x", ref: "_tabs", datas: newTabs, keyParam: "key" //主键
                                            , countParam: "key" //数量
                                            , counts: Search.top.groupCount, searchType: hasSearch ? (hasKeySearch ? ['base', 'advanced'] : ['advanced']) : [], selectedKey: Search.top.selectedKey, onChange: _this.changeTabs, searchsBaseValue: Search.quickSearchValue, advanceHeight: 'auto', showSearchAd: Search.condition.visible, setShowSearchAd: _this.setAdcancAction, replaceLeft: newTabs.length <= 0 &&
                                                quickSearchData.isquicksearch &&
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__quickSearch__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_QuickSearch@aiwoln", datas: quickSearchData.quicksearchinfo, listStore: Search, onChange: _this.onChange }), buttonsAd: _this.getSerchButtons(Search.condition, true), searchsAd: Search.condition.visible ?
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__AdvancedSearchs__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_AdvancedSearchs@8ykphr", form: Search.condition.form, conditioninfo: Search.conditionInfo, customComponent: _this.getTemplateSelect(Search.condition), quickSearch: _this.refresh, listStore: Search })
                                                : "", leftStyle: _this.leftStyle(), onSearchChange: _this.changeQuickSearchValue, onSearch: _this.quickSearch, searchsBasePlaceHolder: keySearchFields.join(' or '), searchsBasePlaceHolderExtra: keySearchFields.join(' or '), buttons: _this.getWeaTabBtns() }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, (newTabs.length > 0 || !havetab) && quickSearchData.isquicksearch &&
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__quickSearch__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_QuickSearch@fnd8pl", datas: quickSearchData.quicksearchinfo, listStore: Search, onChange: _this.onChange })),
                                    Search.isEdit ?
                                        (Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].Excel ?
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "excelDiv", style: { position: "relative" } },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Excel__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Excel@bvjj5k", store: Search })),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'right', margin: '7px', marginBottom: 0 } },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Pagination"], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Pagination@fgtfl0@" }, Search.editPagination, { onChange: _this.excelPageChange, onShowSizeChange: _this.excelPageShowSizeChange }))))
                                            : Search.editTableStore.isInit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Spin"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Spin@v6omu5", style: !Search.editTableStore.isDataLoaded ? { marginTop: '200px' } : {}, spinning: Search.loading },
                                                Search.editTableStore.isDataLoaded &&
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__mobx_table__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_MobxTable@h6yqbe@", tableStore: Search.editTableStore, isMergeLine: isMergeLine, scroll: Object(__WEBPACK_IMPORTED_MODULE_29__utils__["f" /* getScroll */])(Search), pagination: false, isRowSelection: false, isNoSwitchEditStatus: true, isfrontmultlang: isfrontmultlang }),
                                                Search.editTableStore.isDataLoaded &&
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'right', margin: '7px' } },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Pagination"], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Pagination@gqrffq" }, Search.editPagination, { onChange: _this.excelPageChange, onShowSizeChange: _this.excelPageShowSizeChange })))))
                                        :
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                                countDisplayPosition !== '2' && countData.length > 0 &&
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__ListCount__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ListCount@gdu3ob@listcount", Search: Search }),
                                                (Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].ImgType) ?
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "imgSearchDiv", style: { position: "relative" } },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ImgSearch__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ImgSearch@uk6gj8", store: Search })),
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'right', margin: '7px' } },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Pagination"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Pagination@r9fwvw", current: Search.newTable.current, pageSize: Search.newTable.pageSize, total: Search.newTable.count, showTotal: function (total) { return " " + (getLabel(18609, "共") + total + ' ' + getLabel(18256, "条")) + " "; }, showSizeChanger: true, showQuickJumper: true, pageSizeOptions: _this.pageSizeOptions, onChange: _this.imgPageChange, onShowSizeChange: _this.imgPageShowSizeChange })))
                                                    :
                                                        (Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].TreeType && Search.isTree) ?
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Tree__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tree@ptqcjv", store: Search })
                                                            : Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].Excel ?
                                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "excelDiv", style: { position: "relative" } },
                                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Excel__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Excel@0gajpg", store: Search })),
                                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'right', margin: '7px', marginBottom: 0 } },
                                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Pagination"], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Pagination@nysz0d" }, Search.editPagination, { onChange: _this.excelPageChange, onShowSizeChange: _this.excelPageShowSizeChange }))))
                                                                :
                                                                    (displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].VerticalType) ? //纵向列表的时候纵向展示
                                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__verticalList__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_VerticalList@uxn24n", store: Search })
                                                                        : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeaTable, { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTable@7zwhai", className: className, register_table: Search.register_table, comsWeaTableStore: Search.newTable, getColumns: _this.parseColumns, needScroll: true, heightSpace: 10, tableWidth: _this.tableWidth, rowKey: __WEBPACK_IMPORTED_MODULE_8__util__["getListKey"], hasOrder: true, customOperates: _this.tableCustomOperate, expiredRefreshFun: Search.refresh, needRowClick: true, pageSizeOptions: _this.pageSizeOptions, onRowClick: _this.normalTableRowClick }))
                                ])),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__pages_batch_share__["BatchShareDialog"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_BatchShareDialog@o4sst1", iconInfo: Search.iconInfo, share: Search.share, params: _this.getParams(), success: _this.refresh }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__pages_batch_share_Single__["SingleShareDialog"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SingleShareDialog@vxnldd", iconInfo: Search.iconInfo, share: Search.share, formId: Search.formId, modeId: Search.modeId, nonDefaultShared: Search.nondefaultshared, defaultShared: Search.defaultshared, type: '0' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__pages_template__["a" /* TemplateDialog */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_TemplateDialog@9ni35w", template: Search.template, params: Search }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__modeTab_TabSetDialog__["a" /* TabSetDialog */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_TabSetDialog@0ij9md", Search: Search }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__card_CustomDialog__["default"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_CustomDialog@b8skwl", customDialog: Search.customDialog, iconInfo: Search.iconInfo }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Batchmodifyfeild__["a" /* BatchmodifyfeildDialog */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_BatchmodifyfeildDialog@emiyv8", batchEditStore: Search.batchEditStore, iconInfo: Search.iconInfo })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: classnameval, onClick: _this.weashowSlideModal }),
                    !Search.isInSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "Cube-WeaSlideModal" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaSlideModal"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSlideModal@xjvcqi", visible: slideModalVisible, top: topLeft.top + "px", width: (scrollwidth * parseFloat(Search.sliderPercentage) / 100) + "px", height: scrollheigth + "px", direction: 'right', measure: '', style: { overflowY: "hidden" }, content: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { src: Search.slideModalUrl, name: "iframe_" + new Date().getTime(), style: { border: "0", height: "100%", width: "100%" } })), onClose: _this.weaSlidClose }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_map__["a" /* MapDialog */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_MapDialog@ydh759", cubeMap: Search.cubeMap, onCancel: _this.mapDialogClose, iconInfo: Search.iconInfo }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__batchAdd__["a" /* BatchAddDialog */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_BatchAddDialog@eaz2uo", batchAddStore: Search.batchAddStore }),
                Search && Search.dataBoard ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__dataBoard__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_DataBoard@po21y8", search: Search })
                    : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "none" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { id: "cube-list-exportfile", name: "cubeListExportfile", frameBorder: "no", width: "100%", height: "100%", scrolling: "auto", src: "about:blank" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDialog"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDialog@8x8wcz", style: { width: 600, height: 90 }, onCancel: _this.exportCancel, icon: Search.iconInfo.icon, iconBgcolor: Search.iconInfo.iconBg, iconFontColor: Search.iconInfo.iconColor || "#fff", title: getLabel('508300', '导出进度'), visible: Search.showProgerss, buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@pgue0w@cancelExport", key: "cancel", type: "ghost", onClick: _this.cancelExport }, getLabel(201, "取消")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@gsstg9@showProIsclose", key: "back", type: "ghost", onClick: _this.showProIsclose }, getLabel(309, "关闭"))] },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: "15px 25px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { lineHeight: "30px", textAlign: 'left' } }, Object(__WEBPACK_IMPORTED_MODULE_29__utils__["d" /* getContent */])(Search)),
                        (Search.progress.step == 'expSheet' || Search.progress.step == 'expcard') &&
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Progress"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Progress@hnesqx", percent: Search.progress.percent || 0 }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDialog"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDialog@u4pdx0", style: { width: 600, height: 135 }, 
                    // onCancel={() => {
                    //     Search.isClose = true;
                    //     Search.isDelShow = false
                    // }}
                    // icon={Search.iconInfo.icon}
                    // iconBgcolor={Search.iconInfo.iconBg}
                    // title={"删除进度"}
                    closable: false, visible: Search.isDelShow },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: "15px 25px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { lineHeight: "30px", textAlign: 'left' } }, getLabel(516336, "删除进度")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Progress"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Progress@qp3zas", percent: Search.delLoadingProgress.percent || 0 }))),
                Search.showExpList && _this.showModal(),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDialog"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDialog@ius7ze", title: getLabel(131329, '信息确认'), icon: "icon-coms02-Warning-01", className: 'cube-batch-msg', visible: Search.msgConfirmVisible, style: { width: 462, height: 80 }, buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@qgah3h@onContinueEdit", type: "primary", onClick: _this.onContinueEdit }, getLabel(522116, "保存后继续修改")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@phz9qy@onBatchEditBack", type: "primary", onClick: _this.onBatchEditBack }, getLabel(522117, "保存后返回")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@4y0xux@closeMsgConfirm", type: "ghost", onClick: _this.closeMsgConfirm }, getLabel(31129, '取消'))], onCancel: _this.closeMsgConfirm },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "cube-batch-msg-info" }, getLabel(522118, "是否确定批量保存？")))));
        };
        _this.computeTableHeight = function (Search) {
            Object(__WEBPACK_IMPORTED_MODULE_29__utils__["e" /* getHeight */])(Search);
        };
        //nosearch 是否需要查询(单行文本的变动不需要进行查询)
        _this.onChange = function (fieldid, value, nosearch) {
            var _a;
            var Search = _this.props.Search;
            var quickSearchFormData = Search.quickSearchFormData, quickSearchData = Search.quickSearchData;
            var _b = quickSearchData.quicksearchinfo, quicksearchinfo = _b === void 0 ? [] : _b;
            __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.set(quickSearchFormData, fieldid, value);
            var resetDate = {};
            //默认值与选择值的筛选，当选择值后，默认值就不会上传，以选择值为主
            quicksearchinfo.map(function (item) {
                var handleItem = function (item) {
                    if (!quickSearchFormData[item.fieldid] && quickSearchFormData[item.fieldid] != '') {
                        if (item.value && item.value != "") {
                            resetDate[item.fieldid] = item.value;
                        }
                        else if (item.fieldhtmltype == "1" && item.fieldtype != '1') { //浮点数整数单独解析
                            var options = item.options;
                            options.map(function (key) {
                                var selected = key.selected;
                                if (selected) {
                                    resetDate[item.fieldid] = key.key;
                                }
                            });
                        }
                        else if (item.fieldhtmltype == "3" && item.fieldtype != '1' && item.fieldtype != '2' && item.fieldtype != '19' && item.fieldtype != '290') { //浏览框也单独解析
                            var replaceDatas = item.replaceDatas;
                            var ids_1 = "";
                            replaceDatas && replaceDatas.map(function (rep) {
                                var id = rep.id;
                                ids_1 += id + ",";
                            });
                            ids_1 = ids_1.substring(0, ids_1.length - 1);
                            resetDate[item.fieldid] = ids_1;
                        }
                    }
                    if (item.fieldid == fieldid && item.fieldhtmltype == '5' && item.fieldtype != '2') {
                        Search.changeQuickSearchData(item.domkey[0]);
                    }
                };
                if (item.hasOwnProperty('searchGroup')) {
                    item.searchGroup.forEach(function (field) {
                        handleItem(field);
                    });
                }
                else {
                    handleItem(item);
                }
            });
            //存在页面扩展关联字段，则需要取关联字段的值QC944386
            var linkParams = {};
            var linkFields = Search.copyDataSource && Search.copyDataSource.linkFields || '';
            if (linkFields) {
                linkParams = {
                    linkFields: linkFields
                };
                var templinkFields = linkFields.split(",");
                for (var i = 0; i < templinkFields.length; i++) {
                    linkParams = __assign((_a = {}, _a[templinkFields[i]] = Search.copyDataSource[templinkFields[i]], _a), linkParams);
                }
            }
            if (!nosearch) {
                // 查询快捷搜索必填字段拦截
                var searchInfo = Search.quickSearchData.quicksearchinfo.slice();
                var requiredFiledIds_1 = searchInfo.filter(function (i) { return i['viewAttr'] === 3; }).map(function (i) { return i['fieldid'] || i['domkey'][0]; });
                var prefix_1 = "con_";
                requiredFiledIds_1.forEach(function (element, index) {
                    if (element.indexOf(prefix_1) != -1) {
                        requiredFiledIds_1[index] = element.split("_")[1];
                    }
                });
                //去重
                requiredFiledIds_1 = Array.from(new Set(requiredFiledIds_1));
                var searchData_1 = __assign({}, Search.getConditionValues(), Search.quickSearchConditionData);
                var emptyVals_1 = ["", null, undefined, ["0", null, null]];
                if (__WEBPACK_IMPORTED_MODULE_26_lodash___default.a.isEmpty(searchData_1) && requiredFiledIds_1.length > 0) {
                    Search.tableDatas.clear();
                    Search.checkAdvanedData = getLabel(512283, "查询条件/快捷搜索条件有必填字段未填写，请填写后再试！");
                    return;
                }
                var needReturn_1 = false;
                requiredFiledIds_1.forEach(function (value, index) {
                    var requiredConditionValue = searchData_1[prefix_1 + value];
                    if (requiredConditionValue === undefined || __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.findIndex(emptyVals_1, function (e) { return __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.isEqual(e, value); }) != -1) {
                        Search.tableDatas.clear();
                        Search.checkAdvanedData = getLabel(512283, "查询条件/快捷搜索条件有必填字段未填写，请填写后再试！");
                        needReturn_1 = true;
                        return;
                    }
                });
                if (needReturn_1)
                    return;
                var parm = __assign({ isQuickSearch: "1", customid: Search.customId, groupValue: Search.top.selectedKey }, Search.quickSearchFormData, linkParams, resetDate, { isOnlyQuick: '1' });
                Search.searchTree.current = 1;
                if (Search.isEdit) {
                    if (Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].Excel) {
                        Search.doBatchEdit_datakey(function (dataKey) {
                            Search.excelStore.getDatas(dataKey, 1);
                        }, parm, true);
                    }
                    else {
                        Search.doBatchEdit_datakey('', parm, true);
                    }
                }
                else {
                    Search.dataKey(parm);
                }
            }
        };
        _this.selectOnChange = function (fieldid, value) {
            var Search = _this.props.Search;
            var formParams = Search.condition.form.getFormParams(); //QC699153,选择框快捷搜索时将值传到高级查询条件中
            __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.set(formParams, "con_" + fieldid, value);
            Search.condition.form.updateFields(formParams, false);
        };
        _this.quickSearchClick = function () {
            var Search = _this.props.Search;
            var parm = __assign({ isQuickSearch: "1", customid: Search.customId, groupValue: Search.top.selectedKey }, Search.quickSearchFormData);
            if (Search.isEdit) {
                if (Search.displayType === __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].Excel) {
                    Search.doBatchEdit_datakey(function (dataKey) {
                        Search.excelStore.getDatas(dataKey, 1);
                    });
                }
                else {
                    Search.doBatchEdit_datakey();
                }
            }
            else {
                Search.dataKey(parm);
            }
        };
        _this.getExpContent = function () {
            var Search = _this.props.Search;
            var expCardParm = Search.expCardParm;
            var _a = expCardParm.datas, datas = _a === void 0 ? [] : _a, expcardname = expCardParm.expcardname;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { minHeight: 100, maxHeight: 400, overflow: "scroll", textAlign: 'center', } },
                datas && datas.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadioGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_RadioGroup@jkkvq6", onChange: function (e) {
                        localStorage.setItem("cube_export_type", e.target.value);
                    }, defaultValue: datas[0]['key'] || "" }, _this.getRadioGroup(datas)) : '',
                expcardname && expcardname.key == "1" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@zhxaa7", style: datas.length > 1 ? { top: '0px' } : { top: '30px' }, label: getLabel(17517, '文件名称'), labelCol: { span: 6 }, wrapperCol: { span: 16 }, width: "20%" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaError"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaError@32ritg", tipPosition: 'top', error: getLabel(17517, '文件名称') + getLabel(21423, "未填写"), style: { width: "100%" }, ref: "filenameref" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@pevmz6", value: expcardname.showname, width: "60%", onChange: function (e) {
                                    localStorage.setItem("cube_export_name", e);
                                } })))) : ""));
        };
        _this.getRadioGroup = function (datas) {
            if (datas === void 0) { datas = []; }
            var radioArr = [];
            var radioStyle = {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
                marginLeft: "10px",
            };
            for (var i = 0; i < datas.length; i++) {
                var item = datas[i];
                radioArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Radio"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Radio@nyebee@" + i, style: radioStyle, key: item.key, value: item.key }, item.showname));
            }
            return radioArr;
        };
        _this.showModal = function () {
            var Search = _this.props.Search;
            if (Search.showExpList) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Modal"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Modal@7myich", title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'wea-browser-single-icon-circle', style: { background: "#96358a" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-ModelingEngine' })),
                        getLabel(17416, '导出')), visible: Search.showExpList, width: 400, wrapClassName: "expOpenDialog", okText: getLabel(33703, '确认'), cancelText: getLabel(31129, '取消'), onOk: _this.showExpListOnoK, onCancel: _this.showExpListOnCancel }, _this.getExpContent());
            }
        };
        _this.showExpListOnCancel = function () {
            var Search = _this.props.Search;
            Search.showExpList = false;
        };
        _this.showExpListOnoK = function () {
            var Search = _this.props.Search;
            var expCardParm = Search.expCardParm;
            var billsid = expCardParm.billsid, modeid = expCardParm.modeid, type = expCardParm.type, expcardname = expCardParm.expcardname, comefrom = expCardParm.comefrom, dataKey = expCardParm.dataKey, modeCustomid = expCardParm.modeCustomid, callBack = expCardParm.callBack;
            var _a = expcardname.isExpOne, isExpOne = _a === void 0 ? '' : _a, key = expcardname.key;
            var that = _this;
            if (key == '1' && localStorage.getItem("cube_export_name") == '') {
                that.refs.filenameref["showError"]();
                return;
            }
            Search.showExpList = false;
            if (type === "list") {
                if (localStorage.getItem("cube_export_type") == "list" || isExpOne == "1") { //如果选择的是列表EXCEL列表文件，走老的导出   ,当后台设置了一种导出类型的时候直接导出
                    var excelName = localStorage.getItem("cube_export_name");
                    typeof callBack == "function" && callBack(billsid, excelName);
                    return;
                }
                var parm = {
                    action: "expbatchcard",
                    fileType: localStorage.getItem("cube_export_type"),
                    billids: billsid,
                    modeId: modeid,
                    excelName: localStorage.getItem("cube_export_name"),
                    comefrom: comefrom,
                    modeCustomid: modeCustomid,
                    dataKey: dataKey
                };
                Search.doExcelExpost('', '', parm);
            }
            setTimeout(function () {
                localStorage.setItem("cube_export_type", "");
                localStorage.setItem("cube_export_name", "");
            }, 500);
        };
        _this.tableCustomOperate = function (record, index, operates) {
            var Search = _this.props.Search;
            return Object(__WEBPACK_IMPORTED_MODULE_29__utils__["c" /* customOperates */])(record, index, operates, Search);
        };
        _this.mapDialogClose = function () {
            var Search = _this.props.Search;
            Search.showCubeMap(false);
        };
        _this.getParams = function () {
            var Search = _this.props.Search;
            return __assign({}, Search.params, { customid: Search.customId, modeid: Search.modeId });
        };
        _this.getSearchData = function () {
            var Search = _this.props.Search;
            var displayType = Search.displayType;
            var treeData = Search.isTreeType == '1' ? Search.newTable.selectedRowKeysAllPages : Search.selectedRowKeys; //组合查询
            var data = displayType == __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].ImgType ? Search.selectRowkeys
                : displayType == __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].TreeType ? treeData
                    : displayType == __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].VerticalType ? Search.selectRowkeys
                        : Search.newTable.selectedRowKeysAllPages;
            return data;
        };
        _this.getNewRightmenus = function () {
            var Search = _this.props.Search;
            var rightMenus = Search.rightMenus, displayType = Search.displayType;
            var newRightmenus = [];
            if (Search.type == 'advanced') {
                newRightmenus = [{
                        key: '-1',
                        content: getLabel(197, '搜索'),
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-search' })
                    }, {
                        key: '-2',
                        content: getLabel(2022, '重置'),
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: ' icon-coms-Revoke' })
                    }, {
                        key: '-3',
                        content: getLabel(18418, '存为模板'),
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-task-list' })
                    }];
            }
            else {
                newRightmenus = rightMenus.map(function (m) {
                    var expandBtn = "expandid_" + m.key + "span";
                    if (displayType == __WEBPACK_IMPORTED_MODULE_14__stores_list__["SearchDisplayType"].TreeType) {
                        expandBtn = "expandid_" + m.key;
                    }
                    var searchData = _this.getSearchData();
                    var btnDisable = (Search.checkBtn == expandBtn && m.isfilter == '1' && (searchData.length < 1 || !searchData));
                    return {
                        key: m.key,
                        content: m.name,
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: m.icon }),
                        quickButton: m.quickButton,
                        disabled: btnDisable
                    };
                });
            }
            return newRightmenus;
        };
        _this.getFormStyle = function () {
            var Search = _this.props.Search;
            return Search.waterImg ? {
                height: '100%', backgroundAttachment: 'scroll', backgroundRepeat: 'repeat', width: "100%",
                backgroundImage: "url('" + Search.waterImg + "')"
            } : {};
        };
        _this.leftStyle = function () {
            //#935375
            var Search = _this.props.Search;
            var hasKeySearch = Search.hasKeySearch, top = Search.top;
            var tabs = top.tabs;
            var leftMargin = '10%';
            if (hasKeySearch) {
                leftMargin = '289px';
            }
            if (tabs != undefined && tabs.length > 0) {
                leftMargin = '289px';
            }
            return {
                width: "100%",
                paddingRight: leftMargin,
                boxSizing: "border-box"
            };
        };
        _this.getWeaTabBtns = function () {
            var Search = _this.props.Search;
            var btnarr = [];
            if (Search.isBackUpData && Search.isCoverType) {
                btnarr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@gtlum7@reset", type: "primary", onClick: _this.onClick }, getLabel('589', '还原')));
            }
            return btnarr;
        };
        /***edittable分页事件 */
        /***exceltable分页事件 */
        _this.excelPageChange = function (current, pageSize) {
            var Search = _this.props.Search;
            Search.editPagination.onChange(current, pageSize);
        };
        _this.excelPageShowSizeChange = function (current, pageSize) {
            var Search = _this.props.Search;
            Search.editPagination.onShowSizeChange(current, pageSize);
        };
        /***imgtable分页事件 */
        _this.imgPageChange = function (current, pageSize) {
            var Search = _this.props.Search;
            Search.imgPageChaneg(current, pageSize);
        };
        _this.imgPageShowSizeChange = function (current, pageSize) {
            var Search = _this.props.Search;
            Search.imgPageChaneg(current, pageSize);
        };
        /***mobxtable行点击事件 */
        _this.normalTableRowClick = function (record, index) {
            var Search = _this.props.Search;
            if (Object.keys(Search.rowClick).length == 0) {
                return;
            }
            var e = event || __WEBPACK_IMPORTED_MODULE_8__util__["default"].event;
            if (e && e.srcElement && e.srcElement.nodeName != 'A') {
                Search.rowClickFun(record, e);
                _this.showOrCloseExpand(true);
            }
        };
        _this.showOrCloseExpand = function (rowClicked) {
            if (rowClicked === void 0) { rowClicked = false; }
            var Search = _this.props.Search;
            if (Search.rightLayoutWidth.startsWith('0')) {
                var width = Search.rowClick['4'].width;
                if (width) {
                    if (width == '100%') {
                        __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.cube-rightleft-layout-right').css('top', -__WEBPACK_IMPORTED_MODULE_8__util__["default"].innerHeight + 'px');
                    }
                    Search.rightLayoutWidth = width;
                }
                else {
                    Search.rightLayoutWidth = '35%';
                }
            }
            else if (!rowClicked) {
                __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.cube-rightleft-layout-right').css('top', '0px');
                Search.rightLayoutWidth = '0px';
            }
        };
        _this.exportCancel = function () {
            var Search = _this.props.Search;
            Search.isClose = true;
            Search.showProgerss = false;
        };
        _this.getSearch = function () {
            var Search = _this.props.Search || {};
            if (Search.rowClick['4'].hreftype == '3') { //如果右侧关联的是查询
                if (Search.search) {
                    return Search.search;
                }
                else {
                    Search.update({ search: new __WEBPACK_IMPORTED_MODULE_14__stores_list__["listStore"]() });
                    Search.search.update({ isInSearch: true, parentSearch: Search });
                    return Search.search;
                }
            }
            else {
                return new __WEBPACK_IMPORTED_MODULE_14__stores_list__["listStore"]();
            }
        };
        return _this;
    }
    List.prototype.componentDidMount = function () {
        var Search = this.props.Search;
        var params = Search.params;
        /***涉及的一些计算的单独提出来 */
        Object(__WEBPACK_IMPORTED_MODULE_29__utils__["a" /* componentComputed */])(Search, this.computeTableHeight);
        if (params && params.hidetop) {
            this.judgeTopHide();
        }
        this.setStore();
        __WEBPACK_IMPORTED_MODULE_8__util__["default"].showSearchSlideModal = Search.showSlideModal;
    };
    List.prototype.componentWillReceiveProps = function (nextProps) {
        var Search = this.props.Search;
        if (Search.params) {
            this.judgeTopHide();
        }
        this.setStore();
    };
    List.prototype.componentWillUnmount = function () {
        var Search = this.props.Search;
        Search.clear();
    };
    List.prototype.componentDidUpdate = function () {
        var Search = this.props.Search;
        __WEBPACK_IMPORTED_MODULE_25_jquery___default()(document).bind('click', function (e) {
            var e = e || __WEBPACK_IMPORTED_MODULE_8__util__["default"].event;
            var elem = e.target || e.srcElement;
            while (elem) {
                if (elem.className && (elem.className == 'wea-left-right-layout-left'
                    || elem.className == 'e8theme-layout-header'
                    || elem.className == 'e8header-container'
                    || elem.className == 'e8header-right'
                    || elem.className == 'e8theme-layout-aside'
                    || elem.className == 'wea-left-right-layout-left'
                    || elem.className == 'cube-tree-list'
                    || elem.className == 'e9theme-layout-header'
                    || elem.className == 'e9header-container'
                    || elem.className == 'e9header-right'
                    || elem.className == 'e9theme-layout-aside'
                    || elem.className == 'wea-menu'
                    || elem.className == 'coms-mode-docker coms-mode-viewCustomPage')) {
                    Search.showSlideModal(false, "", "");
                }
                elem = elem.parentNode;
            }
        });
        if (Search.showGlobalSpin.isShow == 'hide') {
            Search.showGlobalSpin.isShow = 'none';
        }
        Object(__WEBPACK_IMPORTED_MODULE_8__util__["addEnterFun"])(this.refresh);
        this.computeTableHeight(Search);
        Object(__WEBPACK_IMPORTED_MODULE_29__utils__["b" /* computeSearchAd */])(Search);
        // jQuery('.backupBtn').parent('span').css('float','right').css('margin-right','15px');
        this.handleParentIframe(); //主要针对流程iframe嵌套查询
        var countDisplayPosition = Search.countDisplayPosition, countData = Search.countData;
        if (countDisplayPosition === '2' && countData.length > 0) { //countDisplayPosition:统计-显示位置 ['0':顶部显示、'1':顶部简约显示、'2':右上角显示]
            this.showCountDataOnTopRight();
        }
        // 资源面板页面当右键菜单高度超过查询列表高度时，右键菜单超出部分设置成滑动显示
        var $listContainer = __WEBPACK_IMPORTED_MODULE_25_jquery___default()('.coms-mode-viewResource .list-container');
        if ($listContainer.length > 0) {
            var listHeight = $listContainer.eq(0).height();
            $listContainer.find('.ant-spin-container>div').eq(0).css('height', listHeight);
            Search.isNeedFixedToTop(listHeight);
        }
    };
    List.prototype.getColumn = function (columns, dataindex, columns2) {
        var Search = this.props.Search;
        var mergeInfos = Search.mergeInfos;
        var maxTier = 0;
        for (var index = 0; index < mergeInfos.length; index++) {
            var tier = mergeInfos[index].maxTier || '0';
            if (parseInt(tier) > maxTier) {
                maxTier = parseInt(tier);
            }
        }
        for (var i = 0; i < mergeInfos.length; i++) {
            if (mergeInfos[i].fields.indexOf(dataindex) > -1) {
                for (var m = 0; m < mergeInfos[i].fields.length; m++) {
                    columns2.push(mergeInfos[i].fields[m]);
                }
                var mergecolumn = {};
                mergecolumn.title = mergeInfos[i].mergename;
                mergecolumn.className = "column-text-center";
                mergecolumn.display = "true";
                mergecolumn.dataIndex = "mergeline_" + i;
                mergecolumn.oldWidth = this.getoldWidth(mergeInfos[i], columns) + '%';
                mergecolumn.children = this.getchildren(mergeInfos[i], columns, maxTier);
                return mergecolumn;
            }
        }
    };
    List.prototype.getSumWidth = function (columns) {
        var sumWidth = 0;
        for (var n = 0; n < columns.length; n++) {
            if (columns[n].display && columns[n].display != "none") {
                var oldwidth = parseFloat((columns[n].oldWidth || '5').replace("%", ""));
                if (oldwidth == 0) {
                    oldwidth = 5;
                }
                sumWidth += oldwidth;
            }
        }
        return sumWidth;
    };
    List.prototype.getchildrenWidth = function (columns, oldwidth) {
        var sumWidth = this.getSumWidth(columns);
        var width = '0';
        var oldwidth1 = parseFloat((oldwidth || '5').replace("%", ""));
        if (oldwidth1 == 0) {
            oldwidth1 = 5;
        }
        width = Number(parseFloat((oldwidth1 + (100 - sumWidth) * parseFloat(oldwidth1 / sumWidth + "")) + "")).toFixed(2) + "%";
        return width;
    };
    List.prototype.getoldWidth = function (mergeInfo, columns) {
        var width = 0;
        var children = mergeInfo.children;
        if (children) {
            for (var j = 0; j < children.length; j++) {
                if (children[j].fieldname) {
                    var fieldname = children[j].fieldname;
                    for (var i = 0; i < columns.length; i++) {
                        if (fieldname == columns[i].dataIndex) {
                            var childrenOldWidth = parseFloat(columns[i].oldWidth || '0');
                            width = width + childrenOldWidth;
                        }
                    }
                }
                else {
                    width = width + this.getoldWidth(children[j], columns);
                }
            }
        }
        return width;
    };
    List.prototype.getchildren = function (mergeInfo, columns, maxTier) {
        var children = mergeInfo.children;
        var childrens = [];
        if (children) {
            for (var j = 0; j < children.length; j++) {
                var childreninfo = {};
                if (children[j].fieldname) {
                    var fieldname = children[j].fieldname;
                    for (var i = 0; i < columns.length; i++) {
                        if (fieldname == columns[i].dataIndex) {
                            var fieldTier = children[j].fieldTier || '0';
                            if (parseInt(fieldTier) < maxTier) {
                                var rowSpan = maxTier - parseInt(fieldTier) + 1;
                                columns[i].rowSpan = rowSpan + '';
                            }
                            columns[i].title = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: columns[i].title, className: "ant-table-column-sorterN text-elli" }, columns[i].title));
                            columns[i].width = this.getchildrenWidth(columns, columns[i].oldWidth);
                            childreninfo = columns[i];
                            break;
                        }
                    }
                }
                else {
                    childreninfo.title = children[j].mergename;
                    childreninfo.className = "column-text-center";
                    childreninfo.display = "true";
                    var oldWidth = this.getoldWidth(children[j], columns) + '%';
                    childreninfo.width = this.getchildrenWidth(columns, oldWidth);
                    childreninfo.children = this.getchildren(children[j], columns, maxTier);
                }
                childrens.push(childreninfo);
            }
        }
        return childrens;
    };
    List.prototype.render = function () {
        var Search = this.props.Search;
        var verified = Search.verified, hasRight = Search.hasRight, isCharts = Search.isCharts, windowTitle = Search.windowTitle, checkLoading = Search.checkLoading, backupDataLoading = Search.backupDataLoading, showGlobalSpin = Search.showGlobalSpin;
        if (windowTitle != '') {
            document.title = windowTitle;
        }
        if (showGlobalSpin.isShow !== 'none') {
            Object(__WEBPACK_IMPORTED_MODULE_8__util__["doGlobalSpin"])(showGlobalSpin);
        }
        this.hideAdvacedIfNoCondition();
        if (verified && !hasRight) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaAlertPage"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaAlertPage@y5m4ot" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: '#000' } }, getLabel(2012, '对不起，您暂时没有权限！'))));
        }
        var returnDiv = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
        if (verified && hasRight) {
            //行点击事件
            if (!__WEBPACK_IMPORTED_MODULE_26_lodash___default.a.isEmpty(Search.rowClick) && Search.rowClick['4']) {
                var isCube = false;
                if (Search.rightLayoutHref.indexOf("/spa/cube/index.html") >= 0 || Search.rightLayoutHref.indexOf("/spa/cube/index.jsp") >= 0) {
                    if (Search.rightLayoutHref.split('?')[0].endsWith('board') || Search.rightLayoutHref.split('?')[0].endsWith('gantt')) {
                        //看板和甘特图先用iframe
                    }
                    else {
                        isCube = true;
                    }
                }
                var queryRightDiv = void 0;
                var hreftype = Search.rowClick['4'].hreftype;
                if (hreftype == 1 && !Search.modeDataMatched) {
                    var errorMsg = "未找到满足关联字段设置的数据！";
                    queryRightDiv = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaAlertPage"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaAlertPage@y5m4ot" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: '#000' } }, errorMsg),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: "" + (this && this.props && this.props.ecId || ''), style: { borderBottomRightRadius: '0', borderTopRightRadius: '0', marginTop: '10px' }, type: "primary", onClick: function () {
                                __WEBPACK_IMPORTED_MODULE_8__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_35__util_contentPath__["a" /* getContentPath */])(Search.rightLayoutHref));
                            } }, getLabel('365', '新建')));
                }
                else {
                    queryRightDiv = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28____["UrlDocker"], { ecId: (this && this.props && this.props.ecId || '') + "_UrlDocker@n675i7", url: Search.rightLayoutHref, Card: this.props.Card, Search: this.getSearch(), Tree: this.props.Tree, Reply: this.props.reply, ViewCustomPage: this.props.customPageStore });
                }
                returnDiv = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@r4pb9c", tip: getLabel(513100, "正在筛选符合条件数据中..."), spinning: checkLoading, size: 'large' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__card_RightLeftLayout__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_RightLeftLayout@t31lox", visible: false, leftCom: this.getlistCompent(), iconClass: "icon-coms-Right", rightCom: !Search.rightLayoutWidth.startsWith('0') ? (isCube ? queryRightDiv : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { style: {
                                height: __WEBPACK_IMPORTED_MODULE_8__util__["default"].innerHeight,
                                width: '100%',
                                borderLeft: '1px solid #dad8d8',
                                borderTop: '0px solid #dad8d8',
                                borderBottom: '0px solid #dad8d8'
                            }, src: Search.rightLayoutHref })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), canDrag: true, iconParentStyle: { top: '200px', left: '0px', padding: '0px', borderRadius: '0px 4px 4px 0px', background: "url(" + Object(__WEBPACK_IMPORTED_MODULE_35__util_contentPath__["a" /* getContentPath */])('/spa/portal/images/synergy/right.png') + ") center center no-repeat", width: '16px', height: '60px' }, rightLayoutWidth: Search.rightLayoutWidth, showOrCloseExpand: this.showOrCloseExpand }));
            }
            else {
                returnDiv = isCharts ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@itqzvg", tip: getLabel(513100, "正在筛选符合条件数据中..."), spinning: checkLoading, size: 'large' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__card_RightLeftLayout__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_RightLeftLayout@318vj2", visible: false, bottomHeight: __WEBPACK_IMPORTED_MODULE_8__util__["default"].outerHeight, leftCom: this.getlistCompent(), iconClass: "icon-coms-Advice", rightCom: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { id: "iframeChart", style: {
                                    height: __WEBPACK_IMPORTED_MODULE_8__util__["default"].outerHeight - 100,
                                    width: __WEBPACK_IMPORTED_MODULE_8__util__["default"].outerWidth * 0.35 - 10,
                                    borderLeft: '1px solid #dad8d8',
                                    borderTop: '0px solid #dad8d8',
                                    borderBottom: '0px solid #dad8d8'
                                }, src: Object(__WEBPACK_IMPORTED_MODULE_35__util_contentPath__["a" /* getContentPath */])('/formmode/search/ChartsView.jsp?customid=' + Search.customId) }) }))
                    : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@j82znn", tip: backupDataLoading ? "" : getLabel(513100, "正在筛选符合条件数据中..."), spinning: checkLoading || backupDataLoading, size: 'large' }, this.getlistCompent());
            }
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cube_search_" + Search.customId }, returnDiv);
    };
    List = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('Search', 'Tree', 'Card', 'reply', "customPageStore", "cubeViewResource"),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], List);
    return List;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"].tryCatch(__WEBPACK_IMPORTED_MODULE_0_react___default.a, function (props) { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaErrorPage"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaErrorPage@t0yj5p", msg: props.error ? props.error : '对不起，该页面异常，请联系管理员！' }); }, { error: '' })(List));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(830),
    listCacheDelete = __webpack_require__(831),
    listCacheGet = __webpack_require__(832),
    listCacheHas = __webpack_require__(833),
    listCacheSet = __webpack_require__(834);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(150);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(220);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(855);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["a"] = (omit);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var AdvancedSearchs = /** @class */ (function (_super) {
    __extends(AdvancedSearchs, _super);
    function AdvancedSearchs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formParams = {};
        _this.changeQuickSearchData1 = function (form, conditioninfo, domkey) {
            var clearField = function (key) {
                conditioninfo.map(function (c) {
                    c.items.map(function (item) {
                        if (item.parentDomkey && item.parentDomkey[0] == key) {
                            form.$(item.domkey[0]).value = '';
                            clearField(item.domkey[0]);
                        }
                    });
                });
            };
            clearField(domkey);
        };
        _this.getFields = function (field, conditioninfo, form) {
            if (field.parentDomkey && field.parentDomkey.length > 0) {
                var items_1 = {};
                conditioninfo.map(function (c) {
                    c.items.map(function (f) {
                        if (f.domkey == field.parentDomkey[0]) {
                            var value1 = form.$(f.domkey).values() ? form.$(f.domkey).values() : __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].getSelectDefaultValue(f.options);
                            var childitem_1 = [];
                            value1.split(',').map(function (val) {
                                childitem_1 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.union(childitem_1, f.options.filter(function (o) { return o.key == val; }));
                            });
                            var childitemid_1 = [];
                            childitem_1.map(function (item) {
                                childitemid_1 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.union(childitemid_1, item.childitemid);
                            });
                            var childArry = [];
                            var _loop_1 = function (i) {
                                var arr = field.options.filter(function (option) { return option.key == childitemid_1[i] || option.key == ""; });
                                childArry = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.union(childArry, arr);
                            };
                            for (var i = 0; i < childitemid_1.length; i++) {
                                _loop_1(i);
                            }
                            // field.options = childArry;
                            field = __assign({}, field, { options: childArry });
                            items_1 = field;
                        }
                        else {
                            items_1 = field;
                        }
                    });
                });
                return items_1;
            }
            else {
                return field;
            }
        };
        _this.getParams = function (field, key) {
            if (key in field) {
                return field[key];
            }
            else {
                if (field.otherParams) {
                    return field.otherParams[key];
                }
            }
        };
        /** 重新计算蒙层的高度 */
        _this.recalculateMask = function () {
            var domRootStr = '';
            if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(".coms-mode-top-title-advanced").length > 0) {
                domRootStr = "coms-mode-top-title-advanced";
            }
            else if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(".cube_board").length > 0) {
                domRootStr = "cube_board";
            }
            if (domRootStr) {
                var dom = __WEBPACK_IMPORTED_MODULE_5_jquery___default()("." + domRootStr + " .wea-search-container")[0];
                if (dom) {
                    var maskDarkHeight = window.innerHeight - dom.offsetTop - 110;
                    __WEBPACK_IMPORTED_MODULE_5_jquery___default()("." + domRootStr + " .mask-dark").height(maskDarkHeight);
                }
            }
        };
        _this.func = function () {
            var quickSearch = _this.props.quickSearch;
            quickSearch && setTimeout(quickSearch, 50);
        };
        _this.onVisibleChange = function (isVisible) {
            var listStore = _this.props.listStore;
            if (listStore && listStore.isShowCondition && !isVisible) { //#879462 启用查询条件展开，点击收缩，将整个高级搜索收起来
                listStore.condition.visible = isVisible;
            }
            _this.recalculateMask();
        };
        return _this;
    }
    AdvancedSearchs.prototype.render = function () {
        var _this = this;
        var _a = this.props, form = _a.form, conditioninfo = _a.conditioninfo, _b = _a.customComponent, customComponent = _b === void 0 ? '' : _b;
        var isFormInit = form.isFormInit;
        var group = [];
        if (isFormInit) {
            var formParamsTemp = form.getFormParams();
            for (var param in formParamsTemp) {
                this.formParams[param] = formParamsTemp[param];
            }
            // isFormInit 为true，form已经初始化完成
            isFormInit && conditioninfo.map(function (c, i) {
                var items = [];
                var Timedata = [
                    { showname: getLabel(332, '全部'), key: '0', selected: true },
                    { showname: getLabel(517615, '昨天'), key: '9', selected: false },
                    { showname: getLabel(15537, '今天'), key: '1', selected: false },
                    { showname: getLabel(517616, '明天'), key: '10', selected: false },
                    { showname: getLabel(517617, '上周'), key: '11', selected: false },
                    { showname: getLabel(15539, '本周'), key: '2', selected: false },
                    { showname: getLabel(517618, '下周'), key: '12', selected: false },
                    { showname: getLabel(15541, '本月'), key: '3', selected: false },
                    { showname: getLabel(21904, '本季'), key: '4', selected: false },
                    { showname: getLabel(15384, '本年'), key: '5', selected: false },
                    { showname: getLabel(27347, '上个月'), key: '7', selected: false },
                    { showname: getLabel(81716, '上一年'), key: '8', selected: false },
                    { showname: getLabel(32530, '指定日期范围'), key: '6' } // 时间范围的值必须为6
                ];
                c.items.map(function (fields) {
                    // fields['style']={width:'95%'};
                    var func2 = function (fieldObj, datas) {
                        if (fields.conditionType === 'BROWSER' && fields.browserConditionParam.type == '141') {
                            // 更新表单
                            var ids = Object(__WEBPACK_IMPORTED_MODULE_6__util__["spellResourceCondition"])(datas.valueObj);
                            fieldObj[fields.domkey[0]].value = ids;
                            form.updateFields(fieldObj);
                        }
                        else if (fields.conditionType === 'SELECT') {
                            _this.changeQuickSearchData1(form, conditioninfo, fields.domkey[0]);
                        }
                    };
                    if (fields.conditionType === 'BROWSER') {
                        var type = fields.browserConditionParam.type;
                        if (type && (type == "161" || type == "162" || type == "256" || type == "257")) {
                            fields = __assign({}, fields, { browserConditionParam: __assign({}, fields.browserConditionParam, { completeParams: __assign({}, fields.browserConditionParam.completeParams, _this.formParams, { consearch: "consearch" }), conditionDataParams: __assign({}, fields.browserConditionParam.conditionDataParams, _this.formParams, { consearch: "consearch" }), dataParams: __assign({}, fields.browserConditionParam.dataParams, _this.formParams, { consearch: "consearch" }) }) });
                        }
                        if (type && (type == '4' || type == '57' || type == '164' || type == '169' || type == '194' || type == '167' || type == '170' || type == '168')) { //部门，多部门，分部，多分部，单点分权，分权单部门，分权多分部，分权多部门
                            fields.browserConditionParam.dataParams['fromModule'] = "model";
                            fields.browserConditionParam.destDataParams['fromModule'] = "model";
                            fields.browserConditionParam.completeParams['fromModule'] = "model";
                        }
                    }
                    //多分部处理
                    if (fields.conditionType === 'SELECT_LINKAGE' && fields.selectLinkageDatas) {
                        for (var i in fields.selectLinkageDatas) {
                            fields.selectLinkageDatas[i].browserConditionParam.dataParams['fromModule'] = "model";
                        }
                    }
                    if (fields.otherParams && fields.otherParams.tips) {
                        fields.helpfulTip = fields.otherParams.tips;
                        fields.helpfulTipProps.width = fields.tipsWidth || 320;
                    }
                    if (fields.conditionType == 'DATE') {
                        items.push({
                            com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@zngh1l@" + fields.domkey[0], label: "" + fields.label, labelCol: { span: fields.labelcol }, wrapperCol: { span: fields.fieldcol } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_comsMobx__["WeaSwitch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSwitch@m90yu8@" + fields.domkey[0], fieldConfig: __assign({}, _this.getFields(fields, conditioninfo, form), { 
                                        // fields.domkey[0]=='con_1'，创建日期过滤“明天”“下周”
                                        options: fields.domkey[0] == 'con_1' ? Timedata.filter(function (item) { return ['10', '12'].indexOf(item.key) == -1; }).slice() : Timedata.slice() }), form: form, formParams: _this.formParams, onChange: _this.getParams(fields, "quickSearch") ? _this.func : func2 }))),
                            colSpan: 1
                        });
                    }
                    else {
                        items.push({
                            com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@pdcj8h@" + fields.domkey[0], label: "" + fields.label, labelCol: { span: fields.labelcol }, wrapperCol: { span: fields.fieldcol } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_comsMobx__["WeaSwitch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSwitch@e31200@" + fields.domkey[0], fieldConfig: _this.getFields(fields, conditioninfo, form), form: form, formParams: _this.formParams, onChange: _this.getParams(fields, "quickSearch") ? _this.func : func2 }))),
                            colSpan: 1
                        });
                    }
                });
                group.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSearchGroup"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSearchGroup@kxbn09@" + i, needTigger: true, title: c.title, showGroup: c.defaultshow, items: items, customComponent: customComponent, onVisibleChange: _this.onVisibleChange, className: 'cube-search-advance' }));
            });
        }
        return group;
    };
    AdvancedSearchs = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], AdvancedSearchs);
    return AdvancedSearchs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (AdvancedSearchs);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1005),
    listCacheDelete = __webpack_require__(1006),
    listCacheGet = __webpack_require__(1007),
    listCacheHas = __webpack_require__(1008),
    listCacheSet = __webpack_require__(1009);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(401);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(86);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1027);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InnerTabCard", function() { return InnerTabCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__excel_layout__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TopTabs__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailImport__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reply_reply__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reply_replySingle__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reply_rightReply__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_batch_share_Single__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cube_map__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CustomDialog__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RightLeftLayout__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__list__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_log_list__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PreviewCard__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






















var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var InnerTabCard = /** @class */ (function (_super) {
    __extends(InnerTabCard, _super);
    function InnerTabCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBottomHeight = function () {
            var toptabsHeight = __WEBPACK_IMPORTED_MODULE_17_jquery___default()('.coms-mode-card').find('.cube-card-toptabs').outerHeight();
            var topHeight = __WEBPACK_IMPORTED_MODULE_17_jquery___default()('.coms-mode-card').find('.wea-new-top-req-wapper').find('.wea-new-top-req').height();
            var h = document.documentElement.clientHeight - topHeight - toptabsHeight;
            return h - 1;
        };
        return _this;
    }
    InnerTabCard.prototype.render = function () {
        var _a = this.props, Card = _a.Card, _b = _a.hideRightmenu, hideRightmenu = _b === void 0 ? false : _b;
        var verified = Card.verified, hasRight = Card.hasRight, iconInfo = Card.iconInfo, padding = Card.cardMarginParams.padding;
        if (verified && !hasRight) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaAlertPage"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaAlertPage@hwqa2w" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: '#000' } }, getLabel(2012, '对不起，您暂时没有权限！'))));
        }
        if (verified && hasRight) {
            var arr = [];
            if (Card.isInit) {
                if (Card.reply && Card.base.showReply && Card.base.type == '0') {
                    if (Card.base.replyposition == 1) { //底部
                        arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelLayout@gdv1pi@bottom", Card: Card }));
                        arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__reply_reply__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Reply@u8w98q@bottom", reply: Card.reply, padding: padding }));
                    }
                    else if (Card.base.replyposition == 2) { //右
                        var bottomHeight = this.getBottomHeight();
                        var visible = Card.base.defaultcontraction == '1';
                        //回复评论在右侧的时候，页面边距这里处理 ---1
                        arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RightLeftLayout__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_RightLeftLayout@wfyihq@right", padding: padding, visible: visible, bottomHeight: bottomHeight - padding.top - padding.bottom, leftCom: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelLayout@7hjt0g@right", Card: Card }), iconClass: "icon-coms-Advice", titletext: getLabel(128283, '回复评论'), rightCom: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__reply_rightReply__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_RightReply@kcqwxh@right", reply: Card.reply, h: bottomHeight - padding.top - padding.bottom }) }));
                    }
                    else {
                        arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelLayout@x86kju", Card: Card }));
                    }
                }
                else {
                    arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelLayout@9mecdu", Card: Card }));
                }
            }
            var childComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-layout" }, arr),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DetailImport__["DetailImportDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_DetailImportDialog@qijwxu", detailImport: Card.detailImport, iconInfo: iconInfo, ecme: { boolean: false } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_batch_share_Single__["SingleShareDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_SingleShareDialog@pk352n", iconInfo: iconInfo, share: Card.share, formId: Card.base.formId, modeId: Card.base.modeId, nonDefaultShared: Card.base.nondefaultshared, defaultShared: Card.base.defaultshared, type: "0" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__cube_map__["MapAddressDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_MapAddressDialog@li134w", mapStore: Card.mapStore, iconInfo: iconInfo }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CustomDialog__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_CustomDialog@phn022", customDialog: Card.customDialog, iconInfo: iconInfo }));
            if (hideRightmenu) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-inline-wrapper" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-inline-tab" }, childComponent));
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-inline-wrapper" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-inline-tab" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@dpwm0k", datas: Card.cardTab.rightMenusToShow.slice(), onClick: Card.cardTab.rightMenuHandle }, childComponent))));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null));
    };
    InnerTabCard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], InnerTabCard);
    return InnerTabCard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBottomHeight = function () {
            var toptabsHeight = __WEBPACK_IMPORTED_MODULE_17_jquery___default()('.coms-mode-card').find('.cube-card-toptabs').outerHeight();
            var topHeight = __WEBPACK_IMPORTED_MODULE_17_jquery___default()('.coms-mode-card').find('.wea-new-top-req-wapper').find('.wea-new-top-req').height();
            var h = document.documentElement.clientHeight - topHeight - toptabsHeight;
            return h - 1;
        };
        _this.getExcelAndReplayCom = function () {
            var Card = _this.props.Card;
            var padding = Card.cardMarginParams.padding;
            var arr = new Array();
            if (Card.reply && Card.base.showReply && Card.base.type == '0') {
                if (Card.base.replyposition == 1) { //底部
                    arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelLayout@sro8ox@bottom", Card: Card }));
                    arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__reply_reply__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Reply@kcznhb@bottom", reply: Card.reply, padding: padding }));
                }
                else if (Card.base.replyposition == 2) { //右侧
                    var bottomHeight = _this.getBottomHeight();
                    var visible = Card.base.defaultcontraction == '1';
                    //回复评论在右侧的时候，页面边距这里处理 ---1
                    arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RightLeftLayout__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_RightLeftLayout@h30vfd@right", padding: padding, visible: visible, bottomHeight: bottomHeight - padding.top - padding.bottom, leftCom: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelLayout@t7kwye@right", Card: Card }), iconClass: "icon-coms-Advice", titletext: getLabel(128283, '回复评论'), rightCom: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__reply_rightReply__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_RightReply@cdhmre@right", reply: Card.reply, h: bottomHeight - padding.top - padding.bottom }) }));
                }
                else {
                    arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelLayout@xbf2ij", Card: Card }));
                }
            }
            else {
                arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelLayout@f39zvx", Card: Card }));
            }
            return arr;
        };
        _this.slideModalClose = function () {
            var Card = _this.props.Card;
            Card.showSlideModal(false, "", "");
        };
        return _this;
    }
    Card.prototype.componentDidMount = function () {
        __WEBPACK_IMPORTED_MODULE_13__util__["default"].perfectHeight = function () {
            var toptabsHeight = __WEBPACK_IMPORTED_MODULE_17_jquery___default()('.coms-mode-card').find('.cube-card-toptabs').outerHeight();
            var topHeight = __WEBPACK_IMPORTED_MODULE_17_jquery___default()('.coms-mode-card').find('.wea-new-top-req-wapper').find('.wea-new-top-req').height();
            var bodyHeight = __WEBPACK_IMPORTED_MODULE_17_jquery___default()('.coms-mode-card').find('.wea-new-top-req-wapper').find('.wea-new-top-req-content').prop('scrollHeight');
            return bodyHeight + topHeight + toptabsHeight;
        };
    };
    Card.prototype.doScrollYEvent = function () {
        __WEBPACK_IMPORTED_MODULE_20__util_cubeUtil__["b" /* fixedDetailHead */](); //明细表头固定
    };
    Card.prototype.render = function () {
        var _a = this.props, Card = _a.Card, Search = _a.Search, cubeLogList = _a.cubeLogList;
        var verified = Card.verified, hasRight = Card.hasRight, iconInfo = Card.iconInfo, windowTitle = Card.windowTitle, sliderParams = Card.sliderParams;
        if (windowTitle != '') {
            document.title = windowTitle;
        }
        if (verified && !hasRight) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaAlertPage"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaAlertPage@sqoh2v" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: '#000' } }, getLabel(2012, '对不起，您暂时没有权限！'))));
        }
        if (verified && hasRight) {
            if (Card.params.type == '4') {
                return (Card.isInit ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelLayout@k6xzmk", Card: Card }) :
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null));
            }
            if (Card.params.isPreview && ((Card.params.isPreview | 0) == 1)) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__PreviewCard__["a" /* PreviewCard */], { ecId: (this && this.props && this.props.ecId || '') + "_PreviewCard@8do1g7", Card: Card });
            }
            if (Card.params.hidetop && ((Card.params.hidetop | 0) === 1)) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerTabCard, { ecId: (this && this.props && this.props.ecId || '') + "_InnerTabCard@8q59i5", Card: Card, Search: Search });
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TopTabs__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_TopTabs@353cxd", modeName: getLabel(1361, "基本信息"), onTabClick: Card.cardTab.changeTopActiveKey, topTabs: Card.cardTab.topTabs && Card.cardTab.topTabs.slice(), activeKey: Card.cardTab.topActiveKey, activeDropKey: Card.cardTab.topDropActiveKey, isCube: Card.cardTab.isCube, url: Card.cardTab.hrefUrl, Search: this.props.Search, Tree: this.props.Tree, Reply: this.props.reply, Custompage: this.props.customPageStore },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@spqptt", datas: Card.cardTab.rightMenusToShow.slice(), onClick: Card.cardTab.rightMenuHandle, collectParams: {
                        "favname": getLabel(1361, "基本信息"),
                        "link": '/' + __WEBPACK_IMPORTED_MODULE_13__util__["default"].location.toString().split('/').slice(3).join('/'),
                        "favouritetype": 5,
                        "importantlevel": 1
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_18_classnames___default()({ 'cube-card-top-wrapper-no-tabs': !Card.cardTab.tabDatas.slice().length }) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaReqTop"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaReqTop@87komh", loading: Card.isShowLoading, title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { title: Card.cardTab.title }, Card.cardTab.title), icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: iconInfo.icon, style: { color: iconInfo.iconColor } }), iconBgcolor: iconInfo.iconBg, tabDatas: Card.cardTab.tabDatas.slice(), onChange: Card.cardTab.changeInnerTabSelectedKey, selectedKey: Card.cardTab.innerTabSelectedKey, onDropMenuClick: Card.cardTab.rightMenuHandle }, this.getRightMenusProps),
                            Card.cardTab.innerTabSelectedKey == '1000' && Card.isInit &&
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-form-content", onScroll: this.doScrollYEvent.bind(this) }, this.getExcelAndReplayCom()),
                            Card.isSearchShow && Search.isInit &&
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-list-wrapper" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__list__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_List@g31noo", Search: Search, hideRightmenu: true })),
                            Card.isCardShow && Card.card.isInit &&
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-form-content", onScroll: this.doScrollYEvent.bind(this) },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerTabCard, { ecId: (this && this.props && this.props.ecId || '') + "_InnerTabCard@byohlz", Card: Card.card, Search: Search, hideRightmenu: true })),
                            Card.isLogListShow &&
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-list-wrapper" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_log_list__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_LogList@7jgl0l", cubeLogList: cubeLogList })),
                            Card.isShowReply && Card.reply && (Card.base.type == '0' || Card.base.type == '2') &&
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { paddingTop: 25 } }, Card.base.showReply ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__reply_replySingle__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ReplySingle@mbsg4d", reply: Card.reply })
                                    : Card.base.showReply === false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-no-open-reply" }, getLabel("391240", "请联系管理员后台开启回复评论功能！"))
                                        : null
                                // <ReplySingle reply={Card.reply}/> 
                                ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-iframe", style: { display: 'none' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { onLoad: function () {
                                        Card.changeLoadingState();
                                    }, id: "tabcontentframe", name: "tabcontentframe", width: "100%", height: "100%", frameBorder: 0, scrolling: "yes", style: { display: 'none' } })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DetailImport__["DetailImportDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_DetailImportDialog@59ft7w", detailImport: Card.detailImport, iconInfo: iconInfo, ecme: { boolean: false } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_batch_share_Single__["SingleShareDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_SingleShareDialog@fzgmiy", iconInfo: iconInfo, share: Card.share, formId: Card.base.formId, modeId: Card.base.modeId, nonDefaultShared: Card.base.nondefaultshared, defaultShared: Card.base.defaultshared, type: "0" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__cube_map__["MapAddressDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_MapAddressDialog@057b2l", mapStore: Card.mapStore, iconInfo: iconInfo }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CustomDialog__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_CustomDialog@4l6qbk", customDialog: Card.customDialog, iconInfo: iconInfo }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "Cube-card-WeaSlideModal" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaSlideModal"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSlideModal@450zoo", visible: Card.slideModalVisible, top: this.slideStyle.newtop + "px", width: ((this.slideStyle.width) * parseFloat(sliderParams.sliderPercentage) / 100) + "px", height: (this.slideStyle.height) + "px", direction: 'right', measure: '', style: { overflowY: "hidden" }, content: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { src: sliderParams.slideModalUrl, name: "iframe_" + new Date().getTime(), style: {
                                            border: "0",
                                            height: "100%",
                                            width: "100%"
                                        } })), onClose: this.slideModalClose })))))));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null));
    };
    Object.defineProperty(Card.prototype, "slideStyle", {
        get: function () {
            var themelayoutType = (__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].ls.getJSONObj('theme-themeInfo') && __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].ls.getJSONObj('theme-themeInfo').themeLayoutType) || "1"; //门户布局
            var newtop = 0;
            if (themelayoutType == '1') { //默认布局
                newtop = __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout-main").offset() ? (__WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout-main").offset().top ? __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout-main").offset().top + 10 : 0) : 0;
            }
            else {
                newtop = __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout" + themelayoutType + "-main").offset() ? (__WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout" + themelayoutType + "-main").offset().top ? __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout" + themelayoutType + "-main").offset().top + 10 : 0) : 0;
            }
            if (newtop == 0) {
                newtop = __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e8theme-layout-main").offset() ? (__WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e8theme-layout-main").offset().top ? __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e8theme-layout-main").offset().top + 10 : 0) : 0;
            }
            /***计算left */
            var left = __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout-main").offset() ? (__WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout-main").offset().left ? __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e9theme-layout-main").offset().left + 10 : 0) : 0;
            if (left == 0) {
                left = __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e8theme-layout-main").offset() ? (__WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e8theme-layout-main").offset().left ? __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".e8theme-layout-main").offset().left + 10 : 0) : 0;
                if (left == 0) {
                    left = __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".cube-tree-list").css('width');
                    if (left == undefined) {
                        left = 0;
                    }
                    else {
                        left = left.replace('px', '') - 14;
                    }
                }
                else {
                    var treeleft = __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".cube-tree-list").css('width');
                    if (treeleft == undefined) {
                        treeleft = 0;
                    }
                    else {
                        left = left + parseFloat(treeleft.replace('px', '')) - 10;
                    }
                }
            }
            else {
                var treeleft = __WEBPACK_IMPORTED_MODULE_17_jquery___default()(".cube-tree-list").css('width');
                if (treeleft == undefined) {
                    treeleft = 0;
                }
                else {
                    left = left + parseFloat(treeleft.replace('px', '')) - 10;
                }
            }
            var scrollheigth = document.documentElement.clientHeight - newtop;
            var scrollwidth = document.documentElement.clientWidth - left;
            return { height: scrollheigth, width: scrollwidth, newtop: newtop };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "getRightMenusProps", {
        get: function () {
            var Card = this.props.Card;
            var rightMenusProps = {};
            if (Card.cardTab.quickButtons.slice().length > 0) {
                __WEBPACK_IMPORTED_MODULE_16_lodash___default.a.set(rightMenusProps, 'buttons', Card.cardTab.quickButtons.slice());
            }
            if (Card.cardTab.rightMenusToShow.slice().length > 0) {
                __WEBPACK_IMPORTED_MODULE_16_lodash___default.a.set(rightMenusProps, 'dropMenuDatas', Card.cardTab.rightMenusToShow.slice());
                __WEBPACK_IMPORTED_MODULE_16_lodash___default.a.set(rightMenusProps, 'showDropIcon', true);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_16_lodash___default.a.set(rightMenusProps, 'showDropIcon', false);
            }
            return rightMenusProps;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_21_mobx__["computed"]
    ], Card.prototype, "slideStyle", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_21_mobx__["computed"]
    ], Card.prototype, "getRightMenusProps", null);
    Card = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('Card', 'Search', 'Tree', 'reply', 'customPageStore', 'cubeLogList'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Card);
    return Card;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (Card);


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(55);
var call = __webpack_require__(380);
var isArrayIter = __webpack_require__(381);
var anObject = __webpack_require__(56);
var toLength = __webpack_require__(114);
var getIterFn = __webpack_require__(382);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_162__;

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MapViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;


var CubeMap = /** @class */ (function (_super) {
    __extends(CubeMap, _super);
    function CubeMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.paint = function (obj) {
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap) {
                var titles = obj.titles;
                if (!_this.map) {
                    _this.map = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Map(_this.refs._map, {
                        resizeEnable: true,
                    });
                }
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(titles, function (title) {
                    _this.geocoder(title);
                });
            }
            else {
                setTimeout(function () {
                    that.paint(that.props);
                }, 50);
            }
        };
        _this.geocoder = function (title) {
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Geocoder) {
                that.geocoderAfter(title);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.plugin(['AMap.Geocoder'], function () {
                    that.geocoderAfter(title);
                });
            }
        };
        _this.geocoderAfter = function (title) {
            var that = _this;
            var geocoder = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Geocoder({
                radius: 500,
            });
            //地理编码,返回地理编码结果
            geocoder.getLocation(title, function (status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    that.geocoder_CallBack(result);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].info({
                        title: getLabel(15172, '系统提示'),
                        content: getLabel(128181, '未能定位具体位置！ 1.请确保所有字词拼写正确 2.尝试不同的关键字 3.尝试更宽泛的关键字'),
                        onOk: function () { },
                    });
                }
            });
        };
        _this.geocoder_CallBack = function (data) {
            //地理编码结果数组
            var geocode = data.geocodes;
            for (var i = 0; i < 1; i++) {
                var position = [geocode[i].location.getLng(), geocode[i].location.getLat()];
                _this.addMarker(i, position, geocode[i].formattedAddress);
            }
            _this.map.setFitView();
        };
        _this.addMarker = function (_, p, address) {
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Marker) {
                that.addMarkerAfter(_, p, address);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.plugin(['AMap.Marker'], function () {
                    that.addMarkerAfter(_, p, address);
                });
            }
        };
        _this.addMarkerAfter = function (_, p, address) {
            var that = _this;
            that.marker = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Marker({
                map: that.map,
                position: p
            });
            var infoWindow = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.InfoWindow({
                content: address,
                offset: { x: 0, y: -30 }
            });
            that.marker.on("mouseover", function (e) {
                infoWindow.open(that.map, e.target.getPosition());
            });
            infoWindow.open(that.map, that.marker.getPosition()); //设置显示出来标签内容
        };
        return _this;
    }
    CubeMap.prototype.componentDidMount = function () {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_6_loadjs___default.a.isDefined('mapjs')) {
            __WEBPACK_IMPORTED_MODULE_6_loadjs___default()(["https://webapi.amap.com/maps?v=1.4.4&key=53a92850ca00d7f77aef3297effd8d59"], 'mapjs', {
                //&plugin=AMap.Geocoder,AMap.ToolBar,AMap.Scale
                success: function () {
                    _this.paint(_this.props);
                }
            });
        }
        else {
            this.paint(this.props);
        }
    };
    CubeMap.prototype.componentWillReceiveProps = function (nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_7_mobx__["toJS"])(this.props.titles), Object(__WEBPACK_IMPORTED_MODULE_7_mobx__["toJS"])(nextProps.titles))) {
            this.marker && this.map.remove(this.marker);
            this.map && this.paint(nextProps);
        }
    };
    CubeMap.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { ref: '_map', style: { height: '100%' } })));
    };
    return CubeMap;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["c"] = (CubeMap);
var MapViewer = /** @class */ (function (_super) {
    __extends(MapViewer, _super);
    function MapViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MapViewer.prototype.componentWillMount = function () {
        var mapStore = this.props.mapStore;
        mapStore.getTitles();
    };
    MapViewer.prototype.render = function () {
        var mapStore = this.props.mapStore;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CubeMap, { ecId: (this && this.props && this.props.ecId || '') + "_CubeMap@w5mw7v", titles: mapStore.titles }));
    };
    MapViewer = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["inject"])('mapStore'),
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], MapViewer);
    return MapViewer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var MapDialog = /** @class */ (function (_super) {
    __extends(MapDialog, _super);
    function MapDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MapDialog.prototype.render = function () {
        var _a = this.props, _b = _a.cubeMap, visible = _b.visible, location = _b.location, onCancel = _a.onCancel, iconInfo = _a.iconInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@uaqetg", buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@s2eqqg@onCancel", type: "primary", onClick: onCancel }, getLabel(309, "关闭"))], title: getLabel(82639, '地图显示'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: visible, style: { width: 700, height: 450 }, hasScroll: true, onCancel: onCancel }, visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CubeMap, { ecId: (this && this.props && this.props.ecId || '') + "_CubeMap@tcml1v", titles: [location] })));
    };
    MapDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], MapDialog);
    return MapDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validatorjs__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var getLabel = __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaLocaleProvider"].getLabel;
var ShareStore = /** @class */ (function () {
    function ShareStore() {
        var _this = this;
        this.conditions = [];
        this.form = new __WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaForm"]();
        this.visible = false;
        this.singleVisible = false;
        this.billid = '';
        this.refObj = {};
        this.errors = {};
        this.loading = false;
        this.imgSelectValue = "";
        this.verticalValue = '';
        this.getRule = function () {
            var rule = {};
            var errors = {};
            var sharetype = _this.form.$('sharetype').values();
            if (sharetype != '5') {
                rule["relatedid" + sharetype] = 'required';
                errors["required.relatedid" + sharetype] = getLabel(128937, "请选择") + getLabel(19117, "共享对象");
                if (sharetype == '4') {
                    var isRoleLimited = _this.form.$('isRoleLimited').values();
                    if (isRoleLimited == '1') {
                        var rolefieldtype = _this.form.$('rolefieldtype').values();
                        rule.rolefieldtype = 'required';
                        rule["rolefield" + rolefieldtype] = 'required';
                        errors['required.rolefieldtype'] = getLabel(128937, "383747");
                        errors["required.rolefield" + rolefieldtype] = getLabel(128937, "请选择") + getLabel(82386, "限制字段");
                    }
                }
                else if (sharetype == '6') {
                    var joblevel = _this.form.$('joblevel').values();
                    if (joblevel == '0') {
                        rule.jobleveltext1 = 'required';
                        errors['required.jobleveltext1'] = getLabel(125231, '请选择部门');
                    }
                    else if (joblevel == '1') {
                        rule.jobleveltext2 = 'required';
                        errors['required.jobleveltext2'] = getLabel(82181, '请选择分部');
                    }
                }
            }
            return {
                rule: rule,
                errors: errors
            };
        };
        this.onCancel = function () {
            _this.form.resetConditionValue();
            _this.visible = false;
        };
        this.doValidaParam = function () {
            var _a = _this.form.getFormParams(), sharetype = _a.sharetype, rolefieldtype = _a.rolefieldtype, isRoleLimited = _a.isRoleLimited;
            var _b = _this.getRule(), rule = _b.rule, errors = _b.errors;
            if (sharetype != '5') {
                var relatedid = 'relatedid' + sharetype;
                if (!_this.form.getFormDatas()[relatedid].value) {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(getLabel(30933, "必填信息不完整!"));
                    return false;
                }
            }
            if (sharetype == '4' && isRoleLimited == '1') {
                var rolefield = 'rolefield' + rolefieldtype;
                if (!_this.form.getFormDatas()[rolefield].value) {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(getLabel(30933, "必填信息不完整!"));
                    return false;
                }
            }
            if (sharetype != '1' && !(_this.form.$('showlevel').value[0] + "")) {
                _this.refObj["showlevel"].showError();
                return false;
            }
            var validator = new __WEBPACK_IMPORTED_MODULE_6_validatorjs___default.a(_this.form.getFormDatas(), rule, errors);
            if (validator.fails()) {
                var errors_1 = validator.errors.errors;
                var _errors = {};
                for (var field in errors_1) {
                    _errors[field] = errors_1[field].join();
                }
                _this.update({
                    errors: _errors
                });
                __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(getLabel(30933, "必填信息不完整!"));
                _this.loading = false;
                return false;
            }
            return true;
        };
        this.onOk = function (params, success) {
            if (!_this.doValidaParam()) {
                return;
            }
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].saveBatchShare(__assign({}, params, { billids: _this.treeKey ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(_this.treeKey.map(function (d) { return d.split('_')[0]; })) + ""
                    : _this.imgSelectValue ?
                        _this.imgSelectValue
                        : _this.verticalValue ?
                            _this.verticalValue : __WEBPACK_IMPORTED_MODULE_4__util__["default"]._xtable_CheckedCheckboxId() }, _this.form.values())).then(function (_a) {
                var status = _a.status, error = _a.error, tips = _a.tips;
                if (status == '1') {
                    // message.success(tips);
                    __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].info({
                        title: getLabel(386786, '信息确认'),
                        content: tips,
                        onOk: function () {
                        },
                    });
                    _this.onCancel();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
                success && success();
            });
        };
        this.clearError = function (name) {
            if (name == 'sharetype') {
                _this.errors = {};
            }
            _this.errors[name] = '';
        };
        this.getBatchShareCondition = function (params, callback) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].batchShareCondition(params).then(function (_a) {
                var status = _a.status, error = _a.error, conditions = _a.conditions;
                if (status == '1') {
                    _this.conditions = conditions;
                    _this.form.initFormFieldObj(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.values(conditions));
                    callback && callback();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.batchShare = function (Search) {
            if (!Search.checkSeleted()) {
                return;
            }
            if (Search.treeKey) {
                _this.treeKey = Search.treeKey;
            }
            if (Search) {
                _this.imgSelectValue = Search.imgSelectValue;
                _this.verticalValue = Search.verticalListStore.selectValue;
            }
            var showBatchShare = function () {
                _this.visible = true;
            };
            _this.form.resetConditionValue();
            _this.getBatchShareCondition({
                modeId: Search.modeId,
                formId: Search.formId
            }, showBatchShare);
        };
        this.closeSingle = function () {
            _this.update({ singleVisible: false });
        };
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "conditions", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "singleVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "billid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "refObj", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "errors", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "treeKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "imgSelectValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ShareStore.prototype, "verticalValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ShareStore.prototype, "onOk", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ShareStore.prototype, "clearError", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ShareStore.prototype, "getBatchShareCondition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ShareStore.prototype, "batchShare", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ShareStore.prototype, "update", void 0);
    return ShareStore;
}());
/* harmony default export */ __webpack_exports__["default"] = (ShareStore);


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'The :attribute must be accepted.',
  after: 'The :attribute must be after :after.',
  after_or_equal: 'The :attribute must be equal or after :after_or_equal.',
  alpha: 'The :attribute field must contain only alphabetic characters.',
  alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
  alpha_num: 'The :attribute field must be alphanumeric.',
  before: 'The :attribute must be before :before.',
  before_or_equal: 'The :attribute must be equal or before :before_or_equal.',
  between: 'The :attribute field must be between :min and :max.',
  confirmed: 'The :attribute confirmation does not match.',
  email: 'The :attribute format is invalid.',
  date: 'The :attribute is not a valid date format.',
  def: 'The :attribute attribute has errors.',
  digits: 'The :attribute must be :digits digits.',
  different: 'The :attribute and :different must be different.',
  'in': 'The selected :attribute is invalid.',
  integer: 'The :attribute must be an integer.',
  min: {
    numeric: 'The :attribute must be at least :min.',
    string: 'The :attribute must be at least :min characters.'
  },
  max: {
    numeric: 'The :attribute may not be greater than :max.',
    string: 'The :attribute may not be greater than :max characters.'
  },
  not_in: 'The selected :attribute is invalid.',
  numeric: 'The :attribute must be a number.',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'The :attribute field is required.',
  required_if: 'The :attribute field is required when :other is :value.',
  required_unless: 'The :attribute field is required when :other is not :value.',
  required_with: 'The :attribute field is required when :field is not empty.',
  required_with_all: 'The :attribute field is required when :fields are not empty.',
  required_without: 'The :attribute field is required when :field is empty.',
  required_without_all: 'The :attribute field is required when :fields are empty.',
  same: 'The :attribute and :same fields must match.',
  size: {
    numeric: 'The :attribute must be :size.',
    string: 'The :attribute must be :size characters.'
  },
  string: 'The :attribute must be a string.',
  url: 'The :attribute format is invalid.',
  regex: 'The :attribute format is invalid.',
  attributes: {}
};


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modeForm_pc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__convert__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);



var modeForm_pc = {
    showMessage: function (msg, type, duration) {
        if (type === void 0) { type = 1; }
        if (duration === void 0) { duration = 1.5; }
        var message = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].WindowFunc.getTop().antd.message;
        if (type === 1) //警告
            message.warning(msg, duration);
        else if (type === 2) //错误
            message.error(msg, duration);
        else if (type === 3) //成功
            message.success(msg, duration);
        else //普通信息
            message.info(msg, duration);
    },
    showConfirm: function (content, okEvent, cancelEvent, otherInfo) {
        if (otherInfo === void 0) { otherInfo = {}; }
        var Modal = Object(__WEBPACK_IMPORTED_MODULE_1__convert__["a" /* getAntd */])().Modal;
        Modal.confirm({
            title: otherInfo.title || Object(__WEBPACK_IMPORTED_MODULE_1__convert__["b" /* getLabel */])(131329, '信息确认'),
            content: __WEBPACK_IMPORTED_MODULE_0____["default"].React.createElement("div", { dangerouslySetInnerHTML: { __html: content } }),
            okText: otherInfo.okText || Object(__WEBPACK_IMPORTED_MODULE_1__convert__["b" /* getLabel */])(826, '确定'),
            cancelText: otherInfo.cancelText || Object(__WEBPACK_IMPORTED_MODULE_1__convert__["b" /* getLabel */])(201, '取消'),
            onOk: function () {
                typeof okEvent === "function" && okEvent();
            },
            onCancel: function () {
                typeof cancelEvent === "function" && cancelEvent();
            },
        });
    },
    getCurrentUserInfo: function () {
        return __WEBPACK_IMPORTED_MODULE_0____["default"].ecCom.WeaTools.ls.getJSONObj('theme-account');
    },
    showModalMsg: function (title, msg, type) {
        if (type === void 0) { type = 1; }
        var Modal = Object(__WEBPACK_IMPORTED_MODULE_1__convert__["a" /* getAntd */])().Modal;
        var typeName = "info";
        if (type === 1) //普通信息
            typeName = "info";
        else if (type === 2) //错误
            typeName = "error";
        else if (type === 3) //成功
            typeName = "success";
        else //警告
            typeName = "warning";
        Modal[typeName]({
            title: title || "",
            content: React.createElement("div", { dangerouslySetInnerHTML: { __html: msg } }),
        });
    },
};



/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAntd; });
/* unused harmony export getEcCom */
/* unused harmony export getComsMobx */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(7);

var getAntd = function () {
    return typeof __WEBPACK_IMPORTED_MODULE_0____["default"].antd === "undefined" ? {} : __WEBPACK_IMPORTED_MODULE_0____["default"].antd;
};
var getEcCom = function () {
    return typeof __WEBPACK_IMPORTED_MODULE_0____["default"].ecCom === "undefined" ? {} : __WEBPACK_IMPORTED_MODULE_0____["default"].ecCom;
};
var getComsMobx = function () {
    return typeof __WEBPACK_IMPORTED_MODULE_0____["default"].comsMobx === "undefined" ? {} : __WEBPACK_IMPORTED_MODULE_0____["default"].comsMobx;
};
var getLabel = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var WeaLocaleProvider = getEcCom().WeaLocaleProvider;
    return WeaLocaleProvider.getLabel.apply(WeaLocaleProvider, args);
};


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellLabel__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSpan__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cell_field__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailTable__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailButtons__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CellLink__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CellDiv__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DetailSum__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cell_field_checkbox_element_DetailCheckAll__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cell_field_checkbox_element_DetailCheckbox__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabTable__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modeTab__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MutilContent__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PortalPage__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CellLikes__ = __webpack_require__(533);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




















var getLabel = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaLocaleProvider"].getLabel;
var ExcelTableCell = /** @class */ (function (_super) {
    __extends(ExcelTableCell, _super);
    function ExcelTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExcelTableCell.prototype.render = function () {
        var _a = this.props, cell = _a.cell, card = _a.card, contentType = _a.contentType, index = _a.index, excel = _a.excel, form = _a.form, className = _a.className, detail = _a.detail, content = _a.content;
        if (cell && (cell.evalue == "#QRCodeImg#" || cell.evalue == "#BARCodeImg#")) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CellDiv__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDiv@cft66b", cell: cell, card: card });
        }
        /****
         * 显示布局点赞功能
         */
        if (card.base.type == '0' && cell && (cell.evalue == "#likes#" || cell.evalue == "#dislikes#") && card.isallowdislike == '1') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__CellLikes__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_CellLikes@8uc030", cell: cell, card: card });
        }
        switch (cell.etype) {
            case '':
            case '0':
            case '1':
            case '4':
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CellSpan__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellSpan@k3pdfw", cell: cell, excel: excel, contentType: contentType, form: form, card: card, index: index }));
            case '6':
                ////文本、节点名称、图片
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null);
            case '2':
                ////字段名
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CellLabel__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellLabel@3jje5q", form: form, cell: cell, card: this.props.card });
            case '3':
                ////字段值
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__cell_field__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellField@ujil20", cell: cell, form: form, card: card, excel: excel, index: index });
            case '7':
                ////明细
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DetailTable__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTable@rpigwa", cell: cell, card: this.props.card });
            case '10':
                ////明细操作按钮
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailButtons__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailButtons@gb2zn5", card: card, excel: excel });
            case '11':
                ////链接
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CellLink__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellLink@q7l7a3", cell: cell });
            case '12':
                ////标签页
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TabTable__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableTabTable@fr9pxt", card: card, cell: cell });
            case '13':
                ////多内容
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__MutilContent__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableMutilContent@si0fy9", cell: cell, excel: excel, contentType: contentType, form: form, card: card, index: index, detail: detail, content: content, className: className });
            case '14':
                ////多内容换行
                if (cell.brsign == 'Y') { //换行
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null);
                }
                else {
                    return null;
                }
            case '15':
                //////门户元素
                var jsonparam = Object(__WEBPACK_IMPORTED_MODULE_17_mobx__["toJS"])(cell.jsonparam) || {};
                var hpid = jsonparam.hpid || "";
                var formData_1 = {};
                if (hpid != '' && jsonparam.trifields) {
                    var form_1 = this.props.form;
                    var trifields = jsonparam.trifields || "";
                    trifields.split(",").map(function (fieldid) {
                        var bindObj = form_1.has(fieldid) ? form_1.$(fieldid) : {};
                        if (!__WEBPACK_IMPORTED_MODULE_18_jquery___default.a.isEmptyObject(bindObj)) {
                            var bind = bindObj.bind();
                            var fieldValue = bind.value;
                            formData_1[fieldid] = fieldValue;
                        }
                    });
                    formData_1["_billid"] = this.props.card.base.billid;
                }
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PortalPage__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_PortalPage@y4vty8", hpid: hpid, formData: formData_1 });
            case '16':
            case '17':
                //////iframe区域、扫码区
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CellDiv__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDiv@ghyr2q", cell: cell, card: card });
            case '18':
                ////合计名称
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CellSpan__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellSpan@90lifg", cell: cell, excel: excel, form: form, card: card, index: index, content: "(" + getLabel('358', '合计') + ")", contentType: 'content' }));
            case '19':
                ////合计值
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DetailSum__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailSum@rifaq3", cell: cell, form: form, card: card }));
            case '20':
                ////明细全选
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__cell_field_checkbox_element_DetailCheckAll__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_DetailCheckAll@jvs6hp", detail: detail, excel: excel, form: form, card: card }));
            case '21':
                ////明细单选
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__cell_field_checkbox_element_DetailCheckbox__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_DetailCheckbox@qn5zfi", detail: detail, excel: excel, form: form, card: card }));
            case '22':
                ////序号
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CellSpan__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellSpan@3kzszj", cell: cell, excel: excel, form: form, card: card, index: index, contentType: 'index' }));
            case '23':
                var parm = this.props.card.params;
                var istagset = this.props.card.base.istagset;
                if (istagset == '1') {
                    ////标签
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__modeTab__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ModeTab@frvt99", container: "#container", modeid: parm.modeId, billid: parm.billid, type: 'card' }));
                }
                else {
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: 'red' } }, getLabel(385121, '请联系管理员后台开启标签功能!')));
                }
            case '8':
                return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, cell.evalue));
    };
    ExcelTableCell = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCell);
    return ExcelTableCell;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCell);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(259),
    castSlice = __webpack_require__(455),
    charsEndIndex = __webpack_require__(457),
    charsStartIndex = __webpack_require__(461),
    stringToArray = __webpack_require__(462),
    toString = __webpack_require__(466);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_checkbox__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shallowequal__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shallowequal__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};





var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveCheckbox = function (node) {
            _this.rcCheckbox = node;
        };
        return _this;
    }
    Checkbox.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        return !__WEBPACK_IMPORTED_MODULE_4_shallowequal___default()(this.props, nextProps) ||
            !__WEBPACK_IMPORTED_MODULE_4_shallowequal___default()(this.state, nextState) ||
            !__WEBPACK_IMPORTED_MODULE_4_shallowequal___default()(this.context.checkboxGroup, nextContext.checkboxGroup);
    };
    Checkbox.prototype.focus = function () {
        this.rcCheckbox.focus();
    };
    Checkbox.prototype.blur = function () {
        this.rcCheckbox.blur();
    };
    Checkbox.prototype.render = function () {
        var _a, _b;
        var _c = this, props = _c.props, context = _c.context;
        var prefixCls = props.prefixCls, className = props.className, children = props.children, indeterminate = props.indeterminate, checkAll = props.checkAll, style = props.style, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "checkAll", "style", "onMouseEnter", "onMouseLeave"]);
        var checkboxGroup = context.checkboxGroup;
        var checkboxProps = __assign({}, restProps);
        if (checkboxGroup) {
            checkboxProps.onChange = function () { return checkboxGroup.toggleOption({ label: children, value: props.value }); };
            checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
            checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
        }
        if (checkAll !== undefined) {
            checkboxProps.checked = checkAll;
        }
        var classString = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_a = {},
            _a[prefixCls + "-wrapper"] = true,
            _a[prefixCls + "-wrapper-checked"] = checkboxProps.checked,
            _a[prefixCls + "-wrapper-disabled"] = checkboxProps.disabled,
            _a));
        var checkboxClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_b = {},
            _b[prefixCls + "-indeterminate"] = indeterminate,
            _b[prefixCls + "-checked"] = checkAll,
            _b));
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: classString, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_checkbox__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_RcCheckbox@wopdjk" }, checkboxProps, { prefixCls: prefixCls, className: checkboxClass, ref: this.saveCheckbox })),
            children !== undefined && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, children)));
    };
    Checkbox.defaultProps = {
        prefixCls: 'ant-checkbox',
        indeterminate: false,
    };
    Checkbox.contextTypes = {
        checkboxGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
    };
    return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(43);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(173);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 175 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(177)('keys');
var uid = __webpack_require__(116);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(22);
var global = __webpack_require__(38);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(115) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 179 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(504)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(181)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(115);
var $export = __webpack_require__(31);
var redefine = __webpack_require__(268);
var hide = __webpack_require__(49);
var Iterators = __webpack_require__(92);
var $iterCreate = __webpack_require__(505);
var setToStringTag = __webpack_require__(119);
var getPrototypeOf = __webpack_require__(269);
var ITERATOR = __webpack_require__(32)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(32);


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(116)('meta');
var isObject = __webpack_require__(43);
var has = __webpack_require__(58);
var setDesc = __webpack_require__(34).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(57)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(38);
var core = __webpack_require__(22);
var LIBRARY = __webpack_require__(115);
var wksExt = __webpack_require__(182);
var defineProperty = __webpack_require__(34).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__add__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};










var getParent = __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaTools"].WindowFunc.getParent;
var getLabel = __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaLocaleProvider"].getLabel;
var ReplyStore = /** @class */ (function () {
    function ReplyStore(props) {
        var _this = this;
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.init = function (props) {
            if (props === void 0) { props = {}; }
            _this.update(props);
            _this.conditionInfo = [{
                    colSpan: 2,
                    conditionType: 'INPUT',
                    domkey: [
                        'content'
                    ],
                    fieldcol: 12,
                    isQuickSearch: true,
                    label: getLabel(131393, '内容'),
                    labelcol: 6,
                    value: '',
                    viewAttr: 2
                }, {
                    browserConditionParam: {
                        completeParams: {},
                        conditionDataParams: {},
                        dataParams: {},
                        destDataParams: {},
                        hasAddBtn: false,
                        hasAdvanceSerach: true,
                        idSeparator: ',',
                        isAutoComplete: 1,
                        isDetail: 0,
                        isMultCheckbox: false,
                        isSingle: true,
                        linkUrl: '/hrm/resource/HrmResource.jsp?id=',
                        pageSize: 10,
                        quickSearchName: '',
                        replaceDatas: [],
                        title: getLabel(172, '选择') + getLabel(26225, '发表人'),
                        type: '1',
                        viewAttr: 2
                    },
                    colSpan: 2,
                    conditionType: 'BROWSER',
                    domkey: [
                        'operatorid'
                    ],
                    fieldcol: 12,
                    isQuickSearch: false,
                    label: getLabel(26225, '发表人'),
                    labelcol: 6,
                    viewAttr: 2
                }, {
                    colSpan: 2,
                    fieldcol: 12,
                    labelcol: 6,
                    conditionType: 'DATE',
                    datas: [
                        { name: getLabel(332, '全部'), value: '0' },
                        { name: getLabel(15537, '今天'), value: '1' },
                        { name: getLabel(15539, '本周'), value: '2' },
                        { name: getLabel(15541, '本月'), value: '3' },
                        { name: getLabel(21904, '本季'), value: '4' },
                        { name: getLabel(15384, '本年'), value: '5' },
                        { name: getLabel(27347, '上个月'), value: '7' },
                        { name: getLabel(81716, '上一年'), value: '8' },
                        { name: getLabel(32530, '指定日期范围'), value: '6' } // 时间范围的值必须为6
                    ],
                    domkey: ['createdateselect', 'createdatefrom', 'createdateto'],
                    label: getLabel(21663, '操作日期'),
                    value: '',
                    viewAttr: 2,
                }, {
                    colSpan: 2,
                    conditionType: 'WeaInput',
                    rules: 'integer|min:1',
                    domkey: [
                        'floorNum'
                    ],
                    fieldcol: 12,
                    isQuickSearch: true,
                    label: getLabel(27519, '楼号'),
                    labelcol: 6,
                    value: '',
                    viewAttr: 2,
                }];
            _this.condition = new __WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaForm"]();
            _this.condition.initFormFields([{ items: _this.conditionInfo }]);
            _this.replyAdd.initReplyAddStore(__assign({}, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(_this.modeInfo, ['maincategory', 'subcategory', 'seccategory']), { contentid: "field" + _this.replyModeInfo.replayContentFieldId, callSubmit: _this.submitReply, isdefault: _this.isdefault, showbuttons: _this.showbuttons, secretLevel: _this.secretLevel }));
            _this.loading = false;
        };
        this.searchContent = '';
        this.showReply = void (0);
        this.replyposition = "1";
        this.scrollTop = 0;
        this.replyModeInfo = {};
        this.modeInfo = {};
        this.replyList = [];
        this.dateList = [];
        this.replyData = {};
        this.scrollBottom = {};
        this.getScrollTop = {};
        this.pagesize = 5;
        this.total = 0;
        this.pagecount = 0;
        this.current = 1;
        this.loading = false;
        this.isdefault = true;
        this.showbuttons = {};
        this.replyAdd = new __WEBPACK_IMPORTED_MODULE_5__add__["a" /* ReplyAddStore */]();
        this.params = {};
        this.secretLevel = '-1';
        this.tabDatas = [
            { title: getLabel('332', '全部'), key: '1' },
            { title: getLabel(32572, '与我相关'), key: '2' }
        ];
        this.selectedKey = '1';
        this.showSearchDrop = false;
        this.showRichText = false;
        this.initReply = function () {
            _this.loading = true;
            _this.params.pagesize = _this.pagesize;
            _this.params.current = _this.current;
            __WEBPACK_IMPORTED_MODULE_8__apis__["a" /* default */].getAppInfoByID({ modeid: _this.params.modeId }).then(function (data) {
                if (data.status == "1") {
                    _this.iconInfo = {
                        icon: data.icon || "icon-coms-ModelingEngine",
                        iconColor: data.iconColor || "#fff",
                        iconBg: data.iconBg || "#96358a"
                    };
                }
            });
            __WEBPACK_IMPORTED_MODULE_3__apis_card__["J" /* initReply */](_this.params).then(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, props = __rest(_a, ["status", "errorCode", "error"]);
                if (status == '1') {
                    _this.update(_this.params);
                    _this.init(props);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("[" + (getLabel(127353, '错误') + errorCode) + "]:" + error);
                    //   throw api_errormsg;
                }
                _this.loading = false;
            });
        };
        this.update = function (param) {
            for (var key in param) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(_this, key, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(param, key));
            }
        };
        this.updateParams = function (params) {
            var temp = false;
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.params), params)) {
                temp = true;
            }
            _this.params = params;
            if (temp) {
                _this.initReply();
            }
        };
        this.reloadSearch = function (params) {
            _this.params = params;
            _this.initReply();
        };
        this.changeTab = function (key) {
            _this.selectedKey = key;
            _this.search({ replySearchtype: key });
        };
        this.quickSearch = function (e) {
            var keyCode = e.charCode || e.keyCode;
            if (keyCode == 13) {
                if (_this.condition.has('content')) {
                    _this.condition.$('content').set('value', e.target.value);
                }
                _this.doSearch({ content: e.target.value });
            }
        };
        this.showSearch = function () {
            _this.showSearchDrop = true;
        };
        this.hideSearch = function () {
            _this.showSearchDrop = false;
        };
        this.doSearch = function (params) {
            _this.loading = true;
            _this.hideSearch();
            var _params = __assign({ current: params.current ? params.current : 1, modeId: _this.modeId, formId: _this.formId, billid: _this.billid }, params, { replySearchtype: _this.selectedKey, replyposition: _this.replyposition, pagesize: _this.pagesize });
            if (params.isfromTab) {
                _params.isfromTab = params.isfromTab;
            }
            __WEBPACK_IMPORTED_MODULE_3__apis_card__["O" /* reply */](_params).then(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, props = __rest(_a, ["status", "errorCode", "error"]);
                if (status == '1') {
                    if (_this.replyAdd.okClickType != 'new' && _this.replyAdd.okClickType != 'quote') { //不等于新建或者引用
                        if (typeof (_this.getScrollTop) === 'function') {
                            _this.scrollTop = _this.getScrollTop();
                        }
                    }
                    _this.update(props);
                    if (typeof (_this.scrollBottom) === 'function') {
                        _this.scrollBottom();
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("[" + (getLabel(127353, '错误') + errorCode) + "]:" + error);
                    //   throw api_errormsg;
                }
                _this.loading = false;
            });
        };
        this.onPageChange = function (current, pageSize) {
            if (current === void 0) { current = _this.current; }
            if (pageSize === void 0) { pageSize = _this.pagesize; }
            _this.current = current;
            _this.pagesize = pageSize;
            _this.search({ replySearchtype: _this.selectedKey == '2' ? '2' : '' }, { current: current, pagesize: pageSize });
        };
        this.search = function (__, params) {
            if (params === void 0) { params = _this.params; }
            var _params = {};
            var values = _this.condition.values();
            var _loop_1 = function (key) {
                var keys = key.split('__');
                keys.forEach(function (k, index) {
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(_params, k, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(values, "" + key + (keys.length > 1 ? '[' + index + ']' : '')) || '');
                });
            };
            for (var key in values) {
                _loop_1(key);
            }
            if (_this.params.isfromTab) {
                _params.isfromTab = _this.params.isfromTab;
            }
            var p = __assign({}, params, _params);
            if (__.current) {
                p.current = __.current;
            }
            _this.searchContent = _this.condition.values().content ? _this.condition.values().content : "";
            _this.doSearch(p);
        };
        this.resetSearch = function () {
            __WEBPACK_IMPORTED_MODULE_9_jquery___default()(".ant-input").val("");
            _this.condition.resetConditionValue();
        };
        this.add = function () {
            _this.replyAdd.visible = true;
            _this.replyAdd.popup = false;
            _this.replyAdd.initContent({}, 'new');
        };
        this.edit = function (replyData) {
            _this.replyAdd.visible = true;
            _this.replyAdd.initContent(replyData, 'edit');
        };
        this.deleteItem = function (id) {
            for (var i = 0; i < _this.replyList.length; i++) { //删除这一个选项即可
                if (_this.replyList[i].id == id) {
                    _this.replyList.splice(i, 1);
                    break;
                }
            }
        };
        this.delete = function (replyData) {
            _this.loading = true;
            var id = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(replyData, 'id');
            __WEBPACK_IMPORTED_MODULE_3__apis_card__["g" /* deleteReply */]({
                id: id, modeId: _this.modeId, billid: _this.billid, formId: _this.formId
            }).then(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, msg = _a.message, messageType = _a.messageType;
                if (status == '1') {
                    if (messageType == '1') {
                        __WEBPACK_IMPORTED_MODULE_4_antd__["message"].success(msg);
                        if (_this.current == 1) { //第一页
                            if (_this.pagecount == 1) { //仅一页
                                _this.deleteItem(id);
                            }
                            else if (_this.replyList.length < 5) { //大于1页且当前少于5项目
                                _this.search({ replySearchtype: _this.selectedKey == '2' ? '2' : '' });
                            }
                            else {
                                _this.deleteItem(id);
                            }
                        }
                        else if (_this.current == _this.pagecount) { //最后一页
                            _this.deleteItem(id);
                        }
                        else {
                            _this.search({ replySearchtype: _this.selectedKey == '2' ? '2' : '' });
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error(msg);
                    }
                    _this.replyAdd.initContent({}, 'new'); //重新初始化为新建
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("[" + (getLabel(127353, '错误') + errorCode) + "]:" + error);
                }
                _this.loading = false;
            });
        };
        this.like = function (replyData) {
            _this.loading = true;
            var id = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(replyData, 'id');
            __WEBPACK_IMPORTED_MODULE_3__apis_card__["L" /* likeReply */]({
                id: id,
                modeId: _this.modeId,
                billid: _this.billid,
                formId: _this.formId,
                current: _this.current,
                pagesize: _this.pagesize
            }).then(function (_a) {
                var api_status = _a.api_status, api_errormsg = _a.api_errormsg, item = _a.item;
                if (api_status) {
                    _this.setReplyItem(item);
                    //this.search({replySearchtype: this.selectedKey == '2' ? '2' : ''})
                }
                else {
                    if (api_errormsg) {
                        __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].warning({
                            content: api_errormsg
                        });
                    }
                    // throw api_errormsg;
                }
                _this.loading = false;
            });
        };
        this.unlike = function (replyData) {
            _this.loading = true;
            var id = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(replyData, 'id');
            __WEBPACK_IMPORTED_MODULE_3__apis_card__["R" /* unlikeReply */]({
                id: id,
                modeId: _this.modeId,
                billid: _this.billid,
                formId: _this.formId,
                current: _this.current,
                pagesize: _this.pagesize
            }).then(function (_a) {
                var api_status = _a.api_status, api_errormsg = _a.api_errormsg, item = _a.item;
                if (api_status) {
                    _this.setReplyItem(item);
                    //this.search({replySearchtype: this.selectedKey == '2' ? '2' : ''})
                }
                else {
                    if (api_errormsg) {
                        __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].warning({
                            content: api_errormsg
                        });
                    }
                    // throw api_errormsg;
                }
                _this.loading = false;
            });
        };
        this.reference = function (replyData, offset, flag) {
            // this.replyAdd.visible = true;
            // this.replyAdd.initContent(replyData, 'quote');
            _this.replyAdd.isInitPopup = true;
            _this.replyAdd.popup = true;
            _this.replyAdd.initContent(replyData, 'quote');
            _this.replyAdd.popupOffset = offset;
            _this.replyAdd.popupArrowPostion = !!flag;
        };
        this.referenceRight = function (replyData) {
            _this.replyAdd.isInitPopup = true;
            _this.replyAdd.popup = true;
            _this.replyAdd.initContent(replyData, 'quote');
        };
        this.about = function (replyData, offset, flag) {
            _this.replyAdd.isInitPopup = true;
            _this.replyAdd.popup = true;
            _this.replyAdd.initContent(replyData, 'comment');
            _this.replyAdd.popupOffset = offset;
            _this.replyAdd.popupArrowPostion = !!flag;
        };
        this.aboutRight = function (replyData) {
            _this.replyAdd.isInitPopup = true;
            _this.replyAdd.popup = true;
            _this.replyAdd.initContent(replyData, 'comment');
        };
        this.loadNextPage = function () {
            _this.current = _this.current + 1;
            _this.replyposition = 2;
            _this.scrollTop = _this.getScrollTop();
            _this.onPageChange();
        };
        this.setReplyItem = function (item) {
            for (var i = 0; i < _this.replyList.length; i++) { //编辑时只要替换这一个选项即可
                if (_this.replyList[i].id == item.id) {
                    _this.replyList[i] = item;
                    break;
                }
            }
        };
        this.submitReply = function (params) {
            var content = params.replycontent.replace(/\u200B/g, '');
            var index = content.indexOf("#@split@#</span></p>");
            if (index != -1) {
                content = content.substring(index + "#@split@#</span></p>".length);
            }
            var tempcontent = content;
            if (tempcontent !== "") {
                tempcontent = tempcontent.replace("&nbsp;", "");
                tempcontent = tempcontent.replace("\n", "");
            }
            if (tempcontent.trim() === '' || tempcontent == "<p></p>") {
                __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("" + getLabel(33285, ' 评论的内容不能为空'));
                _this.replyAdd.loading = false;
                _this.replyAdd.popup = false;
                return;
            }
            else {
                //提交时，去掉光标特殊字符：&#8203;，否零宽字符会变成问号
                var Base64 = __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaTools"].Base64;
                content = Base64.encode(content);
                params.replycontent = content;
            }
            _this.loading = true;
            var _params = {
                reqModeId: _this.modeId,
                reqBillid: _this.billid,
                reqFormid: _this.formId,
                from: 'reply',
                src: 'submit',
                isFormMode: '1',
                layoutid: _this.replyModeInfo.layoutid,
                formId: _this.replyModeInfo.formid,
                modeId: _this.replyModeInfo.id,
                current: _this.current,
                pagesize: _this.pagesize,
            };
            __WEBPACK_IMPORTED_MODULE_3__apis_card__["P" /* replySubmit */](__assign({}, _params, params)).then(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, msg = _a.message, messageType = _a.messageType, item = _a.item;
                if (status == '1') {
                    if (messageType == '0') {
                        __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].error({
                            content: msg
                        });
                    }
                    else {
                        if (item && item.id && item.id > 0) {
                            _this.setReplyItem(item);
                        }
                        _this.search({ replySearchtype: _this.selectedKey == '2' ? '2' : '', current: _this.current });
                    }
                    _this.replyAdd.visible = false;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error("[" + (getLabel(127353, '错误') + errorCode) + "]:" + error);
                    //  throw api_errormsg;
                }
                _this.replyAdd.initContent({}, 'new'); //重新初始化为新建
                _this.loading = false;
                _this.replyAdd.loading = false;
                _this.replyAdd.popup = false;
            });
        };
        this.isShowAddReplyText = function (bool) {
            _this.showRichText = bool;
        };
        this.setFromTabInfo = function (bool) {
            if (bool) {
                _this.params.isfromTab = 1;
                _this.current = 1;
            }
            else {
                if (_this.params.isfromTab == 1) {
                    delete _this.params.isfromTab;
                }
            }
        };
        if (props) {
            this.init(props);
        }
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["autorun"])(function () {
            __WEBPACK_IMPORTED_MODULE_6__util__["default"].changeLoadingState && __WEBPACK_IMPORTED_MODULE_6__util__["default"].changeLoadingState(_this.loading);
            if (getParent().location.href.indexOf('/main/cube/card') > -1) {
                var parentWindow = getParent();
                parentWindow.changeLoadingState && parentWindow.changeLoadingState(_this.loading);
            }
        });
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "condition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "searchContent", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "showReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "replyposition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "scrollTop", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "replyModeInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "modeInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "replyList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "dateList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "replyData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "scrollBottom", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "getScrollTop", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "pagesize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "total", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "pagecount", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "current", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "isdefault", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "showbuttons", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "replyAdd", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "secretLevel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "tabDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "selectedKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "showSearchDrop", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyStore.prototype, "showRichText", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "initReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "reloadSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "changeTab", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "showSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "hideSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "doSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "onPageChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "resetSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "add", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "edit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "deleteItem", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "delete", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "like", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "unlike", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "reference", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "referenceRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "about", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "aboutRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "loadNextPage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "submitReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "isShowAddReplyText", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyStore.prototype, "setFromTabInfo", void 0);
    return ReplyStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (ReplyStore);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLayoutFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deal4ReplaceDatas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_excel_layout_cell_field_browser_element_Browser__ = __webpack_require__(87);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var getLayoutFields = function (fields1, card, newParams) {
    var _fields = [];
    var labels = {};
    var values = {};
    var rules = {};
    var placeholders = {};
    var uploadData = {};
    __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](fields1, function (field1, fieldName) {
        var formKey;
        if (field1.detail) { //明细表  detailtable之前用的这个参数判断的，取uf_httzgl_dt4 表的最后一个数字，现在走detail的id
            var detailOrderId = field1.detail.split('_')[1];
            var detail = "detail_" + detailOrderId;
            if (_fields.indexOf(detail) < 0) {
                _fields.push(detail);
                _fields.push(detail + "[]");
                _fields.push(detail + "[].checkbox");
                _fields.push(detail + "[].dtl_index");
                _fields.push(detail + "[].dtl_id");
                _fields.push("deldtlid" + detailOrderId);
            }
            formKey = detail + "[]." + fieldName;
        }
        else { //主表
            formKey = fieldName;
            if (field1.replaceDatas && __WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"](field1.replaceDatas)) {
                var obj = deal4ReplaceDatas(field1.replaceDatas, field1.fieldtype);
                if (field1.fieldtype == '17') { //多人力
                    obj.value = field1.value;
                }
                __WEBPACK_IMPORTED_MODULE_0_lodash__["set"](values, formKey, obj);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_0_lodash__["set"](values, formKey, field1.value || '');
            }
            if (field1.uploadData) {
                __WEBPACK_IMPORTED_MODULE_0_lodash__["set"](uploadData, formKey, field1.uploadData);
            }
            // 解决#608436 当选择框字段作为标题时，应该显示showname，而非选项的key值
            if (field1.fieldhtmltype === '5' && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNumber"](Number(field1.value)) && field1.value) {
                // let options: any = field1.options;
                // let obj = {
                //     value: field1.value,
                //     valueSpan: options[Number(field1.value)]&&options[Number(field1.value)].showname||'',
                // }
                // _.set(values, formKey, {...obj, valueObj: obj});
                //#775361 概述：解决了模块基础，页面标题设置复选框字段，当卡片页面选择多个值的时候，值不解析的问题
                var options_1 = field1.options;
                var valueArr = field1.value.split(',');
                var valueSpan_1 = [];
                __WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"](valueArr, function (item) {
                    var have = false;
                    //#873149选择框的选项值和options下标不一定一致，需要通过key来判断
                    __WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"](options_1, function (option) {
                        if (option.key == Number(item)) {
                            valueSpan_1.push(option.showname);
                            have = true;
                        }
                    });
                    if (!have) {
                        valueSpan_1.push('');
                    }
                });
                var obj = {
                    value: field1.value,
                    valueSpan: valueSpan_1.join(','),
                };
                __WEBPACK_IMPORTED_MODULE_0_lodash__["set"](values, formKey, __assign({}, obj, { valueObj: obj }));
            }
        }
        _fields.push(formKey);
        __WEBPACK_IMPORTED_MODULE_0_lodash__["set"](labels, formKey, field1.fieldlabel);
        __WEBPACK_IMPORTED_MODULE_0_lodash__["set"](placeholders, formKey, field1.placeholder);
    });
    try {
        //qc608226概述：表单建模，明细表单，布局中选择了标题没有选择值，卡片页面显示空白
        var etables = newParams['datajson'].eformdesign.etables;
        __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](etables, function (value, key) {
            if (key.indexOf("detail_") > -1) {
                var detailOrderId = key.split('_')[1];
                var detail = "detail_" + detailOrderId;
                if (_fields.indexOf(detail) < 0) {
                    _fields.push(detail);
                    _fields.push(detail + "[]");
                    _fields.push(detail + "[].checkbox");
                    _fields.push(detail + "[].dtl_index");
                    _fields.push(detail + "[].dtl_id");
                    _fields.push("deldtlid" + detailOrderId);
                }
            }
        });
    }
    catch (e) { }
    var form = new __WEBPACK_IMPORTED_MODULE_1__form__["a" /* default */](card, {
        fields: _fields,
        rules: rules,
        labels: labels, placeholders: placeholders
    });
    form.updateValues(values, fields1);
    form.setUploadData(uploadData);
    form.isInit = true;
    return form;
};
var deal4ReplaceDatas = function (replaceDatas, fieldtype) {
    if (fieldtype == '141') {
        var props = replaceDatas.map(function (d) { return d.prop; });
        return {
            value: Object(__WEBPACK_IMPORTED_MODULE_2__components_excel_layout_cell_field_browser_element_Browser__["b" /* spellResourceCondition */])(props),
            valueObj: props
        };
    }
    else {
        return {
            value: replaceDatas.map(function (d) { return d.id || d.randomFieldId; }).join(","),
            valueSpan: replaceDatas.map(function (d) { return d.name || d.lastname; }).join(","),
            valueObj: replaceDatas
        };
    }
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(291);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(189),
    eq = __webpack_require__(94);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(292);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(95);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(592),
    mapCacheDelete = __webpack_require__(604),
    mapCacheGet = __webpack_require__(606),
    mapCacheHas = __webpack_require__(607),
    mapCacheSet = __webpack_require__(608);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(296),
    isObject = __webpack_require__(23),
    isSymbol = __webpack_require__(95);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(303);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(305);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 197 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(624),
    shortOut = __webpack_require__(310);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(128),
    baseLodash = __webpack_require__(202);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsDate = __webpack_require__(652),
    baseUnary = __webpack_require__(61),
    nodeUtil = __webpack_require__(100);

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(653),
    keys = __webpack_require__(46);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(656),
    isObjectLike = __webpack_require__(24);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 208 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(333),
    stubArray = __webpack_require__(334);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(208),
    isFlattenable = __webpack_require__(672);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(332),
    getSymbolsIn = __webpack_require__(347),
    keysIn = __webpack_require__(76);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(60),
    castSlice = __webpack_require__(143),
    charsStartIndex = __webpack_require__(342),
    stringToArray = __webpack_require__(144),
    toString = __webpack_require__(37);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      start = charsStartIndex(strSymbols, stringToArray(chars));

  return castSlice(strSymbols, start).join('');
}

module.exports = trimStart;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResourcesInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);

var getResourcesInfo = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi("/api/cube/resource/resourceView", "get", params);
};
var getCurrentDate = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi("/api/cube/resource/getCurrentDate", "get", params);
};


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SingleShareDialog", function() { return SingleShareDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_index_css__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_index_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var FormItem = __WEBPACK_IMPORTED_MODULE_1_antd__["Form"].Item;
var InputGroup = __WEBPACK_IMPORTED_MODULE_1_antd__["Input"].Group;
var confirm = __WEBPACK_IMPORTED_MODULE_1_antd__["Modal"].confirm;
var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var SingleShare = /** @class */ (function (_super) {
    __extends(SingleShare, _super);
    function SingleShare(props) {
        var _this = _super.call(this, props) || this;
        _this.refObj = {};
        _this.remderShareType = function (text, record, _) {
            if (record.islink) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                    record.typeTopStr,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: record.typeHrefStr, target: "_blank" }, record.typeTitleStr),
                    record.typeEndStr));
            }
            else {
                return text;
            }
        };
        _this.changeSelect = function (field, value) {
            var shareData = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.extend(true, {}, _this.state.shareData);
            shareData[field] = value;
            if (field == "rolefieldtype") {
                shareData.rolefieldvlaue = "";
                shareData.rolefield = "";
            }
            _this.setState({ shareData: shareData });
        };
        _this.changeBrowserField = function (field, ids, _, datas) {
            var shareData = _this.state.shareData;
            shareData[field] = datas;
            shareData[field + "value"] = ids;
            _this.setState({ shareData: shareData });
        };
        _this.changeLevel = function (field, value) {
            var shareData = _this.state.shareData;
            shareData[field] = value;
            _this.setState({ shareData: shareData });
        };
        _this.getShareTypeOptions = function () {
            var _a = _this.state, shareData = _a.shareData, appDetachDisableAll = _a.appDetachDisableAll;
            var options = [
                { key: "1", selected: shareData.shareType == "1" || !shareData.shareType, showname: getLabel(1867, "人员") },
                { key: "2", selected: shareData.shareType == "2", showname: getLabel(141, "分部") },
                { key: "3", selected: shareData.shareType == "3", showname: getLabel(124, "部门") },
                { key: "4", selected: shareData.shareType == "4", showname: getLabel(122, "角色") },
                { key: "5", selected: shareData.shareType == "5", showname: getLabel(1340, "所有人") },
                { key: "6", selected: shareData.shareType == "6", showname: getLabel(6086, "岗位") }
            ];
            if (appDetachDisableAll) { //禁用所有人
                options.splice(4, 1);
            }
            return options;
        };
        _this.getShareTypeOptionsForRole = function () {
            console;
            var _a = _this.state, shareData = _a.shareData, shareFieldMap = _a.shareFieldMap;
            var options = [];
            if (shareData.rolefieldtype == "1" || !shareData.rolefieldtype) {
                options = shareFieldMap && shareFieldMap.optionListForHrm;
            }
            else if (shareData.rolefieldtype == "2") {
                options = shareFieldMap && shareFieldMap.optionListForDep;
            }
            else if (shareData.rolefieldtype == "3") {
                options = shareFieldMap && shareFieldMap.optionListForSub;
            }
            return options;
        };
        _this.getRowSelection = function () {
            var _a = _this.state, columns = _a.columns, selectedRowKeys = _a.selectedRowKeys;
            if (!(columns + " "))
                return null;
            var _b = _this.props, defaultShared = _b.defaultShared, nonDefaultShared = _b.nonDefaultShared;
            var rowSelection = {
                selectedRowKeys: selectedRowKeys,
                onChange: function (sRowKeys, _) {
                    _this.setState({ selectedRowKeys: sRowKeys });
                },
                getCheckboxProps: function (record) {
                    return {
                        disabled: record.isdefault == '1' ? !(defaultShared && record.candel) : !nonDefaultShared,
                    };
                }
            };
            return rowSelection;
        };
        //btns
        _this.doAdd = function () {
            _this.setState({ _visible: true });
        };
        _this.doDelete = function () {
            var selectedRowKeys = _this.state.selectedRowKeys;
            var _a = _this.props, billid = _a.billid, formId = _a.formId, modeId = _a.modeId;
            if (selectedRowKeys.length == 0) {
                __WEBPACK_IMPORTED_MODULE_1_antd__["Modal"].info({
                    title: getLabel(15172, '系统提示'),
                    content: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, getLabel(31251, '请先选择需要删除的权限项！')))),
                    onOk: function () { },
                });
            }
            else {
                confirm({
                    title: getLabel(31250, '确认需要删除这些共享吗？'),
                    onOk: function () {
                        __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].callApi('/api/formmode/card/shareDataDel', 'POST', { billid: billid, formId: formId, modeId: modeId, delid: selectedRowKeys }).then(function (datas) {
                            var shareDataList = datas.shareDataList;
                            _this.setState({ shareDataList: shareDataList, _visible: false, selectedRowKeys: [] });
                        });
                    },
                    onCancel: function () { },
                });
            }
        };
        _this.onCancel = function () {
            _this.props.onClose();
        };
        _this._onOk = function () {
            var shareData = _this.state.shareData;
            var _a = _this.props, billid = _a.billid, formId = _a.formId, modeId = _a.modeId;
            if (_this.checkSubmit()) {
                var shareType = shareData.shareType ? shareData.shareType : "1";
                shareData.relatedid = shareData["relatedid" + shareType + "value"];
                if (shareType == "4" && shareData.isRoleLimited == "1") {
                    //shareData.rolefield = shareData.rolefieldvalue;
                    var parm = { billid: billid, formId: formId, modeId: modeId, role: shareData.relatedid4value, rolefieldtype: shareData.rolefieldtype, rolefield: shareData.rolefield, rolelevel: shareData.rolelevel, showlevel: shareData.showlevel, showlevel2: shareData.showlevel2 ? shareData.showlevel2 : "" };
                    __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].callApi('/api/formmode/card/checkShareRole', 'POST', parm).then(function (datas) {
                        var canadd = datas.canadd;
                        if (canadd) {
                            __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].callApi('/api/formmode/card/shareData', 'POST', __assign({ billid: billid, formId: formId, modeId: modeId }, shareData)).then(function (datas) {
                                var shareDataList = datas.shareDataList;
                                _this.setState({ shareDataList: shareDataList, _visible: false, shareData: { HrmCompanyVirtual: "0", shareType: "1", rightType: "1", isRoleLimited: "0", rolelevel: "0", showlevel: "0", joblevel: "3", rolefieldtype: "1" }, });
                            });
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_1_antd__["message"].warning(getLabel(82469, '按照你的限制条件，在角色中没有满足条件的人员！'), 5);
                        }
                    });
                }
                else {
                    if (shareType == "6") {
                        if (shareData.joblevel == "0") {
                            shareData.jobleveltext = shareData.jobleveltext1value;
                        }
                        else if (shareData.joblevel == "1") {
                            shareData.jobleveltext = shareData.jobleveltext0value;
                        }
                    }
                    __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].callApi('/api/formmode/card/shareData', 'POST', __assign({ billid: billid, formId: formId, modeId: modeId }, shareData)).then(function (datas) {
                        var shareDataList = datas.shareDataList;
                        _this.setState({ shareDataList: shareDataList, _visible: false, shareData: { HrmCompanyVirtual: "0", shareType: "1", rightType: "1", isRoleLimited: "0", rolelevel: "0", showlevel: "0", joblevel: "2", rolefieldtype: "1" }, });
                    });
                }
            }
        };
        _this.checkSubmit = function () {
            var shareData = _this.state.shareData;
            var shareType = shareData.shareType ? shareData.shareType : "1";
            var showlevel = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(shareData.showlevel);
            if (shareType == "1") {
                var relatedid1value = shareData.relatedid1value;
                if (!relatedid1value) {
                    _this.showError('relatedid1');
                }
                return relatedid1value;
            }
            else if (shareType == "2") {
                var relatedid2value = shareData.relatedid2value;
                if (!relatedid2value) {
                    _this.showError('relatedid2');
                }
                else if (!showlevel) {
                    _this.showError('showlevel');
                }
                return relatedid2value && showlevel;
            }
            else if (shareType == "3") {
                var relatedid3value = shareData.relatedid3value;
                if (!relatedid3value) {
                    _this.showError('relatedid3');
                }
                else if (!showlevel) {
                    _this.showError('showlevel');
                }
                return relatedid3value && showlevel;
            }
            else if (shareType == "4") {
                var relatedid4value = shareData.relatedid4value;
                if (shareData.isRoleLimited == "1") {
                    if (!relatedid4value) {
                        _this.showError('relatedid4');
                    }
                    else if (!showlevel) {
                        _this.showError('showlevel');
                    }
                    else if (!shareData.rolefield) {
                        _this.showError('rolefield');
                    }
                    return relatedid4value && showlevel && shareData.rolefield && shareData.rolefieldtype;
                }
                else {
                    if (!relatedid4value) {
                        _this.showError('relatedid4');
                    }
                    else if (!showlevel) {
                        _this.showError('showlevel');
                    }
                    return relatedid4value && showlevel;
                }
            }
            else if (shareType == "5") {
                if (!showlevel) {
                    _this.showError('showlevel');
                }
                return showlevel;
            }
            else if (shareType == "6") {
                var relatedid6value = shareData.relatedid6value;
                var joblevel = shareData.joblevel;
                if (joblevel == "0") {
                    var jobleveltext1 = shareData.jobleveltext1;
                    if (!relatedid6value) {
                        _this.showError('relatedid6');
                    }
                    else if (!showlevel) {
                        _this.showError('showlevel');
                    }
                    else if (!jobleveltext1) {
                        _this.showError('jobleveltext1');
                    }
                    return relatedid6value && showlevel && jobleveltext1;
                }
                else if (joblevel == "1") {
                    var jobleveltext0 = shareData.jobleveltext0;
                    if (!relatedid6value) {
                        _this.showError('relatedid6');
                    }
                    else if (!showlevel) {
                        _this.showError('showlevel');
                    }
                    else if (!jobleveltext0) {
                        _this.showError('jobleveltext0');
                    }
                    return relatedid6value && showlevel && jobleveltext0;
                }
                else {
                    if (!relatedid6value) {
                        _this.showError('relatedid6');
                    }
                    else if (!showlevel) {
                        _this.showError('showlevel');
                    }
                    return relatedid6value && showlevel;
                }
            }
        };
        _this.showError = function (key) {
            var domkeyRef = _this.refObj[key];
            domkeyRef.showError();
            return false;
        };
        _this._onCancel = function () {
            _this.setState({ _visible: false });
        };
        _this.state = {
            labels: {},
            columns: [],
            shareData: { HrmCompanyVirtual: "0", shareType: "1", rightType: "1", isRoleLimited: "0", rolelevel: "0", showlevel: "0", joblevel: "2", rolefieldtype: "1" },
            selectedRowKeys: [],
            pageSize: 10,
            _visible: false,
            addData: {},
            addDataInit: {},
            seclevelMin: 0,
            seclevelMax: 100,
            shareDataList: [],
            shareFieldMap: {},
            appDetachDisableAll: false,
            maxShare: 0,
        };
        return _this;
    }
    SingleShare.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, billid = _a.billid, formId = _a.formId, modeId = _a.modeId, type = _a.type;
        //初始化数据
        __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].callApi('/api/formmode/card/getShareData', 'POST', { billid: billid, formId: formId, modeId: modeId, type: type }).then(function (datas) {
            var shareDataList = datas.shareDataList, appDetachDisableAll = datas.appDetachDisableAll, shareFieldMap = datas.shareFieldMap;
            _this.setState({ shareDataList: shareDataList, appDetachDisableAll: appDetachDisableAll, shareFieldMap: shareFieldMap });
        });
        //获取当前操作人的最大操作权限
        __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].callApi('/api/formmode/card/right', 'POST', { billid: billid, formId: formId, modeId: modeId, type: type }).then(function (datas) {
            var MaxShare = datas.MaxShare;
            _this.setState({ maxShare: MaxShare });
        });
        //获取当前表单数据的密级信息
        __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].callApi('/api/cube/mode/mode/getBillSecInfo', 'POST', { billid: billid, formId: formId, modeId: modeId }).then(function (datas) {
            var seclevel = datas.seclevel;
            _this.setState({ seclevel: seclevel });
        });
    };
    SingleShare.prototype.render = function () {
        var _a = this.props, _b = _a.visible, visible = _b === void 0 ? false : _b, defaultShared = _a.defaultShared, nonDefaultShared = _a.nonDefaultShared, _c = _a.iconInfo, iconInfo = _c === void 0 ? {} : _c;
        var _d = this.state, _visible = _d._visible, selectedRowKeys = _d.selectedRowKeys, shareDataList = _d.shareDataList;
        // console.log("=============="+this.state.seclevel);
        var buttons = []; //底部按钮预留 
        var _buttons = [
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@ta0fed@_onOk", key: "submit", type: "primary", size: "large", onClick: this._onOk }, getLabel(86, '保存')),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@7dops2@_onCancel", key: "back", type: "ghost", size: "large", onClick: this._onCancel }, getLabel(201, "取消"))
        ];
        var columns = [{
                title: getLabel(31248, '共享来源'),
                dataIndex: 'source',
                width: 90
            }, {
                title: getLabel(18495, '共享类型'),
                dataIndex: 'type',
                render: this.remderShareType,
                width: 250
            }, {
                title: getLabel(3005, '共享级别'),
                dataIndex: 'level',
                width: 250,
                render: function (_, record) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: record.level } })); }
            }, {
                title: getLabel(19117, '共享对象'),
                dataIndex: 'object',
                render: function (_, record) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { maxWidth: "300px" }, dangerouslySetInnerHTML: { __html: record.relatedShareNames } })); }
            }, {
                title: getLabel(385, '权限'),
                dataIndex: 'right',
                width: 90
            }];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'wea-mode-share' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@3mwr5h", className: 'wea-hr-muti-input wea-cube-muti-input', buttons: buttons, title: this.getTitle(), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: visible, style: { width: 900, height: 500 }, hasScroll: true, onCancel: this.onCancel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'wea-table-edit wea-mode-share-table', style: { height: 460 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@iemab0", className: "wea-table-edit-title" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@eak5y2" },
                            getLabel(26137, '共享权限'),
                            (nonDefaultShared || defaultShared) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Button@ihekio", type: "primary", disabled: !("" + selectedRowKeys) }, { title: getLabel(91, "删除") }, { size: "small", onClick: this.doDelete.bind(this, selectedRowKeys) }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-form-delete-hot" })),
                            nonDefaultShared && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Button@cspgdk", type: "primary" }, { title: getLabel(1421, '新增') }, { size: "small", onClick: this.doAdd }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-Add-to-hot" })))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Table"], { ecId: (this && this.props && this.props.ecId || '') + "_Table@0jmyod", columns: columns, dataSource: shareDataList, pagination: false, rowSelection: this.getRowSelection(), scroll: { y: 372 } })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@q0l4et", className: 'wea-hr-muti-input', buttons: _buttons, title: this.getTitle(true), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: _visible, style: { width: 650, height: 350 }, hasScroll: true, onCancel: this._onCancel }, this.getAddComponent()))));
    };
    SingleShare.prototype.getAddComponent = function () {
        var _this = this;
        var shareData = this.state.shareData;
        var _a = this.state, maxShare = _a.maxShare, seclevel = _a.seclevel;
        var shareType = shareData.shareType ? shareData.shareType : "1";
        var style = { marginBottom: 10 };
        var roleDataParams = {};
        if (shareData.isRoleLimited == "1") {
            var rolefieldtype = shareData.rolefieldtype;
            roleDataParams.formId = this.props.formId;
            roleDataParams.modeId = this.props.modeId;
            roleDataParams.fieldHtmlType = "3";
            roleDataParams.isRoleLimited = "1";
            roleDataParams.rolefieldtype = rolefieldtype ? rolefieldtype : "1";
            roleDataParams.fieldType = rolefieldtype == "3" ? "170,169,164,194" : (rolefieldtype == "2" ? "168,167,57,4" : "166,165,17,1");
        }
        var shareOptions = [
            { key: "1", selected: shareData.rightType == "1" || !shareData.rightType, showname: getLabel(367, "查看") },
        ];
        if (maxShare > 1) {
            shareOptions.push({ key: "2", selected: shareData.rightType == "2", showname: getLabel(93, "编辑") });
            if (maxShare > 2) {
                shareOptions.push({ key: "3", selected: shareData.rightType == "3", showname: getLabel(17874, "完全控制") });
            }
        }
        var options = this.getShareTypeOptions();
        var optionsForRole = this.getShareTypeOptionsForRole();
        var otherparam = { "secretLevel": seclevel };
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Form"], { ecId: (this && this.props && this.props.ecId || '') + "_Form@an2exf" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@1c3xpv", style: style, label: getLabel(18495, "共享类型"), labelCol: { span: 6 }, wrapperCol: { span: 12 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: "left" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@0l6lma", fieldName: "shareType", options: options, value: shareData.shareType, style: { width: "100px" }, onChange: function (vlaue) { _this.changeSelect("shareType", vlaue); } })),
                    (shareType == "2" || shareType == "3") &&
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { position: "absolute", left: "120px" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@wvhnx4", fieldName: "orgrelation", options: [
                                    { key: "0", selected: shareData.orgrelation == "0" || !shareData.orgrelation, showname: "" },
                                    { key: "1", selected: shareData.orgrelation == "1", showname: getLabel(15762, "所有上级") },
                                    { key: "2", selected: shareData.orgrelation == "2", showname: getLabel(15765, "所有下级") }
                                ], value: shareData.orgrelation, style: { width: "100px" }, onChange: function (vlaue) { _this.changeSelect("orgrelation", vlaue); } }))),
                shareType == "1" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@o1hxz9", style: style, label: getLabel(172, "选择"), labelCol: { span: 6 }, wrapperCol: { span: 10 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@0osxwu", tipPosition: 'bottom', error: getLabel(172, "选择") + getLabel(1867, "人员") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) { _this.refObj["relatedid1"] = ref; } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@239e4x", type: "17", title: getLabel(1867, "人员"), fieldName: "relatedid1", viewAttr: "3", isSingle: false, replaceDatas: shareData.relatedid1 ? shareData.relatedid1 : new Array(), dataParams: otherparam, onChange: function (ids, names, datas) { _this.changeBrowserField("relatedid1", ids, names, datas); } }))),
                shareType == "2" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@wi71hr", style: style, label: getLabel(172, "选择"), labelCol: { span: 6 }, wrapperCol: { span: 10 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@sc5vfd", tipPosition: 'bottom', error: getLabel(172, "选择") + getLabel(141, "分部") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) { _this.refObj["relatedid2"] = ref; } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@pdn40m", type: "194", title: getLabel(141, "分部"), fieldName: "relatedid2", viewAttr: "3", isSingle: false, replaceDatas: shareData.relatedid2 ? shareData.relatedid2 : new Array(), onChange: function (ids, names, datas) { _this.changeBrowserField("relatedid2", ids, names, datas); } }))),
                shareType == "3" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@nx727b", style: style, label: getLabel(172, "选择"), labelCol: { span: 6 }, wrapperCol: { span: 10 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@h0epus", tipPosition: 'bottom', error: getLabel(172, "选择") + getLabel(124, "部门") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) { _this.refObj["relatedid3"] = ref; } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@1c3jvm", type: "57", title: getLabel(124, "部门"), fieldName: "relatedid3", viewAttr: "3", isSingle: false, replaceDatas: shareData.relatedid3 ? shareData.relatedid3 : new Array(), onChange: function (ids, names, datas) { _this.changeBrowserField("relatedid3", ids, names, datas); } }))),
                shareType == "4" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@mwrjy4", style: style, label: getLabel(172, "选择"), labelCol: { span: 6 }, wrapperCol: { span: 10 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@hhzr1o", tipPosition: 'bottom', error: getLabel(172, "选择") + getLabel(122, "角色") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) { _this.refObj["relatedid4"] = ref; } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@y2pjy9", type: "65", title: getLabel(122, "角色"), fieldName: "relatedid4", viewAttr: "3", isSingle: false, replaceDatas: shareData.relatedid4 ? shareData.relatedid4 : new Array(), onChange: function (ids, names, datas) { _this.changeBrowserField("relatedid4", ids, names, datas); } }))),
                shareType == "6" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@90p6ds", style: style, label: getLabel(172, "选择"), labelCol: { span: 6 }, wrapperCol: { span: 10 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@qqo8z6", tipPosition: 'bottom', error: getLabel(172, "选择") + getLabel(6086, "岗位") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) { _this.refObj["relatedid6"] = ref; } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@ibhf30", type: "278", title: getLabel(6086, "岗位"), fieldName: "relatedid6", viewAttr: "3", isSingle: false, replaceDatas: shareData.relatedid6 ? shareData.relatedid6 : new Array(), onChange: function (ids, names, datas) { _this.changeBrowserField("relatedid6", ids, names, datas); } }))),
                shareType == "4" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@mud6ll", style: style, label: getLabel(82385, '角色是否受范围限制'), labelCol: { span: 6 }, wrapperCol: { span: 6 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@mbuzkp", fieldName: "isRoleLimited", options: [
                            { key: "0", selected: shareData.isRoleLimited == "0" || !shareData.isRoleLimited, showname: getLabel(161, "否") },
                            { key: "1", selected: shareData.isRoleLimited == "1", showname: getLabel(163, "是") }
                        ], value: shareData.isRoleLimited, style: { width: "100px" }, onChange: function (vlaue) { _this.changeSelect("isRoleLimited", vlaue); } })),
                shareType == "4" && shareData.isRoleLimited == "1" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@2xhlfe", style: style, label: getLabel(686, "字段类型"), labelCol: { span: 6 }, wrapperCol: { span: 16 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, { ecId: (this && this.props && this.props.ecId || '') + "_InputGroup@l8pofb" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@2qccnw", span: 5 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@puyngd", fieldName: "rolefieldtype", options: [
                                    { key: "1", selected: shareData.rolefieldtype == "1" || !shareData.rolefieldtype, showname: getLabel(1867, "人员") },
                                    { key: "2", selected: shareData.rolefieldtype == "2", showname: getLabel(124, "部门") },
                                    { key: "3", selected: shareData.rolefieldtype == "3", showname: getLabel(141, "分部") }
                                ], value: shareData.rolefieldtype, 
                                //style={{ width: "50%" }}
                                onChange: function (vlaue) { _this.changeSelect("rolefieldtype", vlaue); } })))),
                shareType == "4" && shareData.isRoleLimited == "1" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@3ux9ma", style: style, label: getLabel(82386, "限制字段"), labelCol: { span: 6 }, wrapperCol: { span: 16 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, { ecId: (this && this.props && this.props.ecId || '') + "_InputGroup@i1hsma" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@3pw7f2", span: 10 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@j1dlgi", tipPosition: 'bottom', error: getLabel(82386, "限制字段") + getLabel(21423, "未填写"), style: { width: "200px" }, ref: function (ref) { _this.refObj["rolefield"] = ref; } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@bidrvh", fieldName: "rolefield", options: optionsForRole, value: shareData.rolefield, viewAttr: "3", style: { width: "100%" }, onChange: function (vlaue) { _this.changeSelect("rolefield", vlaue); } }))))),
                shareType == "4" && shareData.isRoleLimited == '0' && (shareData.rolefieldtype == '2' || shareData.rolefieldtype == '3') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@nvw10v", style: style, label: getLabel(3005, "共享级别"), labelCol: { span: 6 }, wrapperCol: { span: 6 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@ypsiv9", fieldName: "rolelevel", options: [
                            { key: "0", selected: shareData.rolelevel == "0" || !shareData.rolelevel, showname: getLabel(124, "部门") },
                            { key: "1", selected: shareData.rolelevel == "1", showname: getLabel(141, "分部") },
                            { key: "2", selected: shareData.rolelevel == "2", showname: getLabel(140, "总部") },
                        ], value: shareData.rolelevel, style: { width: "100px" }, onChange: function (vlaue) { _this.changeSelect("rolelevel", vlaue); } })),
                shareType == "4" && shareData.rolefieldtype == '1' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@tk9arl", style: style, label: getLabel(3005, "共享级别"), labelCol: { span: 6 }, wrapperCol: { span: 6 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@yfvcx0", fieldName: "rolelevel", options: [
                            { key: "0", selected: shareData.rolelevel == "0" || !shareData.rolelevel, showname: getLabel(124, "部门") },
                            { key: "1", selected: shareData.rolelevel == "1", showname: getLabel(141, "分部") },
                            { key: "2", selected: shareData.rolelevel == "2", showname: getLabel(140, "总部") },
                        ], value: shareData.rolelevel, style: { width: "100px" }, onChange: function (vlaue) { _this.changeSelect("rolelevel", vlaue); } })),
                shareType == "6" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@qk20m4", style: style, label: getLabel(28169, "岗位级别"), labelCol: { span: 6 }, wrapperCol: { span: 16 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, { ecId: (this && this.props && this.props.ecId || '') + "_InputGroup@kpqyuq" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@pr71fd", span: 5 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@d3kd71", fieldName: "joblevel", options: [
                                    { key: "0", selected: shareData.joblevel == "0", showname: getLabel(19438, "指定部门") },
                                    { key: "1", selected: shareData.joblevel == "1", showname: getLabel(19437, "指定分部") },
                                    { key: "2", selected: shareData.joblevel == "2" || !shareData.joblevel, showname: getLabel(140, "总部") },
                                ], value: shareData.joblevel, 
                                //style={{ width: "50%" }}
                                onChange: function (vlaue) { _this.changeSelect("joblevel", vlaue); } })))),
                shareType == "6" && (shareData.joblevel == "0" || shareData.joblevel == "1") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@dx1ppa", style: style, label: shareData.joblevel == "0" ? getLabel(19438, "指定部门") : getLabel(19437, "指定分部"), labelCol: { span: 6 }, wrapperCol: { span: 16 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, { ecId: (this && this.props && this.props.ecId || '') + "_InputGroup@n4g7c5" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@jazvyi", span: 5 },
                            shareData.joblevel == "0" &&
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@gxkihp", tipPosition: 'bottom', error: getLabel(124, "部门") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) { _this.refObj["jobleveltext1"] = ref; } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@bdvw9n", className: "wea-cube-muti-browser-com", type: "57", title: getLabel(124, "部门"), fieldName: "jobleveltext1", viewAttr: "3", isSingle: false, replaceDatas: shareData.jobleveltext1 ? shareData.jobleveltext1 : new Array(), onChange: function (ids, names, datas) { _this.changeBrowserField("jobleveltext1", ids, names, datas); } })),
                            shareData.joblevel == "1" &&
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@qaucqq", tipPosition: 'bottom', error: getLabel(141, "分部") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) { _this.refObj["jobleveltext0"] = ref; } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@7mn4fb", className: "wea-cube-muti-browser-com", type: "194", title: getLabel(141, "分部"), fieldName: "jobleveltext0", viewAttr: "3", isSingle: false, replaceDatas: shareData.jobleveltext0 ? shareData.jobleveltext0 : new Array(), onChange: function (ids, names, datas) { _this.changeBrowserField("jobleveltext0", ids, names, datas); } }))))),
                shareType && shareType != "1" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@r6do6n", style: style, label: getLabel(683, "安全级别"), labelCol: { span: 6 }, wrapperCol: { span: 12 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, { ecId: (this && this.props && this.props.ecId || '') + "_InputGroup@fi9hqz" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@usmnug", span: 8 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@th8yqu", tipPosition: 'bottom', error: getLabel(683, "安全级别") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) { _this.refObj["showlevel"] = ref; } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaInputNumber"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputNumber@2qj58u", onChange: function (v) { _this.changeLevel("showlevel", v); }, value: shareData.showlevel ? shareData.showlevel : "", id: "showlevel", fieldName: "showlevel", name: "showlevel", viewAttr: "3" }))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@hnb2zw", span: 2 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "ant-form-split" }, "-")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@bsrgqi", span: 8 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaInputNumber"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputNumber@18uksc", onChange: function (v) { _this.changeLevel("showlevel2", v); }, value: shareData.showlevel2 ? shareData.showlevel2 : "", id: "showlevel2", fieldName: "showlevel2", name: "showlevel2" })))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormItem, { ecId: (this && this.props && this.props.ecId || '') + "_FormItem@xrgrew", style: __assign({ marginTop: -5 }, style), label: getLabel(440, "权限项"), labelCol: { span: 6 }, wrapperCol: { span: 6 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@i9t9mz", fieldName: "rightType", options: shareOptions, value: shareData.rightType, style: { width: "100px" }, onChange: function (vlaue) { _this.changeSelect("rightType", vlaue); } })))));
    };
    SingleShare.prototype.getTitle = function (bool) {
        var _a = this.props.title, title = _a === void 0 ? getLabel(119, '共享') : _a;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-hr-muti-input-title" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { verticalAlign: 'middle' } }, bool ? getLabel(18645, '添加共享') : title)));
    };
    return SingleShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (SingleShare);
var SingleShareDialog = /** @class */ (function (_super) {
    __extends(SingleShareDialog, _super);
    function SingleShareDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleShareDialog.prototype.render = function () {
        var share = this.props.share;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, share.singleVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SingleShare, __assign({ ecId: (this && this.props && this.props.ecId || '') + "_SingleShare@29jv2z" }, this.props, { billid: share.billid, visible: share.singleVisible, onClose: share.closeSingle }))));
    };
    SingleShareDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"]
    ], SingleShareDialog);
    return SingleShareDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(840),
    getValue = __webpack_require__(846);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(104),
    isObject = __webpack_require__(64);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(366);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(221),
    isLength = __webpack_require__(370);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(360);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(104),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_omit_js__ = __webpack_require__(154);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyDown = function (e) {
            var _a = _this.props, onPressEnter = _a.onPressEnter, onKeyDown = _a.onKeyDown;
            if (e.keyCode === 13 && onPressEnter) {
                onPressEnter(e);
            }
            if (onKeyDown) {
                onKeyDown(e);
            }
        };
        _this.saveInput = function (node) {
            _this.input = node;
        };
        return _this;
    }
    Input.prototype.focus = function () {
        this.input.focus();
    };
    Input.prototype.blur = function () {
        this.input.blur();
    };
    Input.prototype.getInputClassName = function () {
        var _a;
        var _b = this.props, prefixCls = _b.prefixCls, size = _b.size, disabled = _b.disabled;
        return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls, (_a = {},
            _a[prefixCls + "-sm"] = size === 'small',
            _a[prefixCls + "-lg"] = size === 'large',
            _a[prefixCls + "-disabled"] = disabled,
            _a));
    };
    Input.prototype.renderLabeledInput = function (children) {
        var _a, _b;
        var props = this.props;
        // Not wrap when there is not addons
        if ((!props.addonBefore && !props.addonAfter)) {
            return children;
        }
        var wrapperClassName = props.prefixCls + "-group";
        var addonClassName = wrapperClassName + "-addon";
        var addonBefore = props.addonBefore ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: addonClassName }, props.addonBefore)) : null;
        var addonAfter = props.addonAfter ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: addonClassName }, props.addonAfter)) : null;
        var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(props.prefixCls + "-wrapper", this.props.wrapperClassName, (_a = {},
            _a[wrapperClassName] = (addonBefore || addonAfter),
            _a));
        var groupClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(props.prefixCls + "-group-wrapper", (_b = {},
            _b[props.prefixCls + "-group-wrapper-sm"] = props.size === 'small',
            _b[props.prefixCls + "-group-wrapper-lg"] = props.size === 'large',
            _b));
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        if (addonBefore || addonAfter) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: groupClassName, style: props.style },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: className },
                    addonBefore,
                    __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, { style: null }),
                    addonAfter)));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: className },
            addonBefore,
            children,
            addonAfter));
    };
    Input.prototype.renderLabeledIcon = function (children) {
        var _a;
        var props = this.props;
        if (!('prefix' in props || 'suffix' in props)) {
            return children;
        }
        var prefix = props.prefix ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: props.prefixCls + "-prefix" }, props.prefix)) : null;
        var suffix = props.suffix ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: props.prefixCls + "-suffix" }, props.suffix)) : null;
        var affixWrapperCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(props.className, props.prefixCls + "-affix-wrapper", (_a = {},
            _a[props.prefixCls + "-affix-wrapper-sm"] = props.size === 'small',
            _a[props.prefixCls + "-affix-wrapper-lg"] = props.size === 'large',
            _a));
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: affixWrapperCls, style: props.style },
            prefix,
            __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, { style: null, className: this.getInputClassName() }),
            suffix));
    };
    Input.prototype.renderInput = function () {
        var _a = this.props, value = _a.value, className = _a.className;
        // Fix https://fb.me/react-unknown-prop
        var otherProps = Object(__WEBPACK_IMPORTED_MODULE_3_omit_js__["a" /* default */])(this.props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
        ]);
        if ('value' in this.props) {
            otherProps.value = fixControlledValue(value);
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            delete otherProps.defaultValue;
        }
        return this.renderLabeledIcon(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({}, otherProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(this.getInputClassName(), className), onKeyDown: this.handleKeyDown, ref: this.saveInput })));
    };
    Input.prototype.render = function () {
        return this.renderLabeledInput(this.renderInput());
    };
    Input.defaultProps = {
        prefixCls: 'cube-input',
        type: 'text',
        disabled: false,
    };
    Input.propTypes = {
        type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
            __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        ]),
        size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small', 'default', 'large']),
        maxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
            __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        ]),
        disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
        defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
        className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        addonBefore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
        addonAfter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
        prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        autosize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
        onPressEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onKeyUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        prefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
        suffix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    };
    return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Input);


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_abutton__ = __webpack_require__(971);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focus: false
        };
        _this.onSearch = function () {
            var onSearch = _this.props.onSearch;
            if (onSearch) {
                onSearch(_this.input.input.value);
            }
            _this.input.focus();
        };
        _this.handleFocus = function (e) {
            var onFocus = _this.props.onFocus;
            _this.setState({ focus: true });
            if (onFocus) {
                onFocus(e);
            }
        };
        _this.handleBlur = function (e) {
            _this.setState({ focus: false });
            var onBlur = _this.props.onBlur;
            if (onBlur) {
                onBlur(e);
            }
        };
        _this.saveInput = function (node) {
            _this.input = node;
        };
        return _this;
    }
    Search.prototype.focus = function () {
        this.input.focus();
    };
    Search.prototype.blur = function () {
        this.input.blur();
    };
    Search.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, prefixCls = _b.prefixCls, inputPrefixCls = _b.inputPrefixCls, size = _b.size, enterButton = _b.enterButton, enterButtonType = _b.enterButtonType, suffix = _b.suffix, others = __rest(_b, ["className", "prefixCls", "inputPrefixCls", "size", "enterButton", "enterButtonType", "suffix"]);
        delete others.onSearch;
        var buttonOrIcon = enterButton
            ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__view_abutton__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Button@s499gz", className: prefixCls + "-button", type: enterButtonType, size: size, onClick: this.onSearch, key: "enterButton" }, enterButton === true ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "anticon anticon-search" }) : enterButton)) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__view_abutton__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Button@wamx7s", className: prefixCls + "-button", type: enterButtonType, size: size, onClick: this.onSearch, key: "enterButton" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: prefixCls + "-icon anticon anticon-search", key: "searchIcon" }));
        var searchSuffix = suffix ? [suffix, buttonOrIcon] : buttonOrIcon;
        var inputClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(prefixCls, className, (_a = {},
            _a[prefixCls + "-enter-button"] = !!enterButton,
            _a[prefixCls + "-" + size] = !!size,
            _a[prefixCls + "-focus"] = this.state.focus,
            _a));
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Input__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Input@w4yrxb", onPressEnter: this.onSearch }, others, { size: size, className: inputClassName, prefixCls: inputPrefixCls, suffix: searchSuffix, ref: this.saveInput, onFocus: this.handleFocus, onBlur: this.handleBlur })));
    };
    Search.defaultProps = {
        inputPrefixCls: 'cube-input',
        prefixCls: 'cube-input-search',
        enterButton: false,
    };
    return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Search);


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var CustomDialog = /** @class */ (function (_super) {
    __extends(CustomDialog, _super);
    function CustomDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomDialog.prototype.render = function () {
        var _a = this.props, customDialog = _a.customDialog, _b = _a.iconInfo, iconInfo = _b === void 0 ? {} : _b;
        var buttons = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@zpx543@onCancel", icon: "cross", onClick: customDialog.onCancel }, getLabel(309, '关闭')),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@u49ac0@onOk", type: "primary", icon: "save", loading: customDialog.loading, onClick: customDialog.onOk }, customDialog.okText)];
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@4au7z4", className: 'wea-auth-modal cube-dialog', buttons: buttons, title: customDialog.title, iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: customDialog.visible, style: { width: '500px', height: customDialog.height + 'px' }, hasScroll: true, onCancel: customDialog.onCancel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: customDialog.content } })));
    };
    CustomDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx_react__["observer"]
    ], CustomDialog);
    return CustomDialog;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (CustomDialog);


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);


var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;
/* harmony default export */ __webpack_exports__["a"] = (function (Props) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaAlertPage"], { ecId: "_WeaAlertPage@zudhbu" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: '#000' } }, getLabel(2012, '对不起，您暂时没有权限！')))); });


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(86),
    root = __webpack_require__(42);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isObject = __webpack_require__(402);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Colgroup__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableTBody__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_cubeUtil__ = __webpack_require__(19);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var ExcelLayout = /** @class */ (function (_super) {
    __extends(ExcelLayout, _super);
    function ExcelLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            contentH: 500
        };
        return _this;
    }
    ExcelLayout.prototype.componentDidMount = function () {
        var h = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(".mode-card-resource").height();
        if (h == null) {
            h = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(".wea-new-top-req-content").height();
        }
        this.setState({ contentH: h });
        //必填校验 暂时先预执行一次校验逻辑  防止后续校验出错 -------by ljc
        // this.props.Card.cubeForm.validate();
        /***显示布局的是很绑定document点击事件 */
        var _a = this.props.Card, params = _a.params, quickEditStore = _a.quickEditStore;
        if (params.type == '0') {
            document.addEventListener('mousedown', quickEditStore.handleClickOutSide, true);
        }
    };
    ExcelLayout.prototype.componentDidUpdate = function () {
        var Card = this.props.Card;
        if (Card.showGlobalSpin.isShow == 'hide') {
            Card.showGlobalSpin.isShow = 'none';
        }
    };
    ExcelLayout.prototype.componentWillUnmount = function () {
        var quickEditStore = this.props.Card.quickEditStore;
        document.removeEventListener("mousedown", quickEditStore.handleClickOutSide);
    };
    ExcelLayout.prototype.render = function () {
        var _a = this.props, Card = _a.Card, className = _a.className;
        var padding = Card.cardMarginParams.padding, showGlobalSpin = Card.showGlobalSpin;
        var cardtype = Card.base.type; //当只有显示模板的的时候不需要添加最小高度，页面出现空白
        /**
      * 这里做了大量的计算，主要处理表单边距的问题；
      * 回复评论的两种情况，底部显示和右侧显示
      * */
        var showReply = Card.base.showReply;
        var replyposition = Card.base.replyposition == 1; //1  是底部
        var classNames = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'excelMainTable');
        var style = {
            margin: "0 auto",
            width: Card.modeExcel.tableStyle['width'],
            backgroundImage: Card.modeExcel.backgroundImg ? 'URL(' + ("" + Card.modeExcel.backgroundImg) + ')' : 'none'
        };
        var fromStyle = Card.waterImg ? {
            backgroundAttachment: 'scroll', backgroundRepeat: 'repeat', width: "100%",
            backgroundImage: 'URL(' + ("" + Card.waterImg) + ')'
        } : {};
        if (showGlobalSpin.isShow !== 'none') {
            Object(__WEBPACK_IMPORTED_MODULE_6__util__["doGlobalSpin"])(showGlobalSpin);
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-wrap", style: {
                minHeight: cardtype == "0" && showReply && replyposition ? "auto" :
                    showReply && !replyposition ? this.state.contentH - padding.top - padding.bottom : this.state.contentH,
                padding: cardtype == "0" && showReply && !replyposition ? "" : "" + (cardtype == "4" ? "0px 0px" : padding.top + "px " + padding.right + "px " + padding.bottom + "px " + padding.left + "px")
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-form", style: __assign({}, fromStyle, { minHeight: cardtype == "0" && showReply && replyposition ? "auto" :
                        this.state.contentH - padding.top - padding.bottom }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-excelMainTable-wrapper", style: {
                        overflowX: 'auto',
                        minHeight: cardtype == "0" && showReply && replyposition ? "auto" :
                            this.state.contentH - padding.top - padding.bottom,
                        paddingBottom: 20
                    }, onScroll: this.doScrollYEvent.bind(this) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: classNames, style: style },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Colgroup__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableColgroup@d4f8mf", excel: Card.modeExcel }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableTBody__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableTBody@upfebd", excel: Card.modeExcel, card: Card, form: Card.cubeForm, actions: Card.Actions }))))));
    };
    ExcelLayout.prototype.doScrollYEvent = function () {
        __WEBPACK_IMPORTED_MODULE_7__util_cubeUtil__["b" /* fixedDetailHead */](); //明细表头固定
    };
    ExcelLayout = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelLayout);
    return ExcelLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (ExcelLayout);


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MapAddressDialog", function() { return MapAddressDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loadjs__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;

var MapContainer = /** @class */ (function (_super) {
    __extends(MapContainer, _super);
    function MapContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.paint = function (title, lnglat) {
            if (lnglat === void 0) { lnglat = []; }
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap) {
                if (!_this.map) {
                    if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.ToolBar && __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Scale) {
                        that.paintAfter(title, lnglat);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
                            that.paintAfter(title, lnglat);
                        });
                    }
                }
            }
            else {
                setTimeout(function () {
                    that.paint(title, lnglat);
                }, 50);
            }
        };
        _this.paintAfter = function (title, lnglat) {
            if (lnglat === void 0) { lnglat = []; }
            _this.toolBar = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.ToolBar({
                visible: true
            });
            _this.scale = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Scale({
                visible: true
            });
            _this.map = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Map(_this.refs._map, {
                resizeEnable: true,
            });
            _this.map.addControl(_this.toolBar); //添加工具条控制
            _this.map.addControl(_this.scale);
            _this.toolBar.show();
            _this.toolBar.showDirection();
            _this.toolBar.showRuler();
            _this.scale.show();
            _this.map.on('click', function (e) {
                _this.regeocoder([e.lnglat.getLng(), e.lnglat.getLat()]);
            });
            if (title) {
                _this.geocoder(title, lnglat);
            }
            else {
                _this.geoCurrentLocation();
            }
        };
        _this.geocoder = function (title, lnglat) {
            if (lnglat === void 0) { lnglat = []; }
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Geocoder) {
                that.geocoderAfter(title, lnglat);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.plugin(['AMap.Geocoder'], function () {
                    that.geocoderAfter(title, lnglat);
                });
            }
        };
        _this.geocoderAfter = function (title, lnglat) {
            if (lnglat === void 0) { lnglat = []; }
            var that = _this;
            var geocoder = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Geocoder({
                radius: 1000 //范围，默认：500
            });
            //地理编码,返回地理编码结果
            if (lnglat.length > 0) { //如果有经纬度优先通过经纬度定位
                _this.map.remove(_this.marker || "");
                _this.addMarker(0, lnglat, title);
                _this.map.setFitView();
            }
            else {
                geocoder.getLocation(title, function (status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                        _this.map.remove(_this.marker || "");
                        _this.geocoder_CallBack(result);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].info({
                            title: getLabel(15172, '系统提示'),
                            content: getLabel(128181, "未能定位具体位置！ 1.请确保所有字词拼写正确 2.尝试不同的关键字 3.尝试更宽泛的关键字"),
                            onOk: function () {
                                that.geoCurrentLocation();
                            },
                        });
                    }
                });
            }
        };
        _this.regeocoder = function (lnglatXY) {
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Geocoder) {
                that.regeocoderAfter(lnglatXY);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.plugin(['AMap.Geocoder'], function () {
                    that.regeocoderAfter(lnglatXY);
                });
            }
        };
        _this.regeocoderAfter = function (lnglatXY) {
            var geocoder = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Geocoder({
                radius: 1000,
                extensions: "all"
            });
            //已知地理坐标，逆地理编码   
            geocoder.getAddress(lnglatXY, function (status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    _this.reGeocoder_CallBack(lnglatXY, result);
                }
            });
        };
        _this.geocoder_CallBack = function (data) {
            //地理编码结果数组
            var geocode = data.geocodes;
            for (var i = 0; i < 1; i++) {
                var position = [geocode[i].location.getLng(), geocode[i].location.getLat()];
                _this.addMarker(i, position, geocode[i].formattedAddress);
            }
            _this.map.setFitView();
        };
        _this.reGeocoder_CallBack = function (lnglatXY, data) {
            _this.addMarker("e", lnglatXY, data.regeocode.formattedAddress);
        };
        _this.addMarker = function (_, p, address) {
            if (_this.marker) {
                _this.map.remove(_this.marker);
            }
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Marker) {
                that.addMarkerAfter(_, p, address);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.plugin(['AMap.Marker'], function () {
                    that.addMarkerAfter(_, p, address);
                });
            }
        };
        _this.addMarkerAfter = function (_, p, address) {
            _this.marker = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Marker({
                map: _this.map,
                position: p
            });
            var infoWindow = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.InfoWindow({
                content: address,
                offset: { x: 0, y: -30 }
            });
            infoWindow.open(_this.map, _this.marker.getPosition());
            _this.marker.on("mouseover", function (_) {
                infoWindow.open(_this.map, _this.marker.getPosition());
            });
            _this.props.mapStore.updateAddress(address, p);
        };
        _this.geoCurrentLocation = function () {
            __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.plugin('AMap.Geolocation', function () {
                _this.geolocation = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Geolocation({
                    enableHighAccuracy: true,
                    timeout: 10000,
                    buttonOffset: new __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.Pixel(10, 20),
                    zoomToAccuracy: true,
                    buttonPosition: 'RB'
                });
                _this.map.addControl(_this.geolocation);
                _this.geolocation.getCurrentPosition();
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.event.addListener(_this.geolocation, 'complete', _this.onComplete); //返回定位信息
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].AMap.event.addListener(_this.geolocation, 'error', _this.onError); //返回定位出错信息
            });
        };
        _this.onComplete = function (data) {
            _this.addMarker("e", [data.position.getLng(), data.position.getLat()], getLabel(34177, "当前位置") + (":" + data.formattedAddress));
        };
        _this.onError = function () {
            __WEBPACK_IMPORTED_MODULE_4_antd__["message"].warning(getLabel(383751, "定位失败"));
        };
        _this.searchAddress = function () {
            var addressParams = _this.state.addressParams;
            _this.map = undefined; //处理搜索不生效问题
            _this.paint(addressParams);
        };
        _this.state = {
            addressParams: ""
        };
        return _this;
    }
    MapContainer.prototype.componentDidMount = function () {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_5_loadjs___default.a.isDefined('mapjs')) {
            __WEBPACK_IMPORTED_MODULE_5_loadjs___default()(["https://webapi.amap.com/maps?v=1.4.4&key=53a92850ca00d7f77aef3297effd8d59"], 'mapjs', {
                //&plugin=AMap.Geocoder,AMap.ToolBar,AMap.Scale
                success: function () {
                    var value = _this.props.mapStore.defaultAddress;
                    var lnglat = _this.props.mapStore.lnglat;
                    if (value == '') {
                        //value = getLabel(501929, '上海');
                    }
                    _this.paint(value, lnglat);
                }
            });
        }
        else {
            var value = this.props.mapStore.defaultAddress;
            var lnglat = this.props.mapStore.lnglat;
            if (value == '') {
                // value = getLabel(501929, '上海');
            }
            this.paint(value, lnglat);
        }
    };
    MapContainer.prototype.render = function () {
        var _this = this;
        var mapStore = this.props.mapStore;
        var defaultAddress = mapStore.defaultAddress;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: '100%', } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { position: "absolute", top: 20, left: 70, zIndex: 1, whiteSpace: 'nowrap' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaInput"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@nyc625", defaultValue: defaultAddress, onChange: function (v) { return _this.setState({ addressParams: v }); }, onPressEnter: function () { _this.searchAddress(); } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@ngobrk", type: "primary", onClick: this.searchAddress, style: { margin: "0 0 3px 10px" } }, "\u641C\u7D22")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { ref: '_map', style: { height: '100%' } })));
    };
    MapContainer = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], MapContainer);
    return MapContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (MapContainer);
var MapAddressDialog = /** @class */ (function (_super) {
    __extends(MapAddressDialog, _super);
    function MapAddressDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MapAddressDialog.prototype.render = function () {
        var _a = this.props, mapStore = _a.mapStore, iconInfo = _a.iconInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@1qznvj", onCancel: mapStore.onCancel, title: getLabel(126782, "获取地址"), visible: mapStore.visible, iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", style: { width: 820, height: 520 }, hasScroll: true, buttons: mapStore.showButtons ? [
                (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@dkizni@getLocation", type: "primary", onClick: mapStore.getLocation }, getLabel(383752, '获取位置'))),
                (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@myn7hp@getLocationCover", type: "primary", onClick: mapStore.getLocationCover }, getLabel(126783, '获取并覆盖'))),
                (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@yltaa6@onCancel", type: "ghost", onClick: mapStore.onCancel }, getLabel(309, "关闭")))
            ] : [] }, mapStore.visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MapContainer, { ecId: (this && this.props && this.props.ecId || '') + "_MapContainer@2d0vjb", ref: "_map", mapStore: mapStore })));
    };
    MapAddressDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], MapAddressDialog);
    return MapAddressDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1089);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(236);
var GetIntrinsic = __webpack_require__(422);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tree__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__batch__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_MapStore__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__batchPrint__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__card__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stores_amkjzg__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reply__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__list_BatchImportStore__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__list_LogListStore__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__custompage__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__list_ViewResourceStore__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modetab_TabStore__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__list_TemplateManageStore__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__list_BatchAddStore__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cubeMind__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__board_BoardStore__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mindMap_mindMapStore__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dev__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__timeline_TimelineStore__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__gantt_GanttStore__ = __webpack_require__(774);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





















/* harmony default export */ __webpack_exports__["default"] = (__assign({ Search: __WEBPACK_IMPORTED_MODULE_0__list__["default"],
    Tree: __WEBPACK_IMPORTED_MODULE_1__tree__["b" /* default */],
    Amkjzg: __WEBPACK_IMPORTED_MODULE_6__stores_amkjzg__["a" /* default */], Card: new __WEBPACK_IMPORTED_MODULE_5__card__["default"](), QrCodeStore: new __WEBPACK_IMPORTED_MODULE_2__batch__["a" /* default */](), BarCodeStore: new __WEBPACK_IMPORTED_MODULE_2__batch__["a" /* default */](), mapStore: new __WEBPACK_IMPORTED_MODULE_3__list_MapStore__["a" /* default */](), reply: new __WEBPACK_IMPORTED_MODULE_7__reply__["a" /* default */](), batchImport: new __WEBPACK_IMPORTED_MODULE_8__list_BatchImportStore__["a" /* default */](), cubeLogList: __WEBPACK_IMPORTED_MODULE_9__list_LogListStore__["a" /* default */], customPageStore: __WEBPACK_IMPORTED_MODULE_10__custompage__["a" /* default */], cubeViewResource: new __WEBPACK_IMPORTED_MODULE_11__list_ViewResourceStore__["a" /* default */](), TabStore: new __WEBPACK_IMPORTED_MODULE_12__modetab_TabStore__["a" /* default */](), templateManageStore: new __WEBPACK_IMPORTED_MODULE_13__list_TemplateManageStore__["a" /* default */](), batchAddStore: new __WEBPACK_IMPORTED_MODULE_14__list_BatchAddStore__["a" /* default */](), cubeMind: new __WEBPACK_IMPORTED_MODULE_15__cubeMind__["a" /* default */](), boardStore: new __WEBPACK_IMPORTED_MODULE_16__board_BoardStore__["a" /* default */](), mindMapStore: new __WEBPACK_IMPORTED_MODULE_17__mindMap_mindMapStore__["a" /* default */](), BatchPrint: new __WEBPACK_IMPORTED_MODULE_4__batchPrint__["a" /* default */](), timelineStore: new __WEBPACK_IMPORTED_MODULE_19__timeline_TimelineStore__["a" /* default */](), ganttStore: new __WEBPACK_IMPORTED_MODULE_20__gantt_GanttStore__["a" /* default */]() }, __WEBPACK_IMPORTED_MODULE_18__dev__["a" /* default */]));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var Rules = __webpack_require__(437);
var Lang = __webpack_require__(438);
var Errors = __webpack_require__(441);
var Attributes = __webpack_require__(240);
var AsyncResolvers = __webpack_require__(442);

var Validator = function (input, rules, customMessages) {
  var lang = Validator.getDefaultLang();
  this.input = input || {};

  this.messages = Lang._make(lang);
  this.messages._setCustom(customMessages);
  this.setAttributeFormatter(Validator.prototype.attributeFormatter);

  this.errors = new Errors();
  this.errorCount = 0;

  this.hasAsync = false;
  this.rules = this._parseRules(rules);
};

Validator.prototype = {

  constructor: Validator,

  /**
   * Default language
   *
   * @type {string}
   */
  lang: 'en',

  /**
   * Numeric based rules
   *
   * @type {array}
   */
  numericRules: ['integer', 'numeric'],

  /**
   * Attribute formatter.
   *
   * @type {function}
   */
  attributeFormatter: Attributes.formatter,

  /**
   * Run validator
   *
   * @return {boolean} Whether it passes; true = passes, false = fails
   */
  check: function () {
    var self = this;

    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];
      var inputValue = this._objectPath(this.input, attribute);

      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
        continue;
      }

      for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
        ruleOptions = attributeRules[i];
        rule = this.getRule(ruleOptions.name);

        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }

        rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);
        if (!rulePassed) {
          this._addFailure(rule);
        }

        if (this._shouldStopValidating(attribute, rulePassed)) {
          break;
        }
      }
    }

    return this.errorCount === 0;
  },

  /**
   * Run async validator
   *
   * @param {function} passes
   * @param {function} fails
   * @return {void}
   */
  checkAsync: function (passes, fails) {
    var _this = this;
    passes = passes || function () {};
    fails = fails || function () {};

    var failsOne = function (rule, message) {
      _this._addFailure(rule, message);
    };

    var resolvedAll = function (allPassed) {
      if (allPassed) {
        passes();
      } else {
        fails();
      }
    };

    var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);

    var validateRule = function (inputValue, ruleOptions, attribute, rule) {
      return function () {
        var resolverIndex = asyncResolvers.add(rule);
        rule.validate(inputValue, ruleOptions.value, attribute, function () {
          asyncResolvers.resolve(resolverIndex);
        });
      };
    };

    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];
      var inputValue = this._objectPath(this.input, attribute);

      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
        continue;
      }

      for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
        ruleOptions = attributeRules[i];

        rule = this.getRule(ruleOptions.name);

        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }

        validateRule(inputValue, ruleOptions, attribute, rule)();
      }
    }

    asyncResolvers.enableFiring();
    asyncResolvers.fire();
  },

  /**
   * Add failure and error message for given rule
   *
   * @param {Rule} rule
   */
  _addFailure: function (rule) {
    var msg = this.messages.render(rule);
    this.errors.add(rule.attribute, msg);
    this.errorCount++;
  },

  /**
   * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
   *
   * @param  {object} nested object
   * @return {object} flattened object
   */
  _flattenObject: function (obj) {
    var flattened = {};

    function recurse(current, property) {
      if (!property && Object.getOwnPropertyNames(current).length === 0) {
        return;
      }
      if (Object(current) !== current || Array.isArray(current)) {
        flattened[property] = current;
      } else {
        var isEmpty = true;
        for (var p in current) {
          isEmpty = false;
          recurse(current[p], property ? property + "." + p : p);
        }
        if (isEmpty) {
          flattened[property] = {};
        }
      }
    }
    if (obj) {
      recurse(obj);
    }
    return flattened;
  },

  /**
   * Extract value from nested object using string path with dot notation
   *
   * @param  {object} object to search in
   * @param  {string} path inside object
   * @return {any|void} value under the path
   */
  _objectPath: function (obj, path) {
    if (Object.prototype.hasOwnProperty.call(obj, path)) {
      return obj[path];
    }

    var keys = path.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split(".");
    var copy = {};
    for (var attr in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) {
        copy[attr] = obj[attr];
      }
    }

    for (var i = 0, l = keys.length; i < l; i++) {
      if (Object.hasOwnProperty.call(copy, keys[i])) {
        copy = copy[keys[i]];
      } else {
        return;
      }
    }
    return copy;
  },

  /**
   * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
   *
   * @param  {object} rules
   * @return {object}
   */
  _parseRules: function (rules) {

    var parsedRules = {};
    rules = this._flattenObject(rules);

    for (var attribute in rules) {

      var rulesArray = rules[attribute];

      this._parseRulesCheck(attribute, rulesArray, parsedRules);
    }
    return parsedRules;


  },

  _parseRulesCheck: function (attribute, rulesArray, parsedRules, wildCardValues) {
    if (attribute.indexOf('*') > -1) {
      this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
    } else {
      this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
    }
  },

  _parsedRulesRecurse: function (attribute, rulesArray, parsedRules, wildCardValues) {
    var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);
    var propertyValue = this._objectPath(this.input, parentPath);

    if (propertyValue) {
      for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
        var workingValues = wildCardValues ? wildCardValues.slice() : [];
        workingValues.push(propertyNumber);
        this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
      }
    }
  },

  _parseRulesDefault: function (attribute, rulesArray, parsedRules, wildCardValues) {
    var attributeRules = [];

    if (rulesArray instanceof Array) {
      rulesArray = this._prepareRulesArray(rulesArray);
    }

    if (typeof rulesArray === 'string') {
      rulesArray = rulesArray.split('|');
    }

    for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
      rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];
      if (rule.value) {
        rule.value = this._replaceWildCards(rule.value, wildCardValues);
        this._replaceWildCardsMessages(wildCardValues);
      }

      if (Rules.isAsync(rule.name)) {
        this.hasAsync = true;
      }
      attributeRules.push(rule);
    }

    parsedRules[attribute] = attributeRules;
  },

  _replaceWildCards: function (path, nums) {

    if (!nums) {
      return path;
    }

    var path2 = path;
    nums.forEach(function (value) {
      var pos = path2.indexOf('*');
      if (pos === -1) {
        return path2;
      }
      path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
    });
    return path2;
  },

  _replaceWildCardsMessages: function (nums) {
    var customMessages = this.messages.customMessages;
    var self = this;
    Object.keys(customMessages).forEach(function (key) {
      if (nums) {
        var newKey = self._replaceWildCards(key, nums);
        customMessages[newKey] = customMessages[key];
      }
    });

    this.messages._setCustom(customMessages);
  },
  /**
   * Prepare rules if it comes in Array. Check for objects. Need for type validation.
   *
   * @param  {array} rulesArray
   * @return {array}
   */
  _prepareRulesArray: function (rulesArray) {
    var rules = [];

    for (var i = 0, len = rulesArray.length; i < len; i++) {
      if (typeof rulesArray[i] === 'object') {
        for (var rule in rulesArray[i]) {
          rules.push({
            name: rule,
            value: rulesArray[i][rule]
          });
        }
      } else {
        rules.push(rulesArray[i]);
      }
    }

    return rules;
  },

  /**
   * Determines if the attribute is supplied with the original data object.
   *
   * @param  {array} attribute
   * @return {boolean}
   */
  _suppliedWithData: function (attribute) {
    return this.input.hasOwnProperty(attribute);
  },

  /**
   * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
   *
   * @param  {string} ruleString min:3
   * @return {object} object containing the name of the rule and value
   */
  _extractRuleAndRuleValue: function (ruleString) {
    var rule = {},
      ruleArray;

    rule.name = ruleString;

    if (ruleString.indexOf(':') >= 0) {
      ruleArray = ruleString.split(':');
      rule.name = ruleArray[0];
      rule.value = ruleArray.slice(1).join(":");
    }

    return rule;
  },

  /**
   * Determine if attribute has any of the given rules
   *
   * @param  {string}  attribute
   * @param  {array}   findRules
   * @return {boolean}
   */
  _hasRule: function (attribute, findRules) {
    var rules = this.rules[attribute] || [];
    for (var i = 0, len = rules.length; i < len; i++) {
      if (findRules.indexOf(rules[i].name) > -1) {
        return true;
      }
    }
    return false;
  },

  /**
   * Determine if attribute has any numeric-based rules.
   *
   * @param  {string}  attribute
   * @return {Boolean}
   */
  _hasNumericRule: function (attribute) {
    return this._hasRule(attribute, this.numericRules);
  },

  /**
   * Determine if rule is validatable
   *
   * @param  {Rule}   rule
   * @param  {mixed}  value
   * @return {boolean}
   */
  _isValidatable: function (rule, value) {
    if (Rules.isImplicit(rule.name)) {
      return true;
    }

    return this.getRule('required').validate(value);
  },

  /**
   * Determine if we should stop validating.
   *
   * @param  {string} attribute
   * @param  {boolean} rulePassed
   * @return {boolean}
   */
  _shouldStopValidating: function (attribute, rulePassed) {

    var stopOnAttributes = this.stopOnAttributes;
    if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
      return false;
    }

    if (stopOnAttributes instanceof Array) {
      return stopOnAttributes.indexOf(attribute) > -1;
    }

    return true;
  },

  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   * @return {void}
   */
  setAttributeNames: function (attributes) {
    this.messages._setAttributeNames(attributes);
  },

  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  setAttributeFormatter: function (func) {
    this.messages._setAttributeFormatter(func);
  },

  /**
   * Get validation rule
   *
   * @param  {string} name
   * @return {Rule}
   */
  getRule: function (name) {
    return Rules.make(name, this);
  },

  /**
   * Stop on first error.
   *
   * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
   * @return {void}
   */
  stopOnError: function (attributes) {
    this.stopOnAttributes = attributes;
  },

  /**
   * Determine if validation passes
   *
   * @param {function} passes
   * @return {boolean|undefined}
   */
  passes: function (passes) {
    var async = this._checkAsync('passes', passes);
    if (async) {
      return this.checkAsync(passes);
    }
    return this.check();
  },

  /**
   * Determine if validation fails
   *
   * @param {function} fails
   * @return {boolean|undefined}
   */
  fails: function (fails) {
    var async = this._checkAsync('fails', fails);
    if (async) {
      return this.checkAsync(function () {}, fails);
    }
    return !this.check();
  },

  /**
   * Check if validation should be called asynchronously
   *
   * @param  {string}   funcName Name of the caller
   * @param  {function} callback
   * @return {boolean}
   */
  _checkAsync: function (funcName, callback) {
    var hasCallback = typeof callback === 'function';
    if (this.hasAsync && !hasCallback) {
      throw funcName + ' expects a callback when async rules are being tested.';
    }

    return this.hasAsync || hasCallback;
  }

};

/**
 * Set messages for language
 *
 * @param {string} lang
 * @param {object} messages
 * @return {this}
 */
Validator.setMessages = function (lang, messages) {
  Lang._set(lang, messages);
  return this;
};

/**
 * Get messages for given language
 *
 * @param  {string} lang
 * @return {Messages}
 */
Validator.getMessages = function (lang) {
  return Lang._get(lang);
};

/**
 * Set default language to use
 *
 * @param {string} lang
 * @return {void}
 */
Validator.useLang = function (lang) {
  this.prototype.lang = lang;
};

/**
 * Get default language
 *
 * @return {string}
 */
Validator.getDefaultLang = function () {
  return this.prototype.lang;
};

/**
 * Set the attribute formatter.
 *
 * @param {fuction} func
 * @return {void}
 */
Validator.setAttributeFormatter = function (func) {
  this.prototype.attributeFormatter = func;
};

/**
 * Stop on first error.
 *
 * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
 * @return {void}
 */
Validator.stopOnError = function (attributes) {
  this.prototype.stopOnAttributes = attributes;
};

/**
 * Register custom validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.register = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.register(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register custom validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerImplicit = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerImplicit(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register asynchronous validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerAsync = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerAsync(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register asynchronous validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerAsyncImplicit = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerAsyncImplicit(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register validator for missed validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerMissedRuleValidator = function(fn, message) {
  Rules.registerMissedRuleValidator(fn, message);
};

module.exports = Validator;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

var replacements = {

  /**
   * Between replacement (replaces :min and :max)
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  between: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      min: parameters[0],
      max: parameters[1]
    });
  },

  /**
   * Required_if replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_if: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: this._getAttributeName(parameters[0]),
      value: parameters[1]
    });
  },

  /**
   * Required_unless replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_unless: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: this._getAttributeName(parameters[0]),
      value: parameters[1]
    });
  },

  /**
   * Required_with replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Required_with_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with_all: function(template, rule) {
    var parameters = rule.getParameters();
    var getAttributeName = this._getAttributeName.bind(this);
    return this._replacePlaceholders(rule, template, {
      fields: parameters.map(getAttributeName).join(', ')
    });
  },

  /**
   * Required_without replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Required_without_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without_all: function(template, rule) {
    var parameters = rule.getParameters();
    var getAttributeName = this._getAttributeName.bind(this);
    return this._replacePlaceholders(rule, template, {
      fields: parameters.map(getAttributeName).join(', ')
    });
  },

 /**
   * After replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Before replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before: this._getAttributeName(parameters[0])
    });
  },

  /**
   * After_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after_or_equal: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after_or_equal: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Before_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before_or_equal: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before_or_equal: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Same replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  same: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      same: this._getAttributeName(parameters[0])
    });
  },
};

function formatter(attribute) {
  return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
}

module.exports = {
  replacements: replacements,
  formatter: formatter
};


/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Das :attribute Feld muss akzeptiert werden.',
  after: 'Das :attribute muss ein Datum nach dem :after sein.',
  after_or_equal: 'Das :attribute Datum muss kleiner oder gleich dem :after_or_equal sein.',
  alpha: 'Das :attribute Feld darf nur aus Buchstaben bestehen.',
  alpha_dash: 'Das :attribute Feld darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.',
  alpha_num: 'Das :attribute Feld darf nur aus Buchstaben und Zahlen bestehen.',
  before: 'Das :attribute muss ein Datum vor dem :before sein.',
  before_or_equal: 'Das :attribute Datum muss größer oder gleich dem :before_or_equal sein.',
  between: 'Das :attribute Feld muss zwischen :min und :max liegen.',
  confirmed: 'Das :attribute Feld stimmt nicht mit der Bestätigung überein.',
  email: 'Das :attribute Format ist ungültig.',
  date: 'Das :attribute Feld muss ein gültiges Datum sein.',
  def: 'Das :attribute Feld hat Fehler.',
  digits: 'Das :attribute Feld muss :digits Stellen haben.',
  different: 'Die Felder :attribute und :different müssen sich unterscheiden.',
  'in': 'Der gewählte Wert für :attribute ist ungültig.',
  integer: 'Das :attribute Feld muss eine ganze Zahl sein.',
  min: {
    numeric: 'Das :attribute Feld muss mindestens :min sein.',
    string: 'Das :attribute Feld muss mindestens :min Zeichen lang sein.'
  },
  max: {
    numeric: 'Das :attribute Feld darf maximal :max sein.',
    string: 'Das :attribute Feld darf maximal :max Zeichen haben.'
  },
  not_in: 'Der gewählte Wert für :attribute ist ungültig.',
  numeric: 'Das :attribute Feld muss eine Zahl sein.',
  present: 'Das Feld :attribute muss vorhanden sein (kann aber leer sein).',
  required: 'Das :attribute Feld muss ausgefüllt sein.',
  required_if: 'Das :attribute Feld muss ausgefüllt sein, wenn :other :value ist.',
  same: 'Die Felder :attribute und :same müssen übereinstimmen.',
  size: {
    numeric: 'Das :attribute Feld muss gleich :size sein.',
    string: 'Das :attribute Feld muss :size Zeichen lang sein.'
  },
  string: 'Das :attribute Feld muss ein Satz sein.',
  url: 'Das Format von :attribute ist ungültig.',
  regex: 'Das :attribute Format ist ungültig.',
  attributes: {}
};


/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Το πεδίο :attribute πρέπει να γίνει αποδεκτό.',
  after: 'Το πεδίο :attribute πρέπει να είναι μία ημερομηνία μετά από :after.',
  alpha: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα.',
  alpha_dash: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα, αριθμούς, και παύλες.',
  alpha_num: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα και αριθμούς.',
  between: 'Το πεδίο :attribute πρέπει να είναι μεταξύ :min και :max.',
  confirmed: 'Η επιβεβαίωση του :attribute δεν ταιριάζει.',
  email: 'Το πεδίο :attribute πρέπει να είναι μία έγκυρη διεύθυνση email.',
  date: 'Το πεδίο :attribute δεν είναι έγκυρη ημερομηνία.',
  def: 'Το πεδίο :attribute περιέχει σφάλματα.',
  digits: 'Το πεδίο :attribute πρέπει να είναι :digits ψηφία.',
  different: 'Το πεδίο :attribute  και :different πρέπει να είναι διαφορετικά.',
  'in': 'Το επιλεγμένο :attribute δεν είναι έγκυρο.',
  integer: 'Το πεδίο :attribute πρέπει να είναι ακέραιος.',
  min: {
    numeric: 'Το πεδίο :attribute πρέπει να είναι τουλάχιστον :min.',
    string: 'Το πεδίο :attribute πρέπει να έχει τουλάχιστον :min χαρακτήρες.'
  },
  max: {
    numeric: 'Το πεδίο :attribute δεν μπορεί να είναι μεγαλύτερο από :max.',
    string: 'Το πεδίο :attribute δεν μπορεί να έχει περισσότερους από :max χαρακτήρες.'
  },
  not_in: 'Το επιλεγμένο :attribute δεν είναι αποδεκτό.',
  numeric: 'Το πεδίο :attribute πρέπει να είναι αριθμός.',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'Το πεδίο :attribute είναι απαραίτητο.',
  required_if: 'Το πεδίο :attribute είναι απαραίτητο όταν το πεδίο :other είναι :value.',
  same: 'Τα πεδία :attribute και :same πρέπει να είναι ίδια.',
  size: {
    numeric: 'Το πεδίο :attribute πρέπει να είναι :size.',
    string: 'Το πεδίο :attribute πρέπει να είναι :size χαρακτήρες.'
  },
  string: 'Το πεδίο :attribute πρέπει να είναι αλφαριθμητικό.',
  url: 'Το πεδίο :attribute δεν είναι έγκυρη διεύθυνση URL.',
  regex: 'Η μορφή του :attribute δεν είναι αποδεκτή.',
  attributes: {}
};


/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'El campo :attribute debe ser aceptado.',
  after: 'El campo :attribute debe ser una fecha posterior a :after.',
  alpha: 'El campo :attribute solo debe contener letras.',
  alpha_dash: 'El campo :attribute solo debe contener letras, números y guiones.',
  alpha_num: 'El campo :attribute solo debe contener letras y números.',
  attributes: {},
  between: 'El campo :attribute tiene que estar entre :min - :max.',
  confirmed: 'La confirmación de :attribute no coincide.',
  different: 'El campo :attribute y :other deben ser diferentes.',
  digits: 'El campo :attribute debe tener :digits dígitos.',
  email: 'El campo :attribute no es un correo válido.',
  'in': 'El campo :attribute es inválido.',
  integer: 'El campo :attribute debe ser un número entero.',
  max: {
    numeric: 'El campo :attribute no debe ser mayor a :max.',
    string: 'El campo :attribute no debe ser mayor que :max caracteres.'
  },
  min: {
    numeric: 'El tamaño del campo :attribute debe ser de al menos :min.',
    string: 'El campo :attribute debe contener al menos :min caracteres.'
  },
  not_in: 'El campo :attribute es inválido.',
  numeric: 'El campo :attribute debe ser numérico.',
  present: 'El campo de :attribute debe estar presente (pero puede estar vacío).',
  regex: 'El formato del campo :attribute es inválido.',
  required: 'El campo :attribute es obligatorio.',
  required_if: 'El campo :attribute es obligatorio cuando :other es :value.',
  same: 'El campo :attribute y :other deben coincidir.',
  size: {
    numeric: 'El tamaño del campo :attribute debe ser :size.',
    string: 'El campo :attribute debe contener :size caracteres.'
  },
  url: 'El formato de :attribute es inválido.'
};


/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'فیلد :attribute می بایست تایید شود',
  alpha: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی باشد',
  alpha_dash: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی و خط تیره و زیرخط باشد',
  alpha_num: 'فیلد :attribute می بایست فقط شامل حروف و اعداد باشد',
  between: 'فیلد :attribute می بایست بزرگتر از :min و کوچکتر از :max باشد',
  confirmed: 'تطبیق فیلد :attribute صحیح نمی باشد',
  email: 'فرمت ایمیل وارد شده در :attribute صحیح نمی‌باشد',
  date: 'تاریخ درج شده در فیلد :attribute صحیح نیست',
  def: 'فیلد :attribute اشکال دارد',
  digits: 'فیلد :attribute می بایست شامل :digits رقم باشد',
  different: 'فیلد :attribute می بایست مقداری غیر از :different داشته باشد',
  'in': 'فیلد :attribute انتخاب شده صحیح نمی باشد',
  integer: 'فیلد :attribute می بایست عددی باشد',
  min: {
    numeric: 'فیلد :attribute می بایست از :min بزرگتر باشد',
    string: 'فیلد :attribute بایستی حداقل :min کاراکتر طول داشته باشد'
  },
  max: {
    numeric: 'فیلد :attribute می بایست از :max کوچکتر باشد',
    string: 'فیلد :attribute نباید بیشتر از :max کاراکتر طول داشته باشد'
  },
  not_in: 'فیلد :attribute انتخاب شده صحیح نمی باشد',
  numeric: 'فیلد :attribute می بایست عددی باشد',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'فیلد :attribute الزامی است',
  required_if: 'در صورت دادن :value به :other تکمیل فیلد :attribute الزامی است',
  same: 'فیلد :attribute می بایست با فیلد :same یکی باشد',
  size: {
    numeric: 'فیلد :attribute می بایست :size باشد',
    string: 'فیلد :attribute می بایست :size کاراکتر طول داشته باشد'
  },
  string: 'فیلد :attribute می بایست متنی باشد',
  url: 'آدرس فیلد :attribute صحیح نمی باشد',
  regex: 'فرمت آدرس :attribute صحیح نمی باشد',
  attributes: {}
};


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Le champ :attribute doit être accepté.',
  alpha: 'Le champ :attribute ne peut contenir que des caractères alphabétiques.',
  alpha_dash: 'Le champ :attribute ne peut contenir que des caractères alphanumériques, des tirets et des underscores.',
  alpha_num: 'Le champ :attribute ne peut contenir que des caractères alphanumériques.',
  between: 'La longueur du champ :attribute doit être comprise entre :min and :max.',
  confirmed: 'Le champ :attribute n\'est pas confirmé.',
  email: 'Le champ :attribute contient un format invalide.',
  def: 'Le champ :attribute contient un attribut erroné.',
  digits: 'Le champ :attribute doit être composé de :digits chiffres.',
  different: 'Les champs :attribute et :different doivent être différents.',
  'in': 'Le champ :attribute est invalide.',
  integer: 'Le champ :attribute doit être un entier.',
  min: {
    numeric: 'Le champ :attribute doit être supérieur à :min.',
    string: 'Le champ :attribute doit contenir plus de :min caractères.'
  },
  max: {
    numeric: 'Le champ :attribute doit être inférieur à :max.',
    string: 'Le champ :attribute doit contenir moins de :max caractères.'
  },
  not_in: 'Le champ :attribute est invalide.',
  numeric: 'Le champ :attribute doit être un chiffre.',
  present: 'Le champ :attribute doit être présent (mais peut être vide).',
  required: 'Le champ :attribute est requis.',
  required_if: 'Le champ :attribute est requis quand :other est :value.',
  same: 'Les champs :attribute et :same doivent correspondre.',
  size: {
    numeric: 'Le champ :attribute doit être égal à :size.',
    string: 'Le champ :attribute doit contenir :size caractères.'
  },
  url: 'Le format du champ :attribute est invalide.',
  regex: 'Le format du champ :attribute est invalide.',
  attributes: {}
};


/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Il campo :attribute deve essere accettato.',
  alpha: 'Il campo :attribute deve contenere sono caratteri alfabetici.',
  alpha_dash: 'Il campo :attribute può contenere solo caratteri alfanumerici oltre a trattini e trattini bassi.',
  alpha_num: 'Il campo :attribute deve essere alfanumerico.',
  between: 'Il campo :attribute deve essere compreso tra :min e :max.',
  confirmed: 'Il campo conferma :attribute non è uguale.',
  email: 'Il formato dell\'attributo :attribute non è valido.',
  def: 'Gli attributi del campo :attribute contengono degli errori.',
  digits: 'Il campo :attribute deve essere di :digits cifre.',
  different: 'Il campo :attribute e :different devo essere diversi.',
  'in': 'Il valore del campo :attribute non è valido.',
  integer: 'Il campo :attribute deve essere un valore intero.',
  min: {
    numeric: 'Il campo :attribute deve essere maggiore o uguale di :min.',
    string: 'Il campo :attribute deve essere composto da almeno :min caratteri.'
  },
  max: {
    numeric: 'Il campo :attribute deve essere minore o uguale di :max.',
    string: 'Il campo :attribute deve essere composto da massimo :max caratteri.'
  },
  not_in: 'Il campo :attribute non è valido.',
  numeric: 'Il campo :attribute deve essere un numero.',
  present: 'Il campo :attribute deve essere presente (ma può essere vuoto).',
  required: 'Il campo :attribute è richiesto.',
  required_if: 'Il campo :attribute è richiesto quando il campo :other è uguale a :value.',
  same: 'I campi :attribute e :same devono essere uguali.',
  size: {
    numeric: 'La dimensione del campo :attribute deve essere uguale a :size.',
    string: 'Il campo :attribute deve essere di :size caratteri.'
  },
  string: 'Il campo :attribute deve essere una stringa.',
  url: 'Il formato del campo :attribute non è valido.',
  regex: 'Il formato del campo :attribute non è valido.',
  attributes: {}
};


/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = {
    accepted: ':attributeを確認してください。',
    alpha: ':attributeは英字のみで入力してください。',
    alpha_dash: ':attributeは英字とダッシュと下線のみで入力してください。',
    alpha_num: ':attributeは英数字のみで入力してください。',
    between: ':attributeは:min〜:max文字で入力してください。',
    confirmed: ':attributeは確認が一致しません。',
    email: ':attributeは正しいメールアドレスを入力してください。',
    date: ':attributeは正しい日付形式を入力してください',
    def: ':attributeは検証エラーが含まれています。',
    digits: ':attributeは:digitsの数字のみで入力してください。',
    different: ':attributeと:differentは同じであってはなりません。',
    'in': '選択された:attributeは無効です。',
    integer: ':attributeは整数で入力してください。',
    min        : {
        numeric : ":attributeは:min以上で入力してください。",
        string  : ":attributeは:min文字以上で入力してください。"
    },
    max : {
        numeric : ":attributeは:max以下で入力してください。",
        string  : ":attributeは:max文字以下で入力してください。"
    },
    not_in      : "選択された:attributeは無効です。",
    numeric     : ":attributeは数値で入力してください。",
    present: 'The :attribute field must be present (but can be empty).',
    required    : ":attributeは必須です。",
    required_if : ":otherは:valueになったら:attributeは必須です。",
    same        : ":attributeと:sameは同じでなければなりません。",
    size        : {
        numeric : ":attributeは:sizeを入力してください。",
        string  : ":attributeは:size文字で入力してください。"
    },
    url        : ":attributeは正しいURIを入力してください。",
    regex      : ":attributeの値 \":value\" はパターンにマッチする必要があります。",
    attributes : {}
};


/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute må være akseptert.',
  alpha: ':attribute feltet kan kun inneholde alfabetiske tegn.',
  alpha_dash: ':attribute feltet kan kun inneholde alfanumeriske tegn, i tillegg til bindestreker og understreker.',
  alpha_num: ':attribute feltet må være alfanumerisk.',
  between: ':attribute feltet må være mellom :min og :max.',
  confirmed: ':attribute feltet stemmer ikke overens med bekreftelsen.',
  email: ':attribute formatet er ugyldig.',
  date: ':attribute er et ugyldig datoformat.',
  def: ':attribute attributtet har feil.',
  digits: ':attribute må være på :digits siffer.',
  different: ':attribute og :different må være forskjellige.',
  'in': 'Den oppgitte verdien for :attribute er ugyldig.',
  integer: ':attribute må være et heltall.',
  min: {
    numeric: ':attribute må minst være :min.',
    string: ':attribute må være på minst :min tegn.'
  },
  max: {
    numeric: ':attribute kan ikke være større enn :max.',
    string: ':attribute kan maks ha :max tegn.'
  },
  'not_in': 'Den oppgitte verdien for :attribute er ugyldig.',
  numeric: ':attribute må være et tall.',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute feltet er påkrevd.',
  required_if: ':attribute er påkrevd når :other er :value.',
  same: ':attribute og :same må være like.',
  size: {
    numeric: ':attribute må ha størrelsen :size.',
    string: ':attribute må ha :size tegn.'
  },
  string: ':attribute må være tekst.',
  url: ':attribute formatet er ugyldig.',
  regex: ':attribute formatet er ugyldig.',
  attributes: {}
};


/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Het :attribute veld moet geaccepteerd worden.',
  after: ':attribute moet een datum na :after zijn.',
  after_or_equal: 'De :attribute datum moet op of na :after_or_equal zijn.',
  alpha: 'Het :attribute veld mag alleen maar letters bevatten.',
  alpha_dash: 'Het :attribute veld mag alleen maar letters, cijfers en (liggende) streepjes bevatten.',
  alpha_num: 'Het :attribute veld mag alleen maar letters en cijfers bevatten.',
  before: ':attribute moet vòòr :before zijn.',
  before_or_equal: ':attribute moet vòòr of op :before_or_equal zijn.',
  between: 'Het :attribute veld moet tussen :min en :max liggen.',
  confirmed: 'Het :attribute veld komt niet met de bevestiging overeen.',
  email: 'Het :attribute formaat is ongeldig.',
  date: 'Het :attribute veld moet een geldige datum zijn.',
  def: 'Het :attribute veld bevat fouten.',
  digits: 'Het :attribute veld moet :digits cijfers hebben.',
  different: 'Het :attribute en :different veld moeten verschillend zijn.',
  'in': 'De gekozen waarde voor :attribute is ongeldig.',
  integer: 'Het :attribute veld moet een geheel getal zijn.',
  min: {
    numeric: 'Het :attribute veld moet minstens :min zijn.',
    string: 'Het :attribute veld moet minstens :min karakters bevatten.'
  },
  max: {
    numeric: 'Het :attribute veld mag maximaal :max zijn.',
    string: 'Het :attribute veld mag niet meer dan :max karakters bevatten.'
  },
  not_in: 'De gekozen waarde voor :attribute is ongeldig.',
  numeric: 'Het :attribute veld moet een getal zijn.',
  present: 'Het :attribute veld moet aanwezig zijn (maar mag leeg zijn).',
  required: 'Het :attribute veld moet ingevuld zijn.',
  required_if: 'Het :attribute veld moet ingevuld zijn, wanneer :other :value is.',
  required_unless: 'Het :attribute veld moet ingevuld zijn, wanneer :other niet :value is.',
  required_with: 'Het :attribute veld moet ingevuld zijn, wanneer :field niet leeg is.',
  required_with_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields niet leeg zijn.',
  required_without: 'Het :attribute veld moet ingevuld zijn, wanneer :field leeg is.',
  required_without_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields leeg zijn.',
  same: 'De :attribute en :same velden moeten overeenkomen.',
  size: {
    numeric: 'Het :attribute veld moet :size zijn.',
    string: 'Het :attribute veld moet :size karakters bevatten.'
  },
  string: 'Het :attribute veld moet een woord of zin zijn.',
  url: 'Het :attribute veld heeft een ongeldig formaat.',
  regex: 'Het :attribute veld heeft een ongeldig formaat.',
  attributes: {}
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = {
    accepted: 'Pole :attribute musi być zaakceptowane.',
    alpha: 'Pole :attribute może zawierać tylko litery.',
    alpha_dash: 'Pole :attribute moze zawierać tylko litery, myślnik i podrkeślenie.',
    alpha_num: 'Pole :attribute moze zawierac tylko znaki alfanumeryczne.',
    between: 'Pole :attribute musi mieć długość od :min do :max.',
    confirmed: 'Pole :attribute nie spełnia warunku potwierdzenia.',
    email: 'Pole :attribute ma niepoprawny format adresu email.',
    date: 'Pole :attribute musi mieć poprawny format daty.',
    def: 'Pole :attribute zawiera błędy.',
    digits: 'Pole :attribute może zawierać tylko cyfry ze zbioru :digits.',
    different: 'Pola :attribute i :different muszą się różnić.',
    'in': 'Pole :attribute musi należeć do zbioru :in.',
    integer: 'Pole :attribute musi być liczbą całkowitą.',
    min: {
        numeric: 'Pole :attribute musi być równe conajmniej :min.',
        string: 'Pole :attribute musi zawierać conajmniej :min znaków.'
    },
    max: {
        numeric: 'Pole :attribute nie moze być większe :max.',
        string: 'Pole :attribute nie moze być dłuższe niż :max znaków.'
    },
    not_in: 'Pole :attribute nie może należeć do zbioru :not_in.',
    numeric: 'Pole :attribute musi być liczbą.',
    present: 'Polu :attribute musi być obecny (ale może być pusta).',
    required: 'Pole :attribute jest wymagane.',
    required_if: 'Pole :attribute jest wymagane jeśli pole :other jest równe :value.',
    same: 'Pola :attribute i :same muszą być takie same.',
    size: {
        numeric: 'Pole :attribute musi być równe :size.',
        string: 'Pole :attribute musi zawierać :size znaków.'
    },
    string: 'Pole :attribute musi być ciągiem znaków.',
    url: 'Pole :attribute musi być poprawnym adresem URL.',
    regex: 'Pole :attribute nie spełnia warunku.',
    attributes: {}
};


/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'O :attribute precisa ser aceito.',
  alpha: 'O campo :attribute só pode conter letras.',
  alpha_dash: 'O campo :attribute só pode conter letras, números, hífens e sublinha.',
  alpha_num: 'O campo :attribute só pode conter letras e números.',
  between: 'O campo :attribute precisa estar entre :min e :max.',
  confirmed: 'A confirmação de :attribute não coincide.',
  email: 'O formato de :attribute é inválido.',
  date: 'O :attribute não é um formato de data válido',
  def: 'O atributo :attribute contém erros.',
  digits: 'O atributo :attribute precisa ter :digits dígitos.',
  different: 'O :attribute e :different precisam ser diferentes.',
  'in': 'O atributo selecionado :attribute é inválido.',
  integer: 'O :attribute precisa ser um inteiro.',
  min: {
    numeric: 'O :attribute precisa ser no mínimo :min.',
    string: 'O :attribute precisa ter no mínimo :min caracteres.'
  },
  max: {
    numeric: 'O :attribute não pode ser maior que :max.',
    string: 'O :attribute não pode ter mais que :max caracteres.'
  },
  not_in: 'O :attribute selecionado é inválido.',
  numeric: 'O :attribute precisa ser um número.',
  present: 'O campo :attribute deve estar presente (mas pode estar vazio).',
  required: 'O campo :attribute é obrigatório.',
  required_if: 'O campo :attribute é obrigatório quando :other é :value.',
  same: 'Os campos :attribute e :same precisam ser iguais.',
  size: {
    numeric: 'O :attribute precisa ser :size.',
    string: 'O :attribute precisa ter :size caracteres.'
  },
  string: 'O :attribute precisa ser uma palavra.',
  url: 'O formato de :attribute é inválido.',
  regex: 'O formato de :attribute é inválido.',
  attributes: {}
};


/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Вы должны принять :attribute.',
  alpha: 'Поле :attribute может содержать только буквы.',
  alpha_dash: 'Поле :attribute может содержать только буквы, цифры, дефисы и символы подчёркивания.',
  alpha_num: 'Поле :attribute может содержать только буквы и цифры.',
  between: 'Поле :attribute должно быть между :min и :max.',
  confirmed: 'Поле :attribute не совпадает с подтверждением.',
  email: 'Поле :attribute должно быть действительным электронным адресом.',
  def: 'Поле :attribute содержит ошибки.',
  digits: 'Длина цифрового поля :attribute должна быть :digits.',
  different: 'Поля :attribute и :different должны различаться.',
  'in': 'Выбранное значение для :attribute ошибочно.',
  integer: 'Поле :attribute должно быть целым числом.',
  min: {
    numeric: 'Значение поля :attribute должно быть больше или равно :min.',
    string: 'Количество символов в поле :attribute должно быть не менее :min.'
  },
  max: {
    numeric: 'Значение поля :attribute должно быть меньше или равно :max.',
    string: 'Количество символов в поле :attribute не может превышать :max.'
  },
  not_in: 'Выбранное значение для :attribute ошибочно.',
  numeric: 'Поле :attribute должно быть числом.',
  present: 'Поле :attribute должно присутствовать (но может быть пустым).',
  required: 'Поле :attribute обязательно для заполнения.',
  required_if: 'Поле :attribute требуется когда значения поля :other равно :value.',
  same: 'Значение :attribute должно совпадать с :same.',
  size: {
    numeric: 'Значение поля :attribute должно быть равным :size.',
    string: 'Количество символов в поле :attribute должно быть равно :size.'
  },
  url: 'Поле :attribute должно содержать валидный URL.',
  regex: 'Неверный формат поля :attribute.',
  attributes: {}
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute kabul edilmeli.',
  alpha: ':attribute alanı sadece harflerden oluşabilir.',
  alpha_dash: ':attribute alanı sadece alfa-nümerik, tire ve alt çizgi karakterlerden oluşabilir.',
  alpha_num: ':attribute alanı alfa-nümerik olmalıdır.',
  between: ':attribute alanı :min ile :max arasında olabilir.',
  confirmed: ':attribute uyuşmuyor.',
  email: ':attribute formatı geçersiz.',
  date: ':attribute geöerli bir tarih alanı değil.',
  def: ':attribute hatalar içeriyor.',
  digits: ':attribute sadece rakamlardan oluşabilir.',
  different: ':attribute ve :different farklı olmalı.',
  'in': 'Seçilen :attribute geçerli değil.',
  integer: ':attribute tam sayı olmalı.',
  min: {
    numeric: ':attribute en az :min olmalı.',
    string: ':attribute en az :min karakter uzunluğunda olmalı.'
  },
  max: {
    numeric: ':attribute en çok :max olabilir.',
    string: ':attribute uzunluğu en çok :max karakter uzunluğunda olabilir.'
  },
  not_in: 'Seçilen :attribute geçerli değil.',
  numeric: ':attribute sayı olmalı.',
  present: ':attribute alanı bulunmalıdır (ancak boş olabilir).',
  required: ':attribute alanı gerekli.',
  required_if: ':attribute alanı :other alanı :value olduğunda gerekli.',
  same: ':attribute ve :same aynı olmalı.',
  size: {
    numeric: ':attribute :size olmalı.',
    string: ':attribute :size karakter uzunluğunda olmalı.'
  },
  string: ':attribute alfa-numerik olmalı.',
  url: ':attribute formatı geçersiz.',
  regex: ':attribute formatı geçersiz.',
  attributes: {}
};


/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute повиннен бути прийнятий.',
  alpha: 'Поле :attribute може складатись тільки з літер.',
  alpha_dash: 'Поле :attribute може складатись тільки з літер, чисел, дефісів та символів підкреслення.',
  alpha_num: 'Поле :attribute може складатись тільки з літер та чисел.',
  between: 'Значення поля :attribute повинно знаходитись між :min і :max.',
  confirmed: 'Поле :attribute не співпадає з підтвердженням.',
  email: 'Значення поля :attribute повинно бути існуючою електронною адресою.',
  def: 'Поле :attribute містить помилки.',
  digits: 'Довжина числового поля :attribute повинна бути :digits.',
  different: 'Поля :attribute і :different повинні відрізнятись.',
  'in': 'Обране значення для :attribute помилкове.',
  integer: 'Значення поля :attribute повинно бути цілим числом.',
  min: {
    numeric: 'Значення поля :attribute повинно бути більшим або рівним :min.',
    string: 'Кількість символів в полі :attribute повинна бути не менше :min.'
  },
  max: {
    numeric: 'Значення поля :attribute повинно бути менше або рівне :max.',
    string: 'Кількість символів в полі :attribute не може превищувати :max.'
  },
  not_in: 'Обране значення для :attribute помилкове.',
  numeric: 'Значення поля :attribute повинно бути числом.',
  present: 'Поле :attribute повинно бути присутнім (але може бути пустим).',
  required: 'Поле :attribute обов\'язкове для заповнення.',
  required_if: 'Поле :attribute потрібне у випадку коли значення поля :other рівне :value.',
  same: 'Значеня поля :attribute повинно співпадати з :same.',
  size: {
    numeric: 'Значення поля :attribute повинно бути рівним :size.',
    string: 'Кількість символів в полі :attribute повинна бути рівною :size.'
  },
  url: 'Поле :attribute повинне містити валідний URL.',
  regex: 'Неправильний формат значення :attribute.',
  attributes: {}
};


/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute phải được chấp nhận.',
  alpha: 'Trường :attribute phải là ký tự',
  alpha_dash: ':attribute chỉ chấp nhận ký tự chữ cái, số, dấu gạch chéo và gạch dưới.',
  alpha_num: ':attribute phải là ký tự chữ cái hoặc chữ số.',
  between: ':attribute phải nằm trong khoảng :min và :max.',
  confirmed: ':attribute xác nhận không trùng khớp.',
  email: ':attribute không phải là email.',
  date: ':attribute không phải là ngày hợp lệ',
  def: 'Thuộc tính :attribute có lỗi.',
  digits: ':attribute phải là số và có chiều dài bằng :digits.',
  different: 'Giá trị của hai trường :attribute và :different phải khác nhau.',
  'in': 'Giá trị được chọn của :attribute không hợp lệ.',
  integer: ':attribute phải là số nguyên.',
  min: {
    numeric: ':attribute phải lớn hơn hoặc bằng :min.',
    string: ':attribute phải có ít nhất :min ký tự.'
  },
  max: {
    numeric: ':attribute phải nhỏ hơn hoặc bằng :max.',
    string: ':attribute phải có ít hơn :max ký tự.'
  },
  not_in: 'Giá trị được chọn của trường :attribute không hợp lệ.',
  numeric: ':attribute phải là số.',
  present: 'Trường :attribute phải có mặt (nhưng có thể để trống).',
  required: ':attribute bắt buộc nhập.',
  required_if: ':attribute là bắt buộc khi :other có giá trị :value.',
  same: 'Giá trị của :attribute và :same phải như nhau.',
  size: {
    numeric: ':attribute phải có chiều dài của bằng :size.',
    string: 'Số ký tự của :attribute phải là :size ký tự.'
  },
  string: ':attribute không phải là một chuỗi',
  url: ':attribute không phải là một Url hợp lệ.',
  regex: ':attribute không đúng định dạng',
  attributes: {}
};


/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute必须是可接受的.',
  alpha: ':attribute只能包含字母.',
  alpha_dash: ':attribute只能包含字母,连字符和下划线.',
  alpha_num: ':attribute只能包含字母和数字.',
  between: ':attribute的(大小,长度等)只能在:min和:max之间.',
  confirmed: ':attribute确认不一致.',
  email: ':attribute格式不正确.',
  date: ':attribute日期格式错误.',
  def: ':attribute属性错误.',
  digits: ':attribute必须是:digits位小数.',
  different: ':attribute和:different必须不同.',
  'in': '选择的:attribute无效',
  integer: ':attribute必须是一个整数.',
  min: {
    numeric: ':attribute不能小于:min.',
    string: ':attribute长度不能小于:min.'
  },
  max: {
    numeric: ':attribute不能大于:max.',
    string: ':attribute长度不能大于:max.'
  },
  not_in: '所选的:attribute无效.',
  numeric: ':attribute必须是一个数字.',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute不能为空.',
  required_if: '当:other是:value时,:attribute不能为空.',
  same: ':attribute和:same必须一致.',
  size: {
    numeric: ':attribute必须等于:size.',
    string: ':attribute的长度必须等于:size.'
  },
  string: ':attribute必须是一个字符串.',
  url: ':attribute格式不正确.',
  regex: ':attribute格式不正确.',
  attributes: {}
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute必須接受。',
  alpha: ':attribute只能包含字母。',
  alpha_dash: ':attribute只能包含字母，連字符和下划線。',
  alpha_num: ':attribute只能包含字母和數字。',
  between: ':attribute的值只能在:min和:max之間。',
  confirmed: ':attribute與確認輸入不一致。',
  email: ':attribute的格式錯誤。',
  date: ':attribute的日期格式錯誤。',
  def: ':attribute屬性錯誤。',
  digits: ':attribute必須是:digits位小數。',
  different: ':attribute和:different必須不同。',
  'in': '選擇的:attribute無效',
  integer: ':attribute必須是一個整數。',
  min: {
    numeric: ':attribute不能小於:min。',
    string: ':attribute的長度不能小於:min.'
  },
  max: {
    numeric: ':attribute不能大於:max。',
    string: ':attribute的長度不能大於:max.'
  },
  not_in: '所選的:attribute無效。',
  numeric: ':attribute必須是一個數字。',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute不能空白。',
  required_if: '當:other是:value時,:attribute不能空白。',
  same: ':attribute和:same必須一致。',
  size: {
    numeric: ':attribute必須等於:size。',
    string: ':attribute的長度必須等於:size.'
  },
  string: ':attribute必須是一個字串。',
  url: ':attribute格式不正確。',
  regex: ':attribute格式不正確。',
  attributes: {}
};


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_less__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var main = /** @class */ (function (_super) {
    __extends(main, _super);
    function main() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    main.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return this.props.type !== nextProps.type
            || this.props.className !== nextProps.className
            || this.props.viewAttr !== nextProps.viewAttr
            || this.props.value !== nextProps.value;
    };
    main.prototype.render = function () {
        var _a = this.props, type = _a.type, finNum = _a.finNum, className = _a.className;
        var showTds = new Array();
        if (type === 1) { //财务表头
            var _b = this.props, fontSize = _b.fontSize, label = _b.label;
            if (!fontSize)
                fontSize = "12px"; //字体大小为pt单位，默认9pt
            var headArr = ["分", "角", "元", "十", "百", "千", "万", "十", "百", "千", "亿", "十"];
            for (var i = finNum - 1; i >= 0; i--) {
                var itemBorder = "fborder1";
                if (i === 0)
                    itemBorder = "";
                else if (i === 2)
                    itemBorder = "fborder2";
                else if ((i - 2) % 3 === 0)
                    itemBorder = "fborder3";
                itemBorder = "finborder " + itemBorder;
                showTds.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td", { className: itemBorder }, headArr[i]));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "wf-findiv" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "fintop" }, label),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "finbottom" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table", { className: "fintable " + className },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr", null, showTds))),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("style", null, "." + className + " td{width:" + parseInt(fontSize.replace("pt", "")) * 2 + "px;}")));
        }
        else if (type === 2) { //财务表览
            var _c = this.props, value = _c.value, clickEvent = _c.clickEvent;
            var valArr = this.transFinancialArr(value);
            for (var i = finNum - 1; i >= 0; i--) {
                var itemBorder = "fborder1";
                if (i === 0)
                    itemBorder = "";
                else if (i === 2)
                    itemBorder = "fborder2";
                else if ((i - 2) % 3 === 0)
                    itemBorder = "fborder3";
                itemBorder = "finborder " + itemBorder;
                showTds.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td", { className: itemBorder }, valArr[i] || ""));
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "wf-findiv", onClick: clickEvent },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table", { className: "fintable " + className },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr", null, showTds))));
        }
        else
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null);
    };
    main.prototype.transFinancialArr = function (fieldVal) {
        var valArr = new Array();
        if (fieldVal === "" || fieldVal === null) {
            if (this.props.viewAttr === 3) //必填标示
                valArr.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { style: { color: "red !important", fontSize: "14px !important" } }, "*"));
            return valArr;
        }
        fieldVal = fieldVal.replace(/,/g, "");
        var reg1 = /^(-?\d+)(\.\d+)?$/;
        var reg2 = /^(-?\d*)(\.\d+)$/; //解决类型-.22这种格式
        if (reg1.test(fieldVal) || reg2.test(fieldVal)) {
            fieldVal = parseFloat(fieldVal).toFixed(2);
            if ((fieldVal.length > 2 && fieldVal.substring(0, 2) == "0.") || (fieldVal.length > 3 && fieldVal.substring(0, 3) == "-0.")) {
                fieldVal = fieldVal.replace("0.", ".");
            }
            for (var i = fieldVal.length - 1; i >= 0; i--) {
                var valc = fieldVal.charAt(i);
                if (valc != ".")
                    valArr.push(valc);
            }
        }
        return valArr;
    };
    return main;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (main);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(109),
    arrayMap = __webpack_require__(451),
    isArray = __webpack_require__(110),
    isSymbol = __webpack_require__(452);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(458),
    baseIsNaN = __webpack_require__(459),
    strictIndexOf = __webpack_require__(460);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MapPic = /** @class */ (function (_super) {
    __extends(MapPic, _super);
    function MapPic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initMapPic = function () {
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap) {
                if (!_this.map) {
                    _this.map = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Map(_this.refs._map, {
                        resizeEnable: true,
                    });
                }
                _this.map.on('click', function (e) {
                    _this.regeocoder([e.lnglat.getLng(), e.lnglat.getLat()]);
                });
                _this.geocoder(_this.props.address);
            }
            else {
                setTimeout(function () {
                    that.initMapPic();
                }, 50);
            }
        };
        _this.regeocoder = function (lnglatXY) {
            var that = _this;
            __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.plugin(['AMap.Geocoder'], function () {
                var geocoder = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Geocoder({
                    radius: 1000,
                    extensions: "all"
                });
                //已知地理坐标，逆地理编码   
                geocoder.getAddress(lnglatXY, function (status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                        that.reGeocoder_CallBack(lnglatXY, result);
                    }
                });
            });
        };
        _this.geocoder_CallBack = function (data) {
            //地理编码结果数组
            var geocode = data.geocodes;
            for (var i = 0; i < geocode.length; i++) {
                var position = [geocode[i].location.getLng(), geocode[i].location.getLat()];
                _this.addMarker(i, position, geocode[i].formattedAddress);
            }
            _this.map.setFitView();
        };
        _this.reGeocoder_CallBack = function (lnglatXY, data) {
            _this.addMarker("e", lnglatXY, data.regeocode.formattedAddress);
        };
        _this.addMarker = function (_, p, address) {
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Marker) {
                that.addMarkerAfter(_, p, address);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.plugin(['AMap.Marker'], function () {
                    that.addMarkerAfter(_, p, address);
                });
            }
        };
        _this.addMarkerAfter = function (_, p, address) {
            if (_this.marker) {
                _this.map.remove(_this.marker);
            }
            _this.marker = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Marker({
                map: _this.map,
                position: p
            });
            var infoWindow = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.InfoWindow({
                content: address,
                offset: { x: 0, y: -30 }
            });
            infoWindow.open(_this.map, _this.marker.getPosition());
            _this.marker.on("mouseover", function (_) {
                infoWindow.open(_this.map, _this.marker.getPosition());
            });
        };
        _this.geocoder = function (title) {
            var that = _this;
            if (__WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Geocoder) {
                that.geocoderAfter(title);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.plugin(['AMap.Geocoder'], function () {
                    that.geocoderAfter(title);
                });
            }
        };
        _this.geocoderAfter = function (title) {
            var geocoder = new __WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap.Geocoder({
                radius: 1000 //范围，默认：500
            });
            //地理编码,返回地理编码结果
            geocoder.getLocation(title, function (status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    _this.map.remove(_this.marker || "");
                    _this.geocoder_CallBack(result);
                }
            });
        };
        return _this;
    }
    MapPic.prototype.componentDidMount = function () {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_1__util__["default"].AMap) {
            if (!__WEBPACK_IMPORTED_MODULE_2_loadjs___default.a.isDefined('mapjs')) {
                __WEBPACK_IMPORTED_MODULE_2_loadjs___default()(["https://webapi.amap.com/maps?v=1.4.4&key=53a92850ca00d7f77aef3297effd8d59&plugin=AMap.Geocoder"], 'mapjs', {
                    success: function () {
                        _this.initMapPic();
                    }
                });
            }
        }
        else {
            this.initMapPic();
        }
    };
    MapPic.prototype.componentWillReceiveProps = function (nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(this.props.address), Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(nextProps.address))) {
            this.marker && this.map.remove(this.marker);
            this.map && this.initMapPic();
        }
    };
    MapPic.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { ref: "_map", style: { minHeight: 200 } }));
    };
    return MapPic;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (MapPic);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var PopoverTips = /** @class */ (function (_super) {
    __extends(PopoverTips, _super);
    function PopoverTips() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopoverTips.prototype.render = function () {
        var _a = this.props, label = _a.label, error = _a.error;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Popover"], { ecId: (this && this.props && this.props.ecId || '') + "_Popover@mc4517", placement: "bottomLeft", overlayClassName: "cube-card-waring", visible: error.visible, content: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "anticon anticon-exclamation-circle", style: { paddingRight: 5, color: '#f5222d' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#fe4042', fontWeight: 700, paddingRight: 5, } },
                    "\"",
                    label,
                    "\""),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, error.msg && (error.msg.replace(label, '').indexOf("needAdd") > -1 ? getLabel('383709', "未新增数据") : (error.msg.replace(label, '') ? getLabel(21423, "未填写") : "")))] }, this.props.children));
    };
    PopoverTips = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], PopoverTips);
    return PopoverTips;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (PopoverTips);


/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(35) && !__webpack_require__(57)(function () {
  return Object.defineProperty(__webpack_require__(266)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(43);
var document = __webpack_require__(38).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(58);
var toIObject = __webpack_require__(67);
var arrayIndexOf = __webpack_require__(500)(false);
var IE_PROTO = __webpack_require__(176)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(49);


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(58);
var toObject = __webpack_require__(68);
var IE_PROTO = __webpack_require__(176)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(508);
var global = __webpack_require__(38);
var hide = __webpack_require__(49);
var Iterators = __webpack_require__(92);
var TO_STRING_TAG = __webpack_require__(32)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(173);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(267);
var hiddenKeys = __webpack_require__(178).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(117);
var createDesc = __webpack_require__(90);
var toIObject = __webpack_require__(67);
var toPrimitive = __webpack_require__(171);
var has = __webpack_require__(58);
var IE8_DOM_DEFINE = __webpack_require__(265);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(35) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {



/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shallowequal__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Checkbox__ = __webpack_require__(170);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CheckboxGroup = /** @class */ (function (_super) {
    __extends(CheckboxGroup, _super);
    function CheckboxGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleOption = function (option) {
            var optionIndex = _this.state.value.indexOf(option.value);
            var value = _this.state.value.slice();
            if (optionIndex === -1) {
                value.push(option.value);
            }
            else {
                value.splice(optionIndex, 1);
            }
            if (!('value' in _this.props)) {
                _this.setState({ value: value });
            }
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(value);
            }
        };
        _this.state = {
            value: props.value || props.defaultValue || [],
        };
        return _this;
    }
    CheckboxGroup.prototype.getChildContext = function () {
        return {
            checkboxGroup: {
                toggleOption: this.toggleOption,
                value: this.state.value,
                disabled: this.props.disabled,
            },
        };
    };
    CheckboxGroup.prototype.componentWillReceiveProps = function (nextProps) {
        if ('value' in nextProps) {
            this.setState({
                value: nextProps.value || [],
            });
        }
    };
    CheckboxGroup.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !__WEBPACK_IMPORTED_MODULE_3_shallowequal___default()(this.props, nextProps) ||
            !__WEBPACK_IMPORTED_MODULE_3_shallowequal___default()(this.state, nextState);
    };
    CheckboxGroup.prototype.getOptions = function () {
        var options = this.props.options;
        // https://github.com/Microsoft/TypeScript/issues/7960
        return options.map(function (option) {
            if (typeof option === 'string') {
                return {
                    label: option,
                    value: option,
                };
            }
            return option;
        });
    };
    CheckboxGroup.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var prefixCls = props.prefixCls, className = props.className, style = props.style, options = props.options;
        var children = props.children;
        if (options && options.length > 0) {
            children = this.getOptions().map(function (option, idn) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Checkbox__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Checkbox@14hzt5@" + idn, key: option.value, disabled: 'disabled' in option ? option.disabled : props.disabled, value: option.value, checked: state.value.indexOf(option.value) !== -1, onChange: function () { return _this.toggleOption(option); }, className: prefixCls + "-item" }, option.label)); });
        }
        var classString = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls, className);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classString, style: style }, children));
    };
    CheckboxGroup.defaultProps = {
        options: [],
        prefixCls: 'cube-checkbox-group',
    };
    CheckboxGroup.propTypes = {
        defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
        value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
        options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
        onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    };
    CheckboxGroup.childContextTypes = {
        checkboxGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    };
    return CheckboxGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CheckboxGroup);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ExcelTableColgroup = /** @class */ (function (_super) {
    __extends(ExcelTableColgroup, _super);
    function ExcelTableColgroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExcelTableColgroup.prototype.render = function () {
        var excel = this.props.excel;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("colgroup", null, excel && excel.cols.slice().map(function (_a, index) {
            var size = _a.size, hide = _a.hide;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("col", { width: size, style: { display: hide && hide === "y" ? "none" : "" } }));
        })));
    };
    ExcelTableColgroup = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableColgroup);
    return ExcelTableColgroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableColgroup);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableTds__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var ExcelTableTBody = /** @class */ (function (_super) {
    __extends(ExcelTableTBody, _super);
    function ExcelTableTBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDetailTrs = function () {
            var _a = _this.props, excel = _a.excel, form = _a.form, card = _a.card, detail = _a.detail;
            var _b = excel || {}, _c = _b.edtitleinrow, edtitleinrow = _c === void 0 ? '0' : _c, _d = _b.edtailinrow, edtailinrow = _d === void 0 ? '0' : _d, _e = _b.seniorset, seniorset = _e === void 0 ? '0' : _e;
            var headRow = parseInt(edtitleinrow, 0);
            var bodyRow = parseInt(edtailinrow, 0);
            var isSeniorset = seniorset == '1';
            var _rowhead = excel.rows.slice();
            if (headRow == 0 || bodyRow == 0 || bodyRow <= headRow) {
                return ([[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, getLabel(386148, '对不起，表头标识、表尾标识设置异常，无法渲染明细！'))]]);
            }
            var detailLenth = 0;
            return excel ? _rowhead.map(function (row) {
                var rowIndex = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id);
                var trs = [];
                if (rowIndex == headRow + 1) {
                    //位于表头表尾标识之间
                    for (var j = 0; j < detailLenth; j++) {
                        for (var i = rowIndex; i < bodyRow; i++) {
                            var style_obj = {};
                            if (row.obj && row.obj['style']) {
                                style_obj = _this.getTrStyle(row.obj['style']);
                            }
                            trs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: __assign({ height: row.size }, style_obj) },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableTds__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableTds@5w91ug@" + j, excel: excel, detailIndex: j, row: Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id), card: card, form: form, detail: detail, isFixFieldDiv: false, isTitle: false })));
                        }
                    }
                    return trs;
                }
                else if (rowIndex < headRow || (isSeniorset && rowIndex > bodyRow)) {
                    var style_obj = {};
                    if (row.obj && row.obj['style']) {
                        style_obj = _this.getTrStyle(row.obj['style']);
                    }
                    trs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: __assign({ height: row.size }, style_obj) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableTds__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableTds@7olifg@" + row.id, excel: excel, row: Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id), card: card, form: form, detail: detail, isFixFieldDiv: false, isTitle: true })));
                }
                return trs;
            }) : [];
        };
        _this.renderMainTrs = function () {
            var _a = _this.props, excel = _a.excel, form = _a.form, card = _a.card, detail = _a.detail;
            var rowhead = excel ? excel.rows.slice() : [];
            return excel ? rowhead.map(function (row) {
                var style_obj = {};
                if (row.obj && row.obj['style']) {
                    style_obj = _this.getTrStyle(row.obj['style']);
                    delete row.obj['style'];
                }
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", __assign({ style: __assign({ height: row.size, display: row.obj.hide && row.obj.hide == "y" ? "none" : "table-row" }, style_obj) }, row.obj),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableTds__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableTds@jrfr1k@" + row.id, row: Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id), excel: excel, card: card, form: form, detail: detail, isFixFieldDiv: false, isTitle: false })));
            }) : [];
        };
        _this.getTrStyle = function (styleStr) {
            var styleArr = styleStr.split(';');
            var styleObj = {};
            styleArr.forEach(function (item) {
                if (item.indexOf(':') > -1) {
                    var _a = item.split(':'), key = _a[0], value = _a[1];
                    if (key) {
                        styleObj[key] = value || '';
                    }
                }
            });
            return styleObj;
        };
        _this.renderFloatImg = function () {
            var excel = _this.props.excel;
            var trs = [];
            var floatImgArr = excel.floatingObjectArray && excel.floatingObjectArray.floatingObjects;
            var imgArr = new Array();
            if (!!floatImgArr) {
                floatImgArr.map(function (imgInfo) {
                    var imgStyle = { width: imgInfo.width, height: imgInfo.height, top: imgInfo.y, left: imgInfo.x, position: 'absolute', zIndex: '999' };
                    imgArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imgInfo.src, style: imgStyle }));
                });
                var columnSize = Object.keys(excel.cols).length;
                trs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: { height: "0px" } }, [
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { colSpan: columnSize }, imgArr)
                ]));
            }
            return trs;
        };
        return _this;
    }
    ExcelTableTBody.prototype.render = function () {
        var detail = this.props.detail;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null,
            detail ? this.renderDetailTrs() : this.renderMainTrs(),
            this.renderFloatImg()));
    };
    ExcelTableTBody = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableTBody);
    return ExcelTableTBody;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableTBody);


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tagSet__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tagdata__ = __webpack_require__(530);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var Option = __WEBPACK_IMPORTED_MODULE_0_antd__["SelectNew"].Option;



var ModeTab = /** @class */ (function (_super) {
    __extends(ModeTab, _super);
    function ModeTab(props) {
        var _this = _super.call(this, props) || this;
        _this.isSelect = false;
        _this.isEdit = false;
        _this.click = function () {
            var that = _this;
            clearTimeout(_this.timer);
            _this.timer = setTimeout(function () {
                that.setState({ visible: false, addTabVisible: false, value: '', tabname: '' });
            }, 300);
        };
        _this.handleFocus = function (e) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()(_this.props.container).off('click', _this.click);
            _this.setState({ visible: false, tabname: '' });
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()(".tabsDiv .ant-select-search__field").click(); //点击添加标签要自动显示下拉框
            return false;
        };
        _this.handleFocusBlur = function (e) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()(_this.props.container).on('click', _this.click);
            _this.setState({
                focus: e.target === document.activeElement,
            });
        };
        _this.renderModal = function () {
            var TabStore = _this.props.TabStore;
            var existTabs = TabStore.existTabs;
            var btnCls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
                'ant-search-btn': true,
                'ant-search-btn-noempty': !!_this.state.value.trim(),
            });
            var searchCls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
                'ant-search-input': true,
                'ant-search-input-focus': _this.state.focus,
            });
            var tabs = TabStore.tabs;
            var options = tabs && tabs.map(function (tab, o) {
                return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Option, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Option@mr5bis@" + o, key: tab.id },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { style: { display: 'none' } }, JSON.stringify(tab)),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { title: tab.tabname, className: "cube-mode-tag wev-cube-menu-item-text", style: {
                            color: tab.color,
                            background: tab.bgcolor,
                            borderColor: tab.bdcolor,
                            width: 100
                        } }, tab.tabname),
                    tab.selected &&
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@z5n02v@" + o, type: "check", style: { color: '#1890ff', float: 'right' } }),
                    _this.props.billid == '' && _this.checkTabExist(tab.id) &&
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@mitwt7@" + o, type: "check", style: { color: '#1890ff', float: 'right' } }),
                    tab.edit && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { title: getLabel(93, "编辑"), id: "groupBtnEdit_" + tab.id, className: "wev-cube-menu-item-icon" },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", { className: "icon-coms-edit", onClick: function () { return _this.editClick(tab.tabname, tab.color, tab.bgcolor, tab.bdcolor, tab.id); } })));
            });
            return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: "tabsDiv" },
                existTabs && existTabs.map(function (tagObj, index) {
                    var tag = tagObj.tabname;
                    var id = tagObj.id;
                    var color = tagObj.color;
                    var isLongTag = tag.length > 20;
                    var tagElem = (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTag"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTag@ywhu6j@" + index, style: { color: color, backgroundColor: tagObj.bgcolor, borderColor: tagObj.bdcolor }, color: color, key: id, closable: tagObj.canDelete, afterClose: function () { return _this.handleClose(tagObj); } }, isLongTag ? tag.slice(0, 20) + "..." : tag));
                    return isLongTag ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Tooltip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tooltip@9sjc4x@" + index, title: tag, key: id }, tagElem) : tagElem;
                }),
                _this.state.tags && _this.state.tags.map(function (tagObj, index) {
                    var tag = tagObj.tabname;
                    var id = tagObj.id;
                    var color = tagObj.color;
                    var isLongTag = tag.length > 20;
                    var tagElem = (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTag"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTag@fmblxd@" + index, style: { 'border-radius': '4px', color: color, backgroundColor: tagObj.bgcolor, borderColor: tagObj.bdcolor }, color: color, key: id, closable: true, afterClose: function () { return _this.handleClose(tagObj); } }, isLongTag ? tag.slice(0, 20) + "..." : tag));
                    return isLongTag ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Tooltip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tooltip@tq0dgj@" + index, title: tag, key: id }, tagElem) : tagElem;
                }),
                _this.state.addTabVisible && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: "wev-cube-tab-dropdown" },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: "ant-search-input-wrapper", style: { width: 235 } },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Input"].Group, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Input.Group@eeex5g", className: searchCls },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["SelectNew"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectNew@u9dwgo", combobox: true, value: _this.state.value, notFoundContent: "", defaultActiveFirstOption: false, showArrow: false, filterOption: _this.selectFilterOption, onChange: _this.handleChange, onBlur: _this.handleFocusBlur, onSelect: _this.selectClick, onFocus: _this.handleFocus, autoFocus: true }, options),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: "ant-input-group-wrap" },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Popover"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Popover@17g41x", placement: "bottomRight", visible: _this.state.visible, title: _this.getTitle(), content: _this.getContent(), trigger: "click" },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@etadgr", className: btnCls, onClick: _this.add },
                                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@b65ags", type: "plus-circle-o" }))))))),
                !_this.state.addTabVisible && (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTag"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTag@nhz6w1", className: "otherTag ", onClick: _this.showInput },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@xq728b", type: "plus" }),
                    getLabel(81324, "添加标签")))));
        };
        _this.checkTabExist = function (value) {
            var result = false;
            _this.state.tags.map(function (tab) {
                if (tab.id == value) {
                    result = true;
                }
            });
            return result;
        };
        _this.getTitle = function () {
            if (_this.state.id == '') {
                return getLabel(83263, "新建标签");
            }
            else {
                return getLabel(83264, "编辑标签");
            }
        };
        _this.editClick = function (tabname, color, bgcolor, bdcolor, id) {
            _this.setState({ visible: !_this.state.visible, tabname: tabname, color: color, bgcolor: bgcolor, bdcolor: bdcolor, id: id });
            _this.isEdit = true;
        };
        _this.inputChange = function (v) { return _this.setState({ tabname: v }); };
        _this.tagSetChange = function (obj) { _this.setState(obj); };
        _this.getContent = function () {
            return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { style: { width: 250 }, className: "wev-cube-tab-form" },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@dvdqsk", label: getLabel(81323, '标签名称'), labelCol: { span: 8 }, wrapperCol: { span: 16 } },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaError"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaError@jmc8a5", tipPosition: 'bottom', error: getLabel(81323, '标签名称') + getLabel(21423, "未填写"), style: { width: "100%" }, ref: "tagAdd" },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@tstqmj", value: _this.state.tabname, onChange: _this.inputChange, viewAttr: 3 }))),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@1q2kzx", label: getLabel(500433, "样式模板"), labelCol: { span: 8 }, wrapperCol: { span: 16 } }, _this.getTagsSelectDemo()),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__tagSet__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_TagSet@b6vv7y", color: _this.state.color, bgcolor: _this.state.bgcolor, bdcolor: _this.state.bdcolor, onChange: _this.tagSetChange }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@y1z6du", label: '', labelCol: { span: 0 }, wrapperCol: { span: 24 } }, _this.state.id == '' ? //创建
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@0catqa", className: "wev-cube-tab-addButton", type: "primary", size: "large", onClick: _this.saveTab }, getLabel(125, "创建"))
                    : //编辑
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null,
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Popconfirm"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Popconfirm@2as3ks", title: getLabel('385240', "确认删除标签？"), okText: getLabel(826, "确定"), cancelText: getLabel(201, "取消"), onConfirm: _this.delTab },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@hwjmmv", className: "wev-cube-tab-delButton", type: "primary", size: "large" }, getLabel(23777, "删除"))),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@p7liu0", onClick: _this.saveTab, className: "wev-cube-tab-okButton", type: "primary", size: "large" }, getLabel(555, "完成"))))));
        };
        _this.delTab = function () {
            var _a = _this.props, billid = _a.billid, TabStore = _a.TabStore, modeid = _a.modeid;
            var parm = { id: _this.state.id, billid: billid, modeid: modeid, tablename: TabStore.tablename };
            TabStore.delSingtonTab(parm);
            clearTimeout(_this.timer);
            var tags = _this.state.tags.slice();
            tags.splice(tags.findIndex(function (item) { return item.id === _this.state.id; }), 1);
            _this.setState({ visible: !_this.state.visible, tabname: '', tags: tags });
        };
        _this.saveTab = function () {
            if (_this.state.tabname == '') {
                _this.refs.tagAdd["showError"]();
                // message.error(getLabel(384148, "必填项不能为空!"));
                return;
            }
            if (_this.state.tabname.length > 16) {
                __WEBPACK_IMPORTED_MODULE_0_antd__["message"].error(getLabel(385735, "标签名太长!"));
                return;
            }
            var _a = _this.props, billid = _a.billid, TabStore = _a.TabStore, modeid = _a.modeid;
            var parm = { id: _this.state.id, tabname: _this.state.tabname, color: _this.state.color, bgcolor: _this.state.bgcolor, bdcolor: _this.state.bdcolor, billid: billid, modeid: modeid };
            TabStore.saveSingtonTab(parm, _this.addTabForListShow);
            clearTimeout(_this.timer);
            _this.setState({ visible: !_this.state.visible, addTabVisible: false, value: '', tabname: '' });
        };
        _this.add = function (e) {
            clearTimeout(_this.timer);
            _this.setState({ visible: !_this.state.visible, id: '', key: 0, color: '#eb2f96', bgcolor: '#fff0f6', bdcolor: '#ffadd2' });
            if (_this.state.value == '') {
                _this.setState({ tabname: '' });
            }
        };
        //查询列表新建标签也要选中
        _this.addTabForListShow = function (parm) {
            if (parm.billid == '') { //如果是查询列表
                var tags = _this.state.tags.slice();
                tags.push({ id: parm.id, tabname: parm.tabname, color: parm.color, bgcolor: parm.bgcolor, bdcolor: parm.bdcolor });
                _this.setState({ tags: tags, visible: false });
            }
        };
        /**
         * 根据选择框的名称，搜索过滤选项
         * @param value
         * @param option
         */
        _this.selectFilterOption = function (value, option) {
            if (value != "") {
                var children = option["props"].children;
                if (children) {
                    var namediv = children[1]["props"].children;
                    return namediv.toLowerCase().indexOf(value.toLowerCase()) != -1;
                }
                else {
                    return false;
                }
            }
            return true;
        };
        _this.handleChange = function (value) {
            if (!_this.isSelect) {
                _this.setState({ value: value, tabname: value });
            }
            _this.isSelect = false;
        };
        _this.selectClick = function (value, option) {
            var _a = _this.props, billid = _a.billid, TabStore = _a.TabStore, modeid = _a.modeid;
            var isadd = true;
            var modelableid = '';
            var tabid = value;
            if (billid != '') {
                TabStore.existTabs.map(function (tab) {
                    modelableid += tab.id + ',';
                    if (tab.id == tabid) {
                        isadd = false;
                    }
                });
            }
            else {
                _this.state.tags.map(function (tab) {
                    if (tab.id == tabid) {
                        isadd = false;
                    }
                });
            }
            if (!_this.isEdit && isadd) {
                if (billid != '') {
                    modelableid += tabid;
                    var parm = { operate: '0', modelableid: modelableid, billid: billid, tablename: TabStore.tablename, modeid: modeid, tabid: tabid };
                    TabStore.updateDataTab(parm);
                    _this.setState({ addTabVisible: false });
                }
                else {
                    var _b = option.props, value_1 = _b.value, children = _b.children;
                    var tag = JSON.parse(children[0].props.children);
                    var tags = _this.state.tags.slice();
                    tags.push({ id: value_1, tabname: tag.tabname, color: tag.color, bgcolor: tag.bgcolor, bdcolor: tag.bdcolor });
                    _this.setState({ tags: tags, visible: false });
                }
            }
            _this.setState({ value: '' });
            _this.isSelect = true;
            _this.isEdit = false;
        };
        _this.handleClose = function (removedTag) {
            var _a = _this.props, billid = _a.billid, TabStore = _a.TabStore, modeid = _a.modeid;
            if (billid != '') { //卡片页面
                var tags = TabStore.existTabs.filter(function (tag) { return tag.tabname !== removedTag.tabname; });
                var modelableid_1 = '';
                TabStore.existTabs = tags;
                tags.map(function (tag) {
                    modelableid_1 += tag.id + ',';
                });
                modelableid_1 = modelableid_1.replace(/,$/, '');
                var parm = { operate: "1", modelableid: modelableid_1, billid: billid, tablename: TabStore.tablename, modeid: modeid, tabid: removedTag.id };
                TabStore.updateDataTab(parm);
            }
            else { //查询列表
                var tags = _this.state.tags.slice().filter(function (tag) { return (tag.id !== removedTag.id) && tag; });
                _this.setState({ tags: tags });
            }
        };
        _this.showInput = function () {
            clearTimeout(_this.timer);
            _this.setState({ addTabVisible: true, value: '' });
        };
        _this.getTagsSelectDemo = function () {
            var _a = _this.state, key = _a.key, color = _a.color, bgcolor = _a.bgcolor, bdcolor = _a.bdcolor;
            var tags = [];
            var styleTemplateKey = key; // qc#998534 当创建标签时采用样式模板标签样式，编辑时需在“样式模板”字段处选中该option
            __WEBPACK_IMPORTED_MODULE_7__tagdata__["a" /* tagsJson */].forEach(function (item, i) {
                tags.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Option, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Option@vy7vy0@" + i, key: item.key, value: item.key },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", { style: { marginRight: 5 } }, "#" + item.key),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: "cube-mode-tag", style: {
                            color: item.color,
                            background: item.bgcolor,
                            borderColor: item.bdcolor
                        } }, getLabel(176, '标签') + item.key)));
                if (key !== 0 && color === item.color && bgcolor === item.bgcolor && bdcolor === item.bdcolor) {
                    styleTemplateKey = item.key;
                }
            });
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["SelectNew"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectNew@vlkxru", value: styleTemplateKey > 0 ? styleTemplateKey : '', style: { width: '100%' }, onChange: _this.selectNewChange }, tags);
        };
        _this.selectNewChange = function (v) { _this.setState(__WEBPACK_IMPORTED_MODULE_7__tagdata__["a" /* tagsJson */][v - 1]); };
        _this.state = {
            value: '',
            focus: false,
            key: 0,
            color: '#eb2f96',
            bgcolor: '#fff0f6',
            bdcolor: '#ffadd2',
            tabname: '',
            visible: false,
            id: '',
            addTabVisible: false,
            tags: []
        };
        return _this;
    }
    ModeTab.prototype.componentDidMount = function () {
        var _a = this.props, modeid = _a.modeid, billid = _a.billid, TabStore = _a.TabStore, container = _a.container, _b = _a.type, type = _b === void 0 ? "" : _b;
        TabStore.initData(modeid, billid);
        TabStore.update({ type: type });
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(container).on('click', this.click);
    };
    ModeTab.prototype.render = function () {
        return this.renderModal();
    };
    ModeTab = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])("TabStore"),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ModeTab);
    return ModeTab;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ModeTab);


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var getKey = function (d) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(d, 'randomkey');
};
var TableStore = /** @class */ (function () {
    function TableStore() {
        var _this = this;
        this.form = null;
        this.oldDataRecord = [];
        this.columns = [];
        this.loading = false;
        this.isInit = false;
        this.isDataLoaded = false;
        this.selectedRowKeys = [];
        this.showDialog = function (column, randomkey) {
            // if (column.dialogName) {
            //     this.dialog = require(`./${column.dialogName}`).default();
            //     this.dialog.update(this);
            //     this.dialog.init(column, randomkey);
            // }
        };
        this.onSelectedRowChange = function (selectedRowKeys) {
            _this.selectedRowKeys = selectedRowKeys;
        };
        this.initTableForm = function (datas, columns) {
            if (columns === void 0) { columns = _this.columns; }
            _this.columns = columns;
            var fields = [];
            var values = {};
            fields.push("tableForm");
            fields.push("tableForm[]");
            columns.map(function (c) {
                fields.push("tableForm[]." + c.key);
            });
            var _values = datas.map(function (d) {
                var _value = {};
                columns.map(function (c) {
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(_value, c.key, '');
                });
                return __assign({}, _value, d);
            });
            _this.datas = datas.map(function (d) { return getKey(d); });
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(values, 'tableForm', _values);
            _this.form = new __WEBPACK_IMPORTED_MODULE_1__form__["a" /* default */]({ fields: fields, values: values });
            _this.isInit = true;
        };
        this.updateDatas = function (datas) {
            var tableForm = _this.form.$('tableForm');
            _this.datas = datas.map(function (d) {
                var key = getKey(d);
                return tableForm.add(d, { key: key });
            });
        };
        this.addDatas = function (datas) {
            var tableForm = _this.form.$('tableForm');
            datas.forEach(function (d) {
                var key = getKey(d);
                _this.datas.unshift(tableForm.add(d, { key: key }));
            });
        };
        this.delDatas = function (keys) {
            var tableForm = _this.form.$('tableForm');
            keys.forEach(function (key) {
                _this.datas['remove'](key);
                tableForm.del(key);
            });
        };
        this.toEdit = function (randonkey, key) {
            _this.form.$('tableForm').map(function (r) { return r.map(function (c) { return c.editable = false; }); });
            _this.form.$("tableForm." + randonkey + "." + key).editable = true;
        };
        this.toReadonly = function (randonkey, key) {
            _this.form.$("tableForm." + randonkey + "." + key).editable = false;
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TableStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TableStore.prototype, "oldDataRecord", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TableStore.prototype, "columns", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TableStore.prototype, "datas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TableStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TableStore.prototype, "isInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TableStore.prototype, "isDataLoaded", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TableStore.prototype, "selectedRowKeys", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TableStore.prototype, "showDialog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TableStore.prototype, "onSelectedRowChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TableStore.prototype, "initTableForm", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TableStore.prototype, "updateDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TableStore.prototype, "addDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TableStore.prototype, "delDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TableStore.prototype, "toEdit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TableStore.prototype, "toReadonly", void 0);
    return TableStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (TableStore);


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;
var CustomDialogStore = /** @class */ (function () {
    function CustomDialogStore() {
        var _this = this;
        this.visible = false;
        this.content = '';
        this.title = '';
        this.loading = false;
        this.okText = "";
        this.onOkFuncs = '';
        this.tempParams = {};
        this.typeName = "";
        this.height = '200';
        this.width = '200';
        this.onCancel = function () {
            _this.visible = false;
            _this.tempParams = {};
            _this.typeName = "";
        };
        this.onOk = function () {
            if (_this.onOkFuncs) {
                var run = function () {
                    eval(_this.onOkFuncs);
                };
                run.bind(_this)();
            }
            _this.onCancel();
        };
        this.setCustomDialog = function (customDialog) {
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(customDialog, function (v, k) {
                __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(_this, k, v);
            });
        };
        this.showCustomDialog = function (APIFunc, APIParams, name) {
            if (name === void 0) { name = ""; }
            var props = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                props[_i - 3] = arguments[_i];
            }
            _this.tempParams = APIParams;
            _this.typeName = name;
            APIFunc(APIParams).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, error = _a.error, errorCode = _a.errorCode, showError = _a.showError, msg = _a.message, customDialog = _a.customDialog, onOk = _a.onOk, height = _a.height, width = _a.width;
                if (status == '1') {
                    if (showError) {
                        __WEBPACK_IMPORTED_MODULE_1_antd__["Modal"].error({ content: msg, align: 'top', className: "cube-custom-dialog-error" });
                    }
                    else {
                        _this.setCustomDialog(__assign({}, props, customDialog));
                        _this.onOkFuncs = "this." + onOk + "()";
                        _this.height = height && Number(height) < 200 ? '300' : Number(height) + 100 + '';
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
            }));
        };
        this.toPrint = function () {
            if (_this.typeName == "qrCode") {
                //二维码
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].modeopenFullWindowHaveBar(Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/qrCode?modeId=" + _this.tempParams.modeId + "&customId=" + _this.tempParams.customId + "&formId=" + _this.tempParams.formId + "&billId=" + _this.tempParams.billid + "&from=card"));
            }
            else if (_this.typeName == "barCode") {
                //条形码
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].modeopenFullWindowHaveBar(Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/barCode?modeId=" + _this.tempParams.modeId + "&customId=" + _this.tempParams.customId + "&formId=" + _this.tempParams.formId + "&billId=" + _this.tempParams.billid + "&from=card"));
            }
        };
        this.okText = getLabel(382958, "确定");
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "content", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "title", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "okText", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "tempParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "typeName", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "height", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CustomDialogStore.prototype, "width", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CustomDialogStore.prototype, "onCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CustomDialogStore.prototype, "onOk", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CustomDialogStore.prototype, "setCustomDialog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CustomDialogStore.prototype, "showCustomDialog", void 0);
    return CustomDialogStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (CustomDialogStore);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;
var PaginationStore = /** @class */ (function () {
    function PaginationStore() {
        var _this = this;
        this.pageSize = 10;
        this.current = 1;
        this.total = 0;
        this.showQuickJumper = true;
        this.showSizeChanger = true;
        this.pageSizeOptions = [10, 20, 50, 100];
        this.showTotal = function (total) { return " " + (getLabel(18609, "共") + total + ' ' + getLabel(18256, "条")) + " "; };
        this.onChange = function (current, pageSize) {
            if (current === void 0) { current = _this.current; }
            if (pageSize === void 0) { pageSize = _this.pageSize; }
            _this.current = current;
            _this.pageSize = pageSize;
        };
        this.onShowSizeChange = function (current, pageSize) {
            if (current === void 0) { current = _this.current; }
            if (pageSize === void 0) { pageSize = _this.pageSize; }
            _this.current = current;
            _this.pageSize = pageSize;
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], PaginationStore.prototype, "pageSize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], PaginationStore.prototype, "current", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], PaginationStore.prototype, "total", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], PaginationStore.prototype, "showQuickJumper", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], PaginationStore.prototype, "showSizeChanger", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], PaginationStore.prototype, "pageSizeOptions", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], PaginationStore.prototype, "onChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], PaginationStore.prototype, "onShowSizeChange", void 0);
    return PaginationStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (PaginationStore);


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTableSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTableDatas; });
/* unused harmony export getTableChecks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTableCounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setTablePageSize; });
/* unused harmony export tableColSet */
/* unused harmony export exportData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);

// 第一版获取表头，已废弃
var getTableSet = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/set', 'POST', params);
};
// 获取table 全部数据
var getTableDatas = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/datas', 'POST', params);
};
// 获取table ops数据
var getTableChecks = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/checks', 'POST', params);
};
// 获取table 条目数量
var getTableCounts = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/counts', 'POST', params);
};
// 存储新的分页大小
var setTablePageSize = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/pageSize', 'POST', params);
};
// 自定义列
var tableColSet = function (params, method) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/showCol', method, params);
};
// Daochu
var exportData = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/export', "POST", params);
};


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = __waterDocumentSvg;
/* unused harmony export CreateText */
/* unused harmony export isIE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(7);



/**
 *网页加水印 svg 方式
 *
 * @export
 * @param {*} [{
 *   content = '栾俊超',
 *   width = '300px',
 *   height = '200px',
 *   opacity = '0.2',
 *   fontSize = '20px',
 *   zIndex = 1000
 * }={}]
 */
function __waterDocumentSvg(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.content, content = _c === void 0 ? '栾俊超' : _c, _d = _b.width, width = _d === void 0 ? '300px' : _d, _e = _b.height, height = _e === void 0 ? '180px' : _e, _f = _b.opacity, opacity = _f === void 0 ? '0.5' : _f, _g = _b.fontSize, fontSize = _g === void 0 ? '14px' : _g, _h = _b.fontFamily, fontFamily = _h === void 0 ? '微软雅黑' : _h, _j = _b.color, color = _j === void 0 ? '#ccc' : _j, _k = _b.zIndex, zIndex = _k === void 0 ? 1000 : _k;
    var isIe = isIE();
    var svgStr = "";
    if (!isIe) {
        svgStr = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"" + width + "\" height=\"" + height + "\">\n    <g>\n       <foreignObject width='100%' height='100%'>\n       <div xmlns='http://www.w3.org/1999/xhtml' \n         style=\"font-size: " + fontSize + "; font-family:" + fontFamily + ";color:" + color + ";opacity:" + opacity + ";\n         transform: rotate(-31deg) translate(-6px,35px);\n         -ms-transform: rotate(-31deg) translate(-6px,35px);\n         -moz-transform: rotate(-31deg) translate(-6px,35px);\n         -webkit-transform: rotate(-31deg) translate(-6px,35px);\n         -o-transform: rotate(-31deg) translate(-6px,35px);\"\n       >\n       " + content + "\n       </div>\n       </foreignObject>\n     </g>\n   </svg>";
    }
    else {
        var teSre = CreateText(content, color, opacity, fontSize, fontFamily);
        svgStr = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"" + width + "\" height=\"" + height + "\">" + teSre + "</svg>";
    }
    var base64Url = "data:image/svg+xml;base64," + __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].Base64.encode(svgStr);
    return base64Url;
}
var CreateText = function (contextStr, color, opacity, fontSize, fontFamily) {
    if (contextStr === void 0) { contextStr = "系统管理员 <br/><br/>2019-01-22  13:54:03"; }
    var strArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.compact(contextStr.split("<br/>"));
    var textArr = "";
    strArr && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(strArr, function (value, index) {
        textArr += "<text x=\"40%\" y=\"" + (50 + 5 * index) + "\" dy=\"" + (12 + 13 * index) + "px\"\n    text-anchor=\"middle\"\n    stroke=\"" + color + "\"\n    stroke-width=\"1\"\n    stroke-opacity=\"" + opacity + "\"\n    fill=\"none\"\n    transform=\"rotate(-25, 120 120)\"\n    style=\"font-size: " + fontSize + ";font-family:" + fontFamily + ";\">\n    " + value + "\n  </text>";
    });
    return textArr;
};
var isIE = function () {
    if (!!__WEBPACK_IMPORTED_MODULE_2__util__["default"].ActiveXObject || "ActiveXObject" in __WEBPACK_IMPORTED_MODULE_2__util__["default"]) {
        return true;
    }
    else {
        return false;
    }
};


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_batchAdd__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobxTable_table__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_batchAdd__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cubeUtil__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_fp__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};













var getLabel = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaLocaleProvider"].getLabel;
var BatchAddStore = /** @class */ (function () {
    function BatchAddStore() {
        var _this = this;
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.loading = false;
        this.title = '';
        this.customid = '';
        this.editTableStore = new __WEBPACK_IMPORTED_MODULE_3__mobxTable_table__["a" /* default */]();
        this.hasRight = true;
        this.visible = false;
        this.bathAddExpendname = '';
        this.isButtonClick = true;
        this.params = {};
        this.secretTimeDefValue = { 1: "20年", 2: "10年" };
        this.isOpenClassprotect = false; // 是否开启分级保护
        this.defalutSeclevel = ''; // 默认密级
        this.init = function () {
            _this.getIconInfo(_this.customid);
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__apis_batchAdd__["a" /* getColumnInfo */](__assign({}, _this.params, { customid: _this.customid })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, dataList = _a.dataList, optionsMap = _a.optionsMap, browserMap = _a.browserMap, title = _a.title, hasRight = _a.hasRight, uploadMap = _a.uploadMap, bathAddExpendname = _a.bathAddExpendname, secretTimeDefValue = _a.secretTimeDefValue, isOpenClassprotect = _a.isOpenClassprotect, defalutSeclevel = _a.defalutSeclevel;
                if (status == '1') {
                    _this.bathAddExpendname = bathAddExpendname;
                    _this.secretTimeDefValue = secretTimeDefValue;
                    _this.isOpenClassprotect = isOpenClassprotect;
                    _this.defalutSeclevel = defalutSeclevel;
                    if (dataList.length == 0) {
                        __WEBPACK_IMPORTED_MODULE_5_antd__["message"].warn(getLabel(510166, '新增列表字段定义中批量新增没有勾选，请联系管理员处理！'));
                        _this.loading = false;
                    }
                    _this.hasRight = hasRight;
                    if (hasRight) {
                        var hasSeclevel = __WEBPACK_IMPORTED_MODULE_12_lodash_fp___default.a.flowRight(__WEBPACK_IMPORTED_MODULE_12_lodash_fp___default.a.size, __WEBPACK_IMPORTED_MODULE_12_lodash_fp___default.a.filter(function (item) { return item.fieldid == '-9'; }));
                        if (hasSeclevel(dataList) > 0) {
                            dataList.push({ colwidth: "0", editable: "0", fielddbtype: "integer", fieldhtmltype: "1", fieldid: "-10", fieldlabel: getLabel('131188', '保密期限'), fieldname: "modesecrettime", qfws: 0, textheight: 0, type: "1", viewtype: "" });
                        }
                        _this.title = title;
                        _this.editTableStore.initTableForm([], Object(__WEBPACK_IMPORTED_MODULE_4__data_batchAdd__["a" /* getColumns */])(dataList, optionsMap, browserMap, _this.editTableStore, uploadMap, _this.buildsqlkey(dataList)));
                        _this.addNewData();
                        // 判断
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
            }));
        };
        this.save = function (callback) {
            if (_this.isButtonClick == false) {
                return;
            }
            if (_this.loading) {
                return;
            }
            var datas = _this.editTableStore.form.$("tableForm").values();
            //重复验证
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].batchEditGetVerifyField({ customid: _this.customid }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, result = _a.result;
                if (status == '1') {
                    if (result && result.VerifyField && result.VerifyField.length > 0) {
                        var fields_1 = '';
                        result.VerifyField.forEach(function (element) {
                            fields_1 += element.fieldids + ',';
                        });
                        if (fields_1 == '') {
                            _this.doSave(datas, callback);
                        }
                        var fieldArray = fields_1.split(',');
                        var verifyDataObj = new Array();
                        var columns_1 = _this.editTableStore.columns;
                        __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.reverse(datas).forEach(function (item, index) {
                            var fieldvalues = {};
                            fieldArray.forEach(function (fieldid, index) {
                                columns_1.forEach(function (element) {
                                    if (element.fieldid == fieldid) {
                                        fieldvalues['pluginName' + fieldid] = item[element.key];
                                    }
                                });
                            });
                            fieldvalues[result.primaryKeyPluginName] = item['randomFieldId'];
                            if (result.detailPrimaryKeyPluginName) {
                                fieldvalues[result.detailPrimaryKeyPluginName] = item['randomFieldSubKeyd_id'];
                            }
                            fieldvalues['^_^rownum^_^'] = index;
                            verifyDataObj.push(fieldvalues);
                        });
                        var jsonstr = JSON.stringify(verifyDataObj);
                        __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].batchEditVerifyData({
                            customid: _this.customid,
                            data: jsonstr,
                            isBathAdd: '1'
                        }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                            var error = _a.error, status = _a.status, result = _a.result, colorMap = _a.colorMap;
                            if (status == '1') {
                                _this.checkFail(result, _this.doSave, datas, columns_1, colorMap, callback);
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                                if (callback) {
                                    callback();
                                }
                                throw error;
                            }
                        }));
                    }
                    else {
                        _this.doSave(datas, callback);
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    if (callback) {
                        callback();
                    }
                    throw error;
                }
                //this.loading=false;
                //  if(callback){callback()} 
            }));
        };
        // 校验密级字段必填
        this.doVerifySeclevel = function () {
            var datas = _this.editTableStore.form.$('tableForm').values();
            var isEmpty = false;
            for (var i = 0, len = datas.length; i < len; i++) {
                if (datas[i].hasOwnProperty('seclevel') && !datas[i].seclevel) {
                    isEmpty = true;
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(getLabel('530631', '密级字段不能为空！'));
                    return isEmpty;
                }
                if (datas[i].hasOwnProperty('seclevel') && ['1', '2'].indexOf(datas[i].seclevel) > -1 &&
                    datas[i].hasOwnProperty('modesecrettime') && !datas[i].modesecrettime) {
                    isEmpty = true;
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(getLabel('530632', '保密期限不能为空！'));
                    return isEmpty;
                }
            }
            return isEmpty;
        };
        //重复验证返回信息处理
        this.checkFail = function (result, func, data, columns, colorMap, callback) {
            if (result.verify || result.confirmbefore && result.confirmbefore.verify) {
                if (callback) {
                    callback();
                }
                ;
                __WEBPACK_IMPORTED_MODULE_10_jquery___default()(__WEBPACK_IMPORTED_MODULE_10_jquery___default()('.cube-table-fixed')[1]).find('td').css('backgroundColor', '');
                var detail = result.detail;
                detail && detail.forEach(function (elem, index) {
                    var columnsIndex = elem.fields.map(function (element) {
                        return __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.findIndex(columns, function (o) {
                            var fieldname = element.detailtable ? 'd_' + element.fieldname : element.fieldname;
                            return o['key'] == fieldname;
                        });
                    });
                    var tableNode = Object(__WEBPACK_IMPORTED_MODULE_8__cubeUtil__["getCurrentWindow"])().document.getElementsByClassName('cube-table-fixed')[1];
                    if (elem.rownums != null && elem.rownums != undefined && elem.rownums.constructor == Number)
                        elem.rownums = [elem.rownums];
                    elem.rownums && (elem.rownums.constructor == Array) && elem.rownums.forEach(function (rowNum) {
                        columnsIndex.forEach(function (columnNum) {
                            if (columnNum >= 0) {
                                columnNum += 1;
                                if (tableNode && tableNode.rows && tableNode.rows[rowNum] && tableNode.rows[rowNum].cells[columnNum]) {
                                    tableNode.rows[rowNum].cells[columnNum].style.backgroundColor = colorMap[elem.verifyid];
                                }
                            }
                        });
                    });
                });
                var operate = result.operate || result.confirmbefore && result.confirmbefore.operate;
                if (!operate) {
                    operate = '0';
                }
                if (operate == '0') {
                    var that_1 = _this;
                    __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].info({
                        title: getLabel(558, '提示'),
                        content: React.createElement("div", { dangerouslySetInnerHTML: { __html: result.msg } }),
                        onOk: function () {
                            that_1.loading = false;
                            that_1.isButtonClick = true;
                        },
                    });
                }
                else {
                    if (result.confirmbefore) {
                        var that_2 = _this;
                        _this.checkFail(result.confirmbefore, function () {
                            __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].confirm({
                                title: React.createElement("div", { dangerouslySetInnerHTML: { __html: result.msg || '是否继续？' } }),
                                okText: getLabel(382958, '继续'),
                                cancelText: getLabel(201, '取消'),
                                onOk: function () {
                                    func && func(data, callback);
                                },
                                onCancel: function () {
                                    that_2.loading = false;
                                    that_2.isButtonClick = true;
                                }
                            });
                        }, data, columns, colorMap);
                    }
                    else {
                        var that_3 = _this;
                        __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].confirm({
                            title: React.createElement("div", { dangerouslySetInnerHTML: { __html: result.msg } }),
                            okText: getLabel(382958, '继续'),
                            cancelText: getLabel(201, '取消'),
                            onOk: function () {
                                func && func(data, callback);
                            },
                            onCancel: function () {
                                that_3.loading = false;
                                that_3.isButtonClick = true;
                            }
                        });
                    }
                }
            }
            else {
                _this.doSave(data, callback);
            }
        };
        this.doSave = function (data, callback) {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__apis_batchAdd__["b" /* saveDatas */](__assign({}, _this.params, { customid: _this.customid, datas: JSON.stringify(_this.editTableStore.form.$("tableForm").values()) })).then(function (_a) {
                var error = _a.error, status = _a.status, errorCode = _a.errorCode, pageExpendResult = _a.pageExpendResult;
                if (status == '1') {
                    if (errorCode == '-1') {
                        __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    }
                    else {
                        try {
                            var searchTemp = window['cubeStore']['Search'];
                            var isTreeList = searchTemp && searchTemp.dataShowtype === 'treeType' && searchTemp.changeSearch == '1'; // 分组包含 组合转换，单独判断
                            if (isTreeList) {
                                searchTemp.refresh();
                            }
                            else {
                                if (searchTemp && searchTemp.isFromViewResource) { // 资源面板
                                    searchTemp.cubeViewResource && searchTemp.cubeViewResource.query();
                                }
                                else {
                                    // window['_table'].reLoad();
                                    searchTemp.reloadBaseList();
                                }
                            }
                        }
                        catch (e) {
                            window['cubeStore']['Search'].refresh();
                        }
                        // window['_table'].reLoad();
                        if (pageExpendResult && pageExpendResult.haveError) {
                            Object(__WEBPACK_IMPORTED_MODULE_7__util_cubeUtil__["h" /* showExpendError */])(pageExpendResult, _this.getHref());
                            return;
                        }
                        __WEBPACK_IMPORTED_MODULE_5_antd__["message"].success(getLabel(30700, '操作成功'));
                        _this.visible = false;
                        if (callback) {
                            callback();
                        }
                        _this.editTableStore.initTableForm([]);
                        _this.editTableStore.selectedRowKeys = [];
                        _this.addNewData();
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
                _this.isButtonClick = true;
            });
        };
        this.getHref = function () {
            var href = Object(__WEBPACK_IMPORTED_MODULE_9__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/search?customid=" + _this.customid + "&");
            return href;
        };
        this.buildsqlkey = function (dataList) {
            var sqlNeedKey = { randomkey: new Date().getTime() };
            dataList.map(function (item) {
                __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.set(sqlNeedKey, item.fieldname, item.sqlNeedFieldKey);
            });
            return sqlNeedKey;
        };
        this.addNewData = function (data) {
            if (data === void 0) { data = {}; }
            var newData = { randomkey: new Date().getTime() };
            _this.editTableStore.columns.forEach(function (item) {
                newData[item.key] = item['fieldhtmltype'] != "6" && data[item.key] ? data[item.key] : '';
                newData[item.key + 'span'] = item['fieldhtmltype'] != "6" && data[item.key + 'span'] ? data[item.key + 'span'] : '';
            });
            _this.editTableStore.addDatas([newData]);
        };
        this.deleteData = function () {
            _this.editTableStore.delDatas(_this.editTableStore.selectedRowKeys);
            _this.editTableStore.selectedRowKeys = [];
        };
        this.copyData = function () {
            _this.editTableStore.selectedRowKeys.forEach(function (key) {
                _this.addNewData(_this.editTableStore.form.$("tableForm." + key).values());
            });
        };
        this.getIconInfo = function (customid) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getAppInfoByID({ customid: customid }).then(function (data) {
                if (data.status == "1") {
                    _this.iconInfo = {
                        icon: data.icon || "icon-coms-ModelingEngine",
                        iconColor: data.iconColor || "#fff",
                        iconBg: data.iconBg || "#96358a"
                    };
                }
            });
        };
        this.update = function (param) {
            for (var key in param) {
                if (param.hasOwnProperty(key)) {
                    _this[key] = param[key];
                }
            }
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "title", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "customid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "editTableStore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "hasRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "isfrontmultlang", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "bathAddExpendname", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "isButtonClick", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "secretTimeDefValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "isOpenClassprotect", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchAddStore.prototype, "defalutSeclevel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchAddStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchAddStore.prototype, "save", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchAddStore.prototype, "doSave", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchAddStore.prototype, "addNewData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchAddStore.prototype, "deleteData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchAddStore.prototype, "copyData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchAddStore.prototype, "getIconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchAddStore.prototype, "update", void 0);
    return BatchAddStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (BatchAddStore);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColumnInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveDatas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var newUrl = '/api/cube/batchadd/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                resolve(__assign({ noRight: noRight }, data));
            }
            else {
                resolve(data);
            }
        });
    });
};
var getColumnInfo = function (params) {
    return CallAPI(newUrl + "getColumnInfo", "get", params);
};
var saveDatas = function (params) {
    return CallAPI(newUrl + "saveDatas", "post", params);
};


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export url */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return columns; });
/* unused harmony export datas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return columnWidth; });
/* unused harmony export rowHeight */
/* unused harmony export getRowHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTableCounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setTablePageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDataAndTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cellColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCellColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkColorIsChange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);

var url = '/api/cube/excelsearch';
var columns = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/columns", "get", params);
};
var datas = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/datas', 'post', params);
};
var columnWidth = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/columnWidth", "post", params);
};
var rowHeight = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/rowHeight", "post", params);
};
var getRowHeight = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/rowHeight", "get", params);
};
// 获取table 条目数量
var getTableCounts = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/counts', 'POST', params);
};
// 存储新的分页大小
var setTablePageSize = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi('/api/ec/dev/table/pageSize', 'POST', params);
};
//获取数据和时间 
var getDataAndTime = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/getDataAndTime", "post", params);
};
//保存颜色
var cellColor = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/cellColor", "post", params);
};
//获取颜色数据
var getCellColor = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/getCellColor", "get", params);
};
//校验颜色是否过期
var checkColorIsChange = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/checkColorIsChange", "post", params);
};


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExcelStore__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldCellType__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_excel_layout_cell_field_input_element_wf_form_input_util__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var convertToThousand = function (value) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__components_excel_layout_cell_field_input_element_wf_form_input_util__["f" /* judgeIsNumber */])(value)) {
        return value;
    }
    var index = value.indexOf(".");
    var intPar = index > -1 ? value.substring(0, index) : value;
    var pointPar = index > -1 ? value.substring(index) : "";
    var reg1 = /(-?\d+)(\d{3})/;
    while (reg1.test(intPar)) {
        intPar = intPar.replace(reg1, "$1,$2");
    }
    return intPar + pointPar;
};
var getHtmlText = function (value) {
    var div = document.createElement('div');
    div.innerHTML = value;
    return div.innerText || div.textContent;
};
/* harmony default export */ __webpack_exports__["a"] = (function (column, editable) {
    if (editable === void 0) { editable = false; }
    var typeName = column.typeName, type = column.type;
    var isText = typeName === __WEBPACK_IMPORTED_MODULE_1__FieldCellType__["a" /* FieldTypeName */].Text;
    var isInt = typeName === __WEBPACK_IMPORTED_MODULE_1__FieldCellType__["a" /* FieldTypeName */].Int;
    var isFloat = typeName === __WEBPACK_IMPORTED_MODULE_1__FieldCellType__["a" /* FieldTypeName */].Float;
    var isThousand = typeName === __WEBPACK_IMPORTED_MODULE_1__FieldCellType__["a" /* FieldTypeName */].Thousand;
    var isMoney = typeName === __WEBPACK_IMPORTED_MODULE_1__FieldCellType__["a" /* FieldTypeName */].Money;
    var Type = /** @class */ (function (_super) {
        __extends(Type, _super);
        function Type() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.itemWidth = {};
            return _this;
        }
        Type.prototype.paint = function (ctx, value, x, y, w, h, style, context) {
            try {
                ctx.clearRect(x, y, w, h);
                if (!editable && Object(__WEBPACK_IMPORTED_MODULE_1__FieldCellType__["e" /* getHreflink */])(value)) {
                    style.foreColor = __WEBPACK_IMPORTED_MODULE_1__FieldCellType__["h" /* linkedColor */];
                    style.textDecoration = GC.Spread.Sheets.TextDecorationType.underline;
                    var row = context.row;
                    this.itemWidth[row] = parseInt(ctx.measureText(Object(__WEBPACK_IMPORTED_MODULE_1__FieldCellType__["f" /* getInputValue */])(value)).width.toString());
                }
                if (column.column.toLowerCase() === 'modedatacreatedate') {
                    value = { "value": value };
                }
                if (column.column.toLowerCase() === 'modedatamodifydatetime') {
                    value = { "value": value };
                }
                if (column.column.toLowerCase() === 'modelableid') {
                    value = { "value": value };
                }
                if (column.column.toLowerCase() === 'modedatastatus') {
                    value = { "value": value };
                }
                if (column['htmltype'] == '2' && type == '2') { //多行文本html去除标签
                    value = __assign({}, value, { "value": getHtmlText(Object(__WEBPACK_IMPORTED_MODULE_1__FieldCellType__["f" /* getInputValue */])(value)) });
                }
                _super.prototype.paint.call(this, ctx, value, x, y, w, h, style, context);
                if (editable) {
                    var sheet = context.sheet, row = context.row, col = context.col;
                    if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(sheet.modifyedValues, __WEBPACK_IMPORTED_MODULE_0__ExcelStore__["a" /* StoreFuncs */].getRandomId(row) + "." + col)) {
                        ctx.drawImage(__WEBPACK_IMPORTED_MODULE_1__FieldCellType__["c" /* dotPngImg */], x, y, 8, 8);
                    }
                }
            }
            catch (e) {
            }
        };
        Type.prototype.getAutoFitWidth = function (value, text, cellStyle, zoomFactor, context) {
            return _super.prototype.getAutoFitWidth.call(this, value, text, cellStyle, zoomFactor, context);
        };
        Type.prototype.createEditorElement = function (context) {
            return _super.prototype.createEditorElement.call(this, context);
        };
        Type.prototype.setEditorValue = function (editorContext, value, context) {
            var inputValue = Object(__WEBPACK_IMPORTED_MODULE_1__FieldCellType__["f" /* getInputValue */])(value);
            if (isThousand) {
                return _super.prototype.setEditorValue.call(this, editorContext, inputValue ? inputValue.replace(/,/g, '') : inputValue, context);
            }
            else {
                return _super.prototype.setEditorValue.call(this, editorContext, inputValue, context);
            }
        };
        Type.prototype.getEditorValue = function (editorContext, context) {
            var sheet = context.sheet, row = context.row, col = context.col;
            var value = sheet.getValue(row, col);
            var hreflink = Object(__WEBPACK_IMPORTED_MODULE_1__FieldCellType__["e" /* getHreflink */])(value);
            var inputValue = '';
            if (isThousand) {
                inputValue = convertToThousand(_super.prototype.getEditorValue.call(this, editorContext, context));
            }
            else {
                inputValue = _super.prototype.getEditorValue.call(this, editorContext, context);
            }
            return JSON.stringify({
                hreflink: hreflink,
                value: inputValue
            });
        };
        Type.prototype.format = function (value, format, formattedData, context) {
            var inputValue = Object(__WEBPACK_IMPORTED_MODULE_1__FieldCellType__["f" /* getInputValue */])(value);
            if (editable || isText || isInt || isFloat) {
                return inputValue;
            }
            else if (isThousand) {
                return convertToThousand(inputValue);
            }
            else if (isMoney) {
                if ("****" == inputValue) {
                    return "****";
                }
                return Object(__WEBPACK_IMPORTED_MODULE_3__components_excel_layout_cell_field_input_element_wf_form_input_util__["b" /* convertAmountChinese */])(inputValue);
            }
        };
        Type.prototype.processMouseUp = function (hitInfo) {
            if (editable) {
                return _super.prototype.processMouseUp.call(this, hitInfo);
            }
            var _a = hitInfo, sheet = _a.sheet, row = _a.row, col = _a.col, sheetArea = _a.sheetArea, isReservedLocation = _a.isReservedLocation;
            if (isReservedLocation) {
                var hreflink = Object(__WEBPACK_IMPORTED_MODULE_1__FieldCellType__["e" /* getHreflink */])(sheet.getValue(row, col, sheetArea));
                if (hreflink) {
                    window.cubeOpenHreflinkFromExcel(hreflink);
                }
            }
            return true;
        };
        Type.prototype.getHitInfo = function (x, y, cellStyle, cellRect, context) {
            var row = context.row, col = context.col, sheetArea = context.sheetArea, sheet = context.sheet;
            var info = {
                x: x,
                y: y,
                row: row,
                col: col,
                cellRect: cellRect,
                sheetArea: sheetArea,
                sheet: sheet,
                isReservedLocation: !editable && x - cellRect.x <= this.itemWidth[row]
            };
            return info;
        };
        Type.prototype.processMouseMove = function (hitInfo) {
            var _a = hitInfo, sheet = _a.sheet, isReservedLocation = _a.isReservedLocation;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";
            var canvas = __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#" + canvasId)[0];
            if (sheet && isReservedLocation) {
                canvas.style.cursor = 'pointer';
                return true;
            }
            else {
                canvas.title = "";
                canvas.style.cursor = 'default';
            }
            return false;
        };
        ;
        return Type;
    }(GC.Spread.Sheets.CellTypes.Text));
    return Type;
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__doSubmit__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cubeUtil__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_contentPath__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};











var getParent = __WEBPACK_IMPORTED_MODULE_8_ecCom__["WeaTools"].WindowFunc.getParent;
var getLabel = __WEBPACK_IMPORTED_MODULE_8_ecCom__["WeaLocaleProvider"].getLabel;
var Actions = /** @class */ (function () {
    function Actions(card) {
        var _this = this;
        this.runCustomAction = function (pageexpandid, rVisible) {
            try {
                var func = _this.card.cardTab.getRightMenu(pageexpandid).function;
                if (func) {
                    var jsMehtod = func.replace('javascript:', 'this.');
                    if (jsMehtod.endsWith("()")) {
                        jsMehtod = jsMehtod.split(")").join('') + "'" + pageexpandid + "')";
                    }
                    if (rVisible) {
                        jsMehtod = jsMehtod.split(")").join('') + "," + rVisible + ")";
                    }
                    if (jsMehtod.indexOf("doSubmit") > 0) { //新建保存，编辑保存，处理判断回调函数
                        var callbackContent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.card.cardTab.urlMap, pageexpandid);
                        // let callbackContent = `/*****fdsafds */function a(id){alert(id);console.log('55')}`;
                        if (callbackContent) {
                            var index = callbackContent.lastIndexOf("*/");
                            if (index >= 0) {
                                callbackContent = callbackContent.substring(index + 2);
                            }
                            var callbackfn = callbackContent;
                            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(callbackfn)) {
                                jsMehtod = jsMehtod.split(")").join('') + ",'',false," + callbackfn + ")";
                                eval(jsMehtod);
                                return;
                            }
                        }
                    }
                    eval(jsMehtod);
                }
            }
            catch (e) {
                __WEBPACK_IMPORTED_MODULE_0_antd__["message"].error("出错:" + e);
                _this.card.cardTab.disabled = false;
            }
        };
        this.toEdit = function (pageexpandid) {
            _this.doInterfacesAction(_this.card.base.billid, pageexpandid, function () {
                _this.changeViewType('2');
            });
        };
        this.doPrint = function (pageexpandid) {
            _this.doInterfacesAction(_this.card.base.billid, pageexpandid, function () {
                _this.changeViewType('4', __WEBPACK_IMPORTED_MODULE_2__util__["default"].openFullWindowHaveBar);
            });
        };
        this.doBack = function () {
            _this.changeViewType('0');
        };
        this.toDel = function (pageexpandid, callBack, rVisible) {
            __WEBPACK_IMPORTED_MODULE_0_antd__["Modal"].confirm({
                content: getLabel(383710, '您是否要删除该条数据？'),
                title: getLabel(131329, '信息确认'),
                onOk: function () {
                    _this.deleteData(__assign({}, _this.card.params, { operate: 'DeleteAction', billids: _this.card.params.billid, pageexpandid: pageexpandid }), function () {
                        if (rVisible) {
                            rVisible();
                        }
                        else if (getParent() && !__WEBPACK_IMPORTED_MODULE_2__util__["default"].opener && !__WEBPACK_IMPORTED_MODULE_2__util__["default"]._cubeCard) {
                            if (typeof (getParent()['slideflgfun']) == 'function') {
                                if (getParent()['slideflgfun']()) {
                                    getParent()['openSlideModalDel']("", "", "");
                                }
                            }
                        }
                        else {
                            if (__WEBPACK_IMPORTED_MODULE_2__util__["default"]._cubeCard && __WEBPACK_IMPORTED_MODULE_2__util__["default"]._cubeCard.delCard) { //外部调用编辑方法，例如：合同使用建模卡片，操作之后
                                __WEBPACK_IMPORTED_MODULE_2__util__["default"]._cubeCard.delCard();
                                return;
                            }
                            var _a = _this.card.params, boardid = _a.boardid, boardgroup = _a.boardgroup, boardcustomid = _a.boardcustomid, viewfrom = _a.viewfrom;
                            if (boardid && boardgroup && boardcustomid) {
                                if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener.cubeStore) {
                                    __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener.cubeStore.boardStore.doSearch();
                                }
                            }
                            else if (viewfrom == 'fromboarditem' && __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener.cubeStore) {
                                __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener.cubeStore.boardStore.doSearch();
                            }
                            else {
                                //--------------打开的列表数据回调刷新页面-----
                                _this.card.cardTab.disabled = false;
                                if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener._table && __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener._table.reLoad) {
                                    __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener._table.reLoad();
                                }
                                else if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener.cubeStore) {
                                    __WEBPACK_IMPORTED_MODULE_2__util__["default"].opener.cubeStore.Search.refresh();
                                }
                            }
                            __WEBPACK_IMPORTED_MODULE_2__util__["default"].close();
                        }
                    });
                }
            });
        };
        this.deleteData = function (params, callback) {
            __WEBPACK_IMPORTED_MODULE_5__apis__["a" /* default */].deleteData(params).then(function (_a) {
                var status = _a.status, error = _a.error, data = __rest(_a, ["status", "error"]);
                if (status == '1') {
                    if (data.pageExpendResult && data.pageExpendResult.flag == "false") {
                        __WEBPACK_IMPORTED_MODULE_0_antd__["Modal"].error({
                            content: data.pageExpendResult.errmsg
                        });
                        return;
                    }
                    callback(data);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_0_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.doSubNew = function (pageexpandid, issystemflag) {
            _this.doSubmit(pageexpandid, issystemflag, '3');
        };
        this.doSubCopy = function (pageexpandid, issystemflag) {
            _this.doSubmit(pageexpandid, issystemflag, '4');
        };
        this.viewLog = function (pageexpandid) {
            var billid = _this.card.params.billid;
            _this.doInterfacesAction(billid, pageexpandid, function () {
                __WEBPACK_IMPORTED_MODULE_4__cubeUtil__["default"].viewLog(billid, _this.card.base.modeName, _this.card.base.modeId, '');
            });
        };
        this.doShare = function (pageexpandid) {
            var billid = _this.card.params.billid;
            _this.doInterfacesAction(billid, pageexpandid, function () {
                _this.card.share.update({
                    singleVisible: true,
                    billid: _this.card.params.billid
                });
            });
        };
        this.doImportDetail = function (id, issystemflag) {
            if (!_this.card.base.billid) {
                __WEBPACK_IMPORTED_MODULE_0_antd__["Modal"].confirm({
                    title: getLabel(82873, '请确认'),
                    content: React.createElement("div", { dangerouslySetInnerHTML: { __html: getLabel(383711, "您还未保存数据，是否保存?") } }),
                    onOk: function () {
                        _this.doSubmit(id, issystemflag, "5", false);
                    }
                });
            }
            else {
                _this.card.showDetailImport();
            }
        };
        //生成二维码
        this.createQRCode = function (pageexpandid) {
            var menuName = _this.card.cardTab.getRightMenu(pageexpandid).menuName;
            _this.doInterfacesAction(_this.card.base.billid, pageexpandid, function () {
                _this.card.customDialog.showCustomDialog(__WEBPACK_IMPORTED_MODULE_6__apis_card__["A" /* getQRCode */], _this.card.base, "qrCode", menuName);
            });
        };
        //生成条形码
        this.createBARCode = function (pageexpandid) {
            var menuName = _this.card.cardTab.getRightMenu(pageexpandid).menuName;
            _this.doInterfacesAction(_this.card.base.billid, pageexpandid, function () {
                _this.card.customDialog.showCustomDialog(__WEBPACK_IMPORTED_MODULE_6__apis_card__["m" /* getBarCode */], _this.card.base, "barCode", menuName);
            });
        };
        this.windowOpenOnSelf = function (pageexpandid) {
            _this.secondConfirmPrompt(pageexpandid, function () {
                _this.doInterfacesAction(_this.card.base.billid, pageexpandid, function () {
                    var hreftarget = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.card.cardTab.urlMap, pageexpandid);
                    if (hreftarget) {
                        hreftarget = hreftarget.replace(/\+/g, "%2B");
                        __WEBPACK_IMPORTED_MODULE_2__util__["default"].location.href = Object(__WEBPACK_IMPORTED_MODULE_10__util_contentPath__["a" /* getContentPath */])(hreftarget);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_antd__["message"].error(getLabel('383713', "链接不存在"));
                    }
                });
            });
        };
        this.windowOpenOnNew = function (pageexpandid) {
            _this.secondConfirmPrompt(pageexpandid, function () {
                _this.doInterfacesAction(_this.card.base.billid, pageexpandid, function () {
                    var hreftarget = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.card.cardTab.urlMap, pageexpandid);
                    if (hreftarget) {
                        hreftarget = hreftarget.replace(/\+/g, "%2B");
                        __WEBPACK_IMPORTED_MODULE_2__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_10__util_contentPath__["a" /* getContentPath */])(hreftarget));
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_antd__["message"].error(getLabel('383713', "链接不存在"));
                    }
                });
            });
        };
        this.doCustomFunction = function (pageexpandid) {
            _this.secondConfirmPrompt(pageexpandid, function () {
                _this.doInterfacesAction(_this.card.base.billid, pageexpandid, function () {
                    var hreftarget = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.card.cardTab.urlMap, pageexpandid);
                    // hreftarget = hreftarget.replace(/\+/g, "%2B");   //将+ 号转换成%2B
                    if (hreftarget) {
                        try {
                            eval(hreftarget);
                        }
                        catch (e) {
                            console && console.log(e);
                            // message.error(getLabel('383714',"链接错误"))
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_antd__["message"].error(getLabel('383713', "链接不存在"));
                    }
                });
            });
        };
        //二次确认提示
        this.secondConfirmPrompt = function (pageexpandid, callBackFun) {
            var confirmContent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.card.cardTab.confirmMap, pageexpandid);
            if (confirmContent !== '' && confirmContent !== undefined) {
                confirmContent = _this.getConfirmInfo(confirmContent);
                if (confirmContent == '') {
                    return;
                }
            }
            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(confirmContent)) { //页面扩展得二次确认提示
                __WEBPACK_IMPORTED_MODULE_0_antd__["Modal"].confirm({
                    title: React.createElement("div", { dangerouslySetInnerHTML: { __html: confirmContent } }),
                    okText: getLabel(382958, '继续'),
                    cancelText: getLabel(201, '取消'),
                    onOk: function () {
                        callBackFun();
                    },
                    onCancel: function () { },
                });
                return;
            }
            callBackFun();
            return true;
        };
        this.getConfirmInfo = function (confirmContent) {
            var info = '';
            if (confirmContent.startsWith('javascript:getConfirmMessage')) {
                var str = confirmContent.substring(confirmContent.indexOf('{') + 1, confirmContent.indexOf('}'));
                str = str.replace('return', '');
                try {
                    info = eval(str);
                }
                catch (e) {
                    __WEBPACK_IMPORTED_MODULE_0_antd__["message"].error(getLabel('511399', '二次确认提示的js函数有错'));
                }
            }
            else {
                info = confirmContent;
            }
            return info;
        };
        //执行接口动作
        this.doInterfacesAction = function (billid, pageexpandid, callBackFun, params) {
            var _a = _this.card.params, modeId = _a.modeId, formId = _a.formId;
            __WEBPACK_IMPORTED_MODULE_5__apis__["a" /* default */].doInterface(__assign({ pageexpandid: pageexpandid, billid: billid, modeid: modeId, formid: formId }, _this.card.params)).then(function (_a) {
                var pageExpendResult = _a.pageExpendResult, status = _a.status;
                if (pageExpendResult) {
                    if (pageExpendResult.haveError) {
                        __WEBPACK_IMPORTED_MODULE_0_antd__["Modal"].error({
                            content: pageExpendResult.executeResult.errmsg
                        });
                        return;
                    }
                    else if (pageExpendResult.executeResult.flag == "true" && pageExpendResult.executeResult.interfacetype && pageExpendResult.executeResult.interfacetype == '6' && pageExpendResult.executeResult.callbackFun) {
                        var callbackFun = pageExpendResult.executeResult.callbackFun;
                        var esbdata = pageExpendResult.executeResult.esbdata;
                        eval(callbackFun + "(" + esbdata + ")");
                    }
                }
                _this.callfun(callBackFun, params);
            });
        };
        this.callfun = function (callBackFun, params) {
            if (callBackFun) {
                if (params) {
                    callBackFun(params);
                }
                else {
                    callBackFun();
                }
            }
        };
        this.changeViewType = function (type, func) {
            var query = __assign({}, _this.card.params, { billid: _this.card.base.billid });
            if (type == '0') {
                delete query.fromImportDetail;
            }
            delete query._key;
            query.type = type;
            delete query.layoutid;
            var queryStr = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.mapKeys(query, function (value, key) {
                return key + "=" + value;
            })).join("&");
            if (type == "2" || type == "0") {
                if (__WEBPACK_IMPORTED_MODULE_2__util__["default"]._cubeCard && __WEBPACK_IMPORTED_MODULE_2__util__["default"]._cubeCard.editCard) { //外部调用编辑方法，例如：合同使用建模卡片，操作之后
                    __WEBPACK_IMPORTED_MODULE_2__util__["default"]._cubeCard.editCard(query);
                    return;
                }
                if (_this.card.params && _this.card.params.istree) { //处理树的情况下，是否刷新左侧树，禁止路由跳转
                    _this.card.reloadSearch(query);
                    return;
                }
            }
            if (func) {
                // func(`${window.location.pathname}#/main/cube/card?${queryStr}`);
                if (type == "4" && _this.card.printEdcUrl && _this.card.printEdcUrl != '') {
                    var printurl = _this.card.printEdcUrl + "&cubePrintKey=" + _this.card.base.billid;
                    func(printurl);
                }
                else {
                    func(Object(__WEBPACK_IMPORTED_MODULE_10__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/card?" + queryStr));
                }
            }
            else {
                //window.weaHistory.push({ pathname: `/main/cube/card?${queryStr}` });
                if (_this.card.isInline || _this.card.isInTree) {
                    _this.card.reloadSearch(query);
                }
                else if (__WEBPACK_IMPORTED_MODULE_2__util__["default"].cubeStore.Search.rightLayoutHref) { //查询-行点击-禁止路由跳转
                    __WEBPACK_IMPORTED_MODULE_2__util__["default"].cubeStore.Search.rightLayoutHref = "/spa/cube/index.html#/main/cube/card?" + queryStr;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2__util__["default"].weaHistory.push({ pathname: "/main/cube/card?" + queryStr });
                }
            }
        };
        //保存草稿
        this.doSubmitDraft = function (pageexpandid, issystemflag, btntype, isRefreshto, callBack) {
            if (isRefreshto === void 0) { isRefreshto = true; }
            _this.doSubmit(pageexpandid, issystemflag, '99', false, callBack);
        };
        this.expCard = function (pageexpandid) {
            var modeId = _this.card.base.modeId;
            var billid = _this.card.params.billid;
            __WEBPACK_IMPORTED_MODULE_5__apis__["a" /* default */].doInterface(__assign({}, _this.card.params, { pageexpandid: pageexpandid, billid: billid, modeid: modeId })).then(function (_a) {
                var pageExpendResult = _a.pageExpendResult, status = _a.status;
                if (pageExpendResult && pageExpendResult.haveError) {
                    __WEBPACK_IMPORTED_MODULE_0_antd__["Modal"].error({
                        content: pageExpendResult.executeResult.errmsg
                    });
                    return;
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_6__apis_card__["i" /* doExpCardConfig */])({ action: 'getExpList', modeid: modeId }).then(function (data) {
                        try {
                            if (data.ExpList.length > 0) {
                                if (data.ExpList.length == 1) { //当后台设置了一种导出类型的时候直接导出
                                    __WEBPACK_IMPORTED_MODULE_2__util__["default"].open(Object(__WEBPACK_IMPORTED_MODULE_10__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.formmode.expcard.servlet.ExpCardServer?action=expcard&fileType=" + data.ExpList[0]['key'] + "&billid=" + billid + "&modeId=" + modeId + "&layoutid=" + _this.card.layoutid + "&pageexpandid=" + pageexpandid + "&doInterface=1"));
                                }
                                else {
                                    __WEBPACK_IMPORTED_MODULE_8_ecCom__["WeaTools"].ls.set('cube_export_type', data.ExpList[0]['key']);
                                    Object(__WEBPACK_IMPORTED_MODULE_9__util_cubeUtil__["i" /* showExportMenu */])(data.ExpList, billid, modeId, "card", "", "", "", "", _this.card.layoutid);
                                }
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_0_antd__["Modal"].info({
                                    title: getLabel(17416, '导出'),
                                    content: (React.createElement("div", null, getLabel('500890', '模块没有设置导出文件类型，请联系管理员！'))),
                                    onOk: function () { },
                                });
                            }
                        }
                        catch (error) {
                        }
                    });
                }
            });
            // const { modeId, billid, formId } = this.card.base;
            // this.doInterfacesAction(this.card.base.billid, pageexpandid, () => {
            //     window.open(`/weaver/weaver.formmode.excel.ExpCardExcelServer?modeId=${modeId}&formId=${formId}&action=expcard&billid=${billid}`, '_self');
            // });
        };
        this.card = card;
        this.submitActions = new __WEBPACK_IMPORTED_MODULE_1__doSubmit__["a" /* default */](card);
        this.doSubmit = this.submitActions.execute;
        this.ecmeDoSubmit = this.submitActions.ecmeExecute; //督办建模布局保存用
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_7_mobx__["action"]
    ], Actions.prototype, "deleteData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_7_mobx__["action"]
    ], Actions.prototype, "doImportDetail", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_7_mobx__["action"]
    ], Actions.prototype, "expCard", void 0);
    return Actions;
}());
/* harmony default export */ __webpack_exports__["a"] = (Actions);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollToX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;

var getParent = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].WindowFunc.getParent;
/**
 *
 * 卡片必填竖向滚动
 */
var scrollTo = function ($ele, form, callback) {
    if ($ele.length == 0) {
        setTimeout(function () {
            $ele = form.firstErrorField;
            if ($ele) {
                scrollTo($ele, form, callback);
            }
        }, 100);
        return;
    }
    /***判断是不是内联form */
    var $scroll = __WEBPACK_IMPORTED_MODULE_6_jquery___default()('div').hasClass('cube-card-inline-wrapper') ? __WEBPACK_IMPORTED_MODULE_6_jquery___default()(".cube-card-wrap").closest(".cube-card-inline-wrapper") : __WEBPACK_IMPORTED_MODULE_6_jquery___default()(".cube-card-wrap").closest(".cube-card-form-content");
    $scroll = $scroll.length == 0 ? __WEBPACK_IMPORTED_MODULE_6_jquery___default()(".cube-card-wrap").closest(".cube-card-inline-tab-wrapper") : $scroll;
    var viewHeight = $scroll.parent().height();
    var curScrollTop = $scroll.scrollTop();
    $scroll.animate({
        scrollTop: $ele.offset().top + curScrollTop - viewHeight / 2
    }, 300, function () { callback($ele); });
    if ($scroll.length == 0) {
        callback($ele);
    }
};
/**
 *
 * 卡片必填明细表横向滚动
 */
var scrollToX = function ($ele, form, callback) {
    if ($ele.length == 0) {
        setTimeout(function () {
            $ele = form.firstErrorField;
            if ($ele) {
                scrollToX($ele, form, callback);
            }
        }, 100);
        return;
    }
    var $scroll = __WEBPACK_IMPORTED_MODULE_6_jquery___default()($ele).closest(".excelDetailTable_wrap");
    var viewWidth = $scroll.width();
    var curScrollWidth = $scroll.scrollLeft();
    $scroll.animate({
        scrollLeft: $ele.offset().left - $scroll.offset().left - viewWidth / 2 + curScrollWidth
    }, 300, function () { callback(); });
};
var DoSubmit = /** @class */ (function () {
    function DoSubmit(card) {
        var _this_1 = this;
        this.execute = function (pageexpandid, issystemflag, btntype, isRefreshto, callBack, method, needValidate) {
            if (isRefreshto === void 0) { isRefreshto = true; }
            if (needValidate === void 0) { needValidate = true; }
            var isSub = true;
            if (btntype && btntype == "99") { //保存草稿
                _this_1.doSubmitDraft(pageexpandid, issystemflag, btntype, isRefreshto, callBack);
                return;
            }
            var promise = new Promise(function (resolve, reject) {
                if (_this_1.check_table()) {
                    if (needValidate) {
                        if (_this_1.check_form()) {
                            Object(__WEBPACK_IMPORTED_MODULE_2__apis_card__["a" /* checkCardDataChange */])(__assign({}, _this_1.card.params, { changeDataTime: _this_1.card.changeDataTime })).then(function (_a) {
                                var _b = _a.errMessage, errMessage = _b === void 0 ? '' : _b, _c = _a.isChange, isChange = _c === void 0 ? true : _c;
                                if (!isChange) {
                                    isSub = false;
                                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                                        title: errMessage,
                                        okText: getLabel(382958, '确定'),
                                        cancelText: getLabel(201, '取消'),
                                        onOk: function () {
                                            __WEBPACK_IMPORTED_MODULE_4__util__["default"].location.reload();
                                        },
                                        onCancel: function () {
                                            return;
                                        }
                                    });
                                }
                                else {
                                    _this_1.verifyRepeat().then(function () {
                                        resolve();
                                    }).catch(function (e) {
                                        reject(e);
                                    });
                                }
                            });
                        }
                        else {
                            reject();
                        }
                    }
                    else {
                        Object(__WEBPACK_IMPORTED_MODULE_2__apis_card__["a" /* checkCardDataChange */])(__assign({}, _this_1.card.params, { changeDataTime: _this_1.card.changeDataTime })).then(function (_a) {
                            var _b = _a.errMessage, errMessage = _b === void 0 ? '' : _b, _c = _a.isChange, isChange = _c === void 0 ? true : _c;
                            if (!isChange) {
                                isSub = false;
                                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                                    title: errMessage,
                                    okText: getLabel(382958, '确定'),
                                    cancelText: getLabel(201, '取消'),
                                    onOk: function () {
                                        __WEBPACK_IMPORTED_MODULE_4__util__["default"].location.reload();
                                    },
                                    onCancel: function () {
                                        return;
                                    }
                                });
                            }
                            else {
                                _this_1.verifyRepeat().then(function () {
                                    resolve();
                                }).catch(function (e) {
                                    reject(e);
                                });
                            }
                        });
                    }
                }
                else {
                    reject();
                }
            }).then(function () {
                var submitData = function () {
                    try {
                        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isFunction(__WEBPACK_IMPORTED_MODULE_4__util__["default"].startUploadAll)) {
                            __WEBPACK_IMPORTED_MODULE_4__util__["default"].startUploadAll();
                        }
                        var allUploaded_1 = false;
                        var timer_1 = setInterval(function () {
                            allUploaded_1 = true;
                            _this_1.card.uploadFields.map(function (f) {
                                if (!allUploaded_1) {
                                    return;
                                }
                                var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                                if (isdetail) {
                                    if (_this_1.card.cubeForm.has(detail)) {
                                        var detailTable = _this_1.card.cubeForm.$(detail);
                                        detailTable.map(function (row) {
                                            if (!allUploaded_1) {
                                                return;
                                            }
                                            if (row.has(f)) {
                                                if (!row.$(f).isUpload) {
                                                    allUploaded_1 = false;
                                                }
                                            }
                                        });
                                    }
                                }
                                else {
                                    if (_this_1.card.cubeForm.has(f)) {
                                        if (!_this_1.card.cubeForm.$(f).isUpload) {
                                            allUploaded_1 = false;
                                        }
                                    }
                                }
                            });
                            if (allUploaded_1) {
                                if (typeof (getParent()['slideflgfun']) == 'function') {
                                    if (getParent()['slideflgfun']()) {
                                        getParent()['dosubmitfun']();
                                    }
                                }
                                if (isSub) {
                                    _this_1.doSubmitPost(pageexpandid, issystemflag, btntype, isRefreshto, callBack, method);
                                    clearInterval(timer_1);
                                }
                            }
                        }, 100);
                    }
                    catch (e) {
                        if (isSub) {
                            _this_1.doSubmitPost(pageexpandid, issystemflag, btntype, isRefreshto, callBack, method);
                        }
                    }
                };
                if (typeof (__WEBPACK_IMPORTED_MODULE_4__util__["default"].checkCustomize) == 'function') {
                    try {
                        new Promise(function (resolve) {
                            var a = __WEBPACK_IMPORTED_MODULE_4__util__["default"].checkCustomize(resolve);
                            if (typeof a === 'boolean') {
                                resolve(a);
                            }
                        }).then(function (res) {
                            if (res) {
                                submitData();
                            }
                        });
                    }
                    catch (e) {
                        return false;
                    }
                }
                else {
                    submitData();
                }
            }).catch(function (e) {
                // window.console && window.console.log(e);
            });
            return promise;
        };
        this.ecmeExecute = function () {
            var promise = new Promise(function (resolve, reject) {
                if (_this_1.check_table() && _this_1.check_form()) {
                    _this_1.verifyRepeat().then(function () {
                        if (typeof (__WEBPACK_IMPORTED_MODULE_4__util__["default"].checkCustomize) == 'function') {
                            try {
                                var flag = __WEBPACK_IMPORTED_MODULE_4__util__["default"].checkCustomize();
                                if (!flag) {
                                    return false;
                                }
                            }
                            catch (e) {
                                return false;
                            }
                        }
                        try {
                            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isFunction(__WEBPACK_IMPORTED_MODULE_4__util__["default"].startUploadAll)) {
                                __WEBPACK_IMPORTED_MODULE_4__util__["default"].startUploadAll();
                            }
                            var allUploaded_2 = false;
                            var timer_2 = setInterval(function () {
                                allUploaded_2 = true;
                                _this_1.card.uploadFields.map(function (f) {
                                    if (!allUploaded_2) {
                                        return;
                                    }
                                    var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                                    if (isdetail) {
                                        if (_this_1.card.cubeForm.has(detail)) {
                                            var detailTable = _this_1.card.cubeForm.$(detail);
                                            detailTable.map(function (row) {
                                                if (!allUploaded_2) {
                                                    return;
                                                }
                                                if (row.has(f)) {
                                                    if (!row.$(f).isUpload) {
                                                        allUploaded_2 = false;
                                                    }
                                                }
                                            });
                                        }
                                    }
                                    else {
                                        if (_this_1.card.cubeForm.has(f)) {
                                            if (!_this_1.card.cubeForm.$(f).isUpload) {
                                                allUploaded_2 = false;
                                            }
                                        }
                                    }
                                });
                                if (allUploaded_2) {
                                    if (typeof (__WEBPACK_IMPORTED_MODULE_4__util__["default"].parent['slideflgfun']) == 'function') {
                                        if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].parent['slideflgfun']()) {
                                            __WEBPACK_IMPORTED_MODULE_4__util__["default"].parent['dosubmitfun']();
                                        }
                                    }
                                    clearInterval(timer_2);
                                    resolve();
                                }
                            }, 100);
                        }
                        catch (e) {
                            return false;
                        }
                    }).catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject();
                }
            }).then(function () {
                return _this_1.ecmeDoSubmitPost();
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_4__util__["default"].console && __WEBPACK_IMPORTED_MODULE_4__util__["default"].console.log(e);
            });
            return promise;
        };
        this.getSubmitData = function () {
            var data = {};
            _this_1.card.cubeForm.map(function (f) {
                if (f.key.startsWith('detail_')) {
                    var detailExcel = _this_1.card.modeExcel.getExcel(f.key);
                    if (!detailExcel) {
                        return;
                    }
                    var isDrag = _this_1.card.cubeForm.$(f.key).isDrag;
                    var detailProps = detailExcel.detailProps;
                    var isHideNull = false;
                    if (detailProps && detailProps.isHideNull) {
                        isHideNull = true;
                    }
                    if (isHideNull) {
                        if (isDrag) {
                            var values = _this_1.getDragedData(f);
                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(data, f.key, values);
                        }
                        else {
                            f.map(function (row) {
                                var isNull = true;
                                row.map(function (d) {
                                    var value = d.getValue();
                                    if (d.key != 'checkbox' && !!value) {
                                        isNull = false;
                                    }
                                });
                                if (!isNull) {
                                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(data, f.key + ".[" + row.key + "]", row.values());
                                }
                            });
                        }
                    }
                    else {
                        if (isDrag) {
                            var values = _this_1.getDragedData(f);
                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(data, f.key, values);
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(data, f.key, f.values());
                        }
                    }
                    var submitdtlids = f.map(function (row) {
                        return row.key;
                    }).join(",");
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(data, "submitdtlid" + f.key.replace('detail_', ''), submitdtlids);
                }
                else {
                    var _a = _this_1.card.getFieldProps(f.path), fieldhtmltype = _a.fieldhtmltype, fieldtype = _a.fieldtype;
                    if (fieldhtmltype == '3' && fieldtype == '17') { //多人力资源特殊处理
                        var groupInfo = f.buildMultiUserGroupInfo(f.getValue(), f.valueObj);
                        var groupnum = groupInfo.groupnum;
                        for (var i = 0; i < groupnum; i++) {
                            if ("group_" + i in groupInfo)
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(data, f.key + "group" + i, groupInfo["group_" + i]);
                        }
                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(data, f.key + "groupnum", groupnum);
                    }
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(data, f.key, f.getValue());
                }
            });
            return data;
        };
        this.getDragedData = function (f) {
            var detailindex = f.key.replace('detail_', '');
            var realIds = new Array();
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()("#oTable" + detailindex + " tr").each(function (item, e) {
                var rowindex = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(e).attr('data-rowindex');
                if (rowindex) {
                    realIds.push(parseInt(rowindex));
                }
            });
            //如果有删除行,可能会出现索引错乱
            var sortids = realIds.slice();
            sortids.sort(function (a, b) { return a - b; });
            var map = new Map();
            sortids.forEach(function (v, index) { map.set(v, index); });
            for (var i = 0; i < realIds.length; i++) {
                realIds[i] = map.get(realIds[i]);
            }
            var datas = new Array();
            var values = f.values();
            realIds.forEach(function (rowindex) {
                if (rowindex <= values.length) {
                    datas.push(values[rowindex]);
                }
            });
            return datas;
        };
        /**
         * btntyoe == 3 //保存并新建
         * btntyoe == 4 //保存并复制
         * btntyoe == 5 //明细导入
         * btntype == 99 //保存草稿
         * detailid：页面扩展id
         * issystemflag  是否是系统标签
         * isRefreshto 是否跳转页面
         * callBack  回调函数
         */
        this.doSubmitPost = function (detailid, issystemflag, btntype, isRefreshto, callBack, method) {
            if (isRefreshto === void 0) { isRefreshto = true; }
            try {
                var values_1 = _this_1.getSubmitData();
                if (values_1.hasOwnProperty('field-9') && ['1', '2'].indexOf(values_1['field-9']) == -1) {
                    values_1['field-10'] = '';
                }
                var type = _this_1.card.params.type;
                var layoutid_1 = _this_1.card.layoutid;
                var isOreadySubmit = _this_1.card.isOreadySubmit;
                var isFormMode_1 = "1";
                var iscreate_1 = _this_1.card.base.billid ? '2' : type;
                var src_1 = (type == 1 && !_this_1.card.base.billid) ? "submit" : "save";
                if (method) {
                    src_1 = method;
                }
                var currentLayoutId_1 = layoutid_1;
                _this_1.card.cardTab.disabled = true;
                //if(iscreate == '2'){
                if (!isOreadySubmit) {
                    return;
                }
                if (iscreate_1 == '1') {
                    _this_1.card.setIsOreadySubmit(false);
                }
                Object(__WEBPACK_IMPORTED_MODULE_2__apis_card__["a" /* checkCardDataChange */])(__assign({}, _this_1.card.params, { changeDataTime: _this_1.card.changeDataTime, iscreate: iscreate_1 })).then(function (_a) {
                    var _b = _a.errMessage, errMessage = _b === void 0 ? '' : _b, _c = _a.isChange, isChange = _c === void 0 ? true : _c;
                    if (isChange) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__apis_card__["k" /* doSubmit */])(__assign({}, _this_1.card.params, { token: _this_1.card.token, layoutid: layoutid_1,
                            isFormMode: isFormMode_1,
                            iscreate: iscreate_1,
                            src: src_1,
                            currentLayoutId: currentLayoutId_1, pageexpandid: detailid, JSONStr: JSON.stringify(values_1), btntype: btntype,
                            issystemflag: issystemflag, oldmodedatastatus: _this_1.card.base["modedatastatus"] == 1 ? 1 : 0 }, _this_1.card.submitParam)).then(function (_a) {
                            var billid = _a.billid, repeat = _a.repeat, sqlresult = _a.sqlresult, pageExpendResult = _a.pageExpendResult;
                            var iscontinue = _this_1.handleResult(billid, repeat, sqlresult, pageExpendResult, _this_1.card.params, btntype);
                            if (!iscontinue) {
                                //新建完成后，后面push会添加一个key，这里删掉key，确保不会两个key导致两次请求。
                                delete _this_1.card.params._key;
                                return;
                            }
                            var query = __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.getCurrentLocation().query;
                            query = __assign({}, _this_1.card.params, query);
                            /**************************************外部调用保存方法，例如：合同使用建模卡片，操作之后*** */
                            if (__WEBPACK_IMPORTED_MODULE_4__util__["default"]._cubeCard && __WEBPACK_IMPORTED_MODULE_4__util__["default"]._cubeCard.reLoad) {
                                _this_1.card.cardTab.disabled = false;
                                if (btntype == '3') {
                                    __WEBPACK_IMPORTED_MODULE_4__util__["default"]._cubeCard.reLoad();
                                    return;
                                }
                                __WEBPACK_IMPORTED_MODULE_4__util__["default"]._cubeCard.reLoad(billid);
                                return;
                            }
                            /*------------------------------------------------------------------------------------*/
                            if (callBack && typeof callBack == 'function') {
                                callBack(billid);
                            }
                            if (isRefreshto) { //需要跳转到显示页面了在设置，否则取当前的type
                                query.type = '0'; //type =0 显示 1 新建
                            }
                            else {
                                query.isSaveCallback = true; //监控是不是保存之后的页面刷新，不跳转页面，判断重复请求问
                            }
                            query.billid = billid;
                            if (btntype == '3') {
                                query.type = '1';
                                delete query.billid;
                                delete query.copyid;
                            }
                            else if (btntype == '4') {
                                query.copyid = billid;
                                query.type = '1';
                                delete query.billid;
                            }
                            else if (btntype == '5') {
                                query.type = '1';
                            }
                            query.t = new Date().getTime();
                            delete query._key; //新建完成后，后面push会添加一个key，这里删掉key，确保不会两个key导致两次请求。
                            if (btntype != '3' && btntype != '4' && btntype != '5' && btntype != '99') {
                                delete query.layoutid;
                            }
                            var otherQuery = [];
                            if (btntype != '3') {
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(query, function (value, key) { if (!key.startsWith('field'))
                                    otherQuery[key] = value; return 0; }); //去除掉field开头的参数，避免新增链接上的参数带到显示页面
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(query, function (value, key) { otherQuery[key] = value; return 0; }); //去除掉field开头的参数，避免新增链接上的参数带到显示页面
                            }
                            var queryStr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(otherQuery, function (value, key) {
                                return key + "=" + value;
                            })).join("&");
                            if (query.type == '0') {
                                query = __assign({}, otherQuery);
                            }
                            if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].cubeStore.Search.rightLayoutHref) { //处理查询行点击-右侧显示模块，禁止路由跳转
                                _this_1.card.params.isInnerCard = true;
                                _this_1.card.targetHref = __WEBPACK_IMPORTED_MODULE_4__util__["default"].cubeStore.Search.rightLayoutHref;
                            }
                            if (btntype == '5') {
                                _this_1.card.init(query, _this_1.card.showDetailImport);
                            }
                            else if (_this_1.card.params && _this_1.card.params.istree) { //处理树的情况下，是否刷新左侧树，禁止路由跳转
                                _this_1.card.init(query);
                                if (_this_1.card.params.isRefreshTree == '1') {
                                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].refreshTree(_this_1.card.params.customTreeDataId);
                                }
                            }
                            else if (_this_1.card.params && _this_1.card.params.isInnerCard) { //处理内嵌卡片的情况，禁止路由跳转
                                var cardParams = _this_1.card.getQuery(_this_1.card.targetHref);
                                cardParams.type = '0'; //type =0 显示 1 新建
                                cardParams.billid = billid;
                                if (btntype == '3') {
                                    cardParams.type = '1';
                                    delete cardParams.billid;
                                }
                                else if (btntype == '4') {
                                    cardParams.copyid = billid;
                                    cardParams.type = '1';
                                    delete cardParams.billid;
                                }
                                else if (btntype == '5') {
                                    cardParams.type = '1';
                                }
                                cardParams.t = new Date().getTime();
                                delete cardParams._key;
                                _this_1.card.innerCardInit(cardParams);
                            }
                            else if (!isRefreshto) {
                                _this_1.card.init(query);
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.push({ pathname: "/main/cube/card?" + queryStr });
                            }
                            try {
                                //--------------------------------------是否看板，看板相关处理
                                var _b = _this_1.card.params, boardid = _b.boardid, boardgroup = _b.boardgroup, boardcustomid = _b.boardcustomid, viewfrom = _b.viewfrom;
                                if (boardid && boardgroup && boardcustomid) {
                                    if (top.window['current_boardStore']) {
                                        top.window['current_boardStore'].cardSaveFun(billid, iscreate_1, boardid, boardgroup, boardcustomid, btntype);
                                    }
                                    else if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener.cubeStore) {
                                        __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener.cubeStore.boardStore.doSearch();
                                    }
                                }
                                else if (viewfrom == 'fromboarditem' && __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener.cubeStore) {
                                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener.cubeStore.boardStore.doSearch();
                                }
                                else if (viewfrom == 'fromgantt') {
                                    top.window['current_ganttStore'].cardSaveFun();
                                }
                                else {
                                    //--------------打开的列表数据回调刷新页面-----
                                    _this_1.card.cardTab.disabled = false;
                                    if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].opener) {
                                        var _c = __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener, _table = _c._table, cubeStore = _c.cubeStore;
                                        if (cubeStore && cubeStore.Search.isFromViewResource) { // 资源面板
                                            cubeStore.cubeViewResource && cubeStore.cubeViewResource.query();
                                        }
                                        else {
                                            if (_table && _table.reLoad) {
                                                var isTreeList = cubeStore && cubeStore.Search.dataShowtype === 'treeType' && cubeStore.Search.changeSearch == '1'; // 分组的组合转换，单独判断
                                                if (isTreeList && cubeStore.Search.customId) {
                                                    cubeStore.Search.refresh();
                                                }
                                                else {
                                                    _table.reLoad();
                                                }
                                            }
                                            else if (cubeStore && cubeStore.Search.customId) {
                                                cubeStore.Search.refresh();
                                            }
                                        }
                                    }
                                    else if (top.window && top.window['cubeStore'] && top.window['cubeStore']) {
                                        var _table = top.window['_table'];
                                        var _d = top.window['cubeStore'].Search, slideModalVisible = _d.slideModalVisible, customId = _d.customId, reloadBaseList = _d.reloadBaseList;
                                        if (slideModalVisible) {
                                            if (_this_1.card.params.customid == customId) { // base列表刷新
                                                reloadBaseList();
                                            }
                                            else {
                                                _table && _table.reLoad(); // 滑动展开的列表刷新
                                            }
                                        }
                                    }
                                }
                            }
                            catch (e) {
                            }
                        });
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                            title: errMessage,
                            okText: getLabel(382958, '确定'),
                            cancelText: getLabel(201, '取消'),
                            onOk: function () {
                                __WEBPACK_IMPORTED_MODULE_4__util__["default"].location.reload();
                            },
                            onCancel: function () {
                                //return;
                            }
                        });
                    }
                });
                // }else{
                //     if(!isOreadySubmit ){
                //         return;
                //     }
                //     if(iscreate == '1'){
                //          this.card.setIsOreadySubmit(false);
                //     }
                //     doSubmit({
                //         ...this.card.params,
                //         token:this.card.token,
                //         layoutid,
                //         isFormMode,
                //         iscreate,
                //         src,
                //         currentLayoutId,
                //         pageexpandid: detailid,
                //         JSONStr: JSON.stringify(values),
                //         btntype,
                //         issystemflag,
                //         oldmodedatastatus: this.card.base["modedatastatus"] == 1 ? 1 : 0
                //     }).then(({ billid,repeat,sqlresult,pageExpendResult }) => {
                //         let iscontinue=this.handleResult(billid,repeat,sqlresult,pageExpendResult,this.card.params,btntype)
                //         if(!iscontinue){
                //             //新建完成后，后面push会添加一个key，这里删掉key，确保不会两个key导致两次请求。
                //             delete this.card.params._key
                //             return;
                //         }
                //         let { query } = window.weaHistory.getCurrentLocation();
                //         query = { ...this.card.params, ...query };
                //         /**************************************外部调用保存方法，例如：合同使用建模卡片，操作之后*** */
                //         if (window._cubeCard && window._cubeCard.reLoad) {
                //             this.card.cardTab.disabled = false;
                //             if (btntype == '3') {
                //                 window._cubeCard.reLoad();
                //                 return;
                //             }
                //             window._cubeCard.reLoad(billid);
                //             return;
                //         }
                //         /*------------------------------------------------------------------------------------*/
                //         if (callBack && typeof callBack == 'function') {
                //             callBack(billid);
                //         }
                //         if (isRefreshto) {  //需要跳转到显示页面了在设置，否则取当前的type
                //             query.type = '0';  //type =0 显示 1 新建
                //         }else{
                //             query.isSaveCallback = true;//监控是不是保存之后的页面刷新，不跳转页面，判断重复请求问
                //         }
                //         query.billid = billid;
                //         if (btntype == '3') {
                //             query.type = '1';
                //             delete query.billid;
                //             delete query.copyid;
                //         } else if (btntype == '4') {
                //             query.copyid = billid;
                //             query.type = '1';
                //             delete query.billid;
                //         } else if (btntype == '5') {
                //             query.type = '1';
                //         }
                //         query.t = new Date().getTime();
                //         delete query._key; //新建完成后，后面push会添加一个key，这里删掉key，确保不会两个key导致两次请求。
                //         if (btntype != '3' && btntype != '4' && btntype != '5' && btntype != '99') {
                //             delete query.layoutid;
                //         }
                //         let otherQuery:any=[];
                //         if(btntype != '3'){
                //             _.mapKeys(query, (value, key) => {if(!key.startsWith('field'))otherQuery[key]=value;return 0;});//去除掉field开头的参数，避免新增链接上的参数带到显示页面
                //         }else{
                //             _.mapKeys(query, (value, key) => {otherQuery[key]=value;return 0;});//去除掉field开头的参数，避免新增链接上的参数带到显示页面
                //         }
                //         const queryStr = _.keys(_.mapKeys(otherQuery, (value, key) => {
                //             return `${key}=${value}`;
                //         })).join("&");
                //         if(query.type == '0'){
                //             query={...otherQuery};
                //         }
                //         if (btntype == '5') {
                //             this.card.init(query, this.card.showDetailImport);
                //         } else if (this.card.params && this.card.params.istree) {  //处理树的情况下，是否刷新左侧树，禁止路由跳转
                //             this.card.init(query);
                //             if (this.card.params.isRefreshTree == '1') {
                //                 (window as any).refreshTree(this.card.params.customTreeDataId);
                //             }
                //         } else if (this.card.params && this.card.params.isInnerCard) {  //处理内嵌卡片的情况，禁止路由跳转
                //             const cardParams = this.card.getQuery(this.card.targetHref);
                //             cardParams.type = '0';  //type =0 显示 1 新建
                //             cardParams.billid = billid;
                //             if (btntype == '3') {
                //                 cardParams.type = '1';
                //                 delete cardParams.billid;
                //             } else if (btntype == '4') {
                //                 cardParams.copyid = billid;
                //                 cardParams.type = '1';
                //                 delete cardParams.billid;
                //             } else if (btntype == '5') {
                //                 cardParams.type = '1';
                //             }
                //             cardParams.t = new Date().getTime();
                //             delete cardParams._key;
                //             this.card.innerCardInit(cardParams);
                //         } else if (!isRefreshto) {
                //             this.card.init(query);
                //         } else {
                //             window.weaHistory.push({ pathname: `/main/cube/card?${queryStr}` });
                //         }
                //         //--------------打开的列表数据回调刷新页面-----
                //         try {
                //             this.card.cardTab.disabled = false;
                //             if (window.opener && window.opener._table && window.opener._table.reLoad) {
                //                 window.opener._table.reLoad();
                //             }else if(window.opener && window.opener.cubeStore){
                //                 window.opener.cubeStore.Search.refresh();
                //             }
                //         } catch (e) {
                //         }
                //         //--------------------------------------------------------
                //         //--------------------------------------是否看板，看板相关处理
                //         try {
                //             const { boardid, boardgroup, boardcustomid } = this.card.params;
                //             if (boardid && boardgroup && boardcustomid) {
                //                 top.window['current_boardStore'].cardSaveFun(billid, iscreate, boardid, boardgroup, boardcustomid);
                //             }
                //         } catch (e) {
                //         }
                //         //----------------------------------------是否看板，看板相关处理
                //     });
                // }
            }
            catch (error) {
            }
        };
        this.handleResult = function (billid, repeat, sqlresult, pageExpendResult, params, btntype) {
            if (repeat && (repeat == "true" || repeat == true)) {
                __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel('511158', '禁止重复提交表单'));
                return false;
            }
            if (sqlresult && sqlresult == "false") {
                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].error({
                    content: getLabel('511621', 'sql执行错误,请联系管理员查看后台日志')
                });
                return false;
            }
            if (billid == undefined) {
                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].error({
                    content: getLabel('512662', '保存数据出错!billid为空')
                });
                return false;
            }
            if (pageExpendResult) {
                var obj = JSON.parse(pageExpendResult);
                var _this_2 = _this_1;
                if (obj.flag == "false") {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].error({
                        content: React.createElement("div", { dangerouslySetInnerHTML: { __html: obj.errmsg } }),
                        onOk: function () {
                            _this_2.jumpPath(billid, params, btntype);
                        },
                        onCancel: function () {
                            _this_2.jumpPath(billid, params, btntype);
                        }
                    });
                    return false;
                }
                else if (obj.flag == "true" && obj.interfacetype && obj.interfacetype == '6' && obj.callbackFun) {
                    var callbackFun = obj.callbackFun;
                    var esbdata = obj.esbdata;
                    eval(callbackFun + "(" + esbdata + ")");
                }
            }
            return true;
        };
        this.jumpPath = function (billid, params, btntype) {
            var query = __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.getCurrentLocation().query;
            query = __assign({}, params, query);
            query.billid = billid;
            delete query.layoutid;
            query.type = '0';
            if (btntype == '3') {
                query.type = '1';
                delete query.billid;
                delete query.copyid;
            }
            else if (btntype == '4') {
                query.copyid = billid;
                query.type = '1';
                delete query.billid;
            }
            else if (btntype == '5') {
                query.type = '1';
            }
            var otherQuery = [];
            if (btntype != '3') {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(query, function (value, key) { if (!key.startsWith('field'))
                    otherQuery[key] = value; return 0; }); //去除掉field开头的参数，避免新增链接上的参数带到显示页面
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(query, function (value, key) { otherQuery[key] = value; return 0; }); //去除掉field开头的参数，避免新增链接上的参数带到显示页面
            }
            var queryStr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(otherQuery, function (value, key) {
                return key + "=" + value;
            })).join("&");
            if (query.type == '0') {
                query = __assign({}, otherQuery);
            }
            __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.push({ pathname: "/main/cube/card?" + queryStr });
        };
        this.ecmeDoSubmitPost = function () {
            try {
                var values = _this_1.getSubmitData();
                var result = _this_1.convertFields(values);
                _this_1.card.cardTab.disabled = true;
                var pickCardParams = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(_this_1.card.params, ['appid', 'feaid', 'isecme']);
                var newParams = __assign({}, pickCardParams, { JSONStr: result });
                return Promise.resolve(newParams);
            }
            catch (error) {
            }
        };
        /*  转换建模字段到模块字段
        *   values = {detail_1: Array(2), field-57099: "1", field-57088: "", …}
        *   return :{
        *       mainTable:{ tablename(主表或者扩展表表名):{ fieldname:"14:55",fieldname:"", …} },
        *       detaiTable:{ tablename（明细表名）:[{fieldname:"14:55",fieldname:"", …},{fieldname:"14:55",fieldname:"", …}] }
        *   }
        */
        this.convertFields = function (values) {
            var mainTable = {};
            var detailTable = {};
            var exmainTable = {};
            var exdetailTable = {};
            var _allFields = _this_1.card.allFields;
            var _loop_1 = function (key) {
                if (key.startsWith('field')) {
                    var tablename = '';
                    for (var _key in _allFields) {
                        if (key == _key) {
                            var issystem = _allFields[_key].issystem;
                            if (issystem == 4) {
                                var tableid = _allFields[_key].tableid;
                                var extable = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(exmainTable, tableid);
                                if (extable == undefined) {
                                    extable = {};
                                }
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(extable, _key, values[key]);
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(exmainTable, tableid, extable);
                            }
                            else {
                                tablename = _allFields[_key].tablename;
                                var table = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(mainTable, tablename);
                                if (table == undefined) {
                                    table = {};
                                }
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(table, _allFields[_key].fieldname, values[key]);
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(mainTable, tablename, table);
                            }
                        }
                    }
                }
                else if (key.startsWith('detail_')) {
                    var dttablename_1 = '';
                    var detailTableList_1 = [];
                    var dttableid_1 = '';
                    var exdetailTableList_1 = [];
                    dt = values[key];
                    dt.forEach(function (_dtvalues, index) {
                        var dtTable = {};
                        var exdtTable = {};
                        for (var dtkey in _dtvalues) {
                            if (dtkey.startsWith('field')) {
                                for (var _dtkey in _allFields) {
                                    if (dtkey == _dtkey) {
                                        var issystem = _allFields[_dtkey].issystem;
                                        if (issystem == 4) {
                                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(exdtTable, _dtkey, _dtvalues[dtkey]);
                                            dttableid_1 = _allFields[_dtkey].tableid;
                                        }
                                        else {
                                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(dtTable, _allFields[_dtkey].fieldname, _dtvalues[dtkey]);
                                            dttablename_1 = _allFields[_dtkey].tablename;
                                        }
                                    }
                                }
                            }
                            else if (dtkey == 'dtl_id') {
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(dtTable, 'id', _dtvalues[dtkey]);
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(exdtTable, 'id', _dtvalues[dtkey]);
                            }
                        }
                        detailTableList_1.push(dtTable);
                        exdetailTableList_1.push(exdtTable);
                    });
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(detailTable, dttablename_1, detailTableList_1);
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(exdetailTable, dttableid_1, exdetailTableList_1);
                }
            };
            var dt;
            for (var key in values) {
                _loop_1(key);
            }
            var result = {
                'mainTable': mainTable,
                'detailTable': detailTable,
                'extendDatas': {
                    'exmainTable': exmainTable,
                    'exdetailTable': exdetailTable,
                }
            };
            return result;
        };
        this.setColor = function (colors, form) {
            if (form === void 0) { form = _this_1.card.cubeForm; }
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(colors))
                return;
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(colors, function (color, field) {
                if (color) {
                    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isString(color)) {
                        form.$(field).color = color;
                    }
                    else {
                        _this_1.setColor(color, form.$(field));
                    }
                }
            });
        };
        this.clearColor = function (colors, form) {
            if (colors === void 0) { colors = []; }
            if (form === void 0) { form = _this_1.card.cubeForm; }
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(colors))
                return;
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(colors, function (color, field) {
                if (color) {
                    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isString(color)) {
                        form.$(field).color = undefined;
                    }
                    else {
                        _this_1.clearColor(color, form.$(field));
                    }
                }
            });
        };
        this.clearAllColor = function () {
            _this_1.card.cubeForm.map(function (field) {
                field.color = undefined;
                field.map(function (row) {
                    row.map(function (f) {
                        f.color = undefined;
                    });
                });
            });
        };
        this.verifyRepeat = function (bool, v_fields, v_fieldinfos) {
            if (bool === void 0) { bool = true; }
            if (v_fields === void 0) { v_fields = []; }
            if (v_fieldinfos === void 0) { v_fieldinfos = []; }
            _this_1.clearAllColor();
            return new Promise(function (resolve, reject) {
                if (bool) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__apis_card__["F" /* getVerifyEntity */])(_this_1.card.params).then(function (_a) {
                        var status = _a.status, errorCode = _a.errorCode, error = _a.error, fields = _a.fields, fieldinfos = _a.fieldinfos;
                        if (status != '1') {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                            reject();
                            return;
                        }
                        if (fields && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(fields)) {
                            _this_1.handleVerifyRepeat(fields, fieldinfos, resolve, reject);
                        }
                        else {
                            resolve();
                        }
                    });
                }
                else {
                    _this_1.handleVerifyRepeat(v_fields, v_fieldinfos, resolve, reject);
                }
            });
        };
        //重复验证数据处理
        this.handleVerifyRepeat = function (fields, fieldinfos, resolve, reject) {
            if (fields && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(fields)) {
                var values_2 = {};
                fields.map(function (field) {
                    var _a = _this_1.card.getFieldProps(field), isdetail = _a.isdetail, detail = _a.detail;
                    if (isdetail) {
                        _this_1.card.cubeForm.$(detail).map(function (d, index) {
                            if (d.has(field)) {
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(values_2, detail + ".[" + index + "]." + field, d.$(field).getValue());
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(values_2, detail + ".[" + index + "].dtl_id", d.$('dtl_id').getValue());
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(values_2, detail + ".[" + index + "].index", index);
                            }
                        });
                    }
                    else {
                        if (_this_1.card.cubeForm.has(field)) {
                            var value = _this_1.card.cubeForm.$(field).getValue();
                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(values_2, field, value);
                        }
                        else { //设置了重复验证,但是卡片页面没有该字段
                            fieldinfos && fieldinfos.map(function (info) {
                                if (info.fieldid == field) {
                                    if (info.isdetail) {
                                        _this_1.card.cubeForm.$(info.detail).map(function (d, index) {
                                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(values_2, info.detail + ".[" + index + "]." + field, "");
                                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(values_2, info.detail + ".[" + index + "].dtl_id", "");
                                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(values_2, info.detail + ".[" + index + "].index", index);
                                        });
                                    }
                                    else {
                                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(values_2, field, '');
                                    }
                                }
                            });
                        }
                    }
                });
                Object(__WEBPACK_IMPORTED_MODULE_2__apis_card__["f" /* cubeVerifyRepeat */])(__assign({}, _this_1.card.params, { verifys: JSON.stringify(values_2) })).then(function (_a) {
                    var status = _a.status, errorCode = _a.errorCode, error = _a.error, verifyErrors = _a.verifyErrors;
                    if (status != '1') {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                        reject();
                        return;
                    }
                    var confirmsStr = '';
                    var confirmsIndex = 1;
                    var confirmsColor = {};
                    var breaksStr = '';
                    var breaksIndex = 1;
                    var breaksColor = {};
                    var repeatFields = [];
                    if (verifyErrors && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isArray(verifyErrors)) {
                        verifyErrors.map(function (verifyError) {
                            var color = verifyError.color, operate = verifyError.operate, errors = verifyError.errors, index = verifyError.index, errorFields = verifyError.errorFields, isDetailSelfRepeat = verifyError.isDetailSelfRepeat, fields = verifyError.fields, repeatIndex = verifyError.repeatIndex, detailName = verifyError.detailName;
                            if (isDetailSelfRepeat) {
                                if (operate == '0') { //operate == '0'禁止提交,operate == '1'	仅提醒不做处理
                                    breaksStr += (breaksIndex++) + "、" + detailName + getLabel(15323, "第") + repeatIndex.map(function (d) { return d + 1; }).join(",") + getLabel(18620, "行") + getLabel(18082, "重复") + '.<br />';
                                    fields.map(function (f) {
                                        var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                                        if (isdetail) { //明细表
                                            if (_this_1.card.cubeForm.has(detail)) {
                                                _this_1.card.cubeForm.$(detail).map(function (row, _index) {
                                                    if (repeatIndex.indexOf(_index) > -1 && row.has(f)) {
                                                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(breaksColor, "[" + detail + "." + row.key + "." + f + "]", color);
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            if (_this_1.card.cubeForm.has(f)) {
                                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(breaksColor, f, color);
                                            }
                                        }
                                    });
                                }
                                else {
                                    confirmsStr += confirmsIndex + "、" + detailName + getLabel(15323, "第") + repeatIndex.map(function (d) { return d + 1; }).join(",") + getLabel(18620, "行") + getLabel(18082, "重复") + '.<br />';
                                    confirmsIndex++;
                                    fields.map(function (f) {
                                        var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                                        if (isdetail) { //明细表
                                            if (_this_1.card.cubeForm.has(detail)) {
                                                _this_1.card.cubeForm.$(detail).map(function (row, _index) {
                                                    if (repeatIndex.indexOf(_index) > -1 && row.has(f)) {
                                                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(confirmsColor, "[" + detail + "." + row.key + "." + f + "]", color);
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            if (_this_1.card.cubeForm.has(f)) {
                                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(confirmsColor, f, color);
                                            }
                                        }
                                    });
                                }
                            }
                            else {
                                if (operate == '0') {
                                    repeatFields.push(verifyError);
                                    breaksStr += (breaksIndex++) + "、" + (errors.length > 1 ? getLabel('83735', "组合") + getLabel('84110', "验证") : '') + errors.join(",") + getLabel('383704', "已重复") + '.<br />';
                                    errorFields.map(function (f) {
                                        var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                                        if (isdetail) {
                                            if (_this_1.card.cubeForm.has(detail)) {
                                                _this_1.card.cubeForm.$(detail).map(function (row, _index) {
                                                    if (_index == index && row.has(f)) {
                                                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(breaksColor, "[" + detail + "." + row.key + "." + f + "]", color);
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            if (_this_1.card.cubeForm.has(f)) {
                                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(breaksColor, f, color);
                                            }
                                        }
                                    });
                                }
                                else {
                                    repeatFields.push(verifyError);
                                    confirmsStr += confirmsIndex + "、" + (errors.length > 1 ? getLabel('83735', "组合") + getLabel('84110', "验证") : '') + errors.join(",") + getLabel('383704', "已重复") + '.<br />';
                                    confirmsIndex++;
                                    errorFields.map(function (f) {
                                        var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                                        if (isdetail) {
                                            if (_this_1.card.cubeForm.has(detail)) {
                                                _this_1.card.cubeForm.$(detail).map(function (row, _index) {
                                                    if (_index == index && row.has(f)) {
                                                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(confirmsColor, "[" + detail + "." + row.key + "." + f + "]", color);
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            if (_this_1.card.cubeForm.has(f)) {
                                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(confirmsColor, f, color);
                                            }
                                        }
                                    });
                                }
                            }
                            //breaksIndex++;
                        });
                        if (confirmsStr) {
                            _this_1.setColor(confirmsColor);
                            __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                                width: 500,
                                content: (React.createElement("div", { style: { maxHeight: 600, overflowY: 'auto' } },
                                    React.createElement("div", null, getLabel('383707', "您录入的数据不满足以下验证:")),
                                    React.createElement("div", { dangerouslySetInnerHTML: { __html: confirmsStr } }),
                                    React.createElement("div", null,
                                        " ",
                                        getLabel(15382, '是否继续？')))),
                                okText: getLabel(1256, "继续"),
                                cancelText: getLabel(201, "取消"),
                                title: getLabel(15172, '系统提示'),
                                onOk: function () {
                                    _this_1.clearColor(confirmsColor);
                                    if (breaksStr) {
                                        _this_1.setColor(breaksColor);
                                        __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].error({
                                            width: 500,
                                            content: (React.createElement("div", { style: { maxHeight: 600, overflowY: 'auto' } },
                                                React.createElement("div", null, getLabel('383707', "您录入的数据不满足以下验证:")),
                                                React.createElement("div", { dangerouslySetInnerHTML: { __html: breaksStr } }),
                                                React.createElement("div", null,
                                                    " ",
                                                    getLabel('383708', "请重新录入"),
                                                    "\uFF01"))),
                                            title: getLabel(15172, '系统提示'),
                                        });
                                        reject();
                                    }
                                    else {
                                        resolve();
                                    }
                                },
                                onCancel: function () {
                                    reject();
                                }
                            });
                        }
                        else if (breaksStr) {
                            //明细表开启了分页
                            _this_1.repeatFieldsPosition(repeatFields);
                            _this_1.setColor(breaksColor);
                            __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].error({
                                width: 500,
                                content: (React.createElement("div", { style: { maxHeight: 600, overflowY: 'auto' } },
                                    React.createElement("div", null, getLabel('383707', "您录入的数据不满足以下验证:")),
                                    React.createElement("div", { dangerouslySetInnerHTML: { __html: breaksStr } }),
                                    React.createElement("div", null,
                                        " ",
                                        getLabel('383708', "请重新录入"),
                                        "\uFF01"))),
                                title: getLabel(15172, '系统提示'),
                            });
                            reject();
                        }
                        else {
                            resolve();
                        }
                    }
                    else {
                        resolve();
                    }
                });
            }
        };
        // @action
        // getFirstMainFied=()=>{
        //     let field:string = "";
        //     _.forEach(this.card.allFields,(v,key)=>{
        //         if(!v.isdetail){
        //             field = key;
        //             return;
        //         }
        //     })
        //     return field;
        // }
        this.check_form = function () {
            // const fistFields = this.getFirstMainFied();
            _this_1.card.cubeForm.validate();
            _this_1.card.cubeForm.showErrors();
            var firstErrorField = _this_1.card.cubeForm.firstErrorField;
            if (firstErrorField) {
                /**
                 * 此处处理明细表必填校验定位问题，页面跳转到当前第一个未填的数据所在的分页
                 */
                var nullFieldObj = _this_1.getDetailNullPlace();
                var path = nullFieldObj.path;
                if (path) {
                    var _a = path.split('.'), detail = _a[0], index = _a[1];
                    var fieldDetail = _this_1.card.cubeForm.$(detail);
                    var pageSize = Number(fieldDetail.pageSize);
                    var total = fieldDetail.values().length;
                    var pageTotal = Math.ceil(total / pageSize);
                    for (var i = 1; i <= pageTotal; i++) {
                        if (index >= pageSize * (i - 1) && index < pageSize * i) {
                            fieldDetail.pageNum = i;
                        }
                    }
                }
                scrollTo(firstErrorField, _this_1.card.cubeForm, function ($ele) {
                    var firstErrorFieldId = $ele.attr('data-fieldmark');
                    var _a = firstErrorFieldId.split("_"), field = _a[0], index = _a[1];
                    var _b = _this_1.card.getFieldProps(field), isdetail = _b.isdetail, detail = _b.detail;
                    var errorField;
                    if (isdetail) {
                        errorField = _this_1.card.cubeForm.$(detail + "." + index + "." + field);
                        scrollToX(firstErrorField, _this_1.card.cubeForm, function () {
                            errorField.tips = {
                                visible: true,
                                msg: errorField.errors()
                            };
                        });
                    }
                    else {
                        errorField = _this_1.card.cubeForm.$(field);
                        errorField.tips = {
                            visible: true,
                            msg: errorField.errors()
                        };
                    }
                    setTimeout(function () {
                        errorField.tips = {
                            visible: false,
                            msg: ''
                        };
                    }, 1500);
                });
            }
            return _this_1.card.cubeForm.isValid;
        };
        this.check_table = function () {
            var rt = true;
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this_1.card.modeExcel.details, function (detialExcel, detail) {
                if (detail.startsWith("detail_")) {
                    if (detialExcel.detailProps.isNeed) {
                        if (_this_1.card.cubeForm.$(detail).values().length < 1) {
                            rt = false;
                            scrollTo(__WEBPACK_IMPORTED_MODULE_6_jquery___default()("#" + detail.replace('detail_', 'oTable')), _this_1.card.cubeForm, function () {
                                detialExcel.error = {
                                    visible: true,
                                    msg: getLabel('383709', "未新增数据") + "needAdd"
                                };
                                setTimeout(function () {
                                    detialExcel.error = { visible: false, msg: getLabel('383709', "未新增数据") + "needAdd" };
                                }, 1000);
                            });
                        }
                    }
                }
            });
            return rt;
        };
        this.doSubmitDraft = function (pageexpandid, issystemflag, btntype, isRefreshto, callBack) {
            if (isRefreshto === void 0) { isRefreshto = true; }
            try {
                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isFunction(__WEBPACK_IMPORTED_MODULE_4__util__["default"].startUploadAll)) {
                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].startUploadAll();
                }
                var allUploaded_3 = false;
                var timer_3 = setInterval(function () {
                    allUploaded_3 = true;
                    _this_1.card.uploadFields.map(function (f) {
                        if (!allUploaded_3) {
                            return;
                        }
                        var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                        if (isdetail) {
                            if (_this_1.card.cubeForm.has(detail)) {
                                var detailTable = _this_1.card.cubeForm.$(detail);
                                detailTable.map(function (row) {
                                    if (!allUploaded_3) {
                                        return;
                                    }
                                    if (row.has(f)) {
                                        if (!row.$(f).isUpload) {
                                            allUploaded_3 = false;
                                        }
                                    }
                                });
                            }
                        }
                        else {
                            if (_this_1.card.cubeForm.has(f)) {
                                if (!_this_1.card.cubeForm.$(f).isUpload) {
                                    allUploaded_3 = false;
                                }
                            }
                        }
                    });
                    if (allUploaded_3) {
                        if (typeof (__WEBPACK_IMPORTED_MODULE_4__util__["default"].parent['slideflgfun']) == 'function') {
                            if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].parent['slideflgfun']()) {
                                __WEBPACK_IMPORTED_MODULE_4__util__["default"].parent['dosubmitfun']();
                            }
                        }
                        _this_1.doSubmitDraftPost(pageexpandid, issystemflag, callBack);
                        clearInterval(timer_3);
                    }
                }, 100);
            }
            catch (e) {
                _this_1.doSubmitDraftPost(pageexpandid, issystemflag, callBack);
            }
        };
        this.doSubmitDraftPost = function (detailid, issystemflag, callBack) {
            var values = _this_1.getSubmitData();
            var type = _this_1.card.params.type;
            var layoutid = _this_1.card.layoutid;
            var isFormMode = "1";
            var iscreate = _this_1.card.base.billid ? '2' : type;
            var src = (type == 1 && !_this_1.card.base.billid) ? "submit" : "save";
            var currentLayoutId = layoutid;
            _this_1.card.cardTab.disabled = true;
            Object(__WEBPACK_IMPORTED_MODULE_2__apis_card__["k" /* doSubmit */])(__assign({}, _this_1.card.params, { token: _this_1.card.token, layoutid: layoutid,
                isFormMode: isFormMode,
                iscreate: iscreate,
                src: src,
                currentLayoutId: currentLayoutId, pageexpandid: detailid, JSONStr: JSON.stringify(values), issystemflag: issystemflag, modedatastatus: 1 }, _this_1.card.submitParam)).then(function (_a) {
                var billid = _a.billid, pageExpendResult = _a.pageExpendResult;
                if (pageExpendResult) {
                    var obj = JSON.parse(pageExpendResult);
                    if (obj.flag == "false") {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].error({
                            content: obj.errmsg
                        });
                        return;
                    }
                }
                var query = __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.getCurrentLocation().query;
                query = __assign({}, _this_1.card.params, query);
                query.type = '0'; //type =0 显示 1 新建
                query.billid = billid;
                query.t = new Date().getTime();
                delete query._key; //新建完成后，后面push会添加一个key，这里删掉key，确保不会两个key导致两次请求。
                var queryStr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mapKeys(query, function (value, key) {
                    return key + "=" + value;
                })).join("&");
                if (callBack && typeof callBack == 'function') {
                    callBack(billid);
                }
                if (_this_1.card.params && _this_1.card.params.istree) { //处理树的情况下，是否刷新左侧树，禁止路由跳转
                    _this_1.card.init(query);
                    if (_this_1.card.params.isRefreshTree == '1') {
                        __WEBPACK_IMPORTED_MODULE_4__util__["default"].refreshTree(_this_1.card.params.customTreeDataId);
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.push({ pathname: "/main/cube/card?" + queryStr });
                }
                try {
                    //--------------------------------------是否看板，看板相关处理
                    var _b = _this_1.card.params, boardid = _b.boardid, boardgroup = _b.boardgroup, boardcustomid = _b.boardcustomid, viewfrom = _b.viewfrom;
                    if (boardid && boardgroup && boardcustomid) {
                        if (top.window['current_boardStore']) {
                            top.window['current_boardStore'].cardSaveFun(billid, iscreate, boardid, boardgroup, boardcustomid);
                        }
                        else if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener.cubeStore) {
                            __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener.cubeStore.boardStore.doSearch();
                        }
                    }
                    else if (viewfrom == 'fromboarditem' && __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener.cubeStore) {
                        __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener.cubeStore.boardStore.doSearch();
                    }
                    else {
                        //--------------打开的列表数据回调刷新页面-----
                        _this_1.card.cardTab.disabled = false;
                        if (__WEBPACK_IMPORTED_MODULE_4__util__["default"].opener) {
                            var _c = __WEBPACK_IMPORTED_MODULE_4__util__["default"].opener, _table = _c._table, cubeStore = _c.cubeStore;
                            if (_table && _table.reLoad) {
                                var isTreeList = cubeStore && cubeStore.Search.dataShowtype === 'treeType' && cubeStore.Search.changeSearch == '1'; // 分组的组合转换，单独判断
                                if (isTreeList && cubeStore.Search.customId) {
                                    cubeStore.Search.refresh();
                                }
                                else {
                                    _table.reLoad();
                                }
                            }
                            else if (cubeStore && cubeStore.Search.customId) {
                                cubeStore.Search.refresh();
                            }
                        }
                        else if (top.window && top.window['cubeStore'] && top.window['cubeStore']) {
                            var _table = top.window['_table'];
                            var _d = top.window['cubeStore'].Search, slideModalVisible = _d.slideModalVisible, customId = _d.customId, reloadBaseList = _d.reloadBaseList;
                            if (slideModalVisible) {
                                if (_this_1.card.params.customid == customId) { // base列表刷新
                                    reloadBaseList();
                                }
                                else {
                                    _table && _table.reLoad(); // 滑动展开的列表刷新
                                }
                            }
                        }
                    }
                }
                catch (e) {
                }
                //----------------------------------------是否看板，看板相关处理
            });
        };
        this.getDetailNullPlace = function () {
            var nullField = {};
            _this_1.card.cubeForm.map(function (d) { return d.key.startsWith('detail_') && d.map(function (a) { return a.map(function (b) {
                if (!b.isValid && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(nullField)) {
                    nullField = b;
                    return;
                }
                ;
                return b.isValid;
            }); }); });
            return { path: nullField.path || "", label: nullField.label || "" };
        };
        /**
         * 明细表分页重复验证定位
         */
        this.repeatFieldsPosition = function (fields) {
            if (fields === void 0) { fields = []; }
            var detailObj = {};
            fields.map(function (field) {
                var f = field.errorFields[0];
                var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                if (isdetail) {
                    if (_this_1.card.cubeForm.has(detail)) {
                        if (!detailObj[detail]) {
                            detailObj[detail] = [];
                        }
                        detailObj[detail].push(field.index);
                    }
                }
            });
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(detailObj)) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(detailObj, function (val, key) {
                    var value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortedUniq(val)[0];
                    var fieldDetail = _this_1.card.cubeForm.$(key);
                    var pageSize = Number(fieldDetail.pageSize);
                    var total = fieldDetail.values().length;
                    var pageTotal = Math.ceil(total / pageSize);
                    for (var i = 1; i <= pageTotal; i++) {
                        if (value >= pageSize * (i - 1) && value < pageSize * i) {
                            fieldDetail.pageNum = i;
                        }
                    }
                });
            }
        };
        this.card = card;
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DoSubmit.prototype, "setColor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DoSubmit.prototype, "clearColor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DoSubmit.prototype, "clearAllColor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"] //重复验证
    ], DoSubmit.prototype, "verifyRepeat", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DoSubmit.prototype, "handleVerifyRepeat", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DoSubmit.prototype, "check_form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DoSubmit.prototype, "check_table", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DoSubmit.prototype, "getDetailNullPlace", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DoSubmit.prototype, "repeatFieldsPosition", void 0);
    return DoSubmit;
}());
/* harmony default export */ __webpack_exports__["a"] = (DoSubmit);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(188),
    castPath = __webpack_require__(73),
    isIndex = __webpack_require__(96),
    isObject = __webpack_require__(23),
    toKey = __webpack_require__(74);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 294 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23),
    now = __webpack_require__(609),
    toNumber = __webpack_require__(193);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(297);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 297 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(189),
    eq = __webpack_require__(94);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(300);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(21);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(194);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(128),
    getPrototype = __webpack_require__(195),
    isPrototype = __webpack_require__(129);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(621),
    isArguments = __webpack_require__(97),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(99),
    isIndex = __webpack_require__(96),
    isTypedArray = __webpack_require__(130);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(77),
    isIterateeCall = __webpack_require__(131);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(197);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(129),
    nativeKeys = __webpack_require__(628);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(45);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isFunction2 = __webpack_require__(44);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _mobx = __webpack_require__(4);

var _utils = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Base = (_class = function () {
  function Base() {
    var _this = this;

    _classCallCheck(this, Base);

    this.noop = function () {};

    this.execHook = function (name) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, _utils.$try)(fallback[name], _this.$hooks[name], _this.hooks && _this.hooks.apply(_this, [_this])[name], _this.noop).apply(_this, [_this]);
    };

    this.execHandler = function (name, args) {
      var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return [(0, _utils.$try)(_this.$handlers[name] && _this.$handlers[name].apply(_this, [_this]), _this.handlers && _this.handlers.apply(_this, [_this])[name].apply(_this, [_this]), fallback, _this.noop).apply(_this, [].concat(_toConsumableArray(args))), _this.execHook(name)];
    };

    this.intercept = function (opt) {
      return _this.MOBXEvent((0, _isFunction3.default)(opt) ? { type: 'interceptor', call: opt } : _extends({ type: 'interceptor' }, opt));
    };

    this.observe = function (opt) {
      return _this.MOBXEvent((0, _isFunction3.default)(opt) ? { type: 'observer', call: opt } : _extends({ type: 'observer' }, opt));
    };

    this.onClear = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _this.execHandler('onClear', args, function (e) {
        e.preventDefault();
        _this.clear(true);
      });
    };

    this.onReset = function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.execHandler('onReset', args, function (e) {
        e.preventDefault();
        _this.reset(true);
      });
    };

    this.onSubmit = function () {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.execHandler('onSubmit', args, function (e) {
        var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        e.preventDefault();
        _this.submit(o);
      });
    };

    this.onAdd = function () {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.execHandler('onAdd', args, function (e, val) {
        e.preventDefault();
        _this.add((0, _utils.$isEvent)(val) ? null : val);
      });
    };

    this.onDel = function () {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.execHandler('onDel', args, function (e, path) {
        e.preventDefault();
        _this.del((0, _utils.$isEvent)(path) ? _this.path : path);
      });
    };
  }

  _createClass(Base, [{
    key: 'hasIncrementalKeys',
    get: function get() {
      return this.fields.size && (0, _utils.hasIntKeys)(this.fields);
    }
  }, {
    key: 'hasNestedFields',
    get: function get() {
      return this.fields.size !== 0;
    }
  }, {
    key: 'size',
    get: function get() {
      return this.fields.size;
    }

    /**
     Interceptor
     */


    /**
     Observer
     */


    /**
      Event Handler: On Clear
    */


    /**
      Event Handler: On Reset
    */


    /**
      Event Handler: On Submit
     */


    /**
      Event Handler: On Add
    */


    /**
      Event Handler: On Del
    */

  }]);

  return Base;
}(), (_applyDecoratedDescriptor(_class.prototype, 'hasIncrementalKeys', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'hasIncrementalKeys'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasNestedFields', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'hasNestedFields'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'size', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'size'), _class.prototype)), _class);
exports.default = Base;
module.exports = exports['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(80);

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(316),
    createBind = __webpack_require__(636),
    createCurry = __webpack_require__(637),
    createHybrid = __webpack_require__(319),
    createPartial = __webpack_require__(650),
    getData = __webpack_require__(323),
    mergeData = __webpack_require__(651),
    setData = __webpack_require__(326),
    setWrapToString = __webpack_require__(327),
    toInteger = __webpack_require__(80);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(78),
    metaMap = __webpack_require__(317);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(318);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(320),
    composeArgsRight = __webpack_require__(321),
    countHolders = __webpack_require__(638),
    createCtor = __webpack_require__(133),
    createRecurry = __webpack_require__(322),
    getHolder = __webpack_require__(203),
    reorder = __webpack_require__(649),
    replaceHolders = __webpack_require__(136),
    root = __webpack_require__(21);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 321 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(639),
    setData = __webpack_require__(326),
    setWrapToString = __webpack_require__(327);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(317),
    noop = __webpack_require__(324);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(128),
    baseLodash = __webpack_require__(202);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(316),
    shortOut = __webpack_require__(310);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(644),
    insertWrapDetails = __webpack_require__(645),
    setToString = __webpack_require__(198),
    updateWrapDetails = __webpack_require__(646);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(138),
    arraySome = __webpack_require__(330),
    cacheHas = __webpack_require__(139);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(332),
    getSymbols = __webpack_require__(209),
    keys = __webpack_require__(46);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(208),
    isArray = __webpack_require__(13);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 333 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(666),
    hasPath = __webpack_require__(339);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(73),
    isArguments = __webpack_require__(97),
    isArray = __webpack_require__(13),
    isIndex = __webpack_require__(96),
    isLength = __webpack_require__(196),
    toKey = __webpack_require__(74);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(135);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(135);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(37);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(51),
    baseIntersection = __webpack_require__(679),
    baseRest = __webpack_require__(77),
    castArrayLikeObject = __webpack_require__(680);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(141),
    baseSet = __webpack_require__(291),
    castPath = __webpack_require__(73);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(208),
    getPrototype = __webpack_require__(195),
    getSymbols = __webpack_require__(209),
    stubArray = __webpack_require__(334);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(138),
    arrayIncludes = __webpack_require__(134),
    arrayIncludesWith = __webpack_require__(211),
    arrayMap = __webpack_require__(51),
    baseUnary = __webpack_require__(61),
    cacheHas = __webpack_require__(139);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(708),
    overRest = __webpack_require__(309),
    setToString = __webpack_require__(198);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prototypes = exports.default = undefined;

var _omit2 = __webpack_require__(711);

var _omit3 = _interopRequireDefault(_omit2);

var _head2 = __webpack_require__(215);

var _head3 = _interopRequireDefault(_head2);

var _toString2 = __webpack_require__(37);

var _toString3 = _interopRequireDefault(_toString2);

var _isPlainObject2 = __webpack_require__(52);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _has2 = __webpack_require__(82);

var _has3 = _interopRequireDefault(_has2);

var _map2 = __webpack_require__(137);

var _map3 = _interopRequireDefault(_map2);

var _isNil2 = __webpack_require__(83);

var _isNil3 = _interopRequireDefault(_isNil2);

var _isDate2 = __webpack_require__(204);

var _isDate3 = _interopRequireDefault(_isDate2);

var _isBoolean2 = __webpack_require__(132);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _isEqual2 = __webpack_require__(729);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _toNumber2 = __webpack_require__(193);

var _toNumber3 = _interopRequireDefault(_toNumber2);

var _isNumber2 = __webpack_require__(212);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _isString2 = __webpack_require__(47);

var _isString3 = _interopRequireDefault(_isString2);

var _isEmpty2 = __webpack_require__(81);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _debounce2 = __webpack_require__(295);

var _debounce3 = _interopRequireDefault(_debounce2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _desc2, _value2, _obj;

var _mobx = __webpack_require__(4);

var _Base2 = __webpack_require__(313);

var _Base3 = _interopRequireDefault(_Base2);

var _utils = __webpack_require__(27);

var _parser = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var setupFieldProps = function setupFieldProps(instance, props, data) {
  return Object.assign(instance, {
    $value: instance.$initial,
    $label: props.$label || data.label || instance.name,
    $placeholder: props.$placeholder || data.placeholder || '',
    $disabled: props.$disabled || data.disabled || false,
    $bindings: props.$bindings || data.bindings || 'default',
    $related: props.$related || data.related || [],
    $validators: (0, _mobx.toJS)(props.$validators || data.validators || null),
    $validatedWith: props.$validatedWith || data.validatedWith || 'value',
    $rules: props.$rules || data.rules || null,
    $observers: props.$observers || data.observers || null,
    $interceptors: props.$interceptors || data.interceptors || null,
    $extra: props.$extra || data.extra || null,
    $options: props.$options || data.options || {},
    $hooks: props.$hooks || data.hooks || {},
    $handlers: props.$handlers || data.handlers || {}
  });
};

var setupDefaultProp = function setupDefaultProp(instance, data, props, update, _ref) {
  var isEmptyArray = _ref.isEmptyArray,
      checkArray = _ref.checkArray;
  return (0, _parser.parseInput)(instance.$input, {
    isEmptyArray: isEmptyArray,
    type: instance.type,
    unified: update ? '' : checkArray(data.default),
    separated: checkArray(props.$default),
    initial: checkArray(instance.$initial)
  });
};

var Field = (_class = function (_Base) {
  _inherits(Field, _Base);

  function Field(_ref2) {
    var key = _ref2.key,
        path = _ref2.path,
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data,
        _ref2$props = _ref2.props,
        props = _ref2$props === undefined ? {} : _ref2$props,
        _ref2$update = _ref2.update,
        update = _ref2$update === undefined ? false : _ref2$update,
        state = _ref2.state;

    _classCallCheck(this, Field);

    var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this));

    _this.fields = _mobx.observable.map ? _mobx.observable.map({}) : (0, _mobx.asMap)({});
    _this.hasInitialNestedFields = false;
    _this.incremental = false;
    _this.$hooks = {};
    _this.$handlers = {};

    _this.$input = function ($) {
      return $;
    };

    _this.$output = function ($) {
      return $;
    };

    _initDefineProp(_this, '$options', _descriptor, _this);

    _initDefineProp(_this, '$value', _descriptor2, _this);

    _initDefineProp(_this, '$label', _descriptor3, _this);

    _initDefineProp(_this, '$placeholder', _descriptor4, _this);

    _initDefineProp(_this, '$default', _descriptor5, _this);

    _initDefineProp(_this, '$initial', _descriptor6, _this);

    _initDefineProp(_this, '$bindings', _descriptor7, _this);

    _initDefineProp(_this, '$extra', _descriptor8, _this);

    _initDefineProp(_this, '$related', _descriptor9, _this);

    _initDefineProp(_this, '$validatedWith', _descriptor10, _this);

    _initDefineProp(_this, '$validators', _descriptor11, _this);

    _initDefineProp(_this, '$rules', _descriptor12, _this);

    _initDefineProp(_this, '$disabled', _descriptor13, _this);

    _initDefineProp(_this, '$focused', _descriptor14, _this);

    _initDefineProp(_this, '$touched', _descriptor15, _this);

    _initDefineProp(_this, '$changed', _descriptor16, _this);

    _initDefineProp(_this, '$submitting', _descriptor17, _this);

    _initDefineProp(_this, '$validating', _descriptor18, _this);

    _initDefineProp(_this, '$clearing', _descriptor19, _this);

    _initDefineProp(_this, '$resetting', _descriptor20, _this);

    _initDefineProp(_this, 'autoFocus', _descriptor21, _this);

    _initDefineProp(_this, 'showError', _descriptor22, _this);

    _initDefineProp(_this, 'errorSync', _descriptor23, _this);

    _initDefineProp(_this, 'errorAsync', _descriptor24, _this);

    _initDefineProp(_this, 'validationErrorStack', _descriptor25, _this);

    _initDefineProp(_this, 'validationFunctionsData', _descriptor26, _this);

    _initDefineProp(_this, 'validationAsyncData', _descriptor27, _this);

    _initDefineProp(_this, 'files', _descriptor28, _this);

    _this.sync = (0, _mobx.action)(function (e) {
      var v = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      _this.$changed = true;

      var $get = function $get($) {
        return (0, _utils.$isBool)($, _this.value) ? $.target.checked : $.target.value;
      };

      // assume "v" or "e" are the values
      if ((0, _isNil3.default)(e) || (0, _isNil3.default)(e.target)) {
        if (!(0, _isNil3.default)(v) && !(0, _isNil3.default)(v.target)) {
          v = $get(v); // eslint-disable-line
        }

        _this.value = (0, _utils.$try)(e, v);
        return;
      }

      if (!(0, _isNil3.default)(e.target)) {
        _this.value = $get(e);
        return;
      }

      _this.value = e;
    });

    _this.onChange = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _this.type === 'file' ? _this.onDrop.apply(_this, args) : _this.execHandler('onChange', args, _this.sync);
    };

    _this.onToggle = function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.execHandler('onToggle', args, _this.sync);
    };

    _this.onBlur = function () {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.execHandler('onBlur', args, (0, _mobx.action)(function () {
        _this.$focused = false;
      }));
    };

    _this.onFocus = function () {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.execHandler('onFocus', args, (0, _mobx.action)(function () {
        _this.$focused = true;
        _this.$touched = true;
      }));
    };

    _this.onDrop = function () {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.execHandler('onDrop', args, (0, _mobx.action)(function () {
        var e = args[0];
        var files = null;

        if ((0, _utils.$isEvent)(e) && (0, _utils.$hasFiles)(e)) {
          files = (0, _map3.default)(e.target.files);
        }

        _this.files = files || args;
      }));
    };

    _this.state = state;

    _this.setupField(key, path, data, props, update);
    _this.checkDVRValidationPlugin();
    _this.initNestedFields(data, update);

    _this.incremental = _this.hasIncrementalKeys !== 0;

    _this.debouncedValidation = (0, _debounce3.default)(_this.validate, _this.state.options.get('validationDebounceWait', _this), _this.state.options.get('validationDebounceOptions', _this));

    _this.observeValidationOnBlur();
    _this.observeValidationOnChange();

    _this.initMOBXEvent('observers');
    _this.initMOBXEvent('interceptors');

    _this.execHook('onInit');
    return _this;
  }

  /* ------------------------------------------------------------------ */
  /* COMPUTED */

  _createClass(Field, [{
    key: 'checkValidationErrors',
    get: function get() {
      return this.validationAsyncData.valid === false && !(0, _isEmpty3.default)(this.validationAsyncData) || !(0, _isEmpty3.default)(this.validationErrorStack) || (0, _isString3.default)(this.errorAsync) || (0, _isString3.default)(this.errorSync);
    }
  }, {
    key: 'checked',
    get: function get() {
      return this.type === 'checkbox' ? this.value : undefined;
    }
  }, {
    key: 'value',
    get: function get() {
      return this.getComputedProp('value');
    },
    set: function set(newVal) {
      if (this.$value === newVal) return;
      // handle numbers
      if (this.state.options.get('autoParseNumbers', this) === true) {
        if ((0, _isNumber3.default)(this.$initial)) {
          if (new RegExp('^-?\\d+(,\\d+)*(\\.\\d+([eE]\\d+)?)?$', 'g').exec(newVal)) {
            this.$value = (0, _toNumber3.default)(newVal);
            return;
          }
        }
      }
      // handle parse value
      this.$value = newVal;
    }
  }, {
    key: 'initial',
    get: function get() {
      return this.getComputedProp('initial');
    },
    set: function set(val) {
      this.$initial = (0, _parser.parseInput)(this.$input, { separated: val });
    }
  }, {
    key: 'default',
    get: function get() {
      return this.getComputedProp('default');
    },
    set: function set(val) {
      this.$default = (0, _parser.parseInput)(this.$input, { separated: val });
    }
  }, {
    key: 'actionRunning',
    get: function get() {
      return this.submitting || this.clearing || this.resetting;
    }
  }, {
    key: 'submitting',
    get: function get() {
      return (0, _mobx.toJS)(this.$submitting);
    }
  }, {
    key: 'validating',
    get: function get() {
      return (0, _mobx.toJS)(this.$validating);
    }
  }, {
    key: 'label',
    get: function get() {
      return (0, _parser.parseGetLabel)(this.$label);
    }
  }, {
    key: 'placeholder',
    get: function get() {
      return (0, _mobx.toJS)(this.$placeholder);
    }
  }, {
    key: 'extra',
    get: function get() {
      return (0, _mobx.toJS)(this.$extra);
    }
  }, {
    key: 'options',
    get: function get() {
      return (0, _mobx.toJS)(this.$options);
    }
  }, {
    key: 'bindings',
    get: function get() {
      return (0, _mobx.toJS)(this.$bindings);
    }
  }, {
    key: 'related',
    get: function get() {
      return (0, _mobx.toJS)(this.$related);
    }
  }, {
    key: 'disabled',
    get: function get() {
      return (0, _mobx.toJS)(this.$disabled);
    }
  }, {
    key: 'rules',
    get: function get() {
      return (0, _mobx.toJS)(this.$rules);
    }
  }, {
    key: 'validators',
    get: function get() {
      return (0, _mobx.toJS)(this.$validators);
    }
  }, {
    key: 'validatedValue',
    get: function get() {
      return this[this.$validatedWith];
    }
  }, {
    key: 'error',
    get: function get() {
      if (this.showError === false) return null;
      return this.errorAsync || this.errorSync || null;
    }
  }, {
    key: 'hasError',
    get: function get() {
      return this.checkValidationErrors || this.check('hasError', true);
    }
  }, {
    key: 'isValid',
    get: function get() {
      return !this.checkValidationErrors && this.check('isValid', true);
    }
  }, {
    key: 'isDirty',
    get: function get() {
      return this.hasNestedFields ? this.check('isDirty', true) : !(0, _isEqual3.default)(this.$default, this.value);
    }
  }, {
    key: 'isPristine',
    get: function get() {
      return this.hasNestedFields ? this.check('isPristine', true) : (0, _isEqual3.default)(this.$default, this.value);
    }
  }, {
    key: 'isDefault',
    get: function get() {
      return this.hasNestedFields ? this.check('isDefault', true) : (0, _isEqual3.default)(this.$default, this.value);
    }
  }, {
    key: 'resetting',
    get: function get() {
      return this.hasNestedFields ? this.check('resetting', true) : this.$resetting;
    }
  }, {
    key: 'clearing',
    get: function get() {
      return this.hasNestedFields ? this.check('clearing', true) : this.$clearing;
    }
  }, {
    key: 'isEmpty',
    get: function get() {
      if (this.hasNestedFields) return this.check('isEmpty', true);
      if ((0, _isBoolean3.default)(this.value)) return !!this.$value;
      if ((0, _isNumber3.default)(this.value)) return false;
      if ((0, _isDate3.default)(this.value)) return false;
      return (0, _isEmpty3.default)(this.value);
    }
  }, {
    key: 'focused',
    get: function get() {
      return this.hasNestedFields ? this.check('focused', true) : this.$focused;
    }
  }, {
    key: 'touched',
    get: function get() {
      return this.hasNestedFields ? this.check('touched', true) : this.$touched;
    }
  }, {
    key: 'changed',
    get: function get() {
      return this.hasNestedFields ? this.check('changed', true) : this.$changed;
    }

    /* ------------------------------------------------------------------ */
    /* EVENTS HANDLERS */

  }]);

  return Field;
}(_Base3.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '$options', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, '$value', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, '$label', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, '$placeholder', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, '$default', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, '$initial', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, '$bindings', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, '$extra', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, '$related', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, '$validatedWith', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, '$validators', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, '$rules', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, '$disabled', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, '$focused', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, '$touched', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, '$changed', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, '$submitting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, '$validating', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, '$clearing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, '$resetting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, 'autoFocus', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, 'showError', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, 'errorSync', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, 'errorAsync', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, 'validationErrorStack', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, 'validationFunctionsData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, 'validationAsyncData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, 'files', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'checkValidationErrors', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'checkValidationErrors'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'checked', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'checked'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'value', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'value'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initial', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'initial'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'default', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'default'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'actionRunning', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'actionRunning'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'submitting', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'submitting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validating', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'validating'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'label', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'label'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'placeholder', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'placeholder'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'extra', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'extra'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'options', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'options'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindings', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'bindings'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'related', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'related'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'disabled', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'disabled'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'rules', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'rules'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validators', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'validators'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validatedValue', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'validatedValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'error', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'error'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasError', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'hasError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isValid', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isValid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDirty', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isPristine', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isPristine'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDefault', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isDefault'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetting', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'resetting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearing', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'clearing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isEmpty', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isEmpty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'focused', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'focused'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'touched', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'touched'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changed', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'changed'), _class.prototype)), _class);

/**
  Prototypes
*/

exports.default = Field;
var prototypes = exports.prototypes = (_obj = {
  setupField: function setupField($key, $path, $data, $props, update) {
    this.key = $key;
    this.path = $path;
    this.id = this.state.options.get('uniqueId').apply(this, [this]);
    var isEmptyArray = (0, _has3.default)($data, 'fields') && (0, _isArray3.default)($data.fields);
    var checkArray = function checkArray(val) {
      return isEmptyArray ? [] : val;
    };

    var $value = $props.$value,
        $type = $props.$type,
        $input = $props.$input,
        $output = $props.$output;

    // eslint-disable-next-line

    if ((0, _isNil3.default)($data)) $data = '';

    if ((0, _isPlainObject3.default)($data)) {
      var _$data = $data,
          value = _$data.value,
          type = _$data.type,
          input = _$data.input,
          output = _$data.output;


      this.type = $type || type || 'text';
      this.name = (0, _toString3.default)($data.name || $key);

      this.$input = (0, _utils.$try)($input, input, this.$input);
      this.$output = (0, _utils.$try)($output, output, this.$output);

      this.$initial = (0, _parser.parseInput)(this.$input, {
        isEmptyArray: isEmptyArray,
        type: this.type,
        unified: checkArray(value),
        separated: checkArray($props.$initial),
        initial: checkArray($data.initial)
      });

      this.$default = setupDefaultProp(this, $data, $props, update, {
        isEmptyArray: isEmptyArray, checkArray: checkArray
      });

      setupFieldProps(this, $props, $data);
      return;
    }

    /* The field IS the value here */
    this.name = (0, _toString3.default)($key);
    this.type = $type || 'text';

    this.$input = (0, _utils.$try)($input, this.$input);
    this.$output = (0, _utils.$try)($output, this.$output);

    this.$initial = (0, _parser.parseInput)(this.$input, {
      isEmptyArray: isEmptyArray,
      type: this.type,
      unified: checkArray($data),
      separated: checkArray($value)
    });

    this.$default = setupDefaultProp(this, $data, $props, update, {
      isEmptyArray: isEmptyArray, checkArray: checkArray
    });

    setupFieldProps(this, $props, $data);
  },
  getComputedProp: function getComputedProp(key) {
    var _this2 = this;

    if (this.incremental || this.hasNestedFields) {
      var $val = key === 'value' ? this.get(key, false) : (0, _mobx.untracked)(function () {
        return _this2.get(key, false);
      });

      return !(0, _isEmpty3.default)($val) ? $val : [];
    }

    var val = this['$' + key];

    if ((0, _isArray3.default)(val) || (0, _mobx.isObservableArray)(val)) {
      return [].slice.call(val);
    }

    return (0, _mobx.toJS)(val);
  },
  checkDVRValidationPlugin: function checkDVRValidationPlugin() {
    var drivers = this.state.form.validator.drivers;

    if ((0, _isNil3.default)(drivers.dvr) && !(0, _isNil3.default)(this.rules)) {
      // eslint-disable-next-line
      console.warn('The DVR validation rules are defined', 'but no plugin provided (DVR). Field:', this.path);
    }
  },
  initNestedFields: function initNestedFields(field, update) {
    var fields = (0, _isNil3.default)(field) ? null : field.fields;

    if ((0, _isArray3.default)(fields) && !(0, _isEmpty3.default)(fields)) {
      this.hasInitialNestedFields = true;
    }

    this.initFields({ fields: fields }, update);
  },
  invalidate: function invalidate(message) {
    var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (async === true) {
      this.errorAsync = message;
      return;
    }

    if ((0, _isArray3.default)(message)) {
      this.validationErrorStack = message;
      this.showErrors(true);
      return;
    }

    this.validationErrorStack.unshift(message);
    this.showErrors(true);
  },
  setValidationAsyncData: function setValidationAsyncData() {
    var valid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    this.validationAsyncData = { valid: valid, message: message };
  },
  resetValidation: function resetValidation() {
    var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    this.showError = true;
    this.errorSync = null;
    this.errorAsync = null;
    this.validationAsyncData = {};
    this.validationFunctionsData = [];
    this.validationErrorStack = [];
    if (deep) this.each(function (field) {
      return field.resetValidation();
    });
  },
  clear: function clear() {
    var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.$clearing = true;
    this.$touched = false;
    this.$changed = false;

    this.$value = (0, _parser.defaultClearValue)({ value: this.$value });
    this.files = undefined;

    if (deep) this.each(function (field) {
      return field.clear(true, false);
    });

    this.validate({
      showErrors: this.state.options.get('showErrorsOnClear', this)
    });
  },
  reset: function reset() {
    var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.$resetting = true;
    this.$touched = false;
    this.$changed = false;

    var useDefaultValue = this.$default !== this.$initial;
    if (useDefaultValue) this.value = this.$default;
    if (!useDefaultValue) this.value = this.$initial;
    this.files = undefined;

    if (deep) this.each(function (field) {
      return field.reset(true, false);
    });

    this.validate({
      showErrors: this.state.options.get('showErrorsOnReset', this)
    });
  },
  focus: function focus() {
    // eslint-disable-next-line
    this.state.form.each(function (field) {
      return field.autoFocus = false;
    });
    this.autoFocus = true;
  },
  showErrors: function showErrors() {
    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.showError = show;
    this.errorSync = (0, _head3.default)(this.validationErrorStack);
    this.each(function (field) {
      return field.showErrors(show);
    });
  },
  showAsyncErrors: function showAsyncErrors() {
    if (this.validationAsyncData.valid === false) {
      this.errorAsync = this.validationAsyncData.message;
      return;
    }
    this.errorAsync = null;
  },
  observeValidationOnBlur: function observeValidationOnBlur() {
    var _this3 = this;

    var opt = this.state.options;
    if (opt.get('validateOnBlur', this)) {
      this.disposeValidationOnBlur = (0, _mobx.observe)(this, '$focused', function (change) {
        return change.newValue === false && _this3.debouncedValidation({
          showErrors: opt.get('showErrorsOnBlur', _this3)
        });
      });
    }
  },
  observeValidationOnChange: function observeValidationOnChange() {
    var _this4 = this;

    var opt = this.state.options;
    if (opt.get('validateOnChange', this)) {
      this.disposeValidationOnChange = (0, _mobx.observe)(this, '$value', function () {
        return !_this4.actionRunning && _this4.debouncedValidation({
          showErrors: opt.get('showErrorsOnChange', _this4)
        });
      });
    }
  },
  initMOBXEvent: function initMOBXEvent(type) {
    if (!(0, _isArray3.default)(this['$' + type])) return;

    var fn = void 0;
    if (type === 'observers') fn = this.observe;
    if (type === 'interceptors') fn = this.intercept;
    this['$' + type].map(function (obj) {
      return fn((0, _omit3.default)(obj, 'path'));
    });
  },
  bind: function bind() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return this.state.bindings.load(this, this.bindings, props);
  }
}, (_applyDecoratedDescriptor(_obj, 'setupField', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'setupField'), _obj), _applyDecoratedDescriptor(_obj, 'initNestedFields', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'initNestedFields'), _obj), _applyDecoratedDescriptor(_obj, 'invalidate', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'invalidate'), _obj), _applyDecoratedDescriptor(_obj, 'setValidationAsyncData', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'setValidationAsyncData'), _obj), _applyDecoratedDescriptor(_obj, 'resetValidation', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'resetValidation'), _obj), _applyDecoratedDescriptor(_obj, 'clear', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'clear'), _obj), _applyDecoratedDescriptor(_obj, 'reset', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'reset'), _obj), _applyDecoratedDescriptor(_obj, 'focus', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'focus'), _obj), _applyDecoratedDescriptor(_obj, 'showErrors', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'showErrors'), _obj), _applyDecoratedDescriptor(_obj, 'showAsyncErrors', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'showAsyncErrors'), _obj)), _obj);

/***/ }),
/* 351 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(733),
    baseEach = __webpack_require__(79),
    baseIteratee = __webpack_require__(40),
    baseReduce = __webpack_require__(353),
    isArray = __webpack_require__(13);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(60),
    castSlice = __webpack_require__(143),
    charsEndIndex = __webpack_require__(341),
    stringToArray = __webpack_require__(144),
    toString = __webpack_require__(37),
    trimmedEndIndex = __webpack_require__(297);

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.slice(0, trimmedEndIndex(string) + 1);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

  return castSlice(strSymbols, 0, end).join('');
}

module.exports = trimEnd;


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDateBetweenDates; });
/* unused harmony export getWeekStartAndEnd */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isInWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getHourBetweenDates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var getDate = function (datestr) {
    return new Date(datestr);
};
//获取开始日期及结束日期之间的日期
var getDateBetweenDates = function (start, end) {
    var startTime = getDate(start);
    var endTime = getDate(end);
    var result = [];
    while ((endTime.getTime() - startTime.getTime()) >= 0) {
        var year = startTime.getFullYear();
        var month = startTime.getMonth() < 9 ? "0" + (startTime.getMonth() + 1).toString() : startTime.getMonth() + 1;
        var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
        result.push(year + "-" + month + "-" + day);
        startTime.setDate(startTime.getDate() + 1);
    }
    return result;
};
var f = 'YYYY-MM-DD';
var f1 = 'YYYY-MM-DD HH:MM';
//获取当前日期所在周的开始日期和结束日期
var getWeekStartAndEnd = function (date, weekstart) {
    if (date === void 0) { date = '2018-05-30'; }
    var m;
    if (typeof date == 'string') {
        m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, f);
    }
    else {
        m = date;
    }
    var weekOfday = (weekstart && weekstart == '3') ? 0 : parseInt(m.format('E')); //计算今天是这周第几天 
    weekOfday = weekOfday == 7 ? 1 : (weekOfday + 1);
    if (weekstart && weekstart == '2') { //周一作为一周开始日期
        weekOfday = weekOfday - 1;
    }
    var sunday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(m).subtract(weekOfday - 1, 'days').format(f); //周日日期  
    var saturday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(m).add(7 - weekOfday, 'days').format(f); //周六日期 
    return { sunday: sunday, saturday: saturday };
};
//是否当周日期
var isInWeek = function (currentDate, movedate, objDate, weekstart) {
    var _a = getWeekStartAndEnd(currentDate, weekstart), sunday = _a.sunday, saturday = _a.saturday;
    if (movedate == '1') {
        sunday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(sunday, f).add(7, 'days').format(f);
        saturday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(saturday, f).add(7, 'days').format(f);
    }
    else if (movedate == '-1') {
        sunday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(sunday, f).subtract(7, 'days').format(f);
        saturday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(saturday, f).subtract(7, 'days').format(f);
    }
    var s = new Date(sunday).getTime();
    var e = new Date(saturday).getTime();
    var o = new Date(objDate).getTime();
    if (o >= s && o <= e) {
        return true;
    }
    else {
        return false;
    }
};
var addDay = function (currentDate, day) {
    var m;
    if (typeof currentDate == 'string') {
        m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(currentDate, f);
    }
    else {
        m = currentDate;
    }
    var currentday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(m, f).add(day, 'days').format(f);
    return currentday;
};
//获取当天的开始时刻及结束时刻
var getHourBetweenDates = function (currentDate, movedate, startDate, startTime, endDate, endTime, dspunit) {
    currentDate = currentDate.split(' ')[0];
    var hour = [];
    var current = __WEBPACK_IMPORTED_MODULE_0_moment___default()(currentDate, f1);
    if (movedate == '1') {
        current.add(1, 'days').format(f1);
    }
    else if (movedate == '-1') {
        current.subtract(1, 'days').format(f1);
    }
    var start = new Date(Date.parse((startDate + " " + startTime).replace(/-/g, "/")));
    var start_h = startTime.split(':')[0]; //开始时间小时
    var start_m = startTime.split(':')[1]; //开始时间分钟
    if (start_m != '00') {
        var dspunittime = dspunit == 2 ? parseInt(start_m) < 30 ? ":00" : ":30" : ":00";
        start = new Date(Date.parse((startDate + " " + start_h + dspunittime).replace(/-/g, "/")));
    }
    var end = new Date(Date.parse((endDate + " " + endTime).replace(/-/g, "/")));
    for (var i = 0; i < 24; i = i + (1 / dspunit)) {
        var dspunittime = Math.floor(i) == i ? ":00" : ":30";
        var m = void 0;
        if (i < 10) {
            m = new Date(Date.parse((current.format(f) + " 0" + Math.floor(i) + dspunittime).replace(/-/g, "/")));
        }
        else {
            m = new Date(Date.parse((current.format(f) + " " + Math.floor(i) + dspunittime).replace(/-/g, "/")));
        }
        if (start.getTime() <= m.getTime() && m.getTime() < end.getTime()) {
            hour.push(i);
        }
    }
    return hour;
};


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogListStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_logList__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var getLabel = __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaLocaleProvider"].getLabel;
var LogListStore = /** @class */ (function () {
    function LogListStore() {
        var _this = this;
        this.form = new __WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaForm"]();
        this.detailFrom = new __WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaForm"]();
        this.loading = false;
        this.title = "日志";
        this.tableData = {
            total: 0,
            logData: [],
        };
        this.logDetailTableData = {
            logDataDetail: [],
            detailTotal: 0
        };
        this.showSearchAd = false;
        this.condition = [];
        this.detailCondition = [];
        this.baseParams = {};
        this.isBackLog = false;
        this.logid = '';
        this.detailBaseParams = {};
        this.checkValues = {
            munedit: "1",
            create: "1",
            view: "0",
            edit: "1",
            delete: '1',
            recover: '1'
        };
        this.table = {
            current: 1,
            pagesize: 10
        };
        this.detailTable = {
            current: 1,
            pagesize: 10
        };
        this.visible = false;
        this.mainLog_visible = false;
        this.delLog_visible = false;
        this.detailLog_visible = false;
        this.currentType = '';
        this.dialog = {
            loading: false,
            loadingTips: "正在加载中...",
            title: ""
        };
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.operateButton = [];
        this.updateParams = function (params) {
            _this.isBackLog = 'back' == params.logtype;
            if (_this.isBackLog) {
                _this.checkValues.view = "1";
            }
            _this.condition = Object(__WEBPACK_IMPORTED_MODULE_4__data_logList__["a" /* condition */])(_this.isBackLog);
            _this.detailCondition = Object(__WEBPACK_IMPORTED_MODULE_4__data_logList__["b" /* detailCondition */])();
            _this.title = getLabel(83, '日志');
            _this.dialog = {
                loading: false,
                loadingTips: getLabel(124820, "正在加载中..."),
                title: ""
            };
            _this.form && !_this.form.isFormInit && _this.form.initFormFields(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.condition));
            _this.title = decodeURIComponent(params.modename);
            _this.setOperateTypeValue(params);
            delete params.modename;
            delete params.guid;
            _this.search(__assign({}, _this.checkValues, params));
            _this.baseParams = __assign({}, params);
            _this.modeId = params.modeId;
            _this.getIconInfo(params.modeId);
        };
        this.setShowSearchAd = function (bool) {
            _this.showSearchAd = bool;
        };
        this.setOperateTypeValue = function (params) {
            var checkValues = {};
            if (params.operatetype) { //自定义操作类型值
                var operates = params.operatetype.split(',');
                if (operates.length >= 4) {
                    checkValues['create'] = operates[0];
                    checkValues['edit'] = operates[1];
                    checkValues['view'] = operates[2];
                    checkValues['munedit'] = operates[3];
                    _this.checkValues = __assign({}, _this.checkValues, checkValues);
                }
            }
        };
        this.clearFormFields = function () {
            _this.form.resetConditionValue(); //清除查询条件值
            _this.checkValues = {
                munedit: "1",
                create: "1",
                view: "0",
                edit: "1"
            };
            if (_this.isBackLog) {
                _this.checkValues.delete = "1";
                _this.checkValues.view = "1";
                _this.checkValues.recover = "1";
            }
            _this.setOperateTypeValue(_this.baseParams);
        };
        this.onCheckGroupChange = function (checkedValue) {
            var newObj = {};
            __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.each(checkedValue, function (data) {
                newObj[data] = "1";
            });
            var checkValues = __assign({ munedit: "0", create: "0", view: "0", edit: "0" }, newObj);
            _this.checkValues = checkValues;
        };
        this.doSearch = function (params) {
            if (params === void 0) { params = {}; }
            var searchParamsAd = _this.form.getFormParams();
            var newParams = __assign({}, _this.table, _this.baseParams, _this.checkValues, searchParamsAd, params);
            _this.search(newParams);
        };
        this.recoverData = function () {
            __WEBPACK_IMPORTED_MODULE_2__apis_card__["N" /* recoverData */]({ logid: _this.logid, modeid: _this.modeId }).then(function (_a) {
                var api_status = _a.api_status, api_errormsg = _a.api_errormsg, noRight = _a.noRight, status = _a.status;
                _this.delLog_visible = false;
                if (noRight) {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(2012, '对不起，您暂时没有权限！'));
                }
                if (api_status) {
                    if (status == '1') {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].info(getLabel('522825', '数据恢复成功'));
                    }
                    else if (status == '0') {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel('522827', '该数据在数据库中已存在,无法恢复'));
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel('522826', '数据恢复失败'));
                    }
                    _this.doSearch();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(383746, '请求失败') + "：" + api_errormsg);
                }
            });
        };
        this.search = function (params) {
            __WEBPACK_IMPORTED_MODULE_2__apis_card__["n" /* getCardLog */](params).then(function (_a) {
                var api_status = _a.api_status, api_errormsg = _a.api_errormsg, total = _a.total, logData = _a.logData, orderList = _a.orderList;
                if (api_status) {
                    //对操作类型进行多语言转化
                    var newLogData = logData.map(function (element) {
                        // switch (element.operatetype) {
                        //     case '1': element.operatedesc = getLabel(82, "新建"); break;
                        //     case '2': element.operatedesc = getLabel(103, "修改"); break;
                        //     case '3': element.operatedesc = getLabel(91, "删除"); break;
                        //     case '5': element.operatedesc = getLabel(25465,"批量修改") ;break;
                        // }
                        return element;
                    });
                    _this.tableData = {
                        total: total,
                        logData: newLogData
                    };
                    if (orderList) {
                        _this.operateButton = orderList;
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(383746, '请求失败') + "：" + api_errormsg);
                }
            });
        };
        this.changePageSize = function (current, pagesize) {
            _this.table = {
                current: current,
                pagesize: pagesize
            };
            _this.doSearch({ current: current, pagesize: pagesize });
        };
        this.nextDatas = function (pagination) {
            var current = pagination.current;
            _this.table = __assign({}, _this.table, { current: current });
            _this.doSearch({ current: current });
        };
        this.objToArr = function (obj) {
            var item = [];
            __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.each(obj, function (value, key) {
                if (value == "1") {
                    item.push(key);
                }
            });
            return item;
        };
        this.onCancel = function () {
            _this.visible = false;
            _this.detailTable = {
                current: 1,
                pagesize: 10
            };
        };
        this.showCodeAllLog = function (id, name) {
            _this.visible = true;
            _this.dialog = __assign({}, _this.dialog, { loading: true, title: name });
            _this.detailFrom = new __WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaForm"]();
            _this.detailFrom && !_this.detailFrom.isFormInit && _this.detailFrom.initFormFields(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.detailCondition));
            _this.detailBaseParams = { fieldid: id };
            _this.searchDetail(__assign({}, _this.detailTable, _this.baseParams, { fieldid: id }));
        };
        this.searchDetail = function (params) {
            _this.dialog = __assign({}, _this.dialog, { loading: true });
            __WEBPACK_IMPORTED_MODULE_2__apis_card__["o" /* getCardLogDetail */](params).then(function (_a) {
                var api_status = _a.api_status, api_errormsg = _a.api_errormsg, logDataDetail = _a.logDataDetail, detailTotal = _a.detailTotal;
                if (api_status) {
                    _this.logDetailTableData = {
                        logDataDetail: logDataDetail,
                        detailTotal: detailTotal
                    };
                    _this.dialog = __assign({}, _this.dialog, { loading: false });
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(383746, '请求失败') + "：" + api_errormsg);
                }
            });
        };
        this.doDetailSearch = function (params) {
            if (params === void 0) { params = {}; }
            var detailSearchParamsAd = _this.detailFrom.getFormParams();
            var newParams = __assign({}, _this.detailTable, _this.baseParams, _this.detailBaseParams, detailSearchParamsAd, params);
            _this.searchDetail(newParams);
        };
        this.changeDetailPageSize = function (current, pagesize) {
            _this.detailTable = {
                current: current,
                pagesize: pagesize
            };
            _this.doDetailSearch({ current: current, pagesize: pagesize });
        };
        this.nextDetailDatas = function (pagination) {
            var current = pagination.current;
            _this.detailTable = __assign({}, _this.detailTable, { current: current });
            _this.doDetailSearch({ current: current });
        };
        this.getIconInfo = function (modeid) {
            __WEBPACK_IMPORTED_MODULE_5__apis__["a" /* default */].getAppInfoByID({ modeid: modeid }).then(function (data) {
                if (data.status == "1") {
                    _this.iconInfo = {
                        icon: data.icon || "icon-coms-ModelingEngine",
                        iconColor: data.iconColor || "#fff",
                        iconBg: data.iconBg || "#96358a"
                    };
                }
            });
        };
        //获取主表字段变更信息
        this.showMainFieldLog = function (viewlogid, billid) {
            if (_this.isBackLog) {
                _this.baseParams.billid = billid;
            }
            __WEBPACK_IMPORTED_MODULE_2__apis_card__["y" /* getMainFieldLog */](__assign({}, _this.baseParams, { viewlogid: viewlogid, modeId: _this.modeId })).then(function (_a) {
                var api_status = _a.api_status, api_errormsg = _a.api_errormsg, fieldDetail = _a.fieldDetail;
                if (api_status) {
                    _this.mainLog_data = fieldDetail;
                    _this.mainLog_visible = true;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(383746, '请求失败') + "：" + api_errormsg);
                }
            });
        };
        //获取明细表字段变更信息
        this.showDetailFieldLog = function (viewlogid, detailtable, billid) {
            if (_this.isBackLog) {
                _this.baseParams.billid = billid;
            }
            var splitStr = '  ,  ';
            __WEBPACK_IMPORTED_MODULE_2__apis_card__["r" /* getDetailFieldLog */](__assign({}, _this.baseParams, { viewlogid: viewlogid, modeId: _this.modeId, detailtable: detailtable })).then(function (_a) {
                var api_status = _a.api_status, api_errormsg = _a.api_errormsg, dataMap = _a.dataMap;
                if (api_status) {
                    _this.detailLog_data = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keys(dataMap).map(function (item) {
                        var operateType;
                        var operateDesc = '';
                        dataMap[item].forEach(function (element, index) {
                            if (index == 0) {
                                operateType = element.operateType;
                            }
                            if (operateType == 'EDIT') {
                                operateDesc += element.fieldlabel + getLabel(623, '由') + _this.transValue(element.prefieldvalue) + getLabel(515395, '变更为') + _this.transValue(element.fieldvalue) + splitStr;
                            }
                            else if (operateType == 'ADD') {
                                operateDesc += element.fieldlabel + ':' + _this.transValue(element.fieldvalue) + splitStr;
                            }
                            else if (operateType == 'DEL') {
                                operateDesc += element.fieldlabel + ':' + _this.transValue(element.prefieldvalue) + splitStr;
                            }
                        });
                        if (operateDesc.endsWith(splitStr)) {
                            operateDesc = operateDesc.substring(0, operateDesc.length - 5);
                        }
                        var operateTypeText = "";
                        if (operateType == 'ADD') {
                            operateTypeText = getLabel(1421, '新增');
                        }
                        else if (operateType == 'EDIT') {
                            operateTypeText = getLabel(93, '编辑');
                        }
                        else if (operateType == 'DEL') {
                            operateTypeText = getLabel(91, '删除');
                        }
                        return { id: item, operateType: operateTypeText, operateDesc: operateDesc };
                    });
                    _this.detailLog_visible = true;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(383746, '请求失败') + "：" + api_errormsg);
                }
            });
        };
        this.transValue = function (value) {
            if (value == '') {
                return "<span style='color:green'>" + getLabel(15863, '空') + "</span>";
            }
            else {
                return "<span style='color:red'>" + value + "</span>";
            }
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "detailFrom", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "title", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "tableData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "logDetailTableData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "showSearchAd", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "condition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "detailCondition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "baseParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "isBackLog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "logid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "checkValues", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "table", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "detailTable", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "mainLog_visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "delLog_visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "detailLog_visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "currentType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "mainLog_data", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "detailLog_data", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "dialog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], LogListStore.prototype, "operateButton", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "setShowSearchAd", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "clearFormFields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "onCheckGroupChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "doSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "recoverData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "search", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "changePageSize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "nextDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "objToArr", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "onCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "showCodeAllLog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "searchDetail", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "doDetailSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "changeDetailPageSize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "nextDetailDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], LogListStore.prototype, "getIconInfo", void 0);
    return LogListStore;
}());

/* harmony default export */ __webpack_exports__["a"] = (new LogListStore());


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdvancedButton__ = __webpack_require__(807);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var Top = /** @class */ (function (_super) {
    __extends(Top, _super);
    function Top() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeTabs = function (selectedKey) {
            _this.props.top.update({ selectedKey: selectedKey });
            _this.props.onTabChange && _this.props.onTabChange();
        };
        return _this;
    }
    Top.prototype.render = function () {
        var _a;
        var _b = this.props, _c = _b.prefixCls, prefixCls = _c === void 0 ? 'coms-mode-top-title' : _c, top = _b.top, children = _b.children, _d = _b.isDialog, isDialog = _d === void 0 ? false : _d, loading = _b.loading, _e = _b.showDropIcon, showDropIcon = _e === void 0 ? false : _e, _f = _b.dropMenuDatas, dropMenuDatas = _f === void 0 ? [] : _f, onDropMenuClick = _b.onDropMenuClick, style = _b.style, buttons = _b.buttons, searchType = _b.searchType;
        var name = top.name, title = top.title, icon = top.icon, iconColor = top.iconColor, iconBgcolor = top.iconBgcolor;
        var classNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(prefixCls, prefixCls + "-" + searchType, (_a = {},
            _a[prefixCls + "-noIcon"] = !icon,
            _a[prefixCls + "-dialog"] = isDialog,
            _a));
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: classNames, ref: "_container", style: style }, top.isInit && (this.props.isInnerTab ? children :
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTop"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTop@3vl96a", title: top.title ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: top.title }, name) : name, icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: title, className: icon, style: { color: iconColor } }), iconBgcolor: iconBgcolor, loading: loading, buttons: typeof buttons == 'function' ? buttons(true) : buttons, showDropIcon: showDropIcon, dropMenuDatas: dropMenuDatas, onDropMenuClick: onDropMenuClick, buttonSpace: 10 }, children))));
    };
    Top.AdvancedButton = __WEBPACK_IMPORTED_MODULE_4__AdvancedButton__["a" /* default */];
    Top = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], Top);
    return Top;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Top);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BatchShareDialog", function() { return BatchShareDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBatchShare", function() { return getBatchShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _this = this;







var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var InputGroup = __WEBPACK_IMPORTED_MODULE_4_antd__["Input"].Group;
var BatchShare = /** @class */ (function (_super) {
    __extends(BatchShare, _super);
    function BatchShare(props) {
        var _this = _super.call(this, props) || this;
        var conditions = _this.props.share.conditions;
        _this.state = {
            showlevel0: conditions.showlevel.valueList.length > 0 && (conditions.showlevel.valueList[0] + "") || conditions.showlevel.startValue || "",
            showlevel1: conditions.showlevel.valueList.length > 1 && (conditions.showlevel.valueList[1] + "") || ""
        };
        return _this;
    }
    BatchShare.prototype.render = function () {
        var _this = this;
        var share = this.props.share;
        var conditions = share.conditions, form = share.form, refObj = share.refObj;
        var errors = Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(share.errors);
        var formParams = form.getFormParams();
        var values = form.values();
        var relatedid = conditions["relatedid" + values.sharetype];
        var rolefield = conditions["rolefield" + values.rolefieldtype];
        var relatedidError = errors["relatedid" + values.sharetype];
        var rolefieldError = errors["rolefield" + values.rolefieldtype];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-batch-share wea-search-group", style: { marginTop: 3 } },
            conditions.sharetype &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@o1iid5", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45 }, label: conditions.sharetype.label, labelCol: { span: conditions.sharetype.labelcol }, wrapperCol: { span: conditions.sharetype.fieldcol } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: 'inline-block' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@2owxp6", fieldConfig: conditions.sharetype, form: form, formParams: formParams, onChange: share.clearError.bind(this, __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].getKey(conditions.sharetype)) })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { paddingLeft: 8, display: 'inline-block', width: "120px" } }, (values.sharetype == '2' || values.sharetype == '3') && conditions.orgrelation &&
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@roxvye", fieldConfig: conditions.orgrelation, form: form, formParams: formParams }))),
            relatedid && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@ur7h1p", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45 }, label: relatedid.label, labelCol: { span: relatedid.labelcol }, wrapperCol: { span: relatedid.fieldcol } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@k55zpk", fieldConfig: relatedid, form: form, formParams: formParams, onChange: share.clearError.bind(this, __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].getKey(relatedid)) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item-error", dangerouslySetInnerHTML: { __html: relatedidError && "<span style=\"color:#f50;\"><i class=\"anticon anticon-cross-circle\" ></i>" + relatedidError + "</span>" } })),
            values.sharetype == '4' && conditions.isRoleLimited && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@zm0l3a", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45 }, label: conditions.isRoleLimited.label, labelCol: { span: conditions.isRoleLimited.labelcol }, wrapperCol: { span: conditions.isRoleLimited.fieldcol } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@qdc6fk" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@6rzpjj", span: 6, style: { width: 60 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@kwyx9f", fieldConfig: conditions.isRoleLimited, form: form, formParams: formParams })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@uiucb2", span: 9, style: { width: 200 }, className: "cube-auth-child-cell" }, values.isRoleLimited == '1' && conditions.rolefieldtype &&
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@p18054", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45 }, label: conditions.rolefieldtype.label, labelCol: { span: conditions.rolefieldtype.labelcol }, wrapperCol: { span: conditions.rolefieldtype.fieldcol, offset: 10 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@zuzo6z", fieldConfig: conditions.rolefieldtype, form: form, formParams: formParams, onChange: share.clearError.bind(this, __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].getKey(conditions.rolefieldtype)) }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item-error", dangerouslySetInnerHTML: { __html: errors.rolefieldtype && "<span style=\"color:#f50;\"><i class=\"anticon anticon-cross-circle\" ></i>" + errors.rolefieldtype + "</span>" } }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@2kfp6v", span: 9, style: { width: 'calc(100% - 280px)' }, className: "cube-auth-child-cell" }, values.isRoleLimited == '1' && rolefield &&
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@d9jnky", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45, width: 150 }, label: rolefield.label, labelCol: { span: rolefield.labelcol }, wrapperCol: { span: rolefield.fieldcol, offset: 10 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@mdb8b8", fieldConfig: rolefield, form: form, formParams: formParams, onChange: share.clearError.bind(this, __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].getKey(rolefield)) }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item-error", dangerouslySetInnerHTML: { __html: rolefieldError && "<span style=\"color:#f50;\"><i class=\"anticon anticon-cross-circle\" ></i>" + rolefieldError + "</span>" } }))))),
            values.sharetype == '4' && values.isRoleLimited == '0' && (values.rolefieldtype == '2' || values.rolefieldtype == '3') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@ki7cpt", label: conditions.rolelevel.label, labelCol: { span: conditions.rolelevel.labelcol }, wrapperCol: { span: conditions.rolelevel.fieldcol } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: 'inline-block', width: 200 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@7j3piw", fieldConfig: conditions.rolelevel, form: form, formParams: formParams }))),
            values.sharetype == '4' && values.rolefieldtype == '1' && conditions.rolelevel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@wo0dv8", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45 }, label: conditions.rolelevel.label, labelCol: { span: conditions.rolelevel.labelcol }, wrapperCol: { span: conditions.rolelevel.fieldcol } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@5f8edh", fieldConfig: conditions.rolelevel, form: form, formParams: formParams })),
            values.sharetype == '6' && conditions.joblevel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@oiwdfn", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45 }, label: conditions.joblevel.label, labelCol: { span: conditions.joblevel.labelcol }, wrapperCol: { span: conditions.joblevel.fieldcol } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@knh5dp" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@icnk1n", span: 6, style: { width: 100 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@qi3a5n", fieldConfig: conditions.joblevel, form: form, formParams: formParams })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@q7wd0z", style: { paddingLeft: 8, display: 'inline-block', marginTop: '-3px' }, span: 8 },
                        values.joblevel == '0' && conditions.jobleveltext1 &&
                            [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@x0bz7d", key: values.joblevel, fieldConfig: conditions.jobleveltext1, form: form, formParams: formParams, onChange: share.clearError.bind(this, __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].getKey(conditions.jobleveltext1)) }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item-error", dangerouslySetInnerHTML: { __html: errors.jobleveltext1 && "<span style=\"color:#f50;\"><i class=\"anticon anticon-cross-circle\" ></i>" + errors.jobleveltext1 + "</span>" } })
                            ],
                        values.joblevel == '1' && conditions.jobleveltext2 &&
                            [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@e889s6", key: values.joblevel, fieldConfig: conditions.jobleveltext2, form: form, formParams: formParams, onChange: share.clearError.bind(this, __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].getKey(conditions.jobleveltext2)) }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item-error", dangerouslySetInnerHTML: { __html: errors.jobleveltext2 && "<span style=\"color:#f50;\"><i class=\"anticon anticon-cross-circle\" ></i>" + errors.jobleveltext2 + "</span>" } })
                            ]))),
            values.sharetype != '1' && conditions.showlevel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@koqm11", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45 }, label: conditions.showlevel.label, labelCol: { span: conditions.showlevel.labelcol }, wrapperCol: { span: conditions.showlevel.fieldcol } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, { ecId: (this && this.props && this.props.ecId || '') + "_InputGroup@vl4s73" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@403txj", span: 6 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@6pbzxf", tipPosition: 'bottom', error: getLabel(683, "安全级别") + getLabel(21423, "未填写"), style: { width: "100%" }, ref: function (ref) {
                                refObj["showlevel"] = ref;
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInputNumber"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputNumber@l17jrj", id: "showlevel", fieldName: "showlevel", name: "showlevel", value: this.state.showlevel0, onChange: function (v) {
                                    if (v !== undefined) {
                                        form.$('showlevel').value[0] = v;
                                        _this.setState({ showlevel0: v });
                                    }
                                }, viewAttr: "3" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@9u0pa3", span: 1, style: { paddingTop: 4 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "ant-form-split" }, "-")),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@pxgxk7", span: 6 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInputNumber"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputNumber@xoluik", value: this.state.showlevel1, onChange: function (v) {
                                if (v !== undefined) {
                                    form.$('showlevel').value[1] = v;
                                    _this.setState({ showlevel1: v });
                                }
                            } })))),
            conditions.righttype && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@swy6nu", style: { paddingTop: 0, paddingBottom: 0, minHeight: 45 }, label: conditions.righttype.label, labelCol: { span: conditions.righttype.labelcol }, wrapperCol: { span: conditions.righttype.fieldcol } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSwitch@5jmzpy", fieldConfig: conditions.righttype, form: form, formParams: formParams }))));
    };
    BatchShare = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], BatchShare);
    return BatchShare;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (BatchShare);
var BatchShareDialog = /** @class */ (function (_super) {
    __extends(BatchShareDialog, _super);
    function BatchShareDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getButtons = function () {
            var share = _this.props.share;
            return [
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@0wy2xz@onCancel", onClick: share.onCancel }, getLabel(309, "关闭")),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@hm8jcr@onOks", type: "primary", loading: share.loading, onClick: _this.onOk }, getLabel(86, '保存'))
            ];
        };
        _this.onOk = function () {
            var _a = _this.props, share = _a.share, params = _a.params, success = _a.success;
            share.onOk(params, success);
        };
        return _this;
    }
    BatchShareDialog.prototype.render = function () {
        var _a = this.props, share = _a.share, iconInfo = _a.iconInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@410pgk", className: 'wea-auth-modal cube-dialog', buttons: this.getButtons(), title: getLabel(18037, '批量共享'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: share.visible, style: { width: 650, height: 450 }, hasScroll: true, onCancel: share.onCancel },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BatchShare, { ecId: (this && this.props && this.props.ecId || '') + "_BatchShare@wwyu0d", share: share }))));
    };
    BatchShareDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], BatchShareDialog);
    return BatchShareDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var getBatchShare = function (store) {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BatchShare, { ecId: (_this && _this.props && _this.props.ecId || '') + "_BatchShare@aivvdh", share: store }));
};


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_view_table__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_cell__ = __webpack_require__(964);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var MobxTable = /** @class */ (function (_super) {
    __extends(MobxTable, _super);
    function MobxTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowKey = function (record) {
            return record;
        };
        _this.renderCell = function (column, randomkey) {
            var _a = _this.props, tableStore = _a.tableStore, isNoSwitchEditStatus = _a.isNoSwitchEditStatus, isfrontmultlang = _a.isfrontmultlang;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__table_cell__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_TableCell@8apfdm", column: column, randomkey: randomkey, tableStore: tableStore, isfrontmultlang: isfrontmultlang, isNoSwitchEditStatus: isNoSwitchEditStatus }));
        };
        return _this;
    }
    MobxTable.prototype.render = function () {
        var _a = this.props, tableStore = _a.tableStore, scroll = _a.scroll, pagination = _a.pagination, _b = _a.isMergeLine, isMergeLine = _b === void 0 ? false : _b, _c = _a.isRowSelection, isRowSelection = _c === void 0 ? true : _c;
        var rowSelection = isRowSelection && {
            onChange: function (selectedRowKeys) {
                tableStore.onSelectedRowChange(selectedRowKeys);
            },
            getCheckboxProps: function (record) { return ({
                disabled: record.name === 'Disabled User',
                name: record.name,
            }); },
            selectedRowKeys: tableStore.selectedRowKeys.slice()
        };
        var className = "cube-mobx-table cube-mobx-table-tbody-tr-td-lk";
        if (isMergeLine) {
            className = "cube-mobx-table cube-mobx-table-tbody-tr-td-lk mergeLine";
        }
        return ([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__view_view_table__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_Table@l8ou5e", loading: tableStore.loading, className: className, rowSelection: rowSelection, renderCell: this.renderCell, columns: tableStore.columns && tableStore.columns.slice(), scroll: __assign({}, scroll), rowKey: this.rowKey, pagination: pagination, dataSource: tableStore.datas.slice() })
        ]);
    };
    MobxTable = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], MobxTable);
    return MobxTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (MobxTable);


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(817), __esModule: true };

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeShape = undefined;

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeShape = exports.storeShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  setState: _propTypes2.default.func.isRequired,
  getState: _propTypes2.default.func.isRequired
});

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(220),
    root = __webpack_require__(84);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(847),
    mapCacheDelete = __webpack_require__(854),
    mapCacheGet = __webpack_require__(856),
    mapCacheHas = __webpack_require__(857),
    mapCacheSet = __webpack_require__(858);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(223),
    eq = __webpack_require__(150);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(220);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(869);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(870),
    isObjectLike = __webpack_require__(85);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(84),
    stubFalse = __webpack_require__(872);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(874),
    baseUnary = __webpack_require__(875),
    nodeUtil = __webpack_require__(876);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(880),
    baseKeysIn = __webpack_require__(882),
    isArrayLike = __webpack_require__(224);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(378);
} catch (err) {
  var index = __webpack_require__(378);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(895);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(56);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(92);
var ITERATOR = __webpack_require__(32)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(383);
var ITERATOR = __webpack_require__(32)('iterator');
var Iterators = __webpack_require__(92);
module.exports = __webpack_require__(22).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(173);
var TAG = __webpack_require__(32)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ColGroup__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableHeader__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableRow__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExpandableRow__ = __webpack_require__(917);














var BaseTable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BaseTable, _React$Component);

  function BaseTable() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BaseTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = BaseTable.__proto__ || Object.getPrototypeOf(BaseTable)).call.apply(_ref, [this].concat(args))), _this), _this.handleRowHover = function (isHover, key) {
      _this.props.store.setState({
        currentHoverKey: isHover ? key : null
      });
    }, _this.renderRows = function (renderData, indent) {
      var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var ancestorKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var table = _this.context.table;
      var columnManager = table.columnManager,
          components = table.components;
      var _table$props = table.props,
          prefixCls = _table$props.prefixCls,
          childrenColumnName = _table$props.childrenColumnName,
          rowClassName = _table$props.rowClassName,
          rowRef = _table$props.rowRef,
          onRowClick = _table$props.onRowClick,
          onRowDoubleClick = _table$props.onRowDoubleClick,
          onRowContextMenu = _table$props.onRowContextMenu,
          onRowMouseEnter = _table$props.onRowMouseEnter,
          onRowMouseLeave = _table$props.onRowMouseLeave,
          onRow = _table$props.onRow;
      var _this$props = _this.props,
          getRowKey = _this$props.getRowKey,
          fixed = _this$props.fixed,
          expander = _this$props.expander,
          isAnyColumnsFixed = _this$props.isAnyColumnsFixed;

      var _loop = function _loop(i) {
        var record = renderData[i];
        var key = getRowKey(record, i);
        var className = typeof rowClassName === 'string' ? rowClassName : rowClassName(record, i, indent);

        var onHoverProps = {};
        if (columnManager.isAnyColumnsFixed()) {
          onHoverProps.onHover = _this.handleRowHover;
        }

        var leafColumns = void 0;
        if (fixed === 'left') {
          leafColumns = columnManager.leftLeafColumns();
        } else if (fixed === 'right') {
          leafColumns = columnManager.rightLeafColumns();
        } else {
          leafColumns = _this.getColumns(columnManager.leafColumns());
        }

        var rowPrefixCls = prefixCls + '-row';
        var rowIndex = rows.filter(function (row) {
          return !row.props.expandedRow;
        }).length;

        var row = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__ExpandableRow__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, expander.props, {
            fixed: fixed,
            index: rowIndex,
            prefixCls: rowPrefixCls,
            record: record,
            key: key,
            rowKey: key,
            onRowClick: onRowClick,
            needIndentSpaced: expander.needIndentSpaced,
            onExpandedChange: expander.handleExpandChange
          }),
          function (expandableRow) {
            return (// eslint-disable-line
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TableRow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                fixed: fixed,
                indent: indent,
                className: className,
                record: record,
                index: rowIndex,
                prefixCls: rowPrefixCls,
                childrenColumnName: childrenColumnName,
                columns: leafColumns,
                onRow: onRow,
                onRowDoubleClick: onRowDoubleClick,
                onRowContextMenu: onRowContextMenu,
                onRowMouseEnter: onRowMouseEnter,
                onRowMouseLeave: onRowMouseLeave
              }, onHoverProps, {
                rowKey: key,
                ancestorKeys: ancestorKeys,
                ref: rowRef(record, i, indent),
                components: components,
                isAnyColumnsFixed: isAnyColumnsFixed
              }, expandableRow))
            );
          }
        );

        rows.push(row);

        expander.renderRows(_this.renderRows, rows, record, i, indent, fixed, key, ancestorKeys);
      };

      for (var i = 0; i < renderData.length; i++) {
        _loop(i);
      }
      return rows;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(BaseTable, [{
    key: 'getColumns',
    value: function getColumns(cols) {
      var _props = this.props,
          _props$columns = _props.columns,
          columns = _props$columns === undefined ? [] : _props$columns,
          fixed = _props.fixed;
      var table = this.context.table;
      var prefixCls = table.props.prefixCls;

      return (cols || columns).map(function (column) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, column, {
          className: !!column.fixed && !fixed ? __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls + '-fixed-columns-in-body', column.className) : column.className
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var table = this.context.table;
      var components = table.components;
      var _table$props2 = table.props,
          prefixCls = _table$props2.prefixCls,
          scroll = _table$props2.scroll,
          data = _table$props2.data,
          getBodyWrapper = _table$props2.getBodyWrapper;
      var _props2 = this.props,
          expander = _props2.expander,
          tableClassName = _props2.tableClassName,
          hasHead = _props2.hasHead,
          hasBody = _props2.hasBody,
          fixed = _props2.fixed;

      var tableStyle = {};

      if (!fixed && scroll.x) {
        // not set width, then use content fixed width
        if (scroll.x === true) {
          tableStyle.tableLayout = 'fixed';
        } else {
          tableStyle.width = scroll.x;
        }
      }

      var Table = hasBody ? components.table : 'table';
      var BodyWrapper = components.body.wrapper;

      var body = void 0;
      if (hasBody) {
        body = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          BodyWrapper,
          { className: prefixCls + '-tbody' },
          this.renderRows(data, 0)
        );
        if (getBodyWrapper) {
          body = getBodyWrapper(body);
        }
      }

      var columns = this.getColumns();

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        Table,
        { className: tableClassName, style: tableStyle, key: 'table' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ColGroup__["a" /* default */], { columns: columns, fixed: fixed }),
        hasHead && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */], { expander: expander, columns: columns, fixed: fixed }),
        body
      );
    }
  }]);

  return BaseTable;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

BaseTable.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  columns: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
  tableClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  hasHead: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  hasBody: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  expander: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  getRowKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  isAnyColumnsFixed: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
BaseTable.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["connect"])()(BaseTable));

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableCell__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(106);














var TableRow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TableRow, _React$Component);

  function TableRow(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TableRow);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    _this.onRowClick = function (event) {
      var _this$props = _this.props,
          record = _this$props.record,
          index = _this$props.index,
          onRowClick = _this$props.onRowClick;

      if (onRowClick) {
        onRowClick(record, index, event);
      }
    };

    _this.onRowDoubleClick = function (event) {
      var _this$props2 = _this.props,
          record = _this$props2.record,
          index = _this$props2.index,
          onRowDoubleClick = _this$props2.onRowDoubleClick;

      if (onRowDoubleClick) {
        onRowDoubleClick(record, index, event);
      }
    };

    _this.onContextMenu = function (event) {
      var _this$props3 = _this.props,
          record = _this$props3.record,
          index = _this$props3.index,
          onRowContextMenu = _this$props3.onRowContextMenu;

      if (onRowContextMenu) {
        onRowContextMenu(record, index, event);
      }
    };

    _this.onMouseEnter = function (event) {
      var _this$props4 = _this.props,
          record = _this$props4.record,
          index = _this$props4.index,
          onRowMouseEnter = _this$props4.onRowMouseEnter,
          onHover = _this$props4.onHover,
          rowKey = _this$props4.rowKey;

      onHover(true, rowKey);
      if (onRowMouseEnter) {
        onRowMouseEnter(record, index, event);
      }
    };

    _this.onMouseLeave = function (event) {
      var _this$props5 = _this.props,
          record = _this$props5.record,
          index = _this$props5.index,
          onRowMouseLeave = _this$props5.onRowMouseLeave,
          onHover = _this$props5.onHover,
          rowKey = _this$props5.rowKey;

      onHover(false, rowKey);
      if (onRowMouseLeave) {
        onRowMouseLeave(record, index, event);
      }
    };

    _this.shouldRender = props.visible;

    _this.state = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TableRow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.shouldRender) {
        this.saveRowRef();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !!(this.props.visible || nextProps.visible);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.shouldRender && !this.rowRef) {
        this.saveRowRef();
      }
    }
  }, {
    key: 'setExpanedRowHeight',
    value: function setExpanedRowHeight() {
      var _props = this.props,
          store = _props.store,
          rowKey = _props.rowKey;

      var _store$getState = store.getState(),
          expandedRowsHeight = _store$getState.expandedRowsHeight;

      var height = this.rowRef.getBoundingClientRect().height;
      expandedRowsHeight = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, expandedRowsHeight, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, rowKey, height));
      store.setState({ expandedRowsHeight: expandedRowsHeight });
    }
  }, {
    key: 'setRowHeight',
    value: function setRowHeight() {
      var _props2 = this.props,
          store = _props2.store,
          rowKey = _props2.rowKey;

      var _store$getState2 = store.getState(),
          fixedColumnsBodyRowsHeight = _store$getState2.fixedColumnsBodyRowsHeight;

      var height = this.rowRef.getBoundingClientRect().height;
      store.setState({
        fixedColumnsBodyRowsHeight: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, fixedColumnsBodyRowsHeight, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, rowKey, height))
      });
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      var _props3 = this.props,
          height = _props3.height,
          visible = _props3.visible;


      if (height && height !== this.style.height) {
        this.style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.style, { height: height });
      }

      if (!visible && !this.style.display) {
        this.style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.style, { display: 'none' });
      }

      return this.style;
    }
  }, {
    key: 'saveRowRef',
    value: function saveRowRef() {
      this.rowRef = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this);

      var _props4 = this.props,
          isAnyColumnsFixed = _props4.isAnyColumnsFixed,
          fixed = _props4.fixed,
          expandedRow = _props4.expandedRow,
          ancestorKeys = _props4.ancestorKeys;


      if (!isAnyColumnsFixed) {
        return;
      }

      if (!fixed && expandedRow) {
        this.setExpanedRowHeight();
      }

      if (!fixed && ancestorKeys.length >= 0) {
        this.setRowHeight();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.shouldRender) {
        return null;
      }

      var _props5 = this.props,
          prefixCls = _props5.prefixCls,
          columns = _props5.columns,
          record = _props5.record,
          rowKey = _props5.rowKey,
          index = _props5.index,
          onRow = _props5.onRow,
          indent = _props5.indent,
          indentSize = _props5.indentSize,
          hovered = _props5.hovered,
          height = _props5.height,
          visible = _props5.visible,
          components = _props5.components,
          hasExpandIcon = _props5.hasExpandIcon,
          renderExpandIcon = _props5.renderExpandIcon,
          renderExpandIconCell = _props5.renderExpandIconCell;


      var BodyRow = components.body.row;
      var BodyCell = components.body.cell;

      var className = this.props.className;


      if (hovered) {
        className += ' ' + prefixCls + '-hover';
      }

      var cells = [];

      renderExpandIconCell(cells);

      for (var i = 0; i < columns.length; i++) {
        var column = columns[i];

        Object(__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* warningOnce */])(column.onCellClick === undefined, 'column[onCellClick] is deprecated, please use column[onCell] instead.');

        cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TableCell__["a" /* default */], {
          prefixCls: prefixCls,
          record: record,
          indentSize: indentSize,
          indent: indent,
          index: index,
          column: column,
          key: column.key || column.dataIndex,
          expandIcon: hasExpandIcon(i) && renderExpandIcon(),
          component: BodyCell
        }));
      }

      var rowClassName = (prefixCls + ' ' + className + ' ' + prefixCls + '-level-' + indent).trim();

      var rowProps = onRow(record, index);
      var customStyle = rowProps ? rowProps.style : {};
      var style = { height: height };

      if (!visible) {
        style.display = 'none';
      }

      style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, style, customStyle);

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        BodyRow,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          onClick: this.onRowClick,
          onDoubleClick: this.onRowDoubleClick,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          onContextMenu: this.onContextMenu,
          className: rowClassName
        }, rowProps, {
          style: style,
          'data-row-key': rowKey
        }),
        cells
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.visible || !prevState.visible && nextProps.visible) {
        return {
          shouldRender: true,
          visible: nextProps.visible
        };
      }
      return {
        visible: nextProps.visible
      };
    }
  }]);

  return TableRow;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TableRow.propTypes = {
  onRow: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowDoubleClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowContextMenu: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowMouseEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onRowMouseLeave: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  record: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  onHover: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  columns: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,
  height: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  index: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  rowKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]).isRequired,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  indent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  indentSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  hasExpandIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  hovered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  store: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,
  fixed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  renderExpandIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  renderExpandIconCell: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  components: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  expandedRow: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  isAnyColumnsFixed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  ancestorKeys: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array.isRequired
};
TableRow.defaultProps = {
  onRow: function onRow() {},
  onHover: function onHover() {},
  hasExpandIcon: function hasExpandIcon() {},
  renderExpandIcon: function renderExpandIcon() {},
  renderExpandIconCell: function renderExpandIconCell() {}
};


function getRowHeight(state, props) {
  var expandedRowsHeight = state.expandedRowsHeight,
      fixedColumnsBodyRowsHeight = state.fixedColumnsBodyRowsHeight;
  var fixed = props.fixed,
      rowKey = props.rowKey;


  if (!fixed) {
    return null;
  }

  if (expandedRowsHeight[rowKey]) {
    return expandedRowsHeight[rowKey];
  }

  if (fixedColumnsBodyRowsHeight[rowKey]) {
    return fixedColumnsBodyRowsHeight[rowKey];
  }

  return null;
}

Object(__WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__["polyfill"])(TableRow);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_mini_store__["connect"])(function (state, props) {
  var currentHoverKey = state.currentHoverKey,
      expandedRowKeys = state.expandedRowKeys;
  var rowKey = props.rowKey,
      ancestorKeys = props.ancestorKeys;

  var visible = ancestorKeys.length === 0 || ancestorKeys.every(function (k) {
    return ~expandedRowKeys.indexOf(k);
  });

  return {
    visible: visible,
    hovered: currentHoverKey === rowKey,
    height: getRowHeight(state, props)
  };
})(TableRow));

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveKey;
/* unused harmony export saveRef */
/* unused harmony export SubPopupMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DOMWrap__ = __webpack_require__(930);














function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }
  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var _extends2;

  var state = store.getState();
  store.setState({
    activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.activeKey, (_extends2 = {}, _extends2[menuId] = activeKey, _extends2))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found = void 0;
    Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* loopMenuItem */])(children, function (c, i) {
      if (c && !c.props.disabled && activeKey === Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i)) {
        found = true;
      }
    });
    if (found) {
      return activeKey;
    }
  }
  activeKey = null;
  if (props.defaultActiveFirst) {
    Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* loopMenuItem */])(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i);
      }
    });
    return activeKey;
  }
  return activeKey;
}

function saveRef(c) {
  if (c) {
    var index = this.instanceArray.indexOf(c);
    if (index !== -1) {
      // update component if it's already inside instanceArray
      this.instanceArray[index] = c;
    } else {
      // add component if it's not in instanceArray yet;
      this.instanceArray.push(c);
    }
  }
}

var SubPopupMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SubPopupMenu, _React$Component);

  function SubPopupMenu(props) {
    var _extends3;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SubPopupMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    props.store.setState({
      activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props.store.getState().activeKey, (_extends3 = {}, _extends3[props.eventKey] = getActiveKey(props, props.activeKey), _extends3))
    });

    _this.instanceArray = [];
    return _this;
  }

  SubPopupMenu.prototype.componentDidMount = function componentDidMount() {
    // invoke customized ref to expose component to mixin
    if (this.props.manualRef) {
      this.props.manualRef(this);
    }
  };

  SubPopupMenu.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.visible || nextProps.visible;
  };

  SubPopupMenu.prototype.componentDidUpdate = function componentDidUpdate() {
    var props = this.props;
    var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
    var activeKey = getActiveKey(props, originalActiveKey);
    if (activeKey !== originalActiveKey) {
      updateActiveKey(props.store, getEventKey(props), activeKey);
    }
  };

  // all keyboard events callbacks run from here at first


  SubPopupMenu.prototype.render = function render() {
    var _this2 = this;

    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    this.instanceArray = [];
    var className = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(props.prefixCls, props.className, props.prefixCls + '-' + props.mode);
    var domProps = {
      className: className,
      // role could be 'select' and by default set to menu
      role: props.role || 'menu'
    };
    if (props.id) {
      domProps.id = props.id;
    }
    if (props.focusable) {
      domProps.tabIndex = '0';
      domProps.onKeyDown = this.onKeyDown;
    }
    var prefixCls = props.prefixCls,
        eventKey = props.eventKey,
        visible = props.visible;

    __WEBPACK_IMPORTED_MODULE_11__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });

    // Otherwise, the propagated click event will trigger another onClick
    delete props.onClick;
    return (
      // ESLint is not smart enough to know that the type of `children` was checked.
      /* eslint-disable */
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__DOMWrap__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
          tag: 'ul',
          hiddenClassName: prefixCls + '-hidden',
          visible: visible
        }, domProps),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(props.children, function (c, i) {
          return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
        })
      )
      /*eslint-enable */

    );
  };

  return SubPopupMenu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SubPopupMenu.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    setState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),

  // adding in refactor
  focusable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['click', 'hover']),
  inlineIndent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */]
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onKeyDown = function (e, callback) {
    var keyCode = e.keyCode;
    var handled = void 0;
    _this3.getFlatInstanceArray().forEach(function (obj) {
      if (obj && obj.props.active && obj.onKeyDown) {
        handled = obj.onKeyDown(e);
      }
    });
    if (handled) {
      return 1;
    }
    var activeItem = null;
    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN) {
      activeItem = _this3.step(keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP ? -1 : 1);
    }
    if (activeItem) {
      e.preventDefault();
      updateActiveKey(_this3.props.store, getEventKey(_this3.props), activeItem.props.eventKey);

      if (typeof callback === 'function') {
        callback(activeItem);
      }

      return 1;
    }
  };

  this.onItemHover = function (e) {
    var key = e.key,
        hover = e.hover;

    updateActiveKey(_this3.props.store, getEventKey(_this3.props), hover ? key : null);
  };

  this.onDeselect = function (selectInfo) {
    _this3.props.onDeselect(selectInfo);
  };

  this.onSelect = function (selectInfo) {
    _this3.props.onSelect(selectInfo);
  };

  this.onClick = function (e) {
    _this3.props.onClick(e);
  };

  this.onOpenChange = function (e) {
    _this3.props.onOpenChange(e);
  };

  this.onDestroy = function (key) {
    /* istanbul ignore next */
    _this3.props.onDestroy(key);
  };

  this.getFlatInstanceArray = function () {
    return _this3.instanceArray;
  };

  this.getOpenTransitionName = function () {
    return _this3.props.openTransitionName;
  };

  this.step = function (direction) {
    var children = _this3.getFlatInstanceArray();
    var activeKey = _this3.props.store.getState().activeKey[getEventKey(_this3.props)];
    var len = children.length;
    if (!len) {
      return null;
    }
    if (direction < 0) {
      children = children.concat().reverse();
    }
    // find current activeIndex
    var activeIndex = -1;
    children.every(function (c, ci) {
      if (c && c.props.eventKey === activeKey) {
        activeIndex = ci;
        return false;
      }
      return true;
    });
    if (!_this3.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
      return undefined;
    }
    var start = (activeIndex + 1) % len;
    var i = start;

    do {
      var child = children[i];
      if (!child || child.props.disabled) {
        i = (i + 1) % len;
      } else {
        return child;
      }
    } while (i !== start);

    return null;
  };

  this.renderCommonMenuItem = function (child, i, extraProps) {
    var state = _this3.props.store.getState();
    var props = _this3.props;
    var key = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(child, props.eventKey, i);
    var childProps = child.props;
    var isActive = key === state.activeKey;
    var newChildProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
      mode: props.mode,
      level: props.level,
      inlineIndent: props.inlineIndent,
      renderMenuItem: _this3.renderMenuItem,
      rootPrefixCls: props.prefixCls,
      index: i,
      parentMenu: props.parentMenu,
      // customized ref function, need to be invoked manually in child's componentDidMount
      manualRef: childProps.disabled ? undefined : Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__["a" /* default */])(child.ref, saveRef.bind(_this3)),
      eventKey: key,
      active: !childProps.disabled && isActive,
      multiple: props.multiple,
      onClick: function onClick(e) {
        (childProps.onClick || __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */])(e);
        _this3.onClick(e);
      },
      onItemHover: _this3.onItemHover,
      openTransitionName: _this3.getOpenTransitionName(),
      openAnimation: props.openAnimation,
      subMenuOpenDelay: props.subMenuOpenDelay,
      subMenuCloseDelay: props.subMenuCloseDelay,
      forceSubMenuRender: props.forceSubMenuRender,
      onOpenChange: _this3.onOpenChange,
      onDeselect: _this3.onDeselect,
      onSelect: _this3.onSelect,
      builtinPlacements: props.builtinPlacements
    }, extraProps);
    if (props.mode === 'inline') {
      newChildProps.triggerSubMenuAction = 'click';
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, newChildProps);
  };

  this.renderMenuItem = function (c, i, subMenuKey) {
    /* istanbul ignore if */
    if (!c) {
      return null;
    }
    var state = _this3.props.store.getState();
    var extraProps = {
      openKeys: state.openKeys,
      selectedKeys: state.selectedKeys,
      triggerSubMenuAction: _this3.props.triggerSubMenuAction,
      subMenuKey: subMenuKey
    };
    return _this3.renderCommonMenuItem(c, i, extraProps);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["connect"])()(SubPopupMenu));

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(390);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var Group = function (props) {
    var _a;
    var _b = props.prefixCls, prefixCls = _b === void 0 ? 'cube-input-group' : _b, _c = props.className, className = _c === void 0 ? '' : _c;
    var cls = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(prefixCls, (_a = {},
        _a[prefixCls + "-lg"] = props.size === 'large',
        _a[prefixCls + "-sm"] = props.size === 'small',
        _a[prefixCls + "-compact"] = props.compact,
        _a), className);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: cls, style: props.style }, props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (Group);


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_omit_js__ = __webpack_require__(154);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === 'string';
}
// Insert one space between two chinese characters automatically.
function insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child == null) {
        return;
    }
    var SPACE = needInserted ? ' ' : '';
    // strictNullChecks oops.
    if (typeof child !== 'string' && typeof child !== 'number' &&
        isString(child.type) && isTwoCNChar(child.props.children)) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, {}, child.props.children.split('').join(SPACE));
    }
    if (typeof child === 'string') {
        if (isTwoCNChar(child)) {
            child = child.split('').join(SPACE);
        }
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, child);
    }
    return child;
}
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            // Add click effect
            _this.setState({ clicked: true });
            clearTimeout(_this.timeout);
            _this.timeout = window.setTimeout(function () { return _this.setState({ clicked: false }); }, 500);
            var onClick = _this.props.onClick;
            if (onClick) {
                onClick(e);
            }
        };
        _this.state = {
            loading: props.loading,
            clicked: false,
            hasTwoCNChar: false,
        };
        return _this;
    }
    Button.prototype.componentDidMount = function () {
        // Fix for HOC usage like <FormatMessage />
        if (this.btn) {
            var buttonText = this.btn.innerText;
            if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
                this.setState({
                    hasTwoCNChar: true,
                });
            }
        }
    };
    Button.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var currentLoading = this.props.loading;
        var loading = nextProps.loading;
        if (currentLoading) {
            clearTimeout(this.delayTimeout);
        }
        if (typeof loading !== 'boolean' && loading && loading.delay) {
            this.delayTimeout = window.setTimeout(function () { return _this.setState({ loading: loading }); }, loading.delay);
        }
        else {
            this.setState({ loading: loading });
        }
    };
    Button.prototype.componentWillUnmount = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
        }
    };
    Button.prototype.isNeedInserted = function () {
        var _a = this.props, loading = _a.loading, icon = _a.icon, children = _a.children;
        var iconType = loading ? 'loading' : icon;
        return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) === 1 && (!iconType || iconType === 'loading');
    };
    Button.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, type = _b.type, shape = _b.shape, size = _b.size, className = _b.className, htmlType = _b.htmlType, children = _b.children, icon = _b.icon, prefixCls = _b.prefixCls, ghost = _b.ghost, others = __rest(_b, ["type", "shape", "size", "className", "htmlType", "children", "icon", "prefixCls", "ghost"]);
        var _c = this.state, loading = _c.loading, clicked = _c.clicked, hasTwoCNChar = _c.hasTwoCNChar;
        // large => lg
        // small => sm
        var sizeCls = '';
        switch (size) {
            case 'large':
                sizeCls = 'lg';
                break;
            case 'small':
                sizeCls = 'sm';
            default:
                break;
        }
        var ComponentProp = others.href ? 'a' : 'button';
        var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls, className, (_a = {},
            _a[prefixCls + "-" + type] = type,
            _a[prefixCls + "-" + shape] = shape,
            _a[prefixCls + "-" + sizeCls] = sizeCls,
            _a[prefixCls + "-icon-only"] = !children && icon,
            _a[prefixCls + "-loading"] = loading,
            _a[prefixCls + "-clicked"] = clicked,
            _a[prefixCls + "-background-ghost"] = ghost,
            _a[prefixCls + "-two-chinese-chars"] = hasTwoCNChar,
            _a));
        var iconType = loading ? 'loading' : icon;
        var iconNode = iconType ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "anticon anticon-" + iconType }) : null;
        var kids = (children || children === 0)
            ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) { return insertSpace(child, _this.isNeedInserted()); }) : null;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ComponentProp, __assign({ ecId: (this && this.props && this.props.ecId || '') + "_ComponentProp@jjjcum", ref: function (ref) { return _this.btn = ref; } }, Object(__WEBPACK_IMPORTED_MODULE_3_omit_js__["a" /* default */])(others, ['loading']), { type: others.href ? undefined : (htmlType || 'button'), className: classes, onClick: this.handleClick }),
            iconNode,
            kids));
    };
    Button.__ANT_BUTTON = true;
    Button.defaultProps = {
        prefixCls: 'cube-btn',
        loading: false,
        ghost: false,
    };
    Button.propTypes = {
        type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        shape: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['circle', 'circle-outline']),
        size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['large', 'default', 'small']),
        htmlType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['submit', 'button', 'reset']),
        onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
        className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    };
    return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Button);


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var ButtonGroup = function (props) {
    var _a;
    var _b = props.prefixCls, prefixCls = _b === void 0 ? 'cube-btn-group' : _b, size = props.size, className = props.className, others = __rest(props, ["prefixCls", "size", "className"]);
    // large => lg
    // small => sm
    var sizeCls = '';
    switch (size) {
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
        default:
            break;
    }
    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(prefixCls, (_a = {},
        _a[prefixCls + "-" + sizeCls] = sizeCls,
        _a), className);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({}, others, { className: classes }));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_omit_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calculateNodeHeight__ = __webpack_require__(972);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




function onNextFrame(cb) {
    if (window.requestAnimationFrame) {
        return window.requestAnimationFrame(cb);
    }
    return window.setTimeout(cb, 1);
}
function clearNextFrameAction(nextFrameId) {
    if (window.cancelAnimationFrame) {
        window.cancelAnimationFrame(nextFrameId);
    }
    else {
        window.clearTimeout(nextFrameId);
    }
}
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            textareaStyles: {},
        };
        _this.resizeTextarea = function () {
            var autosize = _this.props.autosize;
            if (!autosize || !_this.textAreaRef) {
                return;
            }
            var minRows = autosize ? autosize.minRows : null;
            var maxRows = autosize ? autosize.maxRows : null;
            var textareaStyles = Object(__WEBPACK_IMPORTED_MODULE_3__calculateNodeHeight__["a" /* default */])(_this.textAreaRef, false, minRows, maxRows);
            _this.setState({ textareaStyles: textareaStyles });
        };
        _this.handleTextareaChange = function (e) {
            if (!('value' in _this.props)) {
                _this.resizeTextarea();
            }
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(e);
            }
        };
        _this.handleKeyDown = function (e) {
            var _a = _this.props, onPressEnter = _a.onPressEnter, onKeyDown = _a.onKeyDown;
            if (e.keyCode === 13 && onPressEnter) {
                onPressEnter(e);
            }
            if (onKeyDown) {
                onKeyDown(e);
            }
        };
        _this.saveTextAreaRef = function (textArea) {
            _this.textAreaRef = textArea;
        };
        return _this;
    }
    TextArea.prototype.componentDidMount = function () {
        this.resizeTextarea();
    };
    TextArea.prototype.componentWillReceiveProps = function (nextProps) {
        // Re-render with the new content then recalculate the height as required.
        if (this.props.value !== nextProps.value) {
            if (this.nextFrameActionId) {
                clearNextFrameAction(this.nextFrameActionId);
            }
            this.nextFrameActionId = onNextFrame(this.resizeTextarea);
        }
    };
    TextArea.prototype.focus = function () {
        this.textAreaRef.focus();
    };
    TextArea.prototype.blur = function () {
        this.textAreaRef.blur();
    };
    TextArea.prototype.getTextAreaClassName = function () {
        var _a;
        var _b = this.props, prefixCls = _b.prefixCls, className = _b.className, disabled = _b.disabled;
        return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls, className, (_a = {},
            _a[prefixCls + "-disabled"] = disabled,
            _a));
    };
    TextArea.prototype.render = function () {
        var props = this.props;
        var otherProps = Object(__WEBPACK_IMPORTED_MODULE_1_omit_js__["a" /* default */])(props, [
            'prefixCls',
            'onPressEnter',
            'autosize',
        ]);
        var style = __assign({}, props.style, this.state.textareaStyles);
        // Fix https://github.com/ant-design/ant-design/issues/6776
        // Make sure it could be reset when using form.getFieldDecorator
        if ('value' in otherProps) {
            otherProps.value = otherProps.value || '';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", __assign({}, otherProps, { className: this.getTextAreaClassName(), style: style, onKeyDown: this.handleKeyDown, onChange: this.handleTextareaChange, ref: this.saveTextAreaRef })));
    };
    TextArea.defaultProps = {
        prefixCls: 'cube-input',
    };
    return TextArea;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (TextArea);


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var RightLeftLayout = /** @class */ (function (_super) {
    __extends(RightLeftLayout, _super);
    function RightLeftLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultRightWidth = '35%';
        _this.changeChartsShow = function () {
            if (_this.props.showOrCloseExpand) {
                _this.props.showOrCloseExpand();
                return;
            }
            var rightDiv = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(".cube-rightleft-layout-right");
            var leftDiv = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(".cube-rightleft-layout-left");
            var chartsWidth = 0;
            var searchWidth = 100;
            var width = parseInt(_this.defaultRightWidth.replace('%', ''));
            if (rightDiv.hasClass("cube-rightleft-hide")) {
                rightDiv.removeClass("cube-rightleft-hide");
                chartsWidth = width;
                searchWidth = 100 - width;
            }
            else {
                rightDiv.addClass("cube-rightleft-hide");
            }
            _this.setState({ rightWidth: chartsWidth });
            rightDiv.css("width", chartsWidth + "%");
            leftDiv.css("width", searchWidth + "%");
        };
        _this.getOtherWidth = function () {
            var width = _this.state.width;
            if (width.endsWith('%')) {
                return (100 - parseInt(width.replace('%', ''))) + '%';
            }
            else if (width.endsWith('px')) {
                _this.totalWidth = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this).scrollWidth;
                return (_this.totalWidth - parseInt(width.replace('px', ''))) + 'px';
            }
        };
        _this.isMoveing = false;
        _this.onStart = function (e) {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.wea-draggable-defaultCss').css('width', '400px');
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.wea-draggable-defaultCss').css('left', '-200px');
            if (_this.state.width && _this.state.width.startsWith('0')) {
                return;
            }
            _this.isMoveing = true;
            _this.startX = e.screenX;
        };
        _this.onDrag = function (e) {
            if (_this.isMoveing) {
                var width = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#cube_rightContainer').width() + _this.startX - e.screenX;
                if (width < 10 || width > _this.totalWidth - 10) {
                    return;
                }
                if (Math.abs(_this.startX - e.screenX) < 4)
                    return;
                _this.setState({ width: width + 'px' });
                _this.startX = e.screenX;
            }
        };
        _this.onStop = function () {
            _this.isMoveing = false;
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.wea-draggable-defaultCss').css('width', '10px');
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.wea-draggable-defaultCss').css('left', '-5px');
        };
        _this.state = {
            rightWidth: 0,
            width: props.rightLayoutWidth ? props.rightLayoutWidth : '35%' //右边宽度
        };
        return _this;
    }
    RightLeftLayout.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ width: nextProps.rightLayoutWidth ? nextProps.rightLayoutWidth : '35%' });
    };
    RightLeftLayout.prototype.componentDidMount = function () {
        var _this = this;
        var visible = this.props.visible;
        if (visible) {
            this.changeChartsShow();
        }
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(window).resize(function () {
            _this.totalWidth = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.cube-rightleft-layout-warper').width();
            var width = _this.state.width;
            if (width.endsWith('px')) {
                width = width.replace('px', '') / _this.totalWidth;
                _this.setState({ width: Math.round(width * 100) + '%' });
            }
        });
    };
    RightLeftLayout.prototype.componentDidUpdate = function () {
        if (this.state.width.endsWith('%')) {
            this.totalWidth = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#cube_rightContainer').width() / (parseInt(this.state.width.replace('%', '')) / 100);
        }
        else {
            this.totalWidth = __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.cube-rightleft-layout-warper').width();
        }
    };
    RightLeftLayout.prototype.render = function () {
        var _a = this.props, leftCom = _a.leftCom, rightCom = _a.rightCom, bottomHeight = _a.bottomHeight, padding = _a.padding, iconClass = _a.iconClass, titletext = _a.titletext, visible = _a.visible, canDrag = _a.canDrag, iconParentStyle = _a.iconParentStyle;
        var defaultShowReplyPanel = !visible;
        var isshow = defaultShowReplyPanel || (this.state.rightWidth > 0);
        var dragStyle = {};
        var rightClosed = false;
        if (iconParentStyle) { //如果存在iconParentStyle说明是来自查询的右侧展开，否则可能是回复评论右侧框
            if (this.state.width && this.state.width.startsWith('0')) {
                iconParentStyle['background'] = "url(" + Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])('/spa/portal/images/synergy/left.png') + ") center center no-repeat";
                iconParentStyle['left'] = '-17px';
                dragStyle = { width: '0px' };
                rightClosed = true;
            }
            else {
                iconParentStyle['background'] = "url(" + Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])('/spa/portal/images/synergy/right.png') + ") center center no-repeat";
                iconParentStyle['left'] = '0px';
                dragStyle = { cursor: 'e-resize' };
                rightClosed = false;
            }
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-rightleft-layout-warper", style: {
                boxSizing: "border-box",
                padding: padding ? "" + (padding.top + "px " + padding.right + "px " + padding.bottom + "px " + padding.left + "px") : ""
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-rightleft-layout-inner", style: { minHeight: bottomHeight + "px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-rightleft-layout-left", style: { "width": this.getOtherWidth() } }, bottomHeight ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaNewScroll"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaNewScroll@32tl3f", height: bottomHeight }, leftCom) : leftCom),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-rightleft-layout-right", style: { "width": this.state.width } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: this.changeChartsShow, style: iconParentStyle, className: "cube-rightleft-layout-expand" },
                        iconClass && iconClass != "" && !iconParentStyle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-rightleft-icon " + iconClass }),
                        titletext && titletext != "" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-rightleft-title" }, titletext)),
                    canDrag &&
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-draggable-defaultCss", onMouseDown: this.onStart, onMouseUp: this.onStop, onMouseMove: this.onDrag, style: __assign({ height: '100%', width: '10px', position: 'absolute', zIndex: 100, left: '-5px' }, dragStyle) }),
                    isshow && (bottomHeight ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaNewScroll"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaNewScroll@d2lz15", height: bottomHeight },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cube_rightContainer", style: rightClosed ? { display: 'none' } : { display: 'block' } }, rightCom)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cube_rightContainer", style: rightClosed ? { display: 'none' } : { display: 'block' } }, rightCom))))));
    };
    RightLeftLayout = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], RightLeftLayout);
    return RightLeftLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RightLeftLayout);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTimedata */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__excel_layout_cell_field_browser_element_Browser__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComs_buttonNew__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComs_selectNew__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComs_inputNew__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComs_DateGroupNew__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComs_TimeRangePickerNew__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComs_RangePickerNew__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComs_SelectGroupNew__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComs_BrowserNew__ = __webpack_require__(996);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

















var getLabel = __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaLocaleProvider"].getLabel;
var getTimedata = function () {
    return [
        { name: getLabel(332, '全部'), value: '0' },
        { name: getLabel(517615, '昨天'), value: '9' },
        { name: getLabel(15537, '今天'), value: '1' },
        { name: getLabel(517616, '明天'), value: '10' },
        { name: getLabel(517617, '上周'), value: '11' },
        { name: getLabel(15539, '本周'), value: '2' },
        { name: getLabel(517618, '下周'), value: '12' },
        { name: getLabel(15541, '本月'), value: '3' },
        { name: getLabel(21904, '本季'), value: '4' },
        { name: getLabel(15384, '本年'), value: '5' },
        { name: getLabel(27347, '上个月'), value: '7' },
        { name: getLabel(81716, '上一年'), value: '8' },
        { name: getLabel(32530, '指定日期范围'), value: '6' } // 时间范围的值必须为6
    ];
};
/****处理快捷搜索 */
var QuickSearch = /** @class */ (function (_super) {
    __extends(QuickSearch, _super);
    function QuickSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * @description 由于分组内的组件会弹出模态框，当点击内部的模态框时，应维持分组的展示，只有点击
         * 非分组相关区域时，才关闭分组的模态框展示。
         * */
        _this.onHideGroupPanel = function (classname, datas) {
            if (datas === void 0) { datas = []; }
            if (datas.some(function (item) { return item.hasOwnProperty('searchGroup'); })) { //快捷搜索有分组才适用
                __WEBPACK_IMPORTED_MODULE_4_jquery___default()(classname).on('click', function () {
                    if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.ant-popover.cube-quicksearch-group-popover').not('.ant-popover-hidden').css('display') == 'block') {
                        if (datas.some(function (data) { return data.hasOwnProperty('_visible') && data._visible; })) {
                            _this.setGroupVisible('', false);
                        }
                    }
                });
            }
        };
        /**
         * 分组显隐
         * */
        _this.setGroupVisible = function (id, isShow) {
            var _a = _this.props, datas = _a.datas, listStore = _a.listStore;
            var setQuickSearchInfo = listStore.setQuickSearchInfo;
            var newData = datas.map(function (item) {
                var groupid = item.groupid;
                if (groupid == id) {
                    item['_visible'] = isShow;
                }
                else {
                    item['_visible'] = false;
                }
                return item;
            });
            setQuickSearchInfo(newData);
        };
        /**
         * 表单项修改
         * */
        _this.onValueChange = function (fieldid, value, doNotSearch) {
            _this.props.onChange(fieldid, value, doNotSearch); //如果是分组则记录,true form记录但不发起搜索
        };
        /**
         * 判断分组的内部的组件是否选择了值
         * */
        _this.getGroupChecked = function (data, index, QSDataObj) {
            return data.searchGroup.some(function (item) {
                var sourceData = QSDataObj[index];
                if (sourceData) {
                    for (var i = 0, len = sourceData.searchGroup.length; i < len; i++) {
                        var tmpdata = sourceData.searchGroup[i];
                        var fieldid = item.fieldid, fieldhtmltype = item.fieldhtmltype, fieldtype = item.fieldtype, _a = item.value, value = _a === void 0 ? '' : _a, _b = item.replaceDatas, replaceDatas = _b === void 0 ? [] : _b;
                        if (fieldid == tmpdata.fieldid) {
                            if (item.hasOwnProperty('value')) {
                                //默认值或初始值特殊 的情况
                                if ((fieldhtmltype == '1' && fieldtype != '1') //数值类型
                                    || (fieldhtmltype == '5' && fieldtype == '1') //下拉框
                                    || (fieldhtmltype == '4' && fieldtype == '1') //勾选框
                                    || (fieldhtmltype == '5' && fieldtype == '2') //多选框
                                    || (fieldhtmltype == '5' && fieldtype == '3') //单选框
                                ) {
                                    if (value == '-1') { // 默认值可能更改为-1
                                        return false;
                                    }
                                }
                                else if (fieldhtmltype == '3' && fieldtype == '1') { //人员 ["-5",""]||[]
                                    if (!value[0]) {
                                        return false;
                                    }
                                    if (value[0] == '-5') {
                                        if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(value[1])) {
                                            return false; //默认值 ["-5",""]||["-5",[]]
                                        }
                                        else if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isArray(value[1]) && !value[1][0]) {
                                            return false; //["-5",['','',empty]]
                                        }
                                    }
                                    else if (value[0] == '0' && !value[1]) { //全部 ["0", null]
                                        return false;
                                    }
                                }
                                else if (fieldhtmltype == '3' && fieldtype == '2') { //创建日期
                                    if (!value[0] || value[0] == '0') {
                                        return false; //value: ["0", "", ""]||value: ["0"]
                                    }
                                    else if (value[0] == '6' && !value[1]) { //指定日期范围['6']
                                        return false;
                                    }
                                }
                                //通常情况
                                if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(value), Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(tmpdata['value']))) { //与原始后台数据相等
                                    return false;
                                }
                                else if (!Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(value)) { //空
                                    return false;
                                }
                                else if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isArray(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(value))) {
                                    if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(value)) || value[0] == '') { //[]||[""]
                                        return false;
                                    }
                                }
                            }
                            else if (item.hasOwnProperty('replaceDatas')) {
                                if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(replaceDatas)) || replaceDatas[0] == '') { //如果数组为空或第一项是空值
                                    return false;
                                }
                                else if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(replaceDatas), Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(tmpdata['replaceDatas']))) { //如果与原始数据相同
                                    return false;
                                }
                            }
                            else if (!item.hasOwnProperty('value') && !item.hasOwnProperty('replaceDatas')) {
                                return false;
                            }
                            return true;
                        }
                    }
                }
                return false;
            });
        };
        /**
         * 重置
         * */
        _this.resetConditions = function (groupid) {
            var listStore = _this.props.listStore;
            var quickSearchFormData = listStore.quickSearchFormData, quickSearchData = listStore.quickSearchData, quickSearchDataWithNoChange = listStore.quickSearchDataWithNoChange, setQuickSearchInfo = listStore.setQuickSearchInfo;
            var QSDataObj = quickSearchDataWithNoChange && JSON.parse(quickSearchDataWithNoChange); //原始数据作为初始值
            var info = quickSearchData.quicksearchinfo.map(function (data) {
                if (data.groupid == groupid) {
                    data = QSDataObj.filter(function (em) { return em.groupid == groupid; })[0];
                    data['_visible'] = false;
                    data.searchGroup.map(function (item) {
                        var _a = item.fieldid, fieldid = _a === void 0 ? '' : _a;
                        __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchFormData, fieldid, '');
                        listStore.changeConditioninfo(fieldid, '');
                    });
                }
                return data;
            });
            setQuickSearchInfo(info);
            _this.props.onChange('', '', false);
        };
        /**
         * 搜索
         * */
        _this.doGroupSearch = function (groupid) {
            _this.props.onChange('', '', false); //form do search
            _this.setGroupVisible(groupid, false);
        };
        _this.getFields = function (field, conditioninfo) {
            var listStore = _this.props.listStore;
            var quickSearchFormData = listStore.quickSearchFormData;
            if (field.parentDomkey && field.parentDomkey.length > 0) {
                var items_1 = {};
                conditioninfo.map(function (f) {
                    if (f.domkey == field.parentDomkey[0]) {
                        var domkeyValue = f.domkey[0].split('_')[1];
                        var value1 = quickSearchFormData[domkeyValue] ? quickSearchFormData[domkeyValue] : __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaTools"].getSelectDefaultValue(f.options);
                        var childitem_1 = [];
                        value1.split(',').map(function (val) {
                            childitem_1 = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.union(childitem_1, f.options.filter(function (o) { return o.key == val; }));
                        });
                        var childitemid_1 = [];
                        childitem_1.map(function (item) {
                            childitemid_1 = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.union(childitemid_1, item.childitemid);
                        });
                        var childArry = [];
                        var _loop_1 = function (i) {
                            var arr = field.options.filter(function (option) { return option.key == childitemid_1[i] || option.key == ""; });
                            childArry = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.union(childArry, arr);
                        };
                        for (var i = 0; i < childitemid_1.length; i++) {
                            _loop_1(i);
                        }
                        field = __assign({}, field, { options: childArry });
                    }
                    items_1 = field;
                });
                return items_1;
            }
            else {
                return field;
            }
        };
        _this.renderGroup = function (data, data_index, getRender) {
            var listStore = _this.props.listStore;
            var quickSearchDataWithNoChange = listStore.quickSearchDataWithNoChange;
            var QSDataObj = quickSearchDataWithNoChange && JSON.parse(quickSearchDataWithNoChange);
            var _a = data.groupname, groupname = _a === void 0 ? '筛选条件' : _a;
            var _b = data._visible, _visible = _b === void 0 ? false : _b;
            var ghostChecked = _this.getGroupChecked(data, data_index, QSDataObj);
            var cont = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cube-quicksearch-group" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'cube-quicksearch-list' }, getRender(data.searchGroup, true)),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'cube-quicksearch-funbtn' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__commonComs_buttonNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonNew@v85fdt", type: 'ghost', content: getLabel(2022, '重置'), id: data.groupid, onClick: _this.resetConditions }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__commonComs_buttonNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonNew@eb1vh0", type: 'primary', content: getLabel(388113, '搜索'), id: data.groupid, onClick: _this.doGroupSearch }))));
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Popover"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Popover@j115z8", content: cont, trigger: "click", overlayClassName: "cube-quicksearch-group-popover", placement: "bottomLeft", visible: _visible, onVisibleChange: function (v) { return v && _this.setGroupVisible(data.groupid, true); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cube-quicksearch-group-btn" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@9qqalq", type: "ghost", className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-group-mainbtn', { 'cube-ghostChecked': ghostChecked }) },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, groupname),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "icon-coms-down2" })))));
        };
        return _this;
    }
    QuickSearch.prototype.componentDidMount = function () {
        var _a = this.props.datas, datas = _a === void 0 ? [] : _a;
        if (datas.length) {
            this.onHideGroupPanel('.coms-mode-docker', datas);
        }
    };
    QuickSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, datas = _a.datas, listStore = _a.listStore;
        var quickSearchFormData = listStore.quickSearchFormData, quickSearchConditionData = listStore.quickSearchConditionData;
        var _b = listStore.quickSearchData, ishidename = _b.ishidename, isshowtype = _b.isshowtype;
        var showInOneLine = isshowtype === '0'; //是否为一行显示
        var divstyle = { display: 'inline-block', margin: '2px 10px' };
        var copyReplaceData = [];
        var copyData = datas;
        var Timedata = getTimedata();
        /**
         * 记录快捷搜索填入的值
         * */
        var setCopyReplaceData = function (fieldid, v, keyName) {
            if (keyName === void 0) { keyName = 'value'; }
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchConditionData, "con_" + fieldid, v);
            copyReplaceData.map(function (itemss, findex) {
                if (itemss.hasOwnProperty('searchGroup')) {
                    itemss.searchGroup.map(function (dd, inx) {
                        if (dd.fieldid == fieldid) {
                            copyReplaceData[findex]['searchGroup'][inx][keyName] = v;
                        }
                    });
                }
                else {
                    if (itemss.fieldid == fieldid) {
                        copyReplaceData[findex][keyName] = v;
                    }
                }
            });
        };
        var onPressEnter = function (fieldid, v, isChild) {
            setCopyReplaceData(fieldid, v);
            listStore.changeConditioninfo(fieldid, v);
            _this.onValueChange(fieldid, v, isChild);
        };
        var onBlur = function (fieldid, v, isChild) {
            setCopyReplaceData(fieldid, __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.trim(v));
            listStore.changeConditioninfo(fieldid, v);
            v != __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(quickSearchFormData, fieldid, '') && _this.onValueChange(fieldid, v, isChild);
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchConditionData, "con_" + fieldid, v);
        };
        var selectGroupChange = function (fieldid, v, isChild) {
            if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isArray(v) && v[0] != '-5') {
                v = [v[0], []];
            }
            setCopyReplaceData(fieldid, v);
            listStore.changeConditioninfo(fieldid, v);
            _this.onValueChange(fieldid, v, isChild);
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchConditionData, "con_" + fieldid, v);
        };
        var BrowserChange = function (ids, names, datas, fieldtype, fieldid, isChild) {
            var valueSpan = "";
            var data = [];
            try {
                if (fieldtype == '141') {
                    ids = Object(__WEBPACK_IMPORTED_MODULE_8__excel_layout_cell_field_browser_element_Browser__["b" /* spellResourceCondition */])(datas);
                    valueSpan = names + ",";
                    datas.map(function (it) {
                        data.push(it);
                    });
                }
                else if (fieldtype == '17') { // 多人力类型，需保留type属性
                    datas.map(function (it) {
                        data.push(it);
                    });
                }
                else {
                    datas.map(function (it) {
                        var name = it.name;
                        valueSpan += name + ",";
                        for (var k in it) {
                            if (k == 'id' || k == 'name') {
                            }
                            else {
                                delete it[k];
                            }
                        }
                        it["tips"] = name;
                        it["count"] = 0;
                        data.push(it);
                    });
                }
                valueSpan = valueSpan.substring(0, valueSpan.length - 1);
                listStore.changeConditioninfoForBrowser(fieldid, ids, data, valueSpan);
            }
            catch (e) {
                listStore.changeConditioninfoForBrowser(fieldid, ids, data, valueSpan);
            }
            var replaceData = [];
            if (ids.indexOf(",") > -1) {
                var BValue = ids.split(",");
                var dataAny_1 = names.split(",");
                var datas_1 = {};
                var i_1 = 0;
                BValue.map(function (item) {
                    datas_1 = { id: item, name: dataAny_1[i_1] };
                    replaceData.push(datas_1);
                    i_1++;
                });
            }
            else {
                replaceData = [{ id: ids, name: names }];
            }
            if (fieldtype == '141') {
                replaceData = datas;
            }
            setCopyReplaceData(fieldid, replaceData, 'replaceDatas');
            _this.onValueChange(fieldid, ids, isChild);
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchConditionData, "con_" + fieldid, ids);
        };
        /**
         * 渲染快捷搜索表单
         * */
        var getRender = function (copyData, isChild) {
            if (isChild === void 0) { isChild = false; }
            return copyData.map(function (data, data_index) {
                if (!isChild) {
                    copyReplaceData.push(data);
                }
                //处理分组
                if (data.hasOwnProperty('searchGroup')) {
                    return _this.renderGroup(data, data_index, getRender);
                }
                //不分组
                var fieldtype = data.fieldtype, fieldhtmltype = data.fieldhtmltype, fieldid = data.fieldid, customname = data.customname, browserProps = data.browserProps, _a = data.value, value = _a === void 0 ? "" : _a, detailtype = data.detailtype, multiple = data.multiple, viewAttr = data.viewAttr, _b = data.replaceDatas, replaceDatas = _b === void 0 ? [] : _b, conditiontransition = data.conditiontransition, floatValue = data.floatValue, requiredCon = data.requiredCon, showmodel = data.showmodel;
                var isflatlay = showmodel === '1'; //是否是平铺
                var colonStr = '';
                var title = isChild && showInOneLine ? { title: customname } : {};
                if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(listStore.quickSearchConditionData, "con_" + fieldid) == undefined) {
                    __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(listStore.quickSearchConditionData, "con_" + fieldid, "");
                }
                if (customname) { //如果没有labelname则不显示冒号
                    colonStr = (__WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaLocaleProvider"].getUserLanguage() == 7 || __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaLocaleProvider"].getUserLanguage() == 9) ? '：' : ':';
                }
                if (value) {
                    __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchConditionData, "con_" + fieldid, value);
                }
                if ((fieldhtmltype == '1' && fieldtype != '1') //数值类型
                    || (fieldhtmltype == '5' && fieldtype == '1') //下拉框
                    || (fieldhtmltype == '4' && fieldtype == '1') //勾选框
                    || (fieldhtmltype == '5' && fieldtype == '2') //多选框
                    || (fieldhtmltype == '5' && fieldtype == '3') //单选框
                ) {
                    if (requiredCon == '1' && (value == undefined || value == '-1' || value == -1)) {
                        value = '';
                    }
                    if (value != undefined && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(quickSearchFormData, fieldid, "-1") == -1) {
                        __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchFormData, fieldid, value);
                    }
                    data = _this.getFields(data, copyData);
                    var onNumSelect = function (v) {
                        setCopyReplaceData(fieldid, v);
                        if (v == "-1" || v == "") {
                            listStore.changeConditioninfo(fieldid, []);
                        }
                        else {
                            var float = void 0;
                            float = floatValue;
                            var i = float[v].split(",");
                            listStore.changeConditioninfo(fieldid, i);
                        }
                        _this.onValueChange(fieldid, v, isChild);
                        __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchConditionData, "con_" + fieldid, v);
                    };
                    var onSelectWithDeatilType = function (v, detailtype, multiple) {
                        setCopyReplaceData(fieldid, v);
                        listStore.changeConditioninfo(fieldid, v);
                        _this.onValueChange(fieldid, v, isChild);
                        __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchConditionData, "con_" + fieldid, v);
                    };
                    var onSelectChange = function (v, detailtype, multiple) {
                        setCopyReplaceData(fieldid, v);
                        listStore.changeConditioninfo(fieldid, v);
                        _this.onValueChange(fieldid, v, isChild);
                        __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchConditionData, "con_" + fieldid, v);
                    };
                    /******** start:   平铺模式参数 * (只支持数值类型或下拉框) *******/
                    var cls = '', style = { width: 100 };
                    var supportCancel = false; //单选是否支持取消
                    if (isflatlay) {
                        detailtype = detailtype == '2' ? 2 : multiple ? 2 : 3; //平铺下，2多选，3单选
                        supportCancel = detailtype === 3;
                        cls = 'cube-quicksearch-flat-lay';
                        style = {};
                        if (data.options.every(function (item) { return !item.showname; })) {
                            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                                !ishidename &&
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 5 } },
                                        customname,
                                        colonStr),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'cube-group-empty' },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, getLabel(514133, '未设置')),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, getLabel(386817, '选项'))))));
                        }
                    }
                    /*************************  end  ****************************/
                    if (detailtype != '' && (fieldhtmltype == '1' && fieldtype != '1')) { //数值类型
                        value = (value == "-1" || value == "") ? "" : value;
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 5 } }),
                                    customname,
                                    colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaSelect"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSelect@e6tk7n@" + data_index, options: Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(data.options), style: __assign({}, style, { verticalAlign: 'middle' }), value: value, viewAttr: viewAttr, multiple: multiple, onChange: onNumSelect, placeholder: customname, detailtype: detailtype, className: cls, supportCancel: supportCancel }))));
                    }
                    else if ((fieldhtmltype == '5' && fieldtype == '1') && detailtype != '') { //下拉框类型
                        var mult = !isflatlay ? { multiple: multiple } : {}; //如果是平铺则不要multiple属性
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 5 } }),
                                    customname,
                                    colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__commonComs_selectNew__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectNew@r5xr1y", options: Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(data.options), style: __assign({}, style, { verticalAlign: 'middle' }), value: value, viewAttr: viewAttr }, mult, { placeholder: customname, className: cls, supportCancel: supportCancel, detailtype: detailtype, 
                                    // multiple={multiple}
                                    onChange: onSelectWithDeatilType })))));
                    }
                    else { //单选框，多选框，勾选框,现在也显示成下拉框
                        var flatlay = isflatlay ? { detailtype: detailtype, supportCancel: supportCancel } : {};
                        var mult = !isflatlay && (detailtype == '2' || multiple) ? { multiple: true } : {};
                        var option = isflatlay || (detailtype == '2' || multiple) ? data.options.filter(function (opt) { return opt.showname; }) : data.options;
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename &&
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 5 } }),
                                    customname,
                                    colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__commonComs_selectNew__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectNew@dsd0au", options: Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(option), style: __assign({}, style, { verticalAlign: 'middle' }), value: value, viewAttr: viewAttr, multiple: multiple, onChange: onSelectChange, placeholder: customname, className: cls }, mult, flatlay)))));
                    }
                }
                else if (fieldhtmltype == '1' && fieldtype == '1') { //文本框
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                        !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                            customname,
                            colonStr),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__commonComs_inputNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_InputNew@oesm65@" + data_index, style: { width: 150, 'vertical-align': 'middle' }, viewAttr: viewAttr, value: value, placeholder: customname, fieldid: fieldid, isChild: isChild, onChange: setCopyReplaceData, onPressEnter: onPressEnter, onBlur: onBlur })));
                }
                else if (fieldhtmltype == '2' && fieldtype == '1') { //多行文本框
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                        !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                            customname,
                            colonStr),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__commonComs_inputNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_InputNew@34r4s9@" + data_index, style: { width: 150, 'vertical-align': 'middle' }, viewAttr: viewAttr, value: value, fieldid: fieldid, isChild: isChild, onChange: setCopyReplaceData, onPressEnter: onPressEnter, onBlur: onBlur, placeholder: customname })));
                }
                else if (fieldhtmltype == '2' && fieldtype == '2') { //文本html
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                        !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                            customname,
                            colonStr),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__commonComs_inputNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_InputNew@pdgtuq@" + data_index, style: { width: 150, 'vertical-align': 'middle' }, viewAttr: viewAttr, value: value, fieldid: fieldid, isChild: isChild, onChange: setCopyReplaceData, onPressEnter: onPressEnter, onBlur: onBlur, placeholder: customname })));
                }
                else if (fieldhtmltype == '3') {
                    if (fieldtype == '2') { //日期
                        if (value != undefined && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(quickSearchFormData, fieldid) == undefined) {
                            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(quickSearchFormData, fieldid, value);
                        }
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                                customname,
                                colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__commonComs_DateGroupNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_DateGroupNew@e1yjbr", isMobx: true, value: Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(value), style: { minWidth: 120, display: 'inline-block' }, 
                                    // fieldid=='1'，创建日期过滤“明天”“下周”
                                    datas: fieldid == '1' ? Timedata.filter(function (item) { return ['10', '12'].indexOf(item.value) == -1; }) : Timedata, viewAttr: viewAttr, isInline: true, fieldid: fieldid, isChild: isChild, onChange: onPressEnter })));
                    }
                    else if (fieldtype == '19') { //时间
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                                customname,
                                colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__commonComs_TimeRangePickerNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_TimeRangePickerNew@3jza17", value: Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(value), noInput: true, viewAttr: viewAttr, fieldid: fieldid, isChild: isChild, onChange: onPressEnter })));
                    }
                    else if (fieldtype == '290') { //日期时间
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                                customname,
                                colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__commonComs_RangePickerNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_RangePickerNew@0qts43", type: fieldtype, value: Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(value), style: { width: 'auto' }, viewAttr: viewAttr, format: "yyyy-MM-dd HH:mm", showTime: true, fieldid: fieldid, isChild: isChild, onChange: onPressEnter })));
                    }
                    else if (fieldtype == '402') { //年
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                                customname,
                                colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__commonComs_RangePickerNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_RangePickerNew@zzphi4", noInput: true, type: fieldtype, value: value + "", format: "YYYY", style: { width: 'auto' }, viewAttr: viewAttr, fieldid: fieldid, isChild: isChild, onChange: onPressEnter })));
                    }
                    else if (fieldtype == '403') { //年月
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                                customname,
                                colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__commonComs_RangePickerNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_RangePickerNew@vg56eu", noInput: true, type: fieldtype, value: value + "", format: "YYYY-MM", style: { width: 'auto' }, viewAttr: viewAttr, fieldid: fieldid, isChild: isChild, onChange: onPressEnter })));
                    }
                    else if (fieldtype == '1' || ('1' == conditiontransition && '17' == fieldtype)) { //人员
                        if (fieldtype == '1' && '1' == conditiontransition) {
                            browserProps = __assign({}, browserProps, { isSingle: false });
                            delete browserProps.isMultCheckbox; //qc732353,由于组件库改造浏览框，单部门单分部单人力多选后快捷搜索不能选择多个，删除该属性。
                        }
                        var selectLink = {
                            "-5": {
                                conditionType: "BROWSER",
                                browserConditionParam: __assign({}, browserProps, { maxBrowerHeight: 28 }),
                                domkey: ['hrmBrowser']
                            }
                        };
                        var vs = value.slice();
                        var width = 280;
                        if (vs.length > 0) {
                            if (vs[0] != -5) {
                                width = 130;
                            }
                            else if (vs[0] == -5 && !vs[1]) { //选择人员，值需为数组
                                vs[1] = [];
                            }
                        }
                        var hrmoptions = [
                            { key: "0", showname: getLabel(332, '全部') },
                            { key: "-1", showname: getLabel(21837, '本部门') },
                            { key: "-2", showname: getLabel(81362, '本部门(包含下级部门)') },
                            { key: "-3", showname: getLabel(30792, '本分部'), visible: true },
                            { key: "-4", showname: getLabel(81363, '本分部(包含下级分部)') },
                            { key: "-6", showname: getLabel(15763, '本人') },
                            { key: "-7", showname: getLabel(15709, '直接上级') },
                            { key: "-8", showname: getLabel(81863, '直接下属') },
                            { key: "-5", showname: getLabel(33210, '选择人员') }
                        ];
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'hrmSelectGrop searchdiv' + fieldid, style: __assign({}, divstyle) },
                            !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                                customname,
                                colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__commonComs_SelectGroupNew__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectGroupNew@ro1ewp", isMobx: true, value: Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(value), options: hrmoptions, style: { width: width, display: 'inline-flex' }, selectLinkageDatas: selectLink, fieldid: fieldid, isChild: isChild, onChange: selectGroupChange })));
                    }
                    else {
                        var hasAdvanceSerach = true;
                        var dataParams = browserProps.dataParams || {};
                        var conditionDataParams = browserProps.conditionDataParams || {};
                        var completeParams = browserProps.completeParams || {};
                        if (fieldtype == '256' || fieldtype == '257') {
                            //disabledInput = true;//树形不支持快捷搜索
                            hasAdvanceSerach = browserProps.hasAdvanceSerach;
                        }
                        var iconStyle = {};
                        if (fieldtype == '256' || fieldtype == '257') { //自定义树形单多选浏览框图标可以用户自定义
                            var treeId = dataParams.cube_treeid;
                            delete dataParams.cube_treeid;
                            dataParams.cube_treeid = treeId + "_searchType";
                            iconStyle.icon = listStore.iconInfo.icon;
                            iconStyle.iconBgcolor = listStore.iconInfo.iconBg;
                            iconStyle.iconFontColor = listStore.iconInfo.iconColor;
                        }
                        if ((fieldtype == '4' && '1' == conditiontransition) || (fieldtype == '164' && '1' == conditiontransition)) {
                            delete browserProps.isMultCheckbox; //qc732353,由于组件库改造浏览框，单部门单分部单人力多选后快捷搜索不能选择多个，删除该属性。
                            browserProps = __assign({}, browserProps, { isSingle: false });
                        }
                        if ((fieldtype == '161' || fieldtype == '162') && replaceDatas != undefined) {
                            //处理自定义单、多选浏览框设置默认值未初始化
                            var quickSearchValue_1 = ""; //replaceDatas[0].id;
                            replaceDatas.map(function (item) {
                                var id = item.id;
                                quickSearchValue_1 += id + ",";
                            });
                            quickSearchValue_1 = quickSearchValue_1.substring(0, quickSearchValue_1.length - 1);
                            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(listStore.quickSearchConditionData, "con_" + fieldid, quickSearchValue_1);
                        }
                        //剔除replaceDatas属性,这里不存储值,不剔除会导致选择后数据丢失,单选，多选，树形单选，树形多选不剔除
                        //if(undefined==browserProps.replaceDatas&&0==browserProps.replaceDatas.length){
                        try {
                            delete browserProps.replaceDatas;
                        }
                        catch (error) {
                            __WEBPACK_IMPORTED_MODULE_6_antd__["message"].error(error);
                            throw error;
                        }
                        dataParams = __assign({}, dataParams, quickSearchConditionData, { consearch: "consearch" });
                        conditionDataParams = __assign({}, conditionDataParams, quickSearchConditionData, { consearch: "consearch" });
                        completeParams = __assign({}, completeParams, quickSearchConditionData, { consearch: "consearch" });
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: __assign({}, divstyle) },
                            !ishidename && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({}, title, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cube-quicksearch-label', { 'cube-quicksearch-label-wrap': !showInOneLine }), style: { marginRight: 20 } }),
                                customname,
                                colonStr),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { width: 150, verticalAlign: 'middle' }, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('wea-input-normal', 'cube-quicksearch-style', { 'cube-quicksearch-in-one-line': showInOneLine }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__commonComs_BrowserNew__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_BrowserNew@o8zi5j" }, browserProps, { inputStyle: { width: 150 }, dataParams: dataParams, conditionDataParams: conditionDataParams, completeParams: completeParams, replaceDatas: replaceDatas, type: fieldtype, fieldtype: fieldtype, 
                                    //disabledInput={disabledInput}
                                    resize: false, maxBrowerHeight: 28, hasAdvanceSerach: hasAdvanceSerach, scrollx: true, viewAttr: viewAttr, fieldid: fieldid, isChild: isChild, onChange: BrowserChange }, iconStyle))));
                    }
                }
            });
        };
        var items = getRender(copyData);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "btnDiv" }, items);
    };
    QuickSearch = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], QuickSearch);
    return QuickSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (QuickSearch);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ButtonNew = /** @class */ (function (_super) {
    __extends(ButtonNew, _super);
    function ButtonNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var _a = _this.props, onClick = _a.onClick, id = _a.id;
            onClick(id);
        };
        return _this;
    }
    ButtonNew.prototype.render = function () {
        var _a = this.props, _b = _a.type, type = _b === void 0 ? 'ghost' : _b, content = _a.content, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@tegwjx", type: type, onClick: this.onClick, disabled: disabled }, content);
    };
    ButtonNew = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ButtonNew);
    return ButtonNew;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ButtonNew);


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeftTree__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stores_tree__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8____ = __webpack_require__(146);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree(props) {
        var _this = _super.call(this, props) || this;
        _this.leftTreeRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
        _this.afterIframeLoad = function () {
            var Tree = _this.props.Tree;
            Tree.changeLoading();
        };
        _this.handleLoadData = function (pid, node, callback) {
            var Tree = _this.props.Tree;
            Tree.currentNodeData = node;
            Tree.getTreeData({ pid: pid }, false, callback);
        };
        _this.handleNodeClick = function (pid, node) {
            var Tree = _this.props.Tree;
            if (pid == '0_0') {
                if (Tree.defaultAdress) {
                    Tree.onLoadRight({ href: Tree.defaultAdress });
                }
                else {
                    Tree.isCube = false;
                    Tree.remarkRefVisible = true;
                }
            }
            else {
                var hrmtype = void 0;
                if (node.data && node.data.hrmtype) {
                    hrmtype = node.data.hrmtype;
                }
                Tree.getTreeHref({ pid: pid }, hrmtype);
                //Tree.remarkRefVisible = false;
            }
        };
        _this.onExpandChange = function (expandKeys) {
            var Tree = _this.props.Tree;
            Tree.onExpandChange(expandKeys);
        };
        _this.setRef = function (ref) {
            _this.leftTreeRef = ref;
        };
        _this.onCollapse = function (bool) {
            setTimeout(function () {
                _this.leftTreeRef.scrollheigth();
            }, 10);
            var Tree = _this.props.Tree;
            Tree.setShowLeft(bool);
        };
        return _this;
    }
    Tree.prototype.componentWillMount = function () {
        //-------------------针对树  工具栏  功能
        var _a = this.props, location = _a.location, Tree = _a.Tree;
        if (location && location.query && location.query.defaultHideLeft) {
            Tree.setDefaultHideLeft(location.query.defaultHideLeft == '1');
        }
    };
    Tree.prototype.componentWillUnmount = function () {
        var Tree = this.props.Tree;
        Tree.clear();
    };
    Tree.prototype.render = function () {
        var _a = this.props, className = _a.className, Tree = _a.Tree, location = _a.location;
        var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('coms-mode-tree', className);
        if (Tree.windowTitle != '') {
            document.title = Tree.windowTitle;
        }
        var searchParamStr = "";
        if (location && location.query) {
            var query_1 = location.query;
            __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keys(query_1).forEach(function (item) {
                if (item.startsWith("con_") || item == 'quickSearchValue' || item == 'fromToolBar' || item == 'datasqlwhere'
                    || item == 'treehavekeyword') {
                    searchParamStr += "&" + item + "=" + query_1[item];
                }
            });
        }
        var _b = Tree.showLeft, showLeft = _b === void 0 ? true : _b;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: classNames },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLeftRightLayout"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaLeftRightLayout@0a2wm1", leftCom: Tree.isInit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LeftTree__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_LeftTree@20nr9r", ref: this.setRef, key: showLeft, datas: Object(__WEBPACK_IMPORTED_MODULE_7_mobx__["toJS"])(Tree.datas), topName: Tree.treeName, loadData: this.handleLoadData, onSelect: this.handleNodeClick, expandFirstNode: Tree.expandFirstNode, hasQuickSearch: Tree.hasQuickSearch, onQuickSearch: Tree.quickSearch, combintree: Tree.combintree, combintreeway: Tree.combintreeway, currentTree: Tree.currentTree, onChangeTree: Tree.onChangeTree, expandedKeys: Tree.expandKeys.slice(), onExpandChange: this.onExpandChange }) : null, resize: true, showLeft: showLeft, leftWidth: Tree.displaywidth, onCollapse: this.onCollapse },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cube-tree-frameMain", className: "cube-tree-main-frame", style: { display: Tree.mainFrameRefVisible ? "block" : 'none' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { id: "cube-tree-mainFrame", name: "cubeTreeMainFrame", frameBorder: "no", width: "100%", height: "100%", scrolling: "auto", src: "about:blank" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cube-tree-remark", style: { paddingLeft: 15, display: Tree.remarkRefVisible ? "block" : 'none' }, dangerouslySetInnerHTML: { __html: Tree.treeRemark } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tree-container", style: { display: Tree.isCube ? 'block' : 'none', height: "100%" } }, Tree.isCube && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8____["UrlDocker"], { ecId: (this && this.props && this.props.ecId || '') + "_UrlDocker@8n4r8a", url: Tree.url + searchParamStr || '', Card: (this.props.Card.isInTree = true, this.props.Card), Search: (this.props.Search), Tree: Tree.tree || (Tree.tree = new __WEBPACK_IMPORTED_MODULE_5__stores_tree__["a" /* TreeStore */](), Tree.tree.isInTree = true, Tree.tree), Reply: this.props.reply, ViewCustomPage: this.props.customPageStore })))));
    };
    Tree = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('Tree', 'Card', 'Search', 'reply', "customPageStore"),
        __WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"]
    ], Tree);
    return Tree;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Tree);


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1002);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1019),
    mapCacheDelete = __webpack_require__(1026),
    mapCacheGet = __webpack_require__(1028),
    mapCacheHas = __webpack_require__(1029),
    mapCacheSet = __webpack_require__(1030);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1031),
    arraySome = __webpack_require__(1034),
    cacheHas = __webpack_require__(1035);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(42),
    stubFalse = __webpack_require__(1052);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1054),
    baseUnary = __webpack_require__(1055),
    nodeUtil = __webpack_require__(1056);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DetailImportDialog", function() { return DetailImportDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var DetailImport = /** @class */ (function (_super) {
    __extends(DetailImport, _super);
    function DetailImport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetailImport.prototype.render = function () {
        var _a = this.props, detailImport = _a.detailImport, ecme = _a.ecme;
        var uploadParams = detailImport.uploadParams;
        var applyToModel = detailImport.applyToModel, downloadTemplate = detailImport.downloadTemplate;
        var layoutid = uploadParams.layoutid;
        if (layoutid == undefined) {
            layoutid = '0';
        }
        var param = { layoutid: layoutid, formId: uploadParams.formId, modeid: uploadParams.modeId, cardtype: uploadParams.type, billid: uploadParams.billid };
        // const href = `/weaver/weaver.formmode.data.FileDownload?type=detailimport_excel&layoutid=${ layoutid}&formId=${ uploadParams.formId}&modeid=${ uploadParams.modeId}&cardtype=${uploadParams.type}&billid=${uploadParams.billid} `;
        var uploadUrl = ecme.boolean === false ? detailImport.importUrl : "/api/doc/upload/uploadFile2Doc?category=" + ecme.category; //督办用
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-detail-import" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSearchGroup"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSearchGroup@lym1bk", col: 1, needTigger: true, showGroup: true, title: getLabel(28576, "下载模板"), items: [{
                        com: ([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginRight: 10 } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                        "1\uFF09",
                                        getLabel(28576, "下载模板"))),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function () { return downloadTemplate(__assign({}, param)); }, style: { color: 'blue', cursor: 'pointer' } }, detailImport.modename))),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginRight: 10 } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                        "2\uFF09",
                                        getLabel(16630, "上传Excel"))),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaUpload"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaUpload@a055yz", key: detailImport.random, uploadUrl: uploadUrl, uploadParams: Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(detailImport.uploadParams), category: 'string', maxUploadSize: 0, maxFilesNumber: 1, limitType: 'xls,xlsx', autoUpload: false, 
                                        // onUploading={detailImport.uploading}
                                        getShowListDatas: detailImport.getShowListDatas, onChange: detailImport.uploadChange },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@kg7gzr", size: "small", loading: detailImport.loading }, getLabel(125333, "选择文件")),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, detailImport.selectedFile))))])
                    }] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSearchGroup"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSearchGroup@agmmg7", col: 1, needTigger: true, showGroup: true, title: getLabel(27577, "操作步骤"), items: [{
                        com: ([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                    "1\uFF09",
                                    getLabel(27578, "请先下载"),
                                    "   ",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function () { return downloadTemplate(__assign({}, param)); }, style: { color: 'blue', cursor: 'pointer' } }, detailImport.modename),
                                    " ",
                                    getLabel(27579, '进行填写导入明细内容，第一行为表单明细字段的名称。')),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                    "2\uFF09",
                                    getLabel(27580, '请在第2步中选择填写好的Excel文件，并点击右键菜单中'),
                                    "+",
                                    getLabel(26255, '明细导入')))])
                    }] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSearchGroup"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSearchGroup@z2n4gt", col: 1, needTigger: true, showGroup: true, title: getLabel(27581, '使用注意事项'), items: [{
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "1\uFF09",
                                getLabel(387780, '导入明细数据时会在原有明细上追加.'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "2\uFF09",
                                getLabel(27583, '只有可编辑的字段才能进行导入，如果查看的字段有默认值的会自动加上默认值。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "3\uFF09",
                                getLabel(27584, '模板中第一行为表单明细字段名称，从第二行开始导入明细数据。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "4\uFF09",
                                getLabel(27585, '明细数据之间不能有空行。'),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: "red" } }, "(" + getLabel(131820, '存在空行时仅会导入空行以上的数据，空行以下的数据不会导入') + ")"))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "5\uFF09",
                                getLabel(27586, '如果有多个明细时模板中会有多个SHEET，一个明细一个SHEET。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "6\uFF09",
                                getLabel(27587, '数字类型字段不要有特殊格式，例如：科学计数法，千分位，货币符号等。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "7\uFF09",
                                getLabel(82723, '浏览类型字段直接输入名称或主键，例如：人力资源字段直接输入人员名称或主键。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "8\uFF09",
                                getLabel(27589, 'check类型字段输入“1/0”或“是/否”。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "9\uFF09",
                                getLabel(27590, '下拉选择框类型字段输入下拉选择框显示名称。(百分比格式的需要改为文本格式)'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "10\uFF09",
                                getLabel(126320, '日期类型字段导入时模板中需改为日期格式。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "11\uFF09",
                                getLabel(126429, '人力资源字段支持编号导入，excel模板中的格式为：workcode_具体编号。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "12\uFF09",
                                getLabel(130475, '部门字段支持编号导入，excel模板中的格式为：deptcode_具体的编号。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "13\uFF09",
                                getLabel(126435, '导入虚拟部门、分部，数据需以virtual_开头，例如：virtual_泛微。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "14\uFF09",
                                getLabel(128659, '模板中红色区域的内容不允许修改，新增行的数据ID必须为空。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "15\uFF09",
                                getLabel(127710, '浏览类型字段根据名称导入，如果名称为整数，则需要加上前缀name_，例如：name_名称。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "16\uFF09",
                                getLabel(514632, '自定义浏览框类型字段根据主键导入，如果主键非整数，则需要加上前缀key_，例如：key_主键。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "17\uFF09",
                                getLabel(510221, "分部，部门，人员字段支持A>B>C格式导入数据。例如，分部：分部>分部；部门：分部>分部>部门；人员：分部>部门>人员"))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "18\uFF09",
                                getLabel(388767, "自定义多选（树形多选）导入时，如果内容中包含英文逗号，请用DH{}包裹，如DH{A,B}。"))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "19\uFF09",
                                getLabel(519411, "人员字段导入时，如果要导入解聘、离职、退休、无效的人员时，请用加上LZRY_前缀，例如：LZRY_张三"))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "20\uFF09",
                                getLabel(520218, "附件，图片支持根据文档id、文档名称、目录1>目录2>文档名称进行导入，如果文档名称为整数，则需要加上前缀name_，例如：name_文档名称（填写全路径时无需添加前缀）。"))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "21\uFF09",
                                getLabel('521677', '树形浏览框支持按照对应的显示所有层级设置来导入'))))
                    },
                    {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "22\uFF09",
                                getLabel(521861, '树形浏览框类型字段支持主键导入，需要加上前缀tree_，格式为：tree_树节点id_数据id，例如：tree_226_1，其中tree为开头，226为树节点id，1为这条数据的id。'))))
                    }, {
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item1", style: { color: 'red', display: applyToModel == '1' ? '' : 'none' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                                "23\uFF09",
                                getLabel(507718, "分部，部门支持按照组织字段显示层级设置来导入") + "，" + getLabel('520811', '其中分部优先简称导入，部门优先全称导入'))))
                    }] })));
    };
    DetailImport = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], DetailImport);
    return DetailImport;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (DetailImport);
var DetailImportDialog = /** @class */ (function (_super) {
    __extends(DetailImportDialog, _super);
    function DetailImportDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetailImportDialog.prototype.render = function () {
        var _a = this.props, detailImport = _a.detailImport, _b = _a.iconInfo, iconInfo = _b === void 0 ? {} : _b;
        var buttons = detailImport && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@by56c1@onCancel", icon: "cross", onClick: detailImport.onCancel }, getLabel(309, '关闭')),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@vwkw6a@canUpload", type: "primary", icon: "save", loading: detailImport.loading, disabled: !detailImport.canUpload, onClick: detailImport.onOk }, getLabel(26255, '明细导入'))];
        return (detailImport ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@hk4lcv", className: 'wea-auth-modal cube-dialog', buttons: buttons, title: getLabel(26255, '明细导入'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: detailImport.visible, style: { width: 800, height: Math.min(580, document.documentElement.clientHeight * 0.8) }, hasScroll: true, onCancel: detailImport.onCancel },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DetailImport, { ecId: (this && this.props && this.props.ecId || '') + "_DetailImport@2a5ut6", detailImport: detailImport, ecme: { boolean: false } })) : null);
    };
    DetailImportDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], DetailImportDialog);
    return DetailImportDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var ReplyBase = /** @class */ (function (_super) {
    __extends(ReplyBase, _super);
    function ReplyBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReplyBase.prototype.render = function () {
        var _a = this.props, reply = _a.reply, _b = _a.padding, padding = _b === void 0 ? { left: 50, right: 50 } : _b;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@qek124", spinning: reply.loading, tip: getLabel(31230, "加载中") + "..." },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply", style: { marginLeft: padding.left, marginRight: padding.right } }, reply && reply.showReply ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__content__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Content@aoe6s7" }, this.props)) :
                reply.showReply === false ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-no-open-reply" }, getLabel("391240", "请联系管理员后台开启回复评论功能！"))
                    : null)));
    };
    ReplyBase = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ReplyBase);
    return ReplyBase;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ReplyBase);


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_input__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reply_item__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reply_add__ = __webpack_require__(1071);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var Content = /** @class */ (function (_super) {
    __extends(Content, _super);
    function Content(props) {
        var _this = _super.call(this, props) || this;
        _this.pageSizeOptions = ['5', '10', '20', '50', '100'];
        _this.getTotal = function (total) { return " " + (getLabel(18609, "共") + total + ' ' + getLabel(18256, "条")) + " "; };
        _this.getSearchs = function () {
        };
        _this.getTabButtons = function () {
            var reply = _this.props.reply;
            return [(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__search_input__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SearchInput@qkab6p@1", reply: reply })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@hrfxcw@adds", type: "primary", icon: "plus", onClick: reply.add }, getLabel(82, "新建"))];
        };
        return _this;
    }
    Content.prototype.render = function () {
        var _this = this;
        var _a = this.props, reply = _a.reply, isSingleReply = _a.isSingleReply;
        var length = reply.replyList.slice().length;
        var list = reply.replyList;
        if (isSingleReply && isSingleReply == 1) {
            if (reply.showReply) { //开启了回复评论
                if (reply.replyposition && reply.replyposition == 2) {
                    list = list.reverse();
                }
            }
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-content", id: "cube-reply-content", style: { minHeight: 450 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-list-wrap" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTab"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTab@d7gz8a", selectedKey: reply.selectedKey, datas: reply.tabDatas, keyParam: 'key', onChange: reply.changeTab, buttons: this.getTabButtons() }),
                list.slice().map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__reply_item__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ReplyItem@swzaxm@" + index, item: item, edit: reply.edit, delete: reply.delete, like: reply.like, unlike: reply.unlike, reference: reply.reference, about: reply.about, isLast: length == index })); }),
                length == 0 ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-list-placeholder" }, getLabel(83553, '暂无数据'))
                    : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Pagination"], { ecId: (this && this.props && this.props.ecId || '') + "_Pagination@2wg8ze", current: reply.current, pageSize: reply.pagesize, total: reply.total, defaultPageSize: reply.pagesize, showSizeChanger: true, showQuickJumper: true, showTotal: this.getTotal, onChange: reply.onPageChange, pageSizeOptions: this.pageSizeOptions, onShowSizeChange: reply.onPageChange }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__reply_add__["a" /* ReplyAddDialog */], { ecId: (this && this.props && this.props.ecId || '') + "_ReplyAddDialog@xl6iqk", replyAdd: reply.replyAdd, params: reply.params, editorId: "cubeReplyAdd", iconInfo: reply.iconInfo }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__reply_add__["b" /* ReplyAddPopup */], { ecId: (this && this.props && this.props.ecId || '') + "_ReplyAddPopup@kxggmw", replyAdd: reply.replyAdd, params: reply.params, editorId: "cubeReplypPop", iconInfo: reply.iconInfo }))));
    };
    Content = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Content);
    return Content;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Content);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popover_search_panel__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_panel__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleSerach = function () {
            var reply = _this.props.reply;
            if (reply.showSearchDrop) {
                reply.hideSearch();
            }
            else {
                reply.showSearch();
            }
        };
        return _this;
    }
    SearchInput.prototype.render = function () {
        var _a;
        var reply = this.props.reply;
        var ClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("cube-search-input-btn", (_a = {}, _a["cube-search-input-active"] = reply.showSearchDrop, _a));
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-search-input-wrap", style: { width: 200 }, ref: "_container" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaInput"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@odc099", value: reply.searchContent, onChange: function (v) { return reply.searchContent = v; } }, { onKeyPress: reply.quickSearch })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@z5sgdt", className: ClassNames, onClick: this.toggleSerach, type: "ghost", shape: "circle-outline" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__popover_search_panel__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_PopoverSearchPanel@n671ra", visible: reply.showSearchDrop, content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__search_panel__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_SearchPanel@nnx89t", reply: reply }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: (reply.showSearchDrop ? 'icon-coms-up' : 'icon-coms-down') + " cube-search-toggle", style: { color: '#b2b2b2' } })))));
    };
    SearchInput = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], SearchInput);
    return SearchInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (SearchInput);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Quotes */
/* unused harmony export Comments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var Quotes = /** @class */ (function (_super) {
    __extends(Quotes, _super);
    function Quotes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Quotes.prototype.render = function () {
        var _a = this.props, replycontent = _a.replycontent, floornum = _a.floornum, replydate = _a.replydate, replytime = _a.replytime, replyorname = _a.replyorname, rdocument = _a.rdocument, rworkflow = _a.rworkflow, rcustomer = _a.rcustomer, rproject = _a.rproject, showType = _a.showType;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-right-quotes" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' }, showType && showType == '2' ?
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    getLabel(19422, '引用') + ' #' + floornum,
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel('131681', "发表于") + ":" + (replydate + " " + replytime) }, replyorname))
                :
                    " " + (getLabel(19422, '引用') + ' #' + floornum) + " " + replyorname + " " + replydate + " " + replytime),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-remark-html', dangerouslySetInnerHTML: { __html: replycontent } }),
            rdocument &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                    getLabel(857, '相关文档') + ':',
                    "\t",
                    rdocument),
            rworkflow &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                    getLabel(1044, '相关流程') + ": ",
                    "\t",
                    rworkflow),
            rcustomer &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                    getLabel(783, '相关客户') + ": ",
                    "\t",
                    rcustomer),
            rproject &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                    getLabel(782, '相关项目') + ": ",
                    "\t$",
                    rproject)));
    };
    Quotes = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Quotes);
    return Quotes;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var Comments = /** @class */ (function (_super) {
    __extends(Comments, _super);
    function Comments() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Comments.prototype.render = function () {
        var _a = this.props, replycontent = _a.replycontent, replydate = _a.replydate, replytime = _a.replytime, rdocument = _a.rdocument, rworkflow = _a.rworkflow, rcustomer = _a.rcustomer, rproject = _a.rproject, replyor = _a.replyor, replyorname = _a.replyorname;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-right-comments" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { style: { paddingRight: 10, color: '#929393' }, href: "javaScript:openhrm(" + replyor + ")", onClick: function (event) { return __WEBPACK_IMPORTED_MODULE_2__util__["default"].pointerXY(event); } }, replyorname),
                " ", replydate + " " + replytime),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-remark-html', dangerouslySetInnerHTML: { __html: replycontent } }),
            rdocument &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                    getLabel(857, '相关文档') + ':',
                    "\t",
                    rdocument),
            rworkflow &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                    getLabel(1044, '相关流程') + ": ",
                    "\t",
                    rworkflow),
            rcustomer &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                    getLabel(783, '相关客户') + ": ",
                    "\t",
                    rcustomer),
            rproject &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'content-right-other-html' },
                    getLabel(782, '相关项目') + ": ",
                    "\t$",
                    rproject)));
    };
    Comments = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Comments);
    return Comments;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var ReplyItemDetail = /** @class */ (function (_super) {
    __extends(ReplyItemDetail, _super);
    function ReplyItemDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReplyItemDetail.prototype.render = function () {
        var _this = this;
        if (this.props.quotes) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Quotes, __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Quotes@b2fxv6" }, this.props.quotes, { showType: this.props.showType ? this.props.showType : '1' })));
        }
        if (this.props.comments) {
            return (this.props.comments.map(function (d) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Comments, __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Comments@u8fs1n" }, d))); }));
        }
        return (null);
    };
    ReplyItemDetail = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ReplyItemDetail);
    return ReplyItemDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ReplyItemDetail);


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_trim__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEqual__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_contentPath__ = __webpack_require__(9);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
/**
 * @功能
 */
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main(props) {
        var _this = _super.call(this, props) || this;
        _this.setAtInfo = function (k, v) {
            var _a = _this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b;
            replyAdd.setAtInfo(k, v, params);
        };
        _this.getAtListCom = function () {
            var _a = _this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b;
            var key = "cube_at_" + params.modeId + "_" + params.billid;
            var data = replyAdd.atInfo[key + "_data"];
            var time = _this.state.time;
            if (data && data._atitems && data._atitems.length > 0) {
                var _c = data._atitems, _atitems = _c === void 0 ? [] : _c;
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaNewScroll"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaNewScroll@dmh5ec", height: 125 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", { key: time }, _atitems.map(function (item, index) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Checkbox"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Checkbox@oasvwk@" + index, onClick: _this.selectedAtUser.bind(_this, item) },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { onClick: _this.addOneAtToCkeditor.bind(_this, item), style: { cursor: 'pointer' } }, item.data)));
                    })));
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: 'wfat-no-data' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "wfat-no-data-icon icon-coms-blank" }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "wfat-no-data-tip" }, getLabel(83553, '暂无数据')));
            }
        };
        _this.addFocus = function () {
            var dom = document.getElementById(_this.state.inputId);
            if (dom) {
                dom.focus();
            }
        };
        _this.refreshTime = function () {
            _this.setState({ time: new Date().getTime() });
        };
        _this.state = {
            time: "",
            inputId: "wfat-input-text-" + new Date().getTime()
        };
        return _this;
    }
    Main.prototype.getAtInfo = function () {
        var _a = this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b;
        return replyAdd.getAtInfo(params);
    };
    Main.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.visible) {
            var atInfo = this.getAtInfo();
            var _a = atInfo.data, data = _a === void 0 ? {} : _a;
            var _b = data.atitems, atitems = _b === void 0 ? [] : _b;
            this.setAtInfo("data", __assign({}, data, { selectUser: [], _atitems: atitems.slice(0, 100) }));
        }
    };
    Main.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var atInfo = this.getAtInfo();
        var _a = atInfo.data, data = _a === void 0 ? {} : _a;
        var _b = data.q, q = _b === void 0 ? '' : _b, _c = data.selectUser, selectUser = _c === void 0 ? [] : _c, _d = data._atitems, _atitems = _d === void 0 ? [] : _d, _e = data.atitems, atitems = _e === void 0 ? [] : _e;
        if (!nextState) {
            nextState = {};
        }
        return !__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default()(atitems, nextState.atitems) ||
            !__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default()(_atitems, nextState._atitems) ||
            !__WEBPACK_IMPORTED_MODULE_5_lodash_isEqual___default()(selectUser, nextState.selectUser) ||
            q !== nextState.q ||
            this.props.visible !== nextState.visible;
    };
    Main.prototype.render = function () {
        var _this = this;
        var atInfo = this.getAtInfo();
        var _a = atInfo.data, data = _a === void 0 ? {} : _a;
        var _b = data.q, q = _b === void 0 ? '' : _b;
        var visible = this.props.visible;
        // const {time} = this.state;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "cube-ckeditor-wfat" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "wea-cb-item", onClick: function () { _this.props.showComponent(visible ? '' : 'CubeAt'); } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Tooltip"], { ecId: (this && this.props && this.props.ecId || '') + "_Tooltip@oxikf7", placement: "topLeft", title: getLabel(386973, "在回复评论框中输入@可直接选择具有本条数据查看权限的人") },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "wea-cbi-icon icon-coms-at" }))),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "wfat-content", style: { display: visible ? 'block' : 'none' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "triangle_border_nw" }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "wfat-input" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Input"], { ecId: (this && this.props && this.props.ecId || '') + "_Input@9kdogk", type: "text", value: q, onChange: this.doSearch.bind(this), id: this.state.inputId, onClick: this.addFocus }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "wfat-input-search icon-coms-search" })),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "wfat-list" }, this.getAtListCom()),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "wfat-footer" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@7mrll4", size: "small", onClick: this.addAtToCKEditor.bind(this), className: "ant-btn-1" }, getLabel(382958, "确定")),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@zmkjum", size: "small", onClick: this.doCancel.bind(this), className: "ant-btn-2" }, getLabel(201, "取消"))))));
    };
    Main.prototype.selectedAtUser = function (user) {
        var _a = this.getAtInfo().data, data = _a === void 0 ? {} : _a;
        var _b = data.selectUser, selectUser = _b === void 0 ? [] : _b;
        var _selectUser = selectUser.filter(function (o) { return o.uid !== user.uid; });
        if (_selectUser.length === selectUser.length) {
            _selectUser.push(user);
        }
        this.setAtInfo("data", __assign({}, data, { selectUser: _selectUser }));
    };
    Main.prototype.addAtToCKEditor = function (_) {
        var _a = this.getAtInfo().data, data = _a === void 0 ? {} : _a;
        var _b = data.selectUser, selectUser = _b === void 0 ? [] : _b;
        if (selectUser.length === 0) {
            __WEBPACK_IMPORTED_MODULE_2_antd__["message"].warning(getLabel(383750, '请至少选择一个!'), 5);
        }
        else {
            var atHtmlArr_1 = [];
            selectUser.map(function (o) {
                atHtmlArr_1.push("<a href=\"" + Object(__WEBPACK_IMPORTED_MODULE_6__util_contentPath__["a" /* getContentPath */])('/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/' + o.uid) + "\" atsome=\"@" + o.uid + "\" contenteditable='false' style=\"cursor:pointer;text-decoration:none !important;margin-right:8px;color:#2777c1!important\" target=\"_blank\">@" + o.data + "&nbsp;</a>");
            });
            this.props.appendHtmlToCKEditor && this.props.appendHtmlToCKEditor(this.appendStyle(atHtmlArr_1.join('')));
            this.setAtInfo('data', __assign({}, data, { selectUser: [], q: '' }));
            this.refreshTime();
            this.props.showComponent('');
        }
    };
    Main.prototype.addOneAtToCkeditor = function (user, e) {
        this.props.appendHtmlToCKEditor && this.props.appendHtmlToCKEditor(this.appendStyle("<a href=\"" + Object(__WEBPACK_IMPORTED_MODULE_6__util_contentPath__["a" /* getContentPath */])('/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/' + user.uid) + "\" atsome=\"@" + user.uid + "\" contenteditable=\"false\" style=\"cursor:pointer;text-decoration:none !important;margin-right:8px;color:#2777c1!important\" target=\"_blank\">@" + user.data + "</a>"));
        var atInfo = this.getAtInfo();
        var _a = atInfo.data, data = _a === void 0 ? {} : _a;
        this.setAtInfo('data', __assign({}, data, { selectUser: [], q: '' }));
        this.props.showComponent('');
        e.stopPropagation();
    };
    Main.prototype.appendStyle = function (info) {
        var _a = this.props, _b = _a.editorId, editorId = _b === void 0 ? "" : _b, windowTop = _a.windowTop;
        var _wrapped_contents = info;
        var windowNew = windowTop ? windowTop : __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].WindowFunc.getTop();
        if (windowNew.CK_REF[editorId]) {
            var instances = windowNew.CK_REF[editorId].getEditor().ui.instances;
            if (instances) {
                var font = instances.Font['_'].value || 'Microsoft YaHei';
                var fontsize = instances.FontSize['_'].value || 12;
                _wrapped_contents = "<span style=\"font-family:'" + font + "';font-size:" + fontsize + "px\" >" + info + "&nbsp;&#8203;</span>";
            }
        }
        return _wrapped_contents;
    };
    Main.prototype.doCancel = function () {
        var atInfo = this.getAtInfo();
        var _a = atInfo.data, data = _a === void 0 ? {} : _a;
        this.setAtInfo("data", __assign({}, data, { q: '', selectUser: [] }));
        this.refreshTime();
        this.props.showComponent('');
    };
    Main.prototype.arrayContains = function (selectUser, user) {
        return selectUser.filter(function (o) { return o.uid === user.uid; }).length > 0;
    };
    Main.prototype.doSearch = function (e) {
        var atInfo = this.getAtInfo();
        var _a = atInfo.data, data = _a === void 0 ? {} : _a;
        var _b = data.atitems, atitems = _b === void 0 ? [] : _b;
        var q = e.target.value;
        var r = [];
        if (__WEBPACK_IMPORTED_MODULE_4_lodash_trim___default()(q).length === 0) {
            r = r.concat(atitems);
        }
        else {
            r = atitems.filter(function (o) {
                return o.data.indexOf(q) >= 0 || (__WEBPACK_IMPORTED_MODULE_4_lodash_trim___default()(o.datapy).length > 0 && o.datapy.indexOf(q.toUpperCase()) >= 0);
            });
        }
        this.setAtInfo("data", __assign({}, data, { _atitems: r.slice(0, 100), q: q }));
        this.refreshTime();
    };
    return Main;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Main);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var ReplySingleBase = /** @class */ (function (_super) {
    __extends(ReplySingleBase, _super);
    function ReplySingleBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReplySingleBase.prototype.render = function () {
        var reply = this.props.reply;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@llhx10", spinning: reply.loading, tip: getLabel(31230, "加载中") + "..." },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply" }, reply && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__content__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Content@v3528f", isSingleReply: 1 }, this.props)))));
    };
    ReplySingleBase = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ReplySingleBase);
    return ReplySingleBase;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ReplySingleBase);


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logDetail__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MainFieldLog__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DetailFieldLog__ = __webpack_require__(1079);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var CheckboxGroup = __WEBPACK_IMPORTED_MODULE_3_antd__["Checkbox"].Group;




var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var LogList = /** @class */ (function (_super) {
    __extends(LogList, _super);
    function LogList(props) {
        var _this = _super.call(this, props) || this;
        _this.onRightMenuClick = function (key) {
            var cubeLogList = _this.props.cubeLogList;
            if (key == "0") {
                cubeLogList.doSearch();
            }
            else if (key == '1') {
                window.close();
            }
        };
        _this.search = function () {
            var cubeLogList = _this.props.cubeLogList;
            cubeLogList.table.current = 1;
            cubeLogList.doSearch();
            cubeLogList.setShowSearchAd(false);
        };
        _this.getComp = function () {
            var cubeLogList = _this.props.cubeLogList;
            var showSearchAd = cubeLogList.showSearchAd, tableData = cubeLogList.tableData, table = cubeLogList.table, iconInfo = cubeLogList.iconInfo;
            var searchButtons = [
                (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@f5l7o3@search", type: "primary", onClick: _this.search }, getLabel(197, "搜索"))),
                (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@cg22qj@clearFormFields", type: "ghost", onClick: function () { return cubeLogList.clearFormFields(); } }, getLabel(2022, "重置"))),
                (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@tdwiy1@setShowSearchAd", type: "ghost", onClick: function () { return cubeLogList.setShowSearchAd(false); } }, getLabel(201, "取消")))
            ];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTab"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTab@73bdqx", buttonsAd: searchButtons, searchType: ['advanced'], setShowSearchAd: function (bool) { cubeLogList.setShowSearchAd(bool); }, hideSearchAd: function () { return cubeLogList.setShowSearchAd(false); }, searchsAd: showSearchAd ? _this.getFormTems() : '', advanceHeight: 'auto', showSearchAd: showSearchAd }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Table"], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Table@2mj9kl", columns: _this.getColumns(), className: "cube-log-list-table", pagination: {
                        current: table.current,
                        pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
                        total: tableData.total,
                        defaultPageSize: table.pagesize,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: function (total) {
                            return " " + (getLabel(18609, "共") + total + ' ' + getLabel(18256, "条")) + " ";
                        },
                        onShowSizeChange: function (current, pageSize) { cubeLogList.changePageSize(current, pageSize); }
                    }, onChange: cubeLogList.nextDatas, dataSource: Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(tableData.logData) }, _this.getScrollConfig())),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__logDetail__["a" /* LogDetailDialog */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_LogDetailDialog@uuw67z", LogListStore: cubeLogList }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MainFieldLog__["a" /* MainFieldLogDialog */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_MainFieldLogDialog@ug9o26", cubeLogList: cubeLogList }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DetailFieldLog__["a" /* DetailFieldLogDialog */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_DetailFieldLogDialog@qu58l8", cubeLogList: cubeLogList }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDialog@xet5ag", onCancel: _this.closeDelDialog, title: getLabel('522702', '数据详情'), visible: cubeLogList.delLog_visible, iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", style: { width: 500, height: 300 }, buttons: _this.getButtons(), hasScroll: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { style: { margin: '15px 0px 15px 20px' } }, getLabel('522703', '数据详情为') + "："),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("pre", { style: { marginLeft: 20, overflow: 'scroll' }, id: "jsonPre", dangerouslySetInnerHTML: { __html: _this.formatJson(_this.state.deldata) } })));
        };
        _this.getBeautifulJson = function () {
            var str = _this.state.deldata;
            return _this.formatJson(str);
        };
        _this.closeDelDialog = function () {
            var cubeLogList = _this.props.cubeLogList;
            cubeLogList.delLog_visible = false;
        };
        _this.recoverData = function () {
            var cubeLogList = _this.props.cubeLogList;
            cubeLogList.recoverData();
        };
        _this.getButtons = function () {
            var cubeLogList = _this.props.cubeLogList;
            var currentType = cubeLogList.currentType;
            var buttons = new Array();
            buttons.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@lypgym@closeDelDialog", type: "primary", onClick: _this.closeDelDialog }, getLabel(309, '关闭')));
            if (currentType == '3') {
                buttons.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@uamlbx", type: "primary", onClick: _this.recoverData }, getLabel('522756', '数据恢复')));
            }
            return buttons;
        };
        _this.getColumns = function () {
            var cubeLogList = _this.props.cubeLogList;
            var operateButton = cubeLogList.operateButton, isBackLog = cubeLogList.isBackLog;
            var detailLog = operateButton && operateButton.length;
            var dropdownShow = "";
            if (detailLog == 0 || detailLog == undefined) {
                dropdownShow = "none";
            }
            var width = ["20%", "15%", "15%", "18%", "20%", "10%"];
            if (isBackLog) {
                width = ["15%", "15%", "15%", "15%", "15%", "10%"];
            }
            var columns = [
                { title: getLabel(99, "操作者"), dataIndex: 'operator', key: 'operator', width: width[0] },
                { title: getLabel(97, "日期"), dataIndex: 'operatedate', key: 'operatedate', width: width[1] },
                { title: getLabel(277, "时间"), dataIndex: 'operatetime', key: 'operatetime', width: width[2] },
                { title: getLabel(63, "类型"), dataIndex: 'operatedesc', key: 'operatedesc', width: width[3] },
                { title: 'IP', dataIndex: 'clientaddress', key: 'clientaddress', width: "20%" },
                { title: '', width: width[4], dataIndex: 'id', render: function (id, record) {
                        if (record.operatetype == '3' || record.operatetype == '6') { //删除
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: 'javascript:void(0)', onClick: function () { return _this.showDeleteInfo(record.deldata, id, record.operatetype); } }, getLabel('22045', '详情'));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Dropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Dropdown@jw2vo3", overlay: _this.getMenu(id, record) },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "ant-dropdown-link", style: { display: dropdownShow } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-coms-more" })));
                        }
                    }
                }
            ];
            if (isBackLog) {
                columns.unshift({ title: getLabel(81287, '数据ID'), dataIndex: 'relatedid', key: 'relatedid', width: "10%" });
            }
            return columns;
        };
        _this.showDeleteInfo = function (deldata, logid, operatetype) {
            var cubeLogList = _this.props.cubeLogList;
            _this.setState({ deldata: deldata });
            cubeLogList.delLog_visible = true;
            cubeLogList.logid = logid;
            cubeLogList.currentType = operatetype;
        };
        _this.getMenu = function (id, record) {
            var cubeLogList = _this.props.cubeLogList;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@de2zof" }, record.orderList.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@frtbx1@" + index },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { onClick: function () {
                            if (item['key'] == '') {
                                cubeLogList.showMainFieldLog(id, record.relatedid);
                            }
                            else {
                                cubeLogList.showDetailFieldLog(id, item['key'], record.relatedid);
                            }
                        } }, item['showname']));
            }));
        };
        _this.getFormTems = function () {
            var cubeLogList = _this.props.cubeLogList;
            var condition = cubeLogList.condition, form = cubeLogList.form, checkValues = cubeLogList.checkValues;
            var isFormInit = form.isFormInit;
            var group = [];
            isFormInit && Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(condition).map(function (c, i) {
                var items = [];
                c.items.map(function (fields, idn) {
                    var dom;
                    if (fields.domkey[0] == "handletype") {
                        dom = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckboxGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_CheckboxGroup@4nnav6@handletype", options: fields.options, value: cubeLogList.objToArr(Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(checkValues)), onChange: cubeLogList.onCheckGroupChange }));
                    }
                    else {
                        dom = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_comsMobx__["WeaSwitch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSwitch@bybtfc@" + fields.domkey[0], fieldConfig: fields, form: form });
                    }
                    items.push({
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@r7jvdp@" + idn, label: "" + fields.label, labelCol: { span: "" + fields.labelcol }, wrapperCol: { span: "" + fields.fieldcol } }, dom)),
                        colSpan: 1,
                    });
                });
                group.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSearchGroup"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSearchGroup@t6h1z9@" + i, needTigger: true, title: c.title, showGroup: c.defaultshow, items: items, onVisibleChange: _this.recalculateMask }));
            });
            return group;
        };
        /** 重新计算蒙层的高度 */
        _this.recalculateMask = function () {
            var dom = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(".coms-mode-logList .wea-tab-search-ad .wea-search-container")[0];
            var maskDarkHeight = window.innerHeight - dom.offsetTop - 110;
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()(".coms-mode-logList .wea-tab-search-ad .mask-dark").height(maskDarkHeight);
        };
        _this.state = {
            height: 0,
            deldata: ''
        };
        return _this;
    }
    LogList.prototype.componentDidMount = function () {
        var _this = this;
        this.scrollheigth(35);
        __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).resize(function () {
            _this.scrollheigth();
        });
    };
    LogList.prototype.render = function () {
        var cubeLogList = this.props.cubeLogList;
        var title = cubeLogList.title, loading = cubeLogList.loading, baseParams = cubeLogList.baseParams, iconInfo = cubeLogList.iconInfo;
        if (title != '') {
            document.title = title;
        }
        var rightMenus = [{
                icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-search' }),
                content: getLabel(197, "搜索"),
                key: 0
            }, {
                icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-go-back' }),
                content: getLabel(309, "关闭"),
                key: 1
            }];
        if (baseParams.hidetop && baseParams.hidetop == "1") {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-log-list" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@bkzt6n", datas: rightMenus, onClick: this.onRightMenuClick, collectParams: {
                        "favname": "",
                        "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                        "favouritetype": 5,
                        "importantlevel": 1
                    } }, this.getComp())));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-log-list" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@g5utpf", datas: rightMenus, onClick: this.onRightMenuClick, collectParams: {
                    "favname": title,
                    "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                    "favouritetype": 5,
                    "importantlevel": 1
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTop"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTop@svl8zf", title: title, loading: loading, icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: iconInfo.icon, style: { color: iconInfo.iconColor } }), iconBgcolor: iconInfo.iconBg, buttonSpace: 10, showDropIcon: true, dropMenuDatas: rightMenus, onDropMenuClick: this.onRightMenuClick }, this.getComp()))));
    };
    LogList.prototype.getScrollConfig = function () {
        var scroll = {}, height = this.state.height;
        scroll.scroll = {};
        scroll.scroll.y = height;
        return scroll;
    };
    LogList.prototype.scrollheigth = function (h) {
        if (h === void 0) { h = 0; }
        var widowClientHeight = document.documentElement.clientHeight || 0;
        var titileHeight = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(".ant-table-header .ant-table-thead").height() || 45;
        var bottom = (__WEBPACK_IMPORTED_MODULE_6_jquery___default()(".ant-pagination.ant-table-pagination").height() || 30) + 15;
        var scrollheigth = widowClientHeight - titileHeight - bottom - 98;
        this.setState({
            height: scrollheigth - 15 - h
        });
    };
    LogList.prototype.formatJson = function (str) {
        if (str == '') {
            return str;
        }
        // 设置缩进为2个空格
        str = JSON.stringify(JSON.parse(str), null, 4);
        str = str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        return str.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'color: darkorange';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'color: red';
                }
                else {
                    cls = 'color: green';
                }
            }
            else if (/true|false/.test(match)) {
                cls = 'color: blue';
            }
            else if (/null/.test(match)) {
                cls = 'color: magenta';
            }
            return '<span style="' + cls + '">' + match + '</span>';
        });
    };
    LogList = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])("cubeLogList"),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], LogList);
    return LogList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (LogList);


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reply__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getParent = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"].WindowFunc.getParent;
var Reply = /** @class */ (function (_super) {
    __extends(Reply, _super);
    function Reply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setIframeHeight = function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#tabcontentframe', getParent()).height(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube-reply').height()).parent().height(__WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube-reply').height());
        };
        return _this;
    }
    Reply.prototype.componentWillMount = function () {
        var reply = this.props.reply;
        reply.initReply();
    };
    Reply.prototype.componentDidMount = function () {
        this.setIframeHeight();
    };
    Reply.prototype.componentDidUpdate = function () {
        this.setIframeHeight();
    };
    Reply.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: '100%', overflowY: 'auto' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { paddingTop: 25, background: '#f1f1f1' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__reply__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_ReplyBase@tt1nol" }, this.props)))));
    };
    Reply = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])("reply"),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Reply);
    return Reply;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (Reply);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(419);
var isArguments = __webpack_require__(1087);
var is = __webpack_require__(1091);
var isRegex = __webpack_require__(1093);
var flags = __webpack_require__(1094);
var isDate = __webpack_require__(1096);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(420);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1086);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(422);

var callBind = __webpack_require__(237);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1088)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(236);
var hasOwn = __webpack_require__(1090);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(424);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(426);

var supportsDescriptors = __webpack_require__(108).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1101), __esModule: true };

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1139), __esModule: true };

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(49);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(43);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouter=__webpack_require__(162);var _stores=__webpack_require__(238);var _stores2=_interopRequireDefault(_stores);var _util=__webpack_require__(7);var _util2=_interopRequireDefault(_util);var _cubeUtil=__webpack_require__(48);var _cubeUtil2=_interopRequireDefault(_cubeUtil);var _excelUtil=__webpack_require__(26);var ModeForm=_interopRequireWildcard(_excelUtil);var _searchUtil=__webpack_require__(120);var ModeList=_interopRequireWildcard(_searchUtil);__webpack_require__(776);var _index=__webpack_require__(146);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(1167);var _index4=_interopRequireDefault(_index3);var _ecCom=__webpack_require__(1);var _ShareStore=__webpack_require__(164);var _ShareStore2=_interopRequireDefault(_ShareStore);var _batchShare=__webpack_require__(358);var ShareCom=_interopRequireWildcard(_batchShare);var _excelLayout=__webpack_require__(234);var _excelLayout2=_interopRequireDefault(_excelLayout);var _reply=__webpack_require__(417);var _reply2=_interopRequireDefault(_reply);var _card=__webpack_require__(93);var _card2=_interopRequireDefault(_card);var _list=__webpack_require__(33);var _list2=_interopRequireDefault(_list);var _Single=__webpack_require__(218);var _card3=__webpack_require__(160);var _DetailImport=__webpack_require__(409);var _cubeMap=__webpack_require__(235);var _CustomDialog=__webpack_require__(230);var _CustomDialog2=_interopRequireDefault(_CustomDialog);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLocaleLabel=_ecCom.WeaLocaleProvider.getLocaleLabel.bind(undefined,'cube');_util2.default.cubeStore=_stores2.default;_util2.default.CubeUtil=_cubeUtil2.default;_util2.default.ModeForm=ModeForm.modeForm;_util2.default.modeForm=ModeForm.modeForm;_util2.default.ModeList=ModeList.modeList;module.exports={Route:_react2.default.createElement(_reactRouter.Route,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@9uoqia',path:'cube'},_react2.default.createElement(_reactRouter.Route,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@9uoqib',path:'dev',onEnter:getLocaleLabel},_react2.default.createElement(_reactRouter.Route,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@9uoqic',path:':guid',component:_index4.default})),_react2.default.createElement(_reactRouter.Route,{ecId:(undefined&&undefined.props&&undefined.props.ecId||'')+'_Route@9uoqid',path:':guid',onEnter:getLocaleLabel,component:_index2.default})),store:_stores2.default,common:{ShareStore:_ShareStore2.default,CardStore:_card2.default,SearchStore:_list2.default,ShareCom:ShareCom,ReplyCom:_reply2.default,ExcelLayoutCom:_excelLayout2.default,//InnerTabCard,
DetailImportDialog:_DetailImport.DetailImportDialog,SingleShareDialog:_Single.SingleShareDialog,MapAddressDialog:_cubeMap.MapAddressDialog,CustomDialog:_CustomDialog2.default}};

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var TopStore = /** @class */ (function () {
    function TopStore() {
        var _this = this;
        this.icon = 'icon-coms-ModelingEngine';
        this.name = '';
        this.total = 0;
        this.iconBgcolor = "#96358a";
        this.extra = '';
        this.tabs = [];
        this.groupCount = {};
        this.selectedKey = "all";
        this.isInit = false;
        this.title = '';
        this.iconColor = '';
        this.hasTabKeyNamedEmpty = true;
        this.update = function (param) {
            for (var key in param) {
                if (key == 'tabs') {
                    _this.tabs = param[key].map(function (t) { return (__assign({}, t, { showcount: true })); });
                }
                else {
                    _this[key] = param[key];
                }
            }
        };
        this.onHandleEmptyTab = function (emptyGroupCount) {
            if (!_this.hasTabKeyNamedEmpty && emptyGroupCount) {
                _this.tabs.push({ key: 'empty', title: getLabel('81307', '未分组'), showcount: true });
                _this.hasTabKeyNamedEmpty = true;
            }
            else {
                if (emptyGroupCount == undefined || emptyGroupCount == 0) {
                    var that_1 = _this;
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this.tabs, function (tab) {
                        if (tab['key'] == 'empty') {
                            that_1.hasTabKeyNamedEmpty = false;
                            return true;
                        }
                    });
                }
            }
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "icon", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "name", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "total", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "iconBgcolor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "extra", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "tabs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "groupCount", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "selectedKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "isInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "title", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "iconColor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TopStore.prototype, "hasTabKeyNamedEmpty", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TopStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TopStore.prototype, "onHandleEmptyTab", void 0);
    return TopStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (TopStore);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comsMobx__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var AdvancedStore = /** @class */ (function () {
    function AdvancedStore() {
        var _this = this;
        this.visible = true;
        this.form = new __WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaForm"]();
        this.templates = [];
        this.isInit = false;
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
        this.updateField = function (dataSource) {
            if (!_this.form.isFormInit) {
                setTimeout(function () {
                    _this.updateField(dataSource);
                }, 200);
                return;
            }
            var otherData = {};
            for (var field in dataSource) {
                if (_this.form.has(field)) {
                    if (Array.isArray(dataSource[field])) {
                        var _field = _this.form.select(field);
                        _field.set(dataSource[field]);
                    }
                    else {
                        otherData[field] = dataSource[field];
                    }
                }
            }
            _this.form.updateFields(otherData, false);
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], AdvancedStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], AdvancedStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], AdvancedStore.prototype, "templates", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], AdvancedStore.prototype, "isInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], AdvancedStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], AdvancedStore.prototype, "updateField", void 0);
    return AdvancedStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (AdvancedStore);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;
var TemplateStore = /** @class */ (function () {
    function TemplateStore() {
        var _this = this;
        this.form = new __WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaForm"]();
        this.visible = false;
        this.loading = false;
        this.fields = [];
        this.errors = {
            templatename: '',
            templatetype: '',
            fieldorder: ''
        };
        this.onCancel = function () {
            _this.form.resetConditionValue();
            _this.visible = false;
        };
        this.onOk = function (Search) {
            _this.loading = true;
            _this.form.validateForm().then(function (f) {
                if (f.isValid) {
                    var formparams = _this.form.getFormParams();
                    var templatename = formparams.templatename;
                    var len = 0;
                    for (var i = 0; i < templatename.length; i++) {
                        if (templatename.charCodeAt(i) > 127 || templatename.charCodeAt(i) == 94) {
                            len += 2;
                        }
                        else {
                            len++;
                        }
                    }
                    if (len > 100) {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(getLabel(532540, "模板名称超出字符数限制（100），无法保存。"));
                        _this.loading = false;
                    }
                    else {
                        _this.saveTemplate(Search, function (_a) {
                            var templates = _a.templates;
                            if (Search.type == 'advanced') {
                                Search.advanced.templates = templates;
                            }
                            else {
                                Search.condition.templates = templates;
                            }
                            _this.onCancel();
                            _this.loading = false;
                        }, 'add', _this.form.values());
                    }
                }
                else {
                    f.showErrors();
                    _this.loading = false;
                    // message.error(getLabel(383975, '必要信息不完整，红色标记为必填项！'));
                }
            });
        };
        this.saveTemplate = function (Search, callback, action, others) {
            if (action === void 0) { action = 'save'; }
            if (others === void 0) { others = {}; }
            var getValues = function (conditionInfo, values) {
                var vi = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(values);
                var ci = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(conditionInfo[0].items);
                var rs = ci.map(function (c) { return "" + c.domkey; });
                var vs = rs.map(function (c) { return "" + vi[c]; });
                return JSON.stringify({ rs: rs, vs: vs });
            };
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].saveTemplate(__assign({ action: action, customid: Search.customId, templateid: Search.templateid, sourcetype: Search.type == 'advanced' ? '1' : '2' }, others, { type: Search.type == 'advanced' ? '1' : ['1', '2'], values: getValues(Search.type == 'advanced' ? Search.advancedInfo : Search.conditionInfo, Search.type == 'advanced' ? Search.advanced.form.values() : Search.condition.form.values()) })).then(function (_a) {
                var status = _a.status, error = _a.error, props = __rest(_a, ["status", "error"]);
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].success(getLabel(18758, "保存成功。"));
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
                callback && callback(props);
            });
        };
        this.clearError = function (domkey) {
            _this.errors[domkey] = '';
        };
        this.saveAsTemplate = function () {
            _this.fields = [{
                    colSapn: 2,
                    conditionType: 'INPUT',
                    domkey: ['templatename'],
                    fieldcol: 14,
                    labelcol: 6,
                    label: getLabel(18151, '模板名称'),
                    viewAttr: 3,
                    'rules': 'required|string',
                }, {
                    colSapn: 2,
                    conditionType: 'SELECT',
                    domkey: ['templatetype'],
                    fieldcol: 14,
                    labelcol: 6,
                    label: getLabel(19471, '模板类型'),
                    viewAttr: 3,
                    options: [{ key: '0', showname: getLabel(83139, '私人模板'), selected: true }]
                }, {
                    colSapn: 2,
                    conditionType: 'INPUTNUMBER',
                    domkey: ['fieldorder'],
                    fieldcol: 14,
                    labelcol: 6,
                    label: getLabel(88, '顺序'),
                    viewAttr: 2,
                    precision: 2
                }, {
                    colSapn: 2,
                    conditionType: 'CHECKBOX',
                    domkey: ['isdefault'],
                    fieldcol: 14,
                    labelcol: 6,
                    label: getLabel(33731, '是否默认', 'label'),
                    viewAttr: 2,
                }];
            if (_this.form.isFormInit) {
                _this.form.resetConditionValue();
            }
            else {
                _this.form.initFormFieldObj(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.fields));
            }
            _this.visible = true;
        };
        this.managerTemplate = function (Search) {
            //window.open(`/formmode/template/TemplateManage.jsp?customid=${Search.customId}&sourcetype=${Search.type == 'advanced' ? '1' : '2'}`);
            window.open(Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/templateManage?customid=" + Search.customId + "&sourcetype=" + (Search.type == 'advanced' ? '1' : '2')));
        };
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateStore.prototype, "fields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateStore.prototype, "errors", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateStore.prototype, "onCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateStore.prototype, "onOk", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateStore.prototype, "saveTemplate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateStore.prototype, "clearError", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateStore.prototype, "saveAsTemplate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateStore.prototype, "update", void 0);
    return TemplateStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (TemplateStore);


/***/ }),
/* 437 */
/***/ (function(module, exports) {

function leapYear(year) {
  return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
}

function isValidDate(inDate) {
    var valid = true;

    // reformat if supplied as mm.dd.yyyy (period delimiter)
    if (typeof inDate === 'string') {
      var pos = inDate.indexOf('.');
      if ((pos > 0 && pos <= 6)) {
        inDate = inDate.replace(/\./g, '-');
      }
    }

    var testDate = new Date(inDate);
    var yr = testDate.getFullYear();
    var mo = testDate.getMonth();
    var day = testDate.getDate();

    var daysInMonth = [31, (leapYear(yr) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (yr < 1000) { return false; }
    if (isNaN(mo)) { return false; }
    if (mo + 1 > 12) { return false; }
    if (isNaN(day)) { return false; }
    if (day > daysInMonth[mo]) { return false; }

    return valid;
}

var rules = {

  required: function(val) {
    var str;

    if (val === undefined || val === null) {
      return false;
    }

    str = String(val).replace(/\s/g, "");
    return str.length > 0 ? true : false;
  },

  required_if: function(val, req, attribute) {
    req = this.getParameters();
    if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_unless: function(val, req, attribute) {
    req = this.getParameters();
    if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_with: function(val, req, attribute) {
    if (this.validator._objectPath(this.validator.input, req)) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_with_all: function(val, req, attribute) {

    req = this.getParameters();

    for(var i = 0; i < req.length; i++) {
      if (!this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }

    return this.validator.getRule('required').validate(val);
  },

  required_without: function(val, req, attribute) {

    if (this.validator._objectPath(this.validator.input, req)) {
      return true;
    }

    return this.validator.getRule('required').validate(val);
  },

  required_without_all: function(val, req, attribute) {

    req = this.getParameters();

    for(var i = 0; i < req.length; i++) {
      if (this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }

    return this.validator.getRule('required').validate(val);
  },

  'boolean': function (val) {
    return (
      val === true ||
      val === false ||
      val === 0 ||
      val === 1 ||
      val === '0' ||
      val === '1' ||
      val === 'true' ||
      val === 'false'
    );
  },

  // compares the size of strings
  // with numbers, compares the value
  size: function(val, req, attribute) {
    if (val) {
      req = parseFloat(req);

      var size = this.getSize();

      return size === req;
    }

    return true;
  },

  string: function(val, req, attribute) {
    return typeof val === 'string';
  },

  sometimes: function(val) {
    return true;
  },

  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  min: function(val, req, attribute) {
    var size = this.getSize();
    return size >= req;
  },

  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  max: function(val, req, attribute) {
    var size = this.getSize();
    return size <= req;
  },

  between: function(val, req, attribute) {
    req = this.getParameters();
    var size = this.getSize();
    var min = parseFloat(req[0], 10);
    var max = parseFloat(req[1], 10);
    return size >= min && size <= max;
  },

  email: function(val) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(val);
  },

  numeric: function(val) {
    var num;

    num = Number(val); // tries to convert value to a number. useful if value is coming from form element

    if (typeof num === 'number' && !isNaN(num) && typeof val !== 'boolean') {
      return true;
    } else {
      return false;
    }
  },

  array: function(val) {
    return val instanceof Array;
  },

  url: function(url) {
    return (/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i).test(url);
  },

  alpha: function(val) {
    return (/^[a-zA-Z]+$/).test(val);
  },

  alpha_dash: function(val) {
    return (/^[a-zA-Z0-9_\-]+$/).test(val);
  },

  alpha_num: function(val) {
    return (/^[a-zA-Z0-9]+$/).test(val);
  },

  same: function(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];
    var val2 = val;

    if (val1 === val2) {
      return true;
    }

    return false;
  },

  different: function(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];
    var val2 = val;

    if (val1 !== val2) {
      return true;
    }

    return false;
  },

  "in": function(val, req) {
    var list, i;

    if (val) {
      list = this.getParameters();
    }

    if (val && !(val instanceof Array)) {
      var localValue = val;

      for (i = 0; i < list.length; i++) {
        if (typeof list[i] === 'string') {
          localValue = String(val);
        }

        if (localValue === list[i]) {
          return true;
        }
      }

      return false;
    }

    if (val && val instanceof Array) {
      for (i = 0; i < val.length; i++) {
        if (list.indexOf(val[i]) < 0) {
          return false;
        }
      }
    }

    return true;
  },

  not_in: function(val, req) {
    var list = this.getParameters();
    var len = list.length;
    var returnVal = true;

    for (var i = 0; i < len; i++) {
      var localValue = val;

      if (typeof list[i] === 'string') {
        localValue = String(val);
      }

      if (localValue === list[i]) {
        returnVal = false;
        break;
      }
    }

    return returnVal;
  },

  accepted: function(val) {
    if (val === 'on' || val === 'yes' || val === 1 || val === '1' || val === true) {
      return true;
    }

    return false;
  },

  confirmed: function(val, req, key) {
    var confirmedKey = key + '_confirmation';

    if (this.validator.input[confirmedKey] === val) {
      return true;
    }

    return false;
  },

  integer: function(val) {
    return String(parseInt(val, 10)) === String(val);
  },

  digits: function(val, req) {
    var numericRule = this.validator.getRule('numeric');
    if (numericRule.validate(val) && String(val).length === parseInt(req)) {
      return true;
    }

    return false;
  },

  regex: function(val, req) {
    var mod = /[g|i|m]{1,3}$/;
    var flag = req.match(mod);
    flag = flag ? flag[0] : "";
    req = req.replace(mod, "").slice(1, -1);
    req = new RegExp(req, flag);
    return !!val.match(req);
  },

  date: function(val, format) {
    return isValidDate(val);
  },

  present: function(val) {
    return typeof val !== 'undefined';
  },

  after: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() < new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

   after_or_equal: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() <= new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

  before: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() > new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

   before_or_equal: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() >= new Date(val2).getTime()) {
      return true;
    }

    return false;
  }


};

var missedRuleValidator = function() {
  throw new Error('Validator `' + this.name + '` is not defined!');
};
var missedRuleMessage;

function Rule(name, fn, async) {
  this.name = name;
  this.fn = fn;
  this.passes = null;
  this._customMessage = undefined;
  this.async = async;
}

Rule.prototype = {

  /**
   * Validate rule
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  validate: function(inputValue, ruleValue, attribute, callback) {
    var _this = this;
    this._setValidatingData(attribute, inputValue, ruleValue);
    if (typeof callback === 'function') {
      this.callback = callback;
      var handleResponse = function(passes, message) {
        _this.response(passes, message);
      };

      if (this.async) {
        return this._apply(inputValue, ruleValue, attribute, handleResponse);
      } else {
        return handleResponse(this._apply(inputValue, ruleValue, attribute));
      }
    }
    return this._apply(inputValue, ruleValue, attribute);
  },

  /**
   * Apply validation function
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  _apply: function(inputValue, ruleValue, attribute, callback) {
    var fn = this.isMissed() ? missedRuleValidator : this.fn;

    return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
  },

  /**
   * Set validating data
   *
   * @param {string} attribute
   * @param {mixed} inputValue
   * @param {mixed} ruleValue
   * @return {void}
   */
  _setValidatingData: function(attribute, inputValue, ruleValue) {
    this.attribute = attribute;
    this.inputValue = inputValue;
    this.ruleValue = ruleValue;
  },

  /**
   * Get parameters
   *
   * @return {array}
   */
  getParameters: function() {
    var value = [];

    if (typeof this.ruleValue === 'string') {
      value = this.ruleValue.split(',');
    }

    if (typeof this.ruleValue === 'number') {
      value.push(this.ruleValue);
    }

    if (this.ruleValue instanceof Array) {
      value = this.ruleValue;
    }

    return value;
  },

  /**
   * Get true size of value
   *
   * @return {integer|float}
   */
  getSize: function() {
    var value = this.inputValue;

    if (value instanceof Array) {
      return value.length;
    }

    if (typeof value === 'number') {
      return value;
    }

    if (this.validator._hasNumericRule(this.attribute)) {
      return parseFloat(value, 10);
    }

    return value.length;
  },

  /**
   * Get the type of value being checked; numeric or string.
   *
   * @return {string}
   */
  _getValueType: function() {

    if (typeof this.inputValue === 'number' || this.validator._hasNumericRule(this.attribute)) {
      return 'numeric';
    }

    return 'string';
  },

  /**
   * Set the async callback response
   *
   * @param  {boolean|undefined} passes  Whether validation passed
   * @param  {string|undefined} message Custom error message
   * @return {void}
   */
  response: function(passes, message) {
    this.passes = (passes === undefined || passes === true);
    this._customMessage = message;
    this.callback(this.passes, message);
  },

  /**
   * Set validator instance
   *
   * @param {Validator} validator
   * @return {void}
   */
  setValidator: function(validator) {
    this.validator = validator;
  },

  /**
   * Check if rule is missed
   *
   * @return {boolean}
   */
  isMissed: function() {
    return typeof this.fn !== 'function';
  },

  get customMessage() {
    return this.isMissed() ? missedRuleMessage : this._customMessage;
  }
};

var manager = {

  /**
   * List of async rule names
   *
   * @type {Array}
   */
  asyncRules: [],

  /**
   * Implicit rules (rules to always validate)
   *
   * @type {Array}
   */
  implicitRules: ['required', 'required_if', 'required_unless', 'required_with', 'required_with_all', 'required_without', 'required_without_all', 'accepted', 'present'],

  /**
   * Get rule by name
   *
   * @param  {string} name
   * @param {Validator}
   * @return {Rule}
   */
  make: function(name, validator) {
    var async = this.isAsync(name);
    var rule = new Rule(name, rules[name], async);
    rule.setValidator(validator);
    return rule;
  },

  /**
   * Determine if given rule is async
   *
   * @param  {string}  name
   * @return {boolean}
   */
  isAsync: function(name) {
    for (var i = 0, len = this.asyncRules.length; i < len; i++) {
      if (this.asyncRules[i] === name) {
        return true;
      }
    }
    return false;
  },

  /**
   * Determine if rule is implicit (should always validate)
   *
   * @param {string} name
   * @return {boolean}
   */
  isImplicit: function(name) {
    return this.implicitRules.indexOf(name) > -1;
  },

  /**
   * Register new rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  register: function(name, fn) {
    rules[name] = fn;
  },

    /**
   * Register new implicit rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerImplicit: function(name, fn) {
    this.register(name, fn);
    this.implicitRules.push(name);
  },

  /**
   * Register async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsync: function(name, fn) {
    this.register(name, fn);
    this.asyncRules.push(name);
  },

  /**
   * Register implicit async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsyncImplicit: function(name, fn) {
    this.registerImplicit(name, fn);
    this.asyncRules.push(name);
  },

  registerMissedRuleValidator: function(fn, message) {
    missedRuleValidator = fn;
    missedRuleMessage = message;
  }
};



module.exports = manager;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var require;var Messages = __webpack_require__(439);

__webpack_require__(165);

var require_method = require;

var container = {

  messages: {},

  /**
   * Set messages for language
   *
   * @param {string} lang
   * @param {object} rawMessages
   * @return {void}
   */
  _set: function(lang, rawMessages) {
    this.messages[lang] = rawMessages;
  },

  /**
   * Set message for given language's rule.
   *
   * @param {string} lang
   * @param {string} attribute
   * @param {string|object} message
   * @return {void}
   */
  _setRuleMessage: function(lang, attribute, message) {
    this._load(lang);
    if (message === undefined) {
      message = this.messages[lang].def;
    }

    this.messages[lang][attribute] = message;
  },

  /**
   * Load messages (if not already loaded)
   *
   * @param  {string} lang
   * @return {void}
   */
  _load: function(lang) {
    if (!this.messages[lang]) {
      try {
        var rawMessages = __webpack_require__(440)("./" + lang);
        this._set(lang, rawMessages);
      } catch (e) {}
    }
  },

  /**
   * Get raw messages for language
   *
   * @param  {string} lang
   * @return {object}
   */
  _get: function(lang) {
    this._load(lang);
    return this.messages[lang];
  },

  /**
   * Make messages for given language
   *
   * @param  {string} lang
   * @return {Messages}
   */
  _make: function(lang) {
    this._load(lang);
    return new Messages(lang, this.messages[lang]);
  }

};

module.exports = container;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Attributes = __webpack_require__(240);

var Messages = function(lang, messages) {
  this.lang = lang;
  this.messages = messages;
  this.customMessages = {};
  this.attributeNames = {};
};

Messages.prototype = {
  constructor: Messages,

  /**
   * Set custom messages
   *
   * @param {object} customMessages
   * @return {void}
   */
  _setCustom: function(customMessages) {
    this.customMessages = customMessages || {};
  },

  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   */
  _setAttributeNames: function(attributes) {
    this.attributeNames = attributes;
  },

  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  _setAttributeFormatter: function(func) {
    this.attributeFormatter = func;
  },

  /**
   * Get attribute name to display.
   *
   * @param  {string} attribute
   * @return {string}
   */
  _getAttributeName: function(attribute) {
    var name = attribute;
    if (this.attributeNames.hasOwnProperty(attribute)) {
      return this.attributeNames[attribute];
    } else if (this.messages.attributes.hasOwnProperty(attribute)) {
      name = this.messages.attributes[attribute];
    }

    if (this.attributeFormatter) {
      name = this.attributeFormatter(name);
    }

    return name;
  },

  /**
   * Get all messages
   *
   * @return {object}
   */
  all: function() {
    return this.messages;
  },

  /**
   * Render message
   *
   * @param  {Rule} rule
   * @return {string}
   */
  render: function(rule) {
    if (rule.customMessage) {
      return rule.customMessage;
    }
    var template = this._getTemplate(rule);

    var message;
    if (Attributes.replacements[rule.name]) {
      message = Attributes.replacements[rule.name].apply(this, [template, rule]);
    } else {
      message = this._replacePlaceholders(rule, template, {});
    }

    return message;
  },

  /**
   * Get the template to use for given rule
   *
   * @param  {Rule} rule
   * @return {string}
   */
  _getTemplate: function(rule) {

    var messages = this.messages;
    var template = messages.def;
    var customMessages = this.customMessages;
    var formats = [rule.name + '.' + rule.attribute, rule.name];

    for (var i = 0, format; i < formats.length; i++) {
      format = formats[i];
      if (customMessages.hasOwnProperty(format)) {
        template = customMessages[format];
        break;
      } else if (messages.hasOwnProperty(format)) {
        template = messages[format];
        break;
      }
    }

    if (typeof template === 'object') {
      template = template[rule._getValueType()];
    }

    return template;
  },

  /**
   * Replace placeholders in the template using the data object
   *
   * @param  {Rule} rule
   * @param  {string} template
   * @param  {object} data
   * @return {string}
   */
  _replacePlaceholders: function(rule, template, data) {
    var message, attribute;

    data.attribute = this._getAttributeName(rule.attribute);
    data[rule.name] = data[rule.name] || rule.getParameters().join(',');

    if (typeof template === 'string' && typeof data === 'object') {
      message = template;

      for (attribute in data) {
        message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
      }
    }

    return message;
  }

};

module.exports = Messages;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": 241,
	"./de.js": 241,
	"./el": 242,
	"./el.js": 242,
	"./en": 165,
	"./en.js": 165,
	"./es": 243,
	"./es.js": 243,
	"./fa": 244,
	"./fa.js": 244,
	"./fr": 245,
	"./fr.js": 245,
	"./it": 246,
	"./it.js": 246,
	"./ja": 247,
	"./ja.js": 247,
	"./nb_NO": 248,
	"./nb_NO.js": 248,
	"./nl": 249,
	"./nl.js": 249,
	"./pl": 250,
	"./pl.js": 250,
	"./pt": 251,
	"./pt.js": 251,
	"./ru": 252,
	"./ru.js": 252,
	"./tr": 253,
	"./tr.js": 253,
	"./ua": 254,
	"./ua.js": 254,
	"./vi": 255,
	"./vi.js": 255,
	"./zh": 256,
	"./zh.js": 256,
	"./zh_TW": 257,
	"./zh_TW.js": 257
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;

/***/ }),
/* 441 */
/***/ (function(module, exports) {

var Errors = function() {
  this.errors = {};
};

Errors.prototype = {
  constructor: Errors,

  /**
   * Add new error message for given attribute
   *
   * @param  {string} attribute
   * @param  {string} message
   * @return {void}
   */
  add: function(attribute, message) {
    if (!this.has(attribute)) {
      this.errors[attribute] = [];
    }

    if (this.errors[attribute].indexOf(message) === -1) {
      this.errors[attribute].push(message);
    }
  },

  /**
   * Returns an array of error messages for an attribute, or an empty array
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {array} An array of error messages
   */
  get: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute];
    }

    return [];
  },

  /**
   * Returns the first error message for an attribute, false otherwise
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {string|false} First error message or false
   */
  first: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute][0];
    }

    return false;
  },

  /**
   * Get all error messages from all failing attributes
   *
   * @return {Object} Failed attribute names for keys and an array of messages for values
   */
  all: function() {
    return this.errors;
  },

  /**
   * Determine if there are any error messages for an attribute
   *
   * @param  {string}  attribute A key in the data object being validated
   * @return {boolean}
   */
  has: function(attribute) {
    if (this.errors.hasOwnProperty(attribute)) {
      return true;
    }

    return false;
  }
};

module.exports = Errors;


/***/ }),
/* 442 */
/***/ (function(module, exports) {

function AsyncResolvers(onFailedOne, onResolvedAll) {
  this.onResolvedAll = onResolvedAll;
  this.onFailedOne = onFailedOne;
  this.resolvers = {};
  this.resolversCount = 0;
  this.passed = [];
  this.failed = [];
  this.firing = false;
}

AsyncResolvers.prototype = {

  /**
   * Add resolver
   *
   * @param {Rule} rule
   * @return {integer}
   */
  add: function(rule) {
    var index = this.resolversCount;
    this.resolvers[index] = rule;
    this.resolversCount++;
    return index;
  },

  /**
   * Resolve given index
   *
   * @param  {integer} index
   * @return {void}
   */
  resolve: function(index) {
    var rule = this.resolvers[index];
    if (rule.passes === true) {
      this.passed.push(rule);
    } else if (rule.passes === false) {
      this.failed.push(rule);
      this.onFailedOne(rule);
    }

    this.fire();
  },

  /**
   * Determine if all have been resolved
   *
   * @return {boolean}
   */
  isAllResolved: function() {
    return (this.passed.length + this.failed.length) === this.resolversCount;
  },

  /**
   * Attempt to fire final all resolved callback if completed
   *
   * @return {void}
   */
  fire: function() {

    if (!this.firing) {
      return;
    }

    if (this.isAllResolved()) {
      this.onResolvedAll(this.failed.length === 0);
    }

  },

  /**
   * Enable firing
   *
   * @return {void}
   */
  enableFiring: function() {
    this.firing = true;
  }

};

module.exports = AsyncResolvers;


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var ListEditStore = /** @class */ (function () {
    function ListEditStore(Search) {
        var _this = this;
        this.sessionKey = '';
        this.changedDatas = [];
        this.editableColumns = {};
        this.back = function () {
            __WEBPACK_IMPORTED_MODULE_1__util__["default"].weaHistory.goBack();
        };
        this.datasChange = function (datas) {
            var diffs = [];
            for (var i = 0; i < datas.length && i < _this.Search.newTable.datas.length; i++) {
                var changed = datas.slice()[i];
                var data = _this.Search.newTable.datas.slice()[i];
                var diff = {};
                diff.notEmpty = false;
                for (var key in data) {
                    if (!key.endsWith("span")) {
                        if (changed[key] != data[key]) {
                            diff[key] = changed[key];
                            diff.notEmpty = true;
                        }
                    }
                }
                if (diff.notEmpty) {
                    diff.primaryKey = Object(__WEBPACK_IMPORTED_MODULE_1__util__["getListMainKey"])(data);
                    diff.subPrimaryKey = Object(__WEBPACK_IMPORTED_MODULE_1__util__["getListSubKey"])(data);
                    diffs.push(diff);
                }
            }
            _this.changedDatas = diffs;
        };
        this.editTablePaginationChange = function (p, _, s) {
            var callback = function () {
                _this.Search.newTable.getDatas(_this.sessionKey, p.current, p.pageSize, s);
            };
            if (_this.changedDatas.length > 0) {
                __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm({
                    title: getLabel(82873, '请确认'),
                    content: getLabel(383745, '当前页面数据有修改，是否需要保存？点击【确认】保存当前页，点击【取消】直接跳转！'),
                    okText: getLabel(16631, "确认"),
                    cancelText: getLabel(201, "取消"),
                    onOk: _this.batchSave.bind(_this, callback),
                    onCancel: callback
                });
            }
            else {
                callback();
            }
        };
        this.batchSave = function (callback) {
            if (callback === void 0) { callback = _this.back; }
            _this.Search.newTable.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].batchSave({ customid: _this.Search.customId, diffs: JSON.stringify(_this.changedDatas) }).then(function (_a) {
                var status = _a.status, error = _a.error;
                if (status == '1') {
                    callback();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this.Search.newTable.loading = false;
            });
        };
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
        this.Search = Search;
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ListEditStore.prototype, "changedDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ListEditStore.prototype, "editableColumns", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ListEditStore.prototype, "datasChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ListEditStore.prototype, "batchSave", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ListEditStore.prototype, "update", void 0);
    return ListEditStore;
}());



/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_index__ = __webpack_require__(7);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;

/**
 * 批量修改字段值
 */
var BatchEditStore = /** @class */ (function () {
    function BatchEditStore() {
        var _this = this;
        this.form = {};
        this.customid = {};
        this.visible = false;
        this.selectedRows = [];
        this.dialog = {};
        this.loading = false;
        this.pageexpandid = '';
        this.selectedRowKeys = [];
        this.datas = [];
        this.cells = [];
        this.showBatctEdit = function (callBackFun, callBackFunParams) {
            _this.callBackFun = callBackFun;
            _this.callBackFunParams = callBackFunParams;
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].getBatchModifyField({ pageexpandid: _this.pageexpandid }).then(function (_a) {
                var error = _a.error, status = _a.status, dataList = _a.dataList, cells = _a.cells;
                if (status == '1') {
                    _this.datas = dataList;
                    _this.cells = cells;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
            });
            _this.visible = true;
        };
        this.onCancel = function () {
            _this.visible = false;
        };
        this.saveBatctEdit = function () {
            var mythis = _this;
            __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm({
                title: getLabel(125395, '你确定进行批量修改吗?', 'label'),
                okText: getLabel(382958, '确定'),
                okType: 'danger',
                cancelText: getLabel(201, "取消"),
                onOk: function () {
                    mythis.checkDataNull();
                }
            });
        };
        this.checkDataNull = function () {
            var mess = '';
            _this.datas.forEach(function (element) {
                if (element.fieldvalue == '') {
                    mess += element.fieldlabel + ',';
                }
            });
            if (mess.endsWith(','))
                mess = mess.substring(0, mess.length - 1);
            if (mess == '') {
                _this.doSaveBatchEdit();
            }
            else {
                var mythis_1 = _this;
                __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm({
                    title: mess + getLabel(128103, '的值为空，执行此批量修改时，字段的值将会被清空，请确认是否提交？', 'label'),
                    okText: getLabel(382958, '确定'),
                    okType: 'danger',
                    cancelText: getLabel(201, "取消"),
                    onOk: function () {
                        mythis_1.doSaveBatchEdit();
                    }
                });
            }
        };
        this.doSaveBatchEdit = function () {
            var s = new Set();
            _this.selectedRowKeys.forEach(function (item) {
                s.add(item);
            });
            _this.loading = true;
            var info = "$DepartmentId$,$AllDepartmentId$,$SubcompanyId$,$AllSubcompanyId$";
            _this.datas.map(function (item) {
                if (item.changetype == 2 && info.includes(item.defaultvalue) && item.fieldvalue_r == 0) {
                    item.fieldvalue_r = '';
                    item.fieldvalue = '';
                }
            });
            __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].saveBatchModifyField({
                billids: Array.from(s).join(','),
                pageexpandid: _this.pageexpandid,
                datas: JSON.stringify(_this.datas)
            }).then(function (_a) {
                var error = _a.error, status = _a.status, errorCode = _a.errorCode, pageExpendResult = _a.pageExpendResult;
                if (status == '1' && errorCode == '1') {
                    if (pageExpendResult && pageExpendResult.haveError) {
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_cubeUtil__["h" /* showExpendError */])(pageExpendResult, Object(__WEBPACK_IMPORTED_MODULE_5__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.html#/main/cube/search?customid=" + _this.customid + "&"));
                        return;
                    }
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].success(getLabel(125585, '成功更新了{0}条数据！', 'label').replace('{0}', _this.selectedRowKeys.length));
                    if (_this.callBackFun) {
                        if (_this.callBackFunParams) {
                            _this.callBackFun(_this.callBackFunParams); //#828123 设置条件必填后，请求接口时需携带这些参数
                        }
                        else {
                            _this.callBackFun();
                        }
                    }
                    _this.visible = false;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
            });
        };
        this.changeRl = function (v, fieldId) {
            var str = Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["spellResourceCondition"])(v);
            _this.datas.map(function (field) {
                if (field.fieldid == fieldId) {
                    field.fieldvalue = str;
                }
            });
        };
        this.dialog = {
            loading: false,
            loadingTips: getLabel(124820, "正在加载中...")
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchEditStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchEditStore.prototype, "customid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchEditStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchEditStore.prototype, "selectedRows", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchEditStore.prototype, "dialog", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchEditStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchEditStore.prototype, "datas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchEditStore.prototype, "cells", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchEditStore.prototype, "showBatctEdit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchEditStore.prototype, "saveBatctEdit", void 0);
    return BatchEditStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (BatchEditStore);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cell_field_input_element_wf_financial__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var ExcelTableCellLabel = /** @class */ (function (_super) {
    __extends(ExcelTableCellLabel, _super);
    function ExcelTableCellLabel(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLabelClick = function () {
            var _a = _this.props, cell = _a.cell, card = _a.card;
            var path = cell.getPath();
            var order = !_this.state.orderbytype;
            _this.setState({
                orderbytype: order
            });
            card.refreshDetail(path, order);
        };
        var cell = props.cell, card = props.card;
        var path = cell.getPath();
        var order = card.getFieldProps(path).order;
        _this.state = {
            orderbytype: order
        };
        return _this;
    }
    /***
     * #446018
        概述：解决了导航树，是否刷新左侧树在前端菜单中使用不生效，后端预览正常的问题
        这个qc加的但是好像没啥关系， 不知道啥问题。，先关闭了吧
     */
    // componentDidMount(){
    //     setTimeout(()=>{this.forceUpdate();},1000)
    // }
    ExcelTableCellLabel.prototype.render = function () {
        var _a = this.props, cell = _a.cell, card = _a.card, form = _a.form;
        var path = cell.getPath();
        var _b = card.getFieldProps(path), label = _b.fieldlabel, isdetail = _b.isdetail, order = _b.order, detail = _b.detail;
        var isOpenCustomOrder = false;
        if (isdetail) {
            var excel = card.modeExcel.getExcel(detail);
            var _c = excel.detailProps.isPagination, isPagination = _c === void 0 ? false : _c;
            var isNeedPagination = (card.base.type == '0' || card.base.type == '1' || card.base.type == '2') && isPagination;
            var detailtable = card.getDetailTable(detail);
            isOpenCustomOrder = detailtable.isOpenCustomOrder && !isNeedPagination;
        }
        var title = isOpenCustomOrder ? getLabel('514223', '已启用拖动排序，字段排序失效！') : '';
        var style = isOpenCustomOrder ? { color: '#BDBDBD' } : {};
        var financial = cell.financial;
        if (financial && financial.indexOf("1-") > -1) { //财务表头
            var finaNum = parseInt(financial.split("-")[1] || "3");
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__cell_field_input_element_wf_financial__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_WeaWfFinancial@drnhc0", type: 1, finNum: finaNum, label: label, className: "cube-financial-th" });
        }
        if (!label) { // 标签不设置对应的值，在store中无法取到标签，此时直接在cell中获取
            label = cell.evalue;
        }
        if (!isdetail && isdetail != undefined) { //如果是非明细表，viewattr=4的时候也隐藏label
            var bindObj = form.has(path) ? form.$(path) : {};
            var viewAttr = bindObj.bind().viewAttr;
            if (viewAttr == '4') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({}, cell.cellProps, { className: "card-table-th-break" })));
            }
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({}, cell.cellProps, { className: "card-table-th-break", onClick: (isdetail && !isOpenCustomOrder && typeof order == 'boolean') ? this.handleLabelClick : undefined }),
            label,
            typeof order == 'boolean' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "sort-icon" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: title, style: style, className: this.state.orderbytype ? 'icon-coms-positive-sequence' : 'icon-coms-Reverse' }))));
    };
    ExcelTableCellLabel = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], ExcelTableCellLabel);
    return ExcelTableCellLabel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellLabel);


/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ExcelTableCellSpan = /** @class */ (function (_super) {
    __extends(ExcelTableCellSpan, _super);
    function ExcelTableCellSpan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.transCellText = function (content) {
            if (content === null || typeof content === "undefined")
                return "";
            return content.replace(/(\r\n|\r|\n)/g, "</br>").replace(/ /g, "&nbsp;");
        };
        return _this;
    }
    ExcelTableCellSpan.prototype.render = function () {
        var _a = this.props, cell = _a.cell, contentType = _a.contentType;
        if (contentType == 'content') {
            var evalue = cell.evalue;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", __assign({}, cell.cellProps, { dangerouslySetInnerHTML: { __html: "" + evalue } })));
        }
        else if (contentType == 'index') {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", __assign({}, cell.cellProps, { className: "serialNumber" }), this.props.index + 1));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({}, cell.cellProps, { dangerouslySetInnerHTML: { __html: this.transCellText(cell.evalue) } })));
        }
    };
    ExcelTableCellSpan = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCellSpan);
    return ExcelTableCellSpan;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellSpan);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input_element__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__textarea_element__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_element__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__checkbox_element__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__select_element__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__upload_element__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__href_element__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__seclevel_element__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PopoverTips__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_excelUtil__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};















var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;
var ExcelTableCellField = /** @class */ (function (_super) {
    __extends(ExcelTableCellField, _super);
    function ExcelTableCellField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderContent = function (bindObj, cell) {
            var _a = _this.props, form = _a.form, card = _a.card, index = _a.index, excel = _a.excel;
            var path = cell.getPath();
            var _b = card.getFieldProps(path).fieldhtmltype, fieldhtmltype = _b === void 0 ? '0' : _b;
            var _c = bindObj.bind(), isHide = _c.isHide, viewAttr = _c.viewAttr, value = _c.value;
            var classNames = (bindObj.isValid || !!bindObj.value) ? 'cube-check-valid' : 'cube-check-error';
            if (fieldhtmltype == '0') {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
            }
            if (typeof (card.getEcmeFieldData) == 'function') {
                try {
                    var fieldData = card.getEcmeFieldData(path, bindObj.bind());
                    var domid = Object(__WEBPACK_IMPORTED_MODULE_12__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
                    if (fieldData) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('fieldValue', classNames), "data-fieldmark": domid }, cell.cellProps), fieldData);
                    }
                }
                catch (e) { }
            }
            if ((isHide || viewAttr == '4')) {
                var domid = Object(__WEBPACK_IMPORTED_MODULE_12__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('fieldValue', classNames), "data-fieldmark": domid }, cell.cellProps),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "hidden", id: domid, name: domid, value: value }));
            }
            else {
                if (path === 'field-9') {
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__seclevel_element__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SelLevelElement@5lai9y", cell: cell, form: form, card: card, excel: excel, className: classNames, index: index }));
                }
                if (fieldhtmltype == '1') { //单行文本
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__input_element__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_InputElement@5lai4y", cell: cell, form: form, card: card, excel: excel, className: classNames, index: index }));
                }
                else if (fieldhtmltype == '2') { //多行文本
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__textarea_element__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_TextareaElement@t2k0s0", cell: cell, form: form, card: card, excel: excel, className: classNames, index: index }));
                }
                else if (fieldhtmltype == '3') { //浏览框、日期、时间
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__browser_element__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_BrowserElement@o9ozcv", cell: cell, form: form, card: card, excel: excel, className: classNames, index: index }));
                }
                else if (fieldhtmltype == '4') { //check框
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__checkbox_element__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_CheckboxElement@m959ut", cell: cell, form: form, card: card, excel: excel, className: classNames, index: index }));
                }
                else if (fieldhtmltype == '5') { //选择框
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__select_element__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectElement@wpmxr8", cell: cell, form: form, card: card, excel: excel, className: classNames, index: index }));
                }
                else if (fieldhtmltype == '6') { //附件上传
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__upload_element__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_UploadElement@zs496o", cell: cell, form: form, card: card, excel: excel, className: classNames, index: index }));
                }
                else if (fieldhtmltype == '7') { //特殊字段
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__href_element__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_HrefElement@eg5b02", cell: cell, form: form, card: card, excel: excel, className: classNames, index: index }));
                }
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null));
        };
        _this.proxyCompFn = function (bindObj, cell) {
            // const forceRender = ;     //仅为强制render
            // const { card } = this.props;
            var fieldName = Object(__WEBPACK_IMPORTED_MODULE_12__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
            var _a = bindObj.bind(), _viewAttr = _a._viewAttr, isEdit = _a.isEdit, isMandatory = _a.isMandatory;
            var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
            // const { forceRender} = bindObj.bind();
            // console.log(forceRender)
            var result = [];
            var _fieldName = fieldName.indexOf('_') > 0 ? fieldName.split('_')[0] : fieldName; //#813884加的，但是影响了明细表的渲染
            var proxyCompFn; // modeForm.getCustomProxyCompFn(`FieldContent_${fieldName}`);
            /***
             * 客户需要根据字段，不用加行号，所有行修改
             */
            if ("FieldContent_" + fieldName in __WEBPACK_IMPORTED_MODULE_14__util_excelUtil__["modeForm"].proxyCompFn) {
                proxyCompFn = __WEBPACK_IMPORTED_MODULE_14__util_excelUtil__["modeForm"].getCustomProxyCompFn("FieldContent_" + fieldName);
            }
            else {
                proxyCompFn = __WEBPACK_IMPORTED_MODULE_14__util_excelUtil__["modeForm"].getCustomProxyCompFn("FieldContent_" + _fieldName);
            }
            if (proxyCompFn === null) {
                var proxyComp = __WEBPACK_IMPORTED_MODULE_14__util_excelUtil__["modeForm"].renderCustomComp(fieldName, viewAttr, 1, _this.props);
                var afterComp = __WEBPACK_IMPORTED_MODULE_14__util_excelUtil__["modeForm"].renderCustomComp(fieldName, viewAttr, 2);
                result.push(proxyComp == null ? _this.renderContent(bindObj, cell) : proxyComp);
                if (afterComp !== null)
                    result.push(afterComp);
            }
            else {
                var fieldinfo = __WEBPACK_IMPORTED_MODULE_14__util_excelUtil__["modeForm"].getFieldInfo(fieldName);
                var needFieldInfo = {
                    fieldMark: fieldName,
                    fieldValue: __WEBPACK_IMPORTED_MODULE_14__util_excelUtil__["modeForm"].getFieldValue(fieldName),
                    fieldid: fieldinfo.fieldid,
                    rowIndex: fieldinfo.isdetail ? fieldName.split('_')[1] : '-1',
                    viewAttr: fieldinfo.viewattr,
                };
                result.push(proxyCompFn(needFieldInfo, _this.renderContent.bind(_this, bindObj, cell)));
            }
            return result;
        };
        return _this;
    }
    ExcelTableCellField.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form;
        var path = cell.getPath();
        var bindObj = form.has(path) ? form.$(path) : {};
        if (path === 'field-9') {
            var bindObj10 = form.has('field-10') ? form.$('field-10') : {};
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (this && this.props && this.props.ecId || '') + "_Fragment@c3rbzc" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PopoverTips__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_PopoverTips@140uco", error: bindObj.tips ? bindObj.tips : { visible: false, msg: '' }, type: "error", label: bindObj.label }, bindObj.bind ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (this && this.props && this.props.ecId || '') + "_Fragment@uv7ps3" }, this.proxyCompFn(bindObj, cell)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null)),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PopoverTips__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_PopoverTips@149uco", error: bindObj10.tips ? bindObj10.tips : { visible: false, msg: '' }, type: "error", label: getLabel('131188', '保密期限') },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: 28 } }))));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PopoverTips__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_PopoverTips@148uco", error: bindObj.tips ? bindObj.tips : { visible: false, msg: '' }, type: "error", label: bindObj.label }, bindObj.bind ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (this && this.props && this.props.ecId || '') + "_Fragment@ybyw61" }, this.proxyCompFn(bindObj, cell)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null)));
    };
    ExcelTableCellField = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], ExcelTableCellField);
    return ExcelTableCellField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellField);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wf_form_input__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_map_MapPic__ = __webpack_require__(262);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var InputElement = /** @class */ (function (_super) {
    __extends(InputElement, _super);
    function InputElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputChange = function (v, change) {
            if (change === void 0) { change = false; }
            var _a = _this.props, cell = _a.cell, form = _a.form, card = _a.card;
            var path = cell.getPath();
            var bindObj = form.$(path);
            var bind = bindObj.bind();
            var fieldtype = card.getFieldProps(path).fieldtype;
            if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(v, bind.value) || change) {
                // 金额千分位和浮点数值相等时不更新
                if (fieldtype === '5' && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(v, bind.value.replace(/,/g, ''))) {
                    return;
                }
                bind.onChange(v);
            }
        };
        /**
        * 解析外部传进来的样式
        */
        _this.getFieldStyle = function (isdetail, fieldtype, cellStyle) {
            var returnObj = {};
            returnObj.width = (isdetail || (fieldtype == "1" || fieldtype == "4")) ? "89%" : "54%";
            if (isdetail && fieldtype == "3")
                returnObj.width = "75%";
            if (cellStyle.verticalAlign)
                returnObj.verticalAlign = cellStyle.verticalAlign;
            if (cellStyle.fontSize)
                returnObj.fontSize = cellStyle.fontSize;
            return returnObj;
        };
        _this.handleMap = function (value, path, form) {
            if (window['getLnglat']) {
                var fieldName = Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["d" /* getDomIdByFieldKey */])(form.$(path).path);
                var index = "";
                if (fieldName.indexOf("_") > -1) { //明细表
                    index = fieldName.substring(fieldName.indexOf("_") + 1);
                }
                window['getLnglat'](path, form, index);
            }
            _this.props.card.mapStore.onShow(value, path, form);
        };
        return _this;
    }
    InputElement.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var bind = bindObj.bind();
        var _viewAttr = bind.viewAttr, isEdit = bind.isEdit, isMandatory = bind.isMandatory;
        var _b = card.getFieldProps(path), fieldtype = _b.fieldtype, fielddbtype = _b.fielddbtype, isdetail = _b.isdetail, qfws = _b.qfws, valueFormat = _b.valueFormat, transtype = _b.transtype, real_fieldtype = _b.real_fieldtype, showhtml = _b.showhtml, isdesensitization = _b.isdesensitization;
        var _c = card.isfrontmultlang, isfrontmultlang = _c === void 0 ? "0" : _c, quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues;
        var mapAttr = card.mapStore.getMapAttr(path);
        if (mapAttr && mapAttr.caltype == '5' && mapAttr.mapdistype && mapAttr.mapdistype.indexOf('S') >= 0) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { minHeight: 200 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__cube_map_MapPic__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_MapPic@lqditm", address: bind.value }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", __assign({}, bind, { id: fieldName, type: "hidden" }))));
        }
        var financial = cell.financial, cellFormat = cell.format;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        var format = {};
        if (financial && financial.indexOf("2-") > -1) {
            var finaNum = parseInt(financial.split("-")[1] || "3");
            format = { decimals: "-1", formatPattern: "2", numberType: 100, finaNum: finaNum };
        }
        else if (financial == "3") { //表单布局格式下拉框中设置的单元格格式  金额大写
            format = { decimals: "-1", formatPattern: "2", numberType: 101, thousands: "-1" };
        }
        else if (financial == "4") {
            format = { numberType: "2", decimals: qfws + "", formatPattern: "2", thousands: "1" };
        }
        else {
            if (cellFormat) {
                format = cellFormat;
            }
            else {
                if (valueFormat) {
                    format = valueFormat;
                }
                else if (transtype == '1') {
                    format = { decimals: "-1", formatPattern: "2", numberType: "8", thousands: "-1" };
                }
                else if (transtype == '2') {
                    format = { numberType: "2", decimals: qfws + "", formatPattern: "2", thousands: "1" };
                }
                else { ////字段原有单元格格式
                    if (fieldtype == '3') {
                        format = { numberType: "2", decimals: qfws + "", formatPattern: "2", thousands: "0" }; //浮点数
                    }
                    else if (fieldtype == '4' || fieldtype == '5') {
                        format = { numberType: "2", decimals: qfws + "", formatPattern: "2", thousands: "1" }; //金额转换
                    }
                }
            }
        }
        var fieldlength_tmp; //fieldtype 1文本   2整数(11)   4金额转换   3浮点(38)
        if (fieldtype == '1') {
            fieldlength_tmp = parseInt(fielddbtype.substring(fielddbtype.indexOf("(") + 1, fielddbtype.length - 1));
        }
        else if (fieldtype == '2') {
            fieldlength_tmp = 11;
        }
        else {
            fieldlength_tmp = 38;
        }
        var placeholder = bind.placeholder;
        if (card.detailMap["" + fieldName] && card.detailMap["" + fieldName]['emptyShowContent']) {
            placeholder = card.detailMap["" + fieldName]['emptyShowContent'];
        }
        var showMapIcon = mapAttr && mapAttr.caltype == '5' && (!mapAttr.mapdistype || mapAttr.mapdistype.indexOf('S') < 0);
        var component = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__wf_form_input__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_WfFormInput@rwz7u3", wrapStyle: isdetail ? { width: "" + (showMapIcon ? 'calc( 100% - 20px )' : '90%'), height: 28 } : { width: '89%', height: 28 }, fieldName: fieldName, format: format, value: bind.value, viewAttr: viewAttr, placeholder: placeholder, fieldid: fieldName, detailtype: fieldtype, qfws: qfws, length: fieldlength_tmp, fieldlabel: bind.label, onChange: this.inputChange, onFocus: bind.onFocus(), onBlur: bind.onBlur(), isDetail: isdetail, isfrontmultlang: isfrontmultlang, cell: cell, real_fieldtype: real_fieldtype, showhtml: showhtml, isdesensitization: isdesensitization });
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            component,
            showMapIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-position", style: { marginLeft: 5 }, onClick: this.handleMap.bind(this, bind.value, path, form) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
    };
    InputElement = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], InputElement);
    return InputElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (InputElement);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wf_financial__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_trim__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_contentPath__ = __webpack_require__(9);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;


var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main(props) {
        var _this = _super.call(this, props) || this;
        _this.setInputText = function (e) {
            var _a = _this.props, detailtype = _a.detailtype, length = _a.length, fieldlabel = _a.fieldlabel;
            var value = e.target.value;
            //this.props.onChange && this.props.onChange(value);
            if (detailtype == '2') {
                if (value > 2147483647 || value < -2147483648)
                    return;
            }
            else if (detailtype == '3' || detailtype == '4' || detailtype == '5') {
                if (value > 999999999999.999999999999 || value < -999999999999.999999999999)
                    return; //最大支持到千亿
            }
            if (detailtype === '1') {
                var valLen = __WEBPACK_IMPORTED_MODULE_3__util__["g" /* realLength */](value);
                if (length && valLen > length) {
                    __WEBPACK_IMPORTED_MODULE_0_antd__["message"].warning("\"" + fieldlabel + "\"" + (getLabel(20246, "文本长度不能超过") + length + '(' + getLabel(20247, '1个中文字符等于3个长度') + ')'));
                    value = __WEBPACK_IMPORTED_MODULE_3__util__["a" /* checkLength */](value, valLen, length);
                }
            }
            _this.setState({ value: value });
        };
        _this.doFocusEvent = function (bool, e) {
            var fieldName = _this.props.fieldName;
            if (_this.props.viewAttr === 1)
                return;
            if (bool) { //获取焦点
                _this.setState({ isonfocus: bool, location: _this.getLocation() });
                __WEBPACK_IMPORTED_MODULE_6__util_excelUtil__["modeForm"].triggerFieldAction("onfocus", fieldName);
                __WEBPACK_IMPORTED_MODULE_6__util_excelUtil__["modeForm"].ecmeFieldEventCallBack("onfocus", fieldName, "");
            }
            else { //失去焦点
                var value = _this.checkLen(e.target.value); //验证长度
                var realValue = _this.transRealValue(value);
                var formatValue = _this.transFormatValue(value, _this.props.format);
                _this.setState({ value: realValue, formatvalue: formatValue, isonfocus: bool });
                __WEBPACK_IMPORTED_MODULE_6__util_excelUtil__["modeForm"].triggerFieldAction("onblur", fieldName);
                __WEBPACK_IMPORTED_MODULE_6__util_excelUtil__["modeForm"].ecmeFieldEventCallBack("onblur", fieldName, "");
            }
        };
        _this.transRealValue = function (value) {
            var _a = _this.props, detailtype = _a.detailtype, qfws = _a.qfws;
            var realValue = value;
            if (detailtype !== '1') {
                var isqfw = detailtype === '5';
                realValue = __WEBPACK_IMPORTED_MODULE_3__util__["c" /* convertFloatValue */](value, qfws, isqfw);
            }
            _this.props.onChange && _this.props.onChange(realValue); //失去焦点触发修改Redux
            return realValue;
        };
        _this.transFormatValue = function (value, format) {
            var _a = _this.props, detailtype = _a.detailtype, qfws = _a.qfws;
            if (detailtype !== '1') {
                value = __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(value).length > 0 ? value.replace(/\,/g, '') : '';
            }
            var formatvalue = value;
            var numberType = parseInt(format.numberType) || 0;
            //失去焦点
            if (numberType > 0) {
                if (numberType === 100) { //财务预览
                }
                else if (numberType === 101) { //财务金额大写
                    formatvalue = __WEBPACK_IMPORTED_MODULE_3__util__["b" /* convertAmountChinese */](value);
                }
                else {
                    formatvalue = __WEBPACK_IMPORTED_MODULE_3__util__["d" /* convertFormatValue */](value, format);
                }
            }
            else {
                if (detailtype !== '1') {
                    var isqfw = false;
                    if (detailtype === '4' || detailtype === '5') {
                        isqfw = true;
                    }
                    formatvalue = __WEBPACK_IMPORTED_MODULE_3__util__["c" /* convertFloatValue */](value, qfws, isqfw);
                }
            }
            return formatvalue;
        };
        _this.checkLen = function (val) {
            var desensitization = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].EncryBase.desensitization;
            if (desensitization(val))
                return val;
            var _a = _this.props, detailtype = _a.detailtype, length = _a.length, qfws = _a.qfws, fieldlabel = _a.fieldlabel;
            if (detailtype === '1') {
                var valLen = __WEBPACK_IMPORTED_MODULE_3__util__["g" /* realLength */](val);
                if (length && valLen > length) {
                    __WEBPACK_IMPORTED_MODULE_0_antd__["message"].warning("\"" + fieldlabel + "\"" + (getLabel(20246, "文本长度不能超过") + length + '(' + getLabel(20247, '1个中文字符等于3个长度') + ')'));
                    val = __WEBPACK_IMPORTED_MODULE_3__util__["a" /* checkLength */](val, valLen, length);
                }
                return val;
            }
            var _length = __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(val).length;
            if (_length === 0) {
                return "";
            }
            if (_length === 1 && val.charCodeAt(0) === 45) {
                return val;
            }
            if (!__WEBPACK_IMPORTED_MODULE_3__util__["f" /* judgeIsNumber */](val)) {
                return "";
            }
            if (val.charCodeAt(0) === 45) {
                length = length + 1;
            }
            var arr = val.toString().split(".");
            if (__WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(arr[0]).length > length - qfws) {
                __WEBPACK_IMPORTED_MODULE_0_antd__["message"].warning("\"" + fieldlabel + "\"\u6574\u6570\u4F4D\u6570\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7" + (length - qfws) + "\u4F4D\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\uFF01", 5);
                return "";
            }
            if (arr.length == 2 && __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(arr[1]).length > qfws) {
                var fv = parseFloat(__WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(val));
                val = fv.toFixed(qfws);
            }
            return val;
        };
        var formatvalue = _this.transFormatValue(props.value, props.format);
        _this.state = {
            value: props.value ? props.value : '',
            formatvalue: formatvalue,
            isonfocus: false,
            location: -1
        };
        return _this;
    }
    Main.prototype.componentDidMount = function () {
        // const newValue = this.checkLen(`${this.props.value}`.replace(/,/g, ''));
        var newValue = this.props.detailtype !== '1' ? this.checkLen(("" + this.props.value).replace(/,/g, '')) : this.props.value;
        if (newValue != this.props.value) {
            this.props.onChange(newValue, true);
        }
    };
    Main.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.state.value !== nextProps.value || this.props.format !== nextProps.format || nextProps.defaultFocus) {
            //const newValue = this.checkLen(`${nextProps.value}`.replace(/,/g, ''));
            var newValue = nextProps.detailtype !== '1' && !this.state.isonfocus ? this.checkLen(("" + nextProps.value).replace(/,/g, '')) : nextProps.value;
            var formatShowValue = this.transFormatValue(newValue, nextProps.format);
            var nextValue = this.transFormatValue(nextProps.value, nextProps.format);
            if (formatShowValue != nextValue) {
                nextProps.onChange(newValue, true);
                return;
            }
            var _state = {
                value: newValue,
                formatvalue: formatShowValue
            };
            if (nextProps.defaultFocus !== this.props.defaultFocus && nextProps.defaultFocus) {
                _state.isonfocus = true;
            }
            this.setState(_state);
        }
    };
    Main.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.props.defaultFocus && this.props.defaultFocus !== nextProps.defaultFocus) //延时失去焦点时不渲染组件
            return false;
        return nextProps.value !== this.props.value ||
            nextProps.viewAttr !== this.props.viewAttr ||
            nextState.value !== this.state.value ||
            nextState.isonfocus !== this.state.isonfocus ||
            nextState.formatvalue !== this.state.formatvalue ||
            nextProps.format !== this.props.format ||
            nextProps.showhtml !== this.props.showhtml ||
            nextProps.placeholder !== this.props.placeholder ||
            nextProps.fieldName !== this.props.fieldName;
    };
    Main.prototype.componentDidUpdate = function (_, prevState) {
        if (this.state.isonfocus === true && prevState.isonfocus === false)
            this.setLocation();
    };
    Main.prototype.render = function () {
        var _this = this;
        var _a = this.state, isonfocus = _a.isonfocus, formatvalue = _a.formatvalue;
        var _b = this.props, viewAttr = _b.viewAttr, _c = _b.style, style = _c === void 0 ? {} : _c, fieldid = _b.fieldid, fieldName = _b.fieldName, detailtype = _b.detailtype, format = _b.format, isDetail = _b.isDetail, showhtml = _b.showhtml, placeholder = _b.placeholder, isfrontmultlang = _b.isfrontmultlang, cell = _b.cell, real_fieldtype = _b.real_fieldtype, isdesensitization = _b.isdesensitization;
        var fontstyle = cell.style || {};
        style["color"] = fontstyle.color || '';
        var value = this.state.value;
        if (viewAttr === 1 && isdesensitization) {
            return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { style: { display: 'inline-block' } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaInputEncrypt"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputEncrypt@mki31z", id: fieldName, name: fieldName, value: value })));
        }
        if (detailtype !== '1') {
            value = __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(value).length > 0 ? value.replace(/\,/g, '') : '';
        }
        var numberType = parseInt(format.numberType) || 0;
        if (!isonfocus && numberType === 100) { //财务表览
            if (!isDetail) {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", null);
            }
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__wf_financial__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_WeaWfFinancial@fgvvzr", type: 2, finNum: format.finaNum, className: "finarea_" + fieldid + (viewAttr == 3 ? ' required' : ''), viewAttr: viewAttr, value: value, clickEvent: this.doFocusEvent.bind(this, true) });
        }
        if (numberType === 2 && (format.formatPattern == "1" || format.formatPattern == "4")) {
            //格式化值负数则变为红色
            style["color"] = !isonfocus && __WEBPACK_IMPORTED_MODULE_3__util__["f" /* judgeIsNumber */](value) && parseFloat(value) < 0 ? "#FF0000" : "inherit";
        }
        var chinglish = detailtype === '4' ? __WEBPACK_IMPORTED_MODULE_3__util__["b" /* convertAmountChinese */](value) : "";
        var domArr = new Array();
        if (viewAttr === 1) {
            if (detailtype === '4') {
                var isRealType = real_fieldtype && real_fieldtype !== '4';
                if (!isRealType) {
                    domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { style: style }, formatvalue));
                    domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null));
                }
                // if (!isDetail) {
                //     domArr.push(<span style={style}>{formatvalue}</span>);
                //     domArr.push(<br />);
                // }
                domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { id: fieldName + "span", style: style }, chinglish));
            }
            else {
                //遇见其他的再说，目前遇见< 符号不行
                var transFormValue = formatvalue.replace(/</g, "&lt;");
                transFormValue = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].transHTML(transFormValue);
                if (transFormValue.startsWith('base64_')) {
                    transFormValue = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].Base64.decode(transFormValue.slice(7));
                }
                if (!!showhtml) { //只对文本、只读生效
                    transFormValue = showhtml;
                }
                domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { id: fieldName + "span", style: style, dangerouslySetInnerHTML: { __html: transFormValue } }));
            }
            return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", null,
                domArr,
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", { type: "hidden", id: fieldName, name: fieldName, value: value })));
        }
        else {
            var className = "wf-input wf-input-" + detailtype + " " + (isDetail ? "wf-input-detail" : "wf-input-main") + " wf-input-field" + fieldid;
            var onKeyPressEvent = function () { };
            if (detailtype === '2')
                onKeyPressEvent = this.doKeyPressCheckInteger.bind(this);
            else if (detailtype === '3' || detailtype === '4' || detailtype === '5')
                onKeyPressEvent = this.doKeyPressCheckFloat.bind(this);
            if (detailtype === '4') { //金额转换字段
                var isRealType_1 = real_fieldtype && real_fieldtype !== '4';
                domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", { ref: "inputEle", type: "text", className: className, id: fieldName, name: fieldName, value: isonfocus ? value : (isRealType_1 ? chinglish : formatvalue), onChange: this.setInputText.bind(this), onKeyDown: this.doKeyDown.bind(this), onKeyPress: onKeyPressEvent, onFocus: function (e) {
                        _this.doFocusEvent(true, e);
                        if (isRealType_1) {
                            _this.setState({ value: formatvalue });
                        }
                    }, onBlur: this.doFocusEvent.bind(this, false), placeholder: placeholder, style: style }));
                // if (!isDetail) {
                //     domArr.push(<br />);
                //     domArr.push(<input type="text" disabled={true} value={chinglish} className={`${className} wf-input-chinese`} style={style} />);
                // }
                if (!isRealType_1) {
                    domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("br", null));
                    domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", { type: "text", disabled: true, value: chinglish, className: className + " wf-input-chinese", style: style }));
                }
            }
            else if (detailtype === '1' && isfrontmultlang == '1') {
                domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaInput"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@25tw4i@" + fieldName, ref: "inputEle", className: className, inputType: "multilang", id: fieldName, name: fieldName, isBase64: true, style: style, value: value, onChange: function (v) {
                        _this.setState({ value: v });
                        _this.props.onChange && _this.props.onChange(v);
                    }, placeholder: placeholder }));
            }
            else {
                //支持可编辑无值时显示灰色默认值
                domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", { ref: "inputEle", type: "text", className: className, id: fieldName, name: fieldName, value: isonfocus ? value : formatvalue, onChange: this.setInputText.bind(this), onKeyDown: this.doKeyDown.bind(this), onKeyPress: onKeyPressEvent, onFocus: this.doFocusEvent.bind(this, true), onBlur: this.doFocusEvent.bind(this, false), placeholder: placeholder, style: style }));
            }
            var isRequired = viewAttr === 3 && __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(value).length === 0;
            domArr.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { id: fieldName + "span-required", className: "wf-input-required cube-input-required" }, isRequired ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { src: Object(__WEBPACK_IMPORTED_MODULE_7__util_contentPath__["a" /* getContentPath */])("/images/BacoError_wev9.png") }) : ""));
            return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: "wf-form-input" + (isRequired ? ' cube-form-input' : ''), style: __assign({}, this.props.wrapStyle, { position: 'relative', display: 'inline-block' }) }, domArr));
        }
    };
    //整数
    Main.prototype.doKeyPressCheckInteger = function (e) {
        var keyCode = __WEBPACK_IMPORTED_MODULE_3__util__["e" /* convertKeyCode */](e);
        var value = this.state.value;
        var length = this.props.length;
        var isNumber = (keyCode >= 48 && keyCode <= 57) || keyCode === 45;
        var selectLen = __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(this.getSelectionText(e).toString()).length;
        if (__WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(value).length > 0 && value.charCodeAt(0) === 45)
            length = length + 1;
        if (keyCode === 45 && __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(value).length === length) {
            var carePos = this.getCursortPosition();
            if (carePos === 0) {
                length = length + 1;
            }
        }
        if (!isNumber || (__WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(value).length - selectLen) >= length) {
            e.preventDefault();
        }
    };
    Main.prototype.doKeyDown = function (e) {
        var enableInput = this.props.enableInput;
        if (enableInput === false) {
            this.props.onDisablePrompt && this.props.onDisablePrompt();
            e.preventDefault();
            return;
        }
        var keyCode = __WEBPACK_IMPORTED_MODULE_3__util__["e" /* convertKeyCode */](e);
        if (keyCode === 13) {
            e.preventDefault(); //阻止enter键导致表单提交
        }
        e.stopPropagation(); //阻止冒泡
    };
    //检测小数输入
    Main.prototype.doKeyPressCheckFloat = function (e) {
        var _a = this.props, length = _a.length, qfws = _a.qfws, detailtype = _a.detailtype;
        var keyCode = __WEBPACK_IMPORTED_MODULE_3__util__["e" /* convertKeyCode */](e);
        var tmpvalue = this.state.value;
        if (detailtype !== '1') {
            tmpvalue = __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(tmpvalue).length > 0 ? tmpvalue.replace(/\,/g, '') : '';
        }
        var selectVal = this.getSelectionText(e).toString();
        if (selectVal.length > 0 && __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(tmpvalue).length > 0) {
            var curPosition = this.getCursortPosition();
            tmpvalue = tmpvalue.substr(0, curPosition) + tmpvalue.substr(curPosition + selectVal.length);
        }
        // 排除backspance 和del
        if (keyCode == 8) {
            return;
        }
        if (__WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(tmpvalue).length === 0 && keyCode == 46) {
            e.preventDefault();
        }
        var dotCount = 0;
        var integerCount = 0;
        var afterDotCount = 0;
        var hasDot = false;
        var len = __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(tmpvalue).length;
        for (var i = 0; i < len; i++) {
            if (tmpvalue.charAt(i) == ".") {
                dotCount++;
                hasDot = true;
            }
            else {
                if (hasDot) {
                    afterDotCount++;
                }
                else {
                    integerCount++;
                }
            }
        }
        //只能输入一个"."
        if (keyCode == 46 && (hasDot || qfws === 0)) {
            e.preventDefault();
        }
        var isNumber = keyCode >= 48 && keyCode <= 57;
        var checkInput = (isNumber || keyCode == 46 || keyCode == 45) || (keyCode == 46 && dotCount == 1);
        if (!checkInput) {
            e.preventDefault();
        }
        var checkInteger = integerCount >= length - qfws && hasDot == false && isNumber;
        if (checkInteger) {
            e.preventDefault();
        }
        var checkLen = afterDotCount >= qfws && (integerCount >= length - qfws);
        if (checkLen) {
            e.preventDefault();
        }
        if (hasDot) {
            var carePos = this.getCursortPosition();
            var dotIndex = __WEBPACK_IMPORTED_MODULE_2_lodash_trim___default()(tmpvalue).indexOf('.');
            if (carePos <= dotIndex) {
                if (integerCount >= length - qfws) {
                    e.preventDefault();
                }
            }
            else {
                if (afterDotCount >= qfws) {
                    e.preventDefault();
                }
            }
        }
    };
    Main.prototype.getSelectionText = function (e) {
        if (document.selection) { //IE
            return document.selection.createRange().text;
        }
        else if (window.getSelection().toString()) { //Chrome
            return window.getSelection().toString();
        }
        else if (e.selectionStart != undefined && e.selectionEnd != undefined) { //其它情况
            var start = e.selectionStart;
            var end = e.selectionEnd;
            return e.value.substring(start, end);
        }
        return "";
    };
    Main.prototype.getCursortPosition = function () {
        var input = this.refs.inputEle;
        var CaretPos = 0;
        if (input.selection) {
            input.focus();
            var Sel = input.selection.createRange();
            if (Sel.text.length < 1) {
                Sel.moveStart('character', -input.value.length);
                CaretPos = Sel.text.length;
            }
        }
        else if (input.selectionStart || input.selectionStart == '0') { //ff
            CaretPos = input.selectionStart;
        }
        return CaretPos;
    };
    Main.prototype.getLocation = function () {
        try { //计算鼠标焦点位置
            var elm = this.refs.inputEle;
            if (elm.createTextRange) { // IE
                var range = document.selection.createRange();
                range.setEndPoint('StartToStart', elm.createTextRange());
                return range.text.length;
            }
            else if (typeof elm.selectionStart === 'number') {
                return elm.selectionStart;
            }
        }
        catch (e) {
            return -1;
        }
    };
    Main.prototype.setLocation = function () {
        try {
            var elm = this.refs.inputEle;
            var location = this.state.location;
            if (location < 0 || location > elm.value.length) //定位到最后
                location = elm.value.length;
            if (elm.createTextRange) { //IE
                var textRange = elm.createTextRange();
                textRange.moveStart('character', location);
                textRange.collapse();
                textRange.select();
            }
            else if (elm.setSelectionRange) {
                elm.setSelectionRange(location, location);
                elm.focus();
            }
        }
        catch (e) {
            return "setLocation failed";
        }
    };
    return Main;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Main);


/***/ }),
/* 451 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isObjectLike = __webpack_require__(89);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(109);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 454 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(456);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 456 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(261);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 458 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 459 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 460 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(261);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(463),
    hasUnicode = __webpack_require__(464),
    unicodeToArray = __webpack_require__(465);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(259);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Textarea__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RichText__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReadonlyText__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cube_map_MapPic__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__input_element_wf_form_input_util__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








// import jQuery from 'jquery';



var TextareaElement = /** @class */ (function (_super) {
    __extends(TextareaElement, _super);
    function TextareaElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonBtnChange = function (name, _, list, type) {
            if (name === void 0) { name = ''; }
            if (_ === void 0) { _ = ''; }
            if (list === void 0) { list = []; }
            if (type === void 0) { type = ''; }
            var html = [];
            if (name === 'Upload') {
                if (type === 'image') {
                    list.map(function (item) {
                        var imglink = "/weaver/weaver.file.FileDownload?fileid=" + item.fileidCode;
                        html.push("<img class='formImgPlay' src='" + Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])(imglink) + "' data-imgsrc='" + Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])(imglink) + "' onclick=\"window.imageCarousel(this)\" alt=''/>");
                    });
                }
            }
            return html.join('');
        };
        _this.handleMap = function (value, path, form) {
            if (window['getLnglat']) {
                var fieldName = Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["d" /* getDomIdByFieldKey */])(form.$(path).path);
                var index = "";
                if (fieldName.indexOf("_") > -1) { //明细表
                    index = fieldName.substring(fieldName.indexOf("_") + 1);
                }
                window['getLnglat'](path, form, index);
            }
            _this.props.card.mapStore.onShow(value, path, form);
        };
        return _this;
    }
    TextareaElement.prototype.componentDidMount = function () {
        var _a = this.props, cell = _a.cell, card = _a.card, form = _a.form;
        var fieldtype = card.getFieldProps(cell.getPath()).fieldtype;
        if (fieldtype == '2') {
            var bindObj = form.$(cell.getPath());
            var fieldName = Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(window, "FORM_CK_REF." + fieldName, this.refs[fieldName]);
        }
    };
    TextareaElement.prototype.ckfocus = function () {
        var _a = this.props, cell = _a.cell, card = _a.card, form = _a.form;
        var fieldtype = card.getFieldProps(cell.getPath()).fieldtype;
        if (fieldtype == '2') {
            var bindObj = form.$(cell.getPath());
            var fieldName = Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
            this.refs[fieldName].getEditor().focus();
        }
    };
    TextareaElement.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var bind = bindObj.bind();
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var _viewAttr = bindObj.viewAttr, isEdit = bindObj.isEdit, isMandatory = bindObj.isMandatory;
        var _b = card.getFieldProps(path), fieldtype = _b.fieldtype, textheight = _b.textheight, placeholder = _b.placeholder;
        var quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues;
        //QC613733 QC620582 问题处理不合适，迁移上来
        var style = cell.style || {};
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        var mapAttr = card.mapStore.getMapAttr(path);
        var showMapIcon = mapAttr && mapAttr.caltype == '5' && (!mapAttr.mapdistype || mapAttr.mapdistype.indexOf('S') < 0);
        if (mapAttr && mapAttr.caltype == '5' && mapAttr.mapdistype && mapAttr.mapdistype.indexOf('S') >= 0) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { minHeight: 200 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__cube_map_MapPic__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_MapPic@m9m03m", address: bind.value }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", __assign({}, bind, { id: fieldName, type: "hidden" }))));
        }
        if (fieldtype != '2') {
            placeholder = bind.placeholder || placeholder;
            if (card.detailMap["" + fieldName] && card.detailMap["" + fieldName]['emptyShowContent']) {
                placeholder = card.detailMap["" + fieldName]['emptyShowContent'];
            }
            var canQuickedit_1 = bindObj.isquickedit && viewAttr == '1';
            //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
            if (canQuickedit_1 && excel.detailProps && !excel.detailProps["isEdit"]) {
                canQuickedit_1 = false;
            }
            var isDisplay = '';
            if (!canQuickedit_1) {
                isDisplay = 'none';
            }
            if (viewAttr == '1') { //只读
                var bind_1 = form.$(path).bind();
                var value = Object(__WEBPACK_IMPORTED_MODULE_9__input_element_wf_form_input_util__["h" /* transHTML */])(bind_1.value);
                if (__WEBPACK_IMPORTED_MODULE_10_ecCom__["WeaTools"].EncryBase.desensitization(value)) { //脱敏
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_ecCom__["WeaInputEncrypt"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputEncrypt@eyews7", value: value, type: 'TEXTAREA' });
                }
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: (canQuickedit_1 ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { style: __assign({}, cell.cellProps.style), onClick: function () { canQuickedit_1 && quickEditStore.lockEditFormItem(fieldName); } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-textarea-normal wea-field-readonly " + className, style: { color: style.color, }, id: fieldName, dangerouslySetInnerHTML: { __html: value } }),
                    showMapIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-position", style: { marginLeft: 5 }, onClick: this.handleMap.bind(this, bind_1.value, path, form) }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: (canQuickedit_1 ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { style: __assign({ paddingRight: "13px" }, cell.cellProps.style), onClick: function () { canQuickedit_1 && quickEditStore.lockEditFormItem(fieldName); } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Textarea__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Textarea@symbwz", path: path, form: form, fieldName: fieldName, viewAttr: viewAttr, placeholder: placeholder, textheight: textheight == 0 ? 4 : textheight, 
                    // style={{ color: style.color, width: viewAttr == '1' ? 'auto' : '96%' }}
                    style: { color: style.color, width: '96%' } }),
                showMapIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-position", style: { marginLeft: 5 }, onClick: this.handleMap.bind(this, bind.value, path, form) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
        }
        else {
            if (viewAttr == 2 || viewAttr == 3 || viewAttr == 5) {
                var ckConfig = {};
                ckConfig.toolbar = [['Source', '-', 'Bold', 'Italic', 'Underline', 'Strike', '-',
                        'Format', 'Font', 'FontSize', 'TextColor', 'BGColor', '-',
                        'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-',
                        'Link', 'Unlink', '-', 'Table', '-', 'Iframe', 'HorizontalRule', 'SpecialChar', '-', 'CopyFormatting', 'RemoveFormat', 'PasteText',
                        'Undo', 'Redo', 'Maximize', "Html5video"
                    ]];
                ckConfig.extraPlugins = 'autogrow,html5video';
                ckConfig.height = 40 * textheight;
                ckConfig['autoGrow_maxHeight'] = 40 * textheight;
                ckConfig['autoGrow_minHeight'] = 40 * textheight;
                ckConfig.removePlugins = 'resize';
                ckConfig.uploadUrl = '/api/doc/upload/uploadFile';
                ckConfig.fontSize_defaultLabel = '12';
                ckConfig.font_names = '仿宋_GB2312/FangSong_GB2312;宋体/SimSun;微软雅黑/Microsoft YaHei;楷体/KaiTi;黑体/SimHei;Arial/Arial, Helvetica, sans-serif;新宋体/NSimSun;楷体_GB2312/KaiTi_GB2312;';
                ckConfig.font_defaultLabel = '微软雅黑';
                ckConfig.fontSize_sizes = '8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;';
                ckConfig.startupFocus = false;
                ckConfig.placeholder = bindObj.$placeholder;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: "cube-card-editformitem2 fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RichText__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_RichText@fkrkc2", path: path, fieldName: fieldName, field: bindObj, viewAttr: viewAttr, extentsConfig: this.initExtentsConfig(), onToolsChange: this.buttonBtnChange, ckConfig: ckConfig }));
            }
            else {
                var bind_2 = form.$(path).bind();
                if (__WEBPACK_IMPORTED_MODULE_10_ecCom__["WeaTools"].EncryBase.desensitization(bind_2.value)) { //脱敏
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_ecCom__["WeaInputEncrypt"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputEncrypt@zxx0b4", value: bind_2.value, type: 'TEXTAREA' });
                }
                var canQuickedit_2 = bindObj.isquickedit && viewAttr == '1';
                var isDisplay = '';
                if (!canQuickedit_2) {
                    isDisplay = 'none';
                }
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: (canQuickedit_2 ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, style: { overflowX: "auto", overflowY: "hidden" }, "data-fieldmark": fieldName, onClick: function () { canQuickedit_2 && quickEditStore.lockEditFormItem(fieldName); } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ReadonlyText__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ReadonlyText@kbwl34", path: path, form: form, fieldName: fieldName }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" })));
            }
        }
    };
    TextareaElement.prototype.initExtentsConfig = function () {
        var extentsConfig = [];
        extentsConfig.push({
            name: 'Upload',
            type: 'image',
            show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon cke_button_icon cke_button__image_icon" })),
            uploadUrl: '/api/doc/upload/uploadFile',
            category: 'all',
            limitType: 'jpg,gif,png',
            title: '上传图片',
            needLoading: false
        });
        return extentsConfig;
    };
    TextareaElement = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TextareaElement);
    return TextareaElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TextareaElement);


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _this = this;



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (_a) {
    var path = _a.path, viewAttr = _a.viewAttr, placeholder = _a.placeholder, textheight = _a.textheight, fieldName = _a.fieldName, form = _a.form, style = _a.style;
    var maxRows = textheight;
    if (maxRows < 10) {
        maxRows = maxRows * 2;
        if (maxRows > 10) {
            maxRows = 10;
        }
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTextarea"], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTextarea@3hl5gy" }, form.$(path).bind(), { fieldName: fieldName, id: fieldName, name: fieldName, viewAttr: viewAttr, placeholder: placeholder, minRows: textheight, maxRows: maxRows, style: style })));
}));


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Main.prototype.render = function () {
        var _a = this.props, fieldName = _a.fieldName, field = _a.field, viewAttr = _a.viewAttr, extentsConfig = _a.extentsConfig, onToolsChange = _a.onToolsChange, ckConfig = _a.ckConfig;
        var bind = field.bind();
        return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { style: { position: "relative", width: '89%', fontSize: '12px' }, className: "cube-card-weaRichtext " + (viewAttr == 3 && !bind.value ? 'required' : '') },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaRichText"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaRichText@9k1j85", ckConfig: ckConfig, id: fieldName, ref: "" + fieldName }, bind, { viewAttr: 2, scrollContainer: '.wea-new-top-req-content', extentsConfig: extentsConfig, onToolsChange: onToolsChange })),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", { type: "hidden", id: fieldName, name: fieldName, value: bind.value })));
    };
    Main = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx_react__["observer"]
    ], Main);
    return Main;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Main);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_element_wf_form_input_util__ = __webpack_require__(65);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["observer"])(function (_a) {
    var path = _a.path, form = _a.form, fieldName = _a.fieldName;
    var bind = form.$(path).bind();
    var value = Object(__WEBPACK_IMPORTED_MODULE_1__input_element_wf_form_input_util__["h" /* transHTML */])(bind.value);
    return (React.createElement("div", { style: { display: "inline-block" } },
        React.createElement("div", __assign({ id: fieldName + "span" }, { name: fieldName + "span" }, { dangerouslySetInnerHTML: { __html: "<div class=\"wea-cube-ckeditor-content\">" + bind.value + "</div>" } })),
        React.createElement("input", { type: "hidden", id: fieldName, name: fieldName, value: value })));
}));


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DatePicker__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimePicker__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DateTimePicker__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__YearMonthPicker__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Browser__ = __webpack_require__(87);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var BrowserElement = /** @class */ (function (_super) {
    __extends(BrowserElement, _super);
    function BrowserElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserElement.prototype.render = function () {
        var _a = this.props, cell = _a.cell, card = _a.card;
        var path = cell.getPath();
        var fieldtype = card.getFieldProps(path).fieldtype;
        if (fieldtype == '2') {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DatePicker__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_DatePicker@bgv1o2" }, this.props)));
        }
        else if (fieldtype == '19') {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TimePicker__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_TimePicker@eubz6j" }, this.props)));
        }
        else if (fieldtype == '290') {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DateTimePicker__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_DateTimePicker@uycxo2" }, this.props)));
        }
        else if (fieldtype == '402' || fieldtype == '403') { //年、年月
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__YearMonthPicker__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_YearMonthPicker@frexqt" }, this.props)));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Browser__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Browser@iflpum" }, this.props)));
        }
    };
    return BrowserElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (BrowserElement);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePicker.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var isdetail = card.getFieldProps(path).isdetail;
        var bind = bindObj.bind();
        var quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues;
        var _viewAttr = bind.viewAttr, isEdit = bind.isEdit, isMandatory = bind.isMandatory;
        var format = cell.format;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        var formatPattern = "2";
        if (format) { //日期字段单元格格式 直接通过字段参数实现
            var numberType = format.numberType;
            if (numberType == "3") {
                formatPattern = format.formatPattern ? format.formatPattern : "2";
            }
        }
        var layoutProps = {};
        if (!isdetail) {
            layoutProps = {
                layout: document.getElementById("date" + fieldName),
                useSelfLayout: true
            };
        }
        var value = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.trim(bind.value.split(' ')[0]);
        if (!/^(\d{1,4})(-|\/)(\d{1,2})(-|\/)(\d{1,2})$/.test(value)) {
            value = ''; //日期不正确，则不显示
        }
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ id: "date" + fieldName, className: (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaDatePicker"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaDatePicker@hzi79x" }, bind, { startValue: bind.startDate || null, endValue: bind.endDate || null, value: value, fieldName: fieldName, noInput: true, viewAttr: viewAttr, formatPattern: formatPattern }, layoutProps)),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
    };
    DatePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], DatePicker);
    return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var TimePicker = /** @class */ (function (_super) {
    __extends(TimePicker, _super);
    function TimePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimePicker.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var isdetail = card.getFieldProps(path).isdetail;
        var bind = bindObj.bind();
        var quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues;
        var format = cell.format;
        var _viewAttr = bind.viewAttr, isEdit = bind.isEdit, isMandatory = bind.isMandatory;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        var formatPattern = "3"; //默认： HH:MI
        if (format) { //日期字段单元格格式 直接通过字段参数实现
            var numberType = format.numberType;
            if (numberType == "4") {
                formatPattern = format.formatPattern ? format.formatPattern : "3";
            }
        }
        var layoutProps = {};
        if (!isdetail) {
            layoutProps = {
                layout: document.getElementById("time" + fieldName),
                useSelfLayout: true
            };
        }
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        var value = "" || __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.trim(bind.value);
        //#997381概述：解决了点击添加明细，页面异常的问题
        if (typeof (value) == 'string' && value.indexOf('doFieldDate') > -1) {
            value = "";
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ id: "time" + fieldName, className: (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTimePicker"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaTimePicker@jl3pl2" }, bind, { value: value, fieldName: fieldName, noInput: true, viewAttr: viewAttr, formatPattern: formatPattern }, layoutProps)),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
    };
    TimePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], TimePicker);
    return TimePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TimePicker);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePicker.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var bind = bindObj.bind();
        var quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues;
        var _viewAttr = bind.viewAttr, isEdit = bind.isEdit, isMandatory = bind.isMandatory;
        var format = cell.format;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        if (format) { //日期字段单元格格式 直接通过字段参数实现
            var numberType = format.numberType;
            if (numberType == "3") {
            }
        }
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && excel.detailProps && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaDatePicker"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaDatePicker@4j86gr" }, bind, bind.value, { fieldName: fieldName, noInput: true, viewAttr: viewAttr, format: "yyyy-MM-dd HH:mm", showTime: true })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
    };
    DatePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], DatePicker);
    return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, cell = _a.cell, form = _a.form;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var bind = bindObj.bind();
        var value = "" || __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.trim(bind.value);
        _this.state = {
            value: value
        };
        return _this;
    }
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var value = this.state.value;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var fieldtype = card.getFieldProps(path).fieldtype;
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var bind = bindObj.bind();
        var quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues;
        var _viewAttr = bind.viewAttr, isEdit = bind.isEdit, isMandatory = bind.isMandatory;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        var format = "YYYY";
        if (fieldtype == '403') {
            format = "YYYY-MM";
        }
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && excel.detailProps && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaDatePicker"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaDatePicker@b0r3qz" }, bind, { value: value, fieldName: fieldName, noInput: true, viewAttr: viewAttr, format: format, onChange: function (value) { _this.setState({ value: value }); bind.onChange(value); } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
    };
    DatePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], DatePicker);
    return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var CheckboxElement = /** @class */ (function (_super) {
    __extends(CheckboxElement, _super);
    function CheckboxElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxElement.prototype.componentDidMount = function () {
        var _a = this.props, cell = _a.cell, form = _a.form;
        var path = cell.getPath();
        var bindObj = form.$(path);
        if (!bindObj.values()) {
            bindObj.onChange('0');
        }
    };
    CheckboxElement.prototype.componentWillReceiveProps = function () {
        var _a = this.props, cell = _a.cell, form = _a.form;
        var path = cell.getPath();
        var bindObj = form.$(path);
        if (!bindObj.values()) {
            bindObj.onChange('0');
        }
    };
    CheckboxElement.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues;
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var _b = bindObj.bind(), _viewAttr = _b.viewAttr, isEdit = _b.isEdit, isMandatory = _b.isMandatory;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && excel.detailProps && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaCheckbox"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaCheckbox@p5ay4m" }, bindObj.bind(), { viewAttr: viewAttr, fieldName: fieldName })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
    };
    CheckboxElement = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], CheckboxElement);
    return CheckboxElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CheckboxElement);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var SelectElement = /** @class */ (function (_super) {
    __extends(SelectElement, _super);
    function SelectElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectElement.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues, DetailDatas = card.DetailDatas;
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var _b = bindObj.bind(), value = _b.value, _viewAttr = _b.viewAttr, isEdit = _b.isEdit, isMandatory = _b.isMandatory, filtedOptions = _b.options;
        var _c = card.getFieldProps(path), fieldtype = _c.fieldtype, options = _c.options, fieldshowtypes = _c.fieldshowtypes, isdetail = _c.isdetail;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        var realOptions = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(filtedOptions) ? filtedOptions : options;
        if (fieldName.indexOf('_') > -1) {
            var fieldnames = fieldName.split('_')[0];
            var fieldIndex = fieldName.split('_')[1];
            fieldnames = fieldnames + 'options';
            try {
                var realOptionsCopy = DetailDatas[fieldIndex][fieldnames];
                if (realOptionsCopy) {
                    realOptions = realOptionsCopy;
                }
            }
            catch (e) {
                realOptions = realOptions;
            }
        }
        realOptions = realOptions.filter(function (f) { return f.cancel != '1'; });
        // realOptions = realOptions.map(option => {
        //     return {
        //         ...option,
        //         selected: viewAttr == '1'? false: option.isdefault == 'y'
        //     }
        // })
        // const value1 = value ? value : WeaTools.getSelectDefaultValue(realOptions);
        var value1 = value;
        var layoutProps = {};
        if (!isdetail) {
            layoutProps = {
                layout: document.getElementById("select" + fieldName),
                useSelfLayout: true
            };
        }
        //打印模式下radio框只显示选中值
        if (card.params.type == "4" && fieldtype == '3') {
            var newfieldName = fieldName;
            if (newfieldName.indexOf('_') > -1) {
                newfieldName = newfieldName.split('_')[0];
            }
            if (card.variableMap["radioPrintText_" + newfieldName] === true) {
                fieldtype = 1;
            }
        }
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ id: "select" + fieldName, className: (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaSelect"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@fsyo9r", className: isdetail ? 'cube-detail-select cube-card-select' : 'cube-card-select', options: [{ key: '', showname: '' }].concat(realOptions), fieldName: fieldName, viewAttr: viewAttr, detailtype: fieldtype, fieldshowtypes: fieldshowtypes, value: value1, onChange: bindObj.onChange }, layoutProps, { supportCancel: true })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
    };
    SelectElement = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], SelectElement);
    return SelectElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (SelectElement);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;


var UploadElement = /** @class */ (function (_super) {
    __extends(UploadElement, _super);
    function UploadElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getShowListDatas = function (listT, newList) {
            var _a = _this.props, cell = _a.cell, form = _a.form;
            var field = cell.field;
            var fieldid = "field" + field;
            var bindObj = form.$(fieldid);
            if (bindObj.values() == '') {
                if (newList.length > 0) {
                    bindObj.onChange('-1');
                }
            }
            else if (newList.length <= 0 && listT.length <= 0) {
                bindObj.onChange('');
            }
        };
        _this.onUploading = function (state) {
            var _a = _this.props, cell = _a.cell, form = _a.form;
            var path = cell.getPath();
            if (form.has(path)) {
                var bindObj = form.$(path);
                bindObj.setUploadState(state);
            }
        };
        /**
        * 附件上传回调方法
        */
        _this.doChangeEvent = function (idsT, filedatas, datas) {
            var _a = _this.props, cell = _a.cell, form = _a.form;
            var path = cell.getPath();
            var i = 0;
            filedatas.map(function (item) {
                var fileid = item.fileid;
                var id = fileid;
                datas.map(function (items) {
                    var fileid = items.fileid, uploaddate = items.uploaddate, username = items.username;
                    var params = { "uploaddate": uploaddate, "username": username };
                    if (id == fileid) {
                        filedatas[i] = __assign({}, filedatas[i], params);
                    }
                });
                i++;
            });
            if (form.has(path)) {
                var bindObj = form.$(path);
                bindObj.onChange(idsT.join(','));
                bindObj.setUploadData({
                    filedatas: filedatas,
                    showBatchLoad: bindObj.uploadData.showBatchLoad
                });
            }
        };
        _this.clearUploadData = function () {
            var _a = _this.props, cell = _a.cell, form = _a.form;
            var path = cell.getPath();
            var bindObj = form.$(path);
            bindObj.setUploadData({
                filedatas: [],
                showBatchLoad: bindObj.uploadData.showBatchLoad
            });
        };
        return _this;
    }
    UploadElement.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className, excel = _a.excel;
        var fileisdisplay = card.base.fileisdisplay;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var _b = bindObj.bind(), value = _b.value, _viewAttr = _b.viewAttr, isEdit = _b.isEdit, isMandatory = _b.isMandatory, _c = _b.uploadData, _d = _c === void 0 ? {} : _c, _e = _d.filedatas, filedatas = _e === void 0 ? [] : _e, _f = _d.showBatchLoad, showBatchLoad = _f === void 0 ? false : _f;
        var _g = card.getFieldProps(path), fieldid = _g.fieldid, fieldtype = _g.fieldtype, isdetail = _g.isdetail, imgheight = _g.imgheight, imgwidth = _g.imgwidth, fileFormat = _g.fileFormat, categorytypeown = _g.categorytypeown;
        var docCategroy = card.docCategroy;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        var base = card.base, empowmentType = card.empowmentType, quickEditStore = card.quickEditStore, getDetailFormValues = card.getDetailFormValues, params = card.params;
        var billid = base.billid, modeId = base.modeId;
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) { //如果是新增加的行，不会产生dtl_id，已有明细才有该字段
                viewAttr = 1;
            }
        }
        var secretLevel = '';
        var seclevelInfo = card.seclevelInfo;
        var casProtect = card.seclevelInfo == 'field-9'; // 是否开启分级保护
        if (seclevelInfo != undefined && seclevelInfo != "-1") {
            if (__WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].getCurrentModeStore().cubeForm.$(seclevelInfo).values() != '') {
                secretLevel = __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["modeForm"].getCurrentModeStore().cubeForm.$(seclevelInfo).values();
            }
        }
        var main;
        var sub;
        var sec;
        var maxUploadSize;
        var mes;
        var category;
        //用户自定义
        if (categorytypeown === "0") { //固定目录
            var _h = card.getFieldProps(path), maincategory = _h.maincategory, subcategory = _h.subcategory, seccategory = _h.seccategory, limitValue = _h.limitValue;
            main = maincategory;
            sub = subcategory;
            sec = seccategory;
            maxUploadSize = limitValue;
        }
        else if (categorytypeown === "1") { //选择目录
            var selectFieldId = card.getFieldProps(path).selectFieldId;
            var category_1 = card.chooseDocCategroy(selectFieldId);
            main = category_1.mainCategory;
            sub = category_1.subCategory;
            sec = category_1.secCategory;
            maxUploadSize = category_1.maxUploadSize;
            mes = category_1.msg;
        }
        else {
            main = docCategroy.mainCategory;
            sub = docCategroy.subCategory;
            sec = docCategroy.secCategory;
            maxUploadSize = docCategroy.maxUploadSize;
            mes = docCategroy.msg;
        }
        var flag = (parseInt(main, 0) != 0 && !isNaN(parseInt(main, 0)) && parseInt(main, 0) != -1)
            || (parseInt(sub, 0) != 0 && !isNaN(parseInt(sub, 0)) && parseInt(sub, 0) != -1)
            || (parseInt(sec, 0) != 0 && !isNaN(parseInt(sec, 0)) && parseInt(sec, 0) != -1);
        if (!flag && viewAttr != "1") {
            if (!mes) {
                mes = getLabel(83157, "附件上传目录未设置") + "!";
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#ff0000' }, id: fieldName },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { position: "relative", display: "inline-block" } },
                        mes,
                        " ",
                        viewAttr == 3 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "required" }))));
        }
        category = main + "," + sub + "," + sec;
        var uploadUrl = "/api/formmode/card/docUpload?detailtype=" + fieldtype + "&category=" + category + "&mainId=" + main + "&subId=" + sub + "&secId=" + sec;
        var baseProps = {};
        baseProps.showBatchLoad = card.base.type != '1' && !isdetail ? showBatchLoad : false;
        // baseProps.showClearAll = !isdetail;
        baseProps.showClearAll = false;
        baseProps.uploadUrl = uploadUrl;
        baseProps.maxUploadSize = maxUploadSize;
        baseProps.category = category;
        if (base.type == '0' && viewAttr != '1') {
            baseProps.datas = Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["toJS"])(filedatas).map(function (item) {
                return __assign({}, item, { showDelete: true });
            });
        }
        else {
            baseProps.datas = filedatas.slice();
        }
        if (!value) {
            baseProps.datas = []; //清空value，也需将datas置空
            filedatas && filedatas.length > 0 && this.clearUploadData(); //清空value，需将uploadData置空
        }
        baseProps.btnSize = isdetail ? "small" : "default";
        baseProps.autoUpload = true;
        baseProps.listType = fieldtype == '2' ? "img" : "list";
        baseProps.limitType = fieldtype == "2" ? "jpg,jpeg,png,gif,bmp" : fileFormat === "0" ? "" : fileFormat;
        baseProps.uploadId = fieldName;
        // baseProps.errorMsg = mes;
        baseProps.display = true;
        if (fieldtype == '2') {
            baseProps.imgWidth = imgwidth + "px";
            baseProps.imgHeight = imgheight + "px";
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.mode-upload-wrap .wea-upload .wea-upload-imgs-item').css("padding", '0 5px 0 0');
        }
        if (!isdetail) {
            var batchLoadUrl = "/weaver/weaver.file.FileDownload?fieldvalue=" + value + "&download=1&downloadBatch=1&desrequestid=0";
            if (empowmentType == '0') { //开启临时赋权
                batchLoadUrl += "&formmode_authorize=formmode_authorize&moduleid=formmode&authorizemodeId=" + modeId + "&authorizefieldid=" + fieldid + "&authorizeformmodebillId=" + billid;
            }
            baseProps.batchLoadUrl = batchLoadUrl;
        }
        var secParams = {}; // 分级保护相关参数，仅对附件上传生效
        if (fieldtype === '1') {
            secParams = {
                secLevel: secretLevel,
                secLevelInfo: getLabel('530630', '请先填写卡片密级！'),
                showSecLevel: casProtect,
                casProtect: casProtect,
                // allowEditSec:(base.type=='1'||(base.type=='2'&&card.datastatus==1))?true:false,
                allowEditSec: false,
                oneline: !casProtect
            };
        }
        var canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
        var isDisplay = '';
        if (!canQuickedit) {
            isDisplay = 'none';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: (fieldtype == '2' ? "cube-upload-img" : "") + " " + (canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2') + "  fieldValue " + className + " mode-upload-wrap", "data-fieldattr": viewAttr, "data-fieldmark": fieldName }, cell.cellProps, { onClick: function () { canQuickedit && quickEditStore.lockEditFormItem(fieldName); } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaUpload"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaUpload@af734b" }, baseProps, bindObj.bind(), { onChange: this.doChangeEvent, isDetail: isdetail, fieldName: fieldName, viewAttr: viewAttr, showUploader: fileisdisplay == 1 ? true : false, showUploadTime: fileisdisplay == 1 ? true : false, onUploading: this.onUploading, oneline: true, editable: true, showEditButton: false, getShowListDatas: this.getShowListDatas }, secParams)),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "editicon", style: { display: isDisplay } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-edit" }))));
    };
    UploadElement = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], UploadElement);
    return UploadElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (UploadElement);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var HrefElement = /** @class */ (function (_super) {
    __extends(HrefElement, _super);
    function HrefElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HrefElement.prototype.render = function () {
        var _a = this.props, cell = _a.cell, card = _a.card, className = _a.className;
        var path = cell.getPath();
        var _b = card.getFieldProps(path), fieldtype = _b.fieldtype, _c = _b.displayname, displayname = _c === void 0 ? "" : _c, linkaddress = _b.linkaddress, _d = _b.descriptivetext, descriptivetext = _d === void 0 ? "" : _d;
        var specialFieldDom;
        if (fieldtype == "1") {
            specialFieldDom = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: linkaddress, target: "_blank", dangerouslySetInnerHTML: { __html: displayname } });
        }
        else if (fieldtype == "0" || fieldtype == "2") { //老表单有type为0的描述性文字
            specialFieldDom = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: descriptivetext } });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "specialField " + className, ref: "specialFieldSpan" }, specialFieldDom));
    };
    HrefElement = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], HrefElement);
    return HrefElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (HrefElement);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var SelLevelElement = /** @class */ (function (_super) {
    __extends(SelLevelElement, _super);
    function SelLevelElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputBlur = function (v) {
            var form = _this.props.form;
            if (/^\d+$/.test(v)) {
                __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error(getLabel('530634', '保密期限不能是纯数字'));
                form.$('field-10').onChange('');
            }
            if (!v) {
                __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error(getLabel('530064', '请填写保密期限'));
            }
        };
        _this.changeSeclevelValue = function (bindObj, v, secretTime) {
            var _a = _this.props, form = _a.form, secretTimeDefValue = _a.card.secretTimeDefValue;
            bindObj.onChange(v);
            if (secretTime) {
                form.$('field-10').onChange(secretTime);
            }
            else {
                switch (v) {
                    case '1':
                        form.$('field-10').onChange(secretTimeDefValue[v]);
                        break;
                    case '2':
                        form.$('field-10').onChange(secretTimeDefValue[v]);
                        break;
                    default:
                        form.$('field-10').onChange('10年');
                        break;
                }
            }
        };
        return _this;
    }
    SelLevelElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card, className = _a.className /*, excel*/;
        var path = cell.getPath();
        var bindObj = form.$(path);
        var fieldName = Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["d" /* getDomIdByFieldKey */])(bindObj.path);
        var secretTimeDefValue = card.secretTimeDefValue, secretTimeDefStyle = card.secretTimeDefStyle;
        var _b = bindObj.bind(), value = _b.value, _viewAttr = _b.viewAttr, isEdit = _b.isEdit, isMandatory = _b.isMandatory, filtedOptions = _b.options;
        var _c = form.$('field-10').bind().value, value1 = _c === void 0 ? '' : _c;
        var _d = card.getFieldProps(path), options = _d.options, fieldshowtypes = _d.fieldshowtypes;
        var viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        var realOptions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isArray(filtedOptions) ? filtedOptions : options;
        realOptions = realOptions.filter(function (f) { return f.cancel != '1'; });
        if (viewAttr == '1') {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "select" + fieldName, className: 'cube-card-editformitem2' + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName, style: __assign({ float: 'left' }, cell.cellProps.style) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@a0hxy1", className: 'cube-card-select', options: [{ key: '', showname: '' }].concat(realOptions), fieldName: fieldName, viewAttr: 1, fieldshowtypes: fieldshowtypes, value: value, onChange: bindObj.onChange, style: { float: 'left' }, 
                    // {...layoutProps}
                    supportCancel: true }),
                ['1', '2'].indexOf(value) > -1 && secretTimeDefStyle[value] == '0' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: 'inline-block', marginRight: 12, height: 28 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { margin: '0px 5px' }, className: "icon-coms-Collection2" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { display: 'inline-block', marginTop: 1, marginBottom: 1 } }, value1 || secretTimeDefValue[value]))));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (this && this.props && this.props.ecId || '') + "_Fragment@3d2vcr" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "select" + fieldName, className: 'cube-card-editformitem2' + " fieldValue " + className, "data-fieldattr": viewAttr, "data-fieldmark": fieldName, style: __assign({ float: 'left' }, cell.cellProps.style) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@f7pubx", className: 'cube-card-select', options: [{ key: '', showname: '' }].concat(realOptions), fieldName: fieldName, viewAttr: viewAttr, fieldshowtypes: fieldshowtypes, value: value, onChange: function (v) {
                        if (value && (value < v || v == '')) { // 高密级切换低密级，需清除数据
                            var mythis_1 = _this;
                            var _secretTime_1 = form.$('field-10').value;
                            __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].confirm({
                                title: getLabel('131329', '信息确认'),
                                content: getLabel('530633', '变更密级，高于当前卡片密级的关联资源会被清除，附件密级将自动调整为修改的密级，确定要调整吗？'),
                                onOk: function () {
                                    /**   明细清空时需保留dtl_id  start ****/
                                    var _dtlIdArr = {};
                                    form.map(function (field) {
                                        if (field.key.startsWith('detail_')) {
                                            var _detailArr = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(field.value, 'dtl_id');
                                            _dtlIdArr[field.key] = _detailArr;
                                        }
                                    });
                                    mythis_1.props.card.cubeForm.clearCubeFields();
                                    var _loop_1 = function (key) {
                                        form.$(key).map(function (item, index) {
                                            form.setValue(item.path + ".dtl_id", _dtlIdArr[key][index], true);
                                        });
                                    };
                                    for (var key in _dtlIdArr) {
                                        _loop_1(key);
                                    }
                                    /*****   end   *****/
                                    mythis_1.changeSeclevelValue(bindObj, v);
                                },
                                onCancel: function () {
                                    mythis_1.changeSeclevelValue(bindObj, value, _secretTime_1);
                                }
                            });
                        }
                        _this.changeSeclevelValue(bindObj, v);
                    }, style: { width: 100 }, 
                    // {...layoutProps}
                    supportCancel: true })),
            ['1', '2'].indexOf(value) > -1 && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "selectfield-10", className: 'cube-card-editformitem2' + " fieldValue " + ((form.$('field-10').isValid || !!form.$('field-10').value) ? 'cube-check-valid' : 'cube-check-error'), "data-fieldattr": viewAttr, "data-fieldmark": 'field-10', style: __assign({ float: 'left', marginLeft: 10 }, cell.cellProps.style) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInput"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@7mkgke", helpfulTip: getLabel('528340', '保密期限填写格式：3个月、10年、20年、长期…不能是纯数字'), value: value1, style: { width: 143 }, viewAttr: viewAttr, onChange: form.$('field-10').onChange, onBlur: this.handleInputBlur })))));
    };
    SelLevelElement = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], SelLevelElement);
    return SelLevelElement;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (SelLevelElement);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PopoverTips__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailTBody__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailTHead__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DetailPagination__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DetailTop__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_excelUtil2__ = __webpack_require__(166);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




// import ExcelTableColgroupTr from './ColgroupTr';



var getLabel = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaLocaleProvider"].getLabel;






var ExcelTableCellDetailTable = /** @class */ (function (_super) {
    __extends(ExcelTableCellDetailTable, _super);
    function ExcelTableCellDetailTable(props) {
        var _this = _super.call(this, props) || this;
        _this.dref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
        // componentWillUnmount() {
        //     const { card } = this.props;
        //     const contents = document.querySelectorAll('.excelDetailContent');
        //     const heads = document.querySelectorAll('.excelDetailFixedHead');
        //     if (card.base.type != "4") {
        //         for (let i = 0; i < contents.length; i++) {
        //             contents[i].removeEventListener('scroll', function () {
        //                 heads[i].scrollLeft = contents[i].scrollLeft;
        //             });
        //         }
        //     }
        // }
        // componentDidUpdate() {
        //     const { card } = this.props;
        //     const contents = document.querySelectorAll('.excelDetailContent');
        //     const heads = document.querySelectorAll('.excelDetailFixedHead');
        //     if (card.base.type != "4") {
        //         for (let i = 0; i < contents.length; i++) {
        //             contents[i].scrollLeft = heads[i].scrollLeft;
        //         }
        //     }
        // }
        _this.hasFooter = function () {
            var _a = _this.props, cell = _a.cell, card = _a.card;
            var excel = card.modeExcel.getExcel(cell.detail);
            var _b = excel || {}, _c = _b.edtailinrow, edtailinrow = _c === void 0 ? '0' : _c, _d = _b.seniorset, seniorset = _d === void 0 ? '0' : _d, _e = _b.rows, rows = _e === void 0 ? [] : _e;
            var bodyRow = parseInt(edtailinrow, 0);
            var isSeniorset = seniorset == '1';
            var _rowhead = rows.slice();
            var rowIndexArr = [];
            _rowhead.map(function (row) {
                var rowIndex = Object(__WEBPACK_IMPORTED_MODULE_8__util_typeUtil__["e" /* getRowIndex */])(row.id);
                rowIndexArr.push(rowIndex);
            });
            var max = Math.max.apply(null, rowIndexArr);
            if (isSeniorset && max > bodyRow) {
                return true;
            }
            return false;
        };
        _this.onDrop = function (datas, dataIdx, downIdx, data) {
            var _a = _this.props, cell = _a.cell, card = _a.card;
            if (card.cubeForm.has(cell.detail)) {
                card.cubeForm.$(cell.detail).isDrag = true;
            }
            var index = cell.detail && cell.detail.replace('detail_', '');
            //修正序号
            __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#oTable" + index + " tbody tr").each(function (item, e) {
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()(e).find('td span[class="serialNumber"] ').text((item + 1));
            });
        };
        _this.getKeyFromData = function (record, index) {
            return index;
        };
        _this.getKeyFromDom = function (dom) {
            var _a = _this.props, cell = _a.cell, card = _a.card;
            var excel = card.modeExcel.getExcel(cell.detail);
            return excel.isHaveDetailCheck ? __WEBPACK_IMPORTED_MODULE_9_jquery___default()("span.icon-coms-move", dom).attr("data-index")
                : __WEBPACK_IMPORTED_MODULE_9_jquery___default()(dom).attr("data-rowindex");
        };
        /**对滚动条进行监听 */
        _this.scrollListen = function (e, fixFieldIndex) {
            if (fixFieldIndex == undefined || fixFieldIndex < 0)
                return true;
            var scroll = __WEBPACK_IMPORTED_MODULE_9_jquery___default()(e.target).scrollLeft();
            if (scroll == 0) {
                //    jQuery(jQuery(e.target).parent().find("#fixField")).css({ "box-shadow": "none", "-webkit-box-shadow": "none" });
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(e.target).parent().find(".excelDetailTableArea_locked")).css({ borderRight: "0px solid", "box-shadow": "none" });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(e.target).parent().find(".excelDetailTableArea_locked")).css({ "box-shadow": "6px 0 6px hsla(0,0%,39%,0.2)" });
            }
        };
        _this.state = {
            isDetailPagePositionInit: false,
        };
        return _this;
    }
    ExcelTableCellDetailTable.prototype.componentDidMount = function () {
        //处理滚动条的问题，考虑除打印布局外的情况
        var card = this.props.card;
        var contents = document.querySelectorAll('.excelDetailContent');
        var heads = document.querySelectorAll('.excelDetailFixedHead');
        if (card.base.type != "4") {
            var _loop_1 = function (i) {
                contents[i].addEventListener('scroll', function () {
                    heads[i].scrollLeft = contents[i].scrollLeft;
                });
            };
            for (var i = 0; i < contents.length; i++) {
                _loop_1(i);
            }
            //    let url=WeaTools.WindowFunc.getTop().location.href;
            __WEBPACK_IMPORTED_MODULE_9_jquery___default()(".excelDetailTable_wrap").each(function () {
                var _a;
                var groupid = parseInt(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).attr("data-groupid")) || parseInt(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).parent().attr("data-groupid"));
                var isDrag = card.modeExcel.isDragulaMap && card.modeExcel.isDragulaMap["detail_" + groupid] || false;
                var excelDetailContent = __WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).find(".excelDetailContent");
                var swapWidth = excelDetailContent.width();
                var dataAreaWidth = excelDetailContent.find("#oTable" + groupid).width();
                var lockedAreaWidth = __WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).parent().find("#fixArea_" + groupid) && __WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).parent().find("#fixArea_" + groupid).width() || -1;
                var detailObj = { "forceDisabledLocked": false };
                if ((lockedAreaWidth > -1) && (swapWidth > 0) && (swapWidth <= lockedAreaWidth)) { //锁定宽度过大，锁定列失效
                    detailObj["forceDisabledLocked"] = true;
                    !isDrag && __WEBPACK_IMPORTED_MODULE_12__util_excelUtil2__["a" /* modeForm_pc */].showMessage(getLabel(514714, "锁定列已超出明细$s可显示宽度，锁定列失效").replace("$s", groupid + ""), 1, 1);
                }
                else if (swapWidth >= dataAreaWidth) { //宽度不足，横向滚动条失效
                    detailObj["forceDisabledLocked"] = true;
                }
                if (!card.modeExcel.detailMap["detail_" + groupid]) {
                    card.modeExcel.detailMap = __assign({}, card.modeExcel.detailMap, (_a = {}, _a["detail_" + groupid] = detailObj, _a));
                }
            });
        }
        var node = this.dref;
        Object(__WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__["a" /* calculateDetailAreaStyle */])(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(node).parent());
    };
    ExcelTableCellDetailTable.prototype.componentDidUpdate = function () {
        var that = this;
        !this.state.isDetailPagePositionInit && __WEBPACK_IMPORTED_MODULE_9_jquery___default()(".excelDetailTable_wrap").each(function () {
            if (__WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).find('.cube-detail-paging').length > 0) {
                var contentwidth = __WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).find('.excelDetailContent').width();
                var scrollwidth = __WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).find('.excelDetailContent')[0].scrollWidth;
                if (contentwidth >= scrollwidth && contentwidth !== 0) {
                    __WEBPACK_IMPORTED_MODULE_9_jquery___default()(this).find(".cube-detail-paging").css('bottom', '5px');
                }
                that.setState({ isDetailPagePositionInit: true });
            }
        });
    };
    ExcelTableCellDetailTable.prototype.randerTable = function (classNames, tableid, newWidth, excel, spinning, isNeedPagination) {
        var _a = this.props, cell = _a.cell, card = _a.card;
        var form = card.cubeForm.$(cell.detail);
        var isDrag = Object(__WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__["f" /* isDragula */])(card, cell.detail);
        if (isDrag) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaDragula"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDragula@1acjsh", container: ".detailtbody", canDrag: function (target) {
                    return excel.isHaveDetailCheck ?
                        __WEBPACK_IMPORTED_MODULE_9_jquery___default()(target).hasClass("icon-coms-move")
                        : __WEBPACK_IMPORTED_MODULE_9_jquery___default()(target).closest("tr");
                }, datas: form.values(), getKeyFromData: this.getKeyFromData, getKeyFromDom: this.getKeyFromDom, onDrop: this.onDrop },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", __assign({ className: classNames, id: tableid }, { name: tableid }, { style: { minWidth: "100%", width: newWidth } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DetailTHead__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTHead@ehrhpj", card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination, isFixFieldDiv: false }),
                    !spinning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTBody__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTBody@c2ybfh", key: form.forceRender, card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination, isFixFieldDiv: false })));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", __assign({ className: classNames, id: tableid }, { name: tableid }, { style: { minWidth: "100%", width: newWidth } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DetailTHead__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTHead@mqwibu", card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination, isFixFieldDiv: false }),
                !spinning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTBody__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTBody@85m8y7", key: form.forceRender, card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination, isFixFieldDiv: false }));
        }
    };
    ExcelTableCellDetailTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, cell = _a.cell, card = _a.card;
        var getDetailFormValues = card.getDetailFormValues;
        var classNames = 'excelDetailTable';
        var wrapClassNames = 'excelDetailTable_wrap';
        var excel = card.modeExcel.getExcel(cell.detail);
        var detailMap = card.modeExcel.detailMap;
        var index = cell.detail && cell.detail.replace('detail_', '');
        var detailObj = detailMap[cell.detail];
        var tableid = "oTable" + index;
        var spinning = !cell.detail || !card.cubeForm.has(cell.detail);
        var style = cell.style || {};
        var _b = excel.detailProps.isPagination, isPagination = _b === void 0 ? false : _b;
        var form = card.cubeForm.$(cell.detail);
        var fixFieldIndex = excel.fixFieldIndex;
        var detailVals = getDetailFormValues(form).lentgh || 0;
        var contentstyle = detailVals > 0 ? { minHeight: '32px' } : {};
        var isNeedPagination = (card.base.type == '0' || card.base.type == '1' || card.base.type == '2') && isPagination;
        var newWidth = '100%';
        var supportLockedCol = excel.edlockedcol || -1;
        var forceDisabledLocked = detailObj && detailObj["forceDisabledLocked"] !== false; //列宽超过，是否强制不显示锁定列
        var isDrag = Object(__WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__["f" /* isDragula */])(card, cell.detail);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@fvntlg", spinning: spinning, style: { width: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PopoverTips__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_PopoverTips@ux9geh", error: excel.error, type: "error", label: "" + (getLabel(17463, "明细") + index) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { ref: function (ref) { _this.dref = ref; }, className: "cube-detail" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DetailTop__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_DetailTop@e5aheo", card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "excelDetailTableDiv", id: "dTableArea_" + index, "data-groupid": index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: wrapClassNames, style: {
                                width: '100%', overflowX: 'auto', msOverflowStyle: 'scrollbar',
                                borderBottom: isNeedPagination ? style.borderLeft || '1px solid #90badd' : 'none',
                                paddingBottom: isNeedPagination ? "45px" : "0px"
                            }, onScroll: function () { return _this.scrollListen(event, fixFieldIndex); } },
                            card.base.type != "4" &&
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "excelDetailFixedHead" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "excelDetailTable", id: tableid + "_head", style: { minWidth: "100%", width: newWidth } }, !spinning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DetailTHead__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTHead@no4v0a", card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination, isFixFieldDiv: false }))),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: card.base.type != "4" ? "excelDetailContent" : "" },
                                this.randerTable(classNames, tableid, newWidth, excel, spinning, isNeedPagination),
                                isNeedPagination &&
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DetailPagination__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_DetailPagination@z13m88", card: card, cell: cell, form: form }))),
                        !forceDisabledLocked && supportLockedCol >= 0 && !isDrag && card.base.type != "4" &&
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "fixArea_" + index, className: "excelDetailTableArea_locked", style: __assign({}, contentstyle, { position: "absolute", left: "0", top: "0", overflow: "hidden", background: "#FFFFFF", width: excel.fixFieldWidth }) },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "excelDetailFixedHead_locked", style: { width: excel.fixFieldWidth } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "excelDetailTable", id: tableid + "_head_locked", style: { minWidth: "100%", width: excel.fixFieldWidth } }, !spinning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DetailTHead__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTHead@s1igy8", card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination, isFixFieldDiv: true }))),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: card.base.type != "4" ? "excelDetailContent" : "", style: __assign({}, contentstyle, { overflow: "hidden" }) },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", __assign({ className: classNames, id: tableid + "_locked" }, { name: tableid }, { style: { minWidth: "100%", width: excel.fixFieldWidth } }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DetailTHead__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTHead@id0j66", card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination, isFixFieldDiv: true }),
                                        !spinning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTBody__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableCellDetailTBody@hv2o1n", key: form.forceRender, card: card, excel: excel, form: form, detail: cell.detail, isNeedPagination: isNeedPagination, isFixFieldDiv: true })))))))));
    };
    ExcelTableCellDetailTable = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCellDetailTable);
    return ExcelTableCellDetailTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellDetailTable);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableTds__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_cubeUtil__ = __webpack_require__(19);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ExcelTableCellDetailTBody = /** @class */ (function (_super) {
    __extends(ExcelTableCellDetailTBody, _super);
    function ExcelTableCellDetailTBody(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTableTrs = function () {
            var flag = _this.state.flag;
            var _a = _this.props, excel = _a.excel, form = _a.form, card = _a.card, detail = _a.detail, isNeedPagination = _a.isNeedPagination, isFixFieldDiv = _a.isFixFieldDiv;
            var formValues = card.getDetailFormValues(form);
            var _b = excel || {}, _c = _b.edtitleinrow, edtitleinrow = _c === void 0 ? '0' : _c, _d = _b.edtailinrow, edtailinrow = _d === void 0 ? '0' : _d, _e = _b.seniorset, seniorset = _e === void 0 ? '0' : _e, _f = _b.rows, rows = _f === void 0 ? [] : _f;
            var headRow = parseInt(edtitleinrow, 0);
            var bodyRow = parseInt(edtailinrow, 0);
            var isSeniorset = seniorset == '1';
            var _rowhead = rows.slice();
            if (headRow == 0 || bodyRow == 0 || bodyRow <= headRow) {
                return ([[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "\u5BF9\u4E0D\u8D77\uFF0C\u8868\u5934\u6807\u8BC6\u3001\u8868\u5C3E\u6807\u8BC6\u8BBE\u7F6E\u5F02\u5E38\uFF0C\u65E0\u6CD5\u6E32\u67D3\u660E\u7EC6\uFF01")]]);
            }
            var isDrag = Object(__WEBPACK_IMPORTED_MODULE_5__util_cubeUtil__["f" /* isDragula */])(card, detail);
            var pageSize = Number(form.pageSize);
            var pageNum = Number(form.pageNum);
            return excel ? _rowhead.map(function (row) {
                var rowIndex = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id);
                var trs = [];
                var rowspanJson = {};
                var mergeFields = excel.mergeFields;
                var supportLockedCol = excel.edlockedcol || -1;
                // mergeFields = [{fieldid:'field32356',fieldIndex:5}];
                if (rowIndex == headRow + 1) {
                    //对明细表数据进行遍历，获取对应行的rowspan
                    if (!flag) {
                        if (isNeedPagination) {
                            var count = mergeFields && mergeFields.count || 0;
                            for (var i = (pageSize * pageNum - pageSize); i <= (pageSize * pageNum - 1); i++) {
                                if (i < formValues.length) {
                                    for (var j = 0.; j < count; j++) {
                                        if (mergeFields[j] === undefined) {
                                            continue;
                                        }
                                        var ffieldid = 'field' + mergeFields[j].fieldid;
                                        if (card.fieldsProps && card.fieldsProps[ffieldid] === undefined) {
                                            continue;
                                        }
                                        var fieldObj = card.fieldsProps[ffieldid];
                                        var fieldViewOnly = fieldObj && fieldObj["isedit"];
                                        if ((fieldViewOnly == '' || fieldViewOnly == '0') && !isDrag) { //只读且未开启明细表拖动排序
                                            rowspanJson = _this.getRowspan(formValues, i, (pageSize * pageNum - 1), mergeFields[j].fieldIndex, 'field' + mergeFields[j].fieldid, rowspanJson);
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            //对明细表数据进行遍历，获取对应行的rowspan
                            // mergeFields = [{fieldid:'field32356',fieldIndex:5}];
                            for (var i = 0; i <= formValues.length; i++) {
                                if (i < formValues.length && mergeFields && mergeFields.count) {
                                    for (var j = 0.; j < mergeFields.count; j++) {
                                        if (mergeFields[j] === undefined) {
                                            continue;
                                        }
                                        var ffieldid = 'field' + mergeFields[j].fieldid;
                                        if (card.fieldsProps && card.fieldsProps[ffieldid] === undefined) {
                                            continue;
                                        }
                                        var fieldObj = card.fieldsProps[ffieldid];
                                        var fieldViewOnly = fieldObj && fieldObj["isedit"];
                                        if ((fieldViewOnly == '' || fieldViewOnly == '0') && !isDrag) { //只读且未开启明细表拖动排序
                                            rowspanJson = _this.getRowspan(formValues, i, formValues.length, mergeFields[j].fieldIndex, 'field' + mergeFields[j].fieldid, rowspanJson);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    //位于表头表尾标识之间
                    form.map(function (detailRow, j) {
                        /***
                         * ljc -- 针对快速编辑，加个样式做判断,
                         * dtl_id 是uuid的时候加个class，暂时未保存的
                         * **/
                        var dtl_id = card.getDetailFormValues(detailRow)['dtl_id'] || "";
                        var trClass = dtl_id.length > 30 ? "detail_data_editing" : "";
                        //明细奇偶行加class方便二开重写
                        trClass += " " + ((j + 1) % 2 === 0 ? "detail_even_row detail_data_row" : "detail_odd_row detail_data_row");
                        if (detail && card.detailMap[detail] && card.detailMap[detail]["row_" + detailRow.key]) {
                            var needHide = card.detailMap[detail]["row_" + detailRow.key].needHide;
                            if (needHide === true) //隐藏明细
                                trClass += " interface_hide";
                        }
                        if (isNeedPagination) { //新建，显示，编辑布局分页展示
                            if (j >= (pageSize * pageNum - pageSize) && j <= (pageSize * pageNum - 1)) { //明细表数据分页显示控制
                                for (var i = rowIndex; i < bodyRow; i++) {
                                    trs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: { height: row.size }, className: trClass, "data-rowindex": detailRow.key },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableTds__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableTds@b8274w@" + i, detailIndex: j, row: i, card: card, excel: excel, form: detailRow, detail: detail, isFixFieldDiv: isFixFieldDiv, rowspanJson: rowspanJson, isTitle: false })));
                                }
                            }
                        }
                        else {
                            for (var i = rowIndex; i < bodyRow; i++) {
                                /***判断是否行合并单元格 */
                                trs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: { height: row.size }, className: trClass, "data-rowindex": detailRow.key },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableTds__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableTds@di4wzg@" + i, detailIndex: j, row: i, card: card, excel: excel, form: detailRow, detail: detail, isFixFieldDiv: isFixFieldDiv, rowspanJson: rowspanJson, isTitle: false })));
                            }
                        }
                    });
                    if (detail && supportLockedCol > -1) {
                        var groupid = detail.replace('detail_', '');
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_excelUtil__["syncLockedForDidMount"])(groupid);
                    }
                    return trs;
                }
                else if (rowIndex < headRow || (isSeniorset && rowIndex > bodyRow)) { //开启合计的情况
                    if (rowIndex < headRow) {
                        return;
                    } //判断有合计的情况合计放在下面
                    //对明细表数据进行遍历，获取对应行的rowspan
                    var rowspanJson_1 = {};
                    trs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: { height: row.size } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableTds__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableTds@m783zm@" + row.id, row: Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id), card: card, excel: excel, form: card.cubeForm, detail: detail, isFixFieldDiv: isFixFieldDiv, rowspanJson: rowspanJson_1, isTitle: true })));
                }
                return trs;
            }) : [];
        };
        /**获取rowspan数据 */
        _this.getRowspan = function (formValues, i, maxIndex, fieldIndex, fieldId, rowspanJson) {
            //  rowspanJson格式：  {1:[{fieldIndex:5,rowspan:'2'}，{fieldIndex:6,rowspan:'0'}]}
            //  rowspanJson[i]格式：  [{fieldIndex:5,rowspan:'2'}，{fieldIndex:6,rowspan:'0'}] -- 表示 第i行的设置
            //1.从当前行往下遍历,有相同，则rowspan值+1
            var rowspanvalue = 1;
            for (var j = i + 1; j <= maxIndex; j++) {
                if (j >= formValues.length)
                    break;
                if (formValues[i] && formValues[i][fieldId] && formValues[i][fieldId] != "" && (formValues[i][fieldId] === formValues[j][fieldId])) {
                    // console.log("formValues[i][fieldId]:"+"i:"+i+"fieldId:"+fieldId+"value:"+formValues[i][fieldId]+" | | formValues[j][fieldId]:"+"j:"+j+"fieldId:"+fieldId+"value:"+formValues[j][fieldId]);
                    //2.如果当前行数据与下一行数据相同，则当前行rowspan值+1，下一行rowspan值=0
                    rowspanvalue++;
                    //2.1当前行(第i行)rowspan值+1
                    if (rowspanJson[i] == undefined) {
                        rowspanJson[i] = [];
                        var colIndexAndRowspan = {};
                        colIndexAndRowspan[fieldIndex] = rowspanvalue;
                        rowspanJson[i].push(colIndexAndRowspan);
                    }
                    else {
                        var needAddField = true;
                        //多个列需要进行行合并时，需要遍历一次，找到需要修改的列
                        for (var a = 0; a < rowspanJson[i].length; a++) {
                            //如果当前td的rowspan已经被设置为0，则说明为被合并的行，不需要再做处理
                            if (rowspanJson[i][a][fieldIndex] == 0) {
                                needAddField = false;
                                break;
                            }
                            //若存在此列的值，则直接覆盖原数据
                            if (rowspanJson[i][a][fieldIndex] != undefined) {
                                rowspanJson[i][a][fieldIndex] = rowspanvalue;
                                needAddField = false;
                                break;
                            }
                        }
                        //若不存在此列的设置，则新增
                        if (needAddField) {
                            var colIndexAndRowspan = {};
                            colIndexAndRowspan[fieldIndex] = rowspanvalue;
                            rowspanJson[i].push(colIndexAndRowspan);
                        }
                    }
                    //2.2被合并行(j=i+1)rowspan值 为0
                    if (rowspanJson[j] == undefined) {
                        rowspanJson[j] = [];
                        var colIndexAndRowspan = {};
                        colIndexAndRowspan[fieldIndex] = 0;
                        rowspanJson[j].push(colIndexAndRowspan);
                    }
                    else {
                        var needAddField = true;
                        //多个列需要进行行合并时，需要遍历一次，找到需要修改的列
                        for (var a = 0; a < rowspanJson[j].length; a++) {
                            //如果当前td的rowspan已经被设置为0，则说明为被合并的行，不需要再做处理
                            if (rowspanJson[j][a][fieldIndex] == 0)
                                break;
                            //若存在此列的值，则直接覆盖原数据
                            if (rowspanJson[j][a][fieldIndex] != undefined) {
                                rowspanJson[j][a][fieldIndex] = 0;
                                needAddField = false;
                                break;
                            }
                        }
                        //若不存在此列的设置，则新增
                        if (needAddField) {
                            var colIndexAndRowspan = {};
                            colIndexAndRowspan[fieldIndex] = 0;
                            rowspanJson[j].push(colIndexAndRowspan);
                        }
                    }
                }
                else {
                    break;
                }
                if (rowspanJson[0] != undefined && rowspanJson[0][1] != undefined && rowspanJson[0][1][3] != undefined) {
                    // console.log("formValues[i][fieldId]:"+"i:"+i+"fieldId:"+fieldId+"value:"+formValues[i][fieldId]+" || || formValues[j][fieldId]:"+"j:"+j+"fieldId:"+fieldId+"value:"+formValues[j][fieldId]);
                }
            }
            return rowspanJson;
        };
        _this.state = {
            needRowspan: true,
            flag: false
        };
        return _this;
    }
    ExcelTableCellDetailTBody.prototype.componentWillUnmount = function () {
        this.setState({ flag: true });
    };
    ExcelTableCellDetailTBody.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", { className: "detailtbody" }, this.renderTableTrs()));
    };
    ExcelTableCellDetailTBody = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCellDetailTBody);
    return ExcelTableCellDetailTBody;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellDetailTBody);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableTds__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColgroupTr__ = __webpack_require__(484);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var ExcelTableCellDetailTHead = /** @class */ (function (_super) {
    __extends(ExcelTableCellDetailTHead, _super);
    function ExcelTableCellDetailTHead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTableTrs = function () {
            var _a = _this.props, excel = _a.excel, card = _a.card, detail = _a.detail, isFixFieldDiv = _a.isFixFieldDiv;
            var _b = excel || {}, _c = _b.edtitleinrow, edtitleinrow = _c === void 0 ? '0' : _c, _d = _b.edtailinrow, edtailinrow = _d === void 0 ? '0' : _d, _e = _b.rows, rows = _e === void 0 ? [] : _e;
            var headRow = parseInt(edtitleinrow, 0);
            var bodyRow = parseInt(edtailinrow, 0);
            var _rowhead = rows.slice();
            if (headRow == 0 || bodyRow == 0 || bodyRow <= headRow) {
                return ([[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "\u5BF9\u4E0D\u8D77\uFF0C\u8868\u5934\u6807\u8BC6\u3001\u8868\u5C3E\u6807\u8BC6\u8BBE\u7F6E\u5F02\u5E38\uFF0C\u65E0\u6CD5\u6E32\u67D3\u660E\u7EC6\uFF01")]]);
            }
            return excel ? _rowhead.map(function (row) {
                var rowIndex = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id);
                var trs = [];
                if ((rowIndex == (headRow == 2 ? headRow + 1 : headRow)) || rowIndex == 0 && headRow != 1) { //针对行合并处理
                    return;
                }
                else if (rowIndex < headRow) { //只遍历头部信息，合计放在下面
                    trs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: { height: row.size } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableTds__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableTds@brxt7l@" + rowIndex, row: Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id), card: card, excel: excel, form: card.cubeForm, detail: detail, isFixFieldDiv: isFixFieldDiv, isTitle: true })));
                }
                return trs;
            }) : [];
        };
        return _this;
    }
    ExcelTableCellDetailTHead.prototype.render = function () {
        var _a = this.props, excel = _a.excel, isFixFieldDiv = _a.isFixFieldDiv;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ColgroupTr__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableColgroupTr@geqd8x", excel: excel, isFixFieldDiv: isFixFieldDiv }),
            this.renderTableTrs()));
    };
    ExcelTableCellDetailTHead = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCellDetailTHead);
    return ExcelTableCellDetailTHead;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellDetailTHead);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ExcelTableColgroupTr = /** @class */ (function (_super) {
    __extends(ExcelTableColgroupTr, _super);
    function ExcelTableColgroupTr() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExcelTableColgroupTr.prototype.render = function () {
        var _a = this.props, excel = _a.excel, isFixFieldDiv = _a.isFixFieldDiv;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { className: "detailControlWidth" }, excel && excel.cols.slice().map(function (_a, index) {
            var size = _a.size, hide = _a.hide;
            var fixFieldIndex = excel.fixFieldIndex || 0;
            if (isFixFieldDiv && index > fixFieldIndex) {
                return;
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { display: hide && hide === "y" ? "none" : "", width: size } }));
        })));
    };
    ExcelTableColgroupTr = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableColgroupTr);
    return ExcelTableColgroupTr;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableColgroupTr);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var DetailPagination = /** @class */ (function (_super) {
    __extends(DetailPagination, _super);
    function DetailPagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageSizeOptions = ['10', '20', '30', '50', '100'];
        _this.total = function (total) { return " " + (getLabel(18609, "共") + total + ' ' + getLabel(18256, "条")) + " "; };
        _this.onChange = function (current) {
            var form = _this.props.form;
            form.pageNum = current;
        };
        _this.showSizeChange = function (current, pagesize) {
            var _a = _this.props, form = _a.form, card = _a.card, cell = _a.cell;
            form.pageNum = current;
            form.pageSize = pagesize;
            card.saveDetailPageSize(pagesize, cell.detail);
        };
        return _this;
    }
    DetailPagination.prototype.render = function () {
        var form = this.props.form;
        var total = form.values().length;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-detail-paging" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Pagination"], { ecId: (this && this.props && this.props.ecId || '') + "_Pagination@bmxfw6", showSizeChanger: true, showQuickJumper: true, total: total, current: form.pageNum, defaultCurrent: 1, showTotal: this.total, pageSize: form.pageSize, pageSizeOptions: this.pageSizeOptions, onChange: this.onChange, onShowSizeChange: this.showSizeChange })));
    };
    DetailPagination = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DetailPagination);
    return DetailPagination;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DetailPagination);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableTds__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var DetailTop = /** @class */ (function (_super) {
    __extends(DetailTop, _super);
    function DetailTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTableTrs = function () {
            var _a = _this.props, excel = _a.excel, card = _a.card, detail = _a.detail;
            var _b = excel || {}, _c = _b.edtitleinrow, edtitleinrow = _c === void 0 ? '0' : _c, _d = _b.edtailinrow, edtailinrow = _d === void 0 ? "0" : _d, _e = _b.rows, rows = _e === void 0 ? [] : _e;
            var headRow = parseInt(edtitleinrow, 0);
            var bodyRow = parseInt(edtailinrow, 0);
            var _rowhead = rows.slice();
            if (headRow == 0 || bodyRow == 0 || bodyRow <= headRow) {
                return ([[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "\u5BF9\u4E0D\u8D77\uFF0C\u8868\u5934\u6807\u8BC6\u3001\u8868\u5C3E\u6807\u8BC6\u8BBE\u7F6E\u5F02\u5E38\uFF0C\u65E0\u6CD5\u6E32\u67D3\u660E\u7EC6\uFF01")]]);
            }
            return excel ? _rowhead.map(function (row) {
                var rowIndex = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id);
                var trs = [];
                if (rowIndex == headRow + 1) {
                    return;
                }
                else if (rowIndex < (headRow == 2 ? headRow - 1 : 1)) { //当头部出现合并行后锁定列要多减1
                    trs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: { height: row.size }, className: "cube-detailbtn-edit-tr" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableTds__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ExcelTableTds@fafq4j@" + rowIndex, row: Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["e" /* getRowIndex */])(row.id), card: card, excel: excel, form: card.cubeForm, detail: detail, isFixFieldDiv: false, isTitle: false })));
                }
                return trs;
            }) : [];
        };
        return _this;
    }
    DetailTop.prototype.render = function () {
        var excel = this.props.excel;
        var _a = (excel || {}).edtitleinrow, edtitleinrow = _a === void 0 ? '0' : _a;
        if (edtitleinrow == '1') {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-detail-locked-btnrow" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-detail-locked-btnrow-content" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "cube-detail-locked-btnrow-table" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { className: "detailControlWidth" }, excel && excel.cols.slice().map(function (_a, index) {
                            var size = _a.size, hide = _a.hide;
                            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: { display: hide && hide === "y" ? "none" : "", width: size, } }));
                        })),
                        this.renderTableTrs()))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-detail-locked-btnrow-placeholder" })));
    };
    DetailTop = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DetailTop);
    return DetailTop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DetailTop);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var ExcelTableCellDetailButtons = /** @class */ (function (_super) {
    __extends(ExcelTableCellDetailButtons, _super);
    function ExcelTableCellDetailButtons() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.isclick = false;
        _this_1.addSapRow = function () {
        };
        _this_1.addRow = function () {
            var _a = _this_1.props, card = _a.card, excel = _a.excel;
            var params = card.params;
            var _b = (excel.detailProps || {}).orderid, orderid = _b === void 0 ? '' : _b;
            card.cubeForm.addRow(orderid, params.type);
        };
        _this_1.delRow = function () {
            var _a = _this_1.props, card = _a.card, excel = _a.excel;
            var params = card.params;
            var _b = (excel.detailProps || {}).orderid, orderid = _b === void 0 ? '' : _b;
            card.cubeForm.delRow(orderid, params.type);
        };
        _this_1.copyRow = function () {
            if (!_this_1.isclick) {
                _this_1.isclick = true;
                var _a = _this_1.props, card = _a.card, excel = _a.excel;
                var params = card.params;
                var _b = (excel.detailProps || {}).orderid, orderid = _b === void 0 ? '' : _b;
                card.cubeForm.copyRow(orderid, params.type);
                var _this_2 = _this_1;
                setTimeout(function () {
                    _this_2.isclick = false;
                }, 500); //500ms内仅能点击一次
            }
        };
        return _this_1;
    }
    ExcelTableCellDetailButtons.prototype.render = function () {
        var _a = this.props, card = _a.card, excel = _a.excel;
        var params = card.params;
        if (params.type == '0' || params.type == '1' || params.type == '2') {
            var _b = excel.detailProps, _c = _b.isOpensapmul, isOpensapmul = _c === void 0 ? false : _c, _d = _b.isAdd, isAdd = _d === void 0 ? false : _d, _e = _b.isCopy, isCopy = _e === void 0 ? false : _e, _f = _b.orderid, orderid = _f === void 0 ? '' : _f, _g = _b.isDelete, isDelete = _g === void 0 ? false : _g;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: " " + (params.type == '0' ? 'cube-detailbtn-edit' : '') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "detailButtonDiv" },
                    isOpensapmul && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", __assign({ id: "sapmulbutton" + orderid }, { name: "sapmulbutton" + orderid }, { className: "icon-coms-form-sap detailBtn", title: "sap", onClick: this.addSapRow })),
                    isAdd && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", __assign({ id: "addbutton" + orderid }, { name: "addbutton" + orderid }, { className: "icon-coms-Add-to detailBtn", title: getLabel(611, "添加"), onClick: this.addRow })),
                    isDelete && params.type != '2' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", __assign({ id: "delbutton" + orderid }, { name: "delbutton" + orderid }, { className: "icon-coms-form-delete detailBtn", title: getLabel(91, "删除"), onClick: this.delRow })),
                    params.type == '2' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", __assign({ id: "delbutton" + orderid }, { name: "delbutton" + orderid }, { className: "icon-coms-form-delete detailBtn", title: getLabel(91, "删除"), onClick: this.delRow })),
                    isCopy && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", __assign({ id: "copybutton" + orderid }, { name: "copybutton" + orderid }, { className: "icon-coms-form-copy detailBtn", title: getLabel(77, "复制"), onClick: this.copyRow })))));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "detailButtonDiv", style: { width: "150px" } }));
    };
    ExcelTableCellDetailButtons = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCellDetailButtons);
    return ExcelTableCellDetailButtons;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellDetailButtons);


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ExcelTableCellLink = /** @class */ (function (_super) {
    __extends(ExcelTableCellLink, _super);
    function ExcelTableCellLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExcelTableCellLink.prototype.render = function () {
        var cell = this.props.cell;
        var fieldtype = cell.fieldtype;
        var field = cell.field;
        var text = cell.evalue;
        var url = "";
        url = fieldtype == '1' ? "http://" : url;
        url = fieldtype == '2' ? "https://" : url;
        url = fieldtype == '3' ? "ftp://" : url;
        url = fieldtype == '4' ? "news://" : url;
        url += field;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { target: "_blank", href: url }, text));
    };
    ExcelTableCellLink = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCellLink);
    return ExcelTableCellLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellLink);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ExcelTableCellDiv = /** @class */ (function (_super) {
    __extends(ExcelTableCellDiv, _super);
    function ExcelTableCellDiv(props) {
        var _this = _super.call(this, props) || this;
        _this.fixed = function () {
            var cell = _this.props.cell;
            if (cell.evalue != "#QRCodeImg#" && cell.evalue != "#BARCodeImg#") {
                if (cell.jsonparam && cell.jsonparam.set_height != undefined && cell.jsonparam.set_height == 'auto') {
                    var height_1 = 0;
                    _this.fixedHeight = setInterval(function () {
                        try {
                            var iframe = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(_this.refs._containter).find('iframe');
                            if (iframe[0]) {
                                var perfectHeight = iframe[0].contentWindow.perfectHeight;
                                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isFunction(perfectHeight)) {
                                    var newHeight = perfectHeight();
                                    if (newHeight && !isNaN(newHeight) && height_1 != newHeight) {
                                        height_1 = newHeight;
                                        iframe.height(newHeight);
                                        clearInterval(_this.fixedHeight);
                                    }
                                }
                            }
                        }
                        catch (e) {
                            clearInterval(_this.fixedHeight);
                        }
                    }, 100);
                }
            }
        };
        _this.getCodeImg = function () {
            var _a = _this.props, cell = _a.cell, card = _a.card;
            var etype = cell.etype;
            if (cell.evalue == "#QRCodeImg#" || cell.evalue == "#BARCodeImg#") {
                etype = "17";
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__apis_card__["u" /* getIframe */])(__assign({}, card.base, cell.jsonparam, { etype: etype, evalue: cell.evalue })).then(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, htmlstr = _a.htmlstr;
                if (status == '1') {
                    _this.setState({ innerHtml: htmlstr });
                    _this.fixed();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error("[" + errorCode + "]:" + error);
                }
            });
        };
        _this.state = {
            innerHtml: ''
        };
        return _this;
    }
    ExcelTableCellDiv.prototype.componentWillUpdate = function () {
        this.fixed();
    };
    ExcelTableCellDiv.prototype.componentDidUpdate = function () {
        var tabledom = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.refs._containter).find('table'));
        var H = tabledom.height();
        var W = tabledom.width();
        H && __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.refs._containter).css({ height: H, width: W });
    };
    ExcelTableCellDiv.prototype.componentDidMount = function () {
        var _a;
        var _b = this.props, cell = _b.cell, card = _b.card;
        this.getCodeImg();
        var key = cell.row + '_' + cell.col;
        card.modeExcel.addCodeFn((_a = {}, _a[key] = this.getCodeImg, _a));
    };
    ExcelTableCellDiv.prototype.render = function () {
        var cell = this.props.cell;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ className: "codeContainer", ref: "_containter" }, cell.cellProps, { dangerouslySetInnerHTML: { __html: this.state.innerHtml } })));
    };
    ExcelTableCellDiv = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCellDiv);
    return ExcelTableCellDiv;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellDiv);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export delcommafy */
/* unused harmony export FormatFloatValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_excel_layout_cell_field_input_element_wf_form_input_util__ = __webpack_require__(65);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * 明细合计区域
 */
var ExcelTableCellDetailSum = /** @class */ (function (_super) {
    __extends(ExcelTableCellDetailSum, _super);
    function ExcelTableCellDetailSum() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExcelTableCellDetailSum.prototype.render = function () {
        var _a = this.props, cell = _a.cell, form = _a.form, card = _a.card;
        var fieldid = cell.getPath();
        var _b = card.getFieldProps(fieldid), fieldtype = _b.fieldtype, qfws = _b.qfws, detail = _b.detail;
        var excel = card.modeExcel.getExcel(detail);
        var detailFinancialMap = excel.detailFinancialMap;
        var showSumValue = 0;
        var fieldSumValue = 0;
        var decimals = 2;
        if (fieldtype == "2")
            decimals = 0;
        else if (fieldtype == "3" || fieldtype == "5")
            decimals = parseInt(qfws, 0);
        detail && form.$(detail).map(function (row) {
            if (row.has(fieldid)) {
                var value = row.$(fieldid).getValue();
                if (fieldtype == 5) {
                    // 千分位处理
                    value = delcommafy(row.$(fieldid).getValue());
                }
                var fieldValue = parseFloat(value);
                if (!!fieldValue && !isNaN(fieldValue)) {
                    fieldSumValue += fieldValue;
                    fieldSumValue = parseFloat(fieldSumValue.toFixed(decimals));
                }
            }
        });
        var thousands = fieldtype == "5" ? 1 : 0;
        var format = cell.format; //qc:1090545,千分位保存显示不生效问题
        if (format !== undefined) {
            thousands = cell.format.thousands === "1" ? 1 : 0;
        }
        var financial = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(detailFinancialMap, fieldid);
        if (financial == '4') {
            thousands = 1;
        }
        showSumValue = FormatFloatValue(fieldSumValue, decimals, thousands);
        if (financial == '3') {
            showSumValue = __WEBPACK_IMPORTED_MODULE_3__components_excel_layout_cell_field_input_element_wf_form_input_util__["b" /* convertAmountChinese */](fieldSumValue);
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, showSumValue);
    };
    ExcelTableCellDetailSum = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ExcelTableCellDetailSum);
    return ExcelTableCellDetailSum;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableCellDetailSum);
function delcommafy(num) {
    if ((num + "").trim() == "") {
        return "";
    }
    num = num.replace(/,/gi, '');
    return num;
}
function FormatFloatValue(realval, decimals, thousands) {
    var regnum = /^(-?\d+)(\.\d+)?$/;
    if (!regnum.test(realval)) {
        return realval;
    }
    realval = realval.toFixed(decimals).toString();
    var formatval;
    if (decimals === 0) { //需取整
        formatval = Math.round(parseFloat(realval));
    }
    else {
        var n = Math.pow(10, decimals);
        formatval = Math.round(parseFloat(realval) * n) / n;
        var pindex = formatval.toString().indexOf(".");
        var pointLength = pindex > -1 ? realval.substr(pindex + 1).length : 0; //当前小数位数
        if (decimals > pointLength) { //需补零
            if (pindex == -1)
                formatval += ".";
            for (var i = 0; i < decimals - pointLength; i++) {
                formatval += "0";
            }
        }
        else if (decimals == pointLength) {
            formatval = realval;
        }
    }
    formatval = formatval.toString();
    var index = formatval.indexOf(".");
    var intPar = index > -1 ? formatval.substring(0, index) : formatval;
    var pointPar = index > -1 ? formatval.substring(index) : "";
    if (thousands === 1) { //整数位format成千分位
        var reg1 = /(-?\d+)(\d{3})/;
        while (reg1.test(intPar)) {
            intPar = intPar.replace(reg1, "$1,$2");
        }
    }
    formatval = intPar + pointPar;
    return formatval;
}


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_view_checkbox__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_cubeUtil__ = __webpack_require__(19);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var DetailCheckAll = /** @class */ (function (_super) {
    __extends(DetailCheckAll, _super);
    function DetailCheckAll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkAllChange = function (e) {
            var checked = e.target.checked;
            var _a = _this.props, detail = _a.detail, form = _a.form, excel = _a.excel;
            var isNeedPagination = _this.isNeedPagination();
            var canNotDeleteHis = false;
            if (!excel.detailProps.isDelete && detail) {
                canNotDeleteHis = true;
            }
            form.checkAll(detail, checked, isNeedPagination, canNotDeleteHis);
        };
        // 判断是否启用分页
        _this.isNeedPagination = function () {
            var _a = _this.props, card = _a.card, excel = _a.excel;
            var _b = excel.detailProps.isPagination, isPagination = _b === void 0 ? false : _b;
            return (card.base.type == '0' || card.base.type == '1' || card.base.type == '2') && isPagination;
        };
        return _this;
    }
    DetailCheckAll.prototype.render = function () {
        var _a = this.props, card = _a.card, detail = _a.detail, form = _a.form, excel = _a.excel;
        var viewAttr = card.params.type == '1' || card.params.type == '2' ? 2 : 1;
        var isNeedPagination = this.isNeedPagination();
        var _b = form.$(detail), pageNum = _b.pageNum, pageSize = _b.pageSize;
        var detailFieldValues = form.$(detail).values();
        if (isNeedPagination) { // 明细表启用分页时，全选只选中当前页数据
            detailFieldValues = detailFieldValues.slice((pageNum - 1) * pageSize, pageNum * pageSize);
        }
        var _values;
        var _c = excel.detailProps, _d = _c.isCopy, isCopy = _d === void 0 ? false : _d, _e = _c.isDelete, isDelete = _e === void 0 ? false : _e;
        if (!isDelete && detail) { //如果设置了不允许删除已有明细
            _values = detailFieldValues.filter(function (val) { return !val.dtl_id; });
            _values = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(_values, 'checkbox'));
        }
        else {
            _values = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mapValues(detailFieldValues, 'checkbox'));
        }
        if (card.params.type == '0' && isCopy || isDelete) { //显示布局下。允许快速编辑，开启删除‘复制功能允许勾选
            viewAttr = 2;
        }
        var __values = _values.filter(function (d) { return d == '1'; });
        var checkAll = __values.length > 0 && __values.length == _values.length; // 是否全选
        var checkSome = __values.length > 0 && __values.length < _values.length;
        var id = "_" + detail + "_all";
        var style = {};
        var isDrag = Object(__WEBPACK_IMPORTED_MODULE_4__util_cubeUtil__["f" /* isDragula */])(card, detail);
        if (isDrag) {
            style = { marginLeft: 17 };
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__view_view_checkbox__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Checkbox@ss6zqp", style: style }, { id: id, name: id }, { onChange: this.checkAllChange, indeterminate: checkSome, checkAll: checkAll, disabled: viewAttr == 1 })));
    };
    DetailCheckAll = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DetailCheckAll);
    return DetailCheckAll;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DetailCheckAll);


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(493);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(495);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Checkbox__["a" /* default */]);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);










var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Checkbox.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return __WEBPACK_IMPORTED_MODULE_7_rc_util_es_PureRenderMixin___default.a.shouldComponentUpdate.apply(this, args);
  };

  Checkbox.prototype.focus = function focus() {
    this.input.focus();
  };

  Checkbox.prototype.blur = function blur() {
    this.input.blur();
  };

  Checkbox.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        className = _props.className,
        style = _props.style,
        name = _props.name,
        id = _props.id,
        type = _props.type,
        disabled = _props.disabled,
        readOnly = _props.readOnly,
        tabIndex = _props.tabIndex,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onBlur = _props.onBlur,
        autoFocus = _props.autoFocus,
        value = _props.value,
        others = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'className', 'style', 'name', 'id', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);

    var globalProps = Object.keys(others).reduce(function (prev, key) {
      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
        prev[key] = others[key];
      }
      return prev;
    }, {});

    var checked = this.state.checked;

    var classString = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'span',
      { className: classString, style: style },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        name: name,
        id: id,
        type: type,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: prefixCls + '-input',
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: this.handleChange,
        autoFocus: autoFocus,
        ref: this.saveInput,
        value: value
      }, globalProps)),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: prefixCls + '-inner' })
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Checkbox.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  checked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var props = _this2.props;

    if (props.disabled) {
      return;
    }
    if (!('checked' in props)) {
      _this2.setState({
        checked: e.target.checked
      });
    }
    props.onChange({
      target: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      },

      nativeEvent: e.nativeEvent
    });
  };

  this.saveInput = function (node) {
    _this2.input = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(497), __esModule: true };

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(498);
module.exports = __webpack_require__(22).Object.assign;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(31);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(499) });


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(35);
var getKeys = __webpack_require__(113);
var gOPS = __webpack_require__(179);
var pIE = __webpack_require__(117);
var toObject = __webpack_require__(68);
var IObject = __webpack_require__(172);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(57)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(67);
var toLength = __webpack_require__(114);
var toAbsoluteIndex = __webpack_require__(501);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(175);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(503), __esModule: true };

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180);
__webpack_require__(270);
module.exports = __webpack_require__(182).f('iterator');


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(175);
var defined = __webpack_require__(174);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(118);
var descriptor = __webpack_require__(90);
var setToStringTag = __webpack_require__(119);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(49)(IteratorPrototype, __webpack_require__(32)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34);
var anObject = __webpack_require__(56);
var getKeys = __webpack_require__(113);

module.exports = __webpack_require__(35) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(38).document;
module.exports = document && document.documentElement;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(509);
var step = __webpack_require__(271);
var Iterators = __webpack_require__(92);
var toIObject = __webpack_require__(67);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(181)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(511), __esModule: true };

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(512);
__webpack_require__(275);
__webpack_require__(515);
__webpack_require__(516);
module.exports = __webpack_require__(22).Symbol;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(38);
var has = __webpack_require__(58);
var DESCRIPTORS = __webpack_require__(35);
var $export = __webpack_require__(31);
var redefine = __webpack_require__(268);
var META = __webpack_require__(183).KEY;
var $fails = __webpack_require__(57);
var shared = __webpack_require__(177);
var setToStringTag = __webpack_require__(119);
var uid = __webpack_require__(116);
var wks = __webpack_require__(32);
var wksExt = __webpack_require__(182);
var wksDefine = __webpack_require__(184);
var enumKeys = __webpack_require__(513);
var isArray = __webpack_require__(272);
var anObject = __webpack_require__(56);
var isObject = __webpack_require__(43);
var toObject = __webpack_require__(68);
var toIObject = __webpack_require__(67);
var toPrimitive = __webpack_require__(171);
var createDesc = __webpack_require__(90);
var _create = __webpack_require__(118);
var gOPNExt = __webpack_require__(514);
var $GOPD = __webpack_require__(274);
var $GOPS = __webpack_require__(179);
var $DP = __webpack_require__(34);
var $keys = __webpack_require__(113);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(273).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(117).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(115)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(49)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(113);
var gOPS = __webpack_require__(179);
var pIE = __webpack_require__(117);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(67);
var gOPN = __webpack_require__(273).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(184)('asyncIterator');


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(184)('observable');


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(518), __esModule: true };

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(519);
module.exports = __webpack_require__(22).Object.setPrototypeOf;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(31);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(520).set });


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(43);
var anObject = __webpack_require__(56);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(55)(Function.call, __webpack_require__(274).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(522), __esModule: true };

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(523);
var $Object = __webpack_require__(22).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(31);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(118) });


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */
var shallowEqual = __webpack_require__(70);

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}
/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */


var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};
module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_cubeUtil__ = __webpack_require__(19);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var DetailCheckbox = /** @class */ (function (_super) {
    __extends(DetailCheckbox, _super);
    function DetailCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetailCheckbox.prototype.render = function () {
        var _a = this.props, card = _a.card, detail = _a.detail, form = _a.form, excel = _a.excel;
        var bindObj = form.$('checkbox');
        var viewAttr = card.params.type == '1' || card.params.type == '2' ? 2 : 1;
        var _b = excel.detailProps.isDelete, isDelete = _b === void 0 ? false : _b;
        if (isDelete || isNaN(Number(form.value.dtl_id)) || form.value.dtl_id === '') {
            viewAttr = 2;
        }
        else {
            viewAttr = 1;
        }
        // if (isDelete) {
        //     viewAttr = 2
        // } else if (card.params.type == '0' && isNaN(Number(form.value.dtl_id))) { // 新增的数据
        //     viewAttr = 2
        // }else{
        //     if (detail && card.detailMap[detail] && card.detailMap[detail][`row_${form.key}`]) {
        //         const { disableCheck } = card.detailMap[detail][`row_${form.key}`];
        //         if (disableCheck === true)  //隐藏明细
        //             viewAttr = 1;
        //     }
        //     if (form.value.dtl_id) {
        //         //不允许删除已有明细
        //         viewAttr = 1;
        //     }
        //     if (card.params.type == '0' && (isCopy || isDelete)) { //显示布局下。允许快速编辑，开启删除或者复制功能允许勾选
        //         viewAttr = 2;
        //     }
        // }
        var checkId = "_" + detail + "_" + (form.key || "");
        var isDrag = Object(__WEBPACK_IMPORTED_MODULE_3__util_cubeUtil__["f" /* isDragula */])(card, detail);
        if (isDrag) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { marginRight: 5 }, "data-index": form.key, key: form.key, className: "icon-coms-move cursor-pointer" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaCheckbox"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaCheckbox@vanpl4" }, bindObj.bind(), { fieldName: checkId, viewAttr: viewAttr })));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaCheckbox"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaCheckbox@391jpf" }, bindObj.bind(), { fieldName: checkId, viewAttr: viewAttr })));
        }
    };
    DetailCheckbox = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], DetailCheckbox);
    return DetailCheckbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DetailCheckbox);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Colgroup__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableTBody__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var ExcelTableTabTable = /** @class */ (function (_super) {
    __extends(ExcelTableTabTable, _super);
    function ExcelTableTabTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showid: '',
        };
        return _this;
    }
    ExcelTableTabTable.prototype.componentDidMount = function () {
        var tabBar = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.refs.tabBar);
        var tab_head = tabBar.parent();
        var tab_top = tab_head.parent();
        var tab_turnleft = tab_top.find(".tab_turnleft");
        var tab_turnright = tab_top.find(".tab_turnright");
        var totalWidth = 0;
        tabBar.children().each(function () {
            totalWidth += __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).width();
        });
        if (totalWidth > tab_top.width()) {
            tab_top.find(".tab_movebtn").css("display", "block");
            tab_head.width(tab_top.width() - tab_turnleft.width() - tab_turnright.width());
            tabBar.width(totalWidth + 1);
        }
        else {
            tab_top.find(".tab_movebtn").css("display", "none");
            tab_head.width("100%");
            tabBar.width("100%");
        }
        if (__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.browser.chrome) {
            var excelTabTable_1 = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(".excelTabTable");
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(excelTabTable_1, function (item, index) {
                var diff = item.scrollWidth - item.offsetWidth;
                if (diff > 0 && diff < 3) {
                    excelTabTable_1.eq(index).css("min-width", "calc(100% - " + diff + "px)");
                }
            });
        }
    };
    ExcelTableTabTable.prototype.componentDidUpdate = function (prevProps, prevState) {
        // const showid = this.props.showid;
        // if(showid !== prevProps.showid){   //切换了标签显示区域
        //     window.formImgLazyLoad(jQuery(`div#${showid}_content`));    //执行图片懒加载
        // }
        if (__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.browser.chrome) {
            var excelTabTable_2 = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(".excelTabTable");
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(excelTabTable_2, function (item, index) {
                var diff = item.scrollWidth - item.offsetWidth;
                if (diff > 0 && diff < 3) {
                    excelTabTable_2.eq(index).css("min-width", "calc(100% - " + diff + "px)");
                }
            });
        }
    };
    ExcelTableTabTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, cell = _a.cell, card = _a.card;
        var id = "tabarea_" + cell.row + "_" + cell.col;
        var wrapClassNames = "cube-tabarea";
        var tabs = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(cell, 'tab.tabs') || [];
        var style = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(cell, 'stylejson') || {};
        if (!style)
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "Empty TabArea Style");
        var tab = cell.tab;
        var defShowIndex = parseInt(tab.defaultActiveKey || 0);
        if (defShowIndex >= tabs.length)
            defShowIndex = 0;
        var tabShowSymbol = this.state.showid === "" ? tabs[defShowIndex].name : this.state.showid;
        var tabHeadBar = new Array();
        var tabContent = new Array();
        tabs.map(function (v, k) {
            var tabid = v.name;
            //拼标签头部bar
            var sel = tabid === tabShowSymbol ? "sel" : "unsel";
            var middleStyle = {
                backgroundImage: "url('" + style[sel + "_bgmiddle"] + "')",
                fontSize: style[sel + "_fontsize"] + "px",
                color: style[sel + "_color"],
                fontFamily: style[sel + "_family"]
            };
            if (style && style[sel + "_bold"] == "1")
                middleStyle["font-weight"] = "bold";
            if (style && style[sel + "_italic"] == "1")
                middleStyle["font-style"] = "italic";
            tabHeadBar.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: tabid, className: "t_" + sel, onClick: _this.changeTab.bind(_this, tabid) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "t_" + sel + "_left norepeat", style: {
                        backgroundImage: "url('" + style[sel + "_bgleft"] + "')",
                        width: style[sel + "_bgleftwidth"] + "px"
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "t_" + sel + "_middle xrepeat lineheight30", style: middleStyle },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, v.tab)),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "t_" + sel + "_right norepeat", style: {
                        backgroundImage: "url('" + style[sel + "_bgright"] + "')",
                        width: style[sel + "_bgrightwidth"] + "px"
                    } })));
            if (k !== tabs.length - 1) {
                tabHeadBar.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "t_sep norepeat", style: { width: style.image_sepwidth + "px" } }));
            }
            //拼接标签页内容
            tabContent.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tab_content", id: tabid + "_content", style: tabid === tabShowSymbol ? {} : { display: "none" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabPane, { tab: v, card: card })));
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: wrapClassNames, id: id, style: { width: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tab_top" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tab_movebtn tab_turnleft", style: { display: "none" }, onClick: this.turnBar.bind(this, "left") }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tab_head", style: { width: "100%" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "t_area xrepeat", ref: "tabBar", style: {
                            backgroundImage: "url(" + style.image_bg + ")",
                            width: "100%"
                        } }, tabHeadBar)),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tab_movebtn tab_turnright", style: { display: "none" }, onClick: this.turnBar.bind(this, "right") })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tab_bottom", style: { height: tab.height } }, card.params && card.params.tabLoadAll === '1' ? tabContent
                : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd__["Tabs"], { ecId: (this && this.props && this.props.ecId || '') + "_Tabs@50tl3p", activeKey: tabShowSymbol }, tabs.map(function (v, k) {
                    var tabid = v.name;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd__["Tabs"].TabPane, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tabs.TabPane@1305oc@" + k, key: tabid },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tab_content", id: tabid + "_content" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabPane, { ecId: (_this && _this.props && _this.props.ecId || '') + "_TabPane@i75ezb@" + k, tab: v, card: card })));
                })))));
    };
    ExcelTableTabTable.prototype.changeTab = function (selectedTabId) {
        this.setState({ showid: selectedTabId });
    };
    ExcelTableTabTable.prototype.turnBar = function (flag) {
        var tab_head = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.refs.tabBar).parent();
        if (flag === "left")
            tab_head.scrollLeft(tab_head.scrollLeft() - 71);
        else if (flag === "right")
            tab_head.scrollLeft(tab_head.scrollLeft() + 71);
    };
    ExcelTableTabTable = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], ExcelTableTabTable);
    return ExcelTableTabTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableTabTable);
var TabPane = /** @class */ (function (_super) {
    __extends(TabPane, _super);
    function TabPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabPane.prototype.render = function () {
        var _a = this.props, tab = _a.tab, card = _a.card;
        var classNames = 'excelTabTable';
        var excel = card.modeExcel.getTabs(tab.name); //返回了新的modeexcel，但是为初始化
        if (excel) {
            excel.mutilContents = card.modeExcel.mutilContents; //给新modeexcel初始属性
        }
        return (excel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { overflowX: "auto", width: "100%" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: classNames, style: { width: excel.sumWidth, minWidth: '100%', borderCollapse: 'collapse' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Colgroup__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableColgroup@nki1i5", excel: excel }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableTBody__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelTableTBody@qp33kg", excel: excel, card: card, form: card.cubeForm, actions: card.Actions }))) : null);
    };
    TabPane = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], TabPane);
    return TabPane;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tagset_less__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tagset_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tagset_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var TagSet = /** @class */ (function (_super) {
    __extends(TagSet, _super);
    function TagSet(props) {
        var _this = _super.call(this, props) || this;
        _this.tagClick = function (obj) {
            // const { form } = this.props;
            // form.$('tag').bind().onChange(obj.tag);
            // this.setState({visible:false})
        };
        _this.colorChange = function (v) { _this.props.onChange({ color: v }); };
        _this.bdColorChange = function (v) { _this.props.onChange({ bdcolor: v }); };
        _this.bgColorChange = function (v) { _this.props.onChange({ bgcolor: v }); };
        return _this;
    }
    TagSet.prototype.render = function () {
        var _a = this.props, color = _a.color, bgcolor = _a.bgcolor, bdcolor = _a.bdcolor;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "100px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cube-browser-single-tag-circle", style: { float: "left" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-mode-tag", style: {
                        color: color,
                        background: bgcolor,
                        borderColor: bdcolor
                    } }, getLabel(176, '标签'))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-label" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaColorPicker"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaColorPicker@kwa71g", customized: true, onChange: this.colorChange },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "set-label-left" },
                            getLabel(500422, "文字颜色"),
                            ":"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-btn", style: { background: color }, title: getLabel(83749, '背景色') },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-btn-inner" })))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-label" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaColorPicker"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaColorPicker@l8y7a1", customized: true, onChange: this.bdColorChange },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "set-label-left" },
                            getLabel(500423, "边框颜色"),
                            ":"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-btn", style: { background: bdcolor }, title: getLabel(387943, '图标') + getLabel(495, "颜色") },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-btn-inner" })))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-label" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaColorPicker"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaColorPicker@qlvups", customized: true, onChange: this.bgColorChange },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "set-label-left" },
                            getLabel(500424, "背景颜色"),
                            ":"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-btn", style: { background: bgcolor }, title: getLabel(387943, '图标') + getLabel(495, "颜色") },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tag-set-btn-inner" }))))));
    };
    TagSet = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TagSet);
    return TagSet;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TagSet);


/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tagsJson; });
var tagsJson = [{
        key: 1,
        color: '#eb2f96',
        bgcolor: '#fff0f6',
        bdcolor: '#ffadd2'
    }, {
        key: 2,
        color: '#f5222d',
        bgcolor: '#fff1f0',
        bdcolor: '#ffa39e'
    }, {
        key: 3,
        color: '#fa541c',
        bgcolor: '#fff2e8',
        bdcolor: '#ffbb96'
    }, {
        key: 4,
        color: '#fa8c16',
        bgcolor: '#fff7e6',
        bdcolor: '#ffd591'
    }, {
        key: 5,
        color: '#faad14',
        bgcolor: '#fffbe6',
        bdcolor: '#ffe58f'
    }, {
        key: 6,
        color: '#a0d911',
        bgcolor: '#fcffe6',
        bdcolor: '#eaff8f'
    }, {
        key: 7,
        color: '#52c41a',
        bgcolor: '#f6ffed',
        bdcolor: '#b7eb8f'
    }, {
        key: 8,
        color: '#13c2c2',
        bgcolor: '#e6fffb',
        bdcolor: '#87e8de'
    }, {
        key: 9,
        color: '#1890ff',
        bgcolor: '#e6f7ff',
        bdcolor: '#91d5ff'
    }, {
        key: 10,
        color: '#2f54eb',
        bgcolor: '#f0f5ff',
        bdcolor: '#adc6ff'
    }, {
        key: 11,
        color: '#722ed1',
        bgcolor: '#f9f0ff',
        bdcolor: '#d3adf7'
    }, {
        key: 12,
        color: '#fff',
        bgcolor: '#ff5500',
        bdcolor: '#ff5500'
    }, {
        key: 13,
        color: '#fff',
        bgcolor: '#2db7f5',
        bdcolor: '#2db7f5'
    }, {
        key: 14,
        color: '#fff',
        bgcolor: '#87d068',
        bdcolor: '#87d068'
    }, {
        key: 15,
        color: '#fff',
        bgcolor: '#108ee9',
        bdcolor: '#108ee9'
    }, {
        key: 16,
        color: '#fff',
        bgcolor: '#13c2c2',
        bdcolor: '#13c2c2'
    }, {
        key: 17,
        color: '#fff',
        bgcolor: '#722ed1',
        bdcolor: '#722ed1'
    }, {
        key: 18,
        color: '#fff',
        bgcolor: '#eb2f96',
        bdcolor: '#eb2f96'
    },];


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableCell__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var ExcelTableMutilContent = /** @class */ (function (_super) {
    __extends(ExcelTableMutilContent, _super);
    function ExcelTableMutilContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExcelTableMutilContent.prototype.render = function () {
        var _this = this;
        var _a = this.props, cell = _a.cell, excel = _a.excel, form = _a.form, contentType = _a.contentType, detail = _a.detail, content = _a.content, card = _a.card, index = _a.index, className = _a.className;
        var mc = cell.mcpoint && excel.getMutilContent(cell.mcpoint);
        var contents = [];
        var colIndex = 0;
        var rowIndex = 0;
        var verifyColor = {};
        mc && mc.cells && mc.cells.map(function (mcCell, i) {
            if (mcCell.etype == '14') {
                if (mcCell.brsign == 'Y') {
                    rowIndex += 1;
                    colIndex = 0;
                }
                return;
            }
            if (mcCell && mcCell.etype == '3' && form.has(mcCell.getPath())) {
                var color = form.$(mcCell.getPath()).color;
                if (color) {
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(verifyColor, "background", color);
                }
            }
            var prop = {};
            if (mcCell && mcCell.otherProps && mcCell.otherProps.id) {
                prop = { id: mcCell.otherProps.id };
            }
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(contents, "[" + rowIndex + "].[" + colIndex + "]", (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ style: mcCell.style }, prop),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableCell__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_TableCell@6rtjsl@" + i, excel: excel, contentType: contentType, form: form, card: card, index: index, detail: detail, content: content, className: className, cell: mcCell }))));
            colIndex++;
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-mutil-content", style: __assign({}, verifyColor) }, contents.map(function (row) {
            if (row === void 0) { row = []; }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, row && row.map(function (col) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: 'inline-block', verticalAlign: "middle" } }, col)); })));
        })));
    };
    ExcelTableMutilContent = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], ExcelTableMutilContent);
    return ExcelTableMutilContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ExcelTableMutilContent);


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export portalFiles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var staticVersion = "?v" + (__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"] && __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"].ls && __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"].ls.getStr("staticVersion") || 0);
var portalFiles = [
    "/spa/portal/public/index.js" + staticVersion,
    "/spa/portal/public/index.css",
    "/spa/portal/static/index.js" + staticVersion,
    "/spa/portal/static/index.css"
];
var PortalPage = /** @class */ (function (_super) {
    __extends(PortalPage, _super);
    function PortalPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasLoad: false };
        return _this;
    }
    PortalPage.prototype.componentDidMount = function () {
        var _this = this;
        var init = function () {
            _this.setState({ hasLoad: true });
        };
        __WEBPACK_IMPORTED_MODULE_1_loadjs___default.a.isDefined('portal') ? __WEBPACK_IMPORTED_MODULE_1_loadjs___default.a.ready('portal', init) : __WEBPACK_IMPORTED_MODULE_1_loadjs___default()(portalFiles, 'portal', {
            async: false,
            success: init
        });
    };
    PortalPage.prototype.render = function () {
        var hasLoad = this.state.hasLoad;
        var _a = this.props, hpid = _a.hpid, formData = _a.formData;
        if (hasLoad) {
            var Homepage = __WEBPACK_IMPORTED_MODULE_2__util__["default"].weaPortal.Homepage;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Homepage, { ecId: (this && this.props && this.props.ecId || '') + "_Homepage@qcv7g2", hpid: hpid, formData: formData }));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@6eb8kh" }));
        }
    };
    return PortalPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (PortalPage);


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var CellLikes = /** @class */ (function (_super) {
    __extends(CellLikes, _super);
    function CellLikes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.likeOrDislike1 = function () {
            var card = _this.props.card;
            if (card.likestatus == '1') {
                card.likeOrdislike('0');
            }
            else {
                card.likeOrdislike('1');
            }
        };
        _this.likeOrDislike2 = function () {
            var card = _this.props.card;
            if (card.likestatus == '2') {
                card.likeOrdislike('0');
            }
            else {
                card.likeOrdislike('2');
            }
        };
        return _this;
    }
    CellLikes.prototype.render = function () {
        var _a = this.props, cell = _a.cell, card = _a.card;
        var isallowlike = card.isallowlike, likeshowname = card.likeshowname, isallowdislike = card.isallowdislike, dislikeshowname = card.dislikeshowname, likecount = card.likecount, dislikecount = card.dislikecount, likestatus = card.likestatus;
        var liketitle = likeshowname;
        var disliketitle = dislikeshowname;
        var likeicon = '';
        var dislikeicon = '';
        if (likestatus == '1') {
            if (likeshowname == '') {
                liketitle = getLabel('32944', '取消赞');
            }
            else {
                liketitle = getLabel('31129', '取消') + likeshowname;
            }
            if (dislikeshowname == '') {
                disliketitle = getLabel('515888', '踩');
            }
            likeicon = 'icon-coms02-like';
            dislikeicon = 'icon-coms02-Negative-comment-o';
        }
        else if (likestatus == '2') {
            if (likeshowname == '') {
                liketitle = getLabel('32942', '赞');
            }
            if (dislikeshowname == '') {
                disliketitle = getLabel('515889', '取消踩');
            }
            else {
                disliketitle = getLabel('31129', '取消') + dislikeshowname;
            }
            likeicon = 'icon-coms02-like-o';
            dislikeicon = 'icon-coms02-Negative-comment';
        }
        else {
            if (likeshowname == '') {
                liketitle = getLabel('32942', '赞');
            }
            if (dislikeshowname == '') {
                disliketitle = getLabel('515888', '踩');
            }
            likeicon = 'icon-coms02-like-o';
            dislikeicon = 'icon-coms02-Negative-comment-o';
        }
        if (cell && cell.evalue == "#likes#" && isallowlike == "1") {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { 'cursor': 'pointer' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: liketitle, className: likeicon, onClick: this.likeOrDislike1 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, ' ' + likeshowname + ' (' + likecount + ')'));
        }
        if (cell && cell.evalue == "#dislikes#" && isallowdislike == "1") {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { 'cursor': 'pointer' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: disliketitle, className: dislikeicon, onClick: this.likeOrDislike2 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, ' ' + dislikeshowname + ' (' + dislikecount + ')'));
        }
    };
    CellLikes = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], CellLikes);
    return CellLikes;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CellLikes);


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var MyField = /** @class */ (function (_super) {
    __extends(MyField, _super);
    function MyField(props) {
        var _this = _super.call(this, props) || this;
        _this.valueSpan = null;
        _this.valueObj = null;
        _this.editable = false;
        _this.modified = false;
        _this.browserProps = {};
        _this.onChange = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (args[1])
                _this.valueSpan = args[1];
            if (args[2])
                _this.valueObj = args[2];
            _this.set(args[0]);
            _this.validate();
            _this.showErrors(true);
        };
        _this.clearRowFields = function () {
            _this.clear();
        };
        return _this;
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], MyField.prototype, "valueSpan", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], MyField.prototype, "valueObj", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], MyField.prototype, "editable", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], MyField.prototype, "modified", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], MyField.prototype, "browserProps", void 0);
    return MyField;
}(__WEBPACK_IMPORTED_MODULE_0_comsMobx__["WeaForm"].MyField));
var bindings = {
    default: {
        id: 'id',
        name: 'name',
        editable: 'editable',
        value: 'value',
        valueSpan: 'valueSpan',
        valueObj: 'valueObj',
        label: 'label',
        checked: 'checked',
        placeholder: 'placeholder',
        disabled: 'disabled',
        onChange: 'onChange',
        onBlur: 'onBlur',
        onFocus: 'onFocus',
        autoFocus: 'autoFocus',
        browserProps: 'browserProps',
    }
};
var CubeForm = /** @class */ (function (_super) {
    __extends(CubeForm, _super);
    function CubeForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CubeForm.prototype.makeField = function (props) {
        return new MyField(props);
    };
    CubeForm.prototype.bindings = function () {
        return bindings;
    };
    return CubeForm;
}(__WEBPACK_IMPORTED_MODULE_0_comsMobx__["WeaForm"]));
/* harmony default export */ __webpack_exports__["a"] = (CubeForm);


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColumns; });
/* unused harmony export getSqlNeedFieldKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var getMultiStrFromBase64 = __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaInputLocale"].getMultiStrFromBase64;
var getColumns = function (columns, optionsMap, browserMap, isfrontmultlang, tableStore, sqlneedkey) {
    return columns.map(function (item) {
        var conditionType = 'INPUT';
        var title = '';
        var key = '';
        var otherParams = {};
        title = item.fieldlabel;
        if (item.fieldid == '-1') {
            key = 'modedatacreatedate';
        }
        else if (item.fieldid == '-2') {
            key = 'modedatacreaterspan';
            conditionType = 'htmlinput';
        }
        else if (item.fieldid == '-3') {
            key = 'id';
        }
        else if (item.fieldid == '-4') {
            key = 'modelableidspan';
        }
        else if (item.fieldid == '-5') {
            key = 'modedatastatusspan';
        }
        else if (item.fieldid == '-8') {
            key = 'modedatamodifydatetime';
        }
        else if (item.fieldid == '-7') {
            key = 'modedatamodifierspan';
            conditionType = 'htmlinput';
        }
        else if (item.fieldid == '-9') {
            key = 'seclevel';
        }
        else {
            key = item.fieldname;
        }
        var fieldhtmltype = item.fieldhtmltype;
        var fielddbtype = item.fielddbtype;
        var type = item.type;
        var options = [];
        var detailtype = '1';
        var width = 0;
        width += parseFloat(item.colwidth);
        var reg = new RegExp('');
        var browserConditionParam = {};
        var uploadConditionParam = {};
        if (fieldhtmltype == '1') { //单行文本
            if (type == '2') { //整数
                reg = /^-?\d+$/;
                detailtype = '2';
                otherParams = { max: 2147483647, min: -2147483648 };
            }
            else if (type == '3' || type == '4' || type == '5') { //浮点数 金额转换 金额千分位
                reg = /^(-?\d+)(.[0-9]{0,2})?$/;
                switch (item.qfws) {
                    case 1:
                        reg = /^(-?\d+)(.[0-9]{0,1})?$/;
                        break;
                    case 2:
                        reg = /^(-?\d+)(.[0-9]{0,2})?$/;
                        break;
                    case 3:
                        reg = /^(-?\d+)(.[0-9]{0,3})?$/;
                        break;
                    case 4:
                        reg = /^(-?\d+)(.[0-9]{0,4})?$/;
                        break;
                    case 5:
                        reg = /^(-?\d+)(.[0-9]{0,5})?$/;
                        break;
                    case 6:
                        reg = /^(-?\d+)(.[0-9]{0,6})?$/;
                        break;
                    case 7:
                        reg = /^(-?\d+)(.[0-9]{0,7})?$/;
                        break;
                    case 8:
                        reg = /^(-?\d+)(.[0-9]{0,8})?$/;
                        break;
                    case 9:
                        reg = /^(-?\d+)(.[0-9]{0,9})?$/;
                        break;
                    case 10:
                        reg = /^(-?\d+)(.[0-9]{0,10})?$/;
                        break;
                    case 11:
                        reg = /^(-?\d+)(.[0-9]{0,11})?$/;
                        break;
                    case 12:
                        reg = /^(-?\d+)(.[0-9]{0,12})?$/;
                        break;
                    case 13:
                        reg = /^(-?\d+)(.[0-9]{0,13})?$/;
                        break;
                    case 14:
                        reg = /^(-?\d+)(.[0-9]{0,14})?$/;
                        break;
                    case 15:
                        reg = /^(-?\d+)(.[0-9]{0,15})?$/;
                        break;
                }
                detailtype = '2';
                key += 'span';
                otherParams = { max: 999999999999.999999999999, min: -999999999999.999999999999 };
            }
        }
        else if (fieldhtmltype == '5') { //选择框
            options = optionsMap[item.fieldid];
            conditionType = 'SELECT';
            detailtype = type;
        }
        else if (fieldhtmltype == '3') { //浏览按钮
            if (type == '2') {
                conditionType = 'date';
            }
            else if (type == '19') {
                conditionType = 'time';
            }
            else if (type == '290') {
                conditionType = 'datetime';
            }
            else if (type == '402') { //年
                conditionType = 'year';
            }
            else if (type == '403') { //年月
                conditionType = 'yearmonth';
            }
            else {
                conditionType = 'browser';
                if (type && (type == '4' || type == '57' || type == '164' || type == '169' || type == '194' || type == '167' || type == '170' || type == '168')) { //部门，多部门，分部，多分部，单点分权，分权单部门，分权多分部，分权多部门
                    browserMap[item.fieldid].dataParams = __assign({}, browserMap[item.fieldid].dataParams, { fromModule: "model" });
                    browserMap[item.fieldid].destDataParams = __assign({}, browserMap[item.fieldid].destDataParams, { fromModule: "model" });
                }
                browserConditionParam = browserMap[item.fieldid];
            }
        }
        else if (fieldhtmltype == '2') { //多行文本
            if (type == '1') {
                conditionType = 'textarea';
                key += 'span';
            }
            else if (type == "2") {
                conditionType = 'htmlinput';
            }
        }
        else if (fieldhtmltype == '4') { //Check框
            conditionType = 'checkbox';
        }
        else if (fieldhtmltype == '6') {
            conditionType = 'weaupload';
            //width+=60;
            uploadConditionParam = item.uploadMap;
        }
        else if (fieldhtmltype == '7') { //特殊字段
            key = item.fieldname + 'span';
            conditionType = 'htmlinput';
        }
        if (width == 0) {
            width = 5;
        }
        return __assign({}, otherParams, { title: title, key: key, width: width, reg: reg, conditionType: conditionType, detailtype: detailtype, viewAttr: item.editable == '1' ? 2 : 1, fixed: false, browserConditionParam: browserConditionParam, uploadConditionParam: uploadConditionParam, options: options, fieldid: item.fieldid, qfw: item.qfws, fieldhtmltype: fieldhtmltype, fielddbtype: fielddbtype, fieldtype: type, textheight: item.textheight, onChange: function (v, row) {
                var value = tableStore.form.$('tableForm').$(row.key).$(key).value;
                var oldValue = tableStore.form.$('tableForm').$(row.key).$(key).oldValue;
                if (fieldhtmltype == '4' && oldValue == '')
                    oldValue = '0';
                var ischange = value != oldValue;
                if (isfrontmultlang && fieldhtmltype == '1' && type == '1') {
                    ischange = value != getMultiStrFromBase64(oldValue);
                }
                if (ischange) {
                    tableStore.form.$("tableForm." + row.key + "." + key).modified = true;
                }
                else {
                    tableStore.form.$("tableForm." + row.key + "." + key).modified = false;
                }
                if (sqlneedkey) {
                    getSqlNeedFieldKey(v, key, item.detailtable, sqlneedkey, tableStore, row.key, item.fieldid);
                }
            } });
    });
};
var getSqlNeedFieldKey = function (v, key, detailtable, sqlneedkey, tableStore, rowkey, fieldid) {
    var currenttime = new Date().getTime();
    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(sqlneedkey, function (value, fieldids) {
        var fields = { currenttime: currenttime, };
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(value, function (value1, sql) {
            var keytemp = key;
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.parseInt(sql) % 2 === 0) { //主表字段
                if (key.indexOf("span") != -1) {
                    keytemp = keytemp.replace("span", "");
                    //fieldids=fieldids+"span";
                }
                if (keytemp === value1) {
                    var oldbrowserProps = tableStore.form.$('tableForm').$(rowkey).$(fieldids).browserProps || {};
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(fields, value1 + "_" + currenttime, v);
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(fields, 'field' + fieldid, v);
                    tableStore.form.$('tableForm').$(rowkey).$(fieldids).browserProps = {
                        dataParams: __assign({}, oldbrowserProps.dataParams, fields),
                        conditionDataParams: __assign({}, oldbrowserProps.conditionDataParams, fields),
                        completeParams: __assign({}, oldbrowserProps.completeParams, fields),
                    };
                }
            }
            else {
                var valuetemp = "d_" + value1;
                if (key.indexOf("span") != -1) {
                    keytemp = keytemp.replace("span", "");
                    //fieldids=fieldids+"span";
                }
                if (keytemp === valuetemp) {
                    var oldbrowserProps = tableStore.form.$('tableForm').$(rowkey).$(fieldids).browserProps || {};
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(fields, detailtable + "_" + value1 + "_" + currenttime, v);
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(fields, 'field' + fieldid, v);
                    tableStore.form.$('tableForm').$(rowkey).$(fieldids).browserProps = {
                        dataParams: __assign({}, oldbrowserProps.dataParams, fields),
                        conditionDataParams: __assign({}, oldbrowserProps.conditionDataParams, fields),
                        completeParams: __assign({}, oldbrowserProps.completeParams, fields),
                    };
                }
            }
        });
    });
};


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColumns; });
/* unused harmony export getSqlNeedFieldKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var getLabel = __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaLocaleProvider"].getLabel;
var getColumns = function (columns, optionsMap, browserMap, tableStore, uploadMap, sqlneedkey) {
    return columns.map(function (item) {
        var conditionType = 'INPUT';
        var title = '';
        var key = '';
        if (item.fieldid == '-1') {
            title = getLabel(722, '创建日期');
            key = 'modedatacreatedate';
        }
        else if (item.fieldid == '-2') {
            title = getLabel(882, '创建人');
            key = 'modedatacreaterspan';
            conditionType = 'htmlinput';
        }
        else if (item.fieldid == '-3') {
            title = getLabel(81287, '数据ID');
            key = 'id';
        }
        else if (item.fieldid == '-4') {
            title = getLabel(176, '标签');
            key = 'modelableidspan';
        }
        else if (item.fieldid == '-5') {
            title = getLabel(385992, '状态');
            key = 'modedatastatusspan';
        }
        else {
            title = item.fieldlabel;
            key = item.fieldname;
        }
        var fieldhtmltype = item.fieldhtmltype;
        var fielddbtype = item.fielddbtype;
        var type = item.type;
        var options = [];
        var detailtype = '1';
        var width = 100;
        //width += parseFloat(item.colwidth);
        var reg = new RegExp('');
        var browserConditionParam = {};
        var uploadConditionParam = {};
        var otherParams = {};
        if (fieldhtmltype == '1') { //单行文本
            if (type == '2') { //整数
                reg = /^-?\d+$/;
                detailtype = '2';
                otherParams = { max: 2147483647, min: -2147483648 };
            }
            else if (type == '3' || type == '4' || type == '5') { //浮点数 金额转换 金额千分位
                reg = /^(-?\d+)(.[0-9]{0,2})?$/;
                switch (item.qfws) {
                    case 1:
                        reg = /^(-?\d+)(.[0-9]{0,1})?$/;
                        break;
                    case 2:
                        reg = /^(-?\d+)(.[0-9]{0,2})?$/;
                        break;
                    case 3:
                        reg = /^(-?\d+)(.[0-9]{0,3})?$/;
                        break;
                    case 4:
                        reg = /^(-?\d+)(.[0-9]{0,4})?$/;
                        break;
                    case 5:
                        reg = /^(-?\d+)(.[0-9]{0,5})?$/;
                        break;
                    case 6:
                        reg = /^(-?\d+)(.[0-9]{0,6})?$/;
                        break;
                    case 7:
                        reg = /^(-?\d+)(.[0-9]{0,7})?$/;
                        break;
                    case 8:
                        reg = /^(-?\d+)(.[0-9]{0,8})?$/;
                        break;
                    case 9:
                        reg = /^(-?\d+)(.[0-9]{0,9})?$/;
                        break;
                    case 10:
                        reg = /^(-?\d+)(.[0-9]{0,10})?$/;
                        break;
                    case 11:
                        reg = /^(-?\d+)(.[0-9]{0,11})?$/;
                        break;
                    case 12:
                        reg = /^(-?\d+)(.[0-9]{0,12})?$/;
                        break;
                    case 13:
                        reg = /^(-?\d+)(.[0-9]{0,13})?$/;
                        break;
                    case 14:
                        reg = /^(-?\d+)(.[0-9]{0,14})?$/;
                        break;
                    case 15:
                        reg = /^(-?\d+)(.[0-9]{0,15})?$/;
                        break;
                }
                detailtype = '2';
                otherParams = { max: 999999999999.999999999999, min: -999999999999.999999999999 };
            }
        }
        else if (fieldhtmltype == '5') { //选择框
            options = optionsMap[item.fieldid];
            conditionType = 'SELECT';
            detailtype = type;
            if (item.fieldid == '-9') {
                width = 165;
            }
        }
        else if (fieldhtmltype == '3') { //浏览按钮
            if (type == '2') {
                conditionType = 'date';
            }
            else if (type == '19') {
                conditionType = 'time';
            }
            else if (type == '290') {
                conditionType = 'datetime';
            }
            else if (type == '402') { //年
                conditionType = 'year';
            }
            else if (type == '403') { //年月
                conditionType = 'yearmonth';
            }
            else {
                conditionType = 'browser';
                if (type && (type == '4' || type == '57' || type == '164' || type == '169' || type == '194' || type == '167' || type == '170' || type == '168')) { //部门，多部门，分部，多分部，单点分权，分权单部门，分权多分部，分权多部门
                    browserMap[item.fieldid].dataParams = __assign({}, browserMap[item.fieldid].dataParams, { fromModule: "model" });
                    browserMap[item.fieldid].destDataParams = __assign({}, browserMap[item.fieldid].dataParams, { fromModule: "model" });
                }
                browserConditionParam = browserMap[item.fieldid];
            }
        }
        else if (fieldhtmltype == '2') { //多行文本
            if (type == '1') {
                conditionType = 'textarea';
            }
            else if (type == "2") {
                conditionType = 'htmlinput';
            }
        }
        else if (fieldhtmltype == '4') { //Check框
            conditionType = 'checkbox';
        }
        else if (fieldhtmltype == '6') {
            conditionType = 'weaupload';
            width += 60;
            uploadConditionParam = item.uploadMap;
        }
        return __assign({}, otherParams, { title: title, key: key, width: width, reg: reg, conditionType: conditionType, detailtype: detailtype, viewAttr: 2, fixed: false, browserConditionParam: browserConditionParam, uploadConditionParam: uploadConditionParam, options: options, fieldid: item.fieldid, qfw: item.qfws, fieldhtmltype: fieldhtmltype, fielddbtype: fielddbtype, fieldtype: type, textheight: item.textheight, onChange: function (v, row, names, datas) {
                if (conditionType == 'browser') {
                    if (item.type === '141') {
                        tableStore.form.$("tableForm." + row.key + "." + key + "span").value = JSON.stringify([{ prop: datas }]);
                    }
                    else {
                        tableStore.form.$("tableForm." + row.key + "." + key + "span").value = JSON.stringify(datas.map(function (item) {
                            return item.name;
                        }));
                    }
                }
                else if (conditionType == 'weaupload') {
                    //tableStore.form.$(`tableForm.${row.key}.${key}span`).value=JSON.stringify(names);
                }
                sqlneedkey && getSqlNeedFieldKey(v, key, sqlneedkey, tableStore, row.key, item.fieldid);
            } });
    });
};
var getSqlNeedFieldKey = function (v, key, sqlneedkey, tableStore, rowkey, fieldid) {
    var currenttime = new Date().getTime();
    var oldbrowserProps = tableStore.form.$('tableForm').$(rowkey).$(key).browserProps || {};
    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(sqlneedkey, function (value, fieldids) {
        var fields = { currenttime: currenttime, };
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(value, function (value1, sql) {
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.parseInt(sql) % 2 === 0) { //主表字段
                if (key.indexOf("span") != -1) {
                    key = key.replace("span", "");
                    fieldids = fieldids + "span";
                }
                if (key === value1) {
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(fields, value1 + "_" + currenttime, v);
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(fields, 'field' + fieldid, v);
                    tableStore.form.$('tableForm').$(rowkey).$(fieldids).browserProps = {
                        dataParams: __assign({}, oldbrowserProps.dataParams, fields),
                        conditionDataParams: __assign({}, oldbrowserProps.conditionDataParams, fields),
                        completeParams: __assign({}, oldbrowserProps.completeParams, fields),
                    };
                }
            }
        });
    });
};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(538).runInContext();
module.exports = __webpack_require__(539)(_, _);


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
;(function(){function n(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function t(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function r(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function e(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););return n}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;
return true}function i(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function o(n,t){return!(null==n||!n.length)&&-1<v(n,t,0)}function f(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function c(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function a(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function l(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);
return r}function s(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function h(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function p(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function _(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function v(n,t,r){if(t===t)n:{--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=_(n,d,r);return n}function g(n,t,r,e){
--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function d(n){return n!==n}function y(n,t){var r=null==n?0:n.length;return r?m(n,t)/r:F}function b(n){return function(t){return null==t?T:t[n]}}function x(n){return function(t){return null==n?T:n[t]}}function j(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function w(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;return n}function m(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==T&&(r=r===T?i:r+i)}return r;
}function A(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function E(n,t){return c(t,function(t){return[t,n[t]]})}function k(n){return function(t){return n(t)}}function S(n,t){return c(t,function(t){return n[t]})}function O(n,t){return n.has(t)}function I(n,t){for(var r=-1,e=n.length;++r<e&&-1<v(t,n[r],0););return r}function R(n,t){for(var r=n.length;r--&&-1<v(t,n[r],0););return r}function z(n){return"\\"+Un[n]}function W(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n];
}),r}function B(n,t){return function(r){return n(t(r))}}function L(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function U(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function C(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function D(n){if(Rn.test(n)){for(var t=On.lastIndex=0;On.test(n);)++t;n=t}else n=Qn(n);return n}function M(n){return Rn.test(n)?n.match(On)||[]:n.split("");
}var T,$=1/0,F=NaN,N=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],P=/\b__p\+='';/g,Z=/\b(__p\+=)''\+/g,q=/(__e\(.*?\)|\b__t\))\+'';/g,V=/&(?:amp|lt|gt|quot|#39);/g,K=/[&<>"']/g,G=RegExp(V.source),H=RegExp(K.source),J=/<%-([\s\S]+?)%>/g,Y=/<%([\s\S]+?)%>/g,Q=/<%=([\s\S]+?)%>/g,X=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,nn=/^\w*$/,tn=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,rn=/[\\^$.*+?()[\]{}|]/g,en=RegExp(rn.source),un=/^\s+|\s+$/g,on=/^\s+/,fn=/\s+$/,cn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,an=/\{\n\/\* \[wrapped with (.+)\] \*/,ln=/,? & /,sn=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,hn=/\\(\\)?/g,pn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,_n=/\w*$/,vn=/^[-+]0x[0-9a-f]+$/i,gn=/^0b[01]+$/i,dn=/^\[object .+?Constructor\]$/,yn=/^0o[0-7]+$/i,bn=/^(?:0|[1-9]\d*)$/,xn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,jn=/($^)/,wn=/['\n\r\u2028\u2029\\]/g,mn="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",An="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+mn,En="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",kn=RegExp("['\u2019]","g"),Sn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),On=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+En+mn,"g"),In=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+",An].join("|"),"g"),Rn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),zn=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Wn="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Bn={};
Bn["[object Float32Array]"]=Bn["[object Float64Array]"]=Bn["[object Int8Array]"]=Bn["[object Int16Array]"]=Bn["[object Int32Array]"]=Bn["[object Uint8Array]"]=Bn["[object Uint8ClampedArray]"]=Bn["[object Uint16Array]"]=Bn["[object Uint32Array]"]=true,Bn["[object Arguments]"]=Bn["[object Array]"]=Bn["[object ArrayBuffer]"]=Bn["[object Boolean]"]=Bn["[object DataView]"]=Bn["[object Date]"]=Bn["[object Error]"]=Bn["[object Function]"]=Bn["[object Map]"]=Bn["[object Number]"]=Bn["[object Object]"]=Bn["[object RegExp]"]=Bn["[object Set]"]=Bn["[object String]"]=Bn["[object WeakMap]"]=false;
var Ln={};Ln["[object Arguments]"]=Ln["[object Array]"]=Ln["[object ArrayBuffer]"]=Ln["[object DataView]"]=Ln["[object Boolean]"]=Ln["[object Date]"]=Ln["[object Float32Array]"]=Ln["[object Float64Array]"]=Ln["[object Int8Array]"]=Ln["[object Int16Array]"]=Ln["[object Int32Array]"]=Ln["[object Map]"]=Ln["[object Number]"]=Ln["[object Object]"]=Ln["[object RegExp]"]=Ln["[object Set]"]=Ln["[object String]"]=Ln["[object Symbol]"]=Ln["[object Uint8Array]"]=Ln["[object Uint8ClampedArray]"]=Ln["[object Uint16Array]"]=Ln["[object Uint32Array]"]=true,
Ln["[object Error]"]=Ln["[object Function]"]=Ln["[object WeakMap]"]=false;var Un={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Cn=parseFloat,Dn=parseInt,Mn=typeof global=="object"&&global&&global.Object===Object&&global,Tn=typeof self=="object"&&self&&self.Object===Object&&self,$n=Mn||Tn||Function("return this")(),Fn=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Nn=Fn&&typeof module=="object"&&module&&!module.nodeType&&module,Pn=Nn&&Nn.exports===Fn,Zn=Pn&&Mn.process,qn=function(){
try{var n=Nn&&Nn.f&&Nn.f("util").types;return n?n:Zn&&Zn.binding&&Zn.binding("util")}catch(n){}}(),Vn=qn&&qn.isArrayBuffer,Kn=qn&&qn.isDate,Gn=qn&&qn.isMap,Hn=qn&&qn.isRegExp,Jn=qn&&qn.isSet,Yn=qn&&qn.isTypedArray,Qn=b("length"),Xn=x({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I",
"\xcd":"I","\xce":"I","\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C",
"\u0108":"C","\u010a":"C","\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i",
"\u012b":"i","\u012d":"i","\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r",
"\u015a":"S","\u015c":"S","\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij",
"\u0152":"Oe","\u0153":"oe","\u0149":"'n","\u017f":"s"}),nt=x({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),tt=x({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),rt=function x(mn){function An(n){if(yu(n)&&!ff(n)&&!(n instanceof Un)){if(n instanceof On)return n;if(oi.call(n,"__wrapped__"))return Fe(n)}return new On(n)}function En(){}function On(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=T}function Un(n){this.__wrapped__=n,
this.__actions__=[],this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Mn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Fn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Fn;++t<r;)this.add(n[t]);
}function Zn(n){this.size=(this.__data__=new Tn(n)).size}function qn(n,t){var r,e=ff(n),u=!e&&of(n),i=!e&&!u&&af(n),o=!e&&!u&&!i&&_f(n),u=(e=e||u||i||o)?A(n.length,ni):[],f=u.length;for(r in n)!t&&!oi.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Se(r,f))||u.push(r);return u}function Qn(n){var t=n.length;return t?n[ir(0,t-1)]:T}function et(n,t){return De(Ur(n),pt(t,0,n.length))}function ut(n){return De(Ur(n))}function it(n,t,r){(r===T||lu(n[t],r))&&(r!==T||t in n)||st(n,t,r);
}function ot(n,t,r){var e=n[t];oi.call(n,t)&&lu(e,r)&&(r!==T||t in n)||st(n,t,r)}function ft(n,t){for(var r=n.length;r--;)if(lu(n[r][0],t))return r;return-1}function ct(n,t,r,e){return uo(n,function(n,u,i){t(e,n,r(n),i)}),e}function at(n,t){return n&&Cr(t,Wu(t),n)}function lt(n,t){return n&&Cr(t,Bu(t),n)}function st(n,t,r){"__proto__"==t&&Ai?Ai(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function ht(n,t){for(var r=-1,e=t.length,u=Ku(e),i=null==n;++r<e;)u[r]=i?T:Ru(n,t[r]);return u;
}function pt(n,t,r){return n===n&&(r!==T&&(n=n<=r?n:r),t!==T&&(n=n>=t?n:t)),n}function _t(n,t,e,u,i,o){var f,c=1&t,a=2&t,l=4&t;if(e&&(f=i?e(n,u,i,o):e(n)),f!==T)return f;if(!du(n))return n;if(u=ff(n)){if(f=me(n),!c)return Ur(n,f)}else{var s=vo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(af(n))return Ir(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Ae(n),!c)return a?Mr(n,lt(f,n)):Dr(n,at(f,n))}else{if(!Ln[s])return i?n:{};f=Ee(n,s,c)}}if(o||(o=new Zn),
i=o.get(n))return i;o.set(n,f),pf(n)?n.forEach(function(r){f.add(_t(r,t,e,r,n,o))}):sf(n)&&n.forEach(function(r,u){f.set(u,_t(r,t,e,u,n,o))});var a=l?a?ve:_e:a?Bu:Wu,p=u?T:a(n);return r(p||n,function(r,u){p&&(u=r,r=n[u]),ot(f,u,_t(r,t,e,u,n,o))}),f}function vt(n){var t=Wu(n);return function(r){return gt(r,n,t)}}function gt(n,t,r){var e=r.length;if(null==n)return!e;for(n=Qu(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===T&&!(u in n)||!i(o))return false}return true}function dt(n,t,r){if(typeof n!="function")throw new ti("Expected a function");
return bo(function(){n.apply(T,r)},t)}function yt(n,t,r,e){var u=-1,i=o,a=true,l=n.length,s=[],h=t.length;if(!l)return s;r&&(t=c(t,k(r))),e?(i=f,a=false):200<=t.length&&(i=O,a=false,t=new Nn(t));n:for(;++u<l;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(a&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function bt(n,t){var r=true;return uo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function xt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===T?o===o&&!wu(o):r(o,f)))var f=o,c=i;
}return c}function jt(n,t){var r=[];return uo(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function wt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=ke),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?wt(f,t-1,r,e,u):a(u,f):e||(u[u.length]=f)}return u}function mt(n,t){return n&&oo(n,t,Wu)}function At(n,t){return n&&fo(n,t,Wu)}function Et(n,t){return i(t,function(t){return _u(n[t])})}function kt(n,t){t=Sr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[Me(t[r++])];return r&&r==e?n:T}function St(n,t,r){return t=t(n),
ff(n)?t:a(t,r(n))}function Ot(n){if(null==n)n=n===T?"[object Undefined]":"[object Null]";else if(mi&&mi in Qu(n)){var t=oi.call(n,mi),r=n[mi];try{n[mi]=T;var e=true}catch(n){}var u=ai.call(n);e&&(t?n[mi]=r:delete n[mi]),n=u}else n=ai.call(n);return n}function It(n,t){return n>t}function Rt(n,t){return null!=n&&oi.call(n,t)}function zt(n,t){return null!=n&&t in Qu(n)}function Wt(n,t,r){for(var e=r?f:o,u=n[0].length,i=n.length,a=i,l=Ku(i),s=1/0,h=[];a--;){var p=n[a];a&&t&&(p=c(p,k(t))),s=Ci(p.length,s),
l[a]=!r&&(t||120<=u&&120<=p.length)?new Nn(a&&p):T}var p=n[0],_=-1,v=l[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;if(v?!O(v,d):!e(h,d,r)){for(a=i;--a;){var y=l[a];if(y?!O(y,d):!e(n[a],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Bt(n,t,r){var e={};return mt(n,function(n,u,i){t(e,r(n),u,i)}),e}function Lt(t,r,e){return r=Sr(r,t),t=2>r.length?t:kt(t,hr(r,0,-1)),r=null==t?t:t[Me(Ve(r))],null==r?T:n(r,t,e)}function Ut(n){return yu(n)&&"[object Arguments]"==Ot(n)}function Ct(n){
return yu(n)&&"[object ArrayBuffer]"==Ot(n)}function Dt(n){return yu(n)&&"[object Date]"==Ot(n)}function Mt(n,t,r,e,u){if(n===t)t=true;else if(null==n||null==t||!yu(n)&&!yu(t))t=n!==n&&t!==t;else n:{var i=ff(n),o=ff(t),f=i?"[object Array]":vo(n),c=o?"[object Array]":vo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&af(n)){if(!af(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Zn),t=i||_f(n)?se(n,t,r,e,Mt,u):he(n,t,f,r,e,Mt,u);else{
if(!(1&r)&&(i=a&&oi.call(n,"__wrapped__"),f=o&&oi.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Zn),t=Mt(n,t,r,e,u);break n}if(c)t:if(u||(u=new Zn),i=1&r,f=_e(n),o=f.length,c=_e(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:oi.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===T?h!==p&&!Mt(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l);
}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Tt(n){return yu(n)&&"[object Map]"==vo(n)}function $t(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=Qu(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===T&&!(c in n))return false;
}else{if(f=new Zn,e)var s=e(a,l,c,n,t,f);if(s===T?!Mt(l,a,3,e,f):!s)return false}}return true}function Ft(n){return!(!du(n)||ci&&ci in n)&&(_u(n)?hi:dn).test(Te(n))}function Nt(n){return yu(n)&&"[object RegExp]"==Ot(n)}function Pt(n){return yu(n)&&"[object Set]"==vo(n)}function Zt(n){return yu(n)&&gu(n.length)&&!!Bn[Ot(n)]}function qt(n){return typeof n=="function"?n:null==n?$u:typeof n=="object"?ff(n)?Jt(n[0],n[1]):Ht(n):Zu(n)}function Vt(n){if(!ze(n))return Li(n);var t,r=[];for(t in Qu(n))oi.call(n,t)&&"constructor"!=t&&r.push(t);
return r}function Kt(n,t){return n<t}function Gt(n,t){var r=-1,e=su(n)?Ku(n.length):[];return uo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Ht(n){var t=xe(n);return 1==t.length&&t[0][2]?We(t[0][0],t[0][1]):function(r){return r===n||$t(r,n,t)}}function Jt(n,t){return Ie(n)&&t===t&&!du(t)?We(Me(n),t):function(r){var e=Ru(r,n);return e===T&&e===t?zu(r,n):Mt(t,e,3)}}function Yt(n,t,r,e,u){n!==t&&oo(t,function(i,o){if(u||(u=new Zn),du(i)){var f=u,c=Le(n,o),a=Le(t,o),l=f.get(a);if(l)it(n,o,l);else{
var l=e?e(c,a,o+"",n,t,f):T,s=l===T;if(s){var h=ff(a),p=!h&&af(a),_=!h&&!p&&_f(a),l=a;h||p||_?ff(c)?l=c:hu(c)?l=Ur(c):p?(s=false,l=Ir(a,true)):_?(s=false,l=zr(a,true)):l=[]:xu(a)||of(a)?(l=c,of(c)?l=Ou(c):du(c)&&!_u(c)||(l=Ae(a))):s=false}s&&(f.set(a,l),Yt(l,a,r,e,f),f.delete(a)),it(n,o,l)}}else f=e?e(Le(n,o),i,o+"",n,t,u):T,f===T&&(f=i),it(n,o,f)},Bu)}function Qt(n,t){var r=n.length;if(r)return t+=0>t?r:0,Se(t,r)?n[t]:T}function Xt(n,t,r){var e=-1;return t=c(t.length?t:[$u],k(ye())),n=Gt(n,function(n){return{
a:c(t,function(t){return t(n)}),b:++e,c:n}}),w(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Wr(u[e],i[e]);if(c){e=e>=f?c:c*("desc"==r[e]?-1:1);break n}}e=n.b-t.b}return e})}function nr(n,t){return tr(n,t,function(t,r){return zu(n,r)})}function tr(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=kt(n,o);r(f,o)&&lr(i,Sr(o,n),f)}return i}function rr(n){return function(t){return kt(t,n)}}function er(n,t,r,e){var u=e?g:v,i=-1,o=t.length,f=n;for(n===t&&(t=Ur(t)),
r&&(f=c(n,k(r)));++i<o;)for(var a=0,l=t[i],l=r?r(l):l;-1<(a=u(f,l,a,e));)f!==n&&xi.call(f,a,1),xi.call(n,a,1);return n}function ur(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];if(r==e||u!==i){var i=u;Se(u)?xi.call(n,u,1):xr(n,u)}}}function ir(n,t){return n+Ii(Ti()*(t-n+1))}function or(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=Ii(t/2))&&(n+=n);while(t);return r}function fr(n,t){return xo(Be(n,t,$u),n+"")}function cr(n){return Qn(Uu(n))}function ar(n,t){var r=Uu(n);
return De(r,pt(t,0,r.length))}function lr(n,t,r,e){if(!du(n))return n;t=Sr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){var c=Me(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):T;a===T&&(a=du(l)?l:Se(t[u+1])?[]:{})}ot(f,c,a),f=f[c]}return n}function sr(n){return De(Uu(n))}function hr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Ku(u);++e<u;)r[e]=n[e+t];return r}function pr(n,t){var r;return uo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}
function _r(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!wu(o)&&(r?o<=t:o<t)?e=i+1:u=i}return u}return vr(n,t,$u,r)}function vr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=wu(t),a=t===T;u<i;){var l=Ii((u+i)/2),s=r(n[l]),h=s!==T,p=null===s,_=s===s,v=wu(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Ci(i,4294967294)}function gr(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){
var o=n[r],f=t?t(o):o;if(!r||!lu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function dr(n){return typeof n=="number"?n:wu(n)?F:+n}function yr(n){if(typeof n=="string")return n;if(ff(n))return c(n,yr)+"";if(wu(n))return ro?ro.call(n):"";var t=n+"";return"0"==t&&1/n==-$?"-0":t}function br(n,t,r){var e=-1,u=o,i=n.length,c=true,a=[],l=a;if(r)c=false,u=f;else if(200<=i){if(u=t?null:so(n))return U(u);c=false,u=O,l=new Nn}else l=t?[]:a;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(c&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;
t&&l.push(h),a.push(s)}else u(l,h,r)||(l!==a&&l.push(h),a.push(s))}return a}function xr(n,t){return t=Sr(t,n),n=2>t.length?n:kt(n,hr(t,0,-1)),null==n||delete n[Me(Ve(t))]}function jr(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?hr(n,e?0:i,e?i+1:u):hr(n,e?i+1:0,e?u:i)}function wr(n,t){var r=n;return r instanceof Un&&(r=r.value()),l(t,function(n,t){return t.func.apply(t.thisArg,a([n],t.args))},r)}function mr(n,t,r){var e=n.length;if(2>e)return e?br(n[0]):[];for(var u=-1,i=Ku(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=yt(i[u]||o,n[f],t,r));
return br(wt(i,1),t,r)}function Ar(n,t,r){for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:T);return o}function Er(n){return hu(n)?n:[]}function kr(n){return typeof n=="function"?n:$u}function Sr(n,t){return ff(n)?n:Ie(n,t)?[n]:jo(Iu(n))}function Or(n,t,r){var e=n.length;return r=r===T?e:r,!t&&r>=e?n:hr(n,t,r)}function Ir(n,t){if(t)return n.slice();var r=n.length,r=gi?gi(r):new n.constructor(r);return n.copy(r),r}function Rr(n){var t=new n.constructor(n.byteLength);return new vi(t).set(new vi(n)),
t}function zr(n,t){return new n.constructor(t?Rr(n.buffer):n.buffer,n.byteOffset,n.length)}function Wr(n,t){if(n!==t){var r=n!==T,e=null===n,u=n===n,i=wu(n),o=t!==T,f=null===t,c=t===t,a=wu(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Br(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Ui(i-o,0),l=Ku(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];
return l}function Lr(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Ui(i-f,0),s=Ku(l+a);for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Ur(n,t){var r=-1,e=n.length;for(t||(t=Ku(e));++r<e;)t[r]=n[r];return t}function Cr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):T;c===T&&(c=n[f]),u?st(r,f,c):ot(r,f,c)}return r}function Dr(n,t){return Cr(n,po(n),t)}function Mr(n,t){return Cr(n,_o(n),t);
}function Tr(n,r){return function(e,u){var i=ff(e)?t:ct,o=r?r():{};return i(e,n,ye(u,2),o)}}function $r(n){return fr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:T,o=2<u?r[2]:T,i=3<n.length&&typeof i=="function"?(u--,i):T;for(o&&Oe(r[0],r[1],o)&&(i=3>u?T:i,u=1),t=Qu(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Fr(n,t){return function(r,e){if(null==r)return r;if(!su(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=Qu(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function Nr(n){return function(t,r,e){
var u=-1,i=Qu(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break}return t}}function Pr(n,t,r){function e(){return(this&&this!==$n&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Vr(n);return e}function Zr(n){return function(t){t=Iu(t);var r=Rn.test(t)?M(t):T,e=r?r[0]:t.charAt(0);return t=r?Or(r,1).join(""):t.slice(1),e[n]()+t}}function qr(n){return function(t){return l(Mu(Du(t).replace(kn,"")),n,"")}}function Vr(n){return function(){var t=arguments;switch(t.length){
case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=eo(n.prototype),t=n.apply(r,t);return du(t)?t:r}}function Kr(t,r,e){function u(){for(var o=arguments.length,f=Ku(o),c=o,a=de(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:L(f,a),
o-=c.length,o<e?ue(t,r,Jr,u.placeholder,T,f,c,T,T,e-o):n(this&&this!==$n&&this instanceof u?i:t,this,f)}var i=Vr(t);return u}function Gr(n){return function(t,r,e){var u=Qu(t);if(!su(t)){var i=ye(r,3);t=Wu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:T}}function Hr(n){return pe(function(t){var r=t.length,e=r,u=On.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ti("Expected a function");if(u&&!o&&"wrapper"==ge(i))var o=new On([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=ge(i),f="wrapper"==u?ho(i):T,o=f&&Re(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[ge(f[0])].apply(o,f[3]):1==i.length&&Re(i)?o[u]():o.thru(i);
return function(){var n=arguments,e=n[0];if(o&&1==n.length&&ff(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Jr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Ku(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=de(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Br(y,e,u,_)),i&&(y=Lr(y,i,o,_)),d-=x,_&&d<a)return j=L(y,j),ue(n,t,Jr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Ci(f.length,x),m=Ur(y);w--;){
var A=f[w];y[w]=Se(A,x)?m[A]:T}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==$n&&this instanceof l&&(b=g||Vr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?T:Vr(n);return l}function Yr(n,t){return function(r,e){return Bt(r,n,t(e))}}function Qr(n,t){return function(r,e){var u;if(r===T&&e===T)return t;if(r!==T&&(u=r),e!==T){if(u===T)return e;typeof r=="string"||typeof e=="string"?(r=yr(r),e=yr(e)):(r=dr(r),e=dr(e)),u=n(r,e)}return u}}function Xr(t){return pe(function(r){
return r=c(r,k(ye())),fr(function(e){var u=this;return t(r,function(t){return n(t,u,e)})})})}function ne(n,t){t=t===T?" ":yr(t);var r=t.length;return 2>r?r?or(t,n):t:(r=or(t,Oi(n/D(t))),Rn.test(t)?Or(M(r),0,n).join(""):r.slice(0,n))}function te(t,r,e,u){function i(){for(var r=-1,c=arguments.length,a=-1,l=u.length,s=Ku(l+c),h=this&&this!==$n&&this instanceof i?f:t;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++r];return n(h,o?e:this,s)}var o=1&r,f=Vr(t);return i}function re(n){return function(t,r,e){
e&&typeof e!="number"&&Oe(t,r,e)&&(r=e=T),t=Au(t),r===T?(r=t,t=0):r=Au(r),e=e===T?t<r?1:-1:Au(e);var u=-1;r=Ui(Oi((r-t)/(e||1)),0);for(var i=Ku(r);r--;)i[n?r:++u]=t,t+=e;return i}}function ee(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Su(t),r=Su(r)),n(t,r)}}function ue(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:T;o=l?T:o;var h=l?i:T;return i=l?T:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(T,u),Re(n)&&yo(r,u),r.placeholder=e,Ue(r,n,t)}function ie(n){
var t=Yu[n];return function(n,r){if(n=Su(n),(r=null==r?0:Ci(Eu(r),292))&&Wi(n)){var e=(Iu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(Iu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function oe(n){return function(t){var r=vo(t);return"[object Map]"==r?W(t):"[object Set]"==r?C(t):E(t,n(t))}}function fe(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ti("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=T),o=o===T?o:Ui(Eu(o),0),f=f===T?f:Eu(f),a-=u?u.length:0,
64&t){var l=e,s=u;e=u=T}var h=c?T:ho(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Br(e,r,h[4]):r,i[4]=e?L(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Lr(e,r,h[6]):r,i[6]=e?L(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Ci(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],
t=i[1],r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===T?c?0:n.length:Ui(i[9]-a,0),!f&&24&t&&(t&=-25),Ue((h?co:yo)(t&&1!=t?8==t||16==t?Kr(n,t,f):32!=t&&33!=t||u.length?Jr.apply(T,i):te(n,t,r,e):Pr(n,t,r),i),n,t)}function ce(n,t,r,e){return n===T||lu(n,ei[r])&&!oi.call(e,r)?t:n}function ae(n,t,r,e,u,i){return du(n)&&du(t)&&(i.set(t,n),Yt(n,t,T,ae,i),i.delete(t)),n}function le(n){return xu(n)?T:n}function se(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;
var c=-1,a=true,l=2&r?new Nn:T;for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],p=t[c];if(e)var _=o?e(p,s,c,t,n,i):e(s,p,c,n,t,i);if(_!==T){if(_)continue;a=false;break}if(l){if(!h(t,function(n,t){if(!O(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==p&&!u(s,p,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function he(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":
if(n.byteLength!=t.byteLength||!i(new vi(n),new vi(t)))break;return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return lu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=W;case"[object Set]":if(f||(f=U),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=se(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(to)return to.call(n)==to.call(t)}
return false}function pe(n){return xo(Be(n,T,Ze),n+"")}function _e(n){return St(n,Wu,po)}function ve(n){return St(n,Bu,_o)}function ge(n){for(var t=n.name+"",r=Gi[t],e=oi.call(Gi,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function de(n){return(oi.call(An,"placeholder")?An:n).placeholder}function ye(){var n=An.iteratee||Fu,n=n===Fu?qt:n;return arguments.length?n(arguments[0],arguments[1]):n}function be(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
}function xe(n){for(var t=Wu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!du(u)]}return t}function je(n,t){var r=null==n?T:n[t];return Ft(r)?r:T}function we(n,t,r){t=Sr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=Me(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&gu(u)&&Se(o,u)&&(ff(n)||of(n)))}function me(n){var t=n.length,r=new n.constructor(t);return t&&"string"==typeof n[0]&&oi.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Ae(n){
return typeof n.constructor!="function"||ze(n)?{}:eo(di(n))}function Ee(n,t,r){var e=n.constructor;switch(t){case"[object ArrayBuffer]":return Rr(n);case"[object Boolean]":case"[object Date]":return new e(+n);case"[object DataView]":return t=r?Rr(n.buffer):n.buffer,new n.constructor(t,n.byteOffset,n.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
case"[object Uint16Array]":case"[object Uint32Array]":return zr(n,r);case"[object Map]":return new e;case"[object Number]":case"[object String]":return new e(n);case"[object RegExp]":return t=new n.constructor(n.source,_n.exec(n)),t.lastIndex=n.lastIndex,t;case"[object Set]":return new e;case"[object Symbol]":return to?Qu(to.call(n)):{}}}function ke(n){return ff(n)||of(n)||!!(ji&&n&&n[ji])}function Se(n,t){var r=typeof n;return t=null==t?9007199254740991:t,!!t&&("number"==r||"symbol"!=r&&bn.test(n))&&-1<n&&0==n%1&&n<t;
}function Oe(n,t,r){if(!du(r))return false;var e=typeof t;return!!("number"==e?su(r)&&Se(t,r.length):"string"==e&&t in r)&&lu(r[t],n)}function Ie(n,t){if(ff(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!wu(n))||(nn.test(n)||!X.test(n)||null!=t&&n in Qu(t))}function Re(n){var t=ge(n),r=An[t];return typeof r=="function"&&t in Un.prototype&&(n===r||(t=ho(r),!!t&&n===t[0]))}function ze(n){var t=n&&n.constructor;return n===(typeof t=="function"&&t.prototype||ei)}function We(n,t){
return function(r){return null!=r&&(r[n]===t&&(t!==T||n in Qu(r)))}}function Be(t,r,e){return r=Ui(r===T?t.length-1:r,0),function(){for(var u=arguments,i=-1,o=Ui(u.length-r,0),f=Ku(o);++i<o;)f[i]=u[r+i];for(i=-1,o=Ku(r+1);++i<r;)o[i]=u[i];return o[r]=e(f),n(t,this,o)}}function Le(n,t){if(("constructor"!==t||"function"!=typeof n[t])&&"__proto__"!=t)return n[t]}function Ue(n,t,r){var e=t+"";t=xo;var u,i=$e;return u=(u=e.match(an))?u[1].split(ln):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],
r=r.join(2<i?", ":" "),e=e.replace(cn,"{\n/* [wrapped with "+r+"] */\n")),t(n,e)}function Ce(n){var t=0,r=0;return function(){var e=Di(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(T,arguments)}}function De(n,t){var r=-1,e=n.length,u=e-1;for(t=t===T?e:t;++r<t;){var e=ir(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function Me(n){if(typeof n=="string"||wu(n))return n;var t=n+"";return"0"==t&&1/n==-$?"-0":t}function Te(n){if(null!=n){try{return ii.call(n)}catch(n){}
return n+""}return""}function $e(n,t){return r(N,function(r){var e="_."+r[0];t&r[1]&&!o(n,e)&&n.push(e)}),n.sort()}function Fe(n){if(n instanceof Un)return n.clone();var t=new On(n.__wrapped__,n.__chain__);return t.__actions__=Ur(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ne(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Eu(r),0>r&&(r=Ui(e+r,0)),_(n,ye(t,3),r)):-1}function Pe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==T&&(u=Eu(r),u=0>r?Ui(e+u,0):Ci(u,e-1)),
_(n,ye(t,3),u,true)}function Ze(n){return(null==n?0:n.length)?wt(n,1):[]}function qe(n){return n&&n.length?n[0]:T}function Ve(n){var t=null==n?0:n.length;return t?n[t-1]:T}function Ke(n,t){return n&&n.length&&t&&t.length?er(n,t):n}function Ge(n){return null==n?n:$i.call(n)}function He(n){if(!n||!n.length)return[];var t=0;return n=i(n,function(n){if(hu(n))return t=Ui(n.length,t),true}),A(t,function(t){return c(n,b(t))})}function Je(t,r){if(!t||!t.length)return[];var e=He(t);return null==r?e:c(e,function(t){
return n(r,T,t)})}function Ye(n){return n=An(n),n.__chain__=true,n}function Qe(n,t){return t(n)}function Xe(){return this}function nu(n,t){return(ff(n)?r:uo)(n,ye(t,3))}function tu(n,t){return(ff(n)?e:io)(n,ye(t,3))}function ru(n,t){return(ff(n)?c:Gt)(n,ye(t,3))}function eu(n,t,r){return t=r?T:t,t=n&&null==t?n.length:t,fe(n,128,T,T,T,T,t)}function uu(n,t){var r;if(typeof t!="function")throw new ti("Expected a function");return n=Eu(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=T),
r}}function iu(n,t,r){return t=r?T:t,n=fe(n,8,T,T,T,T,T,t),n.placeholder=iu.placeholder,n}function ou(n,t,r){return t=r?T:t,n=fe(n,16,T,T,T,T,T,t),n.placeholder=ou.placeholder,n}function fu(n,t,r){function e(t){var r=c,e=a;return c=a=T,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===T||r>=t||0>r||g&&n>=l}function i(){var n=Go();if(u(n))return o(n);var r,e=bo;r=n-_,n=t-(n-p),r=g?Ci(n,l-r):n,h=e(i,r)}function o(n){return h=T,d&&c?e(n):(c=a=T,s)}function f(){var n=Go(),r=u(n);if(c=arguments,
a=this,p=n,r){if(h===T)return _=n=p,h=bo(i,t),v?e(n):s;if(g)return lo(h),h=bo(i,t),e(p)}return h===T&&(h=bo(i,t)),s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ti("Expected a function");return t=Su(t)||0,du(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Ui(Su(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==T&&lo(h),_=0,c=p=a=h=T},f.flush=function(){return h===T?s:o(Go())},f}function cu(n,t){function r(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;
return i.has(u)?i.get(u):(e=n.apply(this,e),r.cache=i.set(u,e)||i,e)}if(typeof n!="function"||null!=t&&typeof t!="function")throw new ti("Expected a function");return r.cache=new(cu.Cache||Fn),r}function au(n){if(typeof n!="function")throw new ti("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function lu(n,t){return n===t||n!==n&&t!==t;
}function su(n){return null!=n&&gu(n.length)&&!_u(n)}function hu(n){return yu(n)&&su(n)}function pu(n){if(!yu(n))return false;var t=Ot(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!xu(n)}function _u(n){return!!du(n)&&(n=Ot(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function vu(n){return typeof n=="number"&&n==Eu(n)}function gu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n;
}function du(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)}function yu(n){return null!=n&&typeof n=="object"}function bu(n){return typeof n=="number"||yu(n)&&"[object Number]"==Ot(n)}function xu(n){return!(!yu(n)||"[object Object]"!=Ot(n))&&(n=di(n),null===n||(n=oi.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&ii.call(n)==li))}function ju(n){return typeof n=="string"||!ff(n)&&yu(n)&&"[object String]"==Ot(n)}function wu(n){return typeof n=="symbol"||yu(n)&&"[object Symbol]"==Ot(n);
}function mu(n){if(!n)return[];if(su(n))return ju(n)?M(n):Ur(n);if(wi&&n[wi]){n=n[wi]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r}return t=vo(n),("[object Map]"==t?W:"[object Set]"==t?U:Uu)(n)}function Au(n){return n?(n=Su(n),n===$||n===-$?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function Eu(n){n=Au(n);var t=n%1;return n===n?t?n-t:n:0}function ku(n){return n?pt(Eu(n),0,4294967295):0}function Su(n){if(typeof n=="number")return n;if(wu(n))return F;if(du(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,
n=du(n)?n+"":n),typeof n!="string")return 0===n?n:+n;n=n.replace(un,"");var t=gn.test(n);return t||yn.test(n)?Dn(n.slice(2),t?2:8):vn.test(n)?F:+n}function Ou(n){return Cr(n,Bu(n))}function Iu(n){return null==n?"":yr(n)}function Ru(n,t,r){return n=null==n?T:kt(n,t),n===T?r:n}function zu(n,t){return null!=n&&we(n,t,zt)}function Wu(n){return su(n)?qn(n):Vt(n)}function Bu(n){if(su(n))n=qn(n,true);else if(du(n)){var t,r=ze(n),e=[];for(t in n)("constructor"!=t||!r&&oi.call(n,t))&&e.push(t);n=e}else{if(t=[],
null!=n)for(r in Qu(n))t.push(r);n=t}return n}function Lu(n,t){if(null==n)return{};var r=c(ve(n),function(n){return[n]});return t=ye(t),tr(n,r,function(n,r){return t(n,r[0])})}function Uu(n){return null==n?[]:S(n,Wu(n))}function Cu(n){return $f(Iu(n).toLowerCase())}function Du(n){return(n=Iu(n))&&n.replace(xn,Xn).replace(Sn,"")}function Mu(n,t,r){return n=Iu(n),t=r?T:t,t===T?zn.test(n)?n.match(In)||[]:n.match(sn)||[]:n.match(t)||[]}function Tu(n){return function(){return n}}function $u(n){return n;
}function Fu(n){return qt(typeof n=="function"?n:_t(n,1))}function Nu(n,t,e){var u=Wu(t),i=Et(t,u);null!=e||du(t)&&(i.length||!u.length)||(e=t,t=n,n=this,i=Et(t,Wu(t)));var o=!(du(e)&&"chain"in e&&!e.chain),f=_u(n);return r(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Ur(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,a([this.value()],arguments))})}),n}function Pu(){}
function Zu(n){return Ie(n)?b(Me(n)):rr(n)}function qu(){return[]}function Vu(){return false}mn=null==mn?$n:rt.defaults($n.Object(),mn,rt.pick($n,Wn));var Ku=mn.Array,Gu=mn.Date,Hu=mn.Error,Ju=mn.Function,Yu=mn.Math,Qu=mn.Object,Xu=mn.RegExp,ni=mn.String,ti=mn.TypeError,ri=Ku.prototype,ei=Qu.prototype,ui=mn["__core-js_shared__"],ii=Ju.prototype.toString,oi=ei.hasOwnProperty,fi=0,ci=function(){var n=/[^.]+$/.exec(ui&&ui.keys&&ui.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),ai=ei.toString,li=ii.call(Qu),si=$n._,hi=Xu("^"+ii.call(oi).replace(rn,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),pi=Pn?mn.Buffer:T,_i=mn.Symbol,vi=mn.Uint8Array,gi=pi?pi.g:T,di=B(Qu.getPrototypeOf,Qu),yi=Qu.create,bi=ei.propertyIsEnumerable,xi=ri.splice,ji=_i?_i.isConcatSpreadable:T,wi=_i?_i.iterator:T,mi=_i?_i.toStringTag:T,Ai=function(){
try{var n=je(Qu,"defineProperty");return n({},"",{}),n}catch(n){}}(),Ei=mn.clearTimeout!==$n.clearTimeout&&mn.clearTimeout,ki=Gu&&Gu.now!==$n.Date.now&&Gu.now,Si=mn.setTimeout!==$n.setTimeout&&mn.setTimeout,Oi=Yu.ceil,Ii=Yu.floor,Ri=Qu.getOwnPropertySymbols,zi=pi?pi.isBuffer:T,Wi=mn.isFinite,Bi=ri.join,Li=B(Qu.keys,Qu),Ui=Yu.max,Ci=Yu.min,Di=Gu.now,Mi=mn.parseInt,Ti=Yu.random,$i=ri.reverse,Fi=je(mn,"DataView"),Ni=je(mn,"Map"),Pi=je(mn,"Promise"),Zi=je(mn,"Set"),qi=je(mn,"WeakMap"),Vi=je(Qu,"create"),Ki=qi&&new qi,Gi={},Hi=Te(Fi),Ji=Te(Ni),Yi=Te(Pi),Qi=Te(Zi),Xi=Te(qi),no=_i?_i.prototype:T,to=no?no.valueOf:T,ro=no?no.toString:T,eo=function(){
function n(){}return function(t){return du(t)?yi?yi(t):(n.prototype=t,t=new n,n.prototype=T,t):{}}}();An.templateSettings={escape:J,evaluate:Y,interpolate:Q,variable:"",imports:{_:An}},An.prototype=En.prototype,An.prototype.constructor=An,On.prototype=eo(En.prototype),On.prototype.constructor=On,Un.prototype=eo(En.prototype),Un.prototype.constructor=Un,Mn.prototype.clear=function(){this.__data__=Vi?Vi(null):{},this.size=0},Mn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
this.size-=n?1:0,n},Mn.prototype.get=function(n){var t=this.__data__;return Vi?(n=t[n],"__lodash_hash_undefined__"===n?T:n):oi.call(t,n)?t[n]:T},Mn.prototype.has=function(n){var t=this.__data__;return Vi?t[n]!==T:oi.call(t,n)},Mn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Vi&&t===T?"__lodash_hash_undefined__":t,this},Tn.prototype.clear=function(){this.__data__=[],this.size=0},Tn.prototype.delete=function(n){var t=this.__data__;return n=ft(t,n),!(0>n)&&(n==t.length-1?t.pop():xi.call(t,n,1),
--this.size,true)},Tn.prototype.get=function(n){var t=this.__data__;return n=ft(t,n),0>n?T:t[n][1]},Tn.prototype.has=function(n){return-1<ft(this.__data__,n)},Tn.prototype.set=function(n,t){var r=this.__data__,e=ft(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Fn.prototype.clear=function(){this.size=0,this.__data__={hash:new Mn,map:new(Ni||Tn),string:new Mn}},Fn.prototype.delete=function(n){return n=be(this,n).delete(n),this.size-=n?1:0,n},Fn.prototype.get=function(n){return be(this,n).get(n);
},Fn.prototype.has=function(n){return be(this,n).has(n)},Fn.prototype.set=function(n,t){var r=be(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},Nn.prototype.add=Nn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},Nn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.clear=function(){this.__data__=new Tn,this.size=0},Zn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Zn.prototype.get=function(n){
return this.__data__.get(n)},Zn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Tn){var e=r.__data__;if(!Ni||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Fn(e)}return r.set(n,t),this.size=r.size,this};var uo=Fr(mt),io=Fr(At,true),oo=Nr(),fo=Nr(true),co=Ki?function(n,t){return Ki.set(n,t),n}:$u,ao=Ai?function(n,t){return Ai(n,"toString",{configurable:true,enumerable:false,value:Tu(t),writable:true})}:$u,lo=Ei||function(n){
return $n.clearTimeout(n)},so=Zi&&1/U(new Zi([,-0]))[1]==$?function(n){return new Zi(n)}:Pu,ho=Ki?function(n){return Ki.get(n)}:Pu,po=Ri?function(n){return null==n?[]:(n=Qu(n),i(Ri(n),function(t){return bi.call(n,t)}))}:qu,_o=Ri?function(n){for(var t=[];n;)a(t,po(n)),n=di(n);return t}:qu,vo=Ot;(Fi&&"[object DataView]"!=vo(new Fi(new ArrayBuffer(1)))||Ni&&"[object Map]"!=vo(new Ni)||Pi&&"[object Promise]"!=vo(Pi.resolve())||Zi&&"[object Set]"!=vo(new Zi)||qi&&"[object WeakMap]"!=vo(new qi))&&(vo=function(n){
var t=Ot(n);if(n=(n="[object Object]"==t?n.constructor:T)?Te(n):"")switch(n){case Hi:return"[object DataView]";case Ji:return"[object Map]";case Yi:return"[object Promise]";case Qi:return"[object Set]";case Xi:return"[object WeakMap]"}return t});var go=ui?_u:Vu,yo=Ce(co),bo=Si||function(n,t){return $n.setTimeout(n,t)},xo=Ce(ao),jo=function(n){n=cu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return 46===n.charCodeAt(0)&&t.push(""),n.replace(tn,function(n,r,e,u){
t.push(e?u.replace(hn,"$1"):r||n)}),t}),wo=fr(function(n,t){return hu(n)?yt(n,wt(t,1,hu,true)):[]}),mo=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),ye(r,2)):[]}),Ao=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),T,r):[]}),Eo=fr(function(n){var t=c(n,Er);return t.length&&t[0]===n[0]?Wt(t):[]}),ko=fr(function(n){var t=Ve(n),r=c(n,Er);return t===Ve(r)?t=T:r.pop(),r.length&&r[0]===n[0]?Wt(r,ye(t,2)):[]}),So=fr(function(n){var t=Ve(n),r=c(n,Er);return(t=typeof t=="function"?t:T)&&r.pop(),
r.length&&r[0]===n[0]?Wt(r,T,t):[]}),Oo=fr(Ke),Io=pe(function(n,t){var r=null==n?0:n.length,e=ht(n,t);return ur(n,c(t,function(n){return Se(n,r)?+n:n}).sort(Wr)),e}),Ro=fr(function(n){return br(wt(n,1,hu,true))}),zo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),br(wt(n,1,hu,true),ye(t,2))}),Wo=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return br(wt(n,1,hu,true),T,t)}),Bo=fr(function(n,t){return hu(n)?yt(n,t):[]}),Lo=fr(function(n){return mr(i(n,hu))}),Uo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),
mr(i(n,hu),ye(t,2))}),Co=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return mr(i(n,hu),T,t)}),Do=fr(He),Mo=fr(function(n){var t=n.length,t=1<t?n[t-1]:T,t=typeof t=="function"?(n.pop(),t):T;return Je(n,t)}),To=pe(function(n){function t(t){return ht(t,n)}var r=n.length,e=r?n[0]:0,u=this.__wrapped__;return!(1<r||this.__actions__.length)&&u instanceof Un&&Se(e)?(u=u.slice(e,+e+(r?1:0)),u.__actions__.push({func:Qe,args:[t],thisArg:T}),new On(u,this.__chain__).thru(function(n){return r&&!n.length&&n.push(T),
n})):this.thru(t)}),$o=Tr(function(n,t,r){oi.call(n,r)?++n[r]:st(n,r,1)}),Fo=Gr(Ne),No=Gr(Pe),Po=Tr(function(n,t,r){oi.call(n,r)?n[r].push(t):st(n,r,[t])}),Zo=fr(function(t,r,e){var u=-1,i=typeof r=="function",o=su(t)?Ku(t.length):[];return uo(t,function(t){o[++u]=i?n(r,t,e):Lt(t,r,e)}),o}),qo=Tr(function(n,t,r){st(n,r,t)}),Vo=Tr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ko=fr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&Oe(n,t[0],t[1])?t=[]:2<r&&Oe(t[0],t[1],t[2])&&(t=[t[0]]),
Xt(n,wt(t,1),[])}),Go=ki||function(){return $n.Date.now()},Ho=fr(function(n,t,r){var e=1;if(r.length)var u=L(r,de(Ho)),e=32|e;return fe(n,e,t,r,u)}),Jo=fr(function(n,t,r){var e=3;if(r.length)var u=L(r,de(Jo)),e=32|e;return fe(t,e,n,r,u)}),Yo=fr(function(n,t){return dt(n,1,t)}),Qo=fr(function(n,t,r){return dt(n,Su(t)||0,r)});cu.Cache=Fn;var Xo=fr(function(t,r){r=1==r.length&&ff(r[0])?c(r[0],k(ye())):c(wt(r,1),k(ye()));var e=r.length;return fr(function(u){for(var i=-1,o=Ci(u.length,e);++i<o;)u[i]=r[i].call(this,u[i]);
return n(t,this,u)})}),nf=fr(function(n,t){return fe(n,32,T,t,L(t,de(nf)))}),tf=fr(function(n,t){return fe(n,64,T,t,L(t,de(tf)))}),rf=pe(function(n,t){return fe(n,256,T,T,T,t)}),ef=ee(It),uf=ee(function(n,t){return n>=t}),of=Ut(function(){return arguments}())?Ut:function(n){return yu(n)&&oi.call(n,"callee")&&!bi.call(n,"callee")},ff=Ku.isArray,cf=Vn?k(Vn):Ct,af=zi||Vu,lf=Kn?k(Kn):Dt,sf=Gn?k(Gn):Tt,hf=Hn?k(Hn):Nt,pf=Jn?k(Jn):Pt,_f=Yn?k(Yn):Zt,vf=ee(Kt),gf=ee(function(n,t){return n<=t}),df=$r(function(n,t){
if(ze(t)||su(t))Cr(t,Wu(t),n);else for(var r in t)oi.call(t,r)&&ot(n,r,t[r])}),yf=$r(function(n,t){Cr(t,Bu(t),n)}),bf=$r(function(n,t,r,e){Cr(t,Bu(t),n,e)}),xf=$r(function(n,t,r,e){Cr(t,Wu(t),n,e)}),jf=pe(ht),wf=fr(function(n,t){n=Qu(n);var r=-1,e=t.length,u=2<e?t[2]:T;for(u&&Oe(t[0],t[1],u)&&(e=1);++r<e;)for(var u=t[r],i=Bu(u),o=-1,f=i.length;++o<f;){var c=i[o],a=n[c];(a===T||lu(a,ei[c])&&!oi.call(n,c))&&(n[c]=u[c])}return n}),mf=fr(function(t){return t.push(T,ae),n(Of,T,t)}),Af=Yr(function(n,t,r){
null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),n[t]=r},Tu($u)),Ef=Yr(function(n,t,r){null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),oi.call(n,t)?n[t].push(r):n[t]=[r]},ye),kf=fr(Lt),Sf=$r(function(n,t,r){Yt(n,t,r)}),Of=$r(function(n,t,r,e){Yt(n,t,r,e)}),If=pe(function(n,t){var r={};if(null==n)return r;var e=false;t=c(t,function(t){return t=Sr(t,n),e||(e=1<t.length),t}),Cr(n,ve(n),r),e&&(r=_t(r,7,le));for(var u=t.length;u--;)xr(r,t[u]);return r}),Rf=pe(function(n,t){return null==n?{}:nr(n,t);
}),zf=oe(Wu),Wf=oe(Bu),Bf=qr(function(n,t,r){return t=t.toLowerCase(),n+(r?Cu(t):t)}),Lf=qr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Uf=qr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Cf=Zr("toLowerCase"),Df=qr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase()}),Mf=qr(function(n,t,r){return n+(r?" ":"")+$f(t)}),Tf=qr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),$f=Zr("toUpperCase"),Ff=fr(function(t,r){try{return n(t,T,r)}catch(n){return pu(n)?n:new Hu(n)}}),Nf=pe(function(n,t){
return r(t,function(t){t=Me(t),st(n,t,Ho(n[t],n))}),n}),Pf=Hr(),Zf=Hr(true),qf=fr(function(n,t){return function(r){return Lt(r,n,t)}}),Vf=fr(function(n,t){return function(r){return Lt(n,r,t)}}),Kf=Xr(c),Gf=Xr(u),Hf=Xr(h),Jf=re(),Yf=re(true),Qf=Qr(function(n,t){return n+t},0),Xf=ie("ceil"),nc=Qr(function(n,t){return n/t},1),tc=ie("floor"),rc=Qr(function(n,t){return n*t},1),ec=ie("round"),uc=Qr(function(n,t){return n-t},0);return An.after=function(n,t){if(typeof t!="function")throw new ti("Expected a function");
return n=Eu(n),function(){if(1>--n)return t.apply(this,arguments)}},An.ary=eu,An.assign=df,An.assignIn=yf,An.assignInWith=bf,An.assignWith=xf,An.at=jf,An.before=uu,An.bind=Ho,An.bindAll=Nf,An.bindKey=Jo,An.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return ff(n)?n:[n]},An.chain=Ye,An.chunk=function(n,t,r){if(t=(r?Oe(n,t,r):t===T)?1:Ui(Eu(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Ku(Oi(r/t));e<r;)i[u++]=hr(n,e,e+=t);return i},An.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){
var i=n[t];i&&(u[e++]=i)}return u},An.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Ku(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return a(ff(r)?Ur(r):[r],wt(t,1))},An.cond=function(t){var r=null==t?0:t.length,e=ye();return t=r?c(t,function(n){if("function"!=typeof n[1])throw new ti("Expected a function");return[e(n[0]),n[1]]}):[],fr(function(e){for(var u=-1;++u<r;){var i=t[u];if(n(i[0],this,e))return n(i[1],this,e)}})},An.conforms=function(n){return vt(_t(n,1))},An.constant=Tu,
An.countBy=$o,An.create=function(n,t){var r=eo(n);return null==t?r:at(r,t)},An.curry=iu,An.curryRight=ou,An.debounce=fu,An.defaults=wf,An.defaultsDeep=mf,An.defer=Yo,An.delay=Qo,An.difference=wo,An.differenceBy=mo,An.differenceWith=Ao,An.drop=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:Eu(t),hr(n,0>t?0:t,e)):[]},An.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:Eu(t),t=e-t,hr(n,0,0>t?0:t)):[]},An.dropRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true,true):[];
},An.dropWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true):[]},An.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&Oe(n,t,r)&&(r=0,e=u),u=n.length,r=Eu(r),0>r&&(r=-r>u?0:u+r),e=e===T||e>u?u:Eu(e),0>e&&(e+=u),e=r>e?0:ku(e);r<e;)n[r++]=t;return n},An.filter=function(n,t){return(ff(n)?i:jt)(n,ye(t,3))},An.flatMap=function(n,t){return wt(ru(n,t),1)},An.flatMapDeep=function(n,t){return wt(ru(n,t),$)},An.flatMapDepth=function(n,t,r){return r=r===T?1:Eu(r),
wt(ru(n,t),r)},An.flatten=Ze,An.flattenDeep=function(n){return(null==n?0:n.length)?wt(n,$):[]},An.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===T?1:Eu(t),wt(n,t)):[]},An.flip=function(n){return fe(n,512)},An.flow=Pf,An.flowRight=Zf,An.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){var u=n[t];e[u[0]]=u[1]}return e},An.functions=function(n){return null==n?[]:Et(n,Wu(n))},An.functionsIn=function(n){return null==n?[]:Et(n,Bu(n))},An.groupBy=Po,An.initial=function(n){
return(null==n?0:n.length)?hr(n,0,-1):[]},An.intersection=Eo,An.intersectionBy=ko,An.intersectionWith=So,An.invert=Af,An.invertBy=Ef,An.invokeMap=Zo,An.iteratee=Fu,An.keyBy=qo,An.keys=Wu,An.keysIn=Bu,An.map=ru,An.mapKeys=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,t(n,e,u),n)}),r},An.mapValues=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,e,t(n,e,u))}),r},An.matches=function(n){return Ht(_t(n,1))},An.matchesProperty=function(n,t){return Jt(n,_t(t,1))},An.memoize=cu,
An.merge=Sf,An.mergeWith=Of,An.method=qf,An.methodOf=Vf,An.mixin=Nu,An.negate=au,An.nthArg=function(n){return n=Eu(n),fr(function(t){return Qt(t,n)})},An.omit=If,An.omitBy=function(n,t){return Lu(n,au(ye(t)))},An.once=function(n){return uu(2,n)},An.orderBy=function(n,t,r,e){return null==n?[]:(ff(t)||(t=null==t?[]:[t]),r=e?T:r,ff(r)||(r=null==r?[]:[r]),Xt(n,t,r))},An.over=Kf,An.overArgs=Xo,An.overEvery=Gf,An.overSome=Hf,An.partial=nf,An.partialRight=tf,An.partition=Vo,An.pick=Rf,An.pickBy=Lu,An.property=Zu,
An.propertyOf=function(n){return function(t){return null==n?T:kt(n,t)}},An.pull=Oo,An.pullAll=Ke,An.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,ye(r,2)):n},An.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,T,r):n},An.pullAt=Io,An.range=Jf,An.rangeRight=Yf,An.rearg=rf,An.reject=function(n,t){return(ff(n)?i:jt)(n,au(ye(t,3)))},An.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=ye(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),
u.push(e))}return ur(n,u),r},An.rest=function(n,t){if(typeof n!="function")throw new ti("Expected a function");return t=t===T?t:Eu(t),fr(n,t)},An.reverse=Ge,An.sampleSize=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:Eu(t),(ff(n)?et:ar)(n,t)},An.set=function(n,t,r){return null==n?n:lr(n,t,r)},An.setWith=function(n,t,r,e){return e=typeof e=="function"?e:T,null==n?n:lr(n,t,r,e)},An.shuffle=function(n){return(ff(n)?ut:sr)(n)},An.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&Oe(n,t,r)?(t=0,
r=e):(t=null==t?0:Eu(t),r=r===T?e:Eu(r)),hr(n,t,r)):[]},An.sortBy=Ko,An.sortedUniq=function(n){return n&&n.length?gr(n):[]},An.sortedUniqBy=function(n,t){return n&&n.length?gr(n,ye(t,2)):[]},An.split=function(n,t,r){return r&&typeof r!="number"&&Oe(n,t,r)&&(t=r=T),r=r===T?4294967295:r>>>0,r?(n=Iu(n))&&(typeof t=="string"||null!=t&&!hf(t))&&(t=yr(t),!t&&Rn.test(n))?Or(M(n),0,r):n.split(t,r):[]},An.spread=function(t,r){if(typeof t!="function")throw new ti("Expected a function");return r=null==r?0:Ui(Eu(r),0),
fr(function(e){var u=e[r];return e=Or(e,0,r),u&&a(e,u),n(t,this,e)})},An.tail=function(n){var t=null==n?0:n.length;return t?hr(n,1,t):[]},An.take=function(n,t,r){return n&&n.length?(t=r||t===T?1:Eu(t),hr(n,0,0>t?0:t)):[]},An.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:Eu(t),t=e-t,hr(n,0>t?0:t,e)):[]},An.takeRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),false,true):[]},An.takeWhile=function(n,t){return n&&n.length?jr(n,ye(t,3)):[]},An.tap=function(n,t){return t(n),
n},An.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ti("Expected a function");return du(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),fu(n,t,{leading:e,maxWait:t,trailing:u})},An.thru=Qe,An.toArray=mu,An.toPairs=zf,An.toPairsIn=Wf,An.toPath=function(n){return ff(n)?c(n,Me):wu(n)?[n]:Ur(jo(Iu(n)))},An.toPlainObject=Ou,An.transform=function(n,t,e){var u=ff(n),i=u||af(n)||_f(n);if(t=ye(t,4),null==e){var o=n&&n.constructor;e=i?u?new o:[]:du(n)&&_u(o)?eo(di(n)):{};
}return(i?r:mt)(n,function(n,r,u){return t(e,n,r,u)}),e},An.unary=function(n){return eu(n,1)},An.union=Ro,An.unionBy=zo,An.unionWith=Wo,An.uniq=function(n){return n&&n.length?br(n):[]},An.uniqBy=function(n,t){return n&&n.length?br(n,ye(t,2)):[]},An.uniqWith=function(n,t){return t=typeof t=="function"?t:T,n&&n.length?br(n,T,t):[]},An.unset=function(n,t){return null==n||xr(n,t)},An.unzip=He,An.unzipWith=Je,An.update=function(n,t,r){return null==n?n:lr(n,t,kr(r)(kt(n,t)),void 0)},An.updateWith=function(n,t,r,e){
return e=typeof e=="function"?e:T,null!=n&&(n=lr(n,t,kr(r)(kt(n,t)),e)),n},An.values=Uu,An.valuesIn=function(n){return null==n?[]:S(n,Bu(n))},An.without=Bo,An.words=Mu,An.wrap=function(n,t){return nf(kr(t),n)},An.xor=Lo,An.xorBy=Uo,An.xorWith=Co,An.zip=Do,An.zipObject=function(n,t){return Ar(n||[],t||[],ot)},An.zipObjectDeep=function(n,t){return Ar(n||[],t||[],lr)},An.zipWith=Mo,An.entries=zf,An.entriesIn=Wf,An.extend=yf,An.extendWith=bf,Nu(An,An),An.add=Qf,An.attempt=Ff,An.camelCase=Bf,An.capitalize=Cu,
An.ceil=Xf,An.clamp=function(n,t,r){return r===T&&(r=t,t=T),r!==T&&(r=Su(r),r=r===r?r:0),t!==T&&(t=Su(t),t=t===t?t:0),pt(Su(n),t,r)},An.clone=function(n){return _t(n,4)},An.cloneDeep=function(n){return _t(n,5)},An.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,5,t)},An.cloneWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,4,t)},An.conformsTo=function(n,t){return null==t||gt(n,t,Wu(t))},An.deburr=Du,An.defaultTo=function(n,t){return null==n||n!==n?t:n},An.divide=nc,An.endsWith=function(n,t,r){
n=Iu(n),t=yr(t);var e=n.length,e=r=r===T?e:pt(Eu(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},An.eq=lu,An.escape=function(n){return(n=Iu(n))&&H.test(n)?n.replace(K,nt):n},An.escapeRegExp=function(n){return(n=Iu(n))&&en.test(n)?n.replace(rn,"\\$&"):n},An.every=function(n,t,r){var e=ff(n)?u:bt;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.find=Fo,An.findIndex=Ne,An.findKey=function(n,t){return p(n,ye(t,3),mt)},An.findLast=No,An.findLastIndex=Pe,An.findLastKey=function(n,t){return p(n,ye(t,3),At);
},An.floor=tc,An.forEach=nu,An.forEachRight=tu,An.forIn=function(n,t){return null==n?n:oo(n,ye(t,3),Bu)},An.forInRight=function(n,t){return null==n?n:fo(n,ye(t,3),Bu)},An.forOwn=function(n,t){return n&&mt(n,ye(t,3))},An.forOwnRight=function(n,t){return n&&At(n,ye(t,3))},An.get=Ru,An.gt=ef,An.gte=uf,An.has=function(n,t){return null!=n&&we(n,t,Rt)},An.hasIn=zu,An.head=qe,An.identity=$u,An.includes=function(n,t,r,e){return n=su(n)?n:Uu(n),r=r&&!e?Eu(r):0,e=n.length,0>r&&(r=Ui(e+r,0)),ju(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<v(n,t,r);
},An.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Eu(r),0>r&&(r=Ui(e+r,0)),v(n,t,r)):-1},An.inRange=function(n,t,r){return t=Au(t),r===T?(r=t,t=0):r=Au(r),n=Su(n),n>=Ci(t,r)&&n<Ui(t,r)},An.invoke=kf,An.isArguments=of,An.isArray=ff,An.isArrayBuffer=cf,An.isArrayLike=su,An.isArrayLikeObject=hu,An.isBoolean=function(n){return true===n||false===n||yu(n)&&"[object Boolean]"==Ot(n)},An.isBuffer=af,An.isDate=lf,An.isElement=function(n){return yu(n)&&1===n.nodeType&&!xu(n)},An.isEmpty=function(n){
if(null==n)return true;if(su(n)&&(ff(n)||typeof n=="string"||typeof n.splice=="function"||af(n)||_f(n)||of(n)))return!n.length;var t=vo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(ze(n))return!Vt(n).length;for(var r in n)if(oi.call(n,r))return false;return true},An.isEqual=function(n,t){return Mt(n,t)},An.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:T)?r(n,t):T;return e===T?Mt(n,t,T,r):!!e},An.isError=pu,An.isFinite=function(n){return typeof n=="number"&&Wi(n)},An.isFunction=_u,
An.isInteger=vu,An.isLength=gu,An.isMap=sf,An.isMatch=function(n,t){return n===t||$t(n,t,xe(t))},An.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:T,$t(n,t,xe(t),r)},An.isNaN=function(n){return bu(n)&&n!=+n},An.isNative=function(n){if(go(n))throw new Hu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return Ft(n)},An.isNil=function(n){return null==n},An.isNull=function(n){return null===n},An.isNumber=bu,An.isObject=du,An.isObjectLike=yu,An.isPlainObject=xu,An.isRegExp=hf,
An.isSafeInteger=function(n){return vu(n)&&-9007199254740991<=n&&9007199254740991>=n},An.isSet=pf,An.isString=ju,An.isSymbol=wu,An.isTypedArray=_f,An.isUndefined=function(n){return n===T},An.isWeakMap=function(n){return yu(n)&&"[object WeakMap]"==vo(n)},An.isWeakSet=function(n){return yu(n)&&"[object WeakSet]"==Ot(n)},An.join=function(n,t){return null==n?"":Bi.call(n,t)},An.kebabCase=Lf,An.last=Ve,An.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==T&&(u=Eu(r),u=0>u?Ui(e+u,0):Ci(u,e-1)),
t===t){for(r=u+1;r--&&n[r]!==t;);n=r}else n=_(n,d,u,true);return n},An.lowerCase=Uf,An.lowerFirst=Cf,An.lt=vf,An.lte=gf,An.max=function(n){return n&&n.length?xt(n,$u,It):T},An.maxBy=function(n,t){return n&&n.length?xt(n,ye(t,2),It):T},An.mean=function(n){return y(n,$u)},An.meanBy=function(n,t){return y(n,ye(t,2))},An.min=function(n){return n&&n.length?xt(n,$u,Kt):T},An.minBy=function(n,t){return n&&n.length?xt(n,ye(t,2),Kt):T},An.stubArray=qu,An.stubFalse=Vu,An.stubObject=function(){return{}},An.stubString=function(){
return""},An.stubTrue=function(){return true},An.multiply=rc,An.nth=function(n,t){return n&&n.length?Qt(n,Eu(t)):T},An.noConflict=function(){return $n._===this&&($n._=si),this},An.noop=Pu,An.now=Go,An.pad=function(n,t,r){n=Iu(n);var e=(t=Eu(t))?D(n):0;return!t||e>=t?n:(t=(t-e)/2,ne(Ii(t),r)+n+ne(Oi(t),r))},An.padEnd=function(n,t,r){n=Iu(n);var e=(t=Eu(t))?D(n):0;return t&&e<t?n+ne(t-e,r):n},An.padStart=function(n,t,r){n=Iu(n);var e=(t=Eu(t))?D(n):0;return t&&e<t?ne(t-e,r)+n:n},An.parseInt=function(n,t,r){
return r||null==t?t=0:t&&(t=+t),Mi(Iu(n).replace(on,""),t||0)},An.random=function(n,t,r){if(r&&typeof r!="boolean"&&Oe(n,t,r)&&(t=r=T),r===T&&(typeof t=="boolean"?(r=t,t=T):typeof n=="boolean"&&(r=n,n=T)),n===T&&t===T?(n=0,t=1):(n=Au(n),t===T?(t=n,n=0):t=Au(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Ti(),Ci(n+r*(t-n+Cn("1e-"+((r+"").length-1))),t)):ir(n,t)},An.reduce=function(n,t,r){var e=ff(n)?l:j,u=3>arguments.length;return e(n,ye(t,4),r,u,uo)},An.reduceRight=function(n,t,r){var e=ff(n)?s:j,u=3>arguments.length;
return e(n,ye(t,4),r,u,io)},An.repeat=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:Eu(t),or(Iu(n),t)},An.replace=function(){var n=arguments,t=Iu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},An.result=function(n,t,r){t=Sr(t,n);var e=-1,u=t.length;for(u||(u=1,n=T);++e<u;){var i=null==n?T:n[Me(t[e])];i===T&&(e=u,i=r),n=_u(i)?i.call(n):i}return n},An.round=ec,An.runInContext=x,An.sample=function(n){return(ff(n)?Qn:cr)(n)},An.size=function(n){if(null==n)return 0;if(su(n))return ju(n)?D(n):n.length;
var t=vo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Vt(n).length},An.snakeCase=Df,An.some=function(n,t,r){var e=ff(n)?h:pr;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.sortedIndex=function(n,t){return _r(n,t)},An.sortedIndexBy=function(n,t,r){return vr(n,t,ye(r,2))},An.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){var e=_r(n,t);if(e<r&&lu(n[e],t))return e}return-1},An.sortedLastIndex=function(n,t){return _r(n,t,true)},An.sortedLastIndexBy=function(n,t,r){return vr(n,t,ye(r,2),true);
},An.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=_r(n,t,true)-1;if(lu(n[r],t))return r}return-1},An.startCase=Mf,An.startsWith=function(n,t,r){return n=Iu(n),r=null==r?0:pt(Eu(r),0,n.length),t=yr(t),n.slice(r,r+t.length)==t},An.subtract=uc,An.sum=function(n){return n&&n.length?m(n,$u):0},An.sumBy=function(n,t){return n&&n.length?m(n,ye(t,2)):0},An.template=function(n,t,r){var e=An.templateSettings;r&&Oe(n,t,r)&&(t=T),n=Iu(n),t=bf({},t,e,ce),r=bf({},t.imports,e.imports,ce);var u,i,o=Wu(r),f=S(r,o),c=0;
r=t.interpolate||jn;var a="__p+='";r=Xu((t.escape||jn).source+"|"+r.source+"|"+(r===Q?pn:jn).source+"|"+(t.evaluate||jn).source+"|$","g");var l=oi.call(t,"sourceURL")?"//# sourceURL="+(t.sourceURL+"").replace(/[\r\n]/g," ")+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(wn,z),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=oi.call(t,"variable")&&t.variable)||(a="with(obj){"+a+"}"),
a=(i?a.replace(P,""):a).replace(Z,"$1").replace(q,"$1;"),a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Ff(function(){return Ju(o,l+"return "+a).apply(T,f)}),t.source=a,pu(t))throw t;return t},An.times=function(n,t){if(n=Eu(n),1>n||9007199254740991<n)return[];var r=4294967295,e=Ci(n,4294967295);for(t=ye(t),n-=4294967295,e=A(e,t);++r<n;)t(r);return e},An.toFinite=Au,
An.toInteger=Eu,An.toLength=ku,An.toLower=function(n){return Iu(n).toLowerCase()},An.toNumber=Su,An.toSafeInteger=function(n){return n?pt(Eu(n),-9007199254740991,9007199254740991):0===n?n:0},An.toString=Iu,An.toUpper=function(n){return Iu(n).toUpperCase()},An.trim=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(un,""):n&&(t=yr(t))?(n=M(n),r=M(t),t=I(n,r),r=R(n,r)+1,Or(n,t,r).join("")):n},An.trimEnd=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(fn,""):n&&(t=yr(t))?(n=M(n),t=R(n,M(t))+1,
Or(n,0,t).join("")):n},An.trimStart=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(on,""):n&&(t=yr(t))?(n=M(n),t=I(n,M(t)),Or(n,t).join("")):n},An.truncate=function(n,t){var r=30,e="...";if(du(t))var u="separator"in t?t.separator:u,r="length"in t?Eu(t.length):r,e="omission"in t?yr(t.omission):e;n=Iu(n);var i=n.length;if(Rn.test(n))var o=M(n),i=o.length;if(r>=i)return n;if(i=r-D(e),1>i)return e;if(r=o?Or(o,0,i).join(""):n.slice(0,i),u===T)return r+e;if(o&&(i+=r.length-i),hf(u)){if(n.slice(i).search(u)){
var f=r;for(u.global||(u=Xu(u.source,Iu(_n.exec(u))+"g")),u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===T?i:c)}}else n.indexOf(yr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},An.unescape=function(n){return(n=Iu(n))&&G.test(n)?n.replace(V,tt):n},An.uniqueId=function(n){var t=++fi;return Iu(n)+t},An.upperCase=Tf,An.upperFirst=$f,An.each=nu,An.eachRight=tu,An.first=qe,Nu(An,function(){var n={};return mt(An,function(t,r){oi.call(An.prototype,r)||(n[r]=t)}),n}(),{chain:false
}),An.VERSION="4.17.15",r("bind bindKey curry curryRight partial partialRight".split(" "),function(n){An[n].placeholder=An}),r(["drop","take"],function(n,t){Un.prototype[n]=function(r){r=r===T?1:Ui(Eu(r),0);var e=this.__filtered__&&!t?new Un(this):this.clone();return e.__filtered__?e.__takeCount__=Ci(r,e.__takeCount__):e.__views__.push({size:Ci(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Un.prototype[n+"Right"]=function(t){return this.reverse()[n](t).reverse()}}),r(["filter","map","takeWhile"],function(n,t){
var r=t+1,e=1==r||3==r;Un.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({iteratee:ye(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),r(["head","last"],function(n,t){var r="take"+(t?"Right":"");Un.prototype[n]=function(){return this[r](1).value()[0]}}),r(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Un.prototype[n]=function(){return this.__filtered__?new Un(this):this[r](1)}}),Un.prototype.compact=function(){return this.filter($u)},Un.prototype.find=function(n){
return this.filter(n).head()},Un.prototype.findLast=function(n){return this.reverse().find(n)},Un.prototype.invokeMap=fr(function(n,t){return typeof n=="function"?new Un(this):this.map(function(r){return Lt(r,n,t)})}),Un.prototype.reject=function(n){return this.filter(au(ye(n)))},Un.prototype.slice=function(n,t){n=Eu(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Un(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),t!==T&&(t=Eu(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Un.prototype.takeRightWhile=function(n){
return this.reverse().takeWhile(n).reverse()},Un.prototype.toArray=function(){return this.take(4294967295)},mt(Un.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=An[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(An.prototype[t]=function(){function t(n){return n=u.apply(An,a([n],f)),e&&h?n[0]:n}var o=this.__wrapped__,f=e?[1]:arguments,c=o instanceof Un,l=f[0],s=c||ff(o);s&&r&&typeof l=="function"&&1!=l.length&&(c=s=false);var h=this.__chain__,p=!!this.__actions__.length,l=i&&!h,c=c&&!p;
return!i&&s?(o=c?o:new Un(this),o=n.apply(o,f),o.__actions__.push({func:Qe,args:[t],thisArg:T}),new On(o,h)):l&&c?n.apply(this,f):(o=this.thru(t),l?e?o.value()[0]:o.value():o)})}),r("pop push shift sort splice unshift".split(" "),function(n){var t=ri[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);An.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){var u=this.value();return t.apply(ff(u)?u:[],n)}return this[r](function(r){return t.apply(ff(r)?r:[],n)});
}}),mt(Un.prototype,function(n,t){var r=An[t];if(r){var e=r.name+"";oi.call(Gi,e)||(Gi[e]=[]),Gi[e].push({name:t,func:r})}}),Gi[Jr(T,2).name]=[{name:"wrapper",func:T}],Un.prototype.clone=function(){var n=new Un(this.__wrapped__);return n.__actions__=Ur(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Ur(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Ur(this.__views__),n},Un.prototype.reverse=function(){if(this.__filtered__){var n=new Un(this);
n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n},Un.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=ff(t),u=0>r,i=e?t.length:0;n=i;for(var o=this.__views__,f=0,c=-1,a=o.length;++c<a;){var l=o[c],s=l.size;switch(l.type){case"drop":f+=s;break;case"dropRight":n-=s;break;case"take":n=Ci(n,f+s);break;case"takeRight":f=Ui(f,n-s)}}if(n={start:f,end:n},o=n.start,f=n.end,n=f-o,o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Ci(n,this.__takeCount__),!e||!u&&i==n&&l==n)return wr(t,this.__actions__);
e=[];n:for(;n--&&a<l;){for(o+=r,u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},An.prototype.at=To,An.prototype.chain=function(){return Ye(this)},An.prototype.commit=function(){return new On(this.value(),this.__chain__)},An.prototype.next=function(){this.__values__===T&&(this.__values__=mu(this.value()));var n=this.__index__>=this.__values__.length;return{done:n,value:n?T:this.__values__[this.__index__++]}},An.prototype.plant=function(n){
for(var t,r=this;r instanceof En;){var e=Fe(r);e.__index__=0,e.__values__=T,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},An.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Un?(this.__actions__.length&&(n=new Un(this)),n=n.reverse(),n.__actions__.push({func:Qe,args:[Ge],thisArg:T}),new On(n,this.__chain__)):this.thru(Ge)},An.prototype.toJSON=An.prototype.valueOf=An.prototype.value=function(){return wr(this.__wrapped__,this.__actions__)},An.prototype.first=An.prototype.head,
wi&&(An.prototype[wi]=Xe),An}(); true?($n._=rt, !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return rt}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):Nn?((Nn.exports=rt)._=rt,Fn._=rt):$n._=rt}).call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54), __webpack_require__(25)(module)))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(540),
    fallbackHolder = __webpack_require__(541);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 540 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 541 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExcelStore__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldCellType__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







var searchPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADjklEQVRYR82XS4gcVRSG/3MrI2MLNoZBfGCQCAlm4duFYwgawYUKzjjgwsfgQhwlZtx01+kBY4oY6Lq3mxloHwvjzmCwkRghQUWCj/gCgxIJ+EAZERc+ogjCVJx03V8KZkJPT4+ddHcSa1d1T53/u4dz7jlXcI4fOcf6aAtQrVaH0jS9H8DFfQL8SlX3tvO1DMBae4eI7AZwSZ/EF90cTdN0fGpq6stmv0sAKpXKZpIHSTYAvAjgkDHmWC8g3vshEdlE8gkRmUvT9LZmiJMAlUrlAu/9dwthv0VVD/ci3PqvtfYmEfkMwI9zc3ProijymU0zwCjJvSSfV9Wt/RRf9GWtfU5EnvTe31Uqld5aAuCcexbA0yIyUiwW3zxDACMi8gaAnWEYbmsFqAHYKiLDxWLx0zMBEMfxsDHmY5I1VX2qK4BqtbrBe28BXAtgiORPAD4BYFX12/8C7xnAWlsUkTKA4yQ/EpGjANYBuBPAed77iVKptGsliJ4AKpXKdpIRgKnBwcGZycnJfxaFZmZmLp2fn6+LyEaS46r6SjuIrgGcc9cB+ILkTlV9pp3zKIpMLpfbTXJzkiRXRlF0vNWuawBr7WsicmM+n796YmLixEohLpfLa4Mg+AHAA2EY7uknwC8A3lbVRzpVh3Pua5KHVPWxfgL8JSIvh2FYOAWAIySPqOp4PwG+AfC9qt7TCcBamyXnS+1O065zwDmX1f3jxpirCoXCis3JOfcogF0kR1V1X98iEMfxmoWa39cutJmQc+4GAO8B+COfz69vl6xdR2BBYIxkHcB+AFtU9efs+/T09OpGo3EfyaqIJAA2hmGYVcKypyeAzFscx5tEZI+IXJYlGoCLROSKrKuSfLfRaDw8MDBwgOSxJElGWs+CngEyiFqtdmGSJPcaY9Z677N2foLk4VKp9M5CpLJT8CGSB1qTti8AnaogiqJVuVzuVZKXq+qtzfZnBaDrbmit3SEi20iOrTTBdtp9p3Xn3BiA1wHsCMNw+5J5II7ju40x+8/GSNa8yZMzYb1eD2ZnZ7OhdE0QBMOFQuHzTjs6nfVqtXpzmqbZ4PI7gPWq+veSCGQv5XL5emPMBwDOF5EXSH5ojPnzdIRabb33qxfG8i0iskpEbi8Wi+8v2i27mGQQQRBkF5MNvQi3/kvyVwAPqurB5rW2VzOS4pwbBXBNnyB+C4Kg3q6P/D8vp33a9Sm5+Rc3K0w/m9eDxAAAAABJRU5ErkJggg==';
var searchPngImg = document.createElement("img");
searchPngImg.src = searchPng;
var div = document.createElement('div');
document.body.appendChild(div);
/* harmony default export */ __webpack_exports__["a"] = (function (column, editable) {
    var type = column.type, dbtype = column.dbtype, isSingle = column.isSingle, dataParams = column.dataParams, destDataParams = column.destDataParams, tabs = column.tabs, conditionDataParams = column.conditionDataParams, hasAdvanceSerach = column.hasAdvanceSerach, scrollx = column.scrollx;
    var Type = /** @class */ (function (_super) {
        __extends(Type, _super);
        function Type() {
            var _this = _super.call(this) || this;
            _this.tabs = {};
            _this._itemsTextWidth = {};
            _this._sumItemTextWidth = {};
            _this._itemsTextRowIndex = {};
            _this._itemsRect = {};
            _this._items = {};
            _this.startY = {};
            _this.allowOverflow = false;
            _this.allowOverflow = false;
            if (type === '161' || type === '162') {
                _this.dataParams = {
                    type: dbtype
                };
                _this.hasAdvanceSerach = true;
                _this.destDataParams = destDataParams;
                _this.conditionDataParams = conditionDataParams;
            }
            else if (type === '256' || type === '257') {
                _this.dataParams = dataParams;
                _this.destDataParams = destDataParams;
                _this.conditionDataParams = conditionDataParams;
                _this.tabs = tabs || {};
                _this.hasAdvanceSerach = hasAdvanceSerach;
                _this.scrollx = scrollx;
            }
            else {
                _this.hasAdvanceSerach = true;
                _this.destDataParams = _this.dataParams;
                _this.conditionDataParams = _this.dataParams;
            }
            return _this;
        }
        Type.prototype.processMouseMove = function (hitInfo) {
            var _a = hitInfo, sheet = _a.sheet, isReservedLocation = _a.isReservedLocation, _b = _a.reservedLocation, reservedLocation = _b === void 0 ? {} : _b;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";
            var canvas = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#" + canvasId)[0];
            if (sheet && isReservedLocation) {
                canvas.style.cursor = 'pointer';
                canvas.title = reservedLocation.names || reservedLocation.name;
                return true;
            }
            else {
                canvas.title = "";
                canvas.style.cursor = 'default';
            }
            return false;
        };
        ;
        Type.prototype.processMouseLeave = function (hitInfo) {
            var sheet = hitInfo.sheet;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";
            var canvas = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#" + canvasId)[0];
            canvas.title = "";
            canvas.style.cursor = 'default';
            return true;
        };
        Type.prototype.processMouseUp = function (hitInfo) {
            var _a = hitInfo, x = _a.x, y = _a.y, cellRect = _a.cellRect, sheet = _a.sheet, row = _a.row, col = _a.col, sheetArea = _a.sheetArea, reservedLocation = _a.reservedLocation, isReservedLocation = _a.isReservedLocation;
            if (editable && x && cellRect) {
                if (x >= cellRect.x + cellRect.width - 20) {
                    this.showBrowserModal(sheet.getCell(row, col, sheetArea), cellRect);
                }
                return true;
            }
            if (sheet && isReservedLocation && reservedLocation && reservedLocation.linkUrl) {
                var hreflink = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["e" /* getHreflink */])(sheet.getValue(row, col, sheetArea));
                if (hreflink) {
                    window.cubeOpenHreflinkFromExcel(hreflink);
                }
                else {
                    if (reservedLocation.linkUrl.toLowerCase().startsWith('javascript:openhrm')) {
                        div.style.position = 'absolute';
                        div.style.left = x + 'px';
                        div.style.top = y + 'px';
                        div.style.visibility = 'hidden';
                        setTimeout(function () {
                            window.pointerXY(__assign({}, window.event, { target: div }));
                            eval(reservedLocation.linkUrl.replace('javascript:', ''));
                        }, 10);
                    }
                    else {
                        window.open(reservedLocation.linkUrl);
                    }
                }
                return true;
            }
            return _super.prototype.processMouseUp.call(this, hitInfo);
        };
        Type.prototype.paint = function (ctx, value, x, y, w, h, style, context) {
            var _this = this;
            ctx.clearRect(x, y, w, h);
            var row = context.row, col = context.col, sheet = context.sheet;
            ctx.font = style.font;
            delete style.vAlign;
            var browserVals = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["d" /* getBrowserValue */])(value);
            var datas = browserVals && browserVals.length ? browserVals : [{ name: '' }];
            this._sumItemTextWidth[row] = [];
            this._itemsRect[row] = [];
            this._itemsTextRowIndex[row] = [];
            var splitWidth = parseInt(ctx.measureText(',').width.toString());
            var rowIndex = 0;
            this._sumItemTextWidth[row][rowIndex] = 0;
            this._items[row] = [];
            this._items[row][rowIndex] = [];
            this._itemsTextWidth[row] = [];
            this._itemsTextWidth[row][rowIndex] = [];
            var _width = editable ? w - 20 : w;
            var leftHeight = h;
            if (!editable) {
                style.foreColor = __WEBPACK_IMPORTED_MODULE_3__FieldCellType__["h" /* linkedColor */];
                style.textDecoration = GC.Spread.Sheets.TextDecorationType.underline;
            }
            var dataArray = datas.map(function (data, index) {
                var name = data.name;
                if (name) {
                    name = Object(__WEBPACK_IMPORTED_MODULE_6__util__["removeHTMLTag"])(name);
                }
                var textWidth = parseInt(ctx.measureText(name).width.toString());
                if (_this._sumItemTextWidth[row][rowIndex] + textWidth > _width && _this._sumItemTextWidth[row][rowIndex] !== 0) {
                    rowIndex++;
                    _this._items[row][rowIndex] = [];
                    _this._sumItemTextWidth[row][rowIndex] = 0;
                    _this._itemsTextWidth[row][rowIndex] = [];
                    leftHeight -= 20;
                    leftHeight = leftHeight < 0 ? 0 : leftHeight;
                }
                var rt = __assign({}, data, { left: x + _this._sumItemTextWidth[row][rowIndex], splitLeft: 0, top: y + 20 * rowIndex, height: leftHeight, notLast: index < datas.length - 1 });
                _this._itemsTextWidth[row][rowIndex].push(textWidth);
                _this._items[row][rowIndex].push(data);
                _this._sumItemTextWidth[row][rowIndex] += textWidth;
                rt.splitLeft = x + _this._sumItemTextWidth[row][rowIndex];
                if (rt.notLast) {
                    _this._sumItemTextWidth[row][rowIndex] += splitWidth;
                }
                return rt;
            });
            this.startY[row] = Math.max(0, (h - rowIndex * 20 - 20) / 2);
            dataArray.forEach(function (data) {
                var left = data.left, top = data.top, height = data.height, notLast = data.notLast, splitLeft = data.splitLeft;
                var name = data.name;
                if (name) {
                    name = Object(__WEBPACK_IMPORTED_MODULE_6__util__["removeHTMLTag"])(name);
                }
                var realTop = _this.startY[row] + top;
                _super.prototype.paint.call(_this, ctx, name, left, realTop, _width, height, style, context);
                if (notLast) {
                    _super.prototype.paint.call(_this, ctx, ',', splitLeft, realTop, _width, height, style, context);
                }
            });
            if (editable) {
                var width = Math.min(16, h);
                ctx.drawImage(searchPngImg, x + w - width, y + (h - width) / 2, width, width);
                if (Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(sheet.modifyedValues, __WEBPACK_IMPORTED_MODULE_0__ExcelStore__["a" /* StoreFuncs */].getRandomId(row) + "." + col)) {
                    ctx.drawImage(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["c" /* dotPngImg */], x, y, 8, 8);
                }
            }
        };
        Type.prototype.getHitInfo = function (x, y, cellStyle, cellRect, context) {
            var row = context.row, col = context.col, sheetArea = context.sheetArea, sheet = context.sheet;
            var info = {
                x: x,
                y: y,
                row: row,
                col: col,
                cellRect: cellRect,
                sheetArea: sheetArea,
                sheet: sheet,
            };
            var rowIndex = parseInt('' + ((y - cellRect.y - this.startY[row]) / 20));
            if (rowIndex < this._sumItemTextWidth[row].length && x < cellRect.x + this._sumItemTextWidth[row][rowIndex]) {
                var startX = cellRect.x;
                var datas = this._items[row][rowIndex] || [];
                for (var i = 0; i < datas.length; i++) {
                    if (x < startX + this._itemsTextWidth[row][rowIndex][i]) {
                        info.isReservedLocation = true;
                        info.reservedLocation = datas[i];
                        break;
                    }
                    startX += (this._itemsTextWidth[row][rowIndex][i]);
                }
            }
            return info;
        };
        Type.prototype.getAutoFitWidth = function (value, text, cellStyle, zoomFactor, context) {
            var datas = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["d" /* getBrowserValue */])(value);
            return _super.prototype.getAutoFitWidth.call(this, value, datas.map(function (d) { return d.name; }).join(','), cellStyle, zoomFactor, context) + (editable ? 20 : 0);
        };
        Type.prototype.showBrowserModal = function (context, cellRect) {
            var _this = this;
            var sheet = context.sheet, row = context.row, col = context.col;
            if (!this.editor) {
                this.editor = document.createElement('div');
                var host = sheet.getParent().getHost();
                host.appendChild(this.editor);
                this.editor.style.visibility = 'hidden';
                __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.editor).css({
                    position: 'absolute',
                    left: cellRect.x,
                    top: cellRect.y,
                    width: cellRect.width,
                    height: cellRect.height,
                });
            }
            var value = context.value();
            var changeValue = function (newValue, valueSpan, valueObj) {
                sheet.suspendPaint();
                var value = context.value();
                var newValueSpan = {};
                var oldValueSpan = {};
                var oldValue = '';
                try {
                    var oldDatas = JSON.parse(value).datas;
                    if (Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["isArray"])(oldDatas)) {
                        oldValue = oldDatas.map(function (d) { return d.id; }).join(',');
                    }
                    oldValueSpan = { value: oldValue, datas: oldDatas };
                    newValueSpan = { value: newValue, datas: valueObj };
                }
                catch (e) {
                    newValueSpan = { datas: valueObj, value: newValue };
                    oldValueSpan = { value: oldValue, datas: [] };
                }
                var dataSource = sheet.getDataSource();
                var datas = dataSource.getValue("datas");
                var data = datas[row];
                data[column.column] = newValue;
                data[column.column + "span"] = JSON.stringify(newValueSpan);
                sheet.setChangedValue(Object(__WEBPACK_IMPORTED_MODULE_0__ExcelStore__["c" /* getRandomId */])(data), column, { sheet: sheet, row: row, col: col, newValue: newValueSpan, oldValue: oldValueSpan, time: data.time });
                sheet.resumePaint();
            };
            if (sheet.getDataSource().xf.datas[row].seclevel != undefined && sheet.getDataSource().xf.datas[row].seclevel != "") {
                this.secretLevel = sheet.getDataSource().xf.datas[row].seclevel;
            }
            else {
                this.secretLevel = 4;
            }
            var replaceDatas = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["d" /* getBrowserValue */])(value);
            __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(this.editor);
            var obj = {
                "secretLevel": this.secretLevel
            };
            this.dataParams = __assign({}, obj, this.dataParams);
            __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(React.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaBrowser"], { ecId: "_WeaBrowser@ep81qe", type: type, title: column.title, hasAdvanceSerach: this.hasAdvanceSerach, scrollx: this.scrollx, ref: function (ref) { return _this.browserInstance = ref; }, onChange: changeValue, isSingle: isSingle, dataParams: this.dataParams, destDataParams: this.destDataParams, replaceDatas: replaceDatas, conditionDataParams: this.conditionDataParams, memorise: true, tabs: this.tabs, 
                //    isMultCheckbox={true}
                // asynLoadAll ={column.asynLoadAll}
                defaultExpandedLevel: column.defaultExpandedLevel }), this.editor);
            var openModal = function () {
                if (_this.browserInstance) {
                    _this.browserInstance.openModal();
                }
                else {
                    setTimeout(function () {
                        openModal();
                    }, 50);
                }
            };
            openModal();
        };
        return Type;
    }(GC.Spread.Sheets.CellTypes.Base));
    return Type;
});


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckBoxType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExcelStore__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldCellType__ = __webpack_require__(50);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var checkedDisabledPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAAXNSR0IArs4c6QAAAadJREFUOBF1U71qwlAUPvfGOBREMkgGfQoXn8KXkG6dHDpolw52aQdB6JZHEBEXF3VxUXAVnJwUFKRxMUhE0/udctMYkwPxhu/n5N7vHsVisTCPx6Mv8dPr9UiMRqOAVBnX6/W9Wq3+IaVSCSCX1C96FePx+CcIAguAlPJLrFYrbqIVbFHfona7zdiDgnsUi0XuoW16VVshqT+gQaydTof6/T4ZhkGZKNFsNqlQKFC9Xg9hMZlMPm3bfoU6XofDwWPB7XZ7jZNCCDefz9tiuVwGSW4YttutK9NICHCAh+w8zyNsVhcLTqcTgyBbrRY1Gg3NU5jcdDql4XDIZC6XY8Fms/kXAEFy0T1BIHFW3S9Kcsy4PgSVzWZfLMt6igq0KWmF2XVdz/f9bx6i6MgkGdIw3mIaGceR0GAwoMvlckfdDQMYdTu03++pXC6zEEbHcWi32/GgnM9nMk0zbPLQYL1ec9zdbpdULjgrG3E3Ov7QrV5SM5jP5zSbzahWqyUa0QQZZDB1KlUrfgOVSoXwpBVuAt4MRlad+UMN3nPSvyepAYzqcZT37Re6QtdQqJ2w9AAAAABJRU5ErkJggg==';
var unCheckedDisabledPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAALdJREFUKBXVUzsOwyAMjS0P2ZGYOFF6id6sp+hGOAcHSIZGyp4pNI82FZ+06tClDOD3np/BCMg5163remVMxpiGrLWBiCYB2oaOzBOAaBhyjLZpWZaHZyd2X8S8s1gzUFV9m5kKVZlSpL7vbyEEXQoi0pH3PpQC8DAM+enKpOzoPxRxe0cDNxxbUUrptm2PcioOxeZ5nhj9f2tCFeTC87HLaruE+COjMPNpHMfL0SNJWnqF8S+InO9zmkZxuCWQDgAAAABJRU5ErkJggg==';
var checkedPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAAXdJREFUKBWFUr8vQ1EU/u7rK61I9bbRQWIgEWI0iIkYWzGIIF1Ewsbib7BXYjJYDAxCYqCd7BYSMYmNSGilbSR+9rXXPef2vb6Kpmc495zzne/e8+MKuZ1PKqWyFqkuGxDRzIsSEI/ix6mpxE7BRKClMwB8VwGLYAqQQ8IcY2rUNUqbCeM8bfRCv9Oc1sRxKe7Jd6RHQxjoCSCsq6IrqDoSj3k6H8XcSRnKxA0oM/kHBdXvi7FpBUTS+g8gtFZVOa9ul3m7GsdeKmLYpKkhkou0xOtnDWvZN/aZeV90cLUSg6296cMSA6QYHN8vYlDamDpoAB5IBo3HL7yAVq34E//aRGzZpj85qAu7XI4h0iE4TKOpD9ikhfS2v+oLpgit4XxRYjhm4043q3+HSdTaI66PhbE12Y3rZwezxyWcLUiMxG3QdIZ2C/hwPA4b3i7Jm+gLIrckGbjJVzBzVMZ7pfEKA3XVRPQD7WxLCJFyP3C7ZMJ5ovrz/AKWB4FZ7esInwAAAABJRU5ErkJggg==';
var unCheckedPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAAKxJREFUKBXVU7ERwyAMRKKkz1CewptligwDHAPENXQcCY/DBTBHkS4qsPjX/0k6TM65Lcb4EFrrF4KQMPNBuAlEpQAgMstHYfIRQhBFU4GvLiNcUXy7y8X19D7PvrL1uNgMJFlrnyml24ALKeXWtdYWGGOG7lo25783tFZie7MoG8Yo3vt2McsctdAw5ldKzYynGGqhWfY6VX7APxISXnwe9j57JLMZy79AtL8B2pul6dwFwGYAAAAASUVORK5CYII=';
var radioCheckedPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABtklEQVR42o1SS0sCURgdi6KioMcigtZBUESLNq5bSMtAaB9BtIo2RRv7AdGinSsXbsJN6KbAUBzf7yejLszXwhgEZ0wbZV6dO6SIgfXBx3CH73zn3HMPRY2UxWKZc7lce16v1+jxeE7Jl5zJf2pC6WiaPsnlcq/lcvmjXq/L+HKFQiGKJTc2m231F8JsNs/4fD5zpVL5FARBkSRJVRRFlWVZFUVRaTQavWg0+gbw/BBkt9uX/H7/Ra1WE9QJ1Ww2VUi3OhyOBQ0IGfpsNkv3+31lMLT70h32oIiCfD7PAXyoAQOBwHmpVOKJrHHQOJjjODEYDN4ZjcZpCjKviRFk41/AbrerYP6ReEJhw1W1WhX+A2y32xLmH2DSLBWJRI6LxeI7ce+vO0LZVygUutQYU6nUFg5WuCZNcrXT6ajwg0kmkwcmk2mKcrvdi/F43IBmWJZVyRuOFmHieV7NZDJsOp0maVoZJiYcDq8hIQbIdjIM02m1WiKeR7sTQtEDUxagMyjb1NhG4wbmZbyTHlJukZIntBP9nEgk7sF2FIvFNsZBwyJuYes6ZG/j7vsA7hCWn7ToRme/AY8rCWzKvTFpAAAAAElFTkSuQmCC';
var radioUnCheckedPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABoklEQVR42o1SO0vDUBhNFUVFwccggrMgCOLg0tmhOAqCexHESVwUJ3+AOLg5d5EuroEKBftumr7SpqUt0tdgQwsJCWna5uG5QaVSSD1wyb3Jd75zvpNLUWMIBoMLoVBoPxqNnobDYS95kjN5TznAFYlEzorFIl2v1z/b7bbRaDTESqXCgHxL0/T6BCOVSs2h+3Oz2ZQ1TTN1XbdM07QMw7CwNzudjsay7BtqFn9JsLQSi8UuW61W33JAt9u14MgHkSWbiC5u2HsfDoemE5E4KJfLIkSObGIikbjATBKxNQ2SJI1Qf+/3+2cpdLghQZCO06Cqqon6J5IJUbxGKP3/EGVZ1lH/WCgU5imkdYLIP0h602aEMzWZTF7ZiqVSaQcHX6/X052IiqJYsMlD7RDHGQqb5Vwu50mn07wgCOS/TSghFAt1Asdx3nw+v2anim8uqG5Uq1UPwzABRK6IojgaDAb2TJhfi8fjHIjnENi21X5AyJlMZrVWq7nx8Q5zv2COANZrNpt94Hn+GGvrD2kcJC3Y2cTaxaU4QJM9ovJ9W1zjtV+MWzTUzx6wyAAAAABJRU5ErkJggg==';
var CheckBoxType;
(function (CheckBoxType) {
    CheckBoxType["Check"] = "check";
    CheckBoxType["MutilCheck"] = "checkbox";
    CheckBoxType["Raido"] = "radio";
})(CheckBoxType || (CheckBoxType = {}));
;
var checkedDisabledPngImg = document.createElement("img");
checkedDisabledPngImg.src = checkedDisabledPng;
var unCheckedDisabledPngImg = document.createElement("img");
unCheckedDisabledPngImg.src = unCheckedDisabledPng;
var checkedPngImg = document.createElement("img");
checkedPngImg.src = checkedPng;
var unCheckedPngImg = document.createElement("img");
unCheckedPngImg.src = unCheckedPng;
var radioCheckedPngImg = document.createElement("img");
radioCheckedPngImg.src = radioCheckedPng;
var radioUnCheckedPngImg = document.createElement("img");
radioUnCheckedPngImg.src = radioUnCheckedPng;
var getImg = function (type, checked, editable) {
    if (editable) {
        if (type === CheckBoxType.Raido) {
            return checked ? radioCheckedPngImg : radioUnCheckedPngImg;
        }
        return checked ? checkedPngImg : unCheckedPngImg;
    }
    if (type === CheckBoxType.Raido) {
        return checked ? radioCheckedPngImg : radioUnCheckedPngImg;
    }
    return checked ? checkedDisabledPngImg : unCheckedDisabledPngImg;
};
/* harmony default export */ __webpack_exports__["b"] = (function (column, editable) {
    var Type = /** @class */ (function (_super) {
        __extends(Type, _super);
        function Type(checkBoxType) {
            if (checkBoxType === void 0) { checkBoxType = CheckBoxType.Check; }
            var _this = _super.call(this) || this;
            _this.checkBoxType = CheckBoxType.Check;
            _this._items = [];
            _this._itemWidth = {};
            _this._itemSumWidth = {};
            _this.startY = {};
            _this._itemsMap = {};
            _this._timer = {};
            _this.checkBoxType = checkBoxType;
            return _this;
        }
        Type.prototype.items = function (items) {
            this._items = items;
        };
        Type.prototype.paint = function (ctx, value, x, y, w, h, style, context) {
            var _this = this;
            var row = context.row, col = context.col, sheet = context.sheet;
            try {
                ctx.clearRect(x, y, w, h);
                ctx.font = style.font;
                delete style.vAlign;
                value = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["f" /* getInputValue */])(value);
                if (!editable && Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["e" /* getHreflink */])(value)) {
                    style.foreColor = __WEBPACK_IMPORTED_MODULE_3__FieldCellType__["h" /* linkedColor */];
                    style.textDecoration = GC.Spread.Sheets.TextDecorationType.underline;
                }
                if (this.checkBoxType === CheckBoxType.Check) {
                    if (value === '1') {
                        ctx.drawImage(getImg(this.checkBoxType, true, editable), x + 7, y + h / 2 - 7, 14, 14);
                        //  ctx.restore();
                    }
                    else {
                        ctx.drawImage(getImg(this.checkBoxType, false, editable), x + 7, y + h / 2 - 7, 14, 14);
                        //  ctx.restore();
                    }
                }
                else if (this.checkBoxType === CheckBoxType.MutilCheck || this.checkBoxType === CheckBoxType.Raido) {
                    var valueArray_1 = value ? value.split(',') : [];
                    var rowIndex_1 = 0;
                    this._itemWidth[row] = [];
                    this._itemWidth[row][rowIndex_1] = [];
                    this._itemSumWidth[row] = [];
                    this._itemSumWidth[row][rowIndex_1] = 0;
                    this._itemsMap[row] = [];
                    this._itemsMap[row][rowIndex_1] = [];
                    var leftHeight_1 = h;
                    var itemArray = this._items.map(function (item) {
                        var isSelected = valueArray_1.indexOf(item.value) > -1;
                        var textWidth = parseInt(ctx.measureText(item.name).width.toString());
                        var itemWidth = 28 + textWidth;
                        if (_this._itemSumWidth[row][rowIndex_1] + itemWidth + 28 > w && _this._itemWidth[row][rowIndex_1].length > 0) {
                            rowIndex_1++;
                            _this._itemWidth[row][rowIndex_1] = [];
                            _this._itemSumWidth[row][rowIndex_1] = 0;
                            _this._itemsMap[row][rowIndex_1] = [];
                            leftHeight_1 -= 20;
                            leftHeight_1 = leftHeight_1 < 0 ? 0 : leftHeight_1;
                        }
                        _this._itemsMap[row][rowIndex_1].push(item);
                        var rt = __assign({}, item, { itemWidth: itemWidth,
                            rowIndex: rowIndex_1, left: x + _this._itemSumWidth[row][rowIndex_1] + 7, top: y + 20 * rowIndex_1, isSelected: isSelected, height: leftHeight_1 });
                        _this._itemWidth[row][rowIndex_1].push(itemWidth);
                        _this._itemSumWidth[row][rowIndex_1] += itemWidth + 7;
                        return rt;
                    });
                    var rowHeight = rowIndex_1 * 20 + 20;
                    this.startY[row] = Math.max(0, (h - rowHeight) / 2);
                    itemArray.forEach(function (item) {
                        var isSelected = item.isSelected, left = item.left, top = item.top, name = item.name, height = item.height;
                        _super.prototype.paint.call(_this, ctx, name, left + 21, top + _this.startY[row], w, height, style, context);
                        //  ctx.save();
                        ctx.drawImage(getImg(_this.checkBoxType, isSelected, editable), left, top + _this.startY[row] + 3, 14, Math.min(height, 14));
                        //   ctx.restore();
                    });
                }
                if (editable && Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(sheet.modifyedValues, __WEBPACK_IMPORTED_MODULE_0__ExcelStore__["a" /* StoreFuncs */].getRandomId(row) + "." + col)) {
                    ctx.drawImage(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["c" /* dotPngImg */], x, y, 8, 8);
                }
            }
            catch (e) {
            }
        };
        Type.prototype.getAutoFitWidth = function (value, a, cellStyle, zoomFactor, context) {
            var _this = this;
            if (this.checkBoxType === CheckBoxType.Check) {
                return 28;
            }
            return Math.max.apply(Math, this._items.map(function (d) {
                return _super.prototype.getAutoFitWidth.call(_this, d.name, d.name, cellStyle, zoomFactor, context) + 28;
            }));
        };
        Type.prototype.getAutoFitHeight = function (value, text, cellStyle, zoomFactor, context) {
            return this.checkBoxType === CheckBoxType.Check ? 20 : 20 * this._items.length;
        };
        Type.prototype.processMouseUp = function (hitInfo) {
            var _a = hitInfo, isReservedLocation = _a.isReservedLocation, doCheck = _a.doCheck;
            if (isReservedLocation && typeof doCheck === 'function') {
                if (editable) {
                    doCheck();
                }
                else {
                    var _b = hitInfo, sheet = _b.sheet, row = _b.row, col = _b.col, sheetArea = _b.sheetArea;
                    var hreflink = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["e" /* getHreflink */])(sheet.getValue(row, col, sheetArea));
                    if (hreflink) {
                        window.cubeOpenHreflinkFromExcel(hreflink);
                    }
                }
                return true;
            }
            return _super.prototype.processMouseUp.call(this, hitInfo);
        };
        Type.prototype.processMouseMove = function (hitInfo) {
            var _a = hitInfo, sheet = _a.sheet, isReservedLocation = _a.isReservedLocation, title = _a.title;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";
            var canvas = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + canvasId)[0];
            if (sheet && isReservedLocation) {
                canvas.style.cursor = 'pointer';
                if (title) {
                    canvas.title = title;
                }
                return true;
            }
            else {
                canvas.title = "";
                canvas.style.cursor = 'default';
            }
            return false;
        };
        Type.prototype.processMouseLeave = function (hitInfo) {
            var sheet = hitInfo.sheet;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";
            var canvas = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#" + canvasId)[0];
            canvas.title = "";
            canvas.style.cursor = 'default';
            return true;
        };
        Type.prototype.getHitInfo = function (x, y, cellStyle, cellRect, context) {
            var row = context.row, col = context.col, sheetArea = context.sheetArea, sheet = context.sheet;
            var info = {
                x: x,
                y: y,
                row: row,
                col: col,
                cellRect: cellRect,
                sheetArea: sheetArea,
                sheet: sheet,
            };
            var changeValue = function (newValue, oldValueSpan) {
                sheet.suspendPaint();
                var hreflink = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["e" /* getHreflink */])(oldValueSpan);
                var newValueSpan = JSON.stringify({ hreflink: hreflink, value: newValue });
                var dataSource = sheet.getDataSource();
                var datas = dataSource.getValue("datas");
                var data = datas[row];
                data[column.column] = newValue;
                data[column.column + "span"] = newValueSpan;
                sheet.setChangedValue(Object(__WEBPACK_IMPORTED_MODULE_0__ExcelStore__["c" /* getRandomId */])(data), column, { sheet: sheet, row: row, col: col, newValue: newValueSpan, oldValue: oldValueSpan, time: data.time });
                sheet.resumePaint();
            };
            if (editable && this.checkBoxType === CheckBoxType.Check) {
                if (x > cellRect.x + 7 && y > cellRect.y + cellRect.height / 2 - 7 && x < cellRect.x + 21 && y < cellRect.y + cellRect.height / 2 + 7) {
                    info.isReservedLocation = true;
                    info.doCheck = function () {
                        var oldValueSpan = sheet.getValue(row, col);
                        var oldValue = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["f" /* getInputValue */])(oldValueSpan);
                        var newValue = oldValue === '1' ? '0' : '1';
                        changeValue(newValue, oldValueSpan);
                    };
                }
            }
            else if (this.checkBoxType === CheckBoxType.MutilCheck || this.checkBoxType === CheckBoxType.Raido) {
                var rowIndex = parseInt('' + ((y - cellRect.y - this.startY[row]) / 20));
                if (rowIndex < this._itemWidth[row].length && x < cellRect.x + this._itemSumWidth[row][rowIndex]) {
                    var startX = cellRect.x;
                    var datas_1 = this._itemsMap[row][rowIndex] || [];
                    var _loop_1 = function (i) {
                        if (x < startX + this_1._itemWidth[row][rowIndex][i]) {
                            info.isReservedLocation = true;
                            info.title = datas_1[i].name;
                            if (editable) {
                                info.doCheck = this_1.checkBoxType === CheckBoxType.MutilCheck ? function () {
                                    var oldValueSpan = sheet.getValue(row, col);
                                    var oldValue = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["f" /* getInputValue */])(oldValueSpan);
                                    var valueArray = typeof oldValue === 'string' ? oldValue.split(',') : [];
                                    var clickedValue = datas_1[i].value;
                                    if (valueArray.indexOf(clickedValue) > -1) {
                                        valueArray = valueArray.filter(function (d) { return d !== clickedValue; });
                                    }
                                    else {
                                        valueArray.push(clickedValue);
                                    }
                                    var newValue = valueArray.join(',');
                                    changeValue(newValue, oldValueSpan);
                                } : function () {
                                    var clickedValue = datas_1[i].value;
                                    var oldValueSpan = sheet.getValue(row, col);
                                    changeValue(clickedValue, oldValueSpan);
                                };
                            }
                            return "break";
                        }
                        startX += (this_1._itemWidth[row][rowIndex][i]);
                    };
                    var this_1 = this;
                    for (var i = 0; i < datas_1.length; i++) {
                        var state_1 = _loop_1(i);
                        if (state_1 === "break")
                            break;
                    }
                }
            }
            return info;
        };
        return Type;
    }(GC.Spread.Sheets.CellTypes.Base));
    return Type;
});


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExcelStore__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldCellType__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/* harmony default export */ __webpack_exports__["a"] = (function (column, editable) {
    if (editable) {
        var Type = /** @class */ (function (_super) {
            __extends(Type, _super);
            function Type(options, column) {
                var _this = _super.call(this) || this;
                _this.items(options.map(function (d) { return ({ value: d.value, text: d.name }); }));
                _this.editorValueType(GC.Spread.Sheets.CellTypes.EditorValueType.value);
                return _this;
            }
            Type.prototype.paint = function (ctx, value, x, y, w, h, style, context) {
                try {
                    ctx.clearRect(x, y, w, h);
                    _super.prototype.paint.call(this, ctx, Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["f" /* getInputValue */])(value), x, y, w, h, style, context);
                    var sheet = context.sheet, row = context.row, col = context.col;
                    if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(sheet.modifyedValues, __WEBPACK_IMPORTED_MODULE_0__ExcelStore__["a" /* StoreFuncs */].getRandomId(row) + "." + col)) {
                        ctx.drawImage(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["c" /* dotPngImg */], x, y, 8, 8);
                    }
                }
                catch (e) {
                }
            };
            Type.prototype.getAutoFitWidth = function (value, text, cellStyle, zoomFactor, context) {
                return _super.prototype.getAutoFitWidth.call(this, Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["f" /* getInputValue */])(value), text, cellStyle, zoomFactor, context);
            };
            Type.prototype.setEditorValue = function (editorContext, value, context) {
                var inputValue = Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["f" /* getInputValue */])(value);
                return _super.prototype.setEditorValue.call(this, editorContext, inputValue, context);
            };
            Type.prototype.getEditorValue = function (editorContext, context) {
                var sheet = context.sheet, row = context.row, col = context.col;
                var value = sheet.getValue(row, col);
                var hreflink = Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["e" /* getHreflink */])(value);
                var inputValue = _super.prototype.getEditorValue.call(this, editorContext, context);
                return JSON.stringify({
                    hreflink: hreflink,
                    value: inputValue
                });
            };
            return Type;
        }(GC.Spread.Sheets.CellTypes.ComboBox));
        return Type;
    }
    else {
        var Type = /** @class */ (function (_super) {
            __extends(Type, _super);
            function Type(options, column) {
                var _this = _super.call(this) || this;
                _this.options = {};
                _this.itemWidth = {};
                _this.column = '';
                options.forEach(function (v) {
                    _this.options[v.value] = v.name;
                });
                _this.column = column;
                return _this;
            }
            Type.prototype.paint = function (ctx, value, x, y, w, h, style, context) {
                try {
                    ctx.clearRect(x, y, w, h);
                    if (!editable && Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["e" /* getHreflink */])(value)) {
                        style.foreColor = __WEBPACK_IMPORTED_MODULE_2__FieldCellType__["h" /* linkedColor */];
                        style.textDecoration = GC.Spread.Sheets.TextDecorationType.underline;
                    }
                    var row = context.row;
                    this.itemWidth[row] = parseInt(ctx.measureText(Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["f" /* getInputValue */])(value)).width.toString());
                    return _super.prototype.paint.call(this, ctx, value, x, y, w, h, style, context);
                }
                catch (e) {
                }
            };
            Type.prototype.getAutoFitWidth = function (value, text, cellStyle, zoomFactor, context) {
                return _super.prototype.getAutoFitWidth.call(this, value, text, cellStyle, zoomFactor, context);
            };
            Type.prototype.format = function (value, format, formattedData, context) {
                var _this = this;
                if (this.column === 'seclevel') {
                    var _value = Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["f" /* getInputValue */])(value);
                    var secrettime = Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["g" /* getParamValue */])(value, 'secrettime');
                    _value = _value && _value.split(',').map(function (v) { return _this.options[v]; }).join(',');
                    return _value + "" + secrettime;
                }
                else {
                    value = Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["f" /* getInputValue */])(value);
                    return value && value.split(',').map(function (v) { return _this.options[v]; }).join(',');
                }
            };
            Type.prototype.processMouseUp = function (hitInfo) {
                var _a = hitInfo, sheet = _a.sheet, row = _a.row, col = _a.col, sheetArea = _a.sheetArea, isReservedLocation = _a.isReservedLocation;
                if (isReservedLocation) {
                    var hreflink = Object(__WEBPACK_IMPORTED_MODULE_2__FieldCellType__["e" /* getHreflink */])(sheet.getValue(row, col, sheetArea));
                    if (hreflink) {
                        window.cubeOpenHreflinkFromExcel(hreflink);
                    }
                }
                return true;
            };
            Type.prototype.processMouseMove = function (hitInfo) {
                var _a = hitInfo, sheet = _a.sheet, isReservedLocation = _a.isReservedLocation;
                var div = sheet.getParent().getHost();
                var canvasId = div.id + "vp_vp";
                var canvas = __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#" + canvasId)[0];
                if (sheet && isReservedLocation) {
                    canvas.style.cursor = 'pointer';
                    return true;
                }
                else {
                    canvas.title = "";
                    canvas.style.cursor = 'default';
                }
                return false;
            };
            ;
            Type.prototype.getHitInfo = function (x, y, cellStyle, cellRect, context) {
                var row = context.row, col = context.col, sheetArea = context.sheetArea, sheet = context.sheet;
                var info = {
                    x: x,
                    y: y,
                    row: row,
                    col: col,
                    cellRect: cellRect,
                    sheetArea: sheetArea,
                    sheet: sheet,
                    isReservedLocation: x - cellRect.x <= this.itemWidth[row]
                };
                return info;
            };
            return Type;
        }(GC.Spread.Sheets.CellTypes.Base));
        return Type;
    }
});


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DateTimeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExcelStore__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputCellType__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldCellType__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__coms_date_picker__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__coms_time_picker__ = __webpack_require__(548);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};








var datePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAACA0lEQVR42r1UTWsUQRBdFTVENIJRPHhUQQX9AeIH5mIUj+uCXsZDBt21s93VH9Xdl0G8REEPgl7EX2AUv8AcQsg/8Og93tT/oPU22bgJI9FdSMOD4tWrN101NdNobMdRSu11zu37Wx45aP7Vb4fx8ap2fK+uCBxy0EBbd5sD2qcnFNLiAL4KVgRLm/jFNW5lTbPOmxCfwqvRSekQ+fjBeH5kmG/pEG5L8pWIPusYC3CDIHAhLpiQX/Y5G/Jj0X+EV8/QhPTacp7ut6xMutD1sSlnz+aOwEmuJV2d73Myguvk0/y6od1o+N9Hu7zRUFp+Z3301vLFYUCcgrT8/o/h6qC/C74NA+nwBzwGbzjfpdjqdGSehs8Q5aluN58tSzvZbvujxqRLAOI7Sh2+T3wOGmhRI/UteQ9vamdobGxTyF9kJqEoijFZ4iPy9GUpWEZcVNWY4RShkbd9FzWohUetoeX0UOJfgmdlWY6rEI4R558A4rKqxsX8+aomPdjScNb7E9rytNbhVFVVO3HLWQpTAGJZm13K2tPQGGOOb2moHN+Qdl8Yxzexc1rrg1hcAHGzWfX2EBqsy/a3rJ27AiGRvyaGu/F9yvAZQAwOXwY02sXLtYbk81tyPENEJ4eCSzPw6BmGEPaTi3PW50+jgEKcg1fvZ1CWPGGtnRwFzDxR+38c9fwG1BL+KX3/T+MAAAAASUVORK5CYII=';
var dateTimePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAACwElEQVR42p1UTW9MYRQeRbUNbSqthopuSIREQiKxKaUWxkYiJoiISRdXZ8ad+35/jbpI0AURId1ZsJG0XVSUIiIlNixIWFlIWfsRPO9trtZMRzre5OS+H+c8555znnMymb9XUxiqzcNCbMjUWXEcr+K80hdo3VFXIQh0B+e8ywuRrkSldum5WiilvUQ5S7g5E4Zht7/Dtx1QKxJASs1WLu0NLt20F6bsVybtXHquFrzNMO3m8P28YGPiMIzbE0Ah3C4m7GMmjBXCHGLSPIDylN8vJZzrLHSm4Pg2Y2qQaS24dtNhaLv/AHJlJwBy1J8jrvcT7rL1chgEwWoqzRFC5J55e3P4n4CNriUB4XGaKnuXKjfcqAiEXguozEv84Qfk5WnDIs0MRVF1SqPqkIeUWkcrlV6vADqs8fvQ2m5Pr5SrhUKhkxC38YJSmwrGdA4svNUCgoMGnn8SYUbLTB30e6bca6pHdqIgXZHQ56nSE0jTC67Mc6RqAhEOR5HraQxQ2n6A3AfAO8g53A1SKg9waU7D9gm4eMdHt+yQ8a6g96Vc1lt82GiGa+Av8x3CmNkNx28jaU7WABJmhvA4GwlF8vl8i7/zvc09E4Q+laaKaTuGKK4HcdyWOJbW+OLWAArlroIGv2BwLwjiNn8XcrsDBrOlUqVvMSDCfA+7MQAVibIn0JI/agA5N3uhXEB++gcG5qvHud3u/7pclttSwCSnKIbX9bagTw463zKREJ7Yz5Doh+jnERTlEkKJ4X0kOXMdYfXAaJIIxaoaxU+YplwutxK6owCdzCTjSNpbQH+1lMDZo2KxuJYodZYp/Z0ptQ+cbE4RAdaMFGFg2I9+Diy7Zz0IqHIZoX6CXCHcHkeRjiGii3D8hkrH8/m4paFBkEU1fb6Qu5tEmnEAjRPwj2CkJRz834UwW33LIV3rIa2L334DaBD72Y619JMAAAAASUVORK5CYII=';
var timePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAACX0lEQVR42pVUTWsUQRBdyUaIqNGc/DrG+IEokruueo16Wi9GBA8T3Lg7Xd3T1d0TYY4i7uZqklUiKGgQ79F41B8ghuTv+GpgN5vNuLtpKOjp7npV86pelUoDVhRF4/V6/SRRNiUmezkrHXZFkZtUib9LNqTK+o/E4ZtYvrcubej0DoAnRwKrKb4C53fE/oe2rqXYP6HEPRSTvbahRdZvKRvWFrWeGQhW1/omHHblccPai9VqdaL/jZwt6jBDnLYBvNNI0muFYC9MuKyt30VmzUqlUu4GEQ45PK1Ze6b3/exsNG6sX9YctiX4PjCl1ClEe0+JX+0FywGZLxhOf2rnbvQnIaDwayOJVQncvdCc3iMXthb6Iw0BzH3Bo/CNAt7ucHIUlXupjHtTJZo4LCDBB1kuw2yWZWVwlAlHn5Thx4WFGgKYg4JjoewZ84mSNKzh8FUl7v7/AEHJb3LukYB2DJlN7VEWHqCgn597f1pSFsCNGIeF1Wc+B37+IItfwnPHYmvncH2kA4j7jTwII03j0nVEnS8CBMdj6IKztLR0vteglGOdN0aan8MHwcr1igw8JdykgqIMW+KjXWjBuKvzXLcofaNxsG2GLWkb/PJ3YFT2hoFzk5DcGhn/Fp9jo8NVyvBbEdvX2LJyfUKbsQ2vhLehUFAUqHptbPhbI5oufBQnyXWIfgfDYWVhwHDQCJ7/EfvtujFXB0aOY76Eh21yfhPabmqXzsN5Tvq0O77Yb0rQGvnpkZgRPoRkODGG6rr0GIj/ImpANZPYuVsHOBuJcvAkcvJQgFgty473T6P+9Q9W+EKJ8/a2MwAAAABJRU5ErkJggg==';
var dateImg = document.createElement('img');
dateImg.src = datePng;
var dateTimeImg = document.createElement('img');
dateTimeImg.src = dateTimePng;
var timeImg = document.createElement('img');
timeImg.src = timePng;
var DateTimeType;
(function (DateTimeType) {
    DateTimeType["Date"] = "2";
    DateTimeType["Time"] = "19";
    DateTimeType["DateTime"] = "290";
    DateTimeType["Year"] = "402";
    DateTimeType["YearMonth"] = "403";
})(DateTimeType || (DateTimeType = {}));
var getImg = function (type) {
    if (type === DateTimeType.Date || type === DateTimeType.Year || type === DateTimeType.YearMonth) {
        return dateImg;
    }
    else if (type === DateTimeType.Time) {
        return timeImg;
    }
    else if (type === DateTimeType.DateTime) {
        return dateTimeImg;
    }
    return undefined;
};
/* harmony default export */ __webpack_exports__["a"] = (function (column, editable) {
    if (editable) {
        var type_1 = column.type;
        var Type = /** @class */ (function (_super) {
            __extends(Type, _super);
            function Type() {
                var _this = _super.call(this) || this;
                _this.itemWidth = {};
                _this.openPicker = function (context, cellRect) {
                    var sheet = context.sheet, row = context.row, col = context.col;
                    if (!_this.div) {
                        _this.div = document.createElement('div');
                        var host = sheet.getParent().getHost();
                        host.appendChild(_this.div);
                        _this.div.style.visibility = 'hidden';
                    }
                    __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.div).css({
                        position: 'absolute',
                        left: cellRect.x,
                        top: cellRect.y,
                        width: cellRect.width,
                        height: cellRect.height,
                    });
                    if (!_this.instance) {
                        var value = context.value();
                        var unmountDatePicker = function () {
                            if (_this.div) {
                                __WEBPACK_IMPORTED_MODULE_0_react_dom__["unmountComponentAtNode"](_this.div);
                                _this.instance = void 0;
                            }
                        };
                        var changeValue = function (newValue) {
                            sheet.suspendPaint();
                            var value = context.value();
                            var newValueSpan = '';
                            var hreflink = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["e" /* getHreflink */])(value);
                            newValueSpan = JSON.stringify({ hreflink: hreflink, value: newValue });
                            var dataSource = sheet.getDataSource();
                            var datas = dataSource.getValue("datas");
                            var data = datas[row];
                            data[column.column] = newValue;
                            data[column.column + "span"] = newValueSpan;
                            sheet.setChangedValue(Object(__WEBPACK_IMPORTED_MODULE_1__ExcelStore__["c" /* getRandomId */])(data), column, { sheet: sheet, row: row, col: col, newValue: newValueSpan, oldValue: value, time: data.time });
                            sheet.resumePaint();
                        };
                        if (type_1 === DateTimeType.Date || type_1 === DateTimeType.DateTime) {
                            __WEBPACK_IMPORTED_MODULE_0_react_dom__["render"](React.createElement(__WEBPACK_IMPORTED_MODULE_6__coms_date_picker__["a" /* default */], { ecId: "_DatePicker@z7qnl3", showTime: type_1 === DateTimeType.DateTime, ref: function (ref) { return _this.instance = ref; }, style: { height: '100%', width: '100%' }, onChange: changeValue, onClose: unmountDatePicker, value: Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["f" /* getInputValue */])(value), formatter: type_1 === DateTimeType.DateTime ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd' }), _this.div);
                        }
                        else if (type_1 === DateTimeType.Year || type_1 === DateTimeType.YearMonth) {
                            __WEBPACK_IMPORTED_MODULE_0_react_dom__["render"](React.createElement(__WEBPACK_IMPORTED_MODULE_6__coms_date_picker__["a" /* default */], { ecId: "_DatePicker@kg48mx", type: 'yearMonth', showTime: false, ref: function (ref) { return _this.instance = ref; }, style: { height: '100%', width: '100%' }, onChange: changeValue, onClose: unmountDatePicker, value: Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["f" /* getInputValue */])(value), formatter: type_1 === DateTimeType.Year ? 'YYYY' : 'YYYY-MM' }), _this.div);
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_0_react_dom__["render"](React.createElement(__WEBPACK_IMPORTED_MODULE_7__coms_time_picker__["a" /* default */], { ecId: "_TimePicker@d0k4a7", ref: function (ref) { return _this.instance = ref; }, value: Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["f" /* getInputValue */])(value), onChange: changeValue, style: { height: '100%', width: '100%' }, onClose: unmountDatePicker }), _this.div);
                        }
                    }
                    var openModal = function () {
                        if (_this.instance) {
                            _this.instance.openModal();
                        }
                        else {
                            setTimeout(function () {
                                openModal();
                            }, 50);
                        }
                    };
                    openModal();
                };
                _this.showTime = type_1 === DateTimeType.DateTime;
                _this.img = getImg(type_1);
                _this.formater = type_1 === DateTimeType.DateTime ? 'yyyy-MM-dd HH:mm' : type_1 === DateTimeType.Date ? 'yyyy-MM-dd' : 'HH:mm';
                return _this;
            }
            Type.prototype.paint = function (ctx, value, x, y, w, h, style, context) {
                try {
                    ctx.clearRect(x, y, w, h);
                    var realValue = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["f" /* getInputValue */])(value);
                    if (!editable && Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["e" /* getHreflink */])(value)) {
                        style.foreColor = __WEBPACK_IMPORTED_MODULE_3__FieldCellType__["h" /* linkedColor */];
                        style.textDecoration = GC.Spread.Sheets.TextDecorationType.underline;
                        var row = context.row;
                        this.itemWidth[row] = parseInt(ctx.measureText(realValue).width.toString());
                    }
                    _super.prototype.paint.call(this, ctx, realValue, x, y, w - 20, h, style, context);
                    if (this.img) {
                        //ctx.save();
                        var width = Math.min(16, h);
                        ctx.drawImage(this.img, x + w - width, y + (h - width) / 2, width, width);
                        // ctx.restore();
                    }
                    if (editable) {
                        var sheet = context.sheet, row = context.row, col = context.col;
                        if (Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(sheet.modifyedValues, __WEBPACK_IMPORTED_MODULE_1__ExcelStore__["a" /* StoreFuncs */].getRandomId(row) + "." + col)) {
                            ctx.drawImage(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["c" /* dotPngImg */], x, y, 8, 8);
                        }
                    }
                }
                catch (e) {
                }
            };
            Type.prototype.getAutoFitWidth = function (value, text, cellStyle, zoomFactor, context) {
                return _super.prototype.getAutoFitWidth.call(this, Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["f" /* getInputValue */])(value), text, cellStyle, zoomFactor, context) + (editable ? 20 : 0);
            };
            Type.prototype.getHitInfo = function (x, y, cellStyle, cellRect, context) {
                var row = context.row, col = context.col, sheetArea = context.sheetArea, sheet = context.sheet;
                var info = {
                    x: x,
                    y: y,
                    row: row,
                    col: col,
                    cellRect: cellRect,
                    sheetArea: sheetArea,
                    sheet: sheet,
                    isReservedLocation: editable ? cellRect.x + cellRect.width - x < 20 : x - cellRect.x <= this.itemWidth[row]
                };
                return info;
            };
            Type.prototype.processMouseMove = function (hitInfo) {
                var _a = hitInfo, sheet = _a.sheet, isReservedLocation = _a.isReservedLocation;
                var div = sheet.getParent().getHost();
                var canvasId = div.id + "vp_vp";
                var canvas = __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#" + canvasId)[0];
                if (sheet && isReservedLocation) {
                    canvas.style.cursor = 'pointer';
                    return true;
                }
                else {
                    canvas.style.cursor = 'default';
                }
                return false;
            };
            ;
            Type.prototype.processMouseUp = function (hitInfo) {
                var _a = hitInfo, sheet = _a.sheet, row = _a.row, col = _a.col, cellRect = _a.cellRect, sheetArea = _a.sheetArea, isReservedLocation = _a.isReservedLocation;
                if (isReservedLocation) {
                    if (editable) {
                        this.openPicker(sheet.getCell(row, col, sheetArea), cellRect);
                    }
                    else {
                        var hreflink = Object(__WEBPACK_IMPORTED_MODULE_3__FieldCellType__["e" /* getHreflink */])(sheet.getValue(row, col, sheetArea));
                        if (hreflink) {
                            window.cubeOpenHreflinkFromExcel(hreflink);
                        }
                    }
                    return true;
                }
                return _super.prototype.processMouseUp.call(this, hitInfo);
            };
            return Type;
        }(GC.Spread.Sheets.CellTypes.Base));
        return Type;
    }
    else {
        return Object(__WEBPACK_IMPORTED_MODULE_2__InputCellType__["a" /* default */])(__assign({}, column, { typeName: __WEBPACK_IMPORTED_MODULE_3__FieldCellType__["a" /* FieldTypeName */].Text }));
    }
});


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.openModal = function () {
            _this.toggleOpen({ open: true });
        };
        _this.fixedPosition = function (left, top) {
            _this.setState({
                left: left, top: top
            });
        };
        _this.toggleOpen = function (state) {
            _this.setState(state, function () {
                if (!state.open) {
                    if (_this.props.onClose) {
                        _this.props.onClose((__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"](_this)).parentElement);
                    }
                }
            });
        };
        _this.changeValue = function (moment, date2) {
            var type = _this.props.type;
            if (typeof _this.props.onChange === 'function') {
                if (type == 'yearMonth') {
                    _this.props.onChange(moment);
                }
                else {
                    _this.props.onChange(date2);
                }
            }
        };
        _this.state = {
            open: false
        };
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        this.div = document.createElement('div');
        this.div.className = 'edc-date-picker-mask';
        this.div.style.display = 'none';
        document.body.appendChild(this.div);
    };
    DatePicker.prototype.componentDidUpdate = function () {
        if (this.div) {
            if (this.state.open) {
                this.div.style.display = 'block';
            }
            else {
                this.div.style.display = 'none';
            }
        }
    };
    DatePicker.prototype.componentWillUnmount = function () {
        document.body.removeChild(this.div);
    };
    DatePicker.prototype.render = function () {
        var type = this.props.type;
        if (type == 'yearMonth') {
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { style: { display: '' } },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { style: { position: 'fixed', top: this.state.top, left: this.state.left, visibility: 'hidden' } },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaDatePicker"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDatePicker@a0b7a0", format: this.props.formatter, showTime: this.props.showtime, open: this.state.open, toggleOpen: this.toggleOpen, onChange: this.changeValue, popupStyle: { left: this.state.left, top: this.state.top }, value: this.props.value }))));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { style: { display: '' } },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { style: { position: 'fixed', top: this.state.top, left: this.state.left, visibility: 'hidden' } },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_antd__["DatePicker"], { ecId: (this && this.props && this.props.ecId || '') + "_AntdDatePicker@phq4ul", format: this.props.formatter, showTime: this.props.showtime, open: this.state.open, toggleOpen: this.toggleOpen, onChange: this.changeValue, popupStyle: { left: this.state.left, top: this.state.top }, value: this.props.value }))));
        }
    };
    return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var TimePicker = /** @class */ (function (_super) {
    __extends(TimePicker, _super);
    function TimePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.openModal = function (left, right) {
            _this.toggleOpen({ open: true });
        };
        _this.fixedPosition = function (left, top, callback) {
            _this.setState({
                left: left, top: top
            }, callback);
        };
        _this.toggleOpen = function (state) {
            _this.setState(state, function () {
                if (!state.open) {
                    if (_this.props.onClose) {
                        _this.props.onClose((__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this)).parentElement);
                    }
                }
            });
        };
        _this.changeValue = function (moment, time) {
            if (typeof _this.props.onChange === 'function') {
                _this.props.onChange(time);
            }
        };
        _this.state = {
            open: false
        };
        return _this;
    }
    TimePicker.prototype.componentDidMount = function () {
        this.div = document.createElement('div');
        this.div.className = 'edc-time-picker-mask';
        this.div.style.display = 'none';
        document.body.appendChild(this.div);
    };
    TimePicker.prototype.componentDidUpdate = function () {
        if (this.div) {
            if (this.state.open) {
                this.div.style.display = 'block';
            }
            else {
                this.div.style.display = 'none';
            }
        }
    };
    TimePicker.prototype.componentWillUnmount = function () {
        document.body.removeChild(this.div);
    };
    TimePicker.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { display: '' } },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { position: 'fixed', top: this.state.top, left: this.state.left, visibility: 'hidden' } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_antd__["TimePicker"], { ecId: (this && this.props && this.props.ecId || '') + "_AntdTimePicker@b2nzrk", open: this.state.open, format: "HH:mm", onOpen: this.toggleOpen.bind(this, { open: true }), onClose: this.toggleOpen.bind(this, { open: false }), onChange: this.changeValue, popupStyle: { left: this.state.left, top: this.state.top }, value: this.props.value }))));
    };
    return TimePicker;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (TimePicker);


/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return register; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__change_value__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paste_data__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clearContent__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__insert_row__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__delete_rows__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apis_excelsearch__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_convert__ = __webpack_require__(167);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};










function r(a) {
    var b, c, d, e, f, g = [];
    if (a) {
        for (b = '"',
            c = !1,
            d = 0; d < a.length; d++)
            e = d > 0 ? a[d - 1] : "",
                f = a[d],
                f === b ? (c = !c,
                    g.push(b)) : c || "\n" !== f || "\r" === e ? g.push(f) : g.push("\r\n");
        return g.join("");
    }
    return "";
}
var register = function (commandManager, store) {
    var _a;
    commandManager.register('cube-change-value', __WEBPACK_IMPORTED_MODULE_0__change_value__["a" /* default */]);
    commandManager.register('cube-paste-data', __WEBPACK_IMPORTED_MODULE_1__paste_data__["a" /* default */]);
    delete commandManager.clear;
    delete commandManager.clearValues;
    commandManager.register('clear', __WEBPACK_IMPORTED_MODULE_2__clearContent__["a" /* default */], GC.Spread.Commands.Key.del);
    commandManager.register('clear', __WEBPACK_IMPORTED_MODULE_2__clearContent__["a" /* default */], GC.Spread.Commands.Key.backspace);
    commandManager.register('cube-insert-rows', __WEBPACK_IMPORTED_MODULE_3__insert_row__["a" /* default */]);
    commandManager.register('cube-delete-rows', __WEBPACK_IMPORTED_MODULE_4__delete_rows__["a" /* default */]);
    store.workbook.commandManager().register("gc.spread.undo", {
        canUndo: true,
        execute: function (context, options, isUndo) {
            if (isUndo) {
            }
            else {
                var sheet = store.workbook.getActiveSheet();
                var selections = sheet.getSelections();
                // var lineStyle = GC.Spread.Sheets.LineStyle.thin;
                // var lineBorder = new GC.Spread.Sheets.LineBorder('#a5a5a5',lineStyle);
                if (selections && selections.length > 0) {
                    var oldColor_1 = "";
                    //挂起sheet绘制
                    sheet.suspendPaint();
                    selections.forEach(function (item) {
                        var cellRange = sheet.getRange(item.row, item.col, item.rowCount, item.colCount);
                        var cell = store.workbook.getActiveSheet().getCell(item.row, item.col);
                        oldColor_1 = cell.backColor() === void 0 ? "" : cell.backColor();
                        //获取配置颜色区域的行(id)-字段-颜色
                        var row = item.row, col = item.col, rowCount = item.rowCount, colCount = item.colCount;
                        var datas = store.dataSource.getValue('datas');
                        var columns = store.columns;
                        var colordatas = [];
                        for (var i = 0; i < rowCount; i++) {
                            var data = datas[row + i] || {};
                            //  const id = data.randomFieldSubKeyd_id ? `${data.randomFieldId}^^--^^${data.randomFieldSubKeyd_id}` : data.randomFieldId;
                            var id = data.randomFieldId;
                            for (var j = 0; j < colCount; j++) {
                                var fieldid = columns[col + j].id();
                                colordatas.push({ id: id, fieldid: fieldid, color: '', oldColor: oldColor_1 });
                            }
                        }
                        __WEBPACK_IMPORTED_MODULE_6__apis_excelsearch__["b" /* checkColorIsChange */](__assign({ colordatas: JSON.stringify(colordatas) }, store.params, { time: store.colortime })).then(function (data) {
                            if (data.status == "1") {
                                if (data.errMessage) { //颜色过期刷新后重新设置
                                    __WEBPACK_IMPORTED_MODULE_7_antd__["Modal"].info({
                                        title: Object(__WEBPACK_IMPORTED_MODULE_8__util_convert__["b" /* getLabel */])(15172, '系统提示'),
                                        content: Object(__WEBPACK_IMPORTED_MODULE_8__util_convert__["b" /* getLabel */])('', '所选区域内存在过期的颜色,请刷新数据后,重新设置颜色'),
                                        onOk: function () { return; },
                                    });
                                }
                                else {
                                    __WEBPACK_IMPORTED_MODULE_6__apis_excelsearch__["a" /* cellColor */](__assign({ type: 'undo', colordatas: JSON.stringify(colordatas) }, store.params)).then(function () {
                                        cellRange.backColor('');
                                        store.getCellColor(store.data);
                                    });
                                }
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_7_antd__["message"].error("校验数据是否过期出现异常");
                            }
                        });
                    });
                    //重绘
                    sheet.resumePaint();
                }
            }
        }
    });
    store.workbook.commandManager().register("colorPicker_backColor", {
        canUndo: true,
        execute: function (context, options, isUndo) {
            //   var Commands = GC.Spread.Sheets.Commands;
            // 在此加cmd
            options.cmd = "colorPicker_backColor";
            if (isUndo) {
            }
            else {
                // Commands.startTransaction(context, options);
                changeColor(store.workbook, options.color, true);
                // Commands.endTransaction(context, options);
                return true;
            }
            store.workbook.resumePaint();
        }
    });
    /*
     *  创建颜色选择面板，并注册事件
     * */
    function createColorpicker(flag) {
        var colors = ['rgb(255,255,255)',
            'rgb(0,255,255)', 'rgb(255,0,255)',
            'rgb(255,255,0)', 'rgb(255,0,0)',
            'rgb(0,255,0)', 'rgb(0,0,255)',
            'rgb(0,0,0)', 'rgb(64,64,64)',
            'rgb(128,128,128)'];
        var colorPicker = __WEBPACK_IMPORTED_MODULE_5_jquery___default()("<div id='colorPicker'></div>");
        for (var i = 0; i < colors.length; i++) {
            var color = __WEBPACK_IMPORTED_MODULE_5_jquery___default()("<span class='cube_colorPicker cube_colorPickerBorderMouseout' mycolor='" + colors[i] + "' style='background-color:" + colors[i] + "'></span>");
            color.mouseenter(function () {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).removeClass("cube_colorPickerBorderMouseout");
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).addClass("cube_colorPickerBorderMouseenter");
            });
            color.mouseout(function () {
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).removeClass("cube_colorPickerBorderMouseenter");
                __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).addClass("cube_colorPickerBorderMouseout");
            });
            color.click(function () {
                var that = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this);
                var color = that.attr("mycolor");
                var sheet = store.workbook.getActiveSheet();
                var commandName = "colorPicker_foreColor";
                if (flag) {
                    commandName = "colorPicker_backColor";
                }
                store.workbook.commandManager().execute({
                    cmd: commandName,
                    sheetName: sheet.name(),
                    color: color
                });
            });
            colorPicker.append(color);
        }
        return colorPicker;
    }
    function ContextMenu() { }
    ContextMenu.prototype = new GC.Spread.Sheets.ContextMenu.ContextMenu();
    //onOpenMenu是在右键点击时触发的事件
    ContextMenu.prototype.onOpenMenu = function (menuData, itemsDataForShown, hitInfo, spread) {
        var index = -1;
        for (var i = 0; i < itemsDataForShown.length; i++) {
            var item = itemsDataForShown[i];
            if (item.name === "gc.spread.filter") {
                index = i;
                break;
            }
        }
        if (index > -1) {
            itemsDataForShown.splice(index, 1);
        }
        return false;
    };
    var contextMenu = new ContextMenu();
    store.workbook.contextMenu = contextMenu;
    // 通过重写MenuView类，将自定义功能加入右键样式
    function CustomMenuView() { }
    CustomMenuView.prototype = new GC.Spread.Sheets.ContextMenu.MenuView();
    CustomMenuView.prototype.createMenuItemElement = function (menuItemData) {
        var self = this;
        var menuItemView = GC.Spread.Sheets.ContextMenu.MenuView.prototype.createMenuItemElement.call(self, menuItemData);
        if (menuItemData.name === "selectColorPicker1") {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()(menuItemView).append(createColorpicker(true));
            return menuItemView;
        }
        else if (menuItemData.name === "selectColorPicker2") {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()(menuItemView).append(createColorpicker(false));
            return menuItemView;
        }
        else {
            return menuItemView;
        }
    };
    // 将自定义MenuView赋值给SpreadJS
    store.workbook.contextMenu.menuView = new CustomMenuView();
    var colorPickers = [{
            text: "颜色选择器",
            name: "gc.spread.colorPicker",
            workArea: "viewport",
            subMenu: [{
                    text: "背景色:",
                    name: "selectColorPicker1"
                }
                // ,{
                //     text: "字体色:",
                //     name: "selectColorPicker2"
                // }
            ]
        },
        {
            text: "撤销",
            name: "gc.spread.undo",
            workArea: "viewport",
        }
    ];
    // 将colorPicker项添加到右键菜单中
    (_a = store.workbook.contextMenu.menuData).splice.apply(_a, [1, 0].concat(colorPickers));
    store.workbook.contextMenu.menuData = store.workbook.contextMenu.menuData.filter(function (d) { return d.name === 'gc.spread.insertRows' || d.name === 'gc.spread.deleteRows' || d.name === 'gc.spread.colorPicker' || d.name === 'gc.spread.undo'; }).map(function (d) {
        if (d.name === 'gc.spread.insertRows') {
            d.command = 'cube-insert-rows';
            d.text = Object(__WEBPACK_IMPORTED_MODULE_8__util_convert__["b" /* getLabel */])(30615, '插入');
        }
        else if (d.name === 'gc.spread.deleteRows') {
            d.command = 'cube-delete-rows';
            d.text = Object(__WEBPACK_IMPORTED_MODULE_8__util_convert__["b" /* getLabel */])(91, '删除');
        }
        else if (d.name === 'gc.spread.undo') {
            d.command = 'gc.spread.undo';
        }
        return d;
    });
    function changeColor(spread, color, flag) {
        var sheet = spread.getActiveSheet();
        var selections = sheet.getSelections();
        var oldColor = "";
        if (selections && selections.length > 0) {
            //挂起sheet绘制
            sheet.suspendPaint();
            selections.forEach(function (item) {
                //获取配置颜色区域的行(id)-字段-颜色
                var row = item.row, col = item.col, rowCount = item.rowCount, colCount = item.colCount;
                var row1;
                if (row == -1) {
                    row1 = row + 1;
                }
                else {
                    row1 = row;
                }
                var cellRange = sheet.getRange(row1, item.col, item.rowCount, item.colCount);
                var datas = store.dataSource.getValue('datas');
                var columns = store.columns;
                var colordatas = [];
                var oldColordatas = [];
                for (var i = 0; i < rowCount; i++) {
                    var data = datas[row1 + i] || {};
                    // const id = data.randomFieldSubKeyd_id ? `${data.randomFieldId}^^--^^${data.randomFieldSubKeyd_id}` : data.randomFieldId;
                    var id = data.randomFieldId;
                    for (var j = 0; j < colCount; j++) {
                        var cell = spread.getActiveSheet().getCell(row1 + i, col + j);
                        oldColor = cell.backColor() === void 0 ? "" : cell.backColor();
                        var fieldid = columns[col + j].id();
                        if (oldColor != '') {
                            oldColordatas.push({ id: id, fieldid: fieldid, oldColor: oldColor });
                        }
                        colordatas.push({ id: id, fieldid: fieldid, color: color, oldColor: oldColor });
                    }
                }
                var type = "modify";
                if (oldColordatas.length === 0) {
                    type = "add";
                }
                __WEBPACK_IMPORTED_MODULE_6__apis_excelsearch__["b" /* checkColorIsChange */](__assign({ colordatas: JSON.stringify(colordatas) }, store.params, { time: store.colortime })).then(function (data) {
                    if (data.status == "1") {
                        if (data.errMessage) { //颜色过期刷新后重新设置
                            __WEBPACK_IMPORTED_MODULE_7_antd__["Modal"].info({
                                title: Object(__WEBPACK_IMPORTED_MODULE_8__util_convert__["b" /* getLabel */])(15172, '系统提示'),
                                content: Object(__WEBPACK_IMPORTED_MODULE_8__util_convert__["b" /* getLabel */])('', '所选区域内存在过期的颜色,请刷新数据后,重新设置颜色'),
                                onOk: function () { return; },
                            });
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_6__apis_excelsearch__["a" /* cellColor */](__assign({ type: type, colordatas: JSON.stringify(colordatas) }, store.params)).then(function () {
                                // 当flag为true时改变背景色，否则改变字体色(暂时不做)
                                if (flag) {
                                    cellRange.backColor(color);
                                }
                                else {
                                    cellRange.foreColor(color);
                                }
                                store.getCellColor(store.data);
                            });
                        }
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_7_antd__["message"].error("校验数据是否过期出现异常");
                    }
                });
            });
            //重绘
            sheet.resumePaint();
        }
    }
    commandManager.paste = undefined;
    store.workbook.uu.KM.removeEventListener('paste', store.workbook.uu.H4);
    store.workbook.uu.KM.addEventListener('paste', function (event) {
        try {
            var sheet = commandManager.xc.getActiveSheet();
            var clipboardData = event.clipboardData;
            var clipboardManager = commandManager.xc.uu;
            if (clipboardData) {
                var html = clipboardData.getData("text/html");
                var textarea = clipboardManager.I4();
                textarea.innerHTML = html;
                var text = html ? clipboardManager.A$a(textarea, !0) : r(clipboardData.getData("text/plain"));
                textarea.innerHTML = "";
                var pasteEvent = sheet.xx(text);
                pasteEvent.cmd = "clipboardPaste";
                pasteEvent.sheetName = sheet.name();
                pasteEvent.clipboardHtml = html;
                store.clipboardPasted(pasteEvent);
            }
        }
        catch (e) {
        }
    });
};


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    canUndo: true,
    execute: function (context, options, isUndo) {
        var row = options.row, col = options.col, sheet = options.sheet, sheetArea = options.sheetArea, newValue = options.newValue, oldValue = options.oldValue;
        var bool = !sheet.isPaintSuspended();
        if (bool) {
            sheet.suspendPaint();
        }
        if (isUndo) {
            sheet.setValue(row, col, oldValue, sheetArea);
        }
        else {
            sheet.setValue(row, col, newValue, sheetArea);
            sheet.Du().trigger(GC.Spread.Sheets.Events.ValueChanged, { sheet: sheet, row: row, col: col, sheetArea: sheetArea, newValue: newValue, oldValue: oldValue });
            // context.getActiveSheet().
            //  (context as any).trigger(GC.Spread.Sheets.Events.ValueChanged, {sheet, row, col, sheetArea, newValue, oldValue});
        }
        if (bool) {
            sheet.resumePaint();
        }
    }
});


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExcelStore__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__ = __webpack_require__(50);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var toCells = function (range) {
    var cells = [];
    var row = range.row, rowCount = range.rowCount, sheet = range.sheet;
    var col = range.col;
    var colCount = range.colCount;
    if (colCount === -1) {
        colCount = sheet.getColumnCount() + 1;
    }
    if (col === -1) {
        col = 0;
    }
    for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        var currentRow = row + rowIndex;
        for (var colIndex = 0; colIndex < colCount; colIndex++) {
            var currentCol = col + colIndex;
            if (currentCol > -1) {
                cells.push(sheet.getCell(currentRow, currentCol));
            }
        }
    }
    return cells;
};
var isSameTypeColumn = function (col1, col2) {
    if (col1.typeName === col2.typeName) {
        if (col1.typeName === __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__["a" /* FieldTypeName */].Int) {
            return true;
        }
        else if (col1.typeName === __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__["a" /* FieldTypeName */].Text) {
            return col1.length <= col2.length;
        }
        else if (col1.typeName === __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__["a" /* FieldTypeName */].Float || col1.typeName === __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__["a" /* FieldTypeName */].Thousand || col1.typeName === __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__["a" /* FieldTypeName */].Money) {
            return col1.length <= col2.length && col1.qfws <= col2.qfws;
        }
        else if (col1.typeName === __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__["a" /* FieldTypeName */].Browser) {
            return col1.type === col2.type && col1.dbtype === col2.dbtype;
        }
        else if (col1.typeName === __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__["a" /* FieldTypeName */].DateTime) {
            return col1.type === col2.type;
        }
        return true;
    }
    else {
        return false;
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    canUndo: true,
    execute: function (context, options, isUndo) {
        context.suspendPaint();
        try {
            var sheet_1 = options.sheet, sheetName_1 = options.sheetName, sourceSheet = options.sourceSheet, cellRange = options.cellRange, table = options.table, dataSource = options.dataSource, backColumn_1 = options.backColumn, setChangedValue_1 = options.setChangedValue, sourceRange = options.sourceRange, value = options.value;
            var targetCells = toCells(__assign({}, cellRange, { sheet: sheet_1 }));
            if (isUndo) {
            }
            else {
                var startRow_1 = table.dataRange().row;
                var datas_1 = dataSource.getValue('datas');
                options.oldValue = targetCells.map(function (cell) { return cell.value(); });
                options.oldText = targetCells.map(function (cell) { return cell.text(); });
                if (sourceSheet && sourceRange) {
                    var sourceCells = toCells(__assign({}, sourceRange, { sheet: sheet_1, sourceSheet: sourceSheet }));
                    if (sourceCells.length === 1) { // 一个单元格时，所有目标单元格都要粘贴
                        var _a = sourceCells[0], row = _a.row, col = _a.col;
                        var dataIndex = row - startRow_1;
                        var sourceColumn_1 = backColumn_1[col];
                        if (dataIndex > -1 && dataIndex < datas_1.length) {
                            var sourceData = datas_1[dataIndex];
                            var newValue_1 = sourceData[sourceColumn_1.column];
                            var newValueSpan_1 = sourceData[sourceColumn_1.column + "span"];
                            targetCells.forEach(function (targetCell) {
                                var targetRow = targetCell.row, targetCol = targetCell.col;
                                var targetColumn = backColumn_1[targetCol];
                                if (targetColumn && targetColumn.editable === '1' && isSameTypeColumn(sourceColumn_1, targetColumn)) {
                                    var targetDataIndex = targetRow - startRow_1;
                                    if (targetDataIndex > -1 && targetDataIndex < datas_1.length) {
                                        var targetData = datas_1[targetDataIndex];
                                        var oldValueSpan = targetData[targetColumn.column + "span"];
                                        targetData[targetColumn.column] = newValue_1;
                                        targetData[targetColumn.column + "span"] = newValueSpan_1;
                                        setChangedValue_1(Object(__WEBPACK_IMPORTED_MODULE_0__ExcelStore__["c" /* getRandomId */])(targetData), targetColumn, { sheet: sheet_1, row: targetRow, col: targetCol, newValue: newValueSpan_1, oldValue: oldValueSpan, sheetName: sheetName_1, time: targetData["time"] });
                                    }
                                }
                            });
                        }
                    }
                    else if (sourceCells.length > 1) { // 复制多个单元格时， 粘贴到目标区域的对应单元格
                        var targetStartRow_1 = cellRange.row, targetStartCol_1 = cellRange.col;
                        var sourceStartRow_1 = sourceRange.row, sourceStartCol_1 = sourceRange.col, sourceRowCount = sourceRange.rowCount, sourceColCount = sourceRange.colCount;
                        var sourceMaxRow_1 = sourceStartRow_1 + sourceRowCount;
                        var sourceMaxCol_1 = sourceStartCol_1 + sourceColCount;
                        targetCells.forEach(function (targetCell) {
                            var targetRow = targetCell.row, targetCol = targetCell.col;
                            var sourceRow = targetRow - targetStartRow_1 + sourceStartRow_1;
                            var sourceCol = targetCol - targetStartCol_1 + sourceStartCol_1;
                            if (sourceRow < sourceMaxRow_1 && sourceCol <= sourceMaxCol_1) {
                                var sourceColumn = backColumn_1[sourceCol];
                                var targetColumn = backColumn_1[targetCol];
                                var sourceDataIndex = sourceRow - startRow_1;
                                var targetDataIndex = targetRow - startRow_1;
                                if (sourceDataIndex > -1
                                    && sourceDataIndex < datas_1.length
                                    && targetDataIndex > -1
                                    && targetDataIndex < datas_1.length
                                    && targetColumn.editable === '1'
                                    && isSameTypeColumn(sourceColumn, targetColumn)) {
                                    var sourceData = datas_1[sourceDataIndex];
                                    var targetData = datas_1[targetDataIndex];
                                    var newValue = sourceData[sourceColumn.column];
                                    var newValueSpan = sourceData[sourceColumn.column + "span"];
                                    var oldValue = targetData[targetColumn.column + "span"];
                                    targetData[targetColumn.column] = newValue;
                                    targetData[targetColumn.column + "span"] = newValueSpan;
                                    setChangedValue_1(Object(__WEBPACK_IMPORTED_MODULE_0__ExcelStore__["c" /* getRandomId */])(targetData), targetColumn, { sheet: sheet_1, row: targetRow, col: targetCol, newValue: newValueSpan, oldValue: oldValue, sheetName: sheetName_1, time: targetData["time"] });
                                }
                            }
                        });
                    }
                }
                else {
                    if (value) {
                        var valueTr = value.split('\r\n');
                        var values_1 = [];
                        valueTr.forEach(function (tr) {
                            var trValues = [];
                            tr.split('	').forEach(function (td) {
                                trValues.push(td);
                            });
                            values_1.push(trValues);
                        });
                        var dataStartRow_1 = table.dataRange().row;
                        var startRow_2 = cellRange.row, startCol_1 = cellRange.col;
                        var datas_2 = dataSource.getValue('datas');
                        targetCells.forEach(function (targetCell) {
                            var targetRow = targetCell.row, targetCol = targetCell.col;
                            var column = backColumn_1[targetCol];
                            var dataIndex = targetRow - dataStartRow_1;
                            if (column.editable === '1' && dataIndex > -1 && dataIndex < datas_2.length && column.typeName === __WEBPACK_IMPORTED_MODULE_1__celltypes_FieldCellType__["a" /* FieldTypeName */].Text) {
                                var newValue = (values_1[targetRow - startRow_2] || {})[targetCol - startCol_1] || '';
                                if (newValue && newValue.length > column.length) {
                                    return;
                                }
                                var data = datas_2[dataIndex];
                                var oldValue = data[column.column + "span"];
                                data[column.column] = newValue;
                                data[column.column + "span"] = JSON.stringify({ value: newValue });
                                setChangedValue_1(Object(__WEBPACK_IMPORTED_MODULE_0__ExcelStore__["c" /* getRandomId */])(data), column, { sheet: sheet_1, row: targetRow, col: targetCol, newValue: data[column.column + "span"], oldValue: oldValue, sheetName: sheetName_1, time: data["time"] });
                            }
                        });
                    }
                }
            }
        }
        catch (e) {
            if (!!(window.console && window.console.log)) {
                window.console.log(e);
            }
        }
        context.resumePaint();
    }
});


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExcelStore__ = __webpack_require__(39);

/* harmony default export */ __webpack_exports__["a"] = ({
    canUndo: true,
    execute: function (context, options, isUndo) {
        var sheetName = options.sheetName;
        var sheet = context.getSheetFromName(sheetName);
        var selections = sheet.getSelections();
        var store = __WEBPACK_IMPORTED_MODULE_0__ExcelStore__["a" /* StoreFuncs */].getInstance();
        var needSuspernded = !sheet.isPaintSuspended();
        if (needSuspernded) {
            sheet.suspendPaint();
        }
        if (store.editable && store.table && store.dataSource) {
            var datas_1 = store.dataSource.getValue('datas');
            if (isUndo) {
                var startRow_1 = store.table.dataRange().row;
                selections.forEach(function (selection) {
                    var row = selection.row, col = selection.col, rowCount = selection.rowCount, colCount = selection.colCount;
                    for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
                        var currentRow = row + rowIndex;
                        var dataIndex = currentRow - startRow_1;
                        var data = datas_1[dataIndex];
                        for (var colIndex = 0; colIndex < colCount; colIndex++) {
                            var currentCol = col + colIndex;
                            var column = store.backColumn[currentCol];
                            if (column.editable) {
                                var _a = options.oldDatas[currentRow + "." + currentCol], value = _a.value, valueSpan = _a.valueSpan;
                                sheet.setValue(currentRow, currentCol, valueSpan);
                                __WEBPACK_IMPORTED_MODULE_0__ExcelStore__["a" /* StoreFuncs */].changeValue({
                                    sheet: sheet,
                                    row: currentRow,
                                    col: currentCol,
                                    newValue: { value: value },
                                    oldValue: { value: data[column.column] },
                                    sheetName: sheetName,
                                    time: 1
                                });
                            }
                        }
                    }
                });
            }
            else {
                var startRow_2 = store.table.dataRange().row;
                options.oldDatas = {};
                selections.forEach(function (selection) {
                    var row = selection.row, col = selection.col, rowCount = selection.rowCount, colCount = selection.colCount;
                    for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
                        var currentRow = row + rowIndex;
                        var dataIndex = currentRow - startRow_2;
                        var data = datas_1[dataIndex];
                        for (var colIndex = 0; colIndex < colCount; colIndex++) {
                            var currentCol = col + colIndex;
                            var column = store.backColumn[currentCol];
                            if (column.editable && column.column != "id") {
                                options.oldDatas[currentRow + "." + currentCol] = {
                                    value: data[column.column],
                                    valueSpan: data[column.column + "span"]
                                };
                                sheet.setValue(currentRow, currentCol, '');
                                __WEBPACK_IMPORTED_MODULE_0__ExcelStore__["a" /* StoreFuncs */].changeValue({
                                    sheet: sheet,
                                    row: currentRow,
                                    col: currentCol,
                                    newValue: { value: "" },
                                    oldValue: { value: data[column.column] },
                                    sheetName: sheetName,
                                    time: 1
                                });
                            }
                        }
                    }
                });
            }
        }
        if (needSuspernded) {
            sheet.resumePaint();
        }
    }
});


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cubeUtil__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExcelStore__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = ({
    canUndo: true,
    execute: function (context, options, isUndo) {
        var sheetName = options.sheetName, activeRow = options.activeRow;
        var sheet = context.getSheetFromName(sheetName);
        var needSuspernded = !sheet.isPaintSuspended();
        if (needSuspernded) {
            sheet.suspendPaint();
        }
        if (isUndo) {
        }
        else {
            var store_1 = __WEBPACK_IMPORTED_MODULE_1__ExcelStore__["a" /* StoreFuncs */].getInstance();
            if (store_1.table && store_1.dataSource) {
                var startRow_1 = store_1.table.dataRange().row;
                var datas = store_1.dataSource.getValue('datas');
                var newDatas_1 = [];
                datas.forEach(function (data, index) {
                    if (startRow_1 + index === activeRow) {
                        var uuid = Object(__WEBPACK_IMPORTED_MODULE_0__cubeUtil__["generateUUID"])();
                        store_1.insertedRows.push(uuid);
                        newDatas_1.push({ randomFieldId: uuid });
                    }
                    newDatas_1.push(data);
                });
                store_1.dataSource.setValue('datas', newDatas_1);
                store_1.bingDatas();
            }
            if (needSuspernded) {
                sheet.resumePaint();
            }
        }
    }
});


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExcelStore__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_convert__ = __webpack_require__(167);



/* harmony default export */ __webpack_exports__["a"] = ({
    canUndo: true,
    execute: function (context, options, isUndo) {
        var selections = options.selections;
        var store = __WEBPACK_IMPORTED_MODULE_0__ExcelStore__["a" /* StoreFuncs */].getInstance();
        var datas = store.dataSource.getValue('datas');
        var rowData = [];
        for (var index = 0; index < selections.length; index++) {
            var selection = selections[index];
            var row = selection.row, rowCount = selection.rowCount;
            for (var j = 0; j < rowCount; j++) {
                var randomFieldId = datas[row + j].randomFieldId;
                if (randomFieldId.indexOf("-") < 0) {
                    continue;
                }
                store.deleteDatas.push(randomFieldId); //存放所有删除行的id
                rowData.push(row + j); //存放所有可删除的行                    
            }
        }
        if (rowData.length == 0) {
            __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error(Object(__WEBPACK_IMPORTED_MODULE_2__util_convert__["b" /* getLabel */])(510487, "只能删除插入的临时行"));
            return;
        }
        var num = 0;
        for (var index = 0; index < rowData.length; index++) {
            context.getActiveSheet().deleteRows(rowData[index] - num, 1);
            num++;
        }
        __WEBPACK_IMPORTED_MODULE_1_antd__["message"].info(Object(__WEBPACK_IMPORTED_MODULE_2__util_convert__["b" /* getLabel */])(510486, "已成功删除插入的临时行"));
        context.getActiveSheet().resumePaint();
    }
});


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var upSortPng = 'data:image/png;base64,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';
var downSortPng = 'data:image/png;base64,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';
var sortPng = 'data:image/png;base64,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';
var upSortimg = document.createElement('img');
upSortimg.src = upSortPng;
var downSortImg = document.createElement('img');
downSortImg.src = downSortPng;
var sortimg = document.createElement('img');
sortimg.src = sortPng;
/* harmony default export */ __webpack_exports__["a"] = (function (col, store) {
    var text = col.text, column = col.column;
    var Type = /** @class */ (function (_super) {
        __extends(Type, _super);
        function Type() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.filterDialogVisible = {};
            _this.filterInfo = {};
            _this.sortOrder = "ascend";
            _this.getImg = function (col) {
                var filterCheckedValue = store.filterCheckedValue;
                var info = filterCheckedValue[column];
                return info;
            };
            return _this;
        }
        Type.prototype.paint = function (ctx, value, x, y, w, h, style, context) {
            try {
                ctx.clearRect(x, y, w, h);
                //    const { col } = context;
                _super.prototype.paint.call(this, ctx, text, x, y, w, h, style, context);
                var width = 15;
                if (col["htmltype"] == 6 || (col["htmltype"] == 3 && col["type"] == '161' || col["type"] == '162')) {
                    return;
                } //附件、单选 多选除外
                //    ctx.drawImage(this.getImg(col), x + w - width - 3, y + (h - width) / 2, width, width); 下拉按钮
                if (store.sortKey) {
                    var sortKeys = store.sortKey.split('@');
                    if (sortKeys[0] == column) {
                        if (sortKeys[1] == 'ascend') {
                            ctx.drawImage(downSortImg, x + w - (2 * width) - 6, y + (h - width) / 2, width, width);
                        }
                        else if (sortKeys[1] == 'descend') {
                            ctx.drawImage(upSortimg, x + w - (2 * width) - 6, y + (h - width) / 2, width, width);
                        }
                    }
                    else {
                        ctx.drawImage(sortimg, x + w - (2 * width) - 6, y + (h - width) / 2, width, width);
                    }
                }
                else {
                    ctx.drawImage(sortimg, x + w - (2 * width) - 6, y + (h - width) / 2, width, width);
                }
            }
            catch (e) {
                console.log(e);
            }
        };
        Type.prototype.getAutoFitWidth = function (value, a, cellStyle, zoomFactor, context) {
            return _super.prototype.getAutoFitWidth.call(this, text, text, cellStyle, zoomFactor, context) + 20;
        };
        Type.prototype.processMouseUp = function (hitInfo) {
            if (col["htmltype"] == 6 || (col["htmltype"] == 3 && col["type"] == '161' || col["type"] == '162')) {
                return true;
            }
            if (hitInfo.sortButton) {
                store.cilckSort(column);
            }
            return true;
        };
        Type.prototype.processMouseMove = function (hitInfo) {
            var sortButton = hitInfo.sortButton;
            var sheet = hitInfo.sheet;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";
            var canvas = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + canvasId)[0];
            if (sortButton) {
                canvas.title = col.title;
                canvas.style.cursor = 'pointer';
                canvas.title = '点击排序';
                return true;
            }
            else {
                canvas.title = col.title;
                canvas.style.cursor = 'default';
                canvas.title = '';
                return false;
            }
        };
        Type.prototype.processMouseLeave = function (hitInfo) {
            var sheet = hitInfo.sheet;
            var div = sheet.getParent().getHost();
            var canvasId = div.id + "vp_vp";
            var canvas = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#" + canvasId)[0];
            canvas.title = col.title ? col.title : '';
            canvas.style.cursor = 'default';
            return true;
        };
        Type.prototype.getHitInfo = function (x, y, cellStyle, cellRect, context) {
            var info = __assign({ x: x,
                y: y,
                cellStyle: cellStyle,
                cellRect: cellRect }, context, { 
                //    filterButton: x > cellRect.x + cellRect.width - 18,
                sortButton: x < cellRect.x + cellRect.width - 20 && x > cellRect.x + cellRect.width - 40 });
            return info;
        };
        return Type;
    }(GC.Spread.Sheets.CellTypes.Base));
    return new Type();
});


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTextLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFloatQfws; });
/* unused harmony export getFloatLength */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRealLength; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__ = __webpack_require__(50);

var getTextLength = function (d) {
    var dbtype = d.dbtype || '0';
    if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Text) {
        return parseInt(dbtype.substring(dbtype.indexOf('(') + 1));
    }
    else if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Int) {
        return 11;
    }
    else if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Float) {
        return parseInt(dbtype.substring(dbtype.indexOf('(') + 1, dbtype.indexOf(','))) - parseInt(dbtype.substring(dbtype.indexOf(',') + 1));
        ;
    }
    else if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Thousand) {
        var length = parseInt(dbtype.substring(dbtype.indexOf('(') + 1)) - 3;
        return length - parseInt('' + length / 4);
    }
    else if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Money) {
        return parseInt(dbtype.substring(dbtype.indexOf('(') + 1, dbtype.indexOf(','))) - parseInt(dbtype.substring(dbtype.indexOf(',') + 1));
        ;
    }
    return 0;
};
var getFloatQfws = function (d) {
    var dbtype = d.dbtype || '0';
    if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Text) {
        return 0;
    }
    else if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Int) {
        return 0;
    }
    else if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Float) {
        return parseInt(dbtype.substring(dbtype.indexOf(',') + 1));
    }
    else if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Thousand) {
        return 2;
    }
    else if (d.typeName === __WEBPACK_IMPORTED_MODULE_0__celltypes_FieldCellType__["a" /* FieldTypeName */].Money) {
        return parseInt(dbtype.substring(dbtype.indexOf(',') + 1));
    }
    return 0;
};
var getFloatLength = function (dbtype) {
    return parseInt(dbtype.substring(dbtype.indexOf('(') + 1, dbtype.indexOf(',')));
};
var getRealLength = function (str) {
    ///<summary>获得字符串实际长度，中文2，英文1</summary>
    ///<param name="str">要获得长度的字符串</param>
    var realLength = 0, len = str.length, charCode = -1;
    for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128)
            realLength += 1;
        else
            realLength += 2;
    }
    return realLength;
};


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_list_utils__ = __webpack_require__(71);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var VerticalListStore = /** @class */ (function () {
    function VerticalListStore(search) {
        var _this = this;
        this.current = 1;
        this.pageSize = 10;
        this.allDatas = [];
        this.loading = false;
        this.hasMore = true; //是否有更多
        this.rowCheckKey = [];
        this.selectValue = '';
        this.newDataBacks = function () {
            var currentDatas = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.Search.newTable.datas);
            _this.allDatas = currentDatas;
            _this.loading = false;
            if (currentDatas.length > 0) {
                Object(__WEBPACK_IMPORTED_MODULE_2__components_list_utils__["e" /* getHeight */])(_this.Search);
            }
        };
        this.dataBacks = function () {
            var currentDatas = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.Search.newTable.datas);
            _this.allDatas = _this.allDatas.concat(currentDatas);
            _this.loading = false;
        };
        this.loadMorePage = function (current, pageSize) {
            if (current === void 0) { current = _this.current; }
            if (pageSize === void 0) { pageSize = _this.pageSize; }
            var _a = _this.Search, sessionKey = _a.sessionKey, newTable = _a.newTable;
            _this.current = current;
            newTable.getDatas(sessionKey, current, pageSize, {}, _this.dataBacks);
        };
        this.updateLikeOrDis = function (billid, isshowlistspan, likesinfospan) {
            if (isshowlistspan === void 0) { isshowlistspan = []; }
            _this.allDatas = _this.allDatas.map(function (item) {
                if (item.randomFieldId == billid) {
                    if (isshowlistspan.length > 0) {
                        return __assign({}, item, { likesinfospan: likesinfospan, isshowlistspan: JSON.stringify(isshowlistspan) });
                    }
                    else {
                        return __assign({}, item, { likesinfospan: likesinfospan });
                    }
                }
                return __assign({}, item);
            });
        };
        this.selectRowKeyAll = function (isClear) {
            var selectStr = '';
            if (isClear) {
                _this.Search.selectRowkeys = [];
            }
            else {
                var rowkeysarr_1 = [];
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(_this.allDatas, function (item) {
                    rowkeysarr_1.push(_this.getRowKey(item));
                });
                _this.Search.update({ selectRowkeys: rowkeysarr_1 });
                selectStr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(rowkeysarr_1.map(function (d) { return d.split('_')[0]; })).join(',');
            }
            _this.selectValue = selectStr;
        };
        this.getRowKey = function (data) {
            return data.randomFieldId ? (data.randomFieldSubKeyd_id ?
                data.randomFieldId + '_' + data.randomFieldSubKeyd_id : data.randomFieldId) : '';
        };
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
        this.clear = function () {
            _this.current = 1;
            _this.allDatas = [];
            _this.rowCheckKey = [];
            _this.selectValue = '';
            _this.hasMore = true;
        };
        this.Search = search;
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], VerticalListStore.prototype, "current", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], VerticalListStore.prototype, "pageSize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], VerticalListStore.prototype, "allDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], VerticalListStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], VerticalListStore.prototype, "hasMore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], VerticalListStore.prototype, "rowCheckKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], VerticalListStore.prototype, "selectValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], VerticalListStore.prototype, "newDataBacks", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], VerticalListStore.prototype, "dataBacks", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], VerticalListStore.prototype, "loadMorePage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], VerticalListStore.prototype, "updateLikeOrDis", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], VerticalListStore.prototype, "selectRowKeyAll", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], VerticalListStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], VerticalListStore.prototype, "clear", void 0);
    return VerticalListStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (VerticalListStore);


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_cell__ = __webpack_require__(560);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var LittleCard = /** @class */ (function (_super) {
    __extends(LittleCard, _super);
    function LittleCard(props) {
        var _this = _super.call(this, props) || this;
        _this.changeCurrentEditFieldid = function (fieldid) {
            _this.setState({ currentEditFieldid: fieldid });
        };
        _this.state = { currentEditFieldid: '' };
        return _this;
    }
    LittleCard.prototype.render = function () {
        var _this = this;
        var _a = this.props, datas = _a.datas, onChange = _a.onChange, canEdit = _a.canEdit, width = _a.width;
        var style = {};
        if (width) {
            style = { width: width };
        }
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "cube_littleCard", onClick: function (e) {
                _this.changeCurrentEditFieldid('');
            } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: style }, datas.map(function (row, index) {
                var spanNum = Math.round(24 / row.length);
                var remainNum = 24 - spanNum * row.length; //24栅格剩余几个未用
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Row"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Row@fzqb9d@" + index, gutter: 10, style: { height: '50px', paddingTop: '10px' } }, row.map(function (col, index) {
                    var num = spanNum;
                    if (index < remainNum) { //剩余的栅格给前面的列
                        num += 1;
                    }
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Col"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Col@kcx2m4@" + index, span: num },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, col.field &&
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__table_cell__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_TableCell@apd214@" + index, style: col.style, changeCurrentEditFieldid: _this.changeCurrentEditFieldid, currentEditFieldid: _this.state.currentEditFieldid, canEdit: canEdit, onChange: onChange, field: col.field })));
                }));
            })));
    };
    LittleCard = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx_react__["observer"]
    ], LittleCard);
    return LittleCard;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (LittleCard);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputNumber__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Checkbox__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Browser__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WeaDatePicker__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WeaTimePicker__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WeaTextarea__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Upload__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WeaDateTimePicker__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};













var TableCell = /** @class */ (function (_super) {
    __extends(TableCell, _super);
    function TableCell(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCom = function (viewAttr) {
            var field = _this.props.field;
            var fieldprop = field.prop;
            var value = fieldprop.value, fieldhtmltype = fieldprop.fieldhtmltype, type = fieldprop.type, qfws = fieldprop.qfws, browserProps = fieldprop.browserProps;
            var detailtype = '1';
            var reg = new RegExp('');
            var otherParams = {};
            var conditionType = 'input';
            var desensitization = __WEBPACK_IMPORTED_MODULE_12_ecCom__["WeaTools"].EncryBase.desensitization;
            if (fieldhtmltype == '1') { //单行文本
                if (type == '2') { //整数
                    reg = /^-?\d+$/;
                    detailtype = '2';
                    otherParams = { max: 2147483647, min: -2147483648 };
                }
                else if (type == '3' || type == '4' || type == '5') { //浮点数 金额转换 金额千分位
                    reg = /^(-?\d+)(.[0-9]{0,2})?$/;
                    switch (qfws) {
                        case 1:
                            reg = /^(-?\d+)(.[0-9]{0,1})?$/;
                            break;
                        case 2:
                            reg = /^(-?\d+)(.[0-9]{0,2})?$/;
                            break;
                        case 3:
                            reg = /^(-?\d+)(.[0-9]{0,3})?$/;
                            break;
                        case 4:
                            reg = /^(-?\d+)(.[0-9]{0,4})?$/;
                            break;
                        case 5:
                            reg = /^(-?\d+)(.[0-9]{0,5})?$/;
                            break;
                        case 6:
                            reg = /^(-?\d+)(.[0-9]{0,6})?$/;
                            break;
                        case 7:
                            reg = /^(-?\d+)(.[0-9]{0,7})?$/;
                            break;
                        case 8:
                            reg = /^(-?\d+)(.[0-9]{0,8})?$/;
                            break;
                        case 9:
                            reg = /^(-?\d+)(.[0-9]{0,9})?$/;
                            break;
                        case 10:
                            reg = /^(-?\d+)(.[0-9]{0,10})?$/;
                            break;
                        case 11:
                            reg = /^(-?\d+)(.[0-9]{0,11})?$/;
                            break;
                        case 12:
                            reg = /^(-?\d+)(.[0-9]{0,12})?$/;
                            break;
                        case 13:
                            reg = /^(-?\d+)(.[0-9]{0,13})?$/;
                            break;
                        case 14:
                            reg = /^(-?\d+)(.[0-9]{0,14})?$/;
                            break;
                        case 15:
                            reg = /^(-?\d+)(.[0-9]{0,15})?$/;
                            break;
                    }
                    detailtype = '2';
                    otherParams = { max: 999999999999.999999999999, min: -999999999999.999999999999 };
                }
            }
            else if (fieldhtmltype == '5') { //选择框
                conditionType = 'select';
                detailtype = type;
            }
            else if (fieldhtmltype == '3') { //浏览按钮
                if (type == '2') {
                    conditionType = 'date';
                }
                else if (type == '19') {
                    conditionType = 'time';
                }
                else if (type == '290') {
                    conditionType = 'datetime';
                }
                else if (type == '402' || type == '403') {
                    conditionType = 'yearmonth';
                }
                else {
                    conditionType = 'browser';
                    if (type && (type == '4' || type == '57' || type == '164' || type == '169' || type == '194' || type == '167' || type == '170' || type == '168')) { //部门，多部门，分部，多分部，单点分权，分权单部门，分权多分部，分权多部门
                        browserProps.dataParams = __assign({}, browserProps.dataParams, { fromModule: "model" });
                        browserProps.destDataParams = __assign({}, browserProps.dataParams, { fromModule: "model" });
                    }
                }
            }
            else if (fieldhtmltype == '2') { //多行文本
                if (type == '1') {
                    conditionType = 'textarea';
                }
                else if (type == "2") {
                    conditionType = 'htmlinput';
                }
            }
            else if (fieldhtmltype == '4') { //Check框
                conditionType = 'checkbox';
            }
            else if (fieldhtmltype == '6') {
                conditionType = 'weaupload';
            }
            if (conditionType == 'htmlinput') {
                return desensitization(value) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_ecCom__["WeaInputEncrypt"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInputEncrypt@ijkzzx", type: "TEXTAREA", value: value, viewAttr: viewAttr, onBlur: _this.onBlur }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: value } });
            }
            else if (conditionType == 'input') { //文本框
                if (desensitization(value)) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@gilg5x", value: value, viewAttr: viewAttr, onBlur: _this.onBlur });
                }
                else {
                    if (detailtype == '2' || detailtype == '3') { //整数
                        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InputNumber__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_InputNumber@fx0ajd", reg: reg, value: value, min: otherParams.min, max: otherParams.max, qfws: qfws, onBlur: _this.onBlur, fieldhtmltype: fieldhtmltype, fieldtype: type, viewAttr: viewAttr }));
                    }
                    else {
                        if (fieldhtmltype == '7') {
                            viewAttr = '1';
                            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Input__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Input@tdx1pp", viewAttr: viewAttr, value: value, onBlur: _this.onBlur }));
                        }
                        else {
                            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Input__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Input@tdx1pp", viewAttr: viewAttr, value: value, onBlur: _this.onBlur }));
                        }
                    }
                }
            }
            else if (conditionType == 'checkbox') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Checkbox__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Checkbox@b505qv", viewAttr: viewAttr, value: value, onChange: _this.onChange }));
            }
            else if (conditionType == 'date') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__WeaDatePicker__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDatePicker@a2j3af", viewAttr: viewAttr, value: value, onChange: _this.onChange }));
            }
            else if (conditionType == 'textarea') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__WeaTextarea__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTextarea@rkeil0", viewAttr: viewAttr, value: value, onBlur: _this.onBlur }));
            }
            else if (conditionType == 'time') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__WeaTimePicker__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTimePicker@iasyle", viewAttr: viewAttr, value: value, onChange: _this.onChange }));
            }
            else if (conditionType == 'datetime') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__WeaDateTimePicker__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDateTimePicker@wtys1t", viewAttr: viewAttr, value: value, onChange: _this.onChange }));
            }
            else if (conditionType == 'yearmonth') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__WeaDatePicker__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDateTimePicker@wtye3t", viewAttr: viewAttr, value: value, type: type, onChange: _this.onChange }));
            }
            else if (conditionType == 'select') { //选择框字段
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Select@wjbbup", detailtype: detailtype, viewAttr: viewAttr, options: fieldprop.options ? fieldprop.options.slice() : [], onChange: _this.onChange, value: value }));
            }
            else if (conditionType == 'browser') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Browser__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Browser@vo49bv", viewAttr: viewAttr, value: value, valueSpan: "", browserConditionParam: fieldprop.browserProps, onChange: _this.browserChange }));
            }
            else if (conditionType == 'weaupload') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Upload__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Upload@3qshnf", viewAttr: viewAttr, key: field.name, fieldtype: type, uploadMap: fieldprop.uploadMap, onChange: _this.onChange }));
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Input__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Input@vbspd1", viewAttr: viewAttr, value: value, onBlur: _this.onBlur }));
        };
        _this.browserChange = function (ids, names, objs) {
            var field = _this.props.field;
            var fieldprop = field.prop;
            fieldprop.browserProps.replaceDatas = objs.map(function (item) {
                return { id: item.id, name: item.name };
            });
            _this.onChange(ids, names);
        };
        _this.onBlur = function (ids) {
            var field = _this.props.field;
            var fieldprop = field.prop;
            var value = fieldprop.value;
            if (ids != value) {
                fieldprop.value = ids;
                _this.props.onChange(field.id, ids);
            }
            _this.props.changeCurrentEditFieldid('');
        };
        _this.onChange = function (ids, names) {
            var field = _this.props.field;
            var fieldprop = field.prop;
            var fieldhtmltype = fieldprop.fieldhtmltype, type = fieldprop.type;
            if (ids instanceof Array) {
                ids = ids.join(',');
            }
            fieldprop.value = ids;
            _this.props.onChange(field.id, ids);
            if (fieldhtmltype == '5' && type == '2') {
                return; //如果是复选框选择一个值后先不恢复只读状态
            }
            _this.props.changeCurrentEditFieldid('');
        };
        _this.editClick = function (e) {
            var _a = _this.props, field = _a.field, canEdit = _a.canEdit, changeCurrentEditFieldid = _a.changeCurrentEditFieldid;
            if (canEdit) {
                changeCurrentEditFieldid(field.id);
            }
            var event = e || window.event;
            event.stopPropagation();
        };
        return _this;
    }
    TableCell.prototype.render = function () {
        var _a = this.props, field = _a.field, canEdit = _a.canEdit, style = _a.style, currentEditFieldid = _a.currentEditFieldid;
        var prop = field.prop;
        var viewAttr = currentEditFieldid == field.id ? '2' : '1';
        var customStyle = { overflow: 'hidden' };
        if (viewAttr == '2') {
            customStyle = { overflow: 'inherit' };
        }
        else {
            customStyle = { overflow: 'hidden' };
        }
        var canNotEdit = false;
        if (prop) {
            var fieldhtmltype = prop.fieldhtmltype, type = prop.type;
            if (!fieldhtmltype || !type || fieldhtmltype == '2' && type == '2') {
                canNotEdit = true;
            }
            if (fieldhtmltype == '7') {
                canNotEdit = true;
            }
        }
        else {
            canNotEdit = true;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: __assign({}, style, { display: 'flex', height: '40px' }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left', lineHeight: '30px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' } }, field.desc ? field.desc + " : " : ""),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "fieldvalueCell", style: __assign({ lineHeight: '30px', textAlign: 'left', paddingLeft: '5px', height: '30px', minWidth: '100px' }, customStyle), onClick: this.editClick },
                prop ? this.renderCom(viewAttr) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: field.content } }),
                viewAttr == '1' && canEdit && !canNotEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { marginLeft: '5px' }, className: "icon-coms-edit" })));
    };
    TableCell = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TableCell);
    return TableCell;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TableCell);


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var onBlur = props.onBlur, viewAttr = props.viewAttr;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaInput"], { ecId: (props && props.ecId || '') + "_WeaInput@wpjhc6", viewAttr: viewAttr, value: props.value || "", onBlur: onBlur })));
}));


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IntegerInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_modeUtil__ = __webpack_require__(66);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _this = this;





var IntegerInput = /** @class */ (function (_super) {
    __extends(IntegerInput, _super);
    function IntegerInput(props) {
        var _this = _super.call(this, props) || this;
        _this.formatter = function (fieldhtmltype, fieldtype, val) {
            var _a = _this.props.qfws, qfws = _a === void 0 ? 2 : _a;
            var _value = val ? "" + val : "";
            if (_value.endsWith(".")) {
                _value += "0";
            }
            _value = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(_value).length > 0 ? _value.replace(/\,/g, '') : '';
            if (fieldhtmltype == '1' && fieldtype == '5') {
                return Object(__WEBPACK_IMPORTED_MODULE_4__util_modeUtil__["a" /* formatFloatValue */])(_value, qfws, true);
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_4__util_modeUtil__["a" /* formatFloatValue */])(_value, qfws, false);
            }
        };
        _this.onChange = function (e) {
            var value = e.target.value;
            var _a = _this.props, reg = _a.reg, max = _a.max, min = _a.min;
            if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                var intValue = (value === '' || value === '-') ? value : value;
                if (max && intValue > max || min && intValue < min)
                    return;
                _this.setState({ value: intValue });
            }
        };
        _this.onBlur = function (e) {
            var value = e.target.value;
            var _a = _this.props, reg = _a.reg, onBlur = _a.onBlur;
            var _b = _this.props, fieldhtmltype = _b.fieldhtmltype, fieldtype = _b.fieldtype;
            if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                var intValue = (value === '' || value === '-') ? value : value;
                intValue = _this.formatter(fieldhtmltype, fieldtype, intValue);
                onBlur(intValue);
            }
        };
        _this.state = { value: _this.props.value };
        return _this;
    }
    IntegerInput.prototype.componentWillReceiveProps = function (nextProps) {
        this.state = { value: nextProps.value };
    };
    IntegerInput.prototype.render = function () {
        var viewAttr = this.props.viewAttr;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } }, viewAttr == '2' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Input"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Input@izko54" }, this.props, { value: this.state.value, onBlur: this.onBlur, onChange: this.onChange })) : this.state.value);
    };
    return IntegerInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntegerInput, __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_IntegerInput@nqru2s" }, props)));
}));


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Main.prototype.render = function () {
        var props = this.props;
        var value = props.value, viewAttr = props.viewAttr;
        var options = props.options || [];
        var valueSpans = options.filter(function (item) { return (',' + value + ',').indexOf(',' + item.key + ',') > -1; });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } }, viewAttr == '2' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@9mrb4k" }, props, { viewAttr: viewAttr, detailtype: props.detailtype, options: options, value: value, onChange: props.onChange, supportCancel: true })) : valueSpans.map(function (item, index) {
            var returnStr = item.showname;
            if (index < (valueSpans.length - 1)) {
                returnStr += ',';
            }
            return returnStr;
        })));
    };
    Main = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Main);
    return Main;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Main);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var CheckboxCom = /** @class */ (function (_super) {
    __extends(CheckboxCom, _super);
    function CheckboxCom(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (v) {
            _this.props.onChange(v);
        };
        return _this;
    }
    CheckboxCom.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaCheckbox"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaCheckbox@4fzla8" }, this.props, { checked: this.props.value == '1', onChange: this.onChange }))));
    };
    CheckboxCom = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], CheckboxCom);
    return CheckboxCom;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CheckboxCom);


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Browser = /** @class */ (function (_super) {
    __extends(Browser, _super);
    function Browser(props) {
        return _super.call(this, props) || this;
    }
    Browser.prototype.render = function () {
        var _a = this.props, browserConditionParam = _a.browserConditionParam, onChange = _a.onChange, viewAttr = _a.viewAttr;
        var browserProps = browserConditionParam || {};
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@has5mp" }, browserProps, { viewAttr: viewAttr, onChange: onChange }))));
    };
    Browser = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Browser);
    return Browser;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Browser);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var value = props.value, onChange = props.onChange, viewAttr = props.viewAttr, type = props.type;
    if (type == '402' || type == '403') {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDatePicker"], { ecId: (props && props.ecId || '') + "_WeaDatePicker@wxurjl", noInput: true, value: value, viewAttr: viewAttr, format: type == '402' ? 'YYYY' : 'YYYY-MM', onChange: onChange })));
    }
    else {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDatePicker"], { ecId: (props && props.ecId || '') + "_WeaDatePicker@wxurjl", noInput: true, value: value, viewAttr: viewAttr, onChange: onChange })));
    }
}));


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var onChange = props.onChange, value = props.value, viewAttr = props.viewAttr;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTimePicker"], { ecId: (props && props.ecId || '') + "_WeaTimePicker@1rsm8z", noInput: true, value: value, viewAttr: viewAttr, onChange: onChange })));
}));


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var value = props.value, onBlur = props.onBlur, viewAttr = props.viewAttr;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTextarea"], { ecId: (props && props.ecId || '') + "_WeaTextarea@ngj4uq", value: value, viewAttr: viewAttr, minRows: 2, maxRows: 10, onBlur: onBlur })));
}));


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var Upload = /** @class */ (function (_super) {
    __extends(Upload, _super);
    function Upload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Upload.prototype.render = function () {
        var _a = this.props, uploadMap = _a.uploadMap, fieldtype = _a.fieldtype, key = _a.key, viewAttr = _a.viewAttr;
        var main;
        var sub;
        var sec;
        var categoryStr;
        var uploadUrl;
        var maxUploadSize;
        var mes;
        var baseProps = {};
        /**
                categoryType  0:固定目录   1：选择目录    9：默认设置
                fileFormat   文档限制格式
        */
        if (!uploadMap.categoryType || uploadMap.categoryType == "") {
            mes = getLabel(388817, "附件上传目录未设置!");
        }
        else if (uploadMap.categoryType == '1') { //选择目录
            mes = getLabel(500335, "附件上传目录为选择目录，不支持批量操作") + "!";
        }
        else {
            main = uploadMap.mainCategory;
            sub = uploadMap.subCategory;
            sec = uploadMap.secCategory;
            if ((uploadMap.categoryType == '9' && main <= 0 && sub <= 0 && sec <= 0) || (uploadMap.categoryType == '0' && main <= 0 && sub <= 0 && sec <= 0)) { //没有设置目录
                mes = getLabel(388817, "附件上传目录未设置!");
            }
            else {
                categoryStr = main + "," + sub + "," + sec;
                uploadUrl = "/api/formmode/card/docUpload?detailtype=" + fieldtype + "&category=" + categoryStr + "&mainId=" + main + "&subId=" + sub + "&secId=" + sec;
                maxUploadSize = uploadMap.maxUploadSize;
                baseProps.showBatchLoad = false;
                baseProps.showClearAll = false;
                baseProps.uploadUrl = uploadUrl;
                baseProps.maxUploadSize = maxUploadSize;
                baseProps.category = { categoryType: uploadMap.categoryType, mainCategory: main, maxUploadSize: maxUploadSize, secCategory: sec, subCategory: sub };
                baseProps.datas = uploadMap.uploadData.filedatas;
                baseProps.btnSize = "small";
                baseProps.autoUpload = "true";
                baseProps.listType = fieldtype == '2' ? "img" : "list";
                baseProps.limitType = fieldtype == "2" ? "jpg,jpeg,png,gif,bmp" : uploadMap.fileFormat === "0" ? "" : uploadMap.fileFormat;
                baseProps.uploadId = key;
                baseProps.display = true;
            }
        }
        baseProps.errorMsg = mes;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaUpload"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaUpload@icgqh1" }, baseProps, { viewAttr: parseInt(viewAttr), onChange: this.props.onChange }))));
    };
    Upload = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Upload);
    return Upload;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Upload);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var value = props.value, onChange = props.onChange, viewAttr = props.viewAttr;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { float: 'left' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDatePicker"], { ecId: (props && props.ecId || '') + "_WeaDatePicker@znt133", noInput: true, showTime: true, viewAttr: viewAttr, format: "yyyy-MM-dd HH:mm", value: value, onChange: onChange })));
}));


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var TreeBaseStore = /** @class */ (function () {
    function TreeBaseStore() {
        var _this = this;
        this.treeName = '';
        this.treeRemark = '';
        this.rootName = '';
        this.rootIcon = '';
        this.defaultAdress = '';
        this.expandFirstNode = 0;
        this.rightLoading = true;
        this.datas = [];
        this.urlMap = {};
        this.isInit = false;
        this.hasQuickSearch = false;
        this.expandKeys = [];
        this.params = {};
        this.query = {};
        this.isCube = false;
        this.isCard = false;
        this.isSearch = false;
        this.isTree = false;
        this.isReply = false;
        this.windowTitle = '';
        this.isInTree = false;
        this.combintreeway = '0';
        this.combintree = [];
        this.currentTree = '';
        this.displaywidth = 310;
        this.isRefreshTree = '0';
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
        this.updateTreeDatas = function (_a, datas) {
            var pid = _a.pid;
            _this.datas = _this.updateChildren(pid, _this.datas, datas);
        };
        this.addParentId2Node = function (pids, datas) {
            return datas.map(function (d) {
                return __assign({}, d, { pids: pids });
            });
        };
        this.updateChildren = function (pid, datas, childs) {
            return datas.map(function (d) {
                var _d = __assign({}, d);
                if (d.domid == pid) {
                    _d.childs = _this.mergeChildren(d.childs, childs);
                }
                else {
                    if (d.childs) {
                        _d.childs = _this.updateChildren(pid, d.childs, childs);
                    }
                }
                return _d;
            });
        };
        this.mergeChildren = function (_childs, childs) {
            if (!_childs || _childs.length == 0) {
                return childs;
            }
            if (!childs || childs.length == 0) {
                return _childs;
            }
            return childs.map(function (c) {
                var newC = __assign({}, c);
                var index = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(_childs, function (_c) { return _c.domid == c.domid; });
                if (index >= 0) {
                    newC.childs = _this.mergeChildren(_childs[index].childs, newC.childs);
                }
                return newC;
            });
        };
        this.clear = function () {
            _this.expandKeys = [];
            _this.treeName = '';
            _this.treeRemark = '';
            _this.rootName = '';
            _this.rootIcon = '';
            _this.defaultAdress = '';
            _this.expandFirstNode = 0;
            _this.datas = [];
            _this.urlMap = {};
            _this.isInit = false;
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "treeName", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "treeRemark", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "rootName", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "rootIcon", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "defaultAdress", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "expandFirstNode", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "rightLoading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "datas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "urlMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "isInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "hasQuickSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "expandKeys", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "query", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "isCube", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "isCard", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "isSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "isTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "isReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "isInTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "combintreeway", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "combintree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "currentTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "defaulthideleft", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TreeBaseStore.prototype, "displaywidth", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TreeBaseStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TreeBaseStore.prototype, "updateTreeDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TreeBaseStore.prototype, "addParentId2Node", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TreeBaseStore.prototype, "updateChildren", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TreeBaseStore.prototype, "clear", void 0);
    return TreeBaseStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (TreeBaseStore);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export url */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTreeDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTreeHref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return quickSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);

var url = '/api/cube/tree';
var initTree = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/init", "get", params);
};
var getTreeDatas = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/datas", "get", params);
};
var getTreeHref = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/href", "get", params);
};
var quickSearch = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/quickSearch", "get", params);
};


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var BatchStore = /** @class */ (function () {
    function BatchStore() {
        var _this = this;
        this.html = [];
        this.rows = 0;
        this.cols = 0;
        this.levelspacing = 0;
        this.verticalspacing = 0;
        this.loading = true;
        this.CodeLeft = '';
        this.CodeRight = '';
        this.postion = '';
        this.windowTitle = '';
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
        this.updateParams = function (params) {
            var temp = !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.params), params);
            _this.params = params;
            if (temp) {
                _this.getCode(params);
            }
        };
        this.getCode = function (_a) {
            var guid = _a.guid, params = __rest(_a, ["guid"]);
            _this.interface = { barCode: __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].getBarCode, qrCode: __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].getQrCode }[guid];
            _this.interface(params).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, error = _a.error, html = _a.html, rows = _a.rows, cols = _a.cols, levelspacing = _a.levelspacing, verticalspacing = _a.verticalspacing, postion = _a.postion, CodeLeft = _a.CodeLeft, CodeRight = _a.CodeRight, windowTitle = _a.windowTitle;
                if (status == '1') {
                    _this.html = html;
                    _this.rows = rows;
                    _this.cols = cols;
                    _this.levelspacing = levelspacing;
                    _this.verticalspacing = verticalspacing;
                    _this.CodeLeft = CodeLeft;
                    _this.CodeRight = CodeRight;
                    _this.postion = postion;
                    _this.windowTitle = windowTitle;
                    _this.loading = false;
                    _this.autoPrint();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        this.autoPrint = function () {
            if (_this.params && _this.params.from && _this.params.from == "card") {
                setTimeout(function () {
                    window.print();
                }, 300);
            }
        };
        this.clearState = function () {
            _this.html = [];
            _this.rows = 0;
            _this.cols = 0;
            _this.levelspacing = 0;
            _this.verticalspacing = 0;
            _this.loading = false;
            _this.params = {};
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "html", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "rows", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "cols", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "levelspacing", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "verticalspacing", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "CodeLeft", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "CodeRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "postion", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchStore.prototype, "getCode", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchStore.prototype, "autoPrint", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchStore.prototype, "clearState", void 0);
    return BatchStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (BatchStore);


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



// export interface MapStoreProps {
//     update: Function;
//     getTitles: Function;
//     titles: string[];
//     params: any;
//     query: any;
// }
// export default class MapStore implements MapStoreProps {
var MapStore = /** @class */ (function () {
    function MapStore() {
        var _this = this;
        this.titles = [];
        this.query = {};
        this.params = {};
        // @observable baseParams = {};
        this.updateParams = function (params) {
            _this.query = { customid: params.customid, billids: params.billids };
        };
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
        this.getTitles = function () {
            //this.titles= ["上海泛微软件大厦"];
            __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].getMapTitles(__assign({}, _this.query)).then(function (_a) {
                var status = _a.status, error = _a.error, titles = _a.titles;
                if (status == '1') {
                    _this.titles = titles;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
            });
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MapStore.prototype, "titles", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MapStore.prototype, "query", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MapStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "getTitles", void 0);
    return MapStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (MapStore);


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

//import { WeaLocaleProvider } from "ecCom";
// import { message} from 'antd';
// import API from '../../apis';
//const getLabel = WeaLocaleProvider.getLabel;
/**
 * 批量打印
 */
var BatchPrintStore = /** @class */ (function () {
    function BatchPrintStore() {
        this.modeid = "";
        this.formid = "";
        this.billid = "";
        this.search = "";
        this.customId = "";
        //该批量打印store暂时不用。
        this.batchPrint = function () {
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchPrintStore.prototype, "modeid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchPrintStore.prototype, "formid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchPrintStore.prototype, "billid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchPrintStore.prototype, "search", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchPrintStore.prototype, "customId", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchPrintStore.prototype, "printMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchPrintStore.prototype, "batchPrint", void 0);
    return BatchPrintStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (BatchPrintStore);


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplyAddStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;

var ReplyAddStore = /** @class */ (function () {
    function ReplyAddStore() {
        var _this = this;
        this.visible = false;
        this.loading = false;
        this.contentid = '';
        this.content = '&#8203;';
        this.optdesc = '';
        this.maincategory = '';
        this.subcategory = '';
        this.seccategory = '';
        this.replyShowType = 'new';
        this.popup = false;
        this.isInitPopup = false;
        this.popupOffset = {
            left: 0, top: 0
        };
        this.popupArrowPostion = false;
        this.atInfo = {};
        this.isdefault = true;
        this.showbuttons = {};
        this.secretLevel = '4';
        this.src = 'submit';
        this.billid = '';
        this.type = '1';
        this.iscreate = '1';
        this.isEditOpt = '0';
        this.temp_Quotesid = '';
        this.temp_CommentTopid = '';
        this.temp_Commentid = '';
        this.temp_CommentUsersid = '';
        this.okClickType = ''; //当为评论和引用时，点击提交需要把滚动条滚动到最后,点击按钮时才记录类型，okClickType=replyShowType='new' 或者'quote'
        this.callSubmit = function () { };
        this.initReplyAddStore = function (props) {
            _this.update(props);
        };
        this.setAtInfo = function (k, v, params) {
            var key = "cube_at_" + params.modeId + "_" + params.billid;
            _this.atInfo[key + "_" + k] = v;
        };
        this.onCancel = function () {
            _this.visible = false;
            // this.content = '&#8203;';
        };
        this.onPopupCancel = function () {
            _this.popup = false;
        };
        this.onOk = function () {
            _this.okClickType = _this.replyShowType; //点击时记录提交的类型
            _this.loading = true;
            _this.callSubmit({
                iscreate: _this.iscreate,
                type: _this.type,
                replycontent: _this.content,
                billid: _this.billid,
                src: _this.src,
                temp_Quotesid: _this.temp_Quotesid,
                temp_CommentTopid: _this.temp_CommentTopid,
                temp_Commentid: _this.temp_Commentid,
                temp_CommentUsersid: _this.temp_CommentUsersid,
                isEditOpt: _this.isEditOpt
            });
        };
        this.onChange = function (content) {
            _this.content = content;
        };
        this.update = function (param) {
            for (var key in param) {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(_this, key, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(param, key));
            }
        };
        this.clearContent = function () {
            _this.initContent({}, 'new');
        };
        this.setEditor = function (editor, initAt) {
            _this.loadJSAndInitAt = initAt;
            _this.editor = editor;
        };
        this.initContent = function (replyData, replyShowType) {
            var content = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(replyData, 'replycontent');
            var opt = "";
            if (replyShowType == 'edit') {
                opt = getLabel(93, '编辑');
            }
            else if (replyShowType == 'quote') {
                opt = getLabel(19422, '引用');
                content = "<p></p>";
            }
            else if (replyShowType == 'comment') {
                opt = getLabel(675, '评论');
                content = "<p></p>";
            }
            else if (replyShowType == "new") {
                content = "&#8203;";
            }
            if (opt != "") {
                _this.optdesc = "<p class='messageTitle' style='color: #999999;font-size: 9px;'>" + opt + " [ #" + replyData.floornum + " " + replyData.replyorname + " ] " + getLabel('33800', "的") + getLabel('33368', "内容") + ":<span style='display:none'>#@split@#</span></p>";
            }
            else {
                _this.optdesc = "";
            }
            if (replyShowType) {
                _this.replyShowType = replyShowType;
                _this.content = content;
                if (_this.editor) {
                    _this.editor.setData(_this.content, { callback: function () {
                            _this.loadJSAndInitAt();
                        } });
                }
                _this.temp_Commentid = '';
                _this.temp_CommentTopid = '';
                _this.temp_CommentUsersid = '';
                _this.temp_Quotesid = '';
                _this.type = '';
                _this.iscreate = '';
                if (replyShowType == "new") {
                    _this.type = '1';
                    _this.iscreate = '1';
                    _this.billid = '';
                    _this.src = 'submit';
                    _this.isEditOpt = '0';
                    _this.temp_Commentid = '';
                    _this.temp_CommentTopid = '';
                    _this.temp_CommentUsersid = '';
                }
                else if (replyShowType == "edit") {
                    _this.type = '2';
                    _this.iscreate = '0';
                    _this.billid = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(replyData, 'id');
                    _this.src = 'edit';
                    _this.isEditOpt = '1';
                }
                else if (replyShowType == "quote") {
                    _this.type = '1';
                    _this.iscreate = '1';
                    _this.billid = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(replyData, 'id');
                    _this.src = 'quote';
                    _this.isEditOpt = '0';
                    _this.temp_Quotesid = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(replyData, 'id');
                    _this.content = content;
                }
                else if (replyShowType == 'comment') {
                    _this.type = '1';
                    _this.iscreate = '1';
                    _this.billid = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(replyData, 'id');
                    _this.src = 'comment';
                    _this.content = content;
                    _this.temp_Commentid = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(replyData, 'id');
                    _this.temp_CommentTopid = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(replyData, 'id');
                    _this.temp_CommentUsersid = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(replyData, 'replyor');
                    _this.isEditOpt = '0';
                }
                else {
                    _this.type = '1';
                    _this.iscreate = '0';
                    _this.billid = '';
                    _this.src = '';
                    _this.isEditOpt = '0';
                }
            }
        };
    }
    ReplyAddStore.prototype.getAtInfo = function (params) {
        var key = "cube_at_" + params.modeId + "_" + params.billid;
        var lasttime = this.atInfo[key + "_time"];
        var data = this.atInfo[key + "_data"];
        return { time: lasttime ? lasttime : '', data: data ? data : {} };
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "contentid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "content", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "optdesc", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "maincategory", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "subcategory", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "seccategory", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "replyShowType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "popup", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "isInitPopup", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "popupOffset", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "popupArrowPostion", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "atInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "editor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "loadJSAndInitAt", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "isdefault", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "showbuttons", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ReplyAddStore.prototype, "secretLevel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "getAtInfo", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "setAtInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "onCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "onPopupCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "onOk", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "onChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "clearContent", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "setEditor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ReplyAddStore.prototype, "initContent", void 0);
    return ReplyAddStore;
}());



/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

// import window from '../../util';





var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var DetailImportStore = /** @class */ (function () {
    function DetailImportStore() {
        var _this = this;
        this.visible = false;
        this.loading = false;
        // @observable importUrl: string = '/api/cube/card/detailImport';
        this.importUrl = "/api/cube/mode/mode/uploadTempFile"; //上传到临时文件目录
        this.uploadParams = {};
        this.modename = '';
        this.selectedFile = "";
        this.random = 0;
        this.applyToModel = '';
        this.canUpload = false;
        this.show = function () {
            Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["I" /* initDetailExcelFile */])(_this.uploadParams).then(function (_a) {
                var applyToModel = _a.applyToModel;
                _this.applyToModel = applyToModel;
            });
            _this.visible = true;
        };
        this.hide = function () {
            _this.visible = false;
            _this.uploadParams.isImportDetail = false;
        };
        this.onCancel = function () {
            _this.hide();
        };
        this.onOk = function () {
            _this.loading = true;
            // window.startUploadAll();
            //解决滑动弹出ifram窗口中，startUploadAll()未定义的问题。 使用下面方法对window做兼容处理
            var window = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].WindowFunc.getTop();
            window.startUploadAll();
        };
        this.uploading = function (status) {
            // if (status == 'uploaded') {
            //     this.loading = false;
            //     this.visible = false;
            //     this.initCard();
            //     this.random = new Date().getTime();
            // }
        };
        this.uploadChange = function (ids, list) {
            var that = _this;
            if (ids && ids.length == 1) {
                var excelid = ids[0];
                var params = __assign({}, _this.uploadParams, { excelid: excelid });
                Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["h" /* detailImportNew */])(params).then(function (data) {
                    if (data.status == "1") {
                        if (data.istrue == "1") {
                            _this.visible = false;
                            _this.initCard();
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].error({
                                title: getLabel(24945, "导入失败"),
                                width: 500,
                                content: React.createElement("div", { style: { maxHeight: 600, overflowY: 'auto' } },
                                    React.createElement("div", { dangerouslySetInnerHTML: { __html: data.msg } })),
                                onOk: function () {
                                    that.visible = false;
                                    that.initCard();
                                },
                            });
                        }
                    }
                    _this.loading = false;
                    _this.random = new Date().getTime();
                });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("Excel" + getLabel(25389, "上传失败") + "！");
            }
        };
        this.getShowListDatas = function (__, newData) {
            if (newData && newData.length == 1) {
                _this.selectedFile = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(newData, '[0].name');
                _this.canUpload = true;
            }
            else {
                _this.selectedFile = getLabel(384040, '未选择任何文件');
                _this.canUpload = false;
            }
        };
        this.downloadTemplate = function (params) {
            var layoutid = params.layoutid, formId = params.formId, modeid = params.modeid, cardtype = params.cardtype, billid = params.billid;
            var href = "/weaver/weaver.formmode.data.FileDownload?type=detailimport_excel&layoutid=" + layoutid + "&formId=" + formId + "&modeid=" + modeid + "&cardtype=" + cardtype + "&billid=" + billid + " ";
            Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["c" /* confirmTemplate */])(params).then(function (data) {
                if (data.status == "1") {
                    if (data.isHas == "1") {
                        window.open(Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])(href), "_self");
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("Excel" + getLabel(520554, "模板不存在") + "！");
                    }
                }
                _this.loading = false;
                _this.random = new Date().getTime();
            });
        };
        this.selectedFile = getLabel(384040, '未选择任何文件');
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "importUrl", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "uploadParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "modename", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "selectedFile", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "random", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "applyToModel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], DetailImportStore.prototype, "canUpload", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DetailImportStore.prototype, "show", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DetailImportStore.prototype, "hide", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DetailImportStore.prototype, "onCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DetailImportStore.prototype, "onOk", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DetailImportStore.prototype, "uploading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DetailImportStore.prototype, "uploadChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DetailImportStore.prototype, "getShowListDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], DetailImportStore.prototype, "downloadTemplate", void 0);
    return DetailImportStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (DetailImportStore);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModeMutilContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Parse__ = __webpack_require__(579);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var ModeMutilContent = /** @class */ (function () {
    function ModeMutilContent() {
        var _this = this;
        this.rowcount = 0;
        this.colcount = 0;
        this.cells = [];
        this.initMc = function (detail) {
            if (detail === void 0) { detail = {}; }
            _this.rowcount = detail.rowcount;
            _this.colcount = detail.colcount;
            var _a = detail.ec, ec = _a === void 0 ? [] : _a;
            var _cells = [];
            __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](ec, function (cell) {
                if (cell) {
                    var ids = cell.id.split(',');
                    if (ids.length == 2) {
                        __WEBPACK_IMPORTED_MODULE_1_lodash__["set"](_cells, "[" + ids[0] + "].[" + ids[1] + "]", Object(__WEBPACK_IMPORTED_MODULE_3__Parse__["a" /* parseCell */])(cell));
                    }
                }
            });
            var _mcCells = [];
            _cells.map(function (rowcells) {
                rowcells.map(function (cell) {
                    _mcCells.push(cell);
                });
            });
            _this.cells = _mcCells;
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeMutilContent.prototype, "cells", void 0);
    return ModeMutilContent;
}());

var ModeExcel = /** @class */ (function () {
    function ModeExcel() {
        var _this = this;
        this.isInit = false;
        this.cols = [];
        this.rows = [];
        this.proportion = 1;
        this.sumWidth = 0;
        this.details = {};
        this.mutilContents = {};
        this.tabs = {};
        this.floatingObjectArray = [];
        this.cells = [];
        this.edlockedcol = -1; //锁定列
        this.detailProps = {};
        this.error = { visible: false, msg: '' };
        this.path = '';
        //定义固定列所在位置（从左往右数，下标从0开始）
        this.fixFieldIndex = 0;
        //定义合并行的字段
        this.mergeFields = {};
        this.fixFieldWidth = 0;
        this.formula = {};
        this.isHaveDetailCheck = false;
        this.containerWidth = document.documentElement.clientWidth - 300;
        this.tableStyle = {};
        this.detailMap = {}; //存放明细表锁定列信息
        // @observable detaicolorlMap: any = {};//存放明细表td style
        this.isDragulaMap = {}; //存放明细表排序信息  
        this.detailFinancialMap = {}; //存放模板格式上面的千分位,金额大写信息 
        this.codeImgFn = {};
        this.init = function (datajson, type) {
            var eformdesign = datajson.eformdesign;
            var etables = eformdesign.etables, formula = eformdesign.formula;
            var _a = etables.emaintable, emaintable = _a === void 0 ? {} : _a, details = __rest(etables, ["emaintable"]);
            var _b = emaintable.colheads, colheads = _b === void 0 ? {} : _b, _c = emaintable.rowheads, rowheads = _c === void 0 ? {} : _c, _d = emaintable.rowattrs, rowattrs = _d === void 0 ? {} : _d, _e = emaintable.ec, ec = _e === void 0 ? [] : _e, _f = emaintable.colattrs, colattrs = _f === void 0 ? {} : _f, _g = emaintable.combine_cell, combine_cell = _g === void 0 ? [] : _g, _h = emaintable.isHaveDetailCheck, isHaveDetailCheck = _h === void 0 ? false : _h, backgroundImage = emaintable.backgroundImage, _j = emaintable.floatingObjectArray, floatingObjectArray = _j === void 0 ? {} : _j;
            _this.formula = formula;
            _this.type = type;
            _this.initCol(colheads);
            _this.initRow(rowheads, rowattrs);
            _this.initCell(ec, colattrs);
            _this.combineCell = combine_cell;
            _this.isHaveDetailCheck = isHaveDetailCheck;
            _this.initDetail(details, type);
            _this.backgroundImg = backgroundImage;
            _this.floatingObjectArray = floatingObjectArray;
            _this.isInit = true;
        };
        this.initDetail = function (details, type) {
            var _details = {};
            var _mutilcontents = {};
            var _tabs = {};
            __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](details, function (detail, name) {
                if (name.startsWith('detail_')) {
                    var excel = new ModeExcel();
                    var _a = detail.colheads, colheads = _a === void 0 ? {} : _a, _b = detail.rowheads, rowheads = _b === void 0 ? {} : _b, _c = detail.ec, ec = _c === void 0 ? [] : _c, _d = detail.colattrs, colattrs = _d === void 0 ? {} : _d, _e = detail.combine_cell, combine_cell = _e === void 0 ? [] : _e, _f = detail.isHaveDetailCheck, isHaveDetailCheck = _f === void 0 ? false : _f;
                    // console.log(toJS(colheads),toJS(rowheads),toJS(colattrs),name)
                    // if(isOpenCustomOrder&&!isHaveDetailCheck){
                    //     colheads={'col_-1':'50',...colheads};
                    //     console.log(toJS(colheads),name)
                    // }
                    //获取明细表的固定列
                    excel.fixFieldIndex = __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](detail, 'edlockedcol');
                    excel.mergeFields = __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](detail, 'mergeFields');
                    excel.initCol(colheads, _this.sumWidth, true, colattrs, excel.fixFieldIndex, type);
                    excel.initRow(rowheads);
                    excel.initCell(ec, colattrs);
                    excel.seniorset = __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](detail, 'seniorset');
                    excel.edtitleinrow = __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](detail, 'edtitleinrow');
                    excel.edtailinrow = __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](detail, 'edtailinrow');
                    excel.edlockedcol = __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](detail, 'edlockedcol');
                    excel.combineCell = combine_cell;
                    excel.isHaveDetailCheck = isHaveDetailCheck;
                    excel.path = name;
                    excel.mergeType = __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](detail, 'mergeType');
                    __WEBPACK_IMPORTED_MODULE_1_lodash__["set"](_details, name, excel);
                }
                else if (name.startsWith('mc_')) {
                    var excel = new ModeMutilContent();
                    excel.initMc(detail);
                    __WEBPACK_IMPORTED_MODULE_1_lodash__["set"](_mutilcontents, name, excel);
                }
                else if (name.startsWith('tab_')) {
                    var excel = new ModeExcel();
                    var _g = detail.colheads, colheads = _g === void 0 ? {} : _g, _h = detail.rowheads, rowheads = _h === void 0 ? {} : _h, _j = detail.ec, ec = _j === void 0 ? [] : _j, _k = detail.colattrs, colattrs = _k === void 0 ? {} : _k, _l = detail.combine_cell, combine_cell = _l === void 0 ? [] : _l, _m = detail.rowattrs, rowattrs = _m === void 0 ? {} : _m;
                    excel.initCol(colheads, _this.sumWidth, true, colattrs, 0, type);
                    excel.initRow(rowheads, rowattrs);
                    excel.initCell(ec, colattrs);
                    excel.combineCell = combine_cell;
                    excel.path = name;
                    __WEBPACK_IMPORTED_MODULE_1_lodash__["set"](_tabs, name, excel);
                }
            });
            _this.details = _details;
            _this.mutilContents = _mutilcontents;
            _this.tabs = _tabs;
        };
        this.getSortField = function (ec) {
            if (ec === void 0) { ec = []; }
            return ec.sort(function (a, b) {
                var _a = a.id.split(','), row1 = _a[0], col1 = _a[1];
                var _b = b.id.split(','), row2 = _b[0], col2 = _b[1];
                var ri1 = parseInt(row1, 10);
                var ci1 = parseInt(col1, 10);
                var ri2 = parseInt(row2, 10);
                var ci2 = parseInt(col2, 10);
                if (ri1 !== ri2) {
                    return ri1 - ri2;
                }
                else {
                    return ci1 - ci2;
                }
            });
        };
        this.initCell = function (ec, colattrs) {
            if (ec === void 0) { ec = []; }
            if (colattrs === void 0) { colattrs = {}; }
            var newKeys = _this.getSortField(ec);
            var fixBlankCell = function (newEc) {
                var mark = -1, count = 0;
                var ec_copy = newEc.slice();
                ec_copy.forEach(function (c, index, arr) {
                    var v = c.id.split(",");
                    if (v[0] != mark) {
                        mark = v[0];
                        while (v[1] > count) {
                            newEc.splice(index + count, 0, {
                                "colspan": "1",
                                "eborder": [],
                                "rowspan": "1",
                                "etype": "0",
                                "evalue": "",
                                "id": mark + "," + count,
                                "font": {}
                            });
                            count++;
                        }
                        if (v[1] <= count) {
                            count = 0;
                        }
                    }
                    else {
                        if (index > 0 && (v[1] - 1) > arr[index - 1].id.split(",")[1]) {
                            for (var i = 0; i < v[1] - 1 - arr[index - 1].id.split(",")[1]; i++) {
                                var temp = parseInt(arr[index - 1].id.split(",")[1], 10) + 1 + i;
                                newEc.splice(index - 1 + i, 0, {
                                    "colspan": "1",
                                    "eborder": [],
                                    "rowspan": "1",
                                    "etype": "0",
                                    "evalue": "",
                                    "id": mark + "," + temp,
                                    "font": {}
                                });
                            }
                        }
                    }
                });
                return newEc;
            };
            ec = _this.getSortField(fixBlankCell(newKeys));
            var cells = ec.map(function (cell) {
                var rowcol = cell.id.split(',');
                var rows = _this.rows.slice().filter(function (row) { return row.id == "row_" + rowcol[0]; });
                var rowHeight = 30;
                if (rows.length > 0) {
                    rowHeight = rows[0].size;
                }
                var colAttr = colattrs["col_" + rowcol[1]];
                var newcell = Object(__WEBPACK_IMPORTED_MODULE_3__Parse__["a" /* parseCell */])(cell, rowHeight, colAttr);
                if (newcell.financial) {
                    __WEBPACK_IMPORTED_MODULE_1_lodash__["set"](_this.detailFinancialMap, "field" + newcell.field, newcell.financial);
                }
                return newcell;
            });
            var removeCells = [];
            cells.forEach(function (cell) {
                if (cell.otherProps && cell.otherProps.colspan && cell.otherProps.colspan > 1) {
                    for (var i = 1; i < cell.otherProps.colspan; i++) {
                        removeCells.push(cell.row + "," + (cell.col + i));
                    }
                }
            });
            _this.cells = cells.filter(function (d) { return removeCells.indexOf(d.row + "," + d.col) < 0; });
        };
        this.initRow = function (rowheads, rowattrs) {
            var _rows = [];
            __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](rowheads, function (size, id) {
                var height = 0;
                if (size.indexOf("%") > 0) {
                    height = (parseFloat(size) * document.documentElement.clientHeight) / 100;
                }
                else {
                    height = parseInt(size);
                }
                _rows.push({
                    id: id,
                    size: height,
                    index: Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["e" /* getRowIndex */])(id),
                    obj: ""
                });
            });
            /**设计器自定义属性隐藏整行功能添加判断 */
            rowattrs && __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](rowattrs, function (obj, id) {
                _rows = _rows.map(function (row) {
                    if (row.id === id) {
                        return __assign({}, row, { obj: obj });
                    }
                    else {
                        return __assign({}, row);
                    }
                });
            });
            _this.rows = _rows.sort(function (a, b) { return a.index - b.index; });
            ;
        };
        this.initCol = function (colheads, mainWidth, isDetail, colattrs, fixFieldIndex, type) {
            if (mainWidth === void 0) { mainWidth = _this.containerWidth; }
            if (isDetail === void 0) { isDetail = false; }
            if (colattrs === void 0) { colattrs = {}; }
            if (fixFieldIndex === void 0) { fixFieldIndex = 0; }
            var _cols = [];
            var allWidth = 0;
            var totalPx = 0;
            // let totalPercent = 0;
            var hasPercent = false;
            var tableStyle = {};
            var widthpxAll = 0;
            var widthAll = {};
            __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](colheads, function (size, id) {
                if (size.indexOf("%") === -1 && size !== "*") {
                    widthpxAll += parseFloat(size);
                    if (isDetail)
                        widthAll[id.split("_")[1]] = parseFloat(size);
                }
            });
            __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](colheads, function (size, id) {
                var width = 0;
                if (size.indexOf("%") > 0) {
                    // totalPercent += parseFloat(size.replace("%",""));
                    hasPercent = true;
                }
                else {
                    width = parseInt(size);
                    totalPx += parseFloat(size);
                }
                allWidth += width;
                // let validPercent = 100;   //处理下表单支持默认显示的百分比布局
                // if(isDetail)     //低级模式预留6%给序号列
                // validPercent = 94;
                var colWidth = size;
                // if(hasPercent&&colWidth.indexOf("%") === -1){
                //     colWidth = (parseFloat(colWidth)/totalPx) * (validPercent-totalPercent);
                //     colWidth = colWidth.toFixed(2)+"%";
                //     hasPercent = false;
                // }
                if (colWidth.indexOf("%") === -1 && colWidth !== "*") {
                    //打印布局 换成百分比
                    if (_this.type == 4 || (type && type == 4)) {
                        colWidth = ((Number(size) / widthpxAll) * 100).toFixed(2) + '%';
                    }
                    else {
                        colWidth += "px";
                    }
                }
                _cols.push({
                    id: id,
                    size: colWidth,
                    index: Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["c" /* getColIndex */])(id),
                    obj: ""
                });
                _this.sumWidth = allWidth;
                if (hasPercent) {
                    tableStyle["width"] = "99%";
                }
                else {
                    tableStyle["width"] = totalPx + "px";
                }
                //获取固定列的表格宽度
                if (isDetail) {
                    var fixtotalPx = 0;
                    for (var index = 0; index <= fixFieldIndex; index++) {
                        fixtotalPx += parseFloat(widthAll[index]);
                    }
                    _this.fixFieldWidth = fixtotalPx;
                }
                _this.tableStyle = tableStyle;
            });
            /**设计器自定义属性隐藏整列 功能添加判断 =----明细表*/
            !__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](colattrs) && __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](colattrs, function (obj, id) {
                _cols = _cols.map(function (col) {
                    if (col.id === id) {
                        return __assign({}, col, obj);
                    }
                    else {
                        return __assign({}, col);
                    }
                });
            });
            _this.cols = _cols.sort(function (a, b) { return a.index - b.index; });
            ;
        };
        this.getExcel = function (detail) {
            return detail ? __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](_this.details, detail) : new ModeExcel();
        };
        this.getTabs = function (tab) {
            return tab ? __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](_this.tabs, tab) : new ModeExcel();
        };
        this.getTds = function (row, detail, combineCell, detailIndex, rowspanJson) {
            var tds = _this.cells.slice().filter(function (cell) {
                return cell.row == row;
            });
            tds.sort(function (a, b) {
                return a.col - b.col;
            });
            var alltds = [];
            var j = 0; //代表每一列
            if (detail) {
                for (var i = 0; i < _this.cols.length; i++) {
                    var td = tds[j];
                    var isadd = false;
                    if (combineCell && _this.containsValue(combineCell, row + ',' + i)) { //是合并单元格跳过不处理
                        if (td != undefined && td.col == i) {
                            isadd = true;
                            j++;
                        }
                        continue;
                    }
                    var rowspanIsZero = false;
                    //合并行数据 rowspanJson[当前行下标] 获取本行涉及到的td以及对应的rowspan；    rowspanJson[detailIndex] 格式：[{5:2}] -- 表示当前行下标为5的td，rowspan=2
                    if (rowspanJson[detailIndex]) {
                        for (var a = 0; a < rowspanJson[detailIndex].length; a++) {
                            //rowspan > 1 则将rowspan属性赋给td； 如果rowspan = 0，则跳过该td的渲染
                            if (rowspanJson[detailIndex][a][j] > 1) {
                                td.otherProps.rowspan = rowspanJson[detailIndex][a][j];
                                break;
                            }
                            else if (rowspanJson[detailIndex][a][j] == 0) {
                                j++;
                                rowspanIsZero = true;
                                break;
                            }
                            else {
                                td = __assign({}, td, { otherProps: __assign({}, td.otherProps, { rowspan: 1 }) });
                                //td.otherProps.rowspan = 1;
                            }
                        }
                    }
                    else if (td != undefined) {
                        if (Object.keys(rowspanJson).length > 0) { //明细存在合并信息时候
                            td = __assign({}, td, { otherProps: __assign({}, td.otherProps, { rowspan: 1 }) });
                        }
                        else { // qc880486  明细一行拆分2行后，放多个字段 与明细合并显示字段冲突。两者互斥
                            td = __assign({}, td, { otherProps: __assign({}, td.otherProps) });
                        }
                    }
                    if (rowspanIsZero)
                        continue;
                    if (td == undefined || td.col != i) { //补空格
                        alltds.push(undefined);
                        continue;
                    }
                    if (!isadd) {
                        j++;
                    }
                    alltds.push(td);
                }
            }
            else {
                for (var i = 0; i < _this.cols.length; i++) {
                    var td = tds[j];
                    var isadd = false;
                    if (combineCell && _this.containsValue(combineCell, row + ',' + i)) { //是合并单元格跳过不处理
                        if (td != undefined && td.col == i) {
                            isadd = true;
                            j++;
                        }
                        continue;
                    }
                    if (td == undefined || td.col != i) { //补空格
                        alltds.push(undefined);
                        continue;
                    }
                    if (!isadd) {
                        j++;
                    }
                    alltds.push(td);
                }
            }
            return alltds;
        };
        this.getFixFieldTds = function (row, detail, combineCell, fixFieldIndex, detailIndex, rowspanJson) {
            var tds = _this.cells.slice().filter(function (cell) {
                return cell.row == row;
            });
            tds.sort(function (a, b) {
                return a.col - b.col;
            });
            var alltds = [];
            var j = 0;
            for (var i = 0; i <= fixFieldIndex; i++) {
                var td = tds[j];
                var isadd = false;
                if (combineCell && _this.containsValue(combineCell, row + ',' + i)) { //是合并单元格跳过不处理
                    if (td != undefined && td.col == i) {
                        isadd = true;
                        j++;
                    }
                    continue;
                }
                var rowspanIsZero = false;
                //合并行数据 rowspanJson[当前行下标] 获取本行涉及到的td以及对应的rowspan；    rowspanJson[detailIndex] 格式：[{5:2}] -- 表示当前行下标为5的td，rowspan=2
                if (rowspanJson[detailIndex]) {
                    for (var a = 0; a < rowspanJson[detailIndex].length; a++) {
                        //rowspan > 1 则将rowspan属性赋给td； 如果rowspan = 0，则跳过该td的渲染
                        if (rowspanJson[detailIndex][a][j] > 1) {
                            td.otherProps.rowspan = rowspanJson[detailIndex][a][j];
                            break;
                        }
                        else if (rowspanJson[detailIndex][a][j] == 0) {
                            j++;
                            rowspanIsZero = true;
                            break;
                        }
                        else {
                            td = __assign({}, td, { otherProps: __assign({}, td.otherProps, { rowspan: 1 }) });
                        }
                    }
                }
                else if (td != undefined) {
                    if (Object.keys(rowspanJson).length > 0) {
                        td = __assign({}, td, { otherProps: __assign({}, td.otherProps, { rowspan: 1 }) });
                    }
                    else { // qc880486  明细一行拆分2行后，放多个字段 与明细合并显示字段冲突。两者互斥
                        td = __assign({}, td, { otherProps: __assign({}, td.otherProps) });
                    }
                }
                if (rowspanIsZero)
                    continue;
                if (td == undefined || td.col != i) { //补空格
                    alltds.push(undefined);
                    continue;
                }
                if (!isadd) {
                    j++;
                }
                alltds.push(td);
            }
            return alltds;
        };
        this.containsValue = function (arrs, value) {
            var res = false;
            for (var i = 0; i < arrs.length; i++) {
                if (arrs[i] == value) {
                    res = true;
                    break;
                }
            }
            return res;
        };
        this.getMutilContent = function (mcname) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash__["get"](_this.mutilContents, mcname) || {};
        };
        this.addCodeFn = function (params) {
            _this.codeImgFn = __assign({}, _this.codeImgFn, params);
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "isInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "cols", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "rows", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "proportion", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "sumWidth", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "details", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "mutilContents", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "tabs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "floatingObjectArray", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "cells", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "detailProps", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "error", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "path", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "fixFieldIndex", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "mergeFields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "fixFieldWidth", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "containerWidth", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "tableStyle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "detailMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "type", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "mergeType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "isDragulaMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ModeExcel.prototype, "detailFinancialMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ModeExcel.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ModeExcel.prototype, "initDetail", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ModeExcel.prototype, "initCell", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ModeExcel.prototype, "initRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ModeExcel.prototype, "initCol", void 0);
    return ModeExcel;
}());
/* harmony default export */ __webpack_exports__["a"] = (ModeExcel);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseCell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var parseCell = function (cell, rowHeight, colAttrs) {
    if (cell === void 0) { cell = {}; }
    if (colAttrs === void 0) { colAttrs = {}; }
    var rt = {};
    var colspan = cell.colspan, rowspan = cell.rowspan, id = cell.id, _a = cell.font, font = _a === void 0 ? {} : _a, _b = cell.eborder, eborder = _b === void 0 ? [] : _b, format = cell.format, etype = cell.etype, evalue = cell.evalue, field = cell.field, fieldtype = cell.fieldtype, financial = cell.financial, _c = cell.attrs, attrs = _c === void 0 ? {} : _c, detail = cell.detail, _d = cell.tab, tab = _d === void 0 ? {} : _d, stylejson = cell.stylejson;
    var ids = id.split(',');
    rt.row = parseInt(ids[0]);
    if (ids.length == 2) {
        rt.col = parseInt(ids[1]);
    }
    //单元格边框
    var borderStyle = appendBorder(eborder, etype);
    var _e = appendStyle(etype, cell), style = _e.style, innerStyle = _e.innerStyle;
    //财务格式所在单元格div增加高度100%
    if (financial) {
        style.lineHeight = rowHeight + 'px';
        style.height = rowHeight;
        innerStyle.height = '100%';
        innerStyle.display = 'flex';
        if (font['text-align']) {
            switch (font['text-align']) {
                case "right":
                    innerStyle.justifyContent = "flex-end";
                    break;
                case "center":
                    innerStyle.justifyContent = "center";
                    break;
                default: innerStyle.justifyContent = "flex-start";
            }
        }
        else {
            innerStyle.justifyContent = "flex-start";
        }
        if (font['vertical-align']) {
            switch (font['vertical-align']) {
                case "bottom":
                    innerStyle.alignItems = "flex-end";
                    break;
                case "middle":
                    innerStyle.alignItems = "center";
                    break;
                case "top":
                    innerStyle.alignItems = "flex-start";
                    break;
            }
        }
        else {
            innerStyle.alignItems = 'flex-start';
        }
        if (font['valign']) {
            switch (font['valign']) {
                case "bottom":
                    innerStyle.alignItems = "flex-end";
                    break;
                case "middle":
                    innerStyle.alignItems = "center";
                    break;
                case "top":
                    innerStyle.alignItems = "flex-start";
                    break;
            }
        }
    }
    var hide = attrs.hide, cusId = attrs.id, name = attrs.name, cusClass = attrs.class, cusStyle = attrs.style, cusAttr = __rest(attrs, ["hide", "id", "name", "class", "style"]);
    //自定义属性
    var hidechild = "";
    if (colAttrs.hide == 'y' || hide == 'y') {
        // style.display = 'none';
        hidechild = "y";
    }
    rt.otherProps = {};
    rt.cellProps = {};
    rt.otherProps.valign = font.valign;
    if (parseInt(colspan, 0) > 1) {
        rt.otherProps.colspan = colspan;
    }
    if (parseInt(rowspan, 0) > 1) {
        rt.otherProps.rowspan = rowspan;
    }
    rt.otherProps.className = __WEBPACK_IMPORTED_MODULE_0_classnames___default()(colAttrs.class, cusClass);
    rt.otherProps.name = name;
    rt.otherProps.id = cusId;
    for (var key in cusAttr) {
        rt.otherProps["data-" + key.toLowerCase()] = cusAttr[key];
    }
    rt.style = __assign({}, borderStyle, style, Object(__WEBPACK_IMPORTED_MODULE_1__util_typeUtil__["a" /* camelCaseObject */])(cusStyle), { lineHeight: '1' });
    rt.cellProps.style = __assign({}, innerStyle);
    rt.financial = financial;
    rt.etype = etype;
    rt.evalue = evalue;
    rt.field = field;
    rt.fieldtype = fieldtype;
    rt.detail = detail;
    rt.tab = parseTab(tab);
    rt.stylejson = stylejson;
    rt.getPath = function () {
        return "field" + rt.field;
    };
    rt.format = format;
    rt.mcpoint = cell.mcpoint;
    rt.brsign = cell.brsign;
    rt.jsonparam = cell.jsonparam;
    rt.hidechild = hidechild;
    return rt;
};
var parseTab = function (tab) {
    if (tab === void 0) { tab = {}; }
    var _tab = {};
    _tab.tabs = [];
    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(tab, function (v, k) {
        if (k == 'areaheight') {
            var _a = v.split(","), type = _a[0], height = _a[1];
            if (type == '1') {
                _tab.height = 'auto';
            }
            else {
                _tab.height = height + 'px';
            }
        }
        else if (k == 'defshow') {
            _tab.defaultActiveKey = v;
        }
        else if (k.startsWith('order_')) {
            var _b = v.split(','), name = _b[0], tab_1 = _b[1];
            var index = parseInt(k.replace('order_', '')) - 1;
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(_tab.tabs, "" + index, {
                key: index,
                name: name,
                tab: tab_1,
            });
        }
        else if (k == 'name') {
            _tab.name = v;
        }
    });
    return _tab;
};
/**
 * 单元格样式
 * @param etype
 * @param cell
 */
var appendStyle = function (etype, cell, isMutilContent) {
    var backgroundColor = cell.backgroundColor, field = cell.field, _a = cell.font, font = _a === void 0 ? {} : _a, etxtindent = cell.etxtindent;
    var styleObj = {};
    var innerStyle = {};
    if (etype == "7" || etype == "12") {
        return {};
    }
    //背景色
    if (backgroundColor) {
        styleObj.backgroundColor = backgroundColor;
    }
    //背景图片
    if (etype == '6') {
        styleObj.backgroundImage = "url('" + field + "')";
        styleObj.backgroundRepeat = "no-repeat";
    }
    //字体
    if (font['text-align']) {
        styleObj.textAlign = font['text-align'];
    }
    else {
        styleObj.textAlign = 'left';
    }
    if (font['vertical-align']) {
        styleObj.verticalAlign = font['vertical-align'];
    }
    else {
        styleObj.verticalAlign = isMutilContent ? 'top' : 'middle';
    }
    if (font['valign']) {
        styleObj.verticalAlign = font['valign'];
    }
    if (font['bold'] == 'true') {
        styleObj.fontWeight = 'bold';
    }
    if (font['font-style'] == 'italic') {
        styleObj.fontStyle = 'italic';
    }
    if (font['italic'] == 'true') {
        styleObj.fontStyle = 'italic';
    }
    var textDecoration = [];
    if (font['text-decoration'] == 'underline') {
        textDecoration.push('underline');
    }
    if (font['underline'] == 'true') {
        textDecoration.push('underline');
    }
    if (font['deleteline'] == 'true') {
        textDecoration.push('line-through');
    }
    styleObj.textDecoration = textDecoration.join(' ');
    var fontSize = parseInt(font['font-size'], 0);
    var fontSizeUnit = "px"; //截取，获取当前字体大小的单位
    if (font['font-size']) {
        fontSizeUnit = font['font-size'].slice(-2);
    }
    if (fontSize) {
        styleObj.fontSize = fontSize + fontSizeUnit;
        innerStyle.fontSize = fontSize + fontSizeUnit;
        if (etype == "3" && fontSize > 9) {
            var suitheight = fontsize_compare_height(fontSize);
            styleObj.height = suitheight;
            innerStyle.lineHeight = suitheight + "px";
        }
        // if(etype == "1" && cell.id == "0,0"){ //布局头部字体单位还是用pt先特俗处理下
        //     styleObj.fontSize = fontSize + 'pt';
        //     innerStyle.fontSize = fontSize + 'pt';
        // }
    }
    else {
        innerStyle.fontSize = '9pt';
    }
    if (font["color"]) {
        styleObj.color = font["color"];
    }
    if (font["font-family"]) {
        innerStyle.fontFamily = styleObj.fontFamily = font["font-family"];
    }
    else {
        innerStyle.fontFamily = "Microsoft YaHei";
    }
    //缩进
    if (etxtindent && etxtindent !== "0") {
        var etxtindent1 = parseFloat(etxtindent) * 8 + "px";
        if (styleObj.textAlign == "left")
            styleObj.paddingLeft = etxtindent1;
        else if (styleObj.textAlign == "right")
            styleObj.paddingRight = etxtindent1;
    }
    innerStyle.wordBreak = "break-all";
    innerStyle.wordWrap = "break-word";
    return { style: styleObj, innerStyle: innerStyle };
};
/**
 * 单元格边框
 * @param eborder
 * @param etype
 */
var appendBorder = function (eborder, etype) {
    var styleObj = {};
    for (var _i = 0, eborder_1 = eborder; _i < eborder_1.length; _i++) {
        var boder = eborder_1[_i];
        var color = boder.color, kind = boder.kind, borderStyle = boder.style;
        if (etype === "7" && (kind === "top" || kind === "bottom")) { //明细所在区域不解析上下边框
            continue;
        }
        var width = 0;
        var style = '';
        if (borderStyle) {
            if (borderStyle == '2') {
                width = 2;
                style = 'solid';
            }
            else if (borderStyle == '3') {
                width = 1;
                style = 'dashed';
            }
            else if (borderStyle == '5') {
                width = 3;
                style = 'solid';
            }
            else if (borderStyle == '6') {
                width = 3;
                style = 'double';
            }
            else if (borderStyle == '7') {
                width = 1;
                style = 'dotted';
            }
            else if (borderStyle == '8') {
                width = 2;
                style = 'dashed';
            }
            else {
                width = 1;
                style = 'solid';
            }
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set(styleObj, "border" + kind.charAt(0).toUpperCase() + kind.slice(1), width + "px " + style + " " + color);
        }
    }
    return styleObj;
};
var fontsize_compare_height = function (fontsize) {
    if (fontsize <= 10) {
        return 24;
    }
    else if (fontsize <= 12) {
        return 26;
    }
    else if (fontsize <= 24) {
        return fontsize * 2;
    }
    else if (fontsize <= 26) {
        return 50;
    }
    else if (fontsize <= 28) {
        return 52;
    }
    else if (fontsize <= 32) {
        return 58;
    }
    else if (fontsize <= 48) {
        return 82;
    }
    else {
        return 108;
    }
};


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkBrowser */
/* unused harmony export CubeField */
/* unused harmony export rules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react_form__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx_react_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_validatorjs__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_excel_layout_cell_field_input_element_wf_form_input_util__ = __webpack_require__(65);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var getLabel = __WEBPACK_IMPORTED_MODULE_8_ecCom__["WeaLocaleProvider"].getLabel;
function checkBrowser(_a) {
    var field = _a.field;
    return [!!field.values().value, __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](rules, field.key + ".message")];
}
var CubeField = /** @class */ (function (_super) {
    __extends(CubeField, _super);
    function CubeField(props, form) {
        var _this_1 = _super.call(this, props) || this;
        _this_1.uploadState = '';
        _this_1.valueSpan = null;
        _this_1.valueObj = [];
        _this_1.isInit = false;
        _this_1.isAdd = false;
        _this_1.isCopy = false;
        _this_1.isDelete = false;
        _this_1.tips = { visible: false, msg: '' };
        _this_1.detailDefaultValue = {};
        _this_1.uploadData = {};
        _this_1.dataParams = undefined;
        _this_1.browserProps = undefined;
        _this_1.pageSize = 10; //明细表分页大小
        _this_1.pageNum = 1; //明细表当前页
        _this_1.forceRender = "";
        _this_1.startDate = null; //开始时间
        _this_1.endDate = null; //结束时间
        _this_1.viewAttrs = {};
        _this_1.setViewAttrs = function (key, viewAttr) {
            var _a, _b, _c, _e, _f;
            if (viewAttr == '3') {
                _this_1.viewAttrs = __assign({}, _this_1.viewAttrs, (_a = {}, _a[key] = 1, _a));
                _this_1.set('rules', '');
            }
            else if (viewAttr == '1') {
                _this_1.viewAttrs = __assign({}, _this_1.viewAttrs, (_b = {}, _b[key] = 2, _b));
                _this_1.set('rules', '');
            }
            else if (viewAttr == '2') {
                _this_1.viewAttrs = __assign({}, _this_1.viewAttrs, (_c = {}, _c[key] = 3, _c));
                _this_1.set('rules', 'required');
            }
            else if (viewAttr == '4') {
                _this_1.viewAttrs = __assign({}, _this_1.viewAttrs, (_e = {}, _e[key] = 4, _e));
                _this_1.set('rules', '');
            }
            else if (viewAttr == '5') {
                _this_1.viewAttrs = __assign({}, _this_1.viewAttrs, (_f = {}, _f[key] = 5, _f));
                _this_1.hideOrShowTr(true);
            }
            else {
                _this_1.removeViewAttrs(key);
            }
        };
        _this_1.setUploadState = function (state) {
            _this_1.uploadState = state;
        };
        _this_1.setUploadData = function (data) {
            _this_1.uploadData = data;
        };
        _this_1.removeViewAttrs = function (key) {
            if (key in _this_1.viewAttrs) {
                if (_this_1.isMandatory) {
                    _this_1.set('rules', 'required');
                }
                else {
                    _this_1.set('rules', '');
                }
                if (_this_1.viewAttrs[key] == '5') {
                    _this_1.hideOrShowTr(false);
                }
                delete _this_1.viewAttrs[key];
                _this_1.viewAttrs = __assign({}, _this_1.viewAttrs);
            }
        };
        /*****属性联动---隐藏行功能 */
        _this_1.hideOrShowTr = function (bool) {
            var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(_this_1.path);
            var $tr;
            var cardId = __WEBPACK_IMPORTED_MODULE_6__util__["default"].location.hash.slice(__WEBPACK_IMPORTED_MODULE_6__util__["default"].location.hash.lastIndexOf("=") + 1).replace(/%/g, "");
            if (__WEBPACK_IMPORTED_MODULE_11_jquery___default()("#display-" + cardId).length > 0) { //ecme模块
                if (__WEBPACK_IMPORTED_MODULE_11_jquery___default()("#display-" + cardId + " #" + fieldName).length > 0) {
                    $tr = __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#display-" + cardId + " #" + fieldName).closest('tr');
                }
                else {
                    $tr = __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#display-" + cardId + " #" + fieldName + "span").closest('tr');
                }
            }
            else {
                if (__WEBPACK_IMPORTED_MODULE_11_jquery___default()('#' + fieldName).length > 0) {
                    $tr = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#' + fieldName).closest('tr');
                }
                else {
                    $tr = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#' + fieldName + 'span').closest('tr');
                }
            }
            if (bool) {
                $tr.hide();
            }
            else {
                $tr.show();
            }
        };
        _this_1.onChangFuncs = [];
        _this_1.getValue = function () {
            return _this_1.values();
        };
        _this_1.setSelfValue = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            //ljc-加了一个参数导致这里进不来了，参数判断优化性能的，为了方便拓展，用>=
            if (args.length >= 3) {
                //QC: #775361
                if (args[1] != undefined) {
                    if (args[1].indexOf(",") >= 0) {
                        args[1] = args[1].replace(/,/g, ' ');
                    }
                }
                _this_1.valueObj = args[2];
                _this_1.valueSpan = args[1];
                var key_1 = '';
                if (args[2] && args[2][0] && args[2][0].randomFieldId) {
                    args[2].forEach(function (item) {
                        key_1 += item.randomFieldId + ',';
                    });
                }
                if (key_1.endsWith(','))
                    key_1 = key_1.substr(0, key_1.length - 1);
                key_1 = key_1 || args[0];
                _this_1.set("" + key_1);
                _this_1.form.card.changeModeTitle(args[1], _this_1.path); // 触发标题自动更新
            }
            else {
                _this_1.set("" + args[0]);
                _this_1.form.card.changeModeTitle(args[0], _this_1.path); // 触发标题自动更新
            }
        };
        _this_1.quickEditOnchange = function (args) {
            var _a;
            var quickEditStore = _this_1.form.card.quickEditStore;
            var editValues = quickEditStore.formItemsCurrentValue || {};
            quickEditStore.setFormItemsCurrentValue(__assign({}, editValues, (_a = {}, _a[_this_1.key] = args[0], _a))); //更新到快速编辑对象
        };
        _this_1.onChange = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var oldvalue = _this_1.getValue();
            _this_1.setSelfValue.apply(_this_1, args);
            _this_1.quickEditOnchange(args); //快速编辑字段维护
            var newvalue = _this_1.getValue();
            var that = _this_1;
            setTimeout(function () {
                that.onChangFuncs.map(function (f) {
                    if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isFunction"](f)) {
                        f.apply(void 0, args);
                    }
                });
                var onChanges = __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](__WEBPACK_IMPORTED_MODULE_6__util__["default"].CubeTrigger.onChangeFuns, that.key);
                if (onChanges && __WEBPACK_IMPORTED_MODULE_2_lodash__["isArray"](onChanges)) {
                    onChanges.map(function (f) {
                        if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isFunction"](f)) {
                            if (oldvalue == newvalue) { //如果值没变化,不触发字段联动
                                return;
                            }
                            var path_1 = that.path;
                            if (path_1.indexOf('detail_') > -1) {
                                var paths = path_1.split('.');
                                if (paths.length == 3) {
                                    f(paths[1]);
                                }
                                else {
                                    f();
                                }
                            }
                            else {
                                f();
                            }
                        }
                    });
                }
                //插入代码快绑定函数触发
                var path = that.path;
                var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(path);
                var funs = __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].__propertyChangeFnObj[fieldName];
                if (funs) {
                    funs.forEach(function (fun) {
                        if (typeof fun === 'function') {
                            fun(document.getElementById(fieldName), fieldName, that.values());
                        }
                    });
                }
                //明细字段值变化触发事件
                var detailFuns = __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].__detailFieldChangeFnObj[that.key];
                if (detailFuns) {
                    detailFuns.forEach(function (fun) {
                        if (typeof fun === 'function') {
                            var rowIndex = fieldName.split('_')[1];
                            fun(fieldName, rowIndex, that.values());
                        }
                    });
                }
            }, 100);
            /***
             * 这个校验很影响性能，缩短三分之二时间
             * 批量修改的时候加个第四个参数true，判断下
             */
            // if(!args[3]){
            // this.validate();
            // this.showErrors(true);
            // }
            //ecme字段变更时回调
            if (oldvalue == newvalue) { //如果值没变化,不触发回调
                return;
            }
            var path = that.path;
            var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(path);
            //执行力平台组
            if (_this_1.form.card.getFieldProps(path).fieldhtmltype === '6' && args.length === 1 && args[0] === '-1') {
                return false;
            }
            else {
                __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].ecmeFieldEventCallBack("onChange", fieldName, "form");
            }
        };
        _this_1.getDetailTable = function () {
            return _this_1.path.split('.')[0];
        };
        _this_1.getDetailRowIndex = function () {
            var index = __WEBPACK_IMPORTED_MODULE_2_lodash__["trim"](_this_1.path.replace(_this_1.getDetailTable(), '').replace(_this_1.key, ''), '.');
            if (index && Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["h" /* isNumber */])(index)) {
                return parseInt(index);
            }
            else {
                return -1;
            }
        };
        _this_1.onFocus = function () {
            __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].triggerFieldAction("onfocus", _this_1.key);
            //ecme字段onFocus时回调
            var path = _this_1.path;
            var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(path);
            __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].ecmeFieldEventCallBack("onfocus", fieldName, "form");
        };
        _this_1.onBlur = function () {
            __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].triggerFieldAction("onblur", _this_1.key);
            //ecme字段onBlur时回调
            var path = _this_1.path;
            var fieldName = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["d" /* getDomIdByFieldKey */])(path);
            __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].ecmeFieldEventCallBack("onblur", fieldName, "form");
        };
        //处理多人力操作组信息
        _this_1.buildMultiUserGroupInfo = function (ids, datas) {
            if (ids === void 0) { ids = ''; }
            if (datas === void 0) { datas = []; }
            var multiUserType = { "subcom": 2, "dept": 3, "group": 4, "virtual_subcom": 5, "virtual_dept": 7, "all": 9 };
            var groupInfo = {};
            var i = 0;
            datas && datas.map(function (v, k) {
                var type = v['type'];
                var typeid = v['id'] || 0;
                if (type == "subcom" || type == "dept" || type == "group") {
                    var users = [];
                    users = v['users'];
                    var userIds_1 = [];
                    users && users.map(function (o) {
                        userIds_1.push(o['id']);
                    });
                    groupInfo["group_" + i] = multiUserType[type] + "|" + typeid + "|" + userIds_1.join(",");
                    i++;
                }
                else if (type == "all") {
                    groupInfo["group_" + i] = multiUserType[type] + "|" + typeid + "|" + ids;
                    i++;
                }
            });
            groupInfo['groupnum'] = i;
            return groupInfo;
        };
        _this_1.form = form;
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["autorun"])(function () {
            if (_this_1.viewAttr == 3 || (_this_1.isMandatory && _this_1.viewAttr == undefined)) {
                _this_1.set('rules', 'required');
            }
            else {
                _this_1.set('rules', '');
            }
        });
        return _this_1;
    }
    Object.defineProperty(CubeField.prototype, "isUpload", {
        get: function () {
            return !this.uploadState || this.uploadState == 'false' || this.uploadState == 'uploaded';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeField.prototype, "viewAttr", {
        get: function () {
            var v = undefined;
            __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](this.viewAttrs, function (v1) {
                v = v1;
            });
            return v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeField.prototype, "isView", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](this.form, "card.fieldsPropsToShow." + this.key + ".isview") == '1';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeField.prototype, "isEdit", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](this.form, "card.fieldsPropsToShow." + this.key + ".isedit") == '1';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeField.prototype, "isMandatory", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](this.form, "card.fieldsPropsToShow." + this.key + ".ismandatory") == '1';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeField.prototype, "isHide", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](this.form, "card.fieldsPropsToShow." + this.key + ".ishide") == '1';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeField.prototype, "order", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](this.form, "card.refreshParams.order." + this.key);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeField.prototype, "isquickedit", {
        /***
         * ljc-快速编辑开启的情况下才会有editstate字段，返回2编辑 3 必填，
         * 其他布局不存在，所以作为判断依据是否可以编辑
         * editstate不好辨别，增加一个isquickedit字段
         */
        get: function () {
            var editstate = __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](this.form, "card.fieldsPropsToShow." + this.key + ".editstate");
            return editstate == '1' ? false : editstate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeField.prototype, "editstate", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](this.form, "card.fieldsPropsToShow." + this.key + ".editstate");
        },
        enumerable: true,
        configurable: true
    });
    CubeField.prototype.onChangeNoTrigger = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.setSelfValue.apply(this, args);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "uploadState", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "valueSpan", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "valueObj", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "color", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "isAdd", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "isCopy", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "isDelete", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "tips", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "detailDefaultValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "uploadData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "dataParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "browserProps", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "pageSize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "pageNum", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "forceRender", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "startDate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "endDate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], CubeField.prototype, "viewAttrs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeField.prototype, "setViewAttrs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeField.prototype, "setUploadState", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "isUpload", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeField.prototype, "setUploadData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeField.prototype, "removeViewAttrs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeField.prototype, "hideOrShowTr", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "viewAttr", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "isView", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "isEdit", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "isMandatory", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "isHide", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "order", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "isquickedit", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], CubeField.prototype, "editstate", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeField.prototype, "setSelfValue", void 0);
    return CubeField;
}(__WEBPACK_IMPORTED_MODULE_0_mobx_react_form__["Field"]));

var bindings = {
    default: {
        id: 'id',
        name: 'name',
        value: 'value',
        valueSpan: 'valueSpan',
        valueObj: 'valueObj',
        label: 'label',
        checked: 'checked',
        options: 'options',
        placeholder: 'placeholder',
        disabled: 'disabled',
        onChange: 'onChange',
        onBlur: 'onBlur',
        onFocus: 'onFocus',
        autoFocus: 'autoFocus',
        onError: 'onError',
        isView: 'isView',
        isHide: 'isHide',
        isEdit: 'isEdit',
        isMandatory: 'isMandatory',
        viewAttr: 'viewAttr',
        uploadData: 'uploadData',
        dataParams: 'dataParams',
        browserProps: 'browserProps',
        forceRender: 'forceRender',
        startDate: 'startDate',
        endDate: 'endDate',
    }
};
var rules = {};
var CubeForm = /** @class */ (function (_super) {
    __extends(CubeForm, _super);
    function CubeForm(card) {
        var props = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            props[_i - 1] = arguments[_i];
        }
        var _this_1 = _super.apply(this, props) || this;
        _this_1.isInit = false;
        _this_1.isDrag = false;
        _this_1.updateValues = function (values, allfields, isInit) {
            __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](values, function (value, key) {
                // const { options = [] } = _.get(allfields, key) || {};
                // if (!value) {
                //     const selecteds = options.filter(o => o.selected);
                //     if (selecteds.length > 0) {
                //         value = _.get(selecteds, '[0].key');
                //     }
                //     if (!value) {
                //         return;
                //     }
                // }
                if (key.startsWith('detail_')) {
                    var detailTable_1 = _this_1.$(key);
                    __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](value, function (v, index) {
                        // if(index&&index!=""&&index!=null){
                        //   index = "";
                        // }
                        if (v['dtl_index']) {
                            if (isInit && isInit == "init") {
                                v['dtl_index'] = "";
                            }
                        } //v['dtl_index']
                        var row = detailTable_1.$("" + index);
                        __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](v, function (v1, k1) {
                            if (!v1) {
                                return;
                            }
                            /**
                             * E9建模明细表布局里明细字段不显示的情况下会导致字段的值无法正常显示，
                             * 只有第一行显示个别字段，提交后会导致增加行或者行数会翻倍
                             */
                            if (!row.has(k1)) {
                                return;
                            }
                            ;
                            if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](v1) || __WEBPACK_IMPORTED_MODULE_2_lodash__["isNumber"](v1)) {
                                if (isInit && isInit == "init") {
                                    row.$(k1).onChangeNoTrigger(v1);
                                }
                                else {
                                    row.$(k1).onChange(v1);
                                }
                            }
                            else {
                                var field = row.$(k1);
                                if (isInit && isInit == "init") {
                                    if (v1.filedatas) { //附件类型
                                        _this_1.dealAnnex(field, v1);
                                    }
                                    else {
                                        field.onChangeNoTrigger(v1.value, v1.valueSpan, v1.valueObj);
                                    }
                                }
                                else {
                                    if (v1.filedatas) {
                                        _this_1.dealAnnex(field, v1);
                                    }
                                    else {
                                        field.onChange(v1.value, v1.valueSpan, v1.valueObj);
                                    }
                                }
                            }
                        });
                    });
                }
                else {
                    if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](value) || __WEBPACK_IMPORTED_MODULE_2_lodash__["isNumber"](value)) {
                        _this_1.$(key).onChangeNoTrigger(value);
                    }
                    else {
                        //field1.fieldhtmltype === '5' && _.isNumber(Number(field1.value)) && field1.value
                        var field = _this_1.$(key);
                        field.onChangeNoTrigger(value.value, value.valueSpan, value.valueObj);
                    }
                }
            });
        };
        _this_1.initCubeFields = function (fields) {
            _this_1.initFields({ fields: fields });
            _this_1.isInit = true;
        };
        _this_1.clearCubeFields = function () {
            _this_1.clear();
        };
        _this_1.getDetailInitData = function (detail) {
            var datas = [];
            if (_this_1.has(detail)) {
                var detailTable = _this_1.$(detail);
                detailTable.map(function (row, index) {
                    row.map(function (f) {
                        if (f.key.startsWith('field')) {
                            var _a = _this_1.card.getFieldProps(f.key), fieldhtmltype = _a.fieldhtmltype, fieldtype = _a.fieldtype;
                            if (fieldhtmltype === '3' && (fieldtype != '2' && fieldtype != '19')) {
                                __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](datas, index + "." + f.key, Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(f.valueObj));
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](datas, index + "." + f.key, f.getValue());
                                if (fieldhtmltype === '6') {
                                    __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](datas, index + "." + f.key + "uploadData", Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(f.uploadData));
                                }
                            }
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](datas, index + "." + f.key, f.getValue());
                        }
                    });
                });
            }
            return datas;
        };
        /***
         * 这里加个参数，批量修改不走校验，校验比较耗时，影响性能
         */
        _this_1.setValue = function (key, value, bool) {
            if (bool === void 0) { bool = false; }
            if (_this_1.judgeHasKey(key)) {
                return;
            }
            var field = _this_1.$(key);
            var _a = _this_1.card.getFieldProps(field.key), fieldtype = _a.fieldtype, fielddbtype = _a.fielddbtype;
            if (value.filedatas) {
                field.uploadData = value;
                if (field.uploadData.filedatas) {
                    var v_1 = [];
                    field.uploadData.filedatas.forEach(function (item) {
                        v_1.push(item.fileid);
                    });
                    field.onChange(v_1.join(','), null, [], bool);
                }
            }
            else if (value == null || value == undefined) {
                field.onChange('', null, [], bool);
            }
            else if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](value) || __WEBPACK_IMPORTED_MODULE_2_lodash__["isNumber"](value)) {
                if (fieldtype == '2') {
                    if (value > 2147483647 || value < -2147483648)
                        return;
                }
                else if (fieldtype == '3' || fieldtype == '4' || fieldtype == '5') {
                    if (value > 999999999999.999999999999 || value < -999999999999.999999999999)
                        return; //最大支持到千亿
                }
                else if (fieldtype === '1') {
                    var valLen = __WEBPACK_IMPORTED_MODULE_12__components_excel_layout_cell_field_input_element_wf_form_input_util__["g" /* realLength */](value);
                    var fieldlength_tmp = 999;
                    if (fielddbtype.indexOf("varchar") > -1) {
                        fieldlength_tmp = parseInt(fielddbtype.substring(fielddbtype.indexOf("(") + 1, fielddbtype.length - 1));
                    }
                    if (fielddbtype.indexOf("text") > -1) {
                        fieldlength_tmp = 2147483647;
                    }
                    if (fieldlength_tmp && valLen > fieldlength_tmp) {
                        __WEBPACK_IMPORTED_MODULE_5_antd__["message"].warning("\"" + field.$label + "\"" + (getLabel(20246, "文本长度不能超过") + fieldlength_tmp + '(' + getLabel(20247, '1个中文字符等于3个长度') + ')'));
                        value = __WEBPACK_IMPORTED_MODULE_12__components_excel_layout_cell_field_input_element_wf_form_input_util__["a" /* checkLength */](value, valLen, fieldlength_tmp);
                    }
                }
                field.onChange(value, null, [], bool);
            }
            else if (fieldtype == '141' && __WEBPACK_IMPORTED_MODULE_2_lodash__["isArray"](value) && __WEBPACK_IMPORTED_MODULE_2_lodash__["has"](value[0], ("prop"))) {
                var obj = Object(__WEBPACK_IMPORTED_MODULE_7____["a" /* deal4ReplaceDatas */])(value, fieldtype);
                field.onChange(obj.value, obj.valueSpan, obj.valueObj, bool);
            }
            else {
                field.onChange(value.map(function (d) { return d.id; }).join(','), value.map(function (d) { return d.name || d.lastname; }).join(','), value, bool);
            }
        };
        _this_1.getValue = function (key) {
            if (_this_1.judgeHasKey(key)) {
                return '';
            }
            var value = _this_1.$(key).value;
            return value;
        };
        //判断key是否存在
        _this_1.judgeHasKey = function (key) {
            var arr = key.split('.');
            var istrue = false;
            if (arr.length > 1) { //明细表逐层判断key是否存在
                if (_this_1.has(arr[0]) && _this_1.$(arr[0]).has(arr[1]) && _this_1.$(arr[0]).$(arr[1]).has(arr[2])) {
                    istrue = false;
                }
                else {
                    istrue = true;
                }
            }
            else { //主表
                if (!_this_1.has(arr[0])) {
                    istrue = true;
                }
            }
            return istrue;
        };
        _this_1.clearAllViewAttr = function (key, ignore, form) {
            if (ignore === void 0) { ignore = []; }
            if (form === void 0) { form = _this_1; }
            form.map(function (field) {
                if (("" + field.key).startsWith('field')) {
                    if (ignore.indexOf(field.key) > -1) {
                        return;
                    }
                    field.removeViewAttrs(key);
                }
                else {
                    _this_1.clearAllViewAttr(key, ignore, field);
                }
            });
        };
        _this_1.initDetailDatas = function (datas, detail, allfields, detailDefaultValue, startkey, callback) {
            if (datas === void 0) { datas = []; }
            var _a;
            if (_this_1.has(detail)) {
                var detailTable_2 = _this_1.$(detail);
                var _datas_1 = {};
                var uploadData_1 = {};
                datas.map(function (d, key) {
                    if (startkey) {
                        key = key + startkey;
                    }
                    ;
                    var _d = {};
                    __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](d, function (v, k) {
                        if (k.endsWith('uploadData')) {
                            var _k = k.replace('uploadData', '');
                            var detail_1 = _this_1.card.getFieldProps(_k).detail;
                            uploadData_1[detail_1 + "." + key + "." + _k] = v;
                            return;
                        }
                        if (v && __WEBPACK_IMPORTED_MODULE_2_lodash__["isArray"](v)) {
                            __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](_d, k, Object(__WEBPACK_IMPORTED_MODULE_7____["a" /* deal4ReplaceDatas */])(v, _this_1.card.getFieldProps(k).fieldtype));
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](_d, k, v);
                        }
                    });
                    detailTable_2.add('', { key: key });
                    __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](_datas_1, key, _d);
                });
                if (_this_1.has(detail)) {
                    var _detailDefaultValue_1 = {};
                    // 处理明细表 选择框字段在选项维护中设置的默认值
                    __WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"](allfields, function (field, key) {
                        if (field.detail === detail && field.fieldhtmltype === '5' && field.value) {
                            __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](_detailDefaultValue_1, key, field.value);
                        }
                    });
                    __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](detailDefaultValue, function (v, k) {
                        if (v && __WEBPACK_IMPORTED_MODULE_2_lodash__["isArray"](v)) {
                            __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](_detailDefaultValue_1, k, Object(__WEBPACK_IMPORTED_MODULE_7____["a" /* deal4ReplaceDatas */])(v, _this_1.card.getFieldProps(k).fieldtype));
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_2_lodash__["set"](_detailDefaultValue_1, k, v);
                        }
                    });
                    _this_1.$(detail).detailDefaultValue = _detailDefaultValue_1;
                }
                _this_1.updateValues((_a = {},
                    _a[detail] = _datas_1,
                    _a), allfields, 'init');
                /***明细表初始化完成，回调行列计算 */
                callback && typeof callback == 'function' && callback();
                _this_1.setUploadData(uploadData_1);
            }
        };
        _this_1.setUploadData = function (data) {
            __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](data, function (v, k) {
                try {
                    _this_1.$(k).setUploadData(v);
                }
                catch (e) {
                }
            });
        };
        _this_1.addRow = function (orderid, type) {
            return Object(__WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__["l" /* verifyCustomRegisterEvent */])(__WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].OPER_ADDROW + orderid, function () {
                var _a, _b;
                var fieldname = "detail_" + orderid;
                var field = _this_1.$(fieldname);
                var fields = field.map(function (d) { return parseInt(d.key); });
                var maxIndex = fields.length > 0 ? Math.max.apply(Math, fields) + 1 : 0;
                var key = "" + (maxIndex ? maxIndex : 0);
                field.add('', { key: key });
                var detailDefaultValue = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(field.detailDefaultValue) || {};
                if (type == '0') {
                    detailDefaultValue = __assign({}, detailDefaultValue, { dtl_id: Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["g" /* guid */])(), dtl_index: key });
                }
                _this_1.updateValues((_a = {},
                    _a[fieldname] = (_b = {},
                        _b[key] = detailDefaultValue,
                        _b),
                    _a), _this_1.card.allFields);
                _this_1.card.cubeTrigger.executeWhenAddRow(fieldname, key);
                _this_1.checkPagination(orderid, "add");
                //执行自定义新增行接口，延时解决DOM先变更，函数体取新增行值情况
                __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].triggerAction(__WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].ACTION_ADDROW + orderid, [key], 100);
                /***快速编辑-新增后当前行可编辑 */
                if (type == '0') {
                    var detailkeys = __WEBPACK_IMPORTED_MODULE_2_lodash__["keys"](field.value[0]).filter(function (d) { return d.startsWith('field'); });
                    var detailkeysState_1 = {};
                    __WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"](detailkeys, function (fieldid) {
                        var editstate = _this_1.card.getFieldEditState(fieldid).editstate;
                        if (editstate == '3') {
                            detailkeysState_1[fieldid] = editstate;
                        }
                        field.$(key).$(fieldid).setViewAttrs("", editstate == '2' ? '1' : (editstate == '3' ? '2' : '3'));
                    });
                    var _this = _this_1;
                    _this.card.quickEditStore.addDetals(fieldname, key, detailDefaultValue, detailkeysState_1);
                }
            });
        };
        _this_1.copyRow = function (orderid, type) {
            var fieldname = "detail_" + orderid;
            var field = _this_1.$(fieldname);
            var fields = field.map(function (d) { return parseInt(d.key); });
            var maxIndex = fields.length > 0 ? Math.max.apply(Math, fields) + 1 : 0;
            var selectedKeys = field.map(function (d) { return d; }).filter(function (f) { return f.$('checkbox').values() == '1'; }).map(function (d) { return d.key; });
            if (selectedKeys.length == 0) {
                __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].warning({
                    title: getLabel(558, '提示'),
                    content: React.createElement("div", null, getLabel(31433, '请选择需要复制的数据')),
                });
            }
            var copyRowDatas = [];
            selectedKeys.map(function (d, index) {
                var row = field.$(d);
                var rowValues = row.values() || {};
                var _d = __assign({}, rowValues, { dtl_id: '', checkbox: '0' });
                var newRowKey = "" + (maxIndex + index);
                field.add(_d, { key: newRowKey });
                _this_1.card.cubeTrigger.executeWhenCopyRow(fieldname, newRowKey, rowValues);
                var newRow = field.$(newRowKey);
                for (var key in _d) {
                    newRow.$(key).value = rowValues[key];
                    newRow.$('checkbox').value = '0';
                    if (type == '0') { //快速编辑加个id,方便替换
                        newRow.$('dtl_id').value = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["g" /* guid */])();
                    }
                    else {
                        newRow.$('dtl_id').value = '';
                    }
                    var _a = row.$(key), valueSpan = _a.valueSpan, valueObj = _a.valueObj;
                    newRow.$(key).valueObj = valueObj;
                    newRow.$(key).valueSpan = valueSpan;
                }
                if (_this_1.card.quickEditStore.detalCurrentValue[fieldname] == undefined) {
                    _this_1.card.quickEditStore.detalCurrentValue[fieldname] = [];
                }
                _this_1.card.quickEditStore.detalCurrentValue[fieldname].push({ 'dtl_id': newRow.$('dtl_id').value, 'dtl_index': newRow.$('dtl_index').value });
                if (type == '0') { //复制出来的新行设置为可编辑状态
                    var detailkeys = __WEBPACK_IMPORTED_MODULE_2_lodash__["keys"](field.value[0]).filter(function (d) { return d.startsWith('field'); });
                    var detailkeysState_2 = {};
                    __WEBPACK_IMPORTED_MODULE_2_lodash__["forEach"](detailkeys, function (fieldid) {
                        var editstate = _this_1.card.getFieldEditState(fieldid).editstate;
                        if (editstate == '3') {
                            detailkeysState_2[fieldid] = editstate;
                        }
                        newRow.$(fieldid).setViewAttrs("", editstate == '2' ? '1' : (editstate == '3' ? '2' : '3'));
                    });
                }
                copyRowDatas.push(newRow.value);
            });
            _this_1.checkPagination(orderid, "copy");
            /****
               * 快速编辑--复制的时候直接保存的
              */
            // if (type == '0') {
            //   const _this = this;
            //   setTimeout(()=>{
            //     _this.card.quickEditStore.handleDetals('copy',fieldname,copyRowDatas);
            //   },100)
            // }
        };
        _this_1.delRow = function (orderid, type) {
            return Object(__WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__["l" /* verifyCustomRegisterEvent */])(__WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].OPER_DELROW + orderid, function () {
                var fieldname = "detail_" + orderid;
                var field = _this_1.$(fieldname);
                var values = field.values();
                var delids = __WEBPACK_IMPORTED_MODULE_2_lodash__["compact"](values.filter(function (d) { return d.checkbox == '1'; }).map(function (d) { return __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](d, "dtl_id"); }));
                var delDatas = __WEBPACK_IMPORTED_MODULE_2_lodash__["compact"](values.filter(function (d) { return d.checkbox == '1'; })) || []; //删除的数据,g过滤掉新增未保存的
                // delDatas = delDatas.filter(d=>d[`dtl_id`].length < 30);
                var delkeys = field.map(function (d) { return d; }).filter(function (f) { return f.$('checkbox').values() == '1'; }).map(function (d) { return d.key; });
                if (delkeys.length == 0) {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].warning({
                        title: getLabel(558, '提示'),
                        content: React.createElement("div", null, getLabel(22686, '请选择需要删除的数据')),
                    });
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].confirm({
                    title: getLabel(82873, '请确认'),
                    content: (type == '0' && delDatas.length > 0) ? getLabel('521950', '删除后会执行保存,确定删除吗?') : React.createElement("div", null, getLabel(127574, '确定删除吗？')),
                    onOk: function () {
                        _this_1.card.cubeTrigger.executeWhenDelRow(fieldname, delkeys);
                        __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](delkeys, function (key) { return field.del(key); });
                        if (!_this_1.has("deldtlid" + orderid)) {
                            _this_1.add('', { key: "deldtlid" + orderid });
                        }
                        var detialidField = _this_1.$("deldtlid" + orderid);
                        var oldValue = detialidField.values();
                        var newValue;
                        if (oldValue) {
                            if (delids.length > 0) {
                                newValue = oldValue + "," + delids.join(',');
                            }
                            else {
                                newValue = oldValue;
                            }
                        }
                        else {
                            newValue = delids.join(',');
                        }
                        detialidField.set('value', newValue);
                        _this_1.checkPagination(orderid, 'del');
                        //执行自定义删除行接口
                        __WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].triggerAction(__WEBPACK_IMPORTED_MODULE_9__util_excelUtil__["modeForm"].ACTION_DELROW + orderid, delkeys.slice(), 50);
                        /***快速编辑-删除后确认直接保存 */
                        if (type == '0') {
                            var _this_2 = _this_1;
                            setTimeout(function () {
                                if (delDatas.length > 0) {
                                    _this_2.card.quickEditStore.handleDetals('delete', fieldname, delDatas);
                                }
                            }, 100);
                        }
                    }
                });
            });
        };
        _this_1.delDetailRow = function (detailMark, rowIndexMark) {
            var orderid = detailMark.split("_")[1];
            var field = _this_1.$(detailMark);
            var delkeys = [];
            if (rowIndexMark === "all") {
                delkeys = field.map(function (d) { return d.key; });
            }
            else {
                delkeys = rowIndexMark.split(",").map(function (d) { return Number(d); });
            }
            var fieldname = "detail_" + orderid;
            var values = _this_1.$(fieldname).values();
            var delids = []; //删除的ids
            for (var i = 0; i < delkeys.length; i++) {
                var key = delkeys[i];
                delids.push(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"](values[key], "dtl_id"));
            }
            delids = __WEBPACK_IMPORTED_MODULE_2_lodash__["compact"](delids);
            //删除数据
            __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](delkeys, function (key) { return field.del(key); });
            //保存被删除的数据
            if (!_this_1.has("deldtlid" + orderid)) {
                _this_1.add('', { key: "deldtlid" + orderid });
            }
            var detialidField = _this_1.$("deldtlid" + orderid);
            var oldValue = detialidField.values();
            var newValue = "";
            if (oldValue) {
                if (delids.length > 0) {
                    newValue = oldValue + "," + delids.join(',');
                }
                else {
                    newValue = oldValue;
                }
            }
            else {
                newValue = delids.join(',');
            }
            detialidField.set('value', newValue);
            _this_1.checkPagination(orderid, 'del');
        };
        _this_1.checkAll = function (detail, checked, isNeedPagination, canNotDeleteHis) {
            if (isNeedPagination === void 0) { isNeedPagination = false; }
            var _a = _this_1.$(detail), pageNum = _a.pageNum, pageSize = _a.pageSize;
            _this_1.$(detail).map(function (d, i) {
                if (isNeedPagination && (i < (pageNum - 1) * pageSize || i >= pageNum * pageSize)) {
                    return;
                }
                if (canNotDeleteHis) { //不允许删除已有明细
                    if (!d.value.dtl_id) {
                        d.$('checkbox').set('value', checked ? '1' : '0');
                    }
                }
                else {
                    var rowsObj = _this_1.card.detailMap[detail] && _this_1.card.detailMap[detail]["row_" + d.key];
                    var disableCheck = rowsObj ? rowsObj.disableCheck : false;
                    if (disableCheck) {
                        return;
                    }
                    d.$('checkbox').set('value', checked ? '1' : '0');
                }
            });
        };
        _this_1.controlDetailCheck = function (detailMark, rowId, isCheck) {
            var checked = isCheck ? '1' : '0';
            var form = _this_1.$(detailMark);
            rowId = rowId.indexOf('row_') > -1 ? rowId.replace('row_', '') : rowId;
            form.map(function (d) {
                if (d.key == rowId) {
                    var checkVal = d.$('checkbox').value;
                    if (checkVal == '1') {
                        d.$('checkbox').set('value', checked);
                    }
                }
            });
        };
        _this_1.checkPagination = function (orderid, type) {
            if (type === void 0) { type = ""; }
            var fieldname = "detail_" + orderid;
            var field = _this_1.$(fieldname);
            var pageSize = Number(field.pageSize);
            var pageNum = Number(field.pageNum);
            var total = field.values().length;
            var intPage = Math.ceil(total / pageSize);
            switch (type) {
                case 'add':
                case 'copy':
                    if (pageSize * pageNum < total && pageSize * (pageNum + 1) > total) {
                        field.pageNum = pageNum + 1;
                    }
                    else {
                        field.pageNum = intPage;
                    }
                    break;
                case 'del':
                    if (intPage <= pageNum) {
                        field.pageNum = intPage;
                    }
                    break;
                default:
                    break;
            }
            // if (pageSize * pageNum < total && pageSize * (pageNum+1)>total) {
            //   field.pageNum = pageNum + 1;
            // } else {
            //   for (let i = 0; i < pageNum; i++) {
            //     if (pageSize * i >= total) {
            //       field.pageNum = i;
            //     }
            //   }
            // }
        };
        _this_1.setDate = function (key, start, end) {
            if (start === void 0) { start = null; }
            if (end === void 0) { end = null; }
            if (_this_1.judgeHasKey(key)) {
                return;
            }
            var field = _this_1.$(key);
            field.startDate = start;
            field.endDate = end;
        };
        _this_1.isInit = true;
        _this_1.card = card;
        return _this_1;
    }
    CubeForm.prototype.makeField = function (props) {
        return new CubeField(props, this);
    };
    CubeForm.prototype.dealAnnex = function (field, value) {
        if (value.filedatas) {
            field.uploadData = value;
            if (field.uploadData.filedatas) {
                var v_2 = [];
                field.uploadData.filedatas.forEach(function (item) {
                    v_2.push(item.fileid);
                });
                field.onChange(v_2.join(','));
            }
        }
    };
    CubeForm.prototype.bindings = function () {
        return bindings;
    };
    CubeForm.prototype.plugins = function () {
        return {
            dvr: {
                package: __WEBPACK_IMPORTED_MODULE_4_validatorjs___default.a,
                extend: function ($validator) {
                    $validator.useLang('zh');
                    var messages = $validator.getMessages('zh');
                    $validator.setMessages('zh', messages);
                    Object.keys(rules).forEach(function (key) {
                        return $validator.register(key, rules[key].function, rules[key].message);
                    });
                }
            }
        };
    };
    Object.defineProperty(CubeForm.prototype, "firstErrorField", {
        get: function () {
            if (this.isValid) {
                return false;
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.cube-check-error').first();
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "updateValues", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "initCubeFields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "clearCubeFields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "setValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "getValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "judgeHasKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "clearAllViewAttr", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "initDetailDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "setUploadData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "addRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "copyRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "delRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "delDetailRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "checkAll", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["action"])('重置明细选中情况')
    ], CubeForm.prototype, "controlDetailCheck", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "checkPagination", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], CubeForm.prototype, "setDate", void 0);
    return CubeForm;
}(__WEBPACK_IMPORTED_MODULE_0_mobx_react_form__["Form"]));
/* harmony default export */ __webpack_exports__["a"] = (CubeForm);


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = exports.Form = undefined;

var _mobx = __webpack_require__(4);

var _Form = __webpack_require__(582);

var _Form2 = _interopRequireDefault(_Form);

var _Field = __webpack_require__(350);

var _Field2 = _interopRequireDefault(_Field);

var _Initializer = __webpack_require__(742);

var _Initializer2 = _interopRequireDefault(_Initializer);

var _Helpers = __webpack_require__(743);

var _Helpers2 = _interopRequireDefault(_Helpers);

var _Actions = __webpack_require__(744);

var _Actions2 = _interopRequireDefault(_Actions);

var _Utils = __webpack_require__(745);

var _Utils2 = _interopRequireDefault(_Utils);

var _Events = __webpack_require__(746);

var _Events2 = _interopRequireDefault(_Events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TEST = Object({"NODE_ENV":"production","PUBLIC_URL":"/spa/cube/static"}).TEST;

/**
  Enables MobX strict mode globally (TEST only).
  - - - - - - - - - - - - - - - - - -
  In strict mode, it is not allowed to
  change any state outside of an action
*/


/* shared prototype methods */

if (TEST) {
  if (_mobx.configure) {
    (0, _mobx.configure)({ enforceActions: true });
  } else {
    (0, _mobx.useStrict)(true);
  }
}

/**
  Extend Classes with Prototype
  - - - - - - - - - - - - - - - - - -
  Cannot use Object.assign as @action
  methods on mixins are non-enumerable
*/
var extend = function extend($class, $obj) {
  return $obj.forEach(function (mixin) {
    return Object.getOwnPropertyNames(mixin).forEach(function (name) {
      return $class.prototype[name] = mixin[name];
    });
  });
}; // eslint-disable-line

var shared = [_Initializer2.default, _Actions2.default, _Helpers2.default, _Utils2.default, _Events2.default];

extend(_Form2.default, shared.concat(_Form.prototypes));
extend(_Field2.default, shared.concat(_Field.prototypes));

exports.default = _Form2.default;
exports.Form = _Form2.default;
exports.Field = _Field2.default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prototypes = exports.default = undefined;

var _set2 = __webpack_require__(187);

var _set3 = _interopRequireDefault(_set2);

var _debounce2 = __webpack_require__(295);

var _debounce3 = _interopRequireDefault(_debounce2);

var _merge2 = __webpack_require__(75);

var _merge3 = _interopRequireDefault(_merge2);

var _isFunction2 = __webpack_require__(44);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _each2 = __webpack_require__(53);

var _each3 = _interopRequireDefault(_each2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _desc2, _value2, _obj;

var _mobx = __webpack_require__(4);

var _Base2 = __webpack_require__(313);

var _Base3 = _interopRequireDefault(_Base2);

var _Validator = __webpack_require__(686);

var _Validator2 = _interopRequireDefault(_Validator);

var _State = __webpack_require__(705);

var _State2 = _interopRequireDefault(_State);

var _Field = __webpack_require__(350);

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Form = (_class = function (_Base) {
  _inherits(Form, _Base);

  function Form() {
    var setup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$name = _ref.name,
        name = _ref$name === undefined ? null : _ref$name,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options,
        _ref$plugins = _ref.plugins,
        plugins = _ref$plugins === undefined ? {} : _ref$plugins,
        _ref$bindings = _ref.bindings,
        bindings = _ref$bindings === undefined ? {} : _ref$bindings,
        _ref$hooks = _ref.hooks,
        hooks = _ref$hooks === undefined ? {} : _ref$hooks,
        _ref$handlers = _ref.handlers,
        handlers = _ref$handlers === undefined ? {} : _ref$handlers;

    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this));

    _this.$hooks = {};
    _this.$handlers = {};

    _initDefineProp(_this, '$submitting', _descriptor, _this);

    _initDefineProp(_this, '$validating', _descriptor2, _this);

    _initDefineProp(_this, 'fields', _descriptor3, _this);

    _this.name = name;
    _this.$hooks = hooks;
    _this.$handlers = handlers;

    // load data from initializers methods
    var initial = (0, _each3.default)({
      setup: setup, options: options, plugins: plugins, bindings: bindings
    }, function (val, key) {
      return (0, _isFunction3.default)(_this[key]) ? (0, _merge3.default)(val, _this[key].apply(_this, [_this])) : val;
    });

    _this.state = new _State2.default({
      form: _this,
      initial: initial.setup,
      options: initial.options,
      bindings: initial.bindings
    });

    _this.validator = new _Validator2.default({
      form: _this,
      plugins: initial.plugins,
      schema: initial.setup.schema
    });

    _this.initFields(initial.setup);

    _this.debouncedValidation = (0, _debounce3.default)(_this.validate, _this.state.options.get('validationDebounceWait'), _this.state.options.get('validationDebounceOptions'));

    // execute validation on form initialization
    if (_this.state.options.get('validateOnInit') === true) {
      _this.validator.validate({ showErrors: _this.state.options.get('showErrorsOnInit') });
    }

    _this.execHook('onInit');
    return _this;
  }

  /* ------------------------------------------------------------------ */
  /* COMPUTED */

  _createClass(Form, [{
    key: 'submitting',
    get: function get() {
      return this.$submitting;
    }
  }, {
    key: 'validating',
    get: function get() {
      return this.$validating;
    }
  }, {
    key: 'clearing',
    get: function get() {
      return this.check('clearing', true);
    }
  }, {
    key: 'resetting',
    get: function get() {
      return this.check('resetting', true);
    }
  }, {
    key: 'error',
    get: function get() {
      return this.validator.error;
    }
  }, {
    key: 'hasError',
    get: function get() {
      return !!this.validator.error || this.check('hasError', true);
    }
  }, {
    key: 'isValid',
    get: function get() {
      return !this.validator.error && this.check('isValid', true);
    }
  }, {
    key: 'isDirty',
    get: function get() {
      return this.check('isDirty', true);
    }
  }, {
    key: 'isPristine',
    get: function get() {
      return this.check('isPristine', true);
    }
  }, {
    key: 'isDefault',
    get: function get() {
      return this.check('isDefault', true);
    }
  }, {
    key: 'isEmpty',
    get: function get() {
      return this.check('isEmpty', true);
    }
  }, {
    key: 'focused',
    get: function get() {
      return this.check('focused', true);
    }
  }, {
    key: 'touched',
    get: function get() {
      return this.check('touched', true);
    }
  }, {
    key: 'changed',
    get: function get() {
      return this.check('changed', true);
    }
  }, {
    key: 'disabled',
    get: function get() {
      return this.check('disabled', true);
    }
  }]);

  return Form;
}(_Base3.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '$submitting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, '$validating', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'fields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _mobx.observable.map ? _mobx.observable.map({}) : (0, _mobx.asMap)({});
  }
}), _applyDecoratedDescriptor(_class.prototype, 'submitting', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'submitting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validating', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'validating'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearing', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'clearing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetting', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'resetting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'error', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'error'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasError', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'hasError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isValid', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isValid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDirty', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isPristine', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isPristine'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDefault', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isDefault'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isEmpty', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'isEmpty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'focused', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'focused'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'touched', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'touched'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changed', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'changed'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'disabled', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'disabled'), _class.prototype)), _class);

/**
  Prototypes
*/

exports.default = Form;
var prototypes = exports.prototypes = (_obj = {
  makeField: function makeField(data) {
    return new _Field2.default(data);
  },
  init: function init() {
    var $fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    (0, _set3.default)(this, 'fields', _mobx.observable.map ? _mobx.observable.map({}) : (0, _mobx.asMap)({}));

    this.state.initial.props.values = $fields; // eslint-disable-line
    this.state.current.props.values = $fields; // eslint-disable-line

    this.initFields({
      fields: $fields || this.state.struct()
    });
  },
  invalidate: function invalidate() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    this.validator.error = message || this.state.options.get('defaultGenericError') || true;
  },
  showErrors: function showErrors() {
    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.each(function (field) {
      return field.showErrors(show);
    });
  },
  clear: function clear() {
    this.$touched = false;
    this.$changed = false;
    this.each(function (field) {
      return field.clear(true);
    });
  },
  reset: function reset() {
    this.$touched = false;
    this.$changed = false;
    this.each(function (field) {
      return field.reset(true);
    });
  }
}, (_applyDecoratedDescriptor(_obj, 'init', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'init'), _obj), _applyDecoratedDescriptor(_obj, 'invalidate', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'invalidate'), _obj), _applyDecoratedDescriptor(_obj, 'clear', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'clear'), _obj), _applyDecoratedDescriptor(_obj, 'reset', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'reset'), _obj)), _obj);

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(44),
    isMasked = __webpack_require__(586),
    isObject = __webpack_require__(23),
    toSource = __webpack_require__(294);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(72);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 585 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(587);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(590);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(591);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(191);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(593),
    ListCache = __webpack_require__(123),
    Map = __webpack_require__(192);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(594),
    hashDelete = __webpack_require__(595),
    hashGet = __webpack_require__(596),
    hashHas = __webpack_require__(597),
    hashSet = __webpack_require__(598);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(122);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 595 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(122);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(122);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(122);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 599 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(124);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(124);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(124);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(124);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(125);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 605 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(125);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(125);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(125);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(126),
    assignMergeValue = __webpack_require__(298),
    baseFor = __webpack_require__(299),
    baseMergeDeep = __webpack_require__(616),
    isObject = __webpack_require__(23),
    keysIn = __webpack_require__(76),
    safeGet = __webpack_require__(306);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(123);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 612 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 613 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 614 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(123),
    Map = __webpack_require__(192),
    MapCache = __webpack_require__(191);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(298),
    cloneBuffer = __webpack_require__(301),
    cloneTypedArray = __webpack_require__(302),
    copyArray = __webpack_require__(127),
    initCloneObject = __webpack_require__(304),
    isArguments = __webpack_require__(97),
    isArray = __webpack_require__(13),
    isArrayLikeObject = __webpack_require__(98),
    isBuffer = __webpack_require__(99),
    isFunction = __webpack_require__(44),
    isObject = __webpack_require__(23),
    isPlainObject = __webpack_require__(52),
    isTypedArray = __webpack_require__(130),
    safeGet = __webpack_require__(306),
    toPlainObject = __webpack_require__(620);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 618 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isLength = __webpack_require__(196),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(62),
    keysIn = __webpack_require__(76);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23),
    isPrototype = __webpack_require__(129),
    nativeKeysIn = __webpack_require__(623);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 623 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(625),
    defineProperty = __webpack_require__(292),
    identity = __webpack_require__(78);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(199),
    baseEach = __webpack_require__(79),
    castFunction = __webpack_require__(629),
    isArray = __webpack_require__(13);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(299),
    keys = __webpack_require__(46);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(305);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(78);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(37);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(632),
    baseGt = __webpack_require__(633),
    identity = __webpack_require__(78);

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseGt)
    : undefined;
}

module.exports = max;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(95);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(193);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(315);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(133),
    root = __webpack_require__(21);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(197),
    createCtor = __webpack_require__(133),
    createHybrid = __webpack_require__(319),
    createRecurry = __webpack_require__(322),
    getHolder = __webpack_require__(203),
    replaceHolders = __webpack_require__(136),
    root = __webpack_require__(21);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(201),
    getData = __webpack_require__(323),
    getFuncName = __webpack_require__(640),
    lodash = __webpack_require__(642);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(641);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(201),
    LodashWrapper = __webpack_require__(325),
    baseLodash = __webpack_require__(202),
    isArray = __webpack_require__(13),
    isObjectLike = __webpack_require__(24),
    wrapperClone = __webpack_require__(643);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(201),
    LodashWrapper = __webpack_require__(325),
    copyArray = __webpack_require__(127);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 644 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(199),
    arrayIncludes = __webpack_require__(134);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 648 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(127),
    isIndex = __webpack_require__(96);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(197),
    createCtor = __webpack_require__(133),
    root = __webpack_require__(21);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(320),
    composeArgsRight = __webpack_require__(321),
    replaceHolders = __webpack_require__(136);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(51);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(655),
    getMatchData = __webpack_require__(664),
    matchesStrictComparable = __webpack_require__(337);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(126),
    baseIsEqual = __webpack_require__(206);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(126),
    equalArrays = __webpack_require__(329),
    equalByTag = __webpack_require__(659),
    equalObjects = __webpack_require__(661),
    getTag = __webpack_require__(101),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(99),
    isTypedArray = __webpack_require__(130);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 658 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(72),
    Uint8Array = __webpack_require__(303),
    eq = __webpack_require__(94),
    equalArrays = __webpack_require__(329),
    mapToArray = __webpack_require__(660),
    setToArray = __webpack_require__(207);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 660 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(331);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(21);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(336),
    keys = __webpack_require__(46);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(206),
    get = __webpack_require__(140),
    hasIn = __webpack_require__(338),
    isKey = __webpack_require__(190),
    isStrictComparable = __webpack_require__(336),
    matchesStrictComparable = __webpack_require__(337),
    toKey = __webpack_require__(74);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 666 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(668),
    basePropertyDeep = __webpack_require__(669),
    isKey = __webpack_require__(190),
    toKey = __webpack_require__(74);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 668 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(141);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(79),
    isArrayLike = __webpack_require__(45);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(210),
    baseRest = __webpack_require__(77),
    baseUniq = __webpack_require__(673),
    isArrayLikeObject = __webpack_require__(98);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(72),
    isArguments = __webpack_require__(97),
    isArray = __webpack_require__(13);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(138),
    arrayIncludes = __webpack_require__(134),
    arrayIncludesWith = __webpack_require__(211),
    cacheHas = __webpack_require__(139),
    createSet = __webpack_require__(674),
    setToArray = __webpack_require__(207);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(335),
    noop = __webpack_require__(324),
    setToArray = __webpack_require__(207);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 675 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(77),
    createWrap = __webpack_require__(315),
    getHolder = __webpack_require__(203),
    replaceHolders = __webpack_require__(136);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 677 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 678 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(138),
    arrayIncludes = __webpack_require__(134),
    arrayIncludesWith = __webpack_require__(211),
    arrayMap = __webpack_require__(51),
    baseUnary = __webpack_require__(61),
    cacheHas = __webpack_require__(139);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(98);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(682),
    baseEvery = __webpack_require__(683),
    baseIteratee = __webpack_require__(40),
    isArray = __webpack_require__(13),
    isIterateeCall = __webpack_require__(131);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 682 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(79);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(330),
    baseIteratee = __webpack_require__(40),
    baseSome = __webpack_require__(685),
    isArray = __webpack_require__(13),
    isIterateeCall = __webpack_require__(131);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(79);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isEmpty2 = __webpack_require__(81);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _isNil2 = __webpack_require__(83);

var _isNil3 = _interopRequireDefault(_isNil2);

var _each2 = __webpack_require__(53);

var _each3 = _interopRequireDefault(_each2);

var _isString2 = __webpack_require__(47);

var _isString3 = _interopRequireDefault(_isString2);

var _map2 = __webpack_require__(137);

var _map3 = _interopRequireDefault(_map2);

var _merge2 = __webpack_require__(75);

var _merge3 = _interopRequireDefault(_merge2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor; // Vanilla JavaScript Functions
// Json Schema Validation Keywords


var _mobx = __webpack_require__(4);

var _utils = __webpack_require__(27);

var _VJF = __webpack_require__(687);

var _VJF2 = _interopRequireDefault(_VJF);

var _SVK = __webpack_require__(688);

var _SVK2 = _interopRequireDefault(_SVK);

var _DVR = __webpack_require__(698);

var _DVR2 = _interopRequireDefault(_DVR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

// Declarative Validation Rules

var Validator = (_class = function () {
  function Validator() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Validator);

    this.promises = [];
    this.form = {};
    this.options = {};
    this.schema = {};
    this.plugins = {
      vjf: true,
      dvr: false,
      svk: false
    };
    this.drivers = {};

    _initDefineProp(this, 'error', _descriptor, this);

    (0, _merge3.default)(this.plugins, obj.plugins);
    this.form = obj.form;
    this.schema = obj.schema || {};
    this.initDrivers({ vjf: _VJF2.default, dvr: _DVR2.default, svk: _SVK2.default });
    this.checkSVKValidationPlugin();
  }

  _createClass(Validator, [{
    key: 'initDrivers',
    value: function initDrivers(drivers) {
      var _this = this;

      // eslint-disable-next-line
      (0, _map3.default)(drivers, function (Class, key) {
        return _this.plugins[key] && (_this.drivers[key] = new Class(_this.plugins[key], {
          schema: key === 'svk' ? _this.schema : null,
          options: _this.form.state.options,
          promises: _this.promises
        }));
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      var _this2 = this;

      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var path = (0, _utils.$try)(opt.path, opt);
      var field = (0, _utils.$try)(opt.field, this.form.select(path, null, null));
      var related = (0, _utils.$try)(opt.related, obj.related, true);
      var showErrors = (0, _utils.$try)(opt.showErrors, obj.showErrors, false);
      var instance = field || this.form;
      instance.$validating = true;
      this.error = null;

      return new Promise(function (resolve) {
        // validate instance (form or filed)
        if (instance.path || (0, _isString3.default)(path)) {
          _this2.validateField({
            field: instance,
            showErrors: showErrors,
            related: related,
            path: path
          });
        }

        // validate nested fields
        instance.each(function ($field) {
          return _this2.validateField({
            path: $field.path,
            field: $field,
            showErrors: showErrors,
            related: related
          });
        });

        // wait all promises
        resolve(Promise.all(_this2.promises));
      }).then((0, _mobx.action)(function () {
        instance.$validating = false;
        instance.$clearing = false;
        instance.$resetting = false;
      })).catch((0, _mobx.action)(function (err) {
        instance.$validating = false;
        instance.$clearing = false;
        instance.$resetting = false;
        throw err;
      })).then(function () {
        return instance;
      });
    }
  }, {
    key: 'validateField',
    value: function validateField(_ref) {
      var _this3 = this;

      var _ref$field = _ref.field,
          field = _ref$field === undefined ? null : _ref$field,
          path = _ref.path,
          _ref$showErrors = _ref.showErrors,
          showErrors = _ref$showErrors === undefined ? false : _ref$showErrors,
          _ref$related = _ref.related,
          related = _ref$related === undefined ? false : _ref$related;

      var instance = field || this.form.select(path);
      // check if the field is a valid instance
      if (!instance.path) throw new Error('Validation Error: Invalid Field Instance');
      // do not validate disabled fields
      if (instance.disabled && !this.form.state.options.get('validateDisabledFields')) return;
      // reset field validation
      instance.resetValidation();
      // validate with all drivers
      (0, _each3.default)(this.drivers, function (driver) {
        return driver.validateField(instance, _this3.form);
      });
      // send error to the view
      instance.showErrors(showErrors);
      // related validation
      if (related) this.relatedFieldValidation(instance, showErrors);
    }

    /**
      Validate 'related' fields if specified
      and related validation allowed (recursive)
    */

  }, {
    key: 'relatedFieldValidation',
    value: function relatedFieldValidation(field, showErrors) {
      var _this4 = this;

      if (!field.related || !field.related.length) return;

      (0, _each3.default)(field.related, function (path) {
        return _this4.validateField({ path: path, showErrors: showErrors, related: false });
      });
    }
  }, {
    key: 'checkSVKValidationPlugin',
    value: function checkSVKValidationPlugin() {
      if ((0, _isNil3.default)(this.drivers.svk) && !(0, _isEmpty3.default)(this.schema)) {
        // eslint-disable-next-line
        console.warn('The SVK validation schema is defined', 'but no plugin provided (SVK).');
      }
    }
  }]);

  return Validator;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'error', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'validate', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'validate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validateField', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'validateField'), _class.prototype)), _class);
exports.default = Validator;
module.exports = exports['default'];

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isString2 = __webpack_require__(47);

var _isString3 = _interopRequireDefault(_isString2);

var _isBoolean2 = __webpack_require__(132);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _isFunction2 = __webpack_require__(44);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _isPlainObject2 = __webpack_require__(52);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mobx = __webpack_require__(4);

var _utils = __webpack_require__(27);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
  Vanilla JavaScript Functions
*/
var VJF = function () {
  function VJF(plugin, _ref) {
    var _ref$promises = _ref.promises,
        promises = _ref$promises === undefined ? [] : _ref$promises,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;

    _classCallCheck(this, VJF);

    this.validator = null;

    if ((0, _isPlainObject3.default)(plugin)) {
      this.validator = plugin;
    }

    this.promises = promises;
    this.options = options;
  }

  _createClass(VJF, [{
    key: 'validateField',
    value: function validateField(field, form) {
      var _this = this;

      // exit if field does not have validation functions
      if (!field.validators) return;

      // get validators from validate property
      var $fn = (0, _mobx.toJS)(field.validators);

      // map only if is an array of validator functions
      if ((0, _isArray3.default)($fn)) {
        $fn.map(function (fn) {
          return _this.collectData(fn, field, form);
        });
      }

      // it's just one function
      if ((0, _isFunction3.default)($fn)) {
        this.collectData($fn, field, form);
      }

      // execute the function validation
      this.executeValidation(field);
    }
  }, {
    key: 'collectData',
    value: function collectData($fn, field, form) {
      var _this2 = this;

      var res = this.handleFunctionResult($fn, field, form);

      // check and execute only if is a promise
      if (_utils2.default.isPromise(res)) {
        var $p = res.then(function ($res) {
          return field.setValidationAsyncData($res[0], $res[1]);
        }).then(function () {
          return _this2.executeAsyncValidation(field);
        }).then(function () {
          return field.showAsyncErrors();
        });

        // push the promise into array
        this.promises.push($p);
        return;
      }

      // is a plain function
      field.validationFunctionsData.unshift({
        valid: res[0],
        message: res[1]
      });
    }
  }, {
    key: 'executeValidation',
    value: function executeValidation(field) {
      // otherwise find an error message to show
      field.validationFunctionsData.map(function (rule) {
        return rule.valid === false && field.invalidate(rule.message);
      });
    }
  }, {
    key: 'executeAsyncValidation',
    value: function executeAsyncValidation(field) {
      if (field.validationAsyncData.valid === false) {
        field.invalidate(field.validationAsyncData.message, true);
      }
    }
  }, {
    key: 'handleFunctionResult',
    value: function handleFunctionResult($fn, field, form) {
      // executre validation function
      var res = $fn({ field: field, form: form, validator: this.validator });

      /**
        Handle "array"
      */
      if ((0, _isArray3.default)(res)) {
        var isValid = res[0] || false;
        var message = res[1] || 'Error';
        return [isValid, message];
      }

      /**
        Handle "boolean"
      */
      if ((0, _isBoolean3.default)(res)) {
        return [res, 'Error'];
      }

      /**
        Handle "string"
      */
      if ((0, _isString3.default)(res)) {
        return [false, res];
      }

      /**
        Handle "object / promise"
      */
      if (_utils2.default.isPromise(res)) {
        return res; // the promise
      }

      /**
        Handle other cases
      */
      return [false, 'Error'];
    }
  }]);

  return VJF;
}();

exports.default = VJF;
module.exports = exports['default'];

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isNaN2 = __webpack_require__(689);

var _isNaN3 = _interopRequireDefault(_isNaN2);

var _isNull2 = __webpack_require__(690);

var _isNull3 = _interopRequireDefault(_isNull2);

var _isEmpty2 = __webpack_require__(81);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _omitBy2 = __webpack_require__(691);

var _omitBy3 = _interopRequireDefault(_omitBy2);

var _includes2 = __webpack_require__(694);

var _includes3 = _interopRequireDefault(_includes2);

var _trim2 = __webpack_require__(142);

var _trim3 = _interopRequireDefault(_trim2);

var _trimStart2 = __webpack_require__(214);

var _trimStart3 = _interopRequireDefault(_trimStart2);

var _find2 = __webpack_require__(695);

var _find3 = _interopRequireDefault(_find2);

var _isUndefined2 = __webpack_require__(200);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _isFunction2 = __webpack_require__(44);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(27);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
  Schema Validation Keywords

    const plugins = {
      svk: {
        package: ajv,
        extend: callback,
      },
    };

*/
var SVK = function () {
  function SVK(plugin) {
    var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SVK);

    this.validate = null;
    this.extend = null;
    this.promises = [];
    this.schema = {};

    this.assignInitData(plugin, obj);
    this.initAJV(plugin);
  }

  _createClass(SVK, [{
    key: 'assignInitData',
    value: function assignInitData(plugin, _ref) {
      var _ref$options = _ref.options,
          options = _ref$options === undefined ? {} : _ref$options,
          _ref$schema = _ref.schema,
          schema = _ref$schema === undefined ? {} : _ref$schema,
          _ref$promises = _ref.promises,
          promises = _ref$promises === undefined ? [] : _ref$promises;

      options.set({
        ajv: {
          v5: true,
          allErrors: true,
          coerceTypes: true,
          errorDataPath: 'property'
        }
      });

      this.options = options;
      this.schema = schema;
      this.promises = promises;
      this.extend = plugin.extend;
    }
  }, {
    key: 'initAJV',
    value: function initAJV(plugin) {
      if (!this.schema) return;
      // get ajv package
      var AJV = plugin.package || plugin;
      // create ajv instance
      var ajvInstance = new AJV(this.options.get('ajv'));
      // extend ajv using "extend" callback
      if ((0, _isFunction3.default)(this.extend)) this.extend(ajvInstance);
      // create ajvInstance validator (compiling rules)
      this.validate = ajvInstance.compile(this.schema);
    }
  }, {
    key: 'validateField',
    value: function validateField(field) {
      var _this = this;

      var data = _defineProperty({}, field.path, field.validatedValue);
      var validate = this.validate(this.parseValues(data));
      // check if is $async schema
      if (_utils2.default.isPromise(validate)) {
        var $p = validate.then(function () {
          return field.setValidationAsyncData(true);
        }).catch(function (err) {
          return err && _this.handleAsyncError(field, err.errors);
        }).then(function () {
          return _this.executeAsyncValidation(field);
        }).then(function () {
          return field.showAsyncErrors();
        });

        // push the promise into array
        this.promises.push($p);
        return;
      }
      // check sync errors
      this.handleSyncError(field, this.validate.errors);
    }
  }, {
    key: 'handleSyncError',
    value: function handleSyncError(field, errors) {
      var fieldErrorObj = this.findError(field.key, errors);
      // if fieldErrorObj is not undefined, the current field is invalid.
      if ((0, _isUndefined3.default)(fieldErrorObj)) return;
      // the current field is now invalid
      // add additional info to the message
      var msg = field.label + ' ' + fieldErrorObj.message;
      // invalidate the current field with message
      field.invalidate(msg);
    }
  }, {
    key: 'handleAsyncError',
    value: function handleAsyncError(field, errors) {
      // find current field error message from ajv errors
      var fieldErrorObj = this.findError(field.path, errors);
      // if fieldErrorObj is not undefined, the current field is invalid.
      if ((0, _isUndefined3.default)(fieldErrorObj)) return;
      // the current field is now invalid
      // add additional info to the message
      var msg = field.label + ' ' + fieldErrorObj.message;
      // set async validation data on the field
      field.setValidationAsyncData(false, msg);
    }
  }, {
    key: 'findError',
    value: function findError(path, errors) {
      return (0, _find3.default)(errors, function (_ref2) {
        var dataPath = _ref2.dataPath;

        var $dataPath = void 0;
        $dataPath = (0, _trimStart3.default)(dataPath, '.');
        $dataPath = (0, _trim3.default)($dataPath, '[\'');
        $dataPath = (0, _trim3.default)($dataPath, '\']');
        return (0, _includes3.default)($dataPath, '' + path);
      });
    }
  }, {
    key: 'executeAsyncValidation',
    value: function executeAsyncValidation(field) {
      if (field.validationAsyncData.valid === false) {
        field.invalidate(field.validationAsyncData.message, true);
      }
    }
  }, {
    key: 'parseValues',
    value: function parseValues(values) {
      if (this.options.get('allowRequired') === true) {
        return (0, _omitBy3.default)(values, _isEmpty3.default || _isNull3.default || _isUndefined3.default || _isNaN3.default);
      }
      return values;
    }
  }]);

  return SVK;
}();

exports.default = SVK;
module.exports = exports['default'];

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(212);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 690 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(40),
    negate = __webpack_require__(692),
    pickBy = __webpack_require__(693);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 692 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(51),
    baseIteratee = __webpack_require__(40),
    basePickBy = __webpack_require__(346),
    getAllKeysIn = __webpack_require__(213);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(135),
    isArrayLike = __webpack_require__(45),
    isString = __webpack_require__(47),
    toInteger = __webpack_require__(80),
    values = __webpack_require__(205);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(696),
    findIndex = __webpack_require__(697);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(40),
    isArrayLike = __webpack_require__(45),
    keys = __webpack_require__(46);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(328),
    baseIteratee = __webpack_require__(40),
    toInteger = __webpack_require__(80);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _intersection2 = __webpack_require__(345);

var _intersection3 = _interopRequireDefault(_intersection2);

var _difference2 = __webpack_require__(699);

var _difference3 = _interopRequireDefault(_difference2);

var _split2 = __webpack_require__(145);

var _split3 = _interopRequireDefault(_split2);

var _isString2 = __webpack_require__(47);

var _isString3 = _interopRequireDefault(_isString2);

var _first2 = __webpack_require__(702);

var _first3 = _interopRequireDefault(_first2);

var _isEmpty2 = __webpack_require__(81);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _isFunction2 = __webpack_require__(44);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _extend2 = __webpack_require__(703);

var _extend3 = _interopRequireDefault(_extend2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
  Declarative Validation Rules

    const plugins = {
      dvr: {
        package: validatorjs,
        extend: callback,
      },
    };

*/
var DVR = function () {
  function DVR(plugin) {
    var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DVR);

    this.promises = [];
    this.asyncRules = [];
    this.validators = {};
    this.validator = null;
    this.extend = null;

    this.assignInitData(plugin, obj);
    this.extendValidator();
  }

  _createClass(DVR, [{
    key: 'assignInitData',
    value: function assignInitData(plugin, _ref) {
      var _ref$options = _ref.options,
          options = _ref$options === undefined ? {} : _ref$options,
          _ref$promises = _ref.promises,
          promises = _ref$promises === undefined ? [] : _ref$promises;

      this.options = options;
      this.promises = promises;
      this.extend = plugin.extend;
      this.validator = plugin.package || plugin;
    }
  }, {
    key: 'extendValidator',
    value: function extendValidator() {
      var _this = this;

      // extend the validator with custom "registerAsyncRule" method
      (0, _extend3.default)(this.validator, {
        registerAsyncRule: function registerAsyncRule(key, callback) {
          return _this.registerAsyncRule(key, callback);
        }
      });
      // extend using "extend" callback
      if ((0, _isFunction3.default)(this.extend)) this.extend(this.validator);
    }
  }, {
    key: 'validateField',
    value: function validateField(field, form) {
      // get form fields data
      var data = {}; // eslint-disable-next-line
      form.each(function ($field) {
        return data[$field.path] = $field.validatedValue;
      });
      this.validateFieldAsync(field, form, data);
      this.validateFieldSync(field, form, data);
    }
  }, {
    key: 'validateFieldSync',
    value: function validateFieldSync(field, form, data) {
      var $rules = this.rules(field.rules, 'sync');
      // exit if no rules found
      if ((0, _isEmpty3.default)($rules[0])) return;
      // get field rules
      var rules = _defineProperty({}, field.path, $rules);
      // create the validator instance
      var Validator = this.validator;
      var validation = new Validator(data, rules);
      // set label into errors messages instead key
      validation.setAttributeNames(_defineProperty({}, field.path, field.label));
      // check validation
      if (validation.passes()) return;
      // the validation is failed, set the field error
      field.invalidate((0, _first3.default)(validation.errors.get(field.path)));
    }
  }, {
    key: 'validateFieldAsync',
    value: function validateFieldAsync(field, form, data) {
      var _this2 = this;

      var $rules = this.rules(field.rules, 'async');
      // exit if no rules found
      if ((0, _isEmpty3.default)($rules[0])) return;
      // get field rules
      var rules = _defineProperty({}, field.path, $rules);
      // create the validator instance
      var Validator = this.validator;
      var validation = new Validator(data, rules);
      // set label into errors messages instead key
      validation.setAttributeNames(_defineProperty({}, field.path, field.label));

      var $p = new Promise(function (resolve) {
        return validation.checkAsync(function () {
          return _this2.handleAsyncPasses(field, resolve);
        }, function () {
          return _this2.handleAsyncFails(field, validation, resolve);
        });
      });

      this.promises.push($p);
    }
  }, {
    key: 'handleAsyncPasses',
    value: function handleAsyncPasses(field, resolve) {
      field.setValidationAsyncData(true);
      field.showAsyncErrors();
      resolve();
    }
  }, {
    key: 'handleAsyncFails',
    value: function handleAsyncFails(field, validation, resolve) {
      field.setValidationAsyncData(false, (0, _first3.default)(validation.errors.get(field.path)));
      this.executeAsyncValidation(field);
      field.showAsyncErrors();
      resolve();
    }
  }, {
    key: 'executeAsyncValidation',
    value: function executeAsyncValidation(field) {
      if (field.validationAsyncData.valid === false) {
        field.invalidate(field.validationAsyncData.message, true);
      }
    }
  }, {
    key: 'registerAsyncRule',
    value: function registerAsyncRule(key, callback) {
      this.asyncRules.push(key);
      this.validator.registerAsync(key, callback);
    }
  }, {
    key: 'rules',
    value: function rules(_rules, type) {
      var $rules = (0, _isString3.default)(_rules) ? (0, _split3.default)(_rules, '|') : _rules;
      if (type === 'sync') return (0, _difference3.default)($rules, this.asyncRules);
      if (type === 'async') return (0, _intersection3.default)($rules, this.asyncRules);
      return [];
    }
  }]);

  return DVR;
}();

exports.default = DVR;
module.exports = exports['default'];

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(348),
    baseFlatten = __webpack_require__(210),
    baseRest = __webpack_require__(77),
    isArrayLikeObject = __webpack_require__(98);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(701),
    baseUnary = __webpack_require__(61),
    nodeUtil = __webpack_require__(100);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(215);


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(704);


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(62),
    createAssigner = __webpack_require__(308),
    keysIn = __webpack_require__(76);

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function(object, source) {
  copyObject(source, keysIn(source), object);
});

module.exports = assignIn;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _get2 = __webpack_require__(140);

var _get3 = _interopRequireDefault(_get2);

var _isString2 = __webpack_require__(47);

var _isString3 = _interopRequireDefault(_isString2);

var _pick2 = __webpack_require__(706);

var _pick3 = _interopRequireDefault(_pick2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mobx = __webpack_require__(4);

var _Options = __webpack_require__(709);

var _Options2 = _interopRequireDefault(_Options);

var _Bindings = __webpack_require__(710);

var _Bindings2 = _interopRequireDefault(_Bindings);

var _utils = __webpack_require__(27);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var State = function () {
  function State(_ref) {
    var form = _ref.form,
        initial = _ref.initial,
        options = _ref.options,
        bindings = _ref.bindings;

    _classCallCheck(this, State);

    this.strict = false;
    this.disposers = {
      interceptor: {},
      observer: {}
    };
    this.$struct = [];
    this.initial = {
      props: {},
      fields: {}
    };
    this.current = {
      props: {},
      fields: {}
    };

    this.set('form', form);
    this.initProps(initial);
    this.options = new _Options2.default();
    this.options.set(options);
    this.bindings = new _Bindings2.default();
    this.bindings.register(bindings);
    this.observeOptions();
  }

  _createClass(State, [{
    key: 'initProps',
    value: function initProps(initial) {
      var initialProps = (0, _pick3.default)(initial, [].concat(_toConsumableArray(_utils2.default.props.separated), _toConsumableArray(_utils2.default.props.validation), _toConsumableArray(_utils2.default.props.function), _toConsumableArray(_utils2.default.props.handlers)));

      this.set('initial', 'props', initialProps);

      var $unified = _utils2.default.hasUnifiedProps(initial);
      var $separated = _utils2.default.hasSeparatedProps(initial);

      if ($unified && $separated) {
        console.warn( // eslint-disable-line
        'WARNING: Your mobx-react-form instance ', this.form.name, ' is running in MIXED Mode (Unified + Separated) as fields properties definition.', 'This mode is experimental, use it at your own risk, or use only one mode.');
      }

      if (($separated || _utils2.default.isStruct(initial.fields)) && !$unified) {
        var struct = _utils2.default.$try(initial.struct || initial.fields);
        this.struct(struct);
        this.strict = true;
        this.mode = 'separated';
        return;
      }

      this.struct(initial.struct);
      this.mode = 'unified';
    }

    /**
      Get/Set Fields Structure
    */

  }, {
    key: 'struct',
    value: function struct() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (data) this.$struct = data;
      return this.$struct;
    }

    /**
      Get Props/Fields
    */

  }, {
    key: 'get',
    value: function get(type, subtype) {
      return this[type][subtype];
    }

    /**
      Set Props/Fields
    */

  }, {
    key: 'set',
    value: function set(type, subtype) {
      var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (type === 'form') {
        // subtype is the form here
        this.form = subtype;
      }

      if (type === 'initial') {
        Object.assign(this.initial[subtype], state);
        Object.assign(this.current[subtype], state);
      }

      if (type === 'current') {
        Object.assign(this.current[subtype], state);
      }
    }
  }, {
    key: 'extra',
    value: function extra() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if ((0, _isString3.default)(data)) return (0, _get3.default)(this.$extra, data);
      if (data === null) return this.$extra;
      this.$extra = data;
      return null;
    }
  }, {
    key: 'observeOptions',
    value: function observeOptions() {
      var _this = this;

      // Fix Issue #201
      (0, _mobx.observe)(this.options.options, _utils2.default.checkObserve([{
        // start observing fields validateOnChange
        type: 'update',
        key: 'validateOnChange',
        to: true,
        exec: function exec() {
          return _this.form.each(function (field) {
            return field.observeValidationOnChange();
          });
        }
      }, {
        // stop observing fields validateOnChange
        type: 'update',
        key: 'validateOnChange',
        to: false,
        exec: function exec() {
          return _this.form.each(function (field) {
            return field.disposeValidationOnChange();
          });
        }
      }, {
        // start observing fields validateOnBlur
        type: 'update',
        key: 'validateOnBlur',
        to: true,
        exec: function exec() {
          return _this.form.each(function (field) {
            return field.observeValidationOnBlur();
          });
        }
      }, {
        // stop observing fields validateOnBlur
        type: 'update',
        key: 'validateOnBlur',
        to: false,
        exec: function exec() {
          return _this.form.each(function (field) {
            return field.disposeValidationOnBlur();
          });
        }
      }]));
    }
  }]);

  return State;
}();

exports.default = State;
module.exports = exports['default'];

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(707),
    flatRest = __webpack_require__(349);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(346),
    hasIn = __webpack_require__(338);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(210);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _has2 = __webpack_require__(82);

var _has3 = _interopRequireDefault(_has2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor;

var _mobx = __webpack_require__(4);

var _utils = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Options = (_class = function () {
  function Options() {
    _classCallCheck(this, Options);

    _initDefineProp(this, 'options', _descriptor, this);
  }

  _createClass(Options, [{
    key: 'get',
    value: function get() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // handle field option
      if ((0, _has3.default)(field, 'path')) {
        if ((0, _has3.default)(field.$options, key)) {
          return field.$options[key];
        }
      }

      // fallback on global form options
      if (key) return this.options[key];
      return (0, _mobx.toJS)(this.options);
    }
  }, {
    key: 'set',
    value: function set(options) {
      if (_mobx.set) {
        (0, _mobx.set)(this.options, options);
      } else {
        (0, _mobx.extendObservable)(this.options, options);
      }
    }
  }]);

  return Options;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'options', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      uniqueId: _utils.uniqueId,
      defaultGenericError: null,
      submitThrowsError: true,
      showErrorsOnInit: false,
      showErrorsOnSubmit: true,
      showErrorsOnBlur: true,
      showErrorsOnChange: true,
      showErrorsOnClear: false,
      showErrorsOnReset: true,
      validateOnInit: true,
      validateOnBlur: true,
      validateOnChange: false,
      validateDisabledFields: false,
      strictUpdate: false,
      strictDelete: true,
      retrieveOnlyDirtyValues: false,
      retrieveOnlyEnabledFields: false,
      autoParseNumbers: false,
      allowRequired: false,
      validationDebounceWait: 250,
      validationDebounceOptions: {
        leading: false,
        trailing: true
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'set', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'set'), _class.prototype)), _class);
exports.default = Options;
module.exports = exports['default'];

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _isPlainObject2 = __webpack_require__(52);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isFunction2 = __webpack_require__(44);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _merge5 = __webpack_require__(75);

var _merge6 = _interopRequireDefault(_merge5);

var _each2 = __webpack_require__(53);

var _each3 = _interopRequireDefault(_each2);

var _has2 = __webpack_require__(82);

var _has3 = _interopRequireDefault(_has2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bindings = function () {
  function Bindings() {
    _classCallCheck(this, Bindings);

    this.templates = {
      // default: ({ field, props, keys, $try }) => ({
      //   [keys.id]: $try(props.id, field.id),
      // }),
    };
    this.rewriters = {
      default: {
        id: 'id',
        name: 'name',
        type: 'type',
        value: 'value',
        checked: 'checked',
        label: 'label',
        placeholder: 'placeholder',
        disabled: 'disabled',
        onChange: 'onChange',
        onBlur: 'onBlur',
        onFocus: 'onFocus',
        autoFocus: 'autoFocus'
      }
    };
  }

  _createClass(Bindings, [{
    key: 'load',
    value: function load(field) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      var props = arguments[2];

      if ((0, _has3.default)(this.rewriters, name)) {
        var $bindings = {};

        (0, _each3.default)(this.rewriters[name], function ($v, $k) {
          return (0, _merge6.default)($bindings, _defineProperty({}, $v, (0, _utils.$try)(props[$k], field[$k])));
        });

        return $bindings;
      }

      return this.templates[name]({
        keys: this.rewriters[name],
        $try: _utils.$try,
        field: field,
        props: props
      });
    }
  }, {
    key: 'register',
    value: function register(bindings) {
      var _this = this;

      (0, _each3.default)(bindings, function (val, key) {
        if ((0, _isFunction3.default)(val)) (0, _merge6.default)(_this.templates, _defineProperty({}, key, val));
        if ((0, _isPlainObject3.default)(val)) (0, _merge6.default)(_this.rewriters, _defineProperty({}, key, val));
      });

      return this;
    }
  }]);

  return Bindings;
}();

exports.default = Bindings;
module.exports = exports['default'];

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(51),
    baseClone = __webpack_require__(712),
    baseUnset = __webpack_require__(726),
    castPath = __webpack_require__(73),
    copyObject = __webpack_require__(62),
    customOmitClone = __webpack_require__(728),
    flatRest = __webpack_require__(349),
    getAllKeysIn = __webpack_require__(213);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(126),
    arrayEach = __webpack_require__(199),
    assignValue = __webpack_require__(188),
    baseAssign = __webpack_require__(713),
    baseAssignIn = __webpack_require__(714),
    cloneBuffer = __webpack_require__(301),
    copyArray = __webpack_require__(127),
    copySymbols = __webpack_require__(715),
    copySymbolsIn = __webpack_require__(716),
    getAllKeys = __webpack_require__(331),
    getAllKeysIn = __webpack_require__(213),
    getTag = __webpack_require__(101),
    initCloneArray = __webpack_require__(717),
    initCloneByTag = __webpack_require__(718),
    initCloneObject = __webpack_require__(304),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(99),
    isMap = __webpack_require__(722),
    isObject = __webpack_require__(23),
    isSet = __webpack_require__(724),
    keys = __webpack_require__(46),
    keysIn = __webpack_require__(76);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(62),
    keys = __webpack_require__(46);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(62),
    keysIn = __webpack_require__(76);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(62),
    getSymbols = __webpack_require__(209);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(62),
    getSymbolsIn = __webpack_require__(347);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(194),
    cloneDataView = __webpack_require__(719),
    cloneRegExp = __webpack_require__(720),
    cloneSymbol = __webpack_require__(721),
    cloneTypedArray = __webpack_require__(302);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(194);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 720 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(72);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(723),
    baseUnary = __webpack_require__(61),
    nodeUtil = __webpack_require__(100);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(101),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(725),
    baseUnary = __webpack_require__(61),
    nodeUtil = __webpack_require__(100);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(101),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(73),
    last = __webpack_require__(216),
    parent = __webpack_require__(727),
    toKey = __webpack_require__(74);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(141),
    baseSlice = __webpack_require__(340);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(52);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(206);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(351),
    baseToString = __webpack_require__(60),
    toInteger = __webpack_require__(80),
    toString = __webpack_require__(37);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null
    ? 0
    : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(333),
    baseFilter = __webpack_require__(732),
    baseIteratee = __webpack_require__(40),
    isArray = __webpack_require__(13);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(79);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 733 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(351),
    baseToString = __webpack_require__(60),
    toInteger = __webpack_require__(80),
    toString = __webpack_require__(37);

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = toString(string);
  target = baseToString(target);

  var length = string.length;
  position = position === undefined
    ? length
    : baseClamp(toInteger(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

module.exports = endsWith;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduceRight = __webpack_require__(736),
    baseEachRight = __webpack_require__(737),
    baseIteratee = __webpack_require__(40),
    baseReduce = __webpack_require__(353),
    isArray = __webpack_require__(13);

/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduceRight : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
}

module.exports = reduceRight;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

module.exports = arrayReduceRight;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwnRight = __webpack_require__(738),
    createBaseEach = __webpack_require__(312);

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

module.exports = baseEachRight;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var baseForRight = __webpack_require__(739),
    keys = __webpack_require__(46);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(300);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(348),
    baseRest = __webpack_require__(77),
    isArrayLikeObject = __webpack_require__(98);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(21),
    toString = __webpack_require__(37);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeParseInt = root.parseInt;

/**
 * Converts `string` to an integer of the specified radix. If `radix` is
 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
 * hexadecimal, in which case a `radix` of `16` is used.
 *
 * **Note:** This method aligns with the
 * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category String
 * @param {string} string The string to convert.
 * @param {number} [radix=10] The radix to interpret `value` by.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.parseInt('08');
 * // => 8
 *
 * _.map(['6', '08', '10'], _.parseInt);
 * // => [6, 8, 10]
 */
function parseInt(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
}

module.exports = parseInt;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = __webpack_require__(140);

var _get3 = _interopRequireDefault(_get2);

var _isNil2 = __webpack_require__(83);

var _isNil3 = _interopRequireDefault(_isNil2);

var _each2 = __webpack_require__(53);

var _each3 = _interopRequireDefault(_each2);

var _trimStart2 = __webpack_require__(214);

var _trimStart3 = _interopRequireDefault(_trimStart2);

var _desc, _value, _obj;

var _mobx = __webpack_require__(4);

var _utils = __webpack_require__(27);

var _utils2 = _interopRequireDefault(_utils);

var _parser = __webpack_require__(102);

var _parser2 = _interopRequireDefault(_parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
  Field Initializer
*/
exports.default = (_obj = {
  initFields: function initFields(initial, update) {
    var _this = this;

    var $path = function $path(key) {
      return (0, _trimStart3.default)([_this.path, key].join('.'), '.');
    };

    var fields = void 0;
    fields = _parser2.default.prepareFieldsData(initial, this.state.strict);
    fields = _parser2.default.mergeSchemaDefaults(fields, this.validator);

    // create fields
    (0, _each3.default)(fields, function (field, key) {
      return (0, _isNil3.default)(_this.select($path(key), null, false)) && _this.initField(key, $path(key), field, update);
    });
  },
  initField: function initField(key, path, data) {
    var update = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var initial = this.state.get('current', 'props');
    var struct = _utils2.default.pathToStruct(path);
    // try to get props from separated objects
    var $try = function $try(prop) {
      return (0, _get3.default)(initial[prop], struct);
    };

    var props = {
      $value: $try('values'),
      $label: $try('labels'),
      $placeholder: $try('placeholders'),
      $default: $try('defaults'),
      $initial: $try('initials'),
      $disabled: $try('disabled'),
      $bindings: $try('bindings'),
      $type: $try('types'),
      $options: $try('options'),
      $extra: $try('extra'),
      $related: $try('related'),
      $hooks: $try('hooks'),
      $handlers: $try('handlers'),
      $validatedWith: $try('validatedWith'),
      $validators: $try('validators'),
      $rules: $try('rules'),
      $observers: $try('observers'),
      $interceptors: $try('interceptors'),
      $input: $try('input'),
      $output: $try('output')
    };

    var field = this.state.form.makeField({
      key: key, path: path, data: data, props: props, update: update, state: this.state
    });

    this.fields.merge(_defineProperty({}, key, field));

    return field;
  }
}, (_applyDecoratedDescriptor(_obj, 'initField', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'initField'), _obj)), _obj);
module.exports = exports['default'];

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
  Field Helpers
*/
exports.default = {

  /**
   Fields Selector (alias of select)
   */
  $: function $(key) {
    return this.select(key);
  },


  /**
   Fields Values (recursive with Nested Fields)
   */
  values: function values() {
    return this.get('value');
  },


  /**
   Fields Errors (recursive with Nested Fields)
   */
  errors: function errors() {
    return this.get('error');
  },


  /**
   Fields Labels (recursive with Nested Fields)
   */
  labels: function labels() {
    return this.get('label');
  },


  /**
   Fields Placeholders (recursive with Nested Fields)
   */
  placeholders: function placeholders() {
    return this.get('placeholder');
  },


  /**
   Fields Default Values (recursive with Nested Fields)
   */
  defaults: function defaults() {
    return this.get('default');
  },


  /**
   Fields Initial Values (recursive with Nested Fields)
   */
  initials: function initials() {
    return this.get('initial');
  },


  /**
   Fields Types (recursive with Nested Fields)
   */
  types: function types() {
    return this.get('type');
  }
};
module.exports = exports['default'];

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trim2 = __webpack_require__(142);

var _trim3 = _interopRequireDefault(_trim2);

var _trimEnd2 = __webpack_require__(354);

var _trimEnd3 = _interopRequireDefault(_trimEnd2);

var _last2 = __webpack_require__(216);

var _last3 = _interopRequireDefault(_last2);

var _split2 = __webpack_require__(145);

var _split3 = _interopRequireDefault(_split2);

var _set2 = __webpack_require__(187);

var _set3 = _interopRequireDefault(_set2);

var _isObject2 = __webpack_require__(23);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isUndefined2 = __webpack_require__(200);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _isString2 = __webpack_require__(47);

var _isString3 = _interopRequireDefault(_isString2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _isNil2 = __webpack_require__(83);

var _isNil3 = _interopRequireDefault(_isNil2);

var _trimStart2 = __webpack_require__(214);

var _trimStart3 = _interopRequireDefault(_trimStart2);

var _has2 = __webpack_require__(82);

var _has3 = _interopRequireDefault(_has2);

var _each2 = __webpack_require__(53);

var _each3 = _interopRequireDefault(_each2);

var _isPlainObject2 = __webpack_require__(52);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _reduce2 = __webpack_require__(352);

var _reduce3 = _interopRequireDefault(_reduce2);

var _merge2 = __webpack_require__(75);

var _merge3 = _interopRequireDefault(_merge2);

var _desc, _value, _obj;

var _mobx = __webpack_require__(4);

var _utils = __webpack_require__(27);

var _utils2 = _interopRequireDefault(_utils);

var _parser = __webpack_require__(102);

var _parser2 = _interopRequireDefault(_parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
  Field Actions
*/
exports.default = (_obj = {
  validate: function validate() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var $opt = (0, _merge3.default)(opt, { path: this.path });
    return this.state.form.validator.validate($opt, obj);
  },
  submit: function submit() {
    var _this = this;

    var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.$submitting = true;

    var exec = function exec(isValid) {
      return isValid ? _this.execHook('onSuccess', o) : _this.execHook('onError', o);
    };

    var validate = function validate() {
      return _this.validate({
        showErrors: _this.state.options.get('showErrorsOnSubmit', _this)
      }).then(function (_ref) {
        var isValid = _ref.isValid;

        var handler = exec(isValid);
        if (isValid) return handler;
        var $err = _this.state.options.get('defaultGenericError', _this);
        var $throw = _this.state.options.get('submitThrowsError', _this);
        if ($throw && $err) _this.invalidate();
        return handler;
      })
      // eslint-disable-next-line
      .then((0, _mobx.action)(function () {
        return _this.$submitting = false;
      })).catch((0, _mobx.action)(function (err) {
        _this.$submitting = false;
        throw err;
      })).then(function () {
        return _this;
      });
    };

    return _utils2.default.isPromise(exec) ? exec.then(function () {
      return validate();
    }) : validate();
  },


  /**
   Check Field Computed Values
   */
  check: function check(prop) {
    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _utils2.default.allowedProps('booleans', [prop]);

    return deep ? _utils2.default.checkPropType({
      type: _utils2.default.props.types[prop],
      data: this.deepCheck(_utils2.default.props.types[prop], prop, this.fields)
    }) : this[prop];
  },
  deepCheck: function deepCheck(type, prop, fields) {
    var _this2 = this;

    return (0, _reduce3.default)(_utils2.default.getObservableMapValues(fields), function (check, field) {
      if (field.fields.size === 0) {
        check.push(field[prop]);
        return check;
      }
      var $deep = _this2.deepCheck(type, prop, field.fields);
      check.push(_utils2.default.checkPropType({ type: type, data: $deep }));
      return check;
    }, []);
  },


  /**
   Update Field Values recurisvely
   OR Create Field if 'undefined'
   */
  update: function update(fields) {
    if (!(0, _isPlainObject3.default)(fields)) {
      throw new Error('The update() method accepts only plain objects.');
    }

    return this.deepUpdate(_parser2.default.prepareFieldsData({ fields: fields }));
  },
  deepUpdate: function deepUpdate(fields) {
    var _this3 = this;

    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var recursion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    (0, _each3.default)(fields, function (field, key) {
      var $key = (0, _has3.default)(field, 'name') ? field.name : key;
      var $path = (0, _trimStart3.default)(path + '.' + $key, '.');
      var $field = _this3.select($path, null, false);
      var $container = _this3.select(path, null, false) || _this3.state.form.select(_this3.path, null, false);

      if (!(0, _isNil3.default)($field) && !(0, _isNil3.default)(field)) {
        if ((0, _isArray3.default)($field.values())) {
          (0, _each3.default)(_utils2.default.getObservableMapValues($field.fields), function ($f) {
            return $field.fields.delete($f.name);
          });
        }
        if ((0, _isNil3.default)(field.fields)) {
          $field.value = field;
          return;
        }
      }

      if (!(0, _isNil3.default)($container)) {
        // get full path when using update() with select() - FIX: #179
        var $newFieldPath = (0, _trimStart3.default)([_this3.path, $path].join('.'), '.');
        // init field into the container field
        $container.initField($key, $newFieldPath, field, true);
      }

      if (recursion) {
        // handle nested fields if undefined or null
        var $fields = _parser2.default.pathToFieldsTree(_this3.state.struct(), $path);
        _this3.deepUpdate($fields, $path, false);
      }

      if (recursion && (0, _has3.default)(field, 'fields') && !(0, _isNil3.default)(field.fields)) {
        // handle nested fields if defined
        _this3.deepUpdate(field.fields, $path);
      }
    });
  },


  /**
    Get Fields Props
   */
  get: function get() {
    var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if ((0, _isNil3.default)(prop)) {
      return this.deepGet([].concat(_toConsumableArray(_utils2.default.props.booleans), _toConsumableArray(_utils2.default.props.field), _toConsumableArray(_utils2.default.props.validation)), this.fields);
    }

    _utils2.default.allowedProps('all', (0, _isArray3.default)(prop) ? prop : [prop]);

    if ((0, _isString3.default)(prop)) {
      if (strict && this.fields.size === 0) {
        return _parser2.default.parseCheckOutput(this, prop);
      }

      var value = this.deepGet(prop, this.fields);
      return _parser2.default.parseCheckArray(this, value, prop);
    }

    return this.deepGet(prop, this.fields);
  },


  /**
    Get Fields Props Recursively
   */
  deepGet: function deepGet(prop, fields) {
    var _this4 = this;

    return (0, _reduce3.default)(_utils2.default.getObservableMapValues(fields), function (obj, field) {
      var $nested = function $nested($fields) {
        return $fields.size !== 0 ? _this4.deepGet(prop, $fields) : undefined;
      };

      Object.assign(obj, _defineProperty({}, field.key, { fields: $nested(field.fields) }));

      if ((0, _isString3.default)(prop)) {
        var removeValue = prop === 'value' && (_this4.state.options.get('retrieveOnlyDirtyValues', _this4) && field.isPristine || _this4.state.options.get('retrieveOnlyEnabledFields', _this4) && field.disabled);

        if (field.fields.size === 0) {
          delete obj[field.key]; // eslint-disable-line
          if (removeValue) return obj;
          return Object.assign(obj, _defineProperty({}, field.key, _parser2.default.parseCheckOutput(field, prop)));
        }

        var value = _this4.deepGet(prop, field.fields);
        if (prop === 'value') value = field.$output(value);

        delete obj[field.key]; // eslint-disable-line
        if (removeValue) return obj;

        return Object.assign(obj, _defineProperty({}, field.key, _parser2.default.parseCheckArray(field, value, prop)));
      }

      (0, _each3.default)(prop, function ($prop) {
        return Object.assign(obj[field.key], _defineProperty({}, $prop, field[$prop]));
      });

      return obj;
    }, {});
  },
  set: function set(prop, data) {
    // UPDATE CUSTOM PROP
    if ((0, _isString3.default)(prop) && !(0, _isUndefined3.default)(data)) {
      _utils2.default.allowedProps('field', [prop]);
      var deep = (0, _isObject3.default)(data) && prop === 'value' || (0, _isPlainObject3.default)(data);
      if (deep && this.hasNestedFields) this.deepSet(prop, data, '', true);else (0, _set3.default)(this, '$' + prop, data);
      return;
    }

    // NO PROP NAME PROVIDED ("prop" is value)
    if ((0, _isNil3.default)(data)) {
      if (this.hasNestedFields) this.deepSet('value', prop, '', true);else this.set('value', prop);
    }
  },


  /**
    Set Fields Props Recursively
   */
  deepSet: function deepSet($, data) {
    var _this5 = this;

    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var recursion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var err = 'You are updating a not existent field:';
    var isStrict = this.state.options.get('strictUpdate', this);

    (0, _each3.default)(data, function ($val, $key) {
      var $path = (0, _trimStart3.default)(path + '.' + $key, '.');
      // get the field by path joining keys recursively
      var field = _this5.select($path, null, isStrict);
      // if no field found when is strict update, throw error
      if (isStrict) _utils2.default.throwError($path, field, err);
      // update the field/fields if defined
      if (!(0, _isUndefined3.default)(field)) {
        // update field values or others props
        if (!(0, _isUndefined3.default)($val)) {
          field.set($, $val, recursion);
        }
        // update values recursively only if field has nested
        if (field.fields.size && (0, _isObject3.default)($val)) {
          _this5.deepSet($, $val, $path, recursion);
        }
      }
    });
  },
  add: function add(obj) {
    var _this6 = this;

    if (_utils2.default.isArrayOfObjects(obj)) {
      return (0, _each3.default)(obj, function (values) {
        return _this6.update(_defineProperty({}, _utils2.default.maxKey(_this6.fields), values));
      });
    }

    var key = void 0; // eslint-disable-next-line
    if ((0, _has3.default)(obj, 'key')) key = obj.key;
    if ((0, _has3.default)(obj, 'name')) key = obj.name;
    if (!key) key = _utils2.default.maxKey(this.fields);

    var $path = function $path($key) {
      return (0, _trimStart3.default)([_this6.path, $key].join('.'), '.');
    };
    var tree = _parser2.default.pathToFieldsTree(this.state.struct(), this.path, 0, true);
    return this.initField(key, $path(key), (0, _merge3.default)(tree[0], obj));
  },
  del: function del() {
    var partialPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var path = _parser2.default.parsePath(_utils2.default.$try(partialPath, this.path));
    var keys = (0, _split3.default)(path, '.');
    var last = (0, _last3.default)(keys);
    var cpath = (0, _trimEnd3.default)(path, '.' + last);
    var isStrict = this.state.options.get('strictDelete', this);

    var container = this.select(cpath, null, false) || this.state.form.select(cpath, null, false) || this.state.form.select(this.path, null, true);

    if (isStrict && !container.fields.has(last)) {
      var msg = 'Key "' + last + '" not found when trying to delete field';
      var $path = (0, _trim3.default)([this.path, path].join('.'), '.');
      _utils2.default.throwError($path, null, msg);
    }

    container.fields.delete(last);
  }
}, (_applyDecoratedDescriptor(_obj, 'submit', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'submit'), _obj), _applyDecoratedDescriptor(_obj, 'deepUpdate', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'deepUpdate'), _obj), _applyDecoratedDescriptor(_obj, 'set', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'set'), _obj), _applyDecoratedDescriptor(_obj, 'add', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'add'), _obj), _applyDecoratedDescriptor(_obj, 'del', [_mobx.action], Object.getOwnPropertyDescriptor(_obj, 'del'), _obj)), _obj);
module.exports = exports['default'];

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trim2 = __webpack_require__(142);

var _trim3 = _interopRequireDefault(_trim2);

var _each2 = __webpack_require__(53);

var _each3 = _interopRequireDefault(_each2);

var _isNil2 = __webpack_require__(83);

var _isNil3 = _interopRequireDefault(_isNil2);

var _head2 = __webpack_require__(215);

var _head3 = _interopRequireDefault(_head2);

var _split2 = __webpack_require__(145);

var _split3 = _interopRequireDefault(_split2);

var _utils = __webpack_require__(27);

var _utils2 = _interopRequireDefault(_utils);

var _parser = __webpack_require__(102);

var _parser2 = _interopRequireDefault(_parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
  Field Utils
*/
exports.default = {

  /**
   Fields Selector
   */
  select: function select(path) {
    var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var isStrict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var $path = _parser2.default.parsePath(path);

    var keys = (0, _split3.default)($path, '.');
    var head = (0, _head3.default)(keys);

    keys.shift();

    var $fields = (0, _isNil3.default)(fields) ? this.fields.get(head) : fields.get(head);

    var stop = false;
    (0, _each3.default)(keys, function ($key) {
      if (stop) return;
      if ((0, _isNil3.default)($fields)) {
        $fields = undefined;
        stop = true;
      } else {
        $fields = $fields.fields.get($key);
      }
    });

    if (isStrict) _utils2.default.throwError(path, $fields);

    return $fields;
  },


  /**
    Get Container
   */
  container: function container(path) {
    var $path = _parser2.default.parsePath(_utils2.default.$try(path, this.path));
    var cpath = (0, _trim3.default)($path.replace(new RegExp('[^./]+$'), ''), '.');

    if (!!this.path && (0, _isNil3.default)(path)) {
      return this.state.form.select(cpath, null, false);
    }

    return this.select(cpath, null, false);
  },


  /**
    Has Field
   */
  has: function has(path) {
    return this.fields.has(path);
  },


  /**
   Map Fields
  */
  map: function map(cb) {
    return _utils2.default.getObservableMapValues(this.fields).map(cb);
  },


  /**
   * Iterates deeply over fields and invokes `iteratee` for each element.
   * The iteratee is invoked with three arguments: (value, index|key, depth).
   *
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Array|Object} [fields=form.fields] fields to iterate over.
   * @param {number} [depth=1] The recursion depth for internal use.
   * @returns {Array} Returns [fields.values()] of input [fields] parameter.
   * @example
   *
   * JSON.stringify(form)
   * // => {
     *   "fields": {
     *     "state": {
     *       "fields": {
     *         "city": {
     *           "fields": { "places": {
     *                "fields": {},
     *                "key": "places", "path": "state.city.places", "$value": "NY Places"
     *              }
     *           },
     *           "key": "city", "path": "state.city", "$value": "New York"
     *         }
     *       },
     *       "key": "state", "path": "state", "$value": "USA"
     *     }
     *   }
     * }
   *
   * const data = {};
   * form.each(field => data[field.path] = field.value);
   * // => {
     *   "state": "USA",
     *   "state.city": "New York",
     *   "state.city.places": "NY Places"
     * }
   *
   */
  each: function each(iteratee) {
    var _this = this;

    var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var $fields = fields || this.fields;
    (0, _each3.default)(_utils2.default.getObservableMapValues($fields), function (field, index) {
      iteratee(field, index, depth);

      if (field.fields.size !== 0) {
        _this.each(iteratee, field.fields, depth + 1);
      }
    });
  }
};
module.exports = exports['default'];

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _each2 = __webpack_require__(53);

var _each3 = _interopRequireDefault(_each2);

var _merge3 = __webpack_require__(75);

var _merge4 = _interopRequireDefault(_merge3);

var _mobx = __webpack_require__(4);

var _utils = __webpack_require__(27);

var _utils2 = _interopRequireDefault(_utils);

var _parser = __webpack_require__(102);

var _parser2 = _interopRequireDefault(_parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
  Field Events
*/
exports.default = {

  /**
   MobX Event (observe/intercept)
   */
  MOBXEvent: function MOBXEvent(_ref) {
    var _this = this;

    var _ref$path = _ref.path,
        path = _ref$path === undefined ? null : _ref$path,
        _ref$key = _ref.key,
        key = _ref$key === undefined ? 'value' : _ref$key,
        call = _ref.call,
        type = _ref.type;

    var $instance = this.select(path || this.path, null, null) || this;

    var $call = function $call(change) {
      return call.apply(null, [{
        change: change,
        form: _this.state.form,
        path: $instance.path || null,
        field: $instance.path ? $instance : null
      }]);
    };

    var fn = void 0;
    var ffn = void 0;

    if (type === 'observer') {
      fn = _mobx.observe;
      ffn = $instance.fields.observe;
    }

    if (type === 'interceptor') {
      // eslint-disable-next-line
      key = '$' + key;
      fn = _mobx.intercept;
      ffn = $instance.fields.intercept;
    }

    var $dkey = $instance.path ? key + '@' + $instance.path : key;

    (0, _merge4.default)(this.state.disposers[type], _defineProperty({}, $dkey, key === 'fields' ? ffn.apply(function (change) {
      return $call(change);
    }) : fn($instance, key, function (change) {
      return $call(change);
    })));
  },


  /**
   Dispose MOBX Events
   */
  dispose: function dispose() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (this.path && opt) return this.disposeSingle(opt);
    return this.disposeAll(opt);
  },


  /**
   Dispose All Events (observe/intercept)
   */
  disposeAll: function disposeAll() {
    var dispose = function dispose(disposer) {
      return disposer.apply();
    };
    (0, _each3.default)(this.state.disposers.interceptor, dispose);
    (0, _each3.default)(this.state.disposers.observer, dispose);
    this.state.disposers = { interceptor: {}, observer: {} };
    return null;
  },


  /**
   Dispose Single Event (observe/intercept)
   */
  disposeSingle: function disposeSingle(_ref2) {
    var type = _ref2.type,
        _ref2$key = _ref2.key,
        key = _ref2$key === undefined ? 'value' : _ref2$key,
        _ref2$path = _ref2.path,
        path = _ref2$path === undefined ? null : _ref2$path;

    var $path = _parser2.default.parsePath(_utils2.default.$try(path, this.path));
    // eslint-disable-next-line
    if (type === 'interceptor') key = '$' + key; // target observables
    this.state.disposers[type][key + '@' + $path].apply();
    delete this.state.disposers[type][key + '@' + $path];
  }
};
module.exports = exports['default'];

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Formula__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__form__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_dateUtil__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};













var getLabel = __WEBPACK_IMPORTED_MODULE_7_ecCom__["WeaLocaleProvider"].getLabel;
var CubeTrigger = /** @class */ (function () {
    function CubeTrigger(card) {
        var _this = this;
        this.params = {};
        this.onChangeFuns = {};
        this.linkPageFuns = {};
        this.linkPage = [];
        this.needSumFields = [];
        this.refFields = {}; //用于触发目标字段关联的字段属性
        this.loading = false;
        this.init = function (params, callBack) {
            _this.params = params;
            _this.colCals = _this.rowCals = '';
            return Promise.all([
                Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["C" /* getRowColCons */])(params),
                Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["w" /* getInputEntry */])(params),
                Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["x" /* getLayoutFieldAttr */])(params),
                Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["t" /* getFieldAttrLinkPage */])(params),
            ]).then(function (_a) {
                var RowColCons = _a[0], InputEntry = _a[1], LayoutFieldAttr = _a[2], LinkPage = _a[3];
                _this.doRowColCons(RowColCons);
                _this.formulaAction.execute(); //公式触发
                _this.formulaAction.doFormulaBindChange(); //给公式字段绑定onchange方法触发公式
                _this.doInputEntry(InputEntry);
                callBack && callBack();
                _this.doLayoutFieldAttr(LayoutFieldAttr);
                _this.doFieldAttrLinkPage(LinkPage);
            });
        };
        this.executeWhenAddRow = function (detail, rowKey) {
            var detailTable = _this.card.cubeForm.has(detail) && _this.card.cubeForm.$(detail);
            var row = detailTable && detailTable.has(rowKey) && detailTable.$(rowKey);
            _this.formulaAction.execute(); //增加一行触发公式
            _this.card.doSelectItemChange(row);
            var type = _this.card.base.type;
            row && row.map(function (field) {
                /**
                 * 新增明细，触发字段为空，新建布局触发，显示布局和编辑布局不触发
                 */
                if (type == "1" || type == "2") {
                    field.onChange(field.getValue());
                }
                else {
                    if (field.getValue()) {
                        field.onChange(field.getValue());
                    }
                }
                //触发明细字段关联的字段属性
                if (_this.refFields[field.key]) {
                    //应该只需要触发其中一个关联字段的字段属性就行了
                    var f_field = _this.refFields[field.key][0];
                    if (field) {
                        var _triggersT = {};
                        var triggerRow = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.compact(_this.getTrigger(_this.refFields[field.key], f_field, true, rowKey));
                        if (triggerRow && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(triggerRow)) {
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_triggersT, f_field, _this.getTrigger(_this.refFields[field.key], f_field, true, rowKey));
                        }
                        _this.cubeFieldAttr(_triggersT, rowKey);
                    }
                }
            });
        };
        this.executeWhenCopyRow = function (detail, rowKey, rowValues) {
            var _a = _this.card, type = _a.base.type, cubeForm = _a.cubeForm;
            var detailTable = cubeForm.has(detail) && cubeForm.$(detail);
            var row = detailTable && detailTable.has(rowKey) && detailTable.$(rowKey);
            _this.formulaAction.execute(); //增加一行触发公式
            row && row.map(function (field) {
                if ((type == "1" || type == "2" || type == '0') && (field.key !== 'checkbox' || field.key !== 'dtl_id')) {
                    field.onChange(rowValues[field.key]);
                }
                //触发明细字段关联的字段属性
                if (_this.refFields[field.key]) {
                    //应该只需要触发其中一个关联字段的字段属性就行了
                    var f_field = _this.refFields[field.key][0];
                    if (field) {
                        var _triggersT = {};
                        var triggerRow = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.compact(_this.getTrigger(_this.refFields[field.key], f_field, true, rowKey));
                        if (triggerRow && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(triggerRow)) {
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_triggersT, f_field, _this.getTrigger(_this.refFields[field.key], f_field, true, rowKey));
                        }
                        _this.cubeFieldAttr(_triggersT, rowKey);
                    }
                }
            });
            _this.card.doSelectItemChange(row);
        };
        this.executeWhenDelRow = function (detail, rowKey) {
            _this.formulaAction.execute(); //增加一行触发公式
            var detailTable = _this.card.cubeForm.has(detail) && _this.card.cubeForm.$(detail);
            rowKey && rowKey.forEach(function (element) {
                var row = detailTable && detailTable.has(element) && detailTable.$(element);
                row && row.map(function (field) {
                    /**
                     * 删除明细，触发列字段规则合计赋值主表字段
                     */
                    field.onChange('');
                });
            });
        };
        this.delcommafy = function (num) {
            if ((num + "").trim() == "") {
                return "";
            }
            num = num.replace(/,/gi, '');
            return num;
        };
        this.doColCals = function (toField, changeField) {
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_this.card.allFields, changeField + ".needSum", true);
            var _a = _this.card.getFieldProps(changeField), isdetail = _a.isdetail, detail = _a.detail, qfws = _a.qfws;
            if (isdetail && _this.card.cubeForm.has(detail)) {
                var sum_1 = 0;
                _this.card.cubeForm.$(detail).map(function (row) {
                    if (row.has(changeField)) {
                        var fieldtype = _this.card.getFieldProps(changeField).fieldtype;
                        var fieldValue = row.$(changeField).getValue();
                        if (fieldtype == 5) {
                            // 千分位处理
                            fieldValue = _this.delcommafy(row.$(changeField).getValue());
                        }
                        var value = parseFloat(fieldValue);
                        if (isNaN(value)) {
                            value = 0;
                        }
                        sum_1 += value;
                    }
                });
                if (_this.card.cubeForm.has(toField)) {
                    _this.card.cubeForm.$(toField).onChange("" + sum_1.toFixed(qfws));
                }
            }
        };
        this.doRowCals = function (rowCal, changeField, index) {
            var cals = rowCal.cals, tofield = rowCal.tofield;
            if (cals && tofield) {
                var _a = _this.card.getFieldProps(changeField), isdetail = _a.isdetail, detail = _a.detail;
                if (isdetail) {
                    _this.card.cubeForm.has(detail) && _this.card.cubeForm.$(detail).map(function (row) {
                        if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(index) && row.key != index) {
                            return;
                        }
                        if (row.has(changeField) && row.has(tofield)) {
                            var _cals = cals.replace(/field[0-9]*/g, function (fieldname) {
                                if (row.has(fieldname)) {
                                    var vals = row.$(fieldname).getValue() + "";
                                    while (vals.indexOf(",") > -1) {
                                        vals = vals.replace(",", "");
                                    }
                                    var value = parseFloat(vals);
                                    if (isNaN(value)) {
                                        value = 0;
                                    }
                                    return " " + value;
                                }
                                else {
                                    return 0;
                                }
                            });
                            try {
                                var calValue = eval(_cals);
                                calValue = isNaN(calValue) ? '' : calValue;
                                row.$(tofield).onChange("" + calValue);
                            }
                            catch (e) {
                                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(getLabel('383716', "行规则计算错误。"));
                            }
                        }
                    });
                }
            }
        };
        this.doRowColCons = function (_a, isInit) {
            var status = _a.status, errorCode = _a.errorCode, error = _a.error, colCals = _a.colCals, rowCals = _a.rowCals;
            if (isInit === void 0) { isInit = true; }
            if (status != '1') {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                return;
            }
            if (colCals) {
                _this.colCals = colCals;
                var needSumFields_1 = [];
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(colCals, function (toField, changeField) {
                    _this.doColCals(toField, changeField); //初始化执行一次
                    if (isInit) {
                        needSumFields_1.push(changeField);
                        _this.addOnChange(changeField, function () {
                            _this.doColCals(toField, changeField);
                        });
                        _this.needSumFields = needSumFields_1;
                    }
                });
            }
            if (rowCals) {
                _this.rowCals = rowCals;
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(rowCals, function (rowCal, changeField) {
                    changeField = changeField.split('_')[0];
                    if (rowCal) {
                        _this.doRowCals(rowCal, changeField);
                        if (isInit) {
                            _this.addOnChange(changeField, function (index) {
                                _this.doRowCals(rowCal, changeField, index);
                            });
                        }
                    }
                });
            }
        };
        /*****外部调用一次行列计算 */
        this.doRowColConsComputed = function () {
            _this.doRowColCons({ status: 1, colCals: _this.colCals, rowCals: _this.rowCals }, false);
        };
        this.findSameRowChilds = function (fieldname) {
            var newChangeFieldIds = []; //filedid存储
            var parent = __WEBPACK_IMPORTED_MODULE_6_jquery___default()("[id*=" + fieldname + "]").parents("tr")[0]; //被隐藏的行
            if (parent) {
                var childrenFields = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(parent).find("*.fieldValue"); //隐藏行内的field元素
                if (childrenFields) {
                    Array.prototype.forEach.call(childrenFields, function (element) {
                        var dataset = _this.getDataset(element);
                        newChangeFieldIds.push(dataset.fieldmark);
                    });
                }
            }
            return newChangeFieldIds;
        };
        this.getDataset = function (ele) {
            if (ele.dataset) {
                return ele.dataset;
            }
            else {
                var attrs = ele.attributes, //元素的属性集合
                dataset = {}, name, matchStr;
                for (var i = 0; i < attrs.length; i++) { //是否是data- 开头
                    matchStr = attrs[i].name.match(/^data-(.+)/);
                    if (matchStr) { //data-auto-play 转成驼峰写法 autoPlay
                        name = matchStr[1].replace(/-([\da-z])/gi, function (all, letter) {
                            return letter.toUpperCase();
                        });
                        dataset[name] = attrs[i].value;
                    }
                }
                return dataset;
            }
        };
        this.isdoByfield = function (linkPage, selectFieldId1, value) {
            var isdo = false;
            for (var i = 0; i < linkPage.length; i++) {
                var flag = false;
                var _a = linkPage[i], selectFieldId = _a.selectFieldId, relationtype = _a.relationtype, selectFieldValue = _a.selectFieldValue;
                if (selectFieldId == selectFieldId1) {
                    if ((relationtype == "0" || relationtype == "1")) { //属于
                        var selectvalues = selectFieldValue && selectFieldValue.split(",") || [];
                        for (var i_1 = 0; i_1 < selectvalues.length; i_1++) {
                            if (selectvalues[i_1] == value) {
                                flag = true;
                                break;
                            }
                        }
                        if ((relationtype == "0" && flag == true) || (relationtype == "1" && flag == false)) {
                            isdo = true;
                            break;
                        }
                    }
                    else if (relationtype == "2" || relationtype == "3") { //包含、不包含
                        var values = value && value.split(",") || [];
                        for (var i_2 = 0; i_2 < values.length; i_2++) {
                            if (values[i_2] == selectFieldValue) {
                                flag = true;
                                break;
                            }
                        }
                        if ((relationtype == "2" && flag == true) || (relationtype == "3" && flag == false)) {
                            isdo = true;
                            break;
                        }
                    }
                }
            }
            ;
            return isdo;
        };
        this.isDoFieldAttrLinkPage = function (selectvalue, relationtype, value) {
            var flag = false;
            if (relationtype == "0" || relationtype == "1") { //属于、不属于
                var selectvalues = selectvalue && selectvalue.split(",") || [];
                for (var i = 0; i < selectvalues.length; i++) {
                    if (selectvalues[i] == value) {
                        flag = true;
                        break;
                    }
                }
                if ((relationtype == "0" && flag == true) || (relationtype == "1" && flag == false)) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (relationtype == "2" || relationtype == "3") { //包含、不包含
                var values = value && value.split(",") || [];
                for (var i = 0; i < values.length; i++) {
                    if (values[i] == selectvalue) {
                        flag = true;
                        break;
                    }
                }
                if ((relationtype == "2" && flag == true) || (relationtype == "3" && flag == false)) {
                    return true;
                }
                else {
                    return false;
                }
            }
        };
        this.doFieldAttrLinkPage = function (_a) {
            var status = _a.status, errorCode = _a.errorCode, error = _a.error, linkPage = _a.linkPage;
            _this.linkPage = linkPage;
            if (status != '1') {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                return;
            }
            var addFunc = function (fieldname, selectvalue, index, fun) {
                if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.linkPageFuns, "" + fieldname)) {
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_this.linkPageFuns, "" + fieldname, {});
                }
                var funs = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.linkPageFuns, fieldname + ".link" + index) || [];
                funs.push(fun);
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_this.linkPageFuns, fieldname + ".link" + index, funs);
            };
            var doLinkPage = function (data, form, index) {
                data.changeFieldIds && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(data.changeFieldIds)) && data.changeFieldIds.map(function (fieldname) {
                    var _a = _this.card.getFieldProps(fieldname), isdetail = _a.isdetail, detail = _a.detail;
                    if ((!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(index) && isdetail && form.path.startsWith(detail))) { //与触发字段同一明细表
                        if (data.viewAttr !== "5") { //隐藏行的功能暂时先不做
                            form.has(fieldname) && form.$(fieldname).setViewAttrs(data.selectFieldId, data.viewAttr);
                        }
                    }
                    else if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(index)) { // 主表触发
                        if (isdetail) { // 变更字段为明细表， 所有明细行都变更
                            form.has(detail) && form.$(detail).map(function (row) {
                                row.has(fieldname) && row.$(fieldname).setViewAttrs(data.selectFieldId, data.viewAttr);
                            });
                        }
                        else {
                            if (data.viewAttr === "5") {
                                _this.findSameRowChilds(fieldname).forEach(function (name) {
                                    form.has(name) && form.$(name).setViewAttrs(data.selectFieldId, data.viewAttr);
                                });
                            }
                            else {
                                // this.datas = data;
                                form.has(fieldname) && form.$(fieldname).setViewAttrs(data.selectFieldId, data.viewAttr);
                            }
                        }
                    }
                });
            };
            if (linkPage && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(linkPage)) {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(linkPage, function (data, index1) {
                    var selectFieldId = data.selectFieldId, selectFieldValue = data.selectFieldValue;
                    addFunc(selectFieldId, selectFieldValue, index1, function (index) {
                        var _a = _this.card.getFieldProps(selectFieldId), isdetail = _a.isdetail, detail = _a.detail;
                        if (isdetail) { // 明细表触发字段
                            _this.card.cubeForm.has(detail) && _this.card.cubeForm.$(detail).map(function (row) {
                                if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(index) && row.key != index) {
                                    return;
                                }
                                doLinkPage(data, row, row.key);
                            });
                        }
                        else {
                            doLinkPage(data, _this.card.cubeForm);
                        }
                    });
                });
                var runLinkPage_1 = function (data, i, index) {
                    var selectFieldId = data.selectFieldId;
                    var _a = _this.card.getFieldProps(selectFieldId), isdetail = _a.isdetail, detail = _a.detail;
                    if (isdetail) {
                        _this.card.cubeForm.has(detail) && _this.card.cubeForm.$(detail).map(function (row) {
                            if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(index) && row.key != index) {
                                return;
                            }
                            _this.card.cubeForm.clearAllViewAttr(selectFieldId, [], row);
                            var value = row.has(selectFieldId) && row.$(selectFieldId).getValue();
                            //判断是否属性联动
                            var funs = [];
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(_this.linkPage, function (temp, index) {
                                if (temp.selectFieldId == data.selectFieldId && _this.isDoFieldAttrLinkPage(temp.selectFieldValue, temp.relationtype, value)) {
                                    var temp_funs = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.linkPageFuns, temp.selectFieldId + ".link" + index) || [];
                                    temp_funs.forEach(function (temp_fun) {
                                        funs.push(temp_fun);
                                    });
                                }
                            });
                            //const funs: Function[] = _.get(this.linkPageFuns, `${data.selectFieldId}.link${i}`);
                            if (funs && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(funs)) {
                                funs.map(function (fun) {
                                    if (fun && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isFunction(fun)) {
                                        fun(row.key);
                                    }
                                });
                            }
                        });
                    }
                    else {
                        _this.card.cubeForm.clearAllViewAttr(selectFieldId);
                        var value_1 = _this.card.cubeForm.has(selectFieldId) && _this.card.cubeForm.$(selectFieldId).getValue();
                        //判断是否属性联动
                        var funs_1 = [];
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(_this.linkPage, function (temp, index) {
                            if (temp.selectFieldId == data.selectFieldId && _this.isDoFieldAttrLinkPage(temp.selectFieldValue, temp.relationtype, value_1)) {
                                var temp_funs = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.linkPageFuns, temp.selectFieldId + ".link" + index) || [];
                                temp_funs.forEach(function (temp_fun) {
                                    funs_1.push(temp_fun);
                                });
                            }
                        });
                        //const funs: Function[] = _.get(this.linkPageFuns, `${data.selectFieldId}.link${i}`);
                        if (funs_1 && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(funs_1)) {
                            funs_1.map(function (fun) {
                                if (fun && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isFunction(fun)) {
                                    fun();
                                }
                            });
                        }
                    }
                    _this.card.cubeForm.validate();
                };
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(linkPage, function (data, i) {
                    runLinkPage_1(data, i);
                    _this.addOnChange(data.selectFieldId, function (index) {
                        runLinkPage_1(data, i, index);
                    });
                });
            }
        };
        this.cubeFieldAttrLinkPage = function (data, funs, index) {
            var selectFieldId = data.selectFieldId;
            var _a = _this.card.getFieldProps(selectFieldId), isdetail = _a.isdetail, detail = _a.detail;
            if (isdetail) {
                _this.card.cubeForm.has(detail) && _this.card.cubeForm.$(detail).map(function (row) {
                    if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(index) && row.key != index) {
                        return;
                    }
                    if (row.has(selectFieldId)) {
                        var func = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(funs, row.$(selectFieldId).getValue());
                        if (func && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isFunction(func)) {
                            func(row.key);
                        }
                    }
                });
            }
        };
        this.doFieldDateGet = function (v) {
            try {
                var result = v.match(/\"(.*)\"/);
                var hasDateStr = '';
                if (result.length > 1) {
                    hasDateStr = result[1].replace(/\s*/g, "");
                }
                var newDate = new Date();
                if (hasDateStr.length > 0 && __WEBPACK_IMPORTED_MODULE_12_moment___default()(newDate).format('YYYY-MM-DD') == hasDateStr.substring(0, 10)) {
                    var days = Number(hasDateStr.substring(10));
                    result = Object(__WEBPACK_IMPORTED_MODULE_9__util_dateUtil__["a" /* addDay */])(newDate, days > 0 ? days - 1 : days);
                }
                return result;
            }
            catch (error) {
                console.log(error);
            }
        };
        this.doLayoutFieldAttr = function (_a) {
            var status = _a.status, errorCode = _a.errorCode, error = _a.error, attrs = _a.attrs, mapAttrs = _a.mapAttrs, valueAttrs = _a.valueAttrs, valuefrom = _a.valuefrom, refFields = _a.refFields;
            if (status != '1') {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                return;
            }
            _this.refFields = refFields;
            var tempParams = {};
            var _b = _this.card, type = _b.base.type, quickEditStore = _b.quickEditStore;
            if (type == '0') {
                quickEditStore.recordParms(tempParams);
            }
            if (valueAttrs && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(valueAttrs)) {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(valueAttrs, function (v, k) {
                    var _a = _this.card.getFieldProps(k), isdetail = _a.isdetail, detail = _a.detail;
                    var isParm = valuefrom[k] || 'isOther';
                    if (isdetail) {
                        if (_this.card.cubeForm.has(detail)) {
                            tempParams[detail] = {};
                            _this.card.cubeForm.$(detail).map(function (row) {
                                tempParams[detail][row.key] = {};
                                if (isParm == 'isParm') { //是parm返回
                                    _this.card.cubeForm.setValue(detail + "." + row.key + "." + k, v, true);
                                    tempParams[detail][row.key][k] = v;
                                }
                                else {
                                    var orivalue = _this.card.cubeForm.getValue(detail + "." + row.key + "." + k);
                                    if (orivalue == '') {
                                        _this.card.cubeForm.setValue(detail + "." + row.key + "." + k, v, true);
                                        tempParams[detail][row.key][k] = v;
                                    }
                                }
                            });
                            if (typeof (v) == 'string' && v.indexOf('doFieldDate') > -1 && v.indexOf('$') < 0) {
                                v = _this.doFieldDateGet(v);
                            }
                        }
                        //    this.card.cubeForm.$(detail).detailDefaultValue = { ...this.card.cubeForm.$(detail).detailDefaultValue, [k]:v };
                        var _detailDefaultValue = {};
                        if (v && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(v)) {
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_detailDefaultValue, k, Object(__WEBPACK_IMPORTED_MODULE_8__form__["a" /* deal4ReplaceDatas */])(v, _this.card.getFieldProps(k).fieldtype));
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_detailDefaultValue, k, v);
                        }
                        _this.card.cubeForm.$(detail).detailDefaultValue = __assign({}, _this.card.cubeForm.$(detail).detailDefaultValue, _detailDefaultValue);
                    }
                    else {
                        if (isParm == 'isParm') { //是parm返回
                            _this.card.cubeForm.setValue(k, v, true);
                            tempParams[k] = v;
                        }
                        else {
                            var orivalue = _this.card.cubeForm.getValue(k);
                            if (orivalue == '') {
                                _this.card.cubeForm.setValue(k, v, true);
                                tempParams[k] = v;
                            }
                            //当前日期与数字的加减 --> 后端返回格式eg:doFieldDate("  2020-04-08  -5 ")
                            if (typeof (v) == 'string' && v.indexOf('doFieldDate') > -1 && v.indexOf('$') < 0) {
                                var value = _this.doFieldDateGet(v);
                                if (value != undefined) {
                                    _this.card.cubeForm.setValue(k, value, true);
                                    tempParams[k] = v;
                                }
                            }
                        }
                    }
                });
            }
            /***
             * 显示布局针对parm参数记录暂存
             * */
            if (type == '0' && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(tempParams)) {
                quickEditStore.recordParms(tempParams);
            }
            if (mapAttrs && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(mapAttrs)) {
                _this.card.mapStore.mapAttrs = mapAttrs;
            }
            if (attrs && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(attrs)) {
                var _triggers_1 = {};
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(attrs, function (fields, trigger) {
                    if (_this.card.base.type == '1' || _this.card.base.type == '0' || _this.card.base.type == '2' || _this.card.base.type == '4') { //0显示 1新建 2 编辑 4打印模板
                        var triggerRow = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.compact(_this.getTrigger(fields, trigger));
                        if (triggerRow && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(triggerRow)) {
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_triggers_1, trigger, triggerRow);
                        }
                    }
                    _this.addOnChange(trigger, function (index) {
                        var _triggersT = {};
                        var triggerRow = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.compact(_this.getTrigger(fields, trigger, true, index));
                        if (triggerRow && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(triggerRow)) {
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_triggersT, trigger, _this.getTrigger(fields, trigger, true, index));
                        }
                        _this.cubeFieldAttr(_triggersT);
                    });
                });
                if (_this.card.base.type == '1' || _this.card.base.type == '0' || _this.card.base.type == '2' || _this.card.base.type == '4') {
                    _this.cubeFieldAttr(_triggers_1);
                }
            }
        };
        this.cubeFieldAttr = function (_triggers, detailRowKey) {
            var newTriggers = {};
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(_triggers, function (value, key) {
                newTriggers[key] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(value, function (n) {
                    return n != null;
                });
            });
            if (!newTriggers || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(newTriggers)) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["e" /* cubeFieldAttr */])(__assign({}, _this.params, { trigger: JSON.stringify(newTriggers) })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas;
                if (status != '1') {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                    return;
                }
                if (datas) {
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(datas, function (valueObjs, caltype) {
                        if (valueObjs && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(valueObjs)) {
                            valueObjs.map(function (valueObj) {
                                var data = __assign({}, valueObj);
                                delete data.index;
                                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(data, function (value, fieldname) {
                                    //if (_.isString(value)) {
                                    var _value;
                                    if (caltype == '1' || caltype == '3' || caltype == "0" || caltype == "4") {
                                        _value = value;
                                    }
                                    else {
                                        try {
                                            _value = eval(value);
                                        }
                                        catch (e) {
                                            __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(getLabel('383717', "字段属性计算错误"));
                                            _value = '';
                                        }
                                    }
                                    var _a = _this.card.getFieldProps(fieldname), isdetail = _a.isdetail, detail = _a.detail;
                                    if (isdetail) {
                                        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(valueObj.index)) {
                                            _this.card.cubeForm.$(detail).values().forEach(function (item, index) {
                                                if (detailRowKey) {
                                                    if (detailRowKey == index) {
                                                        _this.card.cubeForm.setValue(detail + "." + index + "." + fieldname, typeof _value == 'string' ? "" + _value : _value, true);
                                                    }
                                                }
                                                else {
                                                    _this.card.cubeForm.setValue(detail + "." + index + "." + fieldname, typeof _value == 'string' ? "" + _value : _value, true);
                                                }
                                            });
                                        }
                                        else {
                                            _this.card.cubeForm.setValue(detail + "." + valueObj.index + "." + fieldname, typeof _value == 'string' ? "" + _value : _value, true);
                                        }
                                    }
                                    else {
                                        _this.card.cubeForm.setValue(fieldname, _value, true);
                                    }
                                    //  }
                                });
                            });
                        }
                    });
                }
            }));
        };
        this.inputEntryTriggers = [];
        this.doInputEntry = function (_a) {
            var status = _a.status, errorCode = _a.errorCode, error = _a.error, inputEntry = _a.inputEntry, inputEntryConfig = _a.inputEntryConfig;
            _this.inputEntryData = { status: status, errorCode: errorCode, error: error, inputEntry: inputEntry, inputEntryConfig: inputEntryConfig };
            if (status != '1') {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                return;
            }
            var _triggers = {};
            var params = _this.card.params;
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(inputEntry, function (fields, trigger) {
                var isdetail = _this.card.getFieldProps(trigger).isdetail;
                if (_this.card.base.type == '1' || isdetail && _this.card.base.type == '2') { //编辑布局只有明细导入时候才主动触发字段联动
                    var triggerRow = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.compact(_this.getTrigger(fields, trigger));
                    if (triggerRow.length > 0) {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_triggers, trigger, triggerRow);
                    }
                }
                _this.addOnChange(trigger, function (index) {
                    var isdel = '0';
                    var isesb = '0';
                    var pagefieldnames = new Array();
                    inputEntryConfig.map(function (cfg) {
                        if (cfg.triggerfieldname == trigger) {
                            isdel = cfg.isdel;
                            isesb = cfg.isesb;
                            pagefieldnames.push(cfg.pagefieldname);
                        }
                    });
                    var _triggersT = {};
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_triggersT, trigger, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.compact(_this.getTrigger(fields, trigger, true, index)));
                    if (isdel == '1') {
                        _this.delNotSaveDetaildata(trigger, pagefieldnames);
                    }
                    //if(this.loading){
                    _this.cubeDataInput(_triggersT, isesb);
                    //}
                });
            });
            if ((_this.card.base.type == '1' && !params.copyid) || _this.card.base.type == '2' && _this.card.detailImport && _this.card.detailImport.uploadParams && _this.card.detailImport.uploadParams.isImportDetail) { //|| this.card.base.type == '2'  编辑布局一开始不触发字段联动
                if ((_this.card.base.type == '1' || _this.card.base.type == '2') && _this.card.detailImport && _this.card.detailImport.uploadParams && _this.card.detailImport.uploadParams.isImportDetail) {
                    _this.card.params.isSaveCallback = false; //新建保存,编辑保存有回调函数的时候,进行明细导入,需要执行字段联动
                }
                if (_this.card.params.isSaveCallback) {
                    return;
                }
                _this.cubeDataInput(_triggers);
            }
        };
        //删除未保存的明细表数据
        this.delNotSaveDetaildata = function (trigger, pagefieldnames) {
            var set = new Set(); //要删除的明细表集合
            var that = _this;
            pagefieldnames.map(function (pagefield) {
                var _a = that.card.getFieldProps(pagefield), isdetail = _a.isdetail, detail = _a.detail;
                if (isdetail) {
                    set.add(detail);
                }
            });
            var delkeys = new Array();
            set.forEach(function (detail, sameElement, set) {
                if (that.card.cubeForm.has(detail)) {
                    var detailTable_1 = that.card.cubeForm.$(detail);
                    var i_3 = 0;
                    detailTable_1.map(function (d) {
                        var row = detailTable_1.value[i_3];
                        if (row.dtl_id == '' || row.dtl_id.length > 30) {
                            delkeys.push(detail + "|" + d.key);
                        }
                        i_3++;
                    });
                }
            });
            if (delkeys.length > 0) {
                __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm({
                    content: getLabel('390243', '即将执行主表字段联动明细字段，要删除暂未保存的明细表联动数据吗？'),
                    title: getLabel(131329, '信息确认'),
                    onOk: function () {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(delkeys, function (key) {
                            var info = key.split('|');
                            var detailTable = that.card.cubeForm.$(info[0]);
                            that.executeWhenDelRow(info[0], [info[1]]);
                            detailTable.del(info[1]);
                        });
                    },
                    onCancel: function () { }
                });
            }
            else {
            }
        };
        this.cubeDataInput = function (_triggers, isesb) {
            var isTrue = false; //联动清除的时候，主表联动明细表，明细表的数据就不要清除了吧；
            //this.loading = true;
            var keys = "";
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(_triggers, function (value, key) {
                keys += key + ",";
                if (value[0]) {
                    if (value[0]["index"] == undefined) { //主表联动
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(value[0], function (v, k) {
                            if (!v) {
                                isTrue = true;
                            }
                        });
                    }
                }
            });
            if (isesb != '1' && !_triggers || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(_triggers)) {
                return;
            }
            var esbtrigger = {};
            if (isesb && isesb == '1') {
                esbtrigger = { esbtrigger: JSON.stringify(_this.getSubmitData()) };
            }
            /***
             * 如果是显示布局，并且是明细表复制，不触发字段联动
             */
            var _a = _this.card, type = _a.base.type, cubeForm = _a.cubeForm, getFieldEditState = _a.getFieldEditState, quickEditStore = _a.quickEditStore;
            if (type == '0' && quickEditStore.handletype == 'copy') {
                return;
            }
            _this.loading = true;
            Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["d" /* cubeDataInput */])(__assign({}, _this.params, { trigger: JSON.stringify(_triggers) }, esbtrigger)).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas;
                if (status == '1') {
                    if (datas && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(datas)) {
                        var quickEditDataInput_1 = {};
                        var mainFieldState_1 = {};
                        datas.map(function (d) {
                            var index = d.index;
                            delete d.index;
                            var tempObj = {};
                            var tempDetail = '';
                            //明细默认值已处理
                            var detaildefault = false;
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(d, function (v, k) {
                                //   if(d[k]){
                                var _a = _this.card.getFieldProps(k), isdetail = _a.isdetail, detail = _a.detail;
                                if (isdetail && !isTrue) {
                                    if (cubeForm.has(detail)) {
                                        tempDetail = detail;
                                        var uuid = Object(__WEBPACK_IMPORTED_MODULE_10__util_typeUtil__["g" /* guid */])();
                                        var detailTable_2 = cubeForm.$(detail);
                                        /**s
                                         * 主表
                                         *      1- 请求参数格式（trigger:{"field38255":[{"field38255":"B"}]}）
                                         *      1- 返回格式：{"datas":[{"field38256":"文本BB"}],"status":"1"}
                                         * 明细表
                                         *      1- 请求参数格式（trigger:{"field38258":[{"index":0,"field38258":"B"}]}）
                                         *      1- 返回格式：{"datas":[{"field38259":"文本BB","index":0}],"status":"1"}
                                         *      1- 注意：明细表必须返回字段属性 index
                                         */
                                        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(index)) {
                                            var fields = detailTable_2.map(function (f) { return parseInt(f.key); });
                                            var nextId = fields.length > 0 ? Math.max.apply(Math, fields) + 1 : 0;
                                            detailTable_2.add('', { key: "" + nextId });
                                            index = nextId;
                                            if (type == '0') { //显示模板快速编辑下的字段联动
                                                tempObj = __assign({}, tempObj, { dtl_id: uuid, dtl_index: index }, d);
                                                // quickEditDataInput[detail].push({ dtl_id: uuid, dtl_index: index, ...d });
                                            }
                                        }
                                        else {
                                            if (type == '0') { //显示模板快速编辑下的字段联动
                                                tempObj = __assign({}, tempObj, { dtl_id: detailTable_2.$(index).$('dtl_id').value || uuid, dtl_index: index }, d);
                                                // quickEditDataInput[detail].push({ dtl_index: index, ...d });
                                            }
                                        }
                                        if (detailTable_2.has(index)) {
                                            //处理明细表默认值
                                            var field = cubeForm.$(detail);
                                            var detailDefaultValue = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(field.detailDefaultValue) || {};
                                            if (!detaildefault) {
                                                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(detailDefaultValue, function (defaultValue, defaultField) {
                                                    var value;
                                                    if (keys.indexOf(defaultField) < 0) {
                                                        var flag = false;
                                                        if (defaultValue.value != undefined) {
                                                            if (defaultValue.value) {
                                                                flag = true;
                                                            }
                                                            value = defaultValue.valueObj;
                                                        }
                                                        else {
                                                            if (defaultValue) {
                                                                flag = true;
                                                            }
                                                            value = defaultValue;
                                                        }
                                                        var row_1 = detailTable_2.$(index);
                                                        if (row_1.has(defaultField) && flag) {
                                                            if (row_1.$(defaultField).getValue().trim() == undefined) {
                                                                cubeForm.setValue(detail + "." + index + "." + defaultField, value, true);
                                                            }
                                                        }
                                                    }
                                                });
                                            }
                                            detaildefault = true;
                                            var row = detailTable_2.$(index);
                                            if (row.has(k)) {
                                                cubeForm.setValue(detail + "." + index + "." + k, v, true);
                                            }
                                            var orderid = void 0;
                                            if (detail.indexOf('_') > 0) {
                                                orderid = detail.split('_')[1];
                                            }
                                            __WEBPACK_IMPORTED_MODULE_11__util_excelUtil__["modeForm"].triggerAction(__WEBPACK_IMPORTED_MODULE_11__util_excelUtil__["modeForm"].ACTION_ADDROW + orderid, [index], 100);
                                        }
                                    }
                                }
                                else {
                                    cubeForm.setValue(k, v, true);
                                    var editstate = getFieldEditState(k).editstate;
                                    if (editstate == '3') {
                                        mainFieldState_1[k] = editstate;
                                        cubeForm.$(k).setViewAttrs("", '2');
                                    }
                                }
                                //   }
                            });
                            if (tempDetail && !quickEditDataInput_1[tempDetail]) {
                                quickEditDataInput_1[tempDetail] = [];
                            }
                            ;
                            var tempobj1 = {};
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(tempObj, function (val, field) {
                                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(val)) {
                                    tempobj1[field] = {
                                        value: val.map(function (d) { return d.id; }).join(','),
                                        valueSpan: val.map(function (d) { return d.name || d.lastname; }).join(','),
                                        valueObj: val
                                    };
                                }
                                else {
                                    tempobj1[field] = val;
                                }
                            });
                            tempDetail && quickEditDataInput_1[tempDetail].push(tempobj1);
                        });
                        /***
                         * 1、快速编辑-新增后当前行可编辑
                         * 2、更新数据到editstore
                         */
                        if (type == '0') {
                            // console.log("quickEditDataInput",quickEditDataInput)
                            cubeForm.updateValues(quickEditDataInput_1); //更新新增的
                            var detailkeysState_1 = {};
                            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(quickEditDataInput_1, function (detailValues, detailname) {
                                var field = cubeForm.$(detailname);
                                var detailkeys = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(field.value[0]).filter(function (d) { return d.startsWith('field'); });
                                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(detailkeys, function (fieldid) {
                                    var editstate = getFieldEditState(fieldid).editstate;
                                    if (editstate == '3') {
                                        detailkeysState_1[fieldid] = editstate;
                                    }
                                    for (var i = 0; i < detailValues.length; i++) {
                                        field.$(detailValues[i]['dtl_index']).$(fieldid).setViewAttrs("", editstate == '2' ? '1' : (editstate == '3' ? '2' : '3'));
                                    }
                                });
                            });
                            quickEditStore.update({ detailkeysState: detailkeysState_1, detalCurrentValue: quickEditDataInput_1, mainFieldState: mainFieldState_1 });
                            //快速编辑，字段联动后保存
                            setTimeout(function () {
                                if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(mainFieldState_1)) { //联动主表有必填，先校验主表
                                    // quickEditStore.editFieldKey = Object.keys(mainFieldState)[0];
                                    quickEditStore.checkRequireMain({}, true);
                                }
                                else {
                                    if (quickEditStore.handletype == 'copy') {
                                        return;
                                    }
                                    if (quickEditStore.handletype != 'add') {
                                        quickEditStore.checkRequireDetail({}, true);
                                    }
                                }
                            }, 100);
                        }
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this.loading = false;
            }));
        };
        this.getTrigger = function (fields, trigger, nullTrigger, index) {
            var _a = _this.card.getFieldProps(trigger), isdetail = _a.isdetail, detail = _a.detail;
            if (isdetail) {
                if (_this.card.cubeForm.has(detail)) {
                    var detailTable = _this.card.cubeForm.$(detail);
                    return detailTable.map(function (row) {
                        if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(index) && row.key != index) {
                            return null;
                        }
                        var tiggerValue = row.has(trigger) && row.$(trigger).getValue();
                        if (!tiggerValue && !nullTrigger) {
                            return null;
                        }
                        var _trigger = {
                            index: row.key,
                        };
                        fields.map(function (f) {
                            if (row.has(f)) {
                                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_trigger, f, row.$(f).getValue());
                            }
                            else if (_this.card.cubeForm.has(f)) {
                                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_trigger, f, _this.card.cubeForm.$(f).getValue());
                            }
                        });
                        return _trigger;
                    });
                }
            }
            else {
                var _trigger_1 = {};
                var tiggerValue = _this.card.cubeForm.has(trigger) && _this.card.cubeForm.$(trigger).getValue();
                if (!tiggerValue && !nullTrigger) {
                    return [null];
                }
                fields.map(function (f) {
                    if (_this.card.cubeForm.has(f)) {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_trigger_1, f, _this.card.cubeForm.$(f).getValue());
                    }
                });
                return [_trigger_1];
            }
        };
        this.addOnChange = function (field, onChange) {
            var f = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this.onChangeFuns, field);
            if (f && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(f)) {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_this.onChangeFuns, field, f.concat([onChange]));
            }
            else {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(_this.onChangeFuns, field, [onChange]);
            }
        };
        this.getSubmitData = function () {
            var data = {};
            _this.card.cubeForm.map(function (f) {
                if (f.key.startsWith('detail_')) {
                    var detailExcel = _this.card.modeExcel.getExcel(f.key);
                    if (!detailExcel) {
                        return;
                    }
                    var detailProps = detailExcel.detailProps;
                    var isHideNull = false;
                    if (detailProps && detailProps.isHideNull) {
                        isHideNull = true;
                    }
                    if (isHideNull) {
                        f.map(function (row) {
                            var isNull = true;
                            row.map(function (d) {
                                var value = d.getValue();
                                if (d.key != 'checkbox' && !!value) {
                                    isNull = false;
                                }
                            });
                            if (!isNull) {
                                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(data, f.key + ".[" + row.key + "]", row.values());
                            }
                        });
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(data, f.key, f.values());
                    }
                    var submitdtlids = f.map(function (row) {
                        return row.key;
                    }).join(",");
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(data, "submitdtlid" + f.key.replace('detail_', ''), submitdtlids);
                }
                else {
                    var _a = _this.card.getFieldProps(f.path), fieldhtmltype = _a.fieldhtmltype, fieldtype = _a.fieldtype;
                    if (fieldhtmltype == '3' && fieldtype == '17') { //多人力资源特殊处理
                        var groupInfo = f.buildMultiUserGroupInfo(f.getValue(), f.valueObj);
                        var groupnum = groupInfo.groupnum;
                        for (var i = 0; i < groupnum; i++) {
                            if ("group_" + i in groupInfo)
                                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(data, f.key + "group" + i, groupInfo["group_" + i]);
                        }
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(data, f.key + "groupnum", groupnum);
                    }
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(data, f.key, f.getValue());
                }
            });
            return data;
        };
        this.card = card;
        __WEBPACK_IMPORTED_MODULE_4__util__["default"].CubeTrigger = this;
        this.formulaAction = new __WEBPACK_IMPORTED_MODULE_5__Formula__["a" /* default */](this.card, this);
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CubeTrigger.prototype, "needSumFields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CubeTrigger.prototype, "datas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CubeTrigger.prototype, "colCals", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CubeTrigger.prototype, "rowCals", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CubeTrigger.prototype, "inputEntryData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CubeTrigger.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "executeWhenAddRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "executeWhenCopyRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "executeWhenDelRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "doColCals", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "doRowCals", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "doRowColCons", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "findSameRowChilds", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "getDataset", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "isdoByfield", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "isDoFieldAttrLinkPage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "doFieldAttrLinkPage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "cubeFieldAttrLinkPage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "doLayoutFieldAttr", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "cubeFieldAttr", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "doInputEntry", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CubeTrigger.prototype, "cubeDataInput", void 0);
    return CubeTrigger;
}());
/* harmony default export */ __webpack_exports__["a"] = (CubeTrigger);


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var EXCEL_SUM = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = 0;
    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(args, function (v) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(v) && !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNaN(v)) {
            result = rewrite_add(result, v);
            // result += v;
        }
    });
    return result;
};
/**
 * JS 浮点数求和 精度不对 (0.1+0.2=0.30000000000004等的问题)
 */
var rewrite_add = function (arg1, arg2) {
    var r1 = 0, r2 = 0;
    try {
        r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) { }
    try {
        r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) { }
    var m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
};
var EXCEL_SUB = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = args[0]; //第一位参数不处理符号
    args = args.slice(1, args.length);
    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(args, function (v) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(v) && !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNaN(v)) {
            if (v < 0) {
                result = rewrite_add(result, EXCEL_ABS(v));
                // result += EXCEL_ABS(v);
            }
            else if (v >= 0) {
                result = rewrite_add(result, -v);
                // result += -v;
            }
        }
    });
    return result;
};
var EXCEL_AVERAGE = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length == 0) {
        return 0;
    }
    else {
        return EXCEL_SUM.apply(void 0, args) / args.length;
    }
};
var EXCEL_ABS = function (v) {
    return Math.abs(v);
};
var EXCEL_ROUND = function (value, qfws) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(value) && !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNaN(value)) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isInteger(qfws) && !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNaN(qfws)) {
            return value.toFixed(qfws);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("" + ('EXCEL_ROUND' + getLabel('383715', "第一个参数必须是整数")));
        }
    }
    else {
        __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("" + ('EXCEL_ROUND' + getLabel('521951', '第一个参数必须是数字')));
    }
    return 0;
};
var EXCEL_IF = function (condition, ifValue, elseValue) {
    if (condition) {
        return ifValue;
    }
    else {
        return elseValue;
    }
};
var EXCEL_MAX = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Math.max.apply(Math, args);
};
var EXCEL_MIN = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Math.min.apply(Math, args);
};
var Formula = /** @class */ (function () {
    function Formula(card, trigger) {
        var _this = this;
        this.convertCharToInt = function (value) {
            var rtn = 0;
            var powIndex = 0;
            for (var i = value.length - 1; i >= 0; i--) {
                var tmpInt = value[i].charCodeAt() - 64;
                rtn += Math.pow(26, powIndex) * tmpInt;
                powIndex++;
            }
            return rtn;
        };
        this.getCellField = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return args.map(function (d) {
                var _a = d.split('\.'), table = _a[0], xy = _a[1];
                var rowStr = xy.match(/\d+$/);
                var colStr = xy.match(/^[a-zA-Z]+/);
                var rowid = rowStr && parseInt(rowStr[0]) - 1;
                var colid = colStr && _this.convertCharToInt(colStr[0]) - 1;
                var _cell = {};
                if (table.toUpperCase() == 'MAIN') { //主表字段
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this.card.modeExcel.cells, function (cell) {
                        if (cell.row == rowid && cell.col == colid) {
                            _cell = cell;
                        }
                    });
                }
                else if (table.toUpperCase().startsWith("TAB_")) {
                    var tab = _this.card.modeExcel.getTabs(table.toLowerCase());
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(tab.cells, function (cell) {
                        if (cell.row == rowid && cell.col == colid) {
                            _cell = cell;
                        }
                    });
                }
                else {
                    var detail = _this.card.modeExcel.getExcel(table.toLowerCase());
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(detail.cells, function (cell) {
                        if (cell.row == rowid && cell.col == colid) {
                            _cell = cell;
                        }
                    });
                }
                return _cell;
            });
        };
        this.calculate = function (formula, isMain, key) {
            if (EXCEL_SUM || EXCEL_AVERAGE || EXCEL_ABS || EXCEL_ROUND || EXCEL_IF || EXCEL_MAX || EXCEL_MIN || EXCEL_SUB) { }
            var _formulaTxt = _this.replaceFormula(formula, isMain, key);
            if (_formulaTxt.startsWith('=')) {
                _formulaTxt = _formulaTxt.slice(1);
            }
            return eval(_formulaTxt);
        };
        this.replaceFormula = function (formula, isMain, key) {
            var formulatxt = formula.formulatxt;
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(formula.cellrange, function (cell) {
                var rtArray = [];
                var fieldCell = _this.getCellField(cell)[0];
                var path = fieldCell.getPath();
                if (isMain) { //赋值给主表
                    var _a = _this.card.getFieldProps(path), isdetail = _a.isdetail, detail = _a.detail;
                    if (isdetail) {
                        if (_this.card.cubeForm.has(detail)) {
                            _this.card.cubeForm.$(detail).map(function (row) {
                                if (row.has(path)) {
                                    var value = row.$(path).getValue();
                                    if (value) {
                                        if (_this.card.getFieldProps(path).fieldhtmltype == '1' && _this.card.getFieldProps(path).fieldtype == '5') {
                                            value = _this.delcommafy(value);
                                        }
                                        rtArray.push(value);
                                    }
                                    else {
                                        rtArray.push('0');
                                    }
                                }
                            });
                        }
                    }
                    else {
                        if (_this.card.cubeForm.has(path)) {
                            var value = _this.card.cubeForm.$(path).getValue();
                            if (value) {
                                if (_this.card.getFieldProps(path).fieldhtmltype == '1' && _this.card.getFieldProps(path).fieldtype == '5') {
                                    value = _this.delcommafy(value);
                                }
                                rtArray.push(value);
                            }
                            else {
                                rtArray.push('0');
                            }
                        }
                    }
                }
                else { //赋值给明细表
                    var _b = _this.card.getFieldProps(path), isdetail = _b.isdetail, detail = _b.detail;
                    if (isdetail) {
                        if (_this.card.cubeForm.has(detail)) {
                            var detailTable = _this.card.cubeForm.$(detail);
                            if (detailTable.has(key)) {
                                var row = detailTable.$(key);
                                if (row.has(path)) {
                                    var value = row.$(path).getValue();
                                    if (value) {
                                        if (_this.card.getFieldProps(path).fieldhtmltype == '1' && _this.card.getFieldProps(path).fieldtype == '5') {
                                            value = _this.delcommafy(value);
                                        }
                                        rtArray.push(value);
                                    }
                                    else {
                                        rtArray.push('0');
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (_this.card.cubeForm.has(path)) {
                            var value = _this.card.cubeForm.$(path).getValue();
                            if (value) {
                                if (_this.card.getFieldProps(path).fieldhtmltype == '1' && _this.card.getFieldProps(path).fieldtype == '5') {
                                    value = _this.delcommafy(value);
                                }
                                rtArray.push(value);
                            }
                            else {
                                rtArray.push('0');
                            }
                        }
                    }
                }
                var curindex = -1;
                while (formulatxt.indexOf(cell) > curindex) {
                    curindex = formulatxt.indexOf(cell);
                    var str1 = formulatxt.substring(0, curindex);
                    var str2 = formulatxt.substring(curindex + cell.length);
                    var reg = /^[0-9]$/;
                    var nextchar = str2.substr(0, 1);
                    if (reg.test(nextchar))
                        continue;
                    formulatxt = str1 + (rtArray.length == 0 ? '0' : rtArray.join(",")) + str2;
                }
            });
            return formulatxt;
        };
        this.doFormulaBindChange = function () {
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this.card.modeExcel.formula, function (formula) {
                    var destfield = "field" + formula.destfield;
                    var _a = _this.card.getFieldProps(destfield), isdetail = _a.isdetail, detail = _a.detail;
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(formula.cellrange, function (cell) {
                        var fieldCell = _this.getCellField(cell)[0];
                        var path = fieldCell.getPath();
                        var isdetail1 = _this.card.getFieldProps(path) && _this.card.getFieldProps(path).isdetail;
                        _this.trigger.addOnChange(path, function (index) {
                            var value = 0;
                            if (isdetail) {
                                value = _this.calculate(formula, false, index);
                                _this.card.cubeForm.has(detail) && _this.card.cubeForm.$(detail).map(function (row) {
                                    // if (index && row.index != index) {   //QC403315(W-4),没有取到row.index导致直接返回
                                    //     //return;
                                    // }
                                    if (isdetail1 && index) {
                                        _this.card.cubeForm.setValue(detail + "." + index + "." + destfield, "" + value, true);
                                    }
                                    else { // 子表公式配置的是主表字段的时候
                                        if (index) {
                                            _this.card.cubeForm.setValue(detail + "." + row.key + "." + destfield, "" + value, true);
                                        }
                                    }
                                    //row.has(destfield) && row.$(destfield).onChange(`${value}`);
                                });
                            }
                            else {
                                value = _this.calculate(formula, true);
                                _this.card.cubeForm.has(destfield) && _this.card.cubeForm.$(destfield).onChange("" + value, null, [], true);
                            }
                        });
                    });
                });
            }, 10);
        };
        this.card = card;
        this.trigger = trigger;
    }
    Formula.prototype.execute = function () {
        var _this = this;
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this.card.modeExcel.formula, function (formula) {
                var destfield = "field" + formula.destfield;
                var _a = _this.card.getFieldProps(destfield), isdetail = _a.isdetail, detail = _a.detail;
                if (isdetail) { //赋值给明细表
                    var detailTable = _this.card.cubeForm.has(detail) && _this.card.cubeForm.$(detail);
                    if (detailTable) {
                        detailTable.map(function (row) {
                            var value = _this.calculate(formula, false, row.key);
                            row.has(destfield) && !row.$(destfield).value && row.$(destfield).onChange("" + value, null, [], true);
                        });
                    }
                }
                else { //赋值给主表
                    var value = _this.calculate(formula, true);
                    _this.card.cubeForm.has(destfield) && _this.card.cubeForm.$(destfield).onChange("" + value, null, [], true);
                }
            });
        }, 10);
    };
    Formula.prototype.delcommafy = function (num) {
        if ((num + "").trim() == "") {
            return "";
        }
        num = num.replace(/,/gi, '');
        return num;
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], Formula.prototype, "execute", null);
    return Formula;
}());
/* harmony default export */ __webpack_exports__["a"] = (Formula);


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__list__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_contentPath__ = __webpack_require__(9);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var getLabel = __WEBPACK_IMPORTED_MODULE_8_ecCom__["WeaLocaleProvider"].getLabel;



var Base64 = __WEBPACK_IMPORTED_MODULE_8_ecCom__["WeaTools"].Base64;
var numval = 0;
var modeTitle = "";
var CardTab = /** @class */ (function () {
    function CardTab(card) {
        var _this = this;
        this.rightMenus = [];
        this.quickButton = {};
        this.innerTab = [];
        this.topTabs = [];
        this.topActiveKey = '';
        this.topDropActiveKey = '';
        this.innerTabSelectedKey = '1000';
        this.isCube = false;
        this.hrefUrl = "";
        this.reloadModeDefaultParams = {};
        this.RightMenusData = [];
        this.urlMap = {};
        this.confirmMap = {};
        this.disabled = false;
        this.init = function (params) {
            _this.getRightMenus(params);
            if (!_this.card.isInline) {
                _this.getTopTabs(params);
                _this.getInnerTabs(params);
            }
        };
        this.rightMenuHandle = function (key) {
            if (_this.card.isSearchShow) {
                __WEBPACK_IMPORTED_MODULE_7__list__["default"].rightMenuClick(key);
            }
            else if (_this.card.isCardShow) {
                _this.card.card.Actions.runCustomAction(key);
            }
            else {
                _this.card.Actions.runCustomAction(key);
            }
        };
        this.getTopTabs = function (params) {
            Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["D" /* getTopTabs */])(params).then(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, topTabs = _a.topTabs, defaultselect = _a.defaultselect;
                if (status == '1') {
                    _this.topTabs = _this.createTopTab(topTabs);
                    if (defaultselect && defaultselect != '') {
                        //直接调用,内嵌tab页没时间加载,可能会变成空
                        setTimeout(function () { _this.changeTopActiveKey(defaultselect); }, 500);
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_6_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
            });
        };
        this.createTopTab = function (params) {
            var cardTopTabs = [];
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(params, function (value) {
                var key = value.detailid;
                if (key.indexOf("group") > -1) {
                    cardTopTabs.push(__assign({ key: key, title: value.groupname }, value, { groups: _this.createTopTab(value.groups) }));
                }
                else {
                    cardTopTabs.push(__assign({ key: key, title: value.expendname }, value));
                }
            });
            return cardTopTabs;
        };
        this.getInnerTabs = function (params) {
            var cardInnerTabs = [];
            Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["v" /* getInnerTabs */])(params).then(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, innerTabs = _a.innerTabs, defaultselect = _a.defaultselect;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(innerTabs, function (value) {
                        cardInnerTabs.push(__assign({ key: value.detailid, title: value.expendname }, value));
                    });
                    _this.innerTab = cardInnerTabs;
                    if (defaultselect && defaultselect != '') {
                        _this.changeInnerTabSelectedKey(defaultselect);
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_6_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
            });
        };
        this.getRightMenus = function (params) {
            Object(__WEBPACK_IMPORTED_MODULE_1__apis_card__["B" /* getRightMenus */])(params).then(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, rightMenus = _a.rightMenus, urlMap = _a.urlMap, _b = _a.confirmMap, confirmMap = _b === void 0 ? {} : _b;
                if (status == '1') {
                    _this.initRightMenus(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.compact(rightMenus));
                    _this.urlMap = urlMap;
                    _this.confirmMap = confirmMap;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_6_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
            });
        };
        this.setRightMenus = function (rightmenus) {
            _this.rightMenus = rightmenus.map(function (rightMenu) {
                return __assign({}, rightMenu, { icon: React.createElement("i", { className: rightMenu.icon }) });
            });
        };
        this.getRightMenu = function (key) {
            var rightMenus = _this.rightMenus.slice(0).filter(function (d) { return d.key == key; });
            if (rightMenus.length > 0) {
                return rightMenus[0];
            }
            return {};
        };
        this.initRightMenus = function (rightMenus) {
            if (rightMenus) {
                _this.rightMenus = rightMenus.map(function (rightMenu) { return (__assign({}, rightMenu, { content: rightMenu.name, icon: React.createElement("i", { className: rightMenu.icon }), quickButton: rightMenu.quickButton })); });
            }
            else {
                _this.rightMenus = [];
            }
        };
        this.changeTopActiveKey = function (key) {
            if (__WEBPACK_IMPORTED_MODULE_7__list__["default"] && __WEBPACK_IMPORTED_MODULE_7__list__["default"].slideModalVisible) { //如果切换tab的时候有未关闭的Slider
                __WEBPACK_IMPORTED_MODULE_7__list__["default"].showSlideModal(false, "", "");
            }
            var hreftarget = '';
            if (key == '0') {
                _this.topActiveKey = key;
                _this.topDropActiveKey = '';
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe").hide().attr("src", "");
                _this.isCube = false;
                if (_this.innerTabSelectedKey) {
                    setTimeout(function () { _this.changeInnerTabSelectedKey(_this.innerTabSelectedKey); }, 300);
                }
                return;
            }
            for (var i = 0; i < _this.topTabs.length; i++) {
                var k = _this.topTabs[i].key;
                if (Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["h" /* isNumber */])(k)) {
                    if (key == k) {
                        _this.topActiveKey = key;
                        _this.topDropActiveKey = '';
                        hreftarget = _this.topTabs[i].hreftarget;
                        hreftarget = Object(__WEBPACK_IMPORTED_MODULE_4__util__["replaceE8Url"])(hreftarget);
                        _this.hrefUrl = "" + hreftarget;
                        if (hreftarget.indexOf("/spa/cube/index.html") >= 0 || hreftarget.indexOf("/spa/cube/index.jsp") >= 0) {
                            _this.isCube = true;
                            if (hreftarget.indexOf("main/cube/search") >= 0
                                || hreftarget.indexOf("main/cube/reply") >= 0 ||
                                hreftarget.indexOf("main/cube/viewCustomPage") >= 0) {
                                _this.isCube = true;
                                __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe").hide().attr("src", "");
                            }
                            else {
                                _this.isCube = false;
                                hreftarget = Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["b" /* checkHref */])(hreftarget);
                                __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe").attr("src", hreftarget).show();
                                __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe")[0].contentWindow.location.href = hreftarget;
                            }
                        }
                        else {
                            _this.isCube = false;
                            __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe").attr("src", hreftarget).show();
                            __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe")[0].contentWindow.location.href = hreftarget;
                        }
                        return;
                    }
                }
                else { //下拉菜单切换
                    var content = _this.topTabs[i];
                    for (var m = 0; m < content.groups.length; m++) {
                        var mk = content.groups[m].key;
                        if (key == mk) {
                            _this.topActiveKey = k;
                            _this.topDropActiveKey = mk;
                            hreftarget = content.groups[m].hreftarget;
                            hreftarget = Object(__WEBPACK_IMPORTED_MODULE_4__util__["replaceE8Url"])(hreftarget);
                            _this.hrefUrl = "" + hreftarget;
                            if (hreftarget.indexOf("/spa/cube/index.html") >= 0) {
                                _this.isCube = true;
                                if (hreftarget.indexOf("main/cube/search") >= 0
                                    || hreftarget.indexOf("main/cube/tree") >= 0 || hreftarget.indexOf("main/cube/reply") >= 0 ||
                                    hreftarget.indexOf("main/cube/viewCustomPage") >= 0) {
                                    _this.isCube = true;
                                    __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe").hide().attr("src", "");
                                }
                                else {
                                    _this.isCube = false;
                                    __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe").attr("src", hreftarget).show();
                                    __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe")[0].contentWindow.location.href = hreftarget;
                                }
                            }
                            else {
                                _this.isCube = false;
                                __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe").attr("src", hreftarget).show();
                                __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentviewframe")[0].contentWindow.location.href = hreftarget;
                            }
                            return;
                        }
                    }
                }
            }
        };
        this.changeInnerTabSelectedKey = function (key) {
            if (__WEBPACK_IMPORTED_MODULE_7__list__["default"] && __WEBPACK_IMPORTED_MODULE_7__list__["default"].slideModalVisible) { //如果切换tab的时候有未关闭的Slider
                __WEBPACK_IMPORTED_MODULE_7__list__["default"].showSlideModal(false, "", "");
            }
            _this.innerTabSelectedKey = key;
            __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentframe").hide().attr("src", '');
            __WEBPACK_IMPORTED_MODULE_9_jquery___default()(".cube-card-iframe").hide();
            if (key == '1000') {
                _this.card.isCardShow = false;
                _this.card.isSearchShow = false;
                _this.card.isShowReply = false;
                _this.card.params['needdefaultselect'] = 0;
                _this.card.reloadSearch(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.card.params));
                _this.card.reply.initReply();
            }
            else {
                _this.innerTab.slice().map(function (d) {
                    if (d.detailid == key) {
                        var hreftarget = "" + d.hreftarget;
                        if (hreftarget.indexOf('/main/cube/search') > -1) { //查询列表页面
                            _this.card.isCardShow = false;
                            _this.card.isShowReply = false;
                            _this.card.isLogListShow = false;
                            _this.card.showSearch(hreftarget);
                        }
                        else if (hreftarget.indexOf('/main/cube/card') > -1) {
                            _this.card.isSearchShow = false;
                            _this.card.isShowReply = false;
                            _this.card.isLogListShow = false;
                            _this.card.showCard(hreftarget + "&isInnerCard=true"); //属于内嵌卡片在编辑保存的时候走自己的初始化请求，禁止页面跳转
                        }
                        else if (hreftarget.indexOf('/main/cube/reply') > -1) {
                            _this.card.isSearchShow = false;
                            _this.card.isCardShow = false;
                            _this.card.isLogListShow = false;
                            _this.card.showInnerReply(hreftarget);
                            _this.card.reply.initReply();
                        }
                        else if (hreftarget.indexOf('/main/cube/logList') > -1) {
                            _this.card.isSearchShow = false;
                            _this.card.isCardShow = false;
                            _this.card.isShowReply = false;
                            _this.card.showInnerLogList(hreftarget);
                        }
                        else {
                            hreftarget = Object(__WEBPACK_IMPORTED_MODULE_10__util_contentPath__["a" /* getContentPath */])(Object(__WEBPACK_IMPORTED_MODULE_3__util_typeUtil__["b" /* checkHref */])(hreftarget));
                            _this.card.isCardShow = false;
                            _this.card.isSearchShow = false;
                            _this.card.isShowReply = false;
                            _this.card.isLogListShow = false;
                            __WEBPACK_IMPORTED_MODULE_9_jquery___default()('#tabcontentframe').height(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".cube-card-iframe").height() - 5); // 重新计算高度，解决外部链接显示两个滚动条的问题
                            __WEBPACK_IMPORTED_MODULE_4__util__["default"].open(hreftarget, 'tabcontentframe');
                            __WEBPACK_IMPORTED_MODULE_9_jquery___default()(".cube-card-iframe").show();
                            __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentframe").attr("src", hreftarget).show();
                            __WEBPACK_IMPORTED_MODULE_9_jquery___default()("#tabcontentframe")[0].contentWindow.location.href = hreftarget;
                        }
                    }
                });
            }
        };
        this.card = card;
        if (card && card.cardTab) {
            this.topTabs = card.cardTab.topTabs;
            this.innerTab = card.cardTab.innerTab;
        }
    }
    Object.defineProperty(CardTab.prototype, "tabDatas", {
        get: function () {
            if (numval == 0) {
                modeTitle = this.card.base.modeTitle;
                if (modeTitle != undefined && modeTitle != '') {
                    if (modeTitle.startsWith('base64_')) {
                        modeTitle = modeTitle.substring(7, modeTitle.length);
                        modeTitle = Base64.decode(modeTitle);
                    }
                    numval = 1;
                }
            }
            return this.innerTab && this.innerTab.slice().length > 0 ? [{ key: "1000", title: getLabel(1361, "基本信息") }].concat(this.innerTab.slice()) :
                [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardTab.prototype, "title", {
        get: function () {
            numval = 0;
            if (numval == 0) {
                modeTitle = this.card.base.modeTitle;
                if (modeTitle != undefined && modeTitle != '') {
                    if (modeTitle.startsWith('base64_')) {
                        modeTitle = modeTitle.substring(7, modeTitle.length);
                        modeTitle = Base64.decode(modeTitle);
                    }
                    numval = 1;
                }
            }
            if (__WEBPACK_IMPORTED_MODULE_5____["default"].isTitleChanged == '1') {
                return modeTitle;
            }
            else {
                return "";
            }
            ;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardTab.prototype, "rightMenusToShow", {
        get: function () {
            var _this = this;
            if (this.card.isSearchShow) {
                return __WEBPACK_IMPORTED_MODULE_7__list__["default"].rightMenus.map(function (m) { return ({
                    key: m.key,
                    content: m.name,
                    icon: React.createElement("i", { className: m.icon }),
                    quickButton: m.quickButton,
                    disabled: _this.disabled
                }); });
            }
            else if (this.card.isCardShow) {
                return this.card.card.cardTab.rightMenus.map(function (m) { return (__assign({}, m, { disabled: _this.card.card.cardTab.disabled })); });
            }
            else if (this.innerTabSelectedKey == '1000') {
                return this.rightMenus.map(function (m) { return (__assign({}, m, { disabled: _this.disabled })); });
                ;
            }
            else {
                return [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardTab.prototype, "quickButtons", {
        get: function () {
            var _this = this;
            var type = this.card.base.type;
            var buttons = [];
            if (type == '0') {
                var isallowlike = this.card.isallowlike;
                var likeshowname = this.card.likeshowname;
                var isallowdislike = this.card.isallowdislike;
                var dislikeshowname = this.card.dislikeshowname;
                var likecount = this.card.likecount;
                var dislikecount = this.card.dislikecount;
                var liketitle = likeshowname;
                var disliketitle = dislikeshowname;
                var likeicon = '';
                var dislikeicon = '';
                if (this.card.likestatus == '1') {
                    if (likeshowname == '') {
                        liketitle = getLabel('32944', '取消赞');
                    }
                    else {
                        liketitle = getLabel('31129', '取消') + likeshowname;
                    }
                    if (dislikeshowname == '') {
                        disliketitle = getLabel('515888', '踩');
                    }
                    likeicon = 'icon-coms02-like';
                    dislikeicon = 'icon-coms02-Negative-comment-o';
                }
                else if (this.card.likestatus == '2') {
                    if (likeshowname == '') {
                        liketitle = getLabel('32942', '赞');
                    }
                    if (dislikeshowname == '') {
                        disliketitle = getLabel('515889', '取消踩');
                    }
                    else {
                        disliketitle = getLabel('31129', '取消') + dislikeshowname;
                    }
                    likeicon = 'icon-coms02-like-o';
                    dislikeicon = 'icon-coms02-Negative-comment';
                }
                else {
                    if (likeshowname == '') {
                        liketitle = getLabel('32942', '赞');
                    }
                    if (dislikeshowname == '') {
                        disliketitle = getLabel('515888', '踩');
                    }
                    likeicon = 'icon-coms02-like-o';
                    dislikeicon = 'icon-coms02-Negative-comment-o';
                }
                if (isallowlike == '1') {
                    buttons.push(React.createElement("div", { style: { 'cursor': 'pointer' } },
                        React.createElement("i", { title: liketitle, className: likeicon, onClick: function () { _this.likeOrDislike('1'); } }),
                        React.createElement("span", null, ' ' + likeshowname + ' (' + likecount + ')')));
                }
                if (isallowdislike == '1') {
                    buttons.push(React.createElement("div", { style: { 'cursor': 'pointer' } },
                        React.createElement("i", { title: disliketitle, className: dislikeicon, onClick: function () { _this.likeOrDislike('2'); } }),
                        React.createElement("span", null, ' ' + dislikeshowname + ' (' + dislikecount + ')')));
                }
            }
            var quickRightMenus = this.rightMenusToShow ? this.rightMenusToShow.filter(function (d) { return d.quickButton; }) : [];
            if (quickRightMenus.length > 4) {
                quickRightMenus = quickRightMenus.slice(0, 4);
            }
            quickRightMenus.map(function (d, idn) { return (buttons.push(React.createElement(__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: "_Button@fyhj44@" + idn, type: "primary", disabled: d.disabled, onClick: function () {
                    _this.rightMenuHandle(d.key);
                } }, d.content))); });
            return buttons;
        },
        enumerable: true,
        configurable: true
    });
    CardTab.prototype.likeOrDislike = function (key) {
        if (key == '1') {
            if (this.card.likestatus == '1') {
                this.card.likeOrdislike('0');
            }
            else {
                this.card.likeOrdislike(key);
            }
        }
        else if (key == '2') {
            if (this.card.likestatus == '2') {
                this.card.likeOrdislike('0');
            }
            else {
                this.card.likeOrdislike(key);
            }
        }
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "rightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "quickButton", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "innerTab", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "topTabs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "topActiveKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "topDropActiveKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "innerTabSelectedKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "isCube", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "hrefUrl", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], CardTab.prototype, "disabled", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardTab.prototype, "tabDatas", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardTab.prototype, "title", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardTab.prototype, "rightMenusToShow", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], CardTab.prototype, "quickButtons", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardTab.prototype, "getTopTabs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardTab.prototype, "getInnerTabs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardTab.prototype, "getRightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardTab.prototype, "setRightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardTab.prototype, "initRightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardTab.prototype, "changeTopActiveKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], CardTab.prototype, "changeInnerTabSelectedKey", void 0);
    return CardTab;
}());
/* harmony default export */ __webpack_exports__["a"] = (CardTab);


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var formatMultiLang = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].formatMultiLang;
var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var MapStore = /** @class */ (function () {
    function MapStore(card) {
        var _this = this;
        this.mapAttrs = {};
        this.visible = false;
        this.defaultAddress = "";
        this.currentField = "";
        this.lnglat = [];
        this.showButtons = false;
        this.updateParams = function (params) {
            // this.baseParams = {customid:params.customid};
            // this.query();
            // this.search();
            // this.getRightMenus();
        };
        this.getMapAttr = function (key) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.mapAttrs, key);
        };
        this.onCancel = function () {
            _this.visible = false;
        };
        this.onShow = function (value, path, form) {
            if (value.startsWith("~`~`") && value.endsWith("`~`~")) {
                value = formatMultiLang(value);
            }
            _this.defaultAddress = value;
            _this.currentField = path;
            _this.form = form;
            _this.visible = true;
            _this.lnglat = form.$(_this.currentField)["lnglat"];
        };
        this.updateAddress = function (value, lnglat) {
            if (lnglat === void 0) { lnglat = []; }
            if (value.startsWith("~`~`") && value.endsWith("`~`~")) {
                value = formatMultiLang(value);
            }
            _this.defaultAddress = value.replace(getLabel(34177, "当前位置") + ":", "");
            _this.lnglat = lnglat;
        };
        this.getLocation = function () {
            _this.form.$(_this.currentField).onChange(_this.form.$(_this.currentField).getValue() + _this.defaultAddress);
            _this.onCancel();
        };
        this.getLocationCover = function () {
            _this.form.$(_this.currentField).onChange(_this.defaultAddress);
            _this.form.$(_this.currentField)["lnglat"] = _this.lnglat;
            _this.onCancel();
        };
        this.card = card;
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MapStore.prototype, "mapAttrs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MapStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MapStore.prototype, "defaultAddress", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MapStore.prototype, "showButtons", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "onCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "onShow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "updateAddress", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "getLocation", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MapStore.prototype, "getLocationCover", void 0);
    return MapStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (MapStore);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return condition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return detailCondition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);

var getLabel = __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaLocaleProvider"].getLabel;
var getOptions = function (isBackLog) {
    var array = [
        { label: getLabel(82, "新建"), value: 'create' },
        { label: getLabel(93, "编辑"), value: 'edit' },
        { label: getLabel(367, "查看"), value: 'view' },
        { label: getLabel(25465, "批量修改"), value: 'munedit' },
    ];
    if (isBackLog) {
        array.push({ label: getLabel(91, "删除"), value: 'delete' });
        array.push({ label: getLabel('16211', '恢复'), value: 'recover' });
    }
    return array;
};
var condition = function (isBackLog) {
    return [
        {
            "title": getLabel(20331, "查询条件"),
            "items": [
                {
                    "browserConditionParam": {
                        "completeParams": {},
                        "conditionDataParams": {},
                        "dataParams": {},
                        "destDataParams": {},
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "hasBorder": false,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/hrm/resource/HrmResource.jsp?id=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "replaceDatas": [],
                        "title": getLabel(1867, "人员"),
                        "type": "1",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "operatorid"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": getLabel(99, "操作者"),
                    "labelcol": 6,
                    "precision": 0,
                    "viewAttr": 2
                }, {
                    "colSpan": 2,
                    "conditionType": "INPUT",
                    "domkey": [
                        "handletype"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": getLabel(15503, "操作类型"),
                    "labelcol": 6,
                    "precision": 0,
                    "viewAttr": 2,
                    "options": getOptions(isBackLog)
                }, {
                    "colSpan": 2,
                    "conditionType": "DATE",
                    "domkey": [
                        "createdateselect",
                        "createdatefrom",
                        "createdateto"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": getLabel(21663, "操作日期"),
                    "labelcol": 6,
                    "precision": 0,
                    "viewAttr": 2,
                    "options": [
                        { key: '0', selected: true, showname: getLabel(332, "全部") },
                        { key: '1', selected: false, showname: getLabel(15537, "今天") },
                        { key: '2', selected: false, showname: getLabel(15539, "本周") },
                        { key: '3', selected: false, showname: getLabel(15541, "本月") },
                        { key: '4', selected: false, showname: getLabel(21904, "本季") },
                        { key: '5', selected: false, showname: getLabel(15384, "本年") },
                        { key: '6', selected: false, showname: getLabel(32530, "指定日期范围") }
                    ]
                }
            ],
            "defaultshow": true
        }
    ];
};
var detailCondition = function () {
    return [
        {
            "title": getLabel(20331, "查询条件"),
            "items": [
                {
                    "browserConditionParam": {
                        "completeParams": {},
                        "conditionDataParams": {},
                        "dataParams": {},
                        "destDataParams": {},
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "hasBorder": false,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/hrm/resource/HrmResource.jsp?id=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "replaceDatas": [],
                        "title": getLabel(1867, "人员"),
                        "type": "1",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "userid"
                    ],
                    "fieldcol": 14,
                    "isQuickSearch": false,
                    "label": getLabel(99, "操作者"),
                    "labelcol": 8,
                    "precision": 0,
                    "viewAttr": 2,
                    "rowColSpan": 8
                }, {
                    "colSpan": 2,
                    "conditionType": "DATE",
                    "domkey": [
                        "createdateselect",
                        "datefrom",
                        "dateto"
                    ],
                    "fieldcol": 17,
                    "isQuickSearch": false,
                    "label": getLabel(97, "日期"),
                    "labelcol": 5,
                    "precision": 0,
                    "viewAttr": 2,
                    "rowColSpan": 16,
                    "options": [
                        { key: '0', selected: true, showname: getLabel(332, "全部") },
                        { key: '1', selected: false, showname: getLabel(15537, "今天") },
                        { key: '2', selected: false, showname: getLabel(15539, "本周") },
                        { key: '3', selected: false, showname: getLabel(15541, "本月") },
                        { key: '4', selected: false, showname: getLabel(21904, "本季") },
                        { key: '5', selected: false, showname: getLabel(15384, "本年") },
                        { key: '6', selected: false, showname: getLabel(32530, "指定日期范围") }
                    ]
                }
            ],
            "defaultshow": true
        }
    ];
};


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuickEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_card__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_doSubmit__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;
var getParent = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].WindowFunc.getParent;
var QuickEditStore = /** @class */ (function () {
    function QuickEditStore(card) {
        var _this_1 = this;
        this.loading = false;
        this.editFieldKey = '';
        this.formItemsCurrentValue = {};
        this.detalCurrentValue = {};
        this.detailkeysState = {};
        this.mainFieldState = {};
        this.handletype = "";
        this.oldValue = {};
        this.recordParmurls = {};
        this.update = function (params) {
            for (var key in params) {
                _this_1[key] = params[key];
            }
        };
        this.getEditState = function (fieldkey) {
            var getFieldEditState = _this_1.card.getFieldEditState;
            var fielid = fieldkey.split('_')[0];
            var editstate = getFieldEditState(fielid).editstate;
            return editstate;
        };
        this.lockEditFormItem = function (fieldkey) {
            var _a;
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this_1.detalCurrentValue)) {
                return;
            }
            var _b = fieldkey.split('_'), fielid1 = _b[0], index1 = _b[1];
            var _c = _this_1.card.getFieldProps(fielid1), fieldhtmltype = _c.fieldhtmltype, isdetail = _c.isdetail, detail = _c.detail; //fieldhtmltype = 6 附件
            var currentVal = __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__["modeForm"].getFieldValueObj(fieldkey);
            if (fieldhtmltype == '6') {
                if (isdetail) {
                    currentVal = _this_1.card.cubeForm.$(detail).$(index1).$(fielid1).uploadData.filedatas || [];
                }
                else {
                    currentVal = _this_1.card.cubeForm.$(fielid1).uploadData.filedatas || [];
                }
            }
            _this_1.oldValue = __assign({}, _this_1.oldValue, (_a = {}, _a[fieldkey] = currentVal, _a));
            var fielid = _this_1.editFieldKey.split('_')[0];
            var viewAttr = _this_1.getEditState(_this_1.editFieldKey);
            var _this = _this_1;
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__["modeForm"].changeFieldAttr(_this.editFieldKey, 1);
                if (viewAttr == '3' && !_this_1.formItemsCurrentValue[fielid]) {
                    var fieldhtmltype_1 = _this_1.card.getFieldProps(fielid).fieldhtmltype;
                    if (fieldhtmltype_1 == '6') { //附件
                        __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__["modeForm"].changeFieldValue(_this.editFieldKey, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.oldValue[_this.editFieldKey]), 'upload');
                    }
                    else if (fieldhtmltype_1 == '3') { //浏览框
                        __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__["modeForm"].changeFieldValue(_this.editFieldKey, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.oldValue[_this.editFieldKey]));
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__["modeForm"].changeFieldValue(_this.editFieldKey, __assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.oldValue[_this.editFieldKey]), { specialobj: '' }));
                    }
                }
                _this.editFieldKey = fieldkey;
                // if(_.isEmpty(_this.mainFieldState)){
                //     _this.setFormItemsCurrentValue({});
                // }
                __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__["modeForm"].changeFieldAttr(fieldkey, _this.getEditState(fieldkey));
            }, 300);
        };
        this.setFormItemsCurrentValue = function (formItemsCurrentValue) {
            _this_1.formItemsCurrentValue = formItemsCurrentValue;
        };
        this.handleClickOutSide = function (e) {
            if (_this_1.card.params.type != '0') {
                return;
            }
            // console.log("点击了文档别地地方，快速编辑应该提交了")
            var domkey = _this_1.getEditFormItemDomkey();
            var className = e.target.className;
            if (_this_1.isOpenBrowser()) { //浏览框点击不提交，阻断冒泡
                return;
            }
            if (_this_1.clickCut()) { // 其他的一些点击阻断，如富文本、明细表新增行内
                return;
            }
            /****
             * //如果domkey存在，那就是点击了当前编辑状态的字段
             * 不存在则点击了编辑外的其他地方
             */
            if (!domkey) {
                if (!className.startsWith("ant-calendar")
                    && className != "ant-select-dropdown-menu-item-active ant-select-dropdown-menu-item"
                    && className != "ant-select-dropdown-menu-item-active ant-select-dropdown-menu-item text-elli ant-tooltip-open") {
                    var _this_2 = _this_1;
                    setTimeout(function () {
                        _this_2.UpdateCardForm();
                    }, 200);
                }
            }
        };
        this.getEditFormItemDomkey = function (e) {
            var e = e || __WEBPACK_IMPORTED_MODULE_6__util__["default"].event;
            var elem = e.target || e.srcElement;
            while (elem) {
                //只有点点到当前编辑的地方才能获取到domkey
                if (elem.className && elem.className.indexOf("cube-card-editformitem2") >= 0) {
                    var domkey = elem.getAttribute("data-fieldmark");
                    var state = elem.getAttribute("data-fieldattr");
                    return state == '1' ? null : domkey;
                }
                elem = elem.parentNode;
            }
            return null;
        };
        this.unlockEditFormItem = function (bool) {
            if (bool === void 0) { bool = false; }
            // console.log("this.editFieldKey",this.editFieldKey)
            __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__["modeForm"].changeFieldAttr(_this_1.editFieldKey, 1);
            /***
             * 主表联动主表，输入后直接点击下一个字段编辑，联动有必填影响
             */
            // if(_.isEmpty(this.mainFieldState)){
            // this.setFormItemsCurrentValue({});
            // }
            _this_1.update({ editFieldKey: "", detailDefaultValue: {}, detailkeysState: {}, handletype: '' });
            if (bool) {
                _this_1.setFormItemsCurrentValue({});
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.mainFieldState), function (state, field) {
                    _this_1.card.cubeForm.$(field).setViewAttrs("", 3);
                });
                _this_1.oldValue = {};
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(_this_1.detalCurrentValue, function (value, detail) {
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(value, function (item, index) {
                        _this_1.restoreState(detail, item.dtl_index, item);
                    });
                });
                _this_1.update({ detalCurrentValue: {}, mainFieldState: {} });
            }
        };
        this.clickCut = function () {
            var e = e || __WEBPACK_IMPORTED_MODULE_6__util__["default"].event;
            var elem = e.target || e.srcElement;
            var num = 0;
            while (elem) {
                var classnamestr = elem.className;
                if (classnamestr && (classnamestr.indexOf('cube-card-weaRichtext') > -1 ||
                    classnamestr.indexOf('detail_data_editing ') > -1 ||
                    classnamestr.indexOf('cube-detailbtn-edit') > -1)) {
                    return true;
                }
                if (num === 0 && classnamestr && classnamestr.indexOf('excelDetailTable_wrap') > -1) {
                    return true;
                }
                elem = elem.parentNode;
                num++;
            }
            return false;
        };
        this.UpdateCardForm = function () {
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this_1.detalCurrentValue)) { //明细表新建考虑多行数据校验
                _this_1.checkRequireDetail();
                return;
            }
            /***
             * url或者parm带的参数有的话，
             * 点击编辑直接保存应该带上
             */
            //如果当前控件没有改变，不更新
            if ((!_this_1.editFieldKey || Object.keys(_this_1.formItemsCurrentValue).length <= 0) && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this_1.mainFieldState)) {
                if (_this_1.handelParmUrls()) {
                    _this_1.unlockEditFormItem(); //清空值，返回原状态
                    return;
                }
            }
            /****
             * 校验必填字段，先判断是不必填
             */
            if (_this_1.check_require()) {
                // console.log(this.editFieldKey, toJS(this.formItemsCurrentValue));
                /**
                 * ljc- - 如果单单是修改了明细的某一个字段
                 * 考虑行列规则、字段联动处理数据等
                 * 该字段是字段联动触发字段,等返回数据后触发提交
                 */
                var inputEntryData = _this_1.card.cubeTrigger.inputEntryData;
                var fieldid = _this_1.editFieldKey.split('_')[0];
                if (inputEntryData && inputEntryData.inputEntry && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(inputEntryData.inputEntry).indexOf(fieldid) > -1) {
                    return;
                }
                /*** */
                var mainFieldState = _this_1.mainFieldState;
                if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(mainFieldState)) { //联动主表有必填，先校验主表
                    _this_1.checkRequireMain({}, true);
                    return;
                }
                _this_1.packageMainAndDetail();
            }
        };
        this.packageMainAndDetail = function () {
            debugger;
            var values = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.formItemsCurrentValue);
            var mainparams = {};
            var detailparams = {};
            var cubeForm = _this_1.card.cubeForm;
            var template = {};
            var index = _this_1.editFieldKey.split('_')[1];
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(values, function (val, key) {
                var _a;
                var _b = _this_1.card.getFieldProps(key), isdetail = _b.isdetail, detail = _b.detail;
                if (isdetail && index != undefined) {
                    var detailvalues = cubeForm.$(detail).getValue()[index] || {};
                    template = __assign({}, template, (_a = {}, _a[key] = val, _a.dtl_id = detailvalues.dtl_id, _a));
                    if (!detailparams.hasOwnProperty(detail)) {
                        detailparams[detail] = [];
                    }
                    detailparams[detail] = [template];
                }
                else {
                    mainparams[key] = val;
                }
            });
            var dataRange = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(mainparams) ? 'detail' : (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(detailparams) ? 'main' : 'all');
            _this_1.checkDoQuickSubmit({
                JSONStr: JSON.stringify(__assign({}, mainparams, detailparams)),
                dataRange: dataRange
            });
        };
        this.checkDoQuickSubmit = function (params) {
            if (params === void 0) { params = {}; }
            var layoutBase = _this_1.card.layoutBase;
            return new Promise(function (resolve, reject) {
                if (layoutBase.haveVerifyRepeat && layoutBase.haveVerifyRepeat == '1') { //判断是否有重复验证
                    _this_1.card.Actions.submitActions.verifyRepeat(false, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(layoutBase.verify_fields), Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(layoutBase.verify_fieldinfos)).then(function () {
                        _this_1.checkCustomize(params);
                    });
                }
                else {
                    _this_1.checkCustomize(params);
                }
            });
        };
        this.checkCustomize = function (params) {
            try {
                if (typeof (__WEBPACK_IMPORTED_MODULE_6__util__["default"].checkCustomize) == 'function') { //全局校验支持异步
                    return new Promise(function (resolve) {
                        var a = __WEBPACK_IMPORTED_MODULE_6__util__["default"].checkCustomize(resolve);
                        if (typeof a === 'boolean') {
                            resolve(a);
                        }
                    }).then(function (res) {
                        if (res) {
                            _this_1.submitData(params);
                        }
                    });
                }
                else {
                    _this_1.submitData(params);
                }
            }
            catch (e) {
                return false;
            }
        };
        this.submitData = function (params) {
            try {
                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isFunction(__WEBPACK_IMPORTED_MODULE_6__util__["default"].startUploadAll)) {
                    __WEBPACK_IMPORTED_MODULE_6__util__["default"].startUploadAll();
                }
                var allUploaded_1 = false;
                var timer_1 = setInterval(function () {
                    allUploaded_1 = true;
                    _this_1.card.uploadFields.map(function (f) {
                        if (!allUploaded_1) {
                            return;
                        }
                        var _a = _this_1.card.getFieldProps(f), isdetail = _a.isdetail, detail = _a.detail;
                        if (isdetail) {
                            if (_this_1.card.cubeForm.has(detail)) {
                                var detailTable = _this_1.card.cubeForm.$(detail);
                                detailTable.map(function (row) {
                                    if (!allUploaded_1) {
                                        return;
                                    }
                                    if (row.has(f)) {
                                        if (!row.$(f).isUpload) {
                                            allUploaded_1 = false;
                                        }
                                    }
                                });
                            }
                        }
                        else {
                            if (_this_1.card.cubeForm.has(f)) {
                                if (!_this_1.card.cubeForm.$(f).isUpload) {
                                    allUploaded_1 = false;
                                }
                            }
                        }
                    });
                    if (allUploaded_1) {
                        if (typeof (getParent()['slideflgfun']) == 'function') {
                            if (getParent()['slideflgfun']()) {
                                getParent()['dosubmitfun']();
                            }
                        }
                        _this_1.doQuickSubmit(params); //快速编辑提交
                        clearInterval(timer_1);
                    }
                }, 100);
            }
            catch (e) {
                _this_1.doQuickSubmit(params);
            }
        };
        this.check_require = function () {
            var viewAttr = _this_1.getEditState(_this_1.editFieldKey);
            var _a = _this_1.editFieldKey.split('_'), field = _a[0], index = _a[1];
            if (viewAttr == '3' && !_this_1.formItemsCurrentValue[field]) {
                //必填校验不通过
                // const field = this.editFieldKey.indexOf('_')>0 ?  :this.editFieldKey;
                var _b = _this_1.card.getFieldProps(field), isdetail = _b.isdetail, detail = _b.detail;
                var errorField_1;
                if (isdetail) {
                    errorField_1 = _this_1.card.cubeForm.$(detail + "." + index + "." + field);
                    errorField_1.tips = {
                        visible: true,
                        msg: errorField_1.errors()
                    };
                }
                else {
                    errorField_1 = _this_1.card.cubeForm.$(field);
                    errorField_1.tips = {
                        visible: true,
                        msg: errorField_1.errors()
                    };
                }
                setTimeout(function () {
                    errorField_1.tips = {
                        visible: false,
                        msg: ''
                    };
                }, 1500);
                return false;
            }
            return true;
        };
        this.checkRequireMain = function (mainDatas, bool) {
            if (mainDatas === void 0) { mainDatas = {}; }
            if (bool === void 0) { bool = false; }
            var _a = _this_1, mainFieldState = _a.mainFieldState, formItemsCurrentValue = _a.formItemsCurrentValue, cubeForm = _a.card.cubeForm;
            var isTrue = true;
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(mainFieldState), function (state, field) {
                if (cubeForm.has(field) && !cubeForm.$(field).getValue()) {
                    if (!isTrue) {
                        return;
                    }
                    isTrue = false;
                    var firstErrorField = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(".cube-card-editformitem2[data-fieldmark=" + field + "]");
                    Object(__WEBPACK_IMPORTED_MODULE_7__actions_doSubmit__["b" /* scrollTo */])(firstErrorField, _this_1.card.cubeForm, function () {
                        var errorField = cubeForm.$(field);
                        errorField.tips = {
                            visible: true,
                            msg: errorField.errors()
                        };
                        setTimeout(function () {
                            errorField.tips = {
                                visible: false,
                                msg: ''
                            };
                        }, 1500);
                    });
                }
            });
            if (isTrue && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this_1.detalCurrentValue)) {
                _this_1.update({ mainFieldState: {} });
                _this_1.checkRequireDetail({}, true);
                return;
            }
            if (isTrue) {
                var params = __assign({}, formItemsCurrentValue);
                _this_1.checkDoQuickSubmit({
                    JSONStr: JSON.stringify(params),
                    dataRange: 'main'
                });
            }
        };
        this.checkRequireDetail = function (detailDatas, bool) {
            if (detailDatas === void 0) { detailDatas = {}; }
            if (bool === void 0) { bool = false; }
            var mainFieldState = _this_1.mainFieldState;
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(mainFieldState)) { //联动主表有必填，先校验主表
                _this_1.checkRequireMain({}, true);
                return;
            }
            var detailkeysState = _this_1.detailkeysState;
            var isTrue = true;
            var isOut = false;
            var detailSubmitValue = {};
            var tempDetailSubValue = {};
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.detalCurrentValue), function (value, detail) {
                var detailTable = _this_1.card.cubeForm.$(detail);
                var detailvalues = detailTable.getValue();
                var tempdatas = value.length == 1 && detailvalues.filter(function (d) { return d['dtl_id'] == value[0]['dtl_id']; })[0];
                detailvalues = value.length == 1 ? [__assign({}, value[0], tempdatas, { dtl_index: value[0]['dtl_index'] })] : detailvalues.filter(function (d) { return d['dtl_id'].length > 30; });
                detailSubmitValue[detail] = detailvalues;
                tempDetailSubValue[detail] = [];
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(value, function (item) {
                    if (item.dtl_id && detailTable.has(item.dtl_index)) {
                        tempDetailSubValue[detail].push(detailTable.$(item.dtl_index).value);
                    }
                });
                var errorField;
                try {
                    try {
                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(detailkeysState, function (state, field) {
                            var fieldDetail = _this_1.card.getFieldProps(field).detail;
                            if (fieldDetail != detail) {
                                return;
                            }
                            var _loop_1 = function (i) {
                                var list = detailvalues[i];
                                if (!list[field]) {
                                    if (isOut) {
                                        return { value: void 0 };
                                    }
                                    isTrue = false;
                                    isOut = true;
                                    var firstErrorField_1 = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(".cube-card-editformitem2[data-fieldmark=" + field + "_" + list['dtl_index'] + "]");
                                    errorField = _this_1.card.cubeForm.$(detail + "." + list['dtl_index'] + "." + field);
                                    Object(__WEBPACK_IMPORTED_MODULE_7__actions_doSubmit__["b" /* scrollTo */])(firstErrorField_1, _this_1.card.cubeForm, function ($ele) {
                                        Object(__WEBPACK_IMPORTED_MODULE_7__actions_doSubmit__["c" /* scrollToX */])(firstErrorField_1, _this_1.card.cubeForm, function () {
                                            errorField.tips = {
                                                visible: true,
                                                msg: errorField.errors() ? errorField.errors() : errorField.label + getLabel(21423, "未填写")
                                            };
                                        });
                                        setTimeout(function () {
                                            errorField.tips = {
                                                visible: false,
                                                msg: ''
                                            };
                                        }, 1500);
                                    });
                                    throw new Error('error');
                                }
                            };
                            for (var i = 0; i < detailvalues.length; i++) {
                                var state_1 = _loop_1(i);
                                if (typeof state_1 === "object")
                                    return state_1.value;
                            }
                        });
                        if (isOut) {
                            throw new Error('error');
                        }
                    }
                    catch (error) {
                        if (error.message != 'error')
                            throw error;
                    }
                }
                catch (error) {
                    if (error.message != 'error')
                        throw error;
                }
            });
            if (isTrue) {
                var mainValues_1 = {};
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.formItemsCurrentValue), function (value, field) {
                    var isdetail = _this_1.card.getFieldProps(field).isdetail;
                    if (!isdetail) {
                        mainValues_1[field] = value;
                    }
                });
                /**
                 * bool =true
                 * 字段联动返回后触发校验提交，
                 */
                if (bool) {
                    detailSubmitValue = tempDetailSubValue;
                }
                var params = __assign({}, mainValues_1, detailSubmitValue);
                _this_1.checkDoQuickSubmit({
                    JSONStr: JSON.stringify(params),
                    dataRange: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(mainValues_1) ? 'detail' : 'all'
                });
            }
        };
        /***快速编辑提交 */
        this.doQuickSubmit = function (params) {
            if (params === void 0) { params = {}; }
            try {
                var _this_3 = _this_1;
                setTimeout(function () {
                    _this_3.unlockEditFormItem(true);
                }, 100);
                var values_1 = _this_1.formItemsCurrentValue; //表单数据
                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(values_1)) {
                    return;
                }
                var layoutBase = _this_1.card.layoutBase;
                var submitParams_1 = __assign({}, _this_1.card.params, { token: _this_1.card.token, layoutid: _this_1.card.layoutid, currentLayoutId: _this_1.card.layoutid, btntype: '', issystemflag: '2', oldmodedatastatus: 0, isFormMode: '1', iscreate: '2', src: 'save', pageexpandid: layoutBase.pageexpandid, isquickedit: '1', changeDataTime: _this_1.card.changeDataTime, editLayoutid: layoutBase.editLayoutid, dataRange: 'all', haveInterface: layoutBase.haveInterface, JSONStr: JSON.stringify(values_1) }, params);
                Object(__WEBPACK_IMPORTED_MODULE_3__apis_card__["k" /* doSubmit */])(submitParams_1).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                    var pageExpendResult = _a.pageExpendResult, quickDetailIds = _a.quickDetailIds, billid = _a.billid, changeDataTime = _a.changeDataTime, needRefresh = _a.needRefresh, errMessage = _a.errMessage, isChange = _a.isChange, status = _a.status, noRight = _a.noRight;
                    // console.log("===保存成功了===")
                    if (status == '1') {
                        if (noRight) {
                            __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].info({
                                title: getLabel(15172, '系统提示'),
                                content: getLabel('521919', '数据权限已变更，无法编辑！'),
                                okText: getLabel(382958, "确定"),
                                onOk: function () {
                                    __WEBPACK_IMPORTED_MODULE_6__util__["default"].location.reload();
                                },
                            });
                            return;
                        }
                        __WEBPACK_IMPORTED_MODULE_4_antd__["message"].success(getLabel(83551, '保存成功！'), 0.2);
                        if (isChange) { //isChange = true 就是没有被改变，不知道咋定义的。。。。
                            if (pageExpendResult) { //接口执行的返回值
                                var obj = JSON.parse(pageExpendResult);
                                if (obj.flag == "false") {
                                    __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].error({ content: React.createElement("div", { dangerouslySetInnerHTML: { __html: obj.errmsg } }) });
                                    return;
                                }
                            }
                            /***
                           * 如果页面扩展设置了关联字段，切判断关联字段有变化则需要更新内嵌tab，顶部tab，右键
                           */
                            _this_1.checkAssociatedFields(params, values_1);
                            /**
                             * 针对明细表设置了合并显示字段的处理
                             */
                            _this_1.checkDetailRowMerge(submitParams_1.dataRange, submitParams_1.JSONStr);
                            _this_1.card.update({ changeDataTime: changeDataTime, });
                            /**
                             * 是否要刷新页面,这个刷新了整个页面，后面考虑局部刷新替换---ljc
                             * 一般配置的dml等后端接口动作会触发
                             */
                            if (needRefresh) {
                                _this_1.card.reloadCardDatas();
                            }
                            //更新了明细表数据，需要同步更新前端数据
                            _this_1.updateDetailData(quickDetailIds);
                            try {
                                //--------------------------------------是否看板，看板相关处理
                                var _b = _this_1.card.params, boardid = _b.boardid, boardgroup = _b.boardgroup, boardcustomid = _b.boardcustomid, viewfrom = _b.viewfrom;
                                if (boardid && boardgroup && boardcustomid) {
                                    if (top.window['current_boardStore']) {
                                        top.window['current_boardStore'].cardSaveFun(billid, '0', boardid, boardgroup, boardcustomid);
                                    }
                                    else if (__WEBPACK_IMPORTED_MODULE_6__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_6__util__["default"].opener.cubeStore) {
                                        __WEBPACK_IMPORTED_MODULE_6__util__["default"].opener.cubeStore.boardStore.doSearch();
                                    }
                                }
                                else if (viewfrom == 'fromboarditem' && __WEBPACK_IMPORTED_MODULE_6__util__["default"].opener && __WEBPACK_IMPORTED_MODULE_6__util__["default"].opener.cubeStore) {
                                    __WEBPACK_IMPORTED_MODULE_6__util__["default"].opener.cubeStore.boardStore.doSearch();
                                }
                                else {
                                    /***
                                     * 打开的列表数据回调刷新页面-
                                     * excel和相册未注册全局_table方法，加个判断
                                     */
                                    _this_1.card.cardTab.disabled = false;
                                    // if (window.opener && window.opener._table && window.opener._table.reLoad) {
                                    //     window.opener._table.reLoad();
                                    // }else if(window.opener && window.opener.cubeStore){
                                    //     window.opener.cubeStore.Search.refresh();
                                    // }
                                    if (__WEBPACK_IMPORTED_MODULE_6__util__["default"].opener) {
                                        var _c = __WEBPACK_IMPORTED_MODULE_6__util__["default"].opener, _table = _c._table, cubeStore = _c.cubeStore;
                                        if (_table && _table.reLoad) {
                                            var isTreeList = cubeStore && cubeStore.Search.dataShowtype === 'treeType' && cubeStore.Search.changeSearch == '1'; // 分组的组合转换，单独判断
                                            if (isTreeList) {
                                                cubeStore.Search.refresh();
                                            }
                                            else {
                                                _table.reLoad();
                                            }
                                        }
                                        else if (cubeStore) {
                                            cubeStore.Search.refresh();
                                        }
                                    }
                                }
                            }
                            catch (e) {
                            }
                            //----------------------------------------是否看板，看板相关处理
                            /***二维码条形码刷新 */
                            var codeImgFn = _this_1.card.modeExcel.codeImgFn || {};
                            if (submitParams_1.dataRange != 'detail' && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(codeImgFn)) {
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(codeImgFn, function (fn, key) {
                                    fn();
                                });
                            }
                        }
                        else {
                            _this_1.modalConfirm(errMessage, '');
                        }
                    }
                }));
            }
            catch (error) {
            }
        };
        this.checkAssociatedFields = function (params, values) {
            if (params === void 0) { params = {}; }
            var relatedFields = [];
            var _a = _this_1.card, relateField = _a.layoutBase.relateField, reloadParams = _a.reloadParams;
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(params)) {
                var mainfields = params.JSONStr && JSON.parse(params.JSONStr) || {};
                relatedFields = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(mainfields).filter(function (d) { return d.startsWith('field'); });
            }
            else {
                relatedFields = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(values).filter(function (d) { return d.startsWith('field'); });
            }
            var intersectionKeys = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.intersection(relateField, relatedFields);
            if (intersectionKeys.length > 0) {
                _this_1.card.cardTab.init(__assign({}, reloadParams, { datajson: '' }));
            }
        };
        this.checkDetailRowMerge = function (dataRange, formdatas) {
            var _a = _this_1.card, modeExcel = _a.modeExcel, cubeForm = _a.cubeForm;
            if (dataRange != 'main') {
                var datas = JSON.parse(formdatas) || {}; // { "detail_2": [{ "field42724": "2244", "dtl_id": "78" }] }
                var details = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(datas, function (result, value, key) {
                    if (key.startsWith('detail_')) {
                        result[key] = value;
                    }
                    return result;
                }, {});
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(details, function (value, detail) {
                    var mergeFields = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(modeExcel.getExcel(detail).mergeFields) || {};
                    var mergeFieldsArr = [];
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(mergeFields, function (v, k) {
                        if (v && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(v)) {
                            // @ts-ignore
                            mergeFieldsArr.push('field' + v.fieldid);
                        }
                    });
                    if (value && value.length > 0) {
                        var changeFields = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(value[0]).filter(function (d) { return d.startsWith('field'); });
                        var intersectionKeys = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.intersection(mergeFieldsArr, changeFields);
                        if (intersectionKeys.length > 0) {
                            cubeForm.$(detail).forceRender = new Date().getTime();
                        }
                    }
                });
            }
        };
        this.modalConfirm = function (errMessage, okText) {
            __WEBPACK_IMPORTED_MODULE_4_antd__["Modal"].confirm({
                title: errMessage,
                okText: okText || getLabel(354, '刷新'),
                cancelText: getLabel(201, '取消'),
                onOk: function () {
                    __WEBPACK_IMPORTED_MODULE_6__util__["default"].location.reload();
                    return;
                },
                onCancel: function () { }
            });
        };
        this.updateDetailData = function (quickDetailIds) {
            if (quickDetailIds === void 0) { quickDetailIds = {}; }
            if (quickDetailIds && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(quickDetailIds)) {
                var cubeForm_1 = _this_1.card.cubeForm;
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(quickDetailIds, function (val, key) {
                    if (cubeForm_1.has(key)) {
                        if (_this_1.handletype == 'copy') {
                            __WEBPACK_IMPORTED_MODULE_2__util_excelUtil__["modeForm"].checkDetailRow(key, "", true);
                        }
                        var detailvalues = cubeForm_1.$(key).getValue();
                        var formkeys_1 = cubeForm_1.$(key).map(function (d) { return d.key; });
                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(detailvalues, function (item, index) {
                            var delid = item.dtl_id || "";
                            if (val.hasOwnProperty(delid)) {
                                cubeForm_1.$(key).$(formkeys_1[index]).$('dtl_id').value = val[delid];
                                // field.$(key).$(fieldid).setViewAttrs("", editstate== '2' ? '1':(editstate== '3'?'2':'1'));
                            }
                            if (delid.length > 30) {
                                _this_1.restoreState(key, index, item);
                                _this_1.update({ detalCurrentValue: {}, handletype: '' });
                            }
                        });
                    }
                });
            }
        };
        this.restoreState = function (detail, index, indexValue) {
            if (indexValue === void 0) { indexValue = {}; }
            try {
                var cubeForm_2 = _this_1.card.cubeForm;
                var detailkeys = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(cubeForm_2.$(detail).$(index).value).filter(function (d) { return d.startsWith('field'); });
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(detailkeys, function (fieldid) {
                    cubeForm_2.$(detail).$(index).$(fieldid).setViewAttrs("", 3);
                });
            }
            catch (error) {
                //复制已有明细后失焦会报错
            }
        };
        /****
         * 处理行列规则
         *
         */
        this.doRowColConsFields = function () {
            var colCals = _this_1.card.cubeTrigger.colCals;
            var colsFields = [];
            if (Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(colCals)) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(colCals, function (toField, changeField) {
                    colsFields.push(toField);
                });
            }
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(colsFields);
        };
        this.handleDetals = function (type, detail, datas) {
            if (type === void 0) { type = ''; }
            var _a;
            _this_1.handletype = type;
            var colCons = _this_1.doRowColConsFields();
            var order = detail.split('_')[1];
            var detaildata = (_a = {},
                _a[detail] = type === 'delete' ? [] : datas,
                _a['deldtlid' + order] = type === 'delete' ? "" + __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.compact(datas.map(function (d) { return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(d, "dtl_id"); })) : '',
                _a);
            if (colCons.length > 0) {
                var mainValues_2 = {};
                var getMainFields_1 = function (field) {
                    if (_this_1.formItemsCurrentValue.hasOwnProperty(field)) {
                        mainValues_2[field] = _this_1.formItemsCurrentValue[field];
                    }
                };
                var getMainValues_1 = function () { return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(colCons, function (field) {
                    getMainFields_1(field);
                }); };
                var _this_4 = _this_1;
                setTimeout(function () {
                    getMainValues_1();
                    var params = __assign({}, mainValues_2, detaildata);
                    _this_4.checkDoQuickSubmit({
                        JSONStr: JSON.stringify(params),
                        dataRange: 'all'
                    });
                }, 300);
            }
            else {
                _this_1.checkDoQuickSubmit({
                    JSONStr: JSON.stringify(detaildata),
                    dataRange: 'detail'
                });
            }
        };
        this.addDetals = function (detail, index, detailDefaultValue, detailkeysState) {
            // console.log("detail,index,detailDefaultValue,detailkeys", detail, index, detailDefaultValue, detailkeysState)
            if (!_this_1.detalCurrentValue.hasOwnProperty(detail)) {
                _this_1.detalCurrentValue[detail] = [];
            }
            _this_1.update({ detailkeysState: detailkeysState, editFieldKey: detail, handletype: 'add' });
            _this_1.detalCurrentValue[detail].push(detailDefaultValue);
        };
        this.recordParms = function (data) {
            if (data === void 0) { data = {}; }
            var params = _this_1.card.params;
            var fieldkeys = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(params).filter(function (d) { return d.startsWith('field'); });
            var fieldParams = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(params, fieldkeys);
            _this_1.recordParmurls = __assign({}, fieldParams, data);
        };
        this.handelParmUrls = function () {
            var _a, _b;
            var isTrue = true;
            if (_this_1.editFieldKey && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(_this_1.recordParmurls)) {
                var _c = _this_1.card, getFieldProps = _c.getFieldProps, cubeForm = _c.cubeForm;
                var _d = _this_1.editFieldKey.split('_'), field = _d[0], index = _d[1];
                var _e = getFieldProps(field), isdetail = _e.isdetail, detail = _e.detail;
                if (isdetail) {
                    var value = cubeForm.$(detail).$(index).$(field).values();
                    if (value == _this_1.recordParmurls[field]) {
                        _this_1.setFormItemsCurrentValue((_a = {}, _a[field] = value, _a));
                        isTrue = false;
                    }
                }
                else {
                    var value = cubeForm.$(field).values();
                    if (value == _this_1.recordParmurls[field]) {
                        _this_1.setFormItemsCurrentValue((_b = {}, _b[field] = value, _b));
                        isTrue = false;
                    }
                }
            }
            return isTrue;
        };
        this.card = card;
    }
    //浏览按钮对话框是否打开
    QuickEditStore.prototype.isOpenBrowser = function () {
        var e = e || __WEBPACK_IMPORTED_MODULE_6__util__["default"].event;
        var elem = e.target || e.srcElement;
        var isTrue = false;
        while (elem) {
            if (elem.className && elem.className.indexOf('mode-card-dialogshow') > -1) { //资源面板的dialog框
                break;
            }
            if (elem.className && (elem.className.startsWith("ant-modal-") || elem.className.startsWith("wea-city-card-container")
                || elem.className.startsWith("ant-select-") || elem.className.startsWith("ant-calendar"))) {
                isTrue = true;
                break;
            }
            elem = elem.parentNode;
        }
        return isTrue;
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "editFieldKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "formItemsCurrentValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "detalCurrentValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "detailkeysState", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "mainFieldState", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "handletype", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "oldValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], QuickEditStore.prototype, "recordParmurls", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "getEditState", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "lockEditFormItem", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "setFormItemsCurrentValue", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "handleClickOutSide", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"] //获取可编辑项的domkey
    ], QuickEditStore.prototype, "getEditFormItemDomkey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "unlockEditFormItem", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "UpdateCardForm", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "packageMainAndDetail", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "checkDoQuickSubmit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "checkCustomize", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "submitData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "check_require", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "checkRequireMain", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "checkRequireDetail", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "checkAssociatedFields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "checkDetailRowMerge", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "updateDetailData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "restoreState", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "handleDetals", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"] //明细表新增
    ], QuickEditStore.prototype, "addDetals", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "recordParms", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], QuickEditStore.prototype, "handelParmUrls", void 0);
    return QuickEditStore;
}());



/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export amkjzgStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_pagination__ = __webpack_require__(282);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





//import {WeaLocaleProvider} from 'ecCom';

var TableStore = __WEBPACK_IMPORTED_MODULE_4_comsMobx__["WeaTableNew"].TableStore;
//const getLabel = WeaLocaleProvider.getLabel;
var amkjzgStore = /** @class */ (function () {
    function amkjzgStore() {
        var _this = this;
        this.exp_url = ""; // 链接地址
        this.hcstatusoptions = [];
        this.hctypeoptions = [];
        this.flstoptions = [];
        this.sessionKey = '';
        this.params = {};
        this.loading = false; // 加载中状态
        this.newTable = new TableStore();
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.countData = {}; //查询统计数据
        this.isCharts = false; //查询统计数据
        this.starttime = new Date().getTime();
        this.showProgerss = false; //是否显示导出进度
        this.isCancel = false; //是否显示导出进度
        this.isClose = false; //是否关闭进度条
        this.progress = {}; //是否显示导出进度
        this.exportkey = ""; //导出唯一key
        this.clearTable = function () {
            _this.newTable = new TableStore();
        };
        this.editPagination = new __WEBPACK_IMPORTED_MODULE_5__util_pagination__["a" /* default */]();
        this.clear = function () {
            _this.newTable = new TableStore();
            _this.loading = false;
            _this.sessionKey = '';
        };
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
        this.getSlectOption = function (params) {
            _this.loading = true;
            //处理选择框的key
            __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].amkjzgSlectOption(__assign({}, params, _this.params)).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, hcstatus = _a.hcstatus, hctype = _a.hctype, flst = _a.flst, exp_url = _a.exp_url;
                if (status == '1') {
                    _this.hcstatusoptions = hcstatus.options;
                    _this.hctypeoptions = hctype.options;
                    _this.flstoptions = flst.options;
                    _this.exp_url = exp_url;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        this.dataKey = function (params) {
            _this.loading = true;
            //处理选择框的key
            __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].amkjzgdataKey(__assign({}, params, _this.params)).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, datas = _a.datas, countData = _a.countData, originalTableWidth = _a.originalTableWidth;
                if (status == '1') {
                    _this.sessionKey = datas;
                    _this.countData = countData;
                    _this.clearTable();
                    _this.newTable.getDatas(datas);
                    _this.originalTableWidth = originalTableWidth;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        this.refresh = function () {
            _this.loading = true;
            _this.dataKey(__assign({}, _this.params));
        };
        this.reload = function () {
            _this.newTable.getDatas('', _this.newTable.current, _this.newTable.pageSize);
        };
        this.doExcelExpost = function (startdate, hcstatus, hctype, branch, department, bgdd) {
            //message.info(getLabel('508305','正在导出文件'));
            // API.doExcelExpost(params).then(action(({ error, status,key }) => {
            //     if(status=='1'){//成功
            //         this.exportkey=key;
            //         this.getExcelExpProgress();
            //     }else if(status=='2'){
            //         message.info(error);
            //     }else{
            //         message.error(error);
            //     }
            // }));
            __WEBPACK_IMPORTED_MODULE_3__util__["default"].location.href = "/weaver/weaver.formmode.amkjgs.ExcelOutFromReport?current" + _this.newTable.current + "&pageSize=" + _this.newTable.pageSize + "&startdate=" + startdate + "&hcstatus=" + hcstatus + "&hctype=" + hctype + "&branch=" + branch + "&department=" + department + "&bgdd=" + bgdd;
        };
    }
    Object.defineProperty(amkjzgStore.prototype, "register_table", {
        get: function () {
            var _this = this;
            return {
                reLoad: function () {
                    _this.reload();
                    if (_this.params.isRefreshTree == '1') {
                        __WEBPACK_IMPORTED_MODULE_3__util__["default"].refreshTree(_this.params.customTreeDataId);
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(amkjzgStore.prototype, "tableDatas", {
        get: function () {
            return this.newTable.datas;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "exp_url", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "hcstatusoptions", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "hctypeoptions", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "flstoptions", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "newTable", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "countData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "isCharts", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "starttime", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "showProgerss", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "isCancel", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "isClose", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "progress", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "exportkey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], amkjzgStore.prototype, "editPagination", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], amkjzgStore.prototype, "register_table", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], amkjzgStore.prototype, "tableDatas", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], amkjzgStore.prototype, "clear", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], amkjzgStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], amkjzgStore.prototype, "getSlectOption", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], amkjzgStore.prototype, "dataKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], amkjzgStore.prototype, "refresh", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], amkjzgStore.prototype, "reload", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], amkjzgStore.prototype, "doExcelExpost", void 0);
    return amkjzgStore;
}());

/* harmony default export */ __webpack_exports__["a"] = (new amkjzgStore());


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_batchImport__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


// import _ from 'lodash';


var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var BatchImportStore = /** @class */ (function () {
    function BatchImportStore() {
        this.form = new __WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaForm"]();
        this.loading = false;
        this.importUrl = '/api/cube/card/detailImport';
        this.fields = __WEBPACK_IMPORTED_MODULE_2__data_batchImport__["a" /* fields */];
        this.uploadParams = {};
        this.modename = '';
        this.selectedFile = '';
        this.updateParams = function () {
        };
        this.form.initFormFields([{ items: __WEBPACK_IMPORTED_MODULE_2__data_batchImport__["a" /* fields */] }]);
        this.selectedFile = getLabel(132079, '未选择文件');
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchImportStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchImportStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchImportStore.prototype, "importUrl", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchImportStore.prototype, "fields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchImportStore.prototype, "uploadParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchImportStore.prototype, "modename", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BatchImportStore.prototype, "selectedFile", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BatchImportStore.prototype, "updateParams", void 0);
    return BatchImportStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (BatchImportStore);


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var getLabel = __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaLocaleProvider"].getLabel;
var labelcol = 4;
var fieldcol = 16;
var fields = [{
        domkey: ['template'],
        conditionType: 'input',
        label: getLabel(28576, "下载模板"),
        viewAttr: 1,
        rules: 'string',
    }, {
        domkey: ['uploadExe'],
        conditionType: 'button',
        label: getLabel(16630, "上传Excel"),
        viewAttr: 3,
        rules: 'required|string',
    }, {
        conditionType: "SELECT",
        domkey: ['checkCode'],
        viewAttr: 2,
        label: getLabel(24638, "重复验证字段"),
        options: [],
    }, {
        conditionType: "SELECT",
        domkey: ['importType'],
        viewAttr: 2,
        label: getLabel(24863, "导入类型"),
        options: [],
    }, {
        conditionType: "SELECT",
        domkey: ['importOrder'],
        viewAttr: 2,
        label: getLabel(131321, "Excel数据导入顺序"),
    }, {
        conditionType: "CHECKBOX",
        domkey: ['isNext'],
        viewAttr: 2,
        label: getLabel(129659, "【重复验证字段】的值重复了是否继续"),
    }, {
        domkey: ['log'],
        conditionType: 'SWITCH',
        label: getLabel(127410, "打印导入日志"),
        viewAttr: 2,
        value: '1',
        rules: 'required|string',
        className: 'cube-small-item'
    }, {
        domkey: ['submit'],
        conditionType: 'INPUT',
        label: getLabel(32935, "导入"),
        viewAttr: 2,
        className: 'cube-small-item'
    }].map(function (f) {
    return __assign({}, f, { labelcol: labelcol,
        fieldcol: fieldcol });
});


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CustomPageStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_customPage__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__list__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tree__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reply__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__ = __webpack_require__(19);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var CustomPageStore = /** @class */ (function () {
    function CustomPageStore() {
        var _this = this;
        this.loading = false;
        this.detailData = [];
        this.selectedKey = "";
        this.title = "";
        this.params = {};
        this.iframeHref = "";
        this.windowTitle = "";
        this.mainFrameRefVisible = true;
        this.mainFrameSrc = '';
        this.isCube = false;
        this.isSearchShow = false;
        this.isCardShow = false;
        this.isShowReply = false;
        this.isTreeShow = false;
        this.card = new __WEBPACK_IMPORTED_MODULE_6__card__["default"]();
        this.search = __WEBPACK_IMPORTED_MODULE_7__list__["default"];
        this.tree = new __WEBPACK_IMPORTED_MODULE_8__tree__["a" /* TreeStore */]();
        // @observable customPage: CustomPageStore;
        this.reply = new __WEBPACK_IMPORTED_MODULE_9__reply__["a" /* default */]();
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.showMoreCountData = false; //是否显示下拉列表中的查询统计数据
        this.updateParams = function (params) {
            var temp = !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(_this.params), params);
            _this.params = params;
            if (temp) {
                _this.getCustomPageViewData(params);
                _this.getIconInfo(params.id);
            }
        };
        this.getCustomPageViewData = function (params) {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__apis_customPage__["a" /* getCustomPageViewData */](params).then(Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["action"])(function (_a) {
                var status = _a.status, error = _a.error, defaultActiveKey = _a.defaultActiveKey, Customname = _a.Customname, detail = _a.detail, _b = _a.windowTitle, windowTitle = _b === void 0 ? '' : _b;
                if (status == "1") {
                    _this.selectedKey = defaultActiveKey;
                    if (!Object(__WEBPACK_IMPORTED_MODULE_10__util_cubeUtil__["g" /* isFromProtal */])()) {
                        _this.windowTitle = windowTitle;
                    }
                    _this.detailData = detail;
                    _this.title = Customname;
                    _this.iframeHref = _this.getAddress(defaultActiveKey, detail, params);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_4_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
            }));
        };
        this.tabChange = function (key, query) {
            _this.selectedKey = key;
            _this.iframeHref = _this.getAddress(key, Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["toJS"])(_this.detailData), query);
            //关闭列表上左滑，滑动出来的卡片
            window.showSearchSlideModal && window.showSearchSlideModal(false, "", "");
        };
        this.getAddress = function (key, data, params) {
            var href = "";
            var iframeurl = "";
            data && data.map(function (item) {
                if (item.detailid == key) {
                    href = item.hrefaddress;
                }
            });
            _this.isCube = false;
            if (href) {
                var url_1 = Object(__WEBPACK_IMPORTED_MODULE_5__util__["replaceE8Url"])(href);
                //链接参数处理
                if (params) {
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(params).forEach(function (item) {
                        url_1 = url_1.replace('$' + item + '$', params[item]);
                    });
                }
                if (url_1.indexOf('/spa/cube') > -1) { //针对建模模块的地址处理
                    if (url_1.indexOf('?') > -1) {
                        iframeurl = url_1.split('?').join('?hidetop=1&istree=true&_t=' + new Date().getTime() + '&');
                    }
                    else {
                        iframeurl = url_1 + "?hidetop=1&istree=true&_t=" + new Date().getTime();
                    }
                }
                else if (url_1.indexOf('/spa/edc/static/app') > -1) { //数据中心的链接
                    ///spa/edc/static/app/index.html?boardId=a5050d0437b04875aa771ce0e95e91a4#/edc/dataBoard
                    iframeurl = url_1.split('?').join('?_t=' + new Date().getTime() + '&');
                }
                else {
                    iframeurl = url_1;
                }
                if (url_1.indexOf("/spa/cube/index.html") >= 0) {
                    _this.isCube = true;
                    if (url_1.indexOf("main/cube/card") >= 0) {
                        iframeurl = iframeurl + '&noTitleShow=1';
                        _this.isSearchShow = false;
                        _this.isShowReply = false;
                        _this.isTreeShow = false;
                        _this.showCard(iframeurl);
                    }
                    else if (url_1.indexOf("main/cube/search") >= 0) {
                        iframeurl = iframeurl + '&menuIds=1';
                        _this.isCardShow = false;
                        _this.isShowReply = false;
                        _this.isTreeShow = false;
                        _this.showSearch(iframeurl);
                    }
                    else if (url_1.indexOf("main/cube/tree") >= 0) {
                        iframeurl = iframeurl + '&noTitleShow=1';
                        _this.isSearchShow = false;
                        _this.isCardShow = false;
                        _this.isShowReply = false;
                        _this.showTree(iframeurl);
                    }
                    else if (url_1.indexOf("main/cube/reply") >= 0) {
                        _this.isSearchShow = false;
                        _this.isCardShow = false;
                        _this.isTreeShow = false;
                        _this.showReply(iframeurl);
                    }
                    else {
                        _this.isCube = false;
                    }
                    _this.mainFrameRefVisible = false;
                }
                if (!_this.isCube) {
                    _this.isSearchShow = false;
                    _this.isCardShow = false;
                    _this.isShowReply = false;
                    _this.isTreeShow = false;
                    var mainFrame = document.getElementById("cube-custompage-div");
                    if (mainFrame) {
                        mainFrame.src = iframeurl;
                        _this.mainFrameRefVisible = true;
                        _this.mainFrameSrc = iframeurl;
                    }
                }
            }
            return href;
        };
        this.rightMenuHandle = function (key) {
            if (_this.isSearchShow) {
                _this.search.rightMenuClick(key);
            }
            else if (_this.isCardShow) {
                _this.card.Actions.runCustomAction(key);
            }
        };
        this.getQuery = function (href) {
            var lastofnum = href.lastIndexOf('?');
            href = href.slice(lastofnum);
            var query = href.split('?')[1];
            var querys = query.split("&");
            var queryObj = {};
            querys.map(function (q) {
                var _a = q.split("="), name = _a[0], value = _a[1];
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(queryObj, name, value);
            });
            return queryObj;
        };
        this.showSearch = function (href) {
            _this.isSearchShow = true;
            _this.search.isInnerTab = true;
            _this.search.reloadSearch(_this.getQuery(href));
        };
        this.showCard = function (href) {
            _this.isCardShow = true;
            _this.card.isInline = true;
            if (!_this.card) {
                _this.card = new __WEBPACK_IMPORTED_MODULE_6__card__["default"]();
            }
            _this.card.reloadSearch(_this.getQuery(href));
        };
        this.showReply = function (href) {
            _this.isShowReply = true;
            _this.reply.updateParams(_this.getQuery(href));
        };
        this.showTree = function (href) {
            _this.isTreeShow = true;
            _this.tree.updateParams(_this.getQuery(href));
        };
        this.clearStatus = function () {
            _this.detailData = [];
            _this.selectedKey = "";
            _this.title = "";
            _this.params = {};
            _this.iframeHref = "";
            _this.mainFrameRefVisible = true;
            _this.mainFrameSrc = '';
            _this.isCube = false;
        };
        this.getIconInfo = function (pageid) {
            __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].getAppInfoByID({ pageid: pageid }).then(function (data) {
                if (data.status == "1") {
                    _this.iconInfo = {
                        icon: data.icon || "icon-coms-ModelingEngine",
                        iconColor: data.iconColor || "#fff",
                        iconBg: data.iconBg || "#96358a"
                    };
                }
            });
        };
        /* 是否显示‘统计’下拉列表 */
        this.handleShowMoreCountData = function (showMoreCountData) {
            _this.showMoreCountData = !showMoreCountData;
        };
    }
    Object.defineProperty(CustomPageStore.prototype, "rightMenus", {
        get: function () {
            var _this = this;
            if (this.isSearchShow) {
                return this.search.rightMenus.map(function (m) { return (__assign({}, m, { content: m.name, icon: React.createElement("i", { className: m.icon }) })); });
            }
            else if (this.isCardShow) {
                return this.card.cardTab.rightMenus.map(function (m) { return (__assign({}, m, { disabled: _this.card.cardTab.disabled })); });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomPageStore.prototype, "getTitle", {
        get: function () {
            // if (this.isSearchShow) {
            //     return this.search.top.name;
            // } else if (this.isCardShow) {
            //     return this.card.cardTab.title;
            // }
            return this.title;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "detailData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "selectedKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "title", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "iframeHref", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "mainFrameRefVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "mainFrameSrc", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "isCube", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "isSearchShow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "isCardShow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "isShowReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "isTreeShow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "card", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "search", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "tree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "reply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["observable"]
    ], CustomPageStore.prototype, "showMoreCountData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "getCustomPageViewData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "tabChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["computed"]
    ], CustomPageStore.prototype, "rightMenus", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "rightMenuHandle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["computed"]
    ], CustomPageStore.prototype, "getTitle", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "getQuery", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "showSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "showCard", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "showReply", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "showTree", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "clearStatus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "getIconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx__["action"]
    ], CustomPageStore.prototype, "handleShowMoreCountData", void 0);
    return CustomPageStore;
}());

/* harmony default export */ __webpack_exports__["a"] = (new CustomPageStore());


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCustomPageViewData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);

var newUrl = '/api/cube/custompage';
var getCustomPageViewData = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(newUrl + "/getCustomPageViewData", "get", params);
};


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_resource__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_dateUtil__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__card_index__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(7);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var getLabel = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaLocaleProvider"].getLabel;
var getTop = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaTools"].WindowFunc.getTop;


var ViewResouceStore = /** @class */ (function () {
    function ViewResouceStore() {
        var _this = this;
        this.form = new __WEBPACK_IMPORTED_MODULE_1_comsMobx__["WeaForm"]();
        this.loading = false;
        this.rightMenus = [];
        this.customid = ''; //查询id
        this.resourceParams = { bywhat: 0 };
        this.resourcesList = [];
        this.useMap = {}; //占用情况
        this.timeType = 'day';
        this.hasUrlByWhat = false; //判断url是否含有bywaht，bywhat优先级最高
        this.duration = 0;
        this.conHeight = 0;
        this.tabHeight = 0;
        this.spinisload = false;
        // @observable listHeight = 0;
        this.moduls = ''; //解析是否在前端的参数
        this.resourceId = '';
        this.searchParam = { customid: '', datasqlwhere: '' };
        this.resourceFieldName = ''; //资源字段
        this.modename = ''; //模块名称
        this.createUrl = ''; //新增地址
        this.oriCreateUrl = ''; //原始新增地址
        this.visible = false;
        this.currentpage = 1; //当前页数
        this.total = 0; //总记录
        this.windowTitle = ''; //页面标题
        this.showMoreVisible = false; //是否要显示显示更多
        this.startHour = 0; //时间起始
        this.endHour = 23; //时间结束
        this.dspunit = 1; //占用时间单位
        this.usedcolor = '#1372AA'; //占用颜色
        this.conflictedcolor = '#B3110B'; //冲突颜色
        this.weekstart = '1'; //周开始日期  1周日 2周一
        this.opendetailshow = 0; // 是否显示详细展示
        this.panelHeightRatio = 60; // 面板高度占比%
        this.showMoreColorType = false; // 是否展示更多颜色状态
        this.colorType = [];
        this.isHideSearch = false; // 是否收缩列表
        this.isShowMore = false; // 是否获取更多数据
        this.fields = {}; //配置信息
        this.conditions = []; //查询条件
        this.queryparm = {}; //查询条件参数(点击小漏斗的参数)
        this.sqlwhere = '';
        this.isEditList = false;
        this.card = new __WEBPACK_IMPORTED_MODULE_8__card_index__["default"]();
        this.updateHeight = function (conHeight, tabHeight, listHeight) {
            _this.conHeight = conHeight;
            _this.tabHeight = tabHeight;
            // this.listHeight = listHeight; 
            var quickheight = __WEBPACK_IMPORTED_MODULE_9_jquery___default()(".list-container .wea-tab-search-ad").height(); //查询列表快捷搜索高度
            var countheight = __WEBPACK_IMPORTED_MODULE_9_jquery___default()(".list-container .cube-list-countContainer").height(); //统计字段高度
            quickheight = quickheight == null ? 0 : quickheight;
            countheight = countheight == null ? 0 : countheight;
            __WEBPACK_IMPORTED_MODULE_2____["default"].viewResHeight = listHeight;
            // Search.listHeight=listHeight-quickheight-countheight-85;
        };
        this.updateParams = function (params) {
            _this.customid = params.customid;
            __WEBPACK_IMPORTED_MODULE_2____["default"].clear(); //先清空查询的数据
            __WEBPACK_IMPORTED_MODULE_3__apis_resource__["a" /* getCurrentDate */]({}).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, error = _a.error, currentDate = _a.currentDate;
                if (status == '1') {
                    if (params.menuIds) {
                        _this.moduls = params.menuIds;
                    }
                    _this.currentdate = currentDate;
                    _this.resourceParams = { resourceId: params.customid, bywhat: _this.resourceParams.bywhat, currentdate: currentDate };
                    _this.query(_this.resourceParams);
                }
            }));
        };
        this.query = function (params) {
            if (params === void 0) { params = {}; }
            var that = _this;
            _this.currentpage = 1;
            // Search.forceUpdate=false;
            _this.loading = true;
            var iscustomsearch = __WEBPACK_IMPORTED_MODULE_9_jquery___default.a.isEmptyObject(_this.queryparm) ? false : true;
            var hasChangeBywhat = false;
            if (params.bywhat != _this.resourceParams.bywhat) {
                hasChangeBywhat = true;
            }
            _this.resourceParams = __assign({}, _this.resourceParams, params);
            var timeType;
            switch (Number(_this.resourceParams.bywhat)) {
                case 2:
                    timeType = "month";
                    break;
                case 3:
                    timeType = "week";
                    break;
                case 4:
                    timeType = "day";
                    break;
                default: timeType = "day";
            }
            var endparm = __assign({}, _this.resourceParams, _this.queryparm, { iscustomsearch: iscustomsearch });
            _this.updateTimeType(timeType);
            __WEBPACK_IMPORTED_MODULE_3__apis_resource__["b" /* getResourcesInfo */](__assign({}, endparm, { sqlwhere: encodeURIComponent(_this.sqlwhere) })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, error = _a.error, datainfo = _a.datainfo, datasqlwhere = _a.datasqlwhere, conditions = _a.conditions, noRight = _a.noRight;
                if (status == '1') {
                    if (noRight) {
                        __WEBPACK_IMPORTED_MODULE_10__util__["default"].weaHistory.push('/main/cube/encrypt');
                    }
                    _this.fields = datainfo.fields;
                    _this.modename = datainfo.fields.modename;
                    if (_this.moduls == "" && __WEBPACK_IMPORTED_MODULE_10__util__["default"].location.href.indexOf('wui/index.html') == -1) {
                        _this.windowTitle = datainfo.fields.resourceName;
                    }
                    _this.createUrl = datainfo.fields.createUrl || ""; //只针对建模的卡片处理，其他的都正常iframe显示
                    if (datainfo.fields.createUrl && datainfo.fields.createUrl.indexOf("/spa/cube/index.html#/main/cube/card") > -1) {
                        _this.createUrl = datainfo.fields.createUrl.replace("html", "jsp");
                    }
                    _this.oriCreateUrl = _this.createUrl;
                    _this.resourceFieldName = datainfo.fields.resourceFieldName;
                    _this.searchParam = { customid: datainfo.fields.customSearchId, datasqlwhere: datasqlwhere };
                    _this.startHour = parseInt(datainfo.fields.timerangestart);
                    _this.endHour = parseInt(datainfo.fields.timerangeend);
                    _this.dspunit = parseInt(datainfo.fields.dspunit);
                    _this.usedcolor = datainfo.fields.usedcolor;
                    _this.conflictedcolor = datainfo.fields.conflictedcolor;
                    _this.weekstart = datainfo.fields.weekstart;
                    _this.opendetailshow = datainfo.opendetailshow;
                    _this.panelHeightRatio = datainfo.panelHeightRatio;
                    _this.colorType = datainfo.colorType;
                    _this.search(_this.searchParam);
                    _this.duration = (timeType == 'day' && _this.dspunit > 0) ? 60 / _this.dspunit : 0;
                    var ids = datainfo.ids, names_1 = datainfo.names, titles_1 = datainfo.titles, imgs_1 = datainfo.imgs;
                    var resourceList_1 = [];
                    if (_this.resourceParams.bywhat === 0) {
                        var timeType_1 = "day";
                        switch (datainfo.fields.defaultByWhat) {
                            case "2":
                                timeType_1 = "month";
                                break;
                            case "3":
                                timeType_1 = "week";
                                break;
                            case "4":
                                timeType_1 = "day";
                                break;
                            default: timeType_1 = "day";
                        }
                        _this.resourceParams.bywhat = datainfo.fields.defaultByWhat;
                        _this.updateTimeType(timeType_1);
                        _this.updateIsHideSearch();
                    }
                    if (hasChangeBywhat) {
                        _this.updateIsHideSearch();
                    }
                    _this.getRightMenus();
                    ids && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(ids) && ids.map(function (id, index) {
                        resourceList_1.push({
                            "name": names_1[index],
                            "id": id,
                            "title": titles_1[index],
                            "imgs": imgs_1[index]
                        });
                    });
                    that.resourcesList = resourceList_1;
                    _this.total = datainfo.total;
                    var useMap = _this.showSet(datainfo);
                    that.useMap = useMap;
                    that.loading = false;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(getLabel(383746, '请求失败') + "：" + error);
                }
                _this.conditions = conditions;
                _this.loading = false;
            }));
        };
        this.search = function (params) {
            if (params === void 0) { params = {}; }
            __WEBPACK_IMPORTED_MODULE_2____["default"].isInnerTab = true;
            __WEBPACK_IMPORTED_MODULE_2____["default"].params = {};
            __WEBPACK_IMPORTED_MODULE_2____["default"].reloadSearch(__assign({}, params, { datasqlwhere: params['datasqlwhere'] }));
        };
        this.updateTimeType = function (type) {
            _this.timeType = type;
        };
        this.getRightMenus = function () {
            var rightArr = [{
                    key: 'month',
                    content: getLabel(18517, '月使用情况'),
                    icon: React.createElement("i", { className: "icon-coms-New-schedule" })
                }, {
                    key: 'week',
                    content: getLabel(18516, '周使用情况'),
                    icon: React.createElement("i", { className: "icon-coms-New-schedule" })
                }, {
                    key: 'day',
                    content: getLabel(18515, '日使用情况'),
                    icon: React.createElement("i", { className: "icon-coms-New-schedule" })
                }];
            if (_this.createUrl) {
                rightArr.push({
                    key: 'add',
                    content: getLabel(82, '新建') + ' ' + _this.modename,
                    icon: React.createElement("i", { className: "icon-coms-New-Flow" })
                });
            }
            _this.rightMenus = rightArr;
        };
        this.onAdd = function (parms) {
            var urlparm = '';
            if (parms) {
                var id = parms.id, startDate = parms.startDate, startTime = parms.startTime, endDate = parms.endDate, endTime = parms.endTime, startdatetime = parms.startdatetime, enddatetime = parms.enddatetime;
                urlparm = "&field" + _this.fields.resourceFieldId + "=" + id;
                if (_this.fields.startaloneOrcombination == '2') {
                    urlparm += "&field" + _this.fields.startDateTimeFieldId + "=" + startdatetime;
                }
                else {
                    urlparm += "&field" + _this.fields.startDateFieldId + "=" + startDate + "&field" + _this.fields.startTimeFieldId + "=" + startTime;
                }
                if (_this.fields.endaloneOrcombination == '2') {
                    urlparm += "&field" + _this.fields.endDateTimeFieldId + "=" + enddatetime;
                }
                else {
                    urlparm += "&field" + _this.fields.endDateFieldId + "=" + endDate + "&field" + _this.fields.endTimeFieldId + "=" + endTime;
                }
                _this.createUrl = _this.oriCreateUrl.replace(/\$begindate\$/ig, startDate).replace(/\$begintime\$/ig, startTime)
                    .replace(/\$enddate\$/ig, endDate).replace(/\$endtime\$/ig, endTime).replace(/\$resourceid\$/ig, id);
            }
            else {
                _this.createUrl = _this.oriCreateUrl;
            }
            if (_this.createUrl.indexOf("/spa/cube/index.jsp#/main/cube/card") > -1) {
                _this.card.isInline = true;
                if (!_this.card) {
                    _this.card = new __WEBPACK_IMPORTED_MODULE_8__card_index__["default"]();
                }
                var newurl = _this.createUrl;
                if (urlparm != '') {
                    newurl += urlparm;
                }
                _this.card.reloadSearch(_this.getQuery(newurl));
                getTop().document.addEventListener('mousedown', _this.card.quickEditStore.handleClickOutSide, true);
            }
            else {
                var lastofnum = _this.createUrl.lastIndexOf('?');
                var parms_1 = _this.getQuery(_this.createUrl);
                _this.createUrl = _this.createUrl.slice(0, lastofnum);
                if (!__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.isEmptyObject(parms_1)) {
                    _this.createUrl += "?";
                    var i = 0;
                    for (var val in parms_1) {
                        if (i != 0) {
                            _this.createUrl += "&";
                        }
                        i++;
                        _this.createUrl += val + "=" + parms_1[val];
                    }
                }
                //流程页面的话调整新窗口打开   /spa/workflow/index_form.jsp
                var wfUrl = ['/spa/workflow/static4form/index.html', '/spa/workflow/index_form.jsp'];
                if (_this.createUrl.indexOf(wfUrl[0]) > -1 || _this.createUrl.indexOf(wfUrl[1]) > -1) {
                    __WEBPACK_IMPORTED_MODULE_10__util__["default"].open(_this.createUrl, '_blank');
                    return;
                }
            }
            _this.visible = true;
        };
        this.getQuery = function (href) {
            var lastofnum = href.lastIndexOf('?');
            href = href.slice(lastofnum);
            var query = href.split('?')[1];
            var querys = query.split("&");
            var queryObj = {};
            querys.map(function (q) {
                var _a = q.split("="), name = _a[0], value = _a[1];
                var reg = /\$begindate\$|\$begintime\$|\$enddate\$|\$endtime\$|\$resourceid\$/i;
                if (value.match(reg) != null) {
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(queryObj, name, value);
            });
            queryObj.istree = true;
            return queryObj;
        };
        this.getMore = function (callback) {
            _this.spinisload = true;
            _this.currentpage++;
            var iscustomsearch = __WEBPACK_IMPORTED_MODULE_9_jquery___default.a.isEmptyObject(_this.queryparm) ? false : true;
            var parm = __assign({}, _this.resourceParams, { currentpage: _this.currentpage }, _this.queryparm, { iscustomsearch: iscustomsearch });
            __WEBPACK_IMPORTED_MODULE_3__apis_resource__["b" /* getResourcesInfo */](__assign({}, parm, { sqlwhere: encodeURIComponent(_this.sqlwhere) })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, error = _a.error, datainfo = _a.datainfo, datasqlwhere = _a.datasqlwhere;
                if (status == '1') {
                    var ids = datainfo.ids, names_2 = datainfo.names, titles_2 = datainfo.titles, imgs_2 = datainfo.imgs;
                    // Search.forceUpdate=true;
                    var resourceList_2 = [];
                    ids && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isArray(ids) && ids.map(function (id, index) {
                        resourceList_2.push({
                            "name": names_2[index],
                            "id": id,
                            "title": titles_2[index],
                            "imgs": imgs_2[index]
                        });
                    });
                    _this.resourcesList = _this.resourcesList.concat(resourceList_2);
                    _this.isShowMore = true;
                    var useMap = _this.showSet(datainfo);
                    _this.useMap = __assign({}, _this.useMap, useMap);
                    if (callback && _this.isHideSearch) {
                        callback('restore', _this.listContainerHeight);
                    }
                    _this.loading = false;
                }
                _this.spinisload = false;
            }));
        };
        this.showSet = function (datainfo) {
            if (_this.resourcesList.length < _this.total) {
                _this.showMoreVisible = true;
            }
            else {
                _this.showMoreVisible = false;
            }
            var useMap = {};
            datainfo.ids.forEach(function (item) {
                var rinfo = datainfo.resourceInfo[item];
                var mydata = {};
                rinfo.forEach(function (element) {
                    var startDate = element[datainfo.fields.startDateFieldName];
                    var endDate = element[datainfo.fields.endDateFieldName];
                    var startTime = element[datainfo.fields.startTimeFieldName];
                    var endTime = element[datainfo.fields.endTimeFieldName];
                    var title = element[datainfo.fields.titleFieldName];
                    var content = element[datainfo.fields.contentFieldName];
                    var startDateTime = element[datainfo.fields.startDateTimeFieldName];
                    var startaloneOrcombination = datainfo.fields.startaloneOrcombination;
                    var endDateTime = element[datainfo.fields.endDateTimeFieldName];
                    var endaloneOrcombination = datainfo.fields.endaloneOrcombination;
                    if (startaloneOrcombination == '2') {
                        startDate = startDateTime.substring(0, 10);
                        startTime = startDateTime.substring(11);
                    }
                    if (endaloneOrcombination == '2') {
                        endDate = endDateTime.substring(0, 10);
                        endTime = endDateTime.substring(11);
                    }
                    if (_this.resourceParams['bywhat'] == '2') { //月
                        var datas = Object(__WEBPACK_IMPORTED_MODULE_7__util_dateUtil__["b" /* getDateBetweenDates */])(startDate, endDate);
                        datas.forEach(function (item) {
                            var t = mydata[item] ? mydata[item].title : [];
                            t.push([getLabel(229, '标题') + '：' + title, getLabel(124948, '时间段') + '：' + startDate + ' ' + startTime + ' - ' + endDate + ' ' + endTime, getLabel(131393, '内容') + '：' + content]);
                            var _tipsinfo = mydata[item] ? mydata[item].tipsinfo : [];
                            _tipsinfo.push({ tipsinfo: element.tipsinfo });
                            var m = mydata[item] ? mydata[item].meetings : [];
                            m.push({ name: title, id: element.id });
                            mydata[item] = { title: t, meetings: m, tipsinfo: _tipsinfo };
                        });
                    }
                    else if (_this.resourceParams['bywhat'] == '3') { //周
                        var datas = Object(__WEBPACK_IMPORTED_MODULE_7__util_dateUtil__["b" /* getDateBetweenDates */])(startDate, endDate);
                        datas.forEach(function (item) {
                            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_dateUtil__["d" /* isInWeek */])(_this.resourceParams['currentdate'], _this.resourceParams['movedate'], item, _this.weekstart)) { //判断当前日期是否本周日期
                                var t = mydata[item] ? mydata[item].title : [];
                                t.push([getLabel(229, '标题') + '：' + title, getLabel(124948, '时间段') + '：' + startDate + ' ' + startTime + ' - ' + endDate + ' ' + endTime, getLabel(131393, '内容') + '：' + content]);
                                var _tipsinfo = mydata[item] ? mydata[item].tipsinfo : [];
                                _tipsinfo.push({ tipsinfo: element.tipsinfo });
                                var m = mydata[item] ? mydata[item].meetings : [];
                                m.push({ name: title, id: element.id });
                                var _tdContent = mydata[item] ? mydata[item].tdContent : [];
                                _tdContent.push({
                                    resourcedetailsshow: element.resourcedetailsshow
                                });
                                mydata[item] = { title: t, meetings: m, tdContent: _tdContent, tipsinfo: _tipsinfo };
                            }
                        });
                    }
                    else if (_this.resourceParams['bywhat'] == '4') { //日
                        var hour = Object(__WEBPACK_IMPORTED_MODULE_7__util_dateUtil__["c" /* getHourBetweenDates */])(_this.resourceParams['currentdate'], _this.resourceParams['movedate'], startDate, startTime, endDate, endTime, _this.dspunit);
                        hour.forEach(function (i) {
                            var t = mydata[i] ? mydata[i].title : [];
                            t.push([getLabel(229, '标题') + '：' + title, getLabel(500371, '开始时间') + '：' + startDate + ' ' + startTime, getLabel(500372, '结束时间') + '：' + endDate + ' ' + endTime, getLabel(131393, '内容') + '：' + content]);
                            var _tipsinfo = mydata[i] ? mydata[i].tipsinfo : [];
                            _tipsinfo.push({ tipsinfo: element.tipsinfo });
                            var m = mydata[i] ? mydata[i].meetings : [];
                            m.push({ name: title, id: element.id });
                            mydata[i] = { title: t, meetings: m, tipsinfo: _tipsinfo };
                        });
                    }
                });
                var mydatakeys = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.keys(mydata);
                var info = [];
                for (var i = 0; i < mydatakeys.length; i++) {
                    var key = mydatakeys[i];
                    var value = mydata[key];
                    var bgcolor = value.title.length > 1 ? _this.conflictedcolor : _this.usedcolor;
                    var intkey = parseInt(key);
                    var dspunittime = Math.floor(intkey) + '' == key ? ":00" : ":30";
                    info.push({
                        bgcolor: bgcolor,
                        content: value.title.length,
                        date: key,
                        time: Math.floor(intkey) + dspunittime,
                        fontcolor: "",
                        meetings: value.meetings,
                        title: value.title,
                        tdContent: value.tdContent || [],
                        tipsinfo: value.tipsinfo
                    });
                }
                useMap[item] = info;
            });
            return useMap;
        };
        /*拖曳结束*/
        this.dragChooseEnd = function (dragState, activeCellProps) {
            _this.dragref && _this.dragref.clear();
            var startProps = dragState.startProps, endProps = dragState.endProps;
            var startTime = startProps.startTime;
            var endTime = endProps.endTime;
            if (endTime < startTime) {
                startTime = endProps.startTime;
                endTime = startProps.endTime;
            }
            var id = startProps.room.id;
            var date = _this.resourceParams['currentdate'];
            var movedate = _this.resourceParams['movedate'];
            if (movedate) {
                date = Object(__WEBPACK_IMPORTED_MODULE_7__util_dateUtil__["a" /* addDay */])(date, movedate);
            }
            var startdatetime = date + " " + startTime;
            var enddatetime = date + " " + endTime;
            var parms = { "startDate": date, "startTime": startTime, "endDate": date, "endTime": endTime, "id": id, startdatetime: startdatetime, enddatetime: enddatetime };
            _this.onAdd(parms);
            // if (this.createUrl.indexOf("/spa/cube/index.jsp#/main/cube/card") > -1) {
            // }else{
            //   this.visible = true;
            // }
        };
        /** 周新建卡片/流程 */
        this.onWeekChoose = function (dragParams) {
            var date = dragParams.date, room = dragParams.room;
            var startDate = date;
            var endDate = date;
            var id = room.id;
            var startdatetime = startDate + " ";
            var enddatetime = endDate + " ";
            var parms = { "startDate": startDate, "startTime": "", "endDate": endDate, "endTime": "", "id": id, startdatetime: startdatetime, enddatetime: enddatetime };
            _this.onAdd(parms);
        };
        this.setIsEditList = function (bool) {
            _this.isEditList = bool;
        };
        /**
         * 修改store中可观察对象
         * @param key 属性名
         * @param value 属性值
         * @param oppositeValue 是否取相反值
         */
        this.handleValueChange = function (key, value, oppositeValue) {
            if (oppositeValue === void 0) { oppositeValue = false; }
            if (oppositeValue) {
                _this[key] = !value;
            }
            else {
                _this[key] = value;
            }
        };
        this.updateIsHideSearch = function () {
            _this.isHideSearch = false;
            // if (this.resourceParams.bywhat==='3' && this.opendetailshow === 1) {
            //   this.isHideSearch = true;
            // } else {
            //   this.isHideSearch = false;
            // }
        };
    }
    Object.defineProperty(ViewResouceStore.prototype, "quickButtons", {
        get: function () {
            var _this = this;
            var quickRightMenus = this.card.cardTab.rightMenus.map(function (m) { return (__assign({}, m, { disabled: _this.card.cardTab.disabled })); });
            ;
            return quickRightMenus.map(function (d, idn) {
                return React.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: "_Button@x921wp@" + idn, type: "primary", onClick: function () {
                        if (d.function.startsWith('javascript:toDel(')) {
                            _this.card.Actions.runCustomAction(d.key, function () { __WEBPACK_IMPORTED_MODULE_10__util__["default"]['cubeStore'].cubeViewResource.visible = false; });
                        }
                        else {
                            _this.card.Actions.runCustomAction(d.key);
                        }
                    } }, d.content);
            });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "rightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "customid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "currentdate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "resourceParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "resourcesList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "useMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "timeType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "hasUrlByWhat", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "duration", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "conHeight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "tabHeight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "spinisload", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "moduls", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "resourceId", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "modename", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "createUrl", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "oriCreateUrl", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "currentpage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "total", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "showMoreVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "startHour", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "endHour", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "dspunit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "usedcolor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "conflictedcolor", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "weekstart", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "opendetailshow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "panelHeightRatio", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "showMoreColorType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "colorType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "isHideSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "listContainerHeight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "isShowMore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "fields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "dragref", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "conditions", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "queryparm", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "isEditList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ViewResouceStore.prototype, "card", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "updateHeight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "query", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "search", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "updateTimeType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "getRightMenus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "onAdd", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "getQuery", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "getMore", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["computed"]
    ], ViewResouceStore.prototype, "quickButtons", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "setIsEditList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "handleValueChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ViewResouceStore.prototype, "updateIsHideSearch", void 0);
    return ViewResouceStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (ViewResouceStore);


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_modetab__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
// import _ from 'lodash';
// const getLabel = WeaLocaleProvider.getLabel;
var TabStore = /** @class */ (function () {
    function TabStore() {
        var _this = this;
        this.type = "";
        this.initData = function (modeid, billid) {
            //初始化数据
            var parm = { modeid: modeid, billid: billid };
            __WEBPACK_IMPORTED_MODULE_1__apis_modetab__["b" /* getTabs */](parm).then(function (_a) {
                var tabs = _a.tabs, tablename = _a.tablename, existTabs = _a.existTabs, status = _a.status, error = _a.error;
                _this.tabs = tabs;
                _this.tablename = tablename;
                _this.existTabs = existTabs;
            });
        };
        this.updateDataTab = function (parm) {
            //初始化数据
            __WEBPACK_IMPORTED_MODULE_1__apis_modetab__["d" /* updateDataTab */](parm).then(function (_a) {
                var status = _a.status;
                _this.initData(parm.modeid, parm.billid);
                /***
                 * 卡片页面修改标签后刷新查询数据
                 */
                if (_this.type == "card") {
                    if (window.opener) {
                        var _b = window.opener, _table = _b._table, cubeStore = _b.cubeStore;
                        if (_table && _table.reLoad) {
                            var isTreeList = cubeStore && cubeStore.Search.dataShowtype === 'treeType' && cubeStore.Search.changeSearch == '1'; // 分组的组合转换，单独判断
                            if (isTreeList && cubeStore.Search.customId) {
                                cubeStore.Search.refresh();
                            }
                            else {
                                _table.reLoad();
                            }
                        }
                        else if (cubeStore && cubeStore.Search.customId) {
                            cubeStore.Search.refresh();
                        }
                    }
                    else {
                        if (typeof (window.parent['slideflgfun']) == 'function') {
                            if (window.parent['slideflgfun']()) {
                                window.parent['dosubmitfun']();
                            }
                        }
                    }
                }
            });
        };
        this.saveSingtonTab = function (parm, callback) {
            //初始化数据
            __WEBPACK_IMPORTED_MODULE_1__apis_modetab__["c" /* saveSingtonTab */](parm).then(function (_a) {
                var status = _a.status, id = _a.id;
                if (status == 2) { //标签名已存在
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(getLabel(25434, " 标签名已存在！"));
                }
                else if (status == 1) {
                    if (id != undefined) { //新增保存的同时要给数据贴上标签
                        _this.updateDataTabForadd(id, parm);
                        if (callback) {
                            callback(__assign({}, parm, { id: id }));
                        }
                    }
                    else {
                        _this.initData(parm.modeid, parm.billid);
                    }
                }
            });
        };
        this.delSingtonTab = function (parm) {
            //初始化数据
            __WEBPACK_IMPORTED_MODULE_1__apis_modetab__["a" /* delSingtonTab */](parm).then(function (_a) {
                var status = _a.status;
                if (status == 1) {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].info(getLabel(83472, "删除成功！"));
                    _this.initData(parm.modeid, parm.billid);
                }
            });
        };
        this.update = function (param) {
            for (var key in param) {
                _this[key] = param[key];
            }
        };
    }
    TabStore.prototype.updateDataTabForadd = function (id, parm) {
        var modelableid = '';
        this.existTabs.map(function (tab) {
            modelableid += tab.id + ',';
        });
        modelableid += id;
        var parm2 = __assign({ operate: '0', modelableid: modelableid, tablename: this.tablename, tabid: id }, parm);
        this.updateDataTab(parm2);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TabStore.prototype, "tabs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TabStore.prototype, "existTabs", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TabStore.prototype, "type", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TabStore.prototype, "initData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TabStore.prototype, "updateDataTab", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TabStore.prototype, "saveSingtonTab", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TabStore.prototype, "delSingtonTab", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TabStore.prototype, "update", void 0);
    return TabStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (TabStore);


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateDataTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveSingtonTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return delSingtonTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(7);
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var newUrl = '/api/cube/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                reject();
                __WEBPACK_IMPORTED_MODULE_1__util__["default"].weaHistory.push('/main/cube/noright');
            }
            else {
                resolve(data);
            }
        });
    });
};
var getTabs = function (params) {
    return CallAPI(newUrl + "tab/getTabs", "get", params);
};
var updateDataTab = function (params) {
    return CallAPI(newUrl + "tab/updateDataTab", "post", params);
};
var saveSingtonTab = function (params) {
    return CallAPI(newUrl + "tab/saveSingtonTab", "post", params);
};
var delSingtonTab = function (params) {
    return CallAPI(newUrl + "tab/delSingtonTab", "post", params);
};


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_TemplateManage__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_table__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};








var getLabel = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaLocaleProvider"].getLabel;
var TemplateManageStore = /** @class */ (function () {
    function TemplateManageStore() {
        var _this = this;
        this.id = '';
        this.loading = false;
        this.customid = '';
        this.sourcetype = ''; //2普通查询
        this.columns = [];
        this.templateListDataKey = "";
        this.templateName = "";
        this.templateName1 = "";
        this.form = new __WEBPACK_IMPORTED_MODULE_4_comsMobx__["WeaForm"]();
        this.visible = false;
        this.visible_set = false;
        this.visible_set_condition = false;
        this.pagination = {
            pageSize: 10,
            current: 1,
            total: 0,
            onChange: function (current, pageSize) {
                _this.pagination.current = current;
                _this.pagination.pageSize = pageSize;
            }
        };
        this.columnsSet = [];
        this.DatasSet = [];
        this.conditionForm = new __WEBPACK_IMPORTED_MODULE_4_comsMobx__["WeaForm"]();
        this.conditionInfo = [];
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.init = function () {
            _this.columns = Object(__WEBPACK_IMPORTED_MODULE_1__data_TemplateManage__["a" /* getColumns */])(_this);
            _this.columnsSet = Object(__WEBPACK_IMPORTED_MODULE_1__data_TemplateManage__["b" /* getColumnsSet */])(_this.checkAll);
            _this.fields = Object(__WEBPACK_IMPORTED_MODULE_1__data_TemplateManage__["c" /* getFields */])();
            _this.form.initFormFields([{ items: _this.fields.slice() }]);
            _this.getTemplateListDataKey({ customid: _this.customid, sourcetype: _this.sourcetype });
            _this.getIconInfo(_this.customid);
        };
        this.validateForm = function (fields, form) {
            for (var i = 0; i < fields.length; i++) {
                var text = fields[i].domkey[0];
                if (!fields[i].hide && fields[i].viewAttr == 3 && form.getFormParams()[text].trim() == '') {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].warn(getLabel(23073, "请填写") + fields[i].label + '!');
                    return false;
                }
            }
            return true;
        };
        this.getTemplateListDataKey = function (param) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getTemplateList(param).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas;
                if (status == '1') {
                    _this.templateListDataKey = datas;
                    _this.getTemplateListCount();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this.loading = false;
            }));
        };
        this.getTemplateListCount = function () {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__apis_table__["a" /* getTableCounts */]({ dataKey: _this.templateListDataKey }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, count = _a.count;
                if (status == '1') {
                    _this.pagination.total = count;
                    _this.pagination.current = 1;
                    _this.getTemplateListData();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this.loading = false;
            }));
        };
        this.getTemplateListData = function () {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__apis_table__["b" /* getTableDatas */](__assign({}, _this.pagination, { dataKey: _this.templateListDataKey })).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, datas = _a.datas;
                if (status == '1') {
                    _this.templateListDatas = datas;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this.loading = false;
            }));
        };
        this.searchByName = function (name) {
            if (name === void 0) { name = ''; }
            _this.templateName = name;
            _this.templateName1 = _this.templateName;
            _this.getTemplateListDataKey({ customid: _this.customid, templatename: name, sourcetype: _this.sourcetype });
        };
        this.add = function () {
            _this.form.resetForm();
            _this.form.updateFields({ templatetype: '0' }, true);
            _this.visible = true;
        };
        this.rightClick = function (key) {
            if (key == 'add') {
                _this.add();
            }
        };
        this.save = function () {
            // if (!this.validateForm(this.fields,this.form))return;
            _this.form.validateForm().then(function (f) {
                if (f.isValid) {
                    var formparams = _this.form.getFormParams();
                    var templatename = formparams.templatename;
                    var len = 0;
                    for (var i = 0; i < templatename.length; i++) {
                        if (templatename.charCodeAt(i) > 127 || templatename.charCodeAt(i) == 94) {
                            len += 2;
                        }
                        else {
                            len++;
                        }
                    }
                    if (len > 100) {
                        __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(getLabel(532540, "模板名称超出字符数限制（100），无法保存。"));
                        return "";
                    }
                    _this.loading = true;
                    __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].saveOrUpdateTemplate(__assign({ sourcetype: _this.sourcetype, customid: _this.customid }, _this.form.getFormParams())).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                        var status = _a.status, errorCode = _a.errorCode, error = _a.error;
                        if (status == '1') {
                            __WEBPACK_IMPORTED_MODULE_5_antd__["message"].success(getLabel(18758, "保存成功"));
                            _this.getTemplateListDataKey({ customid: _this.customid, sourcetype: _this.sourcetype });
                            _this.visible = false;
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                        }
                        _this.loading = false;
                    }));
                }
                else {
                    f.showErrors();
                }
            });
        };
        this.edit = function (id, templatename, templatetype, displayorder, isdefault) {
            if (templatename === void 0) { templatename = ''; }
            if (templatetype === void 0) { templatetype = ''; }
            if (displayorder === void 0) { displayorder = 0; }
            if (isdefault === void 0) { isdefault = 0; }
            _this.form.resetForm();
            _this.form.updateFields({ id: id, templatename: templatename, templatetype: templatetype, displayorder: displayorder, isdefault: isdefault }, true);
            _this.visible = true;
        };
        this.handleTableChange = function (pagination) {
            _this.pagination = pagination;
            _this.getTemplateListData();
        };
        this.delete = function (id) {
            var mythis = _this;
            __WEBPACK_IMPORTED_MODULE_5_antd__["Modal"].confirm({
                title: getLabel(129890, '确定要删除吗?', 'label'),
                okText: getLabel(382958, '确定'),
                okType: 'danger',
                cancelText: getLabel(201, "取消"),
                onOk: function () {
                    mythis.loading = true;
                    __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].deleteTemplate({ id: id }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                        var status = _a.status, errorCode = _a.errorCode, error = _a.error;
                        if (status == '1') {
                            __WEBPACK_IMPORTED_MODULE_5_antd__["message"].success(getLabel(20461, "删除成功"));
                            mythis.getTemplateListCount();
                            mythis.visible = false;
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                        }
                        mythis.loading = false;
                    }));
                }
            });
        };
        this.setDefault = function (id) {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].setDefault({ sourcetype: _this.sourcetype, customid: _this.customid, id: id }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].success(getLabel(83885, "操作成功！"));
                    _this.getTemplateListData();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this.loading = false;
            }));
        };
        this.setTemplateCustomCondition = function (id) {
            _this.id = id;
            _this.visible_set_condition = true;
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getTemplateInfo({ sourcetype: _this.sourcetype, customid: _this.customid, templateid: id, from: 'templatemanage' }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, conditionInfo = _a.conditionInfo, dataSource = _a.dataSource;
                if (status == '1') {
                    conditionInfo[0].items = conditionInfo[0].items.filter(function (item) {
                        if (item.domkey[0] == 'thisdate' || item.domkey[0] == 'thisorg') {
                            return false;
                        }
                        else {
                            return true;
                        }
                    });
                    _this.conditionForm = new __WEBPACK_IMPORTED_MODULE_4_comsMobx__["WeaForm"]();
                    _this.conditionInfo = conditionInfo;
                    _this.conditionForm.initFormFields(conditionInfo);
                    var otherData = {};
                    for (var field in dataSource) {
                        if (_this.conditionForm.has(field)) {
                            if (Array.isArray(dataSource[field])) {
                                var _field = _this.conditionForm.select(field);
                                _field.set(dataSource[field]);
                            }
                            else {
                                otherData[field] = dataSource[field];
                            }
                        }
                    }
                    _this.conditionForm.updateFields(otherData, false);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this.loading = false;
            }));
        };
        this.setTemplateColumn = function (id) {
            _this.id = id;
            _this.visible_set = true;
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getColumnSetInfo({ sourcetype: _this.sourcetype, customid: _this.customid, id: id }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error, info = _a.info;
                if (status == '1') {
                    _this.DatasSet = info;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this.loading = false;
            }));
        };
        this.saveTemplateField = function () {
            _this.visible_set = true;
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].saveTemplateField({ valuearray: JSON.stringify(_this.DatasSet), id: _this.id }).then(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["action"])(function (_a) {
                var status = _a.status, errorCode = _a.errorCode, error = _a.error;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].success(getLabel(18758, "保存成功"));
                    _this.visible_set = false;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error("[" + (getLabel(127353, "错误") + errorCode) + "]:" + error);
                }
                _this.loading = false;
            }));
        };
        this.saveCustomCondition = function () {
            var getValues = function (conditionInfo, values) {
                var vi = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(values);
                var ci = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(conditionInfo[0].items);
                var rs = ci.map(function (c) { return "" + c.domkey; });
                var vs = rs.map(function (c) { return "" + vi[c]; });
                return JSON.stringify({ rs: rs, vs: vs });
            };
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].saveTemplate({
                action: "save",
                customid: _this.customid,
                templateid: _this.id,
                sourcetype: _this.sourcetype,
                values: getValues(_this.conditionInfo, _this.conditionForm.values())
            }).then(function (_a) {
                var status = _a.status, error = _a.error, props = __rest(_a, ["status", "error"]);
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].success(getLabel(18758, "保存成功。"));
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_5_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.checkAll = function (v) {
            _this.DatasSet = _this.DatasSet.map(function (item) {
                item.isshow = v;
                return item;
            });
        };
        this.getIconInfo = function (customid) {
            __WEBPACK_IMPORTED_MODULE_2__apis__["a" /* default */].getAppInfoByID({ customid: customid }).then(function (data) {
                if (data.status == "1") {
                    _this.iconInfo = {
                        icon: data.icon || "icon-coms-ModelingEngine",
                        iconColor: data.iconColor || "#fff",
                        iconBg: data.iconBg || "#96358a"
                    };
                }
            });
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "columns", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "templateListDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "templateName", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "templateName1", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "fields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "visible_set", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "visible_set_condition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "pagination", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "DatasSet", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "conditionForm", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "conditionInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TemplateManageStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "validateForm", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "getTemplateListDataKey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "getTemplateListCount", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "getTemplateListData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "searchByName", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "add", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "rightClick", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "save", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "edit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "handleTableChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "delete", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "setDefault", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "setTemplateCustomCondition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "setTemplateColumn", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "saveTemplateField", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "saveCustomCondition", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "checkAll", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TemplateManageStore.prototype, "getIconInfo", void 0);
    return TemplateManageStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (TemplateManageStore);


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getColumnsSet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _this_1 = this;


var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;
var getFields = function () {
    var labelcol = 5;
    var fieldcol = 15;
    var fields = [{
            domkey: ['templatename'],
            conditionType: 'input',
            label: getLabel(18151, '模板名称'),
            viewAttr: 3,
            rules: 'required|string'
        }, {
            domkey: ['templatetype'],
            conditionType: 'SELECT',
            label: getLabel(19471, '模板类型'),
            viewAttr: 3,
            options: [{ key: '0', showname: getLabel(83139, '私人模板'), selected: true }]
        }, {
            domkey: ['displayorder'],
            conditionType: 'INPUTNUMBER',
            label: getLabel(88, '顺序'),
            viewAttr: 2,
            precision: 2,
        }, {
            domkey: ['isdefault'],
            conditionType: 'CHECKBOX',
            label: getLabel(33731, '是否默认', 'label'),
            viewAttr: 2,
        }, {
            domkey: ['id'],
            conditionType: 'input',
            label: '',
            viewAttr: 1,
            hide: true
        }].map(function (f) {
        return __assign({}, f, { labelcol: labelcol,
            fieldcol: fieldcol });
    });
    return fields;
};
var getColumns = function (_this) {
    var getMenu = function (id, templatename, templatetype, displayorder, isdefault) {
        return React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Menu"], { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Menu@3dpi5i" },
            React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Menu"].Item, { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Menu.Item@zbk14s" },
                React.createElement("a", { onClick: function () {
                        _this.setTemplateCustomCondition(id);
                    } }, getLabel(83142, '查询条件定义', 'label'))),
            React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Menu"].Item, { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Menu.Item@4wguas" },
                React.createElement("a", { onClick: function () {
                        _this.setTemplateColumn(id);
                    } }, getLabel(84342, '查询条件字段定义', 'label'))),
            React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Menu"].Item, { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Menu.Item@a8fxoc" },
                React.createElement("a", { onClick: function () {
                        _this.edit(id, templatename, templatetype, displayorder, isdefault);
                    } }, getLabel(93, '编辑', 'label'))),
            React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Menu"].Item, { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Menu.Item@zkgyma" },
                React.createElement("a", { onClick: function () {
                        _this.setDefault(id);
                    } }, getLabel(83144, '设置为默认', 'label'))),
            React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Menu"].Item, { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Menu.Item@sby6dx" },
                React.createElement("a", { onClick: function () {
                        _this.delete(id);
                    } }, getLabel(91, '删除', 'label'))));
    };
    var columns = [{
            title: getLabel(18151, '模板名称', 'label'),
            dataIndex: 'templatename',
            render: function (text) { return React.createElement("a", { onClick: function () { } }, text); },
            width: 20,
        }, {
            title: getLabel(19471, '模板类型', 'label'),
            dataIndex: 'templatetypespan',
            width: 10,
        }, {
            title: getLabel(15513, '显示顺序', 'label'),
            dataIndex: 'displayorderspan',
            width: 10,
        }, {
            title: getLabel(33731, '是否默认', 'label'),
            dataIndex: 'isdefaultspan',
            width: 10,
        }, {
            title: getLabel(882, '创建人', 'label'),
            dataIndex: 'createridspan',
            width: 20,
        }, {
            title: getLabel(81517, '创建日期', 'label'),
            dataIndex: 'createdate',
            width: 20,
        }, {
            title: '',
            dataIndex: 'id',
            width: 10,
            render: function (id, record) {
                return React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Dropdown"], { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Dropdown@cxqn9o@id", overlay: getMenu(id, record.templatename, record.templatetype, record.displayorder, record.isdefault) },
                    React.createElement("a", { className: "ant-dropdown-link" },
                        getLabel(104, "操作"),
                        React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Icon"], { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Icon@u9g5j8@action", type: "down" })));
            }
        }];
    return columns;
};
var getColumnsSet = function (checkAll) {
    var columns = [{
            title: getLabel(31644, '字段名'),
            dataIndex: 'fieldlabelname',
            key: 'fieldlabelname',
            com: [
                { label: '', type: 'TEXT' },
            ],
            colSpan: 1,
            width: '30%',
        }, {
            title: React.createElement(__WEBPACK_IMPORTED_MODULE_0_antd__["Checkbox"], { ecId: (_this_1 && _this_1.props && _this_1.props.ecId || '') + "_Checkbox@ynbf4u@isshow", onChange: function (key) {
                    var v = key.target.checked ? '1' : '0';
                    checkAll(v);
                } }, getLabel(15603, '是否显示')),
            dataIndex: 'isshow',
            key: 'isshow',
            com: [
                { label: '', type: 'CHECKBOX', key: 'isshow' },
            ],
            colSpan: 1,
            width: '30%',
        }, {
            title: getLabel(23691, '字段排序'),
            dataIndex: 'fieldorder',
            key: 'fieldorder',
            com: [
                { label: '', type: 'INPUT', key: 'fieldorder' },
            ],
            colSpan: 1,
            width: '40%',
        }];
    return columns;
};


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_mind__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(7);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var MindeStore = /** @class */ (function () {
    function MindeStore() {
        var _this = this;
        this.mindData = {};
        this.nodeList = {};
        this.params = {};
        this.apiFlag = 0;
        /**
         * 前端拖动回调方法
         */
        this.saveDragendMind = function (arr, old_parent, new_parent, selectd_node) {
            _this.editable();
            _this.initMap();
        };
        this.jsmindLoading = function (end) {
            if (end) {
                _this.initMap();
            }
        };
        /**
         * 初始化思维导图
         */
        this.initMap = function () {
            if (_this.loaded == "1" && __WEBPACK_IMPORTED_MODULE_2__util__["default"].jsMind) {
                if (_this._jm) {
                    _this._jm.init();
                    _this._jm.data.init();
                }
                else {
                    var options = {
                        container: 'jsmind_container',
                        editable: false,
                        theme: 'weaver',
                        support_html: true,
                        layout: {
                            hspace: 150,
                            vspace: 10,
                            pspace: 13 // 节点收缩/展开控制器的尺寸
                        }
                    };
                    _this._jm = new __WEBPACK_IMPORTED_MODULE_2__util__["default"].jsMind(options);
                }
                var mind = {
                    meta: {},
                    format: 'node_tree',
                    data: _this.mindData
                };
                _this._jm.show(mind);
                //this.editable();
            }
        };
        /**
         * 调整拖拽控制级别
         */
        this.editable = function () {
            _this._jm.enable_edit();
        };
        /**
         * 放大
         */
        this.zoomIn = function () {
            if (_this._jm) {
                _this._jm.view.zoomIn();
            }
        };
        /**
         * 缩小
         */
        this.zoomOut = function () {
            if (_this._jm) {
                _this._jm.view.zoomOut();
            }
        };
        /**
         * 缩小
         */
        this.collapse_all = function () {
            if (_this._jm) {
                _this._jm.collapse_all();
            }
        };
        /**
         * 缩小
         */
        this.expand_all = function () {
            if (_this._jm) {
                _this._jm.expand_all();
            }
        };
        /**
         * 进入页面方法
         */
        this.updateParams = function (params) {
            _this.params = params;
            _this.init(params);
        };
        /**
         * 页面初始化
         */
        this.init = function (params) {
            _this.params = params;
            _this.apiFlag = 1;
            __WEBPACK_IMPORTED_MODULE_1__apis_mind__["a" /* initMind */](params).then(function (data) {
                _this.apiFlag = 2;
                _this.mindData = data.mindMap;
                _this.loaded = data.loaded;
                _this.defaultFloor = data.defaultFloor;
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].saveDragendMind = _this.saveDragendMind;
                __WEBPACK_IMPORTED_MODULE_2__util__["default"].clickTable = _this.clickTable;
                _this.checkNodeList(data.mindMap);
                _this.initMap();
            });
        };
        /**
         * 把树状数据处理成list
         */
        this.checkNodeList = function (data) {
            var id = data.id;
            var parent = "";
            var count = data.count;
            var loaded = data.loaded;
            var topic = data.topic;
            var title = data.title;
            var children = data.children;
            _this.nodeList[id] = { id: id, parent: parent, count: count, loaded: loaded, topic: topic, title: title };
            for (var i = 0; i < children.length; i++) {
                _this.checkSubNode(id, children[i]);
            }
        };
        /**
         * 把树状数据处理成list
         */
        this.checkSubNode = function (parent, data) {
            var id = data.id;
            var count = data.count;
            var loaded = data.loaded;
            var topic = data.topic;
            var title = data.title;
            var children = data.children;
            _this.nodeList[id] = { id: id, parent: parent, count: count, loaded: loaded, topic: topic, title: title };
            for (var i = 0; i < children.length; i++) {
                _this.checkSubNode(id, children[i]);
            }
        };
        /**
         * 前端点击区块的回调事件  非默认展开子节点加载入口
         */
        this.clickTable = function (id) {
            var data = _this.nodeList[id];
            if (data) {
                var loaded = data.loaded;
                if (loaded) {
                    _this._jm.toggle_node(id);
                }
                else {
                    _this.initNode(id);
                }
            }
        };
        /**
         * 手动加载子节点数据（防止数据过多一次加载过慢）
         */
        this.initNode = function (dataId) {
            __WEBPACK_IMPORTED_MODULE_1__apis_mind__["b" /* mindSubData */](__assign({ dataId: dataId }, _this.params)).then(function (data) {
                var subData = data.subData;
                var PNode = _this._jm.get_node(dataId);
                _this._jm.enable_edit();
                for (var i = 0; i < subData.length; i++) {
                    var node = subData[i];
                    var id = node.id;
                    var topic = node.topic;
                    var count = node.count;
                    var title = node.title;
                    _this.nodeList[id] = { id: id, parent: parent, count: count, loaded: false, topic: topic, title: title };
                    _this._jm.add_node(PNode, id, topic);
                }
                _this._jm.disable_edit();
                _this.nodeList[dataId].loaded = true;
            });
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindeStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "saveDragendMind", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "jsmindLoading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "initMap", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "editable", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "zoomIn", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "zoomOut", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "collapse_all", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "expand_all", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "checkNodeList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "checkSubNode", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "clickTable", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindeStore.prototype, "initNode", void 0);
    return MindeStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (MindeStore);


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export url */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initMind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mindSubData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);

var url = '/api/cube/graph';
var initMind = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/getMindData", "get", params);
};
var mindSubData = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url + "/getMindSub", "get", params);
};


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_board__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cubeUtil__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(7);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var getLabel = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaLocaleProvider"].getLabel;
var BoardStore = /** @class */ (function () {
    function BoardStore() {
        var _this_1 = this;
        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;
        this.timestamp = new Date().getTime() + '';
        this.canAdd = false; //各个分组底部是否有"添加新数据"的按钮
        this.addurl = '';
        this.datasIdList = []; //分组id
        this.statusList = [];
        this.datas_all = {};
        this.groupItems = {}; //记录移动后的元素分组位置
        this.datas = {};
        this.pageSize = 10;
        this.orderField = []; //排序字段
        this.isAdvanceSearch = true;
        this.orderInfo = { type: '', fieldid: '' };
        this.columnGrids = [];
        this.columnGrids_map = {};
        this.loading = false;
        this.data_loading = false;
        this.item_loading = {};
        this.form = new __WEBPACK_IMPORTED_MODULE_5_comsMobx__["WeaForm"](); //高级搜索数据
        this.conditionInfo = [];
        //@observable isHasQuickSearch: boolean = true;//是否有快捷搜索
        this.quickSearchData = {}; //快速搜索数据
        this.quicksearchparam = {}; //url传递的快速搜索数据
        this.quickSearchFormData = {}; //快速搜索表单数据
        this.quickSearchDataWithNoChange = ''; //仅快速搜索处使用，记录空数据结构，不做改变
        this.quickSearchConditionData = {}; //快速搜索输入的数据(用于浏览框动态参数)
        this.iconInfo = {
            icon: "icon-coms-ModelingEngine",
            iconColor: "#fff",
            iconBg: "#96358a"
        };
        this.allStatusMap = {}; //所有状态信息
        this.paginationInfo = {}; //记录每组的分页情况
        this.windowTitle = '';
        this.isScroll = false; //是否显示滚动条
        /**
         *弹框卡片页相关属性
         */
        this.cardDiag_visible = false;
        this.cardDiag_url = "";
        /**
         * 权限
         */
        this.hasRight = false; //是否有看板后台配置的权限
        this.hasSearcgRight = true; //是否有查询列表的查看权限
        this.checkAdvanedData = "";
        this.params = {};
        /**
         * 与 默认分组设置 相同的 看板显示内容 字段
         */
        this.fieldsSameSettingWithDefaultTabField = [];
        /**
         * 初始化看板数据
         */
        this.initData = function () {
            _this_1.loading = true;
            _this_1.quickSearchFormData = {};
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["c" /* checkRight */]({ boardid: _this_1.boardid, dataid: _this_1.resourceid }).then(function (_a) {
                var error = _a.error, status = _a.status, isRight = _a.isRight, customid = _a.customid;
                if (status == '1') {
                    _this_1.hasRight = isRight;
                    _this_1.data_loading = true;
                    _this_1.getConditionInfo(customid, _this_1.afterConditionInit);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this_1.loading = false;
            });
        };
        //初始化时 获取看板数据
        this.getdata = function () {
            var resetDate = {};
            resetDate = _this_1.getResetDate();
            var isQuickSearch1 = false;
            var quickSearchFormData = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.quickSearchFormData);
            if (quickSearchFormData && JSON.stringify(quickSearchFormData) !== '{}') {
                isQuickSearch1 = true;
            }
            else if (resetDate && JSON.stringify(resetDate) !== '{}') {
                isQuickSearch1 = true;
            }
            var copyparams = _this_1.getUrlParam();
            //...this.quicksearchparam?{isQuickSearch: "1",...this.quicksearchparam}:{},
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["f" /* getBoardDatas */](__assign({}, copyparams, { boardid: _this_1.boardid, isBoardData: '1', resourceid: _this_1.resourceid, fromPageExpend: _this_1.fromPageExpend }, _this_1.form.getFormParams(), _this_1.params, resetDate, isQuickSearch1 ? __assign({ isQuickSearch: "1" }, _this_1.quickSearchFormData, resetDate) : {}))
                .then(function (_a) {
                var error = _a.error, status = _a.status, hasSearcgRight = _a.hasSearcgRight, groupIdList = _a.groupIdList, groupMap = _a.groupMap, statusList = _a.statusList, tablename = _a.tablename, reffieldname = _a.reffieldname, type = _a.type, canAdd = _a.canAdd, addurl = _a.addurl, customid = _a.customid, orderFieldList = _a.orderFieldList, isTitle = _a.isTitle, allStatusMap = _a.allStatusMap, pageSize = _a.pageSize, defaultTabSet = _a.defaultTabSet, windowTitle = _a.windowTitle, checkAdvanedData = _a.checkAdvanedData, noRight = _a.noRight, fieldsSameSettingWithDefaultTabField = _a.fieldsSameSettingWithDefaultTabField;
                if (status == '1') {
                    if (noRight) {
                        __WEBPACK_IMPORTED_MODULE_8__util__["default"].weaHistory.push('/main/cube/encrypt');
                    }
                    _this_1.hasSearcgRight = hasSearcgRight;
                    if (window.location.href.indexOf('wui/index.html') == -1) { //不在前端才修改title
                        _this_1.windowTitle = windowTitle;
                    }
                    _this_1.checkAdvanedData = checkAdvanedData;
                    if (hasSearcgRight) { //查询列表未配置权限
                        _this_1.pageSize = pageSize <= 0 ? 10 : pageSize;
                        _this_1.allStatusMap = allStatusMap;
                        _this_1.customid = customid;
                        _this_1.datas_all = groupMap;
                        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(groupMap, function (item, key) {
                            _this_1.groupItems[key] = item.itemIdList.slice();
                        });
                        _this_1.constructorFirstPage(groupIdList);
                        _this_1.datasIdList = groupIdList;
                        _this_1.statusList = statusList;
                        _this_1.tablename = tablename;
                        _this_1.reffieldname = reffieldname;
                        _this_1.canAdd = canAdd;
                        _this_1.addurl = addurl;
                        _this_1.type = type;
                        _this_1.defaultTabSet = defaultTabSet;
                        //this.isHasQuickSearch = quickSearch.isHasQuickSearch;
                        _this_1.orderField = orderFieldList;
                        _this_1.isTitle = isTitle;
                        _this_1.fieldsSameSettingWithDefaultTabField = fieldsSameSettingWithDefaultTabField;
                        _this_1.initBoard();
                    }
                    else {
                        _this_1.data_loading = false;
                    }
                    if (_this_1.checkRequiredConditionIsFilled() === false) {
                        return;
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        /**
         * 快捷搜索默认值渲染方法，防止初始化过程不过滤
         */
        this.getResetDate = function () {
            var _a = _this_1.quickSearchData.quicksearchinfo, quicksearchinfo = _a === void 0 ? [] : _a;
            var resetDate = {};
            quicksearchinfo.map(function (item) {
                var handleItem = function (item) {
                    if (item.value && item.value != "") {
                        resetDate[item.fieldid] = item.value;
                    }
                    else if (item.fieldhtmltype == "1" && item.fieldtype != '1') { //浮点数整数单独解析
                        var options = item.options;
                        options.map(function (key) {
                            var selected = key.selected;
                            if (selected) {
                                resetDate[item.fieldid] = key.key;
                            }
                        });
                    }
                    else if (item.fieldhtmltype == "3" && item.fieldtype != '1' && item.fieldtype != '2' && item.fieldtype != '19' && item.fieldtype != '290') { //浏览框也单独解析
                        var replaceDatas = item.replaceDatas;
                        var ids_1 = "";
                        replaceDatas && replaceDatas.map(function (rep) {
                            var id = rep.id;
                            ids_1 += id + ",";
                        });
                        ids_1 = ids_1.substring(0, ids_1.length - 1);
                        resetDate[item.fieldid] = ids_1;
                    }
                };
                if (item.hasOwnProperty('searchGroup')) {
                    item.searchGroup.forEach(function (field) {
                        handleItem(field);
                    });
                }
                else {
                    handleItem(item);
                }
            });
            return resetDate;
        };
        this.getIconInfo = function (modeid) {
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["e" /* getAppInfoByID */]({ modeid: modeid }).then(function (data) {
                if (data.status == "1") {
                    _this_1.iconInfo = {
                        icon: data.icon || "icon-coms-ModelingEngine",
                        iconColor: data.iconColor || "#fff",
                        iconBg: data.iconBg || "#96358a"
                    };
                }
            });
        };
        this.setQuickSearchInfo = function (data) {
            if (data === void 0) { data = []; }
            _this_1.quickSearchData.quicksearchinfo = data;
        };
        /**
         * 组装第一页数据
         */
        this.constructorFirstPage = function (groupIdList) {
            var datas_temp = {};
            groupIdList.forEach(function (groupid) {
                var column = _this_1.datas_all[groupid];
                _this_1.paginationInfo[groupid] = { current: 0, total: Math.ceil(column.itemIdList.length / _this_1.pageSize) };
                if (column.itemCount > _this_1.pageSize) {
                    var itemIdList = column.itemIdList.slice(0, _this_1.pageSize);
                    var item_1 = {};
                    itemIdList.forEach(function (i) {
                        item_1[i] = column.item[i];
                    });
                    datas_temp[groupid] = __assign({}, column, { item: item_1, itemIdList: itemIdList });
                }
                else {
                    datas_temp[groupid] = column;
                }
            });
            _this_1.datas = datas_temp;
        };
        /**
         * 翻页
         */
        this.changePage = function (groupid) {
            if (groupid.endsWith('_new'))
                return;
            var page = _this_1.paginationInfo[groupid];
            page.current += 1;
            if (page.current < page.total) {
                var itemIdList_temp_1 = _this_1.datas_all[groupid].itemIdList.slice(page.current * _this_1.pageSize, (page.current + 1) * _this_1.pageSize);
                var item_2 = {};
                itemIdList_temp_1.forEach(function (i) {
                    item_2[i] = _this_1.datas_all[groupid].item[i];
                });
                _this_1.datas[groupid].item = __assign({}, _this_1.datas[groupid].item, item_2);
                _this_1.datas[groupid].itemIdList = _this_1.datas[groupid].itemIdList.concat(itemIdList_temp_1);
                setTimeout(function () {
                    itemIdList_temp_1.forEach(function (i) {
                        var grid = _this_1.columnGrids_map["column_content_" + groupid];
                        var element = document.getElementById('item_' + i);
                        grid.add([element], { index: grid.getItems().length });
                    });
                }, 500);
                return true;
            }
            return false;
        };
        /**
         * 初始化看板拖动元素
         */
        this.initBoard = function () {
            var Muuri = window['Muuri'];
            var borderContainer = document.querySelector('.cube_board_container');
            var board = borderContainer.querySelector('.board');
            var itemContainers = Array.prototype.slice.call(borderContainer.querySelectorAll('.board-column-content'));
            var _this = _this_1;
            itemContainers.forEach(function (container) { return _this_1.initItem(container); });
            _this_1.boardGrid = new Muuri(board, {
                layout: function (items, gridWidth, gridHeight) {
                    // The layout data object. Muuri will read this data and position the items
                    // based on it.
                    var layout = {
                        // The layout item slots (left/top coordinates).
                        slots: [],
                        // The layout's total width.
                        width: 0,
                        // The layout's total height.
                        height: 450,
                        // Should Muuri set the grid's width after layout?
                        setWidth: true,
                        // Should Muuri set the grid's height after layout?
                        setHeight: false
                    };
                    // Calculate the slots.
                    var item;
                    var m;
                    var x = 0;
                    var y = 0;
                    var w = 0;
                    // var h = 0;
                    for (var i = 0; i < items.length; i++) {
                        item = items[i];
                        x += w;
                        //y += h;
                        m = item.getMargin();
                        w = item.getWidth() + m.left;
                        //  h = item.getHeight() + m.top + m.bottom;
                        layout.slots.push(x, y);
                    }
                    // Calculate the layout's total width and height.
                    layout.width = x + w;
                    //layout.height = y + h;
                    return layout;
                },
                layoutDuration: 400,
                layoutOnResize: false,
                layoutEasing: 'ease',
                dragEnabled: true,
                dragSortInterval: 0,
                dragStartPredicate: function (item, event) {
                    if (!_this.hasRight) {
                        return false;
                    }
                    if (_this.defaultTabSet == '2') {
                        return false;
                    }
                    // Prevent first item from being dragged.
                    if (_this.boardGrid.getItems().indexOf(item) === _this.boardGrid.getItems().length - 1 || _this.boardGrid.getItems().indexOf(item) === _this.boardGrid.getItems().length - 2) {
                        return false;
                    }
                    // For other items use the default drag start predicate.
                    return Muuri.ItemDrag.defaultStartPredicate(item, event, {
                        handle: '.board-column-header'
                    });
                },
                dragSortPredicate: function (item) {
                    var result = Muuri.ItemDrag.defaultSortPredicate(item, {
                        action: 'swap',
                        threshold: 50
                    });
                    return result && (result.index === _this.boardGrid.getItems().length - 1 || result.index === _this.boardGrid.getItems().length - 2) ? false : result;
                },
                dragReleaseDuration: 400,
                dragReleaseEasing: 'ease'
            }).on('dragMove', function (item, event) {
                if (event) {
                    var borderDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#cube_board_container');
                    if ((event.center.x + item.getWidth() / 2) > window.innerWidth) {
                        borderDiv.scrollLeft(borderDiv.scrollLeft() + 20);
                    }
                    if (event.center.x - item.getWidth() / 2 < 0) {
                        borderDiv.scrollLeft(borderDiv.scrollLeft() - 20);
                    }
                }
            }).on('dragStart', function (item) {
                _this.column_move_info = [];
            }).on('dragReleaseEnd', function (item) {
                var _this_1 = this;
                if (_this.column_move_info.length != 0) {
                    var startD = _this.column_move_info[0];
                    var endD = _this.column_move_info[_this.column_move_info.length - 1];
                    if (startD.fromIndex != endD.toIndex) {
                        _this.loading = true;
                        var leftgroupid = endD.toIndex == 0 ? "" : _this.boardGrid.getItems()[endD.toIndex - 1]._element.getAttribute('id').replace('column_', '');
                        __WEBPACK_IMPORTED_MODULE_3__apis_board__["j" /* saveGroupOrder */]({
                            boardid: _this.boardid, resourceid: _this.resourceid, type: _this.type, groupid: item._element.getAttribute('id').replace('column_', ''),
                            leftgroupid: leftgroupid
                        }).then(function (_a) {
                            var error = _a.error, status = _a.status, errorCode = _a.errorCode;
                            if (status == '1' && errorCode != '-1') {
                                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].success(getLabel(389171, "排序保存成功！"));
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                                throw error;
                            }
                            _this_1.loading = false;
                        });
                    }
                }
            }).on('move', function (data) {
                _this.column_move_info.push(data);
            });
            _this_1.ungroupedShowOrHide();
        };
        /**
         * 初始化item元素
         */
        this.initItem = function (container, isSearch) {
            if (isSearch === void 0) { isSearch = false; }
            var Muuri = window['Muuri'];
            var _this = _this_1;
            var muuri = new Muuri(container, {
                items: '.board-item',
                layoutDuration: 400,
                layoutEasing: 'ease',
                dragEnabled: true,
                dragSortInterval: 0,
                dragStartPredicate: function (item, event) {
                    if (!_this.hasRight) {
                        return false;
                    }
                    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(item._element).attr('data-showlevel') < 2) {
                        return false;
                    }
                    if (event.target.parentNode && event.target.parentNode.id && event.target.parentNode.id == 'boardItemTitle') {
                        return;
                    }
                    return Muuri.ItemDrag.defaultStartPredicate(item, event, {
                        handle: '.board-item-content'
                    });
                },
                dragSort: function () {
                    return _this.columnGrids;
                },
                dragContainer: document.querySelector('.cube_board_container'),
                dragReleaseDuration: 400,
                dragReleaseEasing: 'ease'
            }).on('dragStart', function (item) {
                item.getElement().style.width = item.getWidth() + 'px';
                item.getElement().style.height = item.getHeight() + 'px';
                _this.item_move_old_grid = item.getGrid();
                _this.item_move_info = [];
                _this.item_move_start_index = item.getGrid().getItems().indexOf(item);
            }).on('dragReleaseEnd', function (item) {
                item.getElement().style.width = '';
                item.getElement().style.height = '';
                _this.columnGrids.forEach(function (muuri) {
                    muuri.refreshItems();
                });
                if (item.getGrid() != _this.item_move_old_grid) { //移出到另一个column中
                    var currentId = item._element.getAttribute('id').replace('item_', '');
                    var i = item.getGrid().getItems().indexOf(item);
                    var previousId = item.getGrid().getItems()[i - 1] ? item.getGrid().getItems()[i - 1]._element.getAttribute('id') : '';
                    var nextId = item.getGrid().getItems()[i + 1] ? item.getGrid().getItems()[i + 1]._element.getAttribute('id') : '';
                    var gridid = _this.item_move_old_grid._element.getAttribute('id').replace('column_content_', '');
                    var groupid = item.getGrid()._element.getAttribute('id').replace('column_content_', '');
                    _this.saveItemOrder(true, currentId, groupid, previousId, nextId);
                    //动态变换选项值
                    var datastemp_1 = _this.datas; //前端缓存数据
                    var itemtemp_1 = datastemp_1[groupid].item[currentId];
                    var getTitle = function (dataid) { return _this.datas_all[dataid] ? _this.datas_all[dataid].title : datastemp_1[dataid].title; }; //是否后端数据，不是则从前端新建的分组拿
                    var title_gridid = getTitle(gridid); //拖动前的值
                    var title_groupid_1 = getTitle(groupid); //拖动后的值
                    //if(itemtemp['statusText'] === title_gridid){//如果拖动前的值和状态值都不一致，说明状态字段并非选择框字段
                    if (_this.fieldsSameSettingWithDefaultTabField) {
                        if (title_gridid == '未分组' && itemtemp_1['statusText'] == '') { //如果是从未分组移动到其他分组
                            // itemtemp['statusText'] = title_groupid;
                            _this.fieldsSameSettingWithDefaultTabField.map(function (item) { return itemtemp_1[item] = title_groupid_1; });
                        }
                        else { //分组间互相移动
                            if (title_groupid_1 == '未分组') {
                                itemtemp_1['statusText'] = '';
                            }
                            else {
                                // itemtemp['statusText'] = title_groupid;
                                _this.fieldsSameSettingWithDefaultTabField.map(function (item) { return itemtemp_1[item] = title_groupid_1; });
                            }
                        }
                    }
                    //}
                    datastemp_1[groupid].item[currentId] = itemtemp_1;
                    _this.datas = __assign({}, datastemp_1);
                    //翻页问题处理
                    var divscroll = document.getElementById("board-column-content-scroll" + gridid);
                    var divHeight = divscroll.clientHeight;
                    if (divHeight < (_this.windowHeight - 190)) {
                        _this.changePage(gridid);
                    }
                }
                else if (_this.item_move_info.length != 0) { //自己column中移动
                    var startD = _this.item_move_info[0];
                    var endD = _this.item_move_info[_this.item_move_info.length - 1];
                    if (startD.fromIndex != endD.toIndex && _this.item_move_start_index != endD.toIndex) {
                        var currentId = item._element.getAttribute('id');
                        var i = item.getGrid().getItems().indexOf(item);
                        var previousId = item.getGrid().getItems()[i - 1] ? item.getGrid().getItems()[i - 1]._element.getAttribute('id') : '';
                        var nextId = item.getGrid().getItems()[i + 1] ? item.getGrid().getItems()[i + 1]._element.getAttribute('id') : '';
                        _this.saveItemOrder(false, currentId, item.getGrid()._element.getAttribute('id'), previousId, nextId);
                    }
                }
                if (_this.item_move_old_grid._element.getAttribute('id') == 'column_content_ungrouped') {
                    _this.ungroupedShowOrHide();
                }
            }).on('move', function (data) {
                _this.item_move_info.push(data);
            }).on('receive', function (data) {
                _this.changeStatus(data);
            }).on('layoutStart', function () {
                _this.boardGrid.refreshItems().layout();
            }).on('dragMove', function (item, event) {
                if (event) {
                    //上下拖动
                    var pElement = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(item.getGrid()._element.parentNode);
                    if (event.center.y + item.getHeight() / 2 > item.getGrid()._top + pElement.scrollTop() + __WEBPACK_IMPORTED_MODULE_1_jquery___default()(pElement).height()) {
                        pElement.scrollTop(pElement.scrollTop() + 20);
                    }
                    if (event.center.y - item.getHeight() / 2 < item.getGrid()._top + pElement.scrollTop()) {
                        pElement.scrollTop(pElement.scrollTop() - 20);
                    }
                    //左右拖动
                    var borderDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#cube_board_container');
                    if ((event.center.x + item.getWidth() / 2) > window.innerWidth) {
                        borderDiv.scrollLeft(borderDiv.scrollLeft() + 20);
                    }
                    if (event.center.x - item.getWidth() / 2 < 0) {
                        borderDiv.scrollLeft(borderDiv.scrollLeft() - 20);
                    }
                }
            });
            if (!isSearch) {
                _this.columnGrids.push(muuri);
                _this.columnGrids_map[container.getAttribute('id')] = muuri;
            }
        };
        /**
         * 初始化查询条件
         */
        this.getConditionInfo = function (customid, callback) {
            _this_1.data_loading = true;
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["h" /* getConditionInfo */]({ "customid": customid }).then(function (_a) {
                var error = _a.error, status = _a.status, conditionInfo = _a.conditionInfo, noRight = _a.noRight;
                if (status == '1') {
                    if (noRight || conditionInfo[0].items.length == 0) {
                        _this_1.isAdvanceSearch = false;
                    }
                    else {
                        _this_1.conditionInfo = conditionInfo;
                        _this_1.form.initFormFields(conditionInfo);
                        _this_1.form.isFormInit = true;
                    }
                    _this_1.qiuckSearch(customid, callback);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this_1.data_loading = false;
            });
        };
        this.changeQuickSearchData = function (domkey) {
            _this_1.quickSearchData.quicksearchinfo.map(function (item) {
                var handleItem = function (item) {
                    if (item.parentDomkey && item.parentDomkey[0] == domkey) {
                        item.value = '';
                        // todo
                        // console.log(this.condition.form.getFormDatas())
                        // const conDatas = this.condition.form.getFormDatas();
                        // if (conDatas[item.domkey[0]]) {
                        //     this.condition.form.$(item.domkey[0]).value = '';
                        // }
                        _this_1.quickSearchFormData[item.domkey[0].split('_')[1]] = '';
                        _this_1.changeQuickSearchData(item.domkey[0]);
                    }
                };
                if (item.hasOwnProperty('searchGroup')) {
                    item.searchGroup.forEach(function (field) {
                        handleItem(field);
                    });
                }
                else {
                    handleItem(item);
                }
            });
        };
        this.getUrlParam = function () {
            var urlParams = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaTools"].getUrlParams();
            var copyparams = {};
            for (var key in urlParams) {
                try {
                    if (key != 'boardid' && key != 'fromPageExpend' && key != 'rootId' && key != '_key' && key != 'remove') {
                        copyparams[key] = decodeURI(urlParams[key]);
                    }
                }
                catch (error) {
                    copyparams[key] = urlParams[key];
                }
            }
            return copyparams;
        };
        this.qiuckSearch = function (customid, callback) {
            var copyparams = _this_1.getUrlParam();
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["g" /* getBoardQuickSearch */](__assign({}, copyparams, { boardid: _this_1.boardid })).then(function (_a) {
                var status = _a.status, error = _a.error, quickSearch = _a.quickSearch, quicksearchparam = _a.quicksearchparam;
                if (status == '1') {
                    // 解决 由于quicksearchinfo中数据未返回value字段，导致value改变未被正常观察到的问题
                    if (quickSearch.quicksearchinfo != undefined && quickSearch.quicksearchinfo.length > 0) {
                        quickSearch.quicksearchinfo.map(function (item) {
                            if (item.searchGroup) {
                                item.searchGroup.map(function (field) {
                                    if (!field.hasOwnProperty('value') && field['fieldhtmltype'] == '5') {
                                        field["value"] = '';
                                    }
                                    return field;
                                });
                            }
                            else if (!item.hasOwnProperty('value')) {
                                // 浏览框
                                if (item['fieldhtmltype'] == '3') {
                                    item["value"] = [];
                                    // 单行文本
                                }
                                else if (item['fieldhtmltype'] == '1') {
                                    item["value"] = '';
                                    // 选择框
                                }
                                else if (item['fieldhtmltype'] == '5') {
                                    item["value"] = '';
                                }
                            }
                            return item;
                        });
                    }
                    _this_1.quickSearchData = quickSearch;
                    _this_1.quickSearchFormData = quicksearchparam;
                    _this_1.quickSearchDataWithNoChange = JSON.stringify(_this_1.clearDefaultValue(quickSearch.quicksearchinfo)); //转换为字符串防止对象修改
                    _this_1.initQuickValue();
                    callback && callback(customid);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        /**
         * @description 看板搜索必填字段拦截
         */
        this.checkRequiredConditionIsFilled = function () {
            var isFilled = true;
            var quickSearchInfo = _this_1.quickSearchData.quicksearchinfo;
            if (quickSearchInfo !== undefined) {
                var advancedSearchInfo = [];
                if (_this_1.conditionInfo.length != 0) { // 高级搜索存在
                    advancedSearchInfo = _this_1.conditionInfo[0].items;
                }
                var searchInfo = quickSearchInfo.concat(advancedSearchInfo);
                var requiredFiledIds_1 = _this_1.quickSearchData.quicksearchinfo.concat(advancedSearchInfo).filter(function (i) { return i['viewAttr'] === 3; }).map(function (i) { return i['fieldid'] || i['domkey'][0]; });
                var prefix_1 = "con_";
                requiredFiledIds_1.forEach(function (element, index) {
                    if (element.indexOf(prefix_1) != -1) {
                        requiredFiledIds_1[index] = element.split("_")[1];
                    }
                });
                //去重
                requiredFiledIds_1 = Array.from(new Set(requiredFiledIds_1));
                if (requiredFiledIds_1.length == 0) {
                    return isFilled;
                }
                var emptyVals_1 = ["", null, undefined, ["0", null, null]];
                if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(searchInfo) && requiredFiledIds_1.length > 0) {
                    _this_1.checkAdvanedData = getLabel(512283, "查询条件/快捷搜索条件有必填字段未填写，请填写后再试！");
                    _this_1.clearBoardData();
                    return !isFilled;
                }
                else {
                    searchInfo.forEach(function (item) {
                        var fieldId = item.fieldid || item['domkey'][0].split("_")[1];
                        var fieldHtmlType = item['fieldhtmltype'];
                        var fieldType = item['fieldtype'];
                        var tempValue = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(item.value);
                        if (tempValue === undefined) {
                            tempValue = _this_1.form.getFormParams()[prefix_1 + fieldId];
                        }
                        // 日期字段默认值设为非指定日期
                        if ((item['conditionType'] === 'DATE' || (fieldHtmlType == 3 && fieldType == 2)) && !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEqual("6", tempValue[0])) {
                            return;
                        }
                        if (requiredFiledIds_1.indexOf(fieldId) != -1
                            && (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.findIndex(emptyVals_1, function (e) { return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEqual(e, tempValue); }) != -1
                                || !Object(__WEBPACK_IMPORTED_MODULE_4__cubeUtil__["checkFormComponentIsFilled"])(fieldHtmlType, fieldType, tempValue))) {
                            // message.error(getLabel(512283, "查询条件/快捷搜索条件有必填字段未填写，请填写后再试！"));
                            _this_1.checkAdvanedData = getLabel(512283, "查询条件/快捷搜索条件有必填字段未填写，请填写后再试！");
                            isFilled = false;
                            _this_1.clearBoardData();
                            return;
                        }
                    });
                }
            }
            return isFilled;
        };
        /**
         * 查询
         */
        this.doSearch = function (params) {
            if (params === void 0) { params = {}; }
            if (_this_1.checkRequiredConditionIsFilled() === false) {
                return;
            }
            _this_1.datas = {};
            _this_1.groupItems = {};
            _this_1.datasIdList = [];
            _this_1.data_loading = true;
            var isQuickSearch1 = false;
            var quickSearchFormData = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.quickSearchFormData);
            if (quickSearchFormData && JSON.stringify(quickSearchFormData) !== '{}') {
                isQuickSearch1 = true;
            }
            var copyparams = _this_1.getUrlParam();
            //...this.quicksearchparam?{isQuickSearch: "1",...this.quicksearchparam}:{},
            // 快捷搜索的默认值带过来
            var defaultQuickConditonData = {};
            __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(_this_1.quickSearchConditionData, function (val, key) {
                var _a;
                var keyWithoutPrefix = key.split("_")[1];
                var obj = (_a = {}, _a[keyWithoutPrefix] = val, _a);
                defaultQuickConditonData = __assign({}, defaultQuickConditonData, obj);
            });
            var obj = __assign({}, defaultQuickConditonData, { 'isQuickSearch': 1 });
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["f" /* getBoardDatas */](__assign({}, obj, copyparams, { isFromSearch: '1', isBoardData: '1', boardid: _this_1.boardid, resourceid: _this_1.resourceid, fromPageExpend: _this_1.fromPageExpend }, _this_1.form.getFormParams(), params, isQuickSearch1 ? __assign({ isQuickSearch: "1" }, _this_1.quickSearchFormData) : {})).then(function (_a) {
                var error = _a.error, status = _a.status, groupIdList = _a.groupIdList, groupMap = _a.groupMap, checkAdvanedData = _a.checkAdvanedData, defaultTabSet = _a.defaultTabSet;
                if (status == '1') {
                    _this_1.checkAdvanedData = checkAdvanedData;
                    _this_1.datas_all = groupMap;
                    __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(groupMap, function (item, key) {
                        _this_1.groupItems[key] = item.itemIdList.slice();
                    });
                    _this_1.constructorFirstPage(groupIdList);
                    _this_1.datasIdList = groupIdList;
                    _this_1.timestamp = new Date().getTime() + '';
                    _this_1.defaultTabSet = defaultTabSet;
                    _this_1.initBoard();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                //this.data_loading = false;
            });
        };
        /**
         * 未分组隐藏\显示
         */
        this.ungroupedShowOrHide = function () {
            var ungroupedGrid;
            if (_this_1.hasRight) {
                ungroupedGrid = _this_1.boardGrid.getItems()[_this_1.boardGrid.getItems().length - 2];
            }
            else {
                ungroupedGrid = _this_1.boardGrid.getItems()[_this_1.boardGrid.getItems().length - 1];
            }
            if (_this_1.columnGrids_map['column_content_ungrouped'].getItems().length > 0 || _this_1.defaultTabSet == "2") {
                _this_1.boardGrid.show(ungroupedGrid);
            }
            else {
                _this_1.boardGrid.hide(ungroupedGrid);
            }
            _this_1.data_loading = false;
        };
        /**
         * 添加分组
         */
        this.addColumn = function (title) {
            var newId = Object(__WEBPACK_IMPORTED_MODULE_4__cubeUtil__["generateUUID"])() + "_new";
            var newStatus = {};
            _this_1.statusList.forEach(function (element) {
                newStatus[element] = 0;
            });
            _this_1.datas[newId] = { id: newId, title: Object(__WEBPACK_IMPORTED_MODULE_4__cubeUtil__["decodeMultiLang"])(title), item: [], itemCount: 0, status: newStatus, itemIdList: [] };
            _this_1.datasIdList.push(newId);
            _this_1.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["a" /* addGroup */]({ boardid: _this_1.boardid, resourceid: _this_1.resourceid, title: title, type: _this_1.type, tempid: newId, fromPageExpend: _this_1.fromPageExpend }).then(function (_a) {
                var error = _a.error, status = _a.status;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].success(getLabel(389172, "分组添加成功！"));
                    _this_1.doSearch();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this_1.loading = false;
            });
        };
        /**
         * 删除Column元素
         */
        this.removeColumn = function (id) {
            var mythis = _this_1;
            __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm({
                title: getLabel(129890, '确定要删除吗?', 'label'),
                okText: getLabel(382958, '确定'),
                okType: 'danger',
                cancelText: getLabel(201, "取消"),
                onOk: function () {
                    mythis.loading = true;
                    var params = {
                        id: id, customid: mythis.customid
                    };
                    __WEBPACK_IMPORTED_MODULE_3__apis_board__["d" /* deleteGroup */](params).then(function (_a) {
                        var error = _a.error, status = _a.status;
                        if (status == '1') {
                            __WEBPACK_IMPORTED_MODULE_2_antd__["message"].success(getLabel(83472, "删除成功！"));
                            mythis.doSearch();
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                            throw error;
                        }
                        mythis.loading = false;
                    });
                }
            });
        };
        /**
         * 移动分组数据
         */
        this.changeGroup = function (fromGroupid, toGroupid, fromTitle, toTile) {
            if (_this_1.columnGrids_map['column_content_' + fromGroupid].getItems().length == 0) {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].warn(getLabel(389173, "当前分组中无数据！"));
                return;
            }
            var mythis = _this_1;
            __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm({
                title: Object(__WEBPACK_IMPORTED_MODULE_4__cubeUtil__["formatMultLang"])(getLabel(389174, "确定要将【{0}】中的数据转移至【{1}】吗？"), fromTitle, toTile),
                okText: getLabel(382958, '确定'),
                okType: 'danger',
                cancelText: getLabel(201, "取消"),
                onOk: function () {
                    //若果是从未分组移动到别处的要把无分组数据的数据整理出来
                    var ids = [];
                    if (fromGroupid == 'ungrouped') {
                        mythis.columnGrids_map.column_content_ungrouped.getItems().forEach(function (item) {
                            var id = item._element.getAttribute('id').replace('item_', '');
                            ids.push(id);
                        });
                        var ungroupedPage = mythis.paginationInfo['ungrouped'];
                        if (ungroupedPage.current < ungroupedPage.total) {
                            var remainIds = mythis.datas_all['ungrouped'].itemIdList.slice((ungroupedPage.current + 1) * mythis.pageSize);
                            remainIds.forEach(function (element) {
                                ids.push(element);
                            });
                        }
                    }
                    var data = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.assign({}, mythis.datas_all[fromGroupid].item, mythis.datas[fromGroupid].item);
                    var filterItems = {};
                    __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.map(mythis.groupItems[fromGroupid], function (item, index) {
                        filterItems[item] = data[item];
                    });
                    __WEBPACK_IMPORTED_MODULE_3__apis_board__["b" /* changeGroup */]({ data: JSON.stringify(filterItems), defaultTabSet: mythis.defaultTabSet, tablename: mythis.tablename, fromGroupid: fromGroupid, toGroupid: toGroupid, boardid: mythis.boardid, customid: mythis.customid, ids: ids.join(',') }).then(function (_a) {
                        var error = _a.error, status = _a.status, msg = _a.msg;
                        if (status == '1') {
                            if (msg) {
                                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].success(msg);
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].success(getLabel(389175, "转移成功！"));
                            }
                            mythis.doSearch();
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                            throw error;
                        }
                        mythis.data_loading = false;
                    });
                }
            });
        };
        /**
         * 添加任务元素（Item元素）
         */
        this.addItem = function (data) {
            _this_1.cardDiag_visible = true;
            _this_1.cardDiag_url = _this_1.addurl.replace('.html', '.jsp') + data.id + "&boardcustomid=" + _this_1.customid;
            if (_this_1.defaultTabSet == "2") {
                _this_1.cardDiag_url = _this_1.cardDiag_url.replace('#{defaultTabField}', data.selectValue);
            }
            // setTimeout(() => {
            //     document.getElementsByClassName('ant-modal')[0]['style'].top='30px';
            // }, 100);
        };
        /**
         * 标题字段点击弹框
         */
        this.cube_board_open_dialog = function (url, id, groupid) {
            url += "&boardid=" + _this_1.boardid + "&boardgroup=" + groupid + "&boardcustomid=" + _this_1.customid;
            _this_1.cardDiag_visible = true;
            _this_1.cardDiag_url = url.replace('.html', '.jsp');
            // setTimeout(() => {
            //     document.getElementsByClassName('ant-modal')[0]['style'].top='30px';
            // }, 100);
        };
        /**
         * 卡片页保存回调函数    iscreate:1新建  2编辑
         */
        this.cardSaveFun = function (billid, iscreate, boardid, boardgroup, boardcustomid, btntype) {
            if (iscreate == '1') { //新增的话异步加载新增的数据。
                // this.data_loading = true;
                // API.getChengedItems({boardid,billid}).then(action(({ error, status,allItem,idList}) => {
                //     if (status == '1') {
                //         idList.forEach((item,index)=>{
                //             boardgroup=allItem[item]['groupid'];
                //             allItem[item]['iscreate']='1';
                //             let status=allItem[item]['status'];
                //             if(this.datas[boardgroup].status[status]!=undefined){
                //                 this.datas[boardgroup].status[status]=this.datas[boardgroup].status[status]+1
                //             }
                //             this.datas[boardgroup].itemCount=this.datas[boardgroup].itemCount+1;
                //             if(!this.datas[boardgroup]['item'])this.datas[boardgroup]['item']={};
                //             this.datas[boardgroup]['item'][item]=allItem[item];
                //             let ids=[item];
                //             this.columnGrids_map['column_content_'+boardgroup].getItems().forEach(item=>{
                //                 const id=item._element.getAttribute('id').replace('item_','');
                //                 ids.push(id);
                //             });
                //             this.datas[boardgroup].itemIdList=ids;
                //         });
                //     } else {
                //         message.error(error);
                //         throw error;
                //     }
                //     this.data_loading = false;
                // }))
                _this_1.doSearch();
            }
            else { //编辑的话由于情况太多，涉及明细就状态等，编辑保存直接刷新
                _this_1.doSearch();
            }
            if (!(btntype && (btntype == '3' || btntype == '4'))) {
                _this_1.cardDiag_visible = false;
            }
        };
        /**
         * 保存任务元素排序,优先排在上一个的下边，或排在下一个的上边，或排在第一个
         */
        this.saveItemOrder = function (isChangeGroup, itemid, groupid, previousId, nextId) {
            itemid = itemid.replace('item_', '');
            previousId = previousId.replace('item_', '');
            nextId = nextId.replace('item_', '');
            groupid = groupid.replace('column_content_', '');
            _this_1.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["k" /* saveItemOrder */]({ boardid: _this_1.boardid, customid: _this_1.customid, resourceid: _this_1.resourceid, reffieldname: _this_1.reffieldname, tablename: _this_1.tablename, isChangeGroup: isChangeGroup, itemid: itemid, groupid: groupid, previousId: previousId, nextId: nextId }).then(function (_a) {
                var error = _a.error, status = _a.status;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].success(getLabel(389171, "排序保存成功！"));
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this_1.loading = false;
            });
        };
        /**
         * 点击排序
         */
        this.changeOrder = function (fieldid, fieldlabelname, fieldname, viewtype, fielddbtype, type) {
            _this_1.orderInfo['fieldid'] = fieldid;
            _this_1.orderInfo['fieldlabelname'] = fieldlabelname;
            _this_1.orderInfo['fieldname'] = fieldname;
            _this_1.orderInfo['viewtype'] = viewtype;
            _this_1.orderInfo['fielddbtype'] = fielddbtype;
            _this_1.orderInfo['type'] = type;
            _this_1.doSearch({ orderFieldName: fieldname, orderType: type, orderViewType: viewtype });
        };
        /**
         * 清除排序信息
         */
        this.clearOrderInfo = function () {
            _this_1.orderInfo = { type: '', fieldid: '' };
            _this_1.doSearch();
        };
        /**
         * 计数状态修改
         */
        this.changeStatus = function (data) {
            var itemId = data.item._element.getAttribute('id').replace('item_', '');
            var fromGroupId = data.fromGrid._element.getAttribute('id').replace('column_content_', '');
            var toGroupId = data.toGrid._element.getAttribute('id').replace('column_content_', '');
            var fromGroup = _this_1.datas[fromGroupId];
            var toGroup = _this_1.datas[toGroupId];
            var item = fromGroup.item[itemId];
            var status = item.status;
            fromGroup.itemCount -= 1;
            fromGroup.status[status] -= 1;
            toGroup.itemCount = toGroup.itemCount ? toGroup.itemCount + 1 : 1;
            toGroup.status[status] += 1;
            if (!toGroup.item) {
                toGroup['item'] = {};
            }
            toGroup.item[itemId] = item;
            __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.remove(_this_1.groupItems[fromGroupId], function (item) { return item == itemId; });
            _this_1.groupItems[toGroupId].push(itemId);
        };
        /**
         * 修改分组名称
         */
        this.updateGroupName = function (groupid, name) {
            _this_1.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["l" /* updateGroupName */]({ groupid: groupid, name: name }).then(function (_a) {
                var error = _a.error, status = _a.status;
                if (status == '1') {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].success(getLabel(83551, "保存成功！"));
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this_1.loading = false;
            });
        };
        /**
         * 查询条件获取后处理
         */
        this.afterConditionInit = function (customid) {
            _this_1.getConditionParams(customid, function (dataSource) {
                var dataSourceParams = {};
                for (var field in dataSource) {
                    if (Array.isArray(dataSource[field])) {
                        dataSourceParams[field] = dataSource[field].join(',');
                    }
                    else if (typeof dataSource[field] == 'object') {
                        dataSourceParams[field] = dataSource[field].value;
                    }
                    else {
                        dataSourceParams[field] = dataSource[field];
                    }
                    //多部门单独处理
                    if (field.startsWith('dbm_con_')) {
                        _this_1.params[field] = dataSourceParams[field];
                    }
                }
                _this_1.getdata();
            });
        };
        /**
         * 查询查询列表查询条件默认值设置
         */
        this.getConditionParams = function (customid, callback) {
            var copyparams = _this_1.getUrlParam();
            __WEBPACK_IMPORTED_MODULE_3__apis_board__["i" /* getConditionParams */](__assign({}, copyparams, { "customid": customid })).then(function (_a) {
                var error = _a.error, status = _a.status, dataSource = _a.dataSource;
                if (status == '1') {
                    var newDataSource = __assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this_1.params), dataSource);
                    var otherData = {};
                    for (var field in newDataSource) {
                        if (_this_1.form.has(field)) {
                            if (Array.isArray(dataSource[field])) {
                                var _field = _this_1.form.select(field);
                                _field.set(dataSource[field]);
                            }
                            else {
                                otherData[field] = dataSource[field];
                            }
                        }
                    }
                    _this_1.form.updateFields(otherData, false);
                    callback && callback(newDataSource);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.clearDefaultValue = function (datas) {
            if (datas === void 0) { datas = []; }
            var resetToEmpty = function (item) {
                var fieldhtmltype = item.fieldhtmltype, fieldtype = item.fieldtype, _a = item.value, value = _a === void 0 ? '' : _a;
                if ((fieldhtmltype == '1' && fieldtype != '1') //数值类型
                    || (fieldhtmltype == '5' && fieldtype == '1') //下拉框
                    || (fieldhtmltype == '4' && fieldtype == '1') //勾选框
                    || (fieldhtmltype == '5' && fieldtype == '2') //多选框
                    || (fieldhtmltype == '5' && fieldtype == '3') //单选框
                ) {
                    if (fieldhtmltype == '1' && fieldtype != '1') {
                        item.value = '-1';
                    }
                    else {
                        item.value = '';
                    }
                }
                else if (fieldhtmltype == '3' && fieldtype == '1') { //人员 ["-5",""]||[]
                    if (value[0] == '-5') { //全部 ["0", null]
                        item.value = ["-5", ""];
                    }
                    else {
                        item.value = ["0"];
                    }
                }
                else if (fieldhtmltype == '3' && fieldtype == '2') { //创建日期
                    item.value = ["0"];
                }
                else if (item.hasOwnProperty('replaceDatas')) {
                    item.replaceDatas = [];
                }
                else {
                    item.value = '';
                }
                return item;
            };
            var res = datas.map(function (data) {
                if (data.hasOwnProperty('searchGroup')) {
                    data.searchGroup = data.searchGroup.map(function (item) {
                        return resetToEmpty(item);
                    });
                }
                else {
                    data = resetToEmpty(data);
                }
                return data;
            });
            return res;
        };
        this.initQuickValue = function () {
            _this_1.quickSearchData.quicksearchinfo && _this_1.quickSearchData.quicksearchinfo.map(function (item) {
                var setItem = function (item) {
                    var value;
                    var fieldhtmltype = item.fieldhtmltype, fieldtype = item.fieldtype;
                    if (fieldhtmltype == '1') {
                        if (fieldtype == '1' && item.value) {
                            value = item.value;
                        }
                        if (['2', '3', '4', '5'].indexOf(fieldtype) > -1) { //数值
                            var selectArr = item.options.filter(function (opt) { return opt.selected == true; });
                            if (selectArr.length > 0) {
                                value = selectArr[0].key;
                                item.value = value; //暂时在前端改，后期需要后端返回value
                            }
                        }
                    }
                    else if (fieldhtmltype == '3') {
                        var isHrm = fieldtype == '1' || ('1' == item.conditiontransition && '17' == fieldtype);
                        if (isHrm || ['2', '19', '290'].indexOf(fieldtype) > -1) { //人力资源和日期等
                            if (item.value) {
                                value = item.value;
                            }
                        }
                        else {
                            if (item.replaceDatas) {
                                value = item.replaceDatas.reduce(function (pre, current, c, d) { return pre ? pre + "," + current.id : current.id; }, '');
                            }
                        }
                    }
                    else if ((fieldhtmltype == '5' && ['1', '2', '3'].indexOf(fieldtype) > -1) || (fieldhtmltype == '4' && fieldtype == '1')) { //选择框、勾选框等
                        var selectArr = item.options.filter(function (opt) { return opt.selected == true; });
                        if (selectArr.length > 0) {
                            value = selectArr[0].key;
                        }
                    }
                    return value;
                };
                if (item.hasOwnProperty('searchGroup')) {
                    item.searchGroup.map(function (groupItem) {
                        var value = setItem(groupItem);
                        if (value) {
                            __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.set(_this_1.quickSearchFormData, groupItem.fieldid, value);
                        }
                    });
                }
                else {
                    var value = setItem(item);
                    if (value) {
                        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.set(_this_1.quickSearchFormData, item.fieldid, value);
                    }
                }
            });
        };
        this.changeConditioninfo = function (fieldid, v) {
            _this_1.conditionInfo[0] && _this_1.conditionInfo[0].items && _this_1.conditionInfo[0].items.map(function (item) {
                var domkey = item.domkey;
                if (domkey[0] == "con_" + fieldid) {
                    _this_1.form.$("con_" + fieldid).set(v);
                }
            });
        };
        this.changeConditioninfoForBrowser = function (fieldid, ids, data, valueSpan) {
            _this_1.conditionInfo[0] && _this_1.conditionInfo[0].items && _this_1.conditionInfo[0].items.map(function (item) {
                var domkey = item.domkey;
                if (domkey[0] == "con_" + fieldid) {
                    _this_1.form.$("con_" + fieldid).value = ids;
                    _this_1.form.$("con_" + fieldid).valueObj = data;
                    _this_1.form.$("con_" + fieldid).valueSpan = valueSpan;
                }
            });
        };
    }
    /**
     * 清空看板数据
     */
    BoardStore.prototype.clearBoardData = function () {
        var _this_1 = this;
        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(this.datas_all, function (value, key) {
            _this_1.datas_all[key].itemCount = 0;
            _this_1.datas_all[key].item = {};
        });
        this.constructorFirstPage(Object.keys(this.datas_all));
        setTimeout(function () {
            _this_1.initBoard();
        }, 100);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "windowHeight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "windowWidth", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "timestamp", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "boardid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "resourceid", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "type", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "defaultTabSet", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "isTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "canAdd", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "datasIdList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "statusList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "datas_all", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "groupItems", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "datas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "orderField", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "isAdvanceSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "orderInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "data_loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "item_loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "conditionInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "quickSearchData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "quicksearchparam", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "quickSearchFormData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "quickSearchDataWithNoChange", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "iconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "isScroll", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "cardDiag_visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "cardDiag_url", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "hasRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "hasSearcgRight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "checkAdvanedData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], BoardStore.prototype, "fieldsSameSettingWithDefaultTabField", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "initData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "getIconInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "setQuickSearchInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "constructorFirstPage", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "initBoard", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "getConditionInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "changeQuickSearchData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "qiuckSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "doSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "changeGroup", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "addItem", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "cardSaveFun", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "changeOrder", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "changeStatus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "afterConditionInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "getConditionParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "changeConditioninfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], BoardStore.prototype, "changeConditioninfoForBrowser", void 0);
    return BoardStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (BoardStore);


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getBoardDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBoardQuickSearch; });
/* unused harmony export getIdByCondition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return saveGroupOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return saveItemOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getConditionInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAppInfoByID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateGroupName; });
/* unused harmony export getChengedItems */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getConditionParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var newUrl = '/api/cube/board/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                resolve(__assign({ noRight: noRight }, data));
            }
            else {
                resolve(data);
            }
        });
    });
};
var getBoardDatas = function (params) {
    return CallAPI(newUrl + "getBoardDatas", "get", params);
};
var getBoardQuickSearch = function (params) {
    return CallAPI(newUrl + "getBoardQuickSearch", "get", params);
};
var getIdByCondition = function (params) {
    return CallAPI(newUrl + "getIdByCondition", "get", params);
};
var saveGroupOrder = function (params) {
    return CallAPI(newUrl + "saveGroupOrder", "post", params);
};
var addGroup = function (params) {
    return CallAPI(newUrl + "addGroup", "post", params);
};
var deleteGroup = function (params) {
    return CallAPI(newUrl + "deleteGroup", "post", params);
};
var saveItemOrder = function (params) {
    return CallAPI(newUrl + "saveItemOrder", "post", params);
};
var getConditionInfo = function (params) {
    return CallAPI("/api/cube/search/condition", "get", params);
};
var getAppInfoByID = function (params) {
    return CallAPI(newUrl + "mode/app/getAppInfoByID", "GET", params);
};
var checkRight = function (params) {
    return CallAPI(newUrl + "checkRight", "get", params);
};
var updateGroupName = function (params) {
    return CallAPI(newUrl + "updateGroupName", "post", params);
};
var getChengedItems = function (params) {
    return CallAPI(newUrl + "getChengedItems", "get", params);
};
var changeGroup = function (params) {
    return CallAPI(newUrl + "changeGroup", "post", params);
};
var getConditionParams = function (params) {
    return CallAPI("/api/cube/search/getConditionParams", "get", params);
};


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_mindMap__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__card_actions__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cubeUtil__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(7);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




// import { WeaLocaleProvider } from 'ecCom';
// const getLabel = WeaLocaleProvider.getLabel;






var getLength = function (str) {
    var realLength = 0, len = str.length, charCode = -1;
    for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128)
            realLength += 1;
        else
            realLength += 2;
    }
    return realLength;
};
var getSubStr = function (str, start, length) {
    var rt = [], currentLength = 0, len = str.length, charCode = -1;
    for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) {
            currentLength++;
        }
        else {
            currentLength += 2;
        }
        if (currentLength > start && currentLength <= length) {
            rt.push(str.charAt(i));
        }
    }
    return rt.join('');
};
var getShortStr = function (ele, data, w, fontSize) {
    if (w === void 0) { w = 100; }
    if (fontSize === void 0) { fontSize = 12; }
    var tempDiv = document.createElement('div');
    tempDiv.style.display = "inline-block";
    tempDiv.style.fontSize = fontSize + "px";
    tempDiv.innerHTML = data;
    document.body.appendChild(tempDiv);
    var le = tempDiv.offsetWidth;
    document.body.removeChild(tempDiv);
    var oneCharLen = Math.ceil(le / getLength(data));
    var length = Math.floor(w / oneCharLen);
    var datalength = data ? getLength(data) : 0;
    if (length >= datalength) {
        return data;
    }
    return getSubStr(data, 0, length - 3) + '...';
};
var MindMapStore = /** @class */ (function () {
    function MindMapStore() {
        var _this = this;
        this.rootDatas = {};
        this.loading = false;
        this.windowTitle = '';
        this.width = window.document.body.offsetWidth - 4;
        this.height = window.document.body.offsetHeight - 4;
        this.isFirstInit = true; //是否第一次渲染图形
        this.nodeWidth = 220;
        this.nodeHeight = 80;
        //右键相关
        this.rightMenuTop = 0;
        this.rightMenuLeft = 0;
        this.rightMenuVisible = false;
        //右键相关
        this.Actions = new __WEBPACK_IMPORTED_MODULE_5__card_actions__["a" /* default */](this);
        this.clearAll = function () {
            //清空所有子节点
            var d3 = window['d3'];
            var mindMapContainer = d3.select('#mindMapContainer');
            if (mindMapContainer) {
                mindMapContainer.selectAll("svg > *").remove();
            }
            _this.rootId = "";
        };
        this.init = function (mindMapId) {
            var query = __WEBPACK_IMPORTED_MODULE_8__util__["default"].weaHistory.getCurrentLocation().query;
            var d3 = window['d3'];
            var mindMapContainer = d3.select('#mindMapContainer').attr('width', _this.width).attr('height', _this.height).attr('transform', d3.zoomIdentity).append("g");
            _this.gNode = mindMapContainer.append("g").attr('id', 'nodeGroup');
            _this.gLink = mindMapContainer.append('g').attr('id', 'nodePath');
            _this.isFirstInit = true;
            _this.loading = true;
            if (mindMapId) {
                _this.mindMapId = mindMapId;
            }
            __WEBPACK_IMPORTED_MODULE_1__apis_mindMap__["b" /* getMindInfoAndNodeStyle */]({ mindMapid: _this.mindMapId, rootid: _this.rootId, isold: _this.otherParam.isold }).then(function (_a) {
                var error = _a.error, status = _a.status, info = _a.info, nodeStyle = _a.nodeStyle, rootid = _a.rootid, mindMapid = _a.mindMapid;
                if (status == '1') {
                    if (!_this.isshowroot)
                        _this.isshowroot = info.isshowroot;
                    if (query['level'] > 0) {
                        _this.level = query['level'];
                    }
                    else {
                        if (!_this.level)
                            _this.level = info.defaultexpenddepth || 0;
                        //qc#813014
                        if (_this.level != info.defaultexpenddepth)
                            _this.level = info.defaultexpenddepth || 0;
                    }
                    _this.nodeStyle = nodeStyle;
                    if (rootid)
                        _this.rootId = rootid; //rootId在只有一个节点的情况下支持只传递数据id
                    _this.mindMapId = mindMapid;
                    _this.loadData();
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
            });
            d3.select('#mindMapContainer').call(d3.zoom().scaleExtent([1 / 10, 10]).on("zoom", function () { mindMapContainer.attr("transform", d3.event.transform.toString()); }));
            window.focus();
        };
        this.loadData = function (node) {
            var type = 'root'; //root:根节点 rootid:传rootid参数的根节点 node:点击节点加载
            var pid = '';
            if (node) { //分支节点
                pid = node.data.id;
                type = 'node';
            }
            else if (_this.rootId && !node) {
                pid = _this.rootId;
                type = 'rootid';
            }
            var d3 = window['d3'];
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__apis_mindMap__["a" /* getDatas */](__assign({}, _this.otherParam, { id: _this.mindMapId, pid: pid, type: type, level: _this.level })).then(function (_a) {
                var error = _a.error, status = _a.status, tlist = _a.tlist, levelDatas = _a.levelDatas, windowTitle = _a.windowTitle, noRight = _a.noRight;
                if (status == '1') {
                    if (noRight) {
                        __WEBPACK_IMPORTED_MODULE_8__util__["default"].weaHistory.push('/main/cube/encrypt');
                    }
                    if (!Object(__WEBPACK_IMPORTED_MODULE_7__util_cubeUtil__["g" /* isFromProtal */])()) {
                        _this.windowTitle = windowTitle;
                    }
                    if (type != 'node' && parseInt(_this.level) > 0) {
                        _this.rootDatas = levelDatas;
                        _this.rootDatas.name = _this.replaceParam(Object(__WEBPACK_IMPORTED_MODULE_6__cubeUtil__["decodeMultiLang"])(_this.rootDatas.name));
                    }
                    else {
                        if (type != 'node') {
                            var name_1 = '';
                            var id_1 = '';
                            var childNum_1 = 0;
                            tlist.forEach(function (item) {
                                name_1 = item['name'];
                                id_1 = item['id'];
                                childNum_1 = item['childNum'];
                            });
                            _this.rootDatas['name'] = _this.replaceParam(Object(__WEBPACK_IMPORTED_MODULE_6__cubeUtil__["decodeMultiLang"])(name_1));
                            _this.rootDatas['id'] = id_1;
                            _this.rootDatas['childNum'] = childNum_1;
                        }
                        else {
                            node.data['children'] = tlist;
                            node.data['_children'] = tlist;
                        }
                    }
                    _this.root = d3.hierarchy(_this.rootDatas);
                    _this.root.descendants().forEach(function (d, i) {
                        d.id = i;
                        d._children = d.children;
                    });
                    _this.root.x0 = 0;
                    _this.root.y0 = 0;
                    if (node) {
                        _this.updateNode(node);
                    }
                    else {
                        _this.updateNode(_this.root);
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
            });
        };
        this.replaceParam = function (str) {
            if (_this.otherParam) {
                __WEBPACK_IMPORTED_MODULE_3_lodash__["keys"](_this.otherParam).forEach(function (item) {
                    str = str.replace(new RegExp("\\$" + item + "\\$", "g"), _this.otherParam[item]);
                });
            }
            return str;
        };
        this.updateNode = function (sourceNode) {
            var d3 = window['d3'];
            _this.nodes = _this.root.descendants();
            _this.links = _this.root.links();
            var leftDeviation = _this.nodeWidth;
            if (_this.isshowroot == '0') {
                var rootid_1 = "0_0";
                if (_this.rootId) {
                    rootid_1 = _this.rootId;
                }
                _this.nodes = _this.nodes.filter(function (e) {
                    return e.data.id == rootid_1 ? false : true;
                });
                _this.links = _this.links.filter(function (e) {
                    return e.source.data.id == rootid_1 ? false : true;
                });
                leftDeviation = _this.nodeWidth * 2;
            }
            var tree = d3.tree().nodeSize([_this.nodeHeight + 20, _this.nodeWidth + 80]);
            tree(_this.root); //计算x及y赋予this.root
            var left = _this.root;
            var right = _this.root;
            _this.root.eachBefore(function (node) {
                if (node.y < left.y)
                    left = node;
                if (node.y > right.y)
                    right = node;
            });
            //动画效果
            var transition = d3.select('#mindMapContainer').transition().duration(500);
            if (_this.isFirstInit) {
                d3.select('#mindMapContainer').attr("viewBox", (-(_this.width - (right.y - left.y)) / 2 + leftDeviation) + "," + (-_this.height / 2) + "," + _this.width + "," + _this.height);
            }
            //节点处理
            var node = _this.gNode.selectAll("g").data(_this.nodes, function (d) { return d.data.id; });
            var nodeEnter = node.enter().append('g').attr("transform", function (d) { return "translate(" + sourceNode.y0 + "," + sourceNode.x0 + ")"; }).on("click", function (d) {
                if (!d.data.childNum)
                    return;
                d.children = d.children ? null : d._children;
                if (d.depth >= _this.level)
                    d.data.children = d.data.children ? null : d.data._children;
                if (d.data.isloaded && d.data.childNum != 0 && !d.children && !d._children)
                    d.data.isloaded = false;
                if (d.data.isloaded) {
                    _this.updateNode(d);
                }
                else {
                    _this.loadData(d);
                    d.data['isloaded'] = true;
                }
            });
            _this.constructNodeDom(nodeEnter);
            node.merge(nodeEnter).transition(transition).attr("transform", function (d) { return "translate(" + d.y + "," + d.x + ")"; }).attr("fill-opacity", 1).attr("stroke-opacity", 1);
            node.exit().transition(transition).remove().attr("transform", function (d) { return "translate(" + sourceNode.y + "," + sourceNode.x + ")"; }).attr("fill-opacity", 0).attr("stroke-opacity", 0);
            //连线处理
            _this.gLink.attr("fill", "none").attr("stroke", "#555").attr("stroke-opacity", 0.4).attr("stroke-width", 1.5);
            var link = _this.gLink.selectAll("path").data(_this.links, function (d) { return d.target.data.id; });
            var diagonal = d3.linkHorizontal().x(function (d) { return d.y; }).y(function (d) { return d.x; });
            var linkEnter = link.enter().append('path').attr('d', function (d) {
                var o = { x: sourceNode.x0 + _this.nodeHeight / 2, y: sourceNode.y0 };
                return diagonal({ source: o, target: o });
            });
            link.merge(linkEnter).transition(transition).attr("d", function (d) {
                return diagonal({ source: { x: d.source.x + _this.nodeHeight / 2, y: d.source.y + _this.nodeWidth }, target: { x: d.target.x + _this.nodeHeight / 2, y: d.target.y } });
            });
            link.exit().transition(transition).remove().attr("d", function (d) {
                var o = { x: sourceNode.x + _this.nodeHeight / 2, y: sourceNode.y };
                return diagonal({ source: o, target: o });
            });
            // Stash the old positions for transition.
            _this.root.eachBefore(function (d) {
                d.x0 = d.x;
                d.y0 = d.y;
            });
            _this.isFirstInit = false;
        };
        //获取右键按钮
        this.getRightContextMenu = function (d) {
            var e = window.event;
            // this.loading = true;
            // API.getRightMenus({id:d.data.id}).then(({ error, status,rightMenus,urlMap,confirmMap}) => {
            //     if (status == '1') {
            //         console.log('right',rightMenus,urlMap,confirmMap);
            //         this.rightMenuLeft=e.clientX;
            //         this.rightMenuTop=e.clientY;
            //         this.rightMenuVisible=true;
            //     } else {
            //         message.error(error);
            //         throw error;
            //     }
            //     this.loading = false;
            // });
            e.preventDefault();
        };
        this.getFontHeight = function (fontSize) {
            var h = 0;
            if (fontSize >= 10 && fontSize <= 13) {
                h = fontSize + 4;
            }
            else if (fontSize >= 14 && fontSize <= 17) {
                h = fontSize + 5;
            }
            else if (fontSize >= 18 && fontSize <= 20) {
                h = fontSize + 6;
            }
            return h - 4;
        };
        this.constructNodeDom = function (nodeEnter) {
            nodeEnter.append('rect').attr('width', _this.nodeWidth).attr('height', _this.nodeHeight).attr('fill', '#ffffff').attr('rx', 5).attr('ry', 5).attr('stroke-width', 1).attr('stroke', 'rgb(216, 216, 220)').on('contextmenu', _this.getRightContextMenu);
            var w = 190;
            //配置过节点信息的
            __WEBPACK_IMPORTED_MODULE_3_lodash__["keys"](_this.nodeStyle).forEach(function (nodeid) {
                _this.nodeStyle[nodeid].forEach(function (element) {
                    //配置的字段等于分支节点显示字段，添加链接
                    nodeEnter.data(_this.nodes.filter(function (d) {
                        return d.data.nodeid == nodeid && element['fieldName'] == d.data.showfield;
                    }), function (d) { return d.data.id; }).append("a").attr("onclick", function (d) { return "window['cube_mindMap_titleCilck']('" + d.data.id + "')"; }).attr('onmouseover', "this.getElementsByTagName('text')[0].setAttribute('fill','#017afd')").attr('onmouseout', "this.getElementsByTagName('text')[0].setAttribute('fill','" + element.fontColor + "')").append("text").attr("transform", function (d) {
                        var positionY = element['positionY'];
                        positionY += _this.getFontHeight(element['fontSize']);
                        return "translate(" + element['positionX'] + "," + positionY + ")";
                    }).text(function (d) { return getShortStr(_this, d.data.styleFields[element['fieldName']], w - element['positionX'], element['fontSize']); }).attr('style', "font-size:" + element['fontSize'] + "px;").attr('fill', element['fontColor']).on('contextmenu', _this.getRightContextMenu).append('title').text(function (d) { return d.data.styleFields[element['fieldName']]; });
                    //配置的字段不等于分支节点显示字段
                    nodeEnter.data(_this.nodes.filter(function (d) {
                        return d.data.nodeid == nodeid && element['fieldName'] != d.data.showfield;
                    }), function (d) { return d.data.id; }).append("text").attr("transform", function (d) {
                        var positionY = element['positionY'];
                        positionY += _this.getFontHeight(element['fontSize']);
                        return "translate(" + element['positionX'] + "," + positionY + ")";
                    }).text(function (d) { return getShortStr(_this, d.data.styleFields[element['fieldName']], w - element['positionX'], element['fontSize']); }).attr('style', "font-size:" + element['fontSize'] + "px;").attr('fill', element['fontColor']).on('contextmenu', _this.getRightContextMenu).append('title').text(function (d) { return d.data.styleFields[element['fieldName']]; });
                });
            });
            //未配置过节点信息的
            var unSettingNodeEnter = nodeEnter.data(_this.nodes.filter(function (element) { return !_this.nodeStyle[element.data.nodeid]; }), function (d) { return d.data.id; });
            unSettingNodeEnter.append("a").attr("onclick", function (d) { return "window['cube_mindMap_titleCilck']('" + d.data.id + "')"; }).attr('onmouseover', "this.getElementsByTagName('text')[0].setAttribute('fill','#017afd')").attr('onmouseout', "this.getElementsByTagName('text')[0].setAttribute('fill','')").
                append("text").attr("transform", function (d) { return "translate(10,22)"; }).text(function (d) { return getShortStr(_this, d.data.name ? d.data.name : "", w); }).on('contextmenu', _this.getRightContextMenu).append('title').text(function (d) { return d.data.name; });
            unSettingNodeEnter.append("text").attr("transform", function (d) { return "translate(10,62)"; }).text(function (d) { return d.data.modedatacreater; }).attr('fill', '#8a8a8a').on('contextmenu', _this.getRightContextMenu);
            unSettingNodeEnter.append("text").attr("transform", function (d) { return "translate(120,62)"; }).text(function (d) { return d.data.modedatacreatedate; }).attr('fill', '#8a8a8a').on('contextmenu', _this.getRightContextMenu);
            //子节点个数
            nodeEnter.data(_this.nodes.filter(function (d) { return d.data.childNum; }), function (d) { return d.data.id; }).append("rect").attr('width', 0).attr('height', 0).attr('rx', 5).attr('ry', 5).attr('fill', '#017afd').attr("id", function (d) { return "childNumRect" + d.data.id; }).attr("transform", function (d) { return "translate(188,21)"; }).on('contextmenu', _this.getRightContextMenu);
            nodeEnter.data(_this.nodes.filter(function (d) { return d.data.childNum; }), function (d) { return d.data.id; }).append("text").attr("id", function (d) { return "childNum" + d.data.id; }).text(function (d) { return d.data.childNum; }).attr('fill', 'white').attr("transform", function (d) { return "translate(190,35)"; }).on('contextmenu', _this.getRightContextMenu);
            //子节点个数，数字添加背景色
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()("rect[id^='childNumRect']").each(function (i, element) {
                var numElement = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#' + element.id.replace('childNumRect', 'childNum'))[0];
                var SVGRect = numElement.getBBox();
                if (SVGRect.width)
                    element.setAttribute('width', SVGRect.width + 4);
                if (SVGRect.height)
                    element.setAttribute('height', SVGRect.height + 3);
            });
        };
        this.titleClick = function (nodeid) {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__apis_mindMap__["c" /* getNodeHref */]({ id: _this.mindMapId, pid: nodeid }).then(function (_a) {
                var error = _a.error, status = _a.status, href = _a.href;
                if (status == '1') {
                    href = Object(__WEBPACK_IMPORTED_MODULE_6__cubeUtil__["decodeMultiLang"])(href);
                    if (nodeid = '0_0') {
                        href = _this.replaceParam(href);
                    }
                    if (href)
                        window.open(href);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
            });
            var e = window.event || arguments.callee.caller.arguments[0];
            e.stopPropagation();
        };
        this.changeLevel = function (value) {
            _this.level = value;
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "rootDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "mindMapId", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "rootId", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "level", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "isshowroot", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "rightMenuTop", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "rightMenuLeft", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], MindMapStore.prototype, "rightMenuVisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindMapStore.prototype, "clearAll", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindMapStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindMapStore.prototype, "loadData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindMapStore.prototype, "updateNode", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], MindMapStore.prototype, "changeLevel", void 0);
    return MindMapStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (MindMapStore);


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNodeHref; });
/* unused harmony export getRightMenus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMindInfoAndNodeStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var newUrl = '/api/cube/mindMap/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                resolve(__assign({ noRight: noRight }, data));
            }
            else {
                resolve(data);
            }
        });
    });
};
var getDatas = function (params) {
    return CallAPI(newUrl + "datas", "get", params);
};
var getNodeHref = function (params) {
    return CallAPI(newUrl + "getNodeHref", "get", params);
};
var getRightMenus = function (params) {
    return CallAPI(newUrl + "getRightMenus", "get", params);
};
var getMindInfoAndNodeStyle = function (params) {
    return CallAPI(newUrl + "getMindInfoAndNodeStyle", "get", params);
};


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__electricSignStore__ = __webpack_require__(770);

/* harmony default export */ __webpack_exports__["a"] = ({
    ElectricSign: new __WEBPACK_IMPORTED_MODULE_0__electricSignStore__["a" /* default */](),
});


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_dev__ = __webpack_require__(771);
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var ElectricSignStore = /** @class */ (function () {
    function ElectricSignStore() {
        var _this = this;
        this.loading = true;
        this.signType = '1';
        this.companyname = '';
        this.companyvisible = false;
        this.selectedFile = "";
        this.selectedFileData = {};
        this.refresh = 0;
        this.companys = [];
        this.init = function () {
            Object(__WEBPACK_IMPORTED_MODULE_4__apis_dev__["b" /* getCompanys */])({}).then(function (result) {
                if (result.status == "1" && result.data && result.data.length > 0) {
                    _this.companys = result.data;
                    _this.companys.map(function (com) {
                        if (com.selected) {
                            _this.companyname = com.showname;
                        }
                    });
                    if (_this.companyname == '') {
                        _this.companyname = _this.companys[0].showname;
                    }
                }
            });
        };
        this.getOptions = function () {
            var options = new Array();
            _this.companys.map(function (com) {
                options.push({ key: com.key, showname: com.showname, selected: com.selected });
            });
            return options;
        };
        this.updateParams = function (params) {
            var temp = !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["toJS"])(_this.params), params);
            _this.params = params;
            if (temp) {
                _this.refresh += 1;
            }
        };
        this.changeSignType = function (value) {
            _this.signType = value;
            if (value == '2') {
                _this.companyvisible = true;
            }
            else {
                _this.companyvisible = false;
            }
        };
        this.getShowListDatas = function (__, newData) {
            if (newData && newData.length == 1) {
                _this.selectedFile = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(newData, '[0].name');
                _this.selectedFileData = { filename: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(newData, '[0].name'), fileid: "-999", size: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(newData, '[0].size') };
            }
            else {
                _this.selectedFile = "";
            }
        };
        this.deleteFile = function () {
            var that = _this;
            __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm({
                title: '系统提示',
                content: '你确认删除该待上传文件吗？',
                onOk: function () {
                    that.selectedFile = "";
                    that.selectedFileData = {};
                    that.refresh += 1;
                },
                onCancel: function () {
                },
            });
        };
        this.toSign = function () {
            if (_this.signType == '2' && _this.companyname == '') {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("企业名称不能为空!");
                return;
            }
            __WEBPACK_IMPORTED_MODULE_3__util__["default"].startUploadAll();
        };
        this.uploadChange = function (ids, list) {
            if (ids && ids.length == 1) {
                var excelid = ids[0];
                var filename = list[0].filename;
                filename = filename.replace(/\..*/g, '');
                var params = {
                    fieldid: excelid,
                    filename: filename,
                    signtype: _this.signType,
                    companyname: _this.companyname
                };
                //附件上传成功去签章
                Object(__WEBPACK_IMPORTED_MODULE_4__apis_dev__["a" /* createContract */])(params).then(function (data) {
                    if (data.status == "1" && data.url) {
                        __WEBPACK_IMPORTED_MODULE_3__util__["default"].openFullWindowHaveBar(data.url);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].error({
                            title: "创建失败",
                            width: 500,
                            content: React.createElement("div", { style: { maxHeight: 600, overflowY: 'auto' } },
                                React.createElement("div", { dangerouslySetInnerHTML: { __html: "创建签章文件发生错误" } })),
                            onOk: function () { },
                        });
                    }
                });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error("文件上传失败！");
            }
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "params", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "signType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "companyname", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "companyvisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "selectedFile", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "selectedFileData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "refresh", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], ElectricSignStore.prototype, "companys", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ElectricSignStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ElectricSignStore.prototype, "updateParams", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ElectricSignStore.prototype, "changeSignType", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ElectricSignStore.prototype, "getShowListDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ElectricSignStore.prototype, "deleteFile", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ElectricSignStore.prototype, "toSign", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], ElectricSignStore.prototype, "uploadChange", void 0);
    return ElectricSignStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (ElectricSignStore);


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCompanys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

// import window from '../util';
var newUrl = '/api/cube/dev/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                // reject();
                // window.weaHistory.push('/main/cube/noright');
                resolve(__assign({ noRight: noRight }, data));
            }
            else {
                resolve(data);
            }
        });
    });
};
var createContract = function (params) {
    return CallAPI(newUrl + "electricsign/createContract", "get", params);
};
var getCompanys = function (params) {
    return CallAPI(newUrl + "electricsign/getCompanys", "get", params);
};


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_timeline__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var Base64 = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"].Base64;
var TimelineStore = /** @class */ (function () {
    function TimelineStore() {
        var _this = this;
        this.loading = false;
        this.param = {}; //展板id
        this.name = '';
        this.hasData = true;
        this.maxHeight = 0;
        this.init = function () {
            var vis = window['vis'];
            var moment = window['moment'];
            var template = window['template'];
            template.get = function (source) {
                return template.compile(source, {
                    filename: 'zengh'
                });
            };
            var container = document.getElementById('cube_timeline_container');
            moment.locale('zh-cn', {
                months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
                weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                longDateFormat: {
                    LT: 'HH:mm',
                    LTS: 'HH:mm:ss',
                    L: 'YYYY-MM-DD',
                    LL: 'YYYY年MM月DD日',
                    LLL: 'YYYY年MM月DD日Ah点mm分',
                    LLLL: 'YYYY年MM月DD日ddddAh点mm分',
                    l: 'YYYY-M-D',
                    ll: 'YYYY年M月D日',
                    lll: 'YYYY年M月D日 HH:mm',
                    llll: 'YYYY年M月D日dddd HH:mm'
                },
                meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                meridiemHour: function (hour, meridiem) {
                    if (hour === 12) {
                        hour = 0;
                    }
                    if (meridiem === '凌晨' || meridiem === '早上' ||
                        meridiem === '上午') {
                        return hour;
                    }
                    else if (meridiem === '下午' || meridiem === '晚上') {
                        return hour + 12;
                    }
                    else {
                        // '中午'
                        return hour >= 11 ? hour : hour + 12;
                    }
                },
                meridiem: function (hour, minute, isLower) {
                    var hm = hour * 100 + minute;
                    if (hm < 600) {
                        return '凌晨';
                    }
                    else if (hm < 900) {
                        return '早上';
                    }
                    else if (hm < 1130) {
                        return '上午';
                    }
                    else if (hm < 1230) {
                        return '中午';
                    }
                    else if (hm < 1800) {
                        return '下午';
                    }
                    else {
                        return '晚上';
                    }
                },
                calendar: {
                    sameDay: '[今天]LT',
                    nextDay: '[明天]LT',
                    nextWeek: '[下]ddddLT',
                    lastDay: '[昨天]LT',
                    lastWeek: '[上]ddddLT',
                    sameElse: 'L'
                },
                dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
                ordinal: function (number, period) {
                    switch (period) {
                        case 'd':
                        case 'D':
                        case 'DDD':
                            return number + '日';
                        case 'M':
                            return number + '月';
                        case 'w':
                        case 'W':
                            return number + '周';
                        default:
                            return number;
                    }
                },
                relativeTime: {
                    future: '%s内',
                    past: '%s前',
                    s: '几秒',
                    ss: '%d秒',
                    m: '1分钟',
                    mm: '%d分钟',
                    h: '1小时',
                    hh: '%d小时',
                    d: '1天',
                    dd: '%d天',
                    M: '1个月',
                    MM: '%d个月',
                    y: '1年',
                    yy: '%d年'
                },
                week: {
                    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
                    dow: 1,
                    doy: 4 // The week that contains Jan 4th is the first week of the year.
                }
            });
            var options = {
                locales: {
                    // create a new locale (text strings should be replaced with localized strings)
                    mylocale: {
                        current: 'zh-cn',
                        time: 'time',
                    }
                },
                // use the new locale
                locale: 'mylocale',
                verticalScroll: true,
            };
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis_timeline__["a" /* getDatas */](_this.param).then(function (_a) {
                var error = _a.error, status = _a.status, name = _a.name, htmlTemplate = _a.htmlTemplate, dataInfo = _a.dataInfo, css = _a.css;
                if (status == '1') {
                    _this.name = name;
                    _this.htmlTemplate = htmlTemplate;
                    if (dataInfo && dataInfo.data && dataInfo.groups && dataInfo.groups.length > 0) {
                        dataInfo.data = dataInfo.data.map(function (item) {
                            return __assign({}, item, { content: template(Base64.decode(htmlTemplate[item.flag].titletemplate), item), title: template(Base64.decode(htmlTemplate[item.flag].contenttemplate), item) });
                        });
                        dataInfo.groups = dataInfo.groups.map(function (item) {
                            return __assign({}, item, { content: template(Base64.decode(htmlTemplate[item.flag].titletemplate), item), title: template(Base64.decode(htmlTemplate[item.flag].contenttemplate), item) });
                        });
                        //样式代码块
                        var style = document.createElement("style");
                        style.type = "text/css";
                        try {
                            style.appendChild(document.createTextNode(Base64.decode(css)));
                        }
                        catch (ex) {
                            style.styleSheet.cssText = Base64.decode(css);
                        }
                        document.getElementsByTagName("head")[0].appendChild(style);
                        //样式代码块
                        _this.maxHeight = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube_timeline').height();
                        _this.timeline = new vis.Timeline(container, dataInfo.data, dataInfo.groups, options);
                        if (_this.timeline.dom.background.offsetHeight > _this.maxHeight) {
                            _this.timeline.options.height = _this.maxHeight;
                            _this.timeline.redraw();
                        }
                        setTimeout(function () {
                            _this.timeline._setScrollTop(0);
                        }, 500);
                    }
                    else {
                        _this.hasData = false;
                    }
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_1_antd__["message"].error(error);
                    throw error;
                }
                _this.loading = false;
            });
        };
    }
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TimelineStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TimelineStore.prototype, "param", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TimelineStore.prototype, "name", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TimelineStore.prototype, "htmlTemplate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TimelineStore.prototype, "hasData", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["observable"]
    ], TimelineStore.prototype, "maxHeight", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["action"]
    ], TimelineStore.prototype, "init", void 0);
    return TimelineStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (TimelineStore);


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDatas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var newUrl = '/api/cube/timeline/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                resolve(__assign({ noRight: noRight }, data));
            }
            else {
                resolve(data);
            }
        });
    });
};
var getDatas = function (params) {
    return CallAPI(newUrl + "getDatas", "get", params);
};


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_gantt__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(7);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var getLabel = __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaLocaleProvider"].getLabel;









var GanttStore = /** @class */ (function () {
    function GanttStore() {
        var _this_1 = this;
        this.loading = false;
        this.loadingtip = '';
        this.isInit = false;
        this.deletevisible = false;
        this.currentDeleteId = '';
        this.resourceId = ''; //关联字段
        this.datas = {}; //数据原始值
        this.fields = [];
        this.taskInfo = { show: false, id: '', left: '0px', top: '0px', text1: '', text2: '' };
        this.litterTool = { show: false, id: '', top: '0px', canRead: false, canWrite: false, canDelete: false };
        /**
         *弹框卡片页相关属性
         */
        this.cardDiag_visible = false;
        this.cardDiag_url = "";
        this.canCreate = false;
        this.canSave = false;
        this.isSuperiorFieldSet = false;
        /**
         * 给插件用的临时属性,是否正在拖动svg任务条
         */
        this.ganttIsMouseDown = false;
        /**表格编辑用 */
        this.optionsMap = {};
        this.browserMap = {};
        /**相关字段未显示出来的情况，临时存储，保存时使用 */
        this.otherModifiedDatas = {};
        /**查询条件相关 */
        this.form = new __WEBPACK_IMPORTED_MODULE_4_comsMobx__["WeaForm"]();
        this.conditionInfo = [];
        /**gridEditor是否在拖动中 */
        this.isGridDragging = false;
        this.colorDatas = [];
        this.datasColorMap = {};
        this.toDelIds = [];
        this.windowTitle = '';
        this.init = function () {
            _this_1.form = new __WEBPACK_IMPORTED_MODULE_4_comsMobx__["WeaForm"]();
            _this_1.initMessage();
            _this_1.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis_gantt__["e" /* getGanttDatas */]({ id: _this_1.id, rootId: _this_1.rootId, resourceId: _this_1.resourceId }).then(Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, baseInfo = _a.baseInfo, datas = _a.datas, fieldsList = _a.fieldsList, canCreate = _a.canCreate, canSave = _a.canSave, timelineKey = _a.timelineKey, isSuperiorFieldSet = _a.isSuperiorFieldSet, optionsMap = _a.optionsMap, browserMap = _a.browserMap, dataIndex = _a.dataIndex, datasColorMap = _a.datasColorMap, noRight = _a.noRight;
                if (status == '1') {
                    if (noRight) {
                        __WEBPACK_IMPORTED_MODULE_9__util__["default"].weaHistory.push('/main/cube/encrypt');
                        return;
                    }
                    if (!Object(__WEBPACK_IMPORTED_MODULE_6__util_cubeUtil__["g" /* isFromProtal */])()) {
                        _this_1.windowTitle = baseInfo && baseInfo.ganttname;
                    }
                    _this_1.getConditionInfo();
                    _this_1.fields = fieldsList;
                    _this_1.datasColorMap = datasColorMap;
                    _this_1.canCreate = canCreate;
                    _this_1.canSave = canSave;
                    /**当用户在前端更改时间轴选项之后，不刷新此数据 */
                    // if((this.previousId != undefined && this.previousId != this.id) || (!this.timelinekey && this.timelinekey.length == 1)){
                    if (!_this_1.previousId || (_this_1.previousId != undefined && _this_1.previousId != _this_1.id) || (_this_1.timelinekey && __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.inRange(Number(_this_1.timelinekey), 0, 4))) {
                        switch (timelineKey) {
                            case '1':
                                timelineKey = '2w';
                                break;
                            case '2':
                                timelineKey = '1y';
                                break;
                            case '3':
                                timelineKey = '2Q';
                                break;
                            case '4':
                                timelineKey = '2y';
                                break;
                            default:
                                timelineKey = '1M';
                                break;
                        }
                        _this_1.timelinekey = timelineKey;
                    }
                    _this_1.isSuperiorFieldSet = isSuperiorFieldSet;
                    _this_1.baseInfo = baseInfo;
                    // if (this.resourceId!="" && location.href.indexOf('&resourceid=')==-1) {
                    if (_this_1.baseInfo.reffield != "" && location.href.indexOf('&resourceid=') == -1) {
                        _this_1.loading = false;
                        _this_1.isInit = true;
                        error = '甘特图设置了数据关联字段，需要传递resourceid参数';
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error, 10);
                        // throw new Error(error);
                    }
                    _this_1.optionsMap = optionsMap;
                    _this_1.browserMap = browserMap;
                    _this_1.loadDatas(datas, dataIndex);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            }));
            __WEBPACK_IMPORTED_MODULE_2__apis_gantt__["c" /* getColors */]({ ganttid: _this_1.id }).then(function (_a) {
                var error = _a.error, status = _a.status, datas = _a.datas;
                if (status == '1') {
                    _this_1.colorDatas = datas;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            });
        };
        this.loadDatas = function (datas, dataIndex) {
            var _this = _this_1;
            _this_1.datas = {}; //初始化原始的值
            _this_1.toDelIds = [];
            datas.forEach(function (ele) {
                _this_1.datas[ele.id] = ele; //保存初始状态数据
                ele.depends = dataIndex[ele.front]; //前置关系赋值
            });
            if (datas.length == 0) {
                _this_1.afterInit();
            }
            setTimeout(function () {
                _this.clear();
                _this.ganttMaster = new GanttMaster(_this);
                _this.ganttMaster.init(__WEBPACK_IMPORTED_MODULE_7_jquery___default()("#workSpace_" + _this_1.getGanttId));
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#workSpace_" + _this_1.getGanttId).click(function (e) { _this.workSpaceClick(e); });
                _this.ganttMaster.loadProject({ tasks: datas, selectedRow: 0 });
                //设置时间轴选项
                var str = 'zoomChange' + _this.timelinekey;
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#workSpace_" + _this_1.getGanttId).trigger(str);
                _this_1.loading = false;
                //左侧菜单点击回调
                var leftMenuSwitchDom = __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#portal-intro2");
                leftMenuSwitchDom && __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#portal-intro2').bind('click', function () {
                    setTimeout(function () {
                        // _this.ganttMaster.splitter.resize(50, 300);
                        _this.ganttMaster.splitter.resize();
                    }, 60);
                });
            }, 50);
        };
        /**
         * 初始化查询条件
         */
        this.getConditionInfo = function () {
            _this_1.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis_gantt__["d" /* getConditionInfo */]({ ganttid: _this_1.id }).then(function (_a) {
                var error = _a.error, status = _a.status, conditionInfo = _a.conditionInfo;
                if (status == '1') {
                    _this_1.conditionInfo = conditionInfo;
                    _this_1.form.initFormFields(conditionInfo);
                    _this_1.form.isFormInit = true;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
                _this_1.loading = false;
            });
        };
        /**
         * 查询
         */
        this.doSearch = function () {
            var _this = _this_1;
            var modified = _this_1.getSaveDatas();
            if (!__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.isEmptyObject(modified)) {
                __WEBPACK_IMPORTED_MODULE_3_antd__["Modal"].confirm({
                    title: '当前存在未保存的数据，搜索将清理掉修改，确定搜索？',
                    okText: getLabel(382958, '确定'),
                    okType: 'danger',
                    cancelText: getLabel(201, "取消"),
                    onOk: function () {
                        _this.doSearchSubmit();
                    }
                });
            }
            else {
                _this_1.doSearchSubmit();
            }
        };
        this.doSearchSubmit = function () {
            _this_1.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis_gantt__["b" /* doSearchDatas */](__assign({ ganttid: _this_1.id, rootId: _this_1.rootId, resourceId: _this_1.resourceId }, _this_1.form.getFormParams())).then(function (_a) {
                var error = _a.error, status = _a.status, datas = _a.datas, dataIndex = _a.dataIndex;
                if (status == '1') {
                    _this_1.clear();
                    _this_1.otherModifiedDatas = {};
                    _this_1.loadDatas(datas, dataIndex);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
                _this_1.loading = false;
            });
        };
        /**
         * 卡片保存后的回调
         */
        this.cardSaveFun = function () {
            _this_1.cardDiag_visible = false;
            _this_1.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__apis_gantt__["e" /* getGanttDatas */]({ id: _this_1.id, rootId: _this_1.rootId, resourceId: _this_1.resourceId }).then(Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, baseInfo = _a.baseInfo, datas = _a.datas, fieldsList = _a.fieldsList, canCreate = _a.canCreate, canSave = _a.canSave, isSuperiorFieldSet = _a.isSuperiorFieldSet, optionsMap = _a.optionsMap, browserMap = _a.browserMap, dataIndex = _a.dataIndex, datasColorMap = _a.datasColorMap;
                if (status == '1') {
                    _this_1.clear();
                    _this_1.fields = fieldsList;
                    _this_1.datasColorMap = datasColorMap;
                    _this_1.canCreate = canCreate;
                    _this_1.canSave = canSave;
                    _this_1.isSuperiorFieldSet = isSuperiorFieldSet;
                    _this_1.baseInfo = baseInfo;
                    _this_1.optionsMap = optionsMap;
                    _this_1.browserMap = browserMap;
                    _this_1.otherModifiedDatas = {};
                    _this_1.loadDatas(datas, dataIndex);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        this.initMessage = function () {
            GanttMaster.messages.CANNOT_WRITE = getLabel("130195", "不能编辑");
            GanttMaster.messages.CHANGE_OUT_OF_SCOPE = getLabel("130196", "超出编辑范围更新父任务");
            GanttMaster.messages.START_IS_MILESTONE = getLabel("130197", "开始是里程碑");
            GanttMaster.messages.END_IS_MILESTONE = getLabel("130198", "结束是里程碑");
            GanttMaster.messages.TASK_HAS_CONSTRAINTS = getLabel("130199", "任务包含约束");
            GanttMaster.messages.GANTT_ERROR_DEPENDS_ON_OPEN_TASK = getLabel("130200", "特定于开放的任务");
            GanttMaster.messages.GANTT_ERROR_DESCENDANT_OF_CLOSED_TASK = getLabel("130201", "衍生于关闭的任务");
            GanttMaster.messages.TASK_HAS_EXTERNAL_DEPS = getLabel("130202", "任务包含外部依赖");
            GanttMaster.messages.GANTT_ERROR_LOADING_DATA_TASK_REMOVED = getLabel("130203", "加载被删除的任务");
            GanttMaster.messages.ERROR_SETTING_DATES = getLabel("130204", "日期时间设置错误（依赖时间关系或父级任务工期）");
            GanttMaster.messages.CIRCULAR_REFERENCE = getLabel("130205", "有无限循环参照");
            GanttMaster.messages.CANNOT_DEPENDS_ON_ANCESTORS = getLabel("130206", "不能依赖父级任务");
            GanttMaster.messages.CANNOT_DEPENDS_ON_DESCENDANTS = getLabel("130207", "不能依赖子级任务");
            GanttMaster.messages.INVALID_DATE_FORMAT = getLabel("130208", "无效日期格式");
            GanttMaster.messages.TASK_MOVE_INCONSISTENT_LEVEL = getLabel("130209", "任务移动非连续级别");
            GanttMaster.messages.GANTT_QUARTER = getLabel("17495", "季度");
            GanttMaster.messages.GANTT_MONTH = getLabel("6076", "月");
            GanttMaster.messages.GANTT_SEMESTER = getLabel("20729", "半年");
            GanttMaster.messages.GANTT_UPON = getLabel("31276", "上");
            GanttMaster.messages.GANTT_DOWN = getLabel("23010", "下");
            GanttMaster.messages.GANTT_DI = getLabel("15323", "第");
            GanttMaster.messages.GANTT_WEEK_SHORT = getLabel("1926", "周");
            GanttMaster.messages.Message1 = getLabel("130210", "结束日期必须大于开始日期");
            GanttMaster.messages.Message2 = getLabel("130211", "结束时间必须大于开始时间");
            GanttMaster.messages.Message3 = getLabel("130212", "父任务开始日期不能晚于子任务的开始日期");
            GanttMaster.messages.Message4 = getLabel("130213", "父任务结束日期不能早于子任务结束日期");
            GanttMaster.messages.Message5 = getLabel("130214", "父任务开始时间不能晚于子任务的开始时间");
            GanttMaster.messages.Message6 = getLabel("130215", "父任务结束时间不能早于子任务结束时间");
        };
        this.getTaskRowHtmlTemplate = function (task) {
            var tr = "<tr id=\"tid_" + task.id + "\" canWrite=\"" + task.canWrite + "\" data-taskid=\"" + task.id + "\" class=\"taskEditRow " + (task.isParent() ? 'isParent' : '') + " " + (task.collapsed ? 'collapsed' : '') + "\" data-level=\"" + task.level + "\">\n        <td class=\"gdfCell\">" + (task.getRow() + 1) + "</td>";
            _this_1.fields.forEach(function (item) {
                if (item.systemFlag && item.systemFlag == 1) {
                    tr += "<td class=\"gdfCell indentCell\" fieldLink=\"" + item.fieldLink + "\">\n                        <div class=\"exp-controller\" data-align=\"center\"></div>\n                        <span>" + (task[item.fieldLink] ? task[item.fieldLink] : '') + "</span>\n                    </td>";
                }
                else {
                    var val = task[item.fieldLink] ? task[item.fieldLink] : '';
                    if (item.fieldhtmltype == '4') { //check框
                        if (val == '1') {
                            val = '是';
                        }
                        else if (val == '0') {
                            val = '否';
                        }
                    }
                    tr += "<td class=\"gdfCell\" fieldLink=\"" + item.fieldLink + "\">\n                        <span>" + val + "</span>\n                    </td>";
                }
            });
            tr += '</tr>';
            return tr;
        };
        this.getTaskEmptyRowHtmlTemplate = function () {
            var tr = "<tr class=\"taskEditRow emptyRow\" ><td class=\"gdfCell\"></td>";
            _this_1.fields.forEach(function (item) {
                tr += "<td class=\"gdfCell\"></td>";
            });
            tr += '</tr>';
            return tr;
        };
        this.addTaskRow = function (taskid, type) {
            var task = _this_1.ganttMaster.getTask(taskid);
            var superiorFieldTd = task.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.superiorField + '"]')[0]; //用来判断上级字段是否显示
            var newTaskId = "tmp" + new Date().getTime();
            var superior = ''; //新task的上级span
            var superior_value = ''; //新task的上级value
            var row = task.getRow();
            var level = task.level;
            if (type == 'above') {
                if (task['field' + _this_1.baseInfo.superiorField + "_value"]) {
                    var superTask = _this_1.ganttMaster.getTask(task['field' + _this_1.baseInfo.superiorField + "_value"]);
                    superior = superTask.name;
                    superior_value = superTask.id;
                }
                //当前级及所有下级往下移一级
                var allToRefresh = task.getAllChildren();
                allToRefresh.splice(0, 0, task);
                allToRefresh.forEach(function (element) {
                    element.level += 1;
                    _this_1.ganttMaster.editor.refreshTaskRow(element);
                });
                //如果添加的是上级，则当前级的上级字段都要变更
                task['field' + _this_1.baseInfo.superiorField] = '';
                task['field' + _this_1.baseInfo.superiorField + '_value'] = newTaskId;
                _this_1.modifyTd(superiorFieldTd, newTaskId, _this_1.baseInfo.superiorField, task);
                // this.litterTool.id = newTaskId;
                //更新操作栏
                _this_1.taskOutFun && _this_1.taskOutFun();
                // console.log('id', this.litterTool.id);
            }
            else if (type == 'sibling') {
                superior = task['field' + _this_1.baseInfo.superiorField];
                superior_value = task['field' + _this_1.baseInfo.superiorField + "_value"];
                var allChildrens = task.getAllChildren();
                if (allChildrens.length > 0) {
                    row = allChildrens[allChildrens.length - 1].getRow() + 1;
                }
                else {
                    row += 1;
                }
            }
            else if (type == 'below') {
                superior = task.name;
                superior_value = task.id;
                var allChildrens = task.getAllChildren();
                if (allChildrens.length > 0) {
                    row = allChildrens[allChildrens.length - 1].getRow() + 1;
                }
                else {
                    row += 1;
                    task.rowElement.addClass("isParent");
                }
                level += 1;
            }
            var newTask = new Task(newTaskId, "", "", level, "", "", "", "");
            if (superiorFieldTd) {
                newTask['field' + _this_1.baseInfo.superiorField] = superior;
                newTask['field' + _this_1.baseInfo.superiorField + '_value'] = superior_value;
            }
            _this_1.ganttMaster.addTask(newTask, row, 'addNew');
            _this_1.ganttMaster.editor.refreshTaskRow(newTask);
            //如果上级字段存在则给上级字段赋值(newTask)
            var newSuperiorFieldTd = newTask.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.superiorField + '"]')[0];
            if (superior_value) {
                _this_1.modifyTd(newSuperiorFieldTd, superior_value, _this_1.baseInfo.superiorField, newTask, superior);
            }
            //新增的数据处于编辑状态
            _this_1.editTaskRow(newTask.rowElement, newTask);
        };
        this.clear = function () { }; //index.tsx didMount时赋值，作用：清除ganttContainer组件
        this.getSaveDatas = function () {
            var modified = {};
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()('sup[info]').each(function (index, item) {
                var info = item.getAttribute('info').replace('_value', '');
                var infos = info.split('_');
                var id = infos[0];
                var field = infos[1];
                var task = _this_1.ganttMaster.getTask(id);
                var value = task[field + '_value'] || task[field] || '';
                modified[info] = value;
            });
            modified = __assign({}, modified, _this_1.otherModifiedDatas);
            return modified;
        };
        this.save = function () {
            var conditions = _this_1.form.getFormParams();
            var modified = _this_1.getSaveDatas();
            if (__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.isEmptyObject(modified) && _this_1.toDelIds.length === 0) {
                __WEBPACK_IMPORTED_MODULE_3_antd__["message"].warn('未做任何修改！');
                return;
            }
            var newids = '';
            _this_1.ganttMaster.tasks.forEach(function (item) {
                if (item.id.startsWith('tmp')) {
                    newids += item.id + ',';
                }
            });
            if (newids.endsWith(',')) {
                newids = newids.substring(0, newids.length - 1);
            }
            _this_1.loading = true;
            _this_1.isInit = false;
            //删除待删除的任务（type 0：不删除子级）
            _this_1.toDelIds.forEach(function (id) {
                if (id && !id.startsWith('tmp')) {
                    __WEBPACK_IMPORTED_MODULE_2__apis_gantt__["a" /* deleteDatas */]({ ganttid: _this_1.id, billid: id, type: 0 }).then(Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["action"])(function (_a) {
                        var error = _a.error, status = _a.status, errorCode = _a.errorCode;
                        if (status == '1') {
                            if (errorCode == '-1') {
                                __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                            }
                            else {
                                //message.success(getLabel(83472, "删除成功！"));
                                _this_1.clear();
                                _this_1.init();
                            }
                            _this_1.deletevisible = false;
                            _this_1.loading = false;
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                            throw error;
                        }
                    }));
                }
            });
            //保存修改的内容
            __WEBPACK_IMPORTED_MODULE_2__apis_gantt__["f" /* save */]({ ganttid: _this_1.id, newids: newids, modified: JSON.stringify(modified) }).then(Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, errorCode = _a.errorCode;
                if (status == '1') {
                    if (errorCode == '-1') {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].success(getLabel(18758, "保存成功。"));
                    }
                    _this_1.deletevisible = false;
                    _this_1.loading = false;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
                _this_1.clear();
                _this_1.otherModifiedDatas = {};
                //保存后，保留高级搜索的条件
                _this_1.form.updateFields(conditions);
                if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.values(conditions).some(function (v) { return v != ''; })) {
                    _this_1.doSearch();
                }
                else {
                    _this_1.init();
                }
            }));
        };
        //未保存的数据删除
        this.deleteTmpTaskRow = function (id) {
            _this_1.deletevisible = true;
            _this_1.currentDeleteId = id;
            // this.ganttMaster.getTask(id).deleteTask();
            // var workspace=$(`.TWGanttWorkSpace_${this.id}`);
            // var gridGroup= workspace.find("#gridGroup").get(0);
            // $(gridGroup).find('rect[class="ganttSVGOverRow"]').attr('class','ganttLinesSVG');
            // this.litterTool.show=false;
        };
        //删除行 type:1 且删除子级   0：不删除子级
        this.deleteTaskRow = function (type) {
            _this_1.toDelIds = [];
            var tasks = _this_1.ganttMaster.tasks;
            //获取待删任务
            var task = _this_1.ganttMaster.getTask(_this_1.currentDeleteId);
            _this_1.loading = true;
            //当前任务上级任务赋给子任务上级任务
            _this_1.ganttMaster.tasks.forEach(function (element) {
                if (element['field' + _this_1.baseInfo.superiorField + '_value'] == _this_1.currentDeleteId) {
                    var current_superiorFieldTd = element.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.superiorField + '"]')[0];
                    if (current_superiorFieldTd) {
                        // $(current_superiorFieldTd).find('span')[0].innerText="";
                        // element['field'+this.baseInfo.superiorField]="";
                        __WEBPACK_IMPORTED_MODULE_7_jquery___default()(current_superiorFieldTd).find('span')[0].innerText = task.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.superiorField + '"]')[0].innerText;
                        element['field' + _this_1.baseInfo.superiorField] = task['field' + _this_1.baseInfo.superiorField];
                        var newSuperiorFieldTd = task.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.superiorField + '"]')[0];
                        //task上级任务
                        var superiorId = task['field' + _this_1.baseInfo.superiorField + '_value'];
                        var superiorName = task['field' + _this_1.baseInfo.superiorField];
                        if (superiorId) {
                            _this_1.modifyTd(newSuperiorFieldTd, superiorId, _this_1.baseInfo.superiorField, element, superiorName);
                        }
                        //新增的数据处于编辑状态
                        // this.editTaskRow(element.rowElement,newTask);
                    }
                }
            });
            //当前删除任务为未保存的任务
            if (_this_1.currentDeleteId.startsWith('tmp')) { //当前删除任务为未保存任务，且删除子任务
                if (type == 1) {
                    task.getAllChildren().forEach(function (element) {
                        // this.currentDeleteId = element.id;
                        element.deleteTask();
                        if (_this_1.ganttMaster.getTask(element.id)) {
                            _this_1.ganttMaster.tasks.splice(tasks.findIndex(function (item) { return item.id == element.id; }), 1);
                        }
                        _this_1.toDelIds.push(element.id);
                        // this.deleteTaskRow(1);
                    });
                    var workspace = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(".TWGanttWorkSpace_" + _this_1.id);
                    var gridGroup = workspace.find("#gridGroup").get(0);
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(gridGroup).find('rect[class="ganttSVGOverRow"]').attr('class', 'ganttLinesSVG');
                    _this_1.litterTool.show = false;
                }
                else if (type == 0) { //当前删除任务为未保存任务，且不删除子任务
                    //重新计算名称列的padding-left
                    var allToRefresh = task.getAllChildren();
                    allToRefresh.splice(0, 0, task);
                    allToRefresh.forEach(function (element) {
                        element.level -= 1;
                        _this_1.ganttMaster.editor.refreshTaskRow(element);
                    });
                    //task.deleteTask();
                }
                //删除当前任务
                task.deleteTask();
                if (_this_1.ganttMaster.getTask(_this_1.currentDeleteId)) {
                    _this_1.ganttMaster.tasks.splice(tasks.findIndex(function (item) { return item.id == _this_1.currentDeleteId; }), 1);
                }
                _this_1.loading = false;
                _this_1.deletevisible = false;
                //更新上级任务父任务标识
                var supId_1 = task['field' + _this_1.baseInfo.superiorField + '_value'];
                var supDomId_1 = "#tid_" + supId_1;
                tasks.forEach(function (item) {
                    if (item.id == supId_1 && item.getAllChildren().length == 0) {
                        //清除父任务标识
                        __WEBPACK_IMPORTED_MODULE_7_jquery___default()(supDomId_1).attr('class', __WEBPACK_IMPORTED_MODULE_7_jquery___default()(supDomId_1).attr('class').replace(/isParent/, ''));
                    }
                });
                return;
            }
            //更新上级任务父任务标识
            var supId = task['field' + _this_1.baseInfo.superiorField + '_value'];
            var supDomId = "#tid_" + supId;
            tasks.forEach(function (item) {
                if (item.id == supId && item.getAllChildren().length == 0) {
                    //清除父任务标识
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(supDomId).attr('class', __WEBPACK_IMPORTED_MODULE_7_jquery___default()(supDomId).attr('class').replace(/isParent/, ''));
                }
            });
            //当前删除任务为已保存的任务
            __WEBPACK_IMPORTED_MODULE_2__apis_gantt__["a" /* deleteDatas */]({ ganttid: _this_1.id, billid: _this_1.currentDeleteId, type: type }).then(Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["action"])(function (_a) {
                var error = _a.error, status = _a.status, errorCode = _a.errorCode;
                if (status == '1') {
                    if (errorCode == '-1') {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_3_antd__["message"].success(getLabel(83472, "删除成功！"));
                        _this_1.clear();
                        _this_1.init();
                    }
                    _this_1.deletevisible = false;
                    _this_1.loading = false;
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].error(error);
                    throw error;
                }
            }));
        };
        //双击编辑行
        this.editTaskRow = function (taskRow, task) {
            if (!task.canWrite)
                return;
            if (taskRow.attr('modify') == '1')
                return; //modify:1编辑状态
            var tds = taskRow.find("td");
            _this_1.fields.forEach(function (item, index) {
                var td = tds[index + 1];
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).find('span').remove();
                var conditionType = ecCom.WeaInput;
                var fieldhtmltype = item.fieldhtmltype;
                var params = {};
                var type = item.fieldtype;
                var detailtype = '1';
                var reg = new RegExp('');
                var otherParams = {};
                if (fieldhtmltype == '1') { //单行文本
                    if (type == '2') { //整数
                        reg = /^-?\d+$/;
                        detailtype = '2';
                        otherParams = { max: 2147483647, min: -2147483648 };
                    }
                    else if (type == '3' || type == '4' || type == '5') { //浮点数 金额转换 金额千分位
                        reg = /^(-?\d+)(.[0-9]{0,2})?$/;
                        switch (item.qfws) {
                            case 1:
                                reg = /^(-?\d+)(.[0-9]{0,1})?$/;
                                break;
                            case 2:
                                reg = /^(-?\d+)(.[0-9]{0,2})?$/;
                                break;
                            case 3:
                                reg = /^(-?\d+)(.[0-9]{0,3})?$/;
                                break;
                            case 4:
                                reg = /^(-?\d+)(.[0-9]{0,4})?$/;
                                break;
                            case 5:
                                reg = /^(-?\d+)(.[0-9]{0,5})?$/;
                                break;
                            case 6:
                                reg = /^(-?\d+)(.[0-9]{0,6})?$/;
                                break;
                            case 7:
                                reg = /^(-?\d+)(.[0-9]{0,7})?$/;
                                break;
                            case 8:
                                reg = /^(-?\d+)(.[0-9]{0,8})?$/;
                                break;
                            case 9:
                                reg = /^(-?\d+)(.[0-9]{0,9})?$/;
                                break;
                            case 10:
                                reg = /^(-?\d+)(.[0-9]{0,10})?$/;
                                break;
                            case 11:
                                reg = /^(-?\d+)(.[0-9]{0,11})?$/;
                                break;
                            case 12:
                                reg = /^(-?\d+)(.[0-9]{0,12})?$/;
                                break;
                            case 13:
                                reg = /^(-?\d+)(.[0-9]{0,13})?$/;
                                break;
                            case 14:
                                reg = /^(-?\d+)(.[0-9]{0,14})?$/;
                                break;
                            case 15:
                                reg = /^(-?\d+)(.[0-9]{0,15})?$/;
                                break;
                        }
                        detailtype = '2';
                        otherParams = { max: 999999999999.999999999999, min: -999999999999.999999999999 };
                    }
                    params = __assign({ detailtype: detailtype }, otherParams, { regExp: reg });
                }
                else if (fieldhtmltype == '5') { //选择框
                    conditionType = ecCom.WeaSelect;
                    params = { options: _this_1.optionsMap[item.fieldid], detailtype: type };
                }
                else if (fieldhtmltype == '3') { //浏览按钮
                    if (type == '2') {
                        conditionType = ecCom.WeaDatePicker;
                    }
                    else if (type == '19') {
                        conditionType = ecCom.WeaTimePicker;
                    }
                    else if (type == '290') {
                        conditionType = ecCom.WeaDatePicker;
                        params = { showTime: { format: "HH:mm" }, format: "yyyy-MM-dd HH:mm" };
                    }
                    else if (type == '402') {
                        conditionType = ecCom.WeaDatePicker;
                        params = { showTime: false, noinput: true, format: "YYYY" };
                    }
                    else if (type == '403') {
                        conditionType = ecCom.WeaDatePicker;
                        params = { showTime: false, noinput: true, format: "YYYY-MM" };
                    }
                    else {
                        conditionType = ecCom.WeaBrowser;
                        if (type && (type == '4' || type == '57' || type == '164' || type == '169' || type == '194' || type == '167' || type == '170' || type == '168')) { //部门，多部门，分部，多分部，单点分权，分权单部门，分权多分部，分权多部门
                            _this_1.browserMap[item.fieldid].dataParams = __assign({}, _this_1.browserMap[item.fieldid].dataParams, { fromModule: "model" });
                            _this_1.browserMap[item.fieldid].destDataParams = __assign({}, _this_1.browserMap[item.fieldid].dataParams, { fromModule: "model" });
                        }
                        if (type == '256' || type == '257') { //	自定义树形单/多选
                            var urlParams = _this_1.browserMap[item.fieldid].dataParams;
                            // let temp = {...urlParams, cube_treeid: urlParams.type + "_searchType" };
                            var temp = __assign({}, urlParams, { cube_treeid: urlParams.type });
                            _this_1.browserMap[item.fieldid].dataParams = temp;
                            _this_1.browserMap[item.fieldid].destDataParams = temp;
                        }
                        var value = task[item.fieldLink + "_value"] ? task[item.fieldLink + "_value"] : '';
                        var valueSpan = task[item.fieldLink] ? task[item.fieldLink] : '';
                        if (item.fieldLink.replace('field', '') == _this_1.baseInfo.superiorField && value != '') { //如果是上级字段需要特殊处理下
                            valueSpan = _this_1.ganttMaster.getTask(value).name;
                        }
                        var replaceDatas_1 = [];
                        var valArr = [];
                        var valSpanArr_1 = [];
                        if (value && type == '141') { //人力资源条件
                            var values = void 0;
                            var names = void 0;
                            values = Object(__WEBPACK_IMPORTED_MODULE_6__util_cubeUtil__["k" /* unSpellResourceCondition */])(value);
                            names = Object(__WEBPACK_IMPORTED_MODULE_6__util_cubeUtil__["c" /* getDefaultValueSpan */])(valueSpan, values).split(/,|，/);
                            if (values.length == names.length) {
                                for (var i = 0; i < values.length; i++) {
                                    var theName = names[i].replace(/  /g, ',');
                                    valSpanArr_1.push(Object(__WEBPACK_IMPORTED_MODULE_6__util_cubeUtil__["d" /* getReConditionObj */])(values[i], theName));
                                }
                            }
                            replaceDatas_1 = valSpanArr_1;
                        }
                        else if (value.trim()) {
                            valArr = value.trim().split(',');
                            valSpanArr_1 = valueSpan.trim().split(/,| /);
                            if (valArr.length === valSpanArr_1.length) {
                                valArr.forEach(function (element, i) {
                                    replaceDatas_1.push({ id: element, name: valSpanArr_1[i] });
                                });
                            }
                        }
                        params = __assign({}, _this_1.browserMap[item.fieldid], { replaceDatas: replaceDatas_1 });
                    }
                }
                else if (fieldhtmltype == '2') { //多行文本
                    if (type == '1') {
                    }
                    else if (type == "2") {
                    }
                }
                else if (fieldhtmltype == '4') { //Check框
                    conditionType = ecCom.WeaCheckbox;
                }
                else {
                    return;
                }
                var div = __WEBPACK_IMPORTED_MODULE_7_jquery___default()("<div type='react' style='display: inline;'>");
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).append(div);
                var eleValue = task[item.fieldLink + '_value'] ? task[item.fieldLink + '_value'] : (task[item.fieldLink] ? task[item.fieldLink] : '');
                var ele = React.createElement(conditionType, __assign({}, params, { value: eleValue, noInput: true, viewAttr: '2', onChange: function (value, valueSpan, temp) {
                        if (type == '141') { // 人力资源条件
                            var targetVal = Object(__WEBPACK_IMPORTED_MODULE_6__util_cubeUtil__["j" /* spellResourceCondition */])(temp);
                            var targetValSpan = temp.map(function (item) {
                                if (item.sharetype == '5') {
                                    return item.sharetypespan;
                                }
                                else {
                                    var newName = item.sharetypespan + "(" + item.relatedsharespan + ")";
                                    if (item.sharetype == '6') {
                                        newName = item.sharetypespan + "(" + item.relatedsharespan + "/" + item.joblevelspan + (item.jobfieldspan ? "(" + item.jobfieldspan + ")" : '') + ")";
                                    }
                                    return newName;
                                }
                            }).join(',');
                            value = targetVal;
                            valueSpan = targetValSpan;
                        }
                        if (!valueSpan && value) {
                            valueSpan = value;
                        }
                        if (fieldhtmltype == '3' && !task.hasOwnProperty(item.fieldLink + '_value')) {
                            task[item.fieldLink + '_value'] = '';
                        }
                        var flag = _this_1.synchronizeSVG(item, value, task);
                        if (flag) {
                            task[item.fieldLink] = valueSpan;
                            if (task.hasOwnProperty(item.fieldLink + '_value')) {
                                task[item.fieldLink + '_value'] = value;
                                _this_1.modifiedSup(td, value, task.id, item.fieldLink + '_value');
                            }
                            else {
                                _this_1.modifiedSup(td, value, task.id, item.fieldLink);
                            }
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).empty();
                            var div1 = __WEBPACK_IMPORTED_MODULE_7_jquery___default()("<div type='react' style='display: inline;'>");
                            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).append(div1);
                            ReactDOM.render(ele, div1[0]);
                        }
                    }, onBlur: function (value, valueSpan) {
                        if (!valueSpan && value) {
                            valueSpan = value;
                        }
                        if (item.systemFlag == '1') { //如果修改的是标题字段则需要处理界面相关关联的地方
                            var superiorFieldTd = task.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.superiorField + '"]')[0];
                            var frontFieldTd = task.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.frontField + '"]')[0];
                            if (superiorFieldTd || frontFieldTd) {
                                _this_1.ganttMaster.tasks.forEach(function (element) {
                                    if (element['field' + _this_1.baseInfo.superiorField + '_value'] == task.id) {
                                        var current_superiorFieldTd = element.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.superiorField + '"]')[0];
                                        if (current_superiorFieldTd) {
                                            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(current_superiorFieldTd).find('span')[0].innerText = valueSpan;
                                            element['field' + _this_1.baseInfo.superiorField] = valueSpan;
                                        }
                                    }
                                    if (element['field' + _this_1.baseInfo.frontField + '_value'] == task.id) {
                                        var current_frontFieldTd = element.rowElement.find('td[fieldLink="field' + _this_1.baseInfo.frontField + '"]')[0];
                                        if (current_frontFieldTd) {
                                            __WEBPACK_IMPORTED_MODULE_7_jquery___default()(current_frontFieldTd).find('span')[0].innerText = valueSpan;
                                            element['field' + _this_1.baseInfo.frontField] = valueSpan;
                                        }
                                    }
                                });
                            }
                        }
                        //关于svg上的文字描述
                        if (item.fieldid == _this_1.baseInfo.progressField || item.systemFlag == '1' && task.ganttElement && task.ganttElement.find('.taskLabelSVG')[0]) {
                            task.ganttElement.find('.taskLabelSVG')[0].innerHTML = task.name + '(' + (task['field' + _this_1.baseInfo.progressField] || '0') + '%)';
                        }
                    } }));
                ReactDOM.render(ele, div[0]);
            });
            taskRow.attr('modify', '1');
        };
        //添加被修改的状态
        this.modifiedSup = function (td, value, id, fieldLink) {
            var task = _this_1.ganttMaster.getTask(id);
            if (task) {
                task[fieldLink] = value;
            }
            if (!_this_1.datas[id] || value != _this_1.datas[id][fieldLink]) {
                if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).find('sup').length == 0) {
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).append(__WEBPACK_IMPORTED_MODULE_7_jquery___default()('<sup info="' + id + '_' + fieldLink + '"></sup>'));
                }
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).find('sup').remove();
            }
        };
        //空白处点击，取消table的编辑状态
        this.workSpaceClick = function (e) {
            if (e && e.originalEvent) {
                if (__WEBPACK_IMPORTED_MODULE_7_jquery___default()("tr[modify='1']").length == 0)
                    return;
                var path = e.originalEvent.path;
                //是否执行
                var isCancelEdit_1 = true;
                path.forEach(function (p) {
                    if (p.nodeName == 'TR' && p.getAttribute('modify') == '1') {
                        isCancelEdit_1 = false;
                    }
                });
                if (isCancelEdit_1) {
                    _this_1.cancelEditTaskRow();
                }
            }
        };
        this.afterInit = function () {
            _this_1.isInit = true;
        };
        //取消行的编辑状态
        this.cancelEditTaskRow = function () {
            __WEBPACK_IMPORTED_MODULE_7_jquery___default()("tr[modify='1']").each(function (index, item) {
                var task = _this_1.ganttMaster.getTask(item.getAttribute('data-taskid'));
                var tds = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(item).find("td");
                _this_1.fields.forEach(function (item, index) {
                    var td = tds[index + 1];
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).find("div[type='react']").remove();
                    var val = task[item.fieldLink] ? task[item.fieldLink] : '';
                    if (item.fieldhtmltype == '3') { //浏览框
                        val = val.trim().split(',').join(' ');
                    }
                    else if (item.fieldhtmltype == '4') { //check框
                        if (val == '1') {
                            val = '是';
                        }
                        else if (val == '0') {
                            val = '否';
                        }
                    }
                    else if (item.fieldhtmltype == '5') { //选择框
                        // let reg = /^[0-9]+.?[0-9]*$/;//数字正则
                        // if (reg.test(val)) {
                        //     val = this.optionsMap[item.fieldid][Number(val) + 1].showname || '';
                        // }else{
                        if (task.id.indexOf('tmp') == -1) {
                            val = task[item.fieldLink + '_value'] ? task[item.fieldLink + '_value'] : '';
                        }
                        var ops_1 = _this_1.optionsMap[item.fieldid];
                        var newValArr_1 = [];
                        val.split(",").forEach(function (element) {
                            var obj = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(ops_1, { 'key': element });
                            obj && obj.showname && newValArr_1.push(obj.showname);
                        });
                        val = newValArr_1.join();
                        // }
                    }
                    // $(td).find("div[type='react']").remove();
                    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).append(__WEBPACK_IMPORTED_MODULE_7_jquery___default()("<span>" + val + "</span>"));
                });
                item.setAttribute('modify', '0');
            });
        };
        this.showTaskInfo = function (param) {
            if (_this_1.ganttIsMouseDown) { //如果是正在拖拽情况下
                return;
            }
            var task = param.task;
            if (task.id == _this_1.taskInfo.id && _this_1.taskInfo.show) { //若果已经打开状态就不用继续执行
                return;
            }
            var startp = new Date(task.start);
            // @ts-ignore
            startp = startp.format("yyyy-MM-dd HH:mm");
            var endp = new Date(task.end);
            // @ts-ignore
            endp = endp.format("yyyy-MM-dd HH:mm");
            var text1 = '计划日期:' + startp + ' - ' + endp;
            var text2 = '';
            if (task.hasActual) {
                var astartp = new Date(task.actualbegindate);
                // @ts-ignore
                astartp = astartp.format("yyyy-MM-dd HH:mm");
                var aendp = new Date(task.actualenddate);
                // @ts-ignore
                aendp = aendp.format("yyyy-MM-dd HH:mm");
                text2 = '实际日期:' + astartp + ' - ' + aendp;
            }
            _this_1.taskInfo = { show: true, id: task.id, left: param.left - 144 + 'px', top: param.top - 65 + 'px', text1: text1, text2: text2 };
        };
        this.closeTaskInfo = function () {
            _this_1.taskInfo.show = false;
        };
        this.update = function (param) {
            for (var key in param) {
                if (key === 'id') {
                    _this_1.previousId = _this_1.id;
                }
                _this_1[key] = param[key];
            }
            // this.init();
        };
        /**
         * 添加任务元素（Item元素）
         */
        this.openDialog = function (url, id) {
            _this_1.cardDiag_visible = true;
            top.window['current_ganttStore'] = _this_1;
            if (id) {
                var url_1 = Object(__WEBPACK_IMPORTED_MODULE_5__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.jsp#/main/cube/card?type=0&modeId=" + _this_1.baseInfo.modeid + "&formId=" + _this_1.baseInfo.formid + "&billid=" + id);
                _this_1.cardDiag_url = url_1;
            }
            else {
                _this_1.cardDiag_url = url;
            }
            _this_1.cardDiag_url += '&viewfrom=fromgantt';
            var reffield = '';
            if (_this_1.resourceId && _this_1.baseInfo.reffield) {
                reffield = '&field' + _this_1.baseInfo.reffield + '=' + _this_1.resourceId;
            }
            _this_1.cardDiag_url += reffield;
            setTimeout(function () {
                document.getElementsByClassName('ant-modal')[0]['style'].top = '30px';
            }, 100);
        };
        //---------------------------------------------------------------------------------------------litterTool相关
        this.showLitterTool = function (id, top) {
            if (!_this_1.litterTool.show) {
                var task = _this_1.ganttMaster.getTask(id);
                if (_this_1.canCreate || task.canRead) {
                    _this_1.litterTool = { show: true, id: id, top: top + 'px', canRead: task.canRead, canWrite: task.canWrite, canDelete: task.canDelete };
                }
            }
        };
        this.closeLitterTool = function () {
            _this_1.litterTool.show = false;
        };
        //-----------------------------------------------------------------------------------------------同步右侧甘特图相关操作
        this.synchronizeSVG = function (field, value, task) {
            if (field.fieldid == _this_1.baseInfo.actualStartDateField) {
                var orDate = _this_1.getDateStr(task.actualbegindate);
                task.actualbegindate = new Date(value + " " + orDate.split(' ')[1]).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.actualStartTimeField) {
                var orDate = _this_1.getDateStr(task.actualbegindate);
                task.actualbegindate = new Date(orDate.split(' ')[0] + " " + value).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.gttactualStartDateTimeField) {
                task.actualbegindate = new Date(value).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.actualEndDateField) {
                var orDate = _this_1.getDateStr(task.actualenddate);
                task.actualenddate = new Date(value + " " + orDate.split(' ')[1]).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.actualEndTimeField) {
                var orDate = _this_1.getDateStr(task.actualenddate);
                task.actualenddate = new Date(orDate.split(' ')[0] + " " + value).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.gttactualEndDateTimeField) {
                task.actualenddate = new Date(value).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.startDateField) {
                var orDate = _this_1.getDateStr(task.start);
                task.start = new Date(value + " " + orDate.split(' ')[1]).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.startTimeField) {
                var orDate = _this_1.getDateStr(task.start);
                task.start = new Date(orDate.split(' ')[0] + " " + value).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.gttstartDateTimeField) {
                task.start = new Date(value).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.endDateField) {
                var orDate = _this_1.getDateStr(task.end);
                task.end = new Date(value + " " + orDate.split(' ')[1]).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.endTimeField) {
                var orDate = _this_1.getDateStr(task.end);
                task.end = new Date(orDate.split(' ')[0] + " " + value).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.gttendDateTimeField) {
                task.end = new Date(value).getTime();
                _this_1.ganttMaster.afterModifiedTask(task);
            }
            else if (field.fieldid == _this_1.baseInfo.superiorField) { //上级字段变更
                if (value == task.id) {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].warn('不可用当前数据作为上级！');
                    return false;
                }
                if (_this_1.ganttMaster.getTask(task.id).getAllChildren().findIndex(function (item) { return item.id == value; }) > -1) {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].warn('不可用当前数据的下级作为上级！');
                    return false;
                }
                task.depends = value;
                var parentTask = _this_1.ganttMaster.getTask(value);
                var oldParentTask = task.getParent();
                if (parentTask) {
                    var parentTaskRow = parentTask.getRow();
                    var difLevel = parentTask.level - task.level + 1;
                    //找到最下边一个子任务的index
                    var row = task.getRow();
                    var descNumber = 0;
                    for (var i = row + 1; i < _this_1.ganttMaster.tasks.length; i++) {
                        var desc = _this_1.ganttMaster.tasks[i];
                        if (desc.level > task.level) {
                            descNumber++;
                            desc.level += difLevel;
                            _this_1.ganttMaster.editor.refreshTaskRow(desc);
                        }
                        else {
                            break;
                        }
                    }
                    task.level += difLevel;
                    //移动editor
                    var rows = _this_1.ganttMaster.editor.element.find("tr[data-taskid]");
                    parentTask.rowElement.after(rows.slice(row, row + descNumber + 1));
                    var blockToMove = _this_1.ganttMaster.tasks.splice(row, descNumber + 1);
                    var topNum = parentTaskRow + 1;
                    if (row < parentTaskRow) { //如果新上级在下边，top要减掉blockToMove的长度
                        topNum -= blockToMove.length;
                    }
                    var top = _this_1.ganttMaster.tasks.splice(0, topNum);
                    _this_1.ganttMaster.tasks = [].concat(top, blockToMove, _this_1.ganttMaster.tasks);
                    _this_1.ganttMaster.editor.refreshExpandStatus(parentTask);
                    //移动gantt
                    _this_1.ganttMaster.gantt.moveGantt(row, row + descNumber, parentTaskRow);
                }
                else { //如果清除了上级，就将单条数据移到第一个去
                    //找到最下边一个子任务的index
                    var row = task.getRow();
                    var descNumber = 0;
                    for (var i = row + 1; i < _this_1.ganttMaster.tasks.length; i++) {
                        var desc = _this_1.ganttMaster.tasks[i];
                        if (desc.level > task.level) {
                            descNumber++;
                            desc.level += descNumber;
                            _this_1.ganttMaster.editor.refreshTaskRow(desc);
                        }
                        else {
                            break;
                        }
                    }
                    task.level = 0;
                    //移动editor
                    var rows = _this_1.ganttMaster.editor.element.find("tr[data-taskid]");
                    _this_1.ganttMaster.tasks[0].rowElement.before(rows.slice(row, row + descNumber + 1));
                    var blockToMove = _this_1.ganttMaster.tasks.splice(row, descNumber + 1);
                    _this_1.ganttMaster.tasks = [].concat(blockToMove, _this_1.ganttMaster.tasks); //将task放到最前面
                    //移动gantt
                    _this_1.ganttMaster.gantt.moveGantt(row, row + descNumber, -1);
                }
                task.rowElement.click();
                _this_1.ganttMaster.editor.refreshTaskRow(task);
                _this_1.ganttMaster.editor.refreshExpandStatus(oldParentTask);
            }
            else if (field.fieldid == _this_1.baseInfo.frontField) { //前置字段变更
                if (value == task.id) {
                    __WEBPACK_IMPORTED_MODULE_3_antd__["message"].warn('不可用当前数据作为前置关系！');
                    return false;
                }
                task.front = value;
                var getGanttId = _this_1.id;
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(".TWGanttWorkSpace_" + getGanttId).find("g[to=" + task.id + "]").remove();
                //更新links
                _this_1.ganttMaster.links = _this_1.ganttMaster.links.filter(function (item) { return item.to.id != task.id; });
                _this_1.ganttMaster.links.push({ from: value, to: task.id, lag: 0 });
                _this_1.ganttMaster.gantt.drawLink(_this_1.ganttMaster.getTask(value), task);
            }
            return true;
        };
        this.getDateStr = function (d) {
            if (isNaN(d)) {
                // @ts-ignore
                return new Date().format('yyyy-MM-dd HH:mm:ss');
            }
            // @ts-ignore
            return new Date(d).format('yyyy-MM-dd HH:mm:ss');
        };
        //svg变更同步左侧table数据  
        this.synchronizeGridEditor = function (task, status) {
            var taskTr = __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#workSpace_" + _this_1.getGanttId).find('tr[data-taskid="' + task.id + '"]');
            if (status == 'jh') { //计划svg
                //处理开始日期
                if (_this_1.baseInfo.startaloneOrcombination == '1') { //单独日期时间
                    var startDateField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.startDateField + '"]');
                    var startTimeField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.startTimeField + '"]');
                    var st = _this_1.getDateStr(task.start).split(' ');
                    _this_1.modifyTd(startDateField[0], st[0], _this_1.baseInfo.startDateField, task);
                    _this_1.modifyTd(startTimeField[0], st[1].substring(0, 5), _this_1.baseInfo.startTimeField, task);
                }
                else {
                    var startDateTimeField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.gttstartDateTimeField + '"]');
                    _this_1.modifyTd(startDateTimeField[0], _this_1.getDateStr(task.start), _this_1.baseInfo.gttstartDateTimeField, task);
                }
                //处理结束日期
                if (_this_1.baseInfo.endaloneOrcombination == '1') {
                    var endDateField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.endDateField + '"]');
                    var endTimeField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.endTimeField + '"]');
                    var st = _this_1.getDateStr(task.end).split(' ');
                    _this_1.modifyTd(endDateField[0], st[0], _this_1.baseInfo.endDateField, task);
                    _this_1.modifyTd(endTimeField[0], st[1].substring(0, 5), _this_1.baseInfo.endTimeField, task);
                }
                else {
                    var endDateTimeField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.gttendDateTimeField + '"]');
                    _this_1.modifyTd(endDateTimeField[0], _this_1.getDateStr(task.end), _this_1.baseInfo.gttendDateTimeField, task);
                }
            }
            else if (status == 'actual') { //实际svg
                //处理开始日期
                if (_this_1.baseInfo.actualStartaloneOrcombination == '1') {
                    var startDateField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.actualStartDateField + '"]');
                    var startTimeField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.actualStartTimeField + '"]');
                    var st = _this_1.getDateStr(task.actualbegindate).split(' ');
                    _this_1.modifyTd(startDateField[0], st[0], _this_1.baseInfo.actualStartDateField, task);
                    _this_1.modifyTd(startTimeField[0], st[1].substring(0, 5), _this_1.baseInfo.actualStartTimeField, task);
                }
                else {
                    var startDateTimeField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.gttactualStartDateTimeField + '"]');
                    _this_1.modifyTd(startDateTimeField[0], _this_1.getDateStr(task.actualbegindate), _this_1.baseInfo.gttactualStartDateTimeField, task);
                }
                //处理结束日期
                if (_this_1.baseInfo.actualendaloneOrcombination == '1') {
                    var endDateField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.actualEndDateField + '"]');
                    var endTimeField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.actualEndTimeField + '"]');
                    var st = _this_1.getDateStr(task.actualenddate).split(' ');
                    _this_1.modifyTd(endDateField[0], st[0], _this_1.baseInfo.actualEndDateField, task);
                    _this_1.modifyTd(endTimeField[0], st[1].substring(0, 5), _this_1.baseInfo.actualEndTimeField, task);
                }
                else {
                    var endDateTimeField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.gttactualEndDateTimeField + '"]');
                    _this_1.modifyTd(endDateTimeField[0], _this_1.getDateStr(task.actualenddate), _this_1.baseInfo.gttactualEndDateTimeField, task);
                }
            }
        };
        //修改svg前置关系后同步grid
        this.synchronizeGridEditorFront = function (taskFrom, taskTo) {
            var taskTr = __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#workSpace_" + _this_1.getGanttId).find('tr[data-taskid="' + taskTo.id + '"]');
            var frontField = taskTr.find('td[fieldLink="field' + _this_1.baseInfo.frontField + '"]');
            _this_1.modifyTd(frontField[0], taskFrom.id, _this_1.baseInfo.frontField, taskTo, taskFrom.name);
            _this_1.modifiedSup(frontField[0], taskFrom.id, taskTo.id, 'field' + _this_1.baseInfo.frontField + '_value');
        };
        //修改字段值,记录svg修改的值
        this.modifyTd = function (td, value, fieldid, task, valueSpan) {
            if (valueSpan === void 0) { valueSpan = ''; }
            var innerText = value;
            var fieldLink = 'field' + fieldid;
            if (td) {
                if (task.hasOwnProperty('field' + fieldid + '_value')) {
                    task[fieldLink + '_value'] = value;
                    task['field' + fieldid] = valueSpan;
                    innerText = valueSpan;
                    _this_1.modifiedSup(td, value, task.id, 'field' + fieldid + '_value');
                }
                else {
                    task[fieldLink] = value;
                    _this_1.modifiedSup(td, value, task.id, 'field' + fieldid);
                }
                __WEBPACK_IMPORTED_MODULE_7_jquery___default()(td).find('span')[0].innerText = innerText;
            }
            else {
                if (task.hasOwnProperty('field' + fieldid + '_value')) { //浏览框字段
                    fieldLink = fieldLink + '_value';
                }
                if (!_this_1.datas[task.id] || value != _this_1.datas[task.id][fieldLink]) {
                    _this_1.otherModifiedDatas[task.id + '_field' + fieldid] = value;
                }
                else {
                    delete _this_1.otherModifiedDatas[task.id + '_field' + fieldid];
                }
            }
        };
    }
    Object.defineProperty(GanttStore.prototype, "getGanttId", {
        get: function () {
            return this.id;
        },
        enumerable: true,
        configurable: true
    });
    GanttStore.prototype.delHtmlTag = function (str) {
        return str.replace(/<[^>]+>/g, "");
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "loading", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "loadingtip", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "isInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "id", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "previousId", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "deletevisible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "rootId", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "timelinekey", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "datas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "fields", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "taskInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "litterTool", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "cardDiag_visible", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "cardDiag_url", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "baseInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "form", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "conditionInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "colorDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "toDelIds", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], GanttStore.prototype, "windowTitle", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "init", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "loadDatas", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "getConditionInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "doSearch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "doSearchSubmit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "cardSaveFun", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "addTaskRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "save", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "deleteTmpTaskRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "deleteTaskRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "editTaskRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "afterInit", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "cancelEditTaskRow", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "showTaskInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "closeTaskInfo", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "update", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["computed"]
    ], GanttStore.prototype, "getGanttId", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["action"]
    ], GanttStore.prototype, "openDialog", void 0);
    return GanttStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (GanttStore);


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newUrl */
/* unused harmony export CallAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getGanttDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return save; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getConditionInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return doSearchDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getColors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var newUrl = '/api/cube/visual/gantt/';
var CallAPI = function (url, method, params) {
    return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_0_ecCom__["WeaTools"].callApi(url, method, params).then(function (_a) {
            var noRight = _a.noRight, data = __rest(_a, ["noRight"]);
            if (noRight) {
                resolve(__assign({ noRight: noRight }, data));
            }
            else {
                resolve(data);
            }
        });
    });
};
var getGanttDatas = function (params) {
    return CallAPI(newUrl + "getDatas", "get", params);
};
var save = function (params) {
    return CallAPI(newUrl + "save", "post", params);
};
var deleteDatas = function (params) {
    return CallAPI(newUrl + "deleteDatas", "post", params);
};
var getConditionInfo = function (params) {
    return CallAPI(newUrl + "condition", "get", params);
};
var doSearchDatas = function (params) {
    return CallAPI(newUrl + "doSearchDatas", "get", params);
};
var getColors = function (params) {
    return CallAPI(newUrl + "getColors", "get", params);
};


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_less__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_less__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rightMenuWrap_less__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rightMenuWrap_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rightMenuWrap_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__topTitle_less__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__topTitle_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__topTitle_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__advanced_less__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__advanced_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__advanced_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_less__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__form_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__batchedit_less__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__batchedit_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__batchedit_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree_less__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tree_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__card_less__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__card_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__card_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__spin_css__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__spin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__spin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__checkbox_css__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__abutton_css__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__abutton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__abutton_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__input_css__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__list_less__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__list_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__list_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__resource_less__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__resource_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__resource_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fonticon_less__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fonticon_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__fonticon_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modetab_css__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modetab_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__modetab_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tooltip_css__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__table_css__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__select_css__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__radio_css__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pagination_css__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__menu_css__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__layout_css__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dropdown_css__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__inputnumber_css__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__inputnumber_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__inputnumber_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__wea_ckeditor_content_less__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__wea_ckeditor_content_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__wea_ckeditor_content_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__popover_less__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__popover_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__popover_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__dev_electricsign_less__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__dev_electricsign_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__dev_electricsign_less__);































/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopTitle__ = __webpack_require__(357);
/* unused harmony reexport TopProps */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TopTitle__["a" /* default */]);


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var AdvancedButton = /** @class */ (function (_super) {
    __extends(AdvancedButton, _super);
    function AdvancedButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleVisibleChange = function () {
            var advanced = _this.props.advanced;
            advanced.update({ visible: !advanced.visible });
        };
        return _this;
    }
    AdvancedButton.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@g5g9r5", onClick: this.handleVisibleChange }, getLabel(347, '高级搜索')));
    };
    AdvancedButton.defaultProps = {
        prefixCls: 'coms-mode-top-title-ab'
    };
    AdvancedButton = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], AdvancedButton);
    return AdvancedButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (AdvancedButton);


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var RightMenuWrap = /** @class */ (function (_super) {
    __extends(RightMenuWrap, _super);
    function RightMenuWrap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleButtonClick = function (key) {
            var rightMenuClick = _this.props.rightMenuClick;
            rightMenuClick && rightMenuClick(key);
        };
        _this.handleMenuClick = function (_a) {
            var key = _a.key;
            var rightMenuClick = _this.props.rightMenuClick;
            rightMenuClick && rightMenuClick(key);
        };
        _this.renderMenus = function (rightMenus) {
            var prefixCls = _this.props.prefixCls;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls + "-drop-wrap" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls + "-drop-icon-bg" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@x5gccu", prefixCls: "mode-dropdown-menu", className: prefixCls + "-drop-menu", onClick: _this.handleMenuClick }, rightMenus.map(function (d, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@j2yx7p@" + i, key: d.key || i, disabled: d.disabled },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: prefixCls + "-drop-icon" }, d.icon),
                        d.content);
                }))));
        };
        return _this;
    }
    RightMenuWrap.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.prefixCls, prefixCls = _b === void 0 ? "coms-mode-menu-wrap" : _b, rightMenuClick = _a.rightMenuClick, _c = _a.rightMenus, rightMenus = _c === void 0 ? [] : _c, _d = _a.isDialog, isDialog = _d === void 0 ? false : _d, children = _a.children, _e = _a.quickSize, quickSize = _e === void 0 ? 5 : _e, _f = _a.hideRightmenu, hideRightmenu = _f === void 0 ? false : _f, needFixedToTop = _a.needFixedToTop;
        if (hideRightmenu) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, { ecId: (this && this.props && this.props.ecId || '') + "_React.Fragment@mpdtf8" },
                children,
                " ");
        }
        if (isDialog) {
            var quickMenus = rightMenus.slice(0, quickSize);
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls, ref: "_container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@fsfk9g", datas: rightMenus, onClick: rightMenuClick, collectParams: {
                        "favname": "",
                        "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                        "favouritetype": 5,
                        "importantlevel": 1
                    } }, children),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@7v51jz", className: prefixCls + "-row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@yxvfm9", span: 24 },
                        quickMenus && quickMenus.map(function (btn, i) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@hm3ber@" + i, type: "primary", onClick: _this.handleButtonClick.bind(_this, btn.key) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: prefixCls + "-btn-icon" }, btn.icon),
                            btn.content)); }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Dropdown"], { ecId: (this && this.props && this.props.ecId || '') + "_Dropdown@s25pmo", getPopupContainer: function () { return _this.refs._container; }, overlay: this.renderMenus(rightMenus), placement: "topRight", trigger: "click" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@f2eaef" }, "\u66F4\u591A>>"))))));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@aej31g", datas: rightMenus, onClick: rightMenuClick, collectParams: {
                    "favname": "",
                    "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                    "favouritetype": 5,
                    "importantlevel": 1
                }, handleVisible: function (isshow) {
                    if (isshow && needFixedToTop) {
                        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.coms-mode-viewResource .list-container .wea-right-menu-wrap .wea-right-menu').eq(0).addClass('viewResource-right-menu-toTop');
                    }
                } }, children));
        }
    };
    RightMenuWrap.defaultProps = {
        prefixCls: "coms-mode-menu-wrap",
    };
    RightMenuWrap = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], RightMenuWrap);
    return RightMenuWrap;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RightMenuWrap);


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var Advanced = /** @class */ (function (_super) {
    __extends(Advanced, _super);
    function Advanced() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hide = function () {
            _this.props.advanced.update({ visible: false });
        };
        _this.fixScroll = function () {
            var prefixCls = _this.props.prefixCls;
            var $this = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this));
            var winHeight = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').height();
            var height = Math.min($this.height(), winHeight) - 90;
            $this.find("." + prefixCls + "-content").css({ 'height': height });
        };
        return _this;
    }
    Advanced.prototype.componentDidMount = function () {
        var _this = this;
        window.onresize = function () {
            if (_this._timer) {
                clearTimeout(_this._timer);
            }
            _this._timer = setTimeout(function () {
                _this.fixScroll();
            }, 200);
        };
        this.fixScroll();
    };
    Advanced.prototype.componentDidUpdate = function () {
        this.fixScroll();
    };
    Advanced.prototype.render = function () {
        var _a;
        var _b = this.props, prefixCls = _b.prefixCls, className = _b.className, content = _b.content, buttons = _b.buttons;
        var _c = this.props.advanced.visible, visible = _c === void 0 ? false : _c;
        var classNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls, className, (_a = {}, _a[prefixCls + "-hide"] = !visible, _a));
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: classNames },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls + "-content" }, content),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls + "-buttons" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'center' } }, buttons.map(function (btn) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { marginLeft: 15 } }, btn)); }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls + "-mask" })));
    };
    Advanced.defaultProps = {
        prefixCls: 'coms-mode-advanced',
    };
    Advanced = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], Advanced);
    return Advanced;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Advanced);


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TemplateDialog; });
/* unused harmony export getTemplate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _this = this;





var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var Template = /** @class */ (function (_super) {
    __extends(Template, _super);
    function Template() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Template.prototype.render = function () {
        var _this = this;
        var template = this.props.template;
        var formParams = template.form.getFormParams();
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, template.fields.map(function (d, idn) {
            var key = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].getKey(d);
            var error = template.errors[key];
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-search-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@1bnz2q@" + idn, label: d.label, labelCol: { span: d.labelcol }, wrapperCol: { span: d.fieldcol }, error: template.form.getError(d), tipPosition: "bottom" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_comsMobx__["WeaSwitch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSwitch@78qfe7@" + idn, fieldConfig: d, form: template.form, formParams: formParams, onChange: template.clearError.bind(_this, key) }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "form-item-error", dangerouslySetInnerHTML: { __html: error && "<span style=\"color:#f50;\"><i class=\"anticon anticon-cross-circle\" ></i>" + error + "</span>" } }))));
        })));
    };
    Template = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Template);
    return Template;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (Template);
var TemplateDialog = /** @class */ (function (_super) {
    __extends(TemplateDialog, _super);
    function TemplateDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplateDialog.prototype.render = function () {
        var _a = this.props, template = _a.template, params = _a.params;
        var iconInfo = params.iconInfo;
        var buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@epln74@onCancel", onClick: template.onCancel }, getLabel(309, "关闭")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@8emr1h@onOk", type: "primary", loading: template.loading, onClick: template.onOk.bind(this, params) }, getLabel(86, '保存'))];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@0v9x6l", className: 'wea-auth-modal cube-dialog', buttons: buttons, title: getLabel(16388, '新建模板'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: template.visible, style: { width: 520, height: 250 }, hasScroll: true, onCancel: template.onCancel },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Template, { ecId: (this && this.props && this.props.ecId || '') + "_Template@8qpqtw", template: template })));
    };
    TemplateDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TemplateDialog);
    return TemplateDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var getTemplate = function (template) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Template, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Template@fvxi2b", template: template });
};


/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabSetDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;
var TabSetDialog = /** @class */ (function (_super) {
    __extends(TabSetDialog, _super);
    function TabSetDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.closeDoalog = function () {
            var Search = _this.props.Search;
            Search.tagVisible = false;
        };
        _this.onSave = function () {
            var Search = _this.props.Search;
            var _a = Search.treeKey, treeKey = _a === void 0 ? [] : _a, _b = Search.selectRowkeys, selectRowkeys = _b === void 0 ? [] : _b;
            var selectTab = _this.refs.modetab['wrappedInstance'].state.tags;
            var tabids = '';
            if (selectTab.length <= 0) {
                _this.refs.listTagAdd["showError"]();
                return;
            }
            selectTab.map(function (tab) {
                tabids = tabids + tab.id + ",";
            });
            tabids = tabids.replace(/,$/, '');
            var selectedRowsAllPages = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(_this.props.Search.newTable.selectedRowKeysAllPages.map(function (d) { return d.split('_')[0]; })).join(',');
            var parm = { billids: treeKey.length > 0 ? __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(treeKey.map(function (d) { return d.split('_')[0]; })).join(",") : selectRowkeys.length > 0 ? __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(selectRowkeys.map(function (d) { return d.split('_')[0]; })).join(',') : selectedRowsAllPages, ids: tabids };
            Search.saveTabBatch(parm);
        };
        _this.state = {
            visible: false,
            tabid: '',
            tabname: '',
            color: '#000',
            orderid: '',
        };
        return _this;
    }
    TabSetDialog.prototype.render = function () {
        var Search = this.props.Search;
        var iconInfo = Search.iconInfo, _a = Search.treeKey, treeKey = _a === void 0 ? [] : _a, _b = Search.selectRowkeys, selectRowkeys = _b === void 0 ? [] : _b;
        var buttons = new Array();
        var selectedRowsAllPages = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(this.props.Search.newTable.selectedRowKeysAllPages.map(function (d) {
            if (d.indexOf('_') > -1) {
                return d.split('_')[0];
            }
            else {
                return d;
            }
        }));
        if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.compact(treeKey).length > 0) {
            selectedRowsAllPages = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.compact(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["toJS"])(treeKey)).map(function (d) {
                if (d.indexOf('_') > -1) {
                    return d.split('_')[0];
                }
                else {
                    return d;
                }
            }));
        }
        if (selectRowkeys.length > 0) {
            selectedRowsAllPages = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(selectRowkeys.map(function (d) { return d.split('_')[0]; }));
        }
        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@mtt6de@onSave", type: "primary", onClick: this.onSave }, getLabel(86, "保存")));
        buttons.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@extmng@closeDoalog", onClick: this.closeDoalog }, getLabel(309, "关闭")));
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@dtgywf", style: { width: 600, height: 150 }, onCancel: this.closeDoalog, iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", title: getLabel(384962, "批量设置标签"), visible: Search.tagVisible, buttons: buttons },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: 30 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: 20 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: 'red', height: 20, lineHeight: '20px', float: 'left' } },
                            getLabel('385398', "您已选中"),
                            selectedRowsAllPages.length,
                            getLabel(30690, "条数据"))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginTop: 10 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-mode-tag", style: { color: '#757575', display: 'inline-block', float: 'left', marginTop: 10 } }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaError"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaError@s90gjo", tipPosition: 'bottom', error: getLabel(385311, '标签不能为空！'), style: { display: "block" }, ref: "listTagAdd" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ModeTab@x4t6te", ref: "modetab", container: ".wea-dialog", modeid: Search.modeId, billid: '' })))))));
    };
    TabSetDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], TabSetDialog);
    return TabSetDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

;


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interface__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__interface__);
/* unused harmony namespace reexport */


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */]);


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_table__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locale_provider_LocaleReceiver__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locale_provider_default__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filterDropdown__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__createStore__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SelectionBox__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SelectionCheckboxAll__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Column__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ColumnGroup__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__createBodyRow__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util__ = __webpack_require__(962);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


















function noop() {
}
function stopPropagation(e) {
    e.stopPropagation();
    if (e.nativeEvent.stopImmediatePropagation) {
        e.nativeEvent.stopImmediatePropagation();
    }
}
var defaultPagination = {
    onChange: noop,
    onShowSizeChange: noop,
};
/**
 * Avoid creating new object, so that parent component's shouldComponentUpdate
 * can works appropriately。
 */
var emptyObject = {};
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.getCheckboxPropsByItem = function (item, index) {
            var _a = _this.props.rowSelection, rowSelection = _a === void 0 ? {} : _a;
            if (!rowSelection.getCheckboxProps) {
                return {};
            }
            var key = _this.getRecordKey(item, index);
            // Cache checkboxProps
            if (!_this.CheckboxPropsCache[key]) {
                _this.CheckboxPropsCache[key] = rowSelection.getCheckboxProps(item);
            }
            return _this.CheckboxPropsCache[key];
        };
        _this.onRow = function (record, index) {
            var _a = _this.props, onRow = _a.onRow, prefixCls = _a.prefixCls;
            var custom = onRow ? onRow(record, index) : {};
            return __assign({}, custom, { prefixCls: prefixCls, store: _this.store, rowKey: _this.getRecordKey(record, index) });
        };
        _this.handleFilter = function (column, nextFilters) {
            var _a;
            var props = _this.props;
            var pagination = __assign({}, _this.state.pagination);
            var filters = __assign({}, _this.state.filters, (_a = {}, _a[_this.getColumnKey(column)] = nextFilters, _a));
            // Remove filters not in current columns
            var currentColumnKeys = [];
            Object(__WEBPACK_IMPORTED_MODULE_16__util__["d" /* treeMap */])(_this.columns, function (c) {
                if (!c.children) {
                    currentColumnKeys.push(_this.getColumnKey(c));
                }
            });
            Object.keys(filters).forEach(function (columnKey) {
                if (currentColumnKeys.indexOf(columnKey) < 0) {
                    delete filters[columnKey];
                }
            });
            if (props.pagination) {
                // Reset current prop
                pagination.current = 1;
                pagination.onChange(pagination.current);
            }
            var newState = {
                pagination: pagination,
                filters: {},
            };
            var filtersToSetState = __assign({}, filters);
            // Remove filters which is controlled
            _this.getFilteredValueColumns().forEach(function (col) {
                var columnKey = _this.getColumnKey(col);
                if (columnKey) {
                    delete filtersToSetState[columnKey];
                }
            });
            if (Object.keys(filtersToSetState).length > 0) {
                newState.filters = filtersToSetState;
            }
            // Controlled current prop will not respond user interaction
            if (typeof props.pagination === 'object' && 'current' in props.pagination) {
                newState.pagination = __assign({}, pagination, { current: _this.state.pagination.current });
            }
            _this.setState(newState, function () {
                _this.store.setState({
                    selectionDirty: false,
                });
                var onChange = _this.props.onChange;
                if (onChange) {
                    onChange.apply(null, _this.prepareParamsArguments(__assign({}, _this.state, { selectionDirty: false, filters: filters,
                        pagination: pagination })));
                }
            });
        };
        _this.handleSelect = function (record, rowIndex, e) {
            var checked = e.target.checked;
            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
            var key = _this.getRecordKey(record, rowIndex);
            if (checked) {
                selectedRowKeys.push(_this.getRecordKey(record, rowIndex));
            }
            else {
                selectedRowKeys = selectedRowKeys.filter(function (i) { return key !== i; });
            }
            _this.store.setState({
                selectionDirty: true,
            });
            _this.setSelectedRowKeys(selectedRowKeys, {
                selectWay: 'onSelect',
                record: record,
                checked: checked,
            });
        };
        _this.handleRadioSelect = function (record, rowIndex, e) {
            var checked = e.target.checked;
            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
            var key = _this.getRecordKey(record, rowIndex);
            selectedRowKeys = [key];
            _this.store.setState({
                selectionDirty: true,
            });
            _this.setSelectedRowKeys(selectedRowKeys, {
                selectWay: 'onSelect',
                record: record,
                checked: checked,
            });
        };
        _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
            var data = _this.getFlatCurrentPageData();
            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
            var changeableRowKeys = data
                .filter(function (item, i) { return !_this.getCheckboxPropsByItem(item, i).disabled; })
                .map(function (item, i) { return _this.getRecordKey(item, i); });
            var changeRowKeys = [];
            var selectWay = '';
            var checked;
            // handle default selection
            switch (selectionKey) {
                case 'all':
                    changeableRowKeys.forEach(function (key) {
                        if (selectedRowKeys.indexOf(key) < 0) {
                            selectedRowKeys.push(key);
                            changeRowKeys.push(key);
                        }
                    });
                    selectWay = 'onSelectAll';
                    checked = true;
                    break;
                case 'removeAll':
                    changeableRowKeys.forEach(function (key) {
                        if (selectedRowKeys.indexOf(key) >= 0) {
                            selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
                            changeRowKeys.push(key);
                        }
                    });
                    selectWay = 'onSelectAll';
                    checked = false;
                    break;
                case 'invert':
                    changeableRowKeys.forEach(function (key) {
                        if (selectedRowKeys.indexOf(key) < 0) {
                            selectedRowKeys.push(key);
                        }
                        else {
                            selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
                        }
                        changeRowKeys.push(key);
                        selectWay = 'onSelectInvert';
                    });
                    break;
                default:
                    break;
            }
            _this.store.setState({
                selectionDirty: true,
            });
            // when select custom selection, callback selections[n].onSelect
            var rowSelection = _this.props.rowSelection;
            var customSelectionStartIndex = 2;
            if (rowSelection && rowSelection.hideDefaultSelections) {
                customSelectionStartIndex = 0;
            }
            if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
                return onSelectFunc(changeableRowKeys);
            }
            _this.setSelectedRowKeys(selectedRowKeys, {
                selectWay: selectWay,
                checked: checked,
                changeRowKeys: changeRowKeys,
            });
        };
        _this.handlePageChange = function (current) {
            var otherArguments = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                otherArguments[_i - 1] = arguments[_i];
            }
            var props = _this.props;
            var pagination = __assign({}, _this.state.pagination);
            if (current) {
                pagination.current = current;
            }
            else {
                pagination.current = pagination.current || 1;
            }
            pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
            var newState = {
                pagination: pagination,
            };
            // Controlled current prop will not respond user interaction
            if (props.pagination &&
                typeof props.pagination === 'object' &&
                'current' in props.pagination) {
                newState.pagination = __assign({}, pagination, { current: _this.state.pagination.current });
            }
            _this.setState(newState);
            _this.store.setState({
                selectionDirty: false,
            });
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange.apply(null, _this.prepareParamsArguments(__assign({}, _this.state, { selectionDirty: false, pagination: pagination })));
            }
        };
        _this.renderSelectionBox = function (type) {
            return function (_, record, index) {
                var rowIndex = _this.getRecordKey(record, index); // 从 1 开始
                var props = _this.getCheckboxPropsByItem(record, index);
                var handleChange = function (e) {
                    type === 'radio' ? _this.handleRadioSelect(record, rowIndex, e) :
                        _this.handleSelect(record, rowIndex, e);
                };
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: stopPropagation },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__SelectionBox__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_SelectionBox@0ts14s", type: type, store: _this.store, rowIndex: rowIndex, onChange: handleChange, defaultSelection: _this.getDefaultSelection() }, props))));
            };
        };
        _this.getRecordKey = function (record, index) {
            var rowKey = _this.props.rowKey;
            var recordKey = (typeof rowKey === 'function') ?
                rowKey(record, index) : record[rowKey];
            return recordKey === undefined ? index : recordKey;
        };
        _this.getPopupContainer = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_this);
        };
        _this.handleShowSizeChange = function (current, pageSize) {
            var pagination = _this.state.pagination;
            pagination.onShowSizeChange(current, pageSize);
            var nextPagination = __assign({}, pagination, { pageSize: pageSize,
                current: current });
            _this.setState({ pagination: nextPagination });
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange.apply(null, _this.prepareParamsArguments(__assign({}, _this.state, { pagination: nextPagination })));
            }
        };
        _this.regroupMergeLine = function (Childrens) {
            if (Childrens) {
                var _loop_1 = function (i) {
                    if (Childrens[i].key) {
                        Childrens[i].render = Childrens[i].render ? Childrens[i].render : function (text, record, index) { return _this.props.renderCell(Childrens[i], _this.getRecordKey(record, index), record, text, index); };
                    }
                    else {
                        _this.regroupMergeLine(Childrens[i].children);
                    }
                };
                for (var i = 0; i < Childrens.length; i++) {
                    _loop_1(i);
                }
                return Childrens;
            }
        };
        _this.renderTable = function (contextLocale) {
            var _a;
            var locale = __assign({}, contextLocale, _this.props.locale);
            var _b = _this.props, rowSelection = _b.rowSelection, style = _b.style, loading = _b.loading, className = _b.className, prefixCls = _b.prefixCls, showHeader = _b.showHeader, restProps = __rest(_b, ["rowSelection", "style", "loading", "className", "prefixCls", "showHeader"]);
            var data = _this.getCurrentPageData();
            var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false;
            var classString = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_a = {},
                _a[prefixCls + "-" + _this.props.size] = true,
                _a[prefixCls + "-bordered"] = _this.props.bordered,
                _a[prefixCls + "-empty"] = !data.length,
                _a[prefixCls + "-without-column-header"] = !showHeader,
                _a));
            var columns = _this.renderRowSelection(locale);
            //columns = this.renderColumnsDropdown(columns, locale);
            columns = columns.map(function (column, i) {
                var newColumn = __assign({}, column);
                newColumn.key = _this.getColumnKey(newColumn, i);
                if (column.children) {
                    newColumn.children = _this.regroupMergeLine(column.children);
                }
                else {
                    newColumn.render = newColumn.render ? newColumn.render : function (text, record, index) { return _this.props.renderCell(column, _this.getRecordKey(record, index), record, text, index); };
                }
                return newColumn;
            });
            columns = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(columns, function (item) { return item.fieldid !== '-10'; }); // 不展示数组最后一项保密期限
            var expandIconColumnIndex = (columns[0] && columns[0].key === 'selection-column') ? 1 : 0;
            if ('expandIconColumnIndex' in restProps) {
                expandIconColumnIndex = restProps.expandIconColumnIndex;
            }
            var scroll;
            if (!rowSelection) { //仅对批量修改操作
                scroll = _this.getScroll(columns);
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_table__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_RcTable@sq798s", key: "table" }, restProps, { onRow: _this.onRow, components: _this.components, prefixCls: prefixCls, data: data, columns: columns, showHeader: showHeader, className: classString, expandIconColumnIndex: expandIconColumnIndex, expandIconAsCell: expandIconAsCell, emptyText: !loading && locale.emptyText, needScroll: true, scroll: scroll })));
        };
        _this.getScroll = function (columns) {
            var width = 0, height = document.documentElement.clientHeight;
            columns.map(function (column) {
                if (column.width) {
                    if (typeof column.width === 'string') {
                        if (column.width.indexOf('%') > -1) {
                            width += document.documentElement.clientWidth * parseFloat(column.width.replace('%', ''));
                        }
                        else {
                            width += width += parseFloat(column.width);
                        }
                    }
                    else if (typeof column.width === 'number') {
                        width += (document.documentElement.clientWidth * column.width) / 100;
                    }
                }
                else {
                    width += 100;
                }
            });
            return {
                x: width,
                y: height - 214
            };
        };
        _this.columns = props.columns || Object(__WEBPACK_IMPORTED_MODULE_16__util__["c" /* normalizeColumns */])(props.children);
        _this.createComponents(props.components);
        _this.state = __assign({}, _this.getDefaultSortOrder(_this.columns), { 
            // 减少状态
            filters: _this.getFiltersFromColumns(), pagination: _this.getDefaultPagination(props) });
        _this.CheckboxPropsCache = {};
        _this.store = Object(__WEBPACK_IMPORTED_MODULE_10__createStore__["a" /* default */])({
            selectedRowKeys: (props.rowSelection || {}).selectedRowKeys || [],
            selectionDirty: false,
        });
        return _this;
    }
    Table.prototype.getDefaultSelection = function () {
        var _this = this;
        var _a = this.props.rowSelection, rowSelection = _a === void 0 ? {} : _a;
        if (!rowSelection.getCheckboxProps) {
            return [];
        }
        return this.getFlatData()
            .filter(function (item, rowIndex) { return _this.getCheckboxPropsByItem(item, rowIndex).defaultChecked; })
            .map(function (record, rowIndex) { return _this.getRecordKey(record, rowIndex); });
    };
    Table.prototype.getDefaultPagination = function (props) {
        var pagination = props.pagination || {};
        return this.hasPagination(props) ? __assign({}, defaultPagination, pagination, { current: pagination.defaultCurrent || pagination.current || 1, pageSize: pagination.defaultPageSize || pagination.pageSize || 10 }) : {};
    };
    Table.prototype.componentWillReceiveProps = function (nextProps) {
        this.columns = nextProps.columns || Object(__WEBPACK_IMPORTED_MODULE_16__util__["c" /* normalizeColumns */])(nextProps.children);
        if ('pagination' in nextProps || 'pagination' in this.props) {
            this.setState(function (previousState) {
                var newPagination = __assign({}, defaultPagination, previousState.pagination, nextProps.pagination);
                newPagination.current = newPagination.current || 1;
                newPagination.pageSize = newPagination.pageSize || 10;
                return { pagination: nextProps.pagination !== false ? newPagination : emptyObject };
            });
        }
        if (nextProps.rowSelection &&
            'selectedRowKeys' in nextProps.rowSelection) {
            this.store.setState({
                selectedRowKeys: nextProps.rowSelection.selectedRowKeys || [],
            });
            var rowSelection = this.props.rowSelection;
            if (rowSelection && (nextProps.rowSelection.getCheckboxProps !== rowSelection.getCheckboxProps)) {
                this.CheckboxPropsCache = {};
            }
        }
        if ('dataSource' in nextProps &&
            nextProps.dataSource !== this.props.dataSource) {
            this.store.setState({
                selectionDirty: false,
            });
            this.CheckboxPropsCache = {};
        }
        if (this.getSortOrderColumns(this.columns).length > 0) {
            var sortState = this.getSortStateFromColumns(this.columns);
            if (sortState.sortColumn !== this.state.sortColumn ||
                sortState.sortOrder !== this.state.sortOrder) {
                this.setState(sortState);
            }
        }
        var filteredValueColumns = this.getFilteredValueColumns(this.columns);
        if (filteredValueColumns.length > 0) {
            var filtersFromColumns_1 = this.getFiltersFromColumns(this.columns);
            var newFilters_1 = __assign({}, this.state.filters);
            Object.keys(filtersFromColumns_1).forEach(function (key) {
                newFilters_1[key] = filtersFromColumns_1[key];
            });
            if (this.isFiltersChanged(newFilters_1)) {
                this.setState({ filters: newFilters_1 });
            }
        }
        this.createComponents(nextProps.components, this.props.components);
    };
    Table.prototype.setSelectedRowKeys = function (selectedRowKeys, _a) {
        var _this = this;
        var selectWay = _a.selectWay, record = _a.record, checked = _a.checked, changeRowKeys = _a.changeRowKeys;
        var _b = this.props.rowSelection, rowSelection = _b === void 0 ? {} : _b;
        if (rowSelection && !('selectedRowKeys' in rowSelection)) {
            this.store.setState({ selectedRowKeys: selectedRowKeys });
        }
        var data = this.getFlatData();
        if (!rowSelection.onChange && !rowSelection[selectWay]) {
            return;
        }
        var selectedRows = data.filter(function (row, i) { return selectedRowKeys.indexOf(_this.getRecordKey(row, i)) >= 0; });
        if (rowSelection.onChange) {
            rowSelection.onChange(selectedRowKeys, selectedRows);
        }
        if (selectWay === 'onSelect' && rowSelection.onSelect) {
            rowSelection.onSelect(record, checked, selectedRows);
        }
        else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
            var changeRows = data.filter(function (row, i) { return changeRowKeys.indexOf(_this.getRecordKey(row, i)) >= 0; });
            rowSelection.onSelectAll(checked, selectedRows, changeRows);
        }
        else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
            rowSelection.onSelectInvert(selectedRowKeys);
        }
    };
    Table.prototype.hasPagination = function (props) {
        return (props || this.props).pagination !== false;
    };
    Table.prototype.isFiltersChanged = function (filters) {
        var _this = this;
        var filtersChanged = false;
        if (Object.keys(filters).length !== Object.keys(this.state.filters).length) {
            filtersChanged = true;
        }
        else {
            Object.keys(filters).forEach(function (columnKey) {
                if (filters[columnKey] !== _this.state.filters[columnKey]) {
                    filtersChanged = true;
                }
            });
        }
        return filtersChanged;
    };
    Table.prototype.getSortOrderColumns = function (columns) {
        return Object(__WEBPACK_IMPORTED_MODULE_16__util__["b" /* flatFilter */])(columns || this.columns || [], function (column) { return 'sortOrder' in column; });
    };
    Table.prototype.getFilteredValueColumns = function (columns) {
        return Object(__WEBPACK_IMPORTED_MODULE_16__util__["b" /* flatFilter */])(columns || this.columns || [], function (column) { return typeof column.filteredValue !== 'undefined'; });
    };
    Table.prototype.getFiltersFromColumns = function (columns) {
        var _this = this;
        var filters = {};
        this.getFilteredValueColumns(columns).forEach(function (col) {
            var colKey = _this.getColumnKey(col);
            filters[colKey] = col.filteredValue;
        });
        return filters;
    };
    Table.prototype.getDefaultSortOrder = function (columns) {
        var definedSortState = this.getSortStateFromColumns(columns);
        var defaultSortedColumn = Object(__WEBPACK_IMPORTED_MODULE_16__util__["b" /* flatFilter */])(columns || [], function (column) { return column.defaultSortOrder != null; })[0];
        if (defaultSortedColumn && !definedSortState.sortColumn) {
            return {
                sortColumn: defaultSortedColumn,
                sortOrder: defaultSortedColumn.defaultSortOrder,
            };
        }
        return definedSortState;
    };
    Table.prototype.getSortStateFromColumns = function (columns) {
        // return first column which sortOrder is not falsy
        var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) { return col.sortOrder; })[0];
        if (sortedColumn) {
            return {
                sortColumn: sortedColumn,
                sortOrder: sortedColumn.sortOrder,
            };
        }
        return {
            sortColumn: null,
            sortOrder: null,
        };
    };
    Table.prototype.getSorterFn = function () {
        var _a = this.state, sortOrder = _a.sortOrder, sortColumn = _a.sortColumn;
        if (!sortOrder || !sortColumn ||
            typeof sortColumn.sorter !== 'function') {
            return;
        }
        return function (a, b) {
            var result = sortColumn.sorter(a, b);
            if (result !== 0) {
                return (sortOrder === 'descend') ? -result : result;
            }
            return 0;
        };
    };
    Table.prototype.toggleSortOrder = function (order, column) {
        var _a = this.state, sortColumn = _a.sortColumn, sortOrder = _a.sortOrder;
        // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题
        var isSortColumn = this.isSortColumn(column);
        if (!isSortColumn) { // 当前列未排序
            sortOrder = order;
            sortColumn = column;
        }
        else { // 当前列已排序
            if (sortOrder === order) { // 切换为未排序状态
                sortOrder = '';
                sortColumn = null;
            }
            else { // 切换为排序状态
                sortOrder = order;
            }
        }
        var newState = {
            sortOrder: sortOrder,
            sortColumn: sortColumn,
        };
        // Controlled
        if (this.getSortOrderColumns().length === 0) {
            this.setState(newState);
        }
        var onChange = this.props.onChange;
        if (onChange) {
            onChange.apply(null, this.prepareParamsArguments(__assign({}, this.state, newState)));
        }
    };
    Table.prototype.renderRowSelection = function (locale) {
        var _this = this;
        var _a;
        var _b = this.props, prefixCls = _b.prefixCls, rowSelection = _b.rowSelection;
        var columns = this.columns.concat();
        if (rowSelection) {
            var data = this.getFlatCurrentPageData().filter(function (item, index) {
                if (rowSelection.getCheckboxProps) {
                    return !_this.getCheckboxPropsByItem(item, index).disabled;
                }
                return true;
            });
            var selectionColumnClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(prefixCls + "-selection-column", (_a = {},
                _a[prefixCls + "-selection-column-custom"] = rowSelection.selections,
                _a));
            var selectionColumn = {
                key: 'selection-column',
                render: this.renderSelectionBox(rowSelection.type),
                className: selectionColumnClass,
                fixed: rowSelection.fixed,
            };
            if (rowSelection.type !== 'radio') {
                var checkboxAllDisabled = data.every(function (item, index) { return _this.getCheckboxPropsByItem(item, index).disabled; });
                selectionColumn.title = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SelectionCheckboxAll__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_SelectionCheckboxAll@o0zrx8", store: this.store, locale: locale, data: data, getCheckboxPropsByItem: this.getCheckboxPropsByItem, getRecordKey: this.getRecordKey, disabled: checkboxAllDisabled, prefixCls: prefixCls, onSelect: this.handleSelectRow, selections: rowSelection.selections, hideDefaultSelections: rowSelection.hideDefaultSelections, getPopupContainer: this.getPopupContainer }));
            }
            if ('fixed' in rowSelection) {
                selectionColumn.fixed = rowSelection.fixed;
            }
            else if (columns.some(function (column) { return column.fixed === 'left' || column.fixed === true; })) {
                selectionColumn.fixed = 'left';
            }
            selectionColumn.width = 62;
            if (columns[0] && columns[0].key === 'selection-column') {
                columns[0] = selectionColumn;
            }
            else {
                columns.unshift(selectionColumn);
            }
        }
        return columns;
    };
    Table.prototype.getColumnKey = function (column, index) {
        return column.key || column.dataIndex || index;
    };
    Table.prototype.getMaxCurrent = function (total) {
        var _a = this.state.pagination, current = _a.current, pageSize = _a.pageSize;
        if ((current - 1) * pageSize >= total) {
            return Math.floor((total - 1) / pageSize) + 1;
        }
        return current;
    };
    Table.prototype.isSortColumn = function (column) {
        var sortColumn = this.state.sortColumn;
        if (!column || !sortColumn) {
            return false;
        }
        return this.getColumnKey(sortColumn) === this.getColumnKey(column);
    };
    Table.prototype.renderColumnsDropdown = function (columns, locale) {
        var _this = this;
        var _a = this.props, prefixCls = _a.prefixCls, dropdownPrefixCls = _a.dropdownPrefixCls;
        var sortOrder = this.state.sortOrder;
        return Object(__WEBPACK_IMPORTED_MODULE_16__util__["d" /* treeMap */])(columns, function (originColumn, i) {
            var _a;
            var column = __assign({}, originColumn);
            var key = _this.getColumnKey(column, i);
            var filterDropdown;
            var sortButton;
            if ((column.filters && column.filters.length > 0) || column.filterDropdown) {
                var colFilters = _this.state.filters[key] || [];
                filterDropdown = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__filterDropdown__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_FilterDropdown@jmz48g", locale: locale, column: column, selectedKeys: colFilters, confirmFilter: _this.handleFilter, prefixCls: prefixCls + "-filter", dropdownPrefixCls: dropdownPrefixCls || 'cube-dropdown', getPopupContainer: _this.getPopupContainer }));
            }
            if (column.sorter) {
                var isSortColumn = _this.isSortColumn(column);
                if (isSortColumn) {
                    column.className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(column.className, (_a = {},
                        _a[prefixCls + "-column-sort"] = sortOrder,
                        _a));
                }
                var isAscend = isSortColumn && sortOrder === 'ascend';
                var isDescend = isSortColumn && sortOrder === 'descend';
                sortButton = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: prefixCls + "-column-sorter" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: prefixCls + "-column-sorter-up " + (isAscend ? 'on' : 'off'), title: "\u2191", onClick: function () { return _this.toggleSortOrder('ascend', column); } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "anticon anticon-caret-up" })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: prefixCls + "-column-sorter-down " + (isDescend ? 'on' : 'off'), title: "\u2193", onClick: function () { return _this.toggleSortOrder('descend', column); } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "anticon anticon-caret-down" }))));
            }
            column.title = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                column.title,
                sortButton,
                filterDropdown));
            return column;
        });
    };
    Table.prototype.renderPagination = function () {
        // 强制不需要分页
        if (!this.hasPagination()) {
            return null;
        }
        var size = 'default';
        var pagination = this.state.pagination;
        if (pagination.size) {
            size = pagination.size;
        }
        else if (this.props.size === 'middle' || this.props.size === 'small') {
            size = 'small';
        }
        var total = pagination.total || this.getLocalData().length;
        return (total > 0) ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Pagination"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Pagination@usjpe3", key: "pagination" }, pagination, { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(pagination.className, this.props.prefixCls + "-pagination"), onChange: this.handlePageChange, total: total, size: size, current: this.getMaxCurrent(total), onShowSizeChange: this.handleShowSizeChange }))) : null;
    };
    // Get pagination, filters, sorter
    Table.prototype.prepareParamsArguments = function (state) {
        var pagination = __assign({}, state.pagination);
        // remove useless handle function in Table.onChange
        delete pagination.onChange;
        delete pagination.onShowSizeChange;
        var filters = state.filters;
        var sorter = {};
        if (state.sortColumn && state.sortOrder) {
            sorter.column = state.sortColumn;
            sorter.order = state.sortOrder;
            sorter.field = state.sortColumn.dataIndex;
            sorter.columnKey = this.getColumnKey(state.sortColumn);
        }
        return [pagination, filters, sorter];
    };
    Table.prototype.findColumn = function (myKey) {
        var _this = this;
        var column;
        Object(__WEBPACK_IMPORTED_MODULE_16__util__["d" /* treeMap */])(this.columns, function (c) {
            if (_this.getColumnKey(c) === myKey) {
                column = c;
            }
        });
        return column;
    };
    Table.prototype.getCurrentPageData = function () {
        var data = this.getLocalData();
        var current;
        var pageSize;
        var state = this.state;
        // 如果没有分页的话，默认全部展示
        if (!this.hasPagination()) {
            pageSize = Number.MAX_VALUE;
            current = 1;
        }
        else {
            pageSize = state.pagination.pageSize;
            current = this.getMaxCurrent(state.pagination.total || data.length);
        }
        // 分页
        // ---
        // 当数据量少于等于每页数量时，直接设置数据
        // 否则进行读取分页数据
        if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
            data = data.filter(function (_, i) {
                return i >= (current - 1) * pageSize && i < current * pageSize;
            });
        }
        return data;
    };
    Table.prototype.getFlatData = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_16__util__["a" /* flatArray */])(this.getLocalData());
    };
    Table.prototype.getFlatCurrentPageData = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_16__util__["a" /* flatArray */])(this.getCurrentPageData());
    };
    Table.prototype.recursiveSort = function (data, sorterFn) {
        var _this = this;
        var _a = this.props.childrenColumnName, childrenColumnName = _a === void 0 ? 'children' : _a;
        return data.sort(sorterFn).map(function (item) {
            var _a;
            return (item[childrenColumnName] ? __assign({}, item, (_a = {}, _a[childrenColumnName] = _this.recursiveSort(item[childrenColumnName], sorterFn), _a)) : item);
        });
    };
    Table.prototype.getLocalData = function () {
        var _this = this;
        var state = this.state;
        var dataSource = this.props.dataSource;
        var data = dataSource || [];
        // 优化本地排序
        data = data.slice(0);
        var sorterFn = this.getSorterFn();
        if (sorterFn) {
            data = this.recursiveSort(data, sorterFn);
        }
        // 筛选
        if (state.filters) {
            Object.keys(state.filters).forEach(function (columnKey) {
                var col = _this.findColumn(columnKey);
                if (!col) {
                    return;
                }
                var values = state.filters[columnKey] || [];
                if (values.length === 0) {
                    return;
                }
                var onFilter = col.onFilter;
                data = onFilter ? data.filter(function (record) {
                    return values.some(function (v) { return onFilter(v, record); });
                }) : data;
            });
        }
        return data;
    };
    Table.prototype.createComponents = function (components, prevComponents) {
        if (components === void 0) { components = {}; }
        var bodyRow = components && components.body && components.body.row;
        var preBodyRow = prevComponents && prevComponents.body && prevComponents.body.row;
        if (!this.components || bodyRow !== preBodyRow) {
            this.components = __assign({}, components);
            this.components.body = __assign({}, components.body, { row: Object(__WEBPACK_IMPORTED_MODULE_15__createBodyRow__["a" /* default */])(bodyRow) });
        }
    };
    Table.prototype.render = function () {
        var _a = this.props, style = _a.style, className = _a.className, prefixCls = _a.prefixCls;
        var data = this.getCurrentPageData();
        var table = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__locale_provider_LocaleReceiver__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_LocaleReceiver@chtvl9", componentName: "Table", defaultLocale: __WEBPACK_IMPORTED_MODULE_8__locale_provider_default__["a" /* default */].Table }, this.renderTable));
        // if there is no pagination or no data,
        // the height of spin should decrease by half of pagination
        var paginationPatchClass = (this.hasPagination() && data && data.length !== 0)
            ? prefixCls + "-with-pagination" : prefixCls + "-without-pagination";
        var loading = this.props.loading;
        if (typeof loading === 'boolean') {
            loading = {
                spinning: loading,
            };
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(prefixCls + "-wrapper", className), style: style },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Spin"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Spin@l4r3ez" }, loading, { className: loading ? paginationPatchClass + " " + prefixCls + "-spin-holder" : '' }),
                table,
                this.renderPagination())));
    };
    Table.Column = __WEBPACK_IMPORTED_MODULE_13__Column__["a" /* default */];
    Table.ColumnGroup = __WEBPACK_IMPORTED_MODULE_14__ColumnGroup__["a" /* default */];
    Table.propTypes = {
        dataSource: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
        columns: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
        prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
        useFixedHeader: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
        rowSelection: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
        className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
        size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
        loading: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([
            __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
            __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
        ]),
        bordered: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
        onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
        locale: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
        dropdownPrefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
    };
    Table.defaultProps = {
        dataSource: [],
        prefixCls: 'cube-table',
        useFixedHeader: false,
        rowSelection: null,
        className: '',
        size: 'large',
        loading: false,
        bordered: false,
        indentSize: 20,
        locale: {},
        rowKey: 'key',
        showHeader: true,
    };
    return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Table);


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Column__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColumnGroup__ = __webpack_require__(922);
/* unused harmony reexport Column */
/* unused harmony reexport ColumnGroup */




__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */].Column = __WEBPACK_IMPORTED_MODULE_1__Column__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */].ColumnGroup = __WEBPACK_IMPORTED_MODULE_2__ColumnGroup__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */]);


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_component_classes__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_lifecycles_compat__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ColumnManager__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HeadTable__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BodyTable__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ExpandableTable__ = __webpack_require__(920);



















var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.state = {};

    _this.getRowKey = function (record, index) {
      var rowKey = _this.props.rowKey;
      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      Object(__WEBPACK_IMPORTED_MODULE_13__utils__["d" /* warningOnce */])(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
      return key === undefined ? index : key;
    };

    _this.handleWindowResize = function () {
      _this.syncFixedTableRowHeight();
      _this.setScrollPositionClassName();
    };

    _this.syncFixedTableRowHeight = function () {
      var tableRect = _this.tableNode.getBoundingClientRect();
      // If tableNode's height less than 0, suppose it is hidden and don't recalculate rowHeight.
      // see: https://github.com/ant-design/ant-design/issues/4836
      if (tableRect.height !== undefined && tableRect.height <= 0) {
        return;
      }
      var prefixCls = _this.props.prefixCls;

      var headRows = _this.headTable ? _this.headTable.querySelectorAll('thead') : _this.bodyTable.querySelectorAll('thead');
      var bodyRows = _this.bodyTable.querySelectorAll('.' + prefixCls + '-row') || [];
      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
        return row.getBoundingClientRect().height || 'auto';
      });
      var state = _this.store.getState();
      var fixedColumnsBodyRowsHeight = [].reduce.call(bodyRows, function (acc, row) {
        var rowKey = row.getAttribute('data-row-key');
        var height = row.getBoundingClientRect().height || state.fixedColumnsBodyRowsHeight[rowKey] || 'auto';
        acc[rowKey] = height;
        return acc;
      }, {});
      if (__WEBPACK_IMPORTED_MODULE_7_shallowequal___default()(state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && __WEBPACK_IMPORTED_MODULE_7_shallowequal___default()(state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
        return;
      }

      _this.store.setState({
        fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
        fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
      });
    };

    _this.handleBodyScrollLeft = function (e) {
      // Fix https://github.com/ant-design/ant-design/issues/7635
      if (e.currentTarget !== e.target) {
        return;
      }
      var target = e.target;
      var _this$props$scroll = _this.props.scroll,
          scroll = _this$props$scroll === undefined ? {} : _this$props$scroll;
      var headTable = _this.headTable,
          bodyTable = _this.bodyTable;

      if (target.scrollLeft !== _this.lastScrollLeft && scroll.x) {
        if (target === bodyTable && headTable) {
          headTable.scrollLeft = target.scrollLeft;
        } else if (target === headTable && bodyTable) {
          bodyTable.scrollLeft = target.scrollLeft;
        }
        _this.setScrollPositionClassName();
      }
      // Remember last scrollLeft for scroll direction detecting.
      _this.lastScrollLeft = target.scrollLeft;
    };

    _this.handleBodyScrollTop = function (e) {
      var target = e.target;
      // Fix https://github.com/ant-design/ant-design/issues/9033
      if (e.currentTarget !== target) {
        return;
      }
      var _this$props$scroll2 = _this.props.scroll,
          scroll = _this$props$scroll2 === undefined ? {} : _this$props$scroll2;
      var headTable = _this.headTable,
          bodyTable = _this.bodyTable,
          fixedColumnsBodyLeft = _this.fixedColumnsBodyLeft,
          fixedColumnsBodyRight = _this.fixedColumnsBodyRight;

      if (target.scrollTop !== _this.lastScrollTop && scroll.y && target !== headTable) {
        var scrollTop = target.scrollTop;
        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }
        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }
        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      }
      // Remember last scrollTop for scroll direction detecting.
      _this.lastScrollTop = target.scrollTop;
    };

    _this.handleBodyScroll = function (e) {
      _this.handleBodyScrollLeft(e);
      _this.handleBodyScrollTop(e);
    };

    _this.handleWheel = function (event) {
      var _this$props$scroll3 = _this.props.scroll,
          scroll = _this$props$scroll3 === undefined ? {} : _this$props$scroll3;

      if (window.navigator.userAgent.match(/Trident\/7\./) && scroll.y) {
        event.preventDefault();
        var wd = event.deltaY;
        var target = event.target;
        var bodyTable = _this.bodyTable,
            fixedColumnsBodyLeft = _this.fixedColumnsBodyLeft,
            fixedColumnsBodyRight = _this.fixedColumnsBodyRight;

        var scrollTop = 0;

        if (_this.lastScrollTop) {
          scrollTop = _this.lastScrollTop + wd;
        } else {
          scrollTop = wd;
        }

        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }
        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }
        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      }
    };

    _this.saveRef = function (name) {
      return function (node) {
        _this[name] = node;
      };
    };

    ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
      Object(__WEBPACK_IMPORTED_MODULE_13__utils__["d" /* warningOnce */])(props[name] === undefined, name + ' is deprecated, please use onRow instead.');
    });

    Object(__WEBPACK_IMPORTED_MODULE_13__utils__["d" /* warningOnce */])(props.getBodyWrapper === undefined, 'getBodyWrapper is deprecated, please use custom components instead.');

    _this.columnManager = new __WEBPACK_IMPORTED_MODULE_14__ColumnManager__["a" /* default */](props.columns, props.children);

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_9_mini_store__["create"])({
      currentHoverKey: null,
      fixedColumnsHeadRowsHeight: [],
      fixedColumnsBodyRowsHeight: {}
    });

    _this.setScrollPosition('left');

    _this.debouncedWindowResize = Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* debounce */])(_this.handleWindowResize, 150);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        table: {
          props: this.props,
          columnManager: this.columnManager,
          saveRef: this.saveRef,
          components: __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default()({
            table: 'table',
            header: {
              wrapper: 'thead',
              row: 'tr',
              cell: 'th'
            },
            body: {
              wrapper: 'tbody',
              row: 'tr',
              cell: 'td'
            }
          }, this.props.components)
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();
        this.resizeEvent = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.debouncedWindowResize);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();
        if (!this.resizeEvent) {
          this.resizeEvent = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.debouncedWindowResize);
        }
      }
      // when table changes to empty, reset scrollLeft
      if (prevProps.data.length > 0 && this.props.data.length === 0 && this.hasScrollX()) {
        this.resetScrollX();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.resizeEvent) {
        this.resizeEvent.remove();
      }
      if (this.debouncedWindowResize) {
        this.debouncedWindowResize.cancel();
      }
    }
  }, {
    key: 'setScrollPosition',
    value: function setScrollPosition(position) {
      this.scrollPosition = position;
      if (this.tableNode) {
        var prefixCls = this.props.prefixCls;

        if (position === 'both') {
          __WEBPACK_IMPORTED_MODULE_11_component_classes___default()(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-left').add(prefixCls + '-scroll-position-right');
        } else {
          __WEBPACK_IMPORTED_MODULE_11_component_classes___default()(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-' + position);
        }
      }
    }
  }, {
    key: 'setScrollPositionClassName',
    value: function setScrollPositionClassName() {
      var node = this.bodyTable;
      var scrollToLeft = node.scrollLeft === 0;
      var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;
      if (scrollToLeft && scrollToRight) {
        this.setScrollPosition('both');
      } else if (scrollToLeft) {
        this.setScrollPosition('left');
      } else if (scrollToRight) {
        this.setScrollPosition('right');
      } else if (this.scrollPosition !== 'middle') {
        this.setScrollPosition('middle');
      }
    }
  }, {
    key: 'resetScrollX',
    value: function resetScrollX() {
      if (this.headTable) {
        this.headTable.scrollLeft = 0;
      }
      if (this.bodyTable) {
        this.bodyTable.scrollLeft = 0;
      }
    }
  }, {
    key: 'hasScrollX',
    value: function hasScrollX() {
      var _props$scroll = this.props.scroll,
          scroll = _props$scroll === undefined ? {} : _props$scroll;

      return 'x' in scroll;
    }
  }, {
    key: 'renderMainTable',
    value: function renderMainTable() {
      var _props = this.props,
          scroll = _props.scroll,
          prefixCls = _props.prefixCls;

      var isAnyColumnsFixed = this.columnManager.isAnyColumnsFixed();
      var scrollable = isAnyColumnsFixed || scroll.x || scroll.y;

      var table = [this.renderTable({
        columns: this.columnManager.groupedColumns(),
        isAnyColumnsFixed: isAnyColumnsFixed
      }), this.renderEmptyText(), this.renderFooter()];

      return scrollable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-scroll' },
        table
      ) : table;
    }
  }, {
    key: 'renderLeftFixedTable',
    value: function renderLeftFixedTable() {
      var prefixCls = this.props.prefixCls;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-fixed-left' },
        this.renderTable({
          columns: this.columnManager.leftColumns(),
          fixed: 'left'
        })
      );
    }
  }, {
    key: 'renderRightFixedTable',
    value: function renderRightFixedTable() {
      var prefixCls = this.props.prefixCls;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-fixed-right' },
        this.renderTable({
          columns: this.columnManager.rightColumns(),
          fixed: 'right'
        })
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable(options) {
      var columns = options.columns,
          fixed = options.fixed,
          isAnyColumnsFixed = options.isAnyColumnsFixed;
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          _props2$scroll = _props2.scroll,
          scroll = _props2$scroll === undefined ? {} : _props2$scroll;

      var tableClassName = scroll.x || fixed ? prefixCls + '-fixed' : '';

      var headTable = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HeadTable__["a" /* default */], {
        key: 'head',
        columns: columns,
        fixed: fixed,
        tableClassName: tableClassName,
        handleBodyScrollLeft: this.handleBodyScrollLeft,
        expander: this.expander
      });

      var bodyTable = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__BodyTable__["a" /* default */], {
        key: 'body',
        columns: columns,
        fixed: fixed,
        tableClassName: tableClassName,
        getRowKey: this.getRowKey,
        handleWheel: this.handleWheel,
        handleBodyScroll: this.handleBodyScroll,
        expander: this.expander,
        isAnyColumnsFixed: isAnyColumnsFixed
      });

      return [headTable, bodyTable];
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var _props3 = this.props,
          title = _props3.title,
          prefixCls = _props3.prefixCls;

      return title ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-title', key: 'title' },
        title(this.props.data)
      ) : null;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var _props4 = this.props,
          footer = _props4.footer,
          prefixCls = _props4.prefixCls;

      return footer ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-footer', key: 'footer' },
        footer(this.props.data)
      ) : null;
    }
  }, {
    key: 'renderEmptyText',
    value: function renderEmptyText() {
      var _props5 = this.props,
          emptyText = _props5.emptyText,
          prefixCls = _props5.prefixCls,
          data = _props5.data;

      if (data.length) {
        return null;
      }
      var emptyClassName = prefixCls + '-placeholder';
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: emptyClassName, key: 'emptyText' },
        typeof emptyText === 'function' ? emptyText() : emptyText
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var prefixCls = props.prefixCls;

      if (this.state.columns) {
        this.columnManager.reset(props.columns);
      } else if (this.state.children) {
        this.columnManager.reset(null, props.children);
      }

      var className = props.prefixCls;
      if (props.className) {
        className += ' ' + props.className;
      }
      if (props.useFixedHeader || props.scroll && props.scroll.y) {
        className += ' ' + prefixCls + '-fixed-header';
      }
      if (this.scrollPosition === 'both') {
        className += ' ' + prefixCls + '-scroll-position-left ' + prefixCls + '-scroll-position-right';
      } else {
        className += ' ' + prefixCls + '-scroll-position-' + this.scrollPosition;
      }
      var hasLeftFixed = this.columnManager.isAnyColumnsLeftFixed();
      var hasRightFixed = this.columnManager.isAnyColumnsRightFixed();

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_mini_store__["Provider"],
        { store: this.store },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__ExpandableTable__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { columnManager: this.columnManager, getRowKey: this.getRowKey }),
          function (expander) {
            _this2.expander = expander;
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              {
                ref: _this2.saveRef('tableNode'),
                className: className,
                style: props.style,
                id: props.id
              },
              _this2.renderTitle(),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: prefixCls + '-content' },
                _this2.renderMainTable(),
                hasLeftFixed && _this2.renderLeftFixedTable(),
                hasRightFixed && _this2.renderRightFixedTable()
              )
            );
          }
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.columns && nextProps.columns !== prevState.columns) {
        return {
          columns: nextProps.columns,
          children: null
        };
      } else if (nextProps.children !== prevState.children) {
        return {
          columns: null,
          children: nextProps.children
        };
      }
      return null;
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Table.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  useFixedHeader: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  columns: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bodyStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rowKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  rowClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  onRow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onHeaderRow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowDoubleClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowContextMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onRowMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  showHeader: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  footer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  emptyText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  scroll: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rowRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  getBodyWrapper: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  components: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    table: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      wrapper: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
      row: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
      cell: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
    }),
    body: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      wrapper: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
      row: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
      cell: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
    })
  })
}, __WEBPACK_IMPORTED_MODULE_17__ExpandableTable__["a" /* default */].PropTypes);
Table.childContextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  components: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
Table.defaultProps = {
  data: [],
  useFixedHeader: false,
  rowKey: 'key',
  rowClassName: function rowClassName() {
    return '';
  },
  onRow: function onRow() {},
  onHeaderRow: function onHeaderRow() {},

  prefixCls: 'rc-table',
  bodyStyle: {},
  style: {},
  showHeader: true,
  scroll: {},
  rowRef: function rowRef() {
    return null;
  },
  emptyText: function emptyText() {
    return 'No Data';
  }
};


Object(__WEBPACK_IMPORTED_MODULE_12_react_lifecycles_compat__["polyfill"])(Table);

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(818);
var $Object = __webpack_require__(22).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(31);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(35), 'Object', { defineProperty: __webpack_require__(34).f });


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(820);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(821);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(822);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(361);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        miniStore: this.props.store
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

Provider.propTypes = {
  store: _PropTypes.storeShape.isRequired
};
Provider.childContextTypes = {
  miniStore: _PropTypes.storeShape.isRequired
};
exports.default = Provider;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connect;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__(70);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _hoistNonReactStatics = __webpack_require__(825);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactLifecyclesCompat = __webpack_require__(103);

var _PropTypes = __webpack_require__(361);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function isStateless(Component) {
  return !Component.prototype.render;
}

var defaultMapStateToProps = function defaultMapStateToProps() {
  return {};
};

function connect(mapStateToProps) {
  var shouldSubscribe = !!mapStateToProps;
  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;

  return function wrapWithConnect(WrappedComponent) {
    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      _createClass(Connect, null, [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, prevState) {
          // using ownProps
          if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
            return {
              subscribed: finnalMapStateToProps(prevState.store.getState(), props),
              props: props
            };
          }
          return { props: props };
        }
      }]);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));

        _this.handleChange = function () {
          if (!_this.unsubscribe) {
            return;
          }
          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
          if (!(0, _shallowequal2.default)(_this.state.subscribed, nextState)) {
            _this.setState({ subscribed: nextState });
          }
        };

        _this.store = context.miniStore;
        _this.state = {
          subscribed: finnalMapStateToProps(_this.store.getState(), props),
          store: _this.store,
          props: props
        };
        return _this;
      }

      _createClass(Connect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.trySubscribe();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.tryUnsubscribe();
        }
      }, {
        key: 'trySubscribe',
        value: function trySubscribe() {
          if (shouldSubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange);
            this.handleChange();
          }
        }
      }, {
        key: 'tryUnsubscribe',
        value: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = _extends({}, this.props, this.state.subscribed, {
            store: this.store
          });

          if (!isStateless(WrappedComponent)) {
            props = _extends({}, props, {
              ref: function ref(c) {
                return _this2.wrappedInstance = c;
              }
            });
          }

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return Connect;
    }(_react.Component);

    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
    Connect.contextTypes = {
      miniStore: _PropTypes.storeShape.isRequired
    };


    (0, _reactLifecyclesCompat.polyfill)(Connect);

    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
  };
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = create;
function create(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _extends({}, state, partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);

    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(828),
    createAssigner = __webpack_require__(884);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(829),
    assignMergeValue = __webpack_require__(365),
    baseFor = __webpack_require__(859),
    baseMergeDeep = __webpack_require__(861),
    isObject = __webpack_require__(64),
    keysIn = __webpack_require__(374),
    safeGet = __webpack_require__(373);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(148),
    stackClear = __webpack_require__(835),
    stackDelete = __webpack_require__(836),
    stackGet = __webpack_require__(837),
    stackHas = __webpack_require__(838),
    stackSet = __webpack_require__(839);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 830 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(149);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(149);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(149);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(149);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(148);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 836 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 837 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 838 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(148),
    Map = __webpack_require__(362),
    MapCache = __webpack_require__(364);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(221),
    isMasked = __webpack_require__(843),
    isObject = __webpack_require__(64),
    toSource = __webpack_require__(845);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(222);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 842 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(844);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 845 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 846 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(848),
    ListCache = __webpack_require__(148),
    Map = __webpack_require__(362);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(849),
    hashDelete = __webpack_require__(850),
    hashGet = __webpack_require__(851),
    hashHas = __webpack_require__(852),
    hashSet = __webpack_require__(853);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(151);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 850 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(151);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(151);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(151);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(152);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 855 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(152);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(152);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(152);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(860);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(365),
    cloneBuffer = __webpack_require__(862),
    cloneTypedArray = __webpack_require__(863),
    copyArray = __webpack_require__(866),
    initCloneObject = __webpack_require__(867),
    isArguments = __webpack_require__(369),
    isArray = __webpack_require__(105),
    isArrayLikeObject = __webpack_require__(871),
    isBuffer = __webpack_require__(371),
    isFunction = __webpack_require__(221),
    isObject = __webpack_require__(64),
    isPlainObject = __webpack_require__(873),
    isTypedArray = __webpack_require__(372),
    safeGet = __webpack_require__(373),
    toPlainObject = __webpack_require__(877);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(84);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(864);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(865);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(868),
    getPrototype = __webpack_require__(367),
    isPrototype = __webpack_require__(368);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 869 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(104),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(224),
    isObjectLike = __webpack_require__(85);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 872 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(104),
    getPrototype = __webpack_require__(367),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(104),
    isLength = __webpack_require__(370),
    isObjectLike = __webpack_require__(85);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 875 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(363);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(878),
    keysIn = __webpack_require__(374);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(879),
    baseAssignValue = __webpack_require__(223);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(223),
    eq = __webpack_require__(150);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(881),
    isArguments = __webpack_require__(369),
    isArray = __webpack_require__(105),
    isBuffer = __webpack_require__(371),
    isIndex = __webpack_require__(375),
    isTypedArray = __webpack_require__(372);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 881 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64),
    isPrototype = __webpack_require__(368),
    nativeKeysIn = __webpack_require__(883);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 883 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(885),
    isIterateeCall = __webpack_require__(892);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(376),
    overRest = __webpack_require__(886),
    setToString = __webpack_require__(888);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(887);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 887 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(889),
    shortOut = __webpack_require__(891);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(890),
    defineProperty = __webpack_require__(366),
    identity = __webpack_require__(376);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 890 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 891 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(150),
    isArrayLike = __webpack_require__(224),
    isIndex = __webpack_require__(375),
    isObject = __webpack_require__(64);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var ColumnManager = function () {
  function ColumnManager(columns, elements) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ColumnManager);

    this._cached = {};

    this.columns = columns || this.normalize(elements);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ColumnManager, [{
    key: 'isAnyColumnsFixed',
    value: function isAnyColumnsFixed() {
      var _this = this;

      return this._cache('isAnyColumnsFixed', function () {
        return _this.columns.some(function (column) {
          return !!column.fixed;
        });
      });
    }
  }, {
    key: 'isAnyColumnsLeftFixed',
    value: function isAnyColumnsLeftFixed() {
      var _this2 = this;

      return this._cache('isAnyColumnsLeftFixed', function () {
        return _this2.columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: 'isAnyColumnsRightFixed',
    value: function isAnyColumnsRightFixed() {
      var _this3 = this;

      return this._cache('isAnyColumnsRightFixed', function () {
        return _this3.columns.some(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: 'leftColumns',
    value: function leftColumns() {
      var _this4 = this;

      return this._cache('leftColumns', function () {
        return _this4.groupedColumns().filter(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: 'rightColumns',
    value: function rightColumns() {
      var _this5 = this;

      return this._cache('rightColumns', function () {
        return _this5.groupedColumns().filter(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: 'leafColumns',
    value: function leafColumns() {
      var _this6 = this;

      return this._cache('leafColumns', function () {
        return _this6._leafColumns(_this6.columns);
      });
    }
  }, {
    key: 'leftLeafColumns',
    value: function leftLeafColumns() {
      var _this7 = this;

      return this._cache('leftLeafColumns', function () {
        return _this7._leafColumns(_this7.leftColumns());
      });
    }
  }, {
    key: 'rightLeafColumns',
    value: function rightLeafColumns() {
      var _this8 = this;

      return this._cache('rightLeafColumns', function () {
        return _this8._leafColumns(_this8.rightColumns());
      });
    }

    // add appropriate rowspan and colspan to column

  }, {
    key: 'groupedColumns',
    value: function groupedColumns() {
      var _this9 = this;

      return this._cache('groupedColumns', function () {
        var _groupColumns = function _groupColumns(columns) {
          var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

          // track how many rows we got
          rows[currentRow] = rows[currentRow] || [];
          var grouped = [];
          var setRowSpan = function setRowSpan(column) {
            var rowSpan = rows.length - currentRow;
            if (column && !column.children && // parent columns are supposed to be one row
            rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
              column.rowSpan = rowSpan;
            }
          };
          columns.forEach(function (column, index) {
            var newColumn = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, column);
            rows[currentRow].push(newColumn);
            parentColumn.colSpan = parentColumn.colSpan || 0;
            if (newColumn.children && newColumn.children.length > 0) {
              newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
              parentColumn.colSpan += newColumn.colSpan;
            } else {
              parentColumn.colSpan++;
            }
            // update rowspan to all same row columns
            for (var i = 0; i < rows[currentRow].length - 1; ++i) {
              setRowSpan(rows[currentRow][i]);
            }
            // last column, update rowspan immediately
            if (index + 1 === columns.length) {
              setRowSpan(newColumn);
            }
            grouped.push(newColumn);
          });
          return grouped;
        };
        return _groupColumns(_this9.columns);
      });
    }
  }, {
    key: 'normalize',
    value: function normalize(elements) {
      var _this10 = this;

      var columns = [];
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(elements, function (element) {
        if (!__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(element)) {
          return;
        }
        var column = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, element.props);
        if (element.key) {
          column.key = element.key;
        }
        if (element.type.isTableColumnGroup) {
          column.children = _this10.normalize(column.children);
        }
        columns.push(column);
      });
      return columns;
    }
  }, {
    key: 'reset',
    value: function reset(columns, elements) {
      this.columns = columns || this.normalize(elements);
      this._cached = {};
    }
  }, {
    key: '_cache',
    value: function _cache(name, fn) {
      if (name in this._cached) {
        return this._cached[name];
      }
      this._cached[name] = fn();
      return this._cached[name];
    }
  }, {
    key: '_leafColumns',
    value: function _leafColumns(columns) {
      var _this11 = this;

      var leafColumns = [];
      columns.forEach(function (column) {
        if (!column.children) {
          leafColumns.push(column);
        } else {
          leafColumns.push.apply(leafColumns, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this11._leafColumns(column.children)));
        }
      });
      return leafColumns;
    }
  }]);

  return ColumnManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ColumnManager);

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(896), __esModule: true };

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180);
__webpack_require__(897);
module.exports = __webpack_require__(22).Array.from;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(55);
var $export = __webpack_require__(31);
var toObject = __webpack_require__(68);
var call = __webpack_require__(380);
var isArrayIter = __webpack_require__(381);
var toLength = __webpack_require__(114);
var createProperty = __webpack_require__(898);
var getIterFn = __webpack_require__(382);

$export($export.S + $export.F * !__webpack_require__(899)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(34);
var createDesc = __webpack_require__(90);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(32)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HeadTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseTable__ = __webpack_require__(384);





function HeadTable(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      scroll = _table$props.scroll,
      showHeader = _table$props.showHeader;
  var columns = props.columns,
      fixed = props.fixed,
      tableClassName = props.tableClassName,
      handleBodyScrollLeft = props.handleBodyScrollLeft,
      expander = props.expander;
  var saveRef = table.saveRef;
  var useFixedHeader = table.props.useFixedHeader;

  var headStyle = {};

  if (scroll.y) {
    useFixedHeader = true;
    // Add negative margin bottom for scroll bar overflow bug
    var scrollbarWidth = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* measureScrollbar */])('horizontal');
    if (scrollbarWidth > 0 && !fixed) {
      headStyle.marginBottom = '-' + scrollbarWidth + 'px';
      headStyle.paddingBottom = '0px';
    }
  }

  if (!useFixedHeader || !showHeader) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      key: 'headTable',
      ref: fixed ? null : saveRef('headTable'),
      className: prefixCls + '-header',
      style: headStyle,
      onScroll: handleBodyScrollLeft
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BaseTable__["a" /* default */], {
      tableClassName: tableClassName,
      hasHead: true,
      hasBody: false,
      fixed: fixed,
      columns: columns,
      expander: expander
    })
  );
}

HeadTable.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  columns: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  tableClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  handleBodyScrollLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  expander: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

HeadTable.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ColGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function ColGroup(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      expandIconAsCell = _table$props.expandIconAsCell;
  var fixed = props.fixed;


  var cols = [];

  if (expandIconAsCell && fixed !== 'right') {
    cols.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col', { className: prefixCls + '-expand-icon-col', key: 'rc-table-expand-icon-col' }));
  }

  var leafColumns = void 0;

  if (fixed === 'left') {
    leafColumns = table.columnManager.leftLeafColumns();
  } else if (fixed === 'right') {
    leafColumns = table.columnManager.rightLeafColumns();
  } else {
    leafColumns = table.columnManager.leafColumns();
  }
  cols = cols.concat(leafColumns.map(function (c) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col', { key: c.key || c.dataIndex, style: { width: c.width, minWidth: c.width } });
  }));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'colgroup',
    null,
    cols
  );
}

ColGroup.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

ColGroup.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TableHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableHeaderRow__ = __webpack_require__(904);




function getHeaderRows(columns) {
  var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var rows = arguments[2];

  rows = rows || [];
  rows[currentRow] = rows[currentRow] || [];

  columns.forEach(function (column) {
    if (column.rowSpan && rows.length < column.rowSpan) {
      while (rows.length < column.rowSpan) {
        rows.push([]);
      }
    }
    var cell = {
      key: column.key,
      className: column.className || '',
      children: column.title,
      column: column
    };
    if (column.children) {
      getHeaderRows(column.children, currentRow + 1, rows);
    }
    if ('colSpan' in column) {
      cell.colSpan = column.colSpan;
    }
    if ('rowSpan' in column) {
      cell.rowSpan = column.rowSpan;
    }
    if (cell.colSpan !== 0) {
      rows[currentRow].push(cell);
    }
  });
  return rows.filter(function (row) {
    return row.length > 0;
  });
}

function TableHeader(props, _ref) {
  var table = _ref.table;
  var components = table.components;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      showHeader = _table$props.showHeader,
      onHeaderRow = _table$props.onHeaderRow;
  var expander = props.expander,
      columns = props.columns,
      fixed = props.fixed;


  if (!showHeader) {
    return null;
  }

  var rows = getHeaderRows(columns);

  expander.renderExpandIndentCell(rows, fixed);

  var HeaderWrapper = components.header.wrapper;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    HeaderWrapper,
    { className: prefixCls + '-thead' },
    rows.map(function (row, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableHeaderRow__["a" /* default */], {
        key: index,
        index: index,
        fixed: fixed,
        columns: columns,
        rows: rows,
        row: row,
        components: components,
        onHeaderRow: onHeaderRow
      });
    })
  );
}

TableHeader.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  columns: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  expander: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onHeaderRow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

TableHeader.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mini_store__);






function TableHeaderRow(_ref) {
  var row = _ref.row,
      index = _ref.index,
      height = _ref.height,
      components = _ref.components,
      onHeaderRow = _ref.onHeaderRow;

  var HeaderRow = components.header.row;
  var HeaderCell = components.header.cell;
  var rowProps = onHeaderRow(row.map(function (cell) {
    return cell.column;
  }), index);
  var customStyle = rowProps ? rowProps.style : {};
  var style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ height: height }, customStyle);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    HeaderRow,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rowProps, { style: style }),
    row.map(function (cell, i) {
      var column = cell.column,
          cellProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(cell, ['column']);

      var customProps = column.onHeaderCell ? column.onHeaderCell(column) : {};
      if (column.align) {
        customProps.style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, customProps.style, { textAlign: column.align });
      }
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(HeaderCell, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, cellProps, customProps, { key: column.key || column.dataIndex || i }));
    })
  );
}

TableHeaderRow.propTypes = {
  row: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  index: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  components: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  onHeaderRow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

function getRowHeight(state, props) {
  var fixedColumnsHeadRowsHeight = state.fixedColumnsHeadRowsHeight;
  var columns = props.columns,
      rows = props.rows,
      fixed = props.fixed;

  var headerHeight = fixedColumnsHeadRowsHeight[0];

  if (!fixed) {
    return null;
  }

  if (headerHeight && columns) {
    if (headerHeight === 'auto') {
      return 'auto';
    }
    return headerHeight / rows.length;
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mini_store__["connect"])(function (state, props) {
  return {
    height: getRowHeight(state, props)
  };
})(TableHeaderRow));

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);









function isInvalidRenderCellText(text) {
  return text && !__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
}

var TableCell = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TableCell, _React$Component);

  function TableCell() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TableCell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          record = _this$props.record,
          onCellClick = _this$props.column.onCellClick;

      if (onCellClick) {
        onCellClick(record, e);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TableCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          record = _props.record,
          indentSize = _props.indentSize,
          prefixCls = _props.prefixCls,
          indent = _props.indent,
          index = _props.index,
          expandIcon = _props.expandIcon,
          column = _props.column,
          BodyCell = _props.component;
      var dataIndex = column.dataIndex,
          render = column.render,
          _column$className = column.className,
          className = _column$className === undefined ? '' : _column$className;

      // We should return undefined if no dataIndex is specified, but in order to
      // be compatible with object-path's behavior, we return the record object instead.

      var text = void 0;
      if (typeof dataIndex === 'number') {
        text = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(record, dataIndex);
      } else if (!dataIndex || dataIndex.length === 0) {
        text = record;
      } else {
        text = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(record, dataIndex);
      }
      var tdProps = {};
      var colSpan = void 0;
      var rowSpan = void 0;

      if (render) {
        text = render(text, record, index);
        if (isInvalidRenderCellText(text)) {
          tdProps = text.props || tdProps;
          colSpan = tdProps.colSpan;
          rowSpan = tdProps.rowSpan;
          text = text.children;
        }
      }

      if (column.onCell) {
        tdProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tdProps, column.onCell(record));
      }

      // Fix https://github.com/ant-design/ant-design/issues/1202
      if (isInvalidRenderCellText(text)) {
        text = null;
      }

      var indentText = expandIcon ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
        style: { paddingLeft: indentSize * indent + 'px' },
        className: prefixCls + '-indent indent-level-' + indent
      }) : null;

      if (rowSpan === 0 || colSpan === 0) {
        return null;
      }

      if (column.align) {
        tdProps.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tdProps.style, { textAlign: column.align });
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        BodyCell,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: className, onClick: this.handleClick }, tdProps),
        indentText,
        expandIcon,
        text
      );
    }
  }]);

  return TableCell;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TableCell.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  indent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  indentSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  column: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  expandIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  component: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (TableCell);

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(907);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(908),
    toKey = __webpack_require__(916);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(105),
    isKey = __webpack_require__(909),
    stringToPath = __webpack_require__(910),
    toString = __webpack_require__(913);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(105),
    isSymbol = __webpack_require__(226);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(911);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(912);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(364);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(914);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(222),
    arrayMap = __webpack_require__(915),
    isArray = __webpack_require__(105),
    isSymbol = __webpack_require__(226);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(226);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExpandIcon__ = __webpack_require__(918);









var ExpandableRow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ExpandableRow, _React$Component);

  function ExpandableRow() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ExpandableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ExpandableRow.__proto__ || Object.getPrototypeOf(ExpandableRow)).call.apply(_ref, [this].concat(args))), _this), _this.hasExpandIcon = function (columnIndex) {
      var expandRowByClick = _this.props.expandRowByClick;

      return !_this.expandIconAsCell && !expandRowByClick && columnIndex === _this.expandIconColumnIndex;
    }, _this.handleExpandChange = function (record, event) {
      var _this$props = _this.props,
          onExpandedChange = _this$props.onExpandedChange,
          expanded = _this$props.expanded,
          rowKey = _this$props.rowKey;

      if (_this.expandable) {
        onExpandedChange(!expanded, record, event, rowKey);
      }
    }, _this.handleRowClick = function (record, index, event) {
      var _this$props2 = _this.props,
          expandRowByClick = _this$props2.expandRowByClick,
          onRowClick = _this$props2.onRowClick;

      if (expandRowByClick) {
        _this.handleExpandChange(record, event);
      }
      if (onRowClick) {
        onRowClick(record, index, event);
      }
    }, _this.renderExpandIcon = function () {
      var _this$props3 = _this.props,
          prefixCls = _this$props3.prefixCls,
          expanded = _this$props3.expanded,
          record = _this$props3.record,
          needIndentSpaced = _this$props3.needIndentSpaced;


      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ExpandIcon__["a" /* default */], {
        expandable: _this.expandable,
        prefixCls: prefixCls,
        onExpand: _this.handleExpandChange,
        needIndentSpaced: needIndentSpaced,
        expanded: expanded,
        record: record
      });
    }, _this.renderExpandIconCell = function (cells) {
      if (!_this.expandIconAsCell) {
        return;
      }
      var prefixCls = _this.props.prefixCls;


      cells.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'td',
        { className: prefixCls + '-expand-icon-cell', key: 'rc-table-expand-icon-cell' },
        _this.renderExpandIcon()
      ));
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ExpandableRow, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleDestroy();
    }
  }, {
    key: 'handleDestroy',
    value: function handleDestroy() {
      var _props = this.props,
          onExpandedChange = _props.onExpandedChange,
          rowKey = _props.rowKey,
          record = _props.record;

      if (this.expandable) {
        onExpandedChange(false, record, null, rowKey, true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          childrenColumnName = _props2.childrenColumnName,
          expandedRowRender = _props2.expandedRowRender,
          indentSize = _props2.indentSize,
          record = _props2.record,
          fixed = _props2.fixed;


      this.expandIconAsCell = fixed !== 'right' ? this.props.expandIconAsCell : false;
      this.expandIconColumnIndex = fixed !== 'right' ? this.props.expandIconColumnIndex : -1;
      var childrenData = record[childrenColumnName];
      this.expandable = !!(childrenData || expandedRowRender);

      var expandableRowProps = {
        indentSize: indentSize,
        onRowClick: this.handleRowClick,
        hasExpandIcon: this.hasExpandIcon,
        renderExpandIcon: this.renderExpandIcon,
        renderExpandIconCell: this.renderExpandIconCell
      };

      return this.props.children(expandableRowProps);
    }
  }]);

  return ExpandableRow;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ExpandableRow.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  rowKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]).isRequired,
  fixed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool]),
  record: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  indentSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  needIndentSpaced: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  expandRowByClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  expandIconAsCell: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  expandIconColumnIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  childrenColumnName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  expandedRowRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onExpandedChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  onRowClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_mini_store__["connect"])(function (_ref2, _ref3) {
  var expandedRowKeys = _ref2.expandedRowKeys;
  var rowKey = _ref3.rowKey;
  return {
    expanded: !!~expandedRowKeys.indexOf(rowKey)
  };
})(ExpandableRow));

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shallowequal__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shallowequal__);








var ExpandIcon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ExpandIcon, _React$Component);

  function ExpandIcon() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ExpandIcon);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExpandIcon.__proto__ || Object.getPrototypeOf(ExpandIcon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ExpandIcon, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_6_shallowequal___default()(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expandable = _props.expandable,
          prefixCls = _props.prefixCls,
          onExpand = _props.onExpand,
          needIndentSpaced = _props.needIndentSpaced,
          expanded = _props.expanded,
          record = _props.record;

      if (expandable) {
        var expandClassName = expanded ? 'expanded' : 'collapsed';
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', {
          className: prefixCls + '-expand-icon ' + prefixCls + '-' + expandClassName,
          onClick: function onClick(e) {
            return onExpand(record, e);
          }
        });
      } else if (needIndentSpaced) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: prefixCls + '-expand-icon ' + prefixCls + '-spaced' });
      }
      return null;
    }
  }]);

  return ExpandIcon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ExpandIcon.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  expandable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  needIndentSpaced: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onExpand: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (ExpandIcon);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BodyTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BaseTable__ = __webpack_require__(384);






function BodyTable(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
      prefixCls = _table$props.prefixCls,
      scroll = _table$props.scroll;
  var columns = props.columns,
      fixed = props.fixed,
      tableClassName = props.tableClassName,
      getRowKey = props.getRowKey,
      handleBodyScroll = props.handleBodyScroll,
      handleWheel = props.handleWheel,
      expander = props.expander,
      isAnyColumnsFixed = props.isAnyColumnsFixed;
  var saveRef = table.saveRef;
  var useFixedHeader = table.props.useFixedHeader;

  var bodyStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, table.props.bodyStyle);
  var innerBodyStyle = {};

  if (scroll.x || fixed) {
    bodyStyle.overflowX = bodyStyle.overflowX || 'scroll';
    // Fix weired webkit render bug
    // https://github.com/ant-design/ant-design/issues/7783
    bodyStyle.WebkitTransform = 'translate3d (0, 0, 0)';
  }

  if (scroll.y) {
    // maxHeight will make fixed-Table scrolling not working
    // so we only set maxHeight to body-Table here
    if (fixed) {
      innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
      innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    } else {
      bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
    }
    bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
    useFixedHeader = true;

    // Add negative margin bottom for scroll bar overflow bug
    var scrollbarWidth = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* measureScrollbar */])();
    if (scrollbarWidth > 0 && fixed) {
      bodyStyle.marginBottom = '-' + scrollbarWidth + 'px';
      bodyStyle.paddingBottom = '0px';
    }
  }

  var baseTable = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BaseTable__["a" /* default */], {
    tableClassName: tableClassName,
    hasHead: !useFixedHeader,
    hasBody: true,
    fixed: fixed,
    columns: columns,
    expander: expander,
    getRowKey: getRowKey,
    isAnyColumnsFixed: isAnyColumnsFixed
  });

  if (fixed && columns.length) {
    var refName = void 0;
    if (columns[0].fixed === 'left' || columns[0].fixed === true) {
      refName = 'fixedColumnsBodyLeft';
    } else if (columns[0].fixed === 'right') {
      refName = 'fixedColumnsBodyRight';
    }
    delete bodyStyle.overflowX;
    delete bodyStyle.overflowY;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { key: 'bodyTable', className: prefixCls + '-body-outer', style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, bodyStyle) },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: prefixCls + '-body-inner',
          style: innerBodyStyle,
          ref: saveRef(refName),
          onWheel: handleWheel,
          onScroll: handleBodyScroll
        },
        baseTable
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      key: 'bodyTable',
      className: prefixCls + '-body',
      style: bodyStyle,
      ref: saveRef('bodyTable'),
      onWheel: handleWheel,
      onScroll: handleBodyScroll
    },
    baseTable
  );
}

BodyTable.propTypes = {
  fixed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  columns: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
  tableClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  handleWheel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  handleBodyScroll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getRowKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  expander: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  isAnyColumnsFixed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

BodyTable.contextTypes = {
  table: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableRow__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(106);













var ExpandableTable = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ExpandableTable, _React$Component);

  function ExpandableTable(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ExpandableTable);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExpandableTable.__proto__ || Object.getPrototypeOf(ExpandableTable)).call(this, props));

    _initialiseProps.call(_this);

    var data = props.data,
        childrenColumnName = props.childrenColumnName,
        defaultExpandAllRows = props.defaultExpandAllRows,
        expandedRowKeys = props.expandedRowKeys,
        defaultExpandedRowKeys = props.defaultExpandedRowKeys,
        getRowKey = props.getRowKey;


    var finnalExpandedRowKeys = [];
    var rows = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));

    if (defaultExpandAllRows) {
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        finnalExpandedRowKeys.push(getRowKey(row, i));
        rows = rows.concat(row[childrenColumnName] || []);
      }
    } else {
      finnalExpandedRowKeys = expandedRowKeys || defaultExpandedRowKeys;
    }

    _this.columnManager = props.columnManager;
    _this.store = props.store;

    _this.store.setState({
      expandedRowsHeight: {},
      expandedRowKeys: finnalExpandedRowKeys
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ExpandableTable, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if ('expandedRowKeys' in this.props) {
        this.store.setState({
          expandedRowKeys: this.props.expandedRowKeys
        });
      }
    }
  }, {
    key: 'renderExpandedRow',
    value: function renderExpandedRow(record, index, _render, className, ancestorKeys, indent, fixed) {
      var _this2 = this;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          expandIconAsCell = _props.expandIconAsCell,
          indentSize = _props.indentSize;

      var parentKey = ancestorKeys[ancestorKeys.length - 1];
      var rowKey = parentKey + '-extra-row';
      var components = {
        body: {
          row: 'tr',
          cell: 'td'
        }
      };
      var colCount = void 0;
      if (fixed === 'left') {
        colCount = this.columnManager.leftLeafColumns().length;
      } else if (fixed === 'right') {
        colCount = this.columnManager.rightLeafColumns().length;
      } else {
        colCount = this.columnManager.leafColumns().length;
      }
      var columns = [{
        key: 'extra-row',
        render: function render() {
          var _store$getState = _this2.store.getState(),
              expandedRowKeys = _store$getState.expandedRowKeys;

          var expanded = !!~expandedRowKeys.indexOf(parentKey);
          return {
            props: {
              colSpan: colCount
            },
            children: fixed !== 'right' ? _render(record, index, indent, expanded) : '&nbsp;'
          };
        }
      }];
      if (expandIconAsCell && fixed !== 'right') {
        columns.unshift({
          key: 'expand-icon-placeholder',
          render: function render() {
            return null;
          }
        });
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TableRow__["a" /* default */], {
        key: rowKey,
        columns: columns,
        className: className,
        rowKey: rowKey,
        ancestorKeys: ancestorKeys,
        prefixCls: prefixCls + '-expanded-row',
        indentSize: indentSize,
        indent: indent,
        fixed: fixed,
        components: components,
        expandedRow: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          data = _props2.data,
          childrenColumnName = _props2.childrenColumnName,
          children = _props2.children;

      var needIndentSpaced = data.some(function (record) {
        return record[childrenColumnName];
      });

      return children({
        props: this.props,
        needIndentSpaced: needIndentSpaced,
        renderRows: this.renderRows,
        handleExpandChange: this.handleExpandChange,
        renderExpandIndentCell: this.renderExpandIndentCell
      });
    }
  }]);

  return ExpandableTable;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ExpandableTable.propTypes = {
  expandIconAsCell: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  expandedRowKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  expandedRowClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  defaultExpandAllRows: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  defaultExpandedRowKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  expandIconColumnIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  expandedRowRender: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  childrenColumnName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  indentSize: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onExpand: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onExpandedRowsChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  columnManager: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  store: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  getRowKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
};
ExpandableTable.defaultProps = {
  expandIconAsCell: false,
  expandedRowClassName: function expandedRowClassName() {
    return '';
  },
  expandIconColumnIndex: 0,
  defaultExpandAllRows: false,
  defaultExpandedRowKeys: [],
  childrenColumnName: 'children',
  indentSize: 15,
  onExpand: function onExpand() {},
  onExpandedRowsChange: function onExpandedRowsChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleExpandChange = function (expanded, record, event, rowKey) {
    var destroy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var _props3 = _this3.props,
        onExpandedRowsChange = _props3.onExpandedRowsChange,
        onExpand = _props3.onExpand;

    var _store$getState2 = _this3.store.getState(),
        expandedRowKeys = _store$getState2.expandedRowKeys;

    if (expanded) {
      // row was expaned
      expandedRowKeys = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(expandedRowKeys), [rowKey]);
    } else {
      // row was collapse
      var expandedRowIndex = expandedRowKeys.indexOf(rowKey);
      if (expandedRowIndex !== -1) {
        expandedRowKeys = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["c" /* remove */])(expandedRowKeys, rowKey);
      }
    }

    if (!_this3.props.expandedRowKeys) {
      _this3.store.setState({ expandedRowKeys: expandedRowKeys });
    }

    onExpandedRowsChange(expandedRowKeys);
    if (!destroy) {
      onExpand(expanded, record);
    }
  };

  this.renderExpandIndentCell = function (rows, fixed) {
    var _props4 = _this3.props,
        prefixCls = _props4.prefixCls,
        expandIconAsCell = _props4.expandIconAsCell;

    if (!expandIconAsCell || fixed === 'right' || !rows.length) {
      return;
    }

    var iconColumn = {
      key: 'rc-table-expand-icon-cell',
      className: prefixCls + '-expand-icon-th',
      title: '',
      rowSpan: rows.length
    };

    rows[0].unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, iconColumn, { column: iconColumn }));
  };

  this.renderRows = function (renderRows, rows, record, index, indent, fixed, parentKey, ancestorKeys) {
    var _props5 = _this3.props,
        expandedRowClassName = _props5.expandedRowClassName,
        expandedRowRender = _props5.expandedRowRender,
        childrenColumnName = _props5.childrenColumnName;

    var childrenData = record[childrenColumnName];
    var nextAncestorKeys = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(ancestorKeys), [parentKey]);
    var nextIndent = indent + 1;

    if (expandedRowRender) {
      rows.push(_this3.renderExpandedRow(record, index, expandedRowRender, expandedRowClassName(record, index, indent), nextAncestorKeys, nextIndent, fixed));
    }

    if (childrenData) {
      renderRows(childrenData, nextIndent, rows, nextAncestorKeys);
    }
  };
};

Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(ExpandableTable);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_mini_store__["connect"])()(ExpandableTable));

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function Column() {}

Column.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  colSpan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  dataIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
  fixed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([true, 'left', 'right']),
  render: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onCellClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onCell: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onHeaderCell: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Column);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var ColumnGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ColumnGroup, _Component);

  function ColumnGroup() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ColumnGroup);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnGroup.__proto__ || Object.getPrototypeOf(ColumnGroup)).apply(this, arguments));
  }

  return ColumnGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

ColumnGroup.isTableColumnGroup = true;
ColumnGroup.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ColumnGroup);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var LocaleReceiver = /** @class */ (function (_super) {
    __extends(LocaleReceiver, _super);
    function LocaleReceiver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocaleReceiver.prototype.getLocale = function () {
        var _a = this.props, componentName = _a.componentName, defaultLocale = _a.defaultLocale;
        var antLocale = this.context.antLocale;
        var localeFromContext = antLocale && antLocale[componentName];
        return __assign({}, (typeof defaultLocale === 'function' ? defaultLocale() : defaultLocale), (localeFromContext || {}));
    };
    LocaleReceiver.prototype.getLocaleCode = function () {
        var antLocale = this.context.antLocale;
        var localeCode = antLocale && antLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if (antLocale && antLocale.exist && !localeCode) {
            return 'en-us';
        }
        return localeCode;
    };
    LocaleReceiver.prototype.render = function () {
        return this.props.children(this.getLocale(), this.getLocaleCode());
    };
    LocaleReceiver.contextTypes = {
        antLocale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    };
    return LocaleReceiver;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LocaleReceiver);


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_pagination_lib_locale_en_US__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_pagination_lib_locale_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rc_pagination_lib_locale_en_US__);

/* harmony default export */ __webpack_exports__["a"] = ({
    locale: 'en',
    Pagination: __WEBPACK_IMPORTED_MODULE_0_rc_pagination_lib_locale_en_US___default.a,
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK',
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel',
    },
    Transfer: {
        titles: ['', ''],
        notFoundContent: 'Not Found',
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
    },
    Select: {
        notFoundContent: 'Not Found',
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
    },
});


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Goto',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
};
module.exports = exports['default'];

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_menu__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_closest__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_closest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dom_closest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_checkbox__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FilterDropdownMenuWrapper__ = __webpack_require__(955);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var FilterMenu = /** @class */ (function (_super) {
    __extends(FilterMenu, _super);
    function FilterMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.setNeverShown = function (column) {
            var rootNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](_this);
            var filterBelongToScrollBody = !!__WEBPACK_IMPORTED_MODULE_3_dom_closest___default()(rootNode, ".cube-table-scroll");
            if (filterBelongToScrollBody) {
                // When fixed column have filters, there will be two dropdown menus
                // Filter dropdown menu inside scroll body should never be shown
                // To fix https://github.com/ant-design/ant-design/issues/5010 and
                // https://github.com/ant-design/ant-design/issues/7909
                _this.neverShown = !!column.fixed;
            }
        };
        _this.setSelectedKeys = function (_a) {
            var selectedKeys = _a.selectedKeys;
            _this.setState({ selectedKeys: selectedKeys });
        };
        _this.handleClearFilters = function () {
            _this.setState({
                selectedKeys: [],
            }, _this.handleConfirm);
        };
        _this.handleConfirm = function () {
            _this.setVisible(false);
            _this.confirmFilter();
        };
        _this.onVisibleChange = function (visible) {
            _this.setVisible(visible);
            if (!visible) {
                _this.confirmFilter();
            }
        };
        _this.handleMenuItemClick = function (info) {
            if (info.keyPath.length <= 1) {
                return;
            }
            var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;
            if (_this.state.selectedKeys.indexOf(info.key) >= 0) {
                // deselect SubMenu child
                delete keyPathOfSelectedItem[info.key];
            }
            else {
                // select SubMenu child
                keyPathOfSelectedItem[info.key] = info.keyPath;
            }
            _this.setState({ keyPathOfSelectedItem: keyPathOfSelectedItem });
        };
        _this.renderFilterIcon = function () {
            var _a;
            var _b = _this.props, column = _b.column, locale = _b.locale, prefixCls = _b.prefixCls;
            var filterIcon = column.filterIcon;
            var dropdownSelectedClass = _this.props.selectedKeys.length > 0 ? prefixCls + "-selected" : '';
            return filterIcon ? __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](filterIcon, {
                title: locale.filterTitle,
                className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(filterIcon.className, (_a = {},
                    _a[prefixCls + "-icon"] = true,
                    _a)),
            }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: locale.filterTitle, className: dropdownSelectedClass + " anticon anticon-filter" });
        };
        var visible = ('filterDropdownVisible' in props.column) ?
            props.column.filterDropdownVisible : false;
        _this.state = {
            selectedKeys: props.selectedKeys,
            keyPathOfSelectedItem: {},
            visible: visible,
        };
        return _this;
    }
    FilterMenu.prototype.componentDidMount = function () {
        var column = this.props.column;
        this.setNeverShown(column);
    };
    FilterMenu.prototype.componentWillReceiveProps = function (nextProps) {
        var column = nextProps.column;
        this.setNeverShown(column);
        var newState = {};
        if ('selectedKeys' in nextProps) {
            newState.selectedKeys = nextProps.selectedKeys;
        }
        if ('filterDropdownVisible' in column) {
            newState.visible = column.filterDropdownVisible;
        }
        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    };
    FilterMenu.prototype.setVisible = function (visible) {
        var column = this.props.column;
        if (!('filterDropdownVisible' in column)) {
            this.setState({ visible: visible });
        }
        if (column.onFilterDropdownVisibleChange) {
            column.onFilterDropdownVisibleChange(visible);
        }
    };
    FilterMenu.prototype.confirmFilter = function () {
        if (this.state.selectedKeys !== this.props.selectedKeys) {
            this.props.confirmFilter(this.props.column, this.state.selectedKeys);
        }
    };
    FilterMenu.prototype.renderMenuItem = function (item) {
        var column = this.props.column;
        var multiple = ('filterMultiple' in column) ? column.filterMultiple : true;
        var input = multiple ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__view_checkbox__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Checkbox@9wa8fo", checked: this.state.selectedKeys.indexOf(item.value.toString()) >= 0 })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Radio"], { ecId: (this && this.props && this.props.ecId || '') + "_Radio@cq0se8", checked: this.state.selectedKeys.indexOf(item.value.toString()) >= 0 }));
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_menu__["a" /* Item */], { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@6bt65i", key: item.value },
            input,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, item.text)));
    };
    FilterMenu.prototype.hasSubMenu = function () {
        var _a = this.props.column.filters, filters = _a === void 0 ? [] : _a;
        return filters.some(function (item) { return !!(item.children && item.children.length > 0); });
    };
    FilterMenu.prototype.renderMenus = function (items) {
        var _this = this;
        return items.map(function (item, idn) {
            if (item.children && item.children.length > 0) {
                var keyPathOfSelectedItem_1 = _this.state.keyPathOfSelectedItem;
                var containSelected = Object.keys(keyPathOfSelectedItem_1).some(function (key) { return keyPathOfSelectedItem_1[key].indexOf(item.value) >= 0; });
                var subMenuCls = containSelected ? _this.props.dropdownPrefixCls + "-submenu-contain-selected" : '';
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_menu__["b" /* SubMenu */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SubMenu@nd9bgd@" + idn, title: item.text, className: subMenuCls, key: item.value.toString() }, _this.renderMenus(item.children)));
            }
            return _this.renderMenuItem(item);
        });
    };
    FilterMenu.prototype.render = function () {
        var _a;
        var _b = this.props, column = _b.column, locale = _b.locale, prefixCls = _b.prefixCls, dropdownPrefixCls = _b.dropdownPrefixCls, getPopupContainer = _b.getPopupContainer;
        // default multiple selection in filter dropdown
        var multiple = ('filterMultiple' in column) ? column.filterMultiple : true;
        var dropdownMenuClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_a = {},
            _a[dropdownPrefixCls + "-menu-without-submenu"] = !this.hasSubMenu(),
            _a));
        var menus = column.filterDropdown ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FilterDropdownMenuWrapper__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_FilterDropdownMenuWrapper@nchn04" }, column.filterDropdown)) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FilterDropdownMenuWrapper__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_FilterDropdownMenuWrapper@0h3rek", className: prefixCls + "-dropdown" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_menu__["c" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Menu@1uoxm8", multiple: multiple, onClick: this.handleMenuItemClick, prefixCls: dropdownPrefixCls + "-menu", className: dropdownMenuClass, onSelect: this.setSelectedKeys, onDeselect: this.setSelectedKeys, selectedKeys: this.state.selectedKeys }, this.renderMenus(column.filters)),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: prefixCls + "-dropdown-btns" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: prefixCls + "-dropdown-link confirm", onClick: this.handleConfirm }, locale.filterConfirm),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: prefixCls + "-dropdown-link clear", onClick: this.handleClearFilters }, locale.filterReset))));
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_antd__["Dropdown"], { ecId: (this && this.props && this.props.ecId || '') + "_Dropdown@g9m5pj", trigger: ['click'], overlay: menus, visible: this.neverShown ? false : this.state.visible, onVisibleChange: this.onVisibleChange, getPopupContainer: getPopupContainer, forceRender: true }, this.renderFilterIcon()));
    };
    FilterMenu.defaultProps = {
        handleFilter: function () { },
        column: {},
    };
    return FilterMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (FilterMenu);


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divider__ = __webpack_require__(952);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* unused harmony reexport MenuItem */
/* unused harmony reexport MenuItemGroup */
/* unused harmony reexport ItemGroup */
/* unused harmony reexport Divider */








/* harmony default export */ __webpack_exports__["c"] = (__WEBPACK_IMPORTED_MODULE_0__Menu__["a" /* default */]);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(107);











var Menu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Menu, _React$Component);

  function Menu(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Menu);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    _this.isRootMenu = true;

    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;
    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }
    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["create"])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: { '0-menu-': Object(__WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["b" /* getActiveKey */])(props, props.activeKey) }
    });
    return _this;
  }

  Menu.prototype.componentDidMount = function componentDidMount() {
    this.updateMiniStore();
  };

  Menu.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateMiniStore();
  };

  // onKeyDown needs to be exposed as a instance method
  // e.g., in rc-select, we need to navigate menu item while
  // current active item is rc-select input box rather than the menu itself


  Menu.prototype.updateMiniStore = function updateMiniStore() {
    if ('selectedKeys' in this.props) {
      this.store.setState({
        selectedKeys: this.props.selectedKeys || []
      });
    }
    if ('openKeys' in this.props) {
      this.store.setState({
        openKeys: this.props.openKeys || []
      });
    }
  };

  Menu.prototype.render = function render() {
    var _this2 = this;

    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    props.className += ' ' + props.prefixCls + '-root';
    props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.onClick,
      onOpenChange: this.onOpenChange,
      onDeselect: this.onDeselect,
      onSelect: this.onSelect,
      openTransitionName: this.getOpenTransitionName(),
      parentMenu: this
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_mini_store__["Provider"],
      { store: this.store },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { ref: function ref(c) {
            return _this2.innerMenu = c;
          } }),
        this.props.children
      )
    );
  };

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Menu.propTypes = {
  defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  subMenuOpenDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  subMenuCloseDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  forceSubMenuRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  selectable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
Menu.defaultProps = {
  selectable: true,
  onClick: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onSelect: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onOpenChange: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  onDeselect: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {},
  builtinPlacements: {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSelect = function (selectInfo) {
    var props = _this3.props;
    if (props.selectable) {
      // root menu
      var selectedKeys = _this3.store.getState().selectedKeys;
      var selectedKey = selectInfo.key;
      if (props.multiple) {
        selectedKeys = selectedKeys.concat([selectedKey]);
      } else {
        selectedKeys = [selectedKey];
      }
      if (!('selectedKeys' in props)) {
        _this3.store.setState({
          selectedKeys: selectedKeys
        });
      }
      props.onSelect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
        selectedKeys: selectedKeys
      }));
    }
  };

  this.onClick = function (e) {
    _this3.props.onClick(e);
  };

  this.onKeyDown = function (e, callback) {
    _this3.innerMenu.getWrappedInstance().onKeyDown(e, callback);
  };

  this.onOpenChange = function (event) {
    var props = _this3.props;
    var openKeys = _this3.store.getState().openKeys.concat();
    var changed = false;
    var processSingle = function processSingle(e) {
      var oneChanged = false;
      if (e.open) {
        oneChanged = openKeys.indexOf(e.key) === -1;
        if (oneChanged) {
          openKeys.push(e.key);
        }
      } else {
        var index = openKeys.indexOf(e.key);
        oneChanged = index !== -1;
        if (oneChanged) {
          openKeys.splice(index, 1);
        }
      }
      changed = changed || oneChanged;
    };
    if (Array.isArray(event)) {
      // batch change call
      event.forEach(processSingle);
    } else {
      processSingle(event);
    }
    if (changed) {
      if (!('openKeys' in _this3.props)) {
        _this3.store.setState({ openKeys: openKeys });
      }
      props.onOpenChange(openKeys);
    }
  };

  this.onDeselect = function (selectInfo) {
    var props = _this3.props;
    if (props.selectable) {
      var selectedKeys = _this3.store.getState().selectedKeys.concat();
      var selectedKey = selectInfo.key;
      var index = selectedKeys.indexOf(selectedKey);
      if (index !== -1) {
        selectedKeys.splice(index, 1);
      }
      if (!('selectedKeys' in props)) {
        _this3.store.setState({
          selectedKeys: selectedKeys
        });
      }
      props.onDeselect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
        selectedKeys: selectedKeys
      }));
    }
  };

  this.getOpenTransitionName = function () {
    var props = _this3.props;
    var transitionName = props.openTransitionName;
    var animationName = props.openAnimation;
    if (!transitionName && typeof animationName === 'string') {
      transitionName = props.prefixCls + '-open-' + animationName;
    }
    return transitionName;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var DOMWrap = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DOMWrap, _React$Component);

  function DOMWrap() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DOMWrap);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DOMWrap.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
    if (!props.visible) {
      props.className += ' ' + props.hiddenClassName;
    }
    var Tag = props.tag;
    delete props.tag;
    delete props.hiddenClassName;
    delete props.visible;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, props);
  };

  return DOMWrap;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

DOMWrap.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (DOMWrap);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__placements__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rc_animate__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(107);
















var guid = 0;

var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var _extends2;

  var menuId = Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.defaultActiveFirst, (_extends2 = {}, _extends2[menuId] = defaultActiveFirst, _extends2))
  });
};

var SubMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SubMenu, _React$Component);

  function SubMenu(props) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SubMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var store = props.store;
    var eventKey = props.eventKey;
    var defaultActiveFirst = store.getState().defaultActiveFirst;

    _this.isRootMenu = false;

    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    updateDefaultActiveFirst(store, eventKey, value);
    return _this;
  }

  SubMenu.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate();
  };

  SubMenu.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var _props = this.props,
        mode = _props.mode,
        parentMenu = _props.parentMenu,
        manualRef = _props.manualRef;

    // invoke customized ref to expose component to mixin

    if (manualRef) {
      manualRef(this);
    }

    if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
      return;
    }

    this.minWidthTimeout = setTimeout(function () {
      return _this2.adjustWidth();
    }, 0);
  };

  SubMenu.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        onDestroy = _props2.onDestroy,
        eventKey = _props2.eventKey;

    if (onDestroy) {
      onDestroy(eventKey);
    }

    /* istanbul ignore if */
    if (this.minWidthTimeout) {
      clearTimeout(this.minWidthTimeout);
    }

    /* istanbul ignore if */
    if (this.mouseenterTimeout) {
      clearTimeout(this.mouseenterTimeout);
    }
  };

  SubMenu.prototype.renderChildren = function renderChildren(children) {
    var props = this.props;
    var baseProps = {
      mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
      visible: this.props.isOpen,
      level: props.level + 1,
      inlineIndent: props.inlineIndent,
      focusable: false,
      onClick: this.onSubMenuClick,
      onSelect: this.onSelect,
      onDeselect: this.onDeselect,
      onDestroy: this.onDestroy,
      selectedKeys: props.selectedKeys,
      eventKey: props.eventKey + '-menu-',
      openKeys: props.openKeys,
      openTransitionName: props.openTransitionName,
      openAnimation: props.openAnimation,
      onOpenChange: this.onOpenChange,
      subMenuOpenDelay: props.subMenuOpenDelay,
      parentMenu: this,
      subMenuCloseDelay: props.subMenuCloseDelay,
      forceSubMenuRender: props.forceSubMenuRender,
      triggerSubMenuAction: props.triggerSubMenuAction,
      builtinPlacements: props.builtinPlacements,
      defaultActiveFirst: props.store.getState().defaultActiveFirst[Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(props.eventKey)],
      multiple: props.multiple,
      prefixCls: props.rootPrefixCls,
      id: this._menuId,
      manualRef: this.saveMenuInstance
    };

    var haveRendered = this.haveRendered;
    this.haveRendered = true;

    this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender;
    // never rendered not planning to, don't render
    if (!this.haveOpened) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null);
    }

    // don't show transition on first rendering (no animation for opened menu)
    // show appear transition if it's not visible (not sure why)
    // show appear transition if it's not inline mode
    var transitionAppear = haveRendered || !baseProps.visible || !baseProps.mode === 'inline';

    baseProps.className = ' ' + baseProps.prefixCls + '-sub';
    var animProps = {};

    if (baseProps.openTransitionName) {
      animProps.transitionName = baseProps.openTransitionName;
    } else if (typeof baseProps.openAnimation === 'object') {
      animProps.animation = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps.openAnimation);
      if (!transitionAppear) {
        delete animProps.animation.appear;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_rc_animate__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, animProps, {
        showProp: 'visible',
        component: '',
        transitionAppear: transitionAppear
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps, { id: this._menuId }),
        children
      )
    );
  };

  SubMenu.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);
    var isOpen = props.isOpen;
    var prefixCls = this.getPrefixCls();
    var isInlineMode = props.mode === 'inline';
    var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, prefixCls + '-' + props.mode, (_classNames = {}, _classNames[props.className] = !!props.className, _classNames[this.getOpenClassName()] = isOpen, _classNames[this.getActiveClassName()] = props.active || isOpen && !isInlineMode, _classNames[this.getDisabledClassName()] = props.disabled, _classNames[this.getSelectedClassName()] = this.isChildrenSelected(), _classNames));

    if (!this._menuId) {
      if (props.eventKey) {
        this._menuId = props.eventKey + '$Menu';
      } else {
        this._menuId = '$__$' + ++guid + '$Menu';
      }
    }

    var mouseEvents = {};
    var titleClickEvents = {};
    var titleMouseEvents = {};
    if (!props.disabled) {
      mouseEvents = {
        onMouseLeave: this.onMouseLeave,
        onMouseEnter: this.onMouseEnter
      };

      // only works in title, not outer li
      titleClickEvents = {
        onClick: this.onTitleClick
      };
      titleMouseEvents = {
        onMouseEnter: this.onTitleMouseEnter,
        onMouseLeave: this.onTitleMouseLeave
      };
    }

    var style = {};
    if (isInlineMode) {
      style.paddingLeft = props.inlineIndent * props.level;
    }

    var ariaOwns = {};
    // only set aria-owns when menu is open
    // otherwise it would be an invalid aria-owns value
    // since corresponding node cannot be found
    if (this.props.isOpen) {
      ariaOwns = {
        'aria-owns': this._menuId
      };
    }

    var title = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
        ref: this.saveSubMenuTitle,
        style: style,
        className: prefixCls + '-title'
      }, titleMouseEvents, titleClickEvents, {
        'aria-expanded': isOpen
      }, ariaOwns, {
        'aria-haspopup': 'true',
        title: typeof props.title === 'string' ? props.title : undefined
      }),
      props.title,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i', { className: prefixCls + '-arrow' })
    );
    var children = this.renderChildren(props.children);

    var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
      return triggerNode.parentNode;
    };
    var popupPlacement = popupPlacementMap[props.mode];
    var popupAlign = props.popupOffset ? { offset: props.popupOffset } : {};
    var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
    var disabled = props.disabled,
        triggerSubMenuAction = props.triggerSubMenuAction,
        subMenuOpenDelay = props.subMenuOpenDelay,
        forceSubMenuRender = props.forceSubMenuRender,
        subMenuCloseDelay = props.subMenuCloseDelay,
        builtinPlacements = props.builtinPlacements;

    __WEBPACK_IMPORTED_MODULE_14__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });
    // Set onClick to null, to ignore propagated onClick event
    delete props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, props, mouseEvents, {
        className: className,
        role: 'menuitem'
      }),
      isInlineMode && title,
      isInlineMode && children,
      !isInlineMode && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
        {
          prefixCls: prefixCls,
          popupClassName: prefixCls + '-popup ' + popupClassName,
          getPopupContainer: getPopupContainer,
          builtinPlacements: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__placements__["a" /* default */], builtinPlacements),
          popupPlacement: popupPlacement,
          popupVisible: isOpen,
          popupAlign: popupAlign,
          popup: children,
          action: disabled ? [] : [triggerSubMenuAction],
          mouseEnterDelay: subMenuOpenDelay,
          mouseLeaveDelay: subMenuCloseDelay,
          onPopupVisibleChange: this.onPopupVisibleChange,
          forceRender: forceSubMenuRender
        },
        title
      )
    );
  };

  return SubMenu;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SubMenu.propTypes = {
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, // TODO: remove
  onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTitleClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  popupOffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
SubMenu.defaultProps = {
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  onTitleClick: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
  mode: 'vertical',
  title: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onDestroy = function (key) {
    _this3.props.onDestroy(key);
  };

  this.onKeyDown = function (e) {
    var keyCode = e.keyCode;
    var menu = _this3.menuInstance;
    var _props3 = _this3.props,
        isOpen = _props3.isOpen,
        store = _props3.store;


    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].ENTER) {
      _this3.onTitleClick(e);
      updateDefaultActiveFirst(store, _this3.props.eventKey, true);
      return true;
    }

    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
      if (isOpen) {
        menu.onKeyDown(e);
      } else {
        _this3.triggerOpenChange(true);
        // need to update current menu's defaultActiveFirst value
        updateDefaultActiveFirst(store, _this3.props.eventKey, true);
      }
      return true;
    }
    if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].LEFT) {
      var handled = void 0;
      if (isOpen) {
        handled = menu.onKeyDown(e);
      } else {
        return undefined;
      }
      if (!handled) {
        _this3.triggerOpenChange(false);
        handled = true;
      }
      return handled;
    }

    if (isOpen && (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN)) {
      return menu.onKeyDown(e);
    }
  };

  this.onOpenChange = function (e) {
    _this3.props.onOpenChange(e);
  };

  this.onPopupVisibleChange = function (visible) {
    _this3.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
  };

  this.onMouseEnter = function (e) {
    var _props4 = _this3.props,
        key = _props4.eventKey,
        onMouseEnter = _props4.onMouseEnter,
        store = _props4.store;

    updateDefaultActiveFirst(store, _this3.props.eventKey, false);
    onMouseEnter({
      key: key,
      domEvent: e
    });
  };

  this.onMouseLeave = function (e) {
    var _props5 = _this3.props,
        parentMenu = _props5.parentMenu,
        eventKey = _props5.eventKey,
        onMouseLeave = _props5.onMouseLeave;

    parentMenu.subMenuInstance = _this3;
    onMouseLeave({
      key: eventKey,
      domEvent: e
    });
  };

  this.onTitleMouseEnter = function (domEvent) {
    var _props6 = _this3.props,
        key = _props6.eventKey,
        onItemHover = _props6.onItemHover,
        onTitleMouseEnter = _props6.onTitleMouseEnter;

    onItemHover({
      key: key,
      hover: true
    });
    onTitleMouseEnter({
      key: key,
      domEvent: domEvent
    });
  };

  this.onTitleMouseLeave = function (e) {
    var _props7 = _this3.props,
        parentMenu = _props7.parentMenu,
        eventKey = _props7.eventKey,
        onItemHover = _props7.onItemHover,
        onTitleMouseLeave = _props7.onTitleMouseLeave;

    parentMenu.subMenuInstance = _this3;
    onItemHover({
      key: eventKey,
      hover: false
    });
    onTitleMouseLeave({
      key: eventKey,
      domEvent: e
    });
  };

  this.onTitleClick = function (e) {
    var props = _this3.props;

    props.onTitleClick({
      key: props.eventKey,
      domEvent: e
    });
    if (props.triggerSubMenuAction === 'hover') {
      return;
    }
    _this3.triggerOpenChange(!props.isOpen, 'click');
    updateDefaultActiveFirst(props.store, _this3.props.eventKey, false);
  };

  this.onSubMenuClick = function (info) {
    _this3.props.onClick(_this3.addKeyPath(info));
  };

  this.onSelect = function (info) {
    _this3.props.onSelect(info);
  };

  this.onDeselect = function (info) {
    _this3.props.onDeselect(info);
  };

  this.getPrefixCls = function () {
    return _this3.props.rootPrefixCls + '-submenu';
  };

  this.getActiveClassName = function () {
    return _this3.getPrefixCls() + '-active';
  };

  this.getDisabledClassName = function () {
    return _this3.getPrefixCls() + '-disabled';
  };

  this.getSelectedClassName = function () {
    return _this3.getPrefixCls() + '-selected';
  };

  this.getOpenClassName = function () {
    return _this3.props.rootPrefixCls + '-submenu-open';
  };

  this.saveMenuInstance = function (c) {
    // children menu instance
    _this3.menuInstance = c;
  };

  this.addKeyPath = function (info) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, info, {
      keyPath: (info.keyPath || []).concat(_this3.props.eventKey)
    });
  };

  this.triggerOpenChange = function (open, type) {
    var key = _this3.props.eventKey;
    var openChange = function openChange() {
      _this3.onOpenChange({
        key: key,
        item: _this3,
        trigger: type,
        open: open
      });
    };
    if (type === 'mouseenter') {
      // make sure mouseenter happen after other menu item's mouseleave
      _this3.mouseenterTimeout = setTimeout(function () {
        openChange();
      }, 0);
    } else {
      openChange();
    }
  };

  this.isChildrenSelected = function () {
    var ret = { find: false };
    Object(__WEBPACK_IMPORTED_MODULE_14__util__["d" /* loopMenuItemRecursively */])(_this3.props.children, _this3.props.selectedKeys, ret);
    return ret.find;
  };

  this.isOpen = function () {
    return _this3.props.openKeys.indexOf(_this3.props.eventKey) !== -1;
  };

  this.adjustWidth = function () {
    /* istanbul ignore if */
    if (!_this3.subMenuTitle || !_this3.menuInstance) {
      return;
    }
    var popupMenu = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this3.menuInstance);
    if (popupMenu.offsetWidth >= _this3.subMenuTitle.offsetWidth) {
      return;
    }

    /* istanbul ignore next */
    popupMenu.style.minWidth = _this3.subMenuTitle.offsetWidth + 'px';
  };

  this.saveSubMenuTitle = function (subMenuTitle) {
    _this3.subMenuTitle = subMenuTitle;
  };
};

var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
  var openKeys = _ref.openKeys,
      activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);

connected.isSubMenu = true;

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(935);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(388);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(937);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(939);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(387);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(390);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(391);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(107);













/* eslint react/no-is-mounted:0 */

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER) {
        _this.onClick(e);
        return true;
      }
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;

      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;

      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;

      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: _this,
        domEvent: e
      };
      onClick(info);
      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    return _this;
  }

  MenuItem.prototype.componentDidMount = function componentDidMount() {
    // invoke customized ref to expose component to mixin
    this.callRef();
  };

  MenuItem.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.active) {
      __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default()(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this), __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.props.parentMenu), {
        onlyScrollIfNeeded: true
      });
    }
    this.callRef();
  };

  MenuItem.prototype.componentWillUnmount = function componentWillUnmount() {
    var props = this.props;
    if (props.onDestroy) {
      props.onDestroy(props.eventKey);
    }
  };

  MenuItem.prototype.getPrefixCls = function getPrefixCls() {
    return this.props.rootPrefixCls + '-item';
  };

  MenuItem.prototype.getActiveClassName = function getActiveClassName() {
    return this.getPrefixCls() + '-active';
  };

  MenuItem.prototype.getSelectedClassName = function getSelectedClassName() {
    return this.getPrefixCls() + '-selected';
  };

  MenuItem.prototype.getDisabledClassName = function getDisabledClassName() {
    return this.getPrefixCls() + '-disabled';
  };

  MenuItem.prototype.callRef = function callRef() {
    if (this.props.manualRef) {
      this.props.manualRef(this);
    }
  };

  MenuItem.prototype.render = function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
    var className = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(this.getPrefixCls(), props.className, (_classNames = {}, _classNames[this.getActiveClassName()] = !props.disabled && props.active, _classNames[this.getSelectedClassName()] = props.isSelected, _classNames[this.getDisabledClassName()] = props.disabled, _classNames));
    var attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.attribute, {
      title: props.title,
      className: className,
      // set to menuitem by default
      role: props.role || 'menuitem',
      'aria-disabled': props.disabled
    });

    if (props.role === 'option') {
      // overwrite to option
      attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, attrs, {
        role: 'option',
        'aria-selected': props.isSelected
      });
    } else if (props.role === null || props.role === 'none') {
      // sometimes we want to specify role inside <li/> element
      // <li><a role='menuitem'>Link</a></li> would be a good example
      // in this case the role on <li/> should be "none" to
      // remove the implied listitem role.
      // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
      attrs.role = 'none';
    }
    // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner
    var mouseEvent = {
      onClick: props.disabled ? null : this.onClick,
      onMouseLeave: props.disabled ? null : this.onMouseLeave,
      onMouseEnter: props.disabled ? null : this.onMouseEnter
    };
    var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style);
    if (props.mode === 'inline') {
      style.paddingLeft = props.inlineIndent * props.level;
    }
    __WEBPACK_IMPORTED_MODULE_11__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, attrs, mouseEvent, {
        style: style
      }),
      props.children
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MenuItem.propTypes = {
  attribute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  isSelected: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
MenuItem.defaultProps = {
  onSelect: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
  manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */]
};
MenuItem.isMenuItem = true;

var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem);

/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(949);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(950);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(107);









var MenuItemGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItemGroup, _React$Component);

  function MenuItemGroup() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItemGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;

      return renderMenuItem(item, index, _this.props.subMenuKey);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  MenuItemGroup.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        rootPrefixCls = props.rootPrefixCls;

    var titleClassName = rootPrefixCls + '-item-group-title';
    var listClassName = rootPrefixCls + '-item-group-list';
    var title = props.title,
        children = props.children;

    __WEBPACK_IMPORTED_MODULE_7__util__["e" /* menuAllProps */].forEach(function (key) {
      return delete props[key];
    });

    // Set onClick to null, to ignore propagated onClick event
    delete props.onClick;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'li',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: className + ' ' + rootPrefixCls + '-item-group' }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: titleClassName,
          title: typeof title === 'string' ? title : undefined
        },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'ul',
        { className: listClassName },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(children, this.renderInnerMenuItem)
      )
    );
  };

  return MenuItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MenuItemGroup.propTypes = {
  renderMenuItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  subMenuKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
MenuItemGroup.defaultProps = {
  disabled: true
};


MenuItemGroup.isMenuItemGroup = true;

/* unused harmony default export */ var _unused_webpack_default_export = (MenuItemGroup);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Divider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Divider, _React$Component);

  function Divider() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Divider);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Divider.prototype.render = function render() {
    var _props = this.props,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        rootPrefixCls = _props.rootPrefixCls;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li', { className: className + ' ' + rootPrefixCls + '-item-divider' });
  };

  return Divider;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Divider.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};
Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true
};
/* unused harmony default export */ var _unused_webpack_default_export = (Divider);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var matches = __webpack_require__(954);

/**
 * @param element {Element}
 * @param selector {String}
 * @param context {Element}
 * @return {Element}
 */
module.exports = function (element, selector, context) {
  context = context || document;
  // guard against orphans
  element = { parentNode: element };

  while ((element = element.parentNode) && element !== context) {
    if (matches(element, selector)) {
      return element;
    }
  }
};


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determine if a DOM element matches a CSS selector
 *
 * @param {Element} elem
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function matches(elem, selector) {
  // Vendor-specific implementations of `Element.prototype.matches()`.
  var proto = window.Element.prototype;
  var nativeMatches = proto.matches ||
      proto.mozMatchesSelector ||
      proto.msMatchesSelector ||
      proto.oMatchesSelector ||
      proto.webkitMatchesSelector;

  if (!elem || elem.nodeType !== 1) {
    return false;
  }

  var parentElem = elem.parentNode;

  // use native 'matches'
  if (nativeMatches) {
    return nativeMatches.call(elem, selector);
  }

  // native support for `matches` is missing and a fallback is required
  var nodes = parentElem.querySelectorAll(selector);
  var len = nodes.length;

  for (var i = 0; i < len; i++) {
    if (nodes[i] === elem) {
      return true;
    }
  }

  return false;
}

/**
 * Expose `matches`
 */

module.exports = matches;


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (function (props) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className, onClick: props.onClick }, props.children)); });


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function createStore(initialState) {
    var state = initialState;
    var listeners = [];
    function setState(partial) {
        state = __assign({}, state, partial);
        for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
        }
    }
    function getState() {
        return state;
    }
    function subscribe(listener) {
        listeners.push(listener);
        return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    }
    return {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
    };
}


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_checkbox__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var SelectionBox = /** @class */ (function (_super) {
    __extends(SelectionBox, _super);
    function SelectionBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            checked: _this.getCheckState(props),
        };
        return _this;
    }
    SelectionBox.prototype.componentDidMount = function () {
        this.subscribe();
    };
    SelectionBox.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    SelectionBox.prototype.subscribe = function () {
        var _this = this;
        var store = this.props.store;
        this.unsubscribe = store.subscribe(function () {
            var checked = _this.getCheckState(_this.props);
            _this.setState({ checked: checked });
        });
    };
    SelectionBox.prototype.getCheckState = function (props) {
        var store = props.store, defaultSelection = props.defaultSelection, rowIndex = props.rowIndex;
        var checked = false;
        if (store.getState().selectionDirty) {
            checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
        }
        else {
            checked = (store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 ||
                defaultSelection.indexOf(rowIndex) >= 0);
        }
        return checked;
    };
    SelectionBox.prototype.render = function () {
        var _a = this.props, type = _a.type, rowIndex = _a.rowIndex, rest = __rest(_a, ["type", "rowIndex"]);
        var checked = this.state.checked;
        if (type === 'radio') {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd__["Radio"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Radio@9mf9qy", checked: checked, value: rowIndex }, rest)));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__view_checkbox__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Checkbox@j4nc5f", checked: checked }, rest)));
        }
    };
    return SelectionBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SelectionBox);


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_checkbox__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var SelectionCheckboxAll = /** @class */ (function (_super) {
    __extends(SelectionCheckboxAll, _super);
    function SelectionCheckboxAll(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectAllChagne = function (e) {
            var checked = e.target.checked;
            _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
        };
        _this.defaultSelections = props.hideDefaultSelections ? [] : [{
                key: 'all',
                text: props.locale.selectAll,
                onSelect: function () { },
            }, {
                key: 'invert',
                text: props.locale.selectInvert,
                onSelect: function () { },
            }];
        _this.state = {
            checked: _this.getCheckState(props),
            indeterminate: _this.getIndeterminateState(props),
        };
        return _this;
    }
    SelectionCheckboxAll.prototype.componentDidMount = function () {
        this.subscribe();
    };
    SelectionCheckboxAll.prototype.componentWillReceiveProps = function (nextProps) {
        this.setCheckState(nextProps);
    };
    SelectionCheckboxAll.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    SelectionCheckboxAll.prototype.subscribe = function () {
        var _this = this;
        var store = this.props.store;
        this.unsubscribe = store.subscribe(function () {
            _this.setCheckState(_this.props);
        });
    };
    SelectionCheckboxAll.prototype.checkSelection = function (data, type, byDefaultChecked) {
        var _a = this.props, store = _a.store, getCheckboxPropsByItem = _a.getCheckboxPropsByItem, getRecordKey = _a.getRecordKey;
        // type should be 'every' | 'some'
        if (type === 'every' || type === 'some') {
            return (byDefaultChecked
                ? data[type](function (item, i) { return getCheckboxPropsByItem(item, i).defaultChecked; })
                : data[type](function (item, i) {
                    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
                }));
        }
        return false;
    };
    SelectionCheckboxAll.prototype.setCheckState = function (props) {
        var checked = this.getCheckState(props);
        var indeterminate = this.getIndeterminateState(props);
        if (checked !== this.state.checked) {
            this.setState({ checked: checked });
        }
        if (indeterminate !== this.state.indeterminate) {
            this.setState({ indeterminate: indeterminate });
        }
    };
    SelectionCheckboxAll.prototype.getCheckState = function (props) {
        var store = props.store, data = props.data;
        var checked;
        if (!data.length) {
            checked = false;
        }
        else {
            checked = store.getState().selectionDirty
                ? this.checkSelection(data, 'every', false)
                : (this.checkSelection(data, 'every', false) ||
                    this.checkSelection(data, 'every', true));
        }
        return checked;
    };
    SelectionCheckboxAll.prototype.getIndeterminateState = function (props) {
        var store = props.store, data = props.data;
        var indeterminate;
        if (!data.length) {
            indeterminate = false;
        }
        else {
            indeterminate = store.getState().selectionDirty
                ? (this.checkSelection(data, 'some', false) &&
                    !this.checkSelection(data, 'every', false))
                : ((this.checkSelection(data, 'some', false) &&
                    !this.checkSelection(data, 'every', false)) ||
                    (this.checkSelection(data, 'some', true) &&
                        !this.checkSelection(data, 'every', true)));
        }
        return indeterminate;
    };
    SelectionCheckboxAll.prototype.renderMenus = function (selections) {
        var _this = this;
        return selections.map(function (selection, index) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@34vgi5@" + index, key: selection.key || index },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { onClick: function () { _this.props.onSelect(selection.key, index, selection.onSelect); } }, selection.text)));
        });
    };
    SelectionCheckboxAll.prototype.render = function () {
        var _a;
        var _b = this.props, disabled = _b.disabled, prefixCls = _b.prefixCls, selections = _b.selections, getPopupContainer = _b.getPopupContainer;
        var _c = this.state, checked = _c.checked, indeterminate = _c.indeterminate;
        var selectionPrefixCls = prefixCls + "-selection";
        var customSelections = null;
        if (selections) {
            var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections)
                : this.defaultSelections;
            var menu = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"], { ecId: (this && this.props && this.props.ecId || '') + "_Menu@sd1g29", className: selectionPrefixCls + "-menu", selectedKeys: [] }, this.renderMenus(newSelections)));
            customSelections = newSelections.length > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_antd__["Dropdown"], { ecId: (this && this.props && this.props.ecId || '') + "_Dropdown@0gq0m6", overlay: menu, getPopupContainer: getPopupContainer },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: selectionPrefixCls + "-down" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "anticon anticon-down" })))) : null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: selectionPrefixCls },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__view_checkbox__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Checkbox@c4b0he", className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()((_a = {}, _a[selectionPrefixCls + "-select-all-custom"] = customSelections, _a)), checked: checked, indeterminate: indeterminate, disabled: disabled, onChange: this.handleSelectAllChagne }),
            customSelections));
    };
    return SelectionCheckboxAll;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (SelectionCheckboxAll);


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Column = /** @class */ (function (_super) {
    __extends(Column, _super);
    function Column() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Column;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Column);


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ColumnGroup = /** @class */ (function (_super) {
    __extends(ColumnGroup, _super);
    function ColumnGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;
    return ColumnGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ColumnGroup);


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTableRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_omit_js__ = __webpack_require__(154);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



function createTableRow(Component) {
    if (Component === void 0) { Component = 'tr'; }
    var BodyRow = /** @class */ (function (_super) {
        __extends(BodyRow, _super);
        function BodyRow(props) {
            var _this = _super.call(this, props) || this;
            _this.store = props.store;
            var selectedRowKeys = _this.store.getState().selectedRowKeys;
            _this.state = {
                selected: selectedRowKeys.indexOf(props.rowKey) >= 0,
            };
            return _this;
        }
        BodyRow.prototype.componentDidMount = function () {
            this.subscribe();
        };
        BodyRow.prototype.componentWillUnmount = function () {
            if (this.unsubscribe) {
                this.unsubscribe();
            }
        };
        BodyRow.prototype.subscribe = function () {
            var _this = this;
            var _a = this.props, store = _a.store, rowKey = _a.rowKey;
            this.unsubscribe = store.subscribe(function () {
                var selectedRowKeys = _this.store.getState().selectedRowKeys;
                var selected = selectedRowKeys.indexOf(rowKey) >= 0;
                if (selected !== _this.state.selected) {
                    _this.setState({ selected: selected });
                }
            });
        };
        BodyRow.prototype.render = function () {
            var _a;
            var rowProps = Object(__WEBPACK_IMPORTED_MODULE_2_omit_js__["a" /* default */])(this.props, ['prefixCls', 'rowKey', 'store']);
            var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, (_a = {},
                _a[this.props.prefixCls + "-row-selected"] = this.state.selected,
                _a));
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component, __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Component@zjiun1" }, rowProps, { className: className }), this.props.children));
        };
        return BodyRow;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
    return BodyRow;
}


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatArray;
/* harmony export (immutable) */ __webpack_exports__["d"] = treeMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = flatFilter;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeColumns;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

function flatArray(data, childrenName) {
    if (data === void 0) { data = []; }
    if (childrenName === void 0) { childrenName = 'children'; }
    var result = [];
    var loop = function (array) {
        array.forEach(function (item) {
            if (item[childrenName]) {
                var newItem = __assign({}, item);
                delete newItem[childrenName];
                result.push(newItem);
                if (item[childrenName].length > 0) {
                    loop(item[childrenName]);
                }
            }
            else {
                result.push(item);
            }
        });
    };
    loop(data);
    return result;
}
function treeMap(tree, mapper, childrenName) {
    if (childrenName === void 0) { childrenName = 'children'; }
    return tree.map(function (node, index) {
        var extra = {};
        if (node[childrenName]) {
            extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
        }
        return __assign({}, mapper(node, index), extra);
    });
}
function flatFilter(tree, callback) {
    return tree.reduce(function (acc, node) {
        if (callback(node)) {
            acc.push(node);
        }
        if (node.children) {
            var children = flatFilter(node.children, callback);
            acc.push.apply(acc, children);
        }
        return acc;
    }, []);
}
function normalizeColumns(elements) {
    var columns = [];
    __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(elements, function (element) {
        if (!__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](element)) {
            return;
        }
        var column = __assign({}, element.props);
        if (element.key) {
            column.key = element.key;
        }
        if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
            column.children = normalizeColumns(column.children);
        }
        columns.push(column);
    });
    return columns;
}


/***/ }),
/* 963 */
/***/ (function(module, exports) {



/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputNumber__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Seclevel__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputPopover__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Checkbox__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShowDialog__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Browser__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WeaDatePicker__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WeaTimePicker__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WeaTextarea__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Upload__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__WeaDateTimePicker__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



















var getMultiStrFromBase64 = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaInputLocale"].getMultiStrFromBase64;
var getCurrentLabel = __WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaInputLocale"].getCurrentLabel;
var TableCell = /** @class */ (function (_super) {
    __extends(TableCell, _super);
    function TableCell(props) {
        var _this = _super.call(this, props) || this;
        _this.renderEditor = function () {
            var _a = _this.props, randomkey = _a.randomkey, tableStore = _a.tableStore, isNoSwitchEditStatus = _a.isNoSwitchEditStatus, isfrontmultlang = _a.isfrontmultlang, batchAddStore = _a.Search.batchAddStore;
            var column = _this.props.column;
            column = __assign({}, column, _this.state._column);
            var isOpenClassprotect = batchAddStore.isOpenClassprotect, secretTimeDefValue = batchAddStore.secretTimeDefValue, defalutSeclevel = batchAddStore.defalutSeclevel;
            var form = tableStore.form.$('tableForm');
            var row = form.$(randomkey);
            if (column.conditionType.toLowerCase() == 'browser' && column.fieldtype == '161') {
                var replaceDatas = Object(__WEBPACK_IMPORTED_MODULE_18_mobx__["toJS"])(column.browserConditionParam.replaceDatas);
                if (tableStore.form.$("tableForm." + row.key + "." + column.key).value == '' && replaceDatas.length > 0) {
                    var spanvalue = new Array();
                    spanvalue.push(replaceDatas[0].name);
                    tableStore.form.$("tableForm." + row.key + "." + column.key).value = replaceDatas[0].id;
                    tableStore.form.$("tableForm." + row.key + "." + column.key + "span").value = JSON.stringify(spanvalue);
                }
            }
            var field = row.$(column.key);
            var bindObj = field.bind();
            if (isNoSwitchEditStatus && column.viewAttr != 1)
                bindObj.editable = true;
            var conditionType = column.conditionType.toLowerCase();
            var commonProps = {
                autoFocus: false,
                onChange: _this.handleChange,
                editable: !bindObj.disabled && bindObj.editable && column.viewAttr != 1,
                disabled: bindObj.disabled,
                row: row,
                field: field,
                column: column,
                isfrontmultlang: column.detailtype == '1' && conditionType == 'input' ? isfrontmultlang : false
            };
            conditionType = _this.state._conditionType || conditionType;
            if (conditionType == 'htmlinput') {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: bindObj.value } });
            }
            else if (conditionType == 'input') { //文本框
                if (column.detailtype == '2' || column.detailtype == '3') { //整数
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InputNumber__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_InputNumber@3zdmqs" }, commonProps, { maxLength: column.maxLength, reg: column.reg, value: bindObj.value, min: column.min, max: column.max, qfws: column.qfw })));
                }
                else if (column.detailtype == '6') {
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputPopover__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_InputPopover@ccb0kt" }, commonProps, { addonBefore: column.addonBefore, value: bindObj.value })));
                }
                else if (column.fieldid == '-4') { //标签
                    var weatag = bindObj.value && JSON.parse(bindObj.value).map(function (tag, i) {
                        if (tag.tabname != '') {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_ecCom__["WeaTag"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTag@1aresy@" + i, title: tag.tabname, style: {
                                    borderRadius: '4px',
                                    marginBottom: 2,
                                    marginRight: 10,
                                    color: tag.color,
                                    backgroundColor: tag.bgcolor,
                                    borderColor: tag.bdcolor
                                } }, tag.tabname.length > 10 ? tag.tabname.slice(0, 10) + "..." : tag.tabname);
                        }
                        else {
                            return tag + " ";
                        }
                    });
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, weatag));
                }
                else {
                    if (isfrontmultlang && column.detailtype == '1' && !bindObj.editable && bindObj.value.indexOf('base64_') >= 0) {
                        bindObj.value = getCurrentLabel(getMultiStrFromBase64(bindObj.value));
                    }
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Input__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Input@0q4ege" }, commonProps, { value: bindObj.value })));
                }
            }
            else if (conditionType == 'checkbox') {
                var newKey = {};
                if (column.linkedFields) {
                    newKey = { key: new Date().getTime() };
                }
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Checkbox__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Checkbox@tqum2e" }, newKey, commonProps, { linkedFields: column.linkedFields, value: bindObj.value })));
            }
            else if (conditionType == 'date') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__WeaDatePicker__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDatePicker@26d1wx" }, commonProps, { value: bindObj.value, onChange: function (v) {
                            _this.handleChange(v);
                        } }))));
            }
            else if (conditionType == 'textarea') {
                if (column.viewAttr == 1) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: bindObj.value } });
                }
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__WeaTextarea__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTextarea@zihgf8" }, commonProps, { value: bindObj.value, onChange: function (v) {
                            _this.handleChange(v);
                        } }))));
            }
            else if (conditionType == 'time') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__WeaTimePicker__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTimePicker@d2qvn2" }, commonProps, { value: bindObj.value, onChange: function (v) {
                            _this.handleChange(v);
                        } }))));
            }
            else if (conditionType == 'datetime') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__WeaDateTimePicker__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDateTimePicker@g6iafm" }, commonProps, { value: bindObj.value, onChange: function (v) {
                            _this.handleChange(v);
                        } }))));
            }
            else if (conditionType == 'year') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__WeaDatePicker__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDatePicker@vgc0kf" }, commonProps, { format: 'YYYY', value: bindObj.value, onChange: function (v) {
                            _this.handleChange(v);
                        } }))));
            }
            else if (conditionType == 'yearmonth') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__WeaDatePicker__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDatePicker@j2ljuh" }, commonProps, { format: 'YYYY-MM', value: bindObj.value, onChange: function (v) {
                            _this.handleChange(v);
                        } }))));
            }
            else if (conditionType == 'select' && column.fieldid == '-9') { // 密级字段
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Seclevel__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Seclevel@31krt0" }, commonProps, { options: column.options ? column.options.slice() : [], value: bindObj.value, tableStore: tableStore, secretTimeDefValue: secretTimeDefValue })));
            }
            else if (conditionType == 'select') { //选择框字段
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Select__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Select@aa82nb" }, commonProps, { options: column.options ? column.options.slice() : [], value: bindObj.value })));
            }
            else if (conditionType == 'dialog') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ShowDialog__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_ShowDialog@ykbttz", readOnly: true }, commonProps, { showDialog: _this.showDialog, value: field && field.value })));
            }
            else if (conditionType == 'browser') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Browser__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Browser@7z35qx" }, commonProps, { defalutSeclevel: defalutSeclevel })));
            }
            else if (conditionType == 'weaupload') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Upload__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Upload@7ju8r0" }, commonProps, { isOpenClassprotect: isOpenClassprotect, defalutSeclevel: defalutSeclevel })));
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Input__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Input@74aqad" }, commonProps, { value: bindObj.value, onChange: function (e) {
                    _this.handleChange(e.target.value);
                } })));
        };
        _this.reRenderModifiedArea = function (props) {
            var _a = props || _this.props, column = _a.column, randomkey = _a.randomkey, tableStore = _a.tableStore;
            var form = tableStore.form.$('tableForm');
            var row = form.$(randomkey);
            var field = row.$(column.key);
            if (field && tableStore.oldDataRecord.length > 0) {
                tableStore.oldDataRecord.forEach(function (el) {
                    if (el._fieldid == column.fieldid && randomkey.toString().split("_")[0] == el.randomFieldId) {
                        if (randomkey.toString().split("_")[1] == el.randomFieldSubKeyd_id) {
                            field.value = el[column.fieldid];
                            field.modified = el.modified;
                        }
                    }
                });
            }
            window['computeTableHeight']();
        };
        _this.handleChange = function (value, names, datas) {
            var _a = _this.props, tableStore = _a.tableStore, randomkey = _a.randomkey, column = _a.column, isfrontmultlang = _a.isfrontmultlang;
            var form = tableStore.form.$('tableForm');
            var row = form.$(randomkey);
            var field = row.$(column.key);
            var obj = {};
            var flag = false, mark = -1;
            obj[column.fieldid] = value;
            obj["_fieldid"] = column.fieldid;
            obj["randomFieldId"] = randomkey ? randomkey.toString().split("_")[0] : "";
            obj["oldValue"] = field.oldValue;
            obj["randomFieldSubKeyd_id"] = randomkey ? randomkey.toString().split("_")[1] : "";
            if (obj["oldValue"] !== undefined) {
                obj["modified"] = obj[column.fieldid] !== obj["oldValue"];
            }
            if (obj["oldValue"] !== undefined && isfrontmultlang && column.detailtype == '1') {
                obj["modified"] = obj[column.fieldid] !== getMultiStrFromBase64(obj["oldValue"]);
            }
            tableStore.oldDataRecord = tableStore.oldDataRecord.map(function (v, i) {
                if (v._fieldid == obj["_fieldid"] && v.randomFieldId == obj["randomFieldId"] && v.randomFieldSubKeyd_id == obj["randomFieldSubKeyd_id"]) {
                    v = obj;
                    flag = true;
                    mark = i;
                }
                return v;
            });
            if (!flag) {
                if (obj[column.fieldid] !== obj["oldValue"]) {
                    tableStore.oldDataRecord.push(obj);
                }
            }
            else {
                if (!obj["modified"]) {
                    tableStore.oldDataRecord.splice(mark, mark + 1);
                }
            }
            field.onChange && field.onChange(value, names, datas);
        };
        _this.showDialog = function () {
            var _a = _this.props, tableStore = _a.tableStore, randomkey = _a.randomkey;
            var column = _this.props.column;
            column = __assign({}, column, _this.state._column);
            tableStore.showDialog(column, randomkey);
        };
        _this.state = { _column: {} };
        return _this;
    }
    TableCell.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, column = _a.column, randomkey = _a.randomkey, tableStore = _a.tableStore, isNoSwitchEditStatus = _a.isNoSwitchEditStatus;
        var form = tableStore.form.$('tableForm');
        var row = form.$(randomkey);
        if (column.conditionType.toLowerCase() != 'checkbox' && !isNoSwitchEditStatus) {
            __WEBPACK_IMPORTED_MODULE_13_jquery___default()(this.refs._container).closest('td').click(function (e) {
                e.preventDefault();
                if (column.changeVirtualFormFieldType) { //作用于表单，虚拟表单修改字段类型和字段属性功能
                    _this.setState({ _column: column.changeVirtualFormFieldType(column.key, row) });
                }
                tableStore.toEdit(randomkey, column.key);
            });
        }
        this.reRenderModifiedArea();
    };
    TableCell.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.reRenderModifiedArea(nextProps);
    };
    TableCell.prototype.render = function () {
        var _a = this.props, tableStore = _a.tableStore, randomkey = _a.randomkey, column = _a.column;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { ref: '_container', className: "cube-mobx-table-cell" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_antd__["Badge"], { ecId: (this && this.props && this.props.ecId || '') + "_Badge@rlo5mo", className: "cube-mobx-table-cell-badge", style: { 'z-index': '1' }, dot: tableStore.form.$("tableForm." + randomkey + "." + column.key).modified }, this.renderEditor())));
    };
    TableCell = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('Search'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TableCell);
    return TableCell;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TableCell);


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _this = this;



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var column = props.column, row = props.row, value = props.value, isfrontmultlang = props.isfrontmultlang;
    var valueSpan = row.value[column.key + 'Span'] && row.$(column.key + 'Span').value;
    var valueDesc = column.valueDesc && column.valueDesc(value, row);
    var hide = column && column.isHide && column.isHide(row);
    var fieldlength_tmp = 100;
    if (column.fielddbtype && column.fieldtype) {
        if (column.fieldtype == '1') {
            fieldlength_tmp = parseInt(column.fielddbtype.substring(column.fielddbtype.indexOf("(") + 1, column.fielddbtype.length - 1));
        }
        else if (column.fieldtype == '2') {
            fieldlength_tmp = 11;
        }
        else {
            fieldlength_tmp = 38;
        }
    }
    var args = isfrontmultlang ? {
        isBase64: true,
        inputType: "multilang",
        i18nLengthValidate: { maxLength: fieldlength_tmp, errorMessage: '' }
    } : {};
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: "none" } : { display: "block" } }, props.editable ?
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaInput"], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@s062lu" }, args, { stringLength: fieldlength_tmp, value: props.value || "", onChange: function (e) {
                props.onChange(e);
                column.onChange && column.onChange(e, row);
            } }))
        : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, valueDesc || valueSpan || value)));
}));


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IntegerInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_modeUtil__ = __webpack_require__(66);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _this = this;





var IntegerInput = /** @class */ (function (_super) {
    __extends(IntegerInput, _super);
    function IntegerInput(props) {
        var _this = _super.call(this, props) || this;
        _this.formatter = function (fieldhtmltype, fieldtype, val) {
            var _a = _this.props.qfws, qfws = _a === void 0 ? 2 : _a;
            var _value = val ? "" + val : "";
            if (_value.endsWith(".")) {
                _value += "0";
            }
            _value = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(_value).length > 0 ? _value.replace(/\,/g, '') : '';
            if (fieldhtmltype == '1' && fieldtype == '5') {
                return Object(__WEBPACK_IMPORTED_MODULE_4__util_modeUtil__["a" /* formatFloatValue */])(_value, qfws, true);
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_4__util_modeUtil__["a" /* formatFloatValue */])(_value, qfws, false);
            }
        };
        _this.onChange = function (e) {
            var value = e.target.value;
            var _a = _this.props, reg = _a.reg, max = _a.max, min = _a.min;
            if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                var intValue = (value === '' || value === '-') ? value : value;
                if (max && intValue > max || min && intValue < min)
                    return;
                _this.props.onChange && _this.props.onChange(intValue);
            }
        };
        _this.onBlur = function (e) {
            var value = e.target.value;
            var _a = _this.props, reg = _a.reg, column = _a.column, row = _a.row;
            var fieldhtmltype = column.fieldhtmltype, fieldtype = column.fieldtype;
            if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                var intValue = (value === '' || value === '-') ? value : value;
                intValue = _this.formatter(fieldhtmltype, fieldtype, intValue);
                _this.props.onChange && _this.props.onChange(intValue);
                column.onChange && column.onChange(intValue, row);
            }
        };
        _this.onFocus = function (e) {
            var value = e.target.value;
            if (value.indexOf(",") === -1) {
                return;
            }
            var _a = _this.props, column = _a.column, row = _a.row;
            var intValue = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(value).length > 0 ? value.replace(/\,/g, '') : '';
            _this.props.onChange && _this.props.onChange(intValue);
            column.onChange && column.onChange(value, row);
        };
        return _this;
    }
    IntegerInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, column = _a.column, row = _a.row;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Input"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Input@3o0mtp" }, this.props, { disabled: this.props.disabled, value: this.props.value, onBlur: function (e) { return _this.onBlur(e); }, onFocus: function (e) { return _this.onFocus(e); }, onChange: function (e) { _this.onChange(e); column.onChange && column.onChange(e.target.value, row); } })));
    };
    return IntegerInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    return (props.editable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntegerInput, __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_IntegerInput@u6ws77" }, props)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, props.value));
}));


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getOptions = function () {
            var options = _this.props.options;
            var optionArr = [];
            options && options.map(function (opt) {
                optionArr.push({
                    key: opt.key,
                    showname: opt.showname
                });
            });
            return optionArr;
        };
        return _this;
    }
    Main.prototype.render = function () {
        var props = this.props;
        var filered = props.options && props.options.filter(function (d) { return props.value ? d.key == props.value : d.selected; });
        var value = props.value;
        var showname = '';
        var column = props.column, row = props.row;
        if (column.detailtype != 2) {
            if (filered && filered.length > 0) {
                value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(filered, '[0].key');
                showname = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(filered, '[0].showname');
            }
            else {
                value = '';
            }
        }
        var hide = column && column.isHide && column.isHide(row);
        var valueSpan = row.value[column.key + 'Span'] && row.$(column.key + 'Span').value;
        var valueDesc = column.valueDesc && column.valueDesc(value, row);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: "none" } : { display: "block" } }, props.editable ?
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaSelect"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@g1rd3z" }, props, { detailtype: column.detailtype, options: this.getOptions(), value: value, onChange: function (key) { props.onChange && props.onChange(key); column.onChange && column.onChange(key, row); }, style: column.width ? { maxWidth: column.width, width: "100%" } : { width: "100%" }, supportCancel: true }))
            :
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, valueDesc || valueSpan || showname)));
    };
    Main = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Main);
    return Main;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Main);


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getOptions = function () {
            var options = _this.props.options;
            var optionArr = [];
            options && options.map(function (opt) {
                optionArr.push({
                    key: opt.key,
                    showname: opt.showname
                });
            });
            return optionArr;
        };
        _this.handleChange = function (v) {
            var _a = _this.props, value = _a.value, tableStore = _a.tableStore, row = _a.row;
            if (value && (value < v || v == '')) { // 高密级切换低密级，需清除数据
                var mythis_1 = _this;
                var randomkey_1 = row.key ? row.key.toString().split("_")[0] : "";
                var _modesecrettime_1 = row.$('modesecrettime').value;
                __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm({
                    title: getLabel('131329', '信息确认'),
                    content: getLabel('530633', '变更密级，高于当前卡片密级的关联资源会被清除，附件密级将自动调整为修改的密级，确定要调整吗？'),
                    onOk: function () {
                        /* 降低密级，清空数据 */
                        row.clearRowFields();
                        tableStore.oldDataRecord = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(tableStore.oldDataRecord, function (item) { return item.randomFieldId != randomkey_1; });
                        mythis_1.changeSeclevelValue(v);
                    },
                    onCancel: function () {
                        mythis_1.changeSeclevelValue(value, _modesecrettime_1);
                    }
                });
            }
            _this.changeSeclevelValue(v);
        };
        _this.changeSeclevelValue = function (key, _modesecrettime) {
            var _a = _this.props, column = _a.column, row = _a.row, onChange = _a.onChange, secretTimeDefValue = _a.secretTimeDefValue;
            onChange && onChange(key);
            column.onChange && column.onChange(key, row);
            var modeSecretTimeField = row.$('modesecrettime');
            if (_modesecrettime) {
                modeSecretTimeField.onChange(_modesecrettime);
            }
            else {
                switch (key) {
                    case '1':
                        modeSecretTimeField.onChange(secretTimeDefValue[key]);
                        break;
                    case '2':
                        modeSecretTimeField.onChange(secretTimeDefValue[key]);
                        break;
                    default:
                        modeSecretTimeField.onChange('');
                        break;
                }
            }
        };
        _this.handleChangeSecretTime = function (value) {
            var row = _this.props.row;
            var modeSecretTimeField = row.$('modesecrettime');
            modeSecretTimeField.onChange && modeSecretTimeField.onChange(value);
        };
        _this.handleInputBlur = function (v) {
            var row = _this.props.row;
            var modeSecretTimeField = row.$('modesecrettime');
            if (/^\d+$/.test(v)) {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(getLabel('530634', '保密期限不能是纯数字'));
                modeSecretTimeField.onChange && modeSecretTimeField.onChange('');
            }
            if (!v) {
                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(getLabel('530064', '请填写保密期限'));
            }
        };
        return _this;
    }
    Main.prototype.render = function () {
        var props = this.props;
        var filered = props.options && props.options.filter(function (d) { return props.value ? d.key == props.value : d.selected; });
        var value = props.value;
        var showname = '';
        var column = props.column, row = props.row;
        if (column.detailtype != 2) {
            if (filered && filered.length > 0) {
                value = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(filered, '[0].key');
                showname = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(filered, '[0].showname');
            }
            else {
                value = '';
            }
        }
        var hide = column && column.isHide && column.isHide(row);
        var valueSpan = row.value[column.key + 'span'] && row.$(column.key + 'span').value;
        var valueDesc = column.valueDesc && column.valueDesc(value, row);
        var isHighSecLevel = value && ['1', '2'].indexOf(value) > -1; // 是否显示保密期限字段
        var modeSecritTimeValue = row.has('modesecrettime') ? row.$('modesecrettime').value : '';
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: "none" } : { display: "block" } }, props.editable ?
            (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (this && this.props && this.props.ecId || '') + "_Fragment@gqodqd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaSelect"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@5r51zo" }, props, { detailtype: column.detailtype, options: this.getOptions(), value: value, viewAttr: 3, onChange: this.handleChange, style: column.width ? { maxWidth: column.width, width: isHighSecLevel ? 70 : "100%" } : { width: isHighSecLevel ? 70 : "100%" }, supportCancel: true })),
                isHighSecLevel && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaInput"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@7aljcm", helpfulTip: getLabel('528340', '保密期限填写格式：3个月、10年、20年、长期…不能是纯数字'), 
                    // helpfulTipProps={{style:{position: "absolute", right: -20, top: 4}}}
                    value: modeSecritTimeValue, style: { paddingLeft: 3, width: 70 }, viewAttr: 3, onChange: this.handleChangeSecretTime, onBlur: this.handleInputBlur })))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, valueDesc || valueSpan || showname)));
    };
    Main = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Main);
    return Main;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Main);


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_view_input__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var Option = __WEBPACK_IMPORTED_MODULE_3_antd__["SelectNew"].Option;
var InputPopover = /** @class */ (function (_super) {
    __extends(InputPopover, _super);
    function InputPopover(props) {
        var _this = _super.call(this, props) || this;
        _this.getTopWidth = function () {
            if (_this.refs._container) {
                var closesttd = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.refs._container).closest('td');
                var offset = closesttd.offset();
                var offset1 = closesttd.closest('table').offset();
                var width = Math.max(document.documentElement.clientWidth - offset.left - 20, 200);
                return {
                    top: offset.top - offset1.top + 8,
                    left: offset.left - offset1.left + 8,
                    width: width
                };
            }
        };
        var column = props.column, row = props.row;
        _this.state = { hide: column && column.isHide && column.isHide(row) };
        return _this;
    }
    InputPopover.prototype.render = function () {
        var _this = this;
        var _a = this.props, row = _a.row, addonBefore = _a.addonBefore, field = _a.field;
        var selectBefore = null;
        if (addonBefore) {
            var _b = addonBefore.options, options_1 = _b === void 0 ? [] : _b, width = addonBefore.width, key = addonBefore.key;
            var bind_1 = row.$(key).bind();
            selectBefore = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["SelectNew"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_SelectNew@iz5c3t", style: { width: width } }, bind_1, { onChange: function (v) {
                    bind_1.onChange(v);
                    setTimeout(function () {
                        var filered = options_1.filter(function (d) { return d.key == v; });
                        if (filered && filered.length > 0) {
                            if ('defaultValue' in filered[0]) {
                                _this.props.onChange(filered[0].defaultValue);
                            }
                            if ('inputDisable' in filered[0]) {
                                field.set('disabled', !!filered[0].inputDisable);
                            }
                            else {
                                field.set('disabled', false);
                            }
                        }
                        else {
                            field.set('disabled', false);
                        }
                    }, 10);
                } }), options_1.map(function (opt, i) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Option@m8y4cv@" + i, value: opt.key }, opt.showname)); })));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: this.state.hide ? { display: "none" } : { display: "block" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { ref: "_container" }, this.props.editable && !this.props.disabled ?
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__view_view_input__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Input@2lrxhd", value: this.props.value, disabled: this.props.disabled, autoFocus: !selectBefore, addonBefore: selectBefore, onChange: function (e) { _this.props.onChange(e.target.value); }, style: __assign({ position: 'absolute', top: 8, zIndex: 1000 }, this.getTopWidth()) })
                : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__view_view_input__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_Input@afd2u1", wrapperClassName: "no-border", disabled: this.props.disabled, addonBefore: selectBefore, value: this.props.value }))));
    };
    InputPopover = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], InputPopover);
    return InputPopover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (InputPopover);


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Group__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Search__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextArea__ = __webpack_require__(395);
/* unused harmony reexport InputProps */
/* unused harmony reexport GroupProps */
/* unused harmony reexport SearchProps */
/* unused harmony reexport TextAreaProps */








__WEBPACK_IMPORTED_MODULE_0__Input__["a" /* default */].Group = __WEBPACK_IMPORTED_MODULE_1__Group__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Input__["a" /* default */].Search = __WEBPACK_IMPORTED_MODULE_2__Search__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Input__["a" /* default */].TextArea = __WEBPACK_IMPORTED_MODULE_3__TextArea__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Input__["a" /* default */]);


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_group__ = __webpack_require__(394);
/* unused harmony reexport ButtonProps */
/* unused harmony reexport ButtonShape */
/* unused harmony reexport ButtonSize */
/* unused harmony reexport ButtonType */
/* unused harmony reexport ButtonGroupProps */




__WEBPACK_IMPORTED_MODULE_0__button__["a" /* default */].Group = __WEBPACK_IMPORTED_MODULE_1__button_group__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__button__["a" /* default */]);


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateNodeHeight;
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node, useCache) {
    if (useCache === void 0) { useCache = false; }
    var nodeRef = (node.getAttribute('id') ||
        node.getAttribute('data-reactid') ||
        node.getAttribute('name'));
    if (useCache && computedStyleCache[nodeRef]) {
        return computedStyleCache[nodeRef];
    }
    var style = window.getComputedStyle(node);
    var boxSizing = (style.getPropertyValue('box-sizing') ||
        style.getPropertyValue('-moz-box-sizing') ||
        style.getPropertyValue('-webkit-box-sizing'));
    var paddingSize = (parseFloat(style.getPropertyValue('padding-bottom')) +
        parseFloat(style.getPropertyValue('padding-top')));
    var borderSize = (parseFloat(style.getPropertyValue('border-bottom-width')) +
        parseFloat(style.getPropertyValue('border-top-width')));
    var sizingStyle = SIZING_STYLE
        .map(function (name) { return name + ":" + style.getPropertyValue(name); })
        .join(';');
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing,
    };
    if (useCache && nodeRef) {
        computedStyleCache[nodeRef] = nodeInfo;
    }
    return nodeInfo;
}
function calculateNodeHeight(uiTextNode, useCache, minRows, maxRows) {
    if (useCache === void 0) { useCache = false; }
    if (minRows === void 0) { minRows = null; }
    if (maxRows === void 0) { maxRows = null; }
    if (!hiddenTextarea) {
        hiddenTextarea = document.createElement('textarea');
        document.body.appendChild(hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) {
        hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    }
    else {
        hiddenTextarea.removeAttribute('wrap');
    }
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _a = calculateNodeStyling(uiTextNode, useCache), paddingSize = _a.paddingSize, borderSize = _a.borderSize, boxSizing = _a.boxSizing, sizingStyle = _a.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    hiddenTextarea.setAttribute('style', sizingStyle + ";" + HIDDEN_TEXTAREA_STYLE);
    hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var minHeight = Number.MIN_SAFE_INTEGER;
    var maxHeight = Number.MAX_SAFE_INTEGER;
    var height = hiddenTextarea.scrollHeight;
    var overflowY;
    if (boxSizing === 'border-box') {
        // border-box: add border, since height = content + padding + border
        height = height + borderSize;
    }
    else if (boxSizing === 'content-box') {
        // remove padding, since height = content
        height = height - paddingSize;
    }
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        hiddenTextarea.value = ' ';
        var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') {
                minHeight = minHeight + paddingSize + borderSize;
            }
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') {
                maxHeight = maxHeight + paddingSize + borderSize;
            }
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    // Remove scroll bar flash when autosize without maxRows
    if (!maxRows) {
        overflowY = 'hidden';
    }
    return { height: height, minHeight: minHeight, maxHeight: maxHeight, overflowY: overflowY };
}


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var CheckboxCom = /** @class */ (function (_super) {
    __extends(CheckboxCom, _super);
    function CheckboxCom(props) {
        var _this = _super.call(this, props) || this;
        _this.checkChange = function (e) {
            // const {column,row}= this.props;
            _this.props.onChange(e.target.checked ? '1' : '0');
            // if(column.onChange&&!column.onChange(e.target.checked ? '1' : '0',row)){
            //     //return;
            // }
            setTimeout(function () {
                var _a = _this.props, row = _a.row, _b = _a.linkedFields, linkedFields = _b === void 0 ? [] : _b;
                linkedFields.map(function (f) {
                    row.has(f) && row.$(f).set('disabled', !e.target.checked);
                });
            }, 10);
        };
        var column = props.column, row = props.row;
        _this.state = { hide: column && column.isHide && column.isHide(row) };
        return _this;
    }
    CheckboxCom.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, row = _a.row, _b = _a.linkedFields, linkedFields = _b === void 0 ? [] : _b;
        linkedFields.map(function (f) {
            row.has(f) && row.$(f).set('disabled', !_this.props.value || _this.props.value != '1');
        });
    };
    CheckboxCom.prototype.render = function () {
        var value = this.props.value;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: this.state.hide ? { display: "none" } : { display: "block" } }, this.props.editable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Checkbox"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Checkbox@sbcedd" }, this.props, { checked: this.props.value == '1', disabled: this.props.renderDisabled && this.props.renderDisabled(), onChange: this.checkChange }))
            : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, value)));
    };
    CheckboxCom = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], CheckboxCom);
    return CheckboxCom;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CheckboxCom);


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_view_input_Search__ = __webpack_require__(229);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _this = this;



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var column = props.column, row = props.row, value = props.value;
    var hide = column && column.isHide && column.isHide(row);
    var valueSpan = row.value[column.key + 'Span'] && row.$(column.key + 'Span').value;
    var valueDesc = column.valueDesc && column.valueDesc(value, row);
    var otherProps = {};
    if (column.key == 'showmethod') {
        otherProps['value'] = '';
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: "none" } : { display: "block" } }, props.editable ?
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__view_view_input_Search__["a" /* default */], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_Search@qtqsi2", enterButton: true }, props, { onChange: function (e) { props.onChange(e.target.value); }, onSearch: props.showDialog }, otherProps)) :
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, valueDesc || valueSpan || value)));
}));


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_excel_layout_cell_field_browser_element_Browser__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var Browser = /** @class */ (function (_super) {
    __extends(Browser, _super);
    function Browser(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { replaceDatas: undefined };
        return _this;
    }
    Browser.prototype.render = function () {
        var _this = this;
        var _a = this.props, column = _a.column, row = _a.row, defalutSeclevel = _a.defalutSeclevel;
        var hide = column && column.isHide && column.isHide(row);
        var replaceDatas = Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(column.browserConditionParam.replaceDatas);
        var replaceDatas1 = [];
        var names;
        var browserProps = column.browserConditionParam || {};
        var tempBrowserProps = {
            dataParams: browserProps.dataParams,
            conditionDataParams: browserProps.conditionDataParams,
            completeParams: browserProps.completeParams,
        };
        if (this.props.editable) {
            var ids = row.$(column.key).values().split(',');
            var names_1 = row.$(column.key + 'span').values() ? JSON.parse(row.$(column.key + 'span').values()) : '';
            ids.forEach(function (element, index) {
                if (element != '')
                    replaceDatas.push({ id: element, name: names_1[index] });
            });
            if (column.fieldtype == '141') {
                if (row.$(column.key + 'span').values()) {
                    var spanvalue = JSON.parse(row.$(column.key + 'span').values());
                    spanvalue.forEach(function (element) {
                        if (element != null && element.prop) {
                            replaceDatas1 = replaceDatas1.concat(element.prop);
                        }
                    });
                }
            }
            var bind = Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(row.$(column.key).bind()) || {};
            var bindBrowsers = bind.browserProps;
            var secretLevel = defalutSeclevel || 4;
            if (row.has("seclevel")) {
                secretLevel = row.$('seclevel').values();
            }
            tempBrowserProps = {
                dataParams: __assign({}, tempBrowserProps.dataParams, bindBrowsers.dataParams, { "secretLevel": secretLevel }),
                conditionDataParams: __assign({}, tempBrowserProps.conditionDataParams, bindBrowsers.conditionDataParams),
                completeParams: __assign({}, tempBrowserProps.completeParams, bindBrowsers.completeParams, { "secretLevel": secretLevel }),
            };
            // dataParams = { ...dataParams, ...bind.dataParams };
            // conditionDataParams = { ...conditionDataParams, ...bind.conditionDataParams };
            // completeParams = { ...completeParams, ...bind.completeParams };
        }
        else {
            names = row.$(column.key + 'span').values();
        }
        if (column.fieldtype == '34') { //请假类型浏览框单独处理，设置value
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: 'none' } : { display: 'block' } }, this.props.editable ?
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaBrowser"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@q06omy" }, browserProps, tempBrowserProps, { 
                    //replaceDatas={this.state.replaceDatas || replaceDatas}
                    value: replaceDatas[0] && replaceDatas[0].id, onChange: function (ids, names, datas) {
                        //this.setState({replaceDatas: datas});
                        _this.props.onChange(ids, names, datas);
                        if (column && column.onChange) {
                            column.onChange(ids, row, names, datas);
                        }
                    } })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: names } })));
        }
        else if (column.fieldtype == '141') {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: 'none' } : { display: 'block' } }, this.props.editable ?
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaBrowser"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@0lbme4" }, browserProps, tempBrowserProps, { replaceDatas: this.state.replaceDatas || replaceDatas1, onChange: function (ids, names, datas) {
                        _this.setState({ replaceDatas: datas });
                        var id = Object(__WEBPACK_IMPORTED_MODULE_4__components_excel_layout_cell_field_browser_element_Browser__["b" /* spellResourceCondition */])(datas);
                        _this.props.onChange(id, names, datas);
                        if (column && column.onChange) {
                            column.onChange(id, row, names, datas);
                        }
                    } })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: names } })));
        }
        else {
            var desensitization = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].EncryBase.desensitization;
            var dataalign = column.dataalign == undefined ? "" : column.dataalign;
            var bindObj = row.$(column.key).bind();
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: 'none' } : { display: 'block' } }, this.props.editable ?
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaBrowser"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@ijkhnj" }, browserProps, tempBrowserProps, { replaceDatas: bindObj.value && this.state.replaceDatas || replaceDatas, onChange: function (ids, names, datas) {
                        _this.setState({ replaceDatas: datas });
                        _this.props.onChange(ids, names, datas);
                        if (column && column.onChange) {
                            column.onChange(ids, row, names, datas);
                        }
                    }, onBeforeFocusCheck: function (success) {
                        if (row.value.hasOwnProperty('seclevel')) { // 存在密级字段才进行必填提醒
                            var value = row.$('seclevel').bind().value;
                            if (value) {
                                success();
                            }
                            else {
                                __WEBPACK_IMPORTED_MODULE_2_antd__["message"].error(getLabel('530630', '请先填写卡片密级！'));
                            }
                        }
                        else {
                            success();
                        }
                    } })) : desensitization(names) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInputEncrypt"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputEncrypt@9cliz8", type: "TEXTAREA", className: "wea-url", style: { textAlign: dataalign }, value: names }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: names } })));
        }
    };
    Browser = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Browser);
    return Browser;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Browser);


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var _this = this;



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var column = props.column, row = props.row, value = props.value, format = props.format;
    var hide = column && column.isHide && column.isHide(row);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: "none" } : { display: "block" } }, props.editable ?
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDatePicker"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDatePicker@msa1f9", noInput: true, value: value, format: format, onChange: function (v) { props.onChange && props.onChange(v); column.onChange && column.onChange(v, row); } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, value)));
}));


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var _this = this;



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var column = props.column, row = props.row, value = props.value;
    var hide = column && column.isHide && column.isHide(row);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: "none" } : { display: "block" } }, props.editable ?
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTimePicker"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTimePicker@byheg4", noInput: true, value: value, onChange: function (v) { props.onChange && props.onChange(v); column.onChange && column.onChange(v, row); } })
        : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, value)));
}));


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var _this = this;



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var column = props.column, row = props.row, value = props.value;
    var hide = column && column.isHide && column.isHide(row);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: "none" } : { display: "block" } }, props.editable ?
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTextarea"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTextarea@gsmsr1", value: value, minRows: column.textheight ? column.textheight : 2, maxRows: 10, onChange: function (v) { props.onChange && props.onChange(v); column.onChange && column.onChange(v, row); } })
        : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, value)));
}));


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var Upload = /** @class */ (function (_super) {
    __extends(Upload, _super);
    function Upload(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { replaceDatas: undefined };
        return _this;
    }
    Upload.prototype.render = function () {
        var _this = this;
        var _a = this.props, column = _a.column, row = _a.row, _b = _a.isOpenClassprotect, isOpenClassprotect = _b === void 0 ? false : _b, defalutSeclevel = _a.defalutSeclevel;
        var hide = column && column.isHide && column.isHide(row);
        var names;
        var value = row.$(column.key).bind().value;
        if (!this.props.editable) { //没有勾选批量修改，显示其文件名称
            names = row.$(column.key + 'span').values();
        }
        var secretLevel = defalutSeclevel;
        if (row.has("seclevel")) {
            secretLevel = row.$('seclevel').values();
        }
        var casProtect = isOpenClassprotect; // 是否开启分级保护
        var main;
        var sub;
        var sec;
        var categoryStr;
        var uploadUrl;
        var maxUploadSize;
        var mes;
        var baseProps = {};
        /**
          categoryType  0:固定目录   1：选择目录    9：默认设置
          fileFormat   文档限制格式
        */
        if (!column.uploadConditionParam.categoryType || column.uploadConditionParam.categoryType == "") {
            mes = getLabel(388817, "附件上传目录未设置!");
        }
        else if (column.uploadConditionParam.categoryType == '1') { //选择目录
            mes = getLabel(500335, "附件上传目录为选择目录，不支持批量操作") + "!";
        }
        else {
            main = column.uploadConditionParam.mainCategory;
            sub = column.uploadConditionParam.subCategory;
            sec = column.uploadConditionParam.secCategory;
            if ((column.uploadConditionParam.categoryType == '9' && main <= 0 && sub <= 0 && sec <= 0) || (column.uploadConditionParam.categoryType == '0' && main <= 0 && sub <= 0 && sec <= 0)) { //没有设置目录
                mes = getLabel(388817, "附件上传目录未设置!");
            }
            else {
                categoryStr = main + "," + sub + "," + sec;
                uploadUrl = "/api/formmode/card/docUpload?detailtype=" + column.fieldtype + "&category=" + categoryStr + "&mainId=" + main + "&subId=" + sub + "&secId=" + sec;
                maxUploadSize = column.uploadConditionParam.maxUploadSize;
                var filedatas = [];
                if (this.props.editable) {
                    filedatas = row.$(column.key + 'span').values() ? JSON.parse(row.$(column.key + 'span').values()) : [];
                }
                baseProps.showBatchLoad = false;
                baseProps.showClearAll = false;
                baseProps.uploadUrl = uploadUrl;
                baseProps.maxUploadSize = maxUploadSize;
                baseProps.category = { categoryType: column.uploadConditionParam.categoryType, mainCategory: main, maxUploadSize: maxUploadSize, secCategory: sec, subCategory: sub };
                baseProps.datas = filedatas;
                baseProps.btnSize = "small";
                baseProps.autoUpload = "true";
                baseProps.listType = column.fieldtype == '2' ? "img" : "list";
                baseProps.limitType = column.fieldtype == "2" ? "jpg,jpeg,png,gif,bmp" : column.uploadConditionParam.fileFormat === "0" ? "" : column.uploadConditionParam.fileFormat;
                baseProps.uploadId = column.key;
                baseProps.display = true;
            }
        }
        baseProps.errorMsg = mes;
        if (!value) {
            baseProps.datas = []; //清空value，也需将datas置空
        }
        var secParams = {}; // 分级保护相关参数，仅对附件上传生效
        if (column.fieldtype === '1') {
            secParams = {
                secLevel: secretLevel,
                secLevelInfo: getLabel('530630', '请先填写卡片密级！'),
                showSecLevel: casProtect,
                casProtect: casProtect,
                allowEditSec: false,
            };
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: 'none' } : { display: 'block' } }, this.props.editable ?
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaUpload"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaUpload@e8x2eo" }, baseProps, secParams, { onChange: function (idsT, names, datas) { _this.props.onChange(idsT.join(','), names, datas); column.onChange && column.onChange(idsT.join(','), row, names, datas); } })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: names } })));
    };
    Upload = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Upload);
    return Upload;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Upload);


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var _this = this;



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"])(function (props) {
    var column = props.column, row = props.row, value = props.value;
    var hide = column && column.isHide && column.isHide(row);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: hide ? { display: "none" } : { display: "block" } }, props.editable ?
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDatePicker"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDatePicker@syo2pm", noInput: true, showTime: true, format: "yyyy-MM-dd HH:mm", value: value, onChange: function (v) { props.onChange && props.onChange(v); column.onChange && column.onChange(v, row); } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, value)));
}));


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BatchmodifyfeildDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var Batchmodifyfeild = /** @class */ (function (_super) {
    __extends(Batchmodifyfeild, _super);
    function Batchmodifyfeild() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                title: getLabel(685, '字段名称', 'label'),
                dataIndex: 'fieldlabel',
                width: '40%',
                com: [
                    { type: 'INPUT', key: 'fieldlabel', viewAttr: '1' }
                ],
            },
            {
                title: getLabel(125391, '字段对应值', 'label'),
                dataIndex: 'fieldvalue',
                width: '60%',
                com: [
                    { type: 'input', key: 'fieldvalue', viewAttr: '1' }
                ],
            }
        ];
        _this.getCells = function (cells) {
            var batchEditStore = _this.props.batchEditStore;
            //cells = toJS(cells);
            cells.map(function (cell) {
                if (cell.fieldvalue.com) {
                    var com_1 = cell.fieldvalue.com[0];
                    if (com_1.type == 'BROWSER' && com_1.browserConditionParam.type == '141') {
                        // 浏览框人力资源条件信息缺失,单独渲染
                        com_1.type = 'CUSTOM';
                        com_1.render = function () {
                            var changeRl = batchEditStore.changeRl;
                            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], __assign({ ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaBrowser@xyf93x" }, com_1.browserConditionParam, { replaceDatas: [], onChange: function (ids, names, datas) { changeRl(datas, cell.fieldid); } })));
                        };
                    }
                }
            });
            return cells;
        };
        _this.getRowSelection = function () { return null; };
        _this.tableChange = function (datas, other) {
            var batchEditStore = _this.props.batchEditStore;
            batchEditStore.datas = datas;
        };
        return _this;
    }
    Batchmodifyfeild.prototype.render = function () {
        var batchEditStore = this.props.batchEditStore;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: 'red' } }, getLabel(125493, '已经勾选{0}条数据进行修改', 'label').replace('{0}', batchEditStore.selectedRowKeys.length)),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTableEditable"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTableEditable@95sy09", rowKey: "fieldid", columns: this.columns, initialDatas: Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(batchEditStore.datas), datas: Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(batchEditStore.datas), 
                // cells={toJS(batchEditStore.cells)}
                cells: this.getCells(Object(__WEBPACK_IMPORTED_MODULE_4_mobx__["toJS"])(batchEditStore.cells)), getRowSelection: this.getRowSelection, showAdd: false, showDelete: false, showCopy: false, onChange: this.tableChange })));
    };
    Batchmodifyfeild = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Batchmodifyfeild);
    return Batchmodifyfeild;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (Batchmodifyfeild);
var BatchmodifyfeildDialog = /** @class */ (function (_super) {
    __extends(BatchmodifyfeildDialog, _super);
    function BatchmodifyfeildDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            var batchEditStore = _this.props.batchEditStore;
            batchEditStore.visible = false;
        };
        return _this;
    }
    BatchmodifyfeildDialog.prototype.render = function () {
        var _a = this.props, batchEditStore = _a.batchEditStore, iconInfo = _a.iconInfo;
        var buttons = [
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@eo383b@onClose", onClick: this.onClose }, getLabel(309, "关闭")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@kxksvh@saveBatctEdit", type: "primary", loading: batchEditStore.loading, onClick: batchEditStore.saveBatctEdit }, getLabel(86, '保存'))
        ];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@wlvl40", className: 'wea-auth-modal cube-dialog', buttons: buttons, title: getLabel(25465, '批量修改', 'label') + getLabel(563, '数据', 'label'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: batchEditStore.visible, style: { width: 800, height: 500 }, hasScroll: true, onCancel: this.onClose },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Batchmodifyfeild, { ecId: (this && this.props && this.props.ecId || '') + "_Batchmodifyfeild@jf5t6f", batchEditStore: batchEditStore })));
    };
    BatchmodifyfeildDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], BatchmodifyfeildDialog);
    return BatchmodifyfeildDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BatchAdd */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BatchAddDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobx_table__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_no_right__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var BatchAdd = /** @class */ (function (_super) {
    __extends(BatchAdd, _super);
    function BatchAdd(props) {
        var _this = _super.call(this, props) || this;
        _this.addScroll = function (datas) {
            if (datas.length < 1) { //若table无数据，将标题栏设为可滚动
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube-list-batchadd .cube-table-wrapper .cube-table .cube-table-header').css('overflow-x', 'auto');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube-list-batchadd .cube-table-wrapper .cube-table .cube-table-body').css('max-height', '0px');
            }
            else {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube-list-batchadd .cube-table-wrapper .cube-table .cube-table-body').css('max-height', '664px');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube-list-batchadd .cube-table-wrapper .cube-table .cube-table-header').css('overflow-x', 'hidden');
            }
        };
        _this.getScroll = function () {
            var batchAddStore = _this.props.batchAddStore;
            var width = 0;
            var heigh = document.body.offsetHeight - 48 - 42 - 36 - 61 - 100;
            batchAddStore.editTableStore.columns.map(function (column) {
                if (column.width) {
                    if (typeof column.width === 'string') {
                        if (column.width.indexOf('%') > -1) {
                            width += document.documentElement.clientWidth * parseFloat(column.width.replace('%', ''));
                        }
                        else {
                            width += parseFloat(column.width);
                        }
                    }
                    else if (typeof column.width === 'number') {
                        width += column.width;
                    }
                }
                else {
                    width += 100;
                }
            });
            return {
                x: width + 100,
                y: heigh
            };
        };
        _this.rightMenuClick = function (key) {
            var batchAddStore = _this.props.batchAddStore;
            if (key == 'save') {
                batchAddStore.save();
                batchAddStore.isButtonClick = false;
            }
        };
        _this.del = function () {
            var batchAddStore = _this.props.batchAddStore;
            if (batchAddStore.editTableStore.selectedRowKeys.length > 0) {
                batchAddStore.deleteData();
            }
        };
        _this.copy = function () {
            var batchAddStore = _this.props.batchAddStore;
            if (batchAddStore.editTableStore.selectedRowKeys.length > 0) {
                batchAddStore.copyData();
            }
        };
        return _this;
    }
    BatchAdd.prototype.componentDidUpdate = function () {
        var batchAddStore = this.props.batchAddStore;
        var datas = batchAddStore.editTableStore.datas;
        if (datas) {
            this.addScroll(datas.slice());
        }
    };
    BatchAdd.prototype.render = function () {
        var batchAddStore = this.props.batchAddStore;
        var isfrontmultlang = batchAddStore.isfrontmultlang;
        var selectdStyle = { fontSize: '20px', 'color': '#2db7f5', marginRight: '10px', cursor: 'pointer' };
        var selectdStyle1 = { fontSize: '20px', 'color': '#d8d8d8', marginRight: '10px', cursor: 'pointer' };
        if (batchAddStore.editTableStore.selectedRowKeys.length > 0) {
            selectdStyle1 = selectdStyle;
        }
        var datalength = batchAddStore.editTableStore.isInit ? batchAddStore.editTableStore.form.$("tableForm").values().length : 0;
        var MenuDatas = [{
                key: 'save',
                disabled: datalength == 0 || !batchAddStore.isButtonClick,
                icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-Save-as' }),
                //content: getLabel(385215, '批量保存'),
                content: batchAddStore.bathAddExpendname,
            }];
        return batchAddStore.hasRight ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "list-batch-add", style: { height: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@2t5bwj", datas: MenuDatas, onClick: this.rightMenuClick },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: '10px', textAlign: 'right' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel(611, '添加'), onClick: batchAddStore.addNewData, style: selectdStyle, className: "icon-coms-Add-to-hot" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel(91, '删除'), onClick: this.del, style: selectdStyle1, className: "icon-coms-form-delete-hot" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel(77, '复制'), onClick: this.copy, style: selectdStyle1, className: "icon-coms-copy-hot" })),
                batchAddStore.editTableStore.isInit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__mobx_table__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_MobxTable@cikyop", tableStore: batchAddStore.editTableStore, scroll: this.getScroll(), pagination: false, isRowSelection: true, isNoSwitchEditStatus: true, isfrontmultlang: isfrontmultlang }))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pages_no_right__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_NoRightPage@r4i4hn" });
    };
    BatchAdd = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], BatchAdd);
    return BatchAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var BatchAddDialog = /** @class */ (function (_super) {
    __extends(BatchAddDialog, _super);
    function BatchAddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            iconLoading: false,
        };
        _this.enterIconLoading = function () {
            _this.setState({ iconLoading: true });
        };
        _this.bathAddExpendnameClick = function () {
            var batchAddStore = _this.props.batchAddStore;
            if (batchAddStore.isButtonClick == false) {
                return;
            }
            // 校验密级字段是否为空
            if (batchAddStore.doVerifySeclevel()) {
                return;
            }
            _this.enterIconLoading();
            batchAddStore.save(function () {
                setTimeout(function () {
                    _this.setState({ iconLoading: false });
                }, 1000);
            });
        };
        _this.cancel = function () {
            var batchAddStore = _this.props.batchAddStore;
            batchAddStore.update({ visible: false });
        };
        return _this;
    }
    BatchAddDialog.prototype.componentWillMount = function () {
        this.setState({ iconLoading: false });
    };
    BatchAddDialog.prototype.render = function () {
        var batchAddStore = this.props.batchAddStore;
        var datas = batchAddStore.editTableStore.datas;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@1kd8b4", className: "cube-list-batchadd", title: getLabel(500091, '批量新增', 'label'), iconBgcolor: batchAddStore.iconInfo.iconBg || "#96358a", icon: batchAddStore.iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: batchAddStore.iconInfo.iconColor || "#fff", onCancel: this.cancel, style: { width: document.body.offsetWidth - 300, height: document.body.offsetHeight - 220 }, buttons: [
                (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@dmvwoc@bathAddExpendnameClick", disabled: datas && datas.slice().length < 1 ? true : false, loading: this.state.iconLoading, type: "primary", onClick: this.bathAddExpendnameClick }, batchAddStore.bathAddExpendname)),
                (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@ibj1fn@cancel", type: "ghost", onClick: this.cancel }, getLabel(201, '取消', 'label')))
            ], visible: batchAddStore.visible },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BatchAdd, __assign({ ecId: (this && this.props && this.props.ecId || '') + "_BatchAdd@14pyi8" }, this.props)));
    };
    BatchAddDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], BatchAddDialog);
    return BatchAddDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_loadSpread__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_excelList_less__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_excelList_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_excelList_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/// <reference path="GC.Spread.Sheets.d.ts" />






var Excel = /** @class */ (function (_super) {
    __extends(Excel, _super);
    function Excel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadSparedjs = function () {
            var store = _this.props.store;
            if (store.host && window.GC) {
                store.excelStore.init(new GC.Spread.Sheets.Workbook(store.host, {}));
            }
        };
        return _this;
    }
    Excel.prototype.render = function () {
        var _this = this;
        var store = this.props.store;
        var windowTitle = store.windowTitle;
        if (windowTitle != '') {
            document.title = windowTitle;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cube-excel-list", ref: function (ref) { return _this.excelList = ref; } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaPopoverHrm"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaPopoverHrm@lqxrkj" }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@v4ac7f", spinning: store.excelStore.loading, size: "large" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cube-excel-list-host", ref: function (ref) { return store.host = ref; } }))));
    };
    Excel.prototype.componentDidMount = function () {
        var store = this.props.store;
        this.test = Object(__WEBPACK_IMPORTED_MODULE_4__util_loadSpread__["a" /* loadSpread */])(this.loadSparedjs);
        store.refresh(); // 为解决切换Excel列表时，未正确绘制的问题
    };
    Excel.prototype.componentWillUnmount = function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__util_loadSpread__["b" /* releaseSpread */])(this.test);
    };
    Excel = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], Excel);
    return Excel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Excel);


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadSpread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return releaseSpread; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_loadjs__);

var l = '*.e-cology.com.cn,681836524279821#A0YNdUjNzgTM8YjI0ICZJJCL3V6csFmZ0IiczRmI1pjIs9WQisnOiQkIsISP3EEc5lWaZR5L4Z4UzlHSihVZLJXc0lGcGN4TrNlT4oEdIR4SoVGNxcGOqNFS0JjRIJTU6ljUXNUQvFHOnJlSSdFT4MjVutSN4kGStBTVv24YpdkZyRkZiojITJCL5kTO8cjN4QzN0IicfJye35XX3JyMiZzZiojIDJCLiETMuYHITpEIkFWZyB7UiojIOJyebpjIkJHUiwiI9IDMxcDMggTM7ADOxAjMiojI4J7QiwiIuNmLt36Yuk7Zvx6bj5SZuoiI0IyctRkIsICuPWOrFWOkZmeicaev1SeoCiOgKaekneOn1eek3eur+W+mza+t5aui8SuI0ISYONkIsISMyg4OtI';
var loadSpread = function (callback, license) {
    var t;
    var s;
    if (license === void 0) {
        license = l;
        t = RegExp.prototype.test;
        RegExp.prototype.test = function (a) {
            return this.toString() === (/^[\w\-]+$/i).toString() && a === location.hostname ? !0 : t.call(this, a);
        };
    }
    s = JSON.stringify;
    JSON.stringify = function (value, replacer) {
        try {
            return s(value, replacer);
        }
        catch (e) {
        }
        return "";
    };
    var language = window.e9_locale.userLanguage || 7;
    if (!__WEBPACK_IMPORTED_MODULE_0_loadjs___default.a.isDefined('weaEdcGCSpread')) {
        __WEBPACK_IMPORTED_MODULE_0_loadjs___default()(['/edc/spreadjs/gc.spread.sheets.11.1.0.css',
            '/edc/spreadjs/gc.spread.sheets.excel2013white.11.1.0.css',
            '/edc/spreadjs/gc.spread.sheets.all.11.1.0.min.js'], 'weaEdcGCSpread', {
            success: function () {
                window.GC.Spread.Sheets.LicenseKey = license;
                if (language === 7 || language === 9) {
                    window.GC.Spread.Common.CultureManager.culture("zh-cn");
                }
                __WEBPACK_IMPORTED_MODULE_0_loadjs___default()((language === 7 || language === 9) ?
                    ['/edc/spreadjs/gc.spread.excelio.11.1.0.min.js',
                        '/edc/spreadjs/FileSaver.min.js',
                        '/edc/spreadjs/gc.spread.sheets.print.11.1.0.min.js',
                        '/edc/spreadjs/gc.spread.sheets.resources.zh.11.1.0.min.js'] :
                    ['/edc/spreadjs/gc.spread.excelio.11.1.0.min.js',
                        '/edc/spreadjs/FileSaver.min.js',
                        '/edc/spreadjs/gc.spread.sheets.print.11.1.0.min.js'], 'gcSpreadExcelIo', {
                    success: callback
                });
            }
        });
    }
    else {
        if (callback) {
            callback();
        }
    }
    return { t: t, s: s };
};
var releaseSpread = function (_a) {
    var t = _a.t, s = _a.s;
    if (t) {
        RegExp.prototype.test = t;
    }
    if (s) {
        JSON.stringify = s;
    }
};


/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var MenuItem = __WEBPACK_IMPORTED_MODULE_6_antd__["Menu"].Item;
var ButtonGroup = __WEBPACK_IMPORTED_MODULE_6_antd__["Button"].Group;
var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.height = 0;
        _this.onShowSizeChange = function (current, pageSize) {
            var store = _this.props.store;
            store.changeDetailPageSize(current, pageSize);
        };
        _this.showTotal = function (total) {
            return " " + (getLabel(18609, "共") + total + ' ' + getLabel(18256, "条")) + " ";
        };
        _this.tableWidth = function (_) {
            var store = _this.props.store;
            return store.originalTableWidth;
        };
        _this.resetTableStyle = function () {
            var _a = _this.props.store, tableData = _a.tableData, addScrollForTree = _a.addScrollForTree;
            addScrollForTree(tableData.Data);
        };
        _this.parseTreeIndent = function () {
            /**展示树形数据时，每层缩进后 内容左对齐“展开符号” */
            setTimeout(function () {
                var disquerycheck = _this.props.store.disquerycheck;
                var domArray = __WEBPACK_IMPORTED_MODULE_5_jquery___default()("span[class*='ant-table-row-indent indent-level-']");
                __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.forEach(domArray, function (item, index) {
                    var paddingLeft = item.className.split('indent-level-')[1] * 20;
                    if (paddingLeft > 0) {
                        if (disquerycheck === '1') { // 当隐藏check框时，需增大padding-left
                            paddingLeft += 28;
                        }
                        __WEBPACK_IMPORTED_MODULE_5_jquery___default()(item).parent().css('padding-left', paddingLeft);
                    }
                });
            }, 1000);
        };
        _this.parserColumnsForShowList = function (record, num, cb, index) {
            var isShowIcon = _this.props.store.isShowIcon;
            var otherparas = cb.otherpara.split("+");
            var index1 = 0;
            for (index1; index1 < otherparas.length; index1++) {
                var islikebutton = otherparas[index1].replace("#islikebutton:", "");
                if (islikebutton && islikebutton == '1') {
                    var likeinfo = otherparas[index1 + 1].replace("#likeinfo:", "");
                    var type = likeinfo.split(",")[0];
                    var status = likeinfo.split(",")[3];
                    var likecount = likeinfo.split(",")[1];
                    var dislikecount = likeinfo.split(",")[2];
                    if (type == '5') {
                        if (status == '1') {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@ngo514", type: "ghost", onClick: function () { _this.props.store.likeOrDislike(record, "0", index, '2'); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-like" }),
                                    isShowIcon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { title: cb.text || '' }, '(' + likecount + ')') : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, ' ' + cb.text + '(' + likecount + ')')));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@fno19z", type: "ghost", onClick: function () { _this.props.store.likeOrDislike(record, "1", index, '2'); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: cb.text, className: "icon-coms02-like-o" }),
                                    isShowIcon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { title: cb.text || '' }, '(' + likecount + ')') : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, ' ' + cb.text + '(' + likecount + ')')));
                        }
                    }
                    else if (type == '6') {
                        if (status == '2') {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@dubxyk", type: "ghost", onClick: function () { _this.props.store.likeOrDislike(record, "0", index, '2'); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-Negative-comment" }),
                                    isShowIcon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { title: cb.text || '' }, '(' + dislikecount + ')') : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, ' ' + cb.text + ' (' + dislikecount + ')')));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@fa182r", type: "ghost", onClick: function () { _this.props.store.likeOrDislike(record, "2", index, '2'); } },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: cb.text, className: "icon-coms02-Negative-comment-o" }),
                                    isShowIcon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { title: cb.text || '' }, '(' + dislikecount + ')') : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, ' ' + cb.text + ' (' + dislikecount + ')')));
                        }
                    }
                }
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@lsjkwm", title: cb.text || '', type: "ghost", onClick: function () {
                    _this.props.store.doCustomButton(record, '', cb, '');
                } },
                cb.icon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { title: cb.text || '', className: 'cube-list-icon-box' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: cb.icon })) : (!isShowIcon ? '' : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'cube-list-icon-box' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: Object(__WEBPACK_IMPORTED_MODULE_7__util_contentPath__["a" /* getContentPath */])('/mobilemode/piclibrary/01-E9_default/setup.png') }))),
                !isShowIcon ? cb.text : '');
        };
        _this.parserColumnsForFunc = function (record, num, cb, index, isExitIcon) {
            var otherparas = cb.otherpara.split("+");
            var index1 = 0;
            for (index1; index1 < otherparas.length; index1++) {
                var islikebutton = otherparas[index1].replace("#islikebutton:", "");
                if (islikebutton && islikebutton == '1') {
                    var likeinfo = otherparas[index1 + 1].replace("#likeinfo:", "");
                    var likecount = likeinfo.split(",")[1];
                    var dislikecount = likeinfo.split(",")[2];
                    var type = likeinfo.split(",")[0];
                    var status = likeinfo.split(",")[3];
                    if (type == '5') {
                        if (status == '1') {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@toitx3" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () {
                                        _this.props.store.likeOrDislike(record, "0", index, '2');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-like" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: '#000' } }, ' ' + cb.text + '(' + likecount + ')'))));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@wpwgp5" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () {
                                        _this.props.store.likeOrDislike(record, "1", index, '2');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: cb.text, className: "icon-coms02-like-o" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + likecount + ')'))));
                        }
                    }
                    else if (type == '6') {
                        if (status == '2') {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@pbcyo8" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () {
                                        _this.props.store.likeOrDislike(record, "0", index, '2');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: getLabel('31129', '取消') + cb.text, className: "icon-coms02-Negative-comment" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + dislikecount + ')'))));
                        }
                        else {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@bkw9su" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () {
                                        _this.props.store.likeOrDislike(record, "2", index, '2');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: cb.text, className: "icon-coms02-Negative-comment-o" }),
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: '#000' } }, ' ' + cb.text + ' (' + dislikecount + ')'))));
                        }
                    }
                }
            }
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_MenuItem@cj1xgt" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function () {
                        _this.props.store.doCustomButton(record, '', cb, '');
                    } },
                    isExitIcon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'cube-list-icon-box' }, cb.icon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: cb.icon }) : '') : '',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: '#000' } }, cb.text)));
        };
        _this.parseColumns = function (columns) {
            var store = _this.props.store;
            var treePercent = store.treePercent, isSuspend = store.isSuspend, isShowIcon = store.isShowIcon, showButtomNum = store.showButtomNum;
            var cols = columns.map(function (col, index) { return ({
                title: col.title,
                className: col.className,
                isHtml: false,
                key: col.key,
                dataIndex: col.dataIndex,
                width: ((parseFloat(col.width.replace('%', '')) / treePercent) * 100).toFixed(2) + '%',
                render: function (text, record, index) {
                    if (col.dataIndex == 'cube_expandmap') {
                        var valueSpan = record[col.dataIndex + "span"] !== undefined ? record[col.dataIndex + "span"] : record[col.dataIndex];
                        var num_1 = -1;
                        var classname = col.className == 'column-text-right' ? 'right' : col.className == 'column-text-center' ? 'center' : 'left';
                        if (record.randomfieldid && record.randomfieldid != '') {
                            record['randomFieldId'] = record.randomfieldid;
                        }
                        var count = valueSpan && JSON.parse(valueSpan).length;
                        var custombutton = void 0;
                        var custombuttonArray_1;
                        if (count > showButtomNum && !isShowIcon) {
                            if (showButtomNum > 0) {
                                var valueSpanarrry = JSON.parse(valueSpan).slice(0, showButtomNum);
                                var valueSpanTemp = JSON.parse(valueSpan).slice(showButtomNum - 1);
                                var isExitIcon_1 = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* isExitIconHandle */])('opt', valueSpanTemp);
                                custombuttonArray_1 = valueSpanTemp && valueSpanTemp.map(function (cb) {
                                    return _this.parserColumnsForFunc(record, num_1, cb, index, isExitIcon_1);
                                });
                                custombutton = valueSpanarrry && valueSpanarrry.map(function (cb) {
                                    num_1++;
                                    if (num_1 < showButtomNum - 1) {
                                        return _this.parserColumnsForShowList(record, num_1, cb, index);
                                    }
                                    else if (num_1 == showButtomNum - 1) {
                                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDropdown@7y0vj2@" + num_1, className: 'wea-table-page-more-drop-down', getPopupContainer: function () { return document.getElementById("buttonGroupbtn" + index + record['randomFieldId']); }, overlay: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@ivzsci" }, custombuttonArray_1) }, getLabel(17499, "更多")));
                                    }
                                });
                            }
                            else {
                                var valueSpanTemp = JSON.parse(valueSpan).slice(0);
                                var isExitIcon_2 = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* isExitIconHandle */])('opt', valueSpanTemp);
                                custombuttonArray_1 = valueSpanTemp && valueSpanTemp.map(function (cb) {
                                    return _this.parserColumnsForFunc(record, num_1, cb, index, isExitIcon_2);
                                });
                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "buttonGroupbtn" + index + record['randomFieldId'], className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: classname, whiteSpace: 'normal' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@p6i5h1" },
                                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDropdown@nuqsz2", className: 'wea-table-page-more-drop-down', getPopupContainer: function () { return document.getElementById("buttonGroupbtn" + index + record['randomFieldId']); }, overlay: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@wkxux1" }, custombuttonArray_1) }, getLabel(17499, "更多")))));
                            }
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: "buttonGroupbtn" + index + record['randomFieldId'], className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: classname, whiteSpace: 'normal' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@7oev4u" }, custombutton)));
                        }
                        else {
                            custombutton = valueSpan && JSON.parse(valueSpan).map(function (cb) {
                                num_1++;
                                return _this.parserColumnsForShowList(record, num_1, cb, index);
                            });
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: isShowIcon ? 'cube-list-table-cusoperate-onlyicon' : 'cube-list-table-cusoperate-andicon' },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: classname, whiteSpace: 'normal' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@yyivuq", className: "cube-custom-btn-group" }, custombutton)));
                        }
                    }
                    else {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: { __html: text } });
                    }
                }
            }); });
            return cols;
        };
        _this.renderCell = function (columns) {
            //let biaoqian  = <div className={"e8operate"}  style={{display: 'block'}}>&nbsp;</div>;
            return columns.map(function (col, index) {
                if (col.dataIndex == 'modelableid') { //如果是标签
                    var newColumn_1 = col;
                    var classname_1 = col.className == 'column-text-right' ? 'right' : col.className == 'column-text-center' ? 'center' : 'left';
                    newColumn_1.render = function (text, record, index) {
                        var valueSpan = record[newColumn_1.dataIndex + "span"] !== undefined ? record[newColumn_1.dataIndex + "span"] : record[newColumn_1.dataIndex];
                        var weatag = valueSpan && JSON.parse(valueSpan).map(function (tag) {
                            if (tag.tabname != '') {
                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTag"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTag@v86tgz@" + index, title: tag.tabname, style: { borderRadius: '4px', marginBottom: 2, marginRight: 10, color: tag.color, backgroundColor: tag.bgcolor, borderColor: tag.bdcolor } }, tag.tabname.length > 10 ? tag.tabname.slice(0, 10) + "..." : tag.tabname);
                            }
                            else {
                                return tag + " ";
                            }
                        });
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { textAlign: classname_1, whiteSpace: 'normal' } }, weatag));
                    };
                    return newColumn_1;
                }
                return col;
            });
        };
        _this.onRowClick = function (record, index) {
            var update = _this.props.store.update;
            update({ rowCheckKey: [record.key || record.id] });
        };
        return _this;
    }
    Tree.prototype.render = function () {
        var store = this.props.store;
        var searchTree = store.searchTree, tableData = store.tableData, disquerycheck = store.disquerycheck, defalutPagesize = store.defalutPagesize, rowCheckKey = store.rowCheckKey;
        var rowSelection = disquerycheck == '1' ? undefined : {
            onSelectAll: function (key, value) {
                store.resetTreeValueId();
                var val = "";
                if (key) {
                    store.setSelectedRowKeys(key, value);
                }
                else {
                    store.setSelectedRowKeys(key, []);
                }
                if (store.treeKey.length > 0) {
                    val = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(store.treeKey.map(function (d) { return d.split('_')[0]; })).join(",");
                }
                store.setTreeValueId(val);
            },
            onChange: function (key, value) {
                store.resetTreeValueId();
                store.getSelectedRowKeys();
                store.setSelectedRowKeys(key, []);
                var val = "";
                if (key) {
                    val = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(key.map(function (d) { return d.split('_')[0]; })).join(",");
                }
                store.setTreeValueId(val);
            },
            getCheckboxProps: function (record) { return ({
                disabled: record.randomFieldCk === 'false',
            }); },
            selectedRowKeys: store.selectedRowKeys
        };
        var pageSizeOptions = [10, 20, 30, 40, 50, 100];
        if (defalutPagesize && defalutPagesize > 0 && pageSizeOptions.indexOf(defalutPagesize) == -1) {
            pageSizeOptions.push(defalutPagesize);
            pageSizeOptions = pageSizeOptions.sort(function (a, b) { return a - b; });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTable"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaTable@2sklg4", className: "cube-list-table", columns: Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(this.parseColumns(store.treecolumns)), 
                // getColumns={toJS(this.parseColumns(store.treecolumns))}
                dataSource: Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(tableData.Data), childrenColumnName: "sublist", rowKey: "key", needScroll: true, rowstylefield: "rowstylefield", createOperateDom: "createOperateDom", rowSelection: rowSelection, indentSize: "0px", renderCell: this.renderCell, onOperatesClick: store.doCustomButton, pagination: false, onRowClick: this.onRowClick, needRowClick: true, rowCheckKey: rowCheckKey }, this.getScrollConfig())),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { float: 'right', margin: '7px' } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Pagination"], { ecId: (this && this.props && this.props.ecId || '') + "_Pagination@gv3r8y", current: searchTree.current, pageSize: searchTree.pagesize, pageSizeOptions: pageSizeOptions, total: tableData.total, showSizeChanger: true, showQuickJumper: true, showTotal: this.showTotal, onShowSizeChange: this.onShowSizeChange, onChange: store.nextDetailDatas }))));
    };
    Tree.prototype.getScrollConfig = function () {
        var store = this.props.store;
        var originalTableWidth = store.originalTableWidth;
        // let widthss = jQuery(window).width() - 60;
        // let widths = 0;
        // if(treeDataWidth>100){
        //     treecolumns.map(columns=>{
        //         const{width} = columns;
        //         widths += jQuery(window).width()*0.01*parseFloat(width.replace('%', ''))*0.8;
        //     });
        // }else if(treecolumns.length > 20 && treecolumns.length < 30){
        //     widths = jQuery(window).width()+300;
        // }else if(treecolumns.length > 30&& treecolumns.length < 50){
        //     widths = jQuery(window).width()+600;
        // }
        var widths = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(window).width() * (parseFloat(originalTableWidth.replace('%', '')) / 100);
        var scroll = {};
        var hight = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(window).height();
        scroll.scroll = {};
        scroll.scroll.y = hight - 300;
        scroll.scroll.x = widths - 70;
        return scroll;
    };
    Tree.prototype.componentDidMount = function () {
        this.getScrollConfig();
        this.parseTreeIndent();
        this.resetTableStyle(); // 重置样式
    };
    Tree.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        this.parseTreeIndent();
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx__["observable"]
    ], Tree.prototype, "height", void 0);
    Tree = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Tree);
    return Tree;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Tree);


/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_contentPath__ = __webpack_require__(9);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var viewer = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].viewer;
var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;






var WeaTable = __WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaTableNew"].WeaTable;
var MenuItem = __WEBPACK_IMPORTED_MODULE_6_antd__["Menu"].Item;
var ImgCell = /** @class */ (function (_super) {
    __extends(ImgCell, _super);
    function ImgCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customOperates = function (record, index, operates) {
            var store = _this.props.store;
            var itemsArr = [];
            var operatesshow = record.operatesshowspan;
            var likestatus = record.likesinfospan && record.likesinfospan.split(',')[2] ? record.likesinfospan.split(',')[2] : '';
            var likecount = record.likesinfospan && record.likesinfospan.split(',')[0] ? record.likesinfospan.split(',')[0] : '0';
            var dislikecount = record.likesinfospan && record.likesinfospan.split(',')[1] ? record.likesinfospan.split(',')[1] : '0';
            var isExitIcon = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["h" /* isExitIconHandle */])('customOpt', operates, operatesshow);
            operates.map(function (value, index1, array) {
                if (operatesshow.split('+')[index1] && operatesshow.split('+')[index1] == 'true') {
                    if (array[index1].nodeName && array[index1].nodeName == 'operate') {
                        if (array[index1].href == 'javascript:likes') {
                            var classname = 'icon-coms02-like-o';
                            var titlename = array[index1].text;
                            var key_1 = '1';
                            if (likestatus == '1') {
                                classname = 'icon-coms02-like';
                                titlename = getLabel('31129', '取消') + array[index1].text;
                                key_1 = '0';
                            }
                            itemsArr.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@k3y0co@" + index1 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript:void(0);", onClick: function () {
                                        store.likeOrDislike(record, key_1, index, '0');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: titlename, className: classname }),
                                    ' ' + array[index1].text + ' (' + likecount + ')')));
                        }
                        else if (array[index1].href == 'javascript:dislikes') {
                            var classname = 'icon-coms02-Negative-comment-o';
                            var titlename = array[index1].text;
                            var key_2 = '2';
                            if (likestatus == '2') {
                                classname = 'icon-coms02-Negative-comment';
                                titlename = getLabel('31129', '取消') + array[index1].text;
                                key_2 = '0';
                            }
                            itemsArr.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@y0pgyj@" + index1 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript:void(0);", onClick: function () {
                                        store.likeOrDislike(record, key_2, index, '0');
                                    } },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { title: titlename, className: classname }),
                                    ' ' + array[index1].text + ' (' + dislikecount + ')')));
                        }
                        else {
                            itemsArr.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@24yedk@" + index1 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript:void(0);", onClick: function () {
                                        store.doCustomButton(record, '', array[index1], '');
                                    } },
                                    isExitIcon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'cube-list-icon-box' }, array[index1].icon ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: array[index1].icon }) : '') : '',
                                    array[index1].text)));
                        }
                    }
                }
            });
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@zpflr9" }, itemsArr));
        };
        _this.addSpan = function (htmlVal, classNameVal, title) {
            var desensitization = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].EncryBase.desensitization;
            var isNeedSpan = htmlVal.indexOf('cube-list-progress') < 0;
            var domParams = {
                className: classNameVal,
                title: title
            };
            if (htmlVal.indexOf("</a>") > -1) {
                htmlVal = htmlVal.replace(/<br\s*>|<br\s*\/>/g, '');
            }
            return desensitization(htmlVal) ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { display: "flex" } },
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@nbrkm2", value: htmlVal })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({}, domParams),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "td-otherCol-content-" + (isNeedSpan ? 'span' : 'nospan'), onClick: _this.stopClick, dangerouslySetInnerHTML: { __html: htmlVal } })));
        };
        _this.onClickImgCell = function (isFilterData) {
            var _a = _this.props, store = _a.store, cellIndex = _a.cellIndex;
            if (!isFilterData) {
                store.selectRowKey(cellIndex);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_6_antd__["message"].info(getLabel('521170', '数据不可勾选'));
            }
        };
        _this.stopClick = function (e) {
            e.stopPropagation();
        };
        // 前端处理check框
        _this.renderCheck = function (item, fieldkeyspan) {
            var datatemp = _this.props.datatemp;
            if (item.className && item.className.indexOf("checkBox") > 0) {
                var valueSpan = datatemp[fieldkeyspan];
                if (valueSpan != '0' && valueSpan != '1' && valueSpan != '') { //被转换 去除条件record[newColumn.dataIndex]!=''&&，当check框为空时也显示转换
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { title: valueSpan, dangerouslySetInnerHTML: { __html: valueSpan } });
                }
                else {
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { whiteSpace: 'normal' } },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaCheckbox"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaCheckbox@2jo555", viewAttr: '1', id: valueSpan, value: valueSpan }));
                }
            }
            return;
        };
        // 自定义按钮
        _this.renderCustomBtn = function () {
            var _a = _this.props, store = _a.store, datatemp = _a.datatemp, cellIndex = _a.cellIndex;
            var operater = store.newTable.operates;
            if (Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(operater).length > 0) {
                var menu = _this.customOperates(datatemp, cellIndex, operater);
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Dropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Dropdown@ai68n0", overlay: menu },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "icon-coms-more" })));
            }
            return;
        };
        return _this;
    }
    ImgCell.prototype.render = function () {
        var _this = this;
        var _a = this.props, datatemp = _a.datatemp, store = _a.store, cellIndex = _a.cellIndex;
        var titleField = store.titleField, dataShowInfo = store.dataShowInfo, userInfo = store.userInfo, checkBtn = store.checkBtn, doRealAction = store.doRealAction, selectRowkeys = store.selectRowkeys;
        var titleShowname = "";
        var titleDecu = "";
        var orherTitle = "";
        var orherTitleDecu = "";
        var orherTitleDecuArr = [];
        var imgFieldSecu = "";
        var selectRowkey = "";
        if (datatemp) {
            datatemp.randomFieldId ? datatemp.randomFieldSubKeyd_id != undefined ? selectRowkey = datatemp.randomFieldId + "_" + datatemp.randomFieldSubKeyd_id : selectRowkey = datatemp.randomFieldId : "";
            var index_1 = 0;
            store.newTable.columns.map(function (item, colIndex) {
                if (item.hasOwnProperty('display') && item.display == 'true') {
                    var fieldkey = item.dbField;
                    var fieldkeyspan = fieldkey && fieldkey + "span";
                    var params = item.transMethodOther;
                    var fielddbtype = params && params.split("+")[2];
                    var fieldtype = params && params.split("+")[3];
                    if (fieldkey && titleField && titleField.fieldname && fieldkey == titleField.fieldname && item.display != "none") {
                        titleDecu = datatemp[fieldkeyspan];
                    }
                    if (fieldkey && dataShowInfo && dataShowInfo.datashowtypefilefieldname && fieldkey == dataShowInfo.datashowtypefilefieldname) {
                        if (datatemp[fieldkeyspan] && datatemp[fieldkeyspan].indexOf("empty-columns") < 0 && datatemp[fieldkeyspan].split("|||")[0]) {
                            imgFieldSecu = datatemp[fieldkeyspan].split("|||")[0] + "&f_weaver_belongto_userid=" + userInfo.userid + "&f_weaver_belongto_usertype=" + userInfo.usertype;
                        }
                        else if (dataShowInfo.datashowtypefileicon) {
                            imgFieldSecu = Object(__WEBPACK_IMPORTED_MODULE_9__util_contentPath__["a" /* getContentPath */])("/weaver/weaver.file.FileDownload?fileid=") + dataShowInfo.datashowtypefileicon;
                        }
                    }
                    if (index_1 < 4 && fieldkey && (!titleField || (titleField && titleField.fieldname && fieldkey != titleField.fieldname)) && (!dataShowInfo || (dataShowInfo.datashowtypefilefieldname && fieldkey != dataShowInfo.datashowtypefilefieldname)) && fieldkey != 'randomFieldId' && fieldkey.indexOf('expandid_') < 0 && item.display != "none") {
                        titleShowname = item.title;
                        if (item.dataIndex == 'modelableid') { //如果是标签
                            var keyspanArr = datatemp[fieldkeyspan] ? JSON.parse(datatemp[fieldkeyspan]) : [];
                            orherTitleDecu = keyspanArr.map(function (tag, index) {
                                if (tag.tabname != '') {
                                    orherTitle += tag.tabname + ",";
                                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTag"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTag@p8p046@" + index, title: tag.tabname, style: {
                                            borderRadius: '4px',
                                            marginBottom: 2,
                                            marginRight: 10,
                                            color: tag.color,
                                            backgroundColor: tag.bgcolor,
                                            borderColor: tag.bdcolor
                                        } }, tag.tabname.length > 10 ? tag.tabname.slice(0, 10) + "..." : tag.tabname);
                                }
                                else {
                                    return tag.tabname + " ";
                                }
                            });
                        }
                        else {
                            orherTitleDecu = datatemp[fieldkeyspan];
                            if (orherTitleDecu.indexOf("|||") >= 0) {
                                var arr = orherTitleDecu.split("|||");
                                orherTitle = arr[0];
                                orherTitleDecu = arr[1];
                            }
                            else {
                                orherTitle = Object(__WEBPACK_IMPORTED_MODULE_8__util__["removeHTMLTag"])(orherTitleDecu);
                            }
                            if (fielddbtype == "1" && fieldtype == "1") {
                                orherTitle = datatemp[fieldkey];
                            }
                        }
                        var customDom = _this.renderCheck(item, fieldkeyspan);
                        if (item.dataIndex !== "isshowlist" && (!((fielddbtype == "2") || (fielddbtype == "6" && fieldtype == "2") || fielddbtype == "7"))) { //html格式多文本、图片
                            orherTitleDecuArr.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "td-otherCol" }, item.dataIndex == 'modelableid' ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'td-otherCol-decu', title: orherTitle }, orherTitleDecu)
                                : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_React.Fragment@z1tvym@" + colIndex },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { title: titleShowname },
                                        titleShowname,
                                        ":"),
                                    customDom ? customDom : _this.addSpan(orherTitleDecu, '', orherTitle))));
                            index_1 = index_1 + 1;
                        }
                        orherTitleDecu = "";
                        titleShowname = "";
                        orherTitle = "";
                    }
                }
            });
            var opt = this.renderCustomBtn();
            var tdStyle = "imgType-tdCol-innerHtml " + (selectRowkeys.indexOf(selectRowkey) > -1 ? 'tdCol-select' : 'tdCol-noselect');
            var isFilterData = doRealAction && checkBtn && datatemp[checkBtn] == 'true' ? true : false; // 数据筛选
            isFilterData ? tdStyle += ' tdCol-filter' : '';
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: tdStyle },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: 'imgtpyetdDiv' + cellIndex, onClick: this.onClickImgCell.bind(this, isFilterData) },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'cubeImgtd-img', onClick: this.stopClick }, imgFieldSecu ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { "data-imgsrc": imgFieldSecu, src: imgFieldSecu, className: 'formImgPlay', onClick: function (e) { viewer(e); } }) : ''),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cubeImgtd-title" },
                        this.addSpan(titleDecu),
                        opt && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "imgType-td-opt", onClick: this.stopClick }, opt)),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cubeImgtd-info" },
                        orherTitleDecuArr,
                        selectRowkey && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: 'imgtpyeselectCol' + cellIndex, className: "td-selectCol" }, selectRowkey),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "cubeImgtd-selectInfo" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: isFilterData ? 'icon-mode-close' : 'icon-coms-Selected' })))))));
        }
    };
    ImgCell = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ImgCell);
    return ImgCell;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var ImgSearch = /** @class */ (function (_super) {
    __extends(ImgSearch, _super);
    function ImgSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.height = 0;
        _this.selectRowkeys = [];
        _this.getImgSearchTable = function () {
            var store = _this.props.store;
            if (store.newTable) {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: 'imgSearchTable', className: "imgTypeDiv-tableCol-innerHtml", style: { overflow: 'scroll' } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table", { cellSpacing: "35", className: "imgType-tableCol-innerHtml" }, _this.getImgSearchTr())));
            }
            else {
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WeaTable, { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTable@luf0zj", className: "cube-list-table", register_table: store.register_table, comsWeaTableStore: store.newTable, needScroll: true, heightSpace: 10, pagination: false, tableWidth: store.originalTableWidth, hasOrder: true, onOperatesClick: store.doCustomButton, expiredRefreshFun: store.refresh }));
            }
        };
        _this.getImgSearchTr = function () {
            var store = _this.props.store;
            var newTable = store.newTable;
            var count = newTable.count, current = newTable.current, pageSize = newTable.pageSize;
            var rownum = (count - current * pageSize) >= 0 ? Math.ceil(pageSize / 5) : Math.ceil((count - (current - 1) * pageSize) / 5); //行数，一行展示5个图片
            var otherFieldMap = [];
            for (var i = 0; i < rownum; i++) {
                otherFieldMap.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", { className: "imgType-tdCol-innerHtml" }, _this.getImgSearchTd(i)));
            }
            return otherFieldMap;
        };
        _this.getImgSearchTd = function (rownum) {
            var store = _this.props.store;
            var newTable = store.newTable;
            var count = newTable.count, current = newTable.current, pageSize = newTable.pageSize;
            var pagesize = 5;
            if (pageSize < 5)
                pagesize = pageSize;
            var maxcolnum = (count - current * pageSize) >= 0 ? pagesize * (rownum + 1) : (current - 1) * pageSize + 5 * (rownum + 1) > count ? count - (current - 1) * pageSize + 5 * rownum : pagesize * (rownum + 1);
            var otherFieldMap = [];
            if (maxcolnum > 0) {
                for (var t = 5 * rownum; t < maxcolnum; t++) {
                    var datatemp = store.newTable.datas.length > t ? store.newTable.datas.get(t) : "";
                    if (datatemp) {
                        otherFieldMap.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ImgCell, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ImgCell@0dr1i3@" + t, datatemp: datatemp, store: store, cellIndex: t }));
                    }
                }
                if (maxcolnum < 5) {
                    for (var index = maxcolnum; index < 5; index++) {
                        otherFieldMap.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null));
                    }
                }
            }
            else {
                otherFieldMap.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", null));
            }
            return otherFieldMap;
        };
        return _this;
    }
    ImgSearch.prototype.componentWillMount = function () {
        var store = this.props.store;
        store.getListInfoForImgSearch(store.customId);
    };
    ImgSearch.prototype.componentDidUpdate = function () {
        var store = this.props.store;
        var newTable = store.newTable;
        var pagesize = newTable.pageSize;
        var timeCounter;
        timeCounter = setTimeout(function () {
            clearTimeout(timeCounter);
            try {
                var paginationHeight = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.ant-pagination.ant-table-pagination').height() + 32 || 46;
                var headerHeight = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.ant-table-header').height() || 40;
                var mxheight = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wea-new-top-content').height() - __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#btnDiv').height() - __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.cube-list-countContainer').height() - headerHeight - paginationHeight - 50;
                if (store.isShowCondition) {
                    mxheight = mxheight - __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.wea-search-container').height();
                }
                mxheight && __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.imgTypeDiv-tableCol-innerHtml').css('maxHeight', mxheight);
            }
            catch (e) {
            }
        }, 100);
        for (var t = 0; t < pagesize; t++) {
            var tempvalue = __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#imgtpyeselectCol" + t) && __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#imgtpyeselectCol" + t).text();
            if (store.selectRowkeys.indexOf(tempvalue) > -1) {
                __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#imgtpyetdDiv" + t).parent().attr('class', 'imgType-tdCol-innerHtml tdCol-select');
            }
        }
    };
    ImgSearch.prototype.render = function () {
        var store = this.props.store;
        var newTable = store.newTable;
        var total = newTable.count;
        var styleStr = 'ant-table-placeholder';
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@lu3lm8", spining: store.searchImg.loading }, total && total > 0 ?
            (!store.searchImg.loading ? this.getImgSearchTable()
                : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styleStr }))
            : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: styleStr },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "anticon anticon-frown", style: { marginRight: 4 } }),
                getLabel(83553, '暂无数据'))));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]
    ], ImgSearch.prototype, "height", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_5_mobx__["observable"]
    ], ImgSearch.prototype, "selectRowkeys", void 0);
    ImgSearch = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ImgSearch);
    return ImgSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ImgSearch);


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




// declare var weaEdcBoard:any;
var DataBoard = /** @class */ (function (_super) {
    __extends(DataBoard, _super);
    function DataBoard(props) {
        var _this = _super.call(this, props) || this;
        _this.loaded = false;
        _this.search = null;
        _this.loadEdcBoard();
        return _this;
    }
    DataBoard.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        var search = nextProps.search;
        if (search) {
            this.search = search;
        }
    };
    DataBoard.prototype.loadEdcBoard = function () {
        var _this = this;
        if (__WEBPACK_IMPORTED_MODULE_2_loadjs___default.a.isDefined('weaEdcBoard')) {
            this.loaded = true;
            return;
        }
        var libUrl = '/spa/edc/static4engine/board4com/';
        __WEBPACK_IMPORTED_MODULE_2_loadjs___default()([
            '/mobilemode/js/echarts4/echarts.min.js'
        ], "echarts", {
            success: function () {
                __WEBPACK_IMPORTED_MODULE_2_loadjs___default()([
                    libUrl + "index.css",
                    libUrl + "index.js",
                    "/font/edc/board/iconfont.js"
                ], "weaEdcBoard", {
                    success: function () {
                        _this.loaded = true;
                    },
                });
            },
        });
    };
    DataBoard.prototype.render = function () {
        var _a = this, loaded = _a.loaded, search = _a.search;
        if (!loaded || !search || !(window.weaEdcBoard)) {
            return null;
        }
        var DataBoardWidget = window.weaEdcBoard.com.DataBoardWidget;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DataBoardWidget, { ecId: (this && this.props && this.props.ecId || '') + "_DataBoardWidget@8coq3v", search: Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(search), board: search.dataBoard, rightslide: true }));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx__["observable"]
    ], DataBoard.prototype, "loaded", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx__["observable"]
    ], DataBoard.prototype, "search", void 0);
    DataBoard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DataBoard);
    return DataBoard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DataBoard);


/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var SelectNew = /** @class */ (function (_super) {
    __extends(SelectNew, _super);
    function SelectNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (v) {
            var _a = _this.props, onChange = _a.onChange, detailtype = _a.detailtype, multiple = _a.multiple;
            onChange(v, detailtype, multiple);
        };
        return _this;
    }
    SelectNew.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@o7u2t1" }, this.props, { onChange: this.onChange }));
    };
    SelectNew = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], SelectNew);
    return SelectNew;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (SelectNew);


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var InputNew = /** @class */ (function (_super) {
    __extends(InputNew, _super);
    function InputNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (v) {
            var _a = _this.props, onChange = _a.onChange, fieldid = _a.fieldid;
            onChange(fieldid, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(v));
        };
        _this.onPressEnter = function (e) {
            var v = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(e.target.value);
            var _a = _this.props, onPressEnter = _a.onPressEnter, fieldid = _a.fieldid, isChild = _a.isChild;
            onPressEnter(fieldid, v, isChild);
        };
        _this.onBlur = function (v) {
            var _a = _this.props, onBlur = _a.onBlur, fieldid = _a.fieldid, isChild = _a.isChild;
            onBlur(fieldid, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(v), isChild);
        };
        return _this;
    }
    InputNew.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaInput"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@acyqkn" }, this.props, { onChange: this.onChange, onPressEnter: this.onPressEnter, onBlur: this.onBlur }));
    };
    InputNew = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], InputNew);
    return InputNew;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (InputNew);


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var DateGroupNew = /** @class */ (function (_super) {
    __extends(DateGroupNew, _super);
    function DateGroupNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (v) {
            var _a = _this.props, onChange = _a.onChange, fieldid = _a.fieldid, isChild = _a.isChild;
            onChange(fieldid, v, isChild);
        };
        return _this;
    }
    DateGroupNew.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDateGroup"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaDateGroup@3dgstv" }, this.props, { onChange: this.onChange }));
    };
    DateGroupNew = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DateGroupNew);
    return DateGroupNew;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DateGroupNew);


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var TimeRangePickerNew = /** @class */ (function (_super) {
    __extends(TimeRangePickerNew, _super);
    function TimeRangePickerNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (v) {
            var _a = _this.props, onChange = _a.onChange, fieldid = _a.fieldid, isChild = _a.isChild;
            onChange(fieldid, v, isChild);
        };
        return _this;
    }
    TimeRangePickerNew.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTimeRangePicker"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaTimeRangePicker@8tlqvx" }, this.props, { onChange: this.onChange }));
    };
    TimeRangePickerNew = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TimeRangePickerNew);
    return TimeRangePickerNew;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TimeRangePickerNew);


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var RangePickerNew = /** @class */ (function (_super) {
    __extends(RangePickerNew, _super);
    function RangePickerNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (v) {
            var _a = _this.props, onChange = _a.onChange, fieldid = _a.fieldid, isChild = _a.isChild;
            onChange(fieldid, v, isChild);
        };
        return _this;
    }
    RangePickerNew.prototype.render = function () {
        var type = this.props.type;
        if (type == '290') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRangePicker"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaRangePicker@096530" }, this.props, { onChange: this.onChange }));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDatePicker"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaDatePicker@433j07" }, this.props, { onChange: this.onChange }));
        }
    };
    RangePickerNew = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], RangePickerNew);
    return RangePickerNew;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RangePickerNew);


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var SelectGroupNew = /** @class */ (function (_super) {
    __extends(SelectGroupNew, _super);
    function SelectGroupNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (v) {
            var _a = _this.props, onChange = _a.onChange, fieldid = _a.fieldid, isChild = _a.isChild;
            onChange(fieldid, v, isChild);
        };
        return _this;
    }
    SelectGroupNew.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelectGroup"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaSelectGroup@2z6o4c" }, this.props, { onChange: this.onChange }));
    };
    SelectGroupNew = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], SelectGroupNew);
    return SelectGroupNew;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (SelectGroupNew);


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var BrowserNew = /** @class */ (function (_super) {
    __extends(BrowserNew, _super);
    function BrowserNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ids, names, datas) {
            var _a = _this.props, onChange = _a.onChange, fieldtype = _a.fieldtype, fieldid = _a.fieldid, isChild = _a.isChild;
            onChange(ids, names, datas, fieldtype, fieldid, isChild);
        };
        return _this;
    }
    BrowserNew.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaBrowser"], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_WeaBrowser@6arpcv" }, this.props, { onChange: this.onChange }));
    };
    BrowserNew = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], BrowserNew);
    return BrowserNew;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (BrowserNew);


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var MenuItem = __WEBPACK_IMPORTED_MODULE_2_antd__["Menu"].Item;
var ButtonGroup = __WEBPACK_IMPORTED_MODULE_2_antd__["Button"].Group;
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main(props) {
        var _this = _super.call(this, props) || this;
        _this.loadedRowsMap = {};
        _this.getList = function () {
            var _a = _this.props, store = _a.store, _b = _a.store, titleField = _b.titleField, newTable = _b.newTable, _c = _b.verticalListStore, allDatas = _c.allDatas, rowCheckKey = _c.rowCheckKey, isShowIcon = _b.isShowIcon, isSuspend = _b.isSuspend, showButtomNum = _b.showButtomNum;
            var doRealAction = store.doRealAction, checkBtn = store.checkBtn;
            // const key =  item.randomFieldId ? item.randomFieldSubKeyd_id != undefined ? selectRowkey = datatemp.randomFieldId + "_" + datatemp.randomFieldSubKeyd_id : selectRowkey = datatemp.randomFieldId : "";
            return allDatas.map(function (item, index) {
                var isFilterData = doRealAction && checkBtn && item[checkBtn] == 'true' ? true : false;
                return React.createElement(ListItem, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ListItem@xtlfo5@" + index, key: item.randomFieldId, data: item, tablestore: newTable, isShowIcon: isShowIcon, isSuspend: isSuspend, showButtomNum: showButtomNum, titleField: titleField, index: index, store: store, needRowClick: true, rowCheckKey: Object(__WEBPACK_IMPORTED_MODULE_7_mobx__["toJS"])(rowCheckKey), isFilterData: isFilterData });
            });
        };
        _this.handleInfiniteOnLoad = function () {
            var _a = _this.props.store, newTable = _a.newTable, _b = _a.verticalListStore, allDatas = _b.allDatas, loadMorePage = _b.loadMorePage, current = _b.current, update = _b.update;
            update({ loading: true });
            if (allDatas.length >= newTable.count) {
                update({ loading: false, hasMore: false });
                return;
            }
            loadMorePage(current + 1);
        };
        return _this;
    }
    Main.prototype.componentWillMount = function () {
        var store = this.props.store;
        store.getListInfoForImgSearch();
    };
    Main.prototype.render = function () {
        var _a = this.props.store, newTable = _a.newTable, _b = _a.verticalListStore, allDatas = _b.allDatas, loading = _b.loading, hasMore = _b.hasMore;
        var allDataL = allDatas.length;
        if (allDataL <= 0) {
            return React.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@6cpaxi", className: "demo-loading", spinning: loading },
                React.createElement("div", { className: 'ant-table-placeholder' },
                    React.createElement("i", { className: "anticon anticon-frown", style: { marginRight: 4 } }),
                    getLabel(83553, '暂无数据')));
        }
        return (React.createElement("div", { className: "cube-vertical-list" },
            React.createElement(__WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller___default.a, { ecId: (this && this.props && this.props.ecId || '') + "_InfiniteScroll@ddwl6c", initialLoad: false, pageStart: 0, loadMore: this.handleInfiniteOnLoad, hasMore: !loading && hasMore, useWindow: false },
                React.createElement("div", { className: "vertical-list-items" },
                    this.getList(),
                    hasMore && newTable.count != allDataL && React.createElement("div", { className: "cube-vertical-list-loading cube-vertical-list-loadingmore", onClick: this.handleInfiniteOnLoad }, getLabel('387979', '加载更多'))),
                loading && React.createElement("div", { className: "cube-vertical-list-loading" },
                    React.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@sxsv6i", className: "demo-loading" })),
                (!hasMore || newTable.count == allDataL) && React.createElement("div", { className: "cube-vertical-list-loading" },
                    getLabel('523054', '暂无更多数据了'),
                    "(",
                    getLabel('523', '总计'),
                    " :",
                    newTable.count,
                    getLabel('18256', '条'),
                    ")!"))));
    };
    Main = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Main);
    return Main;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Main);
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customOperates = function (record, index, operates) {
            var store = _this.props.store;
            var itemsArr = [];
            var operatesshow = record.operatesshowspan;
            var likestatus = record.likesinfospan && record.likesinfospan.split(',')[2] ? record.likesinfospan.split(',')[2] : '';
            var likecount = record.likesinfospan && record.likesinfospan.split(',')[0] ? record.likesinfospan.split(',')[0] : '0';
            var dislikecount = record.likesinfospan && record.likesinfospan.split(',')[1] ? record.likesinfospan.split(',')[1] : '0';
            var isExitIcon = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* isExitIconHandle */])('customOpt', operates, operatesshow);
            operates.map(function (value, index1, array) {
                if (operatesshow.split('+')[index1] && operatesshow.split('+')[index1] == 'true') {
                    if (array[index1].nodeName && array[index1].nodeName == 'operate') {
                        if (array[index1].href == 'javascript:likes') {
                            var classname = 'icon-coms02-like-o';
                            var titlename = array[index1].text;
                            var key_1 = '1';
                            if (likestatus == '1') {
                                classname = 'icon-coms02-like';
                                titlename = getLabel('31129', '取消') + array[index1].text;
                                key_1 = '0';
                            }
                            itemsArr.push(React.createElement(MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@eyqud8@" + index1 },
                                React.createElement("span", { onClick: function () {
                                        store.likeOrDislike(record, key_1, index, '5');
                                    } },
                                    React.createElement("i", { title: titlename, className: classname }),
                                    ' ' + array[index1].text + ' (' + likecount + ')')));
                        }
                        else if (array[index1].href == 'javascript:dislikes') {
                            var classname = 'icon-coms02-Negative-comment-o';
                            var titlename = array[index1].text;
                            var key_2 = '2';
                            if (likestatus == '2') {
                                classname = 'icon-coms02-Negative-comment';
                                titlename = getLabel('31129', '取消') + array[index1].text;
                                key_2 = '0';
                            }
                            itemsArr.push(React.createElement(MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@4jzhuj@" + index1 },
                                React.createElement("span", { onClick: function () {
                                        store.likeOrDislike(record, key_2, index, '5');
                                    } },
                                    React.createElement("i", { title: titlename, className: classname }),
                                    ' ' + array[index1].text + ' (' + dislikecount + ')')));
                        }
                        else {
                            itemsArr.push(React.createElement(MenuItem, { ecId: (this && this.props && this.props.ecId || '') + "_MenuItem@l6htxl@" + index1 },
                                React.createElement("span", { onClick: function () {
                                        store.doCustomButton(record, '', array[index1], '');
                                    } },
                                    isExitIcon ? React.createElement("div", { className: 'cube-list-icon-box' }, array[index1].icon ? React.createElement("img", { src: array[index1].icon }) : '') : '',
                                    array[index1].text)));
                        }
                    }
                }
            });
            if (itemsArr.length > 0) {
                return (React.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@rpldwh" }, itemsArr));
            }
            return "";
        };
        _this.addSpan = function (htmlVal, classNameVal, title) {
            var desensitization = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].EncryBase.desensitization;
            if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isArray(htmlVal)) {
                return desensitization(htmlVal) ? React.createElement("span", { className: classNameVal },
                    React.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@ea6t3h", value: htmlVal })) : React.createElement("span", { className: classNameVal }, htmlVal);
            }
            else if (htmlVal.indexOf("</a>") > 0) {
                var val = htmlVal.replace(/<br\s*>|<br\s*\/>/g, '');
                return desensitization(val) ? React.createElement("div", { className: classNameVal },
                    " ",
                    React.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@kiw3e1", value: val })) : (React.createElement("span", { className: classNameVal, title: title },
                    React.createElement("span", { onClick: _this.stopClick, dangerouslySetInnerHTML: { __html: val } })));
            }
            else {
                return desensitization(htmlVal) ? React.createElement("div", { className: classNameVal },
                    " ",
                    React.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@paeqnq", value: htmlVal })) : (React.createElement("span", { className: classNameVal, onClick: _this.stopClick, title: title, dangerouslySetInnerHTML: { __html: htmlVal } }));
            }
        };
        _this.getListItemCell = function () {
            var _a = _this.props, data = _a.data, tablestore = _a.tablestore, isShowIcon = _a.isShowIcon, isSuspend = _a.isSuspend, index = _a.index, store = _a.store, isFilterData = _a.isFilterData, showButtomNum = _a.showButtomNum;
            var desensitization = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].EncryBase.desensitization;
            var contentArr = [];
            var orherTitleDecuSpan = "";
            var orherTitleDecu = '';
            var orherTitle = "";
            var titleShowname = "";
            // let titleDecu: string = '';
            var createrAndDate = [];
            var firstCol = [];
            var rowkey = _this.getRowKey(data);
            tablestore.columns.map(function (item, colIndex) {
                if (item.hasOwnProperty('display') && item.display == 'true') {
                    var fieldkey = item.dbField;
                    var fieldkeyspan = fieldkey && fieldkey + "span";
                    var params = item.transMethodOther;
                    var fielddbtype = params && params.split("+")[2];
                    var fieldtype = params && params.split("+")[3];
                    if (fieldkey && !fieldkey.startsWith('randomFieldId') && fieldkey.indexOf('expandid_') < 0 && item.display != "none") {
                        titleShowname = item.title;
                        orherTitleDecu = data[fieldkey];
                        if (item.dataIndex == 'modelableid') { //如果是标签
                            var keyspanArr = data[fieldkeyspan] ? JSON.parse(data[fieldkeyspan]) : [];
                            orherTitleDecuSpan = keyspanArr.map(function (tag) {
                                if (tag.tabname != '') {
                                    orherTitle += tag.tabname + ",";
                                    return React.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTag"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTag@1woigs@" + colIndex, title: tag.tabname, style: {
                                            borderRadius: '4px',
                                            marginBottom: 2,
                                            marginRight: 10,
                                            color: tag.color,
                                            backgroundColor: tag.bgcolor,
                                            borderColor: tag.bdcolor
                                        } }, tag.tabname.length > 10 ? tag.tabname.slice(0, 10) + "..." : tag.tabname);
                                }
                                else {
                                    return tag.tabname + " ";
                                }
                            });
                        }
                        else {
                            orherTitleDecuSpan = data[fieldkeyspan];
                            if (orherTitleDecuSpan.indexOf("|||") >= 0) {
                                var arr = orherTitleDecuSpan.split("|||");
                                orherTitle = arr[0];
                                orherTitleDecuSpan = arr[1];
                            }
                            else {
                                orherTitle = Object(__WEBPACK_IMPORTED_MODULE_5__util__["removeHTMLTag"])(orherTitleDecuSpan);
                            }
                            if (fielddbtype == "1" && fieldtype == "1") {
                                orherTitle = data[fieldkey];
                            }
                        }
                        if (colIndex < 2 && item.dataIndex === "modelableid") { //前两列单独处理
                            firstCol.push(React.createElement("span", { className: colIndex == 0 ? 'first-col-0' : 'first-col-1', onClick: _this.stopClick }, orherTitleDecuSpan));
                        }
                        else if (colIndex < 2 && item.dataIndex != "isshowlist") { //前两列单独处理
                            firstCol.push(desensitization(orherTitleDecuSpan) ? React.createElement("span", { className: colIndex == 0 ? 'first-col-0' : 'first-col-1' },
                                React.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInput"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInput@omibla@" + colIndex, value: orherTitleDecuSpan })) : React.createElement("span", { className: colIndex == 0 ? 'first-col-0' : 'first-col-1', onClick: _this.stopClick, dangerouslySetInnerHTML: { __html: orherTitleDecuSpan } }));
                        }
                        // if (fieldkey && titleField && titleField.fieldname && fieldkey == titleField.fieldname && item.display != "none") {
                        //     titleDecu = data[fieldkeyspan];
                        // }
                        var customDom = _this.renderCheck(item, fieldkeyspan);
                        if (colIndex >= 2 && (item.dataIndex == "modedatacreater" || item.dataIndex == "modedatacreatedate")) {
                            createrAndDate.push(React.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Fragment@v2mt5v@" + colIndex },
                                React.createElement("span", { title: orherTitle, dangerouslySetInnerHTML: { __html: orherTitleDecuSpan } })));
                        }
                        else if (colIndex >= 2 && item.dataIndex != "isshowlist") { //html格式多文本、图片&& (!((fielddbtype == "2") || (fielddbtype == "6" && fieldtype == "2") || fielddbtype == "7"))
                            orherTitleDecu && contentArr.push(React.createElement("div", { className: "vertical-list-item-otherCol" }, 
                            // item.dataIndex == 'modelableid' ? <div className='vertical-list-item-decu' title={orherTitle}>{orherTitleDecuSpan}</div>
                            React.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Fragment@v1lyay@" + colIndex },
                                React.createElement("span", { className: "item-label-container", title: titleShowname },
                                    React.createElement("span", { className: "vertical-list-item-label" },
                                        " ",
                                        titleShowname),
                                    React.createElement("span", { className: "vertical-list-item-label-colon" }, ":")),
                                customDom ? customDom : _this.addSpan(orherTitleDecuSpan, 'vertical-list-item-titledecu', orherTitle))));
                        }
                        else if (item.dataIndex == 'isshowlist') { //如果是自定义按钮
                            var newColumn_1 = item;
                            var classname_1 = item.className == 'column-text-right';
                            var colRender = function (text, record, index) {
                                var valueSpan = record[newColumn_1.dataIndex + "span"] !== undefined ? record[newColumn_1.dataIndex + "span"] : record[newColumn_1.dataIndex];
                                var num = -1;
                                var count = valueSpan && JSON.parse(valueSpan).length;
                                var custombutton;
                                var custombuttonArray;
                                if (count > showButtomNum && !isShowIcon) {
                                    if (showButtomNum > 0) {
                                        var valueSpanarrry = JSON.parse(valueSpan).slice(0, showButtomNum);
                                        var valueSpanTemp = JSON.parse(valueSpan).slice(showButtomNum - 1);
                                        var isExitIcon_1 = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* isExitIconHandle */])('opt', valueSpanTemp);
                                        custombuttonArray = valueSpanTemp && valueSpanTemp.map(function (cb) {
                                            return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["i" /* parserColumnsForFunc */])(record, num, cb, index, store, '5', isExitIcon_1);
                                        });
                                        custombutton = valueSpanarrry && valueSpanarrry.map(function (cb) {
                                            num++;
                                            if (num < showButtomNum - 1) {
                                                return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* parserColumnsForShowList */])(record, num, cb, index, isShowIcon, store, '5');
                                            }
                                            else if (num == showButtomNum - 1) {
                                                return (React.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaDropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDropdown@35884u@" + num, className: 'wea-table-page-more-drop-down', getPopupContainer: function () { return document.getElementById("buttonGroupbtn" + rowkey + index); }, overlay: React.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@5u31jt" }, custombuttonArray) }, getLabel(17499, "更多")));
                                            }
                                        });
                                    }
                                    else {
                                        var valueSpanTemp = JSON.parse(valueSpan).slice(0);
                                        var isExitIcon_2 = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* isExitIconHandle */])('opt', valueSpanTemp);
                                        custombuttonArray = valueSpanTemp && valueSpanTemp.map(function (cb) {
                                            return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["i" /* parserColumnsForFunc */])(record, num, cb, index, store, '5', isExitIcon_2);
                                        });
                                        return React.createElement("div", { className: "cube-vertical-list-cusoperate", onClick: _this.stopClick },
                                            React.createElement("div", { id: "buttonGroupbtn" + rowkey + index, className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: classname_1, whiteSpace: 'normal' } },
                                                React.createElement(ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@ecfocv" },
                                                    React.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaDropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaDropdown@8zpy2v", className: 'wea-table-page-more-drop-down', getPopupContainer: function () { return document.getElementById("buttonGroupbtn" + rowkey + index); }, overlay: React.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@yaizh5" }, custombuttonArray) }, getLabel(17499, "更多")))));
                                    }
                                    return React.createElement("div", { className: "cube-vertical-list-cusoperate", onClick: _this.stopClick },
                                        React.createElement("div", { id: "buttonGroupbtn" + rowkey + index, className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: classname_1, whiteSpace: 'normal' } },
                                            React.createElement(ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@m19ee8" }, custombutton)));
                                }
                                else {
                                    custombutton = valueSpan && JSON.parse(valueSpan).map(function (cb) {
                                        num++;
                                        return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* parserColumnsForShowList */])(record, num, cb, index, isShowIcon, store, '5');
                                    });
                                    return React.createElement("div", { className: "cube-vertical-list-cusoperate " + (isShowIcon ? 'cube-list-table-cusoperate-onlyicon' : 'cube-list-table-cusoperate-andicon'), onClick: _this.stopClick },
                                        React.createElement("div", { className: "cube-list-table-cusoperate " + (isSuspend ? 'cusoperate-hidden' : "cusoperate-visible"), style: { textAlign: 'right', whiteSpace: 'normal' } },
                                            React.createElement(ButtonGroup, { ecId: (_this && _this.props && _this.props.ecId || '') + "_ButtonGroup@2yfanr" }, custombutton)));
                                }
                            };
                            contentArr.push(colRender('', data, index));
                        }
                        orherTitleDecuSpan = "";
                        orherTitle = "";
                        titleShowname = "";
                        orherTitleDecu = '';
                    }
                }
            });
            var opt = _this.itemOpts(data, index); //自定义按钮
            return React.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Fragment@5z3iz0" },
                React.createElement("div", { className: "vertical-list-title" },
                    firstCol,
                    opt && React.createElement("div", { id: "buttonGroupbtn" + rowkey, className: "vertical-list-item-opt", onClick: _this.stopClick }, opt)),
                React.createElement("div", { className: "vertical-list-info" },
                    contentArr,
                    !__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isEmpty(createrAndDate) && React.createElement("div", { className: "vertical-list-item-otherCol vertical-list-item-dataandcreater" }, createrAndDate),
                    React.createElement("div", { className: "vertical-list-item-selectInfo" },
                        React.createElement("div", null,
                            React.createElement("i", { className: isFilterData ? 'icon-mode-close' : 'icon-coms-Selected' })))));
        };
        _this.stopClick = function (e) {
            e.stopPropagation();
        };
        _this.itemOpts = function (data, index) {
            var opt = '';
            var tablestore = _this.props.tablestore;
            var operater = tablestore.operates;
            var rowkey = _this.getRowKey(data);
            if (Object(__WEBPACK_IMPORTED_MODULE_7_mobx__["toJS"])(operater).length > 0) {
                var menu = _this.customOperates(data, index, operater);
                if (!menu) {
                    opt = '';
                }
                else {
                    opt = (React.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Dropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Dropdown@j77lt4", overlay: menu, getPopupContainer: function () { return document.getElementById("buttonGroupbtn" + rowkey); } },
                        React.createElement("i", { className: "icon-coms-more" })));
                }
            }
            return opt;
        };
        // 前端处理check框
        _this.renderCheck = function (item, fieldkeyspan) {
            var data = _this.props.data;
            if (item.className && item.className.indexOf("checkBox") > 0) {
                var valueSpan = data[fieldkeyspan];
                if (valueSpan != '0' && valueSpan != '1' && valueSpan != '') { //被转换 去除条件record[newColumn.dataIndex]!=''&&，当check框为空时也显示转换
                    return React.createElement("span", { title: valueSpan, dangerouslySetInnerHTML: { __html: valueSpan } });
                }
                else {
                    return React.createElement("div", { className: 'vertical-list-item-titledecu', style: { whiteSpace: 'normal' } },
                        React.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaCheckbox"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaCheckbox@b8243l", viewAttr: '1', id: valueSpan, value: valueSpan }));
                }
            }
            return;
        };
        _this.getRowKey = function (data) {
            return data.randomFieldId ? data.randomFieldSubKeyd_id != undefined ?
                data.randomFieldId + "_" + data.randomFieldSubKeyd_id : data.randomFieldId : "";
        };
        _this.showlistBts = function () {
        };
        return _this;
    }
    ListItem.prototype.render = function () {
        var _a = this.props, data = _a.data, needRowClick = _a.needRowClick, rowCheckKey = _a.rowCheckKey, store = _a.store, isFilterData = _a.isFilterData;
        var selectRowkeys = store.selectRowkeys;
        var rowkey = this.getRowKey(data);
        var selected = needRowClick && rowCheckKey && rowCheckKey.length > 0 && rowkey == rowCheckKey[0] || false;
        return React.createElement("div", { className: "list-item " + (selected ? 'list-item-selected' : '') + " " + (selectRowkeys.indexOf(rowkey) > -1 ? 'list-item-Col-select' : 'list-item-Col-noselect') },
            React.createElement("div", { id: "list-item-" + rowkey + " list-item-contents", onClick: function () {
                    if (!isFilterData) {
                        store.selectVerticalRowKey(rowkey);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_2_antd__["message"].info(getLabel('521170', '数据不可勾选'));
                    }
                } }, this.getListItemCell()));
    };
    ListItem = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ListItem);
    return ListItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(999)


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports.default = InfiniteScroll;
module.exports = exports['default'];


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var ListCount = /** @class */ (function (_super) {
    __extends(ListCount, _super);
    function ListCount() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListCount.prototype.render = function () {
        var _this = this;
        var Search = this.props.Search;
        var countData = Search.countData, countDisplayPosition = Search.countDisplayPosition;
        var items = [];
        if (countDisplayPosition === '1') { //countDisplayPosition:统计-显示位置 ['0':顶部显示、'1':顶部简约显示、'2':右上角显示]
            items = countData.map(function (data, index) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-list-top-countData" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: data.icon }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "cube-list-top-countData-title" },
                        data.name,
                        ":"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, data.countnum),
                    data.setdesc &&
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaHelpfulTip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaHelpfulTip@m2d1e9@" + index, width: "auto", style: { paddingLeft: '5px' }, title: data.setdesc })));
            });
        }
        else {
            var gridStyle_1 = {
                marginLeft: '0.3%',
                marginRight: '0.3%',
                width: (100 - 0.6 * countData.length) / countData.length + "% "
            };
            if (countData.length == 1) {
                gridStyle_1 = { marginLeft: '0.3%', marginRight: '0.3%', width: 24 + "% " };
            }
            items = countData.map(function (data, index) {
                var name = [];
                name.push(data.name);
                name.push("   ");
                if (data.setdesc) {
                    name.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaHelpfulTip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaHelpfulTip@zcoy4t@" + index, getTooltipContainer: function () { return document.querySelector('.coms-mode-docker'); }, width: "auto", title: data.setdesc }));
                }
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Col"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Col@l1e4ag@" + index, className: "list-count-col" + index, style: gridStyle_1 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ant-card" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ant-card-body", style: { position: "relative" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "card-body-box", style: { width: '100%', paddingRight: 50 } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "card-body-name", style: {
                                        width: '100%',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis'
                                    } }, name),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "card-body-num" }, data.countnum)),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "card-icon  " + data.icon, style: { position: 'absolute', right: 15 } })))));
            });
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-list-countContainer", style: { height: "auto" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@41xdzu", className: "list-count-row" }, items));
    };
    ListCount = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ListCount);
    return ListCount;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ListCount);


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var TreeNode = __WEBPACK_IMPORTED_MODULE_3_antd__["Tree"].TreeNode;
var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;
var TabPane = __WEBPACK_IMPORTED_MODULE_3_antd__["Tabs"].TabPane;
var getKeys = function (datas) { return datas.map(function (data) { return data.domid; }); };
// 获取总数，和每一叉树的所有 key
var getAllKeys = function (datas) {
    var num = datas.length;
    var keys = getKeys(datas);
    var childs = datas.map(function (data) {
        var obj = {
            domid: data.domid,
            childs: [],
            keys: [],
            num: 0
        };
        if (data.childs && data.childs.length > 0) {
            var _obj = getAllKeys(data.childs);
            num += _obj.num;
            obj.num = _obj.num;
            obj.childs = _obj.childs.slice();
            obj.keys = _obj.keys.slice();
            keys = keys.concat(_obj.keys);
        }
        return obj;
    });
    return {
        num: num,
        childs: childs,
        keys: keys,
    };
};
// 添加节点是否可展开标识，即是否有子集
var addLeaf = function (datas) { return datas.map(function (data) {
    var _data = __assign({}, data);
    if (data.childs && data.childs.length > 0) {
        _data.isLeaf = false;
        _data.childs = addLeaf(data.childs);
    }
    else if (data.haschild) {
        _data.isLeaf = false;
    }
    else {
        _data.isLeaf = true;
    }
    return _data;
}); };
// 获取 maxLev 级树的数据
var getDefautDatasShow = function (datas) { return (datas.map(function (data) {
    var _data = __assign({}, data);
    if (_data.childs && _data.childs.length > 0) {
        _data.childs = getDefautDatasShow(data.childs);
    }
    return _data;
})); };
// 点击展开节点，添加当前节点子集数据
var getDatasShow = function (datas, datashow, domid) { return datashow.map(function (data, index) {
    var _data = __assign({}, data);
    if (_data.domid === domid) {
        var _childs = datas[index].childs.slice();
        _childs = _childs.map(function (c) {
            var _c = __assign({}, c);
            _c.childs = [];
            return _c;
        });
        _data.childs = _childs;
    }
    else if (datas[index].childs && datas[index].childs.length > 0) {
        _data.childs = getDatasShow(datas[index].childs, _data.childs, domid);
    }
    return _data;
}); };
// 过滤搜索值
var filterDatas = function (datas, v) { return datas.map(function (data) {
    var _data = __assign({}, data);
    if (data.name.indexOf(v) >= 0 || (data.ecologyPinyinSearch && data.ecologyPinyinSearch.indexOf(v) >= 0)) {
        var _childs = data.childs ? data.childs.slice() : [];
        _data.isFind = true;
        _data.childs = _childs;
    }
    else if (data.childs && data.childs.length > 0) {
        var childs = filterDatas(data.childs, v);
        var _childs = childs.filter(function (c) { return c.isFind; });
        if (_childs.length === 0) {
            _data.isFind = false;
        }
        else {
            _data.isFind = true;
            _data.childs = childs;
        }
    }
    else {
        _data.isFind = false;
    }
    return _data;
}).filter(function (c) { return c.isFind; }); };
// 点击收藏 更改收藏状态
var doFavEdit = function (datas, domid) { return datas.map(function (data) {
    var _data = __assign({}, data);
    if (data.domid === domid) {
        _data.fav = !_data.fav;
    }
    else if (data.childs && data.childs.length > 0) {
        _data.childs = doFavEdit(data.childs, domid);
    }
    return _data;
}); };
// 删除不包含收藏节点的子集
var doNoFavDelete = function (datas) { return datas.map(function (data) {
    var _data = __assign({}, data);
    _data.hasChildFav = false;
    if (data.childs && data.childs.length > 0) {
        var childs = doNoFavDelete(data.childs);
        var _childs = childs.filter(function (c) { return c.fav || c.hasChildFav; });
        if (_childs.length > 0) {
            _data.hasChildFav = true;
            _data.childs = _childs;
        }
        else {
            _data.isLeaf = true;
            _data.childs = [];
        }
    }
    return _data;
}).filter(function (c) { return c.fav || c.hasChildFav; }); };
var LeftTree = /** @class */ (function (_super) {
    __extends(LeftTree, _super);
    function LeftTree(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollheigth = function () {
            var top = __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.wea-new-tree .wea-new-tree-scroll').offset()
                ? (__WEBPACK_IMPORTED_MODULE_6_jquery___default()('.wea-new-tree .wea-new-tree-scroll').offset().top
                    ? __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.wea-new-tree .wea-new-tree-scroll').offset().top : 0) : 0;
            // @ts-ignore
            var scrollheigth = document.documentElement.clientHeight - top - 15;
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('.wea-new-tree .wea-new-tree-scroll').height(scrollheigth);
        };
        _this.onExpandChange = function (expandedKeys) {
            _this.setState({ expandedKeys: expandedKeys });
            _this.props.onExpandChange && _this.props.onExpandChange(expandedKeys);
        };
        _this.onChangeTree = function (treeid) {
            _this.refs.inputsearch['clear'] && _this.refs.inputsearch['clear']();
            _this.props.onChangeTree && _this.props.onChangeTree(treeid);
        };
        _this.onSelect = function (keys, _a) {
            var node = _a.node;
            if (_this.props.onNodeClick && node && node.props && node.props.eventKey) {
                _this.props.onNodeClick(node.props.eventKey);
            }
            var key = node.props.eventKey;
            if (keys.indexOf(key) < 0) {
                keys.push(key);
            }
            _this.setState({ selectedKeys: keys });
            if (typeof (_this.props.onSelect) === 'function') {
                _this.props.onSelect(key, node.props);
            }
        };
        _this.onLoadData = function (node) {
            return new Promise(function (resolve) {
                if (_this.props.loadData && node && node.props && node.props.eventKey) {
                    _this.props.loadData(node.props.eventKey, node.props, function () {
                        resolve();
                    });
                }
            });
        };
        _this.getTitle = function (data) {
            var style = { width: 16, height: 16, border: 'none', verticalAlign: 'middle', marginTop: -3, marginRight: 2 };
            if (data.hrmtype && data.hrmtype == 'resource') {
                var hrmid = data.key.replace(/^\d+_/, '');
                return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaAvatar"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaAvatar@jivvo7", userId: hrmid, style: __assign({ lineHeight: 'normal' }, style) }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: Object(__WEBPACK_IMPORTED_MODULE_5__util__["removeHTMLTag"])(data.name) }, data.name)];
            }
            return ([(data.img || data.icon) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { style: data.img ? __assign({ background: "url(" + data.img + ") 0 0 no-repeat", backgroundSize: '16px 16px' }, style) : style }, data.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: data.icon })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: Object(__WEBPACK_IMPORTED_MODULE_5__util__["removeHTMLTag"])(data.name) }, data.name)]);
        };
        _this.renderTreeNodes = function (datas, counts, countsType, lev) {
            if (datas === void 0) { datas = []; }
            if (counts === void 0) { counts = {}; }
            var newDatas = [];
            datas && datas.forEach(function (data) {
                var _a = data.childs, childs = _a === void 0 ? [] : _a;
                newDatas.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TreeNode, { ecId: (_this && _this.props && _this.props.ecId || '') + "_TreeNode@f4flcw@" + data.domid, browserTree: true, key: data.domid, data: data, isLeaf: data.isLeaf, title: _this.getTitle(data), level: lev }, _this.renderTreeNodes(childs, counts, countsType, lev + 1)));
            });
            return newDatas;
        };
        //平铺显示
        _this.getTabMenu = function () {
            var _a = _this.props, _b = _a.combintree, combintree = _b === void 0 ? [] : _b, currentTree = _a.currentTree;
            if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(combintree))
                return;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Tabs"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tabs@or9vzm", defaultActiveKey: currentTree, onChange: _this.onChangeTree }, combintree.map(function (item) { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabPane, { ecId: (_this && _this.props && _this.props.ecId || '') + "_TabPane@6ewl9i@" + item.companyid, tab: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { title: item.name, className: 'cube-tree-list-tab' }, item.name), key: item.companyid }); }));
        };
        //下拉显示
        _this.getDropMenu = function () {
            var _a = _this.props, combintree = _a.combintree, currentTree = _a.currentTree;
            var showName = "";
            var menuItem = [];
            combintree.forEach(function (item, indx) {
                menuItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@wavrwu@" + indx, key: item.companyid, title: item.name }, item.name));
                menuItem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Menu"].Divider, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Divider@khwx3m@" + indx }));
                if (item.companyid === currentTree) {
                    showName = item.name;
                }
            });
            var typeMenu = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@kxkvpd", className: "wea-browser-drop-menu max-height-large", onSelect: function (node) { return _this.onChangeTree(node.key); }, selectedKeys: [currentTree] }, menuItem));
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-drop-menu cube-tree-menu", style: { width: "100%", display: 'block' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Row"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Row@k3u2yk" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Col"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Col@gsdmx8", span: 24 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Dropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Dropdown@pxpgvm", overlay: typeMenu, trigger: ["click"] },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { style: { height: 47, lineHeight: '47px' }, className: "ant-dropdown-link text-elli pr25" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-mode-org" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: showName || "" },
                                    showName || null,
                                    " "),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@deor9r", type: "down", className: "icon-down" }))))));
        };
        _this.getBaseTree = function () {
            var _a = _this.props, counts = _a.counts, countsType = _a.countsType, hasQuickSearch = _a.hasQuickSearch, expandedKeys = _a.expandedKeys;
            var _b = _this.state, _d = _b.datasShow, datasShow = _d === void 0 ? [] : _d, selectedKeys = _b.selectedKeys;
            var style = hasQuickSearch ? {} : { display: 'none' };
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'wea-new-tree' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'wea-input-wraper wea-left-tree-search wea-cube-left-tree', style: style },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-input-focus" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaInputSearch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaInputSearch@mwenpp", ref: "inputsearch", style: { width: '100%' }, className: "cubeTree-InputSearch", placeholder: getLabel(83788, "请输入关键字搜索"), onSearch: _this.props.onQuickSearch }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaScroll"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaScroll@owjvdi", className: 'wea-new-tree-scroll', typeClass: 'scrollbar-macosx' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Tree"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tree@ltc8uz", className: "wea-left-tree-antd", autoExpandParent: false, expandedKeys: expandedKeys, onExpand: _this.onExpandChange, onSelect: _this.onSelect, selectedKeys: selectedKeys, loadData: _this.onLoadData }, _this.renderTreeNodes(datasShow, counts, countsType, 0))));
        };
        var _a = props.datas, datas = _a === void 0 ? [] : _a, _b = props.selectedKeys, selectedKeys = _b === void 0 ? [] : _b;
        var _datas = addLeaf(datas);
        var datasShow = getDefautDatasShow(_datas);
        _this.isMounted = false;
        _this.state = {
            height: 0,
            datas: _datas,
            datasShow: datasShow,
            selectedKeys: selectedKeys,
            topName: props.topName || ""
        };
        return _this;
    }
    LeftTree.prototype.componentDidMount = function () {
        var _this = this;
        this.isMounted = true;
        this.scrollheigth();
        __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).resize(function () {
            _this.isMounted && _this.scrollheigth();
        });
    };
    LeftTree.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props, _b = _a.datas, datas = _b === void 0 ? [] : _b, _d = _a.selectedKeys, selectedKeys = _d === void 0 ? [] : _d, _e = _a.topName, topName = _e === void 0 ? "" : _e;
        var _selectedKeys = nextProps.selectedKeys || [];
        var _datas = nextProps.datas || [];
        if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(datas, _datas)) {
            var __datas = addLeaf(_datas);
            var datasShow = getDefautDatasShow(__datas);
            this.setState({ datas: __datas, datasShow: datasShow });
        }
        if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(selectedKeys, _selectedKeys)
            && !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.state.selectedKeys, _selectedKeys)) {
            this.setState({ selectedKeys: _selectedKeys });
        }
        if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(topName, nextProps.topName)) {
            this.setState({ topName: nextProps.topName });
        }
    };
    LeftTree.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.state.selectedKeys, nextState.selectedKeys) ||
            !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.props.selectedKeys, nextProps.selectedKeys) ||
            !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.props.datas, nextProps.datas) ||
            !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.props.counts, nextProps.counts) ||
            !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.props.countsType, nextProps.countsType) ||
            this.props.loading !== nextProps.loading ||
            !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.props.expandedKeys, nextProps.expandedKeys) ||
            !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.state.datasShow, nextState.datasShow) ||
            !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(this.state.topName, nextState.topName) ||
            this.state.height !== nextState.height;
    };
    LeftTree.prototype.componentDidUpdate = function () {
        this.scrollheigth();
    };
    LeftTree.prototype.componentWillUnmount = function () {
        this.isMounted = false;
    };
    LeftTree.prototype.onFliterAll = function () {
        if (typeof this.props.onFliterAll === 'function') {
            this.props.onFliterAll();
        }
    };
    LeftTree.prototype.render = function () {
        var _a = this.props, combintree = _a.combintree, combintreeway = _a.combintreeway;
        var topName = this.state.topName;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-tree-list" },
            combintree && combintree.length <= 1 &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTop"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTop@606md0", title: topName, icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-mode-org" }), buttons: [] }, this.getBaseTree()),
            combintree && combintree.length > 1 && combintreeway == '0' && //下拉
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    this.getDropMenu(),
                    this.getBaseTree()),
            combintree && combintree.length > 1 && combintreeway == '1' && //平铺
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    this.getTabMenu(),
                    this.getBaseTree())));
    };
    LeftTree = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], LeftTree);
    return LeftTree;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (LeftTree);


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1003),
    isObjectLike = __webpack_require__(89);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1004),
    equalArrays = __webpack_require__(405),
    equalByTag = __webpack_require__(1036),
    equalObjects = __webpack_require__(1040),
    getTag = __webpack_require__(1062),
    isArray = __webpack_require__(110),
    isBuffer = __webpack_require__(406),
    isTypedArray = __webpack_require__(407);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(156),
    stackClear = __webpack_require__(1010),
    stackDelete = __webpack_require__(1011),
    stackGet = __webpack_require__(1012),
    stackHas = __webpack_require__(1013),
    stackSet = __webpack_require__(1014);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(157);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(157);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(157);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(157);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(156);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(156),
    Map = __webpack_require__(232),
    MapCache = __webpack_require__(404);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(233),
    isMasked = __webpack_require__(1016),
    isObject = __webpack_require__(402),
    toSource = __webpack_require__(403);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1017);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(42);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1020),
    ListCache = __webpack_require__(156),
    Map = __webpack_require__(232);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1021),
    hashDelete = __webpack_require__(1022),
    hashGet = __webpack_require__(1023),
    hashHas = __webpack_require__(1024),
    hashSet = __webpack_require__(1025);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(158);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(158);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(158);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(158);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(159);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(159);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(159);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(159);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(404),
    setCacheAdd = __webpack_require__(1032),
    setCacheHas = __webpack_require__(1033);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(109),
    Uint8Array = __webpack_require__(1037),
    eq = __webpack_require__(401),
    equalArrays = __webpack_require__(405),
    mapToArray = __webpack_require__(1038),
    setToArray = __webpack_require__(1039);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(42);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1038 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1039 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1041);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1042),
    getSymbols = __webpack_require__(1044),
    keys = __webpack_require__(1047);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1043),
    isArray = __webpack_require__(110);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1045),
    stubArray = __webpack_require__(1046);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1048),
    baseKeys = __webpack_require__(1057),
    isArrayLike = __webpack_require__(1061);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1049),
    isArguments = __webpack_require__(1050),
    isArray = __webpack_require__(110),
    isBuffer = __webpack_require__(406),
    isIndex = __webpack_require__(1053),
    isTypedArray = __webpack_require__(407);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1051),
    isObjectLike = __webpack_require__(89);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isObjectLike = __webpack_require__(89);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(88),
    isLength = __webpack_require__(408),
    isObjectLike = __webpack_require__(89);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(260);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)(module)))

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1058),
    nativeKeys = __webpack_require__(1059);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1060);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1060 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(233),
    isLength = __webpack_require__(408);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1063),
    Map = __webpack_require__(232),
    Promise = __webpack_require__(1064),
    Set = __webpack_require__(1065),
    WeakMap = __webpack_require__(1066),
    baseGetTag = __webpack_require__(88),
    toSource = __webpack_require__(403);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(86),
    root = __webpack_require__(42);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(86),
    root = __webpack_require__(42);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(86),
    root = __webpack_require__(42);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(86),
    root = __webpack_require__(42);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_typeUtil__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stores_tree__ = __webpack_require__(121);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var TopTabs = /** @class */ (function (_super) {
    __extends(TopTabs, _super);
    function TopTabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDropTabClick = function (_a) {
            var key = _a.key;
            _this.props.onTabClick(key);
        };
        _this.fixedHeight = function () {
            var $this = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#container');
            var $Tab = $this.find('.cube-card-toptabs');
            var $iframe = $this.find("#tabcontentviewframe");
            try {
                $iframe && $Tab && $iframe.height($this.height() - $Tab.height() - $Tab.offset().top);
            }
            catch (e) { }
        };
        _this.setToptabHeight = function () {
            __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.cube-toptab-container').height(__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#container').height() - __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.ant-tabs-bar').height());
        };
        return _this;
    }
    TopTabs.prototype.componentDidMount = function () {
        this.setToptabHeight();
    };
    TopTabs.prototype.componentWillReceiveProps = function () {
        this.setToptabHeight();
    };
    TopTabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, onTabClick = _a.onTabClick, activeKey = _a.activeKey, modeName = _a.modeName, _b = _a.topTabs, topTabs = _b === void 0 ? [] : _b, activeDropKey = _a.activeDropKey;
        var iframeKey = (activeDropKey ? activeDropKey : activeKey) + "iframe";
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-toptabs-wrap", ref: "_topWrap" },
            (topTabs.length >= 1) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Tabs"], { ecId: (this && this.props && this.props.ecId || '') + "_Tabs@9ed8xq", className: "cube-card-toptabs", type: "card", onTabClick: onTabClick, activeKey: activeKey ? activeKey : '0' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Tabs"].TabPane, { ecId: (this && this.props && this.props.ecId || '') + "_Tabs.TabPane@mcuoej", tab: modeName, key: "0" }),
                topTabs.map(function (_a) {
                    var key = _a.key, title = _a.title, groups = _a.groups;
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__util_typeUtil__["h" /* isNumber */])(key)) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Tabs"].TabPane, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tabs.TabPane@yhujh6@" + key, key: key, tab: title }));
                    }
                    else {
                        var activeTitle_1 = '';
                        var dropMenu = (groups && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@p3aiqk@onDropTabClick", onClick: _this.onDropTabClick }, groups && groups.map(function (_a) {
                            var key1 = _a.key, title1 = _a.title;
                            if (key1 == activeDropKey) {
                                activeTitle_1 = title1;
                            }
                            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@6sqg88@" + key1, key: key1, title: title1 }, title1));
                        })));
                        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Tabs"].TabPane, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tabs.TabPane@cqe77t@" + key, key: key, tab: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Dropdown"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Dropdown@yzd7rl@" + key, overlay: dropMenu, trigger: ['hover'] },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "ant-dropdown-link" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { id: key }, activeTitle_1 ? activeTitle_1 : title),
                                    " ",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@cf516x", type: "down" }))) }));
                    }
                })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-content", style: { display: "" + (activeKey == '0' || !activeKey ? 'inline' : 'none') } }, activeKey == '0' || !activeKey ? this.props.children : ''),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { onLoad: this.fixedHeight.bind(this, iframeKey), src: "", id: "tabcontentviewframe", name: 'tabcontentviewframe', width: "100%", height: '100%', frameBorder: 0, style: { display: 'none' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-toptab-container", style: { display: this.props.isCube ? 'block' : 'none' } }, this.props.isCube && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["UrlDocker"], { ecId: (this && this.props && this.props.ecId || '') + "_UrlDocker@7bo4j3", url: this.props.url || '', Search: (this.props.Search.changeIsInTree(), this.props.Search), Tree: this.props.Tree.tree || (this.props.Tree.tree = new __WEBPACK_IMPORTED_MODULE_6__stores_tree__["a" /* TreeStore */](), this.props.Tree.tree.isInTree = true, this.props.Tree.tree), Reply: this.props.Reply, ViewCustomPage: this.props.Custompage }))));
    };
    TopTabs = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], TopTabs);
    return TopTabs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TopTabs);


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



var PopoverSearchPanel = /** @class */ (function (_super) {
    __extends(PopoverSearchPanel, _super);
    function PopoverSearchPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderPopup = function (_a) {
            var style = _a.style;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: __assign({ display: "" + (_this.props.visible ? 'block' : 'none'), position: 'absolute', paddingTop: 6, zIndex: 2 }, style) }, _this.props.content));
        };
        return _this;
    }
    PopoverSearchPanel.prototype.componentDidMount = function () {
        var getPopupContainer = this.props.getPopupContainer;
        var container = document.getElementById("cube-reply-content") || document.body;
        if (typeof getPopupContainer == 'function') {
            container = getPopupContainer();
        }
        this.popupDom = document.createElement("div");
        var top = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this)).offset().top - __WEBPACK_IMPORTED_MODULE_2_jquery___default()(container).offset().top + 23;
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(this.renderPopup({
            style: { top: top }
        }), this.popupDom);
        container.appendChild(this.popupDom);
    };
    PopoverSearchPanel.prototype.componentWillUnmount = function () {
        if (this.popupDom) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.popupDom).remove();
        }
    };
    PopoverSearchPanel.prototype.componentDidUpdate = function () {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(this.renderPopup({
            style: { top: top }
        }), this.popupDom);
    };
    PopoverSearchPanel.prototype.render = function () {
        return this.props.children;
    };
    return PopoverSearchPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (PopoverSearchPanel);


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;

var SearchPanel = /** @class */ (function (_super) {
    __extends(SearchPanel, _super);
    function SearchPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fiexedWidth = function () {
            var $content = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(".cube-reply-content");
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()(_this.refs._container).width($content.width());
        };
        _this.getSearchs = function () {
            var reply = _this.props.reply;
            return reply.conditionInfo ? reply.conditionInfo.map(function (item, i) {
                return {
                    com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@ybpyih@" + i, label: item.label, labelCol: { span: item.labelcol }, error: reply.condition.getError(item), wrapperCol: { span: item.fieldcol } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_comsMobx__["WeaSwitch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSwitch@wlww93@" + i, fieldConfig: item, form: reply.condition }))),
                    colSpan: item.colSpan
                };
            }) : [];
        };
        return _this;
    }
    SearchPanel.prototype.componentDidMount = function () {
        this.fiexedWidth();
    };
    SearchPanel.prototype.componentDidUpdate = function () {
        this.fiexedWidth();
    };
    SearchPanel.prototype.render = function () {
        var reply = this.props.reply;
        var visibleStyle = { display: "" + (reply.showSearchDrop ? 'block' : 'none') };
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-search-panel", ref: "_container", style: this.props.style },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-search-arrow", style: { right: 110 } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-search-container", style: visibleStyle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaSearchGroup"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSearchGroup@z2mwtc", title: getLabel(20331, "查询条件"), needTigger: true, showGroup: true, items: this.getSearchs() }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@5uda88", style: { borderTop: '1px solid #dadada', padding: '20px 0' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@pv9tgo", span: 24, style: { textAlign: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@mpulbo", type: "primary", style: { marginRight: 15 }, onClick: reply.search }, getLabel(197, "搜索")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@bq28le", type: "ghost", style: { marginRight: 15 }, onClick: reply.resetSearch }, getLabel(2022, "重置")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@2jdhjg", type: "ghost", style: { marginRight: 15 }, onClick: reply.hideSearch }, getLabel(201, "取消"))))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-search-mask", style: visibleStyle })));
    };
    SearchPanel = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], SearchPanel);
    return SearchPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (SearchPanel);


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reply_item_detail__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaLocaleProvider"].getLabel;

var ReplyItem = /** @class */ (function (_super) {
    __extends(ReplyItem, _super);
    function ReplyItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onAbout = function (e) {
            e = e || __WEBPACK_IMPORTED_MODULE_3__util__["default"].event;
            var offsetTop = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(e.target).offset().top;
            var $content = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(e.target).closest('.cube-reply-content');
            var top = offsetTop - $content.offset().top + 30;
            var flag = $content.height() < top + 291;
            if (flag) {
                top = top - 291 - 45;
                top = top > 10 ? top : 10;
            }
            _this.props.about(_this.props.item, { top: top }, flag);
        };
        _this.onReference = function (e) {
            e = e || __WEBPACK_IMPORTED_MODULE_3__util__["default"].event;
            var offsetTop = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(e.target).offset().top;
            var $content = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(e.target).closest('.cube-reply-content');
            var top = offsetTop - $content.offset().top + 30;
            var flag = $content.height() < top + 291;
            if (flag) {
                top = top - 291 - 45;
                top = top > 10 ? top : 10;
            }
            _this.props.reference(_this.props.item, { top: top, right: 60 }, flag);
        };
        _this.onEdit = function () {
            _this.props.edit(_this.props.item);
        };
        _this.onDelete = function () {
            _this.props.delete(_this.props.item);
        };
        _this.onLike = function () {
            _this.props.like(_this.props.item);
        };
        _this.onUnlike = function () {
            _this.props.unlike(_this.props.item);
        };
        return _this;
    }
    ReplyItem.prototype.render = function () {
        var _a = this.props.item, img_path = _a.img_path, replycontent = _a.replycontent, replydate = _a.replydate, replytime = _a.replytime, floornum = _a.floornum, replyor = _a.replyor, replyorname = _a.replyorname, replyorDept = _a.replyorDept, replyorDeptName = _a.replyorDeptName, quotes = _a.quotes, _b = _a.likeList, likeList = _b === void 0 ? [] : _b, _c = _a.comments, comments = _c === void 0 ? [] : _c, showEdit = _a.showEdit, showDelete = _a.showDelete, aleradyLiked = _a.aleradyLiked;
        var dpurl = "/hrm/company/HrmDepartmentDsp.jsp?id=" + replyorDept;
        var showlike = false;
        var showmore;
        var likeObj = '';
        if (likeList.length > 0) {
            showlike = true;
            for (var i = 0; i < (likeList.length > 5 ? 5 : likeList.length); i++) {
                var obj = likeList[i];
                likeObj += (i == 0 ? '' : ',') + obj.name;
            }
            showmore = (likeList.length > 5 ? ' ... ' + getLabel(126387, '等') + likeList.length + getLabel(127, '人') : ' ') + getLabel(383772, '觉得赞') + '！';
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-list" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-top" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: img_path, className: "content-text-left-user-img" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@dv7xri", className: "content-user" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@9or9ja", span: 10 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-user-name" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { style: { paddingRight: 10 }, href: "javaScript:openhrm(" + replyor + ")", onClick: function (event) { return __WEBPACK_IMPORTED_MODULE_3__util__["default"].pointerXY(event); } }, replyorname),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: Object(__WEBPACK_IMPORTED_MODULE_5__util_contentPath__["a" /* getContentPath */])(dpurl), target: "_blank", style: { whiteSpace: 'pre-wrap' } }, replyorDeptName)),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-user-date" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { marginRight: 10 } }, replydate + " " + replytime))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@xcn7di", span: 14 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { style: { lineHeight: '22px', marginTop: 10, color: '#9a9a9a' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "content-right-btn" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@wkw7pq" }, "#" + floornum),
                                showEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@rdrxoy", icon: "edit", onClick: this.onEdit }, getLabel(93, '编辑')),
                                showDelete &&
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Popconfirm"], { ecId: (this && this.props && this.props.ecId || '') + "_Popconfirm@a3ilft", title: getLabel(387329, '确定要删除这个评论吗？'), onConfirm: this.onDelete },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@kijsz4", icon: "delete" }, getLabel(91, '删除'))),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@cl61py", icon: "copy", onClick: this.onReference }, getLabel(19422, '引用')),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@sr9la4", icon: "file-text", onClick: this.onAbout }, getLabel(675, '评论')),
                                aleradyLiked ?
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@ucuew6", style: { color: '#2db7f5' }, title: getLabel(387404, '取消点赞'), onClick: this.onUnlike },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-mode-favour", style: { marginRight: 6 } }), "(" + likeList.length + ")")
                                    :
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@atcqeb", title: getLabel(384393, '点赞'), onClick: this.onLike },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-mode-zan", style: { marginRight: 6 } }), "(" + likeList.length + ")")))))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-bottom" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__reply_item_detail__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ReplyItemDetail@ktniln", quotes: quotes }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-right-remark-html", style: { minHeight: 24 }, dangerouslySetInnerHTML: { __html: "<div class=\"wea-cube-ckeditor-content\">" + replycontent + "</div>" } }),
                showlike && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginTop: 5 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (this && this.props && this.props.ecId || '') + "_Icon@nja0sg", type: "heart-o" }),
                    "\u00A0",
                    likeObj,
                    showmore),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__reply_item_detail__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ReplyItemDetail@p1gy08", comments: comments }))));
    };
    ReplyItem = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ReplyItem);
    return ReplyItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ReplyItem);


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplyAddDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReplyAddPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cube_at__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_modeUtil__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;





var ReplyAdd = /** @class */ (function (_super) {
    __extends(ReplyAdd, _super);
    function ReplyAdd(props) {
        var _this = _super.call(this, props) || this;
        /**
         *  回复评富文本框底部按钮
         */
        _this.getbottomBar = function () {
            var replyAdd = _this.props.replyAdd;
            var showbuttons = replyAdd.showbuttons, secretLevel = replyAdd.secretLevel;
            var bottomBarConfig = [];
            showbuttons.forEach(function (buttoninfo) {
                if (buttoninfo.isdefault && buttoninfo.fieldhtmltype == "3") {
                    if (buttoninfo.type == "37") {
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Browser",
                            show: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-Document" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    " ",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-Journal' }),
                                    " ",
                                    getLabel(58, "文档")))),
                            type: "37",
                            isSingle: false,
                            customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            title: getLabel(58, "文档"),
                            dataParams: { secretLevel: secretLevel }
                        });
                    }
                    else if (buttoninfo.type == "152") {
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Browser",
                            show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-Process" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-Workflow-o' }),
                                    " ",
                                    getLabel(18015, "流程"))),
                            type: "152",
                            isSingle: false,
                            customParams: { 'linkUrl': buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            title: getLabel(18015, "流程"),
                            dataParams: { secretLevel: secretLevel }
                        });
                    }
                    else if (buttoninfo.type == "18") {
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Browser",
                            show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-Personnel" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-currency-Customer' }),
                                    " ",
                                    getLabel(136, "客户"))),
                            type: "18",
                            isSingle: false,
                            customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            title: getLabel(136, "客户"),
                            dataParams: { secretLevel: secretLevel }
                        });
                    }
                    else if (buttoninfo.type == "135") {
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Browser",
                            show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-Project" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-task-list' }),
                                    " ",
                                    getLabel(101, "项目"))),
                            type: "135",
                            isSingle: false,
                            customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            title: getLabel(101, "项目"),
                            dataParams: { secretLevel: secretLevel }
                        });
                    }
                }
                else if (buttoninfo.isdefault && buttoninfo.fieldhtmltype == "6") {
                    bottomBarConfig.push(_this.getUploadCom('buttom_default', buttoninfo));
                }
                if (!buttoninfo.isdefault) {
                    if (buttoninfo.fieldhtmltype == "3") {
                        bottomBarConfig.push(__assign({ isBlog: true, name: "Browser", show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-task-list' }),
                                    " ",
                                    buttoninfo.fieldlabelname)), customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid } }, buttoninfo.buttonProps, { dataParams: __assign({}, buttoninfo.buttonProps.dataParams, { secretLevel: secretLevel }) }));
                    }
                    else if (buttoninfo.fieldhtmltype == "6") {
                        bottomBarConfig.push(_this.getUploadCom('buttom_spicial', buttoninfo));
                    }
                }
            });
            return bottomBarConfig;
        };
        _this.getUploadCom = function (tooltype, buttoninfo) {
            var _a = _this.props, replyAdd = _a.replyAdd, params = _a.params;
            var billid = params.billid, formId = params.formId, modeId = params.modeId;
            var uploadObj = {};
            var limitType = "";
            var uploadType = [
                {
                    type: 'top',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon cke_button_icon cke_button__image_icon" })),
                    uploadUrl: '/api/formmode/card/uploadimage',
                    _html: 'image',
                    category: 'all',
                },
                {
                    type: 'bottom',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-File" }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@4ggdji", type: 'paper-clip' }),
                            " ",
                            getLabel(156, '附件'))),
                    uploadUrl: "/api/formmode/card/replyUpload?category=1&from=reply&mainId=" + replyAdd.maincategory + "&subId=" + replyAdd.subcategory + "&secId=" + replyAdd.seccategory
                        + "&modeid=" + modeId + "&formid=" + formId + "&billid=" + billid,
                    _html: 'file',
                    category: replyAdd.maincategory + "," + replyAdd.subcategory + "," + replyAdd.seccategory,
                },
            ];
            if (buttoninfo) {
                if (buttoninfo['fieldhtmltype'] == '6' && buttoninfo['type'] == '2') {
                    limitType = "jpg,gif,png,bmp";
                }
                var secId = replyAdd.seccategory;
                if (buttoninfo.seccategory) {
                    secId = buttoninfo.seccategory;
                }
                uploadType.push({
                    type: 'buttom_default',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-File" }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@ll3i05", type: 'paper-clip' }),
                            " ",
                            getLabel(156, '附件'))),
                    uploadUrl: "/api/formmode/card/replyUpload?category=1&from=reply&mainId=" + replyAdd.maincategory + "&subId=" + replyAdd.subcategory + "&secId=" + secId
                        + "&modeid=" + modeId + "&formid=" + formId + "&billid=" + billid,
                    _html: 'file',
                    category: replyAdd.maincategory + "," + replyAdd.subcategory + "," + replyAdd.seccategory,
                }, {
                    type: 'buttom_spicial',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-File" }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@41uepf", type: 'paper-clip' }),
                            " ",
                            buttoninfo.fieldlabelname)),
                    uploadUrl: "/api/formmode/card/replyUpload?category=1&from=reply&mainId=" + replyAdd.maincategory + "&subId=" + replyAdd.subcategory + "&secId=" + secId
                        + "&modeid=" + modeId + "&formid=" + formId + "&billid=" + billid,
                    _html: 'file',
                    category: replyAdd.maincategory + "," + replyAdd.subcategory + "," + buttoninfo.seccategory,
                });
            }
            var upload = uploadType.filter(function (item) { return item.type == tooltype; })[0];
            if (__WEBPACK_IMPORTED_MODULE_6__util__["default"] !== __WEBPACK_IMPORTED_MODULE_6__util__["default"].top) {
                uploadObj = {
                    name: 'Component',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Upload"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Upload@vmukyu", name: 'file', action: upload.uploadUrl, accept: upload.type == 'top' ? '.jpg,.gif,.png' : '', showUploadList: false, onChange: function (info) {
                                if (info['file'].response) {
                                    var id_1 = info['file'].response.data.fileid;
                                    var listArr_1 = [];
                                    info.fileList.map(function (item) {
                                        if (id_1 == item.response.data.fileid) {
                                            item = __assign({}, item, item.response.data);
                                            listArr_1.push(__assign({}, item, item.response.data));
                                        }
                                    });
                                    var fileHtml = _this.toolsChange('Upload', id_1, listArr_1, upload._html, '');
                                    _this.addAtInfo(fileHtml, 'upload');
                                }
                            } }, upload.show))
                };
            }
            else {
                uploadObj = {
                    name: 'Upload',
                    show: upload.show,
                    uploadUrl: upload.uploadUrl,
                    category: upload.category,
                };
                if (upload.type == 'top') {
                    uploadObj = __assign({}, uploadObj, { type: 'image', limitType: 'jpg,gif,png', title: '上传图片', needLoading: false });
                }
                else {
                    uploadObj = __assign({}, uploadObj, { isBlog: true, uploadId: "replyUpload", limitType: limitType, autoUpload: true, multiSelection: false, btnSize: "small" });
                }
            }
            if (buttoninfo) {
                uploadObj = __assign({}, uploadObj, { customParams: { isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid }, secLevel: replyAdd.secretLevel + '', secLevelInfo: getLabel('530630', '请先填写卡片密级！'), showSecLevel: true, casProtect: true });
            }
            return uploadObj;
        };
        _this.toolsChange = function (name, _, list, type, customParams) {
            _this.rtInstance.focus('last'); // 光标置后
            var str = '';
            var linkUrl = customParams ? customParams.linkUrl : '';
            var isdefault = customParams ? customParams.isdefault : false;
            var fieldid = customParams ? customParams.fieldid : '0';
            var mirror = {
                37: "doc",
                task: "task",
                18: "crm",
                152: "workflow",
                135: "project",
                workplan: "workplan",
                blogTemplate: "blogTemplate"
            };
            list.map(function (item) {
                if (name === 'Upload' && type === 'image') {
                    str += '<img class="formImgPlay" src="' + item.filelink + '" data-imgsrc="' + (item.loadlink || item.filelink) + '" />';
                }
                if (name === 'Upload' && type === 'file') {
                    str += (item.filelink + '<br>');
                }
                if (name === 'Browser') {
                    // if (mirror[type] == "doc") {//文档
                    //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/spa/document/index.jsp?id=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // }
                    // // else if(mirror[type] == "task"){
                    // //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/spa/document/index.jsp?id=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // // }
                    // else if (mirror[type] == "crm") {//客户
                    //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/spa/crm/static/index.html#/main/crm/customerView?customerId=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // } else if (mirror[type] == "workflow") {//流程
                    //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/workflow/request/ViewRequestForwardSPA.jsp?isrequest=1&requestid=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // } else if (mirror[type] == "project") {//项目
                    //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/spa/prj/index.html#/main/prj/projectCard?prjid=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // } else {
                    //     str += (type === 'blogTemplate' ? item.name : `<a href='javascript:void(0)'  linkid='${item.id}' linkType='${mirror[type]}' onclick='try{return openAppLink(this,${item.id});}catch(e){}' ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>`)
                    // }
                    if (isdefault) {
                        str += (type === 'blogTemplate' ? item.name : "<a href=\"javascript:modeopenFullWindowHaveBar('" + (linkUrl + item.id) + "')\"  linkid='" + item.id + "' linkType='" + mirror[type] + "' onclick=\"try{return openAppLink(this," + item.id + ");}catch(e){}\" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>" + (item.name || item.showname || '') + "</a>&nbsp;&nbsp;&nbsp;");
                    }
                    else {
                        str += (type === 'blogTemplate' ? item.name : "<abbr class='custom' id='" + (fieldid + '_' + item.id) + "' name='" + item.name + "'><a href=\"javascript:modeopenFullWindowHaveBar('" + (linkUrl + item.id) + "')\"  linkid='" + item.id + "' linkType='" + mirror[type] + "' onclick=\"try{return openAppLink(this," + item.id + ");}catch(e){}\" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>" + (item.name || item.showname || '') + "</a></abbr>");
                    }
                    if (mirror[type] == "task") {
                        str += (type === 'blogTemplate' ? item.name : "<a href=\"javascript:modeopenFullWindowHaveBar(" + Object(__WEBPACK_IMPORTED_MODULE_8__util_contentPath__["a" /* getContentPath */])('/spa/document/index.jsp?id=' + item.id) + ")\"  linkid='" + item.id + "' linkType='" + mirror[type] + "' onclick=\"try{return openAppLink(this," + item.id + ");}catch(e){}\" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>" + (item.name || item.showname || '') + "</a>&nbsp;&nbsp;&nbsp;");
                    }
                }
            });
            return str;
        };
        _this.setAtInfo = function (k, v) {
            var _a = _this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b;
            replyAdd.setAtInfo(k, v, params);
        };
        _this.getExtendsBar = function () {
            var _a = _this.props, editorId = _a.editorId, params = _a.params, replyAdd = _a.replyAdd, windowTop = _a.windowTop;
            var visibleComponent = _this.state.visibleComponent;
            var extentsConfig = [
                _this.getUploadCom('top'),
                {
                    name: 'Component',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__cube_at__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_CubeAt@e7326q", editorId: editorId, appendHtmlToCKEditor: _this.addAtInfo.bind(_this), visible: visibleComponent === 'CubeAt', showComponent: _this.showComponent.bind(_this), params: params, replyAdd: replyAdd, windowTop: windowTop })
                },
            ];
            return extentsConfig;
        };
        _this.loadJSAndInitAt = function () {
            var _a = _this.props, visible = _a.visible, replyAdd = _a.replyAdd, windowTop = _a.windowTop;
            if (visible || replyAdd.popup) {
                var ckeditorid_1 = _this.rtInstance.editor.container.getId() || "";
                var iframeIndex_1 = __WEBPACK_IMPORTED_MODULE_6__util__["default"] !== __WEBPACK_IMPORTED_MODULE_6__util__["default"].top ? 0 : 1;
                var init = function () { return _this.initAutoAt(windowTop.$("#" + ckeditorid_1).find('iframe')[iframeIndex_1]); };
                __WEBPACK_IMPORTED_MODULE_9_loadjs___default.a.isDefined("atwhoJS")
                    ? __WEBPACK_IMPORTED_MODULE_9_loadjs___default.a.ready("atwhoJS", init)
                    : __WEBPACK_IMPORTED_MODULE_9_loadjs___default()([
                        "/cloudstore/resource/pc/atwho/jquery.atwho_wev8.js",
                        "/cloudstore/resource/pc/atwho/jquery.nicescroll_wev8.js",
                        "/cloudstore/resource/pc/atwho/jquery.caret_wev8.js",
                        "css!/cloudstore/resource/pc/atwho/jquery.atwho_wev8.css"
                    ], "atwhoJS", init);
            }
        };
        _this.saveAt = function () {
            var ck = _this.rtInstance;
            if (ck) {
                ck.editor.undoManager.save();
            }
        };
        _this.getInstance = function (ins) {
            if (!_this.rtInstance) {
                _this.rtInstance = ins;
            }
        };
        var remark = props.remark, visible = props.visible, windowTop = props.windowTop, replyAdd = props.replyAdd;
        _this.state = {
            remark: remark,
            visibleComponent: '',
            visible: visible,
            richContent: replyAdd.content,
            rtInstanceReady: false
        };
        if (!windowTop.CK_REF) {
            windowTop.CK_REF = {};
        }
        return _this;
    }
    ReplyAdd.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.setState({ richContent: nextProps.replyAdd.content });
    };
    ReplyAdd.prototype.getAtInfo = function () {
        var _a = this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b;
        return replyAdd.getAtInfo(params);
    };
    ReplyAdd.prototype.componentWillMount = function () {
        var _a = this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b, windowTop = _a.windowTop;
        var secretLevel = replyAdd.secretLevel;
        var atInfo = this.getAtInfo();
        var _c = atInfo.time, time = _c === void 0 ? '' : _c;
        var key = "cube_at_" + params.modeId + "_" + params.billid;
        var now = new Date().getTime();
        var isNeedLoad = true;
        if (windowTop.__atdata && time && !isNaN(time)) {
            if (now - time < 1000 * 60 * 3) { //小于3分钟，不需要再次加载
                isNeedLoad = false;
            }
        }
        var tempatitems = [];
        var setAtInfo = this.setAtInfo.bind(this);
        if (isNeedLoad) {
            windowTop.jQuery.ajax({
                url: Object(__WEBPACK_IMPORTED_MODULE_8__util_contentPath__["a" /* getContentPath */])('/api/cube/new/card/getAtUsers'),
                type: 'GET',
                data: { modeid: params.modeId, billid: params.billid, secretLevel: secretLevel },
                success: function (result) {
                    setAtInfo("time", now);
                    var response = JSON.parse(result);
                    tempatitems = [];
                    response.operators.map(function (o) {
                        tempatitems.push(o);
                    });
                    replyAdd.atInfo[key + "_data"] = { atitems: tempatitems, _atitems: tempatitems.slice(0, 100) };
                    windowTop.__atdataready = true;
                    windowTop.__atdata = tempatitems;
                }
            });
        }
        else {
            tempatitems = windowTop.__atdata;
            windowTop.__atdataready = true;
            replyAdd.atInfo[key + "_data"] = { atitems: tempatitems, _atitems: tempatitems.slice(0, 100) };
        }
    };
    ReplyAdd.prototype.componentDidUpdate = function () {
        var _a = this.props, _b = _a.visible, visible = _b === void 0 ? false : _b, replyAdd = _a.replyAdd, windowTop = _a.windowTop;
        if (visible || replyAdd.popup) {
            var ckeditorid = this.rtInstance.editor.container.getId() || "";
            this.initAutoAt(windowTop.$("#" + ckeditorid).find('iframe')[0]);
        }
    };
    ReplyAdd.prototype.componentDidMount = function () {
        var _a = this.props, _b = _a.editorId, editorId = _b === void 0 ? "" : _b, windowTop = _a.windowTop;
        windowTop.CK_REF[editorId] = this.rtInstance;
        if (windowTop.CK_REF[editorId]) {
            var editor = windowTop.CK_REF[editorId].getEditor();
            if (editor) {
                editor.focusManager.focus(editor.editable());
            }
        }
    };
    ReplyAdd.prototype.showComponent = function (componet) {
        this.setState({ visibleComponent: componet });
    };
    ReplyAdd.prototype.addAtInfo = function (html, type) {
        var _a = this.props, _b = _a.editorId, editorId = _b === void 0 ? "" : _b, windowTop = _a.windowTop;
        var _html = html;
        if (windowTop.CK_REF[editorId]) {
            var instances = windowTop.CK_REF[editorId].getEditor().ui.instances;
            if (instances && type !== 'upload') {
                var font = instances.Font['_'].value || '微软雅黑';
                var fontsize = instances.FontSize['_'].value || '12';
                _html = "<span style=\"font-family:'" + font + "';font-size:" + fontsize + "px;\" >" + html + "</span>";
            }
        }
        this.appendHtmlToCKEditor(_html);
    };
    ReplyAdd.prototype.appendHtmlToCKEditor = function (html, pos) {
        var windowTop = this.props.windowTop;
        if (pos) {
            this.rtInstance['insertHTML'](__WEBPACK_IMPORTED_MODULE_6__util__["convertSpecialChar"](html), pos);
            var el = this.rtInstance;
            var me_1 = this;
            windowTop.$(el).off("click").on("click", function (_) {
                me_1.setState({ visibleComponent: '' });
            });
        }
        else {
            this.rtInstance['insertHTML'](__WEBPACK_IMPORTED_MODULE_6__util__["convertSpecialChar"](html));
        }
    };
    ReplyAdd.prototype.initAutoAt = function (ifr) {
        var _a = this.props, editorId = _a.editorId, windowTop = _a.windowTop;
        var me = this;
        var ckeditor = this.rtInstance;
        try {
            var datas = windowTop.__atdata;
            if (windowTop.__atdataready != true || !!!datas) {
                setTimeout(function () {
                    me.initAutoAt(ifr);
                }, 1000);
                return;
            }
            var allatids_1 = ",";
            var names = windowTop.jQuery.map(datas, function (value, _) {
                if (allatids_1.indexOf("," + value.uid + ",") == -1) {
                    allatids_1 += value.uid + ",";
                    return { 'id': value.uid, 'name': value.data, 'py': value.datapy || "" };
                }
            });
            var at_config = {
                at: "@",
                data: names,
                tpl: "<li data-value='@${name}'>${name}</li>",
                insert_tpl: "<a href='" + Object(__WEBPACK_IMPORTED_MODULE_8__util_contentPath__["a" /* getContentPath */])("/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/") + "${id}' atsome='@${id}' contenteditable='false' style='cursor:pointer;text-decoration:none !important;margin-right:8px;color:#2777c1!important;' target='_blank'>${atwho-data-value}</a>",
                limit: 100,
                show_the_at: true,
                start_with_space: false,
                with_repeat_matcher: false,
                search_key_py: 'py',
                ckeditor: ckeditor,
                editorId: editorId,
                save: this.saveAt,
                pageIndex: 1,
                pageSize: 20,
            };
            var ifrBody = ifr.contentDocument.body;
            windowTop.jQuery(ifrBody)['atwho']('setIframe', ifr).atwho(at_config).on("inserted.atwho", function (a, b, c) { });
            var atwhoblockobj = windowTop.jQuery(".atwho-view");
            atwhoblockobj['perfectScrollbar']({ horizrailenabled: false, zindex: 11111 });
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util_modeUtil__["d" /* writeLog */])("", e);
        }
    };
    ReplyAdd.prototype.loadReady = function (info) {
        if (info == 'ready') {
            this.setState({ rtInstanceReady: true });
            var replyAdd = this.props.replyAdd;
            var setEditor = replyAdd.setEditor;
            this.loadJSAndInitAt();
            setEditor(this.rtInstance.editor, this.loadJSAndInitAt);
            var replyModal = __WEBPACK_IMPORTED_MODULE_10_jquery___default()('.cube-reply-iframe').find(".ant-modal");
            if (replyModal.length > 0 && replyModal.width() < 768) {
                replyModal.css("cssText", "left:0px !important;");
            }
        }
    };
    ReplyAdd.prototype.componentWillUnmount = function () {
        var windowTop = this.props.windowTop;
        windowTop.CK_REF = {};
    };
    ReplyAdd.prototype.render = function () {
        var _this = this;
        var _a = this.props, replyAdd = _a.replyAdd, windowTop = _a.windowTop;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-add" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRichText"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRichText@aahz4o", ref: this.getInstance, value: this.state.richContent, 
                //style={{ padding: "12px 10px 0 10px" }} QC:739626
                ckConfig: {
                    toolbar: [
                        { nane: "document", items: ["Source"] },
                        { name: "paragraph", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "-", "NumberList", "BulletedList"] },
                        { name: "styles", items: ["Format", "Font", "FontSize"] },
                        { name: "color", items: ["TextColor"] },
                        { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike"] },
                        { name: "insert", items: ["Table", "Smiley"] },
                    ],
                    extraPlugins: 'autogrow',
                    height: 185,
                    autoGrow_minHeight: 185,
                    autoGrow_maxHeight: 185,
                    removePlugins: 'resize',
                    uploadUrl: '/api/formmode/card/uploadimage',
                }, extentsConfig: this.getExtendsBar(), bottomBarConfig: this.getbottomBar(), onChange: replyAdd.onChange, onToolsChange: this.toolsChange, layout: windowTop, onStatusChange: function (info) { _this.loadReady(info); } })));
    };
    return ReplyAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (ReplyAdd);
var ReplyAddDialog = /** @class */ (function (_super) {
    __extends(ReplyAddDialog, _super);
    function ReplyAddDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReplyAddDialog.prototype.render = function () {
        var _a = this.props, replyAdd = _a.replyAdd, params = _a.params, iconInfo = _a.iconInfo;
        var windowTop = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].WindowFunc.getTop();
        var windowNew; //qc:#752287 iframe情况--window丢失
        var classNameDialog = "wea-auth-modal cube-dialog";
        if (windowTop.location.href.indexOf('cube/card') > -1) {
            windowNew = windowTop;
        }
        else {
            windowNew = __WEBPACK_IMPORTED_MODULE_6__util__["default"];
            classNameDialog += " cube-reply-iframe";
        }
        var buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@7l3a04@onCancel", icon: "cross", onClick: replyAdd.onCancel }, getLabel(309, "关闭")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@ubdo8g@onOk", type: "primary", icon: "save", loading: replyAdd.loading, onClick: replyAdd.onOk }, getLabel(615, '提交'))];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@28y8ba", className: classNameDialog, buttons: buttons, title: getLabel(128283, '回复评论'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: replyAdd.visible, style: { width: '900px', height: '300px' }, hasScroll: true, onCancel: replyAdd.onCancel, layout: windowNew.document.body }, replyAdd.visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReplyAdd, { ecId: (this && this.props && this.props.ecId || '') + "_ReplyAdd@g92mr3", replyAdd: replyAdd, visible: replyAdd.visible, params: params, key: "replyadd", editorId: "replyadd", iconInfo: iconInfo, windowTop: windowNew })));
    };
    ReplyAddDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], ReplyAddDialog);
    return ReplyAddDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var ReplyAddPopup = /** @class */ (function (_super) {
    __extends(ReplyAddPopup, _super);
    function ReplyAddPopup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReplyAddPopup.prototype.render = function () {
        var _a = this.props, replyAdd = _a.replyAdd, params = _a.params, iconInfo = _a.iconInfo;
        var ClassNames = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('cube-replay-add-popup', {
            'cube-reply-add-popup-bottom': replyAdd.popupArrowPostion,
            'cube-reply-add-popup-top': !replyAdd.popupArrowPostion
        });
        var windowTop = __WEBPACK_IMPORTED_MODULE_6__util__["default"];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { ref: "_container", className: ClassNames, style: __assign({ display: "" + (replyAdd.popup ? 'block' : 'none') }, replyAdd.popupOffset) },
            replyAdd.isInitPopup &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: 310, overflow: "scroll" } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReplyAdd, { ecId: (this && this.props && this.props.ecId || '') + "_ReplyAdd@fs1ljb", replyAdd: replyAdd, visible: replyAdd.visible, params: params, key: "replyaddpop", editorId: "replyaddpop", iconInfo: iconInfo, windowTop: windowTop })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-add-popup-btn" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@tek2vz", style: { marginRight: 10 }, icon: "cross", onClick: replyAdd.onPopupCancel }, getLabel(309, "关闭")),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@otj747", type: "primary", icon: "save", loading: replyAdd.loading, onClick: replyAdd.onOk }, getLabel(615, '提交')))));
    };
    ReplyAddPopup = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], ReplyAddPopup);
    return ReplyAddPopup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rightReplyContent__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var RightReplyBase = /** @class */ (function (_super) {
    __extends(RightReplyBase, _super);
    function RightReplyBase(props) {
        var _this = _super.call(this, props) || this;
        var reply = _this.props.reply;
        reply.pagesize = 20;
        reply.total = 0;
        reply.pagecount = 0;
        reply.current = 1;
        return _this;
    }
    RightReplyBase.prototype.render = function () {
        var _a = this.props, reply = _a.reply, h = _a.h;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "100%" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@i4bln2", datas: [], showUrlItem: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@4suy33", spinning: reply.loading },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply", style: { height: h } }, (reply && reply.showReply) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__rightReplyContent__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_RightReplyContent@pbhw6g" }, this.props)))))));
    };
    RightReplyBase = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], RightReplyBase);
    return RightReplyBase;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RightReplyBase);


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_input__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rightReplyItem__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rightReplyAdd__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var confirm = __WEBPACK_IMPORTED_MODULE_2_antd__["Modal"].confirm;
var num = 0;
var RightReplyContent = /** @class */ (function (_super) {
    __extends(RightReplyContent, _super);
    function RightReplyContent(props) {
        var _this = _super.call(this, props) || this;
        _this.doScrollBottom = function () {
            var contentScroll = _this.refs.cubeReplyScroll;
            if (contentScroll && num < 100) {
                if (contentScroll["scroll"]) {
                    num = 0;
                    var reply = _this.props.reply;
                    if (reply.replyAdd.okClickType == 'new' || reply.replyAdd.okClickType == 'quote') { //新建或者引用
                        contentScroll["scrollToLast"]();
                    }
                    else {
                        var h = __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#cubeReplyContentScroll .wea-new-scroll .scroller")[0].scrollHeight;
                        var scrollTop = reply.scrollTop;
                        var top = h - scrollTop;
                        if (top < 0) {
                            top = 0;
                        }
                        contentScroll["scroll"](top);
                    }
                    reply.replyAdd.okClickType = '';
                }
                else {
                    num++;
                    var doScrollBottom_1 = _this.doScrollBottom.bind(_this);
                    setTimeout(function () {
                        doScrollBottom_1();
                    }, 100);
                }
            }
        };
        _this.onScrollNext = function () {
            var reply = _this.props.reply;
            var current = reply.current, pagecount = reply.pagecount;
            if (current < pagecount) {
                var contentScroll = _this.refs.cubeReplyScroll;
                var scrollTop = 0;
                if (contentScroll) {
                    scrollTop = contentScroll["getScrollTop"]();
                }
                if (scrollTop == 0) {
                    _this.loadNextPage();
                }
            }
        };
        _this.getScrollTop = function () {
            var scrollTop = 0;
            var contentScroll = _this.refs.cubeReplyScroll;
            if (contentScroll) {
                scrollTop = contentScroll["getScrollTop"]();
            }
            var top = __WEBPACK_IMPORTED_MODULE_7_jquery___default()("#cubeReplyContentScroll .wea-new-scroll .scroller").prevObject["context"]["children"]["0"].scrollHeight - scrollTop;
            return top;
        };
        _this.loadNextPage = function () {
            var reply = _this.props.reply;
            reply.loadNextPage();
        };
        _this.deleteReply = function (tiem) {
            var reply = _this.props.reply;
            confirm({
                title: getLabel(387329, '确定要删除这个评论吗？'),
                onOk: function () {
                    reply.delete(tiem);
                },
                onCancel: function () { },
            });
        };
        _this.getRelpyList = function () {
            var reply = _this.props.reply;
            var arr = new Array();
            var current = reply.current, pagecount = reply.pagecount;
            var length = reply.replyList.slice().length;
            if (current < pagecount) {
                arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function () { return _this.loadNextPage(); }, className: "cube-reply-showmore" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-overtime' }),
                    " ",
                    getLabel('-81408', "查看更多")));
            }
            var index = reply.replyList.length;
            var pageIndex = 0;
            for (var i = 0; i < reply.dateList.length; i++) {
                var date = reply.dateList[i];
                arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-date-split" }, date));
                for (var j = 0; j < reply.replyList.length; j++) {
                    var item = reply.replyList[j];
                    if (item.replydate == date) {
                        if (index % 20 == 0) {
                            pageIndex++;
                            arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cube-reply-page" + pageIndex }));
                        }
                        arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__rightReplyItem__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_RightReplyItem@r01kq8@" + i, item: item, edit: reply.edit, delete: _this.deleteReply.bind(_this), like: reply.like, unlike: reply.unlike, reference: reply.referenceRight, about: reply.aboutRight, isLast: length == j + 1 }));
                        index++;
                    }
                }
            }
            return arr;
        };
        _this.getSearchs = function () {
        };
        _this.getTabButtons = function () {
            var reply = _this.props.reply;
            return [(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__search_input__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_SearchInput@blz1rq@1", reply: reply }))];
        };
        var reply = _this.props.reply;
        reply.scrollBottom = _this.doScrollBottom;
        reply.getScrollTop = _this.getScrollTop;
        return _this;
    }
    RightReplyContent.prototype.componentDidMount = function () {
        this.doScrollBottom();
    };
    RightReplyContent.prototype.render = function () {
        var _this = this;
        var _a = this.props, reply = _a.reply, h = _a.h;
        var length = reply.replyList.slice().length;
        var height = reply.showRichText ? h - 50 - 270 : h - 92;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-content", id: "cube-reply-content", style: { minHeight: 500, position: "relative" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-list-wrap" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTab"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTab@a3es8l", selectedKey: reply.selectedKey, datas: reply.tabDatas, keyParam: 'key', onChange: reply.changeTab, buttons: this.getTabButtons() }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cubeReplyContentScroll" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaNewScroll"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaNewScroll@sckl25", ref: "cubeReplyScroll", height: height, onScroll: function () { return _this.onScrollNext(); } }, length == 0 ?
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-list-placeholder" }, getLabel(83553, '暂无数据'))
                        :
                            this.getRelpyList())),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaNewScroll"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaNewScroll@gq4abu", height: reply.showRichText ? 270 : "" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "remark_div", className: "" + "creply-right-container " },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'cube-sign-input', style: {
                                background: reply.showRichText ? "#F9F8F7" : "#ffffff",
                                border: "1px solid #E2E2E2",
                                borderLeft: "1px solid #E2E2E2",
                                cursor: reply.showRichText ? "auto" : "pointer",
                            }, onClick: function () { return reply.isShowAddReplyText(true); } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-Need-feedback cube-sign-input-icon" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: "#333333", lineHeight: "40px" } }, getLabel(20009, '发表评论')),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { marginLeft: "10px", display: "inline-block" }, dangerouslySetInnerHTML: { __html: reply.replyAdd.optdesc } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { marginLeft: "15px" } })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, reply.showRichText ?
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__rightReplyAdd__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_RightReplyAdd@68uuzt", replyAdd: reply.replyAdd, params: reply.params, key: "replyaddright", editorId: "replyaddright" })
                            : ""))))));
    };
    RightReplyContent = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], RightReplyContent);
    return RightReplyContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RightReplyContent);


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reply_item_detail__ = __webpack_require__(413);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;

var RightReplyItem = /** @class */ (function (_super) {
    __extends(RightReplyItem, _super);
    function RightReplyItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMenuClick = function (key) {
            var aleradyLiked = _this.props.item.aleradyLiked;
            if (key == "1") {
                _this.onEdit();
            }
            else if (key == "2") {
                _this.onDelete();
            }
            else if (key == "3") {
                _this.onReference();
            }
            else if (key == "4") {
                _this.onAbout();
            }
            else if (key == "5") {
                if (aleradyLiked) {
                    _this.onUnlike();
                }
                else {
                    _this.onLike();
                }
            }
        };
        _this.getMenu = function () {
            var _a = _this.props.item, showEdit = _a.showEdit, showDelete = _a.showDelete, aleradyLiked = _a.aleradyLiked, _b = _a.likeList, likeList = _b === void 0 ? [] : _b;
            var menu = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu@136wko", onClick: function (_a) {
                    var key = _a.key;
                    _this.handleMenuClick(key);
                } },
                showEdit &&
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@fro3gk", key: "1" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@deah0d", type: "edit" }),
                            " ",
                            getLabel(93, '编辑'))),
                showDelete &&
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@s1l2iq", key: "2" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@t3e4vd", type: "delete" }),
                            " ",
                            getLabel(91, '删除'))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@bg3j8t", key: "3" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@9wka63", type: "copy" }),
                        " ",
                        getLabel(19422, '引用'))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@khkou7", key: "4" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@i51987", type: "file-text" }),
                        " ",
                        getLabel(675, '评论'))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Menu"].Item, { ecId: (_this && _this.props && _this.props.ecId || '') + "_Menu.Item@lfyiwg", key: "5" }, aleradyLiked ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#2db7f5' }, title: getLabel(387404, '取消点赞') },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-mode-favour" }),
                        "  ", "(" + likeList.length + ")")
                    :
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel(384393, '点赞') },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-mode-zan" }),
                            "  ", "(" + likeList.length + ")"))));
            return menu;
        };
        _this.onAbout = function () {
            _this.props.about(_this.props.item);
        };
        _this.onReference = function () {
            _this.props.reference(_this.props.item);
        };
        _this.onEdit = function () {
            _this.props.edit(_this.props.item);
        };
        _this.onDelete = function () {
            _this.props.delete(_this.props.item);
        };
        _this.onLike = function () {
            _this.props.like(_this.props.item);
        };
        _this.onUnlike = function () {
            _this.props.unlike(_this.props.item);
        };
        return _this;
    }
    RightReplyItem.prototype.render = function () {
        var _a = this.props.item, img_path = _a.img_path, replycontent = _a.replycontent, replydate = _a.replydate, replytime = _a.replytime, floornum = _a.floornum, replyor = _a.replyor, replyorname = _a.replyorname, replyorDept = _a.replyorDept, replyorDeptName = _a.replyorDeptName, ismy = _a.ismy, quotes = _a.quotes, _b = _a.likeList, likeList = _b === void 0 ? [] : _b, _c = _a.comments, comments = _c === void 0 ? [] : _c;
        var dpurl = "/hrm/company/HrmDepartmentDsp.jsp?id=" + replyorDept;
        var showmore;
        var likeObj = '';
        if (likeList.length > 0) {
            for (var i = 0; i < (likeList.length > 3 ? 3 : likeList.length); i++) {
                var obj = likeList[i];
                likeObj += (i == 0 ? '' : ',') + obj.name;
            }
            showmore = (likeList.length > 3 ? ' ... ' + getLabel(126387, '等') + likeList.length + getLabel(127, '人') : ' ') + getLabel(383772, '觉得赞') + '！';
        }
        var css1 = ismy == "1" ? "cube-reply-my" : "cube-reply-others";
        var css2 = ismy == "1" ? " ant-popover-placement-leftTop" : " ant-popover-placement-rightTop";
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-list" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: css1 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-img" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: img_path, className: "content-text-left-user-img" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-text" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ant-popover" + css2 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ant-popover-content" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ant-popover-arrow" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ant-popover-inner" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ant-popover-title" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { padding: "0 5px 0 0" } }, "#" + floornum),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { title: getLabel('131681', "发表于") + ":" + (replydate + " " + replytime), style: { paddingRight: 10 }, href: "javaScript:openhrm(" + replyor + ")", onClick: function (event) { return __WEBPACK_IMPORTED_MODULE_3__util__["default"].pointerXY(event); } }, replyorname),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])(dpurl), target: "_blank", style: { whiteSpace: 'pre-wrap' } }, replyorDeptName)),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "reply-menu" },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Dropdown"], { ecId: (this && this.props && this.props.ecId || '') + "_Dropdown@z27fku", overlay: this.getMenu() },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "reply-menu-icon" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-more" }))))),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ant-popover-inner-content" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__reply_item_detail__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ReplyItemDetail@bcmhqj", quotes: quotes, showType: 2 }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "content-right-remark-html", style: { minHeight: 24 }, dangerouslySetInnerHTML: { __html: "<div class=\"wea-cube-ckeditor-content\">" + replycontent + "</div>" } }),
                                        likeList.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'replyLikeDesc' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (this && this.props && this.props.ecId || '') + "_Icon@3jhtwg", type: "heart-o" }),
                                            "\u00A0",
                                            likeObj,
                                            showmore),
                                        comments.length > 0 &&
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "replyComments" },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__reply_item_detail__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ReplyItemDetail@409ycy", comments: comments })))))))),
                ismy == "1" ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "clear" })
                    :
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null))));
    };
    RightReplyItem = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], RightReplyItem);
    return RightReplyItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RightReplyItem);


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_at__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_modeUtil__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_loadjs__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;



var window = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaTools"].WindowFunc.getTop();
var allNames = [];
var RightReplyAdd = /** @class */ (function (_super) {
    __extends(RightReplyAdd, _super);
    function RightReplyAdd(props) {
        var _this = _super.call(this, props) || this;
        /**
         *  回复评富文本框底部按钮
         */
        _this.getbottomBar = function () {
            var _a = _this.props, replyAdd = _a.replyAdd, params = _a.params;
            var billid = params.billid, formId = params.formId, modeId = params.modeId;
            var showbuttons = replyAdd.showbuttons, secretLevel = replyAdd.secretLevel;
            var bottomBarConfig = [];
            showbuttons.forEach(function (buttoninfo) {
                if (buttoninfo.isdefault && buttoninfo.fieldhtmltype == "3") {
                    if (buttoninfo.type == "37") {
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Browser",
                            show: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-Document" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    " ",
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-Journal' }),
                                    " ",
                                    getLabel(58, "文档")))),
                            type: "37",
                            isSingle: false,
                            customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            title: getLabel(58, "文档"),
                            dataParams: { secretLevel: secretLevel }
                        });
                    }
                    else if (buttoninfo.type == "152") {
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Browser",
                            show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-Process" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-Workflow-o' }),
                                    " ",
                                    getLabel(18015, "流程"))),
                            type: "152",
                            isSingle: false,
                            customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            title: getLabel(18015, "流程"),
                            dataParams: { secretLevel: secretLevel }
                        });
                    }
                    else if (buttoninfo.type == "18") {
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Browser",
                            show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-Personnel" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-currency-Customer' }),
                                    " ",
                                    getLabel(136, "客户"))),
                            type: "18",
                            isSingle: false,
                            customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            title: getLabel(136, "客户"),
                            dataParams: { secretLevel: secretLevel }
                        });
                    }
                    else if (buttoninfo.type == "135") {
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Browser",
                            show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-Project" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-task-list' }),
                                    " ",
                                    getLabel(101, "项目"))),
                            type: "135",
                            isSingle: false,
                            customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            title: getLabel(101, "项目"),
                            dataParams: { secretLevel: secretLevel }
                        });
                    }
                }
                else if (buttoninfo.isdefault && buttoninfo.fieldhtmltype == "6") {
                    var secId = replyAdd.seccategory;
                    if (buttoninfo.seccategory) {
                        secId = buttoninfo.seccategory;
                    }
                    bottomBarConfig.push({
                        isBlog: true,
                        name: "Upload",
                        show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-File" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@v8615t", type: 'paper-clip' }),
                                " ",
                                getLabel(156, '附件'))),
                        uploadId: "replyUpload",
                        uploadUrl: "/api/formmode/card/replyUpload?category=1&from=reply&mainId=" + replyAdd.maincategory + "&subId=" + replyAdd.subcategory + "&secId=" + secId
                            + "&modeid=" + modeId + "&formid=" + formId + "&billid=" + billid,
                        autoUpload: true,
                        multiSelection: false,
                        customParams: { isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                        category: replyAdd.maincategory + "," + replyAdd.subcategory + "," + replyAdd.seccategory,
                        btnSize: "small",
                        secLevel: replyAdd.secretLevel + '',
                        secLevelInfo: getLabel('530630', '请先填写卡片密级！'),
                        showSecLevel: true,
                        casProtect: true,
                    });
                }
                if (!buttoninfo.isdefault) {
                    if (buttoninfo.fieldhtmltype == "3") {
                        bottomBarConfig.push(__assign({ isBlog: true, name: "Browser", show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-task-list' }),
                                    " ",
                                    buttoninfo.fieldlabelname)), customParams: { linkUrl: buttoninfo.buttonProps.linkUrl, isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid } }, buttoninfo.buttonProps, { dataParams: __assign({}, buttoninfo.buttonProps.dataParams, { secretLevel: secretLevel }) }));
                    }
                    else if (buttoninfo.fieldhtmltype == "6") {
                        var secId = replyAdd.seccategory;
                        if (buttoninfo.seccategory) {
                            secId = buttoninfo.seccategory;
                        }
                        bottomBarConfig.push({
                            isBlog: true,
                            name: "Upload",
                            show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon-File" }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-text" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@jh6b5i", type: 'paper-clip' }),
                                    " ",
                                    buttoninfo.fieldlabelname)),
                            uploadId: "replyUpload",
                            uploadUrl: "/api/formmode/card/replyUpload?category=1&from=reply&mainId=" + replyAdd.maincategory + "&subId=" + replyAdd.subcategory + "&secId=" + secId
                                + "&modeid=" + modeId + "&formid=" + formId + "&billid=" + billid,
                            autoUpload: true,
                            multiSelection: false,
                            customParams: { isdefault: buttoninfo.isdefault, fieldid: buttoninfo.fieldid },
                            category: replyAdd.maincategory + "," + replyAdd.subcategory + "," + buttoninfo.seccategory,
                            btnSize: "small",
                            secLevel: replyAdd.secretLevel + '',
                            secLevelInfo: getLabel('530630', '请先填写卡片密级！'),
                            showSecLevel: true,
                            casProtect: true,
                        });
                    }
                }
            });
            return bottomBarConfig;
        };
        _this.toolsChange = function (name, _, list, type, customParams) {
            _this.rtInstance.focus('last');
            var str = '';
            var linkUrl = customParams ? customParams.linkUrl : '';
            var isdefault = customParams ? customParams.isdefault : false;
            var fieldid = customParams ? customParams.fieldid : '0';
            var mirror = {
                37: "doc",
                task: "task",
                18: "crm",
                152: "workflow",
                135: "project",
                workplan: "workplan",
                blogTemplate: "blogTemplate"
            };
            list.map(function (item) {
                if (name === 'Upload' && type === 'image') {
                    str += '<img class="formImgPlay" src="' + item.filelink + '" data-imgsrc="' + (item.loadlink || item.filelink) + '" />';
                }
                if (name === 'Upload' && type === 'file') {
                    str += (item.filelink + '<br>');
                }
                if (name === 'Browser') {
                    // if (mirror[type] == "doc") {//文档
                    //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/spa/document/index.jsp?id=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // }
                    // // else if(mirror[type] == "task"){
                    // //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/spa/document/index.jsp?id=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // // }
                    // else if (mirror[type] == "crm") {//客户
                    //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/spa/crm/static/index.html#/main/crm/customerView?customerId=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // } else if (mirror[type] == "workflow") {//流程
                    //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/workflow/request/ViewRequestForwardSPA.jsp?isrequest=1&requestid=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // } else if (mirror[type] == "project") {//项目
                    //     str += (type === 'blogTemplate' ? item.name : `<a href="javascript:modeopenFullWindowHaveBar('/spa/prj/index.html#/main/prj/projectCard?prjid=${item.id}')"  linkid='${item.id}' linkType='${mirror[type]}' onclick="try{return openAppLink(this,${item.id});}catch(e){}" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>&nbsp;&nbsp;&nbsp;`)
                    // } else {
                    //     str += (type === 'blogTemplate' ? item.name : `<a href='javascript:void(0)'  linkid='${item.id}' linkType='${mirror[type]}' onclick='try{return openAppLink(this,${item.id});}catch(e){}' ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>${item.name || item.showname}</a>`)
                    // }
                    if (isdefault) {
                        str += (type === 'blogTemplate' ? item.name : "<a href=\"javascript:modeopenFullWindowHaveBar('" + (linkUrl + item.id) + "')\"  linkid='" + item.id + "' linkType='" + mirror[type] + "' onclick=\"try{return openAppLink(this," + item.id + ");}catch(e){}\" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>" + (item.name || item.showname || '') + "</a>&nbsp;&nbsp;&nbsp;");
                    }
                    else {
                        str += (type === 'blogTemplate' ? item.name : "<abbr class='custom' id='" + (fieldid + '_' + item.id) + "' name='" + item.name + "'><a href=\"javascript:modeopenFullWindowHaveBar('" + (linkUrl + item.id) + "')\"  linkid='" + item.id + "' linkType='" + mirror[type] + "' onclick=\"try{return openAppLink(this," + item.id + ");}catch(e){}\" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>" + (item.name || item.showname || '') + "</a></abbr>");
                    }
                    if (mirror[type] == "task") {
                        str += (type === 'blogTemplate' ? item.name : "<a href=\"javascript:modeopenFullWindowHaveBar(" + Object(__WEBPACK_IMPORTED_MODULE_7__util_contentPath__["a" /* getContentPath */])('/spa/document/index.jsp?id=' + item.id) + ")\"  linkid='" + item.id + "' linkType='" + mirror[type] + "' onclick=\"try{return openAppLink(this," + item.id + ");}catch(e){}\" ondblclick='return false;'  unselectable='off' contenteditable='false' style='cursor:pointer;text-decoration:underline !important;margin-right:8px'>" + (item.name || item.showname || '') + "</a>&nbsp;&nbsp;&nbsp;");
                    }
                }
            });
            return str;
        };
        _this.setAtInfo = function (k, v) {
            var _a = _this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b;
            replyAdd.setAtInfo(k, v, params);
        };
        _this.getExtendsBar = function () {
            var _a = _this.props, editorId = _a.editorId, params = _a.params, replyAdd = _a.replyAdd;
            var visibleComponent = _this.state.visibleComponent;
            var extentsConfig = [
                {
                    name: 'Upload',
                    type: 'image',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cb-item" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-cbi-icon cke_button_icon cke_button__image_icon" })),
                    uploadUrl: '/api/formmode/card/uploadimage',
                    category: 'all',
                    limitType: 'jpg,gif,png',
                    title: '上传图片',
                    needLoading: false
                },
                {
                    name: 'Component',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__cube_at__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_CubeAt@nysqrx", editorId: editorId, appendHtmlToCKEditor: _this.addAtInfo.bind(_this), visible: visibleComponent === 'CubeAt', showComponent: _this.showComponent.bind(_this), params: params, replyAdd: replyAdd })
                },
                {
                    name: 'Component',
                    show: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { title: getLabel('128961', "清除内容"), className: "icon-mode-close", onClick: replyAdd.clearContent })
                },
            ];
            return extentsConfig;
        };
        _this.getRightBar = function () {
            var replyAdd = _this.props.replyAdd;
            var disabled = replyAdd.content ? false : true;
            var bottomBarRight = {
                width: 85,
                Component: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "wea-rich-text-toolbar-bottom-item", style: { position: "relative" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@vys6a8", disabled: disabled, className: "wea-button-release", type: "primary", loading: replyAdd.loading, onClick: replyAdd.onOk },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, getLabel(615, '提交')))))
            };
            return bottomBarRight;
        };
        _this.saveAt = function () {
            var ck = _this.rtInstance;
            if (ck) {
                ck.editor.undoManager.save();
            }
        };
        _this.loadReady = function (info) {
            if (info == 'ready') {
                var setEditor = _this.props.replyAdd.setEditor;
                allNames = [];
                _this.loadJSAndInitAt();
                setEditor(_this.rtInstance.editor, _this.loadJSAndInitAt);
            }
        };
        _this.loadJSAndInitAt = function () {
            var ckeditorid = _this.rtInstance.editor.container.getId();
            var init = function () { return _this.initAutoAt(__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#" + ckeditorid).find('iframe')[1]); };
            __WEBPACK_IMPORTED_MODULE_9_loadjs___default.a.isDefined("atwhoJS")
                ? __WEBPACK_IMPORTED_MODULE_9_loadjs___default.a.ready("atwhoJS", init)
                : __WEBPACK_IMPORTED_MODULE_9_loadjs___default()([
                    "/cloudstore/resource/pc/atwho/jquery.atwho_wev8.js",
                    "/cloudstore/resource/pc/atwho/jquery.nicescroll_wev8.js",
                    "/cloudstore/resource/pc/atwho/jquery.caret_wev8.js",
                    "css!/cloudstore/resource/pc/atwho/jquery.atwho_wev8.css"
                ], "atwhoJS", init);
            // 加载高度
            var editor = _this.rtInstance.editor;
            var body = editor.document.getBody();
            if (body && body.$) {
                var ht = body.getStyle('height');
                if (!ht || ht !== '100px') {
                    body.setStyle("height", '100px');
                }
            }
        };
        _this.getInstance = function (ins) {
            if (!_this.rtInstance) {
                _this.rtInstance = ins;
            }
        };
        var remark = props.remark, visible = props.visible;
        _this.state = {
            remark: remark,
            visibleComponent: '',
            visible: visible
        };
        if (!window.CK_REF) {
            window.CK_REF = {};
        }
        return _this;
    }
    RightReplyAdd.prototype.getAtInfo = function () {
        var _a = this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b;
        return replyAdd.getAtInfo(params);
    };
    RightReplyAdd.prototype.componentWillMount = function () {
        var _a = this.props, replyAdd = _a.replyAdd, _b = _a.params, params = _b === void 0 ? {} : _b;
        var secretLevel = replyAdd.secretLevel;
        var atInfo = this.getAtInfo();
        var _c = atInfo.time, time = _c === void 0 ? '' : _c;
        var key = "cube_at_" + params.modeId + "_" + params.billid;
        var now = new Date().getTime();
        var isNeedLoad = true;
        if (window.__atdata && time && !isNaN(time)) {
            if (now - time < 1000 * 60 * 3) { //小于3分钟，不需要再次加载
                isNeedLoad = false;
            }
        }
        var tempatitems = [];
        var setAtInfo = this.setAtInfo.bind(this);
        if (isNeedLoad) {
            __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
                url: Object(__WEBPACK_IMPORTED_MODULE_7__util_contentPath__["a" /* getContentPath */])('/api/cube/new/card/getAtUsers'),
                type: 'GET',
                data: { modeid: params.modeId, billid: params.billid, secretLevel: secretLevel },
                success: function (result) {
                    setAtInfo("time", now);
                    var response = JSON.parse(result);
                    tempatitems = [];
                    response.operators.map(function (o) {
                        tempatitems.push(o);
                    });
                    replyAdd.atInfo[key + "_data"] = { atitems: tempatitems, _atitems: tempatitems.slice(0, 100) };
                    window.__atdataready = true;
                    window.__atdata = tempatitems;
                }
            });
        }
        else {
            tempatitems = window.__atdata;
            window.__atdataready = true;
            replyAdd.atInfo[key + "_data"] = { atitems: tempatitems, _atitems: tempatitems.slice(0, 100) };
        }
    };
    RightReplyAdd.prototype.componentDidMount = function () {
        var _a = this.props.editorId, editorId = _a === void 0 ? "" : _a;
        window.CK_REF[editorId] = this.rtInstance;
    };
    RightReplyAdd.prototype.showComponent = function (componet) {
        var extents = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(".wea-rich-text-extents");
        if (extents.length > 0) {
            var left = extents[0].offsetLeft;
            if (left < 160) {
                __WEBPACK_IMPORTED_MODULE_8_jquery___default()(".wfat-content").addClass("wfat-content-right");
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8_jquery___default()(".wfat-content").removeClass("wfat-content-right");
            }
        }
        this.setState({ visibleComponent: componet });
    };
    RightReplyAdd.prototype.addAtInfo = function (html) {
        var _a = this.props.editorId, editorId = _a === void 0 ? "" : _a;
        var _html = html;
        if (window.CK_REF[editorId]) {
            var instances = window.CK_REF[editorId].getEditor().ui.instances;
            if (instances) {
                var font = instances.Font['_'].value || '微软雅黑';
                var fontsize = instances.FontSize['_'].value || '12';
                _html = "<span style=\"font-family:'" + font + "';font-size:" + fontsize + "px;\" >" + html + "</span>";
            }
        }
        this.appendHtmlToCKEditor(_html);
    };
    RightReplyAdd.prototype.appendHtmlToCKEditor = function (html, pos) {
        if (pos) {
            this.rtInstance['insertHTML'](__WEBPACK_IMPORTED_MODULE_5__util__["convertSpecialChar"](html), pos);
            var el = this.rtInstance;
            var me_1 = this;
            __WEBPACK_IMPORTED_MODULE_8_jquery___default()(el).off("click").on("click", function (_) {
                me_1.setState({ visibleComponent: '' });
            });
        }
        else {
            this.rtInstance['insertHTML'](__WEBPACK_IMPORTED_MODULE_5__util__["convertSpecialChar"](html));
        }
    };
    RightReplyAdd.prototype.initAutoAt = function (ifr) {
        var editorId = this.props.editorId;
        var me = this;
        var ckeditor = this.rtInstance;
        try {
            var datas = window.__atdata;
            if (window.__atdataready != true || !!!datas) {
                setTimeout(function () {
                    me.initAutoAt(ifr);
                }, 1000);
                return;
            }
            var allatids_1 = ",";
            if (allNames.length == 0) {
                __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.map(datas, function (value, _) {
                    if (allatids_1.indexOf("," + value.uid + ",") == -1) {
                        allatids_1 += value.uid + ",";
                        allNames.push({ 'id': value.uid, 'name': value.data, 'py': value.datapy || "" });
                    }
                });
            }
            var names = allNames;
            var at_config = {
                at: "@",
                data: names,
                tpl: "<li data-value='@${name}'>${name}</li>",
                insert_tpl: "<a href='" + Object(__WEBPACK_IMPORTED_MODULE_7__util_contentPath__["a" /* getContentPath */])("/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/") + "${id}' atsome='@${id}' contenteditable='false' style='cursor:pointer;text-decoration:none !important;margin-right:8px;color:#2777c1!important;' target='_blank'>${atwho-data-value}</a>",
                limit: 100,
                show_the_at: true,
                start_with_space: false,
                with_repeat_matcher: false,
                search_key_py: 'py',
                ckeditor: ckeditor,
                editorId: editorId,
                appendHtmlToCKEditor: this.appendHtmlToCKEditor,
                pageIndex: 1,
                pageSize: 20,
                save: this.saveAt,
            };
            var ifrBody = ifr.contentDocument.body;
            __WEBPACK_IMPORTED_MODULE_8_jquery___default()(ifrBody)
                .atwho("setIframe", ifr)
                .atwho(at_config)
                .on("inserted.atwho", function (a, b, c) { });
            var atwhoblockobj = __WEBPACK_IMPORTED_MODULE_8_jquery___default()(".atwho-view");
            atwhoblockobj &&
                atwhoblockobj.perfectScrollbar({
                    horizrailenabled: false,
                    zindex: 11111
                });
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_6__util_modeUtil__["d" /* writeLog */])("", e);
        }
    };
    RightReplyAdd.prototype.render = function () {
        var _this = this;
        var replyAdd = this.props.replyAdd;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-reply-add" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaRichText"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRichText@baeev7", ref: this.getInstance, value: replyAdd.content, ckConfig: {
                    toolbar: [
                        { nane: "document", items: ["Source"] },
                        { name: "paragraph", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "-", "NumberList", "BulletedList"] },
                        { name: "styles", items: ["Format", "Font", "FontSize"] },
                        { name: "color", items: ["TextColor"] },
                        { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike"] },
                        { name: "insert", items: ["Table", "Smiley"] },
                    ],
                    extraPlugins: 'autogrow',
                    height: 100,
                    autoGrow_minHeight: 100,
                    autoGrow_maxHeight: 100,
                    removePlugins: 'resize',
                    uploadUrl: '/api/formmode/card/uploadimage',
                }, extentsConfig: this.getExtendsBar(), bottomBarConfig: this.getbottomBar(), bottomBarRight: this.getRightBar(), onChange: replyAdd.onChange, onToolsChange: this.toolsChange, onStatusChange: function (info) { _this.loadReady(info); } })));
    };
    RightReplyAdd = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], RightReplyAdd);
    return RightReplyAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (RightReplyAdd);


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogDetailDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comsMobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var LogDetail = /** @class */ (function (_super) {
    __extends(LogDetail, _super);
    function LogDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRightMenuClick = function (key) {
            var LogListStore = _this.props.LogListStore;
            if (key == "1") {
                LogListStore.onCancel();
            }
            if (key == "0") {
                LogListStore.detailTable = {
                    current: 1,
                    pagesize: 10
                };
                LogListStore.doDetailSearch();
            }
        };
        _this.getSearchItems = function () {
            var LogListStore = _this.props.LogListStore;
            var detailCondition = LogListStore.detailCondition, detailFrom = LogListStore.detailFrom;
            var isFormInit = detailFrom.isFormInit;
            var groups = [];
            isFormInit && detailCondition.map(function (c) {
                c.items.map(function (fields, idn) {
                    groups.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Col"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Col@mx34pw@" + idn, span: fields.rowColSpan },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@66tmo9@" + idn, label: "" + fields.label, labelCol: { span: "" + fields.labelcol }, wrapperCol: { span: "" + fields.fieldcol } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_comsMobx__["WeaSwitch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSwitch@eepfzn@" + idn, fieldConfig: fields, form: detailFrom }))));
                });
            });
            return groups;
        };
        return _this;
    }
    LogDetail.prototype.render = function () {
        var LogListStore = this.props.LogListStore;
        var dialog = LogListStore.dialog, logDetailTableData = LogListStore.logDetailTableData, detailTable = LogListStore.detailTable;
        var rightMenus = [{
                icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-search' }),
                content: getLabel(197, "搜索"),
                key: 0
            }, {
                icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-go-back' }),
                content: getLabel(309, "关闭"),
                key: 1
            }];
        var columns = [{
                title: getLabel(99, "操作者"),
                dataIndex: 'operateuserid',
                key: 'operateuserid',
                width: 200
            }, {
                title: getLabel(63, "类型"),
                dataIndex: 'operatedesc',
                key: 'operatedesc',
                width: 200
            }, {
                title: getLabel(82281, "日期时间"),
                dataIndex: 'operatedatetime',
                key: 'operatedatetime',
                width: 200
            }, {
                title: getLabel(19113, '值'),
                dataIndex: 'fieldvalue',
                key: 'fieldvalue',
                width: 200,
                render: function (_, record) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: record.fieldvalue } })); }
            }];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@13mk4k", datas: rightMenus, onClick: this.handleRightMenuClick, collectParams: {
                "favname": getLabel(82274, "字段日志") + "-" + LogListStore.dialog.title,
                "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                "favouritetype": 5,
                "importantlevel": 1
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-list-batch-edit" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@w6mv6y", spinning: dialog.loading, tip: dialog.loadingTips },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@omv57r", style: { padding: "10px 0px 10px 30px" } }, this.getSearchItems()),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Table"], { ecId: (this && this.props && this.props.ecId || '') + "_Table@ch1h6v", columns: columns, dataSource: logDetailTableData.logDataDetail.slice(), className: "cube-log-list-table", pagination: {
                            current: detailTable.current,
                            pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
                            total: logDetailTableData.detailTotal,
                            defaultPageSize: detailTable.pagesize,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: function (total) {
                                return " " + (getLabel(18609, "共") + total + ' ' + getLabel(18256, "条")) + " ";
                            },
                            onShowSizeChange: function (current, pageSize) { LogListStore.changeDetailPageSize(current, pageSize); }
                        }, onChange: LogListStore.nextDetailDatas, scroll: { y: 405 } })))));
    };
    LogDetail = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], LogDetail);
    return LogDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (LogDetail);
var LogDetailDialog = /** @class */ (function (_super) {
    __extends(LogDetailDialog, _super);
    function LogDetailDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogDetailDialog.prototype.render = function () {
        var LogListStore = this.props.LogListStore;
        var iconInfo = LogListStore.iconInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@ct00o5", onCancel: LogListStore.onCancel, title: getLabel(82274, "字段日志") + "-" + LogListStore.dialog.title, visible: LogListStore.visible, iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", style: { width: 800, height: 560 }, hasScroll: true }, LogListStore.visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LogDetail, { ecId: (this && this.props && this.props.ecId || '') + "_LogDetail@q9zvw9", LogListStore: LogListStore })));
    };
    LogDetailDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], LogDetailDialog);
    return LogDetailDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainFieldLogDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var MainFieldLog = /** @class */ (function (_super) {
    __extends(MainFieldLog, _super);
    function MainFieldLog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainFieldLog.prototype.render = function () {
        var cubeLogList = this.props.cubeLogList;
        var columns = [
            { title: getLabel(31644, '字段名'), dataIndex: 'fieldlabelname', key: 'fieldlabelname', width: '25%', },
            {
                title: getLabel(82276, '字段值(当前修改)'),
                dataIndex: 'fieldvalue',
                key: 'fieldvalue',
                width: '25%',
                render: function (_, record) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: record.fieldvalue } })); }
            },
            {
                title: getLabel(82277, '字段值(修改前)'),
                dataIndex: 'prefieldvalue',
                key: 'prefieldvalue',
                width: '25%',
                render: function (_, record) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: record.prefieldvalue } })); }
            },
            {
                title: getLabel(104, '操作'),
                dataIndex: 'operation',
                key: 'operation',
                width: '25%',
                render: function (_, record) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: 'table-operation' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { href: "javascript:void(0)", onClick: function () { return cubeLogList.showCodeAllLog(record.fieldid, record.fieldlabelname); } }, getLabel(82278, '查看该字段所有日志')))); },
            },
        ];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Table"], { ecId: (this && this.props && this.props.ecId || '') + "_Table@iyo449", columns: columns, className: "cube-log-list-table", dataSource: cubeLogList.mainLog_data, pagination: false }));
    };
    MainFieldLog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], MainFieldLog);
    return MainFieldLog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (MainFieldLog);
var MainFieldLogDialog = /** @class */ (function (_super) {
    __extends(MainFieldLogDialog, _super);
    function MainFieldLogDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainFieldLogDialog.prototype.render = function () {
        var cubeLogList = this.props.cubeLogList;
        var iconInfo = cubeLogList.iconInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@nrdwtu", onCancel: function () { return cubeLogList.mainLog_visible = false; }, title: getLabel(82274, "字段日志"), visible: cubeLogList.mainLog_visible, iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", style: { width: 800, height: 560 }, hasScroll: true }, cubeLogList.mainLog_visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainFieldLog, { ecId: (this && this.props && this.props.ecId || '') + "_MainFieldLog@jp4zp0", cubeLogList: cubeLogList })));
    };
    MainFieldLogDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], MainFieldLogDialog);
    return MainFieldLogDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailFieldLogDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var DetailFieldLog = /** @class */ (function (_super) {
    __extends(DetailFieldLog, _super);
    function DetailFieldLog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetailFieldLog.prototype.render = function () {
        var cubeLogList = this.props.cubeLogList;
        var columns = [
            { title: 'ID', dataIndex: 'id', key: 'id', width: '10%' },
            { title: getLabel(15503, '操作类型'), dataIndex: 'operateType', key: 'operateType', width: '20%' },
            {
                title: getLabel(382058, '操作描述'),
                dataIndex: 'operateDesc',
                key: 'operateDesc',
                width: '70%',
                render: function (text) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: text } });
                }
            }
        ];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Table"], { ecId: (this && this.props && this.props.ecId || '') + "_Table@3e523p", columns: columns, className: "cube-log-list-table", dataSource: cubeLogList.detailLog_data, pagination: false }));
    };
    DetailFieldLog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DetailFieldLog);
    return DetailFieldLog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (DetailFieldLog);
var DetailFieldLogDialog = /** @class */ (function (_super) {
    __extends(DetailFieldLogDialog, _super);
    function DetailFieldLogDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetailFieldLogDialog.prototype.render = function () {
        var cubeLogList = this.props.cubeLogList;
        var iconInfo = cubeLogList.iconInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@96gxh5", onCancel: function () { return cubeLogList.detailLog_visible = false; }, title: getLabel(82274, "字段日志"), visible: cubeLogList.detailLog_visible, iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", style: { width: 800, height: 560 }, hasScroll: true }, cubeLogList.detailLog_visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DetailFieldLog, { ecId: (this && this.props && this.props.ecId || '') + "_DetailFieldLog@gn0sn7", cubeLogList: cubeLogList })));
    };
    DetailFieldLogDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DetailFieldLogDialog);
    return DetailFieldLogDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreviewCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__excel_layout__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cube_map__ = __webpack_require__(235);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var PreviewCard = /** @class */ (function (_super) {
    __extends(PreviewCard, _super);
    function PreviewCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreviewCard.prototype.render = function () {
        var Card = this.props.Card;
        var iconInfo = Card.iconInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@e4h6wx" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-inline-wrapper cube-card-preview" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-inline-tab" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-layout" }, Card.isInit && [
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__excel_layout__["default"], { ecId: (this && this.props && this.props.ecId || '') + "_ExcelLayout@a3d06r@preview", Card: Card })
                    ]))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__cube_map__["MapAddressDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_MapAddressDialog@pmozuf", mapStore: Card.mapStore, iconInfo: iconInfo })));
    };
    PreviewCard = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], PreviewCard);
    return PreviewCard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





//import { getListKey } from '../../util';


var WeaTable = __WEBPACK_IMPORTED_MODULE_4_comsMobx__["WeaTableNew"].WeaTable;
var amkjzg = /** @class */ (function (_super) {
    __extends(amkjzg, _super);
    function amkjzg() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startdate = '';
        _this.hcstatus = '';
        _this.hctype = '';
        _this.branch = '';
        _this.department = '';
        _this.bgdd = '';
        _this.parseColumns = function (columns) {
            return columns.map(function (col) {
                var oldwidth = col.oldWidth || '5%';
                var widthInt = parseFloat(oldwidth.replace('%', ''));
                if (widthInt <= 0) {
                    widthInt = 5;
                }
                col.oldWidth = widthInt + "%";
                return col;
            });
        };
        _this.tableWidth = function (_) {
            var Amkjzg = _this.props.Amkjzg;
            return Amkjzg.originalTableWidth;
        };
        return _this;
    }
    // constructor(props) {
    //   super(props);
    //   const { Amkjzg } = this.props;
    //   Amkjzg.dataKey({date:""});
    // }
    amkjzg.prototype.componentDidMount = function () {
        var date = new Date();
        var seperator1 = "-";
        //var seperator2 = ":";
        //var month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1;
        //var strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
        // var currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
        // 		+ " "  + date.getHours()  + seperator2  + date.getMinutes()
        // 		+ seperator2 + date.getSeconds();
        //var currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate;
        this.startdate = date.getFullYear() + seperator1 + "01";
        var Amkjzg = this.props.Amkjzg;
        Amkjzg.getSlectOption({});
        Amkjzg.dataKey({ startdate: this.startdate });
    };
    amkjzg.prototype.render = function () {
        var _this = this;
        var Amkjzg = this.props.Amkjzg;
        //console.log(Amkjzg.hcstatusoptions);
        //console.log(Amkjzg.hctypeoptions);
        //console.log(Amkjzg.flstoptions);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaRightMenu"], { datas: [] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline" } }, "Start Date "),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaDatePicker"], { format: "yyyy-MM", value: this.startdate, onChange: function (value) { _this.startdate = value; }, needSecond: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline", paddingLeft: "10px" } }, "HC Status"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaSelect"], { style: { margin: '10px 10px', verticalAlign: 'middle', width: 120 }, options: Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(Amkjzg.hcstatusoptions), value: this.hcstatus, viewAttr: 2, onChange: function (v, showname) {
                            // this.setState({ value: v });
                            _this.hcstatus = v;
                            console.log("v", v, "showname:", showname);
                        } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline", paddingLeft: "10px" } }, "HC type"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaSelect"], { style: { margin: '10px 10px', verticalAlign: 'middle', width: 120 }, options: Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(Amkjzg.hctypeoptions), value: this.hctype, viewAttr: 2, onChange: function (v, showname) {
                            //this.setState({ value: v });
                            _this.hctype = v;
                            console.log("v", v, "showname:", showname);
                        } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline", paddingLeft: "10px" } }, "Branch"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaSelect"], { style: { margin: '10px 10px', verticalAlign: 'middle', width: 120 }, options: Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["toJS"])(Amkjzg.flstoptions), value: this.branch, viewAttr: 2, onChange: function (v, showname) {
                            //   this.setState({ value: v });
                            _this.branch = v;
                            console.log("v", v, "showname:", showname);
                        } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline", paddingLeft: "10px" } }, "Department"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline-block", verticalAlign: "middle", margin: "10px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaBrowser"], { inputStyle: { width: 150 }, type: 4, title: "\u90E8\u95E8", tabs: [
                                {
                                    isSearch: false,
                                    key: "2",
                                    name: "组织结构",
                                    selected: false,
                                    showOrder: 0
                                },
                                {
                                    dataParams: { list: "1" },
                                    isSearch: true,
                                    key: "1",
                                    name: "按列表",
                                    selected: false,
                                    showOrder: 0
                                }
                            ], onChange: function (ids, names, datas) { console.log(ids, names, datas); _this.department = ids; }, linkUrl: "/spa/hrm/engine.html#/hrmengine/organization?showTree=false&type=department&id=" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline", paddingLeft: "10px" } }, "Location"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline-block", verticalAlign: "middle", margin: "10px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaBrowser"], { inputStyle: { width: 150 }, type: 262, title: "\u529E\u516C\u5730\u70B9", linkUrl: "/spa/hrm/engine.html#/hrmengine/officeLocation?id=", onChange: function (ids, names, datas) { console.log(ids, names, datas); _this.bgdd = ids; } })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline", paddingLeft: "20px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { type: "button", style: { color: "#fff", backgroundColor: "#2db7f5", borderColor: "#2db7f5" }, class: "ant-btn", onClick: function () { Amkjzg.dataKey({ startdate: _this.startdate, hcstatus: _this.hcstatus, hctype: _this.hctype, branch: _this.branch, department: _this.department, bgdd: _this.bgdd }); } }, "Query")),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline", paddingLeft: "20px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { type: "button", style: { color: "#fff", backgroundColor: "#2db7f5", borderColor: "#2db7f5" }, class: "ant-btn", onClick: function () { Amkjzg.doExcelExpost(_this.startdate, _this.hcstatus, _this.hctype, _this.branch, _this.department, _this.bgdd); } }, "Export")),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: "inline", paddingLeft: "20px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { type: "button", style: { color: "#fff", backgroundColor: "#2db7f5", borderColor: "#2db7f5" }, class: "ant-btn", onClick: function () { window.open(Amkjzg.exp_url); } }, "Down"))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeaTable, { className: "cube-list-table", 
                    // register_table={Amkjzg.register_table}
                    comsWeaTableStore: Amkjzg.newTable, tableWidth: this.tableWidth, getColumns: this.parseColumns, needScroll: true, heightSpace: 10, 
                    //  rowKey={getListKey}
                    hasOrder: true }))));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], amkjzg.prototype, "startdate", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], amkjzg.prototype, "hcstatus", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], amkjzg.prototype, "hctype", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], amkjzg.prototype, "branch", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], amkjzg.prototype, "department", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx__["observable"]
    ], amkjzg.prototype, "bgdd", void 0);
    amkjzg = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('Amkjzg'),
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], amkjzg);
    return amkjzg;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (amkjzg);


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var ButtonGroup = __WEBPACK_IMPORTED_MODULE_3_antd__["Button"].Group;
var MindBase = /** @class */ (function (_super) {
    __extends(MindBase, _super);
    function MindBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveContracterMind = function (arr, old_parent, new_parent, selectd_node) {
            //this.editable();
            //this.initMap();
        };
        return _this;
    }
    MindBase.prototype.render = function () {
        var cubeMind = this.props.cubeMind;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "cubeMind_Container", style: { height: "100%" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { height: "0px" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaMind"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaMind@da5ts8", onCreate: cubeMind.jsmindLoading, style: { height: "0px" } })),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "btnDiv" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ButtonGroup, { ecId: (this && this.props && this.props.ecId || '') + "_ButtonGroup@fi8245", size: "large" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@qbojyn", type: "ghost", onClick: cubeMind.zoomIn },
                        "+ ",
                        getLabel(22208, '放大')),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@fqauiv", type: "ghost", onClick: cubeMind.zoomOut },
                        "- ",
                        getLabel(22209, '缩小')),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@d54mw5", type: "ghost", onClick: cubeMind.expand_all },
                        "\u25BD ",
                        getLabel(502282, '展开')),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@aux246", type: "ghost", onClick: cubeMind.collapse_all },
                        "\u25B3 ",
                        getLabel(83705, '收缩')))),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { id: "jsmind_container", style: { height: "100%" } })));
    };
    MindBase = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('cubeMind'),
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], MindBase);
    return MindBase;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (MindBase);


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_list__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__list__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_cubeUtil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reply_replySingle__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tree__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





// import { UrlDocker } from '../index';








var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var CustomPage = /** @class */ (function (_super) {
    __extends(CustomPage, _super);
    function CustomPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* 统计 在右上角显示时，将超出部分以下拉框形式显示 type:'selectedKey'时需重新计算下拉框宽度*/
        _this.showCountDataOnTopRight = function () {
            var customPageStore = _this.props.customPageStore;
            var handleShowMoreCountData = customPageStore.handleShowMoreCountData;
            var $topCountDataMore = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#custompage-top-countData-more');
            if ($topCountDataMore.length > 0) {
                setTimeout(function () {
                    // 恢复样式
                    __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.wea-new-top .cube-custompage-top-countData').attr('style', '');
                    __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.wea-new-top .cube-custompage-top-countData-more').attr('style', '');
                    __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#custompage-top-countData-list').attr('style', '');
                    $topCountDataMore.show();
                    /*  动态计算“统计项”展示的宽度  */
                    var containerWidth = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#custompage-top-countData-more').parents(".wea-new-top").width(); // top宽度
                    var containerToLeft = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#custompage-top-countData-more').parents(".wea-new-top").offset().left; // wea-new-top距左侧的距离
                    var topCountMoreToLeft = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#custompage-top-countData-more').offset().left; // custompage-top-countData-more按钮距左侧的距离
                    // 计算 top右侧的快捷搜索按钮宽度和  快捷搜索按钮宽度和 = top宽度 + wea-new-top距左侧的距离 - custompage-top-countData-more按钮距左侧的距离
                    var btnsWidth = containerWidth + containerToLeft - topCountMoreToLeft;
                    var newTopTitleWidth = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.coms-mode-viewCustomPage .wea-new-top .ant-col-14 .wea-new-top-title').width(); // top 标题 整体宽度
                    var newTopTitleBreadcrumbWidth = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.coms-mode-viewCustomPage .wea-new-top .wea-new-top-title .wea-new-top-title-breadcrumb').width(); // top 标题文字宽度
                    /**
                     * 由于ie浏览器下 span内文字长度会超过span元素的宽度，而获取到的是span的宽度，因此当span内文字过长时，依然存在与右侧“统计项”重叠的问题
                     * 因此需要增加判断，当newTopTitleBreadcrumbWidth快要超过父元素newTopTitleWidth的宽度时，就采用父元素newTopTitleWidth的宽度
                     */
                    if (!__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.browser.chrome && newTopTitleBreadcrumbWidth + 100 > newTopTitleWidth) {
                        newTopTitleBreadcrumbWidth = newTopTitleWidth;
                    }
                    // 计算top左侧标题宽度
                    var leftTitleWidth = Math.min(newTopTitleWidth, newTopTitleBreadcrumbWidth);
                    // 计算留给'统计'展示的剩余宽度  留给'统计'展示的剩余宽度 = top宽度 - top标题宽度 - 右侧快捷按钮宽度和
                    var fixedWidth = Math.min(containerWidth - leftTitleWidth, containerWidth * 0.6) - btnsWidth - 60;
                    var countDataWidthSum = 0; // 所有“统计项”总宽度
                    var topCountDataWidth = 0; // 展示在top中的“统计项”总宽度
                    var index = 0; //隐藏的'统计项'数量
                    var $topCountDataList = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.wea-new-top .cube-custompage-top-countData'); // 水平展示'统计'项
                    var $topCountDataListMore = __WEBPACK_IMPORTED_MODULE_11_jquery___default()('.wea-new-top .cube-custompage-top-countData-more'); // 下拉展示'统计'项
                    // 计算'统计'项的总宽度
                    $topCountDataListMore.each(function () {
                        countDataWidthSum += __WEBPACK_IMPORTED_MODULE_11_jquery___default()(this).width();
                    });
                    if (countDataWidthSum > fixedWidth) { // 判断是否需要显示“显示更多”按钮
                        $topCountDataMore.show(); // 需要显示“显示更多”按钮
                        __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#custompage-top-countData-more .icon-coms').css('visibility', 'visible');
                        // 当top展示的“统计项”总长度小于可展示位置的宽度，则从左至右将“统计项”显示在top中
                        while (topCountDataWidth + $topCountDataListMore.eq(index).width() + 10 < fixedWidth) {
                            topCountDataWidth += $topCountDataListMore.eq(index).width() + 10;
                            $topCountDataList.eq(index).css('display', 'inline-block');
                            $topCountDataListMore.eq(index).css('display', 'none');
                            index++;
                        }
                        // 由于ie与Chrome计算宽度的不同，ie下会出现重叠现象，因此隐藏一个统计项避免重叠
                        if (!__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.browser.chrome && index > 0) {
                            index--;
                            topCountDataWidth = topCountDataWidth - $topCountDataListMore.eq(index).width() - 10;
                            $topCountDataList.eq(index).css('display', 'none');
                            $topCountDataListMore.eq(index).css('display', 'inline-block');
                        }
                    }
                    else {
                        $topCountDataMore.hide(); // 不需要显示“显示更多”按钮
                        $topCountDataList.css('display', 'inline-block');
                        $topCountDataListMore.css('display', 'none');
                    }
                    // 调整下拉列表位置/宽度
                    __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#custompage-top-countData-list').css({ 'width': topCountDataWidth + 22, 'right': btnsWidth - 14 });
                    document.addEventListener('click', function () {
                        handleShowMoreCountData(true);
                    });
                }, 200);
            }
        };
        _this.getTabDatas = function () {
            var customPageStore = _this.props.customPageStore;
            var detailData = customPageStore.detailData;
            var buttonArr = [];
            detailData && Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(detailData).map(function (data) {
                buttonArr.push({
                    key: data.detailid,
                    title: data.hrefname
                });
            });
            return buttonArr;
        };
        _this.tabChange = function (v) {
            var customPageStore = _this.props.customPageStore;
            var query;
            if (_this.props['location'] && _this.props['location']['query']) {
                query = _this.props['location']['query'];
            }
            customPageStore.tabChange(v, query);
        };
        _this.getComContent = function () {
            var customPageStore = _this.props.customPageStore;
            var selectedKey = customPageStore.selectedKey, search = customPageStore.search, card = customPageStore.card, mainFrameSrc = customPageStore.mainFrameSrc;
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Fragment@aik058" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTab"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaTab@sldkdn", datas: _this.getTabDatas(), keyParam: "key" //主键
                    , selectedKey: selectedKey, onChange: _this.tabChange }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-custompage-container", style: { display: customPageStore.mainFrameRefVisible ? "block" : 'none' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { id: "cube-custompage-div", src: mainFrameSrc || "about:blank", width: "100%", height: "100%", frameBorder: "0", scrolling: "auto" })),
                customPageStore.isSearchShow && search.isInit &&
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-list-wrapper", style: { height: "calc( 100% - 48px)" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__list__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_List@0ech0d", Search: search, hideRightmenu: true })),
                customPageStore.isCardShow && customPageStore.card.isInit &&
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "coms-mode-docker coms-mode-card" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-card-form-content", onScroll: _this.doScrollYEvent.bind(_this) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__card__["InnerTabCard"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_InnerTabCard@r6qmnp", Card: card, Search: search, hideRightmenu: true }))),
                customPageStore.isShowReply ? (customPageStore.reply.showReply ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { paddingTop: 25 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__reply_replySingle__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_ReplySingle@7x6k20", reply: customPageStore.reply }))
                    : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaAlertPage"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaAlertPage@9r8nrk" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: '#000' } }, getLabel(387029, "请开启回复评论显示"))))
                    : "",
                customPageStore.isTreeShow &&
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__tree__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tree@8e5uqg", Tree: customPageStore.tree, Card: card, Search: search, reply: customPageStore.reply, customPageStore: customPageStore })));
        };
        _this.quickButtons = function () {
            var _a = _this.props, customPageStore = _a.customPageStore, Search = _a.Search;
            var rightMenus = customPageStore.rightMenus, rightMenuHandle = customPageStore.rightMenuHandle, showMoreCountData = customPageStore.showMoreCountData, isSearchShow = customPageStore.isSearchShow;
            var countData = Search.countData, countDisplayPosition = Search.countDisplayPosition;
            var quickRightMenus = rightMenus ? rightMenus.filter(function (d) { return d.quickButton; }) : [];
            if (quickRightMenus.length > 0) {
                quickRightMenus = _this.getNewRightmenus(quickRightMenus);
            }
            var butArrs = [];
            var arr = [], arrMore = [];
            // 自定义页面仅查询列表（即isSearchShow为true）时需要执行判断内容
            if (isSearchShow && countDisplayPosition === '2' && countData.length > 0) { //countDisplayPosition:统计-显示位置 ['0':顶部显示、'1':顶部简约显示、'2':右上角显示]
                countData.forEach(function (item, index) {
                    arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-custompage-top-countData" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: item.icon }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "cube-custompage-top-countData-title" },
                            item.name,
                            ":"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, item.countnum),
                        item.setdesc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaHelpfulTip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaHelpfulTip@cgosw3@" + index, width: "auto", style: { paddingLeft: '5px' }, title: item.setdesc })));
                    arrMore.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-custompage-top-countData-more" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: item.icon }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "cube-custompage-top-countData-title" },
                            item.name,
                            ":"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, item.countnum),
                        item.setdesc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaHelpfulTip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaHelpfulTip@uclrmr@" + index, width: "auto", style: { paddingLeft: '5px' }, title: item.setdesc })));
                });
                arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "custompage-top-countData-more", onClick: _this.countDataClick },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: showMoreCountData ? 'icon-coms icon-coms-up2' : 'icon-coms icon-coms-down2' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { id: "custompage-top-countData-list", className: showMoreCountData ? 'showMore' : '' }, arrMore)));
                butArrs.push(arr);
            }
            quickRightMenus.forEach(function (d) { return (butArrs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@29zss0@" + d.key, type: "primary", onClick: function () { rightMenuHandle(d.key); }, disabled: d.disabled || false }, d.content))); });
            return butArrs;
        };
        _this.countDataClick = function (e) {
            var customPageStore = _this.props.customPageStore;
            var showMoreCountData = customPageStore.showMoreCountData, handleShowMoreCountData = customPageStore.handleShowMoreCountData;
            e.nativeEvent.stopImmediatePropagation();
            handleShowMoreCountData(showMoreCountData);
        };
        // 处理按钮置灰
        _this.getNewRightmenus = function (rightMenus) {
            var _a = _this.props, Search = _a.Search, customPageStore = _a.customPageStore;
            var checkBtn = Search.checkBtn, displayType = Search.displayType;
            var isSearchShow = customPageStore.isSearchShow;
            if (isSearchShow) { // 仅处理列表的情况
                return rightMenus.map(function (m) {
                    var expandBtn = "expandid_" + m.key + "span";
                    if (displayType == __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].TreeType) {
                        expandBtn = "expandid_" + m.key;
                    }
                    var searchData = _this.getSearchData();
                    var btnDisable = (checkBtn == expandBtn && m.isfilter == '1' && (searchData.length < 1 || !searchData));
                    return __assign({}, m, { disabled: btnDisable });
                });
            }
            else {
                return rightMenus;
            }
        };
        _this.getSearchData = function () {
            var Search = _this.props.Search;
            var displayType = Search.displayType;
            var treeData = Search.isTreeType == '1' ? Search.newTable.selectedRowKeysAllPages : Search.selectedRowKeys; //组合查询
            var data = displayType == __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].ImgType ? Search.selectRowkeys
                : displayType == __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].TreeType ? treeData
                    : displayType == __WEBPACK_IMPORTED_MODULE_4__stores_list__["SearchDisplayType"].VerticalType ? Search.selectRowkeys
                        : Search.newTable.selectedRowKeysAllPages;
            return data;
        };
        return _this;
    }
    CustomPage.prototype.componentWillUnmount = function () {
        var customPageStore = this.props.customPageStore;
        customPageStore.clearStatus();
    };
    CustomPage.prototype.componentDidUpdate = function () {
        var _a = this.props, customPageStore = _a.customPageStore, Search = _a.Search;
        var detailData = customPageStore.detailData;
        var countDisplayPosition = Search.countDisplayPosition, countData = Search.countData;
        var array = new Array();
        var i = 0;
        __WEBPACK_IMPORTED_MODULE_11_jquery___default.a.each(__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.ant-tabs-tab-inner'), function () {
            array.push(__WEBPACK_IMPORTED_MODULE_11_jquery___default()(this));
        });
        detailData && Object(__WEBPACK_IMPORTED_MODULE_5_mobx__["toJS"])(detailData).map(function (data) {
            array[i].attr('title', data.hreftitle);
            i++;
        });
        if (countDisplayPosition === '2' && countData.length > 0) { //countDisplayPosition:统计-显示位置 ['0':顶部显示、'1':顶部简约显示、'2':右上角显示]
            this.showCountDataOnTopRight();
        }
    };
    CustomPage.prototype.doScrollYEvent = function () {
        __WEBPACK_IMPORTED_MODULE_8__util_cubeUtil__["b" /* fixedDetailHead */](); //明细表头固定
    };
    CustomPage.prototype.render = function () {
        var customPageStore = this.props.customPageStore;
        if (customPageStore.windowTitle != "") {
            document.title = customPageStore.windowTitle;
        }
        var getTitle = customPageStore.getTitle, loading = customPageStore.loading, rightMenus = customPageStore.rightMenus, rightMenuHandle = customPageStore.rightMenuHandle, iconInfo = customPageStore.iconInfo, params = customPageStore.params;
        var hidetop = params['hidetop'] && params['hidetop'] == 1;
        var newRightMenus = this.getNewRightmenus(rightMenus);
        var topAndCom = !hidetop ?
            (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTop"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTop@8la4vq", title: getTitle, loading: loading, icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: iconInfo.icon, style: { color: iconInfo.iconColor } }), iconBgcolor: iconInfo.iconBg, showDropIcon: true, dropMenuDatas: newRightMenus, onDropMenuClick: rightMenuHandle, buttons: this.quickButtons() }, this.getComContent())) : this.getComContent();
        if (customPageStore.isTreeShow) { //树 隐藏自定义页面右键菜单
            return topAndCom;
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@9b7jve", datas: newRightMenus, onClick: rightMenuHandle, collectParams: {
                    "favname": getTitle,
                    "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                    "favouritetype": 5,
                    "importantlevel": 1
                } }, topAndCom));
        }
    };
    CustomPage = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('customPageStore', 'Search'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], CustomPage);
    return CustomPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CustomPage);


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;

var BarCodeViewer = /** @class */ (function (_super) {
    __extends(BarCodeViewer, _super);
    function BarCodeViewer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRightMenus = function () {
            var btns = [];
            btns.push({
                icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-Print ' }),
                content: getLabel(257, "打印"),
                key: '1',
                onClick: function (key) { return setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_3__util__["default"].print();
                }, 100); }
            });
            return btns;
        };
        return _this;
    }
    BarCodeViewer.prototype.componentWillUnmount = function () {
        var CodeStore = this.props.CodeStore;
        CodeStore.clearState();
    };
    BarCodeViewer.prototype.render = function () {
        var _this = this;
        var container = document.querySelector("body") || "";
        if (container) {
            container.className = "printBody"; //打印时需要body具有"printBody"属性
        }
        var CodeStore = this.props.CodeStore;
        if (CodeStore.windowTitle != '') {
            document.title = CodeStore.windowTitle;
        }
        var gridStyle = { width: 100 / (CodeStore.cols == 0 ? 1 : CodeStore.cols) + " % " };
        var htmls = [];
        CodeStore.html.map(function (h, index) {
            var mindex = index % (CodeStore.cols == 0 ? 1 : CodeStore.cols);
            var tindex = (index - mindex) / (CodeStore.cols == 0 ? 1 : CodeStore.cols);
            if (mindex == 0) {
                htmls.push({ html: [] });
            }
            htmls[tindex].html.push(h);
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@ukq2kk", datas: this.getRightMenus(), collectParams: {
                "favname": "",
                "link": '/' + __WEBPACK_IMPORTED_MODULE_3__util__["default"].location.toString().split('/').slice(3).join('/'),
                "favouritetype": 5,
                "importantlevel": 1
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "coms-mode-code-view-body" }, htmls.map(function (html, index) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Fragment@8w5hil@" + index },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: index % (CodeStore.rows == 0 ? 1 : CodeStore.rows) == ((CodeStore.rows == 0 ? 1 : CodeStore.rows) - 1) ?
                            "coms-mode-code-view  coms-mode-code-view-with-page-break" : "coms-mode-code-view", style: { textAlign: CodeStore.postion == "left" ? "left" : CodeStore.postion == "right" ? "right" : "center", marginLeft: CodeStore.CodeRight, marginRight: CodeStore.CodeLeft } }, html.html.map(function (h) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: gridStyle, className: "coms-mode-code-view-container" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginRight: CodeStore.levelspacing + "cm", marginBottom: CodeStore.verticalspacing + "cm" }, dangerouslySetInnerHTML: { __html: h } })));
                    }))));
            }))));
    };
    BarCodeViewer = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], BarCodeViewer);
    return BarCodeViewer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (BarCodeViewer);


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(420); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var callBound = __webpack_require__(421);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(423);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(236);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(108);
var callBind = __webpack_require__(237);

var implementation = __webpack_require__(424);
var getPolyfill = __webpack_require__(425);
var shim = __webpack_require__(1092);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(425);
var define = __webpack_require__(108);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(421);
var hasSymbols = __webpack_require__(423)();
var hasToStringTag = hasSymbols && !!Symbol.toStringTag;
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(108);
var callBind = __webpack_require__(237);

var implementation = __webpack_require__(426);
var getPolyfill = __webpack_require__(427);
var shim = __webpack_require__(1095);

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(108).supportsDescriptors;
var getPolyfill = __webpack_require__(427);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewResourceContainer__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewResourceContainerMobile__ = __webpack_require__(1108);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var ViewResouce = /** @class */ (function (_super) {
    __extends(ViewResouce, _super);
    function ViewResouce() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.judgeUrlContainByWhat = function (bywhat) {
            if (!bywhat)
                bywhat = 0;
            var cubeViewResource = _this.props.cubeViewResource;
            cubeViewResource.resourceParams.bywhat = Number(bywhat);
            cubeViewResource.hasUrlByWhat = true;
        };
        return _this;
    }
    ViewResouce.prototype.componentDidMount = function () {
        var bywhat = this.props["location"].query.bywhat;
        this.judgeUrlContainByWhat(bywhat);
    };
    ViewResouce.prototype.componentWillReceiveProps = function (n, s) {
        var bywhat_record = this.props["location"].query.bywhat;
        var bywhat = n["location"].query.bywhat;
        if (bywhat || bywhat_record) {
            if (bywhat !== bywhat_record) {
                this.judgeUrlContainByWhat(bywhat);
            }
        }
    };
    ViewResouce.prototype.getUrlKey = function (name) {
        var reg = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href);
        if (reg && reg != undefined) {
            return decodeURIComponent((reg || [, ""])[1].replace(/\+/g, '%20')) || null;
        }
    };
    ViewResouce.prototype.render = function () {
        var _a = this.props, cubeViewResource = _a.cubeViewResource, Search = _a.Search;
        var location = this.props['location'];
        if (location && location.query) {
            if (location.query.sqlwhere) {
                cubeViewResource.sqlwhere = location.query.sqlwhere;
            }
            else {
                cubeViewResource.sqlwhere = "";
            }
        }
        if (this.getUrlKey('ismobile') == '1') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ViewResourceContainerMobile__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ViewResourceContainerMobile@fcvij1", cubeViewResource: cubeViewResource, Search: Search });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ViewResourceContainer__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ViewResourceContainer@ji4wvf", cubeViewResource: cubeViewResource, Search: Search });
        }
    };
    ViewResouce = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('cubeViewResource', "Search"),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ViewResouce);
    return ViewResouce;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ViewResouce);


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_list__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__apis_resource__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_card__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ViewResourceSearch__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ResourceDateSwitch__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ResourceDateSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ResourceDateSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ResourceHideListWrap__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_list_utils__ = __webpack_require__(71);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};















var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
if (__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 7 || __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 9) {
    __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('zh-cn');
}
else {
    __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('en');
}
var ViewResouceContainer = /** @class */ (function (_super) {
    __extends(ViewResouceContainer, _super);
    function ViewResouceContainer(props) {
        var _this = _super.call(this, props) || this;
        /*判断拖拽中的每个块是否激活*/
        _this.checkDragActive = function (itemProps, dragState) {
            var room = itemProps.room, itemPosition = itemProps.itemPosition, _a = dragState.startProps, startProps = _a === void 0 ? {} : _a, startRoom = startProps.room || {};
            if (startRoom.id && room.id == startRoom.id) {
                var minRow = dragState.minRow, minColumn = dragState.minColumn, maxRow = dragState.maxRow, maxColumn = dragState.maxColumn;
                return itemPosition[0] >= minRow && itemPosition[0] <= maxRow && itemPosition[1] >= minColumn && itemPosition[1] <= maxColumn;
            }
            return false;
        };
        _this.createHeight = function () {
            var _a = _this.props, cubeViewResource = _a.cubeViewResource, Search = _a.Search;
            var panelHeightRatio = cubeViewResource.panelHeightRatio, isHideSearch = cubeViewResource.isHideSearch, isShowMore = cubeViewResource.isShowMore, handleValueChange = cubeViewResource.handleValueChange;
            // 处理高度自适应问题
            var container = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container', __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this)), conHeight = _this.props.height ? (_this.props.height - 108) : container.height();
            var listHeight;
            var tab = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-plan-tab', container), tabHeight = tab.height() + 18; // 资源面板内部table高度 + 收缩列表图标高度
            var maxTabHeight = (panelHeightRatio / 100) * __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.coms-mode-viewResource').height() - 108;
            if (cubeViewResource.showMoreVisible) {
                tabHeight = tabHeight + 36;
            }
            if (tabHeight >= maxTabHeight) {
                listHeight = conHeight - maxTabHeight;
                tabHeight = maxTabHeight;
            }
            else {
                listHeight = conHeight - tabHeight;
            }
            // 处理隐藏列表的情况
            if (isHideSearch && tabHeight > 0 && __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container>.align-center').length == 0) {
                // 列表隐藏，资源面板高度 = 页面容器高度
                tabHeight = conHeight;
                // const noDataHeight = jQuery('.resource-container .resource-list-placeholder')[0]?jQuery('.resource-container .resource-list-placeholder')[0].offsetHeight:0;
                var tabContainerHeight = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .tab-container').height();
                // 资源面板需增加的高度 = 页面容器高度 - 收缩列表图标高度 - “显示更多”按钮高度 - 现在资源面包窗口高度
                var addHeight = tabHeight - 18 - _this.hasMoreBtn() - tabContainerHeight;
                // addHeight>=0 &&this.expandResourceHeigh('add', (addHeight!=0||addHeight<listHeight)?listHeight:addHeight);
                // 如果需要增加的高度大于0，调用expandResourceHeight方法调整资源面板高度
                addHeight >= 0 && _this.expandResourceHeigh('add', addHeight);
            }
            if (isShowMore) {
                _this.expandResourceHeigh('reset', 0);
                Object(__WEBPACK_IMPORTED_MODULE_14__components_list_utils__["e" /* getHeight */])(Search);
                // 显示更多可能会触发资源面板窗口扩大，为避免列表出现双滚动条，需要同步调整列表高度
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()(".list-container>div[id^='cube_search']>.ant-spin-nested-loading>.ant-spin-container>div").height(listHeight);
                handleValueChange('isShowMore', false);
            }
            cubeViewResource.updateHeight(conHeight, tabHeight, listHeight);
        };
        /** 当收缩查询列表，资源面板高度需要相应展开
         * type: 'add':加  'minus':减
        */
        _this.expandResourceHeigh = function (type, listHeight) {
            var noDataHeight = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .resource-list-placeholder')[0] ? __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .resource-list-placeholder')[0].offsetHeight : 0;
            // 资源面板-展示高度
            var tabContainerHeight = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .tab-container').height();
            // 资源面板-实际高度
            var tableHeight = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .resource-plan-tab').height();
            var tableTrArr = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .tab-container .resource-plan-tab>tbody>tr');
            if (type === 'add') {
                var newTabHeight = tabContainerHeight + listHeight - noDataHeight;
                if (newTabHeight < tableHeight || tableTrArr.length == 0) {
                    __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .tab-container').height(newTabHeight);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .tab-container').height(newTabHeight);
                    var expandHeightValue = Math.floor((newTabHeight - tableHeight) / tableTrArr.length);
                    for (var i = 0; i < tableTrArr.length; i++) {
                        var _tr = tableTrArr.eq(i);
                        var tr_height = _tr.height();
                        _tr.height(tr_height + expandHeightValue);
                    }
                }
            }
            else if (type === 'minus') {
                var newTabHeight = tabContainerHeight - listHeight;
                if (newTabHeight > tableHeight || tableTrArr.length == 0) {
                    __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .tab-container').height(newTabHeight);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-container .tab-container').height(newTabHeight);
                    var expandHeightValue = Math.ceil(listHeight / tableTrArr.length);
                    for (var i = 0; i < tableTrArr.length; i++) {
                        var _tr = tableTrArr.eq(i);
                        var tr_height = _tr.height();
                        _tr.height(tr_height - expandHeightValue);
                    }
                }
            }
            else if (type === 'restore') { // 点击显示更多后，重新计算行高前先恢复原高度
                var newTabHeight = tabContainerHeight - listHeight - noDataHeight;
                if (newTabHeight > tableHeight || tableTrArr.length == 0) {
                }
                else {
                    var expandHeightValue = Math.floor((newTabHeight - tableHeight) / tableTrArr.length);
                    for (var i = 0; i < tableTrArr.length; i++) {
                        var _tr = tableTrArr.eq(i);
                        var tr_height = _tr.height();
                        _tr.height(tr_height + expandHeightValue);
                    }
                }
            }
            else if (type === 'reset') { // 当DOM树中更新资源面板后，需重新计算高度
                var newTabHeight = tabContainerHeight - listHeight - noDataHeight;
                if (newTabHeight < tableHeight || tableTrArr.length == 0) {
                }
                else {
                    var expandHeightValue = Math.floor((newTabHeight - tableHeight) / tableTrArr.length);
                    for (var i = 0; i < tableTrArr.length; i++) {
                        var _tr = tableTrArr.eq(i);
                        var tr_height = _tr.height();
                        _tr.height(tr_height + expandHeightValue);
                    }
                }
            }
        };
        _this.handleSearchHide = function (bool) {
            var _a = _this.props, Search = _a.Search, cubeViewResource = _a.cubeViewResource;
            var handleValueChange = cubeViewResource.handleValueChange;
            Object(__WEBPACK_IMPORTED_MODULE_14__components_list_utils__["e" /* getHeight */])(Search);
            var listContainerHeight = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-hide-list-wrap .list-container').height();
            if (bool) {
                if (listContainerHeight) {
                    handleValueChange('isHideSearch', bool);
                    handleValueChange('listContainerHeight', listContainerHeight);
                    _this.expandResourceHeigh('add', listContainerHeight);
                }
            }
            else {
                var listContainerHeight_1 = cubeViewResource.listContainerHeight;
                handleValueChange('isHideSearch', bool);
                if (listContainerHeight_1) {
                    _this.expandResourceHeigh('minus', listContainerHeight_1);
                }
            }
        };
        _this.doRightMenuAction = function (key) {
            var cubeViewResource = _this.props.cubeViewResource;
            if (key == 'add') {
                cubeViewResource.onAdd();
                return;
            }
            // 时分秒加上，会导致从周/月视图跳转到日视图时，日期带入的格式问题，导致日期字段保存失败
            // const d = new Date();
            // cubeViewResource.currentdate = cubeViewResource.currentdate.split(' ')[0] + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
            cubeViewResource.currentdate = cubeViewResource.currentdate.split(' ')[0];
            cubeViewResource.timeType = key;
            _this.onChangeWeaDateSwitch(key, cubeViewResource.currentdate, null);
        };
        /*周月日组件切换回调 */
        /**
         * 说明：若日,传点前的日期，且给值movedate，若年或月则传点击后的日期，且movedate不给值
         */
        _this.onChangeWeaDateSwitch = function (type, date, range) {
            var cubeViewResource = _this.props.cubeViewResource;
            var timeType = cubeViewResource.timeType;
            type != timeType && cubeViewResource.updateTimeType(type);
            cubeViewResource.resourceId = '';
            var movedate = '';
            var bywhat = '4';
            if (typeof date != 'string' && date._d && date._i) {
                if (typeof date._d == 'string') {
                    date._d = new Date(date._d);
                }
                if (typeof date._i == 'string') {
                    date._i = new Date(date._i);
                }
                if (date._d.getTime() != date._i.getTime() && type == 'day') { //说明点击箭头切换日期
                    if (date._d.getTime() < date._i.getTime()) {
                        movedate = '-1';
                    }
                    else {
                        movedate = '1';
                    }
                }
            }
            switch (type) {
                case 'year':
                    bywhat = '1';
                    break;
                case 'month':
                    bywhat = '2';
                    break;
                case 'week':
                    bywhat = '3';
                    break;
                case 'day':
                    bywhat = '4';
                    break;
            }
            var currentdate;
            if (typeof date == 'string') {
                currentdate = date;
            }
            else if (typeof date._i == 'string') {
                currentdate = bywhat == '4' ? date._i : date._d;
            }
            else {
                var rightdate = void 0;
                if (date._i && date._d) {
                    rightdate = bywhat == '4' ? date._i : date._d;
                }
                else {
                    rightdate = date;
                }
                var m = rightdate.getMonth() + 1 + '';
                var d = rightdate.getDate() + '';
                if (m.length == 1)
                    m = '0' + m;
                if (d.length == 1)
                    d = '0' + d;
                currentdate = rightdate.getFullYear() + '-' + m + '-' + d;
            }
            _this.setState({ date: date });
            cubeViewResource.query({ bywhat: bywhat, movedate: movedate, currentdate: currentdate });
        };
        _this.getTableHeaderInfo = function (timeType, date, startHour, endHour) {
            var blockNum = 0, tableTitle = '', tableHeaders = [];
            if (__WEBPACK_IMPORTED_MODULE_3_moment___default.a.isMoment(date))
                date = new Date(date.format('L'));
            var curmoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date);
            if (timeType == 'day') {
                blockNum = endHour - startHour + 1;
                tableTitle = curmoment.format("M" + getLabel(383373, '月') + "D" + getLabel(383374, '日').replace('-', '') + "(ddd)" + getLabel(33425, '单位') + ":") + getLabel(383376, '时');
                tableTitle = _this.modifyWeekName(tableTitle);
                for (startHour; startHour <= endHour; startHour++)
                    tableHeaders.push(startHour);
            }
            else if (timeType == 'week') {
                var cubeViewResource = _this.props.cubeViewResource;
                var weekstart = cubeViewResource.weekstart;
                blockNum = 7;
                if (weekstart === '3') { // weekstart=3, 即取今天开始的七天
                    var start = curmoment.day();
                    var endmoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date);
                    var end = endmoment.day(start + 6);
                    var startDate = curmoment.format("YYYY" + getLabel(383372, '年') + "MM" + getLabel(383373, '月') + "DD" + getLabel(383374, '日').replace('-', ''));
                    var endDate = end.format((end.format('YYYY') === curmoment.format('YYYY') ? '' : "YYYY" + getLabel(383372, "年")) + "MM" + getLabel(383373, '月') + "DD" + getLabel(383374, '日').replace('-', ''));
                    tableTitle = startDate + '~' + endDate;
                    for (var i = start; i < (start + 7); i++) {
                        var _curmoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date);
                        var titleTemp = _curmoment.day(i).format("MM" + getLabel(383373, '月') + "DD" + getLabel(383374, '日').replace('-', '') + "(ddd)");
                        titleTemp = _this.modifyWeekName(titleTemp);
                        tableHeaders.push(titleTemp);
                    }
                }
                else {
                    var start = weekstart == '2' ? 1 : 0;
                    tableTitle = curmoment.format("YYYY" + getLabel(383372, '年') + "ww") + getLabel(383377, '周');
                    for (var i = start; i < (start + 7); i++) {
                        var titleTemp = curmoment.day(i).format("MM" + getLabel(383373, '月') + "DD" + getLabel(383374, '日').replace('-', '') + "(ddd)");
                        titleTemp = _this.modifyWeekName(titleTemp);
                        tableHeaders.push(titleTemp);
                    }
                }
            }
            else {
                blockNum = curmoment.daysInMonth();
                tableTitle = curmoment.format("YYYY" + getLabel(383372, '年') + "MM" + getLabel(383373, '月').replace('-', '')) + ("(" + blockNum + getLabel(383378, '天') + ")");
                for (var i = 1; i <= blockNum; i++)
                    tableHeaders.push(i);
            }
            return { blockNum: blockNum, tableTitle: tableTitle, tableHeaders: tableHeaders };
        };
        /*周显示多语言修正 ，moment打包后中文失效*/
        _this.modifyWeekName = function (name) {
            try {
                if (__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 7 || __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 9) {
                    name = name.replace("Sun", "周日");
                    name = name.replace("Mon", "周一");
                    name = name.replace("Tue", "周二");
                    name = name.replace("Wed", "周三");
                    name = name.replace("Thu", "周四");
                    name = name.replace("Fri", "周五");
                    name = name.replace("Sat", "周六");
                }
            }
            catch (Exception) {
            }
            return name;
        };
        /*创建面板使用情况的每一行得td*/
        _this.createTdList = function (resource, blockNum, rowNum) {
            var cubeViewResource = _this.props.cubeViewResource;
            var timeType = cubeViewResource.timeType, duration = cubeViewResource.duration, useMap = cubeViewResource.useMap, weekstart = cubeViewResource.weekstart, resourceParams = cubeViewResource.resourceParams;
            var tdList = [];
            var useArray = useMap[resource.id];
            // 创建冲突的、带有提示的单元格
            var createTooltipTd = function (obj, otherProps, width) {
                if (otherProps === void 0) { otherProps = {}; }
                var content = obj.content, bgcolor = obj.bgcolor, fontcolor = obj.fontcolor, title = obj.title, tipsinfo = obj.tipsinfo;
                var style = { backgroundColor: bgcolor || '#AFDC9E', color: fontcolor || '#000', textAlign: 'center' };
                var td = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Tooltip"], { ecId: (this && this.props && this.props.ecId || '') + "_Tooltip@bd44dc", title: createTitle(Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["toJS"])(tipsinfo), Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["toJS"])(title)), placement: "bottomRight" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({ style: width && { width: width } }, { conflict: true }, otherProps),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: __assign({}, style, { width: '100%', height: '100%' }) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-modal" }),
                            content > 1 && content))));
                return td;
            };
            if (timeType == 'week' || timeType == 'month') {
                for (var i = 0; i < blockNum; i++) {
                    tdList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-modal " })));
                }
                if (!useArray || useArray.length == 0) {
                    return tdList;
                }
                useArray.forEach(function (obj) {
                    var objDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(obj.date);
                    var tdIdx = timeType == 'week' ? objDate.day() : objDate.date() - 1;
                    if (timeType == 'week' && weekstart == '2') { //周一为开始
                        tdIdx = tdIdx == 0 ? 6 : tdIdx - 1;
                    }
                    else if (timeType == 'week' && weekstart == '3') { // 当前日开始七天
                        tdIdx = tdIdx - (resourceParams['currentdate'] ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(resourceParams['currentdate']).day() : 0);
                        if (tdIdx < 0)
                            tdIdx += 7;
                    }
                    if (tdIdx < 0 || tdIdx >= blockNum)
                        return;
                    if (timeType == 'month') { //不是当前月的数据过滤掉，避免覆盖数据
                        var date = _this.state.date;
                        if (__WEBPACK_IMPORTED_MODULE_3_moment___default.a.isMoment(date))
                            date = new Date(date.format('L'));
                        var curmoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date);
                        if (curmoment.year() != objDate.year() || curmoment.month() != objDate.month())
                            return;
                    }
                    tdList[tdIdx] = createTooltipTd(obj);
                });
                return tdList;
            }
            else {
                return _this.createTdListInDay(duration, useArray, resource, createTooltipTd, rowNum, tdList);
            }
        };
        /**
         * 暂只针对 周
         * 创建面板使用情况的每一行得td -- 详细信息
         **/
        _this.createDetailTdList = function (resource, blockNum, rowNum) {
            var cubeViewResource = _this.props.cubeViewResource;
            var timeType = cubeViewResource.timeType, duration = cubeViewResource.duration, useMap = cubeViewResource.useMap, weekstart = cubeViewResource.weekstart, resourceParams = cubeViewResource.resourceParams, onWeekChoose = cubeViewResource.onWeekChoose;
            var tdList = [];
            var useArray = useMap[resource.id];
            // 创建冲突的、带有提示的单元格
            var createTooltipTd = function (obj, otherProps, width) {
                if (otherProps === void 0) { otherProps = {}; }
                var tdContent = obj.tdContent /*, bgcolor, fontcolor*/, title = obj.title, tipsinfo = obj.tipsinfo;
                // let style: any = { backgroundColor: bgcolor || '#AFDC9E', color: fontcolor || '#000', textAlign: 'center' };
                var td = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Tooltip"], { ecId: (this && this.props && this.props.ecId || '') + "_Tooltip@bd44dc", title: createTitle(Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["toJS"])(tipsinfo), Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["toJS"])(title)), placement: "bottomRight" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({ style: width && { width: width } }, { conflict: true }, otherProps),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { /*...style,*/ width: '100%', height: '100%', position: 'relative' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-modal" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-div" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "resource-td-add", onClick: function () { return onWeekChoose(otherProps); } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Icon"], { type: "plus" }))),
                            tdContent && tdContent.length > 0 && tdContent.map(function (item) {
                                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { paddingLeft: 3 }, dangerouslySetInnerHTML: { __html: item.resourcedetailsshow } })));
                            })))));
                return td;
            };
            if (timeType == 'week' || timeType == 'month') {
                var _otherProps_1 = [];
                var index = weekstart === '3' ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(resourceParams['currentdate']).day() : (weekstart === '1' ? 0 : 1);
                var _loop_1 = function (i, len) {
                    var _date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(resourceParams['currentdate']).day(i).format("YYYY-MM-DD");
                    _otherProps_1.push({
                        itemPosition: [rowNum, i],
                        room: resource,
                        date: _date
                    });
                    tdList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({}, { itemPosition: [rowNum, i], room: resource, date: _date }, { onClick: function () { return onWeekChoose({ room: resource, date: _date }); } }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-modal " }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-div resource-td-blank", style: { right: "calc(50% - 12px)" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "resource-td-add" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Icon"], { type: "plus" })))));
                };
                for (var i = index, len = index + blockNum; i < len; i++) {
                    _loop_1(i, len);
                }
                if (!useArray || useArray.length == 0) {
                    return tdList;
                }
                useArray.forEach(function (obj) {
                    var objDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(obj.date);
                    var tdIdx = timeType == 'week' ? objDate.day() : objDate.date() - 1;
                    if (timeType == 'week' && weekstart == '3') { // weekstart=3, 即取今天开始的七天
                        tdIdx = tdIdx - (resourceParams['currentdate'] ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(resourceParams['currentdate']).day() : 0);
                        if (tdIdx < 0)
                            tdIdx += 7;
                    }
                    else if (timeType == 'week' && weekstart == '2') { //周一为开始
                        tdIdx = tdIdx == 0 ? 6 : tdIdx - 1;
                    }
                    if (tdIdx < 0 || tdIdx >= blockNum)
                        return;
                    if (timeType == 'month') { //不是当前月的数据过滤掉，避免覆盖数据
                        var date = _this.state.date;
                        if (__WEBPACK_IMPORTED_MODULE_3_moment___default.a.isMoment(date))
                            date = new Date(date.format('L'));
                        var curmoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date);
                        if (curmoment.year() != objDate.year() || curmoment.month() != objDate.month())
                            return;
                    }
                    tdList[tdIdx] = createTooltipTd(obj, _otherProps_1[tdIdx]);
                });
                return tdList;
            }
            else {
                return _this.createTdListInDay(duration, useArray, resource, createTooltipTd, rowNum, tdList);
            }
        };
        /** 判断是否会显示“显示更多”按钮，如果显示则需在计算中减去高度36px */
        _this.hasMoreBtn = function () {
            var cubeViewResource = _this.props.cubeViewResource;
            var loading = cubeViewResource.loading, resourcesList = cubeViewResource.resourcesList;
            var showMoreBtn = !loading && (resourcesList && resourcesList.length > 0) && cubeViewResource.showMoreVisible;
            if (showMoreBtn) { // 显示“显示更多”按钮
                return 36;
            }
            else { // 不显示“显示更多”按钮
                return 0;
            }
        };
        _this.calculateColorType = function () {
            var cubeViewResource = _this.props.cubeViewResource;
            var showMoreColorType = cubeViewResource.showMoreColorType;
            var colorType = Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["toJS"])(cubeViewResource.colorType);
            var max_ResourcePlanTopWidth = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.resource-plan-top').width() - 580;
            var colorType_length = colorType.length;
            var colorType_Width = colorType_length * 70;
            var colorType_menu = [];
            var div_width = colorType_Width;
            var isShowMore = false;
            var colorTypeList = [];
            while (colorType_length > 0) {
                if (colorType_Width < max_ResourcePlanTopWidth) {
                    colorTypeList = colorType.map(function (item) { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: item } }); });
                    div_width = colorType.length * 70;
                    break;
                }
                else {
                    colorType_menu.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: colorType.pop() } }));
                    colorType_Width -= 70;
                    colorType_length--;
                    isShowMore = true;
                    if (colorType_length == 0) {
                        div_width = 0;
                        break;
                    }
                }
            }
            if (isShowMore) {
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()('#top-colorType-more .icon-coms').css('visibility', 'visible');
            }
            else {
                __WEBPACK_IMPORTED_MODULE_9_jquery___default()('#top-colorType-more .icon-coms').css('visibility', 'hidden');
            }
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-top-colorType", style: { width: div_width + 50 } },
                colorTypeList,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "top-colorType-more", onClick: _this.handleColorTypeClick },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: showMoreColorType ? 'icon-coms icon-coms-up2' : 'icon-coms icon-coms-down2' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { id: "top-colorType-list", className: showMoreColorType ? 'showMore' : '' }, colorType_menu))));
        };
        _this.handleColorTypeClick = function (e) {
            var cubeViewResource = _this.props.cubeViewResource;
            var handleValueChange = cubeViewResource.handleValueChange, showMoreColorType = cubeViewResource.showMoreColorType;
            e.nativeEvent.stopImmediatePropagation();
            e.stopPropagation();
            handleValueChange('showMoreColorType', showMoreColorType, true);
        };
        _this.getTitleHTML = function (title, imgs, index) {
            var tipArr = [];
            tipArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                imgs && imgs.length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Carousel"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Carousel@x6ae07@" + index, className: "resource-carousel" }, imgs instanceof Array && imgs.map(function (res) { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: res } }); }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: title } })));
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { width: 210 } }, tipArr);
        };
        _this.state = {
            date: new Date(),
            foucsInput: false,
        };
        Object(__WEBPACK_IMPORTED_MODULE_8__apis_resource__["a" /* getCurrentDate */])({}).then(function (_a) {
            var currentDate = _a.currentDate;
            _this.setState({ date: currentDate });
        });
        return _this;
    }
    ViewResouceContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.createHeight();
        var _a = this.props, cubeViewResource = _a.cubeViewResource, Search = _a.Search;
        setTimeout(function () {
            if (cubeViewResource.windowTitle != '') {
                document.title = cubeViewResource.windowTitle;
            }
        }, 500);
        Search.isInnerTab = true;
        Search.changeIsFromViewResource();
        document.addEventListener('click', function () {
            cubeViewResource.handleValueChange('showMoreColorType', true, true);
        });
    };
    ViewResouceContainer.prototype.componentWillReceiveProps = function () {
        var cubeViewResource = this.props.cubeViewResource;
        this.setState({ date: cubeViewResource.currentdate });
        cubeViewResource.timeType = 'day';
    };
    /*创建时间类型为天时的单元格*/
    ViewResouceContainer.prototype.createTdListInDay = function (duration, useArray, room, createTooltipTd, rowNum, tdList) {
        var cubeViewResource = this.props.cubeViewResource;
        var startHour = cubeViewResource.startHour, endHour = cubeViewResource.endHour, dspunit = cubeViewResource.dspunit;
        var useBlockMap = {}; //已被使用的块，数据结构：小时数:{变色的序号：{背景颜色，字体颜色，内容}，...}
        // let subNum = 1;//每小时会被分成几段
        // 生成已被占用的时间段
        useArray && useArray.forEach(function (obj) {
            // 时间处理，确认序号
            if (!obj.time)
                return;
            var time = obj.time.split(':');
            if (time.length != 2)
                return;
            var hour = parseInt(time[0]), minute = parseInt(time[1]);
            var idx = duration > 0 ? Math.floor(minute / duration) : 0;
            // 找到该数据对应的存储位置。
            if (!useBlockMap[hour])
                useBlockMap[hour] = {};
            var useHour = useBlockMap[hour];
            useHour[idx] = obj;
        });
        var width = (100 / dspunit) + "%";
        /*创建每小时内的分隔块、即第二层td的方法*/
        var createSubTd = function (hour, idx, rowNum, colNum) {
            var startMinute = idx * duration, endMinute = startMinute + duration - 1;
            var startTime = (hour > 9 ? hour : '0' + hour) + ':' + (startMinute > 9 ? startMinute : '0' + startMinute), endTime = (hour > 9 ? hour : '0' + hour) + ':' + (endMinute > 9 ? endMinute : '0' + endMinute);
            // 有值则说明已被占用
            if (useBlockMap[hour] && useBlockMap[hour][idx]) {
                return createTooltipTd(useBlockMap[hour][idx], {
                    itemPosition: [rowNum, colNum],
                    startTime: startTime,
                    endTime: endTime,
                    room: room
                }, width);
            }
            // 空时段
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({ style: { width: width } }, { itemPosition: [rowNum, colNum] }, { startTime: startTime, endTime: endTime, room: room }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-modal" })));
        };
        // 生成第一层td列表
        var colNum = 0;
        for (startHour; startHour <= endHour; startHour++) {
            var subTdList = [];
            for (var i = 0; i < dspunit; i++) {
                subTdList.push(createSubTd(startHour, i, rowNum, colNum));
                colNum++;
            }
            var td = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "resource-subTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, subTdList))));
            tdList.push(td);
        }
        return tdList;
    };
    ViewResouceContainer.prototype.render = function () {
        var _this = this;
        var _a = this.props, Search = _a.Search, cubeViewResource = _a.cubeViewResource;
        var loading = cubeViewResource.loading, resourcesList = cubeViewResource.resourcesList, timeType = cubeViewResource.timeType, card = cubeViewResource.card, createUrl = cubeViewResource.createUrl, weekstart = cubeViewResource.weekstart, opendetailshow = cubeViewResource.opendetailshow, isHideSearch = cubeViewResource.isHideSearch;
        var resourceId = cubeViewResource.resourceId;
        // 列表中使用的数据
        var date = this.state.date;
        var startHour = cubeViewResource.startHour, endHour = cubeViewResource.endHour;
        var _b = this.getTableHeaderInfo(timeType, date, startHour, endHour), blockNum = _b.blockNum, tableTitle = _b.tableTitle, tableHeaders = _b.tableHeaders;
        var tableContent = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "resource-plan-tab" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, !loading && (resourcesList && resourcesList.length > 0) &&
                resourcesList.map(function (resource, index) {
                    var tdList = (timeType === 'week' && opendetailshow === 1) ? _this.createDetailTdList(resource, blockNum, index) : _this.createTdList(resource, blockNum, index);
                    var tdClass = resourceId == resource.id ? 'resource-name cur' : 'resource-name';
                    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { className: index == 0 ? 'no-border-top' : '' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Tooltip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tooltip@gxaa9r@" + index, placement: "right", title: _this.getTitleHTML(resource.title, resource.imgs, index) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { onClick: function () {
                                    isHideSearch && _this.handleSearchHide(false);
                                    if (resourceId == '') {
                                        cubeViewResource.resourceId = resource.id;
                                        cubeViewResource.search(__assign({}, cubeViewResource.searchParam, { datasqlwhere: cubeViewResource.searchParam.datasqlwhere + ' and t1.' + cubeViewResource.resourceFieldName + '=\'' + resource.id + '\'' }));
                                    }
                                    else {
                                        if (resourceId == resource.id) {
                                            cubeViewResource.resourceId = '';
                                            cubeViewResource.search(cubeViewResource.searchParam);
                                        }
                                        else {
                                            cubeViewResource.resourceId = resource.id;
                                            cubeViewResource.search(__assign({}, cubeViewResource.searchParam, { datasqlwhere: cubeViewResource.searchParam.datasqlwhere + ' and t1.' + cubeViewResource.resourceFieldName + '=\'' + resource.id + '\'' }));
                                        }
                                    }
                                }, className: tdClass }, resource.name)),
                        tdList));
                }))));
        // 高度控制
        var _c = this.props.cubeViewResource, tabHeight = _c.tabHeight, spinisload = _c.spinisload;
        var tabHeightValue = tabHeight - this.hasMoreBtn() - 18; // 减去 “显示更多”和“收缩列表”按钮高度
        var spinisloadvalue = spinisload;
        var listHeightValue = 360;
        var viewResourceContainerHeight = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.coms-mode-viewResource').eq(0).height();
        if (viewResourceContainerHeight) {
            var showMoreBtn = !loading && (resourcesList && resourcesList.length > 0) && cubeViewResource.showMoreVisible;
            var isNoData = !loading && (resourcesList && resourcesList.length == 0);
            // containerHeight - padding-top - 资源面板高度 - “显示更多”按钮高度 - “暂无数据”的高度 - "收缩列表"按钮
            listHeightValue = __WEBPACK_IMPORTED_MODULE_9_jquery___default()('.coms-mode-viewResource').eq(0).height() - 108 - (tabHeightValue > 130 ? tabHeightValue : 130) - (showMoreBtn ? 36 : 0) - (isNoData ? 52 : 0) - 18;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function () { return Search.showSlideModal(false, "", ""); }, className: "wea-cube-resource-con f12", style: { height: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-plan-top" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-plan-top-con line" },
                    createUrl &&
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@pdz1i3", onClick: function () { cubeViewResource.onAdd(); }, style: { marginRight: 10 } }, getLabel(82, '新建')),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ResourceDateSwitch___default.a, { ecId: (this && this.props && this.props.ecId || '') + "_WeaDateSwitch@ob1xrk", currentType: cubeViewResource.timeType, onChange: this.onChangeWeaDateSwitch, currentDay: this.state.date, weekFirstDay: cubeViewResource.weekstart == '2' ? 1 : 0, weekstart: weekstart }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Tooltip"], { ecId: (this && this.props && this.props.ecId || '') + "_Tooltip@1nnvmk", placement: "bottom", title: getLabel(354, '刷新') },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-coms-Refresh", style: {
                                cursor: 'pointer', padding: '0 10px', color: '#B2B2B2',
                                fontSize: '16px', display: 'inline-block', position: 'absolute', top: '15px'
                            }, onClick: function () {
                                cubeViewResource.query(cubeViewResource.resourceParams);
                            } })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-top-colorType" }, this.calculateColorType())),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "resource-plan-tab-header" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { className: "no-border-top" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "first align-center" }, getLabel(124947, '资源面板')),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { colSpan: blockNum }, tableTitle || getLabel(383375, '读取中') + '...')),
                        tableHeaders && tableHeaders.length > 0 && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "search" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaInputSearch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputSearch@3gcgpk", value: this.state.roomName, style: {
                                        display: 'inline-block',
                                        width: cubeViewResource.conditions && cubeViewResource.conditions.length > 0 ? 170 : '100%',
                                        borderRight: '1px solid #eaeaea'
                                    }, placeholder: getLabel(197, '搜索') + '...', onFocusChange: function (bool) { _this.setState({ foucsInput: bool }); }, onSearchChange: function (v) {
                                        cubeViewResource.resourceParams['content'] = v;
                                        // 点击x号刷新页面
                                        if (v == '' && !_this.state.foucsInput) {
                                            cubeViewResource.query(__assign({}, cubeViewResource.resourceParams, { content: v }));
                                        }
                                    }, onSearch: function (v) {
                                        cubeViewResource.query(__assign({}, cubeViewResource.resourceParams, { content: v }));
                                    } }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ViewResourceSearch__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ViewResourceSearch@ymawxp", cubeViewResource: cubeViewResource, Search: Search })),
                            tableHeaders.map(function (header) {
                                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "header" }, header));
                            })))))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-container" },
                loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "align-center", style: { marginTop: 120 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@gqi37q" })),
                !loading && (!resourcesList || resourcesList.length == 0) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-list-placeholder" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "anticon anticon-frown", style: { marginRight: 4 } }),
                    getLabel(83553, '暂无数据'))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@khkq5c", tip: "", spinning: spinisloadvalue },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "tab-container", style: { height: tabHeightValue + 1, minHeight: '130px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@w3dfud", datas: cubeViewResource.rightMenus, onClick: this.doRightMenuAction, collectParams: {
                                "favname": getLabel(124947, '资源面板'),
                                "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                                "favouritetype": 5,
                                "importantlevel": 1
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaNewScroll"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaNewScroll@tvmp7f", height: "100%", ref: "tabScroll", style: {} }, timeType == 'day' && createUrl && createUrl != '' ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDragChoose"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDragChoose@0jh3i9", ref: function (ref) { return cubeViewResource.dragref = ref; }, activeStyle: { backgroundColor: '#E1ECFF' }, onSelectEnd: cubeViewResource.dragChooseEnd, checkActive: this.checkDragActive }, tableContent)) : tableContent)))),
                !loading && (resourcesList && resourcesList.length > 0) && cubeViewResource.showMoreVisible &&
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function () { cubeViewResource.getMore(_this.expandResourceHeigh); }, className: "list-more" }, getLabel('83704', '显示更多')),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ResourceHideListWrap__["a" /* default */], { loading: loading, handleSearchHide: this.handleSearchHide, isHideSearch: cubeViewResource.isHideSearch },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "list-container", style: { height: listHeightValue + 2, 'overflowY': 'auto' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_list__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_List@kv476j", Search: Search })))),
            (cubeViewResource.createUrl.indexOf("/spa/cube/index.jsp#/main/cube/card") > -1) ?
                // (cubeViewResource.visible &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@5ymqa4", onCancel: function () { cubeViewResource.visible = false; cubeViewResource.query(cubeViewResource.resourceParams); }, title: card.cardTab.title || ' ', iconBgcolor: card.iconInfo.iconBg || "#96358a", icon: card.iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: card.iconInfo.iconColor || "#fff", visible: cubeViewResource.visible, hasScroll: true, style: { width: 1200, height: 700 }, buttons: cubeViewResource.quickButtons, destroyBodyOnClose: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "coms-mode-docker coms-mode-card mode-card-resource mode-card-dialogshow" }, cubeViewResource.visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_card__["InnerTabCard"], { ecId: (this && this.props && this.props.ecId || '') + "_InnerTabCard@zf8mb3", Card: card, Search: Search })))
                : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@bsoj9r", onCancel: function () { return cubeViewResource.visible = false; }, url: cubeViewResource.createUrl, visible: cubeViewResource.visible, hasScroll: true, style: { width: 1200, height: 700 } })));
    };
    ViewResouceContainer = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], ViewResouceContainer);
    return ViewResouceContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ViewResouceContainer);
/*创建面板的提示信息*/
var createTitle = function (tipsinfo, titleList) {
    if (Array.isArray(tipsinfo) && tipsinfo.length > 0) {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-resource-titletip" }, tipsinfo.map(function (meet, idx) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                meet.tipsinfo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: meet.tipsinfo } }) : titleList[idx].map(function (tip) { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: tip } }); }),
                idx + 1 < tipsinfo.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "line" })));
        })));
    }
    return undefined;
};


/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
if (__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 7 || __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 9) {
    __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('zh-cn');
}
else {
    __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('en');
}
var ViewResourceSearch = /** @class */ (function (_super) {
    __extends(ViewResourceSearch, _super);
    function ViewResourceSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.click = function (e) {
            if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(e.target).closest('.ant-popover-content').length > 0) { //选择框内部点击,不重置
                _this.setState({ maskClosable: true });
            }
            else {
                _this.setState({ maskClosable: false, showPopover: false });
            }
        };
        _this.onVisibleChange = function (v) {
            _this.setState({ showPopover: v });
        };
        _this.getContent = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { width: 350, maxHeight: 400, overflowY: 'auto' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: 0 } }, _this.getSearchs()),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'center', lineHeight: '50px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Button@q0ehgz", style: { marginRight: '20px' }, type: "primary", size: "large", onClick: _this.onclick }, getLabel(197, "搜索")),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaButton"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaButton@2flee1", size: "large", onClick: _this.reset, text: getLabel(2022, "重置") }))));
        };
        _this.reset = function () {
            var cubeViewResource = _this.props.cubeViewResource;
            _this.props['form'].resetFields();
            cubeViewResource.queryparm = {};
        };
        _this.onclick = function () {
            _this.setState({ showPopover: false, });
            _this.onSearch();
        };
        _this.onSearch = function () {
            var cubeViewResource = _this.props.cubeViewResource;
            cubeViewResource.query();
        };
        _this.getSearchs = function () {
            var cubeViewResource = _this.props.cubeViewResource;
            var conditions = cubeViewResource.conditions;
            var items = new Array();
            if (conditions && conditions.length > 0) {
                for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
                    var field = conditions_1[_i];
                    items.push({
                        com: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@duadbk@" + field.domkey, label: "" + field.label, labelCol: { span: "" + field.labelcol }, wrapperCol: { span: "" + field.fieldcol } }, __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"].getComponent(field.conditionType, field.browserConditionParam, field.domkey, _this.props, field))),
                        colSpan: field.colSpan || 2,
                        hide: __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"].isComponentHide(field)
                    });
                }
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaSearchGroup"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSearchGroup@yoy0it", style: { padding: 0 }, items: items, col: 1, showGroup: true, needTigger: false });
        };
        _this.state = {
            maskClosable: true,
            showPopover: false,
        };
        return _this;
    }
    ViewResourceSearch.prototype.componentDidMount = function () {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()("#container").on('click', this.click);
    };
    ViewResourceSearch.prototype.render = function () {
        var cubeViewResource = this.props.cubeViewResource;
        var conditions = cubeViewResource.conditions;
        if (conditions && conditions.length > 0) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Popover"], { ecId: (this && this.props && this.props.ecId || '') + "_Popover@ermjyj", visible: this.state.showPopover, placement: "bottom", content: this.getContent(), trigger: "click", onVisibleChange: this.onVisibleChange, mask: true, maskClosable: this.state.maskClosable, overlayClassName: "wea-meeting-popover" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { display: 'inline-block', width: 25, cursor: 'pointer', fontSize: 14, color: '#b2b2b2' }, className: "icon-coms-screen" })));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null);
        }
    };
    ViewResourceSearch = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ViewResourceSearch);
    return ViewResourceSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
var viewResourceSearch = __WEBPACK_IMPORTED_MODULE_2_antd__["Form"].create({
    onFieldsChange: function (props, fields) {
        var cubeViewResource = props.cubeViewResource;
        var queryparm = cubeViewResource.queryparm;
        for (var key in fields) {
            queryparm[fields[key].name] = fields[key].value;
        }
    }
})(ViewResourceSearch);
/* harmony default export */ __webpack_exports__["a"] = (viewResourceSearch);


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(18);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(428);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(12);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(28);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(16);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(17);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _antd=__webpack_require__(3);var _moment=__webpack_require__(63);var _moment2=_interopRequireDefault(_moment);var _isFunction=__webpack_require__(233);var _isFunction2=_interopRequireDefault(_isFunction);var _ResourceDatePickerArrow=__webpack_require__(1104);var _ResourceDatePickerArrow2=_interopRequireDefault(_ResourceDatePickerArrow);var _ecCom=__webpack_require__(1);__webpack_require__(1105);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ButtonGroup=_antd.Button.Group;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var ResourceDateSwitch=(_temp=_class=function(_React$Component){(0,_inherits3.default)(ResourceDateSwitch,_React$Component);function ResourceDateSwitch(props){(0,_classCallCheck3.default)(this,ResourceDateSwitch);var _this=(0,_possibleConstructorReturn3.default)(this,(ResourceDateSwitch.__proto__||(0,_getPrototypeOf2.default)(ResourceDateSwitch)).call(this,props));_this.getCurrentButtonText=function(currentType){var weekstart=_this.props.weekstart;var text='';switch(currentType){case"year":text=getLabel("15384","本年");break;case"month":text=getLabel("15541","本月");break;case"week":text=weekstart==="3"?getLabel('383202','最近7天'):getLabel("15539","本周");break;default:text=getLabel("15537","今天");break;}return text;};_this.getCurrentType=function(){_this.state.currentType;};_this.setCurrentType=function(type){_this.setState({currentType:type},_this.onChange);};_this.getCurrentDay=function(){_this.state.currentDay;};_this.setCurrentDay=function(day){_this.setState({currentDay:day},_this.onChange);};_this.parseDate=function(value){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_this.state.currentType;if(!value)return type=="day"||type=="week"?getLabel("27938","请选择日期"):type=="month"?getLabel("385895","请选择月份"):getLabel("385896","请选择年份");var curMoment=value._isAMomentObject?value:(0,_moment2.default)(value);var curMomentCopy=(0,_moment2.default)(curMoment);var weekFirstDay=_this.props.weekFirstDay;var yearFormat=getLabel("386427","YYYY年");var monthDayFormat=getLabel("386428","MM月DD日");var dayFormat=getLabel("386429","YYYY年MM月DD日");var monthFormat=getLabel("386679","YYYY年MM月");switch(type){case"year":return curMomentCopy.format(yearFormat);case"month":return curMomentCopy.format(monthFormat);case"week":{var curDay=curMomentCopy.day();curMomentCopy.day(weekFirstDay);var weekFirstDayNum=curMomentCopy.day();if(weekFirstDayNum<curDay){return curMomentCopy.format(dayFormat)+"~"+curMomentCopy.day(weekFirstDay+6).format(monthDayFormat);}else{return curMomentCopy.day(weekFirstDay-7).format(dayFormat)+"~"+curMomentCopy.day(weekFirstDay+6).format(monthDayFormat);}}case"day":default:return curMomentCopy.format(dayFormat);}};_this.onPick=function(date){if(!date)date=new Date();var dateCopy=(0,_moment2.default)(date);_this.setState({currentDay:dateCopy},_this.onChange);};_this.onChange=function(){if((0,_isFunction2.default)(_this.props.onChange)){var _this$state=_this.state,currentDay=_this$state.currentDay,currentType=_this$state.currentType;var curMomentCopy=(0,_moment2.default)(currentDay);curMomentCopy.fmt=function(){return curMomentCopy.format("YYYY-MM-DD");};var date=[];switch(currentType){case"year":date.push((0,_moment2.default)(curMomentCopy).dayOfYear(1));date.push((0,_moment2.default)(curMomentCopy).dayOfYear(366));break;case"month":date.push((0,_moment2.default)(curMomentCopy).date(1));date.push((0,_moment2.default)(curMomentCopy).date(31));break;case"week":{date.push((0,_moment2.default)(curMomentCopy).day(0));date.push((0,_moment2.default)(curMomentCopy).day(6));break;}case"day":default:date.push(curMomentCopy);}_this.props.onChange(currentType,currentDay,date);}};_this.state={typeList:props.typeList,currentType:props.currentType,currentDay:props.currentDay,C_N:props.C_N||false};return _this;}(0,_createClass3.default)(ResourceDateSwitch,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.currentDay!=this.props.currentDay){this.setState({currentDay:nextProps.currentDay});}if(nextProps.currentType!=this.props.currentType){this.setState({currentType:nextProps.currentType});}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,_props$className=_props.className,className=_props$className===undefined?"":_props$className,style=_props.style,datePickerProps=_props.datePickerProps,ecId=_props.ecId,weekstart=_props.weekstart;var _state=this.state,currentDay=_state.currentDay,currentType=_state.currentType,typeList=_state.typeList;var value=_moment2.default.isMoment(currentDay)?currentDay.toDate():currentDay;var pickerProps={arrow:true,type:currentType,weekstart:weekstart,onChange:this.onPick,value:value,className:"switch-picker ",C_N:this.state.C_N,datePickerProps:datePickerProps};var currentButtonText=this.getCurrentButtonText(currentType);return React.createElement("div",{className:"wea-date-switch "+className,style:style},React.createElement(ButtonGroup,{ecId:ecId+"_ButtonGroup@97p46v"},typeList.map(function(type){var label=undefined;switch(type){case"day":label=getLabel("390","日");break;case"week":label=getLabel("1926","周");break;case"month":label=getLabel("33452","月");break;case"year":label=getLabel("26577","年");break;default:break;}return React.createElement(_antd.Button,{ecId:ecId+"_Button@97p46v@"+type,type:currentType==type?"primary":"ghost",onClick:function onClick(){return _this2.setCurrentType(type);}},label);})),React.createElement(_ResourceDatePickerArrow2.default,(0,_extends3.default)({},pickerProps,{ecId:ecId+"_WeaDatePicker@97p46v"})),React.createElement(_ecCom.WeaButton,{ecId:ecId+"_WeaButton@cjtyz8",type:"ghost",text:currentButtonText,disabled:false,onClick:this.setCurrentDay.bind(this,new Date())}),this.props.children);}}]);return ResourceDateSwitch;}(React.Component),_class.defaultProps={datePickerProps:{}},_temp);exports.default=ResourceDateSwitch;ResourceDateSwitch.defaultProps={typeList:["day","week","month"],currentType:"day",weekFirstDay:0};ResourceDateSwitch.propTypes={typeList:React.PropTypes.array,// 类型列表，要展示出来的类型的数组，支持 year,month,week,day
currentType:React.PropTypes.string,// 当前选中类型
weekFirstDay:React.PropTypes.any,//周的第一天，支持0~6,Sun~Sat
currentDay:React.PropTypes.any,//当前天数，支持传入js Date, yyyy-MM-dd, 也可传入moment对象.
onChange:React.PropTypes.func//onChange事件,参数为type,date(moment), dateRange[moment]
};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1102);
module.exports = __webpack_require__(22).Object.getPrototypeOf;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(68);
var $getPrototypeOf = __webpack_require__(269);

__webpack_require__(1103)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(31);
var core = __webpack_require__(22);
var fails = __webpack_require__(57);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(18);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(428);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(12);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(28);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(16);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(17);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(3);var _moment=__webpack_require__(63);var _moment2=_interopRequireDefault(_moment);var _ecCom=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var MonthPicker=_antd.DatePicker.MonthPicker;var YearPicker=_antd.DatePicker.YearPicker;function getTips(type){switch(type){default:break;case"year":return[getLabel("81716","上一年"),getLabel("81718","下一年")];case"month":return[getLabel("27347","上个月"),getLabel("27348","下个月")];case"week":return[getLabel("26789","上周"),getLabel("83132","下周")];case"day":return[getLabel("385893","上一天"),getLabel("385894","下一天")];}}var ResourceDatePickerArrow=function(_React$Component){(0,_inherits3.default)(ResourceDatePickerArrow,_React$Component);function ResourceDatePickerArrow(props){(0,_classCallCheck3.default)(this,ResourceDatePickerArrow);var _this=(0,_possibleConstructorReturn3.default)(this,(ResourceDatePickerArrow.__proto__||(0,_getPrototypeOf2.default)(ResourceDatePickerArrow)).call(this,props));_this.formatOfZero=function(value){// 增加 年月日 是否带0的处理
var _this$props$formatWit=_this.props.formatWithZero,formatWithZero=_this$props$formatWit===undefined?true:_this$props$formatWit;if(!formatWithZero){return value.replace(/\b(0+)/gi,"");}return value;};_this.state={togglePicker:false,date:props.date||props.value,dateLabel:_this.parseDate(props.date||props.value)};_this.onChange=_this.onChange.bind(_this);_this.togglePicker=_this.togglePicker.bind(_this);_this.parseDate=_this.parseDate.bind(_this);_this.changeValue=_this.changeValue.bind(_this);return _this;}(0,_createClass3.default)(ResourceDatePickerArrow,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){this.setState({date:nextProps.date||nextProps.value,dateLabel:this.parseDate(nextProps.date||nextProps.value,nextProps.type)});}},{key:"parseDate",value:function parseDate(value){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.props.type;var C_N=arguments.length>2&&arguments[2]!==undefined?arguments[2]:this.props.C_N;if(!value)return getLabel("27938","请选择日期");var curMoment=value._isAMomentObject?value:(0,_moment2.default)(value);var yearFormat=getLabel("386427","YYYY年");var monthDayFormat=getLabel("386428","MM月DD日");var dateFormat=getLabel("386429","YYYY年MM月DD日");var monthFormat=getLabel("386679","YYYY年MM月");var curMomentCopy=(0,_moment2.default)(curMoment);var weekFirstDay=1;var isC_N=C_N?true:false;var str="";switch(type){case"year":str=curMoment.format(yearFormat);break;case"quarter":str=curMoment.format(yearFormat)+"第"+curMoment.quarter()+"季度";break;case"month":str=curMoment.format(monthFormat);break;case"week":{if(this.props.weekstart==="3"){// weekstart=3, 即取今天开始的七天
var curDay=curMomentCopy.day();str=curMomentCopy.day(curDay).format(dateFormat)+"~"+curMomentCopy.day(curDay+6).format(monthDayFormat);}else{if(isC_N){var _curDay=curMomentCopy.day();curMomentCopy.day(weekFirstDay);var weekFirstDayNum=curMomentCopy.day();if(weekFirstDayNum<=_curDay){str=curMomentCopy.format(dateFormat)+"~"+curMomentCopy.day(weekFirstDay+6).format(monthDayFormat);}else{str=curMomentCopy.day(weekFirstDay-7).format(dateFormat)+"~"+curMomentCopy.day(weekFirstDay+6).format(monthDayFormat);}}else{str=curMoment.day(0).format(dateFormat)+"~"+curMoment.day(6).format(monthDayFormat);}}break;}case"day":default:str=curMoment.format(dateFormat);}return this.formatOfZero(str);}},{key:"onChange",value:function onChange(date,dateStr){if(!date)date=new Date();this.setState({date:date,dateLabel:this.parseDate(date)});this.togglePicker();this.callback(date);}},{key:"togglePicker",value:function togglePicker(){this.setState({togglePicker:!this.state.togglePicker});}},{key:"changeValue",value:function changeValue(diff){var curMoment=(0,_moment2.default)(this.state.date);switch(this.props.type){default:break;case"year":{var year=curMoment.year();curMoment.year(year+diff);break;}case"quarter":var month=curMoment.month();curMoment.month(month+diff*3);break;case"month":{var _month=curMoment.month();curMoment.month(_month+diff);break;}case"week":{var dayOfYear=curMoment.dayOfYear();curMoment.dayOfYear(dayOfYear+diff*7);break;}case"day":{var _dayOfYear=curMoment.dayOfYear();curMoment.dayOfYear(_dayOfYear+diff);break;}}this.setState({date:curMoment,dateLabel:this.parseDate(curMoment)});this.callback(curMoment);}},{key:"callback",value:function callback(value){if(!this.props.onChange)return;var dateRange=this.getDateRange(value);this.props.onChange(value,dateRange);}},{key:"getDateRange",value:function getDateRange(value){var curMoment=(0,_moment2.default)(value);var date=void 0;switch(this.props.type){case"year":date=curMoment.format("YYYY");break;case"quarter":date=curMoment.format("YYYY-MM");break;case"month":date=curMoment.format("YYYY-MM");break;case"week":date=curMoment.format("YYYY-MM-DD");break;case"day":date=curMoment.format("YYYY-MM-DD");break;default:date=curMoment.format("YYYY-MM-DD");break;}return this.formatOfZero(date);}},{key:"renderPicker",value:function renderPicker(){var date=this.state.date,defaultValue=_moment2.default.isMoment(date)?date.toDate():date;var _props=this.props,_props$formatWithZero=_props.formatWithZero,formatWithZero=_props$formatWithZero===undefined?true:_props$formatWithZero,ecId=_props.ecId;var pickerProps={onChange:this.onChange,open:this.state.togglePicker,defaultValue:defaultValue,value:defaultValue,toggleOpen:this.togglePicker,formatWithZero:formatWithZero// feat: 格式化 年月日 是否带0处理
};var _props2=this.props,type=_props2.type,datePickerProps=_props2.datePickerProps;// -----用于WeaDateSwitch组件支持配置antd DatePicker参数------
if(datePickerProps){pickerProps=(0,_extends3.default)({},pickerProps,datePickerProps);}// --------------------------------------------------------
if(type=="month"){return _react2.default.createElement(MonthPicker,(0,_extends3.default)({},pickerProps,{ecId:ecId+"_MonthPicker@lgk4iu"}));}if(type=="year"){return _react2.default.createElement(YearPicker,(0,_extends3.default)({},pickerProps,{ecId:ecId+"_YearPicker@cx3xn9",className:"wea-year-picker"}));}if(type=="quarter"){return _react2.default.createElement(MonthPicker,(0,_extends3.default)({},pickerProps,{ecId:ecId+"_MonthPicker@v0il0v"}));}return _react2.default.createElement(_antd.DatePicker,(0,_extends3.default)({},pickerProps,{ecId:ecId+"_DatePicker@3hht9m"}));}},{key:"render",value:function render(){var date=this.state.date,defaultValue=_moment2.default.isMoment(date)?date.toDate():date;var _props3=this.props,label=_props3.label,type=_props3.type,style=_props3.style,ecId=_props3.ecId;var tips=getTips(type)||[];return _react2.default.createElement("div",{className:"wea-date-picker-arrow "+this.props.className,style:style},_react2.default.createElement("span",{ecId:ecId+"_span@ep8i01",className:"icon-coms-Browse-box-delete",onClick:this.changeValue.bind(this,-1),title:tips[0]}),_react2.default.createElement("span",{ecId:ecId+"_span@ezufk3",onClick:this.togglePicker,className:"label"},_react2.default.createElement("span",{style:{opacity:0,width:0,position:"absolute",overflow:"hidden"}},this.renderPicker()),label?label:this.state.dateLabel),_react2.default.createElement("span",{ecId:ecId+"_span@o24r4n",className:"icon-coms-Browse-box-Add-to",onClick:this.changeValue.bind(this,1),title:tips[1]}));}}]);return ResourceDatePickerArrow;}(_react2.default.Component);exports.default=ResourceDatePickerArrow;ResourceDatePickerArrow.defaultProps={type:"date"};ResourceDatePickerArrow.propTypes={type:_react2.default.PropTypes.string,//month为月选择器，week为周选择器，其它为日选择器
onChange:_react2.default.PropTypes.func,//时间发生变化的回调,会返回选择的日期与类型对应的日期范围
date:_react2.default.PropTypes.any,//当前日期，支持jsDate,字符串
className:_react2.default.PropTypes.string//附加的样式名
};

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ResourceHideListWrap = /** @class */ (function (_super) {
    __extends(ResourceHideListWrap, _super);
    function ResourceHideListWrap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchHide = function (bool) {
            var handleSearchHide = _this.props.handleSearchHide;
            handleSearchHide && handleSearchHide(bool);
        };
        return _this;
    }
    ResourceHideListWrap.prototype.render = function () {
        var _this = this;
        var _a = this.props, isHideSearch = _a.isHideSearch, loading = _a.loading;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-hide-list-wrap" },
            !loading && (!isHideSearch ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "search-hide", onClick: function () { return _this.searchHide(true); } })
                : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "search-show", onClick: function () { return _this.searchHide(false); } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { 'display': isHideSearch ? 'none' : 'block', boxShadow: '0 -1px 0 0 #e2e2e2' } }, this.props.children)));
    };
    ResourceHideListWrap = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ResourceHideListWrap);
    return ResourceHideListWrap;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ResourceHideListWrap);


/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apis_resource__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
if (__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 7 || __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 9) {
    __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('zh-cn');
}
else {
    __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('en');
}
var ViewResouceContainerMobile = /** @class */ (function (_super) {
    __extends(ViewResouceContainerMobile, _super);
    function ViewResouceContainerMobile(props) {
        var _this = _super.call(this, props) || this;
        _this.createHeight = function () {
            var cubeViewResource = _this.props.cubeViewResource;
            // 处理高度自适应问题
            var container = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('.resource-container', __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this)), conHeight = _this.props.height ? (_this.props.height - 108) : container.height();
            var listHeight;
            var tab = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('.resource-plan-tab', container), tabHeight = tab.height();
            if (cubeViewResource.showMoreVisible) {
                tabHeight = tabHeight + 40;
            }
            if (tabHeight >= (conHeight / 2)) {
                listHeight = (conHeight / 2);
                tabHeight = (conHeight / 2);
            }
            else {
                listHeight = conHeight - tabHeight;
            }
            cubeViewResource.updateHeight(conHeight, tabHeight, listHeight);
        };
        /*周月日组件切换回调 */
        /**
         * 说明：若日,传点前的日期，且给值movedate，若年或月则传点击后的日期，且movedate不给值
         */
        _this.onChangeWeaDateSwitch = function (type, date, range) {
            var cubeViewResource = _this.props.cubeViewResource;
            var timeType = cubeViewResource.timeType;
            type != timeType && cubeViewResource.updateTimeType(type);
            cubeViewResource.resourceId = '';
            var movedate = '';
            var bywhat = '4';
            if (typeof date != 'string' && date._d && date._i) {
                if (typeof date._d == 'string') {
                    date._d = new Date(date._d);
                }
                if (typeof date._i == 'string') {
                    date._i = new Date(date._i);
                }
                if (date._d.getTime() != date._i.getTime() && type == 'day') { //说明点击箭头切换日期
                    if (date._d.getTime() < date._i.getTime()) {
                        movedate = '-1';
                    }
                    else {
                        movedate = '1';
                    }
                }
            }
            switch (type) {
                case 'year':
                    bywhat = '1';
                    break;
                case 'month':
                    bywhat = '2';
                    break;
                case 'week':
                    bywhat = '3';
                    break;
                case 'day':
                    bywhat = '4';
                    break;
            }
            var currentdate;
            if (typeof date == 'string') {
                currentdate = date;
            }
            else if (typeof date._i == 'string') {
                currentdate = bywhat == '4' ? date._i : date._d;
            }
            else {
                var rightdate = void 0;
                if (date._i && date._d) {
                    rightdate = bywhat == '4' ? date._i : date._d;
                }
                else {
                    rightdate = date;
                }
                var m = rightdate.getMonth() + 1 + '';
                var d = rightdate.getDate() + '';
                if (m.length == 1)
                    m = '0' + m;
                if (d.length == 1)
                    d = '0' + d;
                currentdate = rightdate.getFullYear() + '-' + m + '-' + d;
            }
            _this.setState({ date: date });
            cubeViewResource.query({ bywhat: bywhat, movedate: movedate, currentdate: currentdate });
        };
        _this.getTableHeaderInfo = function (timeType, date, startHour, endHour) {
            var blockNum = 0, tableTitle = '', tableHeaders = [];
            if (__WEBPACK_IMPORTED_MODULE_3_moment___default.a.isMoment(date))
                date = new Date(date.format('L'));
            var curmoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date);
            blockNum = endHour - startHour + 1;
            tableTitle = curmoment.format("M" + getLabel(383373, '月') + "D" + getLabel(383374, '日').replace('-', '') + "(ddd)" + getLabel(33425, '单位') + ":") + getLabel(383376, '时');
            tableTitle = _this.modifyWeekName(tableTitle);
            for (startHour; startHour <= endHour; startHour++)
                tableHeaders.push(startHour);
            return { blockNum: blockNum, tableTitle: tableTitle, tableHeaders: tableHeaders };
        };
        /*周显示多语言修正 ，moment打包后中文失效*/
        _this.modifyWeekName = function (name) {
            try {
                if (__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 7 || __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getUserLanguage() == 9) {
                    name = name.replace("Sun", "周日");
                    name = name.replace("Mon", "周一");
                    name = name.replace("Tue", "周二");
                    name = name.replace("Wed", "周三");
                    name = name.replace("Thu", "周四");
                    name = name.replace("Fri", "周五");
                    name = name.replace("Sat", "周六");
                }
            }
            catch (Exception) {
            }
            return name;
        };
        /*创建面板使用情况的每一行得td*/
        _this.createTdList = function (resource, blockNum, rowNum) {
            var cubeViewResource = _this.props.cubeViewResource;
            var duration = cubeViewResource.duration, useMap = cubeViewResource.useMap;
            var tdList = [];
            var useArray = useMap[resource.id];
            // 创建冲突的、带有提示的单元格
            var createTooltipTd = function (obj, otherProps, width) {
                if (otherProps === void 0) { otherProps = {}; }
                var content = obj.content, bgcolor = obj.bgcolor, fontcolor = obj.fontcolor, title = obj.title;
                var style = { backgroundColor: bgcolor || '#AFDC9E', color: fontcolor || '#000', textAlign: 'center' };
                var td = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Tooltip"], { ecId: (this && this.props && this.props.ecId || '') + "_Tooltip@xczef8", title: createTitle(Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["toJS"])(title)), placement: "bottomRight", arrowPointAtCenter: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({ className: "resource-td", style: style }, { conflict: true }, otherProps),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-modal" }),
                        content > 1 && content)));
                return td;
            };
            return _this.createTdListInDay(duration, useArray, resource, createTooltipTd, rowNum, tdList);
        };
        _this.getResourceItem = function () {
            var cubeViewResource = _this.props.cubeViewResource;
            var resourcesList = cubeViewResource.resourcesList, loading = cubeViewResource.loading, startHour = cubeViewResource.startHour, endHour = cubeViewResource.endHour;
            var dif = endHour - startHour + 1;
            var fields = [];
            var field = [];
            var HH = _this.refs.resourceTableBox ? _this.refs.resourceTableBox['offsetHeight'] : '';
            var tableContent = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "resource-plan-tab", style: { width: dif * 30.1 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, !loading && (resourcesList && resourcesList.length > 0) &&
                    resourcesList.map(function (resources, index) {
                        var tdList = _this.createTdList(resources, 0, index);
                        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { className: index == 0 ? "no-border-top" : "" }, tdList));
                    }))));
            resourcesList && resourcesList.map(function (resources, index) {
                field.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Tooltip"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Tooltip@7n3c1x@" + index, placement: "right", title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: resources.title } }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'head-item', key: index }, resources.name)));
            });
            fields.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'resource-table-box-head', ref: 'resourceTableBoxHead', key: 'resourceTableBoxHead', onScroll: _this.onHeadScroll, style: { height: HH } }, field), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'resource-table-box-content', key: 'table', ref: 'resourceTableBoxContent', style: { height: HH, overflow: 'auto' }, onScroll: _this.onscroll }, tableContent));
            return fields;
        };
        _this.getTimeItem = function () {
            var cubeViewResource = _this.props.cubeViewResource;
            var startHour = cubeViewResource.startHour, endHour = cubeViewResource.endHour;
            var fields = [];
            for (var i = startHour; i <= endHour; i++) {
                fields.push(// 时间段格
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'item', key: i }, i));
            }
            return fields;
        };
        _this.tableScroll = function (e) {
            if (e.target.className === 'resource-td-modal') {
                _this.setState({ scrollType: 'table' });
            }
            else if (e.target.className === 'resource-td') {
                _this.setState({ scrollType: 'table' });
            }
            else if (e.target.parentNode.parentNode.parentNode.className === 'resource-subTable' || e.target.parentNode.className === 'resource-subTable') {
                _this.setState({ scrollType: 'table' });
            }
            else if (e.target.className === 'resource-subTable' || e.target.parentNode.parentNode.parentNode.className === 'resource-plan-tab') {
                _this.setState({ scrollType: 'table' });
            }
            else if (e.target.parentNode.parentNode.className === 'resource-table-top-content') {
                _this.setState({ scrollType: 'top' });
            }
            else if (e.target.className === 'head-item') {
                _this.setState({ scrollType: 'head' });
            }
        };
        _this.onTopScroll = function (e) {
            var table = _this.refs.resourceTableBoxContent;
            var topTime = _this.refs.topTime;
            if (_this.state.scrollType === 'top') {
                table['scrollLeft'] = topTime['scrollLeft'];
            }
        };
        _this.onHeadScroll = function (e) {
            var table = _this.refs.resourceTableBoxContent;
            var resourceTableBoxHead = _this.refs.resourceTableBoxHead;
            if (_this.state.scrollType === 'head') {
                table['scrollTop'] = resourceTableBoxHead['scrollTop'];
            }
        };
        _this.onscroll = function (e) {
            var resourceTableBoxHead = _this.refs.resourceTableBoxHead;
            var topTime = _this.refs.topTime;
            var table = _this.refs.resourceTableBoxContent;
            if (_this.state.scrollType === 'table') {
                topTime['scrollLeft'] = table['scrollLeft'];
                resourceTableBoxHead['scrollTop'] = table['scrollTop'];
            }
        };
        _this.state = {
            scrollType: '',
            date: new Date(),
        };
        Object(__WEBPACK_IMPORTED_MODULE_7__apis_resource__["a" /* getCurrentDate */])({}).then(function (_a) {
            var currentDate = _a.currentDate;
            _this.setState({ date: currentDate });
        });
        return _this;
    }
    ViewResouceContainerMobile.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.createHeight();
        var _a = this.props, cubeViewResource = _a.cubeViewResource, Search = _a.Search;
        cubeViewResource.resourceParams.bywhat = '4';
        setTimeout(function () {
            if (cubeViewResource.windowTitle != '') {
                document.title = cubeViewResource.windowTitle;
            }
        }, 500);
        Search.isInnerTab = true;
    };
    ViewResouceContainerMobile.prototype.componentWillReceiveProps = function () {
        var cubeViewResource = this.props.cubeViewResource;
        this.setState({ date: cubeViewResource.currentdate });
        cubeViewResource.timeType = 'day';
    };
    /*创建时间类型为天时的单元格*/
    ViewResouceContainerMobile.prototype.createTdListInDay = function (duration, useArray, room, createTooltipTd, rowNum, tdList) {
        var cubeViewResource = this.props.cubeViewResource;
        var startHour = cubeViewResource.startHour, endHour = cubeViewResource.endHour;
        var dspunit = cubeViewResource.dspunit;
        var useBlockMap = {}; //已被使用的块，数据结构：小时数:{变色的序号：{背景颜色，字体颜色，内容}，...}
        // let subNum = 1;//每小时会被分成几段
        // 生成已被占用的时间段
        useArray && useArray.forEach(function (obj) {
            // 时间处理，确认序号
            if (!obj.time)
                return;
            var time = obj.time.split(':');
            if (time.length != 2)
                return;
            var hour = parseInt(time[0]), minute = parseInt(time[1]);
            var idx = duration > 0 ? Math.floor(minute / duration) : 0;
            // 找到该数据对应的存储位置。
            if (!useBlockMap[hour])
                useBlockMap[hour] = {};
            var useHour = useBlockMap[hour];
            useHour[idx] = obj;
        });
        var width = (100 / dspunit) + "%";
        /*创建每小时内的分隔块、即第二层td的方法*/
        var createSubTd = function (hour, idx, rowNum, colNum) {
            var startMinute = idx * duration, endMinute = startMinute + duration - 1;
            var startTime = (hour > 9 ? hour : '0' + hour) + ':' + (startMinute > 9 ? startMinute : '0' + startMinute), endTime = (hour > 9 ? hour : '0' + hour) + ':' + (endMinute > 9 ? endMinute : '0' + endMinute);
            // 有值则说明已被占用
            if (useBlockMap[hour] && useBlockMap[hour][idx]) {
                return createTooltipTd(useBlockMap[hour][idx], {
                    itemPosition: [rowNum, colNum],
                    startTime: startTime,
                    endTime: endTime,
                    room: room
                }, width);
            }
            // 空时段
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", __assign({ className: "resource-td", style: { width: width } }, { itemPosition: [rowNum, colNum] }, { startTime: startTime, endTime: endTime, room: room }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-td-modal" })));
        };
        // 生成第一层td列表
        var colNum = 0;
        for (startHour; startHour <= endHour; startHour++) {
            var subTdList = [];
            for (var i = 0; i < dspunit; i++) {
                subTdList.push(createSubTd(startHour, i, rowNum, colNum));
                colNum++;
            }
            var td = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "resource-subTable" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, subTdList))));
            tdList.push(td);
        }
        return tdList;
    };
    ViewResouceContainerMobile.prototype.render = function () {
        var _this = this;
        var cubeViewResource = this.props.cubeViewResource;
        var loading = cubeViewResource.loading, resourcesList = cubeViewResource.resourcesList, timeType = cubeViewResource.timeType;
        // 列表中使用的数据
        var date = this.state.date;
        var startHour = cubeViewResource.startHour, endHour = cubeViewResource.endHour;
        var _a = this.getTableHeaderInfo(timeType, date, startHour, endHour), blockNum = _a.blockNum, tableTitle = _a.tableTitle;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-cube-resource-con f12", style: { height: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-plan-top" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-plan-top-con line" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaDateSwitch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDateSwitch@cpb5yp", currentType: 'day', onChange: this.onChangeWeaDateSwitch, currentDay: this.state.date, typeList: [] })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "resource-plan-tab-header" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { className: "no-border-top" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "first align-center", style: { width: 100 } }, getLabel(124947, '资源面板')),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { colSpan: blockNum }, tableTitle || getLabel(383375, '读取中') + '...'))))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-container-mobile" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'resource-table-mobile', ref: 'resourceTable', key: 'resourceTable', onTouchStart: function (e) {
                        _this.tableScroll(e);
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'resource-table-top', ref: 'resourceTableTop' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'resource-table-top-head' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaInputSearch"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInputSearch@pkig3x", value: this.state.roomName, style: { display: 'inline-block',
                                    width: cubeViewResource.conditions && cubeViewResource.conditions.length > 0 ? 170 : '100%',
                                    borderRight: '1px solid #eaeaea' }, placeholder: getLabel(197, '搜索') + '...', onSearchChange: function (v) {
                                    cubeViewResource.resourceParams['content'] = v;
                                }, onSearch: function (v) {
                                    cubeViewResource.query(__assign({}, cubeViewResource.resourceParams, { content: v }));
                                } })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'resource-table-top-content', ref: 'topTime', onScroll: this.onTopScroll },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'table-box' }, this.getTimeItem()))),
                    loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "align-center", style: { marginTop: 120 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@d5qxtw" })),
                    !loading && (!resourcesList || resourcesList.length == 0) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "resource-list-placeholder" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "anticon anticon-frown", style: { marginRight: 4 } }),
                        getLabel(83553, '暂无数据'))),
                    !loading && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'resource-table-box', ref: 'resourceTableBox' }, this.getResourceItem()))),
                !loading && (resourcesList && resourcesList.length > 0) &&
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function () { if (!cubeViewResource.showMoreVisible)
                            return; cubeViewResource.getMore(); }, className: "list-more" }, cubeViewResource.showMoreVisible && getLabel('83704', '显示更多')))));
    };
    ViewResouceContainerMobile = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], ViewResouceContainerMobile);
    return ViewResouceContainerMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ViewResouceContainerMobile);
/*创建面板的提示信息*/
var createTitle = function (titleList) {
    if (Array.isArray(titleList) && titleList.length > 0) {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-resource-titletip" }, titleList.map(function (meet, idx) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                meet.map(function (tip) { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: { __html: tip } }); }),
                idx + 1 < titleList.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "line" })));
        })));
    }
    return undefined;
};


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TemplateList__ = __webpack_require__(1110);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var TemplateManage = /** @class */ (function (_super) {
    __extends(TemplateManage, _super);
    function TemplateManage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplateManage.prototype.componentDidMount = function () {
        var _a = this.props, templateManageStore = _a.templateManageStore, location = _a.location;
        templateManageStore.customid = location['query'].customid || '';
        templateManageStore.sourcetype = location['query'].sourcetype || '';
        templateManageStore.init();
    };
    TemplateManage.prototype.render = function () {
        var templateManageStore = this.props.templateManageStore;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TemplateList__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_TemplateList@9d9vkg", templateManageStore: templateManageStore })));
    };
    TemplateManage = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('templateManageStore'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TemplateManage);
    return TemplateManage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TemplateManage);


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EidtTemplate__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SetTemplateColumn__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SetCustomCondition__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;

var TemplateList = /** @class */ (function (_super) {
    __extends(TemplateList, _super);
    function TemplateList(props) {
        var _this = _super.call(this, props) || this;
        _this.recalculateMask = function () {
            var domRootStr = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(".coms-mode-templateManage");
            if (domRootStr.length > 0) {
                var dom = domRootStr.find('.wea-search-container')[0];
                if (dom) {
                    var maskDarkHeight = window.innerHeight - dom.offsetTop - 110;
                    domRootStr.find(".mask-dark").height(maskDarkHeight);
                }
            }
        };
        _this.state = {
            showSearchAd: false
        };
        return _this;
    }
    TemplateList.prototype.render = function () {
        var _this = this;
        var templateManageStore = this.props.templateManageStore;
        var iconInfo = templateManageStore.iconInfo;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@127seh", datas: [{
                        key: 'add',
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-New-Flow' }),
                        content: getLabel(82, '新建', 'label'),
                    }, {
                        key: 'search',
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-search' }),
                        content: getLabel(197, '搜索', 'label'),
                    }], onClick: templateManageStore.rightClick, collectParams: {
                    "favname": getLabel(17857, "模板管理"),
                    "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                    "favouritetype": 5,
                    "importantlevel": 1
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTop"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTop@s5612b", title: getLabel(17857, "模板管理"), icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: iconInfo.icon, style: { color: iconInfo.iconColor } }), iconBgcolor: iconInfo.iconBg, buttons: [
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@rf5hcx@add", type: 'primary', onClick: function () { templateManageStore.add(); } }, getLabel(82, "新建"))
                    ] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTab"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTab@edc7p0", searchType: ['base', 'advanced'], onSearch: function (v) {
                        templateManageStore.searchByName(v);
                    }, searchsBaseValue: templateManageStore.templateName1, showSearchAd: this.state.showSearchAd, setShowSearchAd: function (bool) {
                        _this.setState({
                            showSearchAd: bool
                        });
                    }, advanceHeight: 'auto', searchsAd: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSearchGroup"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSearchGroup@vokc90", title: getLabel(20331, "查询条件"), items: [
                            { com: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaFormItem"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaFormItem@j1z4pl", label: getLabel(18151, "模板名称"), ratio1to2: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaInput"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@f3923h", onChange: function (v) { return templateManageStore.templateName = v; }, value: templateManageStore.templateName })),
                                colSpan: 1 }
                        ], center: true, showGroup: true, onVisibleChange: this.recalculateMask }), buttonsAd: [
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@nukk1v@searchByName", type: "primary", onClick: function () { templateManageStore.searchByName(templateManageStore.templateName); _this.setState({ showSearchAd: false }); } }, getLabel(387355, "搜索")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@krq5mx@templateName", type: "ghost", onClick: function () { templateManageStore.templateName = ''; } }, getLabel(2022, "重置")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@6jk34y@cancel", type: "ghost", onClick: function () {
                                _this.setState({ showSearchAd: false });
                            } }, getLabel(201, "取消"))
                    ] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTable"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTable@0t3kvo", loading: templateManageStore.loading, columns: templateManageStore.columns, dataSource: templateManageStore.templateListDatas, pagination: templateManageStore.pagination, onChange: function (pagination) { templateManageStore.handleTableChange(pagination); } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EidtTemplate__["a" /* EidtTemplateDialog */], { ecId: (this && this.props && this.props.ecId || '') + "_EidtTemplateDialog@8c9wbz", templateManageStore: templateManageStore }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SetTemplateColumn__["a" /* SetTemplateColumnDialog */], { ecId: (this && this.props && this.props.ecId || '') + "_SetTemplateColumnDialog@mhin7y", templateManageStore: templateManageStore }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SetCustomCondition__["a" /* SetCustomConditionDialog */], { ecId: (this && this.props && this.props.ecId || '') + "_SetCustomConditionDialog@s43loy", templateManageStore: templateManageStore })));
    };
    TemplateList = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TemplateList);
    return TemplateList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TemplateList);


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EidtTemplateDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var EidtTemplate = /** @class */ (function (_super) {
    __extends(EidtTemplate, _super);
    function EidtTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EidtTemplate.prototype.render = function () {
        var _this = this;
        var templateManageStore = this.props.templateManageStore;
        var formParams = templateManageStore.form.getFormParams();
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, templateManageStore.fields.map(function (d, idn) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "wea-search-group", style: d.hide ? { display: 'none' } : {} },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaFormItem"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaFormItem@ev02ho@" + idn, label: d.label, labelCol: { span: d.labelcol }, wrapperCol: { span: d.fieldcol }, error: templateManageStore.form.getError(d), tipPosition: "bottom" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_comsMobx__["WeaSwitch"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaSwitch@46ccfh@" + idn, fieldConfig: d, form: templateManageStore.form, formParams: formParams }))));
        })));
    };
    EidtTemplate = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], EidtTemplate);
    return EidtTemplate;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (EidtTemplate);
var EidtTemplateDialog = /** @class */ (function (_super) {
    __extends(EidtTemplateDialog, _super);
    function EidtTemplateDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EidtTemplateDialog.prototype.render = function () {
        var templateManageStore = this.props.templateManageStore;
        var iconInfo = templateManageStore.iconInfo;
        var buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@v9w1of@visible", onClick: function () { templateManageStore.visible = false; } }, getLabel(309, "关闭")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@y9sap4@save", type: "primary", loading: templateManageStore.loading, onClick: function () { templateManageStore.save(); } }, getLabel(86, '保存'))];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@sgmxx7", className: 'wea-auth-modal cube-dialog', buttons: buttons, title: templateManageStore.form.getFormParams().id ? getLabel(532924, '编辑模板') : getLabel(532925, '新建模板'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: templateManageStore.visible, style: { width: 520, height: 260 }, hasScroll: true, onCancel: function () { templateManageStore.visible = false; } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EidtTemplate, { ecId: (this && this.props && this.props.ecId || '') + "_EidtTemplate@09kp8n", templateManageStore: templateManageStore })));
    };
    EidtTemplateDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], EidtTemplateDialog);
    return EidtTemplateDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetTemplateColumnDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var SetTemplateColumn = /** @class */ (function (_super) {
    __extends(SetTemplateColumn, _super);
    function SetTemplateColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetTemplateColumn.prototype.render = function () {
        var templateManageStore = this.props.templateManageStore;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@plgmrq", datas: [{
                        key: 'save',
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-Preservation' }),
                        content: getLabel(86, '保存', 'label'),
                    }, {
                        key: 'close',
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: 'icon-coms-Return' }),
                        content: getLabel(309, "关闭"),
                    }], onClick: function (key) {
                    if (key == 'save') {
                        templateManageStore.saveTemplateField();
                    }
                    else if (key == 'close') {
                        templateManageStore.visible_set = false;
                    }
                } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTableEdit"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTableEdit@kd9ey2", isModalEdit: false, columns: templateManageStore.columnsSet, showAdd: false, showDelete: false, showCopy: false, datas: Object(__WEBPACK_IMPORTED_MODULE_3_mobx__["toJS"])(templateManageStore.DatasSet), getRowSelection: function () { return null; }, onChange: function (data) {
                        templateManageStore.DatasSet = data;
                    } }))));
    };
    SetTemplateColumn = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], SetTemplateColumn);
    return SetTemplateColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (SetTemplateColumn);
var SetTemplateColumnDialog = /** @class */ (function (_super) {
    __extends(SetTemplateColumnDialog, _super);
    function SetTemplateColumnDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetTemplateColumnDialog.prototype.render = function () {
        var templateManageStore = this.props.templateManageStore;
        var iconInfo = templateManageStore.iconInfo;
        var buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@i4cihg@visible_set", onClick: function () { templateManageStore.visible_set = false; } }, getLabel(309, "关闭")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@0oj42n@saveTemplateField", type: "primary", loading: templateManageStore.loading, onClick: function () { templateManageStore.saveTemplateField(); } }, getLabel(86, '保存'))];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@of1s5w", className: 'wea-auth-modal cube-dialog', buttons: buttons, title: getLabel(84342, '查询条件字段定义'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: templateManageStore.visible_set, style: { width: 700, height: 500 }, hasScroll: true, onCancel: function () { templateManageStore.visible_set = false; } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SetTemplateColumn, { ecId: (this && this.props && this.props.ecId || '') + "_SetTemplateColumn@zvsfb9", templateManageStore: templateManageStore })));
    };
    SetTemplateColumnDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], SetTemplateColumnDialog);
    return SetTemplateColumnDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetCustomConditionDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_list_AdvancedSearchs__ = __webpack_require__(155);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var SetCustomCondition = /** @class */ (function (_super) {
    __extends(SetCustomCondition, _super);
    function SetCustomCondition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetCustomCondition.prototype.render = function () {
        var templateManageStore = this.props.templateManageStore;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_list_AdvancedSearchs__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_AdvancedSearchs@5300gz", form: templateManageStore.conditionForm, conditioninfo: templateManageStore.conditionInfo })));
    };
    SetCustomCondition = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], SetCustomCondition);
    return SetCustomCondition;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (SetCustomCondition);
var SetCustomConditionDialog = /** @class */ (function (_super) {
    __extends(SetCustomConditionDialog, _super);
    function SetCustomConditionDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetCustomConditionDialog.prototype.render = function () {
        var templateManageStore = this.props.templateManageStore;
        var iconInfo = templateManageStore.iconInfo;
        var buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@qp5kye@visible_set_condition", onClick: function () { templateManageStore.visible_set_condition = false; } }, getLabel(309, "关闭")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@lagirk@saveCustomCondition", type: "primary", loading: templateManageStore.loading, onClick: templateManageStore.saveCustomCondition }, getLabel(86, '保存'))];
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@y2v2pk", className: 'wea-auth-modal cube-dialog', buttons: buttons, title: getLabel(83142, '查询条件定义', 'label'), iconBgcolor: iconInfo.iconBg || "#96358a", icon: iconInfo.icon || 'icon-coms-ModelingEngine', iconFontColor: iconInfo.iconColor || "#fff", visible: templateManageStore.visible_set_condition, style: { width: 1024, height: 600 }, hasScroll: true, onCancel: function () { templateManageStore.visible_set_condition = false; } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SetCustomCondition, { ecId: (this && this.props && this.props.ecId || '') + "_SetCustomCondition@gxsayq", templateManageStore: templateManageStore })));
    };
    SetCustomConditionDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], SetCustomConditionDialog);
    return SetCustomConditionDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Container__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comsMobx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comsMobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_comsMobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_board_css__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_board_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__css_board_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quickSearch__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_no_right__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mobx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__list_AdvancedSearchs__ = __webpack_require__(155);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;
var getTop = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTools"].WindowFunc.getTop;
var Board = /** @class */ (function (_super) {
    __extends(Board, _super);
    function Board(props) {
        var _this = _super.call(this, props) || this;
        //nosearch 是否需要查询(单行文本的变动不需要进行查询)
        _this.onChange = function (fieldid, value, nosearch) {
            var boardStore = _this.props.boardStore;
            var quickSearchFormData = boardStore.quickSearchFormData, quickSearchData = boardStore.quickSearchData;
            var _a = quickSearchData.quicksearchinfo, quicksearchinfo = _a === void 0 ? [] : _a;
            __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.set(quickSearchFormData, fieldid, value);
            var resetDate = {};
            //默认值与选择值的筛选，当选择值后，默认值就不会上传，以选择值为主
            quicksearchinfo.map(function (item) {
                var handleItem = function (item) {
                    if (!quickSearchFormData[item.fieldid] && quickSearchFormData[item.fieldid] != '') {
                        if (item.value && item.value != "") {
                            resetDate[item.fieldid] = item.value;
                        }
                        else if (item.fieldhtmltype == "1" && item.fieldtype != '1') { //浮点数整数单独解析
                            var options = item.options;
                            options.map(function (key) {
                                var selected = key.selected;
                                if (selected) {
                                    resetDate[item.fieldid] = key.key;
                                }
                            });
                        }
                        else if (item.fieldhtmltype == "3" && item.fieldtype != '1' && item.fieldtype != '2' && item.fieldtype != '19' && item.fieldtype != '290') { //浏览框也单独解析
                            var replaceDatas = item.replaceDatas;
                            var ids_1 = "";
                            replaceDatas && replaceDatas.map(function (rep) {
                                var id = rep.id;
                                ids_1 += id + ",";
                            });
                            ids_1 = ids_1.substring(0, ids_1.length - 1);
                            resetDate[item.fieldid] = ids_1;
                        }
                    }
                    if (item.fieldid == fieldid && item.fieldhtmltype == '5' && item.fieldtype == '1') {
                        boardStore.changeQuickSearchData(item.domkey[0]);
                    }
                };
                if (item.hasOwnProperty('searchGroup')) {
                    item.searchGroup.forEach(function (field) {
                        handleItem(field);
                    });
                }
                else {
                    handleItem(item);
                }
            });
            if (!nosearch) {
                var parm = __assign({ isQuickSearch: "1", boardid: boardStore.boardid }, boardStore.quickSearchFormData, resetDate, { isOnlyQuick: '1' });
                boardStore.doSearch(parm);
            }
        };
        _this.getOrderStyle = function (element, type) {
            var boardStore = _this.props.boardStore;
            if (element.fieldid == boardStore.orderInfo.fieldid && type == boardStore.orderInfo.type) {
                return { color: 'rgb(34, 215, 187)' };
            }
            return {};
        };
        _this.renderSearchAdPanel = function (boardStore) {
            //窗口变化后，重新计算高级搜索的面板位置。如果查询条件默认展开，使用默认位置，不计算。
            //if(!boardStore.isShowCondition){
            try {
                var hei = __WEBPACK_IMPORTED_MODULE_12_jquery___default()('.cube_board .wea-tab .ant-row').height() || 46;
                __WEBPACK_IMPORTED_MODULE_12_jquery___default()('.cube_board .wea-tab .wea-search-container ').css({ top: hei });
            }
            catch (e) { }
            //}
        };
        _this.tabsetShowSearchAd = function (bool) {
            var boardStore = _this.props.boardStore;
            _this.setState({
                showSearchAd: bool
            });
            if (bool) {
                _this.renderSearchAdPanel(boardStore);
            }
        };
        _this.cancel = function () {
            _this.setState({
                showSearchAd: false
            });
        };
        _this.state = { showSearchAd: false, orderVisible: false, deleteOrderVisible: false };
        var boardStore = props.boardStore;
        window.onresize = function () {
            boardStore.windowHeight = window.innerHeight;
            boardStore.windowWidth = window.innerWidth;
        };
        return _this;
    }
    Board.prototype.componentWillMount = function () {
        var _a = this.props, boardStore = _a.boardStore, location = _a.location;
        boardStore.boardid = location['query'].boardid || '';
        boardStore.resourceid = location['query'].rootId || location['query'].rootid || '';
        boardStore.fromPageExpend = location['query'].fromPageExpend || '';
    };
    Board.prototype.componentDidMount = function () {
        var boardStore = this.props.boardStore;
        window['cube_board_open_dialog'] = boardStore.cube_board_open_dialog;
        getTop()['current_boardStore'] = boardStore;
        boardStore.windowHeight = window.innerHeight;
        boardStore.windowWidth = window.innerWidth;
    };
    Board.prototype.componentDidUpdate = function () {
        var _this = this;
        var _a = this.props, boardStore = _a.boardStore, location = _a.location;
        var boardid = location['query'].boardid || '';
        var rootid = location['query'].rootId || location['query'].rootid || '';
        if (boardid != boardStore.boardid || rootid != boardStore.resourceid) {
            boardStore.datas = {};
            boardStore.conditionInfo = [];
            boardStore.datasIdList = [];
            boardStore.statusList = [];
            boardStore.form = new __WEBPACK_IMPORTED_MODULE_5_comsMobx__["WeaForm"]();
            boardStore.orderField = [];
            boardStore.boardid = boardid;
            boardStore.resourceid = rootid;
            boardStore.initData();
        }
        var doSearch = function () {
            boardStore.doSearch();
            _this.setState({ showSearchAd: false });
        };
        Object(__WEBPACK_IMPORTED_MODULE_7__util__["addEnterFun"])(doSearch);
    };
    Board.prototype.render = function () {
        var _this = this;
        var boardStore = this.props.boardStore;
        var quickSearchData = boardStore.quickSearchData;
        var doSearch = function () {
            boardStore.doSearch();
            _this.setState({ showSearchAd: false });
        };
        var leftMargin = '10%';
        if (boardStore.windowTitle != '') {
            document.title = boardStore.windowTitle;
        }
        return !boardStore.hasSearcgRight ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__pages_no_right__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_NoRightPage@11dptu" })
            : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube_board" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@liywx9", spinning: boardStore.data_loading },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaTab"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTab@nz6hry", searchType: boardStore.isAdvanceSearch ? ['advanced'] : [], showSearchAd: this.state.showSearchAd, setShowSearchAd: this.tabsetShowSearchAd, replaceLeft: quickSearchData.isHasQuickSearch &&
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__quickSearch__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_QuickSearch@yvl2vt", datas: quickSearchData.quicksearchinfo, listStore: boardStore, onChange: this.onChange }), leftStyle: {
                            width: "100%",
                            paddingRight: leftMargin,
                            boxSizing: "border-box"
                        }, buttons: boardStore.orderField && boardStore.orderField.length > 0 ? [
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onMouseOver: function () { boardStore.orderInfo.type && _this.setState({ deleteOrderVisible: true }); }, onMouseLeave: function () { boardStore.orderInfo.type && _this.setState({ deleteOrderVisible: false }); }, style: boardStore.orderInfo.type ? { width: '90px', textAlign: 'left' } : { width: '90px', textAlign: 'center' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Popover"], { ecId: (this && this.props && this.props.ecId || '') + "_Popover@4ygscw@", placement: "bottomRight", content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { lineHeight: '25px' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", null, boardStore.orderField && boardStore.orderField.map(function (element, index) {
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, element.fieldlabelname)),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { float: 'right', cursor: 'pointer' }, onClick: function () {
                                                            boardStore.changeOrder(element.fieldid, element.fieldlabelname, element.fieldname, element.viewtype, element.fielddbtype, 'a');
                                                            _this.setState({ orderVisible: false });
                                                        } },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@a2cddc@", style: _this.getOrderStyle(element, 'a'), type: "arrow-up" }))),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { float: 'right', cursor: 'pointer', marginRight: '5px' }, onClick: function () {
                                                            boardStore.changeOrder(element.fieldid, element.fieldlabelname, element.fieldname, element.viewtype, element.fielddbtype, 'd');
                                                            _this.setState({ orderVisible: false });
                                                        } },
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@hdvf2w@", style: _this.getOrderStyle(element, 'd'), type: "arrow-down" }))));
                                        }))), trigger: "click", visible: this.state.orderVisible, onVisibleChange: function (visible) { return _this.setState({ orderVisible: visible }); } }, boardStore.orderInfo.type ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { title: boardStore.orderInfo.fieldlabelname, style: { width: '66px', textAlign: 'right', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', float: 'left', cursor: 'pointer' } }, boardStore.orderInfo.fieldlabelname),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Icon"], { ecId: (this && this.props && this.props.ecId || '') + "_Icon@nw7qpu@" + boardStore.orderInfo.type, type: boardStore.orderInfo.type == 'a' ? "arrow-up" : "arrow-down" }))
                                    : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { cursor: 'pointer', fontSize: '20px', marginTop: '13px', display: 'block' }, title: getLabel(338, "排序"), className: "icon-mode-paixu" })),
                                this.state.deleteOrderVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { cursor: 'pointer' }, title: getLabel(389169, "删除排序"), onClick: function () {
                                        boardStore.clearOrderInfo();
                                        _this.setState({ deleteOrderVisible: false });
                                    }, className: "icon-coms-Clear" }))
                        ] : [], buttonsAd: [
                            (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@2aufuk@doSearch", type: "primary", onClick: doSearch }, getLabel(387355, "搜索"))),
                            (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@gpuip7@resetForm", type: "ghost", onClick: function () { return boardStore.form.resetForm(); } }, getLabel(2022, "重置"))),
                            (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@7vvrfk@cancel", type: "ghost", onClick: this.cancel }, getLabel(201, "取消")))
                        ], searchsAd: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__list_AdvancedSearchs__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_AdvancedSearchs@i5aiwc", form: boardStore.form, conditioninfo: boardStore.conditionInfo, quickSearch: doSearch }), advanceHeight: 'auto' }),
                    undefined != boardStore.checkAdvanedData && boardStore.checkAdvanedData != '' ?
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Alert"], { ecId: (this && this.props && this.props.ecId || '') + "_Alert@9n44zh", message: Object(__WEBPACK_IMPORTED_MODULE_11_mobx__["toJS"])(boardStore.checkAdvanedData), type: "warning", closable: true, onClose: function (v) {
                                window.console && console.log("Search.checkAdvanedData:", boardStore.checkAdvanedData);
                            } }) : '',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Container__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Container@p8q503" }, this.props)),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@5k1hd9", onCancel: function () { boardStore.cardDiag_visible = false; }, visible: boardStore.cardDiag_visible, style: { width: boardStore.windowWidth - 50, height: boardStore.windowHeight - 60 }, hasScroll: true, url: boardStore.cardDiag_url, className: "cube_board_dialog" })));
    };
    Board = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('boardStore'),
        __WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"]
    ], Board);
    return Board;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Board);


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Column__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_compatible__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ColumnAdd__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Container.prototype.componentDidMount = function () {
        var boardStore = this.props.boardStore;
        var jsFiles = [];
        if (!__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].isBelowIE9()) {
            jsFiles.push('/formmode/e9resource/boardjs/web-animations.min.js');
        }
        jsFiles = jsFiles.concat(['/formmode/e9resource/boardjs/hammer.min.js', '/formmode/e9resource/boardjs/muuri.js']);
        if (!__WEBPACK_IMPORTED_MODULE_1_loadjs___default.a.isDefined('boardjs')) {
            __WEBPACK_IMPORTED_MODULE_1_loadjs___default()(jsFiles, 'boardjs', {
                success: function () {
                    boardStore.initData();
                }
            });
        }
        else {
            boardStore.initData();
        }
        Object(__WEBPACK_IMPORTED_MODULE_5__util_compatible__["a" /* MouseWheelFun */])('cube_board_container', 'cube_board');
    };
    Container.prototype.render = function () {
        var _this = this;
        var boardStore = this.props.boardStore;
        var height = boardStore.windowHeight - __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#btnDiv').height();
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { id: 'cube_board_container', className: "cube_board_container", style: { height: height } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cube_board", className: "board muuri", style: { height: '100%' } },
                boardStore.datasIdList.map(function (element) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Column__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Column@nyodjj@" + boardStore.timestamp + element, key: boardStore.timestamp + "" + element, element: element, boardStore: boardStore });
                }),
                boardStore.hasRight &&
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ColumnAdd__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ColumnAdd@5499jk", key: boardStore.boardid + "_" + boardStore.resourceid + "_" + boardStore.timestamp, sureFun: boardStore.addColumn, defaultTabSet: boardStore.defaultTabSet })));
    };
    Container = __decorate([
        __WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"]
    ], Container);
    return Container;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Container);


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Item__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MyProgress__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mobx__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaLocaleProvider"].getLabel;
var Column = /** @class */ (function (_super) {
    __extends(Column, _super);
    function Column(props) {
        var _this = _super.call(this, props) || this;
        _this.isShow = false; //是否依然显示
        //设置的每页显示数不够一页显示，鼠标移动上去自动加载下一页
        _this.divScroll = function () {
            var boardStore = _this.props.boardStore;
            var id = _this.getData.id;
            var divscroll = document.getElementById("board-column-content-scroll" + id);
            var wholeHeight = divscroll.scrollHeight;
            var scrollTop = divscroll.scrollTop;
            var divHeight = divscroll.clientHeight;
            if (scrollTop + divHeight >= wholeHeight) {
                if (boardStore.changePage(id)) {
                    _this.setState({ loading: true });
                    setTimeout(function () {
                        _this.setState({ loading: false });
                        _this.divScroll();
                    }, 500);
                }
            }
        };
        _this.doMouseOver = function (e) {
            e.target.style.backgroundColor = 'rgb(222, 240, 255)';
        };
        _this.doMouseOut = function (e) {
            e.target.style.backgroundColor = '';
        };
        _this.movePoverVisibleChange = function (visible) {
            if (!visible && !_this.isShow) {
                _this.setState({ changeGroupVisible: visible, btnVisible: false });
            }
            else {
                _this.setState({ changeGroupVisible: visible });
            }
        };
        _this.getBtn = function () {
            var boardStore = _this.props.boardStore;
            var data = _this.getData;
            var btn = [];
            var divStyle = { padding: '3px 10px 3px 10px', cursor: 'pointer' };
            if (boardStore.canAdd) {
                btn.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onMouseOver: function (e) { _this.doMouseOver(e); _this.isShow = true; }, onMouseOut: _this.doMouseOut, onClick: function () { boardStore.addItem(data); _this.setState({ btnVisible: false }); }, style: divStyle }, getLabel(389167, "添加新数据")));
            }
            if (boardStore.hasRight && boardStore.boardGrid && boardStore.datas) {
                var items = boardStore.boardGrid.getItems();
                var groups = [];
                for (var i = 0; i < items.length - 1; i++) {
                    var groupid = items[i]._element.getAttribute('id').replace('column_', '');
                    var groupname = boardStore.datas[groupid] ? boardStore.datas[groupid].title : '';
                    groups.push({ groupid: groupid, groupname: groupname });
                }
                if (groups.length > 0) {
                    btn.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onMouseOver: function (e) { _this.doMouseOver(e); _this.isShow = true; }, onMouseOut: _this.doMouseOut },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Popover"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Popover@6vhtnr@cubeBoardPopover1", overlayClassName: "cubeBoardPopover1", placement: "rightTop", content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { lineHeight: '25px' } }, groups.map(function (item) {
                                if (item.groupid != data.id) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onMouseOver: _this.doMouseOver, onMouseOut: _this.doMouseOut, onClick: function () { boardStore.changeGroup(data.id, item.groupid, data.title, item.groupname); _this.setState({ btnVisible: false, changeGroupVisible: false }); }, style: divStyle }, item.groupname);
                                }
                            })), trigger: "hover", visible: _this.state.changeGroupVisible, onVisibleChange: _this.movePoverVisibleChange },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: divStyle },
                                getLabel(389168, "移动列表数据到"),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Icon@6wpy4x@cubeBoardPopovericon", style: { float: 'right', cursor: 'pointer', marginTop: '5px' }, type: "caret-right", theme: "outlined" })))));
                }
            }
            if (data.id != 'ungrouped' && boardStore.hasRight && boardStore.defaultTabSet != "2") {
                btn.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onMouseOver: function (e) { _this.doMouseOver(e); _this.isShow = true; }, onMouseOut: _this.doMouseOut, onClick: function () { boardStore.removeColumn(data.id); _this.setState({ btnVisible: false }); }, style: divStyle }, getLabel(130629, "删除分组")));
                btn.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function () {
                        _this.setState({ isEdit: true, btnVisible: false });
                    }, onMouseOver: function (e) { _this.doMouseOver(e); _this.isShow = true; }, onMouseOut: _this.doMouseOut, style: divStyle }, getLabel(83149, "编辑分组")));
            }
            return btn;
        };
        _this.colors = ['#22D7BB', '#FED47B', '#F44336', '#9C27B0', '#3F51B5', '#2196F3', '#00BCD4', '#8BC34A', '#FFEB3B', '#FF9800', '#795548', '#CDDC39', '#009688'];
        _this.btnsPoverVisisbleChange = function (visible) {
            if (_this.state.changeGroupVisible) {
                _this.setState({ btnVisible: true });
            }
            else {
                _this.setState({ btnVisible: visible });
            }
        };
        _this.state = { btnVisible: false, changeGroupVisible: false, isEdit: false, title: _this.getData.title, loading: false };
        return _this;
    }
    Object.defineProperty(Column.prototype, "getData", {
        get: function () {
            var _a = this.props, datas = _a.boardStore.datas, element = _a.element;
            return datas[element];
        },
        enumerable: true,
        configurable: true
    });
    Column.prototype.componentDidMount = function () {
        var _this = this;
        //新增Column元素，当前元素渲染到页面上后将元素添加到muuri
        var boardStore = this.props.boardStore;
        var id = this.getData.id;
        if (id.endsWith('_new')) {
            var element = document.getElementById('column_' + id);
            var column = boardStore.boardGrid.add([element], { index: boardStore.boardGrid._items.length - 2 });
            boardStore.initItem(column[0]._element.querySelector('.board-column-content'));
        }
        //div滚动加载
        var divscroll = document.getElementById("board-column-content-scroll" + id);
        divscroll.onscroll = function () {
            var wholeHeight = divscroll.scrollHeight;
            var scrollTop = divscroll.scrollTop;
            var divHeight = divscroll.clientHeight;
            if (scrollTop + divHeight >= wholeHeight) {
                if (boardStore.changePage(id)) {
                    _this.setState({ loading: true });
                    setTimeout(function () {
                        _this.setState({ loading: false });
                    }, 500);
                }
            }
        };
    };
    Column.prototype.componentDidUpdate = function () {
        if (this.refs.editTitle) {
            this.refs.editTitle['refs'].inputNormal.refs.input.refs.input.focus();
        }
    };
    Column.prototype.render = function () {
        var _this = this;
        this.isShow = false;
        var boardStore = this.props.boardStore;
        var data = this.getData;
        if (data === undefined) { //空数据检测
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
        }
        var status = data.status;
        var counts = [];
        var progress = boardStore.statusList.map(function (item) {
            counts.push(status[item]);
            if (data.itemCount && data.itemCount != 0) {
                return status[item] / data.itemCount * 100;
            }
            else {
                return 0;
            }
        });
        var btn = this.getBtn();
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "column_" + data.id, className: "board-column muuri-item muuri-item-shown" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "board-column-header", style: ((boardStore.hasRight && data.id != 'ungrouped') && boardStore.defaultTabSet != "2") ? { cursor: 'move' } : {} },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: '15px 10px 5px 10px' } },
                    !this.state.isEdit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onDoubleClick: function () { if (data.id == 'ungrouped' || !boardStore.hasRight || boardStore.defaultTabSet == "2")
                            return; _this.setState({ isEdit: true }); } }, data.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaInput"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@tlw80i", style: { width: 80, cursor: 'pointer' }, value: this.state.title, ref: "editTitle", onBlur: function () {
                            _this.setState({ isEdit: false });
                            if (_this.state.title != data.title) {
                                boardStore.updateGroupName(data.id, _this.state.title);
                                data.title = _this.state.title;
                            }
                        }, onChange: function (value) {
                            _this.setState({ title: value });
                        } }),
                    "\u00A0\u00A0",
                    boardStore.defaultTabSet == "2" ?
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#f00' } },
                            counts.map(function (item, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: boardStore.allStatusMap[boardStore.statusList[index]] }, item);
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: "\u5168\u90E8" }, data && data.itemCount && '(' + data.itemCount + ')' || '(0)'))
                        : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { color: '#BDC0CB' } },
                            counts.map(function (item, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: boardStore.allStatusMap[boardStore.statusList[index]], style: { color: _this.colors[index] } }, item),
                                    "/");
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: "\u5168\u90E8" }, data && data.itemCount && data.itemCount || 0)),
                    btn.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Popover"], { ecId: (this && this.props && this.props.ecId || '') + "_Popover@45nrre", overlayClassName: "cubeBoardPopover", placement: "bottomRight", content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { lineHeight: '25px' } }, btn), trigger: "hover", visible: this.state.btnVisible, onVisibleChange: this.btnsPoverVisisbleChange },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (this && this.props && this.props.ecId || '') + "_Icon@9qd5na", style: { float: 'right', cursor: 'pointer' }, type: "ellipsis" }))),
                boardStore.defaultTabSet != "2" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: '0px 10px 10px 10px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MyProgress__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_MyProgress@v8gbjt", statusList: boardStore.statusList, allStatusMap: boardStore.allStatusMap, datas: progress, colors: this.colors }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onMouseEnter: function () { boardStore.isScroll = true; _this.divScroll(); }, onMouseLeave: function () { return boardStore.isScroll = false; }, id: "board-column-content-scroll" + data.id, style: boardStore.isScroll ? { 'maxHeight': (boardStore.windowHeight - 190) + "px", display: 'block', overflow: 'auto' } : { 'maxHeight': (boardStore.windowHeight - 190) + "px", display: 'block', overflow: 'hidden' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "column_content_" + data.id, className: "board-column-content muuri" }, data.itemIdList && data.itemIdList.map(function (element) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Item__["a" /* default */], { ecId: (_this && _this.props && _this.props.ecId || '') + "_Item@c5jwqs@" + boardStore.timestamp + element, key: boardStore.timestamp + "" + element, data: data.item[element], hasRight: boardStore.hasRight, columnGrid: boardStore.columnGrids_map["column_content_" + data.id], isTitle: boardStore.isTitle, store: boardStore });
                })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: "center" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@c3ytft", spinning: this.state.loading }))),
            boardStore.canAdd && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: '40px', padding: '10px 0px 0px 10px', cursor: 'pointer' }, onClick: function () { return boardStore.addItem(data); } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Icon"], { ecId: (this && this.props && this.props.ecId || '') + "_Icon@sitd30", type: "plus" }),
                "\u00A0",
                getLabel(389167, "添加新数据")));
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_6_mobx__["computed"]
    ], Column.prototype, "getData", null);
    Column = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], Column);
    return Column;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Column);


/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var getLabel = __WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaLocaleProvider"].getLabel;

var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Item.prototype.componentDidMount = function () {
        var store = this.props.store;
        //新增Column元素，当前元素渲染到页面上后将元素添加到muuri
        var _a = this.props, data = _a.data, columnGrid = _a.columnGrid;
        if (data.iscreate && data.iscreate == '1') {
            var element = document.getElementById('item_' + data.id);
            var item = columnGrid.add([element], { index: 0 });
            var scrollElement = item[0].getGrid()._element.parentNode;
            if (scrollElement.scrollTop != 0) {
                scrollElement.scrollTop = 0;
            }
        }
        var height = store.windowHeight - __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube_board #btnDiv').height();
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.cube_board #cube_board').css('height', height);
    };
    Item.prototype.render = function () {
        var _a = this.props, data = _a.data, isTitle = _a.isTitle, hasRight = _a.hasRight, store = _a.store;
        if (data === undefined) { //空数据检测
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
        }
        var right = hasRight ? true : false;
        if (store.defaultTabSet == '2' && data.sharelevel < 2) {
            right = false;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { "data-showlevel": data.sharelevel, id: "item_" + data.id, className: "board-item muuri-item muuri-item-shown" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "board-item-content", style: right ? { cursor: 'move' } : { cursor: 'not-allowed' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@cb6i92", className: "status-principal" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@ss1y2b", span: 16 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { backgroundColor: '#FEEEEE', padding: '3px 5px 3px 5px', borderRadius: '5px', textAlign: 'center' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Icon"], { ecId: (this && this.props && this.props.ecId || '') + "_Icon@pve1oa", style: { color: '#FA5D4B' }, type: "minus-circle-o" }),
                            "\u00A0\u00A0",
                            data.statusText)),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@mumx8o", span: 8, style: { textAlign: 'right' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: data.principal } }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@epiyx7" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@3zx34z", span: 24, style: { fontSize: '15px', padding: '5px 0px 5px 0px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: isTitle == '1' ? { cursor: 'pointer' } : {}, id: "boardItemTitle", dangerouslySetInnerHTML: { __html: data.title } }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@fh5hmk", className: "date-manager" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@pd4qpe", span: 16 },
                        getLabel(22326, "截止日期"),
                        ":",
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: data.enddate } })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@f46mdy", span: 8, title: getLabel(389170, "直接下级个数"), style: { textAlign: 'right' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-coms-DisplaySubordinates" }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: data.manager } }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@9g0ycj", style: { fontSize: '12px', padding: '5px 0px 5px 0px', color: 'white' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@4arev1", span: 20, style: { lineHeight: '22px' } }, data.modelableid && data.modelableid.map(function (element) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { style: { display: 'inline-block', borderColor: element.bdcolor, color: element.color, backgroundColor: element.bgcolor, padding: '0px 5px', borderRadius: '5px', textAlign: 'center', margin: '2px 5px 2px 0px' } }, element.tabname);
                    })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@5o3htr", style: { color: 'red', textAlign: 'right', 'word-break': 'break-all' }, span: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: data.progress } })))));
    };
    return Item;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Item);


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MyProgress = /** @class */ (function (_super) {
    __extends(MyProgress, _super);
    function MyProgress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyProgress.prototype.render = function () {
        var _a = this.props, datas = _a.datas, colors = _a.colors, allStatusMap = _a.allStatusMap, statusList = _a.statusList;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { backgroundColor: '#e2e2e2', height: '4px', marginTop: '12px', borderRadius: '2px' } }, datas.map(function (element, index) {
            var style = { backgroundColor: colors[index], height: '4px', width: element + '%', float: 'left' };
            style['borderRadius'] = '2px';
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { title: allStatusMap[statusList[index]], style: style });
        }));
    };
    return MyProgress;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (MyProgress);


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MouseWheelFun; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var firefox = navigator.userAgent.indexOf('Firefox') != -1;
//鼠标滚轮事件
var MouseWheel = function (e, srcElementId) {
    e = e || window.event;
    var scrollLength = 100;
    if (e && e.srcElement && e.srcElement.id && e.srcElement.id == srcElementId) {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        else {
            e.cancelBubble = true;
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        else {
            e.returnValue = false;
        }
        var borderDiv = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#cube_board_container');
        if (firefox) {
            if (e.detail < 0) {
                borderDiv.scrollLeft(borderDiv.scrollLeft() - scrollLength);
            }
            else {
                borderDiv.scrollLeft(borderDiv.scrollLeft() + scrollLength);
            }
        }
        else {
            if (e.wheelDelta > 0) {
                borderDiv.scrollLeft(borderDiv.scrollLeft() - scrollLength);
            }
            else {
                borderDiv.scrollLeft(borderDiv.scrollLeft() + scrollLength);
            }
        }
    }
};
var MouseWheelFun = function (elementId, srcElementId) {
    var element = document.getElementById(elementId);
    firefox ? element.addEventListener('DOMMouseScroll', function (e) { return MouseWheel(e, srcElementId); }, false) : (element.onmousewheel = function (e) { return MouseWheel(e, srcElementId); });
};


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var ColumnAdd = /** @class */ (function (_super) {
    __extends(ColumnAdd, _super);
    function ColumnAdd(props) {
        var _this = _super.call(this, props) || this;
        _this.headerClick = function () {
            if (!_this.state.isAdd) {
                _this.setState({ isAdd: true });
            }
        };
        _this.addChange = function (v) { _this.setState({ name: v }); };
        _this.sureClick = function () {
            var sureFun = _this.props.sureFun;
            sureFun && sureFun(_this.state.name);
            _this.setState({ name: '', isAdd: false });
        };
        _this.cancel = function () { _this.setState({ isAdd: false }); };
        _this.state = { isAdd: false, name: '' };
        return _this;
    }
    ColumnAdd.prototype.render = function () {
        var defaultTabSet = this.props.defaultTabSet;
        var headerStyle = { 'cursor': 'pointer' };
        if (this.state.isAdd) {
            headerStyle['height'] = '95px';
        }
        if (defaultTabSet == "2") {
            headerStyle['display'] = 'none';
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "board-column muuri-item muuri-item-shown" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "board-column-header", style: headerStyle, onClick: this.headerClick }, !this.state.isAdd ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { textAlign: 'center', height: '100%', paddingTop: '20px', fontSize: '15px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Icon"], { ecId: (this && this.props && this.props.ecId || '') + "_Icon@0gguxh", style: { color: '#67DAC4' }, type: "plus" }),
                "\u00A0\u00A0\u00A0\u00A0",
                getLabel(30131, "新建分组")) :
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { padding: '5px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@2ekrnd", style: { marginTop: '10px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@j74758", span: 24 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaInput"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaInput@kpa9m2", isBase64: true, inputType: 'multilang', style: { borderColor: '#67DAC4', borderRadius: '5px' }, value: this.state.name, onChange: this.addChange }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Row"], { ecId: (this && this.props && this.props.ecId || '') + "_Row@b76eeh", style: { marginTop: '10px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@7g49ap", span: 4 }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@k1kscb", span: 8 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@mq0o55", onClick: this.sureClick, style: { backgroundColor: '#67DAC4', borderColor: '#67DAC4' }, type: "primary" }, getLabel(382958, "确定"))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@mbjdaj", span: 8 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@d2agij", onClick: this.cancel }, getLabel(201, "取消"))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd__["Col"], { ecId: (this && this.props && this.props.ecId || '') + "_Col@1uafgj", span: 4 })))));
    };
    ColumnAdd = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_mobx_react__["observer"]
    ], ColumnAdd);
    return ColumnAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ColumnAdd);


/***/ }),
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Container__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_timeline_css__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_timeline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_timeline_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var DisplayBoard = /** @class */ (function (_super) {
    __extends(DisplayBoard, _super);
    function DisplayBoard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisplayBoard.prototype.componentWillMount = function () {
        var _a = this.props, timelineStore = _a.timelineStore, location = _a.location;
        timelineStore.param = location['query'];
    };
    DisplayBoard.prototype.render = function () {
        var timelineStore = this.props.timelineStore;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube_timeline", style: { height: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@gjrqjc", spinning: timelineStore.loading },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Container__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Container@09nj7l" }, this.props))));
    };
    DisplayBoard = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('timelineStore'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DisplayBoard);
    return DisplayBoard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DisplayBoard);


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Container.prototype.componentDidMount = function () {
        var timelineStore = this.props.timelineStore;
        var jsFiles = [];
        jsFiles = jsFiles.concat(['/formmode/e9resource/timeline/moment.js', '/formmode/e9resource/timeline/vis.min.js', '/formmode/e9resource/timeline/vis.min.css', '/formmode/e9resource/timeline/template.js']);
        if (!__WEBPACK_IMPORTED_MODULE_2_loadjs___default.a.isDefined('vis')) {
            __WEBPACK_IMPORTED_MODULE_2_loadjs___default()(jsFiles, 'vis', {
                success: function () {
                    timelineStore.init();
                }
            });
        }
        else {
            timelineStore.init();
        }
    };
    Container.prototype.render = function () {
        var timelineStore = this.props.timelineStore;
        if (timelineStore.hasData) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "cube_timeline_container", className: "cube_timeline_container", style: { overflow: 'hidden' } });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { position: 'relative', height: 230 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaAlertPage"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaAlertPage@n55zmn", icon: "icon-coms-blank" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: '#000' } }, "\u6682\u65E0\u6570\u636E\uFF01")));
        }
    };
    Container = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Container);
    return Container;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Container);


/***/ }),
/* 1124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Container__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var MindMap = /** @class */ (function (_super) {
    __extends(MindMap, _super);
    function MindMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.myMouseOver = function (e) {
            e.target.style.backgroundColor = 'rgb(222, 240, 255)';
        };
        _this.myMouseOut = function (e) {
            e.target.style.backgroundColor = '';
        };
        return _this;
    }
    MindMap.prototype.componentWillMount = function () {
        var mindMapStore = this.props.mindMapStore;
        __WEBPACK_IMPORTED_MODULE_4__util__["default"].addEventListener('hashchange', function (hash) {
            if (hash.newURL.split("id=")[1]) {
                mindMapStore.clearAll();
                mindMapStore.init(hash.newURL.split("id=")[1].split("&")[0]);
            }
        });
    };
    MindMap.prototype.render = function () {
        var _a = this.props, mindMapStore = _a.mindMapStore, location = _a.location;
        var query = __WEBPACK_IMPORTED_MODULE_4__util__["default"].weaHistory.getCurrentLocation().query;
        mindMapStore.mindMapId = location['query'].id || '';
        mindMapStore.rootId = location['query'].rootId || location['query'].rootid || '';
        if (location['query'].level)
            mindMapStore.level = location['query'].level;
        if (location['query'].isshowroot)
            mindMapStore.isshowroot = location['query'].isshowroot;
        if (mindMapStore.isshowroot == '0' && !mindMapStore.level) {
            mindMapStore.changeLevel('1');
        }
        mindMapStore.otherParam = query;
        __WEBPACK_IMPORTED_MODULE_4__util__["default"]['cube_mindMap_titleCilck'] = mindMapStore.titleClick;
        if (mindMapStore.windowTitle != '') {
            document.title = mindMapStore.windowTitle;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function () { mindMapStore.rightMenuVisible = false; }, className: "cube_mindMap", style: { height: "100%", width: '100%', overflow: 'auto', backgroundColor: '#efeff4' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@z5tkmc", spinning: mindMapStore.loading },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Container__["a" /* default */], __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Container@c97t4o" }, this.props)),
                mindMapStore.rightMenuVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function () { }, onContextMenu: function (e) { return e.preventDefault(); }, style: {
                        width: '100px',
                        position: 'absolute',
                        top: mindMapStore.rightMenuTop + 'px',
                        left: mindMapStore.rightMenuLeft + 'px'
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { style: { border: '1px solid #cdcdcd', backgroundColor: '#f2f5f7', padding: '5px 0px 5px 0px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { onMouseOver: this.myMouseOver, onMouseOut: this.myMouseOut, style: { height: '30px', padding: '5px', cursor: 'pointer' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "" }, "\u6309\u94AE 1")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { onMouseOver: this.myMouseOver, onMouseOut: this.myMouseOut, style: { height: '30px', padding: '5px', cursor: 'pointer' } }, "\u6309\u94AE 1"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { onMouseOver: this.myMouseOver, onMouseOut: this.myMouseOut, style: { height: '30px', padding: '5px', cursor: 'pointer' } }, "\u6309\u94AE 1"))))));
    };
    MindMap = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('mindMapStore'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], MindMap);
    return MindMap;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (MindMap);


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadjs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loadjs__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Container.prototype.componentDidMount = function () {
        var mindMapStore = this.props.mindMapStore;
        var jsFiles = ['/formmode/e9resource/d3js/d3.v5.min.js'];
        if (!__WEBPACK_IMPORTED_MODULE_2_loadjs___default.a.isDefined('d3')) {
            __WEBPACK_IMPORTED_MODULE_2_loadjs___default()(jsFiles, 'd3', {
                success: function () {
                    mindMapStore.init();
                }
            });
        }
        else {
            mindMapStore.init();
        }
    };
    Container.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube_mindMap_container" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", { id: "mindMapContainer" })));
    };
    Container = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Container);
    return Container;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Container);


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BatchPrint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var getLabel = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaLocaleProvider"].getLabel;
/*
*批量打印页面
*/
var BatchPrint = /** @class */ (function (_super) {
    __extends(BatchPrint, _super);
    function BatchPrint(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            spinloading: true
        };
        return _this;
    }
    //页面完成后，给iframe赋予高度，并显示打印按钮与方法
    BatchPrint.prototype.componentDidMount = function () {
        var time = 6000; //页面加载的时间
        var location = this.props.location;
        var search = location.search;
        var split = search.split("&");
        var modeid = split[0].split("=")[1];
        var formid = split[2].split("=")[1];
        var billids = split[3].split("=")[1];
        var billid = billids.split(","); //获取到的数据的ID
        if (billid.length > 5 && billid < 11) {
            time = 10000;
        }
        else if (billid.length > 11) {
            time = 15000;
        }
        var isDisp = 0;
        var self = this;
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(".batch-topDiv").css("display", "block");
        billid.length > 0 && billid.map(function (item) {
            var iframeObj = __WEBPACK_IMPORTED_MODULE_4_jquery___default()("iframe#cube_" + item);
            var src = Object(__WEBPACK_IMPORTED_MODULE_3__util_contentPath__["a" /* getContentPath */])("/spa/cube/index.jsp#/main/cube/card?type=4&modeId=" + modeid + "&formId=" + formid + "&billid=" + item + "&isbatchprint=1");
            iframeObj.prop("src", src);
            iframeObj.load(function () {
                iframeObj.contents().find('body').prop('class', 'batchPrint');
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_4_jquery___default()("iframe#cube_" + item).css("height", __WEBPACK_IMPORTED_MODULE_4_jquery___default()("iframe#cube_" + item).contents().find('.cube-card-wrap').height() + 30);
                    isDisp++;
                    if (isDisp == billid.length) {
                        var windowTitle = split[4].split("=")[1];
                        windowTitle = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].Base64.decode(windowTitle);
                        if (windowTitle != '') {
                            document.title = windowTitle;
                        }
                        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#buttonPri').removeAttr("disabled"); //增加按钮方法与显示
                        billid.length > 0 && billid.map(function (item) {
                            __WEBPACK_IMPORTED_MODULE_4_jquery___default()("iframe#cube_" + item).css("height", __WEBPACK_IMPORTED_MODULE_4_jquery___default()("iframe#cube_" + item).contents().find('.cube-card-wrap').height() + 30);
                        });
                        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#buttonPri').attr('onclick', '').click(function () {
                            __WEBPACK_IMPORTED_MODULE_4_jquery___default()(".batch-topDiv").css("display", "none");
                            setTimeout(function () {
                                window.print();
                                __WEBPACK_IMPORTED_MODULE_4_jquery___default()(".batch-topDiv").css("display", "block");
                            }, 300);
                        });
                    }
                    self.setState({ spinloading: false });
                }, time);
            });
            iframeObj.ready(function () {
                setTimeout(function () {
                    var hnd = setInterval(function () {
                        var hight = iframeObj.contents().find('.cube-card-wrap').click().outerHeight() + 10;
                        var height = iframeObj.contents().find('.cube-card-wrap').click().height();
                        iframeObj.css("height", hight > height ? hight + 50 : height + 50);
                    });
                    clearInterval(hnd);
                }, 200);
            });
        });
        var by = document.querySelector("body");
        if (by) {
            by.className += by.className + " printBody";
        }
    };
    BatchPrint.prototype.render = function () {
        var location = this.props.location;
        var search = location.search;
        var split = search.split("&");
        var windowTitle = split[4].split("=")[1];
        windowTitle = __WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaTools"].Base64.decode(windowTitle);
        if (windowTitle != '') {
            document.title = windowTitle;
        }
        var billids = split[3].split("=")[1];
        var billid = billids.split(",");
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-batch-print" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@ucrkis", size: 'large', spinning: this.state.spinloading },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'batch-topDiv', style: { position: 'fixed', zIndex: 99999, right: '50px', top: '10px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@desgjj", id: 'buttonPri', type: 'primary', disabled: 'disabled' }, getLabel(502295, "打印"))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_ecCom__["WeaRightMenu"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaRightMenu@3slqsi", style: { paddingTop: '20px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, billid.length > 0 && billid.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-batch-print-item", style: { pageBreakBefore: "always" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { id: "cube_" + item, name: "cubename_" + item, style: { border: 0, width: '100%', height: '100%' } }));
                    }))))));
    };
    BatchPrint = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], BatchPrint);
    return BatchPrint;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));



/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GanttContainer__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var getTop = __WEBPACK_IMPORTED_MODULE_4_ecCom__["WeaTools"].WindowFunc.getTop;
var Gantt = /** @class */ (function (_super) {
    __extends(Gantt, _super);
    function Gantt(props) {
        var _this = _super.call(this, props) || this;
        _this.clear = function () {
            _this.setState({ timestamp: new Date().getTime() });
        };
        _this.state = { timestamp: new Date().getTime() };
        return _this;
    }
    Gantt.prototype.componentWillMount = function () {
        var _a = this.props, ganttStore = _a.ganttStore, location = _a.location;
        var id = location['query'].id || '';
        var rootId = location['query'].rootId || location['query'].rootid || '';
        var resourceId = location['query'].resourceId || location['query'].resourceid || '';
        ganttStore.update({ id: id, rootId: rootId, resourceId: resourceId });
    };
    Gantt.prototype.componentDidMount = function () {
        var ganttStore = this.props.ganttStore;
        getTop()['current_ganttStore'] = ganttStore;
        ganttStore.clear = this.clear;
        ganttStore.init();
    };
    Gantt.prototype.componentWillReceiveProps = function (nextProps) {
        //前台切到甘特页面时清除message
        __WEBPACK_IMPORTED_MODULE_2_antd__["message"].destroy();
        var ganttStore = nextProps.ganttStore, location = nextProps.location;
        var id = location['query'].id || '';
        var resourceId = location['query'].resourceId || location['query'].resourceid || '';
        if (this.props.ganttStore.id != id || this.props.location != location || resourceId != '') {
            ganttStore.clear(); //清除ganttContainer组件
            ganttStore.update({ id: id, resourceId: resourceId });
            ganttStore.init();
        }
    };
    Gantt.prototype.componentWillUnmount = function () {
        //前台切换到非甘特页面时清除message
        __WEBPACK_IMPORTED_MODULE_2_antd__["message"].destroy();
    };
    Gantt.prototype.render = function () {
        var ganttStore = this.props.ganttStore;
        if (ganttStore.windowTitle != "") {
            document.title = ganttStore.windowTitle;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GanttContainer__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_GanttContainer@mp9exe", key: this.state.timestamp, ganttStore: ganttStore, location: '' });
    };
    Gantt = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('ganttStore'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], Gantt);
    return Gantt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (Gantt);


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_gantt__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_gantt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_gantt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_gantt_css_gantt_less__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_gantt_css_gantt_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_gantt_css_gantt_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolBar__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TasksEditHead__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TaskInfo__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LitterTool__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialog_DeleteConfirmDialog__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__list_AdvancedSearchs__ = __webpack_require__(155);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};












var getLabel = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaLocaleProvider"].getLabel;
var GanttContainer = /** @class */ (function (_super) {
    __extends(GanttContainer, _super);
    function GanttContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showSearchAd: false };
        return _this;
    }
    GanttContainer.prototype.render = function () {
        var _this = this;
        var ganttStore = this.props.ganttStore;
        var getGanttId = ganttStore.getGanttId;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd__["Spin"], { ecId: (this && this.props && this.props.ecId || '') + "_Spin@xrd8sb", spinning: ganttStore.loading || !ganttStore.isInit, style: { height: '400px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube_gantt" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TaskInfo__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_TaskInfo@mb7570", ganttStore: ganttStore }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LitterTool__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_LitterTool@3y0egy", ganttStore: ganttStore }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "workSpace_" + getGanttId },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "TWGanttArea", style: { overflow: 'hidden', position: 'relative' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dthead" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TasksEditHead__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_TasksEditHead@wvvvsx", ganttStore: ganttStore }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaTab"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaTab@ain80x", searchType: ['advanced'], showSearchAd: this.state.showSearchAd, setShowSearchAd: function (bool) {
                                        _this.setState({
                                            showSearchAd: bool
                                        });
                                    }, replaceLeft: [
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToolBar__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_ToolBar@npxru1", ganttStore: ganttStore }))
                                    ], buttonsAd: [
                                        (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@rp5qem@doSearch", type: "primary", onClick: ganttStore.doSearch }, getLabel(387355, "搜索"))),
                                        (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@g12rco@reset", type: "ghost", onClick: function () { ganttStore.form.reset(); } }, getLabel(2022, "重置"))),
                                        (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@3onffp@showSearchAd", type: "ghost", onClick: function () { _this.setState({ showSearchAd: false }); } }, getLabel(201, "取消")))
                                    ], searchsAd: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__list_AdvancedSearchs__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_AdvancedSearchs@nwnslq", form: ganttStore.form, conditioninfo: ganttStore.conditionInfo, quickSearch: ganttStore.doSearch }), onChange: function () { } })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "splitterContainer", style: ganttStore.isInit ? { visibility: 'visible' } : { visibility: 'hidden' } })))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaDialog"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaDialog@atfnug", onCancel: function () { ganttStore.cardDiag_visible = false; }, visible: ganttStore.cardDiag_visible, style: { width: window.innerWidth - 50, height: window.innerHeight - 60 }, hasScroll: true, url: ganttStore.cardDiag_url }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__dialog_DeleteConfirmDialog__["a" /* default */], { ecId: (this && this.props && this.props.ecId || '') + "_DeleteConfirmDialog@1au8ur", ganttStore: ganttStore })));
    };
    GanttContainer = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], GanttContainer);
    return GanttContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (GanttContainer);


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(1131);__webpack_require__(1132);__webpack_require__(1133);__webpack_require__(1134);__webpack_require__(1135);__webpack_require__(1138);__webpack_require__(1154);__webpack_require__(1155);__webpack_require__(1156);__webpack_require__(1157);__webpack_require__(1158);

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
jQuery.fn.extend({everyTime:function everyTime(interval,label,fn,times,belay){return this.each(function(){jQuery.timer.add(this,interval,label,fn,times,belay);});},oneTime:function oneTime(interval,label,fn){return this.each(function(){jQuery.timer.add(this,interval,label,fn,1);});},stopTime:function stopTime(label,fn){return this.each(function(){jQuery.timer.remove(this,label,fn);});}});jQuery.extend({timer:{guid:1,global:{},regex:/^([0-9]+)\s*(.*s)?$/,powers:{// Yeah this is major overkill...
'ms':1,'cs':10,'ds':100,'s':1000,'das':10000,'hs':100000,'ks':1000000},timeParse:function timeParse(value){if(value==undefined||value==null)return null;var result=this.regex.exec(jQuery.trim(value.toString()));if(result[2]){var num=parseInt(result[1],10);var mult=this.powers[result[2]]||1;return num*mult;}else{return value;}},add:function add(element,interval,label,fn,times,belay){var counter=0;if(jQuery.isFunction(label)){if(!times)times=fn;fn=label;label=interval;}interval=jQuery.timer.timeParse(interval);if(typeof interval!='number'||isNaN(interval)||interval<=0)return;if(times&&times.constructor!=Number){belay=!!times;times=0;}times=times||0;belay=belay||false;if(!element.$timers)element.$timers={};if(!element.$timers[label])element.$timers[label]={};fn.$timerID=fn.$timerID||this.guid++;var handler=function handler(){if(belay&&this.inProgress)return;this.inProgress=true;if(++counter>times&&times!==0||fn.call(element,counter)===false)jQuery.timer.remove(element,label,fn);this.inProgress=false;};handler.$timerID=fn.$timerID;if(!element.$timers[label][fn.$timerID])element.$timers[label][fn.$timerID]=window.setInterval(handler,interval);if(!this.global[label])this.global[label]=[];this.global[label].push(element);},remove:function remove(element,label,fn){var timers=element.$timers,ret;if(timers){if(!label){for(label in timers){this.remove(element,label,fn);}}else if(timers[label]){if(fn){if(fn.$timerID){window.clearInterval(timers[label][fn.$timerID]);delete timers[label][fn.$timerID];}}else{for(var fn in timers[label]){window.clearInterval(timers[label][fn]);delete timers[label][fn];}}for(ret in timers[label]){break;}if(!ret){ret=null;delete timers[label];}}for(ret in timers){break;}if(!ret)element.$timers=null;}}}});jQuery(window).one("unload",function(){var global=jQuery.timer.global;for(var label in global){var els=global[label],i=els.length;while(--i){jQuery.timer.remove(els[i],label);}}});

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2=__webpack_require__(91);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* http://keith-wood.name/svg.html
   SVG for jQuery v1.4.5.
   Written by Keith Wood (kbwood{at}iinet.com.au) August 2007.
   Dual licensed under the GPL (http://dev.jquery.com/browser/trunk/jquery/GPL-LICENSE.txt) and 
   MIT (http://dev.jquery.com/browser/trunk/jquery/MIT-LICENSE.txt) licenses. 
   Please attribute the author if you use it. */(function($){function SVGManager(){this._settings=[];this._extensions=[];this.regional=[];this.regional['']={errorLoadingText:'Error loading',notSupportedText:'This browser does not support SVG'};this.local=this.regional[''];this._uuid=new Date().getTime();this._renesis=detectActiveX('RenesisX.RenesisCtrl');}function detectActiveX(a){try{return!!(window.ActiveXObject&&new ActiveXObject(a));}catch(e){return false;}}var q='svgwrapper';$.extend(SVGManager.prototype,{markerClassName:'hasSVG',svgNS:'http://www.w3.org/2000/svg',xlinkNS:'http://www.w3.org/1999/xlink',_wrapperClass:SVGWrapper,_attrNames:{class_:'class',in_:'in',alignmentBaseline:'alignment-baseline',baselineShift:'baseline-shift',clipPath:'clip-path',clipRule:'clip-rule',colorInterpolation:'color-interpolation',colorInterpolationFilters:'color-interpolation-filters',colorRendering:'color-rendering',dominantBaseline:'dominant-baseline',enableBackground:'enable-background',fillOpacity:'fill-opacity',fillRule:'fill-rule',floodColor:'flood-color',floodOpacity:'flood-opacity',fontFamily:'font-family',fontSize:'font-size',fontSizeAdjust:'font-size-adjust',fontStretch:'font-stretch',fontStyle:'font-style',fontVariant:'font-variant',fontWeight:'font-weight',glyphOrientationHorizontal:'glyph-orientation-horizontal',glyphOrientationVertical:'glyph-orientation-vertical',horizAdvX:'horiz-adv-x',horizOriginX:'horiz-origin-x',imageRendering:'image-rendering',letterSpacing:'letter-spacing',lightingColor:'lighting-color',markerEnd:'marker-end',markerMid:'marker-mid',markerStart:'marker-start',stopColor:'stop-color',stopOpacity:'stop-opacity',strikethroughPosition:'strikethrough-position',strikethroughThickness:'strikethrough-thickness',strokeDashArray:'stroke-dasharray',strokeDashOffset:'stroke-dashoffset',strokeLineCap:'stroke-linecap',strokeLineJoin:'stroke-linejoin',strokeMiterLimit:'stroke-miterlimit',strokeOpacity:'stroke-opacity',strokeWidth:'stroke-width',textAnchor:'text-anchor',textDecoration:'text-decoration',textRendering:'text-rendering',underlinePosition:'underline-position',underlineThickness:'underline-thickness',vertAdvY:'vert-adv-y',vertOriginY:'vert-origin-y',wordSpacing:'word-spacing',writingMode:'writing-mode'},_attachSVG:function _attachSVG(a,b){var c=a.namespaceURI==this.svgNS?a:null;var a=c?null:a;if($(a||c).hasClass(this.markerClassName)){return;}if(typeof b=='string'){b={loadURL:b};}else if(typeof b=='function'){b={onLoad:b};}$(a||c).addClass(this.markerClassName);try{if(!c){c=document.createElementNS(this.svgNS,'svg');c.setAttribute('version','1.1');if(a.clientWidth>0){c.setAttribute('width',a.clientWidth);}if(a.clientHeight>0){c.setAttribute('height',a.clientHeight);}a.appendChild(c);}this._afterLoad(a,c,b||{});}catch(e){if($.browser.msie){if(!a.id){a.id='svg'+this._uuid++;}this._settings[a.id]=b;a.innerHTML='<embed type="image/svg+xml" width="100%" '+'height="100%" src="'+(b.initPath||'')+'blank.svg" '+'pluginspage="http://www.adobe.com/svg/viewer/install/main.html"/>';}else{a.innerHTML='<p class="svg_error">'+this.local.notSupportedText+'</p>';}}},_registerSVG:function _registerSVG(){for(var i=0;i<document.embeds.length;i++){var a=document.embeds[i].parentNode;if(!$(a).hasClass($.svg.markerClassName)||$.data(a,q)){continue;}var b=null;try{b=document.embeds[i].getSVGDocument();}catch(e){setTimeout($.svg._registerSVG,250);return;}b=b?b.documentElement:null;if(b){$.svg._afterLoad(a,b);}}},_afterLoad:function _afterLoad(a,b,c){var c=c||this._settings[a.id];this._settings[a?a.id:'']=null;var d=new this._wrapperClass(b,a);$.data(a||b,q,d);try{if(c.loadURL){d.load(c.loadURL,c);}if(c.settings){d.configure(c.settings);}if(c.onLoad&&!c.loadURL){c.onLoad.apply(a||b,[d]);}}catch(e){alert(e);}},_getSVG:function _getSVG(a){a=typeof a=='string'?$(a)[0]:a.jquery?a[0]:a;return $.data(a,q);},_destroySVG:function _destroySVG(a){var b=$(a);if(!b.hasClass(this.markerClassName)){return;}b.removeClass(this.markerClassName);if(a.namespaceURI!=this.svgNS){b.empty();}$.removeData(a,q);},addExtension:function addExtension(a,b){this._extensions.push([a,b]);},isSVGElem:function isSVGElem(a){return a.nodeType==1&&a.namespaceURI==$.svg.svgNS;}});function SVGWrapper(a,b){this._svg=a;this._container=b;for(var i=0;i<$.svg._extensions.length;i++){var c=$.svg._extensions[i];this[c[0]]=new c[1](this);}}$.extend(SVGWrapper.prototype,{_width:function _width(){return this._container?this._container.clientWidth:this._svg.width;},_height:function _height(){return this._container?this._container.clientHeight:this._svg.height;},root:function root(){return this._svg;},configure:function configure(a,b,c){if(!a.nodeName){c=b;b=a;a=this._svg;}if(c){for(var i=a.attributes.length-1;i>=0;i--){var d=a.attributes.item(i);if(!(d.nodeName=='onload'||d.nodeName=='version'||d.nodeName.substring(0,5)=='xmlns')){a.attributes.removeNamedItem(d.nodeName);}}}for(var e in b){a.setAttribute($.svg._attrNames[e]||e,b[e]);}return this;},getElementById:function getElementById(a){return this._svg.ownerDocument.getElementById(a);},change:function change(a,b){if(a){for(var c in b){if(b[c]==null){a.removeAttribute($.svg._attrNames[c]||c);}else{a.setAttribute($.svg._attrNames[c]||c,b[c]);}}}return this;},_args:function _args(b,c,d){c.splice(0,0,'parent');c.splice(c.length,0,'settings');var e={};var f=0;if(b[0]!=null&&b[0].jquery){b[0]=b[0][0];}if(b[0]!=null&&!((0,_typeof3.default)(b[0])=='object'&&b[0].nodeName)){e['parent']=null;f=1;}for(var i=0;i<b.length;i++){e[c[i+f]]=b[i];}if(d){$.each(d,function(i,a){if((0,_typeof3.default)(e[a])=='object'){e.settings=e[a];e[a]=null;}});}return e;},title:function title(a,b,c){var d=this._args(arguments,['text']);var e=this._makeNode(d.parent,'title',d.settings||{});e.appendChild(this._svg.ownerDocument.createTextNode(d.text));return e;},describe:function describe(a,b,c){var d=this._args(arguments,['text']);var e=this._makeNode(d.parent,'desc',d.settings||{});e.appendChild(this._svg.ownerDocument.createTextNode(d.text));return e;},defs:function defs(a,b,c){var d=this._args(arguments,['id'],['id']);return this._makeNode(d.parent,'defs',$.extend(d.id?{id:d.id}:{},d.settings||{}));},symbol:function symbol(a,b,c,d,e,f,g){var h=this._args(arguments,['id','x1','y1','width','height']);return this._makeNode(h.parent,'symbol',$.extend({id:h.id,viewBox:h.x1+' '+h.y1+' '+h.width+' '+h.height},h.settings||{}));},marker:function marker(a,b,c,d,e,f,g,h){var i=this._args(arguments,['id','refX','refY','mWidth','mHeight','orient'],['orient']);return this._makeNode(i.parent,'marker',$.extend({id:i.id,refX:i.refX,refY:i.refY,markerWidth:i.mWidth,markerHeight:i.mHeight,orient:i.orient||'auto'},i.settings||{}));},style:function style(a,b,c){var d=this._args(arguments,['styles']);var e=this._makeNode(d.parent,'style',$.extend({type:'text/css'},d.settings||{}));e.appendChild(this._svg.ownerDocument.createTextNode(d.styles));if($.browser.opera){$('head').append('<style type="text/css">'+d.styles+'</style>');}return e;},script:function script(a,b,c,d){var e=this._args(arguments,['script','type'],['type']);var f=this._makeNode(e.parent,'script',$.extend({type:e.type||'text/javascript'},e.settings||{}));f.appendChild(this._svg.ownerDocument.createTextNode(e.script));if(!$.browser.mozilla){$.globalEval(e.script);}return f;},linearGradient:function linearGradient(a,b,c,d,e,f,g,h){var i=this._args(arguments,['id','stops','x1','y1','x2','y2'],['x1']);var j=$.extend({id:i.id},i.x1!=null?{x1:i.x1,y1:i.y1,x2:i.x2,y2:i.y2}:{});return this._gradient(i.parent,'linearGradient',$.extend(j,i.settings||{}),i.stops);},radialGradient:function radialGradient(a,b,c,d,e,r,f,g,h){var i=this._args(arguments,['id','stops','cx','cy','r','fx','fy'],['cx']);var j=$.extend({id:i.id},i.cx!=null?{cx:i.cx,cy:i.cy,r:i.r,fx:i.fx,fy:i.fy}:{});return this._gradient(i.parent,'radialGradient',$.extend(j,i.settings||{}),i.stops);},_gradient:function _gradient(a,b,c,d){var e=this._makeNode(a,b,c);for(var i=0;i<d.length;i++){var f=d[i];this._makeNode(e,'stop',$.extend({offset:f[0],stopColor:f[1]},f[2]!=null?{stopOpacity:f[2]}:{}));}return e;},pattern:function pattern(a,b,x,y,c,d,e,f,g,h,i){var j=this._args(arguments,['id','x','y','width','height','vx','vy','vwidth','vheight'],['vx']);var k=$.extend({id:j.id,x:j.x,y:j.y,width:j.width,height:j.height},j.vx!=null?{viewBox:j.vx+' '+j.vy+' '+j.vwidth+' '+j.vheight}:{});return this._makeNode(j.parent,'pattern',$.extend(k,j.settings||{}));},clipPath:function clipPath(a,b,c,d){var e=this._args(arguments,['id','units']);e.units=e.units||'userSpaceOnUse';return this._makeNode(e.parent,'clipPath',$.extend({id:e.id,clipPathUnits:e.units},e.settings||{}));},mask:function mask(a,b,x,y,c,d,e){var f=this._args(arguments,['id','x','y','width','height']);return this._makeNode(f.parent,'mask',$.extend({id:f.id,x:f.x,y:f.y,width:f.width,height:f.height},f.settings||{}));},createPath:function createPath(){return new SVGPath();},createText:function createText(){return new SVGText();},svg:function svg(a,x,y,b,c,d,e,f,g,h){var i=this._args(arguments,['x','y','width','height','vx','vy','vwidth','vheight'],['vx']);var j=$.extend({x:i.x,y:i.y,width:i.width,height:i.height},i.vx!=null?{viewBox:i.vx+' '+i.vy+' '+i.vwidth+' '+i.vheight}:{});return this._makeNode(i.parent,'svg',$.extend(j,i.settings||{}));},group:function group(a,b,c){var d=this._args(arguments,['id'],['id']);return this._makeNode(d.parent,'g',$.extend({id:d.id},d.settings||{}));},use:function use(a,x,y,b,c,d,e){var f=this._args(arguments,['x','y','width','height','ref']);if(typeof f.x=='string'){f.ref=f.x;f.settings=f.y;f.x=f.y=f.width=f.height=null;}var g=this._makeNode(f.parent,'use',$.extend({x:f.x,y:f.y,width:f.width,height:f.height},f.settings||{}));g.setAttributeNS($.svg.xlinkNS,'href',f.ref);return g;},link:function link(a,b,c){var d=this._args(arguments,['ref']);var e=this._makeNode(d.parent,'a',d.settings);e.setAttributeNS($.svg.xlinkNS,'href',d.ref);return e;},image:function image(a,x,y,b,c,d,e){var f=this._args(arguments,['x','y','width','height','ref']);var g=this._makeNode(f.parent,'image',$.extend({x:f.x,y:f.y,width:f.width,height:f.height},f.settings||{}));g.setAttributeNS($.svg.xlinkNS,'href',f.ref);return g;},path:function path(a,b,c){var d=this._args(arguments,['path']);return this._makeNode(d.parent,'path',$.extend({d:d.path.path?d.path.path():d.path},d.settings||{}));},rect:function rect(a,x,y,b,c,d,e,f){var g=this._args(arguments,['x','y','width','height','rx','ry'],['rx']);return this._makeNode(g.parent,'rect',$.extend({x:g.x,y:g.y,width:g.width,height:g.height},g.rx?{rx:g.rx,ry:g.ry}:{},g.settings||{}));},circle:function circle(a,b,c,r,d){var e=this._args(arguments,['cx','cy','r']);return this._makeNode(e.parent,'circle',$.extend({cx:e.cx,cy:e.cy,r:e.r},e.settings||{}));},ellipse:function ellipse(a,b,c,d,e,f){var g=this._args(arguments,['cx','cy','rx','ry']);return this._makeNode(g.parent,'ellipse',$.extend({cx:g.cx,cy:g.cy,rx:g.rx,ry:g.ry},g.settings||{}));},line:function line(a,b,c,d,e,f){var g=this._args(arguments,['x1','y1','x2','y2']);return this._makeNode(g.parent,'line',$.extend({x1:g.x1,y1:g.y1,x2:g.x2,y2:g.y2},g.settings||{}));},polyline:function polyline(a,b,c){var d=this._args(arguments,['points']);return this._poly(d.parent,'polyline',d.points,d.settings);},polygon:function polygon(a,b,c){var d=this._args(arguments,['points']);return this._poly(d.parent,'polygon',d.points,d.settings);},_poly:function _poly(a,b,c,d){var e='';for(var i=0;i<c.length;i++){e+=c[i].join()+' ';}return this._makeNode(a,b,$.extend({points:$.trim(e)},d||{}));},text:function text(a,x,y,b,c){var d=this._args(arguments,['x','y','value']);if(typeof d.x=='string'&&arguments.length<4){d.value=d.x;d.settings=d.y;d.x=d.y=null;}return this._text(d.parent,'text',d.value,$.extend({x:d.x&&isArray(d.x)?d.x.join(' '):d.x,y:d.y&&isArray(d.y)?d.y.join(' '):d.y},d.settings||{}));},textpath:function textpath(a,b,c,d){var e=this._args(arguments,['path','value']);var f=this._text(e.parent,'textPath',e.value,e.settings||{});f.setAttributeNS($.svg.xlinkNS,'href',e.path);return f;},_text:function _text(a,b,c,d){var e=this._makeNode(a,b,d);if(typeof c=='string'){e.appendChild(e.ownerDocument.createTextNode(c));}else{for(var i=0;i<c._parts.length;i++){var f=c._parts[i];if(f[0]=='tspan'){var g=this._makeNode(e,f[0],f[2]);g.appendChild(e.ownerDocument.createTextNode(f[1]));e.appendChild(g);}else if(f[0]=='tref'){var g=this._makeNode(e,f[0],f[2]);g.setAttributeNS($.svg.xlinkNS,'href',f[1]);e.appendChild(g);}else if(f[0]=='textpath'){var h=$.extend({},f[2]);h.href=null;var g=this._makeNode(e,f[0],h);g.setAttributeNS($.svg.xlinkNS,'href',f[2].href);g.appendChild(e.ownerDocument.createTextNode(f[1]));e.appendChild(g);}else{e.appendChild(e.ownerDocument.createTextNode(f[1]));}}}return e;},other:function other(a,b,c){var d=this._args(arguments,['name']);return this._makeNode(d.parent,d.name,d.settings||{});},_makeNode:function _makeNode(a,b,c){a=a||this._svg;var d=this._svg.ownerDocument.createElementNS($.svg.svgNS,b);for(var b in c){var e=c[b];if(e!=null&&e!=null&&(typeof e!='string'||e!='')){d.setAttribute($.svg._attrNames[b]||b,e);}}a.appendChild(d);return d;},add:function add(b,c){var d=this._args(arguments.length==1?[null,b]:arguments,['node']);var f=this;d.parent=d.parent||this._svg;d.node=d.node.jquery?d.node:$(d.node);try{if($.svg._renesis){throw'Force traversal';}d.parent.appendChild(d.node.cloneNode(true));}catch(e){d.node.each(function(){var a=f._cloneAsSVG(this);if(a){d.parent.appendChild(a);}});}return this;},clone:function clone(b,c){var d=this;var e=this._args(arguments.length==1?[null,b]:arguments,['node']);e.parent=e.parent||this._svg;e.node=e.node.jquery?e.node:$(e.node);var f=[];e.node.each(function(){var a=d._cloneAsSVG(this);if(a){a.id='';e.parent.appendChild(a);f.push(a);}});return f;},_cloneAsSVG:function _cloneAsSVG(a){var b=null;if(a.nodeType==1){b=this._svg.ownerDocument.createElementNS($.svg.svgNS,this._checkName(a.nodeName));for(var i=0;i<a.attributes.length;i++){var c=a.attributes.item(i);if(c.nodeName!='xmlns'&&c.nodeValue){if(c.prefix=='xlink'){b.setAttributeNS($.svg.xlinkNS,c.localName||c.baseName,c.nodeValue);}else{b.setAttribute(this._checkName(c.nodeName),c.nodeValue);}}}for(var i=0;i<a.childNodes.length;i++){var d=this._cloneAsSVG(a.childNodes[i]);if(d){b.appendChild(d);}}}else if(a.nodeType==3){if($.trim(a.nodeValue)){b=this._svg.ownerDocument.createTextNode(a.nodeValue);}}else if(a.nodeType==4){if($.trim(a.nodeValue)){try{b=this._svg.ownerDocument.createCDATASection(a.nodeValue);}catch(e){b=this._svg.ownerDocument.createTextNode(a.nodeValue.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'));}}}return b;},_checkName:function _checkName(a){a=a.substring(0,1)>='A'&&a.substring(0,1)<='Z'?a.toLowerCase():a;return a.substring(0,4)=='svg:'?a.substring(4):a;},load:function load(j,k){k=typeof k=='boolean'?{addTo:k}:typeof k=='function'?{onLoad:k}:typeof k=='string'?{parent:k}:(typeof k==='undefined'?'undefined':(0,_typeof3.default)(k))=='object'&&k.nodeName?{parent:k}:(typeof k==='undefined'?'undefined':(0,_typeof3.default)(k))=='object'&&k.jquery?{parent:k}:k||{};if(!k.parent&&!k.addTo){this.clear(false);}var l=[this._svg.getAttribute('width'),this._svg.getAttribute('height')];var m=this;var n=function n(a){a=$.svg.local.errorLoadingText+': '+a;if(k.onLoad){k.onLoad.apply(m._container||m._svg,[m,a]);}else{m.text(null,10,20,a);}};var o=function o(a){var b=new ActiveXObject('Microsoft.XMLDOM');b.validateOnParse=false;b.resolveExternals=false;b.async=false;b.loadXML(a);if(b.parseError.errorCode!=0){n(b.parseError.reason);return null;}return b;};var p=function p(a){if(!a){return;}if(a.documentElement.nodeName!='svg'){var b=a.getElementsByTagName('parsererror');var c=b.length?b[0].getElementsByTagName('div'):[];n(!b.length?'???':(c.length?c[0]:b[0]).firstChild.nodeValue);return;}var d=k.parent?$(k.parent)[0]:m._svg;var f={};for(var i=0;i<a.documentElement.attributes.length;i++){var g=a.documentElement.attributes.item(i);if(!(g.nodeName=='version'||g.nodeName.substring(0,5)=='xmlns')){f[g.nodeName]=g.nodeValue;}}m.configure(d,f,!k.parent);var h=a.documentElement.childNodes;for(var i=0;i<h.length;i++){try{if($.svg._renesis){throw'Force traversal';}d.appendChild(m._svg.ownerDocument.importNode(h[i],true));if(h[i].nodeName=='script'){$.globalEval(h[i].textContent);}}catch(e){m.add(d,h[i]);}}if(!k.changeSize){m.configure(d,{width:l[0],height:l[1]});}if(k.onLoad){k.onLoad.apply(m._container||m._svg,[m]);}};if(j.match('<svg')){p($.browser.msie?o(j):new DOMParser().parseFromString(j,'text/xml'));}else{$.ajax({url:j,dataType:$.browser.msie?'text':'xml',success:function success(a){p($.browser.msie?o(a):a);},error:function error(a,b,c){n(b+(c?' '+c.message:''));}});}return this;},remove:function remove(a){a=a.jquery?a[0]:a;a.parentNode.removeChild(a);return this;},clear:function clear(a){if(a){this.configure({},true);}while(this._svg.firstChild){this._svg.removeChild(this._svg.firstChild);}return this;},toSVG:function toSVG(a){a=a||this._svg;return typeof XMLSerializer=='undefined'?this._toSVG(a):new XMLSerializer().serializeToString(a);},_toSVG:function _toSVG(a){var b='';if(!a){return b;}if(a.nodeType==3){b=a.nodeValue;}else if(a.nodeType==4){b='<![CDATA['+a.nodeValue+']]>';}else{b='<'+a.nodeName;if(a.attributes){for(var i=0;i<a.attributes.length;i++){var c=a.attributes.item(i);if(!($.trim(c.nodeValue)==''||c.nodeValue.match(/^\[object/)||c.nodeValue.match(/^function/))){b+=' '+(c.namespaceURI==$.svg.xlinkNS?'xlink:':'')+c.nodeName+'="'+c.nodeValue+'"';}}}if(a.firstChild){b+='>';var d=a.firstChild;while(d){b+=this._toSVG(d);d=d.nextSibling;}b+='</'+a.nodeName+'>';}else{b+='/>';}}return b;}});function SVGPath(){this._path='';}$.extend(SVGPath.prototype,{reset:function reset(){this._path='';return this;},move:function move(x,y,a){a=isArray(x)?y:a;return this._coords(a?'m':'M',x,y);},line:function line(x,y,a){a=isArray(x)?y:a;return this._coords(a?'l':'L',x,y);},horiz:function horiz(x,a){this._path+=(a?'h':'H')+(isArray(x)?x.join(' '):x);return this;},vert:function vert(y,a){this._path+=(a?'v':'V')+(isArray(y)?y.join(' '):y);return this;},curveC:function curveC(a,b,c,d,x,y,e){e=isArray(a)?b:e;return this._coords(e?'c':'C',a,b,c,d,x,y);},smoothC:function smoothC(a,b,x,y,c){c=isArray(a)?b:c;return this._coords(c?'s':'S',a,b,x,y);},curveQ:function curveQ(a,b,x,y,c){c=isArray(a)?b:c;return this._coords(c?'q':'Q',a,b,x,y);},smoothQ:function smoothQ(x,y,a){a=isArray(x)?y:a;return this._coords(a?'t':'T',x,y);},_coords:function _coords(a,b,c,d,e,f,g){if(isArray(b)){for(var i=0;i<b.length;i++){var h=b[i];this._path+=(i==0?a:' ')+h[0]+','+h[1]+(h.length<4?'':' '+h[2]+','+h[3]+(h.length<6?'':' '+h[4]+','+h[5]));}}else{this._path+=a+b+','+c+(d==null?'':' '+d+','+e+(f==null?'':' '+f+','+g));}return this;},arc:function arc(a,b,c,d,e,x,y,f){f=isArray(a)?b:f;this._path+=f?'a':'A';if(isArray(a)){for(var i=0;i<a.length;i++){var g=a[i];this._path+=(i==0?'':' ')+g[0]+','+g[1]+' '+g[2]+' '+(g[3]?'1':'0')+','+(g[4]?'1':'0')+' '+g[5]+','+g[6];}}else{this._path+=a+','+b+' '+c+' '+(d?'1':'0')+','+(e?'1':'0')+' '+x+','+y;}return this;},close:function close(){this._path+='z';return this;},path:function path(){return this._path;}});SVGPath.prototype.moveTo=SVGPath.prototype.move;SVGPath.prototype.lineTo=SVGPath.prototype.line;SVGPath.prototype.horizTo=SVGPath.prototype.horiz;SVGPath.prototype.vertTo=SVGPath.prototype.vert;SVGPath.prototype.curveCTo=SVGPath.prototype.curveC;SVGPath.prototype.smoothCTo=SVGPath.prototype.smoothC;SVGPath.prototype.curveQTo=SVGPath.prototype.curveQ;SVGPath.prototype.smoothQTo=SVGPath.prototype.smoothQ;SVGPath.prototype.arcTo=SVGPath.prototype.arc;function SVGText(){this._parts=[];}$.extend(SVGText.prototype,{reset:function reset(){this._parts=[];return this;},string:function string(a){this._parts[this._parts.length]=['text',a];return this;},span:function span(a,b){this._parts[this._parts.length]=['tspan',a,b];return this;},ref:function ref(a,b){this._parts[this._parts.length]=['tref',a,b];return this;},path:function path(a,b,c){this._parts[this._parts.length]=['textpath',b,$.extend({href:a},c||{})];return this;}});$.fn.svg=function(a){var b=Array.prototype.slice.call(arguments,1);if(typeof a=='string'&&a=='get'){return $.svg['_'+a+'SVG'].apply($.svg,[this[0]].concat(b));}return this.each(function(){if(typeof a=='string'){$.svg['_'+a+'SVG'].apply($.svg,[this].concat(b));}else{$.svg._attachSVG(this,a||{});}});};function isArray(a){return a&&a.constructor==Array;}$.svg=new SVGManager();})(jQuery);

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c)2005-2009 Matt Kruse (javascripttoolbox.com)
 * Dual licensed under the MIT and GPL licenses.
 * This basically means you can use this code however you want for
 *//*
Date functions

These functions are used to parse, format, and manipulate Date objects.
See documentation and examples at http://www.JavascriptToolbox.com/lib/date/

*/Date.$VERSION=1.02;// Utility function to append a 0 to single-digit numbers
Date.LZ=function(x){return(x<0||x>9?"":"0")+x;};// Full month names. Change this for local month names
Date.monthNames=new Array('January','February','March','April','May','June','July','August','September','October','November','December');// Month abbreviations. Change this for local month names
Date.monthAbbreviations=new Array('Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec');// Full day names. Change this for local month names
Date.dayNames=new Array('Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday');// Day abbreviations. Change this for local month names
Date.dayAbbreviations=new Array('Sun','Mon','Tue','Wed','Thu','Fri','Sat');// Used for parsing ambiguous dates like 1/2/2000 - default to preferring 'American' format meaning Jan 2.
// Set to false to prefer 'European' format meaning Feb 1
Date.preferAmericanFormat=true;// Set to 0=SUn for American 1=Mon for european
Date.firstDayOfWeek=0;//default 
Date.defaultFormat="dd/MM/yyyy";// If the getFullYear() method is not defined, create it
if(!Date.prototype.getFullYear){Date.prototype.getFullYear=function(){var yy=this.getYear();return yy<1900?yy+1900:yy;};}// Parse a string and convert it to a Date object.
// If no format is passed, try a list of common formats.
// If string cannot be parsed, return null.
// Avoids regular expressions to be more portable.
Date.parseString=function(val,format,lenient){// If no format is specified, try a few common formats
if(typeof format=="undefined"||format==null||format==""){var generalFormats=new Array(Date.defaultFormat,'y-M-d','MMM d, y','MMM d,y','y-MMM-d','d-MMM-y','MMM d','MMM-d','d-MMM');var monthFirst=new Array('M/d/y','M-d-y','M.d.y','M/d','M-d');var dateFirst=new Array('d/M/y','d-M-y','d.M.y','d/M','d-M');var checkList=new Array(generalFormats,Date.preferAmericanFormat?monthFirst:dateFirst,Date.preferAmericanFormat?dateFirst:monthFirst);for(var i=0;i<checkList.length;i++){var l=checkList[i];for(var j=0;j<l.length;j++){var d=Date.parseString(val,l[j]);if(d!=null){return d;}}}return null;};this.isInteger=function(val){for(var i=0;i<val.length;i++){if("1234567890".indexOf(val.charAt(i))==-1){return false;}}return true;};this.getInt=function(str,i,minlength,maxlength){for(var x=maxlength;x>=minlength;x--){var token=str.substring(i,i+x);if(token.length<minlength){return null;}if(this.isInteger(token)){return token;}}return null;};this.decodeShortcut=function(str){str=str?str:"";// just in case
var dateUpper=str.trim().toUpperCase();var ret=new Date();ret.clearTime();if(["NOW","N"].indexOf(dateUpper)>=0){ret=new Date();}else if(["TODAY","T"].indexOf(dateUpper)>=0){//do nothing
}else if(["YESTERDAY","Y"].indexOf(dateUpper)>=0){ret.setDate(ret.getDate()-1);}else if(["TOMORROW","TO"].indexOf(dateUpper)>=0){ret.setDate(ret.getDate()+1);}else if(["W","TW","WEEK","THISWEEK","WEEKSTART","THISWEEKSTART"].indexOf(dateUpper)>=0){ret.setFirstDayOfThisWeek();}else if(["LW","LASTWEEK","LASTWEEKSTART"].indexOf(dateUpper)>=0){ret.setFirstDayOfThisWeek();ret.setDate(ret.getDate()-7);}else if(["NW","NEXTWEEK","NEXTWEEKSTART"].indexOf(dateUpper)>=0){ret.setFirstDayOfThisWeek();ret.setDate(ret.getDate()+7);}else if(["M","TM","MONTH","THISMONTH","MONTHSTART","THISMONTHSTART"].indexOf(dateUpper)>=0){ret.setDate(1);}else if(["LM","LASTMONTH","LASTMONTHSTART"].indexOf(dateUpper)>=0){ret.setDate(1);ret.setMonth(ret.getMonth()-1);}else if(["NM","NEXTMONTH","NEXTMONTHSTART"].indexOf(dateUpper)>=0){ret.setDate(1);ret.setMonth(ret.getMonth()+1);}else if(["Q","TQ","QUARTER","THISQUARTER","QUARTERSTART","THISQUARTERSTART"].indexOf(dateUpper)>=0){ret.setDate(1);ret.setMonth(Math.floor(ret.getMonth()/3)*3);}else if(["LQ","LASTQUARTER","LASTQUARTERSTART"].indexOf(dateUpper)>=0){ret.setDate(1);ret.setMonth(Math.floor(ret.getMonth()/3)*3-3);}else if(["NQ","NEXTQUARTER","NEXTQUARTERSTART"].indexOf(dateUpper)>=0){ret.setDate(1);ret.setMonth(Math.floor(ret.getMonth()/3)*3+3);}else if(/^-?[0-9]+[DWMY]$/.test(dateUpper)){var lastOne=dateUpper.substr(dateUpper.length-1);var val=parseInt(dateUpper.substr(0,dateUpper.length-1));if(lastOne=="W")ret.setDate(ret.getDate()+val*7);else if(lastOne=="M")ret.setMonth(ret.getMonth()+val);else if(lastOne=="Y")ret.setYear(ret.getYear()+val);}else{ret=undefined;}return ret;};var ret=this.decodeShortcut(val);if(ret)return ret;this._getDate=function(val,format){val=val+"";format=format+"";var i_val=0;var i_format=0;var c="";var token="";var token2="";var x,y;var year=new Date().getFullYear();var month=1;var date=1;var hh=0;var mm=0;var ss=0;var ampm="";while(i_format<format.length){// Get next token from format string
c=format.charAt(i_format);token="";while(format.charAt(i_format)==c&&i_format<format.length){token+=format.charAt(i_format++);}// Extract contents of value based on format token
if(token=="yyyy"||token=="yy"||token=="y"){if(token=="yyyy"){x=4;y=4;}if(token=="yy"){x=2;y=2;}if(token=="y"){x=2;y=4;}year=this.getInt(val,i_val,x,y);if(year==null){return null;}i_val+=year.length;if(year.length==2){if(year>70){year=1900+(year-0);}else{year=2000+(year-0);}}//		} else if (token=="MMM" || token=="NNN"){
}else if(token=="MMM"||token=="MMMM"){month=0;var names=token=="MMMM"?Date.monthNames.concat(Date.monthAbbreviations):Date.monthAbbreviations;for(var i=0;i<names.length;i++){var month_name=names[i];if(val.substring(i_val,i_val+month_name.length).toLowerCase()==month_name.toLowerCase()){month=i%12+1;i_val+=month_name.length;break;}}if(month<1||month>12){return null;}}else if(token=="E"||token=="EE"||token=="EEE"||token=="EEEE"){var names=token=="EEEE"?Date.dayNames:Date.dayAbbreviations;for(var i=0;i<names.length;i++){var day_name=names[i];if(val.substring(i_val,i_val+day_name.length).toLowerCase()==day_name.toLowerCase()){i_val+=day_name.length;break;}}}else if(token=="MM"||token=="M"){month=this.getInt(val,i_val,token.length,2);if(month==null||month<1||month>12){return null;}i_val+=month.length;}else if(token=="dd"||token=="d"){date=this.getInt(val,i_val,token.length,2);if(date==null||date<1||date>31){return null;}i_val+=date.length;}else if(token=="hh"||token=="h"){hh=this.getInt(val,i_val,token.length,2);if(hh==null||hh<1||hh>12){return null;}i_val+=hh.length;}else if(token=="HH"||token=="H"){hh=this.getInt(val,i_val,token.length,2);if(hh==null||hh<0||hh>23){return null;}i_val+=hh.length;}else if(token=="KK"||token=="K"){hh=this.getInt(val,i_val,token.length,2);if(hh==null||hh<0||hh>11){return null;}i_val+=hh.length;hh++;}else if(token=="kk"||token=="k"){hh=this.getInt(val,i_val,token.length,2);if(hh==null||hh<1||hh>24){return null;}i_val+=hh.length;hh--;}else if(token=="mm"||token=="m"){mm=this.getInt(val,i_val,token.length,2);if(mm==null||mm<0||mm>59){return null;}i_val+=mm.length;}else if(token=="ss"||token=="s"){ss=this.getInt(val,i_val,token.length,2);if(ss==null||ss<0||ss>59){return null;}i_val+=ss.length;}else if(token=="a"){if(val.substring(i_val,i_val+2).toLowerCase()=="am"){ampm="AM";}else if(val.substring(i_val,i_val+2).toLowerCase()=="pm"){ampm="PM";}else{return null;}i_val+=2;}else{if(val.substring(i_val,i_val+token.length)!=token){return null;}else{i_val+=token.length;}}}// If there are any trailing characters left in the value, it doesn't match
if(i_val!=val.length){return null;}// Is date valid for month?
if(month==2){// Check for leap year
if(year%4==0&&year%100!=0||year%400==0){// leap year
if(date>29){return null;}}else{if(date>28){return null;}}}if(month==4||month==6||month==9||month==11){if(date>30){return null;}}// Correct hours value
if(hh<12&&ampm=="PM"){hh=hh-0+12;}else if(hh>11&&ampm=="AM"){hh-=12;}return new Date(year,month-1,date,hh,mm,ss);};var theDate=this._getDate(val,format);if(!theDate&&lenient){//try with short format
var f=format.replace("MMMM","M").replace("MMM","M").replace("MM","M").replace("yyyy","y").replace("yyy","y").replace("yy","y").replace("dd","d");//console.debug("second round with format "+f);
return this._getDate(val,f);}else{return theDate;}};// Check if a date string is valid
Date.isValid=function(val,format,lenient){return Date.parseString(val,format,lenient)!=null;};// Check if a date object is before another date object
Date.prototype.isBefore=function(date2){if(date2==null){return false;}return this.getTime()<date2.getTime();};// Check if a date object is after another date object
Date.prototype.isAfter=function(date2){if(date2==null){return false;}return this.getTime()>date2.getTime();};Date.prototype.isOutOfRange=function(minDate,maxDate){minDate=minDate||this;maxDate=maxDate||this;if(typeof minDate=="string")minDate=Date.parseString(minDate);if(typeof maxDate=="string")maxDate=Date.parseString(maxDate);/*
   console.debug("date:: ", this);
   console.debug("minDate:: ", minDate);
   console.debug("maxDate:: ", maxDate);
   console.debug("isDisabled:: ", this.isBefore(minDate) , this.isAfter(maxDate));
   */return this.isBefore(minDate)||this.isAfter(maxDate);};// Check if two date objects have equal dates and times
Date.prototype.equals=function(date2){if(date2==null){return false;}return this.getTime()==date2.getTime();};// Check if two date objects have equal dates, disregarding times
Date.prototype.equalsIgnoreTime=function(date2){if(date2==null){return false;}var d1=new Date(this.getTime()).clearTime();var d2=new Date(date2.getTime()).clearTime();return d1.getTime()==d2.getTime();};/**
 * Get week number in the year.
 */Date.prototype.getWeekNumber=function(){var d=new Date(+this);d.setHours(0,0,0,0);d.setDate(d.getDate()+4-(d.getDay()||7));return Math.ceil(((d-new Date(d.getFullYear(),0,1))/8.64e7+1)/7);};// Format a date into a string using a given format string
Date.prototype.format=function(format){if(!format)format=Date.defaultFormat;format=format+"";var result="";var i_format=0;var c="";var token="";var y=this.getFullYear()+"";var M=this.getMonth()+1;var d=this.getDate();var E=this.getDay();var H=this.getHours();var m=this.getMinutes();var s=this.getSeconds();var w=this.getWeekNumber();// Convert real date parts into formatted versions
var value=new Object();if(y.length<4){y=""+(+y+1900);}value["y"]=""+y;value["yyyy"]=y;value["yy"]=y.substring(2,4);value["M"]=M;value["MM"]=Date.LZ(M);value["MMM"]=Date.monthAbbreviations[M-1];value["MMMM"]=Date.monthNames[M-1];value["d"]=d;value["dd"]=Date.LZ(d);value["E"]=Date.dayAbbreviations[E];value["EE"]=Date.dayAbbreviations[E];value["EEE"]=Date.dayAbbreviations[E];value["EEEE"]=Date.dayNames[E];value["H"]=H;value["HH"]=Date.LZ(H);value["w"]=w;value["ww"]=Date.LZ(w);if(H==0){value["h"]=12;}else if(H>12){value["h"]=H-12;}else{value["h"]=H;}value["hh"]=Date.LZ(value["h"]);value["K"]=value["h"]-1;value["k"]=value["H"]+1;value["KK"]=Date.LZ(value["K"]);value["kk"]=Date.LZ(value["k"]);if(H>11){value["a"]="PM";}else{value["a"]="AM";}value["m"]=m;value["mm"]=Date.LZ(m);value["s"]=s;value["ss"]=Date.LZ(s);while(i_format<format.length){c=format.charAt(i_format);token="";while(format.charAt(i_format)==c&&i_format<format.length){token+=format.charAt(i_format++);}if(typeof value[token]!="undefined"){result=result+value[token];}else{result=result+token;}}return result;};// Get the full name of the day for a date
Date.prototype.getDayName=function(){return Date.dayNames[this.getDay()];};// Get the abbreviation of the day for a date
Date.prototype.getDayAbbreviation=function(){return Date.dayAbbreviations[this.getDay()];};// Get the full name of the month for a date
Date.prototype.getMonthName=function(){return Date.monthNames[this.getMonth()];};// Get the abbreviation of the month for a date
Date.prototype.getMonthAbbreviation=function(){return Date.monthAbbreviations[this.getMonth()];};// Clear all time information in a date object
Date.prototype.clearTime=function(){this.setHours(0);this.setMinutes(0);this.setSeconds(0);this.setMilliseconds(0);return this;};// Add an amount of time to a date. Negative numbers can be passed to subtract time.
Date.prototype.add=function(interval,number){if(typeof interval=="undefined"||interval==null||typeof number=="undefined"||number==null){return this;}number=+number;if(interval=='y'){// year
this.setFullYear(this.getFullYear()+number);}else if(interval=='M'){// Month
this.setMonth(this.getMonth()+number);}else if(interval=='d'){// Day
this.setDate(this.getDate()+number);}else if(interval=='w'){// Week
this.setDate(this.getDate()+number*7);}else if(interval=='h'){// Hour
this.setHours(this.getHours()+number);}else if(interval=='m'){// Minute
this.setMinutes(this.getMinutes()+number);}else if(interval=='s'){// Second
this.setSeconds(this.getSeconds()+number);}return this;};Date.prototype.toInt=function(){return this.getFullYear()*10000+(this.getMonth()+1)*100+this.getDate();};Date.fromInt=function(dateInt){var year=parseInt(dateInt/10000);var month=parseInt((dateInt-year*10000)/100);var day=parseInt(dateInt-year*10000-month*100);return new Date(year,month-1,day,12,'00','00');};Date.prototype.isHoliday=function(){return isHoliday(this);};Date.prototype.isToday=function(){return this.toInt()==new Date().toInt();};Date.prototype.incrementDateByWorkingDays=function(days){//console.debug("incrementDateByWorkingDays start ",d,days)
var q=Math.abs(days);while(q>0){this.setDate(this.getDate()+(days>0?1:-1));if(!this.isHoliday())q--;}return this;};Date.prototype.distanceInDays=function(toDate){// Discard the time and time-zone information.
var utc1=Date.UTC(this.getFullYear(),this.getMonth(),this.getDate());var utc2=Date.UTC(toDate.getFullYear(),toDate.getMonth(),toDate.getDate());return Math.floor((utc2-utc1)/(3600000*24));};//low performances in case of long distance
/*Date.prototype.distanceInWorkingDays= function (toDate){
  var pos = new Date(this.getTime());
  pos.setHours(23, 59, 59, 999);
  var days = 0;
  var nd=new Date(toDate.getTime());
  nd.setHours(23, 59, 59, 999);
  var end=nd.getTime();
  while (pos.getTime() <= end) {
    days = days + (isHoliday(pos) ? 0 : 1);
    pos.setDate(pos.getDate() + 1);
  }
  return days;
};*///low performances in case of long distance
// bicch 22/4/2016: modificato per far ritornare anche valori negativi, così come la controparte Java in CompanyCalendar.
// attenzione che prima tornava 1 per due date uguali adesso torna 0
Date.prototype.distanceInWorkingDays=function(toDate){var pos=new Date(Math.min(this,toDate));pos.setHours(12,0,0,0);var days=0;var nd=new Date(Math.max(this,toDate));nd.setHours(12,0,0,0);while(pos<nd){days=days+(isHoliday(pos)?0:1);pos.setDate(pos.getDate()+1);}days=days*(this>toDate?-1:1);//console.debug("distanceInWorkingDays",this,toDate,days);
return days;};Date.prototype.setFirstDayOfThisWeek=function(firstDayOfWeek){if(!firstDayOfWeek)firstDayOfWeek=Date.firstDayOfWeek;this.setDate(this.getDate()-this.getDay()+firstDayOfWeek-(this.getDay()==0&&firstDayOfWeek!=0?7:0));return this;};/* ----- millis format --------- *//**
 * @param         str         - Striga da riempire
 * @param         len         - Numero totale di caratteri, comprensivo degli "zeri"
 * @param         ch          - Carattere usato per riempire
 */function pad(str,len,ch){if((str+"").length<len){return new Array(len-(''+str).length+1).join(ch)+str;}else{return str;}}function getMillisInHours(millis){if(!millis)return"";var hour=Math.floor(millis/3600000);return(millis>=0?"":"-")+pad(hour,1,"0");}function getMillisInHoursMinutes(millis){if(typeof millis!="number")return"";var sgn=millis>=0?1:-1;millis=Math.abs(millis);var hour=Math.floor(millis/3600000);var min=Math.floor(millis%3600000/60000);return(sgn>0?"":"-")+pad(hour,1,"0")+":"+pad(min,2,"0");}function getMillisInDaysHoursMinutes(millis){if(!millis)return"";// millisInWorkingDay is set on partHeaderFooter
var sgn=millis>=0?1:-1;millis=Math.abs(millis);var days=Math.floor(millis/millisInWorkingDay);var hour=Math.floor(millis%millisInWorkingDay/3600000);var min=Math.floor((millis-days*millisInWorkingDay-hour*3600000)/60000);return(sgn>=0?"":"-")+(days>0?days+"  ":"")+pad(hour,1,"0")+":"+pad(min,2,"0");}function millisToString(millis,considerWorkingdays){// console.debug("millisToString",millis)
if(!millis)return"";// millisInWorkingDay is set on partHeaderFooter
var sgn=millis>=0?1:-1;millis=Math.abs(millis);var wm=considerWorkingdays?millisInWorkingDay:3600000*24;var days=Math.floor(millis/wm);var hour=Math.floor(millis%wm/3600000);var min=Math.floor((millis-days*wm-hour*3600000)/60000);var sec=Math.floor((millis-days*wm-hour*3600000-min*60000)/1000);//console.debug("millisToString",wm, millis,days,hour,min)
return(sgn>=0?"":"-")+(days>0?days+"d ":"")+(hour>0?(days>0?" ":"")+hour+"h":"")+(min>0?(days>0||hour>0?" ":"")+min+"m":"")+(sec>0?+sec+"s":"");}function millisFromHourMinute(stringHourMinutes){//All this format are valid: "12:58" "13.75"  "63635676000" (this is already in milliseconds)
var semiColSeparator=stringHourMinutes.indexOf(":");if(semiColSeparator==0)// :30 minutes
return millisFromHourMinuteSecond("00"+stringHourMinutes+":00");else if(semiColSeparator>0)// 1:15 hours:minutes
return millisFromHourMinuteSecond(stringHourMinutes+":00");else return millisFromHourMinuteSecond(stringHourMinutes);}function millisFromHourMinuteSecond(stringHourMinutesSeconds){//All this format are valid: "00:12:58" "12:58:55" "13.75"  "63635676000" (this is already in milliseconds)
var result=0;stringHourMinutesSeconds.replace(",",".");var semiColSeparator=stringHourMinutesSeconds.indexOf(":");var dotSeparator=stringHourMinutesSeconds.indexOf(".");if(semiColSeparator<0&&dotSeparator<0&&stringHourMinutesSeconds.length>5){return parseInt(stringHourMinutesSeconds,10);//already in millis
}else{if(dotSeparator>-1){var d=parseFloat(stringHourMinutesSeconds);result=d*3600000;}else{var hour=0;var minute=0;var second=0;if(semiColSeparator==-1)hour=parseInt(stringHourMinutesSeconds,10);else{var units=stringHourMinutesSeconds.split(":");hour=parseInt(units[0],10);minute=parseInt(units[1],10);second=parseInt(units[2],10);}result=hour*3600000+minute*60000+second*1000;}if(typeof result!="number")result=NaN;return result;}}/**
 * @param string              "3y 4d", "4D:08:10", "12M/3d", "1.5D", "2H4D", "3M4d,2h", "12:30", "11", "3", "1.5", "2m/3D", "12/3d", "1234"
 *                            by default 2 means 2 hours 1.5 means 1:30
 * @param considerWorkingdays if true day length is from global.properties CompanyCalendar.MILLIS_IN_WORKING_DAY  otherwise in 24
 * @return milliseconds. 0 if invalid string
 */window.millisFromString=function(string,considerWorkingdays){if(!string)return 0;//var regex = new RegExp("(\\d+[Yy])|(\\d+[M])|(\\d+[Ww])|(\\d+[Dd])|(\\d+[Hh])|(\\d+[m])|(\\d+[Ss])|(\\d+:\\d+)|(:\\d+)|(\\d*[\\.,]\\d+)|(\\d+)", "g"); // bicch 14/1/16 supporto per 1.5d
var regex=new RegExp("([0-9\\.,]+[Yy])|([0-9\\.,]+[Qq])|([0-9\\.,]+[M])|([0-9\\.,]+[Ww])|([0-9\\.,]+[Dd])|([0-9\\.,]+[Hh])|([0-9\\.,]+[m])|([0-9\\.,]+[Ss])|(\\d+:\\d+:\\d+)|(\\d+:\\d+)|(:\\d+)|(\\d*[\\.,]\\d+)|(\\d+)","g");var matcher=regex.exec(string);var totMillis=0;if(!matcher)return NaN;while(matcher!=null){for(var i=1;i<matcher.length;i++){var match=matcher[i];if(match){var number=0;try{//number = parseInt(match); // bicch 14/1/16 supporto per 1.5d
number=parseFloat(match.replace(',','.'));}catch(e){}if(i==1){// years
totMillis=totMillis+number*(considerWorkingdays?millisInWorkingDay*workingDaysPerWeek*52:3600000*24*365);}else if(i==2){// quarter
totMillis=totMillis+number*(considerWorkingdays?millisInWorkingDay*workingDaysPerWeek*4:3600000*24*91);}else if(i==3){// months
totMillis=totMillis+number*(considerWorkingdays?millisInWorkingDay*workingDaysPerWeek*4:3600000*24*30);}else if(i==4){// weeks
totMillis=totMillis+number*(considerWorkingdays?millisInWorkingDay*workingDaysPerWeek:3600000*24*7);}else if(i==5){// days
totMillis=totMillis+number*(considerWorkingdays?millisInWorkingDay:3600000*24);}else if(i==6){// hours
totMillis=totMillis+number*3600000;}else if(i==7){// minutes
totMillis=totMillis+number*60000;}else if(i==8){// seconds
totMillis=totMillis+number*1000;}else if(i==9){// hour:minutes:seconds
totMillis=totMillis+millisFromHourMinuteSecond(match);}else if(i==10){// hour:minutes
totMillis=totMillis+millisFromHourMinute(match);}else if(i==11){// :minutes
totMillis=totMillis+millisFromHourMinute(match);}else if(i==12){// hour.minutes
totMillis=totMillis+millisFromHourMinute(match);}else if(i==13){// hours
totMillis=totMillis+number*3600000;}}}matcher=regex.exec(string);}return totMillis;};/**
 * @param string              "3y 4d", "4D:08:10", "12M/3d", "2H4D", "3M4d,2h", "12:30", "11", "3", "1.5", "2m/3D", "12/3d", "1234"
 *                            by default 2 means 2 hours 1.5 means 1:30
 * @param considerWorkingdays if true day length is from global.properties CompanyCalendar.MILLIS_IN_WORKING_DAY  otherwise in 24
 * @return milliseconds. 0 if invalid string
 */window.daysFromString=function(string,considerWorkingdays){if(!string)return undefined;//var regex = new RegExp("(\\d+[Yy])|(\\d+[Mm])|(\\d+[Ww])|(\\d+[Dd])|(\\d*[\\.,]\\d+)|(\\d+)", "g"); // bicch 14/1/16 supporto per 1.5d
//var regex = new RegExp("([0-9\\.,]+[Yy])|([0-9\\.,]+[Qq])|([0-9\\.,]+[Mm])|([0-9\\.,]+[Ww])|([0-9\\.,]+[Dd])|(\\d*[\\.,]\\d+)|(\\d+)", "g");
var regex=new RegExp("([\\-]?[0-9\\.,]+[Yy])|([\\-]?[0-9\\.,]+[Qq])|([\\-]?[0-9\\.,]+[Mm])|([\\-]?[0-9\\.,]+[Ww])|([\\-]?[0-9\\.,]+[Dd])|([\\-]?\\d*[\\.,]\\d+)|([\\-]?\\d+)","g");var matcher=regex.exec(string);var totDays=0;if(!matcher)return NaN;while(matcher!=null){for(var i=1;i<matcher.length;i++){var match=matcher[i];if(match){var number=0;try{number=parseInt(match);// bicch 14/1/16 supporto per 1.5d
number=parseFloat(match.replace(',','.'));}catch(e){}if(i==1){// years
totDays=totDays+number*(considerWorkingdays?workingDaysPerWeek*52:365);}else if(i==2){// quarter
totDays=totDays+number*(considerWorkingdays?workingDaysPerWeek*12:91);}else if(i==3){// months
totDays=totDays+number*(considerWorkingdays?workingDaysPerWeek*4:30);}else if(i==4){// weeks
totDays=totDays+number*(considerWorkingdays?workingDaysPerWeek:7);}else if(i==5){// days
totDays=totDays+number;}else if(i==6){// days.minutes
totDays=totDays+number;}else if(i==7){// days
totDays=totDays+number;}}}matcher=regex.exec(string);}return parseInt(totDays);};

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _defineProperty2=__webpack_require__(225);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _i18n;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*
 Copyright (c) 2012-2017 Open Lab
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */function dateToRelative(localTime){var diff=new Date().getTime()-localTime;var ret="";var min=60000;var hour=3600000;var day=86400000;var wee=604800000;var mon=2629800000;var yea=31557600000;if(diff<-yea*2)ret="in ## years".replace("##",(-diff/yea).toFixed(0));else if(diff<-mon*9)ret="in ## months".replace("##",(-diff/mon).toFixed(0));else if(diff<-wee*5)ret="in ## weeks".replace("##",(-diff/wee).toFixed(0));else if(diff<-day*2)ret="in ## days".replace("##",(-diff/day).toFixed(0));else if(diff<-hour)ret="in ## hours".replace("##",(-diff/hour).toFixed(0));else if(diff<-min*35)ret="in about one hour";else if(diff<-min*25)ret="in about half hour";else if(diff<-min*10)ret="in some minutes";else if(diff<-min*2)ret="in few minutes";else if(diff<=min)ret="just now";else if(diff<=min*5)ret="few minutes ago";else if(diff<=min*15)ret="some minutes ago";else if(diff<=min*35)ret="about half hour ago";else if(diff<=min*75)ret="about an hour ago";else if(diff<=hour*5)ret="few hours ago";else if(diff<=hour*24)ret="## hours ago".replace("##",(diff/hour).toFixed(0));else if(diff<=day*7)ret="## days ago".replace("##",(diff/day).toFixed(0));else if(diff<=wee*5)ret="## weeks ago".replace("##",(diff/wee).toFixed(0));else if(diff<=mon*12)ret="## months ago".replace("##",(diff/mon).toFixed(0));else ret="## years ago".replace("##",(diff/yea).toFixed(0));return ret;}//override date format i18n
Date.monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"];// Month abbreviations. Change this for local month names
Date.monthAbbreviations=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];// Full day names. Change this for local month names
Date.dayNames=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];// Day abbreviations. Change this for local month names
Date.dayAbbreviations=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];// Used for parsing ambiguous dates like 1/2/2000 - default to preferring 'American' format meaning Jan 2.
// Set to false to prefer 'European' format meaning Feb 1
Date.preferAmericanFormat=false;Date.firstDayOfWeek=0;Date.defaultFormat="M/d/yyyy";Date.masks={fullDate:"EEEE, MMMM d, yyyy",shortTime:"h:mm a"};Date.today="Today";Number.decimalSeparator=".";Number.groupingSeparator=",";Number.minusSign="-";Number.currencyFormat="###,##0.00";var millisInWorkingDay=28800000;var workingDaysPerWeek=5;window.isHoliday=function(date){var friIsHoly=false;var satIsHoly=true;var sunIsHoly=true;var pad=function pad(val){val="0"+val;return val.substr(val.length-2);};var holidays="##";var ymd="#"+date.getFullYear()+"_"+pad(date.getMonth()+1)+"_"+pad(date.getDate())+"#";var md="#"+pad(date.getMonth()+1)+"_"+pad(date.getDate())+"#";var day=date.getDay();return day==5&&friIsHoly||day==6&&satIsHoly||day==0&&sunIsHoly||holidays.indexOf(ymd)>-1||holidays.indexOf(md)>-1;};var i18n=(_i18n={YES:"Yes",NO:"No",FLD_CONFIRM_DELETE:"confirm the deletion?",INVALID_DATA:"The data inserted are invalid for the field format.",ERROR_ON_FIELD:"Error on field",OUT_OF_BOUDARIES:"Out of field admitted values:",CLOSE_ALL_CONTAINERS:"close all?",DO_YOU_CONFIRM:"Do you confirm?",ERR_FIELD_MAX_SIZE_EXCEEDED:"Field max size exceeded",WEEK_SHORT:"W.",FILE_TYPE_NOT_ALLOWED:"File type not allowed.",FILE_UPLOAD_COMPLETED:"File upload completed.",UPLOAD_MAX_SIZE_EXCEEDED:"Max file size exceeded",ERROR_UPLOADING:"Error uploading",UPLOAD_ABORTED:"Upload aborted",DROP_HERE:"Drop files here",FORM_IS_CHANGED:"You have some unsaved data on the page!",PIN_THIS_MENU:"PIN_THIS_MENU",UNPIN_THIS_MENU:"UNPIN_THIS_MENU",OPEN_THIS_MENU:"OPEN_THIS_MENU",CLOSE_THIS_MENU:"CLOSE_THIS_MENU",PROCEED:"Proceed?",PREV:"Previous",NEXT:"Next",HINT_SKIP:"Got it, close this hint.",WANT_TO_SAVE_FILTER:"save this filter",NEW_FILTER_NAME:"name of the new filter",SAVE:"Save",DELETE:"Delete"},(0,_defineProperty3.default)(_i18n,"HINT_SKIP","Got it, close this hint."),(0,_defineProperty3.default)(_i18n,"COMBO_NO_VALUES","no values available...?"),(0,_defineProperty3.default)(_i18n,"FILTER_UPDATED","Filter updated."),(0,_defineProperty3.default)(_i18n,"FILTER_SAVED","Filter correctly saved."),_i18n);

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _stringify=__webpack_require__(1136);var _stringify2=_interopRequireDefault(_stringify);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*
 Copyright (c) 2012-2017 Open Lab
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */// works also for IE8 beta
var isExplorer=navigator.userAgent.toUpperCase().indexOf("MSIE")>=0||!!navigator.userAgent.match(/Trident.*rv\:11\./);var isMozilla=navigator.userAgent.toUpperCase().indexOf("FIREFOX")>=0;var isSafari=navigator.userAgent.toLowerCase().indexOf("safari")!=-1&&navigator.userAgent.toLowerCase().indexOf('chrome')<0;//Version detection
var version=navigator.appVersion.substring(0,1);var inProduction=false;if(inProduction){window.console=undefined;}// deprecated use $("#domid")...
function obj(element){if(arguments.length>1){alert("invalid use of obj with multiple params:"+element);}var el=document.getElementById(element);if(!el)console.error("element not found: "+element);return el;}if(!window.console){window.console=new function(){this.log=function(str){/*alert(str)*/};this.debug=function(str){/*alert(str)*/};this.error=function(str){/*alert(str)*/};}();}if(!window.console.debug||!window.console.error||!window.console.log){window.console=new function(){this.log=function(str){/*alert(str)*/};this.debug=function(str){/*alert(str)*/};this.error=function(str){/*alert(str)*/};}();}String.prototype.trim=function(){return this.replace(/^\s*(\S*(\s+\S+)*)\s*$/,"$1");};String.prototype.startsWith=function(t,i){if(!i){return t==this.substring(0,t.length);}else{return t.toLowerCase()==this.substring(0,t.length).toLowerCase();}};String.prototype.endsWith=function(t,i){if(!i){return t==this.substring(this.length-t.length);}else{return t.toLowerCase()==this.substring(this.length-t.length).toLowerCase();}};// leaves only char from A to Z, numbers, _ -> valid ID
String.prototype.asId=function(){return this.replace(/[^a-zA-Z0-9_]+/g,'');};String.prototype.replaceAll=function(from,to){return this.replace(new RegExp(RegExp.quote(from),'g'),to);};if(!Array.prototype.indexOf){Array.prototype.indexOf=function(searchElement,fromIndex){if(this==null){throw new TypeError();}var t=Object(this);var len=t.length>>>0;if(len===0){return-1;}var n=0;if(arguments.length>0){n=Number(arguments[1]);if(n!=n){// shortcut for verifying if it's NaN
n=0;}else if(n!=0&&n!=Infinity&&n!=-Infinity){n=(n>0||-1)*Math.floor(Math.abs(n));}}if(n>=len){return-1;}var k=n>=0?n:Math.max(len-Math.abs(n),0);for(;k<len;k++){if(k in t&&t[k]===searchElement){return k;}}return-1;};}Object.size=function(obj){var size=0,key;for(key in obj){if(obj.hasOwnProperty(key))size++;}return size;};// transform string values to printable: \n in <br>
function transformToPrintable(data){for(var prop in data){var value=data[prop];if(typeof value=="string")data[prop]=(value+"").replace(/\n/g,"<br>");}return data;}RegExp.quote=function(str){return str.replace(/([.?*+^$[\]\\(){}-])/g,"\\$1");};/* Object Functions */function stopBubble(e){e.stopPropagation();e.preventDefault();return false;}// ------ ------- -------- wraps http://www.mysite.com/.......   with <a href="...">
jQuery.fn.activateLinks=function(showImages){var httpRE=/(['"]\s*)?(http[s]?:[\d]*\/\/[^"<>\s]*)/g;var wwwRE=/(['"/]\s*)?(www\.[^"<>\s]+)/g;var imgRE=/(['"]\s*)?(http[s]?:[\d]*\/\/[^"<>\s]*\.(?:gif|jpg|png|jpeg|bmp))/g;this.each(function(){var el=$(this);var html=el.html();if(showImages){// workaround for negative look ahead
html=html.replace(imgRE,function($0,$1){return $1?$0:"<div class='imgWrap'  onclick=\"window.open('"+$0+"','_blank');event.stopPropagation();\"><img src='"+$0+"' title='"+$0+"'></div>";});}html=html.replace(httpRE,function($0,$1){return $1?$0:"<a href='#' onclick=\"window.open('"+$0+"','_blank');event.stopPropagation();\">"+$0+"</a>";});html=html.replace(wwwRE,function($0,$1){return $1?$0:"<a href='#' onclick=\"window.open('http://"+$0+"','_blank');event.stopPropagation();\">"+$0+"</a>";});el.empty().append(html);if(showImages){//inject expand capability on images
el.find("div.imgWrap").each(function(){var imageDiv=$(this);imageDiv.click(function(e){if(e.ctrlKey||e.metaKey){window.open(imageDiv.find("img").prop("src"),"_blank");}else{var imageClone=imageDiv.find("img").clone();imageClone.mouseout(function(){$(this).remove();});imageClone.addClass("imageClone").css({"position":"absolute","display":"none","top":imageDiv.position().top,"left":imageDiv.position().left,"z-index":1000000});imageDiv.after(imageClone);imageClone.fadeIn();}});});}});return this;};jQuery.fn.emoticonize=function(){function convert(text){var faccRE=/(:\))|(:-\))|(:-])|(:-\()|(:\()|(:-\/)|(:-\\)|(:-\|)|(;-\))|(:-D)|(:-P)|(:-p)|(:-0)|(:-o)|(:-O)|(:'-\()|(\(@\))/g;return text.replace(faccRE,function(str){var ret={":)":"smile",":-)":"smile",":-]":"polite_smile",":-(":"frown",":(":"frown",":-/":"skepticism",":-\\":"skepticism",":-|":"sarcasm",";-)":"wink",":-D":"grin",":-P":"tongue",":-p":"tongue",":-o":"surprise",":-O":"surprise",":-0":"surprise",":'-(":"tear","(@)":"angry"}[str];if(ret){ret="<img src='"+contextPath+"/img/smiley/"+ret+".png' align='absmiddle'>";return ret;}else return str;});}function addBold(text){var returnedValue;var faccRE=/\*\*[^*]*\*\*/ig;return text.replace(faccRE,function(str){var temp=str.substr(2);var temp2=temp.substr(0,temp.length-2);return"<b>"+temp2+"</b>";});}this.each(function(){var el=$(this);var html=convert(el.html());html=addBold(html);el.html(html);});return this;};// ---------------------------------- initialize management
var __initedComponents=new Object();function initialize(url,type,ndo){//console.debug("initialize before: " + url);
var normUrl=url.asId();var deferred=$.Deferred();if(!__initedComponents[normUrl]){__initedComponents[normUrl]=deferred;if("CSS"==(type+"").toUpperCase()){var link=$("<link rel='stylesheet' type='text/css'>").prop("href",url);$("head").append(link);deferred.resolve();}else if("SCRIPT"==(type+"").toUpperCase()){$.ajax({type:"GET",url:url+"?"+buildNumber,dataType:"script",cache:true,success:function success(){//console.debug("initialize loaded:" + url);
deferred.resolve();},error:function error(){//console.debug("initialize failed:" + url);
deferred.reject();}});}else{//console.debug(url+" as DOM");
//var text = getContent(url);
url=url+(url.indexOf("?")>-1?"&":"?")+buildNumber;var text=$.ajax({type:"GET",url:url,dataType:"html",cache:true,success:function success(text){//console.debug("initialize loaded:" + url);
ndo=ndo||$("body");ndo.append(text);deferred.resolve();},error:function error(){//console.debug("initialize failed:" + url);
deferred.reject();}});}}return __initedComponents[normUrl].promise();}/**
 *  callback receive event, data
 *  data.response  contiene la response json arrivata dal controller
 *  E.G.:
 *     $("body").trigger("worklogEvent",[{type:"delete",response:response}])
 *
 *     in caso di delete di solito c'è il response.deletedId
 */function registerEvent(eventName,callback){$("body").off(eventName).on(eventName,callback);}function openPersistentFile(file){//console.debug("openPersistentFile",file);
var t=window.self;try{if(window.top!=window.self)t=window.top;}catch(e){}if(file.mime.indexOf("image")>=0){var img=$("<img>").prop("src",file.url).css({position:"absolute",top:"-10000px",left:"-10000px"}).one("load",function(){//console.debug("image loaded");
var img=$(this);var w=img.width();var h=img.height();//console.debug("image loaded",w,h);
var f=w/h;var ww=$(t).width()*.8;var wh=$(t).height()*.8;if(w>ww){w=ww;h=w/f;}if(h>wh){h=wh;w=h*f;}var hasTop=false;img.width(w).height(h).css({position:"static",top:0,left:0});t.createModalPopup(w+100,h+100).append(img);});t.$("body").append(img);}else if(file.mime.indexOf("pdf")>=0){t.openBlackPopup(file.url,$(t).width()*.8,$(t).height()*.8);}else{window.open(file.url+"&TREATASATTACH=yes");}}function wrappedEvaluer(toEval){eval(toEval);}function evalInContext(stringToEval,context){wrappedEvaluer.apply(context,[stringToEval]);}Storage.prototype.setObject=function(key,value){this.setItem(key,(0,_stringify2.default)(value));};Storage.prototype.getObject=function(key){return this.getItem(key)&&JSON.parse(this.getItem(key));};function objectSize(size){var divisor=1;var unit="bytes";if(size>=1024*1024){divisor=1024*1024;unit="MB";}else if(size>=1024){divisor=1024;unit="KB";}if(divisor==1)return size+" "+unit;return(size/divisor).toFixed(2)+' '+unit;}function htmlEncode(value){//create a in-memory div, set it's inner text(which jQuery automatically encodes)
//then grab the encoded contents back out.  The div never exists on the page.
return $('<div/>').text(value).html();}function htmlLinearize(value,length){value=value.replace(/(\r\n|\n|\r)/gm,"").replace(/<br>/g," - ");value=value.replace(/-  -/g,"-");var ret=$('<div/>').text(value).text();if(length){var ellips=ret.length>length?"...":"";ret=ret.substring(0,length)+ellips;}return ret;}function htmlDecode(value){return $('<div/>').html(value).text();}function createCookie(name,value,days){if(days){var date=new Date();date.setTime(date.getTime()+days*24*60*60*1000);var expires="; expires="+date.toGMTString();}else var expires="";document.cookie=name+"="+value+expires+"; path=/";}function readCookie(name){var nameEQ=name+"=";var ca=document.cookie.split(';');for(var i=0;i<ca.length;i++){var c=ca[i];while(c.charAt(0)==' '){c=c.substring(1,c.length);}if(c.indexOf(nameEQ)==0)return c.substring(nameEQ.length,c.length);}return null;}function eraseCookie(name){createCookie(name,"",-1);}function getParameterByName(name,url){if(!url)url=window.location.href;name=name.replace(/[\[\]]/g,"\\$&");var regex=new RegExp("[?&]"+name+"(=([^&#]*)|&|#|$)"),results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g," "));}$.fn.isEmptyElement=function(){return!$.trim($(this).html());};//workaround for jquery 3.x
if(typeof $.fn.size!="funcion")$.fn.size=function(){return this.length;};//-----------------------------------------------------------为svg标签添加样式
$.fn.addSvgClass=function(className){return this.each(function(){var attr=$(this).attr('class')||"";if(attr.indexOf(className)==-1){$(this).attr('class',$.trim(attr+' '+className));}});};$.fn.removeSvgClass=function(className){return this.each(function(){var attr=$(this).attr('class')||"";if(attr.indexOf(className)>-1){$(this).attr('class',attr.split(" ").filter(function(item){return item!=className;}).join(" "));}});};

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1137), __esModule: true };

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(22);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _set=__webpack_require__(429);var _set2=_interopRequireDefault(_set);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


 todo For compatibility with IE and SVGElements.getElementsByClassName not implemented changed every find starting from SVGElement (the other works fine)
 .find(".classname"))  -> .find("[class*=classname])
 */window.Ganttalendar=function(startMillis,endMillis,master,minGanttSize){this.master=master;// is the a GantEditor instance
this.element;// is the jquery element containing gantt
this.svg;// instance of svg object containing gantt
this.tasksGroup;//instance of svg group containing tasks
this.linksGroup;//instance of svg group containing links
this.minGanttSize=minGanttSize;this.includeToday=false;//when true today is always visible. If false boundaries comes from tasks periods
this.showCriticalPath=false;//when true critical path is highlighted
this.initZoomlevels();// initialite the zoom level definitions
this.originalStartMillis=startMillis;this.originalEndMillis=endMillis;this.gridChanged=true;//witness for boundaries changed. Force to redraw gantt grid
this.element=this.createGanttGrid();// fake
this.linkOnProgress=false;//set to true when creating a new link
this.taskHeight=20;this.resizeZoneWidth=5;this.taskVertOffset=(this.master.rowHeight-this.taskHeight)/2;};Ganttalendar.prototype.zoomGantt=function(isPlus,zoom){var centerMillis=this.getCenterMillis();if(zoom){if(this.zoom!=zoom){this.zoom=zoom;this.gridChanged=true;this.redraw();this.goToMillis(centerMillis);}}else{var curLevel=this.zoom;var pos=this.zoomLevels.indexOf(curLevel+"");var newPos=pos;if(isPlus){newPos=pos<=0?0:pos-1;}else{newPos=pos>=this.zoomLevels.length-1?this.zoomLevels.length-1:pos+1;}if(newPos!=pos){curLevel=this.zoomLevels[newPos];this.gridChanged=true;this.zoom=curLevel;this.redraw();this.goToMillis(centerMillis);}}};Ganttalendar.prototype.createHeadCell=function(level,zoomDrawer,rowCtx,lbl,span,additionalClass,start,end){var x=(start.getTime()-self.startMillis)*zoomDrawer.computedScaleX;var th=$("<th>").html(lbl).attr("colSpan",span);if(level>1){//set width on second level only
var w=(end.getTime()-start.getTime())*zoomDrawer.computedScaleX;th.width(w);}if(additionalClass)th.addClass(additionalClass);rowCtx.append(th);};Ganttalendar.prototype.createBodyCell=function(zoomDrawer,tr,span,isEnd,additionalClass){var ret=$("<td>").html("").attr("colSpan",span).addClass("ganttBodyCell");if(isEnd)ret.addClass("end");if(additionalClass)ret.addClass(additionalClass);tr.append(ret);};//判断是否时间边界变更了
Ganttalendar.prototype.isChangedBoundary=function(){var self=this;var zoomDrawer=self.zoomDrawers[self.zoom]||self.zoomDrawers[self.zoomLevels[self.zoomLevels.length-1]];var adjustedStartDate=new Date(this.originalStartMillis);var adjustedEndDate=new Date(this.originalEndMillis);zoomDrawer.adjustDates(adjustedStartDate,adjustedEndDate);var start=new Date(adjustedStartDate).setHours(0,0,0,0);//real dimension of gantt
var end=new Date(adjustedEndDate).setHours(23,59,59,999);return start!=self.startMillis||end!=self.endMillis;};Ganttalendar.prototype.createGanttGrid=function(){var self=this;var zoomDrawer=self.zoomDrawers[self.zoom]||self.zoomDrawers[self.zoomLevels[self.zoomLevels.length-1]];//get best dimension for gantt
var adjustedStartDate=new Date(this.originalStartMillis);var adjustedEndDate=new Date(this.originalEndMillis);zoomDrawer.adjustDates(adjustedStartDate,adjustedEndDate);self.startMillis=new Date(adjustedStartDate).setHours(0,0,0,0);//real dimension of gantt
self.endMillis=new Date(adjustedEndDate).setHours(23,59,59,999);//this is computed by hand in order to optimize cell size
var computedTableWidth=(self.endMillis-self.startMillis)*zoomDrawer.computedScaleX;//set a minimal width
computedTableWidth=Math.max(computedTableWidth,self.minGanttSize);var table=$("<table cellspacing=0 cellpadding=0>");//loop for header1
var start=new Date(self.startMillis);var tr1=$("<tr>").addClass("ganttHead1");while(start.getTime()<=self.endMillis){zoomDrawer.row1(start,tr1);}//loop for header2  e tbody
start=new Date(self.startMillis);var tr2=$("<tr>").addClass("ganttHead2");var trBody=$("<tr>").addClass("ganttBody");var rowNum=0;while(start.getTime()<=self.endMillis){zoomDrawer.row2(start,tr2,trBody);rowNum++;}if(self.master.ganttStore.timelinekey=='1M'){computedTableWidth=rowNum*20;//20像素一天
}table.append(tr1).append(tr2);// removed as on FF there are rounding issues  //.css({width:computedTableWidth});
var head=table.clone().addClass("ganttFixHead");table.find('.ganttHead1').css('visibility','hidden');table.find('.ganttHead2').css('visibility','hidden');table.append(trBody).addClass("ganttTable");var height=self.master.editor.element.height();table.height(height);var box=$("<div>");box.addClass("gantt unselectable").attr("unselectable","true").css({position:"relative",width:computedTableWidth});box.append(table);box.append(head);var getGanttId=this.master.ganttStore.id;var temp=80;if(location.href.includes('/wui/index.html')){temp=140;}var svgDiv=$("<div>").addClass("gantSVGBoxDiv").height($(window).height()-temp-this.master.topHeight).width($('.splitBox2').width());svgDiv.scroll(function(e){var el=$(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDiv');var top=el.scrollTop();var firstBox=$(".TWGanttWorkSpace_"+getGanttId).find('.splitBox1');firstBox.scrollTop(top);var left=el.scrollLeft();$(".TWGanttWorkSpace_"+getGanttId).find('.gantt').find('.ganttFixHead').css('left',-left);$(".TWGanttWorkSpace_"+getGanttId).find('.gantt').find('.ganttTable').css('margin-left',-left);});var svgDivContent=$("<div>").addClass("gantSVGBoxDivContent").width(computedTableWidth).height(height);svgDiv.append(svgDivContent);//create the svg
svgDivContent.svg({settings:{class:"ganttSVGBox"},onLoad:function onLoad(svg){//console.debug("svg loaded", svg);
//creates gradient and definitions
var defs=svg.defs('myDefs');//create backgound
var extDep=svg.pattern(defs,"extDep",0,0,10,10,0,0,10,10,{patternUnits:'userSpaceOnUse'});var img=svg.image(extDep,0,0,10,10,self.master.resourceUrl+"hasExternalDeps.png",{opacity:.3});self.svg=svg;$(svg).addClass("ganttSVGBox");//creates grid group
var gridGroup=svg.group("gridGroup");//creates links group
self.linksGroup=svg.group("linksGroup");//creates tasks group
self.tasksGroup=svg.group("tasksGroup");//compute scalefactor fx
//self.fx = computedTableWidth / (endPeriod - startPeriod);
self.fx=zoomDrawer.computedScaleX;}});box.append(svgDiv);return box;};//拖动日期提示相关方法
Ganttalendar.prototype.createTaskBox=function(taskbox,svg,taskBox){var text=$(svg.text(parseInt(taskbox.attr("x"))+parseInt(taskbox.attr("width")+8),parseInt(taskbox.attr("y"))+5,"",{"font-size":"10px","font-weight":"bold","fill":"red"}));taskBox.data("textDur",text);};Ganttalendar.prototype.taskBoxShowText=function(taskbox,taskBox,e,self,type){var st=Math.round(parseFloat(taskbox.attr("x"))/self.fx+self.startMillis);var en=Math.round((parseFloat(taskbox.attr("x"))+parseFloat(taskbox.attr("width")))/self.fx+self.startMillis);var d='';var text=taskBox.data("textDur");var x=parseFloat(taskbox.attr("x"));if(type=='0'){//向左
d=new Date(st).format("yyyy-MM-dd HH:mm");x-=90;}else if(type=='1'){//向右
d=new Date(en).format("yyyy-MM-dd HH:mm");x+=parseFloat(taskbox.attr("width"));}else if(type=='2'){//平移
d=new Date(st).format("yyyy-MM-dd HH:mm")+" - "+new Date(en).format("yyyy-MM-dd HH:mm");}text.attr("x",x).html(d);};Ganttalendar.prototype.removeTaskBox=function(taskBox){var textBox=taskBox.data("textDur");if(textBox)textBox.remove();};//<%-------------------------------------- GANT TASK GRAPHIC ELEMENT --------------------------------------%>
Ganttalendar.prototype.drawTask=function(task){var self=this;var taskBoxs=_createTaskSVG(task);var taskBox=$(taskBoxs[0]);//计划时间
var taskBox2=$(taskBoxs[1]);//实际时间
task.ganttElement=taskBox;task.ganttElement2=taskBox2;if(self.showCriticalPath&&task.isCritical)taskBox.addClass("critical");if(this.master.permissions.canWrite||task.canWrite){//计划任务的拖拽事件
taskBox.click(function(e){// manages selection
e.stopPropagation();// to avoid body remove focused
}).dblclick(function(){}).mouseup(function(e){self.master.ganttStore.ganttIsMouseDown=false;}).mousedown(function(e){self.master.ganttStore.workSpaceClick(e);self.master.ganttStore.ganttIsMouseDown=true;self.master.ganttStore.closeTaskInfo();}).dragExtedSVG($(self.svg.root()),{canResize:this.master.permissions.canWrite||task.canWrite,canDrag:this.master.permissions.canWrite||task.canWrite,resizeZoneWidth:self.resizeZoneWidth,startDrag:function startDrag(e){self.createTaskBox($(this),self.svg,taskBox);},drag:function drag(e){self.taskBoxShowText($(this),taskBox,e,self,'2');},drop:function drop(e){//平移结束回调函数
self.removeTaskBox(taskBox);self.resDrop=true;//hack to avoid select
var taskbox=$(this);var task=self.master.getTask(taskbox.attr("taskid"));var st=Math.round(parseFloat(taskbox.attr("x"))/self.fx+self.startMillis);var en=Math.round((parseFloat(taskbox.attr("x"))+parseFloat(taskbox.attr("width")))/self.fx+self.startMillis);//in order to avoid rounding issue if the movement is less than 1px we keep the same start and end dates
if(Math.abs(st-task.start)<1/self.fx){st=task.start;}if(Math.abs(en-task.end)<1/self.fx){en=task.end;}task.start=st;task.end=en;self.master.afterModifiedTask(task,true);self.master.ganttStore.synchronizeGridEditor(task,'jh');},startResize:function startResize(e){//开始改变taskbox的宽度
self.createTaskBox($(this),self.svg,taskBox);},resize:function resize(e,type){//改变taskbox的宽度  type:0向左，1向右，2平移
self.taskBoxShowText($(this),taskBox,e,self,type);},stopResize:function stopResize(e,type){//结束改变taskbox的宽度
self.removeTaskBox(taskBox);self.resDrop=true;//hack to avoid select
var taskbox=$(this);var task=self.master.getTask(taskbox.attr("taskid"));var st=Math.round(parseFloat(taskbox.attr("x"))/self.fx+self.startMillis);var en=Math.round((parseFloat(taskbox.attr("x"))+parseFloat(taskbox.attr("width")))/self.fx+self.startMillis);//in order to avoid rounding issue if the movement is less than 1px we keep the same start and end dates
if(Math.abs(st-task.start)<1/self.fx){st=task.start;}if(Math.abs(en-task.end)<1/self.fx){en=task.end;}task.start=st;task.end=en;//重绘svg图
self.master.afterModifiedTask(task,true);self.master.ganttStore.synchronizeGridEditor(task,'jh');}});//实际任务的拖拽事件
taskBox2.click(function(e){// manages selection
e.stopPropagation();// to avoid body remove focused
}).dblclick(function(){}).mouseup(function(e){self.master.ganttStore.ganttIsMouseDown=false;}).mousedown(function(e){self.master.ganttStore.workSpaceClick(e);self.master.ganttStore.ganttIsMouseDown=true;self.master.ganttStore.closeTaskInfo();}).dragExtedSVG($(self.svg.root()),{canResize:this.master.permissions.canWrite||task.canWrite,canDrag:this.master.permissions.canWrite||task.canWrite,resizeZoneWidth:self.resizeZoneWidth,startDrag:function startDrag(e){self.createTaskBox($(this),self.svg,taskBox);},drag:function drag(e){self.taskBoxShowText($(this),taskBox,e,self,'2');},drop:function drop(e){//平移结束回调函数
self.removeTaskBox(taskBox);self.resDrop=true;//hack to avoid select
var taskbox=$(this);var task=self.master.getTask(taskbox.attr("taskid"));var st=Math.round(parseFloat(taskbox.attr("x"))/self.fx+self.startMillis);var en=Math.round((parseFloat(taskbox.attr("x"))+parseFloat(taskbox.attr("width")))/self.fx+self.startMillis);//in order to avoid rounding issue if the movement is less than 1px we keep the same actualbegindate and actualenddate dates
if(Math.abs(st-task.actualbegindate)<1/self.fx){st=task.actualbegindate;}if(Math.abs(en-task.actualenddate)<1/self.fx){en=task.actualenddate;}task.actualbegindate=st;task.actualenddate=en;self.master.afterModifiedTask(task,false);self.master.ganttStore.synchronizeGridEditor(task,'actual');},startResize:function startResize(e,type){//开始改变taskbox的宽度
self.createTaskBox($(this),self.svg,taskBox);},resize:function resize(e,type){//改变taskbox的宽度  type:0向左，1向右，2平移
self.taskBoxShowText($(this),taskBox,e,self,type);},stopResize:function stopResize(e,type){//结束改变taskbox的宽度
self.removeTaskBox(taskBox);self.resDrop=true;//hack to avoid select
var taskbox=$(this);var task=self.master.getTask(taskbox.attr("taskid"));var st=Math.round(parseFloat(taskbox.attr("x"))/self.fx+self.startMillis);var en=Math.round((parseFloat(taskbox.attr("x"))+parseFloat(taskbox.attr("width")))/self.fx+self.startMillis);//in order to avoid rounding issue if the movement is less than 1px we keep the same actualbegindate and actualenddate dates
if(Math.abs(st-task.actualbegindate)<1/self.fx){st=task.actualbegindate;}if(Math.abs(en-task.actualenddate)<1/self.fx){en=task.actualenddate;}task.actualbegindate=st;task.actualenddate=en;//重绘svg图
self.master.afterModifiedTask(task,false);self.master.ganttStore.synchronizeGridEditor(task,'actual');}});}taskBox.find("[class*=linkHandleSVG]").mousedown(function(e){e.preventDefault();e.stopPropagation();var taskBox=$(this).closest(".taskBoxSVG");var svg=$(self.svg.root());var offs=svg.offset();self.linkOnProgress=true;self.linkFromEnd=$(this).is(".taskLinkEndSVG");svg.addClass("linkOnProgress");// create the line
var startX=parseFloat(taskBox.attr("x"))+(self.linkFromEnd?parseFloat(taskBox.attr("width")):0);var startY=parseFloat(taskBox.attr("y"))+parseFloat(taskBox.attr("height"))/2;var line=self.svg.line(startX,startY,e.pageX-offs.left-5,e.pageY-offs.top-5,{class:"linkLineSVG"});var circle=self.svg.circle(startX,startY,5,{class:"linkLineSVG"});//bind mousemove to draw a line
svg.bind("mousemove.linkSVG",function(e){var offs=svg.offset();var nx=e.pageX-offs.left;var ny=e.pageY-offs.top;var c=Math.sqrt(Math.pow(nx-startX,2)+Math.pow(ny-startY,2));nx=nx-(nx-startX)*10/c;ny=ny-(ny-startY)*10/c;self.svg.change(line,{x2:nx,y2:ny});self.svg.change(circle,{cx:nx,cy:ny});});//bind mouseup un body to stop
$("body").one("mouseup.linkSVG",function(e){$(line).remove();$(circle).remove();self.linkOnProgress=false;svg.removeClass("linkOnProgress");$(self.svg.root()).unbind("mousemove.linkSVG");var targetBox=$(e.target).closest(".taskBoxSVG");if(targetBox&&targetBox.attr("taskid")!=taskBox.attr("taskid")){var taskTo;var taskFrom;if(self.linkFromEnd){taskTo=self.master.getTask(targetBox.attr("taskid"));taskFrom=self.master.getTask(taskBox.attr("taskid"));}else{taskFrom=self.master.getTask(targetBox.attr("taskid"));taskTo=self.master.getTask(taskBox.attr("taskid"));}if(taskTo&&taskFrom){//权限判断
if(!taskTo.canWrite){antd.message.warning('【'+taskTo.name+'】无编辑权限');return;}var getGanttId=self.master.ganttStore.id;$(".TWGanttWorkSpace_"+getGanttId).find("g[to="+taskTo.id+"]").remove();taskTo.front=taskFrom.id;//更新links
self.master.links=self.master.links.filter(function(item){return item.to.id!=taskTo.id;});self.master.links.push({from:taskFrom,to:taskTo,lag:0});self.drawLink(taskFrom,taskTo);self.master.ganttStore.synchronizeGridEditorFront(taskFrom,taskTo);}}});});//prof.stop();
function taskSVGMouseOver(e){var el=$(this);if(!self.linkOnProgress){$("[class*=linkHandleSVG]").hide();if(!self.master.ganttStore.ganttIsMouseDown)el.find("[class*=linkHandleSVG]").stopTime("hideLink").show();if(e.srcElement&&e.srcElement.getAttribute('class')&&e.srcElement.getAttribute('class').indexOf('taskLayout')>-1){self.master.ganttStore.showTaskInfo({left:e.pageX,top:$(taskBox).offset().top,task:task});}}else{if(el.attr('status')=='STATUS_JH'){el.addSvgClass("linkOver");}}}function taskSVGMouseOut(e){var el=$(this);el.removeSvgClass("linkOver").find("[class*=linkHandleSVG]").oneTime(500,"hideLink",function(){$(this).hide();});if(e.relatedTarget&&e.relatedTarget.getAttribute('class')&&e.relatedTarget.getAttribute('class').indexOf('taskLayout')>-1){return;}self.master.ganttStore.closeTaskInfo();}function _createTaskSVG(task){var svg=self.svg;var start=task.start;var end=task.end;var actualbegindate=task.actualbegindate;var actualenddate=task.actualenddate;var virtual_JH=false;if(!start&&!end){//如果开始日期和结束日期都为空，则取今天
start=new Date().setHours(0,0,0,0);end=new Date().setHours(23,59,59,999);virtual_JH=true;}else if(end<=start){//如果开始日期大于结束日期，则取开始日期
start=new Date(start);end=new Date(start).add('d',1);virtual_JH=true;}else if(!start&&end){start=new Date(end);end=new Date(end).add('d',-1);virtual_JH=true;}else if(start&&!end){start=new Date(start);end=new Date(start).add('d',1);virtual_JH=true;}var virtual_ACTUAL=false;if(!actualbegindate&&!actualenddate){actualbegindate=new Date().setHours(0,0,0,0);actualenddate=new Date().setHours(23,59,59,999);virtual_ACTUAL=true;}else if(actualenddate<=actualbegindate){actualbegindate=new Date(actualbegindate);actualenddate=new Date(actualbegindate).add('d',1);virtual_ACTUAL=true;}else if(!actualbegindate&&actualenddate){actualbegindate=new Date(actualenddate);actualenddate=new Date(actualenddate).add('d',-1);virtual_ACTUAL=true;}else if(actualbegindate&&!actualenddate){actualbegindate=new Date(actualbegindate);actualenddate=new Date(actualbegindate).add('d',1);virtual_ACTUAL=true;}var style_JH="";var style_ACTUAL="";if(self.master.ganttStore.datasColorMap[task.id]){style_JH='fill: '+self.master.ganttStore.datasColorMap[task.id].JH+';';if(virtual_JH){style_JH='fill: transparent;stroke-dasharray: 5;stroke-width:1;stroke:'+self.master.ganttStore.datasColorMap[task.id].JH+';';}style_ACTUAL='fill: '+self.master.ganttStore.datasColorMap[task.id].SJ+';';if(virtual_ACTUAL){style_ACTUAL='fill: transparent;stroke-dasharray: 5;stroke-width:1;stroke:'+self.master.ganttStore.datasColorMap[task.id].SJ+';';}}else{if(virtual_JH){style_JH='fill: transparent;stroke-dasharray: 5;stroke-width:1;';}if(virtual_ACTUAL){style_ACTUAL='fill: transparent;stroke-dasharray: 5;stroke-width:1;';}}var dimensions={x:Math.round((start-self.startMillis)*self.fx),x2:Math.round((actualbegindate-self.startMillis)*self.fx),y:task.rowElement.position().top+task.rowElement.offsetParent().scrollTop()+self.taskVertOffset-60,width:Math.max(Math.round((end-start)*self.fx),1),width2:Math.max(Math.round((actualenddate-actualbegindate)*self.fx),1),height:self.taskHeight};//----------------------------------------------------------------------------------------------计划时间
var taskSvg;taskSvg=svg.svg(self.tasksGroup,dimensions.x,dimensions.y,dimensions.width,dimensions.height,{class:"taskBox taskBoxSVG taskStatusSVG",status:'STATUS_JH',taskid:task.id});var layout=svg.rect(taskSvg,0,0,"100%","100%",{class:"taskLayout",style:style_JH,rx:"2",ry:"2"});$(taskSvg).mouseover(taskSVGMouseOver);$(taskSvg).mouseout(taskSVGMouseOut);//task label
svg.text(taskSvg,"100%",18,task.name+'('+task.progress+'%)',{class:"taskLabelSVG",transform:"translate(20,-5)"});//link tool
if(self.master.permissions.canWrite||task.canWrite){svg.circle(taskSvg,-self.resizeZoneWidth,dimensions.height/2,dimensions.height/3,{class:"taskLinkStartSVG linkHandleSVG",transform:"translate("+(-dimensions.height/3+1)+")"});}svg.circle(taskSvg,dimensions.width+self.resizeZoneWidth,dimensions.height/2,dimensions.height/3,{class:"taskLinkEndSVG linkHandleSVG",transform:"translate("+(dimensions.height/3-1)+")"});//---------------------------------------------------------------------------------------------------实际时间
var taskSvg2;taskSvg2=svg.svg(self.tasksGroup,dimensions.x2,dimensions.y+10,dimensions.width2,dimensions.height,{class:"taskBox taskBoxSVG taskStatusSVG taskActualSVG",status:task.status,taskid:task.id});var layout2=svg.rect(taskSvg2,0,0,"100%","50%",{class:"taskLayout",style:style_ACTUAL,rx:"2",ry:"2"});$(taskSvg2).mouseover(taskSVGMouseOver);$(taskSvg2).mouseout(taskSVGMouseOut);return[taskSvg,taskSvg2];}};Ganttalendar.prototype.addTask=function(task,row,from){var _this2=this;if(from=='addNew'){//点击按钮新增时
this.shrinkBoundaries(task);if(this.gridChanged&&this.isChangedBoundary()){//如果时间边界改变了需要重绘
if(this.master.tasks.length>100){this.master.ganttStore.loadingtip='甘特图绘制中，请等待...';var _this=this;setTimeout(function(){_this.redraw();},100);}else{this.redraw();}}else{//如果没改变时间边界就不重绘，主要处理数据量大时重绘比较耗时的问题。
var getGanttId=this.master.ganttStore.id;var workspace=$(".TWGanttWorkSpace_"+getGanttId);var gridGroup=workspace.find("#gridGroup").get(0);//甘特图最下边添加一行
this.svg.rect(gridGroup,0,this.master.editor.element.height(),"100%",this.master.rowHeight,{class:"ganttLinesSVG"});//延长甘特图的高度
workspace.find('.gantSVGBoxDivContent').height(workspace.find('.gantSVGBoxDivContent').height()+this.master.rowHeight);workspace.find('.ganttTable').height(workspace.find('.ganttTable').height()+this.master.rowHeight);//将新行一下的所有任务往下移一格
workspace.find('#tasksGroup').find('svg').each(function(index,item){if(item.getAttribute('y')>row*_this2.master.rowHeight){item.setAttribute('y',parseInt(item.getAttribute('y'))+parseInt(_this2.master.rowHeight));}});this.drawTask(task);//前置关系横跨row上下的线需要重新绘制
var links=this.master.links.filter(function(item){var fromRow=item.from.getRow();var toRow=item.to.getRow();if(fromRow>row){//大于row的原来task的原本的row都在现在的row基础上-1
fromRow-=1;}if(toRow>row){toRow-=1;}return fromRow>=row&&toRow<=row||fromRow<=row&&toRow>=row||fromRow>=row&&toRow>=row;});links.forEach(function(item){$('g[id="'+item.from.id+'-'+item.to.id+'"]').remove();});links.forEach(function(link){_this2.drawLink(link.from,link.to);});}}};/**
 * 将甘特图的几行移动位置
 * @param {*} from 从第几行
 * @param {*} to   到第几行
 * @param {*} at   移动到这一行下边
 */Ganttalendar.prototype.moveGantt=function(from,to,at){var _this3=this;var moveNum=to-from+1;//移动个数
//获取第一部分数据
var getGanttId=this.master.ganttStore.id;var workspace=$(".TWGanttWorkSpace_"+getGanttId);var firstDatas=workspace.find('#tasksGroup').find('svg').filter(function(index,item){return item.getAttribute('y')>from*_this3.master.rowHeight&&item.getAttribute('y')<(to+1)*_this3.master.rowHeight;});var taskids=new _set2.default();if(at>to){//上边的往下移 ,  分两步操作
var beMoved=at-to;//被移动的个数
var secondDatas=workspace.find('#tasksGroup').find('svg').filter(function(index,item){return item.getAttribute('y')>(to+1)*_this3.master.rowHeight&&item.getAttribute('y')<(at+1)*_this3.master.rowHeight;});//第一步将to至at的所有行往上移动moveNum个高度
secondDatas.each(function(index,item){item.setAttribute('y',parseInt(item.getAttribute('y'))-moveNum*parseInt(_this3.master.rowHeight));taskids.add(item.getAttribute('taskid'));});//第二步将from至to的所有行往下移动secondDatas.length个高度
firstDatas.each(function(index,item){item.setAttribute('y',parseInt(item.getAttribute('y'))+beMoved*parseInt(_this3.master.rowHeight));taskids.add(item.getAttribute('taskid'));});}else{//下边的往上移
var beMoved=from-at-1;//被移动的个数
var secondDatas=workspace.find('#tasksGroup').find('svg').filter(function(index,item){return item.getAttribute('y')>(at+1)*_this3.master.rowHeight&&item.getAttribute('y')<from*_this3.master.rowHeight;});//第一步将to至at的所有行往下移动moveNum个高度
secondDatas.each(function(index,item){item.setAttribute('y',parseInt(item.getAttribute('y'))+moveNum*parseInt(_this3.master.rowHeight));taskids.add(item.getAttribute('taskid'));});//第二步将from至to的所有行往上移动secondDatas.length个高度
firstDatas.each(function(index,item){item.setAttribute('y',parseInt(item.getAttribute('y'))-beMoved*parseInt(_this3.master.rowHeight));taskids.add(item.getAttribute('taskid'));});}//处理相关link
taskids.forEach(function(taskid){_this3.redrawLink(_this3.master.getTask(taskid));});};//<%-------------------------------------- GANT DRAW LINK SVG ELEMENT --------------------------------------%>
//'from' and 'to' are tasks already drawn
Ganttalendar.prototype.drawLink=function(from,to,type){//console.debug("drawLink")
var self=this;var peduncolusSize=10;/**
   * Given an item, extract its rendered position
   * width and height into a structure.
   */function buildRectFromTask(task){var start=task.start;var end=task.end;if(!start&&!end){//如果开始日期和结束日期都为空，则取今天
start=new Date().setHours(0,0,0,0);end=new Date().setHours(23,59,59,999);}else if(end<=start){//如果开始日期大于结束日期，则取开始日期
start=new Date(start);end=new Date(start).add('d',1);}else if(!start&&end){start=new Date(end);end=new Date(end).add('d',-1);}else if(start&&!end){start=new Date(start);end=new Date(start).add('d',1);}var self=task.master.gantt;var editorRow=task.rowElement;var top=editorRow.position().top+editorRow.offsetParent().scrollTop();var x=Math.round((start-self.startMillis)*self.fx);var rect={left:x,top:top+self.taskVertOffset,width:Math.max(Math.round((end-start)*self.fx),1),height:self.taskHeight};return rect;}/**
   * The default rendering method, which paints a start to end dependency.
   */function drawStartToEnd(from,to,ps){var svg=self.svg;//this function update an existing link
function update(){var group=$(this);var from=group.data("from");var to=group.data("to");var rectFrom=buildRectFromTask(from);var rectTo=buildRectFromTask(to);var fx1=rectFrom.left;var fx2=rectFrom.left+rectFrom.width;var fy=rectFrom.height/2+rectFrom.top-60;var tx1=rectTo.left;var tx2=rectTo.left+rectTo.width;var ty=rectTo.height/2+rectTo.top-60;var tooClose=tx1<fx2+2*ps;var r=5;//radius
var arrowOffset=5;var up=fy>ty;var fup=up?-1:1;var prev=fx2+2*ps>tx1;var fprev=prev?-1:1;var image=group.find("image");var p=svg.createPath();if(tooClose){var firstLine=fup*(rectFrom.height/2-2*r+2);p.move(fx2,fy).line(ps,0,true).arc(r,r,90,false,!up,r,fup*r,true).line(0,firstLine,true).arc(r,r,90,false,!up,-r,fup*r,true).line(fprev*2*ps+(tx1-fx2),0,true).arc(r,r,90,false,up,-r,fup*r,true).line(0,(Math.abs(ty-fy)-4*r-Math.abs(firstLine))*fup-arrowOffset,true).arc(r,r,90,false,up,r,fup*r,true).line(ps,0,true);image.attr({x:tx1-5,y:ty-5-arrowOffset});}else{p.move(fx2,fy).line((tx1-fx2)/2-r,0,true).arc(r,r,90,false,!up,r,fup*r,true).line(0,ty-fy-fup*2*r+arrowOffset,true).arc(r,r,90,false,up,r,fup*r,true).line((tx1-fx2)/2-r,0,true);image.attr({x:tx1-5,y:ty-5+arrowOffset});}group.find("path").attr({d:p.path()});}// create the group
var group=svg.group(self.linksGroup,""+from.id+"-"+to.id);svg.title(group,from.name+" -> "+to.name);var p=svg.createPath();//add the arrow
svg.image(group,0,0,5,10,"/formmode/e9resource/imgs/gantt/linkArrow.png");//create empty path
svg.path(group,p,{class:"taskLinkPathSVG"});//set "from" and "to" to the group, bind "update" and trigger it
var jqGroup=$(group).data({from:from,to:to}).attr({from:from.id,to:to.id}).on("update",update).trigger("update");if(self.showCriticalPath&&from.isCritical&&to.isCritical)jqGroup.addClass("critical");jqGroup.addClass("linkGroup");return jqGroup;}/**
   * A rendering method which paints a start to start dependency.
   */function drawStartToStart(from,to){console.error("StartToStart not supported on SVG");var rectFrom=buildRectFromTask(from);var rectTo=buildRectFromTask(to);}var link;// Dispatch to the correct renderer
if(type=='start-to-start'){link=drawStartToStart(from,to,peduncolusSize);}else{link=drawStartToEnd(from,to,peduncolusSize);}// in order to create a dependency you will need permissions on both tasks
if(this.master.permissions.canWrite||from.canWrite&&to.canWrite){link.click(function(e){var el=$(this);e.stopPropagation();// to avoid body remove focused
self.element.find("[class*=focused]").removeClass("focused");$(".ganttSVGBox .focused").removeClass("focused");var el=$(this);if(!self.resDrop)el.addClass("focused");self.resDrop=false;//hack to avoid select
$("body").off("click.focused").one("click.focused",function(){$(".ganttSVGBox .focused").removeClass("focused");});});}};Ganttalendar.prototype.redrawLink_taskids=function(taskids){var collapsedDescendant=this.master.getCollapsedDescendant();var links=this.master.links.filter(function(item){if(collapsedDescendant.indexOf(item.from)>-1||collapsedDescendant.indexOf(item.to)>-1){//如果from或者to被收起这不绘link
return false;}return taskids.has(item.from.id)||taskids.has(item.to.id);});links.forEach(function(item){$('g[id="'+item.from.id+'-'+item.to.id+'"]').remove();});for(var i=0;i<links.length;i++){var link=links[i];this.drawLink(link.from,link.to);}};Ganttalendar.prototype.redrawLink=function(task){var collapsedDescendant=this.master.getCollapsedDescendant();var links=this.master.links.filter(function(item){if(collapsedDescendant.indexOf(item.from)>-1||collapsedDescendant.indexOf(item.to)>-1){//如果from或者to被收起这不绘link
return false;}return item.from==task||item.to==task;});links.forEach(function(item){$('g[id="'+item.from.id+'-'+item.to.id+'"]').remove();});for(var i=0;i<links.length;i++){var link=links[i];this.drawLink(link.from,link.to);}};Ganttalendar.prototype.redrawLinks=function(){//console.debug("redrawLinks ");
var self=this;this.element.stopTime("ganttlnksredr");this.element.oneTime(10,"ganttlnksredr",function(){//remove all links
$("#linksGroup").empty();var collapsedDescendant=[];//[expand]
var collapsedDescendant=self.master.getCollapsedDescendant();for(var i=0;i<self.master.links.length;i++){var link=self.master.links[i];if(collapsedDescendant.indexOf(link.from)>=0||collapsedDescendant.indexOf(link.to)>=0)continue;self.drawLink(link.from,link.to);}self.master.ganttStore.afterInit();});};Ganttalendar.prototype.reset=function(){//var prof= new Profiler("ganttDrawerSVG.reset");
this.element.find("[class*=linkGroup]").remove();this.element.find("[taskid]").remove();//prof.stop()
};Ganttalendar.prototype.redrawTasks=function(drawAll){//console.debug("redrawTasks ");
var self=this;self.master.ganttStore.ganttIsMouseDown=false;var getGanttId=this.master.ganttStore.id;self.element.find("table.ganttTable").height(self.master.editor.element.height()+60);$(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDivContent').height(self.master.editor.element.height());var collapsedDescendant=this.master.getCollapsedDescendant();$(".TWGanttWorkSpace_"+getGanttId).find("#linksGroup,#tasksGroup").empty();var gridGroup=$(".TWGanttWorkSpace_"+getGanttId).find("#gridGroup").empty().get(0);//add missing ones
for(var i=0;i<self.master.tasks.length;i++){var task=self.master.tasks[i];if(collapsedDescendant.indexOf(task)>=0){continue;}this.drawTask(task);this.redrawLinks();}//creates rows grid
for(var i=0;i<=self.master.editor.element.height();i+=self.master.rowHeight){self.svg.rect(gridGroup,0,i,"100%",self.master.rowHeight,{class:"ganttLinesSVG"});}// drawTodayLine
if(new Date().getTime()>self.startMillis&&new Date().getTime()<self.endMillis){var x=Math.round((new Date().getTime()-self.startMillis)*self.fx);self.svg.line(gridGroup,x,0,x,"100%",{class:"ganttTodaySVG"});}$(".TWGanttWorkSpace_"+getGanttId).find('#gridGroup rect').click(function(e){var i=e.srcElement.getAttribute('y')/30;var currentTr=$("tr[data-taskid]:visible")[i];if(currentTr){currentTr.click();}});$(".TWGanttWorkSpace_"+getGanttId).find('#gridGroup rect').mouseover(function(e){var i=e.srcElement.getAttribute('y')/30;var currentTr=$("tr[data-taskid]:visible")[i];if(currentTr){self.master.editor.taskRowMouseOver($(currentTr));}});$(".TWGanttWorkSpace_"+getGanttId).find('#gridGroup rect').mouseout(function(e){var i=e.srcElement.getAttribute('y')/30;var currentTr=$("tr[data-taskid]:visible")[i];if(currentTr){self.master.editor.taskRowMouseOut($(currentTr));}});if(self.master.currentTask){var currentTaskTr=self.master.currentTask.rowElement[0];if(currentTaskTr&&$('.ganttLinesSVG')[currentTaskTr.sectionRowIndex]){$(".TWGanttWorkSpace_"+getGanttId).find('.ganttSVGSeletedRow').each(function(index,item){item.setAttribute('class','ganttLinesSVG');});$(".TWGanttWorkSpace_"+getGanttId).find('.ganttLinesSVG')[currentTaskTr.sectionRowIndex].setAttribute('class','ganttSVGSeletedRow');}}//prof.stop();
};//修改单个task数据时只要在根据当天task重新计算下边界即可
Ganttalendar.prototype.shrinkBoundaries=function(task){//console.debug("shrinkBoundaries")
var start=Infinity;var end=-Infinity;var tasks=this.master.tasks;if(task){//如果是修改了单个任务的日期，原始边界不变在根据当前日期获取新边界
tasks=[task];start=this.originalStartMillis;end=this.originalEndMillis;}for(var i=0;i<tasks.length;i++){var task=tasks[i];if(!task.start&&!task.actualbegindate){//如果都为空取今天
var minStart=new Date().getTime();if(start>minStart)start=minStart;}else{//计划开始日期和实际开始日期不同时为空
var minStart;if(!task.start){minStart=task.actualbegindate;}else if(!task.actualbegindate){minStart=task.start;}else{minStart=task.start>task.actualbegindate?task.actualbegindate:task.start;}if(start>minStart)start=minStart;}if(!task.end&&!task.actualenddate){//如果都为空取今天
var maxEnd=new Date().getTime();if(end<maxEnd)end=maxEnd;}else{var maxEnd;if(!task.end){maxEnd=task.actualenddate;}else if(!task.actualenddate){maxEnd=task.end;}else{maxEnd=task.end>task.actualenddate?task.end:task.actualenddate;}if(end<maxEnd)end=maxEnd;}}//if include today synch extremes
if(this.includeToday){var today=new Date().getTime();start=start>today?today:start;end=end<today?today:end;}//mark boundaries as changed
this.gridChanged=this.gridChanged||this.originalStartMillis!=start||this.originalEndMillis!=end;this.originalStartMillis=start;this.originalEndMillis=end;};Ganttalendar.prototype.setBestFittingZoom=function(){//if zoom is not defined get the best fitting one
var dur=this.originalEndMillis-this.originalStartMillis;var minDist=Number.MAX_VALUE;var i=0;for(;i<this.zoomLevels.length;i++){var dist=Math.abs(dur-millisFromString(this.zoomLevels[i]));if(dist<=minDist){minDist=dist;}else{break;}this.zoom=this.zoomLevels[i];}this.zoom=this.zoom||this.zoomLevels[this.zoomLevels.length-1];//如果用户未设置时间轴，则自适应
if(this.master.ganttStore.timelinekey==''){this.master.ganttStore.timelinekey=this.zoom;}};Ganttalendar.prototype.redraw=function(){if(this.showCriticalPath){this.master.computeCriticalPath();}if(this.gridChanged){this.gridChanged=false;var par=this.element.parent();var scrollDiv=$(".TWGanttWorkSpace_"+this.master.ganttStore.id).find('.gantSVGBoxDiv');//try to maintain last scroll
var scrollY=scrollDiv.scrollTop();var scrollX=scrollDiv.scrollLeft();this.element.remove();var domEl=this.createGanttGrid();this.element=domEl;par.append(domEl);this.redrawTasks();//set old scroll  
scrollDiv=$(".TWGanttWorkSpace_"+this.master.ganttStore.id).find('.gantSVGBoxDiv');scrollDiv.scrollTop(scrollY);scrollDiv.scrollLeft(scrollX);}else{this.redrawTasks();}this.master.ganttStore.loadingtip='';};Ganttalendar.prototype.fitGantt=function(){delete this.zoom;this.redraw();};Ganttalendar.prototype.getCenterMillis=function(){return parseInt((this.element.parent().scrollLeft()+this.element.parent().width()/2)/this.fx+this.startMillis);};Ganttalendar.prototype.goToMillis=function(millis){var x=Math.round((millis-this.startMillis)*this.fx)-this.element.parent().width()/2;//this.element.parent().scrollLeft(x);
var getGanttId=this.master.ganttStore.id;$(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDiv').scrollLeft(x);};Ganttalendar.prototype.centerOnToday=function(){this.goToMillis(new Date().getTime());};/**
 * Allows drag and drop and extesion of task boxes. Only works on x axis
 * @param opt
 * @return {*}
 */$.fn.dragExtedSVG=function(svg,opt){//doing this can work with one svg at once only
var target;var svgX;var offsetMouseRect;var options={canDrag:true,canResize:true,resizeZoneWidth:5,minSize:10,startDrag:function startDrag(e){},drag:function drag(e){},drop:function drop(e){},startResize:function startResize(e){},resize:function resize(e){},stopResize:function stopResize(e){}};$.extend(options,opt);this.each(function(){var el=$(this);svgX=svg.parent().offset().left;//parent is used instead of svg for a Firefox oddity
if(options.canDrag)el.addClass("deSVGdrag");if(options.canResize||options.canDrag){el.bind("mousedown.deSVG",function(e){if($(e.target).is("image")){e.preventDefault();}target=$(this);var x1=parseFloat(el.find("[class*=taskLayout]").offset().left);var x2=x1+parseFloat(el.attr("width"));var posx=e.pageX;//start resize end
if(options.canResize&&Math.abs(posx-x2)<=options.resizeZoneWidth){//向右resize
//store offset mouse x2
offsetMouseRect=x2-e.pageX;target.attr("oldw",target.attr("width"));var one=true;//bind event for start resizing
$(svg).bind("mousemove.deSVG",function(e){$("[class*=linkHandleSVG]").hide();if(one){//trigger startResize
options.startResize.call(target.get(0),e);one=false;}//manage resizing
var nW=e.pageX-x1+offsetMouseRect;target.attr("width",nW<options.minSize?options.minSize:nW);//callback
options.resize.call(target.get(0),e,'1');});//bind mouse up on body to stop resizing
$("body").one("mouseup.deSVG",function(e){stopResize(e,'1');});//start resize start
}else if(options.canResize&&Math.abs(posx-x1)<=options.resizeZoneWidth){//向左resize
//store offset mouse x1
offsetMouseRect=parseFloat(target.attr("x"));target.attr("oldw",target.attr("width"));//todo controllare se è ancora usato oldw
var one=true;//bind event for start resizing
$(svg).bind("mousemove.deSVG",function(e){$("[class*=linkHandleSVG]").hide();if(one){//trigger startResize
options.startResize.call(target.get(0),e);one=false;}//manage resizing
var nx1=offsetMouseRect-(posx-e.pageX);var nW=x2-x1+(posx-e.pageX);nW=nW<options.minSize?options.minSize:nW;target.attr("x",nx1);target.attr("width",nW);//callback
options.resize.call(target.get(0),e,'0');});//bind mouse up on body to stop resizing
$("body").one("mouseup.deSVG",function(e){stopResize(e,'0');});// start drag
}else if(options.canDrag){//平移
//store offset mouse x1
offsetMouseRect=parseFloat(target.attr("x"))-e.pageX;target.attr("oldx",target.attr("x"));var one=true;//bind event for start dragging
$(svg).bind("mousemove.deSVG",function(e){//hide link circle
$("[class*=linkHandleSVG]").hide();if(one){//trigger startDrag
options.startDrag.call(target.get(0),e);one=false;}//manage resizing
target.attr("x",offsetMouseRect+e.pageX);//callback
options.drag.call(target.get(0),e);}).bind("mouseleave.deSVG",drop);//bind mouse up on body to stop resizing
$("body").one("mouseup.deSVG",drop);}}).bind("mousemove.deSVG",//控制鼠标移动到taskbox上的鼠标样式
function(e){var el=$(this);var x1=el.find("[class*=taskLayout]").offset().left;var x2=x1+parseFloat(el.attr("width"));var posx=e.pageX;if(options.canResize&&(Math.abs(posx-x1)<=options.resizeZoneWidth||Math.abs(posx-x2)<=options.resizeZoneWidth)){el.addSvgClass("deSVGhand");el.removeSvgClass("deSVGdrag");}else{el.addSvgClass("deSVGdrag");el.removeSvgClass("deSVGhand");}}).addClass("deSVG");}});return this;function stopResize(e,type){$(svg).unbind("mousemove.deSVG").unbind("mouseup.deSVG").unbind("mouseleave.deSVG");if(target&&target.attr("oldw")!=target.attr("width"))options.stopResize.call(target.get(0),e,type);//callback
target=undefined;}function drop(e,type){$(svg).unbind("mousemove.deSVG").unbind("mouseup.deSVG").unbind("mouseleave.deSVG");if(target&&target.attr("oldx")!=target.attr("x"))options.drop.call(target.get(0),e,type);//callback
target=undefined;}};

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(275);
__webpack_require__(180);
__webpack_require__(270);
__webpack_require__(1140);
__webpack_require__(1147);
__webpack_require__(1150);
__webpack_require__(1152);
module.exports = __webpack_require__(22).Set;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1141);
var validate = __webpack_require__(432);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1143)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(34).f;
var create = __webpack_require__(118);
var redefineAll = __webpack_require__(430);
var ctx = __webpack_require__(55);
var anInstance = __webpack_require__(431);
var forOf = __webpack_require__(161);
var $iterDefine = __webpack_require__(181);
var step = __webpack_require__(271);
var setSpecies = __webpack_require__(1142);
var DESCRIPTORS = __webpack_require__(35);
var fastKey = __webpack_require__(183).fastKey;
var validate = __webpack_require__(432);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(38);
var core = __webpack_require__(22);
var dP = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(35);
var SPECIES = __webpack_require__(32)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(38);
var $export = __webpack_require__(31);
var meta = __webpack_require__(183);
var fails = __webpack_require__(57);
var hide = __webpack_require__(49);
var redefineAll = __webpack_require__(430);
var forOf = __webpack_require__(161);
var anInstance = __webpack_require__(431);
var isObject = __webpack_require__(43);
var setToStringTag = __webpack_require__(119);
var dP = __webpack_require__(34).f;
var each = __webpack_require__(1144)(0);
var DESCRIPTORS = __webpack_require__(35);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(55);
var IObject = __webpack_require__(172);
var toObject = __webpack_require__(68);
var toLength = __webpack_require__(114);
var asc = __webpack_require__(1145);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1146);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(43);
var isArray = __webpack_require__(272);
var SPECIES = __webpack_require__(32)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(31);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1148)('Set') });


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(383);
var from = __webpack_require__(1149);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(161);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1151)('Set');


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(31);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1153)('Set');


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(31);
var aFunction = __webpack_require__(264);
var ctx = __webpack_require__(55);
var forOf = __webpack_require__(161);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */window.GridEditor=function(master){this.master=master;// is the a GantEditor instance
var editorTabel=$('#workSpace_'+master.ganttStore.getGanttId).find('#tasksEditHead').find('.gdfTable');if(!master.permissions.canSeeDep)editorTabel.find(".requireCanSeeDep").hide();this.gridified=$.gridify(editorTabel,{},master.ganttStore.getGanttId,this.master.topHeight);this.element=this.gridified.find(".gdfTable").eq(1);this.minAllowedDate=new Date(new Date().getTime()-3600000*24*365*20).format();this.maxAllowedDate=new Date(new Date().getTime()+3600000*24*365*30).format();this.taskRowMouseOver=function(row,isfromTr){if(this.master.ganttStore.isGridDragging)return;if(isfromTr)this.master.ganttStore.showLitterTool(row.attr('data-taskid'),row[0].offsetTop-$('.gantSVGBoxDiv').scrollTop()+61+this.master.topHeight);if(row.attr('class').indexOf('rowSelected')==-1){row.addClass("rowOver");var ganttRow=$('#gridGroup rect')[row[0].offsetTop/30];if(ganttRow){ganttRow.setAttribute('class','ganttSVGOverRow');}}};this.taskRowMouseOut=function(row,isfromTr){if(this.master.ganttStore.isGridDragging)return;if(isfromTr)this.master.ganttStore.closeLitterTool();row.removeClass("rowOver");if(row.attr('class').indexOf('rowSelected')==-1){var ganttRow=$('#gridGroup rect')[row[0].offsetTop/30];if(ganttRow){ganttRow.setAttribute('class','ganttLinesSVG');}}};};GridEditor.prototype.fillEmptyLines=function(){//console.debug("fillEmptyLines")
var factory=new TaskFactory();var master=this.master;//console.debug("GridEditor.fillEmptyLines");
var rowsToAdd=master.minRowsInEditor-this.element.find(".taskEditRow").length;var empty=this.element.find(".emptyRow").length;rowsToAdd=Math.max(rowsToAdd,empty>5?0:5-empty);//fill with empty lines
for(var i=0;i<rowsToAdd;i++){var emptyRow=$(this.master.ganttStore.getTaskEmptyRowHtmlTemplate());//$.JST.createFromTemplate({}, "TASKEMPTYROW");
if(!master.permissions.canSeeDep)emptyRow.find(".requireCanSeeDep").hide();//click on empty row create a task and fill above
emptyRow.click(function(ev){//console.debug("emptyRow.click")
var emptyRow=$(this);//add on the first empty row only
if(!master.permissions.canAdd||emptyRow.prevAll(".emptyRow").length>0)return;var lastTask;var start=new Date().getTime();var level=0;if(master.tasks[0]){start=master.tasks[0].start;level=master.tasks[0].level+1;}//fill all empty previouses
var cnt=0;emptyRow.prevAll(".emptyRow").addBack().each(function(){cnt++;var ch=factory.build("tmp_fk"+new Date().getTime()+"_"+cnt,"","",level,start,Date.workingPeriodResolution);var task=master.addTask(ch);lastTask=ch;});master.endTransaction();if(lastTask.rowElement){lastTask.rowElement.find("[name=name]").focus();//focus to "name" input
}});this.element.append(emptyRow);}};GridEditor.prototype.addTask=function(task,row,hideIfParentCollapsed){//console.debug("GridEditor.addTask",task,row);
//var prof = new Profiler("ganttGridEditor.addTask");
//remove extisting row
this.element.find("#tid_"+task.id).remove();var taskRow=$(this.master.ganttStore.getTaskRowHtmlTemplate(task));//$.JST.createFromTemplate(task, "TASKROW");
if(!this.master.permissions.canSeeDep)taskRow.find(".requireCanSeeDep").hide();if(!this.master.permissions.canSeePopEdit)taskRow.find(".edit .teamworkIcon").hide();//save row element on task
task.rowElement=taskRow;this.bindRowEvents(task,taskRow);if(typeof row!="number"){var emptyRow=this.element.find(".emptyRow:first");//tries to fill an empty row
if(emptyRow.length>0)emptyRow.replaceWith(taskRow);else this.element.append(taskRow);}else{var tr=this.element.find("tr.taskEditRow").eq(row);if(tr.length>0){tr.before(taskRow);}else{this.element.append(taskRow);}}//[expand]
if(hideIfParentCollapsed){if(task.collapsed)taskRow.addClass('collapsed');var collapsedDescendant=this.master.getCollapsedDescendant();if(collapsedDescendant.indexOf(task)>=0)taskRow.hide();}//prof.stop();
return taskRow;};GridEditor.prototype.refreshExpandStatus=function(task){//console.debug("refreshExpandStatus",task);
if(!task)return;if(task.isParent()){task.rowElement.addClass("isParent");}else{task.rowElement.removeClass("isParent");}var par=task.getParent();if(par&&!par.rowElement.is("isParent")){par.rowElement.addClass("isParent");}};GridEditor.prototype.refreshTaskRow=function(task){var row=task.rowElement;row.find(".indentCell").css("padding-left",task.level*10+18);};GridEditor.prototype.redraw=function(){//console.debug("GridEditor.prototype.redraw")
//var prof = new Profiler("gantt.GridEditor.redraw");
for(var i=0;i<this.master.tasks.length;i++){this.refreshTaskRow(this.master.tasks[i]);}// check if new empty rows are needed
if(this.master.fillWithEmptyLines)this.fillEmptyLines();//prof.stop()
};GridEditor.prototype.reset=function(){this.element.find("[data-taskid]").remove();};GridEditor.prototype.bindRowEvents=function(task,taskRow){var self=this;//bind row selection
taskRow.click(function(event){var row=$(this);row.closest("table").find(".rowSelected").removeClass("rowSelected");row.removeClass("rowOver");row.addClass("rowSelected");//svg
if($('#gridGroup rect')[row[0].offsetTop/30]){$('.ganttSVGSeletedRow').each(function(index,item){item.setAttribute('class','ganttLinesSVG');});$('#gridGroup rect')[row[0].offsetTop/30].setAttribute('class','ganttSVGSeletedRow');}//set current task
self.master.currentTask=self.master.getTask(row.attr("data-taskid"));});taskRow.mouseover(function(event){var row=$(this);self.taskRowMouseOver(row,true);});taskRow.mouseleave(function(event){var row=$(this);if(event.relatedTarget&&event.relatedTarget.parentNode&&event.relatedTarget.parentNode.getAttribute('class')){if(event.relatedTarget.parentNode.getAttribute('class').indexOf('litterTool')>-1){self.master.ganttStore.taskOutFun=function(){self.taskRowMouseOut(row,true);};return;}}self.taskRowMouseOut(row,true);});self.bindRowExpandEvents(task,taskRow);taskRow.dblclick(function(ev){self.master.ganttStore.editTaskRow($(this),task);});};GridEditor.prototype.bindRowExpandEvents=function(task,taskRow){var self=this;//expand collapse
taskRow.find(".exp-controller").click(function(){var el=$(this);var taskId=el.closest("[data-taskid]").attr("data-taskid");var task=self.master.getTask(taskId);if(task.collapsed){self.master.expand(task,false);}else{self.master.collapse(task,false);}});};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _set=__webpack_require__(429);var _set2=_interopRequireDefault(_set);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */window.GanttMaster=function(ganttStore){this.ganttStore=ganttStore;this.tasks=[];this.links=[];this.editor;//element for editor
this.gantt;//element for gantt
this.splitter;//element for splitter
this.isMultiRoot=false;// set to true in case of tasklist
this.workSpace;// the original element used for containing everything
this.element;// editor and gantt box without buttons
this.resources;//list of resources
this.roles;//list of roles
this.minEditableDate=0;this.maxEditableDate=Infinity;this.set100OnClose=false;this.shrinkParent=false;this.fillWithEmptyLines=true;//when is used by widget it could be usefull to do not fill with empty lines
this.rowHeight=30;// todo get it from css?
this.minRowsInEditor=5;// number of rows always visible in editor
this.numOfVisibleRows=0;//number of visible rows in the editor
this.firstScreenLine=0;//first visible row ignoring collapsed tasks
this.rowBufferSize=5;this.baselineMillis;//millis of the current baseline loaded
this.topHeight=45;//甘特图上边的头部高度
this.permissions={canWriteOnParent:true,canWrite:true,canAdd:true,canDelete:true,canInOutdent:true,canMoveUpDown:true,canSeePopEdit:true,canSeeFullEdit:true,canSeeDep:true,canSeeCriticalPath:true,canAddIssue:false,cannotCloseTaskIfIssueOpen:false};this.firstDayOfWeek=Date.firstDayOfWeek;this.serverClientTimeOffset=0;this.currentTask;// task currently selected;
this.resourceUrl="res/";// URL to resources (images etc.)
this.__currentTransaction;// a transaction object holds previous state during changes
this.__undoStack=[];this.__redoStack=[];this.__inUndoRedo=false;// a control flag to avoid Undo/Redo stacks reset when needed
Date.workingPeriodResolution=1;//by default 1 day
var self=this;};GanttMaster.prototype.init=function(workSpace){var _this2=this;var getGanttId=this.ganttStore.getGanttId;var place=$(workSpace).find('.TWGanttArea');workSpace.append(place).addClass('TWGanttWorkSpace TWGanttWorkSpace_'+getGanttId);this.workSpace=workSpace;this.element=place;this.numOfVisibleRows=Math.ceil(this.element.height()/this.rowHeight);//by default task are coloured by status
this.element.addClass('colorByStatus');var self=this;//create editor
this.editor=new GridEditor(this);//place.append(this.editor.gridified);
//create gantt
this.gantt=new Ganttalendar(new Date().getTime()-3600000*24*2,new Date().getTime()+3600000*24*5,this,place.width()*0.01);//setup splitter
self.splitter=$.splittify.init(place,this.editor.gridified,this.gantt.element,50,getGanttId);var firstBox=$('.TWGanttWorkSpace_'+getGanttId).find('.splitBox1');var scrollCallback=function scrollCallback(){//left为零时，纵向滚动时表头会左移
var val=firstBox.scrollLeft();if(location.href.includes('/wui/index.html')){var leftMenuWidth=$("#portal-intro2").width();// if(leftMenuWidth==197){//前台左侧为展开状态
//   val=val-207;
// }else if(leftMenuWidth==61){//前台左侧菜单为折叠状态
//   val=val-71;
// }
val-=leftMenuWidth+10;}firstBox.find('.ganttFixHead').css('left',-val);if(_this2.ganttStore.isGridDragging){$('.TWGanttWorkSpace_'+getGanttId).find('.gantSVGBoxDiv').scrollTop(firstBox.scrollTop());}};firstBox.scroll(scrollCallback);//左侧菜单resize回调
var element=$("#portal-intro2").parent()[0];element&&new ResizeObserver(scrollCallback).observe(element);self.splitter.firstBoxMinWidth=5;self.splitter.secondBoxMinWidth=20;//prepend buttons
// var ganttButtons = $.JST.createFromTemplate({}, "GANTBUTTONS");
// place.before(ganttButtons);
this.checkButtonPermissions();//bindings
workSpace.bind("deleteFocused.gantt",function(e){//delete task or link?
var focusedSVGElement=self.gantt.element.find(".focused.focused.linkGroup");if(focusedSVGElement.size()>0)self.removeLink(focusedSVGElement.data("from"),focusedSVGElement.data("to"));else self.deleteCurrentTask();}).bind("addAboveCurrentTask.gantt",function(){self.addAboveCurrentTask();}).bind("addBelowCurrentTask.gantt",function(){self.addBelowCurrentTask();}).bind("indentCurrentTask.gantt",function(){self.indentCurrentTask();}).bind("outdentCurrentTask.gantt",function(){self.outdentCurrentTask();}).bind("moveUpCurrentTask.gantt",function(){self.moveUpCurrentTask();}).bind("moveDownCurrentTask.gantt",function(){self.moveDownCurrentTask();}).bind("collapseAll.gantt",function(){self.collapseAll();}).bind("expandAll.gantt",function(){self.expandAll();}).bind("fullScreen.gantt",function(){self.fullScreen();}).bind("print.gantt",function(){self.print();}).bind("zoomPlus.gantt",function(){self.gantt.zoomGantt(true);}).bind("zoomMinus.gantt",function(){self.gantt.zoomGantt(false);}).bind("openFullEditor.gantt",function(){}).bind("openAssignmentEditor.gantt",function(){}).bind("addIssue.gantt",function(){self.addIssue();}).bind("openExternalEditor.gantt",function(){self.openExternalEditor();}).bind("resize.gantt",function(){self.resize();}).bind("zoomChange1M",function(){self.gantt.zoomGantt(null,'1M');}).bind("zoomChange2w",function(){self.gantt.zoomGantt(null,'2w');}).bind("zoomChange1y",function(){self.gantt.zoomGantt(null,'1y');}).bind("zoomChange2Q",function(){self.gantt.zoomGantt(null,'2Q');}).bind("zoomChange2y",function(){self.gantt.zoomGantt(null,'2y');});//ask for comment input
$("#saveGanttButton").after($('#LOG_CHANGES_CONTAINER'));//resize
$(window).resize(function(){//左侧横向滚动展示横向滚动条
var temp=20;if(location.href.includes('/wui/index.html')){temp=80;}var windowHeight=$(window).height()-temp;place.css({width:"100%",height:windowHeight-place.position().top});place.trigger("resize.gantt");$('.TWGanttWorkSpace_'+getGanttId).find('.splitBox1').height(windowHeight-self.topHeight);$('.TWGanttWorkSpace_'+getGanttId).find('.splitBox2').height(windowHeight-self.topHeight);$('.TWGanttWorkSpace_'+getGanttId).find(".gantSVGBoxDiv").height(windowHeight-60-self.topHeight);}).oneTime(2,"resize",function(){$(window).trigger("resize");});};GanttMaster.messages={"CANNOT_WRITE":"CANNOT_WRITE","CHANGE_OUT_OF_SCOPE":"NO_RIGHTS_FOR_UPDATE_PARENTS_OUT_OF_EDITOR_SCOPE","START_IS_MILESTONE":"START_IS_MILESTONE","END_IS_MILESTONE":"END_IS_MILESTONE","TASK_HAS_CONSTRAINTS":"TASK_HAS_CONSTRAINTS","GANTT_ERROR_DEPENDS_ON_OPEN_TASK":"GANTT_ERROR_DEPENDS_ON_OPEN_TASK","GANTT_ERROR_DESCENDANT_OF_CLOSED_TASK":"GANTT_ERROR_DESCENDANT_OF_CLOSED_TASK","TASK_HAS_EXTERNAL_DEPS":"TASK_HAS_EXTERNAL_DEPS","GANTT_ERROR_LOADING_DATA_TASK_REMOVED":"GANTT_ERROR_LOADING_DATA_TASK_REMOVED","CIRCULAR_REFERENCE":"CIRCULAR_REFERENCE","CANNOT_MOVE_TASK":"CANNOT_MOVE_TASK","CANNOT_DEPENDS_ON_ANCESTORS":"CANNOT_DEPENDS_ON_ANCESTORS","CANNOT_DEPENDS_ON_DESCENDANTS":"CANNOT_DEPENDS_ON_DESCENDANTS","INVALID_DATE_FORMAT":"INVALID_DATE_FORMAT","GANTT_SEMESTER_SHORT":"GANTT_SEMESTER_SHORT","GANTT_SEMESTER":"GANTT_SEMESTER","GANTT_QUARTER_SHORT":"GANTT_QUARTER_SHORT","GANTT_QUARTER":"GANTT_QUARTER","GANTT_WEEK":"GANTT_WEEK","GANTT_WEEK_SHORT":"GANTT_WEEK_SHORT","CANNOT_CLOSE_TASK_IF_OPEN_ISSUE":"CANNOT_CLOSE_TASK_IF_OPEN_ISSUE","PLEASE_SAVE_PROJECT":"PLEASE_SAVE_PROJECT","CANNOT_CREATE_SAME_LINK":"CANNOT_CREATE_SAME_LINK"};GanttMaster.prototype.createTask=function(id,name,code,level,start,duration){var factory=new TaskFactory();return factory.build(id,name,code,level,start,duration);};GanttMaster.prototype.getOrCreateResource=function(id,name){var res=this.getResource(id);if(!res&&id&&name){res=this.createResource(id,name);}return res;};GanttMaster.prototype.createResource=function(id,name){var res=new Resource(id,name);this.resources.push(res);return res;};//update depends strings
GanttMaster.prototype.updateDependsStrings=function(){//remove all deps
for(var i=0;i<this.tasks.length;i++){this.tasks[i].depends="";}for(var i=0;i<this.links.length;i++){var link=this.links[i];var dep=link.to.depends;link.to.depends=link.to.depends+(link.to.depends==""?"":",")+(link.from.getRow()+1)+(link.lag?":"+link.lag:"");}};GanttMaster.prototype.removeLink=function(fromTask,toTask){//console.debug("removeLink");
if(!this.permissions.canWrite||!fromTask.canWrite&&!toTask.canWrite)return;var found=false;for(var i=0;i<this.links.length;i++){if(this.links[i].from==fromTask&&this.links[i].to==toTask){this.links.splice(i,1);found=true;break;}}if(found){this.updateDependsStrings();if(this.updateLinks(toTask))this.changeTaskDates(toTask,toTask.start,toTask.end);// fake change to force date recomputation from dependencies
}this.endTransaction();};GanttMaster.prototype.__removeAllLinks=function(task,openTrans){if(openTrans)var found=false;for(var i=0;i<this.links.length;i++){if(this.links[i].from==task||this.links[i].to==task){this.links.splice(i,1);found=true;}}if(found){this.updateDependsStrings();}if(openTrans)this.endTransaction();};//------------------------------------  ADD TASK --------------------------------------------
GanttMaster.prototype.addTask=function(task,row,from){//console.debug("master.addTask",task,row,this);
task.master=this;// in order to access controller from task
//replace if already exists
var pos=-1;for(var i=0;i<this.tasks.length;i++){if(task.id==this.tasks[i].id){pos=i;break;}}if(pos>=0){this.tasks.splice(pos,1);row=parseInt(pos);}//add task in collection
if(typeof row!="number"){this.tasks.push(task);}else{this.tasks.splice(row,0,task);//recompute depends string
this.updateDependsStrings();}//add Link collection in memory
var linkLoops=!this.updateLinks(task);//set the status according to parent
if(task.getParent())task.status=task.getParent().status;else task.status="STATUS_NORMAL";var ret=task;if(linkLoops||!task.setPeriod(task.start,task.end)){//remove task from in-memory collection
//console.debug("removing task from memory",task);
this.tasks.splice(task.getRow(),1);ret=undefined;}else{//append task to editor
this.editor.addTask(task,row);//append task to gantt
this.gantt.addTask(task,row,from);}//trigger addedTask event 
$(this.element).trigger("addedTask.gantt",task);return ret;};/**
 * a project contais tasks, resources, roles, and info about permisions
 * @param project
 */GanttMaster.prototype.loadProject=function(project){this.serverClientTimeOffset=typeof project.serverTimeOffset!="undefined"?parseInt(project.serverTimeOffset)+new Date().getTimezoneOffset()*60000:0;this.resources=project.resources;this.roles=project.roles;//permissions from loaded project
this.permissions.canWrite=project.canWrite;this.permissions.canAdd=project.canAdd;this.permissions.canWriteOnParent=project.canWriteOnParent;this.permissions.cannotCloseTaskIfIssueOpen=project.cannotCloseTaskIfIssueOpen;this.permissions.canAddIssue=project.canAddIssue;this.permissions.canDelete=project.canDelete;//repaint button bar basing on permissions
this.checkButtonPermissions();if(project.minEditableDate)this.minEditableDate=computeStart(project.minEditableDate);else this.minEditableDate=-Infinity;if(project.maxEditableDate)this.maxEditableDate=computeEnd(project.maxEditableDate);else this.maxEditableDate=Infinity;//shift dates in order to have client side the same hour (e.g.: 23:59) of the server side
for(var i=0;i<project.tasks.length;i++){var task=project.tasks[i];task.start+=this.serverClientTimeOffset;task.end+=this.serverClientTimeOffset;}this.loadTasks(project.tasks,project.selectedRow);//recover saved zoom level
if(project.zoom){this.gantt.zoom=project.zoom;}else{this.gantt.shrinkBoundaries();this.gantt.setBestFittingZoom();}this.endTransaction();var self=this;this.gantt.element.oneTime(200,function(){self.gantt.centerOnToday();});};GanttMaster.prototype.loadTasks=function(tasks,selectedRow){//console.debug("GanttMaster.prototype.loadTasks")
//var prof=new Profiler("ganttMaster.loadTasks");
var factory=new TaskFactory();//reset
this.reset();for(var i=0;i<tasks.length;i++){var task=tasks[i];if(!(task instanceof Task)){var t=factory.build(task.id,task.name,task.code,task.level,task.start,task.end,task.duration,task.collapsed);for(var key in task){//if (key != "end" && key != "start")
t[key]=task[key];//copy all properties
}task=t;}task.master=this;// in order to access controller from task
this.tasks.push(task);//append task at the end
}for(var i=0;i<this.tasks.length;i++){var task=this.tasks[i];var numOfError=this.__currentTransaction&&this.__currentTransaction.errors?this.__currentTransaction.errors.length:0;//add Link collection in memory
while(!this.updateLinks(task)){// error on update links while loading can be considered as "warning". Can be displayed and removed in order to let transaction commits.
if(this.__currentTransaction&&numOfError!=this.__currentTransaction.errors.length){var msg="ERROR:\n";while(numOfError<this.__currentTransaction.errors.length){var err=this.__currentTransaction.errors.pop();msg=msg+err.msg+"\n\n";}alert(msg);}this.__removeAllLinks(task,false);}if(!task.setPeriod1(task.start,task.end)){alert(GanttMaster.messages.GANNT_ERROR_LOADING_DATA_TASK_REMOVED+"\n"+task.name);//remove task from in-memory collection
this.tasks.splice(task.getRow(),1);}else{//append task to editor
this.editor.addTask(task,null,true);//append task to gantt
this.gantt.addTask(task);}}//this.editor.fillEmptyLines();
//prof.stop();
// re-select old row if tasks is not empty
if(this.tasks&&this.tasks.length>0){selectedRow=selectedRow?selectedRow:0;this.tasks[selectedRow].rowElement.click();}};GanttMaster.prototype.getTask=function(taskId){var ret;for(var i=0;i<this.tasks.length;i++){var tsk=this.tasks[i];if(tsk.id==taskId){ret=tsk;break;}}return ret;};GanttMaster.prototype.getResource=function(resId){var ret;for(var i=0;i<this.resources.length;i++){var res=this.resources[i];if(res.id==resId){ret=res;break;}}return ret;};GanttMaster.prototype.changeTaskDeps=function(task){return task.moveTo(task.start,false,true);};GanttMaster.prototype.changeTaskDates=function(task,start,end){//console.debug("changeTaskDates",task, start, end)
return task.setPeriod(start,end);};GanttMaster.prototype.moveTask=function(task,newStart,isActual){return task.moveTo(newStart,isActual);};GanttMaster.prototype.taskIsChanged=function(){var master=this;this.element.stopTime("gnnttaskIsChanged");this.element.oneTime(50,"gnnttaskIsChanged",function(){master.redraw();});};GanttMaster.prototype.checkButtonPermissions=function(){var ganttButtons=$(".ganttButtonBar");//hide buttons basing on permissions
if(!this.permissions.canWrite)ganttButtons.find(".requireCanWrite").hide();if(!this.permissions.canAdd)ganttButtons.find(".requireCanAdd").hide();if(!this.permissions.canInOutdent)ganttButtons.find(".requireCanInOutdent").hide();if(!this.permissions.canMoveUpDown)ganttButtons.find(".requireCanMoveUpDown").hide();if(!this.permissions.canDelete)ganttButtons.find(".requireCanDelete").hide();if(!this.permissions.canSeeCriticalPath)ganttButtons.find(".requireCanSeeCriticalPath").hide();if(!this.permissions.canAddIssue)ganttButtons.find(".requireCanAddIssue").hide();};GanttMaster.prototype.redraw=function(){this.editor.redraw();this.gantt.redraw();};GanttMaster.prototype.reset=function(){//console.debug("GanttMaster.prototype.reset");
this.tasks=[];if(!this.__inUndoRedo){this.__undoStack=[];this.__redoStack=[];}else{// don't reset the stacks if we're in an Undo/Redo, but restart the inUndoRedo control
this.__inUndoRedo=false;}delete this.currentTask;this.editor.reset();this.gantt.reset();};GanttMaster.prototype.showTaskEditor=function(taskId){var task=this.getTask(taskId);task.rowElement.find(".edit").click();};GanttMaster.prototype.markUnChangedTasksAndAssignments=function(newProject){//console.debug("markUnChangedTasksAndAssignments");
//si controlla che ci sia qualcosa di cambiato, ovvero che ci sia l'undo stack
if(this.__undoStack.length>0){var oldProject=JSON.parse(ge.__undoStack[0]);//si looppano i "nuovi" task
for(var i=0;i<newProject.tasks.length;i++){var newTask=newProject.tasks[i];//se è un task che c'erà già
if(typeof newTask.id=="string"&&!newTask.id.startsWith("tmp_")){//si recupera il vecchio task
var oldTask;for(var j=0;j<oldProject.tasks.length;j++){if(oldProject.tasks[j].id==newTask.id){oldTask=oldProject.tasks[j];break;}}//si controlla se ci sono stati cambiamenti
var taskChanged=oldTask.id!=newTask.id||oldTask.code!=newTask.code||oldTask.name!=newTask.name||oldTask.start!=newTask.start||oldTask.startIsMilestone!=newTask.startIsMilestone||oldTask.end!=newTask.end||oldTask.endIsMilestone!=newTask.endIsMilestone||oldTask.duration!=newTask.duration||oldTask.status!=newTask.status||oldTask.typeId!=newTask.typeId||oldTask.relevance!=newTask.relevance||oldTask.progress!=newTask.progress||oldTask.progressByWorklog!=newTask.progressByWorklog||oldTask.description!=newTask.description||oldTask.level!=newTask.level||oldTask.depends!=newTask.depends;newTask.unchanged=!taskChanged;//se ci sono assegnazioni
if(newTask.assigs&&newTask.assigs.length>0){//se abbiamo trovato il vecchio task e questo aveva delle assegnazioni
if(oldTask&&oldTask.assigs&&oldTask.assigs.length>0){for(var j=0;j<oldTask.assigs.length;j++){var oldAssig=oldTask.assigs[j];//si cerca la nuova assegnazione corrispondente
var newAssig;for(var k=0;k<newTask.assigs.length;k++){if(oldAssig.id==newTask.assigs[k].id){newAssig=newTask.assigs[k];break;}}//se c'è una nuova assig corrispondente
if(newAssig){//si confrontano i valori per vedere se è cambiata
newAssig.unchanged=newAssig.resourceId==oldAssig.resourceId&&newAssig.roleId==oldAssig.roleId&&newAssig.effort==oldAssig.effort;}}}}}}}};GanttMaster.prototype.updateLinks=function(task){//console.debug("updateLinks",task);
//var prof= new Profiler("gm_updateLinks");
// defines isLoop function
function isLoop(task,target,visited){//var prof= new Profiler("gm_isLoop");
//console.debug("isLoop :"+task.name+" - "+target.name);
if(target==task){return true;}var sups=task.getSuperiors();//my parent' superiors are my superiors too
var p=task.getParent();while(p){sups=sups.concat(p.getSuperiors());p=p.getParent();}//my children superiors are my superiors too
var chs=task.getChildren();for(var i=0;i<chs.length;i++){sups=sups.concat(chs[i].getSuperiors());}var loop=false;//check superiors
for(var i=0;i<sups.length;i++){var supLink=sups[i];if(supLink.from==target){loop=true;break;}else{if(visited.indexOf(supLink.from.id+"x"+target.id)<=0){visited.push(supLink.from.id+"x"+target.id);if(isLoop(supLink.from,target,visited)){loop=true;break;}}}}//check target parent
var tpar=target.getParent();if(tpar){if(visited.indexOf(task.id+"x"+tpar.id)<=0){visited.push(task.id+"x"+tpar.id);if(isLoop(task,tpar,visited)){loop=true;}}}//prof.stop();
return loop;}//remove my depends
this.links=this.links.filter(function(link){return link.to!=task;});var todoOk=true;if(task.depends){//cannot depend from an ancestor
//var parents = task.getParents();
//cannot depend from descendants
// var descendants = task.getDescendant();
var deps=task.depends.split(",");var newDepsString="";// var visited = [];
//var depsEqualCheck = [];
for(var j=0;j<deps.length;j++){var depString=deps[j];// in the form of row(lag) e.g. 2:3,3:4,5
var supStr=depString;var lag=0;var pos=depString.indexOf(":");if(pos>0){supStr=depString.substr(0,pos);var lagStr=depString.substr(pos+1);lag=Math.ceil(stringToDuration(lagStr)/Date.workingPeriodResolution)*Date.workingPeriodResolution;}var sup=this.tasks[parseInt(supStr)-1];if(sup){// if (parents && parents.indexOf(sup) >= 0) {
//   this.setErrorOnTransaction("\""+task.name + "\"\n" + GanttMaster.messages.CANNOT_DEPENDS_ON_ANCESTORS + "\n\"" + sup.name+"\"");
//   todoOk = false;
// } else if (descendants && descendants.indexOf(sup) >= 0) {
//   this.setErrorOnTransaction("\""+task.name + "\"\n" + GanttMaster.messages.CANNOT_DEPENDS_ON_DESCENDANTS + "\n\"" + sup.name+"\"");
//   todoOk = false;
// } else if (isLoop(sup, task, visited)) {
//   todoOk = false;
//   this.setErrorOnTransaction(GanttMaster.messages.CIRCULAR_REFERENCE + "\n\"" + task.id +" - "+ task.name + "\" -> \"" + sup.id +" - "+sup.name+"\"");
// } else if(depsEqualCheck.indexOf(sup)>=0) {
//   this.setErrorOnTransaction(GanttMaster.messages.CANNOT_CREATE_SAME_LINK + "\n\"" + sup.name+"\" -> \""+task.name+"\"");
//   todoOk = false;
// } else {
this.links.push(new Link(sup,task,lag));newDepsString=newDepsString+(newDepsString.length>0?",":"")+supStr+(lag==0?"":":"+lag);//}
//if (todoOk)
//depsEqualCheck.push(sup);
}}task.depends=newDepsString;}//prof.stop();
return todoOk;};GanttMaster.prototype.moveUpCurrentTask=function(){var self=this;//console.debug("moveUpCurrentTask",self.currentTask)
if(self.currentTask){if(!(self.permissions.canWrite||self.currentTask.canWrite)||!self.permissions.canMoveUpDown)return;self.currentTask.moveUp();self.endTransaction();}};GanttMaster.prototype.moveDownCurrentTask=function(){var self=this;//console.debug("moveDownCurrentTask",self.currentTask)
if(self.currentTask){if(!(self.permissions.canWrite||self.currentTask.canWrite)||!self.permissions.canMoveUpDown)return;self.currentTask.moveDown();self.endTransaction();}};GanttMaster.prototype.outdentCurrentTask=function(){var self=this;if(self.currentTask){var par=self.currentTask.getParent();//can outdent if you have canRight on current task and on its parent and canAdd on grandfather
if(!self.currentTask.canWrite||!par.canWrite||!par.getParent()||!par.getParent().canAdd)return;self.currentTask.outdent();self.endTransaction();//[expand]
if(par)self.editor.refreshExpandStatus(par);}};GanttMaster.prototype.indentCurrentTask=function(){var self=this;if(self.currentTask){//can indent if you have canRight on current and canAdd on the row above
var row=self.currentTask.getRow();if(!self.currentTask.canWrite||row<=0||!self.tasks[row-1].canAdd)return;self.currentTask.indent();self.endTransaction();}};GanttMaster.prototype.addBelowCurrentTask=function(){var self=this;//console.debug("addBelowCurrentTask",self.currentTask)
var factory=new TaskFactory();var ch;var row=0;if(self.currentTask&&self.currentTask.name){//add below add a brother if current task is not already a parent
var addNewBrother=!(self.currentTask.isParent()||self.currentTask.level==0);var canAddChild=self.currentTask.canAdd;var canAddBrother=self.currentTask.getParent()&&self.currentTask.getParent().canAdd;//if you cannot add a brother you will try to add a child
addNewBrother=addNewBrother&&canAddBrother;if(!canAddBrother&&!canAddChild)return;ch=factory.build("tmp_"+new Date().getTime(),"","",self.currentTask.level+(addNewBrother?0:1),self.currentTask.start,1);row=self.currentTask.getRow()+1;if(row>0){var task=self.addTask(ch,row);if(task){task.rowElement.click();task.rowElement.find("[name=name]").focus();}self.endTransaction();}}};GanttMaster.prototype.addAboveCurrentTask=function(){var self=this;// console.debug("addAboveCurrentTask",self.currentTask)
//check permissions
if(self.currentTask.getParent()&&!self.currentTask.getParent().canAdd)return;var factory=new TaskFactory();var ch;var row=0;if(self.currentTask&&self.currentTask.name){//cannot add brothers to root
if(self.currentTask.level<=0)return;ch=factory.build("tmp_"+new Date().getTime(),"","",self.currentTask.level,self.currentTask.start,1);row=self.currentTask.getRow();if(row>0){var task=self.addTask(ch,row);if(task){task.rowElement.click();task.rowElement.find("[name=name]").focus();}self.endTransaction();}}};GanttMaster.prototype.deleteCurrentTask=function(taskId){//console.debug("deleteCurrentTask",this.currentTask , this.isMultiRoot)
var self=this;var task;if(taskId)task=self.getTask(taskId);else task=self.currentTask;if(!task||!self.permissions.canDelete&&!task.canDelete)return;var taskIsEmpty=task.name=="";var row=task.getRow();if(task&&(row>0||self.isMultiRoot||task.isNew())){var par=task.getParent();task.deleteTask();task=undefined;//recompute depends string
self.updateDependsStrings();//redraw
self.taskIsChanged();//[expand]
if(par)self.editor.refreshExpandStatus(par);//focus next row
row=row>self.tasks.length-1?self.tasks.length-1:row;if(!taskIsEmpty&&row>=0){task=self.tasks[row];task.rowElement.click();task.rowElement.find("[name=name]").focus();}self.endTransaction();}};GanttMaster.prototype.collapseAll=function(){//console.debug("collapseAll");
if(this.currentTask){this.currentTask.collapsed=true;var desc=this.currentTask.getDescendant();for(var i=0;i<desc.length;i++){if(desc[i].isParent())// set collapsed only if is a parent
desc[i].collapsed=true;desc[i].rowElement.hide();}this.redraw();}};GanttMaster.prototype.fullScreen=function(){//console.debug("fullScreen");
this.workSpace.toggleClass("ganttFullScreen").resize();$("#fullscrbtn .teamworkIcon").html(this.workSpace.is(".ganttFullScreen")?"€":"@");};GanttMaster.prototype.expandAll=function(){//console.debug("expandAll");
if(this.currentTask){this.currentTask.collapsed=false;var desc=this.currentTask.getDescendant();for(var i=0;i<desc.length;i++){desc[i].collapsed=false;desc[i].rowElement.show();}this.redraw();}};GanttMaster.prototype.collapse=function(task,all){var _this3=this;//console.debug("collapse",task)
var collapsedDescendant=this.getCollapsedDescendant();task.collapsed=true;task.rowElement.addClass("collapsed");var descs=task.getDescendant();if(descs.length==0)return;var collapseTasks=[];for(var i=0;i<descs.length;i++){var childTask=descs[i];if(collapsedDescendant.indexOf(childTask)>=0)continue;//隐藏table的行
childTask.rowElement.hide();//去掉甘特图的行
this.workSpace.find('svg[taskid='+childTask.id+']').remove();$('g[id^="'+childTask.id+'-"]').remove();$('g[id$="-'+childTask.id+'"]').remove();collapseTasks.push(childTask);}var endRow=descs[collapseTasks.length-1].getRow();//隐藏结束的行
//减少甘特图的高度
this.workSpace.find('.gantSVGBoxDivContent').height(this.workSpace.find('.gantSVGBoxDivContent').height()-collapseTasks.length*this.rowHeight);this.workSpace.find('.ganttTable').height(this.workSpace.find('.ganttTable').height()-collapseTasks.length*this.rowHeight);//将最后一行的下所有任务往上移
var movedTasks=new _set2.default();this.workSpace.find('#tasksGroup').find('svg').each(function(index,item){if(item.getAttribute('y')>(endRow+1)*_this3.rowHeight){item.setAttribute('y',parseInt(item.getAttribute('y'))-collapseTasks.length*parseInt(_this3.rowHeight));movedTasks.add(item.getAttribute('taskid'));}});//处理相关link
this.gantt.redrawLink_taskids(movedTasks);};GanttMaster.prototype.expand=function(task,all){var _this4=this;//console.debug("expand",task)
task.collapsed=false;task.rowElement.removeClass("collapsed");var collapsedDescendant=this.getCollapsedDescendant();var descs=task.getDescendant();var expandTasks=[];for(var i=0;i<descs.length;i++){var childTask=descs[i];if(collapsedDescendant.indexOf(childTask)>=0)continue;//展开table的行
childTask.rowElement.show();expandTasks.push(childTask);}//处理甘特图
var endRow=task.getRow();this.workSpace.find('.gantSVGBoxDivContent').height(this.workSpace.find('.gantSVGBoxDivContent').height()+expandTasks.length*this.rowHeight);this.workSpace.find('.ganttTable').height(this.workSpace.find('.ganttTable').height()+expandTasks.length*this.rowHeight);//将新行一下的所有任务往下移一格
var movedTasks=new _set2.default();this.workSpace.find('#tasksGroup').find('svg').each(function(index,item){if(item.getAttribute('y')>(endRow+1)*_this4.rowHeight){item.setAttribute('y',parseInt(item.getAttribute('y'))+expandTasks.length*parseInt(_this4.rowHeight));movedTasks.add(item.getAttribute('taskid'));}});expandTasks.forEach(function(item){_this4.gantt.drawTask(item);_this4.gantt.redrawLink(item);});//处理移动过的link
this.gantt.redrawLink_taskids(movedTasks);};GanttMaster.prototype.getCollapsedDescendant=function(){var allTasks=this.tasks;var collapsedDescendant=[];for(var i=0;i<allTasks.length;i++){var task=allTasks[i];if(collapsedDescendant.indexOf(task)>=0)continue;if(task.collapsed){collapsedDescendant=collapsedDescendant.concat(task.getDescendant());}}return collapsedDescendant;};GanttMaster.prototype.addIssue=function(){var self=this;if(self.currentTask&&self.currentTask.isNew()){alert(GanttMaster.messages.PLEASE_SAVE_PROJECT);return;}if(!self.currentTask||!self.currentTask.canAddIssue)return;openIssueEditorInBlack('0',"AD","ISSUE_TASK="+self.currentTask.id);};GanttMaster.prototype.openExternalEditor=function(){//console.debug("openExternalEditor ")
var self=this;if(!self.currentTask)return;if(self.currentTask.isNew()){alert(GanttMaster.messages.PLEASE_SAVE_PROJECT);return;}//window.location.href=contextPath+"/applications/teamwork/task/taskEditor.jsp?CM=ED&OBJID="+self.currentTask.id;
};//this function notify an error to a transaction -> transaction will rollback
GanttMaster.prototype.setErrorOnTransaction=function(errorMessage,task){if(this.__currentTransaction){this.__currentTransaction.errors.push({msg:errorMessage,task:task});}else{console.error(errorMessage);}};GanttMaster.prototype.isTransactionInError=function(){if(!this.__currentTransaction){console.error("Transaction never started.");return true;}else{return this.__currentTransaction.errors.length>0;}};GanttMaster.prototype.endTransaction=function(){var ret=true;this.gantt.shrinkBoundaries();this.taskIsChanged();//enqueue for gantt refresh
return ret;};GanttMaster.prototype.afterModifiedTask=function(task){var redrawLink=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;this.ganttStore.ganttIsMouseDown=false;this.gantt.shrinkBoundaries(task);if(this.gantt.gridChanged&&this.gantt.isChangedBoundary()){//如果时间边界改变了需要重绘
if(this.tasks.length>100){this.ganttStore.loadingtip='甘特图绘制中，请等待...';var _this=this;setTimeout(function(){_this.gantt.redraw();},100);}else{this.gantt.redraw();}}else{$('svg[taskid="'+task.id+'"]').remove();this.gantt.drawTask(task);if(redrawLink){this.gantt.redrawLink(task);}}};GanttMaster.prototype.print=function(){this.gantt.redrawTasks(true);print();};GanttMaster.prototype.resize=function(){var self=this;this.element.stopTime("resizeRedraw").oneTime(50,"resizeRedraw",function(){self.splitter.resize();self.numOfVisibleRows=Math.ceil(self.element.height()/self.rowHeight);self.firstScreenLine=Math.floor(self.splitter.firstBox.scrollTop()/self.rowHeight);//self.gantt.redrawTasks();
});};/**
 * Compute the critical path using Backflow algorithm.
 * Translated from Java code supplied by M. Jessup here http://stackoverflow.com/questions/2985317/critical-path-method-algorithm
 *
 * For each task computes:
 * earlyStart, earlyFinish, latestStart, latestFinish, criticalCost
 *
 * A task on the critical path has isCritical=true
 * A task not in critical path can float by latestStart-earlyStart days
 *
 * If you use critical path avoid usage of dependencies between different levels of tasks
 *
 * WARNNG: It ignore milestones!!!!
 * @return {*}
 */GanttMaster.prototype.computeCriticalPath=function(){if(!this.tasks)return false;// do not consider grouping tasks
var tasks=this.tasks.filter(function(t){//return !t.isParent()
return t.getRow()>0&&(!t.isParent()||t.isParent()&&!t.isDependent());});// reset values
for(var i=0;i<tasks.length;i++){var t=tasks[i];t.earlyStart=-1;t.earlyFinish=-1;t.latestStart=-1;t.latestFinish=-1;t.criticalCost=-1;t.isCritical=false;}// tasks whose critical cost has been calculated
var completed=[];// tasks whose critical cost needs to be calculated
var remaining=tasks.concat();// put all tasks in remaining
// Backflow algorithm
// while there are tasks whose critical cost isn't calculated.
while(remaining.length>0){var progress=false;// find a new task to calculate
for(var i=0;i<remaining.length;i++){var task=remaining[i];var inferiorTasks=task.getInferiorTasks();if(containsAll(completed,inferiorTasks)){// all dependencies calculated, critical cost is max dependency critical cost, plus our cost
var critical=0;for(var j=0;j<inferiorTasks.length;j++){var t=inferiorTasks[j];if(t.criticalCost>critical){critical=t.criticalCost;}}task.criticalCost=critical+task.duration;// set task as calculated an remove
completed.push(task);remaining.splice(i,1);// note we are making progress
progress=true;}}// If we haven't made any progress then a cycle must exist in
// the graph and we wont be able to calculate the critical path
if(!progress){console.error("Cyclic dependency, algorithm stopped!");return false;}}// set earlyStart, earlyFinish, latestStart, latestFinish
computeMaxCost(tasks);var initialNodes=initials(tasks);calculateEarly(initialNodes);calculateCritical(tasks);return tasks;function containsAll(set,targets){for(var i=0;i<targets.length;i++){if(set.indexOf(targets[i])<0)return false;}return true;}function computeMaxCost(tasks){var max=-1;for(var i=0;i<tasks.length;i++){var t=tasks[i];if(t.criticalCost>max)max=t.criticalCost;}//console.debug("Critical path length (cost): " + max);
for(var i=0;i<tasks.length;i++){var t=tasks[i];t.setLatest(max);}}function initials(tasks){var initials=[];for(var i=0;i<tasks.length;i++){if(!tasks[i].depends||tasks[i].depends=="")initials.push(tasks[i]);}return initials;}function calculateEarly(initials){for(var i=0;i<initials.length;i++){var initial=initials[i];initial.earlyStart=0;initial.earlyFinish=initial.duration;setEarly(initial);}}function setEarly(initial){var completionTime=initial.earlyFinish;var inferiorTasks=initial.getInferiorTasks();for(var i=0;i<inferiorTasks.length;i++){var t=inferiorTasks[i];if(completionTime>=t.earlyStart){t.earlyStart=completionTime;t.earlyFinish=completionTime+t.duration;}setEarly(t);}}function calculateCritical(tasks){for(var i=0;i<tasks.length;i++){var t=tasks[i];t.isCritical=t.earlyStart==t.latestStart;}}};//------------------------------------------- MANAGE CHANGE LOG INPUT ---------------------------------------------------
/**
 * workStartHour,endStartHour : millis from 00:00
 * dateFormat dd/MM/yyyy HH:mm
 * working period resolution in millis or days
 */GanttMaster.prototype.setHoursOn=function(startWorkingHour,endWorkingHour,dateFormat,resolution){//console.debug("resolution",resolution)
Date.defaultFormat=dateFormat;Date.startWorkingHour=startWorkingHour;Date.endWorkingHour=endWorkingHour;Date.useMillis=resolution>=1000;Date.workingPeriodResolution=resolution;millisInWorkingDay=endWorkingHour-startWorkingHour;};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2=__webpack_require__(91);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *//**
 * A method to instantiate valid task models from
 * raw data.
 */window.TaskFactory=function(){/**
   * Build a new Task
   */this.build=function(id,name,code,level,start,end,duration,collapsed){// Set at beginning of day
var adjusted_start=computeStart(start);if(end==1){//新建任务时,开始日期默认是当天的,而end 则是1,这边判断一下
end=start;}var calculated_end=computeEnd(end);return new Task(id,name,code,level,adjusted_start,calculated_end,duration,collapsed);};};window.Task=function(id,name,code,level,start,end,duration,collapsed){this.id=id;this.name=name;this.progress=0;this.progressByWorklog=false;this.relevance=0;this.type="";this.typeId="";this.description="";this.code=code;this.level=level;this.status="STATUS_UNDEFINED";this.depends="";this.start=start;this.duration=duration;this.end=end;this.startIsMilestone=false;this.endIsMilestone=false;this.collapsed=collapsed;//permissions
// by default all true, but must be inherited from parent
this.canWrite=true;this.canAdd=true;this.canDelete=true;this.canAddIssue=true;this.rowElement;//row editor html element
this.ganttElement;//gantt html element  JH
this.ganttElement2;//SJ
this.master;this.assigs=[];};Task.prototype.clone=function(){var ret={};for(var key in this){if(typeof this[key]!="function")if((0,_typeof3.default)(this[key])!="object"||Array.isArray(this[key]))ret[key]=this[key];}return ret;};Task.prototype.getAssigsString=function(){var ret="";for(var i=0;i<this.assigs.length;i++){var ass=this.assigs[i];var res=this.master.getResource(ass.resourceId);if(res){ret=ret+(ret==""?"":", ")+res.name;}}return ret;};Task.prototype.createAssignment=function(id,resourceId,roleId,effort){var assig=new Assignment(id,resourceId,roleId,effort);this.assigs.push(assig);return assig;};//<%---------- SET PERIOD ---------------------- --%>
Task.prototype.setPeriod=function(start,end){//console.debug("setPeriod ",this.code,this.name,new Date(start), new Date(end));
//var profilerSetPer = new Profiler("gt_setPeriodJS");
if(start instanceof Date){start=start.getTime();}if(end instanceof Date){end=end.getTime();}var originalPeriod={start:this.start,end:this.end,duration:this.duration};//compute legal start/end //todo mossa qui R&S 30/3/2016 perchè altrimenti il calcolo della durata, che è stato modificato sommando giorni, sbaglia
start=computeStart(start);end=computeEnd(end);var newDuration=recomputeDuration(start,end);//if are equals do nothing and return true
if(start==originalPeriod.start&&end==originalPeriod.end&&newDuration==originalPeriod.duration){return true;}if(newDuration==this.duration){// is shift
return this.moveTo(start,false,true);}var wantedStartMillis=start;var children=this.getChildren();if(this.master.shrinkParent&&children.length>0){var chPeriod=this.getChildrenBoudaries();start=chPeriod.start;end=chPeriod.end;}//cannot start after end
if(start>end){start=end;}//if there are dependencies compute the start date and eventually moveTo
var startBySuperiors=this.computeStartBySuperiors(start);if(startBySuperiors!=start){return this.moveTo(startBySuperiors,false,true);}var somethingChanged=false;if(this.start!=start||this.start!=wantedStartMillis){this.start=start;somethingChanged=true;}//set end
var wantedEndMillis=end;if(this.end!=end||this.end!=wantedEndMillis){this.end=end;somethingChanged=true;}this.duration=recomputeDuration(this.start,this.end);//profilerSetPer.stop();
//nothing changed exit
if(!somethingChanged)return true;//cannot write exit
if(!this.canWrite){this.master.setErrorOnTransaction("\""+this.name+"\"\n"+GanttMaster.messages["CANNOT_WRITE"],this);return false;}//external dependencies: exit with error
if(this.hasExternalDep){this.master.setErrorOnTransaction("\""+this.name+"\"\n"+GanttMaster.messages["TASK_HAS_EXTERNAL_DEPS"],this);return false;}var todoOk=true;//I'm restricting
var deltaPeriod=originalPeriod.duration-this.duration;var restricting=deltaPeriod>0;var enlarging=deltaPeriod<0;var restrictingStart=restricting&&originalPeriod.start<this.start;var restrictingEnd=restricting&&originalPeriod.end>this.end;if(restricting){//loops children to get boundaries
var bs=Infinity;var be=0;for(var i=0;i<children.length;i++){var ch=children[i];if(restrictingEnd){be=Math.max(be,ch.end);}else{bs=Math.min(bs,ch.start);}}if(restrictingEnd){this.end=Math.max(be,this.end);}else{this.start=Math.min(bs,this.start);}this.duration=recomputeDuration(this.start,this.end);}else{//check global boundaries
if(this.start<this.master.minEditableDate||this.end>this.master.maxEditableDate){this.master.setErrorOnTransaction("\""+this.name+"\"\n"+GanttMaster.messages["CHANGE_OUT_OF_SCOPE"],this);todoOk=false;}}return todoOk;};//changeTaskDates 这个参数作为后面修改时间传参数  
Task.prototype.setPeriod1=function(start,end,starttime,endtime,passnoworktime,changeTaskDates){if(start instanceof Date){//前台可以直接传标准时间格式过来,也可以为时间戳
start=start.getTime();}if(end instanceof Date){end=end.getTime();}if(changeTaskDates=='1'){//手动调整时间时判断
var start2=new Date(start);start2=start2.format("yyyy-MM-dd");var end2=new Date(end);end2=end2.format("yyyy-MM-dd");if(start>end){this.master.setErrorOnTransaction(GanttMaster.messages["Message1"],this);return false;}else if(new Date(start2+' '+starttime).getTime()>new Date(end2+' '+endtime).getTime()){this.master.setErrorOnTransaction(GanttMaster.messages["Message2"],this);return false;}}var originalPeriod={start:this.start,end:this.end,duration:this.duration};var wantedStartMillis=start;if(start>end){start=end;}//start = computeStart(start);
var somethingChanged=false;//move date to closest day
var date=new Date(start);if(this.start!=start||this.start!=wantedStartMillis){this.start=start;somethingChanged=true;}//set end
var wantedEndMillis=end;//end = computeEnd(end);
if(this.end!=end||this.end!=wantedEndMillis){this.end=end;somethingChanged=true;}//wxp add 日期转换 yyyy-MM-dd
var start1=new Date(this.start);start1=start1.format("yyyy-MM-dd");var end1=new Date(this.end);end1=end1.format("yyyy-MM-dd");//处理新增任务时间未设定报错的问题
if(typeof starttime=='undefined'||starttime=='0'||starttime==''){starttime='00:00';}if(typeof endtime=='undefined'){endtime='23:59';}if(endtime=='0'||endtime==''){endtime='23:59';}//ecology8 工期的计算方法  
if(changeTaskDates=='1'){//手动调整时间 工期计算
var children=this.getChildren();if(children.length>0){for(var i=0;i<children.length;i++){ch=children[i];var startemp=new Date(ch.start);startemp=startemp.format("yyyy-MM-dd");var endtemp=new Date(ch.end);endtemp=endtemp.format("yyyy-MM-dd");if(new Date(start1).getTime()>new Date(startemp).getTime()){this.master.setErrorOnTransaction(GanttMaster.messages["Message3"],this);return false;}else if(new Date(start1+' '+starttime).getTime()>new Date(startemp+' '+ch.starttime).getTime()){this.master.setErrorOnTransaction(GanttMaster.messages["Message5"],this);return false;}else if(new Date(end1).getTime()<new Date(endtemp).getTime()){this.master.setErrorOnTransaction(GanttMaster.messages["Message4"],this);return false;}else if(new Date(end1+' '+endtime).getTime()<new Date(endtemp+' '+ch.endtime).getTime()){this.master.setErrorOnTransaction(GanttMaster.messages["Message6"],this);return false;}else{this.duration=getDur(start1,end1,starttime,endtime,passnoworktime);}}}else{this.duration=getDur(start1,end1,starttime,endtime,passnoworktime);}}else{//初始化时的工期计算
this.duration=getDur(start1,end1,starttime,endtime,passnoworktime);}//时间改变后重新赋值,不然时间选择框不会变
this.starttime=starttime;this.endtime=endtime;//nothing changed exit
if(!somethingChanged)return true;//external dependencies: exit with error
if(this.hasExternalDep){this.master.setErrorOnTransaction(GanttMaster.messages["TASK_HAS_EXTERNAL_DEPS"]+"\n"+this.name,this);return false;}var todoOk=true;//I'm restricting
var deltaPeriod=originalPeriod.duration-this.duration;var restricting=deltaPeriod>0;var restrictingStart=restricting&&originalPeriod.start<this.start;var restrictingEnd=restricting&&originalPeriod.end>this.end;if(restricting){//loops children to get boundaries
var children=this.getChildren();var bs=Infinity;var be=0;for(var i=0;i<children.length;i++){var ch=children[i];if(restrictingEnd){be=Math.max(be,ch.end);}else{bs=Math.min(bs,ch.start);}}if(restrictingEnd){this.end=Math.max(be,this.end);}else{this.start=Math.min(bs,this.start);}if(typeof starttime=='undefined'){starttime='00:00';}if(typeof endtime=='undefined'){endtime='23:59';}this.duration=getDur(start1,end1,starttime,endtime,passnoworktime);}else{//check global boundaries
if(this.start<this.master.minEditableDate||this.end>this.master.maxEditableDate){this.master.setErrorOnTransaction(GanttMaster.messages["CHANGE_OUT_OF_SCOPE"],this);todoOk=false;}}return todoOk;};//e8计算工期方法
function getDur(sDate1,sDate2,sDate3,sDate4,passnoworktime){var aDate,oDate1,oDate2,iDays,odate3,odate4,tdate,otime1,otime2,oDatetime1,oDatetime2;if(passnoworktime!=1){oDate1=new Date(sDate1);oDate2=new Date(sDate2);odate3=new Date(sDate3);odate4=new Date(sDate4);if(true){aDate=sDate1.split("-");tdate=sDate3.split(":");oDate1=new Date(aDate[1]+'-'+aDate[2]+'-'+aDate[0]);//转换为12-18-2002格式
oDatetime1=new Date(aDate[1]+'-'+aDate[2]+'-'+aDate[0]+" "+tdate[0]+":"+tdate[1]);//if(window.console) console.log("oDate1:"+oDate1);
//if(window.console) console.log("oDatetime1:"+oDatetime1);
aDate=sDate2.split("-");tdate=sDate4.split(":");oDate2=new Date(aDate[1]+'-'+aDate[2]+'-'+aDate[0]);oDatetime2=new Date(aDate[1]+'-'+aDate[2]+'-'+aDate[0]+" "+tdate[0]+":"+tdate[1]);}if(oDate2-oDate1<0){iDays=-1;//日期
}else if(oDate2-oDate1==0){if(sDate4<sDate3){iDays=-2;//时间
}else{iDays=(Math.abs(oDatetime1-oDatetime2)/1000/60/60/24).toFixed(2);}}else{iDays=(Math.abs(oDatetime1-oDatetime2)/1000/60/60/24).toFixed(2);}//if(window.console) console.log("iDays:"+(iDays));
}else{$.ajax({type:"post",url:"/proj/process/GetWorkDays.jsp",data:"begindate="+sDate1+"&begintime="+sDate3+"&enddate="+sDate2+"&endtime="+sDate4+"&manager=1",dataType:"text",async:false,success:function success(data){iDays=data.trim();}});}return iDays;}//<%---------- MOVE TO ---------------------- --%>
Task.prototype.moveTo=function(start,isActual){if(start instanceof Date){start=start.getTime();}var wantedStartMillis=start;if(isActual){//移动实际时间
var originalPeriod={actualbegindate:this.actualbegindate,actualenddate:this.actualenddate};var actualenddate=start?start-originalPeriod.actualbegindate+originalPeriod.actualenddate:'';if(this.actualbegindate!=start||this.actualbegindate!=wantedStartMillis){this.actualbegindate=start;this.actualenddate=actualenddate;}}else{//移动计划时间
var originalPeriod={start:this.start,end:this.end};var end=start?start-originalPeriod.start+originalPeriod.end:'';if(this.start!=start||this.start!=wantedStartMillis){this.start=start;this.end=end;}}return true;};//<%---------- COMPUTE START BY SUPERIORS ---------------------- --%>
Task.prototype.computeStartBySuperiors=function(proposedStart){//if depends -> start is set to max end + lag of superior
var supEnd=proposedStart;var sups=this.getSuperiors();if(sups&&sups.length>0){supEnd=0;for(var i=0;i<sups.length;i++){var link=sups[i];supEnd=Math.max(supEnd,incrementDateByUnits(new Date(link.from.end),link.lag));}supEnd+=1;}return computeStart(supEnd);};Task.prototype.getChildrenBoudaries=function(){var newStart=Infinity;var newEnd=-Infinity;var children=this.getChildren();for(var i=0;i<children.length;i++){var ch=children[i];newStart=Math.min(newStart,ch.start);newEnd=Math.max(newEnd,ch.end);}return{start:newStart,end:newEnd};};//<%---------- CHANGE STATUS ---------------------- --%>
Task.prototype.changeStatus=function(newStatus,forceStatusCheck){//console.debug("changeStatus: "+this.name+" from "+this.status+" -> "+newStatus);
var cone=this.getDescendant();function propagateStatus(task,newStatus,manuallyChanged,propagateFromParent,propagateFromChildren){//console.debug("propagateStatus",task.name, task.status,newStatus, manuallyChanged, propagateFromParent, propagateFromChildren);
var oldStatus=task.status;//no changes exit
if(newStatus==oldStatus&&!forceStatusCheck){return true;}var todoOk=true;task.status=newStatus;//xxxx -> STATUS_DONE            may activate dependent tasks, both suspended and undefined. Will set to done all children.
//STATUS_FAILED -> STATUS_DONE   do nothing if not forced by hand
if(newStatus=="STATUS_DONE"){// cannot close task if open issues
if(task.master.permissions.cannotCloseTaskIfIssueOpen&&task.openIssues>0){task.master.setErrorOnTransaction(GanttMaster.messages["CANNOT_CLOSE_TASK_IF_OPEN_ISSUE"]+" \""+task.name+"\"");return false;}if(manuallyChanged||oldStatus!="STATUS_FAILED"){//cannot set failed task as closed for cascade - only if changed manually
//can be closed only if superiors are already done
var sups=task.getSuperiors();for(var i=0;i<sups.length;i++){if(sups[i].from.status!="STATUS_DONE"&&cone.indexOf(sups[i].from)<0){// è un errore se un predecessore è non chiuso ed è fuori dal cono
if(manuallyChanged||propagateFromParent)//genere un errore bloccante se è cambiato a mano o se il cambiamento arriva dal parent ed ho una dipendenza fuori dal cono (altrimenti avrei un attivo figlio di un chiuso
task.master.setErrorOnTransaction(GanttMaster.messages["GANTT_ERROR_DEPENDS_ON_OPEN_TASK"]+"\n\""+sups[i].from.name+"\" -> \""+task.name+"\"");todoOk=false;break;}}if(todoOk){// set progress to 100% if needed by settings
if(task.master.set100OnClose&&!task.progressByWorklog){task.progress=100;}//set children as done
propagateStatusToChildren(task,newStatus,false);//set inferiors as active
propagateStatusToInferiors(task.getInferiors(),"STATUS_ACTIVE");}}else{// una propagazione tenta di chiudere un task fallito
todoOk=false;}//  STATUS_UNDEFINED -> STATUS_ACTIVE       all children become active, if they have no dependencies.
//  STATUS_SUSPENDED -> STATUS_ACTIVE       sets to active all children and their descendants that have no inhibiting dependencies.
//  STATUS_WAITING -> STATUS_ACTIVE         sets to active all children and their descendants that have no inhibiting dependencies.
//  STATUS_DONE -> STATUS_ACTIVE            all those that have dependencies must be set to suspended.
//  STATUS_FAILED -> STATUS_ACTIVE          nothing happens: child statuses must be reset by hand.
}else if(newStatus=="STATUS_ACTIVE"){if(manuallyChanged||oldStatus!="STATUS_FAILED"&&oldStatus!="STATUS_SUSPENDED"){//cannot set failed or suspended task as active for cascade - only if changed manually
//can be active only if superiors are already done, not only on this task, but also on ancestors superiors
var sups=task.getSuperiors();for(var i=0;i<sups.length;i++){if(sups[i].from.status!="STATUS_DONE"){if(manuallyChanged||propagateFromChildren)task.master.setErrorOnTransaction(GanttMaster.messages["GANTT_ERROR_DEPENDS_ON_OPEN_TASK"]+"\n\""+sups[i].from.name+"\" -> \""+task.name+"\"");todoOk=false;break;}}// check if parent is already active
if(todoOk){var par=task.getParent();if(par&&par.status!="STATUS_ACTIVE"){// todoOk = propagateStatus(par, "STATUS_ACTIVE", false, false, true); //todo abbiamo deciso di non far propagare lo status verso l'alto
todoOk=false;}}if(todoOk){if(oldStatus=="STATUS_UNDEFINED"||oldStatus=="STATUS_SUSPENDED"||oldStatus=="STATUS_WAITING"){//set children as active
propagateStatusToChildren(task,newStatus,true);}//set inferiors as suspended
//propagateStatusToInferiors( task.getInferiors(), "STATUS_SUSPENDED");
propagateStatusToInferiors(task.getInferiors(),"STATUS_WAITING");}}else{todoOk=false;}// xxxx -> STATUS_WAITING       all active children and their active descendants become waiting. when not failed or forced
}else if(newStatus=="STATUS_WAITING"){if(manuallyChanged||oldStatus!="STATUS_FAILED"){//cannot set failed task as waiting for cascade - only if changed manually
//check if parent if not active
var par=task.getParent();if(par&&par.status!="STATUS_ACTIVE"&&par.status!="STATUS_SUSPENDED"&&par.status!="STATUS_WAITING"){todoOk=false;}if(todoOk){//set children as STATUS_WAITING
propagateStatusToChildren(task,"STATUS_WAITING",true);//set inferiors as STATUS_WAITING
propagateStatusToInferiors(task.getInferiors(),"STATUS_WAITING");}}else{todoOk=false;}// xxxx -> STATUS_SUSPENDED       all active children and their active descendants become suspended. when not failed or forced
}else if(newStatus=="STATUS_SUSPENDED"){if(manuallyChanged||oldStatus!="STATUS_FAILED"){//cannot set failed task as closed for cascade - only if changed manually
//check if parent if not active
var par=task.getParent();if(par&&par.status!="STATUS_ACTIVE"&&par.status!="STATUS_SUSPENDED"&&par.status!="STATUS_WAITING"){todoOk=false;}if(todoOk){//set children as STATUS_SUSPENDED
propagateStatusToChildren(task,"STATUS_SUSPENDED",true);//set inferiors as STATUS_SUSPENDED
propagateStatusToInferiors(task.getInferiors(),"STATUS_SUSPENDED");}}else{todoOk=false;}// xxxx -> STATUS_FAILED children and dependent failed
// xxxx -> STATUS_UNDEFINED  children and dependant become undefined.
}else if(newStatus=="STATUS_FAILED"||newStatus=="STATUS_UNDEFINED"){//set children as failed or undefined
propagateStatusToChildren(task,newStatus,false);//set inferiors as failed
propagateStatusToInferiors(task.getInferiors(),newStatus);}if(!todoOk){task.status=oldStatus;//console.debug("status rolled back: "+task.name + " to " + oldStatus);
}return todoOk;}/**
   * A helper method to traverse an array of 'inferior' tasks
   * and signal a status change.
   */function propagateStatusToInferiors(infs,status){for(var i=0;i<infs.length;i++){propagateStatus(infs[i].to,status,false,false,false);}}/**
   * A helper method to loop children and propagate new status
   */function propagateStatusToChildren(task,newStatus,skipClosedTasks){var chds=task.getChildren();for(var i=0;i<chds.length;i++){if(!(skipClosedTasks&&chds[i].status=="STATUS_DONE"))propagateStatus(chds[i],newStatus,false,true,false);}}var manuallyChanged=true;var oldStatus=this.status;//first call
if(propagateStatus(this,newStatus,manuallyChanged,false,false)){return true;}else{this.status=oldStatus;return false;}};Task.prototype.synchronizeStatus=function(){//console.debug("synchronizeStatus",this.name);
var oldS=this.status;this.status=this.getParent()?this.getParent().status:"STATUS_UNDEFINED";// di default si invalida lo stato mettendo quello del padre, in modo che inde/outd siano consistenti
return this.changeStatus(oldS,true);};Task.prototype.isLocallyBlockedByDependencies=function(){var sups=this.getSuperiors();var blocked=false;for(var i=0;i<sups.length;i++){if(sups[i].from.status!="STATUS_DONE"){blocked=true;break;}}return blocked;};//<%---------- TASK STRUCTURE ---------------------- --%>
Task.prototype.getRow=function(){var ret=-1;if(this.master)ret=this.master.tasks.indexOf(this);return ret;};Task.prototype.getParents=function(){var ret;if(this.master){var topLevel=this.level;var pos=this.getRow();ret=[];for(var i=pos;i>=0;i--){var par=this.master.tasks[i];if(topLevel>par.level){topLevel=par.level;ret.push(par);}}}return ret;};Task.prototype.getParent=function(){var ret;if(this.master){for(var i=this.getRow();i>=0;i--){var par=this.master.tasks[i];if(this.level>par.level){ret=par;break;}}}return ret;};Task.prototype.isParent=function(){var ret=false;if(this.master){var pos=this.getRow();if(pos<this.master.tasks.length-1)ret=this.master.tasks[pos+1].level>this.level;}return ret;};Task.prototype.getChildren=function(){var ret=[];if(this.master){var pos=this.getRow();for(var i=pos+1;i<this.master.tasks.length;i++){var ch=this.master.tasks[i];if(ch.level==this.level+1)ret.push(ch);else if(ch.level<=this.level)// exit loop if parent or brother
break;}}return ret;};Task.prototype.getAllChildren=function(){var ret=[];if(this.master){var pos=this.getRow();for(var i=pos+1;i<this.master.tasks.length;i++){var ch=this.master.tasks[i];if(ch.level>=this.level+1)ret.push(ch);else if(ch.level<=this.level)// exit loop if parent or brother
break;}}return ret;};Task.prototype.getDescendant=function(){var ret=[];if(this.master){var pos=this.getRow();for(var i=pos+1;i<this.master.tasks.length;i++){var ch=this.master.tasks[i];if(ch.level>this.level)ret.push(ch);else break;}}return ret;};Task.prototype.getSuperiors=function(){var ret=[];var task=this;if(this.master){ret=this.master.links.filter(function(link){return link.to==task;});}return ret;};Task.prototype.getSuperiorTasks=function(){var ret=[];var sups=this.getSuperiors();for(var i=0;i<sups.length;i++){ret.push(sups[i].from);}return ret;};Task.prototype.getInferiors=function(){var ret=[];var task=this;if(this.master){ret=this.master.links.filter(function(link){return link.from==task;});}return ret;};Task.prototype.getInferiorTasks=function(){var ret=[];var infs=this.getInferiors();for(var i=0;i<infs.length;i++){ret.push(infs[i].to);}return ret;};Task.prototype.deleteTask=function(){var _this=this;var row=this.getRow();//if is the current one remove it
if(this.master.currentTask&&this.master.currentTask.id==this.id){var supId=this.master.currentTask['field'+this.master.ganttStore.baseInfo.superiorField+'_value'];delete this.master.currentTask;var tasks=this.master.ganttStore.ganttMaster.tasks;tasks.splice(tasks.findIndex(function(item){return item.id==_this.id;}),1);var supDomId="#tid_"+supId;// tasks.forEach(item =>{
//   //更新子任务的上级任务
//   if (supId && item['field'+this.master.ganttStore.baseInfo.superiorField+'_value'] == this.id) {
//     let itemIndex = tasks.findIndex(i => i.id === item.id);
//     this.master.ganttStore.ganttMaster.tasks[itemIndex]['field'+this.master.ganttStore.baseInfo.superiorField+'_value'] = supId;
//   }
// })
tasks.forEach(function(item){if(item.id==supId&&item.getAllChildren().length==0){//清除父任务标识
$(supDomId).attr('class',$(supDomId).attr('class').replace(/isParent/,''));}});}//delete both dom elements if exists
if(this.rowElement)this.rowElement.remove();//-------------------------------------甘特图的删除处理开始
if(this.ganttElement){this.ganttElement.remove();}if(this.ganttElement2){this.ganttElement2.remove();}var getGanttId=this.master.ganttStore.id;var workspace=$(".TWGanttWorkSpace_"+getGanttId);var gridGroup=workspace.find("#gridGroup").get(0);//甘特图最下边减少一行
$(gridGroup).find('rect:last').remove();//减少甘特图的一个高度
workspace.find('.gantSVGBoxDivContent').height(workspace.find('.gantSVGBoxDivContent').height()-this.master.rowHeight);workspace.find('.ganttTable').height(workspace.find('.ganttTable').height()-this.master.rowHeight);//将删除行的下一个的所有任务往上移一格
workspace.find('#tasksGroup').find('svg').each(function(index,item){if(item.getAttribute('y')>row*_this.master.rowHeight){item.setAttribute('y',parseInt(item.getAttribute('y'))-parseInt(_this.master.rowHeight));}});//-------------------------------------甘特图的删除处理结束
//remove children
// var chd = this.getChildren();
// for (var i = 0; i < chd.length; i++) {
//   //add removed child in list
//   chd[i].deleteTask();
// }
//remove from in-memory collection
// this.master.tasks.splice(row, 1);
//remove from links
var task=this;this.master.links=this.master.links.filter(function(link){if(link.from==task){$('g[id^="'+task.id+'-"]').remove();}if(link.to==task){$('g[id$="-'+task.id+'"]').remove();}return link.from!=task&&link.to!=task;});};Task.prototype.isNew=function(){return(this.id+"").startsWith("tmp");};Task.prototype.isDependent=function(t){//console.debug("isDependent",this.name, t.name)
var task=this;var dep=this.master.links.filter(function(link){return link.from==task;});// is t a direct dependency?
for(var i=0;i<dep.length;i++){if(dep[i].to==t)return true;}// is t an indirect dependency
for(var i=0;i<dep.length;i++){if(dep[i].to.isDependent(t)){return true;}}return false;};Task.prototype.setLatest=function(maxCost){this.latestStart=maxCost-this.criticalCost;this.latestFinish=this.latestStart+this.duration;};//<%------------------------------------------  INDENT/OUTDENT --------------------------------%>
Task.prototype.indent=function(){//console.debug("indent", this);
//a row above must exist
var row=this.getRow();//no row no party
if(row<=0)return false;var ret=false;var taskAbove=this.master.tasks[row-1];var newLev=this.level+1;if(newLev<=taskAbove.level+1){ret=true;//trick to get parents after indent
this.level++;var futureParents=this.getParents();this.level--;var oldLevel=this.level;for(var i=row;i<this.master.tasks.length;i++){var desc=this.master.tasks[i];if(desc.level>oldLevel||desc==this){desc.level++;//remove links from this and descendant to my parents
this.master.links=this.master.links.filter(function(link){var linkToParent=false;if(link.to==desc)linkToParent=futureParents.indexOf(link.from)>=0;else if(link.from==desc)linkToParent=futureParents.indexOf(link.to)>=0;return!linkToParent;});//remove links from this and descendants to predecessors of parents in order to avoid loop
var predecessorsOfFutureParents=[];for(var j=0;j<futureParents.length;j++){predecessorsOfFutureParents=predecessorsOfFutureParents.concat(futureParents[j].getSuperiorTasks());}this.master.links=this.master.links.filter(function(link){var linkToParent=false;if(link.from==desc)linkToParent=predecessorsOfFutureParents.indexOf(link.to)>=0;return!linkToParent;});}else break;}var parent=this.getParent();// set start date to parent' start if no deps
if(parent&&!this.depends){var new_end=computeEndByDuration(parent.start,this.duration);this.master.changeTaskDates(this,parent.start,new_end);}//recompute depends string
this.master.updateDependsStrings();//force status check starting from parent
this.getParent().synchronizeStatus();}return ret;};Task.prototype.outdent=function(){//console.debug("outdent", this);
//a level must be >1 -> cannot escape from root
if(this.level<=1)return false;var ret=false;var oldLevel=this.level;ret=true;var row=this.getRow();for(var i=row;i<this.master.tasks.length;i++){var desc=this.master.tasks[i];if(desc.level>oldLevel||desc==this){desc.level--;}else break;}var task=this;var chds=this.getChildren();//remove links from me to my new children
this.master.links=this.master.links.filter(function(link){var linkExist=link.to==task&&chds.indexOf(link.from)>=0||link.from==task&&chds.indexOf(link.to)>=0;return!linkExist;});//enlarge me if inherited children are larger
for(var i=0;i<chds.length;i++){//remove links from me to my new children
chds[i].setPeriod(chds[i].start+1,chds[i].end+1);}//recompute depends string
this.master.updateDependsStrings();//enlarge parent using a fake set period
this.setPeriod(this.start+1,this.end+1);//force status check
this.synchronizeStatus();return ret;};//<%------------------------------------------  MOVE UP / MOVE DOWN --------------------------------%>
Task.prototype.moveUp=function(){//console.debug("moveUp", this);
var ret=false;//a row above must exist
var row=this.getRow();//no row no party
if(row<=0)return false;//find new row
var newRow;for(newRow=row-1;newRow>=0;newRow--){if(this.master.tasks[newRow].level<=this.level)break;}//is a parent or a brother
if(this.master.tasks[newRow].level==this.level){ret=true;//compute descendant
var descNumber=0;for(var i=row+1;i<this.master.tasks.length;i++){var desc=this.master.tasks[i];if(desc.level>this.level){descNumber++;}else{break;}}//move in memory
var blockToMove=this.master.tasks.splice(row,descNumber+1);var top=this.master.tasks.splice(0,newRow);this.master.tasks=[].concat(top,blockToMove,this.master.tasks);//move on dom
var rows=this.master.editor.element.find("tr[taskid]");var domBlockToMove=rows.slice(row,row+descNumber+1);rows.eq(newRow).before(domBlockToMove);//recompute depends string
this.master.updateDependsStrings();}else{this.master.setErrorOnTransaction(GanttMaster.messages["TASK_MOVE_INCONSISTENT_LEVEL"],this);ret=false;}return ret;};Task.prototype.moveDown=function(){//console.debug("moveDown", this);
//a row below must exist, and cannot move root task
var row=this.getRow();if(row>=this.master.tasks.length-1||row==0)return false;var ret=false;//find nearest brother
var newRow;for(newRow=row+1;newRow<this.master.tasks.length;newRow++){if(this.master.tasks[newRow].level<=this.level)break;}//is brother
if(this.master.tasks[newRow]&&this.master.tasks[newRow].level==this.level){ret=true;//find last desc
for(newRow=newRow+1;newRow<this.master.tasks.length;newRow++){if(this.master.tasks[newRow].level<=this.level)break;}//compute descendant
var descNumber=0;for(var i=row+1;i<this.master.tasks.length;i++){var desc=this.master.tasks[i];if(desc.level>this.level){descNumber++;}else{break;}}//move in memory
var blockToMove=this.master.tasks.splice(row,descNumber+1);var top=this.master.tasks.splice(0,newRow-descNumber-1);this.master.tasks=[].concat(top,blockToMove,this.master.tasks);//move on dom
var rows=this.master.editor.element.find("tr[taskid]");var aft=rows.eq(newRow-1);var domBlockToMove=rows.slice(row,row+descNumber+1);aft.after(domBlockToMove);//recompute depends string
this.master.updateDependsStrings();}return ret;};Task.prototype.canStatusBeChangedTo=function(newStatus){//lo stato corrente è sempre ok
if(newStatus==this.status)return true;var parent=this.getParent();//---------------------------------------------------------------------- STATUS_DONE ----------------------------------------------------------------
// un task può essere STATUS_DONE se di root
// se il suo padre non è fallito o undefined
// se non ha previouses aperti
if("STATUS_DONE"==newStatus){if(!parent)return true;if("STATUS_FAILED"==parent.status||"STATUS_UNDEFINED"==parent.status)return false;var sups=this.getSuperiorTasks();for(var i=0;i<sups.length;i++){if("STATUS_DONE"!=sups[i].status){// è un errore se un predecessore non è chiuso
return false;}}return true;//---------------------------------------------------------------------- STATUS_ACTIVE ----------------------------------------------------------------
//un task può essere STATUS_ACTIVE se l'eventuale padre è active e se tutti i predecessori sono in STATUS_DONE
}else if("STATUS_ACTIVE"==newStatus){if(!parent)return true;if(!"STATUS_ACTIVE"==parent.status)return false;var sups=this.getSuperiorTasks();for(var i=0;i<sups.length;i++){if("STATUS_DONE"!=sups[i].status){// è un errore se un predecessore non è chiuso
return false;}}return true;//---------------------------------------------------------------------- STATUS_WAITING ----------------------------------------------------------------
//un task può essere STATUS_WAITING solo se ha il padre o un predecessore STATUS_WAITING || un predecessore active STATUS_ACTIVE
}else if("STATUS_WAITING"==newStatus){//un task può essere STATUS_WAITING solo se ha il padre
if(!parent)return false;if("STATUS_FAILED"==parent.status||"STATUS_UNDEFINED"==parent.status)return false;if("STATUS_WAITING"==parent.status)return true;var sups=this.getSuperiorTasks();for(var i=0;i<sups.length;i++){if("STATUS_WAITING"==sups[i].status||"STATUS_ACTIVE"==sups[i].status){return true;}}return false;//---------------------------------------------------------------------- STATUS_SUSPENDED ----------------------------------------------------------------
//un task può essere is STATUS_SUSPENDED (a mano) se di root
// se il parent è STATUS_ACTIVE o STATUS_SUSPENDED e se non
}else if("STATUS_SUSPENDED"==newStatus){if(!parent)return true;if("STATUS_UNDEFINED"==parent.status||"STATUS_FAILED"==parent.status)return false;return true;//---------------------------------------------------------------------- STATUS_FAILED ----------------------------------------------------------------
}else if("STATUS_FAILED"==newStatus){//può essere in STATUS_FAILED sempre
return true;//---------------------------------------------------------------------- STATUS_UNDEFINED ----------------------------------------------------------------
}else if("STATUS_UNDEFINED"==newStatus){//può essere in STATUS_UNDEFINED sempre
return true;}return false;};//<%------------------------------------------------------------------------  LINKS OBJECT ---------------------------------------------------------------%>
window.Link=function(taskFrom,taskTo,lagInWorkingDays){this.from=taskFrom;this.to=taskTo;this.lag=lagInWorkingDays;};//<%------------------------------------------------------------------------  ASSIGNMENT ---------------------------------------------------------------%>
window.Assignment=function(id,resourceId,roleId,effort){this.id=id;this.resourceId=resourceId;this.roleId=roleId;this.effort=effort;};//<%------------------------------------------------------------------------  RESOURCE ---------------------------------------------------------------%>
window.Resource=function(id,name){this.id=id;this.name=name;};//<%------------------------------------------------------------------------  ROLE ---------------------------------------------------------------%>
window.Role=function(id,name){this.id=id;this.name=name;};

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */var head;// 获取元素的纵坐标（相对于窗口）
function getTop(e){var offset=e.offsetTop;if(e.offsetParent!=null)offset+=getTop(e.offsetParent);return offset;}$.gridify=function(table,opt,getGanttId,topHeight){var options={resizeZoneWidth:10};$.extend(options,opt);var box=$("<div>").addClass("gdfWrapper");box.append(table);head=table.clone();table.addClass("rowDragTable");//处理table避免左右滚动不平衡
table.find('thead').find('tr').height('0px');table.find('thead').find('tr').find('th').height('0px');table.find('thead').find('tr').find('th').css('border-bottom','none');table.find('thead').find('tr').find('th').each(function(index,item){item.innerHTML='';});table.css('margin-top','60px');head.addClass("table ganttFixHead");head.css('position','fixed');head.css('top',topHeight+2);//remove non head
head.find("tbody").remove();box.append(head);box.append(table);var hTh=head.find(".gdfColHeader");var cTh=table.find(".gdfColHeader");for(var i=0;i<hTh.length;i++){hTh.eq(i).data("fTh",cTh.eq(i));}//--------- set table to 0 to prevent a strange 100%
table.width(0);head.width(0);//----------------------  header management start
head.find("th.gdfColHeader:not(.gdfied)").mouseover(function(){$(this).addClass("gdfColHeaderOver");}).on("mouseout.gdf",function(){$(this).removeClass("gdfColHeaderOver");if(!$.gridify.columInResize){$(".TWGanttWorkSpace_"+getGanttId).removeClass("gdfHResizing");}}).on("mousemove.gdf",function(e){if(!$.gridify.columInResize){var colHeader=$(this);var nextCol=colHeader.next();if(nextCol.length>0&&nextCol.width()<options.resizeZoneWidth)colHeader=nextCol;if(!colHeader.is(".gdfResizable"))return;var mousePos=e.pageX-colHeader.offset().left;if(colHeader.width()-mousePos<options.resizeZoneWidth){$(".TWGanttWorkSpace_"+getGanttId).addClass("gdfHResizing");}else{$(".TWGanttWorkSpace_"+getGanttId).removeClass("gdfHResizing");}}}).on("mousedown.gdf",function(e){//console.debug("mousedown.gdf")
var colHeader=$(this);var nextCol=colHeader.next();if(nextCol.length>0&&nextCol.width()<options.resizeZoneWidth)colHeader=nextCol;if(!colHeader.is(".gdfResizable"))return;var mousePos=e.pageX-colHeader.offset().left;if(colHeader.width()-mousePos<options.resizeZoneWidth){$.gridify.columInResize=colHeader;//on event for start resizing
$(document).on("mousemove.gdf",function(e){e.preventDefault();$(".TWGanttWorkSpace_"+getGanttId).addClass("gdfHResizing");//manage resizing
var w=e.pageX-$.gridify.columInResize.offset().left;w=w<=1?1:w;$.gridify.columInResize.width(w);$.gridify.columInResize.data("fTh").width(w);//on mouse up on body to stop resizing
moveSplitBar(getGanttId);}).on("mouseup.gdf",function(){//console.debug("mouseup.gdf")
$(this).off("mousemove.gdf").off("mouseup.gdf");$(".TWGanttWorkSpace_"+getGanttId).removeClass("gdfHResizing");delete $.gridify.columInResize;$('th[data-initialwidth]').attr('data-initialwidth',$('th[data-initialwidth]').outerWidth());});}}).on("dblclick.gdf",function(){//console.debug("dblclick.gdf")
var col=$(this);if(!col.is(".gdfResizable"))return;var idx=$("th",col.parents("table")).index(col);var columnTd=$("td:nth-child("+(idx+1)+")",table);var w=0;columnTd.each(function(){var td=$(this);var content=td.children("input").length?td.children("input").val():td.html();var tmp=$("<div/>").addClass("columnWidthTest").html(content).css({position:"absolute"});$(".TWGanttWorkSpace_"+getGanttId).append(tmp);w=Math.max(w,tmp.width()+parseFloat(td.css("padding-left")));tmp.remove();});w=w+5;col.width(w);col.data("fTh").width(w);extendLastTh();return false;}).addClass("gdfied unselectable");return box;};//改为延长标题字段
function extendLastTh(getGanttId,opt){//如果box1不存在滚动条则通过动态该表标题字段的宽度来适应box1的展示效果
var titleField=$(".TWGanttWorkSpace_"+getGanttId).find('.splitBox1').find('.ganttFixHead th[data-initialwidth]');//标题字段，需要延长的字段
var initialwidth=titleField.attr('data-initialwidth');//最后一个th的原始长度
//当标题字段的宽度小于自身原始宽度时就不在调整
if(titleField.outerWidth()>=initialwidth){if(opt){//点击按钮触发
var difWidth=opt.newW-$(".TWGanttWorkSpace_"+getGanttId).find('.ganttFixHead').outerWidth()-3+parseInt(titleField.outerWidth());if(difWidth<initialwidth)difWidth=initialwidth;$(".TWGanttWorkSpace_"+getGanttId).find('.gdfTable th[data-initialwidth]').animate({width:difWidth},opt.animTime);}else{//拖动触发
//获取box1的宽度与splitbar的left的差值+标题字段的现有宽度
var difWidth=$(".TWGanttWorkSpace_"+getGanttId).find('.vSplitBar').css('left').replace('px','')-$(".TWGanttWorkSpace_"+getGanttId).find('.ganttFixHead').outerWidth()-3+parseInt(titleField.outerWidth());if(difWidth<initialwidth)difWidth=initialwidth;$(".TWGanttWorkSpace_"+getGanttId).find('.gdfTable th[data-initialwidth]').outerWidth(difWidth);}}}//左边table补齐空白
function moveSplitBar(getGanttId){var barLeft=$(".TWGanttWorkSpace_"+getGanttId).find('.vSplitBar').css('left').replace('px','');var difWidth=barLeft-$(".TWGanttWorkSpace_"+getGanttId).find('.ganttFixHead').outerWidth()-3;if(difWidth>0){$(".TWGanttWorkSpace_"+getGanttId).find('.splitBox1').width($(".TWGanttWorkSpace_"+getGanttId).find('.splitBox1').width()-difWidth);$(".TWGanttWorkSpace_"+getGanttId).find('.vSplitBar').css('left',$(".TWGanttWorkSpace_"+getGanttId).find('.vSplitBar').css('left').replace('px','')-difWidth);$(".TWGanttWorkSpace_"+getGanttId).find('.splitBox2').width($(".TWGanttWorkSpace_"+getGanttId).find('.splitBox2').width()+difWidth);$(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDiv').width($(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDiv').width()+difWidth);$(".TWGanttWorkSpace_"+getGanttId).find('.splitBox2').css('left',$(".TWGanttWorkSpace_"+getGanttId).find('.splitBox2').css('left').replace('px','')-difWidth);}}$.splittify={init:function init(where,first,second,perc,getGanttId){//perc = perc || 50;
var element=where.find('.splitterContainer');//$("<div>").addClass("splitterContainer");
var firstBox=$("<div>").addClass("splitElement splitBox1");var splitterBar=$("<div>").addClass("splitElement vSplitBar").css("padding-top",where.height()/2+"px");var secondBox=$("<div>").addClass("splitElement splitBox2");var splitter=new Splitter(element,firstBox,secondBox,splitterBar,getGanttId);splitter.perc=perc;var toLeft=$("<div>").addClass("toLeft icon-coms-Left").click(function(){splitter.resize(0.001,300);});splitterBar.append(toLeft);var toCenter=$("<div>").addClass("toCenter icon-coms-Refresh").click(function(){splitter.resize(50,300);});splitterBar.append(toCenter);var toRight=$("<div>").addClass("toRight icon-coms-Right").click(function(){splitter.resize(99.9999,300);});splitterBar.append(toRight);firstBox.append(first);secondBox.append(second);element.append(firstBox).append(secondBox).append(splitterBar);if($('.splitBox1')[0]){// head.css('top',getTop($('.splitBox1')[0])+2);
head.css('top',getTop($('.splitBox1')[0]));}//where.append(element);
var totalW=where.innerWidth();var splW=splitterBar.width();var fbw=totalW*perc/100-splW;fbw=fbw>totalW-splW-splitter.secondBoxMinWidth?totalW-splW-splitter.secondBoxMinWidth:fbw;firstBox.width(fbw).css({left:0});splitterBar.css({left:firstBox.width()});secondBox.width(totalW-fbw-splW).css({left:firstBox.width()+splW});splitterBar.on("mousedown.gdf",function(e){e.preventDefault();$(".TWGanttWorkSpace_"+getGanttId).addClass("gdfHResizing");$.splittify.splitterBar=$(this);//on event for start resizing
//console.debug("start splitting");
$(".TWGanttWorkSpace_"+getGanttId).on("mousemove.gdf",function(e){//manage resizing
e.preventDefault();totalW=$(".TWGanttWorkSpace_"+getGanttId).find('.TWGanttArea').innerWidth();var sb=$.splittify.splitterBar;var pos=e.pageX-sb.parent().offset().left;var w=sb.parent().width();pos=pos>splitter.firstBoxMinWidth?pos:splitter.firstBoxMinWidth;//pos = pos < realW - 10 ? pos : realW - 10;
pos=pos>totalW-splW-splitter.secondBoxMinWidth?totalW-splW-splitter.secondBoxMinWidth:pos;sb.css({left:pos});firstBox.width(pos);secondBox.css({left:pos+sb.width(),width:w-pos-sb.width()});$(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDiv').width(secondBox.width());splitter.perc=firstBox.width()/splitter.element.width()*100;extendLastTh(getGanttId);//on mouse up on body to stop resizing
}).on("mouseup.gdf",function(){//console.debug("stop splitting");
$(this).off("mousemove.gdf").off("mouseup.gdf");delete $.splittify.splitterBar;$(".TWGanttWorkSpace_"+getGanttId).removeClass("gdfHResizing");});});firstBox.on('mousewheel MozMousePixelScroll',function(event){event.preventDefault();var deltaY=event.originalEvent.wheelDeltaY;if(!deltaY)deltaY=event.originalEvent.wheelDelta;var deltaX=event.originalEvent.wheelDeltaX;if(event.originalEvent.axis){deltaY=event.originalEvent.axis==2?-event.originalEvent.detail:null;deltaX=event.originalEvent.axis==1?-event.originalEvent.detail:null;}deltaY=Math.abs(deltaY)<40?40*(Math.abs(deltaY)/deltaY):deltaY;deltaX=Math.abs(deltaX)<40?40*(Math.abs(deltaX)/deltaX):deltaX;var scrollToY=$(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDiv').scrollTop()-deltaY;//secondBox.scrollTop() - deltaY;
var scrollToX=firstBox.scrollLeft()-deltaX;//			console.debug( firstBox.scrollLeft(), Math.abs(deltaX), Math.abs(deltaY));
if(deltaY)$(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDiv').scrollTop(scrollToY);//secondBox.scrollTop(scrollToY);
if(deltaX)firstBox.scrollLeft(scrollToX);return false;});function Splitter(element,firstBox,secondBox,splitterBar,getGanttId){this.element=element;this.firstBox=firstBox;this.secondBox=secondBox;this.splitterBar=splitterBar;this.perc=0;this.firstBoxMinWidth=0;this.secondBoxMinWidth=30;var self=this;this.resize=function(newPerc,anim){var animTime=anim?anim:0;this.perc=newPerc?newPerc:this.perc;var totalW=this.element.width();var splW=this.splitterBar.width();var newW=totalW*this.perc/100;newW=newW>this.firstBoxMinWidth?newW:this.firstBoxMinWidth;newW=newW>totalW-splW-splitter.secondBoxMinWidth?totalW-splW-splitter.secondBoxMinWidth:newW;if(!newPerc&&!anim){//初始加载时执行
var realW=$(".TWGanttWorkSpace_"+getGanttId).find('.splitBox1').find('.ganttFixHead').width()+splW+1-3;newW=newW<realW?newW:realW;}this.firstBox.animate({width:newW},animTime,function(){$(this).css("overflow-x","auto");});this.splitterBar.animate({left:newW},animTime);extendLastTh(getGanttId,{newW:newW,animTime:animTime});this.secondBox.animate({left:newW+this.splitterBar.width(),width:totalW-newW-splW},animTime,function(){$(".TWGanttWorkSpace_"+getGanttId).find('.gantSVGBoxDiv').width(self.secondBox.width());});};this.splitterBar.on("dblclick",function(){self.resize(50,true);});}return splitter;}};//<%------------------------------------------------------------------------  UTILITIES ---------------------------------------------------------------%>
// same dates returns 1
window.getDurationInUnits=function(start,end){return start.distanceInWorkingDays(end)+1;// working in days
};//con due date uguali ritorna 0: usata per cancolare la distanza effettiva tra due date
window.getDistanceInUnits=function(date1,date2){return date1.distanceInWorkingDays(date2);// working in days
};window.incrementDateByUnits=function(date,duration){date.incrementDateByWorkingDays(duration);// working in days
return date;};window.computeStart=function(start){return computeStartDate(start).getTime();};/**
 * @param start
 * @returns {Date} the closes start date
 */window.computeStartDate=function(start){var d=new Date(start);d.setHours(0,0,0,0);//move to next working day
while(isHoliday(d)){d.setDate(d.getDate()+1);}d.setHours(0,0,0,0);return d;};window.computeEnd=function(end){return computeEndDate(end).getTime();};/**
 * @param end
 * @returns {Date} the closest end date
 */window.computeEndDate=function(end){var d=new Date(end);d.setHours(23,59,59,999);//move to next working day
while(isHoliday(d)){d.setDate(d.getDate()+1);}d.setHours(23,59,59,999);return d;};window.computeEndByDuration=function(start,duration){var d=new Date(start);var q=duration-1;while(q>0){d.setDate(d.getDate()+1);if(!isHoliday(d))q--;}d.setHours(23,59,59,999);return d.getTime();};window.incrementDateByWorkingDays=function(date,days){var d=new Date(date);d.incrementDateByWorkingDays(days);return d.getTime();};window.recomputeDuration=function(start,end){//console.debug("recomputeDuration");
return getDurationInUnits(new Date(start),new Date(end));};function resynchDates(leavingField,startField,startMilesField,durationField,endField,endMilesField){//console.debug("resynchDates",leavingField.prop("name"), "start. "+startField.val(),"durationField: "+ durationField.val(), "endField: "+endField.val());
function resynchDatesSetFields(command){//console.debug("resynchDatesSetFields",command);
var duration=stringToDuration(durationField.val());var start=computeStart(Date.parseString(startField.val()).getTime());var end=endField.val();if(end.length>0){end=Date.parseString(end);end.setHours(23,59,59,999);//this is necessary because compute end get the closest end, and parseString returns 00:00
end=computeEnd(end.getTime());}var date=new Date();if("CHANGE_END"==command){date.setTime(start);var workingUnits=duration-1;// if we do not decremet a task lasting two days starting on 10 will end on 12 (at 00:00) instead of on (at 23:59)
incrementDateByUnits(date,workingUnits);date.setHours(23,59,59,999);//this is necessary because compute end get the closest end, and parseString returns 00:00
end=computeEnd(date.getTime());// not strictly necessary
}else if("CHANGE_START"==command){date.setTime(end);var workingUnits=duration-1;// if we do not decremet a task lasting two days starting on 10 will end on 12 (at 00:00) instead of on (at 23:59)
incrementDateByUnits(date,-workingUnits);date.setHours(0,0,0,0);//this is necessary because decreasing end we are at 23:50
start=computeStart(date.getTime());//not strictly necessary
}else if("CHANGE_DURATION"==command){duration=getDurationInUnits(new Date(start),new Date(end))+1;}startField.val(new Date(start).format());endField.val(new Date(end).format());durationField.val(duration);return{start:start,end:end,duration:duration};}var leavingFieldName=leavingField.prop("name");var durIsFilled=durationField.val().length>0;var startIsFilled=startField.val().length>0;var endIsFilled=endField.val().length>0;var startIsMilesAndFilled=startIsFilled&&(startMilesField.prop("checked")||startField.is("[readOnly]"));var endIsMilesAndFilled=endIsFilled&&(endMilesField.prop("checked")||endField.is("[readOnly]"));if(durIsFilled){durationField.val(stringToDuration(durationField.val()));}if(leavingFieldName.indexOf("Milestone")>0){if(startIsMilesAndFilled&&endIsMilesAndFilled){durationField.prop("readOnly",true);}else{durationField.prop("readOnly",false);}return;}//need at least two values to resynch the third
if((durIsFilled?1:0)+(startIsFilled?1:0)+(endIsFilled?1:0)<2)return;var ret;if(leavingFieldName=='start'&&startIsFilled){if(endIsMilesAndFilled&&durIsFilled){ret=resynchDatesSetFields("CHANGE_DURATION");}else if(durIsFilled){ret=resynchDatesSetFields("CHANGE_END");}}else if(leavingFieldName=='duration'&&durIsFilled&&!(endIsMilesAndFilled&&startIsMilesAndFilled)){if(endIsMilesAndFilled&&!startIsMilesAndFilled){ret=resynchDatesSetFields("CHANGE_START");}else if(!endIsMilesAndFilled){//document.title=('go and change end!!');
ret=resynchDatesSetFields("CHANGE_END");}}else if(leavingFieldName=='end'&&endIsFilled){ret=resynchDatesSetFields("CHANGE_DURATION");}return ret;}//This prototype is provided by the Mozilla foundation and
//is distributed under the MIT license.
//http://www.ibiblio.org/pub/Linux/LICENSES/mit.license
if(!Array.prototype.filter){Array.prototype.filter=function(fun){var len=this.length;if(typeof fun!="function")throw new TypeError();var res=new Array();var thisp=arguments[1];for(var i=0;i<len;i++){if(i in this){var val=this[i];// in case fun mutates this
if(fun.call(thisp,val,i,this))res.push(val);}}return res;};}window.stringToDuration=function(durStr){var duration=NaN;duration=daysFromString(durStr,true)||1;return duration;};window.goToPage=function(url){if(!canILeave())return;window.location.href=url;};

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/Ganttalendar.prototype.initZoomlevels=function(){//console.debug("Ganttalendar.prototype.initZoomlevels");
var self=this;// define the zoom level arrays 
this.zoomLevels=[];this.zoomDrawers={};function _addZoom(zoom,zoomDrawer){self.zoomLevels.push(zoom);self.zoomDrawers[zoom]=zoomDrawer;//计算每毫秒多少像素
//compute the scale
if(zoom=='1M'){self.zoomDrawers[zoom].computedScaleX=20/(3600000*24);}else{self.zoomDrawers[zoom].computedScaleX=600/millisFromString(zoom);}}//-----------------------------  3 DAYS  600px-----------------------------
// _addZoom("3d", {
//   adjustDates: function (start, end) {
//     start.setFirstDayOfThisWeek();
//     end.setFirstDayOfThisWeek();
//     end.setDate(end.getDate() + 6);
//   },
//   row1:        function (date, ctxHead) {
//     var start = new Date(date.getTime());
//     date.setDate(date.getDate() + 6);
//     self.createHeadCell(1,this,ctxHead,start.format("yyyy/MM/dd") + " - " + date.format("yyyy/MM/dd")+ " ("+GanttMaster.messages["GANTT_DI"]+start.format("w")+GanttMaster.messages["GANTT_WEEK_SHORT"]+")",7,"", start,date);
//     date.setDate(date.getDate() + 1);
//   },
//   row2:        function (date, ctxHead, ctxBody) {
//     var start = new Date(date.getTime());
//     date.setDate(date.getDate() + 1);
//     var holyClass = isHoliday(start) ? "holy" : "";
//     self.createHeadCell(2,this,ctxHead,start.format("d")+"("+GanttMaster.messages["GANTT_WEEK_SHORT"]+convertWeekMultiLanguage(start.format("EEEE"))+")", 1, "headSmall "+holyClass, start,date);
//     self.createBodyCell(this,ctxBody,1, start.getDay() % 7 == (self.master.firstDayOfWeek + 6) % 7, holyClass);
//   }
// });
//-----------------------------  1 WEEK  600px -----------------------------
// _addZoom("1w", {
//   adjustDates: function (start, end) {
//     //reset day of week
//     start.setFirstDayOfThisWeek();
//     start.setDate(start.getDate() - 7);
//     end.setFirstDayOfThisWeek();
//     end.setDate(end.getDate() + 13);
//   },
//   row1:        function (date, ctxHead) {
//     var start = new Date(date.getTime());
//     date.setDate(date.getDate() + 6);
//     self.createHeadCell(1,this,ctxHead,start.format("yyyy/MM/dd") + " - " + date.format("yyyy/MM/dd")+" (" + GanttMaster.messages["GANTT_DI"]+date.format("w")+ GanttMaster.messages["GANTT_WEEK_SHORT"]+")", 7,"",start,date);
//     date.setDate(date.getDate() + 1);
//   },
//   row2:        function (date, ctxHead, ctxBody) {
//     var start = new Date(date.getTime());
//     date.setDate(date.getDate() + 1);
//     var holyClass = isHoliday(start) ? "holy" : "";
//     self.createHeadCell(2,this,ctxHead,convertWeekMultiLanguage(start.format("EEEE"))+" ("+start.format("dd")+")", 1, "headSmall "+holyClass, start,date);
//     self.createBodyCell(this,ctxBody,1, start.getDay() % 7 == (self.master.firstDayOfWeek + 6) % 7, holyClass);
//   }
// });
function convertWeekMultiLanguage(str){var languageidweaver=window.localStorage.getItem('languageidweaver')||'7';if(languageidweaver=='7'){switch(str){case'Sunday':str='日';break;case'Monday':str='一';break;case'Tuesday':str='二';break;case'Wednesday':str='三';break;case'Thursday':str='四';break;case'Friday':str='五';break;case'Saturday':str='六';break;}}return str;}//-----------------------------  2 WEEKS  600px -----------------------------
_addZoom("2w",{adjustDates:function adjustDates(start,end){start.setFirstDayOfThisWeek();start.setDate(start.getDate()-7);end.setFirstDayOfThisWeek();end.setDate(end.getDate()+20);},row1:function row1(date,tr1){var start=new Date(date.getTime());date.setDate(date.getDate()+6);self.createHeadCell(1,this,tr1,start.format("yyyy-MM-dd")+" - "+date.format("yyyy-MM-dd")+" ("+GanttMaster.messages["GANTT_DI"]+date.format("w")+GanttMaster.messages["GANTT_WEEK_SHORT"]+")",7,"",start,date);date.setDate(date.getDate()+1);},row2:function row2(date,tr2,trBody){var start=new Date(date.getTime());date.setDate(date.getDate()+1);var holyClass=isHoliday(start)?"holy":"";self.createHeadCell(2,this,tr2,convertWeekMultiLanguage(start.format("EEEE")),1,"headSmall "+holyClass,start,date);self.createBodyCell(this,trBody,1,start.getDay()%7==(self.master.firstDayOfWeek+6)%7,holyClass);}});//-----------------------------  1 MONTH  600px  -----------------------------
_addZoom("1M",{adjustDates:function adjustDates(start,end){start.setMonth(start.getMonth()-1);start.setDate(15);end.setDate(1);end.setMonth(end.getMonth()+1);end.setDate(end.getDate()+14);},row1:function row1(date,tr1){var start=new Date(date.getTime());date.setDate(1);date.setMonth(date.getMonth()+1);date.setDate(date.getDate()-1);var inc=date.getDate()-start.getDate()+1;date.setDate(date.getDate()+1);self.createHeadCell(1,this,tr1,start.format("yyyy-MM"),inc,"",start,date);//spans mumber of dayn in the month
},row2:function row2(date,tr2,trBody){var start=new Date(date.getTime());date.setDate(date.getDate()+1);var holyClass=isHoliday(start)?"holy":"";self.createHeadCell(2,this,tr2,start.format("d"),1,"headSmall "+holyClass,start,date);var nd=new Date(start.getTime());nd.setDate(start.getDate()+1);self.createBodyCell(this,trBody,1,nd.getDate()==1,holyClass);}});//-----------------------------  1 QUARTERS   -----------------------------
// _addZoom( "1Q", {
//   adjustDates: function (start, end) {
//     start.setDate(1);
//     start.setMonth(Math.floor(start.getMonth() / 3) * 3 -1 );
//     end.setDate(1);
//     end.setMonth(Math.floor(end.getMonth() / 3) * 3 + 4);
//     end.setDate(end.getDate() - 1);
//   },
//   row1:        function (date, tr1) {
//     var start = new Date(date.getTime());
//     date.setMonth(Math.floor(date.getMonth() / 3) * 3 + 3);
//     var inc=(date.getMonth()-start.getMonth());
//     inc=inc>0?inc:1;
//     var q = (Math.floor(start.getMonth() / 3) + 1);
//     self.createHeadCell(1,this,tr1,GanttMaster.messages["GANTT_QUARTER"]+q+" "+start.format("yyyy"), inc,"",start,date);
//   },
//   row2:        function (date, tr2, trBody) {
//     var start = new Date(date.getTime());
//     date.setMonth(date.getMonth() + 1);
//     self.createHeadCell(2,this,tr2,start.format("M")+GanttMaster.messages["GANTT_MONTH"], 1, "headSmall", start,date);
//     self.createBodyCell(this,trBody,1, start.getMonth() % 3 == 2);
//   }
// });
//-----------------------------  2 QUARTERS   -----------------------------
_addZoom("2Q",{adjustDates:function adjustDates(start,end){start.setDate(1);start.setMonth(Math.floor(start.getMonth()/3)*3-3);end.setDate(1);end.setMonth(Math.floor(end.getMonth()/3)*3+6);end.setDate(end.getDate()-1);},row1:function row1(date,tr1){var start=new Date(date.getTime());date.setMonth(date.getMonth()+3);var q=Math.floor(start.getMonth()/3)+1;self.createHeadCell(1,this,tr1,GanttMaster.messages["GANTT_QUARTER"]+q+" "+start.format("yyyy"),3,"",start,date);},row2:function row2(date,tr2,trBody){var start=new Date(date.getTime());date.setMonth(date.getMonth()+1);var lbl=start.format("M")+GanttMaster.messages["GANTT_MONTH"];self.createHeadCell(2,this,tr2,lbl,1,"headSmall",start,date);self.createBodyCell(this,trBody,1,start.getMonth()%3==2);}});//-----------------------------  1 YEAR  -----------------------------
_addZoom("1y",{adjustDates:function adjustDates(start,end){start.setDate(1);start.setMonth(Math.floor(start.getMonth()/6)*6-6);end.setDate(1);end.setMonth(Math.floor(end.getMonth()/6)*6+12);end.setDate(end.getDate()-1);},row1:function row1(date,tr1){var start=new Date(date.getTime());date.setMonth(date.getMonth()+6);var sem=Math.floor(start.getMonth()/6)+1;self.createHeadCell(1,this,tr1,(sem==1?GanttMaster.messages["GANTT_UPON"]:GanttMaster.messages["GANTT_DOWN"])+GanttMaster.messages["GANTT_SEMESTER"]+"-"+start.format("yyyy"),6,"",start,date);},row2:function row2(date,tr2,trBody){var start=new Date(date.getTime());date.setMonth(date.getMonth()+1);self.createHeadCell(2,this,tr2,start.format("M")+GanttMaster.messages["GANTT_MONTH"],1,"headSmall",start,date);self.createBodyCell(this,trBody,1,(start.getMonth()+1)%6==0);}});//-----------------------------  2 YEAR -----------------------------
_addZoom("2y",{adjustDates:function adjustDates(start,end){start.setDate(1);start.setMonth(-6);end.setDate(30);end.setMonth(17);},row1:function row1(date,tr1){var start=new Date(date.getTime());var inc=12-start.getMonth();date.setMonth(date.getMonth()+inc);self.createHeadCell(1,this,tr1,start.format("yyyy"),inc/6,"",start,date);},row2:function row2(date,tr2,trBody){var start=new Date(date.getTime());date.setMonth(date.getMonth()+6);var sem=Math.floor(start.getMonth()/6)+1;self.createHeadCell(2,this,tr2,(sem==1?GanttMaster.messages["GANTT_UPON"]:GanttMaster.messages["GANTT_DOWN"])+GanttMaster.messages["GANTT_SEMESTER"],1,"headSmall",start,date);self.createBodyCell(this,trBody,1,sem==2);}});};

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_contentPath__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var getLabel = __WEBPACK_IMPORTED_MODULE_6_ecCom__["WeaLocaleProvider"].getLabel;
var ToolBar = /** @class */ (function (_super) {
    __extends(ToolBar, _super);
    function ToolBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeZoom = function (v) {
            var ganttStore = _this.props.ganttStore;
            ganttStore.timelinekey = v;
            ganttStore.previousId = ganttStore.id;
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#workSpace_' + ganttStore.getGanttId).trigger('zoomChange' + v);
        };
        return _this;
    }
    ToolBar.prototype.render = function () {
        var _this = this;
        var ganttStore = this.props.ganttStore;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ganttButtonBar noprint" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "title", title: ganttStore.baseInfo && ganttStore.baseInfo.ganttname }, ganttStore.baseInfo && ganttStore.baseInfo.ganttname),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "buttons" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { onClick: function () { print(); }, title: getLabel('257', '打印'), className: "icon-coms-Print", style: { color: '#777', display: 'inline-block', transform: 'scale(2)' } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "ganttButtonSeparator" }),
                    ganttStore.canCreate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@4mej0e", style: { borderBottomRightRadius: '0', borderTopRightRadius: '0', padding: '5px 8px' }, type: "primary", onClick: function () {
                            ganttStore.openDialog(Object(__WEBPACK_IMPORTED_MODULE_4__util_contentPath__["a" /* getContentPath */])('/spa/cube/index.html#/main/cube/card?type=1&modeId=' + ganttStore.baseInfo.modeid + '&formId=' + ganttStore.baseInfo.formid));
                        } }, getLabel('365', '新建')),
                    ganttStore.canSave && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@zexzl0", style: { borderBottomLeftRadius: '0', borderTopLeftRadius: '0', padding: '5px 8px' }, onClick: function () {
                            ganttStore.save();
                        } }, getLabel('30986', '保存'))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "time-line" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"].Group, { ecId: (this && this.props && this.props.ecId || '') + "_Button.Group@kwbkjv" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@pq2qfw", type: ganttStore.timelinekey == '1M' ? "primary" : "ghost", onClick: function () {
                                _this.changeZoom('1M');
                            } }, getLabel('390', '日')),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@1kczte", type: ganttStore.timelinekey == '2w' ? "primary" : "ghost", onClick: function () {
                                _this.changeZoom('2w');
                            } }, getLabel("1926", "周")),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@x7htyb", type: ganttStore.timelinekey == '1y' ? "primary" : "ghost", onClick: function () {
                                _this.changeZoom('1y');
                            } }, getLabel('33452', '月')),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@lygtqt", type: ganttStore.timelinekey == '2Q' ? "primary" : "ghost", onClick: function () {
                                _this.changeZoom('2Q');
                            } }, getLabel('18280', '季')),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@e9va5j", type: ganttStore.timelinekey == '2y' ? "primary" : "ghost", onClick: function () {
                                _this.changeZoom('2y');
                            } }, getLabel('26577', '年')))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginLeft: '10px', color: 'red' } }, ganttStore.loadingtip),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "right-color-type" }, ganttStore.colorDatas.map(function (item) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "color-span", style: { backgroundColor: item.color } }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "color-label" }, item.name));
                }))));
    };
    ToolBar = __decorate([
        __WEBPACK_IMPORTED_MODULE_3_mobx_react__["observer"]
    ], ToolBar);
    return ToolBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ToolBar);


/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



/**
 * 头部模板，不用显示display:none，后边会append到其他元素上。
 */
var TasksEditHead = /** @class */ (function (_super) {
    __extends(TasksEditHead, _super);
    function TasksEditHead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTr = function () {
            var ganttStore = _this.props.ganttStore;
            var fields = ganttStore.fields;
            var trArr = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "gdfColHeader gdfied unselectable", style: { width: '35px' } }, "\u5E8F\u53F7")];
            var clientWidth = document.body.clientWidth;
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(fields.slice(), function (item, index) {
                var colwidth = parseFloat(item.colwidth);
                var width = parseInt((clientWidth * colwidth * 0.4) / 100 + '');
                if (item.systemFlag && item.systemFlag == 1) {
                    trArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "gdfColHeader gdfResizable", "data-initialwidth": width, style: { width: width + 'px' } }, item.showName));
                }
                else {
                    trArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "gdfColHeader gdfResizable", style: { width: width + 'px' } }, item.showName));
                }
            });
            return trArr;
        };
        return _this;
    }
    TasksEditHead.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "tasksEditHead", style: { display: 'none' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", { className: "gdfTable", "data-cellspacing": "0", "data-cellpadding": "0" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: { height: '60px' } }, this.renderTr()))));
    };
    TasksEditHead = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TasksEditHead);
    return TasksEditHead;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TasksEditHead);


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var TaskInfo = /** @class */ (function (_super) {
    __extends(TaskInfo, _super);
    function TaskInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TaskInfo.prototype.render = function () {
        var ganttStore = this.props.ganttStore;
        var taskInfo = ganttStore.taskInfo;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "taskInfo", style: { left: taskInfo.left, top: taskInfo.top } }, taskInfo.show && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "taskContent" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, taskInfo.text1),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, taskInfo.text2)));
    };
    TaskInfo = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('ganttStore'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], TaskInfo);
    return TaskInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (TaskInfo);


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var LitterTool = /** @class */ (function (_super) {
    __extends(LitterTool, _super);
    function LitterTool(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: false };
        return _this;
    }
    LitterTool.prototype.render = function () {
        var _this = this;
        var ganttStore = this.props.ganttStore;
        var litterTool = ganttStore.litterTool;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "litterTool", style: { left: '0px', top: litterTool.top }, onMouseLeave: function () {
                _this.setState({ open: false });
                ganttStore.taskOutFun && ganttStore.taskOutFun();
            } }, litterTool.show && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "litterToolContent" }, this.state.open ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "litterToolList" },
            litterTool.canRead && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel('360', '打开'), onClick: function () {
                    _this.setState({ open: false });
                    ganttStore.openDialog('', litterTool.id);
                }, className: "icon-coms-link litterToolbutton" }),
            litterTool.canWrite && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel('501169', '编辑'), onClick: function () {
                    _this.setState({ open: false });
                    ganttStore.editTaskRow(__WEBPACK_IMPORTED_MODULE_2_jquery___default()("#workSpace_" + ganttStore.getGanttId).find('tr[data-taskid="' + litterTool.id + '"]'), ganttStore.ganttMaster.getTask(litterTool.id));
                }, className: "icon-coms-edit litterToolbutton" }),
            litterTool.canDelete && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel('91', '删除'), onClick: function () {
                    _this.setState({ open: false });
                    if (litterTool.id.startsWith('tmp')) {
                        ganttStore.deleteTmpTaskRow(litterTool.id);
                    }
                    else {
                        ganttStore.currentDeleteId = litterTool.id;
                        ganttStore.deletevisible = true;
                    }
                }, className: "icon-coms-delete litterToolbutton" }),
            ganttStore.canCreate && litterTool.canWrite && ganttStore.isSuperiorFieldSet && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel('527914', '新建上级'), onClick: function () {
                    _this.setState({ open: false });
                    ganttStore.addTaskRow(litterTool.id, 'above');
                }, className: "icon-coms-Batch-add litterToolbutton" }),
            ganttStore.canCreate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel('527915', '新建同级'), onClick: function () {
                    _this.setState({ open: false });
                    ganttStore.addTaskRow(litterTool.id, 'sibling');
                }, className: "icon-coms-Add-to litterToolbutton" }),
            ganttStore.canCreate && ganttStore.isSuperiorFieldSet && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { title: getLabel('382609', '新建下级'), onClick: function () {
                    _this.setState({ open: false });
                    ganttStore.addTaskRow(litterTool.id, 'below');
                }, className: " icon-coms-AddTo litterToolbutton" })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onMouseEnter: function () { _this.setState({ open: true }); }, className: "litterToolMore" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-coms-Right" }))));
    };
    LitterTool = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('ganttStore'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], LitterTool);
    return LitterTool;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (LitterTool);


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var DeleteConfirmDialog = /** @class */ (function (_super) {
    __extends(DeleteConfirmDialog, _super);
    function DeleteConfirmDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeleteConfirmDialog.prototype.render = function () {
        var ganttStore = this.props.ganttStore;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Modal"], { ecId: (this && this.props && this.props.ecId || '') + "_Modal@w7k6dw", wrapClassName: "deleteConfirmDialog", style: { width: '400px', height: '300px' }, visible: ganttStore.deletevisible, maskClosable: false, title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-coms-Prompt", style: { color: 'orange',
                            fontSize: '20px', marginRight: '10px', position: 'relative', top: '4px' } }),
                    "\u5220\u9664\u786E\u8BA4"), onOk: function () { }, onCancel: function () { ganttStore.deletevisible = false; }, footer: [
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@mamvtz@deleteTaskRow1", key: "submit", type: "primary", size: "large", onClick: function () { ganttStore.deleteTaskRow(1); } }, "\u662F\uFF0C\u4E14\u5220\u9664\u5B50\u7EA7"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@2foc8p@deleteTaskRow0", key: "submit", type: "primary", size: "large", onClick: function () { ganttStore.deleteTaskRow(0); } }, "\u662F\uFF0C\u4E0D\u5220\u9664\u5B50\u7EA7"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@wya63o@deletevisible", key: "back", type: "ghost", size: "large", onClick: function () { ganttStore.deletevisible = false; } }, "\u5426"),
                ] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\u00A0"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { style: { fontSize: '14px', textAlign: 'center' } }, "\u786E\u5B9A\u5220\u9664\u5417\uFF1F"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\u00A0")));
    };
    DeleteConfirmDialog = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], DeleteConfirmDialog);
    return DeleteConfirmDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (DeleteConfirmDialog);


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ecCom__);
var _this = this;


var getLabel = __WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaLocaleProvider"].getLabel;
/* harmony default export */ __webpack_exports__["a"] = (function () { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_ecCom__["WeaAlertPage"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaAlertPage@wms00p" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { color: '#000' } }, getLabel(530230, '对不起，存在加密,脱敏信息,您暂时没有权限！请联系管理员')))); });


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DevDocker", function() { return DevDocker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_deep_equal__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__electricSign__ = __webpack_require__(1168);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _this = this;







var getLabel = __WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaLocaleProvider"].getLabel;
var getQuery = function (href) {
    var lastofnum = href.lastIndexOf('?');
    href = href.slice(lastofnum);
    var query = href.split('?')[1];
    var querys = query ? query.split("&") : [];
    var queryObj = {};
    querys.map(function (q) {
        var index = q.indexOf("=");
        var name = q.substring(0, index);
        var value = q.substring(index + 1);
        __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.set(queryObj, name, value);
    });
    return queryObj;
};
var DevDocker = /** @class */ (function (_super) {
    __extends(DevDocker, _super);
    function DevDocker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doUpdate = function (props) {
            var location = props.location, params = props.params, ElectricSign = props.ElectricSign;
            var query = getQuery(decodeURI(location.search));
            var store = { elesign: ElectricSign }[params.guid];
            if (store && store.updateParams) {
                store.updateParams(__assign({}, query, params, { _key: location.key }));
            }
        };
        return _this;
    }
    DevDocker.prototype.componentWillMount = function () {
        this.doUpdate(this.props);
    };
    DevDocker.prototype.componentDidMount = function () {
        if (window.location.href.indexOf('/spa/cube/index.html') > -1 || window.location.href.indexOf('/spa/cube/index.jsp') > -1) {
            document.title = getLabel(16641, "高效源于协同");
        }
    };
    DevDocker.prototype.componentWillReceiveProps = function (nextProps) {
        var nextP = nextProps.location.action;
        var thisP = this.props.location;
        delete nextP.action;
        delete thisP.action;
        if (!__WEBPACK_IMPORTED_MODULE_4_deep_equal___default()(nextP, thisP)) {
            this.doUpdate(nextProps);
        }
    };
    DevDocker.prototype.render = function () {
        var _a = this.props, _b = _a.prefixCls, prefixCls = _b === void 0 ? 'coms-mode-devdocker' : _b, className = _a.className, params = _a.params;
        var Com = {
            elesign: __WEBPACK_IMPORTED_MODULE_6__electricSign__["a" /* default */],
        }[params.guid];
        var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, prefixCls, "coms-mode-" + params.guid);
        var props = { location: this.props.location };
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: classNames },
            (window.location.href.indexOf('/spa/cube/index.html') > -1 || window.location.href.indexOf('/spa/cube/index.jsp') > -1) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaPopoverHrm"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaPopoverHrm@jqtiny" }),
            Com && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Com, __assign({ ecId: (this && this.props && this.props.ecId || '') + "_Com@0bj4p5" }, props))));
    };
    DevDocker = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["inject"])('ElectricSign')
    ], DevDocker);
    return DevDocker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var MyErrorHandler = function () {
    var hasErrorMsg = _this.props.error && _this.props.error !== "";
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaErrorPage"], { ecId: (_this && _this.props && _this.props.ecId || '') + "_WeaErrorPage@zuv86o", msg: hasErrorMsg ? _this.props.error : getLabel(383324, "对不起，该页面异常，请联系管理员") + "!" }));
};
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_ecCom__["WeaTools"].tryCatch(__WEBPACK_IMPORTED_MODULE_0_react___default.a, MyErrorHandler, { error: "" })(DevDocker));


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobx_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ecCom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ecCom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

// import classnames from 'classnames';



var ElectricSign = /** @class */ (function (_super) {
    __extends(ElectricSign, _super);
    function ElectricSign(props) {
        var _this = _super.call(this, props) || this;
        var ElectricSign = _this.props.ElectricSign;
        ElectricSign.init();
        return _this;
    }
    ElectricSign.prototype.render = function () {
        var ElectricSign = this.props.ElectricSign;
        var signType = ElectricSign.signType, selectedFile = ElectricSign.selectedFile, _a = ElectricSign.selectedFileData, filename = _a.filename, size = _a.size, refresh = ElectricSign.refresh;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaNewScroll"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaNewScroll@24syd6", height: document.body.offsetHeight - 50 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "cube-dev-electricsign" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, "\u7B7E\u7AE0\u6587\u4EF6\u4E0A\u4F20"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "electrien-singn-container" },
                    selectedFile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "file-upload-list" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "list-header" }, "\u5F85\u4E0A\u4F20\u6587\u4EF6"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "list-item" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "list-item-icon icon-coms-content-o" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "list-item-info" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "info-name" }, filename),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "info-size" },
                                    (size / 1024).toFixed(2),
                                    "K")),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Icon"], { ecId: (this && this.props && this.props.ecId || '') + "_Icon@xpr5a8", type: "cross", title: '删除', onClick: ElectricSign.deleteFile }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "file-container", style: { display: selectedFile ? 'none' : 'block' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "file-upload" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "file-upload-icon" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaUpload"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaUpload@wk3nas", key: refresh, uploadUrl: '/api/doc/upload/uploadFile', category: 'string', maxUploadSize: 10, multiSelection: false, autoUpload: false, maxFilesNumber: 1, limitType: 'doc,docx,xlsx,xls,txt,pdf,jpg,jpeg,png,gif,tiff', onChange: ElectricSign.uploadChange, getShowListDatas: ElectricSign.getShowListDatas },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-mode-tianjiawenjian1" }))),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "file-upload-text" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "\u70B9\u51FB\u4E0A\u4F20\u9644\u4EF6"),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "(\u6700\u592710M)"))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "file-describe-text" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "\u5EFA\u8BAE\u7EB8\u5F20\u5C3A\u5BF8:A4(210mm x 297mm)"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "\u652F\u6301\u6587\u4EF6\u683C\u5F0F: doc\u3001docx\u3001xlsx\u3001xls\u3001txt\u3001pdf\u3001jpg\u3001jpeg\u3001png\u3001gif\u3001tiff"))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sign-type" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "\u7B7E\u7AE0\u7C7B\u578B\uFF1A"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@f68fx9", options: [{
                                    key: "1",
                                    selected: true,
                                    showname: "个人签名",
                                }, {
                                    key: "2",
                                    selected: false,
                                    showname: "企业签章"
                                }], value: signType, viewAttr: 2, style: { width: 210 }, onChange: function (v, showname) {
                                ElectricSign.changeSignType(v);
                            } })),
                    ElectricSign.companyvisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sign-type" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "\u4F01\u4E1A\u540D\u79F0\uFF1A"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_ecCom__["WeaSelect"], { ecId: (this && this.props && this.props.ecId || '') + "_WeaSelect@h8xa0k", options: ElectricSign.getOptions(), viewAttr: 2, style: { width: 210 }, onChange: function (v, showname) {
                                ElectricSign.companyname = showname;
                            } })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "sign-btn" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd__["Button"], { ecId: (this && this.props && this.props.ecId || '') + "_Button@r4s0xt", type: "primary", disabled: selectedFile ? false : true, onClick: ElectricSign.toSign }, "\u7535\u5B50\u7B7E\u7AE0"))))));
    };
    ElectricSign = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["inject"])('ElectricSign'),
        __WEBPACK_IMPORTED_MODULE_1_mobx_react__["observer"]
    ], ElectricSign);
    return ElectricSign;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ElectricSign);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.tsx.js?v=f7858e41